var _defineProperty = require("/var/lib/jenkins/workspace/apg.openapi/apg.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _assertThisInitialized = require("/var/lib/jenkins/workspace/apg.openapi/apg.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _get = require("/var/lib/jenkins/workspace/apg.openapi/apg.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _possibleConstructorReturn = require("/var/lib/jenkins/workspace/apg.openapi/apg.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/lib/jenkins/workspace/apg.openapi/apg.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/lib/jenkins/workspace/apg.openapi/apg.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _toConsumableArray = require("/var/lib/jenkins/workspace/apg.openapi/apg.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/var/lib/jenkins/workspace/apg.openapi/apg.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/var/lib/jenkins/workspace/apg.openapi/apg.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/lib/jenkins/workspace/apg.openapi/apg.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __getOwnPropSymbols(source)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

  return target;
};

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      var _loop = function _loop() {
        var key = _step3.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (var _iterator3 = __getOwnPropNames(from)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        _loop();
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;

  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }

  if (kind && result) __defProp(target, key, result);
  return result;
};

var __decorateParam = function __decorateParam(index, decorator) {
  return function (target, key) {
    return decorator(target, key, index);
  };
}; // community-modules/core/src/main.ts


var main_exports = {};

__export(main_exports, {
  ALWAYS_SYNC_GLOBAL_EVENTS: function ALWAYS_SYNC_GLOBAL_EVENTS() {
    return _ALWAYS_SYNC_GLOBAL_EVENTS;
  },
  AbstractHeaderCellCtrl: function AbstractHeaderCellCtrl() {
    return _AbstractHeaderCellCtrl2;
  },
  AgAbstractField: function AgAbstractField() {
    return _AgAbstractField;
  },
  AgAbstractLabel: function AgAbstractLabel() {
    return _AgAbstractLabel;
  },
  AgAutocomplete: function AgAutocomplete() {
    return _AgAutocomplete2;
  },
  AgCheckbox: function AgCheckbox() {
    return _AgCheckbox;
  },
  AgDialog: function AgDialog() {
    return _AgDialog;
  },
  AgGroupComponent: function AgGroupComponent() {
    return _AgGroupComponent2;
  },
  AgInputDateField: function AgInputDateField() {
    return _AgInputDateField;
  },
  AgInputNumberField: function AgInputNumberField() {
    return _AgInputNumberField;
  },
  AgInputRange: function AgInputRange() {
    return _AgInputRange;
  },
  AgInputTextArea: function AgInputTextArea() {
    return _AgInputTextArea;
  },
  AgInputTextField: function AgInputTextField() {
    return _AgInputTextField;
  },
  AgMenuItemComponent: function AgMenuItemComponent() {
    return _AgMenuItemComponent2;
  },
  AgMenuItemRenderer: function AgMenuItemRenderer() {
    return _AgMenuItemRenderer;
  },
  AgMenuList: function AgMenuList() {
    return _AgMenuList;
  },
  AgMenuPanel: function AgMenuPanel() {
    return _AgMenuPanel;
  },
  AgPanel: function AgPanel() {
    return _AgPanel2;
  },
  AgPickerField: function AgPickerField() {
    return _AgPickerField;
  },
  AgPromise: function AgPromise() {
    return _AgPromise2;
  },
  AgPromiseStatus: function AgPromiseStatus() {
    return _AgPromiseStatus;
  },
  AgRadioButton: function AgRadioButton() {
    return _AgRadioButton;
  },
  AgRichSelect: function AgRichSelect() {
    return _AgRichSelect;
  },
  AgSelect: function AgSelect() {
    return _AgSelect2;
  },
  AgSlider: function AgSlider() {
    return _AgSlider2;
  },
  AgStackComponentsRegistry: function AgStackComponentsRegistry() {
    return _AgStackComponentsRegistry;
  },
  AgToggleButton: function AgToggleButton() {
    return _AgToggleButton;
  },
  AlignedGridsService: function AlignedGridsService() {
    return _AlignedGridsService;
  },
  AnimateShowChangeCellRenderer: function AnimateShowChangeCellRenderer() {
    return _AnimateShowChangeCellRenderer;
  },
  AnimateSlideCellRenderer: function AnimateSlideCellRenderer() {
    return _AnimateSlideCellRenderer;
  },
  AnimationFrameService: function AnimationFrameService() {
    return _AnimationFrameService;
  },
  AutoScrollService: function AutoScrollService() {
    return _AutoScrollService;
  },
  AutoWidthCalculator: function AutoWidthCalculator() {
    return _AutoWidthCalculator;
  },
  Autowired: function Autowired() {
    return _Autowired;
  },
  BarColumnLabelPlacement: function BarColumnLabelPlacement() {
    return _BarColumnLabelPlacement;
  },
  BaseComponentWrapper: function BaseComponentWrapper() {
    return _BaseComponentWrapper;
  },
  Bean: function Bean() {
    return _Bean;
  },
  BeanStub: function BeanStub() {
    return _BeanStub2;
  },
  Beans: function Beans() {
    return _Beans;
  },
  BodyDropPivotTarget: function BodyDropPivotTarget() {
    return _BodyDropPivotTarget;
  },
  BodyDropTarget: function BodyDropTarget() {
    return _BodyDropTarget;
  },
  CellComp: function CellComp() {
    return _CellComp;
  },
  CellCtrl: function CellCtrl() {
    return _CellCtrl2;
  },
  CellNavigationService: function CellNavigationService() {
    return _CellNavigationService;
  },
  CellPositionUtils: function CellPositionUtils() {
    return _CellPositionUtils;
  },
  CellRangeType: function CellRangeType() {
    return _CellRangeType;
  },
  ChangedPath: function ChangedPath() {
    return _ChangedPath;
  },
  ChartMappings: function ChartMappings() {
    return _ChartMappings;
  },
  CheckboxCellEditor: function CheckboxCellEditor() {
    return _CheckboxCellEditor;
  },
  CheckboxCellRenderer: function CheckboxCellRenderer() {
    return _CheckboxCellRenderer2;
  },
  CheckboxSelectionComponent: function CheckboxSelectionComponent() {
    return _CheckboxSelectionComponent;
  },
  ClientSideRowModelSteps: function ClientSideRowModelSteps() {
    return _ClientSideRowModelSteps;
  },
  Column: function Column() {
    return _Column2;
  },
  ColumnApi: function ColumnApi() {
    return _ColumnApi;
  },
  ColumnFactory: function ColumnFactory() {
    return _ColumnFactory;
  },
  ColumnGroup: function ColumnGroup() {
    return _ColumnGroup2;
  },
  ColumnKeyCreator: function ColumnKeyCreator() {
    return _ColumnKeyCreator;
  },
  ColumnModel: function ColumnModel() {
    return _ColumnModel;
  },
  Component: function Component() {
    return _Component2;
  },
  ComponentUtil: function ComponentUtil() {
    return _ComponentUtil2;
  },
  Context: function Context() {
    return _Context;
  },
  CssClassApplier: function CssClassApplier() {
    return _CssClassApplier;
  },
  CssClassManager: function CssClassManager() {
    return _CssClassManager;
  },
  CtrlsService: function CtrlsService() {
    return _CtrlsService;
  },
  DataTypeService: function DataTypeService() {
    return _DataTypeService;
  },
  DateCellEditor: function DateCellEditor() {
    return _DateCellEditor;
  },
  DateFilter: function DateFilter() {
    return _DateFilter2;
  },
  DateStringCellEditor: function DateStringCellEditor() {
    return _DateStringCellEditor;
  },
  DisplayedGroupCreator: function DisplayedGroupCreator() {
    return _DisplayedGroupCreator;
  },
  DragAndDropService: function DragAndDropService() {
    return _DragAndDropService2;
  },
  DragService: function DragService() {
    return _DragService;
  },
  DragSourceType: function DragSourceType() {
    return _DragSourceType;
  },
  Environment: function Environment() {
    return _Environment;
  },
  EventService: function EventService() {
    return _EventService;
  },
  Events: function Events() {
    return _Events;
  },
  ExcelFactoryMode: function ExcelFactoryMode() {
    return _ExcelFactoryMode;
  },
  ExpansionService: function ExpansionService() {
    return _ExpansionService;
  },
  ExpressionService: function ExpressionService() {
    return _ExpressionService;
  },
  FilterManager: function FilterManager() {
    return _FilterManager;
  },
  FilterWrapperComp: function FilterWrapperComp() {
    return _FilterWrapperComp;
  },
  FloatingFilterMapper: function FloatingFilterMapper() {
    return _FloatingFilterMapper;
  },
  FocusService: function FocusService() {
    return _FocusService2;
  },
  GROUP_AUTO_COLUMN_ID: function GROUP_AUTO_COLUMN_ID() {
    return _GROUP_AUTO_COLUMN_ID;
  },
  Grid: function Grid() {
    return _Grid;
  },
  GridApi: function GridApi() {
    return _GridApi;
  },
  GridBodyComp: function GridBodyComp() {
    return _GridBodyComp;
  },
  GridBodyCtrl: function GridBodyCtrl() {
    return _GridBodyCtrl;
  },
  GridComp: function GridComp() {
    return _GridComp;
  },
  GridCoreCreator: function GridCoreCreator() {
    return _GridCoreCreator;
  },
  GridCtrl: function GridCtrl() {
    return _GridCtrl;
  },
  GridHeaderComp: function GridHeaderComp() {
    return _GridHeaderComp2;
  },
  GridHeaderCtrl: function GridHeaderCtrl() {
    return _GridHeaderCtrl;
  },
  GridOptionsService: function GridOptionsService() {
    return _GridOptionsService2;
  },
  GroupCellRenderer: function GroupCellRenderer() {
    return _GroupCellRenderer2;
  },
  GroupCellRendererCtrl: function GroupCellRendererCtrl() {
    return _GroupCellRendererCtrl;
  },
  GroupInstanceIdCreator: function GroupInstanceIdCreator() {
    return _GroupInstanceIdCreator;
  },
  HeaderCellCtrl: function HeaderCellCtrl() {
    return _HeaderCellCtrl;
  },
  HeaderFilterCellComp: function HeaderFilterCellComp() {
    return _HeaderFilterCellComp2;
  },
  HeaderFilterCellCtrl: function HeaderFilterCellCtrl() {
    return _HeaderFilterCellCtrl;
  },
  HeaderGroupCellCtrl: function HeaderGroupCellCtrl() {
    return _HeaderGroupCellCtrl;
  },
  HeaderNavigationDirection: function HeaderNavigationDirection() {
    return _HeaderNavigationDirection;
  },
  HeaderNavigationService: function HeaderNavigationService() {
    return _HeaderNavigationService;
  },
  HeaderPositionUtils: function HeaderPositionUtils() {
    return _HeaderPositionUtils;
  },
  HeaderRowComp: function HeaderRowComp() {
    return _HeaderRowComp;
  },
  HeaderRowContainerComp: function HeaderRowContainerComp() {
    return _HeaderRowContainerComp2;
  },
  HeaderRowContainerCtrl: function HeaderRowContainerCtrl() {
    return _HeaderRowContainerCtrl;
  },
  HeaderRowCtrl: function HeaderRowCtrl() {
    return _HeaderRowCtrl;
  },
  HeaderRowType: function HeaderRowType() {
    return _HeaderRowType;
  },
  HorizontalDirection: function HorizontalDirection() {
    return _HorizontalDirection;
  },
  HorizontalResizeService: function HorizontalResizeService() {
    return _HorizontalResizeService;
  },
  KeyCode: function KeyCode() {
    return _KeyCode;
  },
  LargeTextCellEditor: function LargeTextCellEditor() {
    return _LargeTextCellEditor2;
  },
  LayoutCssClasses: function LayoutCssClasses() {
    return _LayoutCssClasses;
  },
  LocaleService: function LocaleService() {
    return _LocaleService;
  },
  Logger: function Logger() {
    return _Logger;
  },
  LoggerFactory: function LoggerFactory() {
    return _LoggerFactory;
  },
  ManagedFocusFeature: function ManagedFocusFeature() {
    return _ManagedFocusFeature2;
  },
  MenuService: function MenuService() {
    return _MenuService;
  },
  ModuleNames: function ModuleNames() {
    return _ModuleNames;
  },
  ModuleRegistry: function ModuleRegistry() {
    return _ModuleRegistry2;
  },
  MouseEventService: function MouseEventService() {
    return _MouseEventService2;
  },
  MoveColumnFeature: function MoveColumnFeature() {
    return _MoveColumnFeature;
  },
  NavigationService: function NavigationService() {
    return _NavigationService;
  },
  NumberCellEditor: function NumberCellEditor() {
    return _NumberCellEditor;
  },
  NumberFilter: function NumberFilter() {
    return _NumberFilter2;
  },
  NumberSequence: function NumberSequence() {
    return _NumberSequence;
  },
  Optional: function Optional() {
    return _Optional;
  },
  PaginationProxy: function PaginationProxy() {
    return _PaginationProxy;
  },
  PillDragComp: function PillDragComp() {
    return _PillDragComp2;
  },
  PillDropZonePanel: function PillDropZonePanel() {
    return _PillDropZonePanel2;
  },
  PinnedRowModel: function PinnedRowModel() {
    return _PinnedRowModel;
  },
  PopupComponent: function PopupComponent() {
    return _PopupComponent;
  },
  PopupEditorWrapper: function PopupEditorWrapper() {
    return _PopupEditorWrapper2;
  },
  PopupService: function PopupService() {
    return _PopupService2;
  },
  PositionableFeature: function PositionableFeature() {
    return _PositionableFeature;
  },
  PostConstruct: function PostConstruct() {
    return _PostConstruct;
  },
  PreConstruct: function PreConstruct() {
    return _PreConstruct;
  },
  PreDestroy: function PreDestroy() {
    return _PreDestroy;
  },
  PropertyKeys: function PropertyKeys() {
    return _PropertyKeys2;
  },
  ProvidedColumnGroup: function ProvidedColumnGroup() {
    return _ProvidedColumnGroup2;
  },
  ProvidedFilter: function ProvidedFilter() {
    return _ProvidedFilter2;
  },
  Qualifier: function Qualifier() {
    return _Qualifier;
  },
  QuerySelector: function QuerySelector() {
    return _QuerySelector;
  },
  RefSelector: function RefSelector() {
    return _RefSelector;
  },
  ResizeObserverService: function ResizeObserverService() {
    return _ResizeObserverService;
  },
  RowAnimationCssClasses: function RowAnimationCssClasses() {
    return _RowAnimationCssClasses;
  },
  RowContainerComp: function RowContainerComp() {
    return _RowContainerComp;
  },
  RowContainerCtrl: function RowContainerCtrl() {
    return _RowContainerCtrl2;
  },
  RowContainerName: function RowContainerName() {
    return _RowContainerName;
  },
  RowContainerType: function RowContainerType() {
    return _RowContainerType;
  },
  RowCtrl: function RowCtrl() {
    return _RowCtrl2;
  },
  RowHighlightPosition: function RowHighlightPosition() {
    return _RowHighlightPosition;
  },
  RowNode: function RowNode() {
    return _RowNode2;
  },
  RowNodeBlock: function RowNodeBlock() {
    return _RowNodeBlock2;
  },
  RowNodeBlockLoader: function RowNodeBlockLoader() {
    return _RowNodeBlockLoader2;
  },
  RowNodeSorter: function RowNodeSorter() {
    return _RowNodeSorter;
  },
  RowPositionUtils: function RowPositionUtils() {
    return _RowPositionUtils;
  },
  RowRenderer: function RowRenderer() {
    return _RowRenderer;
  },
  ScalarFilter: function ScalarFilter() {
    return _ScalarFilter2;
  },
  ScrollVisibleService: function ScrollVisibleService() {
    return _ScrollVisibleService;
  },
  SelectCellEditor: function SelectCellEditor() {
    return _SelectCellEditor;
  },
  SelectableService: function SelectableService() {
    return _SelectableService;
  },
  SelectionHandleType: function SelectionHandleType() {
    return _SelectionHandleType;
  },
  ServerSideTransactionResultStatus: function ServerSideTransactionResultStatus() {
    return _ServerSideTransactionResultStatus;
  },
  SetLeftFeature: function SetLeftFeature() {
    return _SetLeftFeature;
  },
  SimpleFilter: function SimpleFilter() {
    return _SimpleFilter2;
  },
  SortController: function SortController() {
    return _SortController2;
  },
  SortIndicatorComp: function SortIndicatorComp() {
    return _SortIndicatorComp2;
  },
  StandardMenuFactory: function StandardMenuFactory() {
    return _StandardMenuFactory;
  },
  StylingService: function StylingService() {
    return _StylingService;
  },
  TabGuardClassNames: function TabGuardClassNames() {
    return _TabGuardClassNames;
  },
  TabGuardComp: function TabGuardComp() {
    return _TabGuardComp;
  },
  TabGuardCtrl: function TabGuardCtrl() {
    return _TabGuardCtrl;
  },
  TabbedLayout: function TabbedLayout() {
    return _TabbedLayout2;
  },
  TextCellEditor: function TextCellEditor() {
    return _TextCellEditor;
  },
  TextFilter: function TextFilter() {
    return _TextFilter2;
  },
  TextFloatingFilter: function TextFloatingFilter() {
    return _TextFloatingFilter;
  },
  Timer: function Timer() {
    return _Timer;
  },
  TooltipFeature: function TooltipFeature() {
    return _TooltipFeature;
  },
  TooltipStateManager: function TooltipStateManager() {
    return _TooltipStateManager2;
  },
  TouchListener: function TouchListener() {
    return _TouchListener2;
  },
  UserComponentFactory: function UserComponentFactory() {
    return _UserComponentFactory;
  },
  UserComponentRegistry: function UserComponentRegistry() {
    return _UserComponentRegistry;
  },
  ValueCache: function ValueCache() {
    return _ValueCache;
  },
  ValueService: function ValueService() {
    return _ValueService;
  },
  VanillaFrameworkOverrides: function VanillaFrameworkOverrides() {
    return _VanillaFrameworkOverrides;
  },
  VerticalDirection: function VerticalDirection() {
    return _VerticalDirection;
  },
  VirtualList: function VirtualList() {
    return _VirtualList2;
  },
  VirtualListDragFeature: function VirtualListDragFeature() {
    return _VirtualListDragFeature;
  },
  _: function _() {
    return _3;
  },
  __FORCE_MODULE_DETECTION: function __FORCE_MODULE_DETECTION() {
    return _FORCE_MODULE_DETECTION;
  },
  createGrid: function createGrid() {
    return _createGrid;
  },
  getRowContainerTypeForName: function getRowContainerTypeForName() {
    return _getRowContainerTypeForName;
  },
  provideGlobalGridOptions: function provideGlobalGridOptions() {
    return _provideGlobalGridOptions;
  }
});

module.exports = __toCommonJS(main_exports); // community-modules/core/src/utils/generic.ts

var generic_exports = {};

__export(generic_exports, {
  attrToBoolean: function attrToBoolean() {
    return _attrToBoolean;
  },
  attrToNumber: function attrToNumber() {
    return _attrToNumber;
  },
  attrToString: function attrToString() {
    return _attrToString;
  },
  defaultComparator: function defaultComparator() {
    return _defaultComparator;
  },
  exists: function exists() {
    return _exists;
  },
  jsonEquals: function jsonEquals() {
    return _jsonEquals;
  },
  makeNull: function makeNull() {
    return _makeNull;
  },
  missing: function missing() {
    return _missing;
  },
  missingOrEmpty: function missingOrEmpty() {
    return _missingOrEmpty;
  },
  toStringOrNull: function toStringOrNull() {
    return _toStringOrNull;
  },
  values: function values() {
    return _values;
  }
});

function _makeNull(value) {
  if (value == null || value === "") {
    return null;
  }

  return value;
}

function _exists(value) {
  var allowEmptyString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return value != null && (value !== "" || allowEmptyString);
}

function _missing(value) {
  return !_exists(value);
}

function _missingOrEmpty(value) {
  return value == null || value.length === 0;
}

function _toStringOrNull(value) {
  return value != null && typeof value.toString === "function" ? value.toString() : null;
}

function _attrToNumber(value) {
  if (value === void 0) {
    return;
  }

  if (value === null || value === "") {
    return null;
  }

  if (typeof value === "number") {
    return isNaN(value) ? void 0 : value;
  }

  var valueParsed = parseInt(value, 10);
  return isNaN(valueParsed) ? void 0 : valueParsed;
}

function _attrToBoolean(value) {
  if (value === void 0) {
    return;
  }

  if (value === null || value === "") {
    return false;
  }

  if (typeof value === "boolean") {
    return value;
  }

  return /true/i.test(value);
}

function _attrToString(value) {
  if (value == null || value === "") {
    return;
  }

  return value;
}

function _jsonEquals(val1, val2) {
  var val1Json = val1 ? JSON.stringify(val1) : null;
  var val2Json = val2 ? JSON.stringify(val2) : null;
  return val1Json === val2Json;
}

function _defaultComparator(valueA, valueB) {
  var accentedCompare = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var valueAMissing = valueA == null;
  var valueBMissing = valueB == null;

  if (valueA && valueA.toNumber) {
    valueA = valueA.toNumber();
  }

  if (valueB && valueB.toNumber) {
    valueB = valueB.toNumber();
  }

  if (valueAMissing && valueBMissing) {
    return 0;
  }

  if (valueAMissing) {
    return -1;
  }

  if (valueBMissing) {
    return 1;
  }

  function doQuickCompare(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  if (typeof valueA !== "string") {
    return doQuickCompare(valueA, valueB);
  }

  if (!accentedCompare) {
    return doQuickCompare(valueA, valueB);
  }

  try {
    return valueA.localeCompare(valueB);
  } catch (e) {
    return doQuickCompare(valueA, valueB);
  }
}

function _values(object) {
  if (object instanceof Set || object instanceof Map) {
    var arr = [];
    object.forEach(function (value) {
      return arr.push(value);
    });
    return arr;
  }

  return Object.values(object);
} // community-modules/core/src/columns/columnKeyCreator.ts


var _ColumnKeyCreator =
/*#__PURE__*/
function () {
  "use strict";

  function _ColumnKeyCreator() {
    _classCallCheck(this, _ColumnKeyCreator);

    this.existingKeys = {};
  }

  _createClass(_ColumnKeyCreator, [{
    key: "addExistingKeys",
    value: function addExistingKeys(keys2) {
      for (var i = 0; i < keys2.length; i++) {
        this.existingKeys[keys2[i]] = true;
      }
    }
  }, {
    key: "getUniqueKey",
    value: function getUniqueKey(colId, colField) {
      colId = _toStringOrNull(colId);
      var count = 0;

      while (true) {
        var idToTry = void 0;

        if (colId) {
          idToTry = colId;

          if (count !== 0) {
            idToTry += "_" + count;
          }
        } else if (colField) {
          idToTry = colField;

          if (count !== 0) {
            idToTry += "_" + count;
          }
        } else {
          idToTry = count;
        }

        if (!this.existingKeys[idToTry]) {
          this.existingKeys[idToTry] = true;
          return String(idToTry);
        }

        count++;
      }
    }
  }]);

  return _ColumnKeyCreator;
}(); // community-modules/core/src/utils/object.ts


var object_exports = {};

__export(object_exports, {
  cloneObject: function cloneObject() {
    return _cloneObject;
  },
  deepCloneDefinition: function deepCloneDefinition() {
    return _deepCloneDefinition;
  },
  getAllValuesInObject: function getAllValuesInObject() {
    return _getAllValuesInObject;
  },
  getValueUsingField: function getValueUsingField() {
    return _getValueUsingField;
  },
  isNonNullObject: function isNonNullObject() {
    return _isNonNullObject;
  },
  iterateObject: function iterateObject() {
    return _iterateObject;
  },
  mergeDeep: function mergeDeep() {
    return _mergeDeep;
  },
  removeAllReferences: function removeAllReferences() {
    return _removeAllReferences;
  }
});

function _iterateObject(object, callback) {
  if (object == null) {
    return;
  }

  if (Array.isArray(object)) {
    for (var i = 0; i < object.length; i++) {
      callback(i.toString(), object[i]);
    }

    return;
  }

  for (var _i = 0, _Object$entries = Object.entries(object); _i < _Object$entries.length; _i++) {
    var _ref3 = _Object$entries[_i];

    var _ref2 = _slicedToArray(_ref3, 2);

    var key = _ref2[0];
    var value = _ref2[1];
    callback(key, value);
  }
}

function _cloneObject(object) {
  var copy = {};
  var keys2 = Object.keys(object);

  for (var i = 0; i < keys2.length; i++) {
    var key = keys2[i];
    var value = object[key];
    copy[key] = value;
  }

  return copy;
}

function _deepCloneDefinition(object, keysToSkip) {
  if (!object) {
    return;
  }

  var obj = object;
  var res = {};
  Object.keys(obj).forEach(function (key) {
    if (keysToSkip && keysToSkip.indexOf(key) >= 0) {
      return;
    }

    var value = obj[key];
    var sourceIsSimpleObject = _isNonNullObject(value) && value.constructor === Object;

    if (sourceIsSimpleObject) {
      res[key] = _deepCloneDefinition(value);
    } else {
      res[key] = value;
    }
  });
  return res;
}

function _getAllValuesInObject(obj) {
  if (!obj) {
    return [];
  }

  var anyObject = Object;

  if (typeof anyObject.values === "function") {
    return anyObject.values(obj);
  }

  var ret = [];

  for (var key in obj) {
    if (obj.hasOwnProperty(key) && obj.propertyIsEnumerable(key)) {
      ret.push(obj[key]);
    }
  }

  return ret;
}

function _mergeDeep(dest, source) {
  var copyUndefined = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var makeCopyOfSimpleObjects = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!_exists(source)) {
    return;
  }

  _iterateObject(source, function (key, sourceValue) {
    var destValue = dest[key];

    if (destValue === sourceValue) {
      return;
    }

    if (makeCopyOfSimpleObjects) {
      var objectIsDueToBeCopied = destValue == null && sourceValue != null;

      if (objectIsDueToBeCopied) {
        var sourceIsSimpleObject = typeof sourceValue === "object" && sourceValue.constructor === Object;
        var dontCopy = sourceIsSimpleObject;

        if (dontCopy) {
          destValue = {};
          dest[key] = destValue;
        }
      }
    }

    if (_isNonNullObject(sourceValue) && _isNonNullObject(destValue) && !Array.isArray(destValue)) {
      _mergeDeep(destValue, sourceValue, copyUndefined, makeCopyOfSimpleObjects);
    } else if (copyUndefined || sourceValue !== void 0) {
      dest[key] = sourceValue;
    }
  });
}

function _getValueUsingField(data, field, fieldContainsDots) {
  if (!field || !data) {
    return;
  }

  if (!fieldContainsDots) {
    return data[field];
  }

  var fields = field.split(".");
  var currentObject = data;

  for (var i = 0; i < fields.length; i++) {
    if (currentObject == null) {
      return void 0;
    }

    currentObject = currentObject[fields[i]];
  }

  return currentObject;
}

function _removeAllReferences(obj) {
  var preserveKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var preDestroyLink = arguments.length > 2 ? arguments[2] : undefined;
  Object.keys(obj).forEach(function (key) {
    var value = obj[key];

    if (typeof value === "object" && !preserveKeys.includes(key)) {
      obj[key] = void 0;
    }
  });
  var proto = Object.getPrototypeOf(obj);
  var properties = {};

  var msgFunc = function msgFunc(key) {
    return "AG Grid: Grid API function ".concat(key, "() cannot be called as the grid has been destroyed.\n    It is recommended to remove local references to the grid api. Alternatively, check gridApi.isDestroyed() to avoid calling methods against a destroyed grid.\n    To run logic when the grid is about to be destroyed use the gridPreDestroy event. See: ").concat(preDestroyLink);
  };

  Object.getOwnPropertyNames(proto).forEach(function (key) {
    var value = proto[key];

    if (typeof value === "function" && !preserveKeys.includes(key)) {
      var func = function func() {
        console.warn(msgFunc(key));
      };

      properties[key] = {
        value: func,
        writable: true
      };
    }
  });
  Object.defineProperties(obj, properties);
}

function _isNonNullObject(value) {
  return typeof value === "object" && value !== null;
} // community-modules/core/src/utils/function.ts


var function_exports = {};

__export(function_exports, {
  compose: function compose() {
    return _compose;
  },
  debounce: function debounce() {
    return _debounce;
  },
  doOnce: function doOnce() {
    return _doOnce;
  },
  errorOnce: function errorOnce() {
    return _errorOnce;
  },
  executeAfter: function executeAfter() {
    return _executeAfter;
  },
  executeInAWhile: function executeInAWhile() {
    return _executeInAWhile;
  },
  executeNextVMTurn: function executeNextVMTurn() {
    return _executeNextVMTurn;
  },
  getFunctionName: function getFunctionName() {
    return _getFunctionName;
  },
  isFunction: function isFunction() {
    return _isFunction;
  },
  noop: function noop() {
    return _noop;
  },
  throttle: function throttle() {
    return _throttle;
  },
  waitUntil: function waitUntil() {
    return _waitUntil;
  },
  warnOnce: function warnOnce() {
    return _warnOnce;
  }
});

var doOnceFlags = {};

function _doOnce(func, key) {
  if (doOnceFlags[key]) {
    return;
  }

  func();
  doOnceFlags[key] = true;
}

function _warnOnce(msg) {
  _doOnce(function () {
    return console.warn("AG Grid: " + msg);
  }, msg);
}

function _errorOnce(msg) {
  _doOnce(function () {
    return console.error("AG Grid: " + msg);
  }, msg);
}

function _getFunctionName(funcConstructor) {
  if (funcConstructor.name) {
    return funcConstructor.name;
  }

  var matches = /function\s+([^\(]+)/.exec(funcConstructor.toString());
  return matches && matches.length === 2 ? matches[1].trim() : null;
}

function _isFunction(val) {
  return !!(val && val.constructor && val.call && val.apply);
}

function _executeInAWhile(funcs) {
  _executeAfter(funcs, 400);
}

var executeNextVMTurnFuncs = [];
var executeNextVMTurnPending = false;

function _executeNextVMTurn(func) {
  executeNextVMTurnFuncs.push(func);

  if (executeNextVMTurnPending) {
    return;
  }

  executeNextVMTurnPending = true;
  window.setTimeout(function () {
    var funcsCopy = executeNextVMTurnFuncs.slice();
    executeNextVMTurnFuncs.length = 0;
    executeNextVMTurnPending = false;
    funcsCopy.forEach(function (func2) {
      return func2();
    });
  }, 0);
}

function _executeAfter(funcs) {
  var milliseconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (funcs.length > 0) {
    window.setTimeout(function () {
      return funcs.forEach(function (func) {
        return func();
      });
    }, milliseconds);
  }
}

function _debounce(func, delay) {
  var timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = this;
    window.clearTimeout(timeout);
    timeout = window.setTimeout(function () {
      func.apply(context, args);
    }, delay);
  };
}

function _throttle(func, wait) {
  var previousCall = 0;
  return function () {
    var context = this;
    var currentCall =
    /* @__PURE__ */
    new Date().getTime();

    if (currentCall - previousCall < wait) {
      return;
    }

    previousCall = currentCall;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    func.apply(context, args);
  };
}

function _waitUntil(condition, callback) {
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
  var timeoutMessage = arguments.length > 3 ? arguments[3] : undefined;
  var timeStamp =
  /* @__PURE__ */
  new Date().getTime();
  var interval = null;
  var executed = false;

  var internalCallback = function internalCallback() {
    var reachedTimeout =
    /* @__PURE__ */
    new Date().getTime() - timeStamp > timeout;

    if (condition() || reachedTimeout) {
      callback();
      executed = true;

      if (interval != null) {
        window.clearInterval(interval);
        interval = null;
      }

      if (reachedTimeout && timeoutMessage) {
        console.warn(timeoutMessage);
      }
    }
  };

  internalCallback();

  if (!executed) {
    interval = window.setInterval(internalCallback, 10);
  }
}

function _compose() {
  for (var _len3 = arguments.length, fns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    fns[_key3] = arguments[_key3];
  }

  return function (arg) {
    return fns.reduce(function (composed, f) {
      return f(composed);
    }, arg);
  };
}

var _noop = function _noop() {
  return;
}; // community-modules/core/src/modules/moduleNames.ts


var _ModuleNames =
/* @__PURE__ */
function (ModuleNames2) {
  ModuleNames2["CommunityCoreModule"] = "@ag-grid-community/core";
  ModuleNames2["InfiniteRowModelModule"] = "@ag-grid-community/infinite-row-model";
  ModuleNames2["ClientSideRowModelModule"] = "@ag-grid-community/client-side-row-model";
  ModuleNames2["CsvExportModule"] = "@ag-grid-community/csv-export";
  ModuleNames2["EnterpriseCoreModule"] = "@ag-grid-enterprise/core";
  ModuleNames2["RowGroupingModule"] = "@ag-grid-enterprise/row-grouping";
  ModuleNames2["ColumnsToolPanelModule"] = "@ag-grid-enterprise/column-tool-panel";
  ModuleNames2["FiltersToolPanelModule"] = "@ag-grid-enterprise/filter-tool-panel";
  ModuleNames2["MenuModule"] = "@ag-grid-enterprise/menu";
  ModuleNames2["SetFilterModule"] = "@ag-grid-enterprise/set-filter";
  ModuleNames2["MultiFilterModule"] = "@ag-grid-enterprise/multi-filter";
  ModuleNames2["StatusBarModule"] = "@ag-grid-enterprise/status-bar";
  ModuleNames2["SideBarModule"] = "@ag-grid-enterprise/side-bar";
  ModuleNames2["RangeSelectionModule"] = "@ag-grid-enterprise/range-selection";
  ModuleNames2["MasterDetailModule"] = "@ag-grid-enterprise/master-detail";
  ModuleNames2["RichSelectModule"] = "@ag-grid-enterprise/rich-select";
  ModuleNames2["GridChartsModule"] = "@ag-grid-enterprise/charts";
  ModuleNames2["ViewportRowModelModule"] = "@ag-grid-enterprise/viewport-row-model";
  ModuleNames2["ServerSideRowModelModule"] = "@ag-grid-enterprise/server-side-row-model";
  ModuleNames2["ExcelExportModule"] = "@ag-grid-enterprise/excel-export";
  ModuleNames2["ClipboardModule"] = "@ag-grid-enterprise/clipboard";
  ModuleNames2["SparklinesModule"] = "@ag-grid-enterprise/sparklines";
  ModuleNames2["AdvancedFilterModule"] = "@ag-grid-enterprise/advanced-filter";
  ModuleNames2["AngularModule"] = "@ag-grid-community/angular";
  ModuleNames2["ReactModule"] = "@ag-grid-community/react";
  ModuleNames2["VueModule"] = "@ag-grid-community/vue";
  return ModuleNames2;
}(_ModuleNames || {}); // community-modules/core/src/modules/moduleRegistry.ts


var _ModuleRegistry =
/*#__PURE__*/
function () {
  "use strict";

  function _ModuleRegistry() {
    _classCallCheck(this, _ModuleRegistry);
  }

  _createClass(_ModuleRegistry, null, [{
    key: "register",

    /**
     * Globally register the given module for all grids.
     * @param module - module to register
     */
    value: function register(module2) {
      _ModuleRegistry.__register(module2, true, void 0);
    }
    /**
     * Globally register the given modules for all grids.
     * @param modules - modules to register
     */

  }, {
    key: "registerModules",
    value: function registerModules(modules) {
      _ModuleRegistry.__registerModules(modules, true, void 0);
    }
    /** AG GRID INTERNAL - Module registration helper. */

  }, {
    key: "__register",
    value: function __register(module2, moduleBased, gridId) {
      _ModuleRegistry.runVersionChecks(module2);

      if (gridId !== void 0) {
        _ModuleRegistry.areGridScopedModules = true;

        if (_ModuleRegistry.gridModulesMap[gridId] === void 0) {
          _ModuleRegistry.gridModulesMap[gridId] = {};
        }

        _ModuleRegistry.gridModulesMap[gridId][module2.moduleName] = module2;
      } else {
        _ModuleRegistry.globalModulesMap[module2.moduleName] = module2;
      }

      _ModuleRegistry.setModuleBased(moduleBased);
    }
    /** AG GRID INTERNAL - Unregister grid scoped module. */

  }, {
    key: "__unRegisterGridModules",
    value: function __unRegisterGridModules(gridId) {
      delete _ModuleRegistry.gridModulesMap[gridId];
    }
    /** AG GRID INTERNAL - Module registration helper. */

  }, {
    key: "__registerModules",
    value: function __registerModules(modules, moduleBased, gridId) {
      _ModuleRegistry.setModuleBased(moduleBased);

      if (!modules) {
        return;
      }

      modules.forEach(function (module2) {
        return _ModuleRegistry.__register(module2, moduleBased, gridId);
      });
    }
  }, {
    key: "isValidModuleVersion",
    value: function isValidModuleVersion(module2) {
      var _ref4 = module2.version.split(".") || [],
          _ref5 = _slicedToArray(_ref4, 2),
          moduleMajor = _ref5[0],
          moduleMinor = _ref5[1];

      var _ref6 = _ModuleRegistry.currentModuleVersion.split(".") || [],
          _ref7 = _slicedToArray(_ref6, 2),
          currentModuleMajor = _ref7[0],
          currentModuleMinor = _ref7[1];

      return moduleMajor === currentModuleMajor && moduleMinor === currentModuleMinor;
    }
  }, {
    key: "runVersionChecks",
    value: function runVersionChecks(module2) {
      if (!_ModuleRegistry.currentModuleVersion) {
        _ModuleRegistry.currentModuleVersion = module2.version;
      }

      if (!module2.version) {
        console.error("AG Grid: You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. '".concat(module2.moduleName, "' is incompatible. Please update all modules to the same version."));
      } else if (!_ModuleRegistry.isValidModuleVersion(module2)) {
        console.error("AG Grid: You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. '".concat(module2.moduleName, "' is version ").concat(module2.version, " but the other modules are version ").concat(this.currentModuleVersion, ". Please update all modules to the same version."));
      }

      if (module2.validate) {
        var result = module2.validate();

        if (!result.isValid) {
          var errorResult = result;
          console.error("AG Grid: ".concat(errorResult.message));
        }
      }
    }
  }, {
    key: "setModuleBased",
    value: function setModuleBased(moduleBased) {
      if (_ModuleRegistry.moduleBased === void 0) {
        _ModuleRegistry.moduleBased = moduleBased;
      } else {
        if (_ModuleRegistry.moduleBased !== moduleBased) {
          _doOnce(function () {
            console.warn("AG Grid: You are mixing modules (i.e. @ag-grid-community/core) and packages (ag-grid-community) - you can only use one or the other of these mechanisms.");
            console.warn("Please see https://www.ag-grid.com/javascript-grid/modules/ for more information.");
          }, "ModulePackageCheck");
        }
      }
    }
    /**
     * AG GRID INTERNAL - Set if files are being served from a single UMD bundle to provide accurate enterprise upgrade steps.
     */

  }, {
    key: "__setIsBundled",
    value: function __setIsBundled() {
      _ModuleRegistry.isBundled = true;
    }
    /** AG GRID INTERNAL - Assert a given module has been register, globally or individually with this grid. */

  }, {
    key: "__assertRegistered",
    value: function __assertRegistered(moduleName, reason, gridId) {
      var _a;

      if (this.__isRegistered(moduleName, gridId)) {
        return true;
      }

      var warningKey = reason + moduleName;
      var warningMessage;

      if (_ModuleRegistry.isBundled) {
        {
          warningMessage = "AG Grid: unable to use ".concat(reason, " as 'ag-grid-enterprise' has not been loaded. Check you are using the Enterprise bundle:\n        \n        <script src=\"https://cdn.jsdelivr.net/npm/ag-grid-enterprise@AG_GRID_VERSION/dist/ag-grid-enterprise.min.js\"></script>\n        \nFor more info see: https://ag-grid.com/javascript-data-grid/getting-started/#getting-started-with-ag-grid-enterprise");
        }
      } else if (_ModuleRegistry.moduleBased || _ModuleRegistry.moduleBased === void 0) {
        var modName = (_a = Object.entries(_ModuleNames).find(function (_ref8) {
          var _ref9 = _slicedToArray(_ref8, 2),
              k = _ref9[0],
              v = _ref9[1];

          return v === moduleName;
        })) == null ? void 0 : _a[0];
        warningMessage = "AG Grid: unable to use ".concat(reason, " as the ").concat(modName, " is not registered").concat(_ModuleRegistry.areGridScopedModules ? " for gridId: ".concat(gridId) : "", ". Check if you have registered the module:\n           \n    import { ModuleRegistry } from '@ag-grid-community/core';\n    import { ").concat(modName, " } from '").concat(moduleName, "';\n    \n    ModuleRegistry.registerModules([ ").concat(modName, " ]);\n\nFor more info see: https://www.ag-grid.com/javascript-grid/modules/");
      } else {
        warningMessage = "AG Grid: unable to use ".concat(reason, " as package 'ag-grid-enterprise' has not been imported. Check that you have imported the package:\n            \n    import 'ag-grid-enterprise';");
      }

      _doOnce(function () {
        console.warn(warningMessage);
      }, warningKey);

      return false;
    }
    /** AG GRID INTERNAL - Is the given module registered, globally or individually with this grid. */

  }, {
    key: "__isRegistered",
    value: function __isRegistered(moduleName, gridId) {
      var _a;

      return !!_ModuleRegistry.globalModulesMap[moduleName] || !!((_a = _ModuleRegistry.gridModulesMap[gridId]) == null ? void 0 : _a[moduleName]);
    }
    /** AG GRID INTERNAL - Get all registered modules globally / individually for this grid. */

  }, {
    key: "__getRegisteredModules",
    value: function __getRegisteredModules(gridId) {
      return [].concat(_toConsumableArray(_values(_ModuleRegistry.globalModulesMap)), _toConsumableArray(_values(_ModuleRegistry.gridModulesMap[gridId] || {})));
    }
    /** AG GRID INTERNAL - Get the list of modules registered individually for this grid. */

  }, {
    key: "__getGridRegisteredModules",
    value: function __getGridRegisteredModules(gridId) {
      var _a;

      return _values((_a = _ModuleRegistry.gridModulesMap[gridId]) != null ? _a : {}) || [];
    }
    /** INTERNAL */

  }, {
    key: "__isPackageBased",
    value: function __isPackageBased() {
      return !_ModuleRegistry.moduleBased;
    }
  }]);

  return _ModuleRegistry;
}(); // having in a map a) removes duplicates and b) allows fast lookup


_ModuleRegistry.globalModulesMap = {};
_ModuleRegistry.gridModulesMap = {};
_ModuleRegistry.areGridScopedModules = false;
var _ModuleRegistry2 = _ModuleRegistry; // community-modules/core/src/context/context.ts

var _Context =
/*#__PURE__*/
function () {
  "use strict";

  function _Context(params, logger) {
    _classCallCheck(this, _Context);

    this.beanWrappers = {};
    this.destroyed = false;

    if (!params || !params.beanClasses) {
      return;
    }

    this.contextParams = params;
    this.logger = logger;
    this.logger.log(">> creating ag-Application Context");
    this.createBeans();
    var beanInstances = this.getBeanInstances();
    this.wireBeans(beanInstances);
    this.logger.log(">> ag-Application Context ready - component is alive");
  }

  _createClass(_Context, [{
    key: "getBeanInstances",
    value: function getBeanInstances() {
      return _values(this.beanWrappers).map(function (beanEntry) {
        return beanEntry.beanInstance;
      });
    }
  }, {
    key: "createBean",
    value: function createBean(bean, afterPreCreateCallback) {
      if (!bean) {
        throw Error("Can't wire to bean since it is null");
      }

      this.wireBeans([bean], afterPreCreateCallback);
      return bean;
    }
  }, {
    key: "wireBeans",
    value: function wireBeans(beanInstances, afterPreCreateCallback) {
      this.autoWireBeans(beanInstances);
      this.methodWireBeans(beanInstances);
      this.callLifeCycleMethods(beanInstances, "preConstructMethods");

      if (_exists(afterPreCreateCallback)) {
        beanInstances.forEach(afterPreCreateCallback);
      }

      this.callLifeCycleMethods(beanInstances, "postConstructMethods");
    }
  }, {
    key: "createBeans",
    value: function createBeans() {
      var _this = this;

      this.contextParams.beanClasses.forEach(this.createBeanWrapper.bind(this));

      _iterateObject(this.beanWrappers, function (key, beanEntry) {
        var constructorParamsMeta;

        if (beanEntry.bean.__agBeanMetaData && beanEntry.bean.__agBeanMetaData.autowireMethods && beanEntry.bean.__agBeanMetaData.autowireMethods.agConstructor) {
          constructorParamsMeta = beanEntry.bean.__agBeanMetaData.autowireMethods.agConstructor;
        }

        var constructorParams = _this.getBeansForParameters(constructorParamsMeta, beanEntry.bean.name);

        var newInstance = new (beanEntry.bean.bind.apply(beanEntry.bean, [null].concat(_toConsumableArray(constructorParams))))();
        beanEntry.beanInstance = newInstance;
      });

      var createdBeanNames = Object.keys(this.beanWrappers).join(", ");
      this.logger.log("created beans: ".concat(createdBeanNames));
    } // tslint:disable-next-line

  }, {
    key: "createBeanWrapper",
    value: function createBeanWrapper(BeanClass) {
      var metaData = BeanClass.__agBeanMetaData;

      if (!metaData) {
        var beanName;

        if (BeanClass.prototype.constructor) {
          beanName = _getFunctionName(BeanClass.prototype.constructor);
        } else {
          beanName = "" + BeanClass;
        }

        console.error("Context item ".concat(beanName, " is not a bean"));
        return;
      }

      var beanEntry = {
        bean: BeanClass,
        beanInstance: null,
        beanName: metaData.beanName
      };
      this.beanWrappers[metaData.beanName] = beanEntry;
    }
  }, {
    key: "autoWireBeans",
    value: function autoWireBeans(beanInstances) {
      var _this2 = this;

      beanInstances.forEach(function (beanInstance) {
        _this2.forEachMetaDataInHierarchy(beanInstance, function (metaData, beanName) {
          var attributes = metaData.agClassAttributes;

          if (!attributes) {
            return;
          }

          attributes.forEach(function (attribute) {
            var otherBean = _this2.lookupBeanInstance(beanName, attribute.beanName, attribute.optional);

            beanInstance[attribute.attributeName] = otherBean;
          });
        });
      });
    }
  }, {
    key: "methodWireBeans",
    value: function methodWireBeans(beanInstances) {
      var _this3 = this;

      beanInstances.forEach(function (beanInstance) {
        _this3.forEachMetaDataInHierarchy(beanInstance, function (metaData, beanName) {
          _iterateObject(metaData.autowireMethods, function (methodName, wireParams) {
            if (methodName === "agConstructor") {
              return;
            }

            var initParams = _this3.getBeansForParameters(wireParams, beanName);

            beanInstance[methodName].apply(beanInstance, initParams);
          });
        });
      });
    }
  }, {
    key: "forEachMetaDataInHierarchy",
    value: function forEachMetaDataInHierarchy(beanInstance, callback) {
      var prototype = Object.getPrototypeOf(beanInstance);

      while (prototype != null) {
        var _constructor = prototype.constructor;

        if (_constructor.hasOwnProperty("__agBeanMetaData")) {
          var metaData = _constructor.__agBeanMetaData;
          var beanName = this.getBeanName(_constructor);
          callback(metaData, beanName);
        }

        prototype = Object.getPrototypeOf(prototype);
      }
    }
  }, {
    key: "getBeanName",
    value: function getBeanName(constructor) {
      if (constructor.__agBeanMetaData && constructor.__agBeanMetaData.beanName) {
        return constructor.__agBeanMetaData.beanName;
      }

      var constructorString = constructor.toString();
      var beanName = constructorString.substring(9, constructorString.indexOf("("));
      return beanName;
    }
  }, {
    key: "getBeansForParameters",
    value: function getBeansForParameters(parameters, beanName) {
      var _this4 = this;

      var beansList = [];

      if (parameters) {
        _iterateObject(parameters, function (paramIndex, otherBeanName) {
          var otherBean = _this4.lookupBeanInstance(beanName, otherBeanName);

          beansList[Number(paramIndex)] = otherBean;
        });
      }

      return beansList;
    }
  }, {
    key: "lookupBeanInstance",
    value: function lookupBeanInstance(wiringBean, beanName) {
      var optional = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (this.destroyed) {
        this.logger.log("AG Grid: bean reference ".concat(beanName, " is used after the grid is destroyed!"));
        return null;
      }

      if (beanName === "context") {
        return this;
      }

      if (this.contextParams.providedBeanInstances && this.contextParams.providedBeanInstances.hasOwnProperty(beanName)) {
        return this.contextParams.providedBeanInstances[beanName];
      }

      var beanEntry = this.beanWrappers[beanName];

      if (beanEntry) {
        return beanEntry.beanInstance;
      }

      if (!optional) {
        console.error("AG Grid: unable to find bean reference ".concat(beanName, " while initialising ").concat(wiringBean));
      }

      return null;
    }
  }, {
    key: "callLifeCycleMethods",
    value: function callLifeCycleMethods(beanInstances, lifeCycleMethod) {
      var _this5 = this;

      beanInstances.forEach(function (beanInstance) {
        return _this5.callLifeCycleMethodsOnBean(beanInstance, lifeCycleMethod);
      });
    }
  }, {
    key: "callLifeCycleMethodsOnBean",
    value: function callLifeCycleMethodsOnBean(beanInstance, lifeCycleMethod, methodToIgnore) {
      var allMethods = {};
      this.forEachMetaDataInHierarchy(beanInstance, function (metaData) {
        var methods = metaData[lifeCycleMethod];

        if (methods) {
          methods.forEach(function (methodName) {
            if (methodName != methodToIgnore) {
              allMethods[methodName] = true;
            }
          });
        }
      });
      var allMethodsList = Object.keys(allMethods);
      allMethodsList.forEach(function (methodName) {
        return beanInstance[methodName]();
      });
    }
  }, {
    key: "getBean",
    value: function getBean(name) {
      return this.lookupBeanInstance("getBean", name, true);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.destroyed) {
        return;
      }

      this.destroyed = true;
      this.logger.log(">> Shutting down ag-Application Context");
      var beanInstances = this.getBeanInstances();
      this.destroyBeans(beanInstances);
      this.contextParams.providedBeanInstances = null;

      _ModuleRegistry2.__unRegisterGridModules(this.contextParams.gridId);

      this.logger.log(">> ag-Application Context shut down - component is dead");
    }
  }, {
    key: "destroyBean",
    value: function destroyBean(bean) {
      if (!bean) {
        return;
      }

      this.destroyBeans([bean]);
    }
  }, {
    key: "destroyBeans",
    value: function destroyBeans(beans) {
      var _this6 = this;

      if (!beans) {
        return [];
      }

      beans.forEach(function (bean) {
        _this6.callLifeCycleMethodsOnBean(bean, "preDestroyMethods", "destroy");

        var beanAny = bean;

        if (typeof beanAny.destroy === "function") {
          beanAny.destroy();
        }
      });
      return [];
    }
  }, {
    key: "isDestroyed",
    value: function isDestroyed() {
      return this.destroyed;
    }
  }, {
    key: "getGridId",
    value: function getGridId() {
      return this.contextParams.gridId;
    }
  }]);

  return _Context;
}();

function _PreConstruct(target, methodName, descriptor) {
  var props = getOrCreateProps(target.constructor);

  if (!props.preConstructMethods) {
    props.preConstructMethods = [];
  }

  props.preConstructMethods.push(methodName);
}

function _PostConstruct(target, methodName, descriptor) {
  var props = getOrCreateProps(target.constructor);

  if (!props.postConstructMethods) {
    props.postConstructMethods = [];
  }

  props.postConstructMethods.push(methodName);
}

function _PreDestroy(target, methodName, descriptor) {
  var props = getOrCreateProps(target.constructor);

  if (!props.preDestroyMethods) {
    props.preDestroyMethods = [];
  }

  props.preDestroyMethods.push(methodName);
}

function _Bean(beanName) {
  return function (classConstructor) {
    var props = getOrCreateProps(classConstructor);
    props.beanName = beanName;
  };
}

function _Autowired(name) {
  return function (target, propertyKey, descriptor) {
    autowiredFunc(target, name, false, target, propertyKey, null);
  };
}

function _Optional(name) {
  return function (target, propertyKey, descriptor) {
    autowiredFunc(target, name, true, target, propertyKey, null);
  };
}

function autowiredFunc(target, name, optional, classPrototype, methodOrAttributeName, index) {
  if (name === null) {
    console.error("AG Grid: Autowired name should not be null");
    return;
  }

  if (typeof index === "number") {
    console.error("AG Grid: Autowired should be on an attribute");
    return;
  }

  var props = getOrCreateProps(target.constructor);

  if (!props.agClassAttributes) {
    props.agClassAttributes = [];
  }

  props.agClassAttributes.push({
    attributeName: methodOrAttributeName,
    beanName: name,
    optional: optional
  });
}

function _Qualifier(name) {
  return function (classPrototype, methodOrAttributeName, index) {
    var constructor = typeof classPrototype == "function" ? classPrototype : classPrototype.constructor;
    var props;

    if (typeof index === "number") {
      var methodName;

      if (methodOrAttributeName) {
        props = getOrCreateProps(constructor);
        methodName = methodOrAttributeName;
      } else {
        props = getOrCreateProps(constructor);
        methodName = "agConstructor";
      }

      if (!props.autowireMethods) {
        props.autowireMethods = {};
      }

      if (!props.autowireMethods[methodName]) {
        props.autowireMethods[methodName] = {};
      }

      props.autowireMethods[methodName][index] = name;
    }
  };
}

function getOrCreateProps(target) {
  if (!target.hasOwnProperty("__agBeanMetaData")) {
    target.__agBeanMetaData = {};
  }

  return target.__agBeanMetaData;
} // community-modules/core/src/eventService.ts


var _EventService =
/*#__PURE__*/
function () {
  "use strict";

  function _EventService() {
    _classCallCheck(this, _EventService);

    this.allSyncListeners =
    /* @__PURE__ */
    new Map();
    this.allAsyncListeners =
    /* @__PURE__ */
    new Map();
    this.globalSyncListeners =
    /* @__PURE__ */
    new Set();
    this.globalAsyncListeners =
    /* @__PURE__ */
    new Set();
    this.asyncFunctionsQueue = [];
    this.scheduled = false; // using an object performs better than a Set for the number of different events we have

    this.firedEvents = {};
  } // because this class is used both inside the context and outside the context, we do not
  // use autowired attributes, as that would be confusing, as sometimes the attributes
  // would be wired, and sometimes not.
  //
  // the global event servers used by AG Grid is autowired by the context once, and this
  // setBeans method gets called once.
  //
  // the times when this class is used outside of the context (eg RowNode has an instance of this
  // class) then it is not a bean, and this setBeans method is not called.


  _createClass(_EventService, [{
    key: "setBeans",
    value: function setBeans(gos, frameworkOverrides) {
      var globalEventListener = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var globalSyncEventListener = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      this.frameworkOverrides = frameworkOverrides;
      this.gos = gos;

      if (globalEventListener) {
        var async = gos.useAsyncEvents();
        this.addGlobalListener(globalEventListener, async);
      }

      if (globalSyncEventListener) {
        this.addGlobalListener(globalSyncEventListener, false);
      }
    }
  }, {
    key: "setFrameworkOverrides",
    value: function setFrameworkOverrides(frameworkOverrides) {
      this.frameworkOverrides = frameworkOverrides;
    }
  }, {
    key: "getListeners",
    value: function getListeners(eventType, async, autoCreateListenerCollection) {
      var listenerMap = async ? this.allAsyncListeners : this.allSyncListeners;
      var listeners = listenerMap.get(eventType);

      if (!listeners && autoCreateListenerCollection) {
        listeners =
        /* @__PURE__ */
        new Set();
        listenerMap.set(eventType, listeners);
      }

      return listeners;
    }
  }, {
    key: "noRegisteredListenersExist",
    value: function noRegisteredListenersExist() {
      return this.allSyncListeners.size === 0 && this.allAsyncListeners.size === 0 && this.globalSyncListeners.size === 0 && this.globalAsyncListeners.size === 0;
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(eventType, listener) {
      var async = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      this.getListeners(eventType, async, true).add(listener);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventType, listener) {
      var async = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var listeners = this.getListeners(eventType, async, false);

      if (!listeners) {
        return;
      }

      listeners.delete(listener);

      if (listeners.size === 0) {
        var listenerMap = async ? this.allAsyncListeners : this.allSyncListeners;
        listenerMap.delete(eventType);
      }
    }
  }, {
    key: "addGlobalListener",
    value: function addGlobalListener(listener) {
      var async = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      (async ? this.globalAsyncListeners : this.globalSyncListeners).add(listener);
    }
  }, {
    key: "removeGlobalListener",
    value: function removeGlobalListener(listener) {
      var async = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      (async ? this.globalAsyncListeners : this.globalSyncListeners).delete(listener);
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      var agEvent = event;

      if (this.gos) {
        this.gos.addGridCommonParams(agEvent);
      }

      this.dispatchToListeners(agEvent, true);
      this.dispatchToListeners(agEvent, false);
      this.firedEvents[agEvent.type] = true;
    }
  }, {
    key: "dispatchEventOnce",
    value: function dispatchEventOnce(event) {
      if (!this.firedEvents[event.type]) {
        this.dispatchEvent(event);
      }
    }
  }, {
    key: "dispatchToListeners",
    value: function dispatchToListeners(event, async) {
      var _this7 = this;

      var _a;

      var eventType = event.type;

      if (async && "event" in event) {
        var browserEvent = event.event;

        if (browserEvent instanceof Event) {
          event.eventPath = browserEvent.composedPath();
        }
      }

      var processEventListeners = function processEventListeners(listeners2, originalListeners2) {
        return listeners2.forEach(function (listener) {
          if (!originalListeners2.has(listener)) {
            return;
          }

          var callback = _this7.frameworkOverrides ? function () {
            return _this7.frameworkOverrides.wrapIncoming(function () {
              return listener(event);
            });
          } : function () {
            return listener(event);
          };

          if (async) {
            _this7.dispatchAsync(callback);
          } else {
            callback();
          }
        });
      };

      var originalListeners = (_a = this.getListeners(eventType, async, false)) != null ? _a :
      /* @__PURE__ */
      new Set();
      var listeners = new Set(originalListeners);

      if (listeners.size > 0) {
        processEventListeners(listeners, originalListeners);
      }

      var globalListeners = new Set(async ? this.globalAsyncListeners : this.globalSyncListeners);
      globalListeners.forEach(function (listener) {
        var callback = _this7.frameworkOverrides ? function () {
          return _this7.frameworkOverrides.wrapIncoming(function () {
            return listener(eventType, event);
          });
        } : function () {
          return listener(eventType, event);
        };

        if (async) {
          _this7.dispatchAsync(callback);
        } else {
          callback();
        }
      });
    } // this gets called inside the grid's thread, for each event that it
    // wants to set async. the grid then batches the events into one setTimeout()
    // because setTimeout() is an expensive operation. ideally we would have
    // each event in it's own setTimeout(), but we batch for performance.

  }, {
    key: "dispatchAsync",
    value: function dispatchAsync(func) {
      var _this8 = this;

      this.asyncFunctionsQueue.push(func);

      if (!this.scheduled) {
        this.frameworkOverrides.wrapIncoming(function () {
          window.setTimeout(_this8.flushAsyncQueue.bind(_this8), 0);
        });
        this.scheduled = true;
      }
    } // this happens in the next VM turn only, and empties the queue of events

  }, {
    key: "flushAsyncQueue",
    value: function flushAsyncQueue() {
      this.scheduled = false;
      var queueCopy = this.asyncFunctionsQueue.slice();
      this.asyncFunctionsQueue = [];
      queueCopy.forEach(function (func) {
        return func();
      });
    }
  }]);

  return _EventService;
}();

__decorateClass([__decorateParam(0, _Qualifier("gridOptionsService")), __decorateParam(1, _Qualifier("frameworkOverrides")), __decorateParam(2, _Qualifier("globalEventListener")), __decorateParam(3, _Qualifier("globalSyncEventListener"))], _EventService.prototype, "setBeans", 1);

_EventService = __decorateClass([_Bean("eventService")], _EventService); // community-modules/core/src/misc/frameworkEventListenerService.ts

var FrameworkEventListenerService =
/*#__PURE__*/
function () {
  "use strict";

  function FrameworkEventListenerService(frameworkOverrides) {
    _classCallCheck(this, FrameworkEventListenerService);

    this.frameworkOverrides = frameworkOverrides; // Map from user listener to wrapped listener so we can remove listener provided by user

    this.wrappedListeners =
    /* @__PURE__ */
    new Map();
    this.wrappedGlobalListeners =
    /* @__PURE__ */
    new Map();
  }

  _createClass(FrameworkEventListenerService, [{
    key: "wrap",
    value: function wrap(userListener) {
      var _this9 = this;

      var listener = userListener;

      if (this.frameworkOverrides.shouldWrapOutgoing) {
        listener = function listener(event) {
          _this9.frameworkOverrides.wrapOutgoing(function () {
            return userListener(event);
          });
        };

        this.wrappedListeners.set(userListener, listener);
      }

      return listener;
    }
  }, {
    key: "wrapGlobal",
    value: function wrapGlobal(userListener) {
      var _this10 = this;

      var listener = userListener;

      if (this.frameworkOverrides.shouldWrapOutgoing) {
        listener = function listener(eventType, event) {
          _this10.frameworkOverrides.wrapOutgoing(function () {
            return userListener(eventType, event);
          });
        };

        this.wrappedGlobalListeners.set(userListener, listener);
      }

      return listener;
    }
  }, {
    key: "unwrap",
    value: function unwrap(userListener) {
      var _a;

      return (_a = this.wrappedListeners.get(userListener)) != null ? _a : userListener;
    }
  }, {
    key: "unwrapGlobal",
    value: function unwrapGlobal(userListener) {
      var _a;

      return (_a = this.wrappedGlobalListeners.get(userListener)) != null ? _a : userListener;
    }
  }]);

  return FrameworkEventListenerService;
}(); // community-modules/core/src/entities/column.ts


var COL_DEF_DEFAULTS = {
  resizable: true,
  sortable: true
};
var instanceIdSequence = 0;

function getNextColInstanceId() {
  return instanceIdSequence++;
}

var _Column =
/*#__PURE__*/
function () {
  "use strict";

  function _Column(colDef, userProvidedColDef, colId, primary) {
    _classCallCheck(this, _Column);

    // used by React (and possibly other frameworks) as key for rendering. also used to
    // identify old vs new columns for destroying cols when no longer used.
    this.instanceId = getNextColInstanceId(); // The measured height of this column's header when autoHeaderHeight is enabled

    this.autoHeaderHeight = null;
    this.moving = false;
    this.menuVisible = false;
    this.lastLeftPinned = false;
    this.firstRightPinned = false;
    this.filterActive = false;
    this.eventService = new _EventService();
    this.tooltipEnabled = false;
    this.rowGroupActive = false;
    this.pivotActive = false;
    this.aggregationActive = false;
    this.colDef = colDef;
    this.userProvidedColDef = userProvidedColDef;
    this.colId = colId;
    this.primary = primary;
    this.setState(colDef);
  }

  _createClass(_Column, [{
    key: "getInstanceId",
    value: function getInstanceId() {
      return this.instanceId;
    }
  }, {
    key: "setState",
    value: function setState(colDef) {
      if (colDef.sort !== void 0) {
        if (colDef.sort === "asc" || colDef.sort === "desc") {
          this.sort = colDef.sort;
        }
      } else {
        if (colDef.initialSort === "asc" || colDef.initialSort === "desc") {
          this.sort = colDef.initialSort;
        }
      }

      var sortIndex = colDef.sortIndex;
      var initialSortIndex = colDef.initialSortIndex;

      if (sortIndex !== void 0) {
        if (sortIndex !== null) {
          this.sortIndex = sortIndex;
        }
      } else {
        if (initialSortIndex !== null) {
          this.sortIndex = initialSortIndex;
        }
      }

      var hide = colDef.hide;
      var initialHide = colDef.initialHide;

      if (hide !== void 0) {
        this.visible = !hide;
      } else {
        this.visible = !initialHide;
      }

      if (colDef.pinned !== void 0) {
        this.setPinned(colDef.pinned);
      } else {
        this.setPinned(colDef.initialPinned);
      }

      var flex = colDef.flex;
      var initialFlex = colDef.initialFlex;

      if (flex !== void 0) {
        this.flex = flex;
      } else if (initialFlex !== void 0) {
        this.flex = initialFlex;
      }
    } // gets called when user provides an alternative colDef, eg

  }, {
    key: "setColDef",
    value: function setColDef(colDef, userProvidedColDef, source) {
      this.colDef = colDef;
      this.userProvidedColDef = userProvidedColDef;
      this.initMinAndMaxWidths();
      this.initDotNotation();
      this.initTooltip();
      this.eventService.dispatchEvent(this.createColumnEvent("colDefChanged", source));
    }
    /**
     * Returns the column definition provided by the application.
     * This may not be correct, as items can be superseded by default column options.
     * However it's useful for comparison, eg to know which application column definition matches that column.
     */

  }, {
    key: "getUserProvidedColDef",
    value: function getUserProvidedColDef() {
      return this.userProvidedColDef;
    }
  }, {
    key: "setParent",
    value: function setParent(parent) {
      this.parent = parent;
    }
    /** Returns the parent column group, if column grouping is active. */

  }, {
    key: "getParent",
    value: function getParent() {
      return this.parent;
    }
  }, {
    key: "setOriginalParent",
    value: function setOriginalParent(originalParent) {
      this.originalParent = originalParent;
    }
    /**
     * Used for marryChildren, helps with comparing when duplicate groups have been created to manage split groups.
     * 
     * Parent may contain a duplicate but not identical group when the group is split.
     */

  }, {
    key: "getOriginalParent",
    value: function getOriginalParent() {
      return this.originalParent;
    }
  }, {
    key: "initialise",
    value: function initialise() {
      this.initMinAndMaxWidths();
      this.resetActualWidth("gridInitializing");
      this.initDotNotation();
      this.initTooltip();
    }
  }, {
    key: "initDotNotation",
    value: function initDotNotation() {
      var suppressDotNotation = this.gos.get("suppressFieldDotNotation");
      this.fieldContainsDots = _exists(this.colDef.field) && this.colDef.field.indexOf(".") >= 0 && !suppressDotNotation;
      this.tooltipFieldContainsDots = _exists(this.colDef.tooltipField) && this.colDef.tooltipField.indexOf(".") >= 0 && !suppressDotNotation;
    }
  }, {
    key: "initMinAndMaxWidths",
    value: function initMinAndMaxWidths() {
      var _a, _b;

      var colDef = this.colDef;
      this.minWidth = (_a = colDef.minWidth) != null ? _a : this.environment.getMinColWidth();
      this.maxWidth = (_b = colDef.maxWidth) != null ? _b : Number.MAX_SAFE_INTEGER;
    }
  }, {
    key: "initTooltip",
    value: function initTooltip() {
      this.tooltipEnabled = _exists(this.colDef.tooltipField) || _exists(this.colDef.tooltipValueGetter) || _exists(this.colDef.tooltipComponent);
    }
  }, {
    key: "resetActualWidth",
    value: function resetActualWidth(source) {
      var initialWidth = this.calculateColInitialWidth(this.colDef);
      this.setActualWidth(initialWidth, source, true);
    }
  }, {
    key: "calculateColInitialWidth",
    value: function calculateColInitialWidth(colDef) {
      var _a, _b;

      var minColWidth = (_a = colDef.minWidth) != null ? _a : this.environment.getMinColWidth();
      var maxColWidth = (_b = colDef.maxWidth) != null ? _b : Number.MAX_SAFE_INTEGER;
      var width;

      var colDefWidth = _attrToNumber(colDef.width);

      var colDefInitialWidth = _attrToNumber(colDef.initialWidth);

      if (colDefWidth != null) {
        width = colDefWidth;
      } else if (colDefInitialWidth != null) {
        width = colDefInitialWidth;
      } else {
        width = 200;
      }

      return Math.max(Math.min(width, maxColWidth), minColWidth);
    }
  }, {
    key: "isEmptyGroup",
    value: function isEmptyGroup() {
      return false;
    }
  }, {
    key: "isRowGroupDisplayed",
    value: function isRowGroupDisplayed(colId) {
      if (_missing(this.colDef) || _missing(this.colDef.showRowGroup)) {
        return false;
      }

      var showingAllGroups = this.colDef.showRowGroup === true;
      var showingThisGroup = this.colDef.showRowGroup === colId;
      return showingAllGroups || showingThisGroup;
    }
    /** Returns `true` if column is a primary column, `false` if secondary. Secondary columns are used for pivoting. */

  }, {
    key: "isPrimary",
    value: function isPrimary() {
      return this.primary;
    }
    /** Returns `true` if column filtering is allowed. */

  }, {
    key: "isFilterAllowed",
    value: function isFilterAllowed() {
      var filterDefined = !!this.colDef.filter;
      return filterDefined;
    }
  }, {
    key: "isFieldContainsDots",
    value: function isFieldContainsDots() {
      return this.fieldContainsDots;
    }
  }, {
    key: "isTooltipEnabled",
    value: function isTooltipEnabled() {
      return this.tooltipEnabled;
    }
  }, {
    key: "isTooltipFieldContainsDots",
    value: function isTooltipFieldContainsDots() {
      return this.tooltipFieldContainsDots;
    }
    /** Add an event listener to the column. */

  }, {
    key: "addEventListener",
    value: function addEventListener(eventType, userListener) {
      var _a, _b;

      if (this.frameworkOverrides.shouldWrapOutgoing && !this.frameworkEventListenerService) {
        this.eventService.setFrameworkOverrides(this.frameworkOverrides);
        this.frameworkEventListenerService = new FrameworkEventListenerService(this.frameworkOverrides);
      }

      var listener = (_b = (_a = this.frameworkEventListenerService) == null ? void 0 : _a.wrap(userListener)) != null ? _b : userListener;
      this.eventService.addEventListener(eventType, listener);
    }
    /** Remove event listener from the column. */

  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventType, userListener) {
      var _a, _b;

      var listener = (_b = (_a = this.frameworkEventListenerService) == null ? void 0 : _a.unwrap(userListener)) != null ? _b : userListener;
      this.eventService.removeEventListener(eventType, listener);
    }
  }, {
    key: "createColumnFunctionCallbackParams",
    value: function createColumnFunctionCallbackParams(rowNode) {
      return this.gos.addGridCommonParams({
        node: rowNode,
        data: rowNode.data,
        column: this,
        colDef: this.colDef
      });
    }
  }, {
    key: "isSuppressNavigable",
    value: function isSuppressNavigable(rowNode) {
      if (typeof this.colDef.suppressNavigable === "boolean") {
        return this.colDef.suppressNavigable;
      }

      if (typeof this.colDef.suppressNavigable === "function") {
        var params = this.createColumnFunctionCallbackParams(rowNode);
        var userFunc = this.colDef.suppressNavigable;
        return userFunc(params);
      }

      return false;
    }
    /**
     * Returns `true` if the cell for this column is editable for the given `rowNode`, otherwise `false`.
     */

  }, {
    key: "isCellEditable",
    value: function isCellEditable(rowNode) {
      if (rowNode.group && !this.gos.get("enableGroupEdit")) {
        return false;
      }

      return this.isColumnFunc(rowNode, this.colDef.editable);
    }
  }, {
    key: "isSuppressFillHandle",
    value: function isSuppressFillHandle() {
      return !!this.colDef.suppressFillHandle;
    }
  }, {
    key: "isAutoHeight",
    value: function isAutoHeight() {
      return !!this.colDef.autoHeight;
    }
  }, {
    key: "isAutoHeaderHeight",
    value: function isAutoHeaderHeight() {
      return !!this.colDef.autoHeaderHeight;
    }
  }, {
    key: "isRowDrag",
    value: function isRowDrag(rowNode) {
      return this.isColumnFunc(rowNode, this.colDef.rowDrag);
    }
  }, {
    key: "isDndSource",
    value: function isDndSource(rowNode) {
      return this.isColumnFunc(rowNode, this.colDef.dndSource);
    }
  }, {
    key: "isCellCheckboxSelection",
    value: function isCellCheckboxSelection(rowNode) {
      return this.isColumnFunc(rowNode, this.colDef.checkboxSelection);
    }
  }, {
    key: "isSuppressPaste",
    value: function isSuppressPaste(rowNode) {
      return this.isColumnFunc(rowNode, this.colDef ? this.colDef.suppressPaste : null);
    }
  }, {
    key: "isResizable",
    value: function isResizable() {
      return !!this.getColDefValue("resizable");
    }
    /** Get value from ColDef or default if it exists. */

  }, {
    key: "getColDefValue",
    value: function getColDefValue(key) {
      var _a;

      return (_a = this.colDef[key]) != null ? _a : COL_DEF_DEFAULTS[key];
    }
  }, {
    key: "isColumnFunc",
    value: function isColumnFunc(rowNode, value) {
      if (typeof value === "boolean") {
        return value;
      }

      if (typeof value === "function") {
        var params = this.createColumnFunctionCallbackParams(rowNode);
        var editableFunc = value;
        return editableFunc(params);
      }

      return false;
    }
  }, {
    key: "setMoving",
    value: function setMoving(moving, source) {
      this.moving = moving;
      this.eventService.dispatchEvent(this.createColumnEvent("movingChanged", source));
    }
  }, {
    key: "createColumnEvent",
    value: function createColumnEvent(type, source) {
      return this.gos.addGridCommonParams({
        type: type,
        column: this,
        columns: [this],
        source: source
      });
    }
  }, {
    key: "isMoving",
    value: function isMoving() {
      return this.moving;
    }
    /** If sorting is active, returns the sort direction e.g. `'asc'` or `'desc'`. */

  }, {
    key: "getSort",
    value: function getSort() {
      return this.sort;
    }
  }, {
    key: "setSort",
    value: function setSort(sort, source) {
      if (this.sort !== sort) {
        this.sort = sort;
        this.eventService.dispatchEvent(this.createColumnEvent("sortChanged", source));
      }

      this.dispatchStateUpdatedEvent("sort");
    }
  }, {
    key: "setMenuVisible",
    value: function setMenuVisible(visible, source) {
      if (this.menuVisible !== visible) {
        this.menuVisible = visible;
        this.eventService.dispatchEvent(this.createColumnEvent("menuVisibleChanged", source));
      }
    }
  }, {
    key: "isMenuVisible",
    value: function isMenuVisible() {
      return this.menuVisible;
    }
  }, {
    key: "isSortable",
    value: function isSortable() {
      return !!this.getColDefValue("sortable");
    }
  }, {
    key: "isSortAscending",
    value: function isSortAscending() {
      return this.sort === "asc";
    }
  }, {
    key: "isSortDescending",
    value: function isSortDescending() {
      return this.sort === "desc";
    }
  }, {
    key: "isSortNone",
    value: function isSortNone() {
      return _missing(this.sort);
    }
  }, {
    key: "isSorting",
    value: function isSorting() {
      return _exists(this.sort);
    }
  }, {
    key: "getSortIndex",
    value: function getSortIndex() {
      return this.sortIndex;
    }
  }, {
    key: "setSortIndex",
    value: function setSortIndex(sortOrder) {
      this.sortIndex = sortOrder;
      this.dispatchStateUpdatedEvent("sortIndex");
    }
  }, {
    key: "setAggFunc",
    value: function setAggFunc(aggFunc) {
      this.aggFunc = aggFunc;
      this.dispatchStateUpdatedEvent("aggFunc");
    }
    /** If aggregation is set for the column, returns the aggregation function. */

  }, {
    key: "getAggFunc",
    value: function getAggFunc() {
      return this.aggFunc;
    }
  }, {
    key: "getLeft",
    value: function getLeft() {
      return this.left;
    }
  }, {
    key: "getOldLeft",
    value: function getOldLeft() {
      return this.oldLeft;
    }
  }, {
    key: "getRight",
    value: function getRight() {
      return this.left + this.actualWidth;
    }
  }, {
    key: "setLeft",
    value: function setLeft(left, source) {
      this.oldLeft = this.left;

      if (this.left !== left) {
        this.left = left;
        this.eventService.dispatchEvent(this.createColumnEvent("leftChanged", source));
      }
    }
    /** Returns `true` if filter is active on the column. */

  }, {
    key: "isFilterActive",
    value: function isFilterActive() {
      return this.filterActive;
    } // additionalEventAttributes is used by provided simple floating filter, so it can add 'floatingFilter=true' to the event

  }, {
    key: "setFilterActive",
    value: function setFilterActive(active, source, additionalEventAttributes) {
      if (this.filterActive !== active) {
        this.filterActive = active;
        this.eventService.dispatchEvent(this.createColumnEvent("filterActiveChanged", source));
      }

      var filterChangedEvent = this.createColumnEvent("filterChanged", source);

      if (additionalEventAttributes) {
        _mergeDeep(filterChangedEvent, additionalEventAttributes);
      }

      this.eventService.dispatchEvent(filterChangedEvent);
    }
    /** Returns `true` when this `Column` is hovered, otherwise `false` */

  }, {
    key: "isHovered",
    value: function isHovered() {
      return this.columnHoverService.isHovered(this);
    }
  }, {
    key: "setPinned",
    value: function setPinned(pinned) {
      if (pinned === true || pinned === "left") {
        this.pinned = "left";
      } else if (pinned === "right") {
        this.pinned = "right";
      } else {
        this.pinned = null;
      }

      this.dispatchStateUpdatedEvent("pinned");
    }
  }, {
    key: "setFirstRightPinned",
    value: function setFirstRightPinned(firstRightPinned, source) {
      if (this.firstRightPinned !== firstRightPinned) {
        this.firstRightPinned = firstRightPinned;
        this.eventService.dispatchEvent(this.createColumnEvent("firstRightPinnedChanged", source));
      }
    }
  }, {
    key: "setLastLeftPinned",
    value: function setLastLeftPinned(lastLeftPinned, source) {
      if (this.lastLeftPinned !== lastLeftPinned) {
        this.lastLeftPinned = lastLeftPinned;
        this.eventService.dispatchEvent(this.createColumnEvent("lastLeftPinnedChanged", source));
      }
    }
  }, {
    key: "isFirstRightPinned",
    value: function isFirstRightPinned() {
      return this.firstRightPinned;
    }
  }, {
    key: "isLastLeftPinned",
    value: function isLastLeftPinned() {
      return this.lastLeftPinned;
    }
  }, {
    key: "isPinned",
    value: function isPinned() {
      return this.pinned === "left" || this.pinned === "right";
    }
  }, {
    key: "isPinnedLeft",
    value: function isPinnedLeft() {
      return this.pinned === "left";
    }
  }, {
    key: "isPinnedRight",
    value: function isPinnedRight() {
      return this.pinned === "right";
    }
  }, {
    key: "getPinned",
    value: function getPinned() {
      return this.pinned;
    }
  }, {
    key: "setVisible",
    value: function setVisible(visible, source) {
      var newValue = visible === true;

      if (this.visible !== newValue) {
        this.visible = newValue;
        this.eventService.dispatchEvent(this.createColumnEvent("visibleChanged", source));
      }

      this.dispatchStateUpdatedEvent("hide");
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return this.visible;
    }
  }, {
    key: "isSpanHeaderHeight",
    value: function isSpanHeaderHeight() {
      var colDef = this.getColDef();
      return !colDef.suppressSpanHeaderHeight && !colDef.autoHeaderHeight;
    }
  }, {
    key: "getColumnGroupPaddingInfo",
    value: function getColumnGroupPaddingInfo() {
      var parent = this.getParent();

      if (!parent || !parent.isPadding()) {
        return {
          numberOfParents: 0,
          isSpanningTotal: false
        };
      }

      var numberOfParents = parent.getPaddingLevel() + 1;
      var isSpanningTotal = true;

      while (parent) {
        if (!parent.isPadding()) {
          isSpanningTotal = false;
          break;
        }

        parent = parent.getParent();
      }

      return {
        numberOfParents: numberOfParents,
        isSpanningTotal: isSpanningTotal
      };
    }
    /** Returns the column definition for this column.
     * The column definition will be the result of merging the application provided column definition with any provided defaults
     * (e.g. `defaultColDef` grid option, or column types.
     *
     * Equivalent: `getDefinition` */

  }, {
    key: "getColDef",
    value: function getColDef() {
      return this.colDef;
    }
  }, {
    key: "getColumnGroupShow",
    value: function getColumnGroupShow() {
      return this.colDef.columnGroupShow;
    }
    /**
     * Returns the unique ID for the column.
     *
     * Equivalent: `getId`, `getUniqueId` */

  }, {
    key: "getColId",
    value: function getColId() {
      return this.colId;
    }
    /**
     * Returns the unique ID for the column.
     *
     * Equivalent: `getColId`, `getUniqueId` */

  }, {
    key: "getId",
    value: function getId() {
      return this.colId;
    }
    /**
     * Returns the unique ID for the column.
     *
     * Equivalent: `getColId`, `getId` */

  }, {
    key: "getUniqueId",
    value: function getUniqueId() {
      return this.colId;
    }
  }, {
    key: "getDefinition",
    value: function getDefinition() {
      return this.colDef;
    }
    /** Returns the current width of the column. If the column is resized, the actual width is the new size. */

  }, {
    key: "getActualWidth",
    value: function getActualWidth() {
      return this.actualWidth;
    }
  }, {
    key: "getAutoHeaderHeight",
    value: function getAutoHeaderHeight() {
      return this.autoHeaderHeight;
    }
    /** Returns true if the header height has changed */

  }, {
    key: "setAutoHeaderHeight",
    value: function setAutoHeaderHeight(height) {
      var changed = height !== this.autoHeaderHeight;
      this.autoHeaderHeight = height;
      return changed;
    }
  }, {
    key: "createBaseColDefParams",
    value: function createBaseColDefParams(rowNode) {
      var params = this.gos.addGridCommonParams({
        node: rowNode,
        data: rowNode.data,
        colDef: this.colDef,
        column: this
      });
      return params;
    }
  }, {
    key: "getColSpan",
    value: function getColSpan(rowNode) {
      if (_missing(this.colDef.colSpan)) {
        return 1;
      }

      var params = this.createBaseColDefParams(rowNode);
      var colSpan = this.colDef.colSpan(params);
      return Math.max(colSpan, 1);
    }
  }, {
    key: "getRowSpan",
    value: function getRowSpan(rowNode) {
      if (_missing(this.colDef.rowSpan)) {
        return 1;
      }

      var params = this.createBaseColDefParams(rowNode);
      var rowSpan = this.colDef.rowSpan(params);
      return Math.max(rowSpan, 1);
    }
  }, {
    key: "setActualWidth",
    value: function setActualWidth(actualWidth, source) {
      var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (this.minWidth != null) {
        actualWidth = Math.max(actualWidth, this.minWidth);
      }

      if (this.maxWidth != null) {
        actualWidth = Math.min(actualWidth, this.maxWidth);
      }

      if (this.actualWidth !== actualWidth) {
        this.actualWidth = actualWidth;

        if (this.flex && source !== "flex" && source !== "gridInitializing") {
          this.flex = null;
        }

        if (!silent) {
          this.fireColumnWidthChangedEvent(source);
        }
      }

      this.dispatchStateUpdatedEvent("width");
    }
  }, {
    key: "fireColumnWidthChangedEvent",
    value: function fireColumnWidthChangedEvent(source) {
      this.eventService.dispatchEvent(this.createColumnEvent("widthChanged", source));
    }
  }, {
    key: "isGreaterThanMax",
    value: function isGreaterThanMax(width) {
      if (this.maxWidth != null) {
        return width > this.maxWidth;
      }

      return false;
    }
  }, {
    key: "getMinWidth",
    value: function getMinWidth() {
      return this.minWidth;
    }
  }, {
    key: "getMaxWidth",
    value: function getMaxWidth() {
      return this.maxWidth;
    }
  }, {
    key: "getFlex",
    value: function getFlex() {
      return this.flex || 0;
    } // this method should only be used by the columnModel to
    // change flex when required by the applyColumnState method.

  }, {
    key: "setFlex",
    value: function setFlex(flex) {
      if (this.flex !== flex) {
        this.flex = flex;
      }

      this.dispatchStateUpdatedEvent("flex");
    }
  }, {
    key: "setMinimum",
    value: function setMinimum(source) {
      if (_exists(this.minWidth)) {
        this.setActualWidth(this.minWidth, source);
      }
    }
  }, {
    key: "setRowGroupActive",
    value: function setRowGroupActive(rowGroup, source) {
      if (this.rowGroupActive !== rowGroup) {
        this.rowGroupActive = rowGroup;
        this.eventService.dispatchEvent(this.createColumnEvent("columnRowGroupChanged", source));
      }

      this.dispatchStateUpdatedEvent("rowGroup");
    }
    /** Returns `true` if row group is currently active for this column. */

  }, {
    key: "isRowGroupActive",
    value: function isRowGroupActive() {
      return this.rowGroupActive;
    }
  }, {
    key: "setPivotActive",
    value: function setPivotActive(pivot, source) {
      if (this.pivotActive !== pivot) {
        this.pivotActive = pivot;
        this.eventService.dispatchEvent(this.createColumnEvent("columnPivotChanged", source));
      }

      this.dispatchStateUpdatedEvent("pivot");
    }
    /** Returns `true` if pivot is currently active for this column. */

  }, {
    key: "isPivotActive",
    value: function isPivotActive() {
      return this.pivotActive;
    }
  }, {
    key: "isAnyFunctionActive",
    value: function isAnyFunctionActive() {
      return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
    }
  }, {
    key: "isAnyFunctionAllowed",
    value: function isAnyFunctionAllowed() {
      return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
    }
  }, {
    key: "setValueActive",
    value: function setValueActive(value, source) {
      if (this.aggregationActive !== value) {
        this.aggregationActive = value;
        this.eventService.dispatchEvent(this.createColumnEvent("columnValueChanged", source));
      }
    }
    /** Returns `true` if value (aggregation) is currently active for this column. */

  }, {
    key: "isValueActive",
    value: function isValueActive() {
      return this.aggregationActive;
    }
  }, {
    key: "isAllowPivot",
    value: function isAllowPivot() {
      return this.colDef.enablePivot === true;
    }
  }, {
    key: "isAllowValue",
    value: function isAllowValue() {
      return this.colDef.enableValue === true;
    }
  }, {
    key: "isAllowRowGroup",
    value: function isAllowRowGroup() {
      return this.colDef.enableRowGroup === true;
    }
    /**
     * @deprecated v31.1 Use `getColDef().menuTabs ?? defaultValues` instead.
     */

  }, {
    key: "getMenuTabs",
    value: function getMenuTabs(defaultValues) {
      _warnOnce("As of v31.1, 'getMenuTabs' is deprecated. Use 'getColDef().menuTabs ?? defaultValues' instead.");

      var menuTabs = this.getColDef().menuTabs;

      if (menuTabs == null) {
        menuTabs = defaultValues;
      }

      return menuTabs;
    }
  }, {
    key: "dispatchStateUpdatedEvent",
    value: function dispatchStateUpdatedEvent(key) {
      this.eventService.dispatchEvent({
        type: _Column.EVENT_STATE_UPDATED,
        key: key
      });
    }
  }]);

  return _Column;
}(); // + renderedHeaderCell - for making header cell transparent when moving


_Column.EVENT_MOVING_CHANGED = "movingChanged"; // + renderedCell - changing left position

_Column.EVENT_LEFT_CHANGED = "leftChanged"; // + renderedCell - changing width

_Column.EVENT_WIDTH_CHANGED = "widthChanged"; // + renderedCell - for changing pinned classes

_Column.EVENT_LAST_LEFT_PINNED_CHANGED = "lastLeftPinnedChanged";
_Column.EVENT_FIRST_RIGHT_PINNED_CHANGED = "firstRightPinnedChanged"; // + renderedColumn - for changing visibility icon

_Column.EVENT_VISIBLE_CHANGED = "visibleChanged"; // + every time the filter changes, used in the floating filters

_Column.EVENT_FILTER_CHANGED = "filterChanged"; // + renderedHeaderCell - marks the header with filter icon

_Column.EVENT_FILTER_ACTIVE_CHANGED = "filterActiveChanged"; // + renderedHeaderCell - marks the header with sort icon

_Column.EVENT_SORT_CHANGED = "sortChanged"; // + renderedHeaderCell - marks the header with sort icon

_Column.EVENT_COL_DEF_CHANGED = "colDefChanged";
_Column.EVENT_MENU_VISIBLE_CHANGED = "menuVisibleChanged"; // + toolpanel, for gui updates

_Column.EVENT_ROW_GROUP_CHANGED = "columnRowGroupChanged"; // + toolpanel, for gui updates

_Column.EVENT_PIVOT_CHANGED = "columnPivotChanged"; // + toolpanel, for gui updates

_Column.EVENT_VALUE_CHANGED = "columnValueChanged"; // + dataTypeService - when waiting to infer cell data types

_Column.EVENT_STATE_UPDATED = "columnStateUpdated";

__decorateClass([_Autowired("gridOptionsService")], _Column.prototype, "gos", 2);

__decorateClass([_Autowired("environment")], _Column.prototype, "environment", 2);

__decorateClass([_Autowired("columnHoverService")], _Column.prototype, "columnHoverService", 2);

__decorateClass([_Autowired("frameworkOverrides")], _Column.prototype, "frameworkOverrides", 2);

__decorateClass([_PostConstruct], _Column.prototype, "initialise", 1);

var _Column2 = _Column; // community-modules/core/src/entities/providedColumnGroup.ts

var _ProvidedColumnGroup =
/*#__PURE__*/
function () {
  "use strict";

  function _ProvidedColumnGroup(colGroupDef, groupId, padding, level) {
    _classCallCheck(this, _ProvidedColumnGroup);

    this.localEventService = new _EventService();
    this.expandable = false; // used by React (and possibly other frameworks) as key for rendering. also used to
    // identify old vs new columns for destroying cols when no longer used.

    this.instanceId = getNextColInstanceId();
    this.expandableListenerRemoveCallback = null;
    this.colGroupDef = colGroupDef;
    this.groupId = groupId;
    this.expanded = !!colGroupDef && !!colGroupDef.openByDefault;
    this.padding = padding;
    this.level = level;
  }

  _createClass(_ProvidedColumnGroup, [{
    key: "destroy",
    value: function destroy() {
      if (this.expandableListenerRemoveCallback) {
        this.reset(null, void 0);
      }
    }
  }, {
    key: "reset",
    value: function reset(colGroupDef, level) {
      this.colGroupDef = colGroupDef;
      this.level = level;
      this.originalParent = null;

      if (this.expandableListenerRemoveCallback) {
        this.expandableListenerRemoveCallback();
      }

      this.children = void 0;
      this.expandable = void 0;
    }
  }, {
    key: "getInstanceId",
    value: function getInstanceId() {
      return this.instanceId;
    }
  }, {
    key: "setOriginalParent",
    value: function setOriginalParent(originalParent) {
      this.originalParent = originalParent;
    }
  }, {
    key: "getOriginalParent",
    value: function getOriginalParent() {
      return this.originalParent;
    }
  }, {
    key: "getLevel",
    value: function getLevel() {
      return this.level;
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      if (this.children) {
        return this.children.some(function (child) {
          return child.isVisible();
        });
      }

      return false;
    }
  }, {
    key: "isPadding",
    value: function isPadding() {
      return this.padding;
    }
  }, {
    key: "setExpanded",
    value: function setExpanded(expanded) {
      this.expanded = expanded === void 0 ? false : expanded;
      var event = {
        type: _ProvidedColumnGroup.EVENT_EXPANDED_CHANGED
      };
      this.localEventService.dispatchEvent(event);
    }
  }, {
    key: "isExpandable",
    value: function isExpandable() {
      return this.expandable;
    }
  }, {
    key: "isExpanded",
    value: function isExpanded() {
      return this.expanded;
    }
  }, {
    key: "getGroupId",
    value: function getGroupId() {
      return this.groupId;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.getGroupId();
    }
  }, {
    key: "setChildren",
    value: function setChildren(children) {
      this.children = children;
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      return this.children;
    }
  }, {
    key: "getColGroupDef",
    value: function getColGroupDef() {
      return this.colGroupDef;
    }
  }, {
    key: "getLeafColumns",
    value: function getLeafColumns() {
      var result = [];
      this.addLeafColumns(result);
      return result;
    }
  }, {
    key: "addLeafColumns",
    value: function addLeafColumns(leafColumns) {
      if (!this.children) {
        return;
      }

      this.children.forEach(function (child) {
        if (child instanceof _Column2) {
          leafColumns.push(child);
        } else if (child instanceof _ProvidedColumnGroup) {
          child.addLeafColumns(leafColumns);
        }
      });
    }
  }, {
    key: "getColumnGroupShow",
    value: function getColumnGroupShow() {
      var colGroupDef = this.colGroupDef;

      if (!colGroupDef) {
        return;
      }

      return colGroupDef.columnGroupShow;
    } // need to check that this group has at least one col showing when both expanded and contracted.
    // if not, then we don't allow expanding and contracting on this group

  }, {
    key: "setupExpandable",
    value: function setupExpandable() {
      var _this11 = this;

      this.setExpandable();

      if (this.expandableListenerRemoveCallback) {
        this.expandableListenerRemoveCallback();
      }

      var listener = this.onColumnVisibilityChanged.bind(this);
      this.getLeafColumns().forEach(function (col) {
        return col.addEventListener("visibleChanged", listener);
      });

      this.expandableListenerRemoveCallback = function () {
        _this11.getLeafColumns().forEach(function (col) {
          return col.removeEventListener("visibleChanged", listener);
        });

        _this11.expandableListenerRemoveCallback = null;
      };
    }
  }, {
    key: "setExpandable",
    value: function setExpandable() {
      if (this.isPadding()) {
        return;
      }

      var atLeastOneShowingWhenOpen = false;
      var atLeastOneShowingWhenClosed = false;
      var atLeastOneChangeable = false;
      var children = this.findChildrenRemovingPadding();

      for (var i = 0, j = children.length; i < j; i++) {
        var abstractColumn = children[i];

        if (!abstractColumn.isVisible()) {
          continue;
        }

        var headerGroupShow = abstractColumn.getColumnGroupShow();

        if (headerGroupShow === "open") {
          atLeastOneShowingWhenOpen = true;
          atLeastOneChangeable = true;
        } else if (headerGroupShow === "closed") {
          atLeastOneShowingWhenClosed = true;
          atLeastOneChangeable = true;
        } else {
          atLeastOneShowingWhenOpen = true;
          atLeastOneShowingWhenClosed = true;
        }
      }

      var expandable = atLeastOneShowingWhenOpen && atLeastOneShowingWhenClosed && atLeastOneChangeable;

      if (this.expandable !== expandable) {
        this.expandable = expandable;
        var event = {
          type: _ProvidedColumnGroup.EVENT_EXPANDABLE_CHANGED
        };
        this.localEventService.dispatchEvent(event);
      }
    }
  }, {
    key: "findChildrenRemovingPadding",
    value: function findChildrenRemovingPadding() {
      var res = [];

      var process = function process(items) {
        items.forEach(function (item) {
          var skipBecausePadding = item instanceof _ProvidedColumnGroup && item.isPadding();

          if (skipBecausePadding) {
            process(item.children);
          } else {
            res.push(item);
          }
        });
      };

      process(this.children);
      return res;
    }
  }, {
    key: "onColumnVisibilityChanged",
    value: function onColumnVisibilityChanged() {
      this.setExpandable();
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(eventType, listener) {
      this.localEventService.addEventListener(eventType, listener);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventType, listener) {
      this.localEventService.removeEventListener(eventType, listener);
    }
  }]);

  return _ProvidedColumnGroup;
}();

_ProvidedColumnGroup.EVENT_EXPANDED_CHANGED = "expandedChanged";
_ProvidedColumnGroup.EVENT_EXPANDABLE_CHANGED = "expandableChanged";

__decorateClass([_PreDestroy], _ProvidedColumnGroup.prototype, "destroy", 1);

var _ProvidedColumnGroup2 = _ProvidedColumnGroup; // community-modules/core/src/entities/defaultColumnTypes.ts

var DefaultColumnTypes = {
  numericColumn: {
    headerClass: "ag-right-aligned-header",
    cellClass: "ag-right-aligned-cell"
  },
  rightAligned: {
    headerClass: "ag-right-aligned-header",
    cellClass: "ag-right-aligned-cell"
  }
}; // community-modules/core/src/utils/event.ts

var event_exports = {};

__export(event_exports, {
  addSafePassiveEventListener: function addSafePassiveEventListener() {
    return _addSafePassiveEventListener;
  },
  createEventPath: function createEventPath() {
    return _createEventPath;
  },
  getCtrlForEventTarget: function getCtrlForEventTarget() {
    return _getCtrlForEventTarget;
  },
  getEventPath: function getEventPath() {
    return _getEventPath;
  },
  isElementInEventPath: function isElementInEventPath() {
    return _isElementInEventPath;
  },
  isEventSupported: function isEventSupported() {
    return _isEventSupported;
  },
  isStopPropagationForAgGrid: function isStopPropagationForAgGrid() {
    return _isStopPropagationForAgGrid;
  },
  stopPropagationForAgGrid: function stopPropagationForAgGrid() {
    return _stopPropagationForAgGrid;
  }
}); // community-modules/core/src/utils/array.ts


var array_exports = {};

__export(array_exports, {
  areEqual: function areEqual() {
    return _areEqual;
  },
  existsAndNotEmpty: function existsAndNotEmpty() {
    return _existsAndNotEmpty;
  },
  flatten: function flatten() {
    return _flatten;
  },
  forEachReverse: function forEachReverse() {
    return _forEachReverse;
  },
  includes: function includes() {
    return _includes;
  },
  insertArrayIntoArray: function insertArrayIntoArray() {
    return _insertArrayIntoArray;
  },
  insertIntoArray: function insertIntoArray() {
    return _insertIntoArray;
  },
  last: function last() {
    return _last;
  },
  moveInArray: function moveInArray() {
    return _moveInArray;
  },
  pushAll: function pushAll() {
    return _pushAll;
  },
  removeAllFromArray: function removeAllFromArray() {
    return _removeAllFromArray;
  },
  removeAllFromUnorderedArray: function removeAllFromUnorderedArray() {
    return _removeAllFromUnorderedArray;
  },
  removeFromArray: function removeFromArray() {
    return _removeFromArray;
  },
  removeFromUnorderedArray: function removeFromUnorderedArray() {
    return _removeFromUnorderedArray;
  },
  removeRepeatsFromArray: function removeRepeatsFromArray() {
    return _removeRepeatsFromArray;
  },
  shallowCompare: function shallowCompare() {
    return _shallowCompare;
  },
  sortNumerically: function sortNumerically() {
    return _sortNumerically;
  },
  toStrings: function toStrings() {
    return _toStrings;
  }
});

function _existsAndNotEmpty(value) {
  return value != null && value.length > 0;
}

function _last(arr) {
  if (!arr || !arr.length) {
    return;
  }

  return arr[arr.length - 1];
}

function _areEqual(a, b, comparator) {
  if (a == null && b == null) {
    return true;
  }

  return a != null && b != null && a.length === b.length && a.every(function (value, index) {
    return comparator ? comparator(value, b[index]) : b[index] === value;
  });
}

function _shallowCompare(arr1, arr2) {
  return _areEqual(arr1, arr2);
}

function _sortNumerically(array) {
  return array.sort(function (a, b) {
    return a - b;
  });
}

function _removeRepeatsFromArray(array, object) {
  if (!array) {
    return;
  }

  for (var index = array.length - 2; index >= 0; index--) {
    var thisOneMatches = array[index] === object;
    var nextOneMatches = array[index + 1] === object;

    if (thisOneMatches && nextOneMatches) {
      array.splice(index + 1, 1);
    }
  }
}

function _removeFromUnorderedArray(array, object) {
  var index = array.indexOf(object);

  if (index >= 0) {
    array[index] = array[array.length - 1];
    array.pop();
  }
}

function _removeFromArray(array, object) {
  var index = array.indexOf(object);

  if (index >= 0) {
    array.splice(index, 1);
  }
}

function _removeAllFromUnorderedArray(array, toRemove) {
  for (var i = 0; i < toRemove.length; i++) {
    _removeFromUnorderedArray(array, toRemove[i]);
  }
}

function _removeAllFromArray(array, toRemove) {
  for (var i = 0; i < toRemove.length; i++) {
    _removeFromArray(array, toRemove[i]);
  }
}

function _insertIntoArray(array, object, toIndex) {
  array.splice(toIndex, 0, object);
}

function _insertArrayIntoArray(dest, src, toIndex) {
  if (dest == null || src == null) {
    return;
  }

  for (var i = src.length - 1; i >= 0; i--) {
    var item = src[i];

    _insertIntoArray(dest, item, toIndex);
  }
}

function _moveInArray(array, objectsToMove, toIndex) {
  _removeAllFromArray(array, objectsToMove);

  objectsToMove.slice().reverse().forEach(function (obj) {
    return _insertIntoArray(array, obj, toIndex);
  });
}

function _includes(array, value) {
  return array.indexOf(value) > -1;
}

function _flatten(arrayOfArrays) {
  return [].concat.apply([], arrayOfArrays);
}

function _pushAll(target, source) {
  if (source == null || target == null) {
    return;
  }

  source.forEach(function (value) {
    return target.push(value);
  });
}

function _toStrings(array) {
  return array.map(_toStringOrNull);
}

function _forEachReverse(list, action) {
  if (list == null) {
    return;
  }

  for (var i = list.length - 1; i >= 0; i--) {
    action(list[i], i);
  }
} // community-modules/core/src/utils/event.ts


var AG_GRID_STOP_PROPAGATION = "__ag_Grid_Stop_Propagation";
var PASSIVE_EVENTS = ["touchstart", "touchend", "touchmove", "touchcancel", "scroll"];
var supports = {};

function _stopPropagationForAgGrid(event) {
  event[AG_GRID_STOP_PROPAGATION] = true;
}

function _isStopPropagationForAgGrid(event) {
  return event[AG_GRID_STOP_PROPAGATION] === true;
}

var _isEventSupported =
/* @__PURE__ */
function () {
  var tags = {
    select: "input",
    change: "input",
    submit: "form",
    reset: "form",
    error: "img",
    load: "img",
    abort: "img"
  };

  var eventChecker = function eventChecker(eventName) {
    if (typeof supports[eventName] === "boolean") {
      return supports[eventName];
    }

    var el = document.createElement(tags[eventName] || "div");
    eventName = "on" + eventName;
    return supports[eventName] = eventName in el;
  };

  return eventChecker;
}();

function _getCtrlForEventTarget(gos, eventTarget, type) {
  var sourceElement = eventTarget;

  while (sourceElement) {
    var renderedComp = gos.getDomData(sourceElement, type);

    if (renderedComp) {
      return renderedComp;
    }

    sourceElement = sourceElement.parentElement;
  }

  return null;
}

function _isElementInEventPath(element, event) {
  if (!event || !element) {
    return false;
  }

  return _getEventPath(event).indexOf(element) >= 0;
}

function _createEventPath(event) {
  var res = [];
  var pointer = event.target;

  while (pointer) {
    res.push(pointer);
    pointer = pointer.parentElement;
  }

  return res;
}

function _getEventPath(event) {
  var eventNoType = event;

  if (eventNoType.path) {
    return eventNoType.path;
  }

  if (eventNoType.composedPath) {
    return eventNoType.composedPath();
  }

  return _createEventPath(eventNoType);
}

function _addSafePassiveEventListener(frameworkOverrides, eElement, event, listener) {
  var isPassive = _includes(PASSIVE_EVENTS, event);

  var options = isPassive ? {
    passive: true
  } : void 0;

  if (frameworkOverrides && frameworkOverrides.addEventListener) {
    frameworkOverrides.addEventListener(eElement, event, listener, options);
  }
} // community-modules/core/src/context/beanStub.ts


var _BeanStub =
/*#__PURE__*/
function () {
  "use strict";

  function _BeanStub() {
    var _this12 = this;

    _classCallCheck(this, _BeanStub);

    this.destroyFunctions = [];
    this.destroyed = false; // for vue 3 - prevents Vue from trying to make this (and obviously any sub classes) from being reactive
    // prevents vue from creating proxies for created objects and prevents identity related issues

    this.__v_skip = true; // this was a test constructor niall built, when active, it prints after 5 seconds all beans/components that are
    // not destroyed. to use, create a new grid, then api.destroy() before 5 seconds. then anything that gets printed
    // points to a bean or component that was not properly disposed of.
    // constructor() {
    //     setTimeout(()=> {
    //         if (this.isAlive()) {
    //             let prototype: any = Object.getPrototypeOf(this);
    //             const constructor: any = prototype.constructor;
    //             const constructorString = constructor.toString();
    //             const beanName = constructorString.substring(9, constructorString.indexOf("("));
    //             console.log('is alive ' + beanName);
    //         }
    //     }, 5000);
    // }
    // Enable multiple grid properties to be updated together by the user but only trigger shared logic once.
    // Closely related to logic in ComponentUtil.ts

    this.lastChangeSetIdLookup = {};
    this.propertyListenerId = 0;

    this.isAlive = function () {
      return !_this12.destroyed;
    };
  } // CellComp and GridComp and override this because they get the FrameworkOverrides from the Beans bean


  _createClass(_BeanStub, [{
    key: "getFrameworkOverrides",
    value: function getFrameworkOverrides() {
      return this.frameworkOverrides;
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this.context;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      for (var i = 0; i < this.destroyFunctions.length; i++) {
        this.destroyFunctions[i]();
      }

      this.destroyFunctions.length = 0;
      this.destroyed = true;
      this.dispatchEvent({
        type: _BeanStub.EVENT_DESTROYED
      });
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(eventType, listener) {
      if (!this.localEventService) {
        this.localEventService = new _EventService();
      }

      this.localEventService.addEventListener(eventType, listener);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventType, listener) {
      if (this.localEventService) {
        this.localEventService.removeEventListener(eventType, listener);
      }
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      if (this.localEventService) {
        this.localEventService.dispatchEvent(event);
      }
    }
  }, {
    key: "addManagedListener",
    value: function addManagedListener(object, event, listener) {
      var _this13 = this;

      if (this.destroyed) {
        return;
      }

      if (object instanceof HTMLElement) {
        _addSafePassiveEventListener(this.getFrameworkOverrides(), object, event, listener);
      } else {
        object.addEventListener(event, listener);
      }

      var destroyFunc = function destroyFunc() {
        object.removeEventListener(event, listener);
        return null;
      };

      this.destroyFunctions.push(destroyFunc);
      return function () {
        destroyFunc();
        _this13.destroyFunctions = _this13.destroyFunctions.filter(function (fn) {
          return fn !== destroyFunc;
        });
        return null;
      };
    }
  }, {
    key: "setupGridOptionListener",
    value: function setupGridOptionListener(event, listener) {
      var _this14 = this;

      this.gos.addEventListener(event, listener);

      var destroyFunc = function destroyFunc() {
        _this14.gos.removeEventListener(event, listener);

        return null;
      };

      this.destroyFunctions.push(destroyFunc);
      return function () {
        destroyFunc();
        _this14.destroyFunctions = _this14.destroyFunctions.filter(function (fn) {
          return fn !== destroyFunc;
        });
        return null;
      };
    }
    /**
     * Setup a managed property listener for the given GridOption property.
     * @param event GridOption property to listen to changes for.
     * @param listener Listener to run when property value changes
     */

  }, {
    key: "addManagedPropertyListener",
    value: function addManagedPropertyListener(event, listener) {
      if (this.destroyed) {
        return function () {
          return null;
        };
      }

      return this.setupGridOptionListener(event, listener);
    }
    /**
     * Setup managed property listeners for the given set of GridOption properties.
     * The listener will be run if any of the property changes but will only run once if
     * multiple of the properties change within the same framework lifecycle event.
     * Works on the basis that GridOptionsService updates all properties *before* any property change events are fired.
     * @param events Array of GridOption properties to listen for changes too.
     * @param listener Shared listener to run if any of the properties change
     */

  }, {
    key: "addManagedPropertyListeners",
    value: function addManagedPropertyListeners(events, listener) {
      var _this15 = this;

      if (this.destroyed) {
        return;
      }

      var eventsKey = events.join("-") + this.propertyListenerId++;

      var wrappedListener = function wrappedListener(event) {
        if (event.changeSet) {
          if (event.changeSet && event.changeSet.id === _this15.lastChangeSetIdLookup[eventsKey]) {
            return;
          }

          _this15.lastChangeSetIdLookup[eventsKey] = event.changeSet.id;
        }

        var propertiesChangeEvent = {
          type: "gridPropertyChanged",
          changeSet: event.changeSet,
          source: event.source
        };
        listener(propertiesChangeEvent);
      };

      events.forEach(function (event) {
        return _this15.setupGridOptionListener(event, wrappedListener);
      });
    }
  }, {
    key: "addDestroyFunc",
    value: function addDestroyFunc(func) {
      if (this.isAlive()) {
        this.destroyFunctions.push(func);
      } else {
        func();
      }
    }
  }, {
    key: "createManagedBean",
    value: function createManagedBean(bean, context) {
      var res = this.createBean(bean, context);
      this.addDestroyFunc(this.destroyBean.bind(this, bean, context));
      return res;
    }
  }, {
    key: "createBean",
    value: function createBean(bean, context, afterPreCreateCallback) {
      return (context || this.getContext()).createBean(bean, afterPreCreateCallback);
    }
  }, {
    key: "destroyBean",
    value: function destroyBean(bean, context) {
      return (context || this.getContext()).destroyBean(bean);
    }
  }, {
    key: "destroyBeans",
    value: function destroyBeans(beans, context) {
      if (beans) {
        for (var i = 0; i < beans.length; i++) {
          this.destroyBean(beans[i], context);
        }
      }

      return [];
    }
  }]);

  return _BeanStub;
}();

_BeanStub.EVENT_DESTROYED = "destroyed";

__decorateClass([_Autowired("frameworkOverrides")], _BeanStub.prototype, "frameworkOverrides", 2);

__decorateClass([_Autowired("context")], _BeanStub.prototype, "context", 2);

__decorateClass([_Autowired("eventService")], _BeanStub.prototype, "eventService", 2);

__decorateClass([_Autowired("gridOptionsService")], _BeanStub.prototype, "gos", 2);

__decorateClass([_Autowired("localeService")], _BeanStub.prototype, "localeService", 2);

__decorateClass([_Autowired("environment")], _BeanStub.prototype, "environment", 2);

__decorateClass([_PreDestroy], _BeanStub.prototype, "destroy", 1);

var _BeanStub2 = _BeanStub; // community-modules/core/src/columns/columnFactory.ts

var _ColumnFactory =
/*#__PURE__*/
function (_BeanStub3) {
  "use strict";

  _inherits(_ColumnFactory, _BeanStub3);

  function _ColumnFactory() {
    _classCallCheck(this, _ColumnFactory);

    return _possibleConstructorReturn(this, _getPrototypeOf(_ColumnFactory).apply(this, arguments));
  }

  _createClass(_ColumnFactory, [{
    key: "setBeans",
    value: function setBeans(loggerFactory) {
      this.logger = loggerFactory.create("ColumnFactory");
    }
  }, {
    key: "createColumnTree",
    value: function createColumnTree(defs, primaryColumns, existingTree, source) {
      var columnKeyCreator = new _ColumnKeyCreator();

      var _this$extractExisting = this.extractExistingTreeData(existingTree),
          existingCols = _this$extractExisting.existingCols,
          existingGroups = _this$extractExisting.existingGroups,
          existingColKeys = _this$extractExisting.existingColKeys;

      columnKeyCreator.addExistingKeys(existingColKeys);
      var unbalancedTree = this.recursivelyCreateColumns(defs, 0, primaryColumns, existingCols, columnKeyCreator, existingGroups, source);
      var treeDept = this.findMaxDept(unbalancedTree, 0);
      this.logger.log("Number of levels for grouped columns is " + treeDept);
      var columnTree = this.balanceColumnTree(unbalancedTree, 0, treeDept, columnKeyCreator);

      var deptFirstCallback = function deptFirstCallback(child, parent) {
        if (child instanceof _ProvidedColumnGroup2) {
          child.setupExpandable();
        }

        child.setOriginalParent(parent);
      };

      depthFirstOriginalTreeSearch(null, columnTree, deptFirstCallback);
      return {
        columnTree: columnTree,
        treeDept: treeDept
      };
    }
  }, {
    key: "extractExistingTreeData",
    value: function extractExistingTreeData(existingTree) {
      var existingCols = [];
      var existingGroups = [];
      var existingColKeys = [];

      if (existingTree) {
        depthFirstOriginalTreeSearch(null, existingTree, function (item) {
          if (item instanceof _ProvidedColumnGroup2) {
            var group = item;
            existingGroups.push(group);
          } else {
            var col = item;
            existingColKeys.push(col.getId());
            existingCols.push(col);
          }
        });
      }

      return {
        existingCols: existingCols,
        existingGroups: existingGroups,
        existingColKeys: existingColKeys
      };
    }
  }, {
    key: "createForAutoGroups",
    value: function createForAutoGroups(autoGroupCols, gridBalancedTree) {
      var _this16 = this;

      return autoGroupCols.map(function (col) {
        return _this16.createAutoGroupTreeItem(gridBalancedTree, col);
      });
    }
  }, {
    key: "createAutoGroupTreeItem",
    value: function createAutoGroupTreeItem(balancedColumnTree, column) {
      var dept = this.findDepth(balancedColumnTree);
      var nextChild = column;

      for (var i = dept - 1; i >= 0; i--) {
        var autoGroup = new _ProvidedColumnGroup2(null, "FAKE_PATH_".concat(column.getId(), "}_").concat(i), true, i);
        this.createBean(autoGroup);
        autoGroup.setChildren([nextChild]);
        nextChild.setOriginalParent(autoGroup);
        nextChild = autoGroup;
      }

      if (dept === 0) {
        column.setOriginalParent(null);
      }

      return nextChild;
    }
  }, {
    key: "findDepth",
    value: function findDepth(balancedColumnTree) {
      var dept = 0;
      var pointer = balancedColumnTree;

      while (pointer && pointer[0] && pointer[0] instanceof _ProvidedColumnGroup2) {
        dept++;
        pointer = pointer[0].getChildren();
      }

      return dept;
    }
  }, {
    key: "balanceColumnTree",
    value: function balanceColumnTree(unbalancedTree, currentDept, columnDept, columnKeyCreator) {
      var result = [];

      for (var i = 0; i < unbalancedTree.length; i++) {
        var child = unbalancedTree[i];

        if (child instanceof _ProvidedColumnGroup2) {
          var originalGroup = child;
          var newChildren = this.balanceColumnTree(originalGroup.getChildren(), currentDept + 1, columnDept, columnKeyCreator);
          originalGroup.setChildren(newChildren);
          result.push(originalGroup);
        } else {
          var firstPaddedGroup = void 0;
          var currentPaddedGroup = void 0;

          for (var j = columnDept - 1; j >= currentDept; j--) {
            var newColId = columnKeyCreator.getUniqueKey(null, null);
            var colGroupDefMerged = this.createMergedColGroupDef(null);
            var paddedGroup = new _ProvidedColumnGroup2(colGroupDefMerged, newColId, true, currentDept);
            this.createBean(paddedGroup);

            if (currentPaddedGroup) {
              currentPaddedGroup.setChildren([paddedGroup]);
            }

            currentPaddedGroup = paddedGroup;

            if (!firstPaddedGroup) {
              firstPaddedGroup = currentPaddedGroup;
            }
          }

          if (firstPaddedGroup && currentPaddedGroup) {
            result.push(firstPaddedGroup);
            var hasGroups = unbalancedTree.some(function (leaf) {
              return leaf instanceof _ProvidedColumnGroup2;
            });

            if (hasGroups) {
              currentPaddedGroup.setChildren([child]);
              continue;
            } else {
              currentPaddedGroup.setChildren(unbalancedTree);
              break;
            }
          }

          result.push(child);
        }
      }

      return result;
    }
  }, {
    key: "findMaxDept",
    value: function findMaxDept(treeChildren, dept) {
      var maxDeptThisLevel = dept;

      for (var i = 0; i < treeChildren.length; i++) {
        var abstractColumn = treeChildren[i];

        if (abstractColumn instanceof _ProvidedColumnGroup2) {
          var originalGroup = abstractColumn;
          var newDept = this.findMaxDept(originalGroup.getChildren(), dept + 1);

          if (maxDeptThisLevel < newDept) {
            maxDeptThisLevel = newDept;
          }
        }
      }

      return maxDeptThisLevel;
    }
  }, {
    key: "recursivelyCreateColumns",
    value: function recursivelyCreateColumns(defs, level, primaryColumns, existingColsCopy, columnKeyCreator, existingGroups, source) {
      if (!defs) return [];
      var result = new Array(defs.length);

      for (var i = 0; i < result.length; i++) {
        var def = defs[i];

        if (this.isColumnGroup(def)) {
          result[i] = this.createColumnGroup(primaryColumns, def, level, existingColsCopy, columnKeyCreator, existingGroups, source);
        } else {
          result[i] = this.createColumn(primaryColumns, def, existingColsCopy, columnKeyCreator, source);
        }
      }

      return result;
    }
  }, {
    key: "createColumnGroup",
    value: function createColumnGroup(primaryColumns, colGroupDef, level, existingColumns, columnKeyCreator, existingGroups, source) {
      var colGroupDefMerged = this.createMergedColGroupDef(colGroupDef);
      var groupId = columnKeyCreator.getUniqueKey(colGroupDefMerged.groupId || null, null);
      var providedGroup = new _ProvidedColumnGroup2(colGroupDefMerged, groupId, false, level);
      this.createBean(providedGroup);
      var existingGroupAndIndex = this.findExistingGroup(colGroupDef, existingGroups);

      if (existingGroupAndIndex) {
        existingGroups.splice(existingGroupAndIndex.idx, 1);
      }

      var existingGroup = existingGroupAndIndex == null ? void 0 : existingGroupAndIndex.group;

      if (existingGroup) {
        providedGroup.setExpanded(existingGroup.isExpanded());
      }

      var children = this.recursivelyCreateColumns(colGroupDefMerged.children, level + 1, primaryColumns, existingColumns, columnKeyCreator, existingGroups, source);
      providedGroup.setChildren(children);
      return providedGroup;
    }
  }, {
    key: "createMergedColGroupDef",
    value: function createMergedColGroupDef(colGroupDef) {
      var colGroupDefMerged = {};
      Object.assign(colGroupDefMerged, this.gos.get("defaultColGroupDef"));
      Object.assign(colGroupDefMerged, colGroupDef);
      return colGroupDefMerged;
    }
  }, {
    key: "createColumn",
    value: function createColumn(primaryColumns, colDef, existingColsCopy, columnKeyCreator, source) {
      var existingColAndIndex = this.findExistingColumn(colDef, existingColsCopy);

      if (existingColAndIndex) {
        existingColsCopy == null ? void 0 : existingColsCopy.splice(existingColAndIndex.idx, 1);
      }

      var column = existingColAndIndex == null ? void 0 : existingColAndIndex.column;

      if (!column) {
        var colId = columnKeyCreator.getUniqueKey(colDef.colId, colDef.field);
        var colDefMerged = this.addColumnDefaultAndTypes(colDef, colId);
        column = new _Column2(colDefMerged, colDef, colId, primaryColumns);
        this.context.createBean(column);
      } else {
        var _colDefMerged = this.addColumnDefaultAndTypes(colDef, column.getColId());

        column.setColDef(_colDefMerged, colDef, source);
        this.applyColumnState(column, _colDefMerged, source);
      }

      this.dataTypeService.addColumnListeners(column);
      return column;
    }
  }, {
    key: "applyColumnState",
    value: function applyColumnState(column, colDef, source) {
      var flex = _attrToNumber(colDef.flex);

      if (flex !== void 0) {
        column.setFlex(flex);
      }

      var noFlexThisCol = column.getFlex() <= 0;

      if (noFlexThisCol) {
        var width = _attrToNumber(colDef.width);

        if (width != null) {
          column.setActualWidth(width, source);
        } else {
          var widthBeforeUpdate = column.getActualWidth();
          column.setActualWidth(widthBeforeUpdate, source);
        }
      }

      if (colDef.sort !== void 0) {
        if (colDef.sort == "asc" || colDef.sort == "desc") {
          column.setSort(colDef.sort, source);
        } else {
          column.setSort(void 0, source);
        }
      }

      var sortIndex = _attrToNumber(colDef.sortIndex);

      if (sortIndex !== void 0) {
        column.setSortIndex(sortIndex);
      }

      var hide = _attrToBoolean(colDef.hide);

      if (hide !== void 0) {
        column.setVisible(!hide, source);
      }

      if (colDef.pinned !== void 0) {
        column.setPinned(colDef.pinned);
      }
    }
  }, {
    key: "findExistingColumn",
    value: function findExistingColumn(newColDef, existingColsCopy) {
      if (!existingColsCopy) return void 0;

      for (var i = 0; i < existingColsCopy.length; i++) {
        var def = existingColsCopy[i].getUserProvidedColDef();
        if (!def) continue;
        var newHasId = newColDef.colId != null;

        if (newHasId) {
          if (existingColsCopy[i].getId() === newColDef.colId) {
            return {
              idx: i,
              column: existingColsCopy[i]
            };
          }

          continue;
        }

        var newHasField = newColDef.field != null;

        if (newHasField) {
          if (def.field === newColDef.field) {
            return {
              idx: i,
              column: existingColsCopy[i]
            };
          }

          continue;
        }

        if (def === newColDef) {
          return {
            idx: i,
            column: existingColsCopy[i]
          };
        }
      }

      return void 0;
    }
  }, {
    key: "findExistingGroup",
    value: function findExistingGroup(newGroupDef, existingGroups) {
      var newHasId = newGroupDef.groupId != null;

      if (!newHasId) {
        return void 0;
      }

      for (var i = 0; i < existingGroups.length; i++) {
        var existingGroup = existingGroups[i];
        var existingDef = existingGroup.getColGroupDef();

        if (!existingDef) {
          continue;
        }

        if (existingGroup.getId() === newGroupDef.groupId) {
          return {
            idx: i,
            group: existingGroup
          };
        }
      }

      return void 0;
    }
  }, {
    key: "addColumnDefaultAndTypes",
    value: function addColumnDefaultAndTypes(colDef, colId) {
      var res = {};
      var defaultColDef = this.gos.get("defaultColDef");

      _mergeDeep(res, defaultColDef, false, true);

      var columnType = this.dataTypeService.updateColDefAndGetColumnType(res, colDef, colId);

      if (columnType) {
        this.assignColumnTypes(columnType, res);
      }

      _mergeDeep(res, colDef, false, true);

      var autoGroupColDef = this.gos.get("autoGroupColumnDef");
      var isSortingCoupled = this.gos.isColumnsSortingCoupledToGroup();

      if (colDef.rowGroup && autoGroupColDef && isSortingCoupled) {
        _mergeDeep(res, {
          sort: autoGroupColDef.sort,
          initialSort: autoGroupColDef.initialSort
        }, false, true);
      }

      this.dataTypeService.validateColDef(res);
      return res;
    }
  }, {
    key: "assignColumnTypes",
    value: function assignColumnTypes(typeKeys, colDefMerged) {
      if (!typeKeys.length) {
        return;
      }

      var allColumnTypes = Object.assign({}, DefaultColumnTypes);
      var userTypes = this.gos.get("columnTypes") || {};

      _iterateObject(userTypes, function (key, value) {
        if (key in allColumnTypes) {
          console.warn("AG Grid: the column type '".concat(key, "' is a default column type and cannot be overridden."));
        } else {
          var colType = value;

          if (colType.type) {
            _warnOnce("Column type definitions 'columnTypes' with a 'type' attribute are not supported because a column type cannot refer to another column type. Only column definitions 'columnDefs' can use the 'type' attribute to refer to a column type.");
          }

          allColumnTypes[key] = value;
        }
      });

      typeKeys.forEach(function (t) {
        var typeColDef = allColumnTypes[t.trim()];

        if (typeColDef) {
          _mergeDeep(colDefMerged, typeColDef, false, true);
        } else {
          console.warn("AG Grid: colDef.type '" + t + "' does not correspond to defined gridOptions.columnTypes");
        }
      });
    } // if object has children, we assume it's a group

  }, {
    key: "isColumnGroup",
    value: function isColumnGroup(abstractColDef) {
      return abstractColDef.children !== void 0;
    }
  }]);

  return _ColumnFactory;
}(_BeanStub2);

__decorateClass([_Autowired("dataTypeService")], _ColumnFactory.prototype, "dataTypeService", 2);

__decorateClass([__decorateParam(0, _Qualifier("loggerFactory"))], _ColumnFactory.prototype, "setBeans", 1);

_ColumnFactory = __decorateClass([_Bean("columnFactory")], _ColumnFactory);

function depthFirstOriginalTreeSearch(parent, tree, callback) {
  if (!tree) {
    return;
  }

  for (var i = 0; i < tree.length; i++) {
    var child = tree[i];

    if (child instanceof _ProvidedColumnGroup2) {
      depthFirstOriginalTreeSearch(child, child.getChildren(), callback);
    }

    callback(child, parent);
  }
} // community-modules/core/src/entities/columnGroup.ts


var _ColumnGroup =
/*#__PURE__*/
function () {
  "use strict";

  function _ColumnGroup(providedColumnGroup, groupId, partId, pinned) {
    _classCallCheck(this, _ColumnGroup);

    // depends on the open/closed state of the group, only displaying columns are stored here
    this.displayedChildren = [];
    this.localEventService = new _EventService();
    this.groupId = groupId;
    this.partId = partId;
    this.providedColumnGroup = providedColumnGroup;
    this.pinned = pinned;
  } // this is static, a it is used outside of this class


  _createClass(_ColumnGroup, [{
    key: "reset",
    // as the user is adding and removing columns, the groups are recalculated.
    // this reset clears out all children, ready for children to be added again
    value: function reset() {
      this.parent = null;
      this.children = null;
      this.displayedChildren = null;
    }
  }, {
    key: "getParent",
    value: function getParent() {
      return this.parent;
    }
  }, {
    key: "setParent",
    value: function setParent(parent) {
      this.parent = parent;
    }
  }, {
    key: "getUniqueId",
    value: function getUniqueId() {
      return _ColumnGroup.createUniqueId(this.groupId, this.partId);
    }
  }, {
    key: "isEmptyGroup",
    value: function isEmptyGroup() {
      return this.displayedChildren.length === 0;
    }
  }, {
    key: "isMoving",
    value: function isMoving() {
      var allLeafColumns = this.getProvidedColumnGroup().getLeafColumns();

      if (!allLeafColumns || allLeafColumns.length === 0) {
        return false;
      }

      return allLeafColumns.every(function (col) {
        return col.isMoving();
      });
    }
  }, {
    key: "checkLeft",
    value: function checkLeft() {
      this.displayedChildren.forEach(function (child) {
        if (child instanceof _ColumnGroup) {
          child.checkLeft();
        }
      });

      if (this.displayedChildren.length > 0) {
        if (this.gos.get("enableRtl")) {
          var lastChild = _last(this.displayedChildren);

          var lastChildLeft = lastChild.getLeft();
          this.setLeft(lastChildLeft);
        } else {
          var firstChildLeft = this.displayedChildren[0].getLeft();
          this.setLeft(firstChildLeft);
        }
      } else {
        this.setLeft(null);
      }
    }
  }, {
    key: "getLeft",
    value: function getLeft() {
      return this.left;
    }
  }, {
    key: "getOldLeft",
    value: function getOldLeft() {
      return this.oldLeft;
    }
  }, {
    key: "setLeft",
    value: function setLeft(left) {
      this.oldLeft = this.left;

      if (this.left !== left) {
        this.left = left;
        this.localEventService.dispatchEvent(this.createAgEvent(_ColumnGroup.EVENT_LEFT_CHANGED));
      }
    }
  }, {
    key: "getPinned",
    value: function getPinned() {
      return this.pinned;
    }
  }, {
    key: "createAgEvent",
    value: function createAgEvent(type) {
      return {
        type: type
      };
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(eventType, listener) {
      this.localEventService.addEventListener(eventType, listener);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventType, listener) {
      this.localEventService.removeEventListener(eventType, listener);
    }
  }, {
    key: "getGroupId",
    value: function getGroupId() {
      return this.groupId;
    }
  }, {
    key: "getPartId",
    value: function getPartId() {
      return this.partId;
    }
  }, {
    key: "isChildInThisGroupDeepSearch",
    value: function isChildInThisGroupDeepSearch(wantedChild) {
      var result = false;
      this.children.forEach(function (foundChild) {
        if (wantedChild === foundChild) {
          result = true;
        }

        if (foundChild instanceof _ColumnGroup) {
          if (foundChild.isChildInThisGroupDeepSearch(wantedChild)) {
            result = true;
          }
        }
      });
      return result;
    }
  }, {
    key: "getActualWidth",
    value: function getActualWidth() {
      var groupActualWidth = 0;

      if (this.displayedChildren) {
        this.displayedChildren.forEach(function (child) {
          groupActualWidth += child.getActualWidth();
        });
      }

      return groupActualWidth;
    }
  }, {
    key: "isResizable",
    value: function isResizable() {
      if (!this.displayedChildren) {
        return false;
      }

      var result = false;
      this.displayedChildren.forEach(function (child) {
        if (child.isResizable()) {
          result = true;
        }
      });
      return result;
    }
  }, {
    key: "getMinWidth",
    value: function getMinWidth() {
      var result = 0;
      this.displayedChildren.forEach(function (groupChild) {
        result += groupChild.getMinWidth() || 0;
      });
      return result;
    }
  }, {
    key: "addChild",
    value: function addChild(child) {
      if (!this.children) {
        this.children = [];
      }

      this.children.push(child);
    }
  }, {
    key: "getDisplayedChildren",
    value: function getDisplayedChildren() {
      return this.displayedChildren;
    }
  }, {
    key: "getLeafColumns",
    value: function getLeafColumns() {
      var result = [];
      this.addLeafColumns(result);
      return result;
    }
  }, {
    key: "getDisplayedLeafColumns",
    value: function getDisplayedLeafColumns() {
      var result = [];
      this.addDisplayedLeafColumns(result);
      return result;
    }
  }, {
    key: "getDefinition",
    value: function getDefinition() {
      return this.providedColumnGroup.getColGroupDef();
    }
  }, {
    key: "getColGroupDef",
    value: function getColGroupDef() {
      return this.providedColumnGroup.getColGroupDef();
    }
  }, {
    key: "isPadding",
    value: function isPadding() {
      return this.providedColumnGroup.isPadding();
    }
  }, {
    key: "isExpandable",
    value: function isExpandable() {
      return this.providedColumnGroup.isExpandable();
    }
  }, {
    key: "isExpanded",
    value: function isExpanded() {
      return this.providedColumnGroup.isExpanded();
    }
  }, {
    key: "setExpanded",
    value: function setExpanded(expanded) {
      this.providedColumnGroup.setExpanded(expanded);
    }
  }, {
    key: "addDisplayedLeafColumns",
    value: function addDisplayedLeafColumns(leafColumns) {
      this.displayedChildren.forEach(function (child) {
        if (child instanceof _Column2) {
          leafColumns.push(child);
        } else if (child instanceof _ColumnGroup) {
          child.addDisplayedLeafColumns(leafColumns);
        }
      });
    }
  }, {
    key: "addLeafColumns",
    value: function addLeafColumns(leafColumns) {
      this.children.forEach(function (child) {
        if (child instanceof _Column2) {
          leafColumns.push(child);
        } else if (child instanceof _ColumnGroup) {
          child.addLeafColumns(leafColumns);
        }
      });
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      return this.children;
    }
  }, {
    key: "getColumnGroupShow",
    value: function getColumnGroupShow() {
      return this.providedColumnGroup.getColumnGroupShow();
    }
  }, {
    key: "getProvidedColumnGroup",
    value: function getProvidedColumnGroup() {
      return this.providedColumnGroup;
    }
  }, {
    key: "getPaddingLevel",
    value: function getPaddingLevel() {
      var parent = this.getParent();

      if (!this.isPadding() || !parent || !parent.isPadding()) {
        return 0;
      }

      return 1 + parent.getPaddingLevel();
    }
  }, {
    key: "calculateDisplayedColumns",
    value: function calculateDisplayedColumns() {
      var _this17 = this;

      this.displayedChildren = [];
      var parentWithExpansion = this;

      while (parentWithExpansion != null && parentWithExpansion.isPadding()) {
        parentWithExpansion = parentWithExpansion.getParent();
      }

      var isExpandable = parentWithExpansion ? parentWithExpansion.providedColumnGroup.isExpandable() : false;

      if (!isExpandable) {
        this.displayedChildren = this.children;
        this.localEventService.dispatchEvent(this.createAgEvent(_ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED));
        return;
      }

      this.children.forEach(function (child) {
        var emptyGroup = child instanceof _ColumnGroup && (!child.displayedChildren || !child.displayedChildren.length);

        if (emptyGroup) {
          return;
        }

        var headerGroupShow = child.getColumnGroupShow();

        switch (headerGroupShow) {
          case "open":
            if (parentWithExpansion.providedColumnGroup.isExpanded()) {
              _this17.displayedChildren.push(child);
            }

            break;

          case "closed":
            if (!parentWithExpansion.providedColumnGroup.isExpanded()) {
              _this17.displayedChildren.push(child);
            }

            break;

          default:
            _this17.displayedChildren.push(child);

            break;
        }
      });
      this.localEventService.dispatchEvent(this.createAgEvent(_ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED));
    }
  }], [{
    key: "createUniqueId",
    value: function createUniqueId(groupId, instanceId) {
      return groupId + "_" + instanceId;
    }
  }]);

  return _ColumnGroup;
}();

_ColumnGroup.EVENT_LEFT_CHANGED = "leftChanged";
_ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED = "displayedChildrenChanged";

__decorateClass([_Autowired("gridOptionsService")], _ColumnGroup.prototype, "gos", 2);

var _ColumnGroup2 = _ColumnGroup; // community-modules/core/src/eventKeys.ts

var _Events = function _Events() {
  "use strict";

  _classCallCheck(this, _Events);
};
/** Everything has changed with the columns. Either complete new set of columns set, or user called applyColumnState() */

/** @deprecated - grid no longer uses this, and setSate() also fires individual events */


_Events.EVENT_COLUMN_EVERYTHING_CHANGED = "columnEverythingChanged";
/** User has set in new columns. */

_Events.EVENT_NEW_COLUMNS_LOADED = "newColumnsLoaded";
/** The pivot mode flag was changed */

_Events.EVENT_COLUMN_PIVOT_MODE_CHANGED = "columnPivotModeChanged";
/** Exceeded the pivot limit when generating columns */

_Events.EVENT_PIVOT_MAX_COLUMNS_EXCEEDED = "pivotMaxColumnsExceeded";
/** A row group column was added, removed or order changed. */

_Events.EVENT_COLUMN_ROW_GROUP_CHANGED = "columnRowGroupChanged";
/** expandAll / collapseAll was called from the api. */

_Events.EVENT_EXPAND_COLLAPSE_ALL = "expandOrCollapseAll";
/** A pivot column was added, removed or order changed. */

_Events.EVENT_COLUMN_PIVOT_CHANGED = "columnPivotChanged";
/** The list of grid columns has changed. */

_Events.EVENT_GRID_COLUMNS_CHANGED = "gridColumnsChanged";
/** A value column was added, removed or agg function was changed. */

_Events.EVENT_COLUMN_VALUE_CHANGED = "columnValueChanged";
/** A column was moved */

_Events.EVENT_COLUMN_MOVED = "columnMoved";
/** One or more columns was shown / hidden */

_Events.EVENT_COLUMN_VISIBLE = "columnVisible";
/** One or more columns was pinned / unpinned*/

_Events.EVENT_COLUMN_PINNED = "columnPinned";
/** A column group was opened / closed */

_Events.EVENT_COLUMN_GROUP_OPENED = "columnGroupOpened";
/** One or more columns was resized. If just one, the column in the event is set. */

_Events.EVENT_COLUMN_RESIZED = "columnResized";
/** The list of displayed columns has changed, can result from columns open / close, column move, pivot, group, etc */

_Events.EVENT_DISPLAYED_COLUMNS_CHANGED = "displayedColumnsChanged";
/** The grid option related to suppressing movable columns has changed */

_Events.EVENT_SUPPRESS_COLUMN_MOVE_CHANGED = "suppressMovableColumns";
/** The grid option related to suppressing column group selection has changed */

_Events.EVENT_SUPPRESS_MENU_HIDE_CHANGED = "suppressMenuHide";
/** The grid option related to suppressing movable columns has changed */

_Events.EVENT_SUPPRESS_FIELD_DOT_NOTATION = "suppressFieldDotNotation";
/** The list of virtual columns has changed, results from viewport changing */

_Events.EVENT_VIRTUAL_COLUMNS_CHANGED = "virtualColumnsChanged";
/** Column header mouse over */

_Events.EVENT_COLUMN_HEADER_MOUSE_OVER = "columnHeaderMouseOver";
/** Column header mouse leave */

_Events.EVENT_COLUMN_HEADER_MOUSE_LEAVE = "columnHeaderMouseLeave";
/** Column header clicked */

_Events.EVENT_COLUMN_HEADER_CLICKED = "columnHeaderClicked";
/** Column header context menu event, such as right-click or context menu key press */

_Events.EVENT_COLUMN_HEADER_CONTEXT_MENU = "columnHeaderContextMenu";
/** Async Transactions Executed */

_Events.EVENT_ASYNC_TRANSACTIONS_FLUSHED = "asyncTransactionsFlushed";
/** A row group was opened / closed */

_Events.EVENT_ROW_GROUP_OPENED = "rowGroupOpened";
/** Client-Side Row Model only. The client has updated data for the grid */

_Events.EVENT_ROW_DATA_UPDATED = "rowDataUpdated";
/** The client has set new floating data into the grid */

_Events.EVENT_PINNED_ROW_DATA_CHANGED = "pinnedRowDataChanged";
/** Range selection has changed */

_Events.EVENT_RANGE_SELECTION_CHANGED = "rangeSelectionChanged";
/** Chart was created */

_Events.EVENT_CHART_CREATED = "chartCreated";
/** Chart Range selection has changed */

_Events.EVENT_CHART_RANGE_SELECTION_CHANGED = "chartRangeSelectionChanged";
/** Chart Options have changed */

_Events.EVENT_CHART_OPTIONS_CHANGED = "chartOptionsChanged";
/** Chart was destroyed */

_Events.EVENT_CHART_DESTROYED = "chartDestroyed";
/** For when the tool panel is shown / hidden */

_Events.EVENT_TOOL_PANEL_VISIBLE_CHANGED = "toolPanelVisibleChanged";
_Events.EVENT_TOOL_PANEL_SIZE_CHANGED = "toolPanelSizeChanged";
_Events.EVENT_COLUMN_PANEL_ITEM_DRAG_START = "columnPanelItemDragStart";
_Events.EVENT_COLUMN_PANEL_ITEM_DRAG_END = "columnPanelItemDragEnd";
/** Model was updated - grid updates the drawn rows when this happens */

_Events.EVENT_MODEL_UPDATED = "modelUpdated";
_Events.EVENT_CUT_START = "cutStart";
_Events.EVENT_CUT_END = "cutEnd";
_Events.EVENT_PASTE_START = "pasteStart";
_Events.EVENT_PASTE_END = "pasteEnd";
_Events.EVENT_FILL_START = "fillStart";
_Events.EVENT_FILL_END = "fillEnd";
_Events.EVENT_RANGE_DELETE_START = "rangeDeleteStart";
_Events.EVENT_RANGE_DELETE_END = "rangeDeleteEnd";
/** Undo operation has started. */

_Events.EVENT_UNDO_STARTED = "undoStarted";
/** Undo operation has ended. */

_Events.EVENT_UNDO_ENDED = "undoEnded";
/** Redo operation has started. */

_Events.EVENT_REDO_STARTED = "redoStarted";
/** Redo operation has ended. */

_Events.EVENT_REDO_ENDED = "redoEnded";
_Events.EVENT_KEY_SHORTCUT_CHANGED_CELL_START = "keyShortcutChangedCellStart";
_Events.EVENT_KEY_SHORTCUT_CHANGED_CELL_END = "keyShortcutChangedCellEnd";
_Events.EVENT_CELL_CLICKED = "cellClicked";
_Events.EVENT_CELL_DOUBLE_CLICKED = "cellDoubleClicked";
_Events.EVENT_CELL_MOUSE_DOWN = "cellMouseDown";
_Events.EVENT_CELL_CONTEXT_MENU = "cellContextMenu";
_Events.EVENT_CELL_VALUE_CHANGED = "cellValueChanged";
_Events.EVENT_CELL_EDIT_REQUEST = "cellEditRequest";
_Events.EVENT_ROW_VALUE_CHANGED = "rowValueChanged";
_Events.EVENT_CELL_FOCUSED = "cellFocused";
_Events.EVENT_CELL_FOCUS_CLEARED = "cellFocusCleared";
_Events.EVENT_FULL_WIDTH_ROW_FOCUSED = "fullWidthRowFocused";
_Events.EVENT_ROW_SELECTED = "rowSelected";
_Events.EVENT_SELECTION_CHANGED = "selectionChanged";
_Events.EVENT_TOOLTIP_SHOW = "tooltipShow";
_Events.EVENT_TOOLTIP_HIDE = "tooltipHide";
_Events.EVENT_CELL_KEY_DOWN = "cellKeyDown";
_Events.EVENT_CELL_MOUSE_OVER = "cellMouseOver";
_Events.EVENT_CELL_MOUSE_OUT = "cellMouseOut";
/** 2 events for filtering. The grid LISTENS for filterChanged and afterFilterChanged */

_Events.EVENT_FILTER_CHANGED = "filterChanged";
/** Filter was change but not applied. Only useful if apply buttons are used in filters. */

_Events.EVENT_FILTER_MODIFIED = "filterModified";
_Events.EVENT_FILTER_OPENED = "filterOpened";
_Events.EVENT_ADVANCED_FILTER_BUILDER_VISIBLE_CHANGED = "advancedFilterBuilderVisibleChanged";
_Events.EVENT_SORT_CHANGED = "sortChanged";
/** A row was removed from the dom, for any reason. Use to clean up resources (if any) used by the row. */

_Events.EVENT_VIRTUAL_ROW_REMOVED = "virtualRowRemoved";
_Events.EVENT_ROW_CLICKED = "rowClicked";
_Events.EVENT_ROW_DOUBLE_CLICKED = "rowDoubleClicked";
/** Gets called once after the grid has finished initialising. */

_Events.EVENT_GRID_READY = "gridReady";
/** Called once when the grid is about to get destroyed. */

_Events.EVENT_GRID_PRE_DESTROYED = "gridPreDestroyed";
/** Width of height of the main grid div has changed. Grid listens for this and does layout of grid if it's
 * changed, so always filling the space it was given. */

_Events.EVENT_GRID_SIZE_CHANGED = "gridSizeChanged";
/** The indexes of the rows rendered has changed, eg user has scrolled to a new vertical position. */

_Events.EVENT_VIEWPORT_CHANGED = "viewportChanged";
/* The width of the scrollbar has been calculated */

_Events.EVENT_SCROLLBAR_WIDTH_CHANGED = "scrollbarWidthChanged";
/** Rows were rendered for the first time (ie on async data load). */

_Events.EVENT_FIRST_DATA_RENDERED = "firstDataRendered";
/** A column drag has started, either resizing a column or moving a column. */

_Events.EVENT_DRAG_STARTED = "dragStarted";
/** A column drag has stopped */

_Events.EVENT_DRAG_STOPPED = "dragStopped";
_Events.EVENT_CHECKBOX_CHANGED = "checkboxChanged";
_Events.EVENT_ROW_EDITING_STARTED = "rowEditingStarted";
_Events.EVENT_ROW_EDITING_STOPPED = "rowEditingStopped";
_Events.EVENT_CELL_EDITING_STARTED = "cellEditingStarted";
_Events.EVENT_CELL_EDITING_STOPPED = "cellEditingStopped";
/** Main body of grid has scrolled, either horizontally or vertically */

_Events.EVENT_BODY_SCROLL = "bodyScroll";
/** Main body of the grid has stopped scrolling, either horizontally or vertically */

_Events.EVENT_BODY_SCROLL_END = "bodyScrollEnd";
_Events.EVENT_HEIGHT_SCALE_CHANGED = "heightScaleChanged";
/** The displayed page for pagination has changed. For example the data was filtered or sorted,
 * or the user has moved to a different page. */

_Events.EVENT_PAGINATION_CHANGED = "paginationChanged";
/** Only used by React, Angular, Web Components and VueJS AG Grid components
 * (not used if doing plain JavaScript). If the grid receives changes due
 * to bound properties, this event fires after the grid has finished processing the change. */

_Events.EVENT_COMPONENT_STATE_CHANGED = "componentStateChanged";
/** Only used by the SSRM, called when the grid has no more rows to refresh */

_Events.EVENT_STORE_REFRESHED = "storeRefreshed";
_Events.EVENT_STATE_UPDATED = "stateUpdated";
/** The visibility of the column menu has changed. */

_Events.EVENT_COLUMN_MENU_VISIBLE_CHANGED = "columnMenuVisibleChanged";
/** The visibility of the context menu has changed. */

_Events.EVENT_CONTEXT_MENU_VISIBLE_CHANGED = "contextMenuVisibleChanged";
/*****************************  INTERNAL EVENTS: START ******************************************* */

/** Please remember to add to ComponentUtil.EXCLUDED_INTERNAL_EVENTS to not have these events exposed to framework components. */

/** All items from here down are used internally by the grid, not intended for external use. */
// not documented, either experimental, or we just don't want users using an depending on them

_Events.EVENT_BODY_HEIGHT_CHANGED = "bodyHeightChanged";
_Events.EVENT_COLUMN_CONTAINER_WIDTH_CHANGED = "columnContainerWidthChanged";
_Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED = "displayedColumnsWidthChanged";
_Events.EVENT_SCROLL_VISIBILITY_CHANGED = "scrollVisibilityChanged";
_Events.EVENT_COLUMN_HOVER_CHANGED = "columnHoverChanged";
_Events.EVENT_FLASH_CELLS = "flashCells";
_Events.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED = "paginationPixelOffsetChanged";
_Events.EVENT_DISPLAYED_ROWS_CHANGED = "displayedRowsChanged";
_Events.EVENT_LEFT_PINNED_WIDTH_CHANGED = "leftPinnedWidthChanged";
_Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED = "rightPinnedWidthChanged";
_Events.EVENT_ROW_CONTAINER_HEIGHT_CHANGED = "rowContainerHeightChanged";
_Events.EVENT_HEADER_HEIGHT_CHANGED = "headerHeightChanged";
_Events.EVENT_COLUMN_HEADER_HEIGHT_CHANGED = "columnHeaderHeightChanged";
_Events.EVENT_ROW_DRAG_ENTER = "rowDragEnter";
_Events.EVENT_ROW_DRAG_MOVE = "rowDragMove";
_Events.EVENT_ROW_DRAG_LEAVE = "rowDragLeave";
_Events.EVENT_ROW_DRAG_END = "rowDragEnd"; // environment

_Events.EVENT_GRID_STYLES_CHANGED = "gridStylesChanged"; // these are used for server side group and agg - only used by CS with Viewport Row Model - intention is
// to design these better around server side functions and then release to general public when fully working with
// all the row models.

_Events.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST = "columnRowGroupChangeRequest";
_Events.EVENT_COLUMN_PIVOT_CHANGE_REQUEST = "columnPivotChangeRequest";
_Events.EVENT_COLUMN_VALUE_CHANGE_REQUEST = "columnValueChangeRequest";
_Events.EVENT_COLUMN_AGG_FUNC_CHANGE_REQUEST = "columnAggFuncChangeRequest";
_Events.EVENT_STORE_UPDATED = "storeUpdated";
_Events.EVENT_FILTER_DESTROYED = "filterDestroyed";
_Events.EVENT_ROW_DATA_UPDATE_STARTED = "rowDataUpdateStarted";
_Events.EVENT_ROW_COUNT_READY = "rowCountReady"; // Advanced Filters

_Events.EVENT_ADVANCED_FILTER_ENABLED_CHANGED = "advancedFilterEnabledChanged";
_Events.EVENT_DATA_TYPES_INFERRED = "dataTypesInferred"; // Widgets

_Events.EVENT_FIELD_VALUE_CHANGED = "fieldValueChanged";
_Events.EVENT_FIELD_PICKER_VALUE_SELECTED = "fieldPickerValueSelected";
_Events.EVENT_SIDE_BAR_UPDATED = "sideBarUpdated"; // community-modules/core/src/events.ts

var _ALWAYS_SYNC_GLOBAL_EVENTS =
/* @__PURE__ */
new Set([_Events.EVENT_GRID_PRE_DESTROYED, _Events.EVENT_FILL_START]); // community-modules/core/src/columns/groupInstanceIdCreator.ts


var _GroupInstanceIdCreator =
/*#__PURE__*/
function () {
  "use strict";

  function _GroupInstanceIdCreator() {
    _classCallCheck(this, _GroupInstanceIdCreator);

    // this map contains keys to numbers, so we remember what the last call was
    this.existingIds = {};
  }

  _createClass(_GroupInstanceIdCreator, [{
    key: "getInstanceIdForKey",
    value: function getInstanceIdForKey(key) {
      var lastResult = this.existingIds[key];
      var result;

      if (typeof lastResult !== "number") {
        result = 0;
      } else {
        result = lastResult + 1;
      }

      this.existingIds[key] = result;
      return result;
    }
  }]);

  return _GroupInstanceIdCreator;
}(); // community-modules/core/src/columns/autoGroupColService.ts


var _GROUP_AUTO_COLUMN_ID = "ag-Grid-AutoColumn";

var AutoGroupColService =
/*#__PURE__*/
function (_BeanStub4) {
  "use strict";

  _inherits(AutoGroupColService, _BeanStub4);

  function AutoGroupColService() {
    _classCallCheck(this, AutoGroupColService);

    return _possibleConstructorReturn(this, _getPrototypeOf(AutoGroupColService).apply(this, arguments));
  }

  _createClass(AutoGroupColService, [{
    key: "createAutoGroupColumns",
    value: function createAutoGroupColumns(rowGroupColumns) {
      var _this18 = this;

      var groupAutoColumns = [];
      var doingTreeData = this.gos.get("treeData");
      var doingMultiAutoColumn = this.gos.isGroupMultiAutoColumn();

      if (doingTreeData && doingMultiAutoColumn) {
        console.warn('AG Grid: you cannot mix groupDisplayType = "multipleColumns" with treeData, only one column can be used to display groups when doing tree data');
        doingMultiAutoColumn = false;
      }

      if (doingMultiAutoColumn) {
        rowGroupColumns.forEach(function (rowGroupCol, index) {
          groupAutoColumns.push(_this18.createOneAutoGroupColumn(rowGroupCol, index));
        });
      } else {
        groupAutoColumns.push(this.createOneAutoGroupColumn());
      }

      return groupAutoColumns;
    }
  }, {
    key: "updateAutoGroupColumns",
    value: function updateAutoGroupColumns(autoGroupColumns, source) {
      var _this19 = this;

      autoGroupColumns.forEach(function (column, index) {
        return _this19.updateOneAutoGroupColumn(column, index, source);
      });
    } // rowGroupCol and index are missing if groupDisplayType != "multipleColumns"

  }, {
    key: "createOneAutoGroupColumn",
    value: function createOneAutoGroupColumn(rowGroupCol, index) {
      var colId;

      if (rowGroupCol) {
        colId = "".concat(_GROUP_AUTO_COLUMN_ID, "-").concat(rowGroupCol.getId());
      } else {
        colId = _GROUP_AUTO_COLUMN_ID;
      }

      var colDef = this.createAutoGroupColDef(colId, rowGroupCol, index);
      colDef.colId = colId;
      var newCol = new _Column2(colDef, null, colId, true);
      this.context.createBean(newCol);
      return newCol;
    }
    /**
     * Refreshes an auto group col to load changes from defaultColDef or autoGroupColDef
     */

  }, {
    key: "updateOneAutoGroupColumn",
    value: function updateOneAutoGroupColumn(colToUpdate, index, source) {
      var oldColDef = colToUpdate.getColDef();
      var underlyingColId = typeof oldColDef.showRowGroup == "string" ? oldColDef.showRowGroup : void 0;
      var underlyingColumn = underlyingColId != null ? this.columnModel.getPrimaryColumn(underlyingColId) : void 0;
      var colDef = this.createAutoGroupColDef(colToUpdate.getId(), underlyingColumn != null ? underlyingColumn : void 0, index);
      colToUpdate.setColDef(colDef, null, source);
      this.columnFactory.applyColumnState(colToUpdate, colDef, source);
    }
  }, {
    key: "createAutoGroupColDef",
    value: function createAutoGroupColDef(colId, underlyingColumn, index) {
      var res = this.createBaseColDef(underlyingColumn);
      var autoGroupColumnDef = this.gos.get("autoGroupColumnDef");

      _mergeDeep(res, autoGroupColumnDef);

      res = this.columnFactory.addColumnDefaultAndTypes(res, colId);

      if (!this.gos.get("treeData")) {
        var noFieldOrValueGetter = _missing(res.field) && _missing(res.valueGetter) && _missing(res.filterValueGetter) && res.filter !== "agGroupColumnFilter";

        if (noFieldOrValueGetter) {
          res.filter = false;
        }
      }

      if (index && index > 0) {
        res.headerCheckboxSelection = false;
      }

      var isSortingCoupled = this.gos.isColumnsSortingCoupledToGroup();
      var hasOwnData = res.valueGetter || res.field != null;

      if (isSortingCoupled && !hasOwnData) {
        res.sortIndex = void 0;
        res.initialSort = void 0;
      }

      return res;
    }
  }, {
    key: "createBaseColDef",
    value: function createBaseColDef(rowGroupCol) {
      var userDef = this.gos.get("autoGroupColumnDef");
      var localeTextFunc = this.localeService.getLocaleTextFunc();
      var res = {
        headerName: localeTextFunc("group", "Group")
      };
      var userHasProvidedGroupCellRenderer = userDef && (userDef.cellRenderer || userDef.cellRendererSelector);

      if (!userHasProvidedGroupCellRenderer) {
        res.cellRenderer = "agGroupCellRenderer";
      }

      if (rowGroupCol) {
        var colDef = rowGroupCol.getColDef();
        Object.assign(res, {
          // cellRendererParams.groupKey: colDefToCopy.field;
          headerName: this.columnModel.getDisplayNameForColumn(rowGroupCol, "header"),
          headerValueGetter: colDef.headerValueGetter
        });

        if (colDef.cellRenderer) {
          Object.assign(res, {
            cellRendererParams: {
              innerRenderer: colDef.cellRenderer,
              innerRendererParams: colDef.cellRendererParams
            }
          });
        }

        res.showRowGroup = rowGroupCol.getColId();
      } else {
        res.showRowGroup = true;
      }

      return res;
    }
  }]);

  return AutoGroupColService;
}(_BeanStub2);

__decorateClass([_Autowired("columnModel")], AutoGroupColService.prototype, "columnModel", 2);

__decorateClass([_Autowired("columnFactory")], AutoGroupColService.prototype, "columnFactory", 2);

AutoGroupColService = __decorateClass([_Bean("autoGroupColService")], AutoGroupColService); // community-modules/core/src/utils/string.ts

var string_exports = {};

__export(string_exports, {
  camelCaseToHumanText: function camelCaseToHumanText() {
    return _camelCaseToHumanText;
  },
  camelCaseToHyphenated: function camelCaseToHyphenated() {
    return _camelCaseToHyphenated;
  },
  capitalise: function capitalise() {
    return _capitalise;
  },
  escapeString: function escapeString() {
    return _escapeString;
  },
  utf8_encode: function utf8_encode() {
    return _utf8_encode;
  }
});

var reUnescapedHtml = /[&<>"']/g;
var HTML_ESCAPES = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};

function _utf8_encode(s) {
  var stringFromCharCode = String.fromCharCode;

  function ucs2decode(string) {
    var output = [];

    if (!string) {
      return [];
    }

    var len = string.length;
    var counter = 0;
    var value;
    var extra;

    while (counter < len) {
      value = string.charCodeAt(counter++);

      if (value >= 55296 && value <= 56319 && counter < len) {
        extra = string.charCodeAt(counter++);

        if ((extra & 64512) == 56320) {
          output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
        } else {
          output.push(value);
          counter--;
        }
      } else {
        output.push(value);
      }
    }

    return output;
  }

  function checkScalarValue(point) {
    if (point >= 55296 && point <= 57343) {
      throw Error("Lone surrogate U+" + point.toString(16).toUpperCase() + " is not a scalar value");
    }
  }

  function createByte(point, shift) {
    return stringFromCharCode(point >> shift & 63 | 128);
  }

  function encodeCodePoint(point) {
    if (point >= 0 && point <= 31 && point !== 10) {
      var convertedCode = point.toString(16).toUpperCase();
      var paddedCode = convertedCode.padStart(4, "0");
      return "_x".concat(paddedCode, "_");
    }

    if ((point & 4294967168) == 0) {
      return stringFromCharCode(point);
    }

    var symbol = "";

    if ((point & 4294965248) == 0) {
      symbol = stringFromCharCode(point >> 6 & 31 | 192);
    } else if ((point & 4294901760) == 0) {
      checkScalarValue(point);
      symbol = stringFromCharCode(point >> 12 & 15 | 224);
      symbol += createByte(point, 6);
    } else if ((point & 4292870144) == 0) {
      symbol = stringFromCharCode(point >> 18 & 7 | 240);
      symbol += createByte(point, 12);
      symbol += createByte(point, 6);
    }

    symbol += stringFromCharCode(point & 63 | 128);
    return symbol;
  }

  var codePoints = ucs2decode(s);
  var length = codePoints.length;
  var index = -1;
  var codePoint;
  var byteString = "";

  while (++index < length) {
    codePoint = codePoints[index];
    byteString += encodeCodePoint(codePoint);
  }

  return byteString;
}

function _capitalise(str) {
  return str[0].toUpperCase() + str.substring(1).toLowerCase();
}

function _escapeString(toEscape, skipEscapingHtmlChars) {
  if (toEscape == null) {
    return null;
  }

  var stringResult = toEscape.toString().toString();

  if (skipEscapingHtmlChars) {
    return stringResult;
  }

  return stringResult.replace(reUnescapedHtml, function (chr) {
    return HTML_ESCAPES[chr];
  });
}

function _camelCaseToHumanText(camelCase) {
  if (!camelCase || camelCase == null) {
    return null;
  }

  var rex = /([a-z])([A-Z])/g;
  var rexCaps = /([A-Z]+)([A-Z])([a-z])/g;
  var words = camelCase.replace(rex, "$1 $2").replace(rexCaps, "$1 $2$3").replace(/\./g, " ").split(" ");
  return words.map(function (word) {
    return word.substring(0, 1).toUpperCase() + (word.length > 1 ? word.substring(1, word.length) : "");
  }).join(" ");
}

function _camelCaseToHyphenated(camelCase) {
  return camelCase.replace(/[A-Z]/g, function (s) {
    return "-".concat(s.toLocaleLowerCase());
  });
} // community-modules/core/src/utils/map.ts


var map_exports = {};

__export(map_exports, {
  convertToMap: function convertToMap() {
    return _convertToMap;
  },
  keys: function keys() {
    return _keys;
  },
  mapById: function mapById() {
    return _mapById;
  }
});

function _convertToMap(arr) {
  var map =
  /* @__PURE__ */
  new Map();
  arr.forEach(function (pair) {
    return map.set(pair[0], pair[1]);
  });
  return map;
}

function _mapById(arr, callback) {
  var map =
  /* @__PURE__ */
  new Map();
  arr.forEach(function (item) {
    return map.set(callback(item), item);
  });
  return map;
}

function _keys(map) {
  var arr = [];
  map.forEach(function (_2, key) {
    return arr.push(key);
  });
  return arr;
} // community-modules/core/src/columns/columnModel.ts


var _ColumnModel =
/*#__PURE__*/
function (_BeanStub5) {
  "use strict";

  _inherits(_ColumnModel, _BeanStub5);

  function _ColumnModel() {
    var _this20;

    _classCallCheck(this, _ColumnModel);

    _this20 = _possibleConstructorReturn(this, _getPrototypeOf(_ColumnModel).apply(this, arguments)); // header row count, based on user provided columns

    _this20.primaryHeaderRowCount = 0;
    _this20.secondaryHeaderRowCount = 0; // header row count, either above, or based on pivoting if we are pivoting

    _this20.gridHeaderRowCount = 0; // leave level columns of the displayed trees

    _this20.displayedColumnsLeft = [];
    _this20.displayedColumnsRight = [];
    _this20.displayedColumnsCenter = []; // all three lists above combined

    _this20.displayedColumns = []; // for fast lookup, to see if a column or group is still displayed

    _this20.displayedColumnsAndGroupsMap = {}; // all columns to be rendered

    _this20.viewportColumns = []; // A hash key to keep track of changes in viewport columns

    _this20.viewportColumnsHash = ""; // same as viewportColumns, except we always include columns with headerAutoHeight

    _this20.headerViewportColumns = []; // all columns to be rendered in the centre

    _this20.viewportColumnsCenter = []; // same as viewportColumnsCenter, except we always include columns with headerAutoHeight

    _this20.headerViewportColumnsCenter = []; // all columns & groups to be rendered, index by row. used by header rows to get all items
    // to render for that row.

    _this20.viewportRowLeft = {};
    _this20.viewportRowRight = {};
    _this20.viewportRowCenter = {};
    _this20.autoHeightActiveAtLeastOnce = false;
    _this20.rowGroupColumns = [];
    _this20.valueColumns = [];
    _this20.pivotColumns = [];
    _this20.ready = false;
    _this20.changeEventsDispatching = false;
    _this20.autoGroupsNeedBuilding = false;
    _this20.forceRecreateAutoGroups = false;
    _this20.pivotMode = false;
    _this20.bodyWidth = 0;
    _this20.leftWidth = 0;
    _this20.rightWidth = 0;
    _this20.bodyWidthDirty = true; // when we're waiting for cell data types to be inferred, we need to defer column resizing

    _this20.shouldQueueResizeOperations = false;
    _this20.resizeOperationQueue = [];
    return _this20;
  }

  _createClass(_ColumnModel, [{
    key: "init",
    value: function init() {
      var _this21 = this;

      this.suppressColumnVirtualisation = this.gos.get("suppressColumnVirtualisation");
      var pivotMode = this.gos.get("pivotMode");

      if (this.isPivotSettingAllowed(pivotMode)) {
        this.pivotMode = pivotMode;
      }

      this.addManagedPropertyListeners(["groupDisplayType", "treeData", "treeDataDisplayType", "groupHideOpenParents"], function (event) {
        return _this21.buildAutoGroupColumns(convertSourceType(event.source));
      });
      this.addManagedPropertyListener("autoGroupColumnDef", function (event) {
        return _this21.onAutoGroupColumnDefChanged(convertSourceType(event.source));
      });
      this.addManagedPropertyListeners(["defaultColDef", "columnTypes", "suppressFieldDotNotation"], function (event) {
        return _this21.onSharedColDefChanged(convertSourceType(event.source));
      });
      this.addManagedPropertyListener("pivotMode", function (event) {
        return _this21.setPivotMode(_this21.gos.get("pivotMode"), convertSourceType(event.source));
      });
      this.addManagedListener(this.eventService, _Events.EVENT_FIRST_DATA_RENDERED, function () {
        return _this21.onFirstDataRendered();
      });
    }
  }, {
    key: "buildAutoGroupColumns",
    value: function buildAutoGroupColumns(source) {
      if (!this.columnDefs) {
        return;
      }

      this.autoGroupsNeedBuilding = true;
      this.forceRecreateAutoGroups = true;
      this.updateGridColumns();
      this.updateDisplayedColumns(source);
    }
  }, {
    key: "onAutoGroupColumnDefChanged",
    value: function onAutoGroupColumnDefChanged(source) {
      if (this.groupAutoColumns) {
        this.autoGroupColService.updateAutoGroupColumns(this.groupAutoColumns, source);
      }
    }
  }, {
    key: "onSharedColDefChanged",
    value: function onSharedColDefChanged(source) {
      if (!this.gridColumns) {
        return;
      }

      if (this.groupAutoColumns) {
        this.autoGroupColService.updateAutoGroupColumns(this.groupAutoColumns, source);
      }

      this.createColumnsFromColumnDefs(true, source);
    }
  }, {
    key: "setColumnDefs",
    value: function setColumnDefs(columnDefs, source) {
      var colsPreviouslyExisted = !!this.columnDefs;
      this.columnDefs = columnDefs;
      this.createColumnsFromColumnDefs(colsPreviouslyExisted, source);
    }
  }, {
    key: "recreateColumnDefs",
    value: function recreateColumnDefs(source) {
      this.onSharedColDefChanged(source);
    }
  }, {
    key: "destroyOldColumns",
    value: function destroyOldColumns(oldTree, newTree) {
      var oldObjectsById = {};

      if (!oldTree) {
        return;
      }

      depthFirstOriginalTreeSearch(null, oldTree, function (child) {
        oldObjectsById[child.getInstanceId()] = child;
      });

      if (newTree) {
        depthFirstOriginalTreeSearch(null, newTree, function (child) {
          oldObjectsById[child.getInstanceId()] = null;
        });
      }

      var colsToDestroy = Object.values(oldObjectsById).filter(function (item) {
        return item != null;
      });
      this.destroyBeans(colsToDestroy);
    }
  }, {
    key: "destroyColumns",
    value: function destroyColumns() {
      this.destroyOldColumns(this.primaryColumnTree);
      this.destroyOldColumns(this.secondaryBalancedTree);
      this.destroyOldColumns(this.groupAutoColsBalancedTree);
    }
  }, {
    key: "createColumnsFromColumnDefs",
    value: function createColumnsFromColumnDefs(colsPreviouslyExisted, source) {
      var _this22 = this;

      var dispatchEventsFunc = colsPreviouslyExisted ? this.compareColumnStatesAndDispatchEvents(source) : void 0;
      this.valueCache.expire();
      this.autoGroupsNeedBuilding = true;
      var oldPrimaryColumns = this.primaryColumns;
      var oldPrimaryTree = this.primaryColumnTree;
      var balancedTreeResult = this.columnFactory.createColumnTree(this.columnDefs, true, oldPrimaryTree, source);
      this.destroyOldColumns(this.primaryColumnTree, balancedTreeResult.columnTree);
      this.primaryColumnTree = balancedTreeResult.columnTree;
      this.primaryHeaderRowCount = balancedTreeResult.treeDept + 1;
      this.primaryColumns = this.getColumnsFromTree(this.primaryColumnTree);
      this.primaryColumnsMap = {};
      this.primaryColumns.forEach(function (col) {
        return _this22.primaryColumnsMap[col.getId()] = col;
      });
      this.extractRowGroupColumns(source, oldPrimaryColumns);
      this.extractPivotColumns(source, oldPrimaryColumns);
      this.extractValueColumns(source, oldPrimaryColumns);
      this.ready = true;
      var gridColsNotProcessed = this.gridColsArePrimary === void 0;
      var processGridCols = this.gridColsArePrimary || gridColsNotProcessed || this.autoGroupsNeedBuilding;

      if (processGridCols) {
        this.updateGridColumns();

        if (colsPreviouslyExisted && this.gridColsArePrimary && !this.gos.get("maintainColumnOrder")) {
          this.orderGridColumnsLikePrimary();
        }

        this.updateDisplayedColumns(source);
        this.checkViewportColumns();
      }

      this.dispatchEverythingChanged(source);
      this.changeEventsDispatching = true;

      if (dispatchEventsFunc) {
        dispatchEventsFunc();
      }

      this.changeEventsDispatching = false;
      this.dispatchNewColumnsLoaded(source);
    }
  }, {
    key: "shouldRowModelIgnoreRefresh",
    value: function shouldRowModelIgnoreRefresh() {
      return this.changeEventsDispatching;
    }
  }, {
    key: "dispatchNewColumnsLoaded",
    value: function dispatchNewColumnsLoaded(source) {
      var newColumnsLoadedEvent = {
        type: _Events.EVENT_NEW_COLUMNS_LOADED,
        source: source
      };
      this.eventService.dispatchEvent(newColumnsLoadedEvent);

      if (source === "gridInitializing") {
        this.onColumnsReady();
      }
    } // this event is legacy, no grid code listens to it. instead the grid listens to New Columns Loaded

  }, {
    key: "dispatchEverythingChanged",
    value: function dispatchEverythingChanged(source) {
      var eventEverythingChanged = {
        type: _Events.EVENT_COLUMN_EVERYTHING_CHANGED,
        source: source
      };
      this.eventService.dispatchEvent(eventEverythingChanged);
    }
  }, {
    key: "orderGridColumnsLikePrimary",
    value: function orderGridColumnsLikePrimary() {
      var _this23 = this;

      var primaryColumns = this.primaryColumns;

      if (!primaryColumns) {
        return;
      }

      var primaryColsOrdered = primaryColumns.filter(function (col) {
        return _this23.gridColumns.indexOf(col) >= 0;
      });
      var otherCols = this.gridColumns.filter(function (col) {
        return primaryColsOrdered.indexOf(col) < 0;
      });
      this.gridColumns = [].concat(_toConsumableArray(otherCols), _toConsumableArray(primaryColsOrdered));
      this.gridColumns = this.placeLockedColumns(this.gridColumns);
    }
  }, {
    key: "getAllDisplayedAutoHeightCols",
    value: function getAllDisplayedAutoHeightCols() {
      return this.displayedAutoHeightCols;
    }
  }, {
    key: "setViewport",
    value: function setViewport() {
      if (this.gos.get("enableRtl")) {
        this.viewportLeft = this.bodyWidth - this.scrollPosition - this.scrollWidth;
        this.viewportRight = this.bodyWidth - this.scrollPosition;
      } else {
        this.viewportLeft = this.scrollPosition;
        this.viewportRight = this.scrollWidth + this.scrollPosition;
      }
    } // checks what columns are currently displayed due to column virtualisation. dispatches an event
    // if the list of columns has changed.
    // + setColumnWidth(), setViewportPosition(), setColumnDefs(), sizeColumnsToFit()

  }, {
    key: "checkViewportColumns",
    value: function checkViewportColumns() {
      var afterScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.displayedColumnsCenter == null) {
        return;
      }

      var viewportColumnsChanged = this.extractViewport();

      if (!viewportColumnsChanged) {
        return;
      }

      var event = {
        type: _Events.EVENT_VIRTUAL_COLUMNS_CHANGED,
        afterScroll: afterScroll
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "setViewportPosition",
    value: function setViewportPosition(scrollWidth, scrollPosition) {
      var afterScroll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (scrollWidth !== this.scrollWidth || scrollPosition !== this.scrollPosition || this.bodyWidthDirty) {
        this.scrollWidth = scrollWidth;
        this.scrollPosition = scrollPosition;
        this.bodyWidthDirty = true;
        this.setViewport();

        if (this.ready) {
          this.checkViewportColumns(afterScroll);
        }
      }
    }
  }, {
    key: "isPivotMode",
    value: function isPivotMode() {
      return this.pivotMode;
    }
  }, {
    key: "isPivotSettingAllowed",
    value: function isPivotSettingAllowed(pivot) {
      if (pivot && this.gos.get("treeData")) {
        _warnOnce("Pivot mode not available with treeData.");

        return false;
      }

      return true;
    }
  }, {
    key: "setPivotMode",
    value: function setPivotMode(pivotMode, source) {
      if (pivotMode === this.pivotMode || !this.isPivotSettingAllowed(this.pivotMode)) {
        return;
      }

      this.pivotMode = pivotMode;

      if (!this.gridColumns) {
        return;
      }

      this.autoGroupsNeedBuilding = true;
      this.updateGridColumns();
      this.updateDisplayedColumns(source);
      var event = {
        type: _Events.EVENT_COLUMN_PIVOT_MODE_CHANGED
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "getSecondaryPivotColumn",
    value: function getSecondaryPivotColumn(pivotKeys, valueColKey) {
      if (_missing(this.secondaryColumns)) {
        return null;
      }

      var valueColumnToFind = this.getPrimaryColumn(valueColKey);
      var foundColumn = null;
      this.secondaryColumns.forEach(function (column) {
        var thisPivotKeys = column.getColDef().pivotKeys;
        var pivotValueColumn = column.getColDef().pivotValueColumn;

        var pivotKeyMatches = _areEqual(thisPivotKeys, pivotKeys);

        var pivotValueMatches = pivotValueColumn === valueColumnToFind;

        if (pivotKeyMatches && pivotValueMatches) {
          foundColumn = column;
        }
      });
      return foundColumn;
    }
  }, {
    key: "setBeans",
    value: function setBeans(loggerFactory) {
      this.logger = loggerFactory.create("columnModel");
    }
  }, {
    key: "setFirstRightAndLastLeftPinned",
    value: function setFirstRightAndLastLeftPinned(source) {
      var lastLeft;
      var firstRight;

      if (this.gos.get("enableRtl")) {
        lastLeft = this.displayedColumnsLeft ? this.displayedColumnsLeft[0] : null;
        firstRight = this.displayedColumnsRight ? _last(this.displayedColumnsRight) : null;
      } else {
        lastLeft = this.displayedColumnsLeft ? _last(this.displayedColumnsLeft) : null;
        firstRight = this.displayedColumnsRight ? this.displayedColumnsRight[0] : null;
      }

      this.gridColumns.forEach(function (column) {
        column.setLastLeftPinned(column === lastLeft, source);
        column.setFirstRightPinned(column === firstRight, source);
      });
    }
  }, {
    key: "autoSizeColumns",
    value: function autoSizeColumns(params) {
      var _this24 = this;

      if (this.shouldQueueResizeOperations) {
        this.resizeOperationQueue.push(function () {
          return _this24.autoSizeColumns(params);
        });
        return;
      }

      var columns = params.columns,
          skipHeader = params.skipHeader,
          skipHeaderGroups = params.skipHeaderGroups,
          stopAtGroup = params.stopAtGroup,
          _params$source = params.source,
          source = _params$source === void 0 ? "api" : _params$source;
      this.animationFrameService.flushAllFrames();
      var columnsAutosized = [];
      var changesThisTimeAround = -1;
      var shouldSkipHeader = skipHeader != null ? skipHeader : this.gos.get("skipHeaderOnAutoSize");
      var shouldSkipHeaderGroups = skipHeaderGroups != null ? skipHeaderGroups : shouldSkipHeader;

      while (changesThisTimeAround !== 0) {
        changesThisTimeAround = 0;
        this.actionOnGridColumns(columns, function (column) {
          if (columnsAutosized.indexOf(column) >= 0) {
            return false;
          }

          var preferredWidth = _this24.autoWidthCalculator.getPreferredWidthForColumn(column, shouldSkipHeader);

          if (preferredWidth > 0) {
            var newWidth = _this24.normaliseColumnWidth(column, preferredWidth);

            column.setActualWidth(newWidth, source);
            columnsAutosized.push(column);
            changesThisTimeAround++;
          }

          return true;
        }, source);
      }

      if (!shouldSkipHeaderGroups) {
        this.autoSizeColumnGroupsByColumns(columns, source, stopAtGroup);
      }

      this.dispatchColumnResizedEvent(columnsAutosized, true, "autosizeColumns");
    }
  }, {
    key: "dispatchColumnResizedEvent",
    value: function dispatchColumnResizedEvent(columns, finished, source) {
      var flexColumns = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      if (columns && columns.length) {
        var event = {
          type: _Events.EVENT_COLUMN_RESIZED,
          columns: columns,
          column: columns.length === 1 ? columns[0] : null,
          flexColumns: flexColumns,
          finished: finished,
          source: source
        };
        this.eventService.dispatchEvent(event);
      }
    }
  }, {
    key: "dispatchColumnChangedEvent",
    value: function dispatchColumnChangedEvent(type, columns, source) {
      var event = {
        type: type,
        columns: columns,
        column: columns && columns.length == 1 ? columns[0] : null,
        source: source
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "dispatchColumnMovedEvent",
    value: function dispatchColumnMovedEvent(params) {
      var movedColumns = params.movedColumns,
          source = params.source,
          toIndex = params.toIndex,
          finished = params.finished;
      var event = {
        type: _Events.EVENT_COLUMN_MOVED,
        columns: movedColumns,
        column: movedColumns && movedColumns.length === 1 ? movedColumns[0] : null,
        toIndex: toIndex,
        finished: finished,
        source: source
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "dispatchColumnPinnedEvent",
    value: function dispatchColumnPinnedEvent(changedColumns, source) {
      if (!changedColumns.length) {
        return;
      }

      var column = changedColumns.length === 1 ? changedColumns[0] : null;
      var pinned = this.getCommonValue(changedColumns, function (col) {
        return col.getPinned();
      });
      var event = {
        type: _Events.EVENT_COLUMN_PINNED,
        // mistake in typing, 'undefined' should be allowed, as 'null' means 'not pinned'
        pinned: pinned != null ? pinned : null,
        columns: changedColumns,
        column: column,
        source: source
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "dispatchColumnVisibleEvent",
    value: function dispatchColumnVisibleEvent(changedColumns, source) {
      if (!changedColumns.length) {
        return;
      }

      var column = changedColumns.length === 1 ? changedColumns[0] : null;
      var visible = this.getCommonValue(changedColumns, function (col) {
        return col.isVisible();
      });
      var event = {
        type: _Events.EVENT_COLUMN_VISIBLE,
        visible: visible,
        columns: changedColumns,
        column: column,
        source: source
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "autoSizeColumn",
    value: function autoSizeColumn(key, source, skipHeader) {
      if (key) {
        this.autoSizeColumns({
          columns: [key],
          skipHeader: skipHeader,
          skipHeaderGroups: true,
          source: source
        });
      }
    }
  }, {
    key: "autoSizeColumnGroupsByColumns",
    value: function autoSizeColumnGroupsByColumns(keys2, source, stopAtGroup) {
      var columnGroups =
      /* @__PURE__ */
      new Set();
      var columns = this.getGridColumns(keys2);
      columns.forEach(function (col) {
        var parent = col.getParent();

        while (parent && parent != stopAtGroup) {
          if (!parent.isPadding()) {
            columnGroups.add(parent);
          }

          parent = parent.getParent();
        }
      });
      var headerGroupCtrl;
      var resizedColumns = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = columnGroups[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var columnGroup = _step4.value;
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = this.ctrlsService.getHeaderRowContainerCtrls()[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var headerContainerCtrl = _step5.value;
              headerGroupCtrl = headerContainerCtrl.getHeaderCtrlForColumn(columnGroup);

              if (headerGroupCtrl) {
                break;
              }
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }

          if (headerGroupCtrl) {
            headerGroupCtrl.resizeLeafColumnsToFit(source);
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return resizedColumns;
    }
  }, {
    key: "autoSizeAllColumns",
    value: function autoSizeAllColumns(source, skipHeader) {
      var _this25 = this;

      if (this.shouldQueueResizeOperations) {
        this.resizeOperationQueue.push(function () {
          return _this25.autoSizeAllColumns(source, skipHeader);
        });
        return;
      }

      var allDisplayedColumns = this.getAllDisplayedColumns();
      this.autoSizeColumns({
        columns: allDisplayedColumns,
        skipHeader: skipHeader,
        source: source
      });
    } // Possible candidate for reuse (alot of recursive traversal duplication)

  }, {
    key: "getColumnsFromTree",
    value: function getColumnsFromTree(rootColumns) {
      var result = [];

      var recursiveFindColumns = function recursiveFindColumns(childColumns) {
        for (var i = 0; i < childColumns.length; i++) {
          var child = childColumns[i];

          if (child instanceof _Column2) {
            result.push(child);
          } else if (child instanceof _ProvidedColumnGroup2) {
            recursiveFindColumns(child.getChildren());
          }
        }
      };

      recursiveFindColumns(rootColumns);
      return result;
    }
  }, {
    key: "getAllDisplayedTrees",
    value: function getAllDisplayedTrees() {
      if (this.displayedTreeLeft && this.displayedTreeRight && this.displayedTreeCentre) {
        return this.displayedTreeLeft.concat(this.displayedTreeCentre).concat(this.displayedTreeRight);
      }

      return null;
    } // + columnSelectPanel

  }, {
    key: "getPrimaryColumnTree",
    value: function getPrimaryColumnTree() {
      return this.primaryColumnTree;
    } // + gridPanel -> for resizing the body and setting top margin

  }, {
    key: "getHeaderRowCount",
    value: function getHeaderRowCount() {
      return this.gridHeaderRowCount;
    } // + headerRenderer -> setting pinned body width

  }, {
    key: "getDisplayedTreeLeft",
    value: function getDisplayedTreeLeft() {
      return this.displayedTreeLeft;
    } // + headerRenderer -> setting pinned body width

  }, {
    key: "getDisplayedTreeRight",
    value: function getDisplayedTreeRight() {
      return this.displayedTreeRight;
    } // + headerRenderer -> setting pinned body width

  }, {
    key: "getDisplayedTreeCentre",
    value: function getDisplayedTreeCentre() {
      return this.displayedTreeCentre;
    } // gridPanel -> ensureColumnVisible

  }, {
    key: "isColumnDisplayed",
    value: function isColumnDisplayed(column) {
      return this.getAllDisplayedColumns().indexOf(column) >= 0;
    } // + csvCreator

  }, {
    key: "getAllDisplayedColumns",
    value: function getAllDisplayedColumns() {
      return this.displayedColumns;
    }
  }, {
    key: "getViewportColumns",
    value: function getViewportColumns() {
      return this.viewportColumns;
    }
  }, {
    key: "getDisplayedLeftColumnsForRow",
    value: function getDisplayedLeftColumnsForRow(rowNode) {
      if (!this.colSpanActive) {
        return this.displayedColumnsLeft;
      }

      return this.getDisplayedColumnsForRow(rowNode, this.displayedColumnsLeft);
    }
  }, {
    key: "getDisplayedRightColumnsForRow",
    value: function getDisplayedRightColumnsForRow(rowNode) {
      if (!this.colSpanActive) {
        return this.displayedColumnsRight;
      }

      return this.getDisplayedColumnsForRow(rowNode, this.displayedColumnsRight);
    }
  }, {
    key: "isColSpanActive",
    value: function isColSpanActive() {
      return this.colSpanActive;
    }
  }, {
    key: "getDisplayedColumnsForRow",
    value: function getDisplayedColumnsForRow(rowNode, displayedColumns, filterCallback, emptySpaceBeforeColumn) {
      var result = [];
      var lastConsideredCol = null;

      for (var i = 0; i < displayedColumns.length; i++) {
        var col = displayedColumns[i];
        var maxAllowedColSpan = displayedColumns.length - i;
        var colSpan = Math.min(col.getColSpan(rowNode), maxAllowedColSpan);
        var columnsToCheckFilter = [col];

        if (colSpan > 1) {
          var colsToRemove = colSpan - 1;

          for (var j = 1; j <= colsToRemove; j++) {
            columnsToCheckFilter.push(displayedColumns[i + j]);
          }

          i += colsToRemove;
        }

        var filterPasses = void 0;

        if (filterCallback) {
          filterPasses = false;
          columnsToCheckFilter.forEach(function (colForFilter) {
            if (filterCallback(colForFilter)) {
              filterPasses = true;
            }
          });
        } else {
          filterPasses = true;
        }

        if (filterPasses) {
          if (result.length === 0 && lastConsideredCol) {
            var gapBeforeColumn = emptySpaceBeforeColumn ? emptySpaceBeforeColumn(col) : false;

            if (gapBeforeColumn) {
              result.push(lastConsideredCol);
            }
          }

          result.push(col);
        }

        lastConsideredCol = col;
      }

      return result;
    } // + rowRenderer
    // if we are not column spanning, this just returns back the virtual centre columns,
    // however if we are column spanning, then different rows can have different virtual
    // columns, so we have to work out the list for each individual row.

  }, {
    key: "getViewportCenterColumnsForRow",
    value: function getViewportCenterColumnsForRow(rowNode) {
      var _this26 = this;

      if (!this.colSpanActive) {
        return this.viewportColumnsCenter;
      }

      var emptySpaceBeforeColumn = function emptySpaceBeforeColumn(col) {
        var left = col.getLeft();
        return _exists(left) && left > _this26.viewportLeft;
      };

      var filterCallback = this.isColumnVirtualisationSuppressed() ? null : this.isColumnInRowViewport.bind(this);
      return this.getDisplayedColumnsForRow(rowNode, this.displayedColumnsCenter, filterCallback, emptySpaceBeforeColumn);
    }
  }, {
    key: "isColumnAtEdge",
    value: function isColumnAtEdge(col, edge) {
      var allColumns = this.getAllDisplayedColumns();

      if (!allColumns.length) {
        return false;
      }

      var isFirst = edge === "first";
      var columnToCompare;

      if (col instanceof _ColumnGroup2) {
        var leafColumns = col.getDisplayedLeafColumns();

        if (!leafColumns.length) {
          return false;
        }

        columnToCompare = isFirst ? leafColumns[0] : _last(leafColumns);
      } else {
        columnToCompare = col;
      }

      return (isFirst ? allColumns[0] : _last(allColumns)) === columnToCompare;
    }
  }, {
    key: "getAriaColumnIndex",
    value: function getAriaColumnIndex(col) {
      var targetColumn;

      if (col instanceof _ColumnGroup2) {
        targetColumn = col.getLeafColumns()[0];
      } else {
        targetColumn = col;
      }

      return this.ariaOrderColumns.indexOf(targetColumn) + 1;
    }
  }, {
    key: "isColumnInHeaderViewport",
    value: function isColumnInHeaderViewport(col) {
      if (col.isAutoHeaderHeight()) {
        return true;
      }

      return this.isColumnInRowViewport(col);
    }
  }, {
    key: "isColumnInRowViewport",
    value: function isColumnInRowViewport(col) {
      if (col.isAutoHeight()) {
        return true;
      }

      var columnLeft = col.getLeft() || 0;
      var columnRight = columnLeft + col.getActualWidth();
      var leftBounds = this.viewportLeft - 200;
      var rightBounds = this.viewportRight + 200;
      var columnToMuchLeft = columnLeft < leftBounds && columnRight < leftBounds;
      var columnToMuchRight = columnLeft > rightBounds && columnRight > rightBounds;
      return !columnToMuchLeft && !columnToMuchRight;
    } // used by:
    // + angularGrid -> setting pinned body width
    // note: this should be cached

  }, {
    key: "getDisplayedColumnsLeftWidth",
    value: function getDisplayedColumnsLeftWidth() {
      return this.getWidthOfColsInList(this.displayedColumnsLeft);
    } // note: this should be cached

  }, {
    key: "getDisplayedColumnsRightWidth",
    value: function getDisplayedColumnsRightWidth() {
      return this.getWidthOfColsInList(this.displayedColumnsRight);
    }
  }, {
    key: "updatePrimaryColumnList",
    value: function updatePrimaryColumnList(keys2, masterList, actionIsAdd, columnCallback, eventType, source) {
      var _this27 = this;

      if (!keys2 || _missingOrEmpty(keys2)) {
        return;
      }

      var atLeastOne = false;
      keys2.forEach(function (key) {
        if (!key) {
          return;
        }

        var columnToAdd = _this27.getPrimaryColumn(key);

        if (!columnToAdd) {
          return;
        }

        if (actionIsAdd) {
          if (masterList.indexOf(columnToAdd) >= 0) {
            return;
          }

          masterList.push(columnToAdd);
        } else {
          if (masterList.indexOf(columnToAdd) < 0) {
            return;
          }

          _removeFromArray(masterList, columnToAdd);
        }

        columnCallback(columnToAdd);
        atLeastOne = true;
      });

      if (!atLeastOne) {
        return;
      }

      if (this.autoGroupsNeedBuilding) {
        this.updateGridColumns();
      }

      this.updateDisplayedColumns(source);
      var event = {
        type: eventType,
        columns: masterList,
        column: masterList.length === 1 ? masterList[0] : null,
        source: source
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "setRowGroupColumns",
    value: function setRowGroupColumns(colKeys, source) {
      this.autoGroupsNeedBuilding = true;
      this.setPrimaryColumnList(colKeys, this.rowGroupColumns, _Events.EVENT_COLUMN_ROW_GROUP_CHANGED, true, this.setRowGroupActive.bind(this), source);
    }
  }, {
    key: "setRowGroupActive",
    value: function setRowGroupActive(active, column, source) {
      if (active === column.isRowGroupActive()) {
        return;
      }

      column.setRowGroupActive(active, source);

      if (active && !this.gos.get("suppressRowGroupHidesColumns")) {
        this.setColumnsVisible([column], false, source);
      }

      if (!active && !this.gos.get("suppressMakeColumnVisibleAfterUnGroup")) {
        this.setColumnsVisible([column], true, source);
      }
    }
  }, {
    key: "addRowGroupColumns",
    value: function addRowGroupColumns(keys2, source) {
      this.autoGroupsNeedBuilding = true;
      this.updatePrimaryColumnList(keys2, this.rowGroupColumns, true, this.setRowGroupActive.bind(this, true), _Events.EVENT_COLUMN_ROW_GROUP_CHANGED, source);
    }
  }, {
    key: "removeRowGroupColumns",
    value: function removeRowGroupColumns(keys2, source) {
      this.autoGroupsNeedBuilding = true;
      this.updatePrimaryColumnList(keys2, this.rowGroupColumns, false, this.setRowGroupActive.bind(this, false), _Events.EVENT_COLUMN_ROW_GROUP_CHANGED, source);
    }
  }, {
    key: "addPivotColumns",
    value: function addPivotColumns(keys2, source) {
      this.updatePrimaryColumnList(keys2, this.pivotColumns, true, function (column) {
        return column.setPivotActive(true, source);
      }, _Events.EVENT_COLUMN_PIVOT_CHANGED, source);
    }
  }, {
    key: "setPivotColumns",
    value: function setPivotColumns(colKeys, source) {
      this.setPrimaryColumnList(colKeys, this.pivotColumns, _Events.EVENT_COLUMN_PIVOT_CHANGED, true, function (added, column) {
        column.setPivotActive(added, source);
      }, source);
    }
  }, {
    key: "removePivotColumns",
    value: function removePivotColumns(keys2, source) {
      this.updatePrimaryColumnList(keys2, this.pivotColumns, false, function (column) {
        return column.setPivotActive(false, source);
      }, _Events.EVENT_COLUMN_PIVOT_CHANGED, source);
    }
  }, {
    key: "setPrimaryColumnList",
    value: function setPrimaryColumnList(colKeys, masterList, eventName, detectOrderChange, columnCallback, source) {
      var _this28 = this;

      if (!this.gridColumns) {
        return;
      }

      var changes =
      /* @__PURE__ */
      new Map();
      masterList.forEach(function (col, idx) {
        return changes.set(col, idx);
      });
      masterList.length = 0;

      if (_exists(colKeys)) {
        colKeys.forEach(function (key) {
          var column = _this28.getPrimaryColumn(key);

          if (column) {
            masterList.push(column);
          }
        });
      }

      masterList.forEach(function (col, idx) {
        var oldIndex = changes.get(col);

        if (oldIndex === void 0) {
          changes.set(col, 0);
          return;
        }

        if (detectOrderChange && oldIndex !== idx) {
          return;
        }

        changes.delete(col);
      });
      (this.primaryColumns || []).forEach(function (column) {
        var added = masterList.indexOf(column) >= 0;
        columnCallback(added, column);
      });

      if (this.autoGroupsNeedBuilding) {
        this.updateGridColumns();
      }

      this.updateDisplayedColumns(source);
      this.dispatchColumnChangedEvent(eventName, _toConsumableArray(changes.keys()), source);
    }
  }, {
    key: "setValueColumns",
    value: function setValueColumns(colKeys, source) {
      this.setPrimaryColumnList(colKeys, this.valueColumns, _Events.EVENT_COLUMN_VALUE_CHANGED, false, this.setValueActive.bind(this), source);
    }
  }, {
    key: "setValueActive",
    value: function setValueActive(active, column, source) {
      if (active === column.isValueActive()) {
        return;
      }

      column.setValueActive(active, source);

      if (active && !column.getAggFunc() && this.aggFuncService) {
        var initialAggFunc = this.aggFuncService.getDefaultAggFunc(column);
        column.setAggFunc(initialAggFunc);
      }
    }
  }, {
    key: "addValueColumns",
    value: function addValueColumns(keys2, source) {
      this.updatePrimaryColumnList(keys2, this.valueColumns, true, this.setValueActive.bind(this, true), _Events.EVENT_COLUMN_VALUE_CHANGED, source);
    }
  }, {
    key: "removeValueColumns",
    value: function removeValueColumns(keys2, source) {
      this.updatePrimaryColumnList(keys2, this.valueColumns, false, this.setValueActive.bind(this, false), _Events.EVENT_COLUMN_VALUE_CHANGED, source);
    } // returns the width we can set to this col, taking into consideration min and max widths

  }, {
    key: "normaliseColumnWidth",
    value: function normaliseColumnWidth(column, newWidth) {
      var minWidth = column.getMinWidth();

      if (_exists(minWidth) && newWidth < minWidth) {
        newWidth = minWidth;
      }

      var maxWidth = column.getMaxWidth();

      if (_exists(maxWidth) && column.isGreaterThanMax(newWidth)) {
        newWidth = maxWidth;
      }

      return newWidth;
    }
  }, {
    key: "getPrimaryOrGridColumn",
    value: function getPrimaryOrGridColumn(key) {
      var column = this.getPrimaryColumn(key);
      return column || this.getGridColumn(key);
    }
  }, {
    key: "setColumnWidths",
    value: function setColumnWidths(columnWidths, shiftKey, finished, source) {
      var _this29 = this;

      var sets = [];
      columnWidths.forEach(function (columnWidth) {
        var col = _this29.getPrimaryOrGridColumn(columnWidth.key);

        if (!col) {
          return;
        }

        sets.push({
          width: columnWidth.newWidth,
          ratios: [1],
          columns: [col]
        });
        var defaultIsShift = _this29.gos.get("colResizeDefault") === "shift";

        if (defaultIsShift) {
          shiftKey = !shiftKey;
        }

        if (shiftKey) {
          var otherCol = _this29.getDisplayedColAfter(col);

          if (!otherCol) {
            return;
          }

          var widthDiff = col.getActualWidth() - columnWidth.newWidth;
          var otherColWidth = otherCol.getActualWidth() + widthDiff;
          sets.push({
            width: otherColWidth,
            ratios: [1],
            columns: [otherCol]
          });
        }
      });

      if (sets.length === 0) {
        return;
      }

      this.resizeColumnSets({
        resizeSets: sets,
        finished: finished,
        source: source
      });
    }
  }, {
    key: "checkMinAndMaxWidthsForSet",
    value: function checkMinAndMaxWidthsForSet(columnResizeSet) {
      var columns = columnResizeSet.columns,
          width = columnResizeSet.width;
      var minWidthAccumulated = 0;
      var maxWidthAccumulated = 0;
      var maxWidthActive = true;
      columns.forEach(function (col) {
        var minWidth = col.getMinWidth();
        minWidthAccumulated += minWidth || 0;
        var maxWidth = col.getMaxWidth();

        if (_exists(maxWidth) && maxWidth > 0) {
          maxWidthAccumulated += maxWidth;
        } else {
          maxWidthActive = false;
        }
      });
      var minWidthPasses = width >= minWidthAccumulated;
      var maxWidthPasses = !maxWidthActive || width <= maxWidthAccumulated;
      return minWidthPasses && maxWidthPasses;
    } // method takes sets of columns and resizes them. either all sets will be resized, or nothing
    // be resized. this is used for example when user tries to resize a group and holds shift key,
    // then both the current group (grows), and the adjacent group (shrinks), will get resized,
    // so that's two sets for this method.

  }, {
    key: "resizeColumnSets",
    value: function resizeColumnSets(params) {
      var _this30 = this;

      var resizeSets = params.resizeSets,
          finished = params.finished,
          source = params.source;
      var passMinMaxCheck = !resizeSets || resizeSets.every(function (columnResizeSet) {
        return _this30.checkMinAndMaxWidthsForSet(columnResizeSet);
      });

      if (!passMinMaxCheck) {
        if (finished) {
          var columns = resizeSets && resizeSets.length > 0 ? resizeSets[0].columns : null;
          this.dispatchColumnResizedEvent(columns, finished, source);
        }

        return;
      }

      var changedCols = [];
      var allResizedCols = [];
      resizeSets.forEach(function (set) {
        var width = set.width,
            columns = set.columns,
            ratios = set.ratios;
        var newWidths = {};
        var finishedCols = {};
        columns.forEach(function (col) {
          return allResizedCols.push(col);
        });
        var finishedColsGrew = true;
        var loopCount = 0;

        var _loop2 = function _loop2() {
          loopCount++;

          if (loopCount > 1e3) {
            console.error("AG Grid: infinite loop in resizeColumnSets");
            return "break";
          }

          finishedColsGrew = false;
          var subsetCols = [];
          var subsetRatioTotal = 0;
          var pixelsToDistribute = width;
          columns.forEach(function (col, index) {
            var thisColFinished = finishedCols[col.getId()];

            if (thisColFinished) {
              pixelsToDistribute -= newWidths[col.getId()];
            } else {
              subsetCols.push(col);
              var ratioThisCol = ratios[index];
              subsetRatioTotal += ratioThisCol;
            }
          });
          var ratioScale = 1 / subsetRatioTotal;
          subsetCols.forEach(function (col, index) {
            var lastCol = index === subsetCols.length - 1;
            var colNewWidth;

            if (lastCol) {
              colNewWidth = pixelsToDistribute;
            } else {
              colNewWidth = Math.round(ratios[index] * width * ratioScale);
              pixelsToDistribute -= colNewWidth;
            }

            var minWidth = col.getMinWidth();
            var maxWidth = col.getMaxWidth();

            if (_exists(minWidth) && colNewWidth < minWidth) {
              colNewWidth = minWidth;
              finishedCols[col.getId()] = true;
              finishedColsGrew = true;
            } else if (_exists(maxWidth) && maxWidth > 0 && colNewWidth > maxWidth) {
              colNewWidth = maxWidth;
              finishedCols[col.getId()] = true;
              finishedColsGrew = true;
            }

            newWidths[col.getId()] = colNewWidth;
          });
        };

        while (finishedColsGrew) {
          var _ret = _loop2();

          if (_ret === "break") break;
        }

        columns.forEach(function (col) {
          var newWidth = newWidths[col.getId()];
          var actualWidth = col.getActualWidth();

          if (actualWidth !== newWidth) {
            col.setActualWidth(newWidth, source);
            changedCols.push(col);
          }
        });
      });
      var atLeastOneColChanged = changedCols.length > 0;
      var flexedCols = [];

      if (atLeastOneColChanged) {
        flexedCols = this.refreshFlexedColumns({
          resizingCols: allResizedCols,
          skipSetLeft: true
        });
        this.setLeftValues(source);
        this.updateBodyWidths();
        this.checkViewportColumns();
      }

      var colsForEvent = allResizedCols.concat(flexedCols);

      if (atLeastOneColChanged || finished) {
        this.dispatchColumnResizedEvent(colsForEvent, finished, source, flexedCols);
      }
    }
  }, {
    key: "setColumnAggFunc",
    value: function setColumnAggFunc(key, aggFunc, source) {
      if (!key) {
        return;
      }

      var column = this.getPrimaryColumn(key);

      if (!column) {
        return;
      }

      column.setAggFunc(aggFunc);
      this.dispatchColumnChangedEvent(_Events.EVENT_COLUMN_VALUE_CHANGED, [column], source);
    }
  }, {
    key: "moveRowGroupColumn",
    value: function moveRowGroupColumn(fromIndex, toIndex, source) {
      if (this.isRowGroupEmpty()) {
        return;
      }

      var column = this.rowGroupColumns[fromIndex];
      var impactedColumns = this.rowGroupColumns.slice(fromIndex, toIndex);
      this.rowGroupColumns.splice(fromIndex, 1);
      this.rowGroupColumns.splice(toIndex, 0, column);
      var event = {
        type: _Events.EVENT_COLUMN_ROW_GROUP_CHANGED,
        columns: impactedColumns,
        column: impactedColumns.length === 1 ? impactedColumns[0] : null,
        source: source
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "moveColumns",
    value: function moveColumns(columnsToMoveKeys, toIndex, source) {
      var finished = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      if (!this.gridColumns) {
        return;
      }

      this.columnAnimationService.start();

      if (toIndex > this.gridColumns.length - columnsToMoveKeys.length) {
        console.warn("AG Grid: tried to insert columns in invalid location, toIndex = " + toIndex);
        console.warn("AG Grid: remember that you should not count the moving columns when calculating the new index");
        return;
      }

      var movedColumns = this.getGridColumns(columnsToMoveKeys);
      var failedRules = !this.doesMovePassRules(movedColumns, toIndex);

      if (failedRules) {
        return;
      }

      _moveInArray(this.gridColumns, movedColumns, toIndex);

      this.updateDisplayedColumns(source);
      this.dispatchColumnMovedEvent({
        movedColumns: movedColumns,
        source: source,
        toIndex: toIndex,
        finished: finished
      });
      this.columnAnimationService.finish();
    }
  }, {
    key: "doesMovePassRules",
    value: function doesMovePassRules(columnsToMove, toIndex) {
      var proposedColumnOrder = this.getProposedColumnOrder(columnsToMove, toIndex);
      return this.doesOrderPassRules(proposedColumnOrder);
    }
  }, {
    key: "doesOrderPassRules",
    value: function doesOrderPassRules(gridOrder) {
      if (!this.doesMovePassMarryChildren(gridOrder)) {
        return false;
      }

      if (!this.doesMovePassLockedPositions(gridOrder)) {
        return false;
      }

      return true;
    }
  }, {
    key: "getProposedColumnOrder",
    value: function getProposedColumnOrder(columnsToMove, toIndex) {
      var proposedColumnOrder = this.gridColumns.slice();

      _moveInArray(proposedColumnOrder, columnsToMove, toIndex);

      return proposedColumnOrder;
    } // returns the provided cols sorted in same order as they appear in grid columns. eg if grid columns
    // contains [a,b,c,d,e] and col passed is [e,a] then the passed cols are sorted into [a,e]

  }, {
    key: "sortColumnsLikeGridColumns",
    value: function sortColumnsLikeGridColumns(cols) {
      var _this31 = this;

      if (!cols || cols.length <= 1) {
        return;
      }

      var notAllColsInGridColumns = cols.filter(function (c) {
        return _this31.gridColumns.indexOf(c) < 0;
      }).length > 0;

      if (notAllColsInGridColumns) {
        return;
      }

      cols.sort(function (a, b) {
        var indexA = _this31.gridColumns.indexOf(a);

        var indexB = _this31.gridColumns.indexOf(b);

        return indexA - indexB;
      });
    }
  }, {
    key: "doesMovePassLockedPositions",
    value: function doesMovePassLockedPositions(proposedColumnOrder) {
      var lastPlacement = 0;
      var rulePassed = true;

      var lockPositionToPlacement = function lockPositionToPlacement(position) {
        if (!position) {
          return 1;
        }

        if (position === true) {
          return 0;
        }

        return position === "left" ? 0 : 2;
      };

      proposedColumnOrder.forEach(function (col) {
        var placement = lockPositionToPlacement(col.getColDef().lockPosition);

        if (placement < lastPlacement) {
          rulePassed = false;
        }

        lastPlacement = placement;
      });
      return rulePassed;
    }
  }, {
    key: "doesMovePassMarryChildren",
    value: function doesMovePassMarryChildren(allColumnsCopy) {
      var rulePassed = true;
      depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function (child) {
        if (!(child instanceof _ProvidedColumnGroup2)) {
          return;
        }

        var columnGroup = child;
        var colGroupDef = columnGroup.getColGroupDef();
        var marryChildren = colGroupDef && colGroupDef.marryChildren;

        if (!marryChildren) {
          return;
        }

        var newIndexes = [];
        columnGroup.getLeafColumns().forEach(function (col) {
          var newColIndex = allColumnsCopy.indexOf(col);
          newIndexes.push(newColIndex);
        });
        var maxIndex = Math.max.apply(Math, newIndexes);
        var minIndex = Math.min.apply(Math, newIndexes);
        var spread = maxIndex - minIndex;
        var maxSpread = columnGroup.getLeafColumns().length - 1;

        if (spread > maxSpread) {
          rulePassed = false;
        }
      });
      return rulePassed;
    }
  }, {
    key: "moveColumnByIndex",
    value: function moveColumnByIndex(fromIndex, toIndex, source) {
      if (!this.gridColumns) {
        return;
      }

      var column = this.gridColumns[fromIndex];
      this.moveColumns([column], toIndex, source);
    }
  }, {
    key: "getColumnDefs",
    value: function getColumnDefs() {
      var _this32 = this;

      if (!this.primaryColumns) {
        return;
      }

      var cols = this.primaryColumns.slice();

      if (this.gridColsArePrimary) {
        cols.sort(function (a, b) {
          return _this32.gridColumns.indexOf(a) - _this32.gridColumns.indexOf(b);
        });
      } else if (this.lastPrimaryOrder) {
        cols.sort(function (a, b) {
          return _this32.lastPrimaryOrder.indexOf(a) - _this32.lastPrimaryOrder.indexOf(b);
        });
      }

      return this.columnDefFactory.buildColumnDefs(cols, this.rowGroupColumns, this.pivotColumns);
    } // used by:
    // + angularGrid -> for setting body width
    // + rowController -> setting main row widths (when inserting and resizing)
    // need to cache this

  }, {
    key: "getBodyContainerWidth",
    value: function getBodyContainerWidth() {
      return this.bodyWidth;
    }
  }, {
    key: "getContainerWidth",
    value: function getContainerWidth(pinned) {
      switch (pinned) {
        case "left":
          return this.leftWidth;

        case "right":
          return this.rightWidth;

        default:
          return this.bodyWidth;
      }
    } // after setColumnWidth or updateGroupsAndDisplayedColumns

  }, {
    key: "updateBodyWidths",
    value: function updateBodyWidths() {
      var newBodyWidth = this.getWidthOfColsInList(this.displayedColumnsCenter);
      var newLeftWidth = this.getWidthOfColsInList(this.displayedColumnsLeft);
      var newRightWidth = this.getWidthOfColsInList(this.displayedColumnsRight);
      this.bodyWidthDirty = this.bodyWidth !== newBodyWidth;
      var atLeastOneChanged = this.bodyWidth !== newBodyWidth || this.leftWidth !== newLeftWidth || this.rightWidth !== newRightWidth;

      if (atLeastOneChanged) {
        this.bodyWidth = newBodyWidth;
        this.leftWidth = newLeftWidth;
        this.rightWidth = newRightWidth;
        var evt = {
          type: _Events.EVENT_COLUMN_CONTAINER_WIDTH_CHANGED
        };
        this.eventService.dispatchEvent(evt);
        var event = {
          type: _Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED
        };
        this.eventService.dispatchEvent(event);
      }
    } // + rowController

  }, {
    key: "getValueColumns",
    value: function getValueColumns() {
      return this.valueColumns ? this.valueColumns : [];
    } // + rowController

  }, {
    key: "getPivotColumns",
    value: function getPivotColumns() {
      return this.pivotColumns ? this.pivotColumns : [];
    } // + clientSideRowModel

  }, {
    key: "isPivotActive",
    value: function isPivotActive() {
      return this.pivotColumns && this.pivotColumns.length > 0 && this.pivotMode;
    } // + toolPanel

  }, {
    key: "getRowGroupColumns",
    value: function getRowGroupColumns() {
      return this.rowGroupColumns ? this.rowGroupColumns : [];
    } // + rowController -> while inserting rows

  }, {
    key: "getDisplayedCenterColumns",
    value: function getDisplayedCenterColumns() {
      return this.displayedColumnsCenter;
    } // + rowController -> while inserting rows

  }, {
    key: "getDisplayedLeftColumns",
    value: function getDisplayedLeftColumns() {
      return this.displayedColumnsLeft;
    }
  }, {
    key: "getDisplayedRightColumns",
    value: function getDisplayedRightColumns() {
      return this.displayedColumnsRight;
    } // used by:
    // + clientSideRowController -> sorting, building quick filter text
    // + headerRenderer -> sorting (clearing icon)

  }, {
    key: "getAllPrimaryColumns",
    value: function getAllPrimaryColumns() {
      return this.primaryColumns ? this.primaryColumns : null;
    }
  }, {
    key: "getSecondaryColumns",
    value: function getSecondaryColumns() {
      return this.secondaryColumns ? this.secondaryColumns : null;
    }
  }, {
    key: "getAllColumnsForQuickFilter",
    value: function getAllColumnsForQuickFilter() {
      return this.columnsForQuickFilter;
    } // + moveColumnController

  }, {
    key: "getAllGridColumns",
    value: function getAllGridColumns() {
      var _a;

      return (_a = this.gridColumns) != null ? _a : [];
    }
  }, {
    key: "isRowGroupEmpty",
    value: function isRowGroupEmpty() {
      return _missingOrEmpty(this.rowGroupColumns);
    }
  }, {
    key: "setColumnsVisible",
    value: function setColumnsVisible(keys2) {
      var visible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var source = arguments.length > 2 ? arguments[2] : undefined;
      this.applyColumnState({
        state: keys2.map(function (key) {
          return {
            colId: typeof key === "string" ? key : key.getColId(),
            hide: !visible
          };
        })
      }, source);
    }
  }, {
    key: "setColumnsPinned",
    value: function setColumnsPinned(keys2, pinned, source) {
      if (!this.gridColumns) {
        return;
      }

      if (this.gos.isDomLayout("print")) {
        console.warn("AG Grid: Changing the column pinning status is not allowed with domLayout='print'");
        return;
      }

      this.columnAnimationService.start();
      var actualPinned;

      if (pinned === true || pinned === "left") {
        actualPinned = "left";
      } else if (pinned === "right") {
        actualPinned = "right";
      } else {
        actualPinned = null;
      }

      this.actionOnGridColumns(keys2, function (col) {
        if (col.getPinned() !== actualPinned) {
          col.setPinned(actualPinned);
          return true;
        }

        return false;
      }, source, function () {
        var event = {
          type: _Events.EVENT_COLUMN_PINNED,
          pinned: actualPinned,
          column: null,
          columns: null,
          source: source
        };
        return event;
      });
      this.columnAnimationService.finish();
    } // does an action on a set of columns. provides common functionality for looking up the
    // columns based on key, getting a list of effected columns, and then updated the event
    // with either one column (if it was just one col) or a list of columns
    // used by: autoResize, setVisible, setPinned

  }, {
    key: "actionOnGridColumns",
    value: function actionOnGridColumns(keys2, action, source, createEvent) {
      var _this33 = this;

      if (_missingOrEmpty(keys2)) {
        return;
      }

      var updatedColumns = [];
      keys2.forEach(function (key) {
        if (!key) {
          return;
        }

        var column = _this33.getGridColumn(key);

        if (!column) {
          return;
        }

        var resultOfAction = action(column);

        if (resultOfAction !== false) {
          updatedColumns.push(column);
        }
      });

      if (!updatedColumns.length) {
        return;
      }

      this.updateDisplayedColumns(source);

      if (_exists(createEvent) && createEvent) {
        var event = createEvent();
        event.columns = updatedColumns;
        event.column = updatedColumns.length === 1 ? updatedColumns[0] : null;
        this.eventService.dispatchEvent(event);
      }
    }
  }, {
    key: "getDisplayedColBefore",
    value: function getDisplayedColBefore(col) {
      var allDisplayedColumns = this.getAllDisplayedColumns();
      var oldIndex = allDisplayedColumns.indexOf(col);

      if (oldIndex > 0) {
        return allDisplayedColumns[oldIndex - 1];
      }

      return null;
    } // used by:
    // + rowRenderer -> for navigation

  }, {
    key: "getDisplayedColAfter",
    value: function getDisplayedColAfter(col) {
      var allDisplayedColumns = this.getAllDisplayedColumns();
      var oldIndex = allDisplayedColumns.indexOf(col);

      if (oldIndex < allDisplayedColumns.length - 1) {
        return allDisplayedColumns[oldIndex + 1];
      }

      return null;
    }
  }, {
    key: "getDisplayedGroupAtDirection",
    value: function getDisplayedGroupAtDirection(columnGroup, direction) {
      var requiredLevel = columnGroup.getProvidedColumnGroup().getLevel() + columnGroup.getPaddingLevel();
      var colGroupLeafColumns = columnGroup.getDisplayedLeafColumns();
      var col = direction === "After" ? _last(colGroupLeafColumns) : colGroupLeafColumns[0];
      var getDisplayColMethod = "getDisplayedCol".concat(direction);

      while (true) {
        var column = this[getDisplayColMethod](col);

        if (!column) {
          return null;
        }

        var groupPointer = this.getColumnGroupAtLevel(column, requiredLevel);

        if (groupPointer !== columnGroup) {
          return groupPointer;
        }
      }
    }
  }, {
    key: "getColumnGroupAtLevel",
    value: function getColumnGroupAtLevel(column, level) {
      var groupPointer = column.getParent();
      var originalGroupLevel;
      var groupPointerLevel;

      while (true) {
        var groupPointerProvidedColumnGroup = groupPointer.getProvidedColumnGroup();
        originalGroupLevel = groupPointerProvidedColumnGroup.getLevel();
        groupPointerLevel = groupPointer.getPaddingLevel();

        if (originalGroupLevel + groupPointerLevel <= level) {
          break;
        }

        groupPointer = groupPointer.getParent();
      }

      return groupPointer;
    }
  }, {
    key: "isPinningLeft",
    value: function isPinningLeft() {
      return this.displayedColumnsLeft.length > 0;
    }
  }, {
    key: "isPinningRight",
    value: function isPinningRight() {
      return this.displayedColumnsRight.length > 0;
    }
  }, {
    key: "getPrimaryAndSecondaryAndAutoColumns",
    value: function getPrimaryAndSecondaryAndAutoColumns() {
      var _ref10;

      return (_ref10 = []).concat.apply(_ref10, [this.primaryColumns || [], this.groupAutoColumns || [], this.secondaryColumns || []]);
    }
  }, {
    key: "createStateItemFromColumn",
    value: function createStateItemFromColumn(column) {
      var rowGroupIndex = column.isRowGroupActive() ? this.rowGroupColumns.indexOf(column) : null;
      var pivotIndex = column.isPivotActive() ? this.pivotColumns.indexOf(column) : null;
      var aggFunc = column.isValueActive() ? column.getAggFunc() : null;
      var sort = column.getSort() != null ? column.getSort() : null;
      var sortIndex = column.getSortIndex() != null ? column.getSortIndex() : null;
      var flex = column.getFlex() != null && column.getFlex() > 0 ? column.getFlex() : null;
      var res = {
        colId: column.getColId(),
        width: column.getActualWidth(),
        hide: !column.isVisible(),
        pinned: column.getPinned(),
        sort: sort,
        sortIndex: sortIndex,
        aggFunc: aggFunc,
        rowGroup: column.isRowGroupActive(),
        rowGroupIndex: rowGroupIndex,
        pivot: column.isPivotActive(),
        pivotIndex: pivotIndex,
        flex: flex
      };
      return res;
    }
  }, {
    key: "getColumnState",
    value: function getColumnState() {
      if (_missing(this.primaryColumns) || !this.isAlive()) {
        return [];
      }

      var colsForState = this.getPrimaryAndSecondaryAndAutoColumns();
      var res = colsForState.map(this.createStateItemFromColumn.bind(this));
      this.orderColumnStateList(res);
      return res;
    }
  }, {
    key: "orderColumnStateList",
    value: function orderColumnStateList(columnStateList) {
      var colIdToGridIndexMap = _convertToMap(this.gridColumns.map(function (col, index) {
        return [col.getColId(), index];
      }));

      columnStateList.sort(function (itemA, itemB) {
        var posA = colIdToGridIndexMap.has(itemA.colId) ? colIdToGridIndexMap.get(itemA.colId) : -1;
        var posB = colIdToGridIndexMap.has(itemB.colId) ? colIdToGridIndexMap.get(itemB.colId) : -1;
        return posA - posB;
      });
    }
  }, {
    key: "resetColumnState",
    value: function resetColumnState(source) {
      var _this34 = this;

      if (_missingOrEmpty(this.primaryColumns)) {
        return;
      }

      var primaryColumns = this.getColumnsFromTree(this.primaryColumnTree);
      var columnStates = [];
      var letRowGroupIndex = 1e3;
      var letPivotIndex = 1e3;
      var colsToProcess = [];

      if (this.groupAutoColumns) {
        colsToProcess = colsToProcess.concat(this.groupAutoColumns);
      }

      if (primaryColumns) {
        colsToProcess = colsToProcess.concat(primaryColumns);
      }

      colsToProcess.forEach(function (column) {
        var stateItem = _this34.getColumnStateFromColDef(column);

        if (_missing(stateItem.rowGroupIndex) && stateItem.rowGroup) {
          stateItem.rowGroupIndex = letRowGroupIndex++;
        }

        if (_missing(stateItem.pivotIndex) && stateItem.pivot) {
          stateItem.pivotIndex = letPivotIndex++;
        }

        columnStates.push(stateItem);
      });
      this.applyColumnState({
        state: columnStates,
        applyOrder: true
      }, source);
    }
  }, {
    key: "getColumnStateFromColDef",
    value: function getColumnStateFromColDef(column) {
      var getValueOrNull = function getValueOrNull(a, b) {
        return a != null ? a : b != null ? b : null;
      };

      var colDef = column.getColDef();
      var sort = getValueOrNull(colDef.sort, colDef.initialSort);
      var sortIndex = getValueOrNull(colDef.sortIndex, colDef.initialSortIndex);
      var hide = getValueOrNull(colDef.hide, colDef.initialHide);
      var pinned = getValueOrNull(colDef.pinned, colDef.initialPinned);
      var width = getValueOrNull(colDef.width, colDef.initialWidth);
      var flex = getValueOrNull(colDef.flex, colDef.initialFlex);
      var rowGroupIndex = getValueOrNull(colDef.rowGroupIndex, colDef.initialRowGroupIndex);
      var rowGroup = getValueOrNull(colDef.rowGroup, colDef.initialRowGroup);

      if (rowGroupIndex == null && (rowGroup == null || rowGroup == false)) {
        rowGroupIndex = null;
        rowGroup = null;
      }

      var pivotIndex = getValueOrNull(colDef.pivotIndex, colDef.initialPivotIndex);
      var pivot = getValueOrNull(colDef.pivot, colDef.initialPivot);

      if (pivotIndex == null && (pivot == null || pivot == false)) {
        pivotIndex = null;
        pivot = null;
      }

      var aggFunc = getValueOrNull(colDef.aggFunc, colDef.initialAggFunc);
      return {
        colId: column.getColId(),
        sort: sort,
        sortIndex: sortIndex,
        hide: hide,
        pinned: pinned,
        width: width,
        flex: flex,
        rowGroup: rowGroup,
        rowGroupIndex: rowGroupIndex,
        pivot: pivot,
        pivotIndex: pivotIndex,
        aggFunc: aggFunc
      };
    }
  }, {
    key: "applyColumnState",
    value: function applyColumnState(params, source) {
      var _this35 = this;

      if (_missingOrEmpty(this.primaryColumns)) {
        return false;
      }

      if (params && params.state && !params.state.forEach) {
        console.warn("AG Grid: applyColumnState() - the state attribute should be an array, however an array was not found. Please provide an array of items (one for each col you want to change) for state.");
        return false;
      }

      var applyStates = function applyStates(states, existingColumns, getById) {
        var dispatchEventsFunc = _this35.compareColumnStatesAndDispatchEvents(source);

        _this35.autoGroupsNeedBuilding = true;
        var columnsWithNoState = existingColumns.slice();
        var rowGroupIndexes = {};
        var pivotIndexes = {};
        var autoGroupColumnStates = [];
        var unmatchedAndAutoStates2 = [];
        var unmatchedCount2 = 0;

        var previousRowGroupCols = _this35.rowGroupColumns.slice();

        var previousPivotCols = _this35.pivotColumns.slice();

        states.forEach(function (state) {
          var colId = state.colId || "";
          var isAutoGroupColumn = colId.startsWith(_GROUP_AUTO_COLUMN_ID);

          if (isAutoGroupColumn) {
            autoGroupColumnStates.push(state);
            unmatchedAndAutoStates2.push(state);
            return;
          }

          var column = getById(colId);

          if (!column) {
            unmatchedAndAutoStates2.push(state);
            unmatchedCount2 += 1;
          } else {
            _this35.syncColumnWithStateItem(column, state, params.defaultState, rowGroupIndexes, pivotIndexes, false, source);

            _removeFromArray(columnsWithNoState, column);
          }
        });

        var applyDefaultsFunc = function applyDefaultsFunc(col) {
          return _this35.syncColumnWithStateItem(col, null, params.defaultState, rowGroupIndexes, pivotIndexes, false, source);
        };

        columnsWithNoState.forEach(applyDefaultsFunc);

        var comparator = function comparator(indexes, oldList, colA, colB) {
          var indexA = indexes[colA.getId()];
          var indexB = indexes[colB.getId()];
          var aHasIndex = indexA != null;
          var bHasIndex = indexB != null;

          if (aHasIndex && bHasIndex) {
            return indexA - indexB;
          }

          if (aHasIndex) {
            return -1;
          }

          if (bHasIndex) {
            return 1;
          }

          var oldIndexA = oldList.indexOf(colA);
          var oldIndexB = oldList.indexOf(colB);
          var aHasOldIndex = oldIndexA >= 0;
          var bHasOldIndex = oldIndexB >= 0;

          if (aHasOldIndex && bHasOldIndex) {
            return oldIndexA - oldIndexB;
          }

          if (aHasOldIndex) {
            return -1;
          }

          return 1;
        };

        _this35.rowGroupColumns.sort(comparator.bind(_this35, rowGroupIndexes, previousRowGroupCols));

        _this35.pivotColumns.sort(comparator.bind(_this35, pivotIndexes, previousPivotCols));

        _this35.updateGridColumns();

        var autoGroupColsCopy = _this35.groupAutoColumns ? _this35.groupAutoColumns.slice() : [];
        autoGroupColumnStates.forEach(function (stateItem) {
          var autoCol = _this35.getAutoColumn(stateItem.colId);

          _removeFromArray(autoGroupColsCopy, autoCol);

          _this35.syncColumnWithStateItem(autoCol, stateItem, params.defaultState, null, null, true, source);
        });
        autoGroupColsCopy.forEach(applyDefaultsFunc);

        _this35.applyOrderAfterApplyState(params);

        _this35.updateDisplayedColumns(source);

        _this35.dispatchEverythingChanged(source);

        dispatchEventsFunc();
        return {
          unmatchedAndAutoStates: unmatchedAndAutoStates2,
          unmatchedCount: unmatchedCount2
        };
      };

      this.columnAnimationService.start();

      var _applyStates = applyStates(params.state || [], this.primaryColumns || [], function (id) {
        return _this35.getPrimaryColumn(id);
      }),
          unmatchedAndAutoStates = _applyStates.unmatchedAndAutoStates,
          unmatchedCount = _applyStates.unmatchedCount;

      if (unmatchedAndAutoStates.length > 0 || _exists(params.defaultState)) {
        unmatchedCount = applyStates(unmatchedAndAutoStates, this.secondaryColumns || [], function (id) {
          return _this35.getSecondaryColumn(id);
        }).unmatchedCount;
      }

      this.columnAnimationService.finish();
      return unmatchedCount === 0;
    }
  }, {
    key: "applyOrderAfterApplyState",
    value: function applyOrderAfterApplyState(params) {
      var _this36 = this;

      if (!params.applyOrder || !params.state) {
        return;
      }

      var newOrder = [];
      var processedColIds = {};
      params.state.forEach(function (item) {
        if (!item.colId || processedColIds[item.colId]) {
          return;
        }

        var col = _this36.gridColumnsMap[item.colId];

        if (col) {
          newOrder.push(col);
          processedColIds[item.colId] = true;
        }
      });
      var autoGroupInsertIndex = 0;
      this.gridColumns.forEach(function (col) {
        var colId = col.getColId();
        var alreadyProcessed = processedColIds[colId] != null;

        if (alreadyProcessed) {
          return;
        }

        var isAutoGroupCol = colId.startsWith(_GROUP_AUTO_COLUMN_ID);

        if (isAutoGroupCol) {
          _insertIntoArray(newOrder, col, autoGroupInsertIndex++);
        } else {
          newOrder.push(col);
        }
      });
      newOrder = this.placeLockedColumns(newOrder);

      if (!this.doesMovePassMarryChildren(newOrder)) {
        console.warn("AG Grid: Applying column order broke a group where columns should be married together. Applying new order has been discarded.");
        return;
      }

      this.gridColumns = newOrder;
    }
  }, {
    key: "compareColumnStatesAndDispatchEvents",
    value: function compareColumnStatesAndDispatchEvents(source) {
      var _this37 = this;

      var startState = {
        rowGroupColumns: this.rowGroupColumns.slice(),
        pivotColumns: this.pivotColumns.slice(),
        valueColumns: this.valueColumns.slice()
      };
      var columnStateBefore = this.getColumnState();
      var columnStateBeforeMap = {};
      columnStateBefore.forEach(function (col) {
        columnStateBeforeMap[col.colId] = col;
      });
      return function () {
        var colsForState = _this37.getPrimaryAndSecondaryAndAutoColumns();

        var dispatchWhenListsDifferent = function dispatchWhenListsDifferent(eventType, colsBefore, colsAfter, idMapper) {
          var beforeList = colsBefore.map(idMapper);
          var afterList = colsAfter.map(idMapper);

          var unchanged = _areEqual(beforeList, afterList);

          if (unchanged) {
            return;
          }

          var changes = new Set(colsBefore);
          colsAfter.forEach(function (id) {
            if (!changes.delete(id)) {
              changes.add(id);
            }
          });

          var changesArr = _toConsumableArray(changes);

          var event = {
            type: eventType,
            columns: changesArr,
            column: changesArr.length === 1 ? changesArr[0] : null,
            source: source
          };

          _this37.eventService.dispatchEvent(event);
        };

        var getChangedColumns = function getChangedColumns(changedPredicate) {
          var changedColumns2 = [];
          colsForState.forEach(function (column) {
            var colStateBefore = columnStateBeforeMap[column.getColId()];

            if (colStateBefore && changedPredicate(colStateBefore, column)) {
              changedColumns2.push(column);
            }
          });
          return changedColumns2;
        };

        var columnIdMapper = function columnIdMapper(c) {
          return c.getColId();
        };

        dispatchWhenListsDifferent(_Events.EVENT_COLUMN_ROW_GROUP_CHANGED, startState.rowGroupColumns, _this37.rowGroupColumns, columnIdMapper);
        dispatchWhenListsDifferent(_Events.EVENT_COLUMN_PIVOT_CHANGED, startState.pivotColumns, _this37.pivotColumns, columnIdMapper);

        var valueChangePredicate = function valueChangePredicate(cs, c) {
          var oldActive = cs.aggFunc != null;
          var activeChanged = oldActive != c.isValueActive();
          var aggFuncChanged = oldActive && cs.aggFunc != c.getAggFunc();
          return activeChanged || aggFuncChanged;
        };

        var changedValues = getChangedColumns(valueChangePredicate);

        if (changedValues.length > 0) {
          _this37.dispatchColumnChangedEvent(_Events.EVENT_COLUMN_VALUE_CHANGED, changedValues, source);
        }

        var resizeChangePredicate = function resizeChangePredicate(cs, c) {
          return cs.width != c.getActualWidth();
        };

        _this37.dispatchColumnResizedEvent(getChangedColumns(resizeChangePredicate), true, source);

        var pinnedChangePredicate = function pinnedChangePredicate(cs, c) {
          return cs.pinned != c.getPinned();
        };

        _this37.dispatchColumnPinnedEvent(getChangedColumns(pinnedChangePredicate), source);

        var visibilityChangePredicate = function visibilityChangePredicate(cs, c) {
          return cs.hide == c.isVisible();
        };

        _this37.dispatchColumnVisibleEvent(getChangedColumns(visibilityChangePredicate), source);

        var sortChangePredicate = function sortChangePredicate(cs, c) {
          return cs.sort != c.getSort() || cs.sortIndex != c.getSortIndex();
        };

        var changedColumns = getChangedColumns(sortChangePredicate);

        if (changedColumns.length > 0) {
          _this37.sortController.dispatchSortChangedEvents(source, changedColumns);
        }

        _this37.normaliseColumnMovedEventForColumnState(columnStateBefore, source);
      };
    }
  }, {
    key: "getCommonValue",
    value: function getCommonValue(cols, valueGetter) {
      if (!cols || cols.length == 0) {
        return void 0;
      }

      var firstValue = valueGetter(cols[0]);

      for (var i = 1; i < cols.length; i++) {
        if (firstValue !== valueGetter(cols[i])) {
          return void 0;
        }
      }

      return firstValue;
    }
  }, {
    key: "normaliseColumnMovedEventForColumnState",
    value: function normaliseColumnMovedEventForColumnState(colStateBefore, source) {
      var _this38 = this;

      var colStateAfter = this.getColumnState();
      var colStateAfterMapped = {};
      colStateAfter.forEach(function (s) {
        return colStateAfterMapped[s.colId] = s;
      });
      var colsIntersectIds = {};
      colStateBefore.forEach(function (s) {
        if (colStateAfterMapped[s.colId]) {
          colsIntersectIds[s.colId] = true;
        }
      });
      var beforeFiltered = colStateBefore.filter(function (c) {
        return colsIntersectIds[c.colId];
      });
      var afterFiltered = colStateAfter.filter(function (c) {
        return colsIntersectIds[c.colId];
      });
      var movedColumns = [];
      afterFiltered.forEach(function (csAfter, index) {
        var csBefore = beforeFiltered && beforeFiltered[index];

        if (csBefore && csBefore.colId !== csAfter.colId) {
          var gridCol = _this38.getGridColumn(csBefore.colId);

          if (gridCol) {
            movedColumns.push(gridCol);
          }
        }
      });

      if (!movedColumns.length) {
        return;
      }

      this.dispatchColumnMovedEvent({
        movedColumns: movedColumns,
        source: source,
        finished: true
      });
    }
  }, {
    key: "syncColumnWithStateItem",
    value: function syncColumnWithStateItem(column, stateItem, defaultState, rowGroupIndexes, pivotIndexes, autoCol, source) {
      var _a;

      if (!column) {
        return;
      }

      var getValue = function getValue(key1, key2) {
        var obj = {
          value1: void 0,
          value2: void 0
        };
        var calculated = false;

        if (stateItem) {
          if (stateItem[key1] !== void 0) {
            obj.value1 = stateItem[key1];
            calculated = true;
          }

          if (_exists(key2) && stateItem[key2] !== void 0) {
            obj.value2 = stateItem[key2];
            calculated = true;
          }
        }

        if (!calculated && defaultState) {
          if (defaultState[key1] !== void 0) {
            obj.value1 = defaultState[key1];
          }

          if (_exists(key2) && defaultState[key2] !== void 0) {
            obj.value2 = defaultState[key2];
          }
        }

        return obj;
      };

      var hide = getValue("hide").value1;

      if (hide !== void 0) {
        column.setVisible(!hide, source);
      }

      var pinned = getValue("pinned").value1;

      if (pinned !== void 0) {
        column.setPinned(pinned);
      }

      var minColWidth = (_a = column.getColDef().minWidth) != null ? _a : this.environment.getMinColWidth();
      var flex = getValue("flex").value1;

      if (flex !== void 0) {
        column.setFlex(flex);
      }

      if (flex == null) {
        var width = getValue("width").value1;

        if (width != null) {
          if (minColWidth != null && width >= minColWidth) {
            column.setActualWidth(width, source);
          }
        }
      }

      var sort = getValue("sort").value1;

      if (sort !== void 0) {
        if (sort === "desc" || sort === "asc") {
          column.setSort(sort, source);
        } else {
          column.setSort(void 0, source);
        }
      }

      var sortIndex = getValue("sortIndex").value1;

      if (sortIndex !== void 0) {
        column.setSortIndex(sortIndex);
      }

      if (autoCol || !column.isPrimary()) {
        return;
      }

      var aggFunc = getValue("aggFunc").value1;

      if (aggFunc !== void 0) {
        if (typeof aggFunc === "string") {
          column.setAggFunc(aggFunc);

          if (!column.isValueActive()) {
            column.setValueActive(true, source);
            this.valueColumns.push(column);
          }
        } else {
          if (_exists(aggFunc)) {
            console.warn("AG Grid: stateItem.aggFunc must be a string. if using your own aggregation functions, register the functions first before using them in get/set state. This is because it is intended for the column state to be stored and retrieved as simple JSON.");
          }

          if (column.isValueActive()) {
            column.setValueActive(false, source);

            _removeFromArray(this.valueColumns, column);
          }
        }
      }

      var _getValue = getValue("rowGroup", "rowGroupIndex"),
          rowGroup = _getValue.value1,
          rowGroupIndex = _getValue.value2;

      if (rowGroup !== void 0 || rowGroupIndex !== void 0) {
        if (typeof rowGroupIndex === "number" || rowGroup) {
          if (!column.isRowGroupActive()) {
            column.setRowGroupActive(true, source);
            this.rowGroupColumns.push(column);
          }

          if (rowGroupIndexes && typeof rowGroupIndex === "number") {
            rowGroupIndexes[column.getId()] = rowGroupIndex;
          }
        } else {
          if (column.isRowGroupActive()) {
            column.setRowGroupActive(false, source);

            _removeFromArray(this.rowGroupColumns, column);
          }
        }
      }

      var _getValue2 = getValue("pivot", "pivotIndex"),
          pivot = _getValue2.value1,
          pivotIndex = _getValue2.value2;

      if (pivot !== void 0 || pivotIndex !== void 0) {
        if (typeof pivotIndex === "number" || pivot) {
          if (!column.isPivotActive()) {
            column.setPivotActive(true, source);
            this.pivotColumns.push(column);
          }

          if (pivotIndexes && typeof pivotIndex === "number") {
            pivotIndexes[column.getId()] = pivotIndex;
          }
        } else {
          if (column.isPivotActive()) {
            column.setPivotActive(false, source);

            _removeFromArray(this.pivotColumns, column);
          }
        }
      }
    }
  }, {
    key: "getGridColumns",
    value: function getGridColumns(keys2) {
      return this.getColumns(keys2, this.getGridColumn.bind(this));
    }
  }, {
    key: "getColumns",
    value: function getColumns(keys2, columnLookupCallback) {
      var foundColumns = [];

      if (keys2) {
        keys2.forEach(function (key) {
          var column = columnLookupCallback(key);

          if (column) {
            foundColumns.push(column);
          }
        });
      }

      return foundColumns;
    } // used by growGroupPanel

  }, {
    key: "getColumnWithValidation",
    value: function getColumnWithValidation(key) {
      if (key == null) {
        return null;
      }

      var column = this.getGridColumn(key);

      if (!column) {
        console.warn("AG Grid: could not find column " + key);
      }

      return column;
    }
  }, {
    key: "getPrimaryColumn",
    value: function getPrimaryColumn(key) {
      if (!this.primaryColumns) {
        return null;
      }

      return this.getColumn(key, this.primaryColumns, this.primaryColumnsMap);
    }
  }, {
    key: "getGridColumn",
    value: function getGridColumn(key) {
      return this.getColumn(key, this.gridColumns, this.gridColumnsMap);
    }
  }, {
    key: "lookupGridColumn",
    value: function lookupGridColumn(key) {
      return this.gridColumnsMap[key];
    }
  }, {
    key: "getSecondaryColumn",
    value: function getSecondaryColumn(key) {
      if (!this.secondaryColumns) {
        return null;
      }

      return this.getColumn(key, this.secondaryColumns, this.secondaryColumnsMap);
    }
  }, {
    key: "getColumn",
    value: function getColumn(key, columnList, columnMap) {
      if (!key || !columnMap) {
        return null;
      }

      if (typeof key == "string" && columnMap[key]) {
        return columnMap[key];
      }

      for (var i = 0; i < columnList.length; i++) {
        if (this.columnsMatch(columnList[i], key)) {
          return columnList[i];
        }
      }

      return this.getAutoColumn(key);
    }
  }, {
    key: "getSourceColumnsForGroupColumn",
    value: function getSourceColumnsForGroupColumn(groupCol) {
      var sourceColumnId = groupCol.getColDef().showRowGroup;

      if (!sourceColumnId) {
        return null;
      }

      if (sourceColumnId === true) {
        return this.rowGroupColumns.slice(0);
      }

      var column = this.getPrimaryColumn(sourceColumnId);
      return column ? [column] : null;
    }
  }, {
    key: "getAutoColumn",
    value: function getAutoColumn(key) {
      var _this39 = this;

      if (!this.groupAutoColumns || !_exists(this.groupAutoColumns) || _missing(this.groupAutoColumns)) {
        return null;
      }

      return this.groupAutoColumns.find(function (groupCol) {
        return _this39.columnsMatch(groupCol, key);
      }) || null;
    }
  }, {
    key: "columnsMatch",
    value: function columnsMatch(column, key) {
      var columnMatches = column === key;
      var colDefMatches = column.getColDef() === key;
      var idMatches = column.getColId() == key;
      return columnMatches || colDefMatches || idMatches;
    }
  }, {
    key: "getDisplayNameForColumn",
    value: function getDisplayNameForColumn(column, location) {
      var includeAggFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (!column) {
        return null;
      }

      var headerName = this.getHeaderName(column.getColDef(), column, null, null, location);

      if (includeAggFunc) {
        return this.wrapHeaderNameWithAggFunc(column, headerName);
      }

      return headerName;
    }
  }, {
    key: "getDisplayNameForProvidedColumnGroup",
    value: function getDisplayNameForProvidedColumnGroup(columnGroup, providedColumnGroup, location) {
      var colGroupDef = providedColumnGroup ? providedColumnGroup.getColGroupDef() : null;

      if (colGroupDef) {
        return this.getHeaderName(colGroupDef, null, columnGroup, providedColumnGroup, location);
      }

      return null;
    }
  }, {
    key: "getDisplayNameForColumnGroup",
    value: function getDisplayNameForColumnGroup(columnGroup, location) {
      return this.getDisplayNameForProvidedColumnGroup(columnGroup, columnGroup.getProvidedColumnGroup(), location);
    } // location is where the column is going to appear, ie who is calling us

  }, {
    key: "getHeaderName",
    value: function getHeaderName(colDef, column, columnGroup, providedColumnGroup, location) {
      var headerValueGetter = colDef.headerValueGetter;

      if (headerValueGetter) {
        var params = this.gos.addGridCommonParams({
          colDef: colDef,
          column: column,
          columnGroup: columnGroup,
          providedColumnGroup: providedColumnGroup,
          location: location
        });

        if (typeof headerValueGetter === "function") {
          return headerValueGetter(params);
        } else if (typeof headerValueGetter === "string") {
          return this.expressionService.evaluate(headerValueGetter, params);
        }

        console.warn("AG Grid: headerValueGetter must be a function or a string");
        return "";
      } else if (colDef.headerName != null) {
        return colDef.headerName;
      } else if (colDef.field) {
        return _camelCaseToHumanText(colDef.field);
      }

      return "";
    }
  }, {
    key: "wrapHeaderNameWithAggFunc",
    value: function wrapHeaderNameWithAggFunc(column, headerName) {
      if (this.gos.get("suppressAggFuncInHeader")) {
        return headerName;
      }

      var pivotValueColumn = column.getColDef().pivotValueColumn;

      var pivotActiveOnThisColumn = _exists(pivotValueColumn);

      var aggFunc = null;
      var aggFuncFound;

      if (pivotActiveOnThisColumn) {
        var isCollapsedHeaderEnabled = this.gos.get("removePivotHeaderRowWhenSingleValueColumn") && this.valueColumns.length === 1;
        var isTotalColumn = column.getColDef().pivotTotalColumnIds !== void 0;

        if (isCollapsedHeaderEnabled && !isTotalColumn) {
          return headerName;
        }

        aggFunc = pivotValueColumn ? pivotValueColumn.getAggFunc() : null;
        aggFuncFound = true;
      } else {
        var measureActive = column.isValueActive();
        var aggregationPresent = this.pivotMode || !this.isRowGroupEmpty();

        if (measureActive && aggregationPresent) {
          aggFunc = column.getAggFunc();
          aggFuncFound = true;
        } else {
          aggFuncFound = false;
        }
      }

      if (aggFuncFound) {
        var aggFuncString = typeof aggFunc === "string" ? aggFunc : "func";
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        var aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
        return "".concat(aggFuncStringTranslated, "(").concat(headerName, ")");
      }

      return headerName;
    } // returns the group with matching colId and instanceId. If instanceId is missing,
    // matches only on the colId.

  }, {
    key: "getColumnGroup",
    value: function getColumnGroup(colId, partId) {
      if (!colId) {
        return null;
      }

      if (colId instanceof _ColumnGroup2) {
        return colId;
      }

      var allColumnGroups = this.getAllDisplayedTrees();
      var checkPartId = typeof partId === "number";
      var result = null;
      depthFirstAllColumnTreeSearch(allColumnGroups, false, function (child) {
        if (child instanceof _ColumnGroup2) {
          var columnGroup = child;
          var matched;

          if (checkPartId) {
            matched = colId === columnGroup.getGroupId() && partId === columnGroup.getPartId();
          } else {
            matched = colId === columnGroup.getGroupId();
          }

          if (matched) {
            result = columnGroup;
          }
        }
      });
      return result;
    }
  }, {
    key: "isReady",
    value: function isReady() {
      return this.ready;
    }
  }, {
    key: "extractValueColumns",
    value: function extractValueColumns(source, oldPrimaryColumns) {
      this.valueColumns = this.extractColumns(oldPrimaryColumns, this.valueColumns, function (col, flag) {
        return col.setValueActive(flag, source);
      }, // aggFunc doesn't have index variant, cos order of value cols doesn't matter, so always return null
      function () {
        return void 0;
      }, function () {
        return void 0;
      }, // aggFunc is a string, so return it's existence
      function (colDef) {
        var aggFunc = colDef.aggFunc;

        if (aggFunc === null || aggFunc === "") {
          return null;
        }

        if (aggFunc === void 0) {
          return;
        }

        return !!aggFunc;
      }, function (colDef) {
        return colDef.initialAggFunc != null && colDef.initialAggFunc != "";
      });
      this.valueColumns.forEach(function (col) {
        var colDef = col.getColDef();

        if (colDef.aggFunc != null && colDef.aggFunc != "") {
          col.setAggFunc(colDef.aggFunc);
        } else {
          if (!col.getAggFunc()) {
            col.setAggFunc(colDef.initialAggFunc);
          }
        }
      });
    }
  }, {
    key: "extractRowGroupColumns",
    value: function extractRowGroupColumns(source, oldPrimaryColumns) {
      this.rowGroupColumns = this.extractColumns(oldPrimaryColumns, this.rowGroupColumns, function (col, flag) {
        return col.setRowGroupActive(flag, source);
      }, function (colDef) {
        return colDef.rowGroupIndex;
      }, function (colDef) {
        return colDef.initialRowGroupIndex;
      }, function (colDef) {
        return colDef.rowGroup;
      }, function (colDef) {
        return colDef.initialRowGroup;
      });
    }
  }, {
    key: "extractColumns",
    value: function extractColumns() {
      var oldPrimaryColumns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var previousCols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var setFlagFunc = arguments.length > 2 ? arguments[2] : undefined;
      var getIndexFunc = arguments.length > 3 ? arguments[3] : undefined;
      var getInitialIndexFunc = arguments.length > 4 ? arguments[4] : undefined;
      var getValueFunc = arguments.length > 5 ? arguments[5] : undefined;
      var getInitialValueFunc = arguments.length > 6 ? arguments[6] : undefined;
      var colsWithIndex = [];
      var colsWithValue = [];
      (this.primaryColumns || []).forEach(function (col) {
        var colIsNew = oldPrimaryColumns.indexOf(col) < 0;
        var colDef = col.getColDef();

        var value = _attrToBoolean(getValueFunc(colDef));

        var initialValue = _attrToBoolean(getInitialValueFunc(colDef));

        var index = _attrToNumber(getIndexFunc(colDef));

        var initialIndex = _attrToNumber(getInitialIndexFunc(colDef));

        var include;
        var valuePresent = value !== void 0;
        var indexPresent = index !== void 0;
        var initialValuePresent = initialValue !== void 0;
        var initialIndexPresent = initialIndex !== void 0;

        if (valuePresent) {
          include = value;
        } else if (indexPresent) {
          if (index === null) {
            include = false;
          } else {
            include = index >= 0;
          }
        } else {
          if (colIsNew) {
            if (initialValuePresent) {
              include = initialValue;
            } else if (initialIndexPresent) {
              include = initialIndex != null && initialIndex >= 0;
            } else {
              include = false;
            }
          } else {
            include = previousCols.indexOf(col) >= 0;
          }
        }

        if (include) {
          var useIndex = colIsNew ? index != null || initialIndex != null : index != null;
          useIndex ? colsWithIndex.push(col) : colsWithValue.push(col);
        }
      });

      var getIndexForCol = function getIndexForCol(col) {
        var index = getIndexFunc(col.getColDef());
        var defaultIndex = getInitialIndexFunc(col.getColDef());
        return index != null ? index : defaultIndex;
      };

      colsWithIndex.sort(function (colA, colB) {
        var indexA = getIndexForCol(colA);
        var indexB = getIndexForCol(colB);

        if (indexA === indexB) {
          return 0;
        }

        if (indexA < indexB) {
          return -1;
        }

        return 1;
      });
      var res = [].concat(colsWithIndex);
      previousCols.forEach(function (col) {
        if (colsWithValue.indexOf(col) >= 0) {
          res.push(col);
        }
      });
      colsWithValue.forEach(function (col) {
        if (res.indexOf(col) < 0) {
          res.push(col);
        }
      });
      previousCols.forEach(function (col) {
        if (res.indexOf(col) < 0) {
          setFlagFunc(col, false);
        }
      });
      res.forEach(function (col) {
        if (previousCols.indexOf(col) < 0) {
          setFlagFunc(col, true);
        }
      });
      return res;
    }
  }, {
    key: "extractPivotColumns",
    value: function extractPivotColumns(source, oldPrimaryColumns) {
      this.pivotColumns = this.extractColumns(oldPrimaryColumns, this.pivotColumns, function (col, flag) {
        return col.setPivotActive(flag, source);
      }, function (colDef) {
        return colDef.pivotIndex;
      }, function (colDef) {
        return colDef.initialPivotIndex;
      }, function (colDef) {
        return colDef.pivot;
      }, function (colDef) {
        return colDef.initialPivot;
      });
    }
  }, {
    key: "resetColumnGroupState",
    value: function resetColumnGroupState(source) {
      if (!this.primaryColumnTree) {
        return;
      }

      var stateItems = [];
      depthFirstOriginalTreeSearch(null, this.primaryColumnTree, function (child) {
        if (child instanceof _ProvidedColumnGroup2) {
          var colGroupDef = child.getColGroupDef();
          var groupState = {
            groupId: child.getGroupId(),
            open: !colGroupDef ? void 0 : colGroupDef.openByDefault
          };
          stateItems.push(groupState);
        }
      });
      this.setColumnGroupState(stateItems, source);
    }
  }, {
    key: "getColumnGroupState",
    value: function getColumnGroupState() {
      var columnGroupState = [];
      depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function (node) {
        if (node instanceof _ProvidedColumnGroup2) {
          columnGroupState.push({
            groupId: node.getGroupId(),
            open: node.isExpanded()
          });
        }
      });
      return columnGroupState;
    }
  }, {
    key: "setColumnGroupState",
    value: function setColumnGroupState(stateItems, source) {
      var _this40 = this;

      if (!this.gridBalancedTree) {
        return;
      }

      this.columnAnimationService.start();
      var impactedGroups = [];
      stateItems.forEach(function (stateItem) {
        var groupKey = stateItem.groupId;
        var newValue = stateItem.open;

        var providedColumnGroup = _this40.getProvidedColumnGroup(groupKey);

        if (!providedColumnGroup) {
          return;
        }

        if (providedColumnGroup.isExpanded() === newValue) {
          return;
        }

        _this40.logger.log("columnGroupOpened(" + providedColumnGroup.getGroupId() + "," + newValue + ")");

        providedColumnGroup.setExpanded(newValue);
        impactedGroups.push(providedColumnGroup);
      });
      this.updateGroupsAndDisplayedColumns(source);
      this.setFirstRightAndLastLeftPinned(source);

      if (impactedGroups.length) {
        var event = {
          type: _Events.EVENT_COLUMN_GROUP_OPENED,
          columnGroup: _ProvidedColumnGroup2.length === 1 ? impactedGroups[0] : void 0,
          columnGroups: impactedGroups
        };
        this.eventService.dispatchEvent(event);
      }

      this.columnAnimationService.finish();
    } // called by headerRenderer - when a header is opened or closed

  }, {
    key: "setColumnGroupOpened",
    value: function setColumnGroupOpened(key, newValue, source) {
      var keyAsString;

      if (key instanceof _ProvidedColumnGroup2) {
        keyAsString = key.getId();
      } else {
        keyAsString = key || "";
      }

      this.setColumnGroupState([{
        groupId: keyAsString,
        open: newValue
      }], source);
    }
  }, {
    key: "getProvidedColumnGroup",
    value: function getProvidedColumnGroup(key) {
      if (typeof key !== "string") {
        console.error("AG Grid: group key must be a string");
      }

      var res = null;
      depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function (node) {
        if (node instanceof _ProvidedColumnGroup2) {
          if (node.getId() === key) {
            res = node;
          }
        }
      });
      return res;
    }
  }, {
    key: "calculateColumnsForDisplay",
    value: function calculateColumnsForDisplay() {
      var _this41 = this;

      var columnsForDisplay;

      if (this.pivotMode && _missing(this.secondaryColumns)) {
        columnsForDisplay = this.gridColumns.filter(function (column) {
          var isAutoGroupCol = _this41.groupAutoColumns && _includes(_this41.groupAutoColumns, column);

          var isValueCol = _this41.valueColumns && _includes(_this41.valueColumns, column);

          return isAutoGroupCol || isValueCol;
        });
      } else {
        columnsForDisplay = this.gridColumns.filter(function (column) {
          var isAutoGroupCol = _this41.groupAutoColumns && _includes(_this41.groupAutoColumns, column);

          return isAutoGroupCol || column.isVisible();
        });
      }

      return columnsForDisplay;
    }
  }, {
    key: "checkColSpanActiveInCols",
    value: function checkColSpanActiveInCols(columns) {
      var result = false;
      columns.forEach(function (col) {
        if (_exists(col.getColDef().colSpan)) {
          result = true;
        }
      });
      return result;
    }
  }, {
    key: "calculateColumnsForGroupDisplay",
    value: function calculateColumnsForGroupDisplay() {
      var _this42 = this;

      this.groupDisplayColumns = [];
      this.groupDisplayColumnsMap = {};

      var checkFunc = function checkFunc(col) {
        var colDef = col.getColDef();
        var underlyingColumn = colDef.showRowGroup;

        if (colDef && _exists(underlyingColumn)) {
          _this42.groupDisplayColumns.push(col);

          if (typeof underlyingColumn === "string") {
            _this42.groupDisplayColumnsMap[underlyingColumn] = col;
          } else if (underlyingColumn === true) {
            _this42.getRowGroupColumns().forEach(function (rowGroupCol) {
              _this42.groupDisplayColumnsMap[rowGroupCol.getId()] = col;
            });
          }
        }
      };

      this.gridColumns.forEach(checkFunc);
    }
  }, {
    key: "getGroupDisplayColumns",
    value: function getGroupDisplayColumns() {
      return this.groupDisplayColumns;
    }
  }, {
    key: "getGroupDisplayColumnForGroup",
    value: function getGroupDisplayColumnForGroup(rowGroupColumnId) {
      return this.groupDisplayColumnsMap[rowGroupColumnId];
    }
  }, {
    key: "updateDisplayedColumns",
    value: function updateDisplayedColumns(source) {
      var columnsForDisplay = this.calculateColumnsForDisplay();
      this.buildDisplayedTrees(columnsForDisplay);
      this.updateGroupsAndDisplayedColumns(source);
      this.setFirstRightAndLastLeftPinned(source);
    }
  }, {
    key: "isSecondaryColumnsPresent",
    value: function isSecondaryColumnsPresent() {
      return _exists(this.secondaryColumns);
    }
  }, {
    key: "setSecondaryColumns",
    value: function setSecondaryColumns(colDefs, source) {
      var _this43 = this;

      if (!this.gridColumns) {
        return;
      }

      var newColsPresent = colDefs;

      if (!newColsPresent && _missing(this.secondaryColumns)) {
        return;
      }

      if (newColsPresent) {
        this.processSecondaryColumnDefinitions(colDefs);
        var balancedTreeResult = this.columnFactory.createColumnTree(colDefs, false, this.secondaryBalancedTree || this.previousSecondaryColumns || void 0, source);
        this.destroyOldColumns(this.secondaryBalancedTree, balancedTreeResult.columnTree);
        this.secondaryBalancedTree = balancedTreeResult.columnTree;
        this.secondaryHeaderRowCount = balancedTreeResult.treeDept + 1;
        this.secondaryColumns = this.getColumnsFromTree(this.secondaryBalancedTree);
        this.secondaryColumnsMap = {};
        this.secondaryColumns.forEach(function (col) {
          return _this43.secondaryColumnsMap[col.getId()] = col;
        });
        this.previousSecondaryColumns = null;
      } else {
        this.previousSecondaryColumns = this.secondaryBalancedTree;
        this.secondaryBalancedTree = null;
        this.secondaryHeaderRowCount = -1;
        this.secondaryColumns = null;
        this.secondaryColumnsMap = {};
      }

      this.updateGridColumns();
      this.updateDisplayedColumns(source);
    }
  }, {
    key: "processSecondaryColumnDefinitions",
    value: function processSecondaryColumnDefinitions(colDefs) {
      var columnCallback = this.gos.get("processPivotResultColDef");
      var groupCallback = this.gos.get("processPivotResultColGroupDef");

      if (!columnCallback && !groupCallback) {
        return void 0;
      }

      var searchForColDefs = function searchForColDefs(colDefs2) {
        colDefs2.forEach(function (abstractColDef) {
          var isGroup = _exists(abstractColDef.children);

          if (isGroup) {
            var colGroupDef = abstractColDef;

            if (groupCallback) {
              groupCallback(colGroupDef);
            }

            searchForColDefs(colGroupDef.children);
          } else {
            var colDef = abstractColDef;

            if (columnCallback) {
              columnCallback(colDef);
            }
          }
        });
      };

      if (colDefs) {
        searchForColDefs(colDefs);
      }
    } // called from: applyColumnState, setColumnDefs, setSecondaryColumns

  }, {
    key: "updateGridColumns",
    value: function updateGridColumns() {
      var _this44 = this;

      var prevGridCols = this.gridBalancedTree;

      if (this.gridColsArePrimary) {
        this.lastPrimaryOrder = this.gridColumns;
      } else {
        this.lastSecondaryOrder = this.gridColumns;
      }

      var areAutoColsChanged = this.createGroupAutoColumnsIfNeeded();

      if (areAutoColsChanged) {
        var groupAutoColsMap = _convertToMap(this.groupAutoColumns.map(function (col) {
          return [col, true];
        }));

        if (this.lastPrimaryOrder) {
          this.lastPrimaryOrder = this.lastPrimaryOrder.filter(function (col) {
            return !groupAutoColsMap.has(col);
          });
          this.lastPrimaryOrder = [].concat(_toConsumableArray(this.groupAutoColumns), _toConsumableArray(this.lastPrimaryOrder));
        }

        if (this.lastSecondaryOrder) {
          this.lastSecondaryOrder = this.lastSecondaryOrder.filter(function (col) {
            return !groupAutoColsMap.has(col);
          });
          this.lastSecondaryOrder = [].concat(_toConsumableArray(this.groupAutoColumns), _toConsumableArray(this.lastSecondaryOrder));
        }
      }

      var sortOrderToRecover;

      if (this.secondaryColumns && this.secondaryBalancedTree) {
        var hasSameColumns = this.secondaryColumns.some(function (col) {
          return _this44.gridColumnsMap[col.getColId()] !== void 0;
        });
        this.gridBalancedTree = this.secondaryBalancedTree.slice();
        this.gridHeaderRowCount = this.secondaryHeaderRowCount;
        this.gridColumns = this.secondaryColumns.slice();
        this.gridColsArePrimary = false;

        if (hasSameColumns) {
          sortOrderToRecover = this.lastSecondaryOrder;
        }
      } else if (this.primaryColumns) {
        this.gridBalancedTree = this.primaryColumnTree.slice();
        this.gridHeaderRowCount = this.primaryHeaderRowCount;
        this.gridColumns = this.primaryColumns.slice();
        this.gridColsArePrimary = true;
        sortOrderToRecover = this.lastPrimaryOrder;
      }

      this.addAutoGroupToGridColumns();
      this.orderGridColsLike(sortOrderToRecover);
      this.gridColumns = this.placeLockedColumns(this.gridColumns);
      this.calculateColumnsForGroupDisplay();
      this.refreshQuickFilterColumns();
      this.clearDisplayedAndViewportColumns();
      this.colSpanActive = this.checkColSpanActiveInCols(this.gridColumns);
      this.gridColumnsMap = {};
      this.gridColumns.forEach(function (col) {
        return _this44.gridColumnsMap[col.getId()] = col;
      });
      this.setAutoHeightActive();

      if (!_areEqual(prevGridCols, this.gridBalancedTree)) {
        var event = {
          type: _Events.EVENT_GRID_COLUMNS_CHANGED
        };
        this.eventService.dispatchEvent(event);
      }
    }
  }, {
    key: "setAutoHeightActive",
    value: function setAutoHeightActive() {
      this.autoHeightActive = this.gridColumns.filter(function (col) {
        return col.isAutoHeight();
      }).length > 0;

      if (this.autoHeightActive) {
        this.autoHeightActiveAtLeastOnce = true;
        var supportedRowModel = this.gos.isRowModelType("clientSide") || this.gos.isRowModelType("serverSide");

        if (!supportedRowModel) {
          _warnOnce("autoHeight columns only work with Client Side Row Model and Server Side Row Model.");
        }
      }
    }
  }, {
    key: "orderGridColsLike",
    value: function orderGridColsLike(colsOrder) {
      if (_missing(colsOrder)) {
        return;
      }

      var lastOrderMapped = _convertToMap(colsOrder.map(function (col, index) {
        return [col, index];
      }));

      var noColsFound = true;
      this.gridColumns.forEach(function (col) {
        if (lastOrderMapped.has(col)) {
          noColsFound = false;
        }
      });

      if (noColsFound) {
        return;
      }

      var gridColsMap = _convertToMap(this.gridColumns.map(function (col) {
        return [col, true];
      }));

      var oldColsOrdered = colsOrder.filter(function (col) {
        return gridColsMap.has(col);
      });

      var oldColsMap = _convertToMap(oldColsOrdered.map(function (col) {
        return [col, true];
      }));

      var newColsOrdered = this.gridColumns.filter(function (col) {
        return !oldColsMap.has(col);
      });
      var newGridColumns = oldColsOrdered.slice();
      newColsOrdered.forEach(function (newCol) {
        var parent = newCol.getOriginalParent();

        if (!parent) {
          newGridColumns.push(newCol);
          return;
        }

        var siblings = [];

        while (!siblings.length && parent) {
          var leafCols = parent.getLeafColumns();
          leafCols.forEach(function (leafCol) {
            var presentInNewGriColumns = newGridColumns.indexOf(leafCol) >= 0;
            var noYetInSiblings = siblings.indexOf(leafCol) < 0;

            if (presentInNewGriColumns && noYetInSiblings) {
              siblings.push(leafCol);
            }
          });
          parent = parent.getOriginalParent();
        }

        if (!siblings.length) {
          newGridColumns.push(newCol);
          return;
        }

        var indexes = siblings.map(function (col) {
          return newGridColumns.indexOf(col);
        });
        var lastIndex = Math.max.apply(Math, _toConsumableArray(indexes));

        _insertIntoArray(newGridColumns, newCol, lastIndex + 1);
      });
      this.gridColumns = newGridColumns;
    }
  }, {
    key: "isPrimaryColumnGroupsPresent",
    value: function isPrimaryColumnGroupsPresent() {
      return this.primaryHeaderRowCount > 1;
    } // if we are using autoGroupCols, then they should be included for quick filter. this covers the
    // following scenarios:
    // a) user provides 'field' into autoGroupCol of normal grid, so now because a valid col to filter leafs on
    // b) using tree data and user depends on autoGroupCol for first col, and we also want to filter on this
    //    (tree data is a bit different, as parent rows can be filtered on, unlike row grouping)

  }, {
    key: "refreshQuickFilterColumns",
    value: function refreshQuickFilterColumns() {
      var _a;

      var columnsForQuickFilter = (_a = this.isPivotMode() && !this.gos.get("applyQuickFilterBeforePivotOrAgg") ? this.secondaryColumns : this.primaryColumns) != null ? _a : [];

      if (this.groupAutoColumns) {
        columnsForQuickFilter = columnsForQuickFilter.concat(this.groupAutoColumns);
      }

      this.columnsForQuickFilter = this.gos.get("includeHiddenColumnsInQuickFilter") ? columnsForQuickFilter : columnsForQuickFilter.filter(function (col) {
        return col.isVisible() || col.isRowGroupActive();
      });
    }
  }, {
    key: "placeLockedColumns",
    value: function placeLockedColumns(cols) {
      var left = [];
      var normal = [];
      var right = [];
      cols.forEach(function (col) {
        var position = col.getColDef().lockPosition;

        if (position === "right") {
          right.push(col);
        } else if (position === "left" || position === true) {
          left.push(col);
        } else {
          normal.push(col);
        }
      });
      return [].concat(left, normal, right);
    }
  }, {
    key: "addAutoGroupToGridColumns",
    value: function addAutoGroupToGridColumns() {
      if (_missing(this.groupAutoColumns)) {
        this.destroyOldColumns(this.groupAutoColsBalancedTree);
        this.groupAutoColsBalancedTree = null;
        return;
      }

      this.gridColumns = this.groupAutoColumns ? this.groupAutoColumns.concat(this.gridColumns) : this.gridColumns;
      var newAutoColsTree = this.columnFactory.createForAutoGroups(this.groupAutoColumns, this.gridBalancedTree);
      this.destroyOldColumns(this.groupAutoColsBalancedTree, newAutoColsTree);
      this.groupAutoColsBalancedTree = newAutoColsTree;
      this.gridBalancedTree = newAutoColsTree.concat(this.gridBalancedTree);
    } // gets called after we copy down grid columns, to make sure any part of the gui
    // that tries to draw, eg the header, it will get empty lists of columns rather
    // than stale columns. for example, the header will received gridColumnsChanged
    // event, so will try and draw, but it will draw successfully when it acts on the
    // virtualColumnsChanged event

  }, {
    key: "clearDisplayedAndViewportColumns",
    value: function clearDisplayedAndViewportColumns() {
      this.viewportRowLeft = {};
      this.viewportRowRight = {};
      this.viewportRowCenter = {};
      this.displayedColumnsLeft = [];
      this.displayedColumnsRight = [];
      this.displayedColumnsCenter = [];
      this.displayedColumns = [];
      this.ariaOrderColumns = [];
      this.viewportColumns = [];
      this.headerViewportColumns = [];
      this.viewportColumnsHash = "";
    }
  }, {
    key: "updateGroupsAndDisplayedColumns",
    value: function updateGroupsAndDisplayedColumns(source) {
      this.updateOpenClosedVisibilityInColumnGroups();
      this.deriveDisplayedColumns(source);
      this.refreshFlexedColumns();
      this.extractViewport();
      this.updateBodyWidths();
      var event = {
        type: _Events.EVENT_DISPLAYED_COLUMNS_CHANGED
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "deriveDisplayedColumns",
    value: function deriveDisplayedColumns(source) {
      this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeLeft, this.displayedColumnsLeft);
      this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeCentre, this.displayedColumnsCenter);
      this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeRight, this.displayedColumnsRight);
      this.joinColumnsAriaOrder();
      this.joinDisplayedColumns();
      this.setLeftValues(source);
      this.displayedAutoHeightCols = this.displayedColumns.filter(function (col) {
        return col.isAutoHeight();
      });
    }
  }, {
    key: "isAutoRowHeightActive",
    value: function isAutoRowHeightActive() {
      return this.autoHeightActive;
    }
  }, {
    key: "wasAutoRowHeightEverActive",
    value: function wasAutoRowHeightEverActive() {
      return this.autoHeightActiveAtLeastOnce;
    }
  }, {
    key: "joinColumnsAriaOrder",
    value: function joinColumnsAriaOrder() {
      var allColumns = this.getAllGridColumns();
      var pinnedLeft = [];
      var center = [];
      var pinnedRight = [];
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = allColumns[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var col = _step6.value;
          var pinned = col.getPinned();

          if (!pinned) {
            center.push(col);
          } else if (pinned === true || pinned === "left") {
            pinnedLeft.push(col);
          } else {
            pinnedRight.push(col);
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      this.ariaOrderColumns = pinnedLeft.concat(center).concat(pinnedRight);
    }
  }, {
    key: "joinDisplayedColumns",
    value: function joinDisplayedColumns() {
      if (this.gos.get("enableRtl")) {
        this.displayedColumns = this.displayedColumnsRight.concat(this.displayedColumnsCenter).concat(this.displayedColumnsLeft);
      } else {
        this.displayedColumns = this.displayedColumnsLeft.concat(this.displayedColumnsCenter).concat(this.displayedColumnsRight);
      }
    } // sets the left pixel position of each column

  }, {
    key: "setLeftValues",
    value: function setLeftValues(source) {
      this.setLeftValuesOfColumns(source);
      this.setLeftValuesOfGroups();
    }
  }, {
    key: "setLeftValuesOfColumns",
    value: function setLeftValuesOfColumns(source) {
      var _this45 = this;

      if (!this.primaryColumns) {
        return;
      }

      var allColumns = this.getPrimaryAndSecondaryAndAutoColumns().slice(0);
      var doingRtl = this.gos.get("enableRtl");
      [this.displayedColumnsLeft, this.displayedColumnsRight, this.displayedColumnsCenter].forEach(function (columns) {
        if (doingRtl) {
          var left = _this45.getWidthOfColsInList(columns);

          columns.forEach(function (column) {
            left -= column.getActualWidth();
            column.setLeft(left, source);
          });
        } else {
          var _left = 0;
          columns.forEach(function (column) {
            column.setLeft(_left, source);
            _left += column.getActualWidth();
          });
        }

        _removeAllFromUnorderedArray(allColumns, columns);
      });
      allColumns.forEach(function (column) {
        column.setLeft(null, source);
      });
    }
  }, {
    key: "setLeftValuesOfGroups",
    value: function setLeftValuesOfGroups() {
      [this.displayedTreeLeft, this.displayedTreeRight, this.displayedTreeCentre].forEach(function (columns) {
        columns.forEach(function (column) {
          if (column instanceof _ColumnGroup2) {
            var columnGroup = column;
            columnGroup.checkLeft();
          }
        });
      });
    }
  }, {
    key: "derivedDisplayedColumnsFromDisplayedTree",
    value: function derivedDisplayedColumnsFromDisplayedTree(tree, columns) {
      columns.length = 0;
      depthFirstAllColumnTreeSearch(tree, true, function (child) {
        if (child instanceof _Column2) {
          columns.push(child);
        }
      });
    }
  }, {
    key: "isColumnVirtualisationSuppressed",
    value: function isColumnVirtualisationSuppressed() {
      return this.suppressColumnVirtualisation || this.viewportRight === 0;
    }
  }, {
    key: "extractViewportColumns",
    value: function extractViewportColumns() {
      if (this.isColumnVirtualisationSuppressed()) {
        this.viewportColumnsCenter = this.displayedColumnsCenter;
        this.headerViewportColumnsCenter = this.displayedColumnsCenter;
      } else {
        this.viewportColumnsCenter = this.displayedColumnsCenter.filter(this.isColumnInRowViewport.bind(this));
        this.headerViewportColumnsCenter = this.displayedColumnsCenter.filter(this.isColumnInHeaderViewport.bind(this));
      }

      this.viewportColumns = this.viewportColumnsCenter.concat(this.displayedColumnsLeft).concat(this.displayedColumnsRight);
      this.headerViewportColumns = this.headerViewportColumnsCenter.concat(this.displayedColumnsLeft).concat(this.displayedColumnsRight);
    }
  }, {
    key: "getVirtualHeaderGroupRow",
    value: function getVirtualHeaderGroupRow(type, dept) {
      var result;

      switch (type) {
        case "left":
          result = this.viewportRowLeft[dept];
          break;

        case "right":
          result = this.viewportRowRight[dept];
          break;

        default:
          result = this.viewportRowCenter[dept];
          break;
      }

      if (_missing(result)) {
        result = [];
      }

      return result;
    }
  }, {
    key: "calculateHeaderRows",
    value: function calculateHeaderRows() {
      this.viewportRowLeft = {};
      this.viewportRowRight = {};
      this.viewportRowCenter = {};
      var virtualColIds = {};
      this.headerViewportColumns.forEach(function (col) {
        return virtualColIds[col.getId()] = true;
      });

      var testGroup = function testGroup(children, result, dept) {
        var returnValue = false;

        for (var i = 0; i < children.length; i++) {
          var child = children[i];
          var addThisItem = false;

          if (child instanceof _Column2) {
            addThisItem = virtualColIds[child.getId()] === true;
          } else {
            var columnGroup = child;
            var displayedChildren = columnGroup.getDisplayedChildren();

            if (displayedChildren) {
              addThisItem = testGroup(displayedChildren, result, dept + 1);
            }
          }

          if (addThisItem) {
            returnValue = true;

            if (!result[dept]) {
              result[dept] = [];
            }

            result[dept].push(child);
          }
        }

        return returnValue;
      };

      testGroup(this.displayedTreeLeft, this.viewportRowLeft, 0);
      testGroup(this.displayedTreeRight, this.viewportRowRight, 0);
      testGroup(this.displayedTreeCentre, this.viewportRowCenter, 0);
    }
  }, {
    key: "extractViewport",
    value: function extractViewport() {
      var hashColumn = function hashColumn(c) {
        return "".concat(c.getId(), "-").concat(c.getPinned() || "normal");
      };

      this.extractViewportColumns();
      var newHash = this.viewportColumns.map(hashColumn).join("#");
      var changed = this.viewportColumnsHash !== newHash;

      if (changed) {
        this.viewportColumnsHash = newHash;
        this.calculateHeaderRows();
      }

      return changed;
    }
  }, {
    key: "refreshFlexedColumns",
    value: function refreshFlexedColumns() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _a;

      var source = params.source ? params.source : "flex";

      if (params.viewportWidth != null) {
        this.flexViewportWidth = params.viewportWidth;
      }

      if (!this.flexViewportWidth) {
        return [];
      }

      var flexAfterDisplayIndex = -1;

      if (params.resizingCols) {
        var allResizingCols = new Set(params.resizingCols);
        var displayedCols = this.displayedColumnsCenter;

        for (var i = displayedCols.length - 1; i >= 0; i--) {
          if (allResizingCols.has(displayedCols[i])) {
            flexAfterDisplayIndex = i;
            break;
          }
        }
      }

      var knownColumnsWidth = 0;
      var flexingColumns = [];
      var minimumFlexedWidth = 0;
      var totalFlex = 0;

      for (var _i2 = 0; _i2 < this.displayedColumnsCenter.length; _i2++) {
        var isFlex = this.displayedColumnsCenter[_i2].getFlex() && _i2 > flexAfterDisplayIndex;

        if (isFlex) {
          flexingColumns.push(this.displayedColumnsCenter[_i2]);
          totalFlex += this.displayedColumnsCenter[_i2].getFlex();
          minimumFlexedWidth += (_a = this.displayedColumnsCenter[_i2].getMinWidth()) != null ? _a : 0;
        } else {
          knownColumnsWidth += this.displayedColumnsCenter[_i2].getActualWidth();
        }
      }

      ;

      if (!flexingColumns.length) {
        return [];
      }

      var changedColumns = [];

      if (knownColumnsWidth + minimumFlexedWidth > this.flexViewportWidth) {
        flexingColumns.forEach(function (col) {
          var _a2;

          return col.setActualWidth((_a2 = col.getMinWidth()) != null ? _a2 : 0, source);
        });
        changedColumns = flexingColumns;
        flexingColumns = [];
      }

      var flexingColumnSizes = [];
      var spaceForFlexingColumns;

      outer: while (true) {
        spaceForFlexingColumns = this.flexViewportWidth - knownColumnsWidth;
        var spacePerFlex = spaceForFlexingColumns / totalFlex;

        for (var _i3 = 0; _i3 < flexingColumns.length; _i3++) {
          var col = flexingColumns[_i3];
          var widthByFlexRule = spacePerFlex * col.getFlex();
          var constrainedWidth = 0;
          var minWidth = col.getMinWidth();
          var maxWidth = col.getMaxWidth();

          if (_exists(minWidth) && widthByFlexRule < minWidth) {
            constrainedWidth = minWidth;
          } else if (_exists(maxWidth) && widthByFlexRule > maxWidth) {
            constrainedWidth = maxWidth;
          }

          if (constrainedWidth) {
            col.setActualWidth(constrainedWidth, source);

            _removeFromUnorderedArray(flexingColumns, col);

            totalFlex -= col.getFlex();
            changedColumns.push(col);
            knownColumnsWidth += col.getActualWidth();
            continue outer;
          }

          flexingColumnSizes[_i3] = Math.round(widthByFlexRule);
        }

        break;
      }

      var remainingSpace = spaceForFlexingColumns;
      flexingColumns.forEach(function (col, i) {
        col.setActualWidth(Math.min(flexingColumnSizes[i], remainingSpace), source);
        changedColumns.push(col);
        remainingSpace -= flexingColumnSizes[i];
      });

      if (!params.skipSetLeft) {
        this.setLeftValues(source);
      }

      if (params.updateBodyWidths) {
        this.updateBodyWidths();
      }

      if (params.fireResizedEvent) {
        this.dispatchColumnResizedEvent(changedColumns, true, source, flexingColumns);
      }

      return flexingColumns;
    } // called from api

  }, {
    key: "sizeColumnsToFit",
    value: function sizeColumnsToFit(gridWidth) {
      var _this46 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "sizeColumnsToFit";
      var silent = arguments.length > 2 ? arguments[2] : undefined;
      var params = arguments.length > 3 ? arguments[3] : undefined;

      var _c, _d, _e, _f, _g;

      if (this.shouldQueueResizeOperations) {
        this.resizeOperationQueue.push(function () {
          return _this46.sizeColumnsToFit(gridWidth, source, silent, params);
        });
        return;
      }

      var limitsMap = {};

      if (params) {
        (_c = params == null ? void 0 : params.columnLimits) == null ? void 0 : _c.forEach(function (_a) {
          var _b = _a,
              key = _b.key,
              dimensions = __objRest(_b, ["key"]);

          limitsMap[typeof key === "string" ? key : key.getColId()] = dimensions;
        });
      }

      var allDisplayedColumns = this.getAllDisplayedColumns();
      var doColumnsAlreadyFit = gridWidth === this.getWidthOfColsInList(allDisplayedColumns);

      if (gridWidth <= 0 || !allDisplayedColumns.length || doColumnsAlreadyFit) {
        return;
      }

      var colsToSpread = [];
      var colsToNotSpread = [];
      allDisplayedColumns.forEach(function (column) {
        if (column.getColDef().suppressSizeToFit === true) {
          colsToNotSpread.push(column);
        } else {
          colsToSpread.push(column);
        }
      });
      var colsToDispatchEventFor = colsToSpread.slice(0);
      var finishedResizing = false;

      var moveToNotSpread = function moveToNotSpread(column) {
        _removeFromArray(colsToSpread, column);

        colsToNotSpread.push(column);
      };

      colsToSpread.forEach(function (column) {
        var _a, _b;

        column.resetActualWidth(source);
        var widthOverride = limitsMap == null ? void 0 : limitsMap[column.getId()];
        var minOverride = (_a = widthOverride == null ? void 0 : widthOverride.minWidth) != null ? _a : params == null ? void 0 : params.defaultMinWidth;
        var maxOverride = (_b = widthOverride == null ? void 0 : widthOverride.maxWidth) != null ? _b : params == null ? void 0 : params.defaultMaxWidth;
        var colWidth = column.getActualWidth();

        if (typeof minOverride === "number" && colWidth < minOverride) {
          column.setActualWidth(minOverride, source, true);
        } else if (typeof maxOverride === "number" && colWidth > maxOverride) {
          column.setActualWidth(maxOverride, source, true);
        }
      });

      while (!finishedResizing) {
        finishedResizing = true;
        var availablePixels = gridWidth - this.getWidthOfColsInList(colsToNotSpread);

        if (availablePixels <= 0) {
          colsToSpread.forEach(function (column) {
            var _a, _b;

            var widthOverride = (_b = (_a = limitsMap == null ? void 0 : limitsMap[column.getId()]) == null ? void 0 : _a.minWidth) != null ? _b : params == null ? void 0 : params.defaultMinWidth;

            if (typeof widthOverride === "number") {
              column.setActualWidth(widthOverride, source, true);
              return;
            }

            column.setMinimum(source);
          });
        } else {
          var scale = availablePixels / this.getWidthOfColsInList(colsToSpread);
          var pixelsForLastCol = availablePixels;

          for (var i = colsToSpread.length - 1; i >= 0; i--) {
            var column = colsToSpread[i];
            var widthOverride = limitsMap == null ? void 0 : limitsMap[column.getId()];
            var minOverride = (_d = widthOverride == null ? void 0 : widthOverride.minWidth) != null ? _d : params == null ? void 0 : params.defaultMinWidth;
            var maxOverride = (_e = widthOverride == null ? void 0 : widthOverride.maxWidth) != null ? _e : params == null ? void 0 : params.defaultMaxWidth;
            var colMinWidth = (_f = column.getMinWidth()) != null ? _f : 0;
            var colMaxWidth = (_g = column.getMaxWidth()) != null ? _g : Number.MAX_VALUE;
            var minWidth = typeof minOverride === "number" && minOverride > colMinWidth ? minOverride : column.getMinWidth();
            var maxWidth = typeof maxOverride === "number" && maxOverride < colMaxWidth ? maxOverride : column.getMaxWidth();
            var newWidth = Math.round(column.getActualWidth() * scale);

            if (_exists(minWidth) && newWidth < minWidth) {
              newWidth = minWidth;
              moveToNotSpread(column);
              finishedResizing = false;
            } else if (_exists(maxWidth) && newWidth > maxWidth) {
              newWidth = maxWidth;
              moveToNotSpread(column);
              finishedResizing = false;
            } else if (i === 0) {
              newWidth = pixelsForLastCol;
            }

            column.setActualWidth(newWidth, source, true);
            pixelsForLastCol -= newWidth;
          }
        }
      }

      colsToDispatchEventFor.forEach(function (col) {
        col.fireColumnWidthChangedEvent(source);
      });
      this.setLeftValues(source);
      this.updateBodyWidths();

      if (silent) {
        return;
      }

      this.dispatchColumnResizedEvent(colsToDispatchEventFor, true, source);
    }
  }, {
    key: "buildDisplayedTrees",
    value: function buildDisplayedTrees(visibleColumns) {
      var leftVisibleColumns = [];
      var rightVisibleColumns = [];
      var centerVisibleColumns = [];
      visibleColumns.forEach(function (column) {
        switch (column.getPinned()) {
          case "left":
            leftVisibleColumns.push(column);
            break;

          case "right":
            rightVisibleColumns.push(column);
            break;

          default:
            centerVisibleColumns.push(column);
            break;
        }
      });
      var groupInstanceIdCreator = new _GroupInstanceIdCreator();
      this.displayedTreeLeft = this.displayedGroupCreator.createDisplayedGroups(leftVisibleColumns, groupInstanceIdCreator, "left", this.displayedTreeLeft);
      this.displayedTreeRight = this.displayedGroupCreator.createDisplayedGroups(rightVisibleColumns, groupInstanceIdCreator, "right", this.displayedTreeRight);
      this.displayedTreeCentre = this.displayedGroupCreator.createDisplayedGroups(centerVisibleColumns, groupInstanceIdCreator, null, this.displayedTreeCentre);
      this.updateDisplayedMap();
    }
  }, {
    key: "updateDisplayedMap",
    value: function updateDisplayedMap() {
      var _this47 = this;

      this.displayedColumnsAndGroupsMap = {};

      var func = function func(child) {
        _this47.displayedColumnsAndGroupsMap[child.getUniqueId()] = child;
      };

      depthFirstAllColumnTreeSearch(this.displayedTreeCentre, false, func);
      depthFirstAllColumnTreeSearch(this.displayedTreeLeft, false, func);
      depthFirstAllColumnTreeSearch(this.displayedTreeRight, false, func);
    }
  }, {
    key: "isDisplayed",
    value: function isDisplayed(item) {
      var fromMap = this.displayedColumnsAndGroupsMap[item.getUniqueId()];
      return fromMap === item;
    }
  }, {
    key: "updateOpenClosedVisibilityInColumnGroups",
    value: function updateOpenClosedVisibilityInColumnGroups() {
      var allColumnGroups = this.getAllDisplayedTrees();
      depthFirstAllColumnTreeSearch(allColumnGroups, false, function (child) {
        if (child instanceof _ColumnGroup2) {
          child.calculateDisplayedColumns();
        }
      });
    }
  }, {
    key: "getGroupAutoColumns",
    value: function getGroupAutoColumns() {
      return this.groupAutoColumns;
    }
    /**
     * Creates new auto group columns if required
     * @returns whether auto cols have changed
     */

  }, {
    key: "createGroupAutoColumnsIfNeeded",
    value: function createGroupAutoColumnsIfNeeded() {
      var forceRecreateAutoGroups = this.forceRecreateAutoGroups;
      this.forceRecreateAutoGroups = false;

      if (!this.autoGroupsNeedBuilding) {
        return false;
      }

      this.autoGroupsNeedBuilding = false;
      var groupFullWidthRow = this.gos.isGroupUseEntireRow(this.pivotMode);
      var suppressAutoColumn = this.pivotMode ? this.gos.get("pivotSuppressAutoColumn") : this.isGroupSuppressAutoColumn();
      var groupingActive = this.rowGroupColumns.length > 0 || this.gos.get("treeData");
      var needAutoColumns = groupingActive && !suppressAutoColumn && !groupFullWidthRow;

      if (needAutoColumns) {
        var newAutoGroupCols = this.autoGroupColService.createAutoGroupColumns(this.rowGroupColumns);
        var autoColsDifferent = !this.autoColsEqual(newAutoGroupCols, this.groupAutoColumns);

        if (autoColsDifferent || forceRecreateAutoGroups) {
          this.groupAutoColumns = newAutoGroupCols;
          return true;
        }
      } else {
        this.groupAutoColumns = null;
      }

      return false;
    }
  }, {
    key: "isGroupSuppressAutoColumn",
    value: function isGroupSuppressAutoColumn() {
      var groupDisplayType = this.gos.get("groupDisplayType");
      var isCustomRowGroups = groupDisplayType === "custom";

      if (isCustomRowGroups) {
        return true;
      }

      var treeDataDisplayType = this.gos.get("treeDataDisplayType");
      return treeDataDisplayType === "custom";
    }
  }, {
    key: "autoColsEqual",
    value: function autoColsEqual(colsA, colsB) {
      return _areEqual(colsA, colsB, function (a, b) {
        return a.getColId() === b.getColId();
      });
    }
  }, {
    key: "getWidthOfColsInList",
    value: function getWidthOfColsInList(columnList) {
      return columnList.reduce(function (width, col) {
        return width + col.getActualWidth();
      }, 0);
    }
  }, {
    key: "getFirstDisplayedColumn",
    value: function getFirstDisplayedColumn() {
      var isRtl = this.gos.get("enableRtl");
      var queryOrder = ["getDisplayedLeftColumns", "getDisplayedCenterColumns", "getDisplayedRightColumns"];

      if (isRtl) {
        queryOrder.reverse();
      }

      for (var i = 0; i < queryOrder.length; i++) {
        var container = this[queryOrder[i]]();

        if (container.length) {
          return isRtl ? _last(container) : container[0];
        }
      }

      return null;
    }
  }, {
    key: "setColumnHeaderHeight",
    value: function setColumnHeaderHeight(col, height) {
      var changed = col.setAutoHeaderHeight(height);

      if (changed) {
        var event = {
          type: _Events.EVENT_COLUMN_HEADER_HEIGHT_CHANGED,
          column: col,
          columns: [col],
          source: "autosizeColumnHeaderHeight"
        };
        this.eventService.dispatchEvent(event);
      }
    }
  }, {
    key: "getColumnGroupHeaderRowHeight",
    value: function getColumnGroupHeaderRowHeight() {
      if (this.isPivotMode()) {
        return this.getPivotGroupHeaderHeight();
      }

      return this.getGroupHeaderHeight();
    }
  }, {
    key: "getColumnHeaderRowHeight",
    value: function getColumnHeaderRowHeight() {
      var defaultHeight = this.isPivotMode() ? this.getPivotHeaderHeight() : this.getHeaderHeight();
      var displayedHeights = this.getAllDisplayedColumns().filter(function (col) {
        return col.isAutoHeaderHeight();
      }).map(function (col) {
        return col.getAutoHeaderHeight() || 0;
      });
      return Math.max.apply(Math, [defaultHeight].concat(_toConsumableArray(displayedHeights)));
    }
  }, {
    key: "getHeaderHeight",
    value: function getHeaderHeight() {
      var _a;

      return (_a = this.gos.get("headerHeight")) != null ? _a : this.environment.getFromTheme(25, "headerHeight");
    }
  }, {
    key: "getFloatingFiltersHeight",
    value: function getFloatingFiltersHeight() {
      var _a;

      return (_a = this.gos.get("floatingFiltersHeight")) != null ? _a : this.getHeaderHeight();
    }
  }, {
    key: "getGroupHeaderHeight",
    value: function getGroupHeaderHeight() {
      var _a;

      return (_a = this.gos.get("groupHeaderHeight")) != null ? _a : this.getHeaderHeight();
    }
  }, {
    key: "getPivotHeaderHeight",
    value: function getPivotHeaderHeight() {
      var _a;

      return (_a = this.gos.get("pivotHeaderHeight")) != null ? _a : this.getHeaderHeight();
    }
  }, {
    key: "getPivotGroupHeaderHeight",
    value: function getPivotGroupHeaderHeight() {
      var _a;

      return (_a = this.gos.get("pivotGroupHeaderHeight")) != null ? _a : this.getGroupHeaderHeight();
    }
  }, {
    key: "queueResizeOperations",
    value: function queueResizeOperations() {
      this.shouldQueueResizeOperations = true;
    }
  }, {
    key: "processResizeOperations",
    value: function processResizeOperations() {
      this.shouldQueueResizeOperations = false;
      this.resizeOperationQueue.forEach(function (resizeOperation) {
        return resizeOperation();
      });
      this.resizeOperationQueue = [];
    }
  }, {
    key: "resetColumnDefIntoColumn",
    value: function resetColumnDefIntoColumn(column, source) {
      var userColDef = column.getUserProvidedColDef();

      if (!userColDef) {
        return false;
      }

      var newColDef = this.columnFactory.addColumnDefaultAndTypes(userColDef, column.getColId());
      column.setColDef(newColDef, userColDef, source);
      return true;
    }
  }, {
    key: "isColumnGroupingLocked",
    value: function isColumnGroupingLocked(column) {
      var groupLockGroupColumns = this.gos.get("groupLockGroupColumns");

      if (!column.isRowGroupActive() || groupLockGroupColumns === 0) {
        return false;
      }

      if (groupLockGroupColumns === -1) {
        return true;
      }

      var colIndex = this.rowGroupColumns.findIndex(function (groupCol) {
        return groupCol.getColId() === column.getColId();
      });
      return groupLockGroupColumns > colIndex;
    }
  }, {
    key: "generateColumnStateForRowGroupAndPivotIndexes",
    value: function generateColumnStateForRowGroupAndPivotIndexes(updatedRowGroupColumnState, updatedPivotColumnState) {
      var _this48 = this;

      var existingColumnStateUpdates = {};

      var orderColumns = function orderColumns(updatedColumnState, colList, enableProp, initialEnableProp, indexProp, initialIndexProp) {
        if (!colList.length || !_this48.primaryColumns) {
          return [];
        }

        var updatedColIdArray = Object.keys(updatedColumnState);
        var updatedColIds = new Set(updatedColIdArray);
        var newColIds = new Set(updatedColIdArray);
        var allColIds = new Set(colList.map(function (column) {
          var colId = column.getColId();
          newColIds.delete(colId);
          return colId;
        }).concat(updatedColIdArray));
        var colIdsInOriginalOrder = [];
        var originalOrderMap = {};
        var orderIndex = 0;

        for (var i = 0; i < _this48.primaryColumns.length; i++) {
          var colId = _this48.primaryColumns[i].getColId();

          if (allColIds.has(colId)) {
            colIdsInOriginalOrder.push(colId);
            originalOrderMap[colId] = orderIndex++;
          }
        }

        var index = 1e3;
        var hasAddedNewCols = false;
        var lastIndex = 0;

        var processPrecedingNewCols = function processPrecedingNewCols(colId) {
          var originalOrderIndex = originalOrderMap[colId];

          for (var _i4 = lastIndex; _i4 < originalOrderIndex; _i4++) {
            var newColId = colIdsInOriginalOrder[_i4];

            if (newColIds.has(newColId)) {
              updatedColumnState[newColId][indexProp] = index++;
              newColIds.delete(newColId);
            }
          }

          lastIndex = originalOrderIndex;
        };

        colList.forEach(function (column) {
          var colId = column.getColId();

          if (updatedColIds.has(colId)) {
            processPrecedingNewCols(colId);
            updatedColumnState[colId][indexProp] = index++;
          } else {
            var colDef = column.getColDef();
            var missingIndex = colDef[indexProp] === null || colDef[indexProp] === void 0 && colDef[initialIndexProp] == null;

            if (missingIndex) {
              if (!hasAddedNewCols) {
                var propEnabled = colDef[enableProp] || colDef[enableProp] === void 0 && colDef[initialEnableProp];

                if (propEnabled) {
                  processPrecedingNewCols(colId);
                } else {
                  newColIds.forEach(function (newColId) {
                    updatedColumnState[newColId][indexProp] = index + originalOrderMap[newColId];
                  });
                  index += colIdsInOriginalOrder.length;
                  hasAddedNewCols = true;
                }
              }

              if (!existingColumnStateUpdates[colId]) {
                existingColumnStateUpdates[colId] = {
                  colId: colId
                };
              }

              existingColumnStateUpdates[colId][indexProp] = index++;
            }
          }
        });
      };

      orderColumns(updatedRowGroupColumnState, this.rowGroupColumns, "rowGroup", "initialRowGroup", "rowGroupIndex", "initialRowGroupIndex");
      orderColumns(updatedPivotColumnState, this.pivotColumns, "pivot", "initialPivot", "pivotIndex", "initialPivotIndex");
      return Object.values(existingColumnStateUpdates);
    }
  }, {
    key: "onColumnsReady",
    value: function onColumnsReady() {
      var _this49 = this;

      var autoSizeStrategy = this.gos.get("autoSizeStrategy");

      if (!autoSizeStrategy) {
        return;
      }

      var type = autoSizeStrategy.type;
      setTimeout(function () {
        if (type === "fitGridWidth") {
          var propColumnLimits = autoSizeStrategy.columnLimits,
              defaultMinWidth = autoSizeStrategy.defaultMinWidth,
              defaultMaxWidth = autoSizeStrategy.defaultMaxWidth;
          var columnLimits = propColumnLimits == null ? void 0 : propColumnLimits.map(function (_ref11) {
            var key = _ref11.colId,
                minWidth = _ref11.minWidth,
                maxWidth = _ref11.maxWidth;
            return {
              key: key,
              minWidth: minWidth,
              maxWidth: maxWidth
            };
          });

          _this49.ctrlsService.getGridBodyCtrl().sizeColumnsToFit({
            defaultMinWidth: defaultMinWidth,
            defaultMaxWidth: defaultMaxWidth,
            columnLimits: columnLimits
          });
        } else if (type === "fitProvidedWidth") {
          _this49.sizeColumnsToFit(autoSizeStrategy.width, "sizeColumnsToFit");
        }
      });
    }
  }, {
    key: "onFirstDataRendered",
    value: function onFirstDataRendered() {
      var _this50 = this;

      var autoSizeStrategy = this.gos.get("autoSizeStrategy");

      if ((autoSizeStrategy == null ? void 0 : autoSizeStrategy.type) !== "fitCellContents") {
        return;
      }

      var columns = autoSizeStrategy.colIds,
          skipHeader = autoSizeStrategy.skipHeader;
      setTimeout(function () {
        if (columns) {
          _this50.autoSizeColumns({
            columns: columns,
            skipHeader: skipHeader,
            source: "autosizeColumns"
          });
        } else {
          _this50.autoSizeAllColumns("autosizeColumns", skipHeader);
        }
      });
    }
  }]);

  return _ColumnModel;
}(_BeanStub2);

__decorateClass([_Autowired("expressionService")], _ColumnModel.prototype, "expressionService", 2);

__decorateClass([_Autowired("columnFactory")], _ColumnModel.prototype, "columnFactory", 2);

__decorateClass([_Autowired("displayedGroupCreator")], _ColumnModel.prototype, "displayedGroupCreator", 2);

__decorateClass([_Autowired("ctrlsService")], _ColumnModel.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("autoWidthCalculator")], _ColumnModel.prototype, "autoWidthCalculator", 2);

__decorateClass([_Autowired("columnAnimationService")], _ColumnModel.prototype, "columnAnimationService", 2);

__decorateClass([_Autowired("autoGroupColService")], _ColumnModel.prototype, "autoGroupColService", 2);

__decorateClass([_Autowired("valueCache")], _ColumnModel.prototype, "valueCache", 2);

__decorateClass([_Autowired("animationFrameService")], _ColumnModel.prototype, "animationFrameService", 2);

__decorateClass([_Autowired("sortController")], _ColumnModel.prototype, "sortController", 2);

__decorateClass([_Autowired("columnDefFactory")], _ColumnModel.prototype, "columnDefFactory", 2);

__decorateClass([_Optional("aggFuncService")], _ColumnModel.prototype, "aggFuncService", 2);

__decorateClass([_PostConstruct], _ColumnModel.prototype, "init", 1);

__decorateClass([_PreDestroy], _ColumnModel.prototype, "destroyColumns", 1);

__decorateClass([__decorateParam(0, _Qualifier("loggerFactory"))], _ColumnModel.prototype, "setBeans", 1);

_ColumnModel = __decorateClass([_Bean("columnModel")], _ColumnModel);

function convertSourceType(source) {
  return source === "gridOptionsUpdated" ? "gridOptionsChanged" : source;
}

function depthFirstAllColumnTreeSearch(tree, useDisplayedChildren, callback) {
  if (!tree) {
    return;
  }

  for (var i = 0; i < tree.length; i++) {
    var child = tree[i];

    if (child instanceof _ColumnGroup2) {
      var childTree = useDisplayedChildren ? child.getDisplayedChildren() : child.getChildren();
      depthFirstAllColumnTreeSearch(childTree, useDisplayedChildren, callback);
    }

    callback(child);
  }
} // community-modules/core/src/columns/displayedGroupCreator.ts


var _DisplayedGroupCreator =
/*#__PURE__*/
function (_BeanStub6) {
  "use strict";

  _inherits(_DisplayedGroupCreator, _BeanStub6);

  function _DisplayedGroupCreator() {
    _classCallCheck(this, _DisplayedGroupCreator);

    return _possibleConstructorReturn(this, _getPrototypeOf(_DisplayedGroupCreator).apply(this, arguments));
  }

  _createClass(_DisplayedGroupCreator, [{
    key: "createDisplayedGroups",
    value: function createDisplayedGroups(sortedVisibleColumns, groupInstanceIdCreator, pinned, oldDisplayedGroups) {
      var _this51 = this;

      var oldColumnsMapped = this.mapOldGroupsById(oldDisplayedGroups);
      var topLevelResultCols = [];
      var groupsOrColsAtCurrentLevel = sortedVisibleColumns;

      var _loop3 = function _loop3() {
        var currentlyIterating = groupsOrColsAtCurrentLevel;
        groupsOrColsAtCurrentLevel = [];
        var lastGroupedColIdx = 0;

        var createGroupToIndex = function createGroupToIndex(to) {
          var from = lastGroupedColIdx;
          lastGroupedColIdx = to;
          var previousNode = currentlyIterating[from];
          var previousNodeProvided = previousNode instanceof _ColumnGroup2 ? previousNode.getProvidedColumnGroup() : previousNode;
          var previousNodeParent = previousNodeProvided.getOriginalParent();

          if (previousNodeParent == null) {
            for (var i = from; i < to; i++) {
              topLevelResultCols.push(currentlyIterating[i]);
            }

            return;
          }

          var newGroup = _this51.createColumnGroup(previousNodeParent, groupInstanceIdCreator, oldColumnsMapped, pinned);

          for (var _i5 = from; _i5 < to; _i5++) {
            newGroup.addChild(currentlyIterating[_i5]);
          }

          groupsOrColsAtCurrentLevel.push(newGroup);
        };

        for (var i = 1; i < currentlyIterating.length; i++) {
          var thisNode = currentlyIterating[i];
          var thisNodeProvided = thisNode instanceof _ColumnGroup2 ? thisNode.getProvidedColumnGroup() : thisNode;
          var thisNodeParent = thisNodeProvided.getOriginalParent();
          var previousNode = currentlyIterating[lastGroupedColIdx];
          var previousNodeProvided = previousNode instanceof _ColumnGroup2 ? previousNode.getProvidedColumnGroup() : previousNode;
          var previousNodeParent = previousNodeProvided.getOriginalParent();

          if (thisNodeParent !== previousNodeParent) {
            createGroupToIndex(i);
          }
        }

        if (lastGroupedColIdx < currentlyIterating.length) {
          createGroupToIndex(currentlyIterating.length);
        }
      };

      while (groupsOrColsAtCurrentLevel.length) {
        _loop3();
      }

      this.setupParentsIntoColumns(topLevelResultCols, null);
      return topLevelResultCols;
    }
  }, {
    key: "createColumnGroup",
    value: function createColumnGroup(providedGroup, groupInstanceIdCreator, oldColumnsMapped, pinned) {
      var groupId = providedGroup.getGroupId();
      var instanceId = groupInstanceIdCreator.getInstanceIdForKey(groupId);

      var uniqueId = _ColumnGroup2.createUniqueId(groupId, instanceId);

      var columnGroup = oldColumnsMapped[uniqueId];

      if (columnGroup && columnGroup.getProvidedColumnGroup() !== providedGroup) {
        columnGroup = null;
      }

      if (_exists(columnGroup)) {
        columnGroup.reset();
      } else {
        columnGroup = new _ColumnGroup2(providedGroup, groupId, instanceId, pinned);
        this.context.createBean(columnGroup);
      }

      return columnGroup;
    } // returns back a 2d map of ColumnGroup as follows: groupId -> instanceId -> ColumnGroup

  }, {
    key: "mapOldGroupsById",
    value: function mapOldGroupsById(displayedGroups) {
      var result = {};

      var recursive = function recursive(columnsOrGroups) {
        columnsOrGroups.forEach(function (columnOrGroup) {
          if (columnOrGroup instanceof _ColumnGroup2) {
            var columnGroup = columnOrGroup;
            result[columnOrGroup.getUniqueId()] = columnGroup;
            recursive(columnGroup.getChildren());
          }
        });
      };

      if (displayedGroups) {
        recursive(displayedGroups);
      }

      return result;
    }
  }, {
    key: "setupParentsIntoColumns",
    value: function setupParentsIntoColumns(columnsOrGroups, parent) {
      var _this52 = this;

      columnsOrGroups.forEach(function (columnsOrGroup) {
        columnsOrGroup.setParent(parent);

        if (columnsOrGroup instanceof _ColumnGroup2) {
          var columnGroup = columnsOrGroup;

          _this52.setupParentsIntoColumns(columnGroup.getChildren(), columnGroup);
        }
      });
    }
  }]);

  return _DisplayedGroupCreator;
}(_BeanStub2);

_DisplayedGroupCreator = __decorateClass([_Bean("displayedGroupCreator")], _DisplayedGroupCreator); // community-modules/core/src/propertyKeys.ts

var INITIAL_GRID_OPTION_KEYS = {
  enableBrowserTooltips: true,
  tooltipTrigger: true,
  tooltipMouseTrack: true,
  tooltipShowMode: true,
  tooltipInteraction: true,
  defaultColGroupDef: true,
  suppressAutoSize: true,
  skipHeaderOnAutoSize: true,
  autoSizeStrategy: true,
  components: true,
  stopEditingWhenCellsLoseFocus: true,
  undoRedoCellEditing: true,
  undoRedoCellEditingLimit: true,
  excelStyles: true,
  cacheQuickFilter: true,
  excludeHiddenColumnsFromQuickFilter: true,
  advancedFilterModel: true,
  customChartThemes: true,
  chartThemeOverrides: true,
  enableChartToolPanelsButton: true,
  suppressChartToolPanelsButton: true,
  chartToolPanelsDef: true,
  loadingCellRendererSelector: true,
  localeText: true,
  keepDetailRows: true,
  keepDetailRowsCount: true,
  detailRowHeight: true,
  detailRowAutoHeight: true,
  tabIndex: true,
  valueCache: true,
  valueCacheNeverExpires: true,
  enableCellExpressions: true,
  suppressParentsInRowNodes: true,
  suppressTouch: true,
  suppressAsyncEvents: true,
  suppressBrowserResizeObserver: true,
  suppressPropertyNamesCheck: true,
  debug: true,
  loadingOverlayComponent: true,
  suppressLoadingOverlay: true,
  noRowsOverlayComponent: true,
  paginationPageSizeSelector: true,
  paginateChildRows: true,
  pivotPanelShow: true,
  pivotSuppressAutoColumn: true,
  suppressExpandablePivotGroups: true,
  aggFuncs: true,
  suppressAggFuncInHeader: true,
  suppressAggAtRootLevel: true,
  removePivotHeaderRowWhenSingleValueColumn: true,
  allowShowChangeAfterFilter: true,
  ensureDomOrder: true,
  enableRtl: true,
  suppressColumnVirtualisation: true,
  suppressMaxRenderedRowRestriction: true,
  suppressRowVirtualisation: true,
  rowDragText: true,
  suppressGroupMaintainValueType: true,
  groupLockGroupColumns: true,
  rowGroupPanelSuppressSort: true,
  suppressGroupRowsSticky: true,
  rowModelType: true,
  cacheOverflowSize: true,
  infiniteInitialRowCount: true,
  serverSideInitialRowCount: true,
  suppressServerSideInfiniteScroll: true,
  maxBlocksInCache: true,
  maxConcurrentDatasourceRequests: true,
  blockLoadDebounceMillis: true,
  serverSideOnlyRefreshFilteredGroups: true,
  serverSidePivotResultFieldSeparator: true,
  viewportRowModelPageSize: true,
  viewportRowModelBufferSize: true,
  debounceVerticalScrollbar: true,
  suppressAnimationFrame: true,
  suppressPreventDefaultOnMouseWheel: true,
  scrollbarWidth: true,
  icons: true,
  suppressRowTransform: true,
  gridId: true,
  functionsPassive: true,
  enableGroupEdit: true,
  initialState: true,
  processUnpinnedColumns: true,
  createChartContainer: true,
  getLocaleText: true,
  getRowId: true,
  reactiveCustomComponents: true,
  columnMenu: true
};

var _PropertyKeys = function _PropertyKeys() {
  "use strict";

  _classCallCheck(this, _PropertyKeys);
};

_PropertyKeys.STRING_PROPERTIES = ["rowSelection", "overlayLoadingTemplate", "overlayNoRowsTemplate", "gridId", "quickFilterText", "rowModelType", "editType", "domLayout", "clipboardDelimiter", "rowGroupPanelShow", "multiSortKey", "pivotColumnGroupTotals", "pivotRowTotals", "pivotPanelShow", "fillHandleDirection", "groupDisplayType", "treeDataDisplayType", "colResizeDefault", "tooltipTrigger", "serverSidePivotResultFieldSeparator", "columnMenu", "tooltipShowMode", "grandTotalRow"];
_PropertyKeys.OBJECT_PROPERTIES = ["components", "rowStyle", "context", "autoGroupColumnDef", "localeText", "icons", "datasource", "serverSideDatasource", "viewportDatasource", "groupRowRendererParams", "aggFuncs", "fullWidthCellRendererParams", "defaultColGroupDef", "defaultColDef", "defaultCsvExportParams", "defaultExcelExportParams", "columnTypes", "rowClassRules", "detailCellRendererParams", "loadingCellRendererParams", "loadingOverlayComponentParams", "noRowsOverlayComponentParams", "popupParent", "statusBar", "sideBar", "chartThemeOverrides", "customChartThemes", "chartToolPanelsDef", "dataTypeDefinitions", "advancedFilterModel", "advancedFilterParent", "advancedFilterBuilderParams", "initialState", "autoSizeStrategy"];
_PropertyKeys.ARRAY_PROPERTIES = ["sortingOrder", "alignedGrids", "rowData", "columnDefs", "excelStyles", "pinnedTopRowData", "pinnedBottomRowData", "chartThemes", "rowClass", "paginationPageSizeSelector"]; // These properties are coerced at runtime, do not do union types

_PropertyKeys.NUMBER_PROPERTIES = ["rowHeight", "detailRowHeight", "rowBuffer", "headerHeight", "groupHeaderHeight", "groupLockGroupColumns", "floatingFiltersHeight", "pivotHeaderHeight", "pivotGroupHeaderHeight", "groupDefaultExpanded", "pivotDefaultExpanded", "viewportRowModelPageSize", "viewportRowModelBufferSize", "autoSizePadding", "maxBlocksInCache", "maxConcurrentDatasourceRequests", "tooltipShowDelay", "tooltipHideDelay", "cacheOverflowSize", "paginationPageSize", "cacheBlockSize", "infiniteInitialRowCount", "serverSideInitialRowCount", "scrollbarWidth", "asyncTransactionWaitMillis", "blockLoadDebounceMillis", "keepDetailRowsCount", "undoRedoCellEditingLimit", "cellFlashDelay", "cellFadeDelay", "cellFlashDuration", "cellFadeDuration", "tabIndex", "pivotMaxGeneratedColumns"]; // These properties are coerced at runtime, do not do union types

_PropertyKeys.BOOLEAN_PROPERTIES = ["suppressMakeColumnVisibleAfterUnGroup", "suppressRowClickSelection", "suppressCellFocus", "suppressHeaderFocus", "suppressHorizontalScroll", "groupSelectsChildren", "alwaysShowHorizontalScroll", "alwaysShowVerticalScroll", "debug", "enableBrowserTooltips", "enableCellExpressions", "groupIncludeTotalFooter", "groupSuppressBlankHeader", "suppressMenuHide", "suppressRowDeselection", "unSortIcon", "suppressMultiSort", "alwaysMultiSort", "singleClickEdit", "suppressLoadingOverlay", "suppressNoRowsOverlay", "suppressAutoSize", "skipHeaderOnAutoSize", "suppressParentsInRowNodes", "suppressColumnMoveAnimation", "suppressMovableColumns", "suppressFieldDotNotation", "enableRangeSelection", "enableRangeHandle", "enableFillHandle", "suppressClearOnFillReduction", "deltaSort", "suppressTouch", "suppressAsyncEvents", "allowContextMenuWithControlKey", "suppressContextMenu", "enableCellChangeFlash", "suppressDragLeaveHidesColumns", "suppressRowGroupHidesColumns", "suppressMiddleClickScrolls", "suppressPreventDefaultOnMouseWheel", "suppressCopyRowsToClipboard", "copyHeadersToClipboard", "copyGroupHeadersToClipboard", "pivotMode", "suppressAggFuncInHeader", "suppressColumnVirtualisation", "alwaysAggregateAtRootLevel", "suppressAggAtRootLevel", "suppressFocusAfterRefresh", "functionsPassive", "functionsReadOnly", "animateRows", "groupSelectsFiltered", "groupRemoveSingleChildren", "groupRemoveLowestSingleChildren", "enableRtl", "suppressClickEdit", "rowDragEntireRow", "rowDragManaged", "suppressRowDrag", "suppressMoveWhenRowDragging", "rowDragMultiRow", "enableGroupEdit", "embedFullWidthRows", "suppressPaginationPanel", "groupHideOpenParents", "groupAllowUnbalanced", "pagination", "paginationAutoPageSize", "suppressScrollOnNewData", "suppressScrollWhenPopupsAreOpen", "purgeClosedRowNodes", "cacheQuickFilter", "includeHiddenColumnsInQuickFilter", "excludeHiddenColumnsFromQuickFilter", "ensureDomOrder", "accentedSort", "suppressChangeDetection", "valueCache", "valueCacheNeverExpires", "aggregateOnlyChangedColumns", "suppressAnimationFrame", "suppressExcelExport", "suppressCsvExport", "includeHiddenColumnsInAdvancedFilter", "suppressMultiRangeSelection", "enterMovesDown", "enterMovesDownAfterEdit", "enterNavigatesVerticallyAfterEdit", "enterNavigatesVertically", "suppressPropertyNamesCheck", "rowMultiSelectWithClick", "suppressRowHoverHighlight", "suppressRowTransform", "suppressClipboardPaste", "suppressLastEmptyLineOnPaste", "enableCharts", "enableChartToolPanelsButton", "suppressChartToolPanelsButton", "suppressMaintainUnsortedOrder", "enableCellTextSelection", "suppressBrowserResizeObserver", "suppressMaxRenderedRowRestriction", "excludeChildrenWhenTreeDataFiltering", "tooltipMouseTrack", "tooltipInteraction", "keepDetailRows", "paginateChildRows", "preventDefaultOnContextMenu", "undoRedoCellEditing", "allowDragFromColumnsToolPanel", "pivotSuppressAutoColumn", "suppressExpandablePivotGroups", "debounceVerticalScrollbar", "detailRowAutoHeight", "serverSideFilterAllLevels", "serverSideSortAllLevels", "serverSideEnableClientSideSort", "serverSideOnlyRefreshFilteredGroups", "serverSideSortOnServer", "serverSideFilterOnServer", "suppressAggFilteredOnly", "showOpenedGroup", "suppressClipboardApi", "suppressModelUpdateAfterUpdateTransaction", "stopEditingWhenCellsLoseFocus", "maintainColumnOrder", "groupMaintainOrder", "columnHoverHighlight", "readOnlyEdit", "suppressRowVirtualisation", "enableCellEditingOnBackspace", "resetRowDataOnUpdate", "removePivotHeaderRowWhenSingleValueColumn", "suppressCopySingleCellRanges", "suppressGroupRowsSticky", "suppressCutToClipboard", "suppressServerSideInfiniteScroll", "rowGroupPanelSuppressSort", "allowShowChangeAfterFilter", "enableAdvancedFilter", "masterDetail", "treeData", "suppressGroupMaintainValueType", "reactiveCustomComponents", "applyQuickFilterBeforePivotOrAgg", "suppressServerSideFullWidthLoadingRow", "suppressAdvancedFilterEval"]; // If property does not fit above, i.e union that should not be coerced.

_PropertyKeys.OTHER_PROPERTIES = ["suppressStickyTotalRow"];
/** You do not need to include event callbacks in this list, as they are generated automatically. */

_PropertyKeys.FUNCTIONAL_PROPERTIES = ["doesExternalFilterPass", "processPivotResultColDef", "processPivotResultColGroupDef", "getBusinessKeyForNode", "isRowSelectable", "rowDragText", "groupRowRenderer", "fullWidthCellRenderer", "loadingCellRenderer", "loadingOverlayComponent", "noRowsOverlayComponent", "detailCellRenderer", "quickFilterParser", "quickFilterMatcher"];
/** These callbacks extend AgGridCommon interface */

_PropertyKeys.CALLBACK_PROPERTIES = ["getLocaleText", "isExternalFilterPresent", "getRowHeight", "getRowClass", "getRowStyle", "getContextMenuItems", "getMainMenuItems", "processRowPostCreate", "processCellForClipboard", "getGroupRowAgg", "isFullWidthRow", "sendToClipboard", "navigateToNextHeader", "tabToNextHeader", "navigateToNextCell", "tabToNextCell", "processCellFromClipboard", "getDocument", "postProcessPopup", "getChildCount", "getDataPath", "isRowMaster", "postSortRows", "processHeaderForClipboard", "processUnpinnedColumns", "processGroupHeaderForClipboard", "paginationNumberFormatter", "processDataFromClipboard", "getServerSideGroupKey", "isServerSideGroup", "createChartContainer", "getChartToolbarItems", "fillOperation", "isApplyServerSideTransaction", "getServerSideGroupLevelParams", "isServerSideGroupOpenByDefault", "isGroupOpenByDefault", "initialGroupOrderComparator", "groupIncludeFooter", "loadingCellRendererSelector", "getRowId", "groupAggFiltering", "chartMenuItems", "groupTotalRow"];
_PropertyKeys.FUNCTION_PROPERTIES = [].concat(_toConsumableArray(_PropertyKeys.FUNCTIONAL_PROPERTIES), _toConsumableArray(_PropertyKeys.CALLBACK_PROPERTIES));
_PropertyKeys.ALL_PROPERTIES = [].concat(_toConsumableArray(_PropertyKeys.ARRAY_PROPERTIES), _toConsumableArray(_PropertyKeys.OBJECT_PROPERTIES), _toConsumableArray(_PropertyKeys.STRING_PROPERTIES), _toConsumableArray(_PropertyKeys.NUMBER_PROPERTIES), _toConsumableArray(_PropertyKeys.FUNCTION_PROPERTIES), _toConsumableArray(_PropertyKeys.BOOLEAN_PROPERTIES), _toConsumableArray(_PropertyKeys.OTHER_PROPERTIES));
var _PropertyKeys2 = _PropertyKeys; // community-modules/core/src/components/componentUtil.ts

var _ComponentUtil =
/*#__PURE__*/
function () {
  "use strict";

  function _ComponentUtil() {
    _classCallCheck(this, _ComponentUtil);
  }

  _createClass(_ComponentUtil, null, [{
    key: "getCallbackForEvent",
    value: function getCallbackForEvent(eventName) {
      if (!eventName || eventName.length < 2) {
        return eventName;
      }

      return "on" + eventName[0].toUpperCase() + eventName.substring(1);
    }
  }, {
    key: "getGridOptionKeys",
    value: function getGridOptionKeys() {
      return this.ALL_PROPERTIES_AND_CALLBACKS;
    }
    /** Combines component props / attributes with the provided gridOptions returning a new combined gridOptions object */

  }, {
    key: "combineAttributesAndGridOptions",
    value: function combineAttributesAndGridOptions(gridOptions, component) {
      if (typeof gridOptions !== "object") {
        gridOptions = {};
      }

      var mergedOptions = __spreadValues({}, gridOptions);

      var keys2 = _ComponentUtil.getGridOptionKeys();

      keys2.forEach(function (key) {
        var value = component[key];

        if (typeof value !== "undefined" && value !== _ComponentUtil.VUE_OMITTED_PROPERTY) {
          mergedOptions[key] = value;
        }
      });
      return mergedOptions;
    }
  }, {
    key: "processOnChange",
    value: function processOnChange(changes, api) {
      if (!changes) {
        return;
      }

      var gridChanges = {};
      var hasChanges = false;
      Object.keys(changes).filter(function (key) {
        return _ComponentUtil.ALL_PROPERTIES_AND_CALLBACKS_SET.has(key);
      }).forEach(function (key) {
        gridChanges[key] = changes[key];
        hasChanges = true;
      });

      if (!hasChanges) {
        return;
      }

      api.__internalUpdateGridOptions(gridChanges);

      var event = {
        type: _Events.EVENT_COMPONENT_STATE_CHANGED
      };

      _iterateObject(gridChanges, function (key, value) {
        event[key] = value;
      });

      api.dispatchEvent(event);
    }
  }]);

  return _ComponentUtil;
}(); // all events


_ComponentUtil.EVENTS = _values(_Events);
_ComponentUtil.VUE_OMITTED_PROPERTY = "AG-VUE-OMITTED-PROPERTY"; // events that are internal to AG Grid and should not be exposed to users via documentation or generated framework components

/** Exclude the following internal events from code generation to prevent exposing these events via framework components */

_ComponentUtil.EXCLUDED_INTERNAL_EVENTS = [_Events.EVENT_SCROLLBAR_WIDTH_CHANGED, _Events.EVENT_CHECKBOX_CHANGED, _Events.EVENT_HEIGHT_SCALE_CHANGED, _Events.EVENT_BODY_HEIGHT_CHANGED, _Events.EVENT_COLUMN_CONTAINER_WIDTH_CHANGED, _Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, _Events.EVENT_SCROLL_VISIBILITY_CHANGED, _Events.EVENT_COLUMN_HOVER_CHANGED, _Events.EVENT_FLASH_CELLS, _Events.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED, _Events.EVENT_DISPLAYED_ROWS_CHANGED, _Events.EVENT_LEFT_PINNED_WIDTH_CHANGED, _Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED, _Events.EVENT_ROW_CONTAINER_HEIGHT_CHANGED, _Events.EVENT_STORE_UPDATED, _Events.EVENT_COLUMN_PANEL_ITEM_DRAG_START, _Events.EVENT_COLUMN_PANEL_ITEM_DRAG_END, _Events.EVENT_KEY_SHORTCUT_CHANGED_CELL_START, _Events.EVENT_KEY_SHORTCUT_CHANGED_CELL_END, _Events.EVENT_FULL_WIDTH_ROW_FOCUSED, _Events.EVENT_HEADER_HEIGHT_CHANGED, _Events.EVENT_COLUMN_HEADER_HEIGHT_CHANGED, _Events.EVENT_CELL_FOCUS_CLEARED, _Events.EVENT_GRID_STYLES_CHANGED, _Events.EVENT_FILTER_DESTROYED, _Events.EVENT_ROW_DATA_UPDATE_STARTED, _Events.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, _Events.EVENT_DATA_TYPES_INFERRED, _Events.EVENT_FIELD_VALUE_CHANGED, _Events.EVENT_FIELD_PICKER_VALUE_SELECTED, _Events.EVENT_SUPPRESS_COLUMN_MOVE_CHANGED, _Events.EVENT_SUPPRESS_MENU_HIDE_CHANGED, _Events.EVENT_SUPPRESS_FIELD_DOT_NOTATION, _Events.EVENT_ROW_COUNT_READY, _Events.EVENT_SIDE_BAR_UPDATED]; // events that are available for use by users of AG Grid and so should be documented

/** EVENTS that should be exposed via code generation for the framework components.  */

_ComponentUtil.PUBLIC_EVENTS = _ComponentUtil.EVENTS.filter(function (e) {
  return !_includes(_ComponentUtil.EXCLUDED_INTERNAL_EVENTS, e);
}); // onXXX methods, based on the above events

_ComponentUtil.EVENT_CALLBACKS = _ComponentUtil.EVENTS.map(function (event) {
  return _ComponentUtil.getCallbackForEvent(event);
});
_ComponentUtil.BOOLEAN_PROPERTIES = _PropertyKeys2.BOOLEAN_PROPERTIES;
_ComponentUtil.ALL_PROPERTIES = _PropertyKeys2.ALL_PROPERTIES;
_ComponentUtil.ALL_PROPERTIES_AND_CALLBACKS = [].concat(_toConsumableArray(_ComponentUtil.ALL_PROPERTIES), _toConsumableArray(_ComponentUtil.EVENT_CALLBACKS));
_ComponentUtil.ALL_PROPERTIES_AND_CALLBACKS_SET = new Set(_ComponentUtil.ALL_PROPERTIES_AND_CALLBACKS);
var _ComponentUtil2 = _ComponentUtil; // community-modules/core/src/components/agStackComponentsRegistry.ts

var _AgStackComponentsRegistry =
/*#__PURE__*/
function (_BeanStub7) {
  "use strict";

  _inherits(_AgStackComponentsRegistry, _BeanStub7);

  function _AgStackComponentsRegistry() {
    var _this53;

    _classCallCheck(this, _AgStackComponentsRegistry);

    _this53 = _possibleConstructorReturn(this, _getPrototypeOf(_AgStackComponentsRegistry).apply(this, arguments));
    _this53.componentsMappedByName = {};
    return _this53;
  }

  _createClass(_AgStackComponentsRegistry, [{
    key: "setupComponents",
    value: function setupComponents(components) {
      var _this54 = this;

      if (components) {
        components.forEach(function (componentMeta) {
          return _this54.addComponent(componentMeta);
        });
      }
    }
  }, {
    key: "addComponent",
    value: function addComponent(componentMeta) {
      var classEscaped = componentMeta.componentName.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
      var classUpperCase = classEscaped.toUpperCase();
      this.componentsMappedByName[classUpperCase] = componentMeta.componentClass;
    }
  }, {
    key: "getComponentClass",
    value: function getComponentClass(htmlTag) {
      return this.componentsMappedByName[htmlTag];
    }
  }]);

  return _AgStackComponentsRegistry;
}(_BeanStub2);

_AgStackComponentsRegistry = __decorateClass([_Bean("agStackComponentsRegistry")], _AgStackComponentsRegistry); // community-modules/core/src/utils/aria.ts

var aria_exports = {};

__export(aria_exports, {
  getAriaCheckboxStateName: function getAriaCheckboxStateName() {
    return _getAriaCheckboxStateName;
  },
  getAriaLabel: function getAriaLabel() {
    return _getAriaLabel;
  },
  getAriaLevel: function getAriaLevel() {
    return _getAriaLevel;
  },
  getAriaPosInSet: function getAriaPosInSet() {
    return _getAriaPosInSet;
  },
  getAriaSortState: function getAriaSortState() {
    return _getAriaSortState;
  },
  removeAriaExpanded: function removeAriaExpanded() {
    return _removeAriaExpanded;
  },
  removeAriaSort: function removeAriaSort() {
    return _removeAriaSort;
  },
  setAriaActiveDescendant: function setAriaActiveDescendant() {
    return _setAriaActiveDescendant;
  },
  setAriaAtomic: function setAriaAtomic() {
    return _setAriaAtomic;
  },
  setAriaChecked: function setAriaChecked() {
    return _setAriaChecked;
  },
  setAriaColCount: function setAriaColCount() {
    return _setAriaColCount;
  },
  setAriaColIndex: function setAriaColIndex() {
    return _setAriaColIndex;
  },
  setAriaColSpan: function setAriaColSpan() {
    return _setAriaColSpan;
  },
  setAriaControls: function setAriaControls() {
    return _setAriaControls;
  },
  setAriaDescribedBy: function setAriaDescribedBy() {
    return _setAriaDescribedBy;
  },
  setAriaDisabled: function setAriaDisabled() {
    return _setAriaDisabled;
  },
  setAriaExpanded: function setAriaExpanded() {
    return _setAriaExpanded;
  },
  setAriaHidden: function setAriaHidden() {
    return _setAriaHidden;
  },
  setAriaLabel: function setAriaLabel() {
    return _setAriaLabel;
  },
  setAriaLabelledBy: function setAriaLabelledBy() {
    return _setAriaLabelledBy;
  },
  setAriaLevel: function setAriaLevel() {
    return _setAriaLevel;
  },
  setAriaLive: function setAriaLive() {
    return _setAriaLive;
  },
  setAriaMultiSelectable: function setAriaMultiSelectable() {
    return _setAriaMultiSelectable;
  },
  setAriaPosInSet: function setAriaPosInSet() {
    return _setAriaPosInSet;
  },
  setAriaRelevant: function setAriaRelevant() {
    return _setAriaRelevant;
  },
  setAriaRole: function setAriaRole() {
    return _setAriaRole;
  },
  setAriaRowCount: function setAriaRowCount() {
    return _setAriaRowCount;
  },
  setAriaRowIndex: function setAriaRowIndex() {
    return _setAriaRowIndex;
  },
  setAriaSelected: function setAriaSelected() {
    return _setAriaSelected;
  },
  setAriaSetSize: function setAriaSetSize() {
    return _setAriaSetSize;
  },
  setAriaSort: function setAriaSort() {
    return _setAriaSort;
  }
});

function toggleAriaAttribute(element, attribute, value) {
  if (value == null || typeof value === "string" && value == "") {
    removeAriaAttribute(element, attribute);
  } else {
    setAriaAttribute(element, attribute, value);
  }
}

function setAriaAttribute(element, attribute, value) {
  element.setAttribute(ariaAttributeName(attribute), value.toString());
}

function removeAriaAttribute(element, attribute) {
  element.removeAttribute(ariaAttributeName(attribute));
}

function ariaAttributeName(attribute) {
  return "aria-".concat(attribute);
}

function _setAriaRole(element, role) {
  if (role) {
    element.setAttribute("role", role);
  } else {
    element.removeAttribute("role");
  }
}

function _getAriaSortState(sortDirection) {
  var sort;

  if (sortDirection === "asc") {
    sort = "ascending";
  } else if (sortDirection === "desc") {
    sort = "descending";
  } else if (sortDirection === "mixed") {
    sort = "other";
  } else {
    sort = "none";
  }

  return sort;
}

function _getAriaLevel(element) {
  return parseInt(element.getAttribute("aria-level"), 10);
}

function _getAriaPosInSet(element) {
  return parseInt(element.getAttribute("aria-posinset"), 10);
}

function _getAriaLabel(element) {
  return element.getAttribute("aria-label");
}

function _setAriaLabel(element, label) {
  toggleAriaAttribute(element, "label", label);
}

function _setAriaLabelledBy(element, labelledBy) {
  toggleAriaAttribute(element, "labelledby", labelledBy);
}

function _setAriaDescribedBy(element, describedby) {
  toggleAriaAttribute(element, "describedby", describedby);
}

function _setAriaLive(element, live) {
  toggleAriaAttribute(element, "live", live);
}

function _setAriaAtomic(element, atomic) {
  toggleAriaAttribute(element, "atomic", atomic);
}

function _setAriaRelevant(element, relevant) {
  toggleAriaAttribute(element, "relevant", relevant);
}

function _setAriaLevel(element, level) {
  toggleAriaAttribute(element, "level", level);
}

function _setAriaDisabled(element, disabled) {
  toggleAriaAttribute(element, "disabled", disabled);
}

function _setAriaHidden(element, hidden) {
  toggleAriaAttribute(element, "hidden", hidden);
}

function _setAriaActiveDescendant(element, descendantId) {
  toggleAriaAttribute(element, "activedescendant", descendantId);
}

function _setAriaExpanded(element, expanded) {
  setAriaAttribute(element, "expanded", expanded);
}

function _removeAriaExpanded(element) {
  removeAriaAttribute(element, "expanded");
}

function _setAriaSetSize(element, setsize) {
  setAriaAttribute(element, "setsize", setsize);
}

function _setAriaPosInSet(element, position) {
  setAriaAttribute(element, "posinset", position);
}

function _setAriaMultiSelectable(element, multiSelectable) {
  setAriaAttribute(element, "multiselectable", multiSelectable);
}

function _setAriaRowCount(element, rowCount) {
  setAriaAttribute(element, "rowcount", rowCount);
}

function _setAriaRowIndex(element, rowIndex) {
  setAriaAttribute(element, "rowindex", rowIndex);
}

function _setAriaColCount(element, colCount) {
  setAriaAttribute(element, "colcount", colCount);
}

function _setAriaColIndex(element, colIndex) {
  setAriaAttribute(element, "colindex", colIndex);
}

function _setAriaColSpan(element, colSpan) {
  setAriaAttribute(element, "colspan", colSpan);
}

function _setAriaSort(element, sort) {
  setAriaAttribute(element, "sort", sort);
}

function _removeAriaSort(element) {
  removeAriaAttribute(element, "sort");
}

function _setAriaSelected(element, selected) {
  toggleAriaAttribute(element, "selected", selected);
}

function _setAriaChecked(element, checked) {
  setAriaAttribute(element, "checked", checked === void 0 ? "mixed" : checked);
}

function _setAriaControls(controllerElement, controlledElement) {
  toggleAriaAttribute(controllerElement, "controls", controlledElement.id);

  _setAriaLabelledBy(controlledElement, controllerElement.id);
}

function _getAriaCheckboxStateName(translate, state) {
  return state === void 0 ? translate("ariaIndeterminate", "indeterminate") : state === true ? translate("ariaChecked", "checked") : translate("ariaUnchecked", "unchecked");
} // community-modules/core/src/utils/browser.ts


var browser_exports = {};

__export(browser_exports, {
  browserSupportsPreventScroll: function browserSupportsPreventScroll() {
    return _browserSupportsPreventScroll;
  },
  getBodyHeight: function getBodyHeight() {
    return _getBodyHeight;
  },
  getBodyWidth: function getBodyWidth() {
    return _getBodyWidth;
  },
  getMaxDivHeight: function getMaxDivHeight() {
    return _getMaxDivHeight;
  },
  getSafariVersion: function getSafariVersion() {
    return _getSafariVersion;
  },
  getScrollbarWidth: function getScrollbarWidth() {
    return _getScrollbarWidth;
  },
  getTabIndex: function getTabIndex() {
    return _getTabIndex;
  },
  isBrowserChrome: function isBrowserChrome() {
    return _isBrowserChrome;
  },
  isBrowserFirefox: function isBrowserFirefox() {
    return _isBrowserFirefox;
  },
  isBrowserSafari: function isBrowserSafari() {
    return _isBrowserSafari;
  },
  isIOSUserAgent: function isIOSUserAgent() {
    return _isIOSUserAgent;
  },
  isInvisibleScrollbar: function isInvisibleScrollbar() {
    return _isInvisibleScrollbar;
  },
  isMacOsUserAgent: function isMacOsUserAgent() {
    return _isMacOsUserAgent;
  }
});

var isSafari;
var safariVersion;
var isChrome;
var isFirefox;
var isMacOs;
var isIOS;
var invisibleScrollbar;
var browserScrollbarWidth;

function _isBrowserSafari() {
  if (isSafari === void 0) {
    isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }

  return isSafari;
}

function _getSafariVersion() {
  if (safariVersion === void 0) {
    if (_isBrowserSafari()) {
      var versionMatch = navigator.userAgent.match(/version\/(\d+)/i);

      if (versionMatch) {
        safariVersion = versionMatch[1] != null ? parseFloat(versionMatch[1]) : 0;
      }
    } else {
      safariVersion = 0;
    }
  }

  return safariVersion;
}

function _isBrowserChrome() {
  if (isChrome === void 0) {
    var win = window;
    isChrome = !!win.chrome && (!!win.chrome.webstore || !!win.chrome.runtime) || /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  }

  return isChrome;
}

function _isBrowserFirefox() {
  if (isFirefox === void 0) {
    isFirefox = /(firefox)/i.test(navigator.userAgent);
  }

  return isFirefox;
}

function _isMacOsUserAgent() {
  if (isMacOs === void 0) {
    isMacOs = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
  }

  return isMacOs;
}

function _isIOSUserAgent() {
  if (isIOS === void 0) {
    isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || // eslint-disable-next-line
    navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  }

  return isIOS;
}

function _browserSupportsPreventScroll() {
  return !_isBrowserSafari() || _getSafariVersion() >= 15;
}

function _getTabIndex(el) {
  if (!el) {
    return null;
  }

  var numberTabIndex = el.tabIndex;
  var tabIndex = el.getAttribute("tabIndex");

  if (numberTabIndex === -1 && (tabIndex === null || tabIndex === "" && !_isBrowserFirefox())) {
    return null;
  }

  return numberTabIndex.toString();
}

function _getMaxDivHeight() {
  if (!document.body) {
    return -1;
  }

  var res = 1e6;
  var testUpTo = navigator.userAgent.toLowerCase().match(/firefox/) ? 6e6 : 1e9;
  var div = document.createElement("div");
  document.body.appendChild(div);

  while (true) {
    var test = res * 2;
    div.style.height = test + "px";

    if (test > testUpTo || div.clientHeight !== test) {
      break;
    } else {
      res = test;
    }
  }

  document.body.removeChild(div);
  return res;
}

function _getBodyWidth() {
  var _a, _b, _c;

  return (_c = (_a = document.body) == null ? void 0 : _a.clientWidth) != null ? _c : window.innerHeight || ((_b = document.documentElement) == null ? void 0 : _b.clientWidth) || -1;
}

function _getBodyHeight() {
  var _a, _b, _c;

  return (_c = (_a = document.body) == null ? void 0 : _a.clientHeight) != null ? _c : window.innerHeight || ((_b = document.documentElement) == null ? void 0 : _b.clientHeight) || -1;
}

function _getScrollbarWidth() {
  if (browserScrollbarWidth == null) {
    initScrollbarWidthAndVisibility();
  }

  return browserScrollbarWidth;
}

function initScrollbarWidthAndVisibility() {
  var body = document.body;
  var div = document.createElement("div");
  div.style.width = div.style.height = "100px";
  div.style.opacity = "0";
  div.style.overflow = "scroll";
  div.style.msOverflowStyle = "scrollbar";
  div.style.position = "absolute";
  body.appendChild(div);
  var width = div.offsetWidth - div.clientWidth;

  if (width === 0 && div.clientWidth === 0) {
    width = null;
  }

  if (div.parentNode) {
    div.parentNode.removeChild(div);
  }

  if (width != null) {
    browserScrollbarWidth = width;
    invisibleScrollbar = width === 0;
  }
}

function _isInvisibleScrollbar() {
  if (invisibleScrollbar == null) {
    initScrollbarWidthAndVisibility();
  }

  return invisibleScrollbar;
} // community-modules/core/src/utils/date.ts


var date_exports = {};

__export(date_exports, {
  dateToFormattedString: function dateToFormattedString() {
    return _dateToFormattedString;
  },
  parseDateTimeFromString: function parseDateTimeFromString() {
    return _parseDateTimeFromString;
  },
  serialiseDate: function serialiseDate() {
    return _serialiseDate;
  }
}); // community-modules/core/src/utils/number.ts


var number_exports = {};

__export(number_exports, {
  cleanNumber: function cleanNumber() {
    return _cleanNumber;
  },
  createArrayOfNumbers: function createArrayOfNumbers() {
    return _createArrayOfNumbers;
  },
  decToHex: function decToHex() {
    return _decToHex;
  },
  formatNumberCommas: function formatNumberCommas() {
    return _formatNumberCommas;
  },
  formatNumberTwoDecimalPlacesAndCommas: function formatNumberTwoDecimalPlacesAndCommas() {
    return _formatNumberTwoDecimalPlacesAndCommas;
  },
  padStartWidthZeros: function padStartWidthZeros() {
    return _padStartWidthZeros;
  },
  sum: function sum() {
    return _sum;
  }
});

function _padStartWidthZeros(value, totalStringSize) {
  return value.toString().padStart(totalStringSize, "0");
}

function _createArrayOfNumbers(first, last2) {
  var result = [];

  for (var i = first; i <= last2; i++) {
    result.push(i);
  }

  return result;
}

function _cleanNumber(value) {
  if (typeof value === "string") {
    value = parseInt(value, 10);
  }

  if (typeof value === "number") {
    return Math.floor(value);
  }

  return null;
}

function _decToHex(number, bytes) {
  var hex = "";

  for (var i = 0; i < bytes; i++) {
    hex += String.fromCharCode(number & 255);
    number >>>= 8;
  }

  return hex;
}

function _formatNumberTwoDecimalPlacesAndCommas(value, thousandSeparator, decimalSeparator) {
  if (typeof value !== "number") {
    return "";
  }

  return _formatNumberCommas(Math.round(value * 100) / 100, thousandSeparator, decimalSeparator);
}

function _formatNumberCommas(value, thousandSeparator, decimalSeparator) {
  if (typeof value !== "number") {
    return "";
  }

  return value.toString().replace(".", decimalSeparator).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1".concat(thousandSeparator));
}

function _sum(values2) {
  return values2 == null ? null : values2.reduce(function (total, value) {
    return total + value;
  }, 0);
} // community-modules/core/src/utils/date.ts


function _serialiseDate(date) {
  var includeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "-";

  if (!date) {
    return null;
  }

  var serialised = [date.getFullYear(), date.getMonth() + 1, date.getDate()].map(function (part) {
    return _padStartWidthZeros(part, 2);
  }).join(separator);

  if (includeTime) {
    serialised += " " + [date.getHours(), date.getMinutes(), date.getSeconds()].map(function (part) {
      return _padStartWidthZeros(part, 2);
    }).join(":");
  }

  return serialised;
}

var calculateOrdinal = function calculateOrdinal(value) {
  if (value > 3 && value < 21) {
    return "th";
  }

  var remainder = value % 10;

  switch (remainder) {
    case 1:
      return "st";

    case 2:
      return "nd";

    case 3:
      return "rd";
  }

  return "th";
};

function _dateToFormattedString(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "YYYY-MM-DD";

  var fullYear = _padStartWidthZeros(date.getFullYear(), 4);

  var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  var replace = {
    YYYY: function YYYY() {
      return fullYear.slice(fullYear.length - 4, fullYear.length);
    },
    YY: function YY() {
      return fullYear.slice(fullYear.length - 2, fullYear.length);
    },
    Y: function Y() {
      return "".concat(date.getFullYear());
    },
    MMMM: function MMMM() {
      return months[date.getMonth()];
    },
    MMM: function MMM() {
      return months[date.getMonth()].slice(0, 3);
    },
    MM: function MM() {
      return _padStartWidthZeros(date.getMonth() + 1, 2);
    },
    Mo: function Mo() {
      return "".concat(date.getMonth() + 1).concat(calculateOrdinal(date.getMonth() + 1));
    },
    M: function M() {
      return "".concat(date.getMonth() + 1);
    },
    Do: function Do() {
      return "".concat(date.getDate()).concat(calculateOrdinal(date.getDate()));
    },
    DD: function DD() {
      return _padStartWidthZeros(date.getDate(), 2);
    },
    D: function D() {
      return "".concat(date.getDate());
    },
    dddd: function dddd() {
      return days[date.getDay()];
    },
    ddd: function ddd() {
      return days[date.getDay()].slice(0, 3);
    },
    dd: function dd() {
      return days[date.getDay()].slice(0, 2);
    },
    do: function _do() {
      return "".concat(date.getDay()).concat(calculateOrdinal(date.getDay()));
    },
    d: function d() {
      return "".concat(date.getDay());
    }
  };
  var regexp = new RegExp(Object.keys(replace).join("|"), "g");
  return format.replace(regexp, function (match) {
    if (match in replace) {
      return replace[match]();
    }

    return match;
  });
}

function _parseDateTimeFromString(value) {
  if (!value) {
    return null;
  }

  var _value$split = value.split(" "),
      _value$split2 = _slicedToArray(_value$split, 2),
      dateStr = _value$split2[0],
      timeStr = _value$split2[1];

  if (!dateStr) {
    return null;
  }

  var fields = dateStr.split("-").map(function (f) {
    return parseInt(f, 10);
  });

  if (fields.filter(function (f) {
    return !isNaN(f);
  }).length !== 3) {
    return null;
  }

  var _fields = _slicedToArray(fields, 3),
      year = _fields[0],
      month = _fields[1],
      day = _fields[2];

  var date = new Date(year, month - 1, day);

  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return null;
  }

  if (!timeStr || timeStr === "00:00:00") {
    return date;
  }

  var _timeStr$split$map = timeStr.split(":").map(function (part) {
    return parseInt(part, 10);
  }),
      _timeStr$split$map2 = _slicedToArray(_timeStr$split$map, 3),
      hours = _timeStr$split$map2[0],
      minutes = _timeStr$split$map2[1],
      seconds = _timeStr$split$map2[2];

  if (hours >= 0 && hours < 24) {
    date.setHours(hours);
  }

  if (minutes >= 0 && minutes < 60) {
    date.setMinutes(minutes);
  }

  if (seconds >= 0 && seconds < 60) {
    date.setSeconds(seconds);
  }

  return date;
} // community-modules/core/src/utils/dom.ts


var dom_exports = {};

__export(dom_exports, {
  FOCUSABLE_EXCLUDE: function FOCUSABLE_EXCLUDE() {
    return _FOCUSABLE_EXCLUDE;
  },
  FOCUSABLE_SELECTOR: function FOCUSABLE_SELECTOR() {
    return _FOCUSABLE_SELECTOR;
  },
  addOrRemoveAttribute: function addOrRemoveAttribute() {
    return _addOrRemoveAttribute;
  },
  addStylesToElement: function addStylesToElement() {
    return _addStylesToElement;
  },
  bindCellRendererToHtmlElement: function bindCellRendererToHtmlElement() {
    return _bindCellRendererToHtmlElement;
  },
  clearElement: function clearElement() {
    return _clearElement;
  },
  copyNodeList: function copyNodeList() {
    return _copyNodeList;
  },
  ensureDomOrder: function ensureDomOrder() {
    return _ensureDomOrder;
  },
  formatSize: function formatSize() {
    return _formatSize;
  },
  getAbsoluteHeight: function getAbsoluteHeight() {
    return _getAbsoluteHeight;
  },
  getAbsoluteWidth: function getAbsoluteWidth() {
    return _getAbsoluteWidth;
  },
  getElementRectWithOffset: function getElementRectWithOffset() {
    return _getElementRectWithOffset;
  },
  getElementSize: function getElementSize() {
    return _getElementSize;
  },
  getInnerHeight: function getInnerHeight() {
    return _getInnerHeight;
  },
  getInnerWidth: function getInnerWidth() {
    return _getInnerWidth;
  },
  getScrollLeft: function getScrollLeft() {
    return _getScrollLeft;
  },
  insertWithDomOrder: function insertWithDomOrder() {
    return _insertWithDomOrder;
  },
  isElementChildOfClass: function isElementChildOfClass() {
    return _isElementChildOfClass;
  },
  isFocusableFormField: function isFocusableFormField() {
    return _isFocusableFormField;
  },
  isHorizontalScrollShowing: function isHorizontalScrollShowing() {
    return _isHorizontalScrollShowing;
  },
  isInDOM: function isInDOM() {
    return _isInDOM;
  },
  isNodeOrElement: function isNodeOrElement() {
    return _isNodeOrElement;
  },
  isRtlNegativeScroll: function isRtlNegativeScroll() {
    return _isRtlNegativeScroll;
  },
  isVerticalScrollShowing: function isVerticalScrollShowing() {
    return _isVerticalScrollShowing;
  },
  isVisible: function isVisible() {
    return _isVisible;
  },
  iterateNamedNodeMap: function iterateNamedNodeMap() {
    return _iterateNamedNodeMap;
  },
  loadTemplate: function loadTemplate() {
    return _loadTemplate;
  },
  nodeListForEach: function nodeListForEach() {
    return _nodeListForEach;
  },
  radioCssClass: function radioCssClass() {
    return _radioCssClass;
  },
  removeFromParent: function removeFromParent() {
    return _removeFromParent;
  },
  setDisabled: function setDisabled() {
    return _setDisabled;
  },
  setDisplayed: function setDisplayed() {
    return _setDisplayed;
  },
  setDomChildOrder: function setDomChildOrder() {
    return _setDomChildOrder;
  },
  setElementHeight: function setElementHeight() {
    return _setElementHeight;
  },
  setElementWidth: function setElementWidth() {
    return _setElementWidth;
  },
  setFixedHeight: function setFixedHeight() {
    return _setFixedHeight;
  },
  setFixedWidth: function setFixedWidth() {
    return _setFixedWidth;
  },
  setScrollLeft: function setScrollLeft() {
    return _setScrollLeft;
  },
  setVisible: function setVisible() {
    return _setVisible;
  }
});

var rtlNegativeScroll;

function _radioCssClass(element, elementClass, otherElementClass) {
  var parent = element.parentElement;
  var sibling = parent && parent.firstChild;

  while (sibling) {
    if (elementClass) {
      sibling.classList.toggle(elementClass, sibling === element);
    }

    if (otherElementClass) {
      sibling.classList.toggle(otherElementClass, sibling !== element);
    }

    sibling = sibling.nextSibling;
  }
}

var _FOCUSABLE_SELECTOR = "[tabindex], input, select, button, textarea, [href]";
var _FOCUSABLE_EXCLUDE = "[disabled], .ag-disabled:not(.ag-button), .ag-disabled *";

function _isFocusableFormField(element) {
  var matches = Element.prototype.matches || Element.prototype.msMatchesSelector;
  var inputSelector = "input, select, button, textarea";
  var isFocusable = matches.call(element, inputSelector);
  var isNotFocusable = matches.call(element, _FOCUSABLE_EXCLUDE);

  var isElementVisible = _isVisible(element);

  var focusable = isFocusable && !isNotFocusable && isElementVisible;
  return focusable;
}

function _setDisplayed(element, displayed) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var skipAriaHidden = options.skipAriaHidden;
  element.classList.toggle("ag-hidden", !displayed);

  if (!skipAriaHidden) {
    _setAriaHidden(element, !displayed);
  }
}

function _setVisible(element, visible) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var skipAriaHidden = options.skipAriaHidden;
  element.classList.toggle("ag-invisible", !visible);

  if (!skipAriaHidden) {
    _setAriaHidden(element, !visible);
  }
}

function _setDisabled(element, disabled) {
  var attributeName = "disabled";
  var addOrRemoveDisabledAttribute = disabled ? function (e) {
    return e.setAttribute(attributeName, "");
  } : function (e) {
    return e.removeAttribute(attributeName);
  };
  addOrRemoveDisabledAttribute(element);

  _nodeListForEach(element.querySelectorAll("input"), function (input) {
    return addOrRemoveDisabledAttribute(input);
  });
}

function _isElementChildOfClass(element, cls, maxNest) {
  var counter = 0;

  while (element) {
    if (element.classList.contains(cls)) {
      return true;
    }

    element = element.parentElement;

    if (typeof maxNest == "number") {
      if (++counter > maxNest) {
        break;
      }
    } else if (element === maxNest) {
      break;
    }
  }

  return false;
}

function _getElementSize(el) {
  var _window$getComputedSt = window.getComputedStyle(el),
      height = _window$getComputedSt.height,
      width = _window$getComputedSt.width,
      borderTopWidth = _window$getComputedSt.borderTopWidth,
      borderRightWidth = _window$getComputedSt.borderRightWidth,
      borderBottomWidth = _window$getComputedSt.borderBottomWidth,
      borderLeftWidth = _window$getComputedSt.borderLeftWidth,
      paddingTop = _window$getComputedSt.paddingTop,
      paddingRight = _window$getComputedSt.paddingRight,
      paddingBottom = _window$getComputedSt.paddingBottom,
      paddingLeft = _window$getComputedSt.paddingLeft,
      marginTop = _window$getComputedSt.marginTop,
      marginRight = _window$getComputedSt.marginRight,
      marginBottom = _window$getComputedSt.marginBottom,
      marginLeft = _window$getComputedSt.marginLeft,
      boxSizing = _window$getComputedSt.boxSizing;

  return {
    height: parseFloat(height || "0"),
    width: parseFloat(width || "0"),
    borderTopWidth: parseFloat(borderTopWidth || "0"),
    borderRightWidth: parseFloat(borderRightWidth || "0"),
    borderBottomWidth: parseFloat(borderBottomWidth || "0"),
    borderLeftWidth: parseFloat(borderLeftWidth || "0"),
    paddingTop: parseFloat(paddingTop || "0"),
    paddingRight: parseFloat(paddingRight || "0"),
    paddingBottom: parseFloat(paddingBottom || "0"),
    paddingLeft: parseFloat(paddingLeft || "0"),
    marginTop: parseFloat(marginTop || "0"),
    marginRight: parseFloat(marginRight || "0"),
    marginBottom: parseFloat(marginBottom || "0"),
    marginLeft: parseFloat(marginLeft || "0"),
    boxSizing: boxSizing
  };
}

function _getInnerHeight(el) {
  var size = _getElementSize(el);

  if (size.boxSizing === "border-box") {
    return size.height - size.paddingTop - size.paddingBottom;
  }

  return size.height;
}

function _getInnerWidth(el) {
  var size = _getElementSize(el);

  if (size.boxSizing === "border-box") {
    return size.width - size.paddingLeft - size.paddingRight;
  }

  return size.width;
}

function _getAbsoluteHeight(el) {
  var size = _getElementSize(el);

  var marginRight = size.marginBottom + size.marginTop;
  return Math.ceil(el.offsetHeight + marginRight);
}

function _getAbsoluteWidth(el) {
  var size = _getElementSize(el);

  var marginWidth = size.marginLeft + size.marginRight;
  return Math.ceil(el.offsetWidth + marginWidth);
}

function _getElementRectWithOffset(el) {
  var offsetElementRect = el.getBoundingClientRect();

  var _getElementSize2 = _getElementSize(el),
      borderTopWidth = _getElementSize2.borderTopWidth,
      borderLeftWidth = _getElementSize2.borderLeftWidth,
      borderRightWidth = _getElementSize2.borderRightWidth,
      borderBottomWidth = _getElementSize2.borderBottomWidth;

  return {
    top: offsetElementRect.top + (borderTopWidth || 0),
    left: offsetElementRect.left + (borderLeftWidth || 0),
    right: offsetElementRect.right + (borderRightWidth || 0),
    bottom: offsetElementRect.bottom + (borderBottomWidth || 0)
  };
}

function _isRtlNegativeScroll() {
  if (typeof rtlNegativeScroll === "boolean") {
    return rtlNegativeScroll;
  }

  var template = document.createElement("div");
  template.style.direction = "rtl";
  template.style.width = "1px";
  template.style.height = "1px";
  template.style.position = "fixed";
  template.style.top = "0px";
  template.style.overflow = "hidden";
  template.dir = "rtl";
  template.innerHTML =
  /* html */
  "<div style=\"width: 2px\">\n            <span style=\"display: inline-block; width: 1px\"></span>\n            <span style=\"display: inline-block; width: 1px\"></span>\n        </div>";
  document.body.appendChild(template);
  template.scrollLeft = 1;
  rtlNegativeScroll = Math.floor(template.scrollLeft) === 0;
  document.body.removeChild(template);
  return rtlNegativeScroll;
}

function _getScrollLeft(element, rtl) {
  var scrollLeft = element.scrollLeft;

  if (rtl) {
    scrollLeft = Math.abs(scrollLeft);

    if (_isBrowserChrome() && !_isRtlNegativeScroll()) {
      scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
    }
  }

  return scrollLeft;
}

function _setScrollLeft(element, value, rtl) {
  if (rtl) {
    if (_isRtlNegativeScroll()) {
      value *= -1;
    } else if (_isBrowserSafari() || _isBrowserChrome()) {
      value = element.scrollWidth - element.clientWidth - value;
    }
  }

  element.scrollLeft = value;
}

function _clearElement(el) {
  while (el && el.firstChild) {
    el.removeChild(el.firstChild);
  }
}

function _removeFromParent(node) {
  if (node && node.parentNode) {
    node.parentNode.removeChild(node);
  }
}

function _isInDOM(element) {
  return !!element.offsetParent;
}

function _isVisible(element) {
  var el = element;

  if (el.checkVisibility) {
    return el.checkVisibility({
      checkVisibilityCSS: true
    });
  }

  var isHidden = !_isInDOM(element) || window.getComputedStyle(element).visibility !== "visible";
  return !isHidden;
}

function _loadTemplate(template) {
  var tempDiv = document.createElement("div");
  tempDiv.innerHTML = (template || "").trim();
  return tempDiv.firstChild;
}

function _ensureDomOrder(eContainer, eChild, eChildBefore) {
  if (eChildBefore && eChildBefore.nextSibling === eChild) {
    return;
  }

  if (eChildBefore) {
    if (eChildBefore.nextSibling) {
      eContainer.insertBefore(eChild, eChildBefore.nextSibling);
    } else {
      eContainer.appendChild(eChild);
    }
  } else {
    if (eContainer.firstChild && eContainer.firstChild !== eChild) {
      eContainer.insertAdjacentElement("afterbegin", eChild);
    }
  }
}

function _setDomChildOrder(eContainer, orderedChildren) {
  for (var i = 0; i < orderedChildren.length; i++) {
    var correctCellAtIndex = orderedChildren[i];
    var actualCellAtIndex = eContainer.children[i];

    if (actualCellAtIndex !== correctCellAtIndex) {
      eContainer.insertBefore(correctCellAtIndex, actualCellAtIndex);
    }
  }
}

function _insertWithDomOrder(eContainer, eToInsert, eChildBefore) {
  if (eChildBefore) {
    eChildBefore.insertAdjacentElement("afterend", eToInsert);
  } else {
    if (eContainer.firstChild) {
      eContainer.insertAdjacentElement("afterbegin", eToInsert);
    } else {
      eContainer.appendChild(eToInsert);
    }
  }
}

function _addStylesToElement(eElement, styles) {
  if (!styles) {
    return;
  }

  for (var _i6 = 0, _Object$entries2 = Object.entries(styles); _i6 < _Object$entries2.length; _i6++) {
    var _ref14 = _Object$entries2[_i6];

    var _ref13 = _slicedToArray(_ref14, 2);

    var key = _ref13[0];
    var value = _ref13[1];

    if (!key || !key.length || value == null) {
      continue;
    }

    var parsedKey = _camelCaseToHyphenated(key);

    var valueAsString = value.toString();
    var parsedValue = valueAsString.replace(/\s*!important/g, "");
    var priority = parsedValue.length != valueAsString.length ? "important" : void 0;
    eElement.style.setProperty(parsedKey, parsedValue, priority);
  }
}

function _isHorizontalScrollShowing(element) {
  return element.clientWidth < element.scrollWidth;
}

function _isVerticalScrollShowing(element) {
  return element.clientHeight < element.scrollHeight;
}

function _setElementWidth(element, width) {
  if (width === "flex") {
    element.style.removeProperty("width");
    element.style.removeProperty("minWidth");
    element.style.removeProperty("maxWidth");
    element.style.flex = "1 1 auto";
  } else {
    _setFixedWidth(element, width);
  }
}

function _setFixedWidth(element, width) {
  width = _formatSize(width);
  element.style.width = width.toString();
  element.style.maxWidth = width.toString();
  element.style.minWidth = width.toString();
}

function _setElementHeight(element, height) {
  if (height === "flex") {
    element.style.removeProperty("height");
    element.style.removeProperty("minHeight");
    element.style.removeProperty("maxHeight");
    element.style.flex = "1 1 auto";
  } else {
    _setFixedHeight(element, height);
  }
}

function _setFixedHeight(element, height) {
  height = _formatSize(height);
  element.style.height = height.toString();
  element.style.maxHeight = height.toString();
  element.style.minHeight = height.toString();
}

function _formatSize(size) {
  if (typeof size === "number") {
    return "".concat(size, "px");
  }

  return size;
}

function _isNodeOrElement(o) {
  return o instanceof Node || o instanceof HTMLElement;
}

function _copyNodeList(nodeList) {
  if (nodeList == null) {
    return [];
  }

  var result = [];

  _nodeListForEach(nodeList, function (node) {
    return result.push(node);
  });

  return result;
}

function _iterateNamedNodeMap(map, callback) {
  if (!map) {
    return;
  }

  for (var i = 0; i < map.length; i++) {
    var attr = map[i];
    callback(attr.name, attr.value);
  }
}

function _addOrRemoveAttribute(element, name, value) {
  if (value == null) {
    element.removeAttribute(name);
  } else {
    element.setAttribute(name, value.toString());
  }
}

function _nodeListForEach(nodeList, action) {
  if (nodeList == null) {
    return;
  }

  for (var i = 0; i < nodeList.length; i++) {
    action(nodeList[i]);
  }
}

function _bindCellRendererToHtmlElement(cellRendererPromise, eTarget) {
  cellRendererPromise.then(function (cellRenderer) {
    var gui = cellRenderer.getGui();

    if (gui != null) {
      if (typeof gui === "object") {
        eTarget.appendChild(gui);
      } else {
        eTarget.innerHTML = gui;
      }
    }
  });
} // community-modules/core/src/utils/fuzzyMatch.ts


var fuzzyMatch_exports = {};

__export(fuzzyMatch_exports, {
  fuzzyCheckStrings: function fuzzyCheckStrings() {
    return _fuzzyCheckStrings;
  },
  fuzzySuggestions: function fuzzySuggestions() {
    return _fuzzySuggestions;
  }
});

function _fuzzyCheckStrings(inputValues, validValues, allSuggestions) {
  var fuzzyMatches = {};
  var invalidInputs = inputValues.filter(function (inputValue) {
    return !validValues.some(function (validValue) {
      return validValue === inputValue;
    });
  });

  if (invalidInputs.length > 0) {
    invalidInputs.forEach(function (invalidInput) {
      return fuzzyMatches[invalidInput] = _fuzzySuggestions(invalidInput, allSuggestions).values;
    });
  }

  return fuzzyMatches;
}

function _fuzzySuggestions(inputValue, allSuggestions, hideIrrelevant, filterByPercentageOfBestMatch) {
  var thisSuggestions = allSuggestions.map(function (text, idx) {
    return {
      value: text,
      relevance: stringWeightedDistances(inputValue.toLowerCase(), text.toLocaleLowerCase()),
      idx: idx
    };
  });
  thisSuggestions.sort(function (a, b) {
    return b.relevance - a.relevance;
  });

  if (hideIrrelevant) {
    thisSuggestions = thisSuggestions.filter(function (suggestion) {
      return suggestion.relevance !== 0;
    });
  }

  if (thisSuggestions.length > 0 && filterByPercentageOfBestMatch && filterByPercentageOfBestMatch > 0) {
    var bestMatch = thisSuggestions[0].relevance;
    var limit = bestMatch * filterByPercentageOfBestMatch;
    thisSuggestions = thisSuggestions.filter(function (suggestion) {
      return limit - suggestion.relevance < 0;
    });
  }

  var values2 = [];
  var indices = [];
  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    for (var _iterator7 = thisSuggestions[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var suggestion = _step7.value;
      values2.push(suggestion.value);
      indices.push(suggestion.idx);
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
        _iterator7.return();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }

  return {
    values: values2,
    indices: indices
  };
}

function stringWeightedDistances(str1, str2) {
  var a = str1.replace(/\s/g, "");
  var b = str2.replace(/\s/g, "");
  var weight = 0;
  var lastIndex = -1;

  for (var i = 0; i < a.length; i++) {
    var idx = b.indexOf(a[i], lastIndex + 1);

    if (idx === -1) {
      continue;
    }

    lastIndex = idx;
    weight += 100 - lastIndex * 100 / 1e4 * 100;
  }

  return weight;
} // community-modules/core/src/utils/icon.ts


var icon_exports = {};

__export(icon_exports, {
  createIcon: function createIcon() {
    return _createIcon;
  },
  createIconNoSpan: function createIconNoSpan() {
    return _createIconNoSpan;
  },
  iconNameClassMap: function iconNameClassMap() {
    return _iconNameClassMap;
  }
});

var _iconNameClassMap = {
  // header column group shown when expanded (click to contract)
  columnGroupOpened: "expanded",
  // header column group shown when contracted (click to expand)
  columnGroupClosed: "contracted",
  // tool panel column group contracted (click to expand)
  columnSelectClosed: "tree-closed",
  // tool panel column group expanded (click to contract)
  columnSelectOpen: "tree-open",
  // column tool panel header expand/collapse all button, shown when some children are expanded and
  //     others are collapsed
  columnSelectIndeterminate: "tree-indeterminate",
  // shown on ghost icon while dragging column to the side of the grid to pin
  columnMovePin: "pin",
  // shown on ghost icon while dragging over part of the page that is not a drop zone
  columnMoveHide: "eye-slash",
  // shown on ghost icon while dragging columns to reorder
  columnMoveMove: "arrows",
  // animating icon shown when dragging a column to the right of the grid causes horizontal scrolling
  columnMoveLeft: "left",
  // animating icon shown when dragging a column to the left of the grid causes horizontal scrolling
  columnMoveRight: "right",
  // shown on ghost icon while dragging over Row Groups drop zone
  columnMoveGroup: "group",
  // shown on ghost icon while dragging over Values drop zone
  columnMoveValue: "aggregation",
  // shown on ghost icon while dragging over pivot drop zone
  columnMovePivot: "pivot",
  // shown on ghost icon while dragging over drop zone that doesn't support it, e.g.
  //     string column over aggregation drop zone
  dropNotAllowed: "not-allowed",
  // shown on row group when contracted (click to expand)
  groupContracted: "tree-closed",
  // shown on row group when expanded (click to contract)
  groupExpanded: "tree-open",
  // set filter tree list group contracted (click to expand)
  setFilterGroupClosed: "tree-closed",
  // set filter tree list group expanded (click to contract)
  setFilterGroupOpen: "tree-open",
  // set filter tree list expand/collapse all button, shown when some children are expanded and
  //     others are collapsed
  setFilterGroupIndeterminate: "tree-indeterminate",
  // context menu chart item
  chart: "chart",
  // chart window title bar
  close: "cross",
  // X (remove) on column 'pill' after adding it to a drop zone list
  cancel: "cancel",
  // indicates the currently active pin state in the "Pin column" sub-menu of the column menu
  check: "tick",
  // "go to first" button in pagination controls
  first: "first",
  // "go to previous" button in pagination controls
  previous: "previous",
  // "go to next" button in pagination controls
  next: "next",
  // "go to last" button in pagination controls
  last: "last",
  // shown on top right of chart when chart is linked to range data (click to unlink)
  linked: "linked",
  // shown on top right of chart when chart is not linked to range data (click to link)
  unlinked: "unlinked",
  // "Choose colour" button on chart settings tab
  colorPicker: "color-picker",
  // rotating spinner shown by the loading cell renderer
  groupLoading: "loading",
  // button to launch enterprise column menu
  menu: "menu",
  menuAlt: "menu-alt",
  // filter tool panel tab
  filter: "filter",
  // column tool panel tab
  columns: "columns",
  // button in chart regular size window title bar (click to maximise)
  maximize: "maximize",
  // button in chart maximised window title bar (click to make regular size)
  minimize: "minimize",
  // "Pin column" item in column header menu
  menuPin: "pin",
  // "Value aggregation" column menu item (shown on numeric columns when grouping is active)"
  menuValue: "aggregation",
  // "Group by {column-name}" item in column header menu
  menuAddRowGroup: "group",
  // "Un-Group by {column-name}" item in column header menu
  menuRemoveRowGroup: "group",
  // context menu copy item
  clipboardCopy: "copy",
  // context menu cut item
  clipboardCut: "cut",
  // context menu paste item
  clipboardPaste: "paste",
  // identifies the pivot drop zone
  pivotPanel: "pivot",
  // "Row groups" drop zone in column tool panel
  rowGroupPanel: "group",
  // columns tool panel Values drop zone
  valuePanel: "aggregation",
  // drag handle used to pick up draggable columns
  columnDrag: "grip",
  // drag handle used to pick up draggable rows
  rowDrag: "grip",
  // context menu export item
  save: "save",
  // csv export
  csvExport: "csv",
  // excel export,
  excelExport: "excel",
  // icon on dropdown editors
  smallDown: "small-down",
  // version of small-right used in RTL mode
  smallLeft: "small-left",
  // separater between column 'pills' when you add multiple columns to the header drop zone
  smallRight: "small-right",
  smallUp: "small-up",
  // show on column header when column is sorted ascending
  sortAscending: "asc",
  // show on column header when column is sorted descending
  sortDescending: "desc",
  // show on column header when column has no sort, only when enabled with gridOptions.unSortIcon=true
  sortUnSort: "none",
  // Builder button in Advanced Filter
  advancedFilterBuilder: "group",
  // drag handle used to pick up Advanced Filter Builder rows
  advancedFilterBuilderDrag: "grip",
  // Advanced Filter Builder row validation error
  advancedFilterBuilderInvalid: "not-allowed",
  // shown on Advanced Filter Builder rows to move them up
  advancedFilterBuilderMoveUp: "up",
  // shown on Advanced Filter Builder rows to move them down
  advancedFilterBuilderMoveDown: "down",
  // shown on Advanced Filter Builder rows to add new rows
  advancedFilterBuilderAdd: "plus",
  // shown on Advanced Filter Builder rows to remove row
  advancedFilterBuilderRemove: "minus",
  // Edit Chart menu item shown in Integrated Charts menu
  chartsMenuEdit: "chart",
  // Advanced Settings menu item shown in Integrated Charts menu
  chartsMenuAdvancedSettings: "settings",
  // shown in Integrated Charts menu add fields
  chartsMenuAdd: "plus"
};

function _createIcon(iconName, gos, column) {
  var iconContents = _createIconNoSpan(iconName, gos, column);

  if (iconContents) {
    var className = iconContents.className;

    if (typeof className === "string" && className.indexOf("ag-icon") > -1 || typeof className === "object" && className["ag-icon"]) {
      return iconContents;
    }
  }

  var eResult = document.createElement("span");
  eResult.appendChild(iconContents);
  return eResult;
}

function _createIconNoSpan(iconName, gos, column, forceCreate) {
  var userProvidedIcon = null;
  var icons = column && column.getColDef().icons;

  if (icons) {
    userProvidedIcon = icons[iconName];
  }

  if (gos && !userProvidedIcon) {
    var optionsIcons = gos.get("icons");

    if (optionsIcons) {
      userProvidedIcon = optionsIcons[iconName];
    }
  }

  if (userProvidedIcon) {
    var rendererResult;

    if (typeof userProvidedIcon === "function") {
      rendererResult = userProvidedIcon();
    } else if (typeof userProvidedIcon === "string") {
      rendererResult = userProvidedIcon;
    } else {
      throw new Error("icon from grid options needs to be a string or a function");
    }

    if (typeof rendererResult === "string") {
      return _loadTemplate(rendererResult);
    }

    if (_isNodeOrElement(rendererResult)) {
      return rendererResult;
    }

    console.warn("AG Grid: iconRenderer should return back a string or a dom object");
  } else {
    var span = document.createElement("span");
    var cssClass = _iconNameClassMap[iconName];

    if (!cssClass) {
      if (!forceCreate) {
        console.warn("AG Grid: Did not find icon ".concat(iconName));
        cssClass = "";
      } else {
        cssClass = iconName;
      }
    }

    span.setAttribute("class", "ag-icon ag-icon-".concat(cssClass));
    span.setAttribute("unselectable", "on");

    _setAriaRole(span, "presentation");

    return span;
  }
} // community-modules/core/src/utils/keyboard.ts


var keyboard_exports = {};

__export(keyboard_exports, {
  isDeleteKey: function isDeleteKey() {
    return _isDeleteKey;
  },
  isEventFromPrintableCharacter: function isEventFromPrintableCharacter() {
    return _isEventFromPrintableCharacter;
  },
  isUserSuppressingHeaderKeyboardEvent: function isUserSuppressingHeaderKeyboardEvent() {
    return _isUserSuppressingHeaderKeyboardEvent;
  },
  isUserSuppressingKeyboardEvent: function isUserSuppressingKeyboardEvent() {
    return _isUserSuppressingKeyboardEvent;
  },
  normaliseQwertyAzerty: function normaliseQwertyAzerty() {
    return _normaliseQwertyAzerty;
  }
}); // community-modules/core/src/constants/keyCode.ts


var _KeyCode = function _KeyCode() {
  "use strict";

  _classCallCheck(this, _KeyCode);
};

_KeyCode.BACKSPACE = "Backspace";
_KeyCode.TAB = "Tab";
_KeyCode.ENTER = "Enter";
_KeyCode.ESCAPE = "Escape";
_KeyCode.SPACE = " ";
_KeyCode.LEFT = "ArrowLeft";
_KeyCode.UP = "ArrowUp";
_KeyCode.RIGHT = "ArrowRight";
_KeyCode.DOWN = "ArrowDown";
_KeyCode.DELETE = "Delete";
_KeyCode.F2 = "F2";
_KeyCode.PAGE_UP = "PageUp";
_KeyCode.PAGE_DOWN = "PageDown";
_KeyCode.PAGE_HOME = "Home";
_KeyCode.PAGE_END = "End"; // these should be used with `event.code` instead of `event.key`
// as `event.key` changes when non-latin keyboards are used

_KeyCode.A = "KeyA";
_KeyCode.C = "KeyC";
_KeyCode.D = "KeyD";
_KeyCode.V = "KeyV";
_KeyCode.X = "KeyX";
_KeyCode.Y = "KeyY";
_KeyCode.Z = "KeyZ"; // community-modules/core/src/utils/keyboard.ts

var A_KEYCODE = 65;
var C_KEYCODE = 67;
var V_KEYCODE = 86;
var D_KEYCODE = 68;
var Z_KEYCODE = 90;
var Y_KEYCODE = 89;

function _isEventFromPrintableCharacter(event) {
  if (event.altKey || event.ctrlKey || event.metaKey) {
    return false;
  }

  var printableCharacter = event.key.length === 1;
  return printableCharacter;
}

function _isUserSuppressingKeyboardEvent(gos, keyboardEvent, rowNode, column, editing) {
  var colDefFunc = column ? column.getColDef().suppressKeyboardEvent : void 0;

  if (!colDefFunc) {
    return false;
  }

  var params = gos.addGridCommonParams({
    event: keyboardEvent,
    editing: editing,
    column: column,
    node: rowNode,
    data: rowNode.data,
    colDef: column.getColDef()
  });

  if (colDefFunc) {
    var colDefFuncResult = colDefFunc(params);

    if (colDefFuncResult) {
      return true;
    }
  }

  return false;
}

function _isUserSuppressingHeaderKeyboardEvent(gos, keyboardEvent, headerRowIndex, column) {
  var colDef = column.getDefinition();
  var colDefFunc = colDef && colDef.suppressHeaderKeyboardEvent;

  if (!_exists(colDefFunc)) {
    return false;
  }

  var params = gos.addGridCommonParams({
    colDef: colDef,
    column: column,
    headerRowIndex: headerRowIndex,
    event: keyboardEvent
  });
  return !!colDefFunc(params);
}

function _normaliseQwertyAzerty(keyboardEvent) {
  var keyCode = keyboardEvent.keyCode;
  var code;

  switch (keyCode) {
    case A_KEYCODE:
      code = _KeyCode.A;
      break;

    case C_KEYCODE:
      code = _KeyCode.C;
      break;

    case V_KEYCODE:
      code = _KeyCode.V;
      break;

    case D_KEYCODE:
      code = _KeyCode.D;
      break;

    case Z_KEYCODE:
      code = _KeyCode.Z;
      break;

    case Y_KEYCODE:
      code = _KeyCode.Y;
      break;

    default:
      code = keyboardEvent.code;
  }

  return code;
}

function _isDeleteKey(key) {
  var alwaysReturnFalseOnBackspace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (key === _KeyCode.DELETE) {
    return true;
  }

  if (!alwaysReturnFalseOnBackspace && key === _KeyCode.BACKSPACE) {
    return _isMacOsUserAgent();
  }

  return false;
} // community-modules/core/src/utils/mouse.ts


var mouse_exports = {};

__export(mouse_exports, {
  areEventsNear: function areEventsNear() {
    return _areEventsNear;
  }
});

function _areEventsNear(e1, e2, pixelCount) {
  if (pixelCount === 0) {
    return false;
  }

  var diffX = Math.abs(e1.clientX - e2.clientX);
  var diffY = Math.abs(e1.clientY - e2.clientY);
  return Math.max(diffX, diffY) <= pixelCount;
} // community-modules/core/src/utils/rowNode.ts


var rowNode_exports = {};

__export(rowNode_exports, {
  sortRowNodesByOrder: function sortRowNodesByOrder() {
    return _sortRowNodesByOrder;
  }
});

function _sortRowNodesByOrder(rowNodes, rowNodeOrder) {
  if (!rowNodes) {
    return false;
  }

  var comparator = function comparator(nodeA, nodeB) {
    var positionA = rowNodeOrder[nodeA.id];
    var positionB = rowNodeOrder[nodeB.id];
    var aHasIndex = positionA !== void 0;
    var bHasIndex = positionB !== void 0;
    var bothNodesAreUserNodes = aHasIndex && bHasIndex;
    var bothNodesAreFillerNodes = !aHasIndex && !bHasIndex;

    if (bothNodesAreUserNodes) {
      return positionA - positionB;
    }

    if (bothNodesAreFillerNodes) {
      return nodeA.__objectId - nodeB.__objectId;
    }

    if (aHasIndex) {
      return 1;
    }

    return -1;
  };

  var rowNodeA;
  var rowNodeB;
  var atLeastOneOutOfOrder = false;

  for (var i = 0; i < rowNodes.length - 1; i++) {
    rowNodeA = rowNodes[i];
    rowNodeB = rowNodes[i + 1];

    if (comparator(rowNodeA, rowNodeB) > 0) {
      atLeastOneOutOfOrder = true;
      break;
    }
  }

  if (atLeastOneOutOfOrder) {
    rowNodes.sort(comparator);
    return true;
  }

  return false;
} // community-modules/core/src/utils/set.ts


var set_exports = {};

__export(set_exports, {
  convertToSet: function convertToSet() {
    return _convertToSet;
  }
});

function _convertToSet(list) {
  var set =
  /* @__PURE__ */
  new Set();
  list.forEach(function (x) {
    return set.add(x);
  });
  return set;
} // community-modules/core/src/utils/utils.ts


var utils = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, aria_exports), array_exports), browser_exports), date_exports), dom_exports), event_exports), function_exports), fuzzyMatch_exports), generic_exports), icon_exports), keyboard_exports), map_exports), mouse_exports), number_exports), object_exports), rowNode_exports), set_exports), string_exports);

var _3 = utils; // community-modules/core/src/utils/numberSequence.ts

var _NumberSequence =
/*#__PURE__*/
function () {
  "use strict";

  function _NumberSequence() {
    var initValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    _classCallCheck(this, _NumberSequence);

    this.nextValue = initValue;
    this.step = step;
  }

  _createClass(_NumberSequence, [{
    key: "next",
    value: function next() {
      var valToReturn = this.nextValue;
      this.nextValue += this.step;
      return valToReturn;
    }
  }, {
    key: "peek",
    value: function peek() {
      return this.nextValue;
    }
  }, {
    key: "skip",
    value: function skip(count) {
      this.nextValue += count;
    }
  }]);

  return _NumberSequence;
}(); // community-modules/core/src/utils/promise.ts


var _AgPromiseStatus =
/* @__PURE__ */
function (AgPromiseStatus2) {
  AgPromiseStatus2[AgPromiseStatus2["IN_PROGRESS"] = 0] = "IN_PROGRESS";
  AgPromiseStatus2[AgPromiseStatus2["RESOLVED"] = 1] = "RESOLVED";
  return AgPromiseStatus2;
}(_AgPromiseStatus || {});

var _AgPromise2 =
/*#__PURE__*/
function () {
  "use strict";

  function _AgPromise(callback) {
    var _this55 = this;

    _classCallCheck(this, _AgPromise);

    this.status = 0
    /* IN_PROGRESS */
    ;
    this.resolution = null;
    this.waiters = [];
    callback(function (value) {
      return _this55.onDone(value);
    }, function (params) {
      return _this55.onReject(params);
    });
  }

  _createClass(_AgPromise, [{
    key: "then",
    value: function then(func) {
      var _this56 = this;

      return new _AgPromise(function (resolve) {
        if (_this56.status === 1
        /* RESOLVED */
        ) {
            resolve(func(_this56.resolution));
          } else {
          _this56.waiters.push(function (value) {
            return resolve(func(value));
          });
        }
      });
    }
  }, {
    key: "resolveNow",
    value: function resolveNow(ifNotResolvedValue, ifResolved) {
      return this.status === 1
      /* RESOLVED */
      ? ifResolved(this.resolution) : ifNotResolvedValue;
    }
  }, {
    key: "onDone",
    value: function onDone(value) {
      this.status = 1
      /* RESOLVED */
      ;
      this.resolution = value;
      this.waiters.forEach(function (waiter) {
        return waiter(value);
      });
    }
  }, {
    key: "onReject",
    value: function onReject(params) {
      console.warn("TBI");
    }
  }], [{
    key: "all",
    value: function all(promises) {
      return new _AgPromise(function (resolve) {
        var remainingToResolve = promises.length;
        var combinedValues = new Array(remainingToResolve);
        promises.forEach(function (promise, index) {
          promise.then(function (value) {
            combinedValues[index] = value;
            remainingToResolve--;

            if (remainingToResolve === 0) {
              resolve(combinedValues);
            }
          });
        });
      });
    }
  }, {
    key: "resolve",
    value: function resolve() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return new _AgPromise(function (resolve) {
        return resolve(value);
      });
    }
  }]);

  return _AgPromise;
}(); // community-modules/core/src/utils/timer.ts


var _Timer =
/*#__PURE__*/
function () {
  "use strict";

  function _Timer() {
    _classCallCheck(this, _Timer);

    this.timestamp =
    /* @__PURE__ */
    new Date().getTime();
  }

  _createClass(_Timer, [{
    key: "print",
    value: function print(msg) {
      var duration =
      /* @__PURE__ */
      new Date().getTime() - this.timestamp;
      console.info("".concat(msg, " = ").concat(duration));
      this.timestamp =
      /* @__PURE__ */
      new Date().getTime();
    }
  }]);

  return _Timer;
}(); // community-modules/core/src/rendering/cssClassManager.ts


var _CssClassManager =
/*#__PURE__*/
function () {
  "use strict";

  function _CssClassManager(getGui) {
    _classCallCheck(this, _CssClassManager);

    // to minimise DOM hits, we only apply CSS classes if they have changed. as adding a CSS class that is already
    // there, or removing one that wasn't present, all takes CPU.
    this.cssClassStates = {};
    this.getGui = getGui;
  }

  _createClass(_CssClassManager, [{
    key: "addCssClass",
    value: function addCssClass(className) {
      var _this57 = this;

      var list = (className || "").split(" ");

      if (list.length > 1) {
        list.forEach(function (cls) {
          return _this57.addCssClass(cls);
        });
        return;
      }

      var updateNeeded = this.cssClassStates[className] !== true;

      if (updateNeeded && className.length) {
        var eGui = this.getGui();

        if (eGui) {
          eGui.classList.add(className);
        }

        this.cssClassStates[className] = true;
      }
    }
  }, {
    key: "removeCssClass",
    value: function removeCssClass(className) {
      var _this58 = this;

      var list = (className || "").split(" ");

      if (list.length > 1) {
        list.forEach(function (cls) {
          return _this58.removeCssClass(cls);
        });
        return;
      }

      var updateNeeded = this.cssClassStates[className] !== false;

      if (updateNeeded && className.length) {
        var eGui = this.getGui();

        if (eGui) {
          eGui.classList.remove(className);
        }

        this.cssClassStates[className] = false;
      }
    }
  }, {
    key: "containsCssClass",
    value: function containsCssClass(className) {
      var eGui = this.getGui();

      if (!eGui) {
        return false;
      }

      return eGui.classList.contains(className);
    }
  }, {
    key: "addOrRemoveCssClass",
    value: function addOrRemoveCssClass(className, addOrRemove) {
      var _this59 = this;

      if (!className) {
        return;
      }

      if (className.indexOf(" ") >= 0) {
        var list = (className || "").split(" ");

        if (list.length > 1) {
          list.forEach(function (cls) {
            return _this59.addOrRemoveCssClass(cls, addOrRemove);
          });
          return;
        }
      }

      var updateNeeded = this.cssClassStates[className] !== addOrRemove;

      if (updateNeeded && className.length) {
        var eGui = this.getGui();

        if (eGui) {
          eGui.classList.toggle(className, addOrRemove);
        }

        this.cssClassStates[className] = addOrRemove;
      }
    }
  }]);

  return _CssClassManager;
}(); // community-modules/core/src/widgets/tooltipStateManager.ts


var _TooltipStateManager =
/*#__PURE__*/
function (_BeanStub8) {
  "use strict";

  _inherits(_TooltipStateManager, _BeanStub8);

  function _TooltipStateManager(parentComp, tooltipShowDelayOverride, tooltipHideDelayOverride, shouldDisplayTooltip) {
    var _this60;

    _classCallCheck(this, _TooltipStateManager);

    _this60 = _possibleConstructorReturn(this, _getPrototypeOf(_TooltipStateManager).call(this));
    _this60.parentComp = parentComp;
    _this60.tooltipShowDelayOverride = tooltipShowDelayOverride;
    _this60.tooltipHideDelayOverride = tooltipHideDelayOverride;
    _this60.shouldDisplayTooltip = shouldDisplayTooltip;
    _this60.SHOW_QUICK_TOOLTIP_DIFF = 1e3;
    _this60.FADE_OUT_TOOLTIP_TIMEOUT = 1e3;
    _this60.INTERACTIVE_HIDE_DELAY = 100;
    _this60.interactionEnabled = false;
    _this60.isInteractingWithTooltip = false;
    _this60.state = 0
    /* NOTHING */
    ; // when showing the tooltip, we need to make sure it's the most recent instance we request, as due to
    // async we could request two tooltips before the first instance returns, in which case we should
    // disregard the second instance.

    _this60.tooltipInstanceCount = 0;
    _this60.tooltipMouseTrack = false;
    return _this60;
  }

  _createClass(_TooltipStateManager, [{
    key: "postConstruct",
    value: function postConstruct() {
      if (this.gos.get("tooltipInteraction")) {
        this.interactionEnabled = true;
      }

      this.tooltipTrigger = this.getTooltipTrigger();
      this.tooltipMouseTrack = this.gos.get("tooltipMouseTrack");
      var el = this.parentComp.getGui();

      if (this.tooltipTrigger === 0
      /* HOVER */
      ) {
          this.addManagedListener(el, "mouseenter", this.onMouseEnter.bind(this));
          this.addManagedListener(el, "mouseleave", this.onMouseLeave.bind(this));
        }

      if (this.tooltipTrigger === 1
      /* FOCUS */
      ) {
          this.addManagedListener(el, "focusin", this.onFocusIn.bind(this));
          this.addManagedListener(el, "focusout", this.onFocusOut.bind(this));
        }

      this.addManagedListener(el, "mousemove", this.onMouseMove.bind(this));

      if (!this.interactionEnabled) {
        this.addManagedListener(el, "mousedown", this.onMouseDown.bind(this));
        this.addManagedListener(el, "keydown", this.onKeyDown.bind(this));
      }
    }
  }, {
    key: "getGridOptionsTooltipDelay",
    value: function getGridOptionsTooltipDelay(delayOption) {
      var delay = this.gos.get(delayOption);

      if (delay < 0) {
        _warnOnce("".concat(delayOption, " should not be lower than 0"));
      }

      return Math.max(200, delay);
    }
  }, {
    key: "getTooltipDelay",
    value: function getTooltipDelay(type) {
      var _a, _b;

      if (type === "show") {
        return (_a = this.tooltipShowDelayOverride) != null ? _a : this.getGridOptionsTooltipDelay("tooltipShowDelay");
      }

      return (_b = this.tooltipHideDelayOverride) != null ? _b : this.getGridOptionsTooltipDelay("tooltipHideDelay");
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.setToDoNothing();

      _get(_getPrototypeOf(_TooltipStateManager.prototype), "destroy", this).call(this);
    }
  }, {
    key: "getTooltipTrigger",
    value: function getTooltipTrigger() {
      var trigger = this.gos.get("tooltipTrigger");

      if (!trigger || trigger === "hover") {
        return 0
        /* HOVER */
        ;
      }

      return 1
      /* FOCUS */
      ;
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter(e) {
      var _this61 = this;

      if (this.interactionEnabled && this.interactiveTooltipTimeoutId) {
        this.unlockService();
        this.startHideTimeout();
      }

      if (_isIOSUserAgent()) {
        return;
      }

      if (_TooltipStateManager.isLocked) {
        this.showTooltipTimeoutId = window.setTimeout(function () {
          _this61.prepareToShowTooltip(e);
        }, this.INTERACTIVE_HIDE_DELAY);
      } else {
        this.prepareToShowTooltip(e);
      }
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove(e) {
      if (this.lastMouseEvent) {
        this.lastMouseEvent = e;
      }

      if (this.tooltipMouseTrack && this.state === 2
      /* SHOWING */
      && this.tooltipComp) {
        this.positionTooltip();
      }
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown() {
      this.setToDoNothing();
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      if (this.interactionEnabled) {
        this.lockService();
      } else {
        this.setToDoNothing();
      }
    }
  }, {
    key: "onFocusIn",
    value: function onFocusIn() {
      this.prepareToShowTooltip();
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut(e) {
      var _a;

      var relatedTarget = e.relatedTarget;
      var parentCompGui = this.parentComp.getGui();
      var tooltipGui = (_a = this.tooltipComp) == null ? void 0 : _a.getGui();

      if (this.isInteractingWithTooltip || parentCompGui.contains(relatedTarget) || this.interactionEnabled && (tooltipGui == null ? void 0 : tooltipGui.contains(relatedTarget))) {
        return;
      }

      this.setToDoNothing();
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown() {
      this.setToDoNothing();
    }
  }, {
    key: "prepareToShowTooltip",
    value: function prepareToShowTooltip(mouseEvent) {
      if (this.state != 0
      /* NOTHING */
      || _TooltipStateManager.isLocked) {
        return;
      }

      var delay = 0;

      if (mouseEvent) {
        delay = this.isLastTooltipHiddenRecently() ? 200 : this.getTooltipDelay("show");
      }

      this.lastMouseEvent = mouseEvent || null;
      this.showTooltipTimeoutId = window.setTimeout(this.showTooltip.bind(this), delay);
      this.state = 1
      /* WAITING_TO_SHOW */
      ;
    }
  }, {
    key: "isLastTooltipHiddenRecently",
    value: function isLastTooltipHiddenRecently() {
      var now =
      /* @__PURE__ */
      new Date().getTime();
      var then = _TooltipStateManager.lastTooltipHideTime;
      return now - then < this.SHOW_QUICK_TOOLTIP_DIFF;
    }
  }, {
    key: "setToDoNothing",
    value: function setToDoNothing() {
      if (this.state === 2
      /* SHOWING */
      ) {
          this.hideTooltip();
        }

      if (this.onBodyScrollEventCallback) {
        this.onBodyScrollEventCallback();
        this.onBodyScrollEventCallback = void 0;
      }

      if (this.onColumnMovedEventCallback) {
        this.onColumnMovedEventCallback();
        this.onColumnMovedEventCallback = void 0;
      }

      this.clearTimeouts();
      this.state = 0
      /* NOTHING */
      ;
      this.lastMouseEvent = null;
    }
  }, {
    key: "showTooltip",
    value: function showTooltip() {
      var params = __spreadValues({}, this.parentComp.getTooltipParams());

      if (!_exists(params.value) || this.shouldDisplayTooltip && !this.shouldDisplayTooltip()) {
        this.setToDoNothing();
        return;
      }

      this.state = 2
      /* SHOWING */
      ;
      this.tooltipInstanceCount++;
      var callback = this.newTooltipComponentCallback.bind(this, this.tooltipInstanceCount);
      var userDetails = this.userComponentFactory.getTooltipCompDetails(params);
      userDetails.newAgStackInstance().then(callback);
    }
  }, {
    key: "hideTooltip",
    value: function hideTooltip(forceHide) {
      if (!forceHide && this.isInteractingWithTooltip) {
        return;
      }

      if (this.tooltipComp) {
        this.destroyTooltipComp();
        _TooltipStateManager.lastTooltipHideTime =
        /* @__PURE__ */
        new Date().getTime();
      }

      var event = {
        type: _Events.EVENT_TOOLTIP_HIDE,
        parentGui: this.parentComp.getGui()
      };
      this.eventService.dispatchEvent(event);
      this.state = 0
      /* NOTHING */
      ;
    }
  }, {
    key: "newTooltipComponentCallback",
    value: function newTooltipComponentCallback(tooltipInstanceCopy, tooltipComp) {
      var compNoLongerNeeded = this.state !== 2
      /* SHOWING */
      || this.tooltipInstanceCount !== tooltipInstanceCopy;

      if (compNoLongerNeeded) {
        this.getContext().destroyBean(tooltipComp);
        return;
      }

      var eGui = tooltipComp.getGui();
      this.tooltipComp = tooltipComp;

      if (!eGui.classList.contains("ag-tooltip")) {
        eGui.classList.add("ag-tooltip-custom");
      }

      if (this.tooltipTrigger === 0
      /* HOVER */
      ) {
          eGui.classList.add("ag-tooltip-animate");
        }

      if (this.interactionEnabled) {
        eGui.classList.add("ag-tooltip-interactive");
      }

      var translate = this.localeService.getLocaleTextFunc();
      var addPopupRes = this.popupService.addPopup({
        eChild: eGui,
        ariaLabel: translate("ariaLabelTooltip", "Tooltip")
      });

      if (addPopupRes) {
        this.tooltipPopupDestroyFunc = addPopupRes.hideFunc;
      }

      this.positionTooltip();

      if (this.tooltipTrigger === 1
      /* FOCUS */
      ) {
          this.onBodyScrollEventCallback = this.addManagedListener(this.eventService, _Events.EVENT_BODY_SCROLL, this.setToDoNothing.bind(this));
          this.onColumnMovedEventCallback = this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_MOVED, this.setToDoNothing.bind(this));
        }

      if (this.interactionEnabled) {
        if (this.tooltipTrigger === 0
        /* HOVER */
        ) {
            this.tooltipMouseEnterListener = this.addManagedListener(eGui, "mouseenter", this.onTooltipMouseEnter.bind(this)) || null;
            this.tooltipMouseLeaveListener = this.addManagedListener(eGui, "mouseleave", this.onTooltipMouseLeave.bind(this)) || null;
          } else {
          this.tooltipFocusInListener = this.addManagedListener(eGui, "focusin", this.onTooltipFocusIn.bind(this)) || null;
          this.tooltipFocusOutListener = this.addManagedListener(eGui, "focusout", this.onTooltipFocusOut.bind(this)) || null;
        }
      }

      var event = {
        type: _Events.EVENT_TOOLTIP_SHOW,
        tooltipGui: eGui,
        parentGui: this.parentComp.getGui()
      };
      this.eventService.dispatchEvent(event);
      this.startHideTimeout();
    }
  }, {
    key: "onTooltipMouseEnter",
    value: function onTooltipMouseEnter() {
      this.isInteractingWithTooltip = true;
      this.unlockService();
    }
  }, {
    key: "onTooltipMouseLeave",
    value: function onTooltipMouseLeave() {
      this.isInteractingWithTooltip = false;
      this.lockService();
    }
  }, {
    key: "onTooltipFocusIn",
    value: function onTooltipFocusIn() {
      this.isInteractingWithTooltip = true;
    }
  }, {
    key: "onTooltipFocusOut",
    value: function onTooltipFocusOut(e) {
      var _a;

      var parentGui = this.parentComp.getGui();
      var tooltipGui = (_a = this.tooltipComp) == null ? void 0 : _a.getGui();
      var relatedTarget = e.relatedTarget;

      if (tooltipGui == null ? void 0 : tooltipGui.contains(relatedTarget)) {
        return;
      }

      this.isInteractingWithTooltip = false;

      if (parentGui.contains(relatedTarget)) {
        this.startHideTimeout();
      } else {
        this.hideTooltip();
      }
    }
  }, {
    key: "positionTooltip",
    value: function positionTooltip() {
      var params = {
        type: "tooltip",
        ePopup: this.tooltipComp.getGui(),
        nudgeY: 18,
        skipObserver: this.tooltipMouseTrack
      };

      if (this.lastMouseEvent) {
        this.popupService.positionPopupUnderMouseEvent(__spreadProps(__spreadValues({}, params), {
          mouseEvent: this.lastMouseEvent
        }));
      } else {
        this.popupService.positionPopupByComponent(__spreadProps(__spreadValues({}, params), {
          eventSource: this.parentComp.getGui(),
          position: "under",
          keepWithinBounds: true,
          nudgeY: 5
        }));
      }
    }
  }, {
    key: "destroyTooltipComp",
    value: function destroyTooltipComp() {
      var _this62 = this;

      this.tooltipComp.getGui().classList.add("ag-tooltip-hiding");
      var tooltipPopupDestroyFunc = this.tooltipPopupDestroyFunc;
      var tooltipComp = this.tooltipComp;
      var delay = this.tooltipTrigger === 0
      /* HOVER */
      ? this.FADE_OUT_TOOLTIP_TIMEOUT : 0;
      window.setTimeout(function () {
        tooltipPopupDestroyFunc();

        _this62.getContext().destroyBean(tooltipComp);
      }, delay);
      this.clearTooltipListeners();
      this.tooltipPopupDestroyFunc = void 0;
      this.tooltipComp = void 0;
    }
  }, {
    key: "clearTooltipListeners",
    value: function clearTooltipListeners() {
      [this.tooltipMouseEnterListener, this.tooltipMouseLeaveListener, this.tooltipFocusInListener, this.tooltipFocusOutListener].forEach(function (listener) {
        if (listener) {
          listener();
        }
      });
      this.tooltipMouseEnterListener = this.tooltipMouseLeaveListener = this.tooltipFocusInListener = this.tooltipFocusOutListener = null;
    }
  }, {
    key: "lockService",
    value: function lockService() {
      var _this63 = this;

      _TooltipStateManager.isLocked = true;
      this.interactiveTooltipTimeoutId = window.setTimeout(function () {
        _this63.unlockService();

        _this63.setToDoNothing();
      }, this.INTERACTIVE_HIDE_DELAY);
    }
  }, {
    key: "unlockService",
    value: function unlockService() {
      _TooltipStateManager.isLocked = false;
      this.clearInteractiveTimeout();
    }
  }, {
    key: "startHideTimeout",
    value: function startHideTimeout() {
      this.clearHideTimeout();
      this.hideTooltipTimeoutId = window.setTimeout(this.hideTooltip.bind(this), this.getTooltipDelay("hide"));
    }
  }, {
    key: "clearShowTimeout",
    value: function clearShowTimeout() {
      if (!this.showTooltipTimeoutId) {
        return;
      }

      window.clearTimeout(this.showTooltipTimeoutId);
      this.showTooltipTimeoutId = void 0;
    }
  }, {
    key: "clearHideTimeout",
    value: function clearHideTimeout() {
      if (!this.hideTooltipTimeoutId) {
        return;
      }

      window.clearTimeout(this.hideTooltipTimeoutId);
      this.hideTooltipTimeoutId = void 0;
    }
  }, {
    key: "clearInteractiveTimeout",
    value: function clearInteractiveTimeout() {
      if (!this.interactiveTooltipTimeoutId) {
        return;
      }

      window.clearTimeout(this.interactiveTooltipTimeoutId);
      this.interactiveTooltipTimeoutId = void 0;
    }
  }, {
    key: "clearTimeouts",
    value: function clearTimeouts() {
      this.clearShowTimeout();
      this.clearHideTimeout();
      this.clearInteractiveTimeout();
    }
  }]);

  return _TooltipStateManager;
}(_BeanStub2);

_TooltipStateManager.isLocked = false;

__decorateClass([_Autowired("popupService")], _TooltipStateManager.prototype, "popupService", 2);

__decorateClass([_Autowired("userComponentFactory")], _TooltipStateManager.prototype, "userComponentFactory", 2);

__decorateClass([_PostConstruct], _TooltipStateManager.prototype, "postConstruct", 1);

var _TooltipStateManager2 = _TooltipStateManager; // community-modules/core/src/widgets/tooltipFeature.ts

var _TooltipFeature =
/*#__PURE__*/
function (_BeanStub9) {
  "use strict";

  _inherits(_TooltipFeature, _BeanStub9);

  function _TooltipFeature(ctrl, beans) {
    var _this64;

    _classCallCheck(this, _TooltipFeature);

    _this64 = _possibleConstructorReturn(this, _getPrototypeOf(_TooltipFeature).call(this));
    _this64.ctrl = ctrl;

    if (beans) {
      _this64.beans = beans;
    }

    return _this64;
  }

  _createClass(_TooltipFeature, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.refreshToolTip();
    }
  }, {
    key: "setBrowserTooltip",
    value: function setBrowserTooltip(tooltip) {
      var name = "title";
      var eGui = this.ctrl.getGui();

      if (!eGui) {
        return;
      }

      if (tooltip != null && tooltip != "") {
        eGui.setAttribute(name, tooltip);
      } else {
        eGui.removeAttribute(name);
      }
    }
  }, {
    key: "updateTooltipText",
    value: function updateTooltipText() {
      this.tooltip = this.ctrl.getTooltipValue();
    }
  }, {
    key: "createTooltipFeatureIfNeeded",
    value: function createTooltipFeatureIfNeeded() {
      var _this65 = this;

      var _a, _b, _c, _d;

      if (this.tooltipManager != null) {
        return;
      }

      var parent = {
        getTooltipParams: function getTooltipParams() {
          return _this65.getTooltipParams();
        },
        getGui: function getGui() {
          return _this65.ctrl.getGui();
        }
      };
      this.tooltipManager = this.createBean(new _TooltipStateManager2(parent, (_b = (_a = this.ctrl).getTooltipShowDelayOverride) == null ? void 0 : _b.call(_a), (_d = (_c = this.ctrl).getTooltipHideDelayOverride) == null ? void 0 : _d.call(_c), this.ctrl.shouldDisplayTooltip), this.beans.context);
    }
  }, {
    key: "refreshToolTip",
    value: function refreshToolTip() {
      this.browserTooltips = this.beans.gos.get("enableBrowserTooltips");
      this.updateTooltipText();

      if (this.browserTooltips) {
        this.setBrowserTooltip(this.tooltip);

        if (this.tooltipManager) {
          this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context);
        }
      } else {
        this.setBrowserTooltip(null);
        this.createTooltipFeatureIfNeeded();
      }
    }
  }, {
    key: "getTooltipParams",
    value: function getTooltipParams() {
      var _this66 = this;

      var ctrl = this.ctrl;
      var column = ctrl.getColumn ? ctrl.getColumn() : void 0;
      var colDef = ctrl.getColDef ? ctrl.getColDef() : void 0;
      var rowNode = ctrl.getRowNode ? ctrl.getRowNode() : void 0;
      return {
        location: ctrl.getLocation(),
        //'cell',
        colDef: colDef,
        column: column,
        rowIndex: ctrl.getRowIndex ? ctrl.getRowIndex() : void 0,
        node: rowNode,
        data: rowNode ? rowNode.data : void 0,
        value: this.getTooltipText(),
        valueFormatted: ctrl.getValueFormatted ? ctrl.getValueFormatted() : void 0,
        hideTooltipCallback: function hideTooltipCallback() {
          var _a;

          return (_a = _this66.tooltipManager) == null ? void 0 : _a.hideTooltip(true);
        }
      };
    }
  }, {
    key: "getTooltipText",
    value: function getTooltipText() {
      return this.tooltip;
    } // overriding to make public, as we don't dispose this bean via context

  }, {
    key: "destroy",
    value: function destroy() {
      if (this.tooltipManager) {
        this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context);
      }

      _get(_getPrototypeOf(_TooltipFeature.prototype), "destroy", this).call(this);
    }
  }]);

  return _TooltipFeature;
}(_BeanStub2);

__decorateClass([_Autowired("beans")], _TooltipFeature.prototype, "beans", 2);

__decorateClass([_PostConstruct], _TooltipFeature.prototype, "postConstruct", 1); // community-modules/core/src/widgets/component.ts


var compIdSequence = new _NumberSequence();

var _Component =
/*#__PURE__*/
function (_BeanStub10) {
  "use strict";

  _inherits(_Component, _BeanStub10);

  function _Component(template) {
    var _this67;

    _classCallCheck(this, _Component);

    _this67 = _possibleConstructorReturn(this, _getPrototypeOf(_Component).call(this)); // if false, then CSS class "ag-hidden" is applied, which sets "display: none"

    _this67.displayed = true; // if false, then CSS class "ag-invisible" is applied, which sets "visibility: hidden"

    _this67.visible = true; // unique id for this row component. this is used for getting a reference to the HTML dom.
    // we cannot use the RowNode id as this is not unique (due to animation, old rows can be lying
    // around as we create a new rowComp instance for the same row node).

    _this67.compId = compIdSequence.next();
    _this67.cssClassManager = new _CssClassManager(function () {
      return _this67.eGui;
    });

    if (template) {
      _this67.setTemplate(template);
    }

    return _this67;
  }

  _createClass(_Component, [{
    key: "preConstructOnComponent",
    value: function preConstructOnComponent() {
      this.usingBrowserTooltips = this.gos.get("enableBrowserTooltips");
    }
  }, {
    key: "getCompId",
    value: function getCompId() {
      return this.compId;
    }
  }, {
    key: "getTooltipParams",
    value: function getTooltipParams() {
      return {
        value: this.tooltipText,
        location: "UNKNOWN"
      };
    }
  }, {
    key: "setTooltip",
    value: function setTooltip(params) {
      var _this68 = this;

      var _ref15 = params || {},
          newTooltipText = _ref15.newTooltipText,
          showDelayOverride = _ref15.showDelayOverride,
          hideDelayOverride = _ref15.hideDelayOverride,
          location = _ref15.location,
          shouldDisplayTooltip = _ref15.shouldDisplayTooltip;

      if (this.tooltipFeature) {
        this.tooltipFeature = this.destroyBean(this.tooltipFeature);
      }

      if (this.tooltipText !== newTooltipText) {
        this.tooltipText = newTooltipText;
      }

      var getTooltipValue = function getTooltipValue() {
        return _this68.tooltipText;
      };

      if (newTooltipText != null) {
        this.tooltipFeature = this.createBean(new _TooltipFeature({
          getTooltipValue: getTooltipValue,
          getGui: function getGui() {
            return _this68.getGui();
          },
          getLocation: function getLocation() {
            return location != null ? location : "UNKNOWN";
          },
          getColDef: params == null ? void 0 : params.getColDef,
          getColumn: params == null ? void 0 : params.getColumn,
          getTooltipShowDelayOverride: showDelayOverride != null ? function () {
            return showDelayOverride;
          } : void 0,
          getTooltipHideDelayOverride: hideDelayOverride != null ? function () {
            return hideDelayOverride;
          } : void 0,
          shouldDisplayTooltip: shouldDisplayTooltip
        }));
      }
    } // for registered components only, eg creates AgCheckbox instance from ag-checkbox HTML tag

  }, {
    key: "createChildComponentsFromTags",
    value: function createChildComponentsFromTags(parentNode, paramsMap) {
      var _this69 = this;

      var childNodeList = _copyNodeList(parentNode.childNodes);

      childNodeList.forEach(function (childNode) {
        if (!(childNode instanceof HTMLElement)) {
          return;
        }

        var childComp = _this69.createComponentFromElement(childNode, function (childComp2) {
          var childGui = childComp2.getGui();

          if (childGui) {
            _this69.copyAttributesFromNode(childNode, childComp2.getGui());
          }
        }, paramsMap);

        if (childComp) {
          if (childComp.addItems && childNode.children.length) {
            _this69.createChildComponentsFromTags(childNode, paramsMap);

            var items = Array.prototype.slice.call(childNode.children);
            childComp.addItems(items);
          }

          _this69.swapComponentForNode(childComp, parentNode, childNode);
        } else if (childNode.childNodes) {
          _this69.createChildComponentsFromTags(childNode, paramsMap);
        }
      });
    }
  }, {
    key: "createComponentFromElement",
    value: function createComponentFromElement(element, afterPreCreateCallback, paramsMap) {
      var key = element.nodeName;
      var componentParams = paramsMap ? paramsMap[element.getAttribute("ref")] : void 0;
      var ComponentClass = this.agStackComponentsRegistry.getComponentClass(key);

      if (ComponentClass) {
        _Component.elementGettingCreated = element;
        var newComponent = new ComponentClass(componentParams);
        newComponent.setParentComponent(this);
        this.createBean(newComponent, null, afterPreCreateCallback);
        return newComponent;
      }

      return null;
    }
  }, {
    key: "copyAttributesFromNode",
    value: function copyAttributesFromNode(source, dest) {
      _iterateNamedNodeMap(source.attributes, function (name, value) {
        return dest.setAttribute(name, value);
      });
    }
  }, {
    key: "swapComponentForNode",
    value: function swapComponentForNode(newComponent, parentNode, childNode) {
      var eComponent = newComponent.getGui();
      parentNode.replaceChild(eComponent, childNode);
      parentNode.insertBefore(document.createComment(childNode.nodeName), eComponent);
      this.addDestroyFunc(this.destroyBean.bind(this, newComponent));
      this.swapInComponentForQuerySelectors(newComponent, childNode);
    }
  }, {
    key: "swapInComponentForQuerySelectors",
    value: function swapInComponentForQuerySelectors(newComponent, childNode) {
      var thisNoType = this;
      this.iterateOverQuerySelectors(function (querySelector) {
        if (thisNoType[querySelector.attributeName] === childNode) {
          thisNoType[querySelector.attributeName] = newComponent;
        }
      });
    }
  }, {
    key: "iterateOverQuerySelectors",
    value: function iterateOverQuerySelectors(action) {
      var thisPrototype = Object.getPrototypeOf(this);

      while (thisPrototype != null) {
        var metaData = thisPrototype.__agComponentMetaData;

        var currentProtoName = _getFunctionName(thisPrototype.constructor);

        if (metaData && metaData[currentProtoName] && metaData[currentProtoName].querySelectors) {
          metaData[currentProtoName].querySelectors.forEach(function (querySelector) {
            return action(querySelector);
          });
        }

        thisPrototype = Object.getPrototypeOf(thisPrototype);
      }
    }
  }, {
    key: "activateTabIndex",
    value: function activateTabIndex(elements) {
      var tabIndex = this.gos.get("tabIndex");

      if (!elements) {
        elements = [];
      }

      if (!elements.length) {
        elements.push(this.getGui());
      }

      elements.forEach(function (el) {
        return el.setAttribute("tabindex", tabIndex.toString());
      });
    }
  }, {
    key: "setTemplate",
    value: function setTemplate(template, paramsMap) {
      var eGui = _loadTemplate(template);

      this.setTemplateFromElement(eGui, paramsMap);
    }
  }, {
    key: "setTemplateFromElement",
    value: function setTemplateFromElement(element, paramsMap) {
      this.eGui = element;
      this.eGui.__agComponent = this;
      this.wireQuerySelectors();

      if (!!this.getContext()) {
        this.createChildComponentsFromTags(this.getGui(), paramsMap);
      }
    }
  }, {
    key: "createChildComponentsPreConstruct",
    value: function createChildComponentsPreConstruct() {
      if (!!this.getGui()) {
        this.createChildComponentsFromTags(this.getGui());
      }
    }
  }, {
    key: "wireQuerySelectors",
    value: function wireQuerySelectors() {
      var _this70 = this;

      if (!this.eGui) {
        return;
      }

      var thisNoType = this;
      this.iterateOverQuerySelectors(function (querySelector) {
        var setResult = function setResult(result) {
          return thisNoType[querySelector.attributeName] = result;
        };

        var topLevelRefMatch = querySelector.refSelector && _this70.getAttribute("ref") === querySelector.refSelector;

        if (topLevelRefMatch) {
          setResult(_this70.eGui);
        } else {
          var resultOfQuery = _this70.eGui.querySelector(querySelector.querySelector);

          if (resultOfQuery) {
            setResult(resultOfQuery.__agComponent || resultOfQuery);
          }
        }
      });
    }
  }, {
    key: "getGui",
    value: function getGui() {
      return this.eGui;
    }
  }, {
    key: "getFocusableElement",
    value: function getFocusableElement() {
      return this.eGui;
    }
  }, {
    key: "getAriaElement",
    value: function getAriaElement() {
      return this.getFocusableElement();
    }
  }, {
    key: "setParentComponent",
    value: function setParentComponent(component) {
      this.parentComponent = component;
    }
  }, {
    key: "getParentComponent",
    value: function getParentComponent() {
      return this.parentComponent;
    } // this method is for older code, that wants to provide the gui element,
    // it is not intended for this to be in ag-Stack

  }, {
    key: "setGui",
    value: function setGui(eGui) {
      this.eGui = eGui;
    }
  }, {
    key: "queryForHtmlElement",
    value: function queryForHtmlElement(cssSelector) {
      return this.eGui.querySelector(cssSelector);
    }
  }, {
    key: "queryForHtmlInputElement",
    value: function queryForHtmlInputElement(cssSelector) {
      return this.eGui.querySelector(cssSelector);
    }
  }, {
    key: "appendChild",
    value: function appendChild(newChild, container) {
      if (newChild == null) {
        return;
      }

      if (!container) {
        container = this.eGui;
      }

      if (_isNodeOrElement(newChild)) {
        container.appendChild(newChild);
      } else {
        var childComponent = newChild;
        container.appendChild(childComponent.getGui());
      }
    }
  }, {
    key: "isDisplayed",
    value: function isDisplayed() {
      return this.displayed;
    }
  }, {
    key: "setVisible",
    value: function setVisible(visible) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (visible !== this.visible) {
        this.visible = visible;
        var skipAriaHidden = options.skipAriaHidden;

        _setVisible(this.eGui, visible, {
          skipAriaHidden: skipAriaHidden
        });
      }
    }
  }, {
    key: "setDisplayed",
    value: function setDisplayed(displayed) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (displayed !== this.displayed) {
        this.displayed = displayed;
        var skipAriaHidden = options.skipAriaHidden;

        _setDisplayed(this.eGui, displayed, {
          skipAriaHidden: skipAriaHidden
        });

        var event = {
          type: _Component.EVENT_DISPLAYED_CHANGED,
          visible: this.displayed
        };
        this.dispatchEvent(event);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.parentComponent) {
        this.parentComponent = void 0;
      }

      if (this.tooltipFeature) {
        this.tooltipFeature = this.destroyBean(this.tooltipFeature);
      }

      var eGui = this.eGui;

      if (eGui && eGui.__agComponent) {
        eGui.__agComponent = void 0;
      }

      _get(_getPrototypeOf(_Component.prototype), "destroy", this).call(this);
    }
  }, {
    key: "addGuiEventListener",
    value: function addGuiEventListener(event, listener, options) {
      var _this71 = this;

      this.eGui.addEventListener(event, listener, options);
      this.addDestroyFunc(function () {
        return _this71.eGui.removeEventListener(event, listener);
      });
    }
  }, {
    key: "addCssClass",
    value: function addCssClass(className) {
      this.cssClassManager.addCssClass(className);
    }
  }, {
    key: "removeCssClass",
    value: function removeCssClass(className) {
      this.cssClassManager.removeCssClass(className);
    }
  }, {
    key: "containsCssClass",
    value: function containsCssClass(className) {
      return this.cssClassManager.containsCssClass(className);
    }
  }, {
    key: "addOrRemoveCssClass",
    value: function addOrRemoveCssClass(className, addOrRemove) {
      this.cssClassManager.addOrRemoveCssClass(className, addOrRemove);
    }
  }, {
    key: "getAttribute",
    value: function getAttribute(key) {
      var eGui = this.eGui;
      return eGui ? eGui.getAttribute(key) : null;
    }
  }, {
    key: "getRefElement",
    value: function getRefElement(refName) {
      return this.queryForHtmlElement("[ref=\"".concat(refName, "\"]"));
    }
  }]);

  return _Component;
}(_BeanStub2);

_Component.EVENT_DISPLAYED_CHANGED = "displayedChanged";

__decorateClass([_Autowired("agStackComponentsRegistry")], _Component.prototype, "agStackComponentsRegistry", 2);

__decorateClass([_PreConstruct], _Component.prototype, "preConstructOnComponent", 1);

__decorateClass([_PreConstruct], _Component.prototype, "createChildComponentsPreConstruct", 1);

var _Component2 = _Component; // community-modules/core/src/widgets/componentAnnotations.ts

function _QuerySelector(selector) {
  return querySelectorFunc.bind(this, selector, void 0);
}

function _RefSelector(ref) {
  return querySelectorFunc.bind(this, "[ref=".concat(ref, "]"), ref);
}

function querySelectorFunc(selector, refSelector, classPrototype, methodOrAttributeName, index) {
  if (selector === null) {
    console.error("AG Grid: QuerySelector selector should not be null");
    return;
  }

  if (typeof index === "number") {
    console.error("AG Grid: QuerySelector should be on an attribute");
    return;
  }

  addToObjectProps(classPrototype, "querySelectors", {
    attributeName: methodOrAttributeName,
    querySelector: selector,
    refSelector: refSelector
  });
}

function addToObjectProps(target, key, value) {
  var props = getOrCreateProps2(target, _getFunctionName(target.constructor));

  if (!props[key]) {
    props[key] = [];
  }

  props[key].push(value);
}

function getOrCreateProps2(target, instanceName) {
  if (!target.__agComponentMetaData) {
    target.__agComponentMetaData = {};
  }

  if (!target.__agComponentMetaData[instanceName]) {
    target.__agComponentMetaData[instanceName] = {};
  }

  return target.__agComponentMetaData[instanceName];
} // community-modules/core/src/filter/floating/provided/readOnlyFloatingFilter.ts


var ReadOnlyFloatingFilter =
/*#__PURE__*/
function (_Component3) {
  "use strict";

  _inherits(ReadOnlyFloatingFilter, _Component3);

  function ReadOnlyFloatingFilter() {
    _classCallCheck(this, ReadOnlyFloatingFilter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReadOnlyFloatingFilter).call(this,
    /* html */
    "\n            <div class=\"ag-floating-filter-input\" role=\"presentation\">\n                <ag-input-text-field ref=\"eFloatingFilterText\"></ag-input-text-field>\n            </div>"));
  } // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.


  _createClass(ReadOnlyFloatingFilter, [{
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(ReadOnlyFloatingFilter.prototype), "destroy", this).call(this);
    }
  }, {
    key: "init",
    value: function init(params) {
      this.params = params;
      var displayName = this.columnModel.getDisplayNameForColumn(params.column, "header", true);
      var translate = this.localeService.getLocaleTextFunc();
      this.eFloatingFilterText.setDisabled(true).setInputAriaLabel("".concat(displayName, " ").concat(translate("ariaFilterInput", "Filter Input")));
    }
  }, {
    key: "onParentModelChanged",
    value: function onParentModelChanged(parentModel) {
      var _this72 = this;

      if (parentModel == null) {
        this.eFloatingFilterText.setValue("");
        return;
      }

      this.params.parentFilterInstance(function (filterInstance) {
        if (filterInstance.getModelAsString) {
          var modelAsString = filterInstance.getModelAsString(parentModel);

          _this72.eFloatingFilterText.setValue(modelAsString);
        }
      });
    }
  }, {
    key: "onParamsUpdated",
    value: function onParamsUpdated(params) {
      this.refresh(params);
    }
  }, {
    key: "refresh",
    value: function refresh(params) {
      this.init(params);
    }
  }]);

  return ReadOnlyFloatingFilter;
}(_Component2);

__decorateClass([_RefSelector("eFloatingFilterText")], ReadOnlyFloatingFilter.prototype, "eFloatingFilterText", 2);

__decorateClass([_Autowired("columnModel")], ReadOnlyFloatingFilter.prototype, "columnModel", 2); // community-modules/core/src/filter/provided/date/dateCompWrapper.ts


var DateCompWrapper =
/*#__PURE__*/
function () {
  "use strict";

  function DateCompWrapper(context, userComponentFactory, dateComponentParams, eParent, onReady) {
    var _this73 = this;

    _classCallCheck(this, DateCompWrapper);

    this.alive = true;
    this.context = context;
    this.eParent = eParent;
    var compDetails = userComponentFactory.getDateCompDetails(dateComponentParams);
    var promise = compDetails.newAgStackInstance();
    promise.then(function (dateComp) {
      if (!_this73.alive) {
        context.destroyBean(dateComp);
        return;
      }

      _this73.dateComp = dateComp;

      if (!dateComp) {
        return;
      }

      eParent.appendChild(dateComp.getGui());

      if (dateComp.afterGuiAttached) {
        dateComp.afterGuiAttached();
      }

      if (_this73.tempValue) {
        dateComp.setDate(_this73.tempValue);
      }

      if (_this73.disabled != null) {
        _this73.setDateCompDisabled(_this73.disabled);
      }

      onReady == null ? void 0 : onReady(_this73);
    });
  }

  _createClass(DateCompWrapper, [{
    key: "destroy",
    value: function destroy() {
      this.alive = false;
      this.dateComp = this.context.destroyBean(this.dateComp);
    }
  }, {
    key: "getDate",
    value: function getDate() {
      return this.dateComp ? this.dateComp.getDate() : this.tempValue;
    }
  }, {
    key: "setDate",
    value: function setDate(value) {
      if (this.dateComp) {
        this.dateComp.setDate(value);
      } else {
        this.tempValue = value;
      }
    }
  }, {
    key: "setDisabled",
    value: function setDisabled(disabled) {
      if (this.dateComp) {
        this.setDateCompDisabled(disabled);
      } else {
        this.disabled = disabled;
      }
    }
  }, {
    key: "setDisplayed",
    value: function setDisplayed(displayed) {
      _setDisplayed(this.eParent, displayed);
    }
  }, {
    key: "setInputPlaceholder",
    value: function setInputPlaceholder(placeholder) {
      if (this.dateComp && this.dateComp.setInputPlaceholder) {
        this.dateComp.setInputPlaceholder(placeholder);
      }
    }
  }, {
    key: "setInputAriaLabel",
    value: function setInputAriaLabel(label) {
      if (this.dateComp && this.dateComp.setInputAriaLabel) {
        this.dateComp.setInputAriaLabel(label);
      }
    }
  }, {
    key: "afterGuiAttached",
    value: function afterGuiAttached(params) {
      if (this.dateComp && typeof this.dateComp.afterGuiAttached === "function") {
        this.dateComp.afterGuiAttached(params);
      }
    }
  }, {
    key: "updateParams",
    value: function updateParams(params) {
      var _a, _b;

      var hasRefreshed = false;

      if (((_a = this.dateComp) == null ? void 0 : _a.refresh) && typeof this.dateComp.refresh === "function") {
        var result = this.dateComp.refresh(params);

        if (result !== null) {
          hasRefreshed = true;
        }
      }

      if (!hasRefreshed && ((_b = this.dateComp) == null ? void 0 : _b.onParamsUpdated) && typeof this.dateComp.onParamsUpdated === "function") {
        var _result = this.dateComp.onParamsUpdated(params);

        if (_result !== null) {
          _warnOnce("Custom date component method 'onParamsUpdated' is deprecated. Use 'refresh' instead.");
        }
      }
    }
  }, {
    key: "setDateCompDisabled",
    value: function setDateCompDisabled(disabled) {
      if (this.dateComp == null) {
        return;
      }

      if (this.dateComp.setDisabled == null) {
        return;
      }

      this.dateComp.setDisabled(disabled);
    }
  }]);

  return DateCompWrapper;
}(); // community-modules/core/src/filter/provided/optionsFactory.ts


var OptionsFactory =
/*#__PURE__*/
function () {
  "use strict";

  function OptionsFactory() {
    _classCallCheck(this, OptionsFactory);

    this.customFilterOptions = {};
  }

  _createClass(OptionsFactory, [{
    key: "init",
    value: function init(params, defaultOptions) {
      this.filterOptions = params.filterOptions || defaultOptions;
      this.mapCustomOptions();
      this.selectDefaultItem(params);
    }
  }, {
    key: "getFilterOptions",
    value: function getFilterOptions() {
      return this.filterOptions;
    }
  }, {
    key: "mapCustomOptions",
    value: function mapCustomOptions() {
      var _this74 = this;

      if (!this.filterOptions) {
        return;
      }

      this.filterOptions.forEach(function (filterOption) {
        if (typeof filterOption === "string") {
          return;
        }

        var requiredProperties = [["displayKey"], ["displayName"], ["predicate", "test"]];

        var propertyCheck = function propertyCheck(keys2) {
          if (!keys2.some(function (key) {
            return filterOption[key] != null;
          })) {
            console.warn("AG Grid: ignoring FilterOptionDef as it doesn't contain one of '".concat(keys2, "'"));
            return false;
          }

          return true;
        };

        if (!requiredProperties.every(propertyCheck)) {
          _this74.filterOptions = _this74.filterOptions.filter(function (v) {
            return v === filterOption;
          }) || [];
          return;
        }

        _this74.customFilterOptions[filterOption.displayKey] = filterOption;
      });
    }
  }, {
    key: "selectDefaultItem",
    value: function selectDefaultItem(params) {
      if (params.defaultOption) {
        this.defaultOption = params.defaultOption;
      } else if (this.filterOptions.length >= 1) {
        var firstFilterOption = this.filterOptions[0];

        if (typeof firstFilterOption === "string") {
          this.defaultOption = firstFilterOption;
        } else if (firstFilterOption.displayKey) {
          this.defaultOption = firstFilterOption.displayKey;
        } else {
          console.warn("AG Grid: invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'");
        }
      } else {
        console.warn("AG Grid: no filter options for filter");
      }
    }
  }, {
    key: "getDefaultOption",
    value: function getDefaultOption() {
      return this.defaultOption;
    }
  }, {
    key: "getCustomOption",
    value: function getCustomOption(name) {
      return this.customFilterOptions[name];
    }
  }]);

  return OptionsFactory;
}(); // community-modules/core/src/filter/filterLocaleText.ts


var FILTER_LOCALE_TEXT = {
  applyFilter: "Apply",
  clearFilter: "Clear",
  resetFilter: "Reset",
  cancelFilter: "Cancel",
  textFilter: "Text Filter",
  numberFilter: "Number Filter",
  dateFilter: "Date Filter",
  setFilter: "Set Filter",
  filterOoo: "Filter...",
  empty: "Choose one",
  equals: "Equals",
  notEqual: "Does not equal",
  lessThan: "Less than",
  greaterThan: "Greater than",
  inRange: "Between",
  inRangeStart: "From",
  inRangeEnd: "To",
  lessThanOrEqual: "Less than or equal to",
  greaterThanOrEqual: "Greater than or equal to",
  contains: "Contains",
  notContains: "Does not contain",
  startsWith: "Begins with",
  endsWith: "Ends with",
  blank: "Blank",
  notBlank: "Not blank",
  before: "Before",
  after: "After",
  andCondition: "AND",
  orCondition: "OR",
  dateFormatOoo: "yyyy-mm-dd"
}; // community-modules/core/src/widgets/managedFocusFeature.ts

var _ManagedFocusFeature =
/*#__PURE__*/
function (_BeanStub11) {
  "use strict";

  _inherits(_ManagedFocusFeature, _BeanStub11);

  function _ManagedFocusFeature(eFocusableElement) {
    var _this75;

    var callbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, _ManagedFocusFeature);

    _this75 = _possibleConstructorReturn(this, _getPrototypeOf(_ManagedFocusFeature).call(this));
    _this75.eFocusableElement = eFocusableElement;
    _this75.callbacks = callbacks;
    _this75.callbacks = __spreadValues({
      shouldStopEventPropagation: function shouldStopEventPropagation() {
        return false;
      },
      onTabKeyDown: function onTabKeyDown(e) {
        if (e.defaultPrevented) {
          return;
        }

        var nextRoot = _this75.focusService.findNextFocusableElement(_this75.eFocusableElement, false, e.shiftKey);

        if (!nextRoot) {
          return;
        }

        nextRoot.focus();
        e.preventDefault();
      }
    }, callbacks);
    return _this75;
  }

  _createClass(_ManagedFocusFeature, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.eFocusableElement.classList.add(_ManagedFocusFeature.FOCUS_MANAGED_CLASS);
      this.addKeyDownListeners(this.eFocusableElement);

      if (this.callbacks.onFocusIn) {
        this.addManagedListener(this.eFocusableElement, "focusin", this.callbacks.onFocusIn);
      }

      if (this.callbacks.onFocusOut) {
        this.addManagedListener(this.eFocusableElement, "focusout", this.callbacks.onFocusOut);
      }
    }
  }, {
    key: "addKeyDownListeners",
    value: function addKeyDownListeners(eGui) {
      var _this76 = this;

      this.addManagedListener(eGui, "keydown", function (e) {
        if (e.defaultPrevented || _isStopPropagationForAgGrid(e)) {
          return;
        }

        if (_this76.callbacks.shouldStopEventPropagation(e)) {
          _stopPropagationForAgGrid(e);

          return;
        }

        if (e.key === _KeyCode.TAB) {
          _this76.callbacks.onTabKeyDown(e);
        } else if (_this76.callbacks.handleKeyDown) {
          _this76.callbacks.handleKeyDown(e);
        }
      });
    }
  }]);

  return _ManagedFocusFeature;
}(_BeanStub2);

_ManagedFocusFeature.FOCUS_MANAGED_CLASS = "ag-focus-managed";

__decorateClass([_Autowired("focusService")], _ManagedFocusFeature.prototype, "focusService", 2);

__decorateClass([_PostConstruct], _ManagedFocusFeature.prototype, "postConstruct", 1);

var _ManagedFocusFeature2 = _ManagedFocusFeature; // community-modules/core/src/rendering/features/positionableFeature.ts

var RESIZE_CONTAINER_STYLE = "ag-resizer-wrapper";
var RESIZE_TEMPLATE =
/* html */
"<div class=\"".concat(RESIZE_CONTAINER_STYLE, "\">\n        <div ref=\"eTopLeftResizer\" class=\"ag-resizer ag-resizer-topLeft\"></div>\n        <div ref=\"eTopResizer\" class=\"ag-resizer ag-resizer-top\"></div>\n        <div ref=\"eTopRightResizer\" class=\"ag-resizer ag-resizer-topRight\"></div>\n        <div ref=\"eRightResizer\" class=\"ag-resizer ag-resizer-right\"></div>\n        <div ref=\"eBottomRightResizer\" class=\"ag-resizer ag-resizer-bottomRight\"></div>\n        <div ref=\"eBottomResizer\" class=\"ag-resizer ag-resizer-bottom\"></div>\n        <div ref=\"eBottomLeftResizer\" class=\"ag-resizer ag-resizer-bottomLeft\"></div>\n        <div ref=\"eLeftResizer\" class=\"ag-resizer ag-resizer-left\"></div>\n    </div>");

var _PositionableFeature =
/*#__PURE__*/
function (_BeanStub12) {
  "use strict";

  _inherits(_PositionableFeature, _BeanStub12);

  function _PositionableFeature(element, config) {
    var _this77;

    _classCallCheck(this, _PositionableFeature);

    _this77 = _possibleConstructorReturn(this, _getPrototypeOf(_PositionableFeature).call(this));
    _this77.element = element;
    _this77.dragStartPosition = {
      x: 0,
      y: 0
    };
    _this77.position = {
      x: 0,
      y: 0
    };
    _this77.lastSize = {
      width: -1,
      height: -1
    };
    _this77.positioned = false;
    _this77.resizersAdded = false;
    _this77.resizeListeners = [];
    _this77.boundaryEl = null;
    _this77.isResizing = false;
    _this77.isMoving = false;
    _this77.resizable = {};
    _this77.movable = false;
    _this77.currentResizer = null;
    _this77.config = Object.assign({}, {
      popup: false
    }, config);
    return _this77;
  }

  _createClass(_PositionableFeature, [{
    key: "center",
    value: function center() {
      var _this$offsetParent = this.offsetParent,
          clientHeight = _this$offsetParent.clientHeight,
          clientWidth = _this$offsetParent.clientWidth;
      var x = clientWidth / 2 - this.getWidth() / 2;
      var y = clientHeight / 2 - this.getHeight() / 2;
      this.offsetElement(x, y);
    }
  }, {
    key: "initialisePosition",
    value: function initialisePosition() {
      if (this.positioned) {
        return;
      }

      var _this$config = this.config,
          centered = _this$config.centered,
          forcePopupParentAsOffsetParent = _this$config.forcePopupParentAsOffsetParent,
          minWidth = _this$config.minWidth,
          width = _this$config.width,
          minHeight = _this$config.minHeight,
          height = _this$config.height,
          x = _this$config.x,
          y = _this$config.y;

      if (!this.offsetParent) {
        this.setOffsetParent();
      }

      var computedMinHeight = 0;
      var computedMinWidth = 0;

      var isElementVisible = _isVisible(this.element);

      if (isElementVisible) {
        var boundaryEl = this.findBoundaryElement();
        var offsetParentComputedStyles = window.getComputedStyle(boundaryEl);

        if (offsetParentComputedStyles.minWidth != null) {
          var paddingWidth = boundaryEl.offsetWidth - this.element.offsetWidth;
          computedMinWidth = parseInt(offsetParentComputedStyles.minWidth, 10) - paddingWidth;
        }

        if (offsetParentComputedStyles.minHeight != null) {
          var paddingHeight = boundaryEl.offsetHeight - this.element.offsetHeight;
          computedMinHeight = parseInt(offsetParentComputedStyles.minHeight, 10) - paddingHeight;
        }
      }

      this.minHeight = minHeight || computedMinHeight;
      this.minWidth = minWidth || computedMinWidth;

      if (width) {
        this.setWidth(width);
      }

      if (height) {
        this.setHeight(height);
      }

      if (!width || !height) {
        this.refreshSize();
      }

      if (centered) {
        this.center();
      } else if (x || y) {
        this.offsetElement(x, y);
      } else if (isElementVisible && forcePopupParentAsOffsetParent) {
        var _boundaryEl = this.boundaryEl;
        var initialisedDuringPositioning = true;

        if (!_boundaryEl) {
          _boundaryEl = this.findBoundaryElement();
          initialisedDuringPositioning = false;
        }

        if (_boundaryEl) {
          var top = parseFloat(_boundaryEl.style.top);
          var left = parseFloat(_boundaryEl.style.left);

          if (initialisedDuringPositioning) {
            this.offsetElement(isNaN(left) ? 0 : left, isNaN(top) ? 0 : top);
          } else {
            this.setPosition(left, top);
          }
        }
      }

      this.positioned = !!this.offsetParent;
    }
  }, {
    key: "isPositioned",
    value: function isPositioned() {
      return this.positioned;
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return this.position;
    }
  }, {
    key: "setMovable",
    value: function setMovable(movable, moveElement) {
      if (!this.config.popup || movable === this.movable) {
        return;
      }

      this.movable = movable;
      var params = this.moveElementDragListener || {
        eElement: moveElement,
        onDragStart: this.onMoveStart.bind(this),
        onDragging: this.onMove.bind(this),
        onDragStop: this.onMoveEnd.bind(this)
      };

      if (movable) {
        this.dragService.addDragSource(params);
        this.moveElementDragListener = params;
      } else {
        this.dragService.removeDragSource(params);
        this.moveElementDragListener = void 0;
      }
    }
  }, {
    key: "setResizable",
    value: function setResizable(resizable) {
      var _this78 = this;

      this.clearResizeListeners();

      if (resizable) {
        this.addResizers();
      } else {
        this.removeResizers();
      }

      if (typeof resizable === "boolean") {
        if (resizable === false) {
          return;
        }

        resizable = {
          topLeft: resizable,
          top: resizable,
          topRight: resizable,
          right: resizable,
          bottomRight: resizable,
          bottom: resizable,
          bottomLeft: resizable,
          left: resizable
        };
      }

      Object.keys(resizable).forEach(function (side) {
        var resizableStructure = resizable;
        var isSideResizable = !!resizableStructure[side];

        var resizerEl = _this78.getResizerElement(side);

        var params = {
          dragStartPixels: 0,
          eElement: resizerEl,
          onDragStart: function onDragStart(e) {
            return _this78.onResizeStart(e, side);
          },
          onDragging: _this78.onResize.bind(_this78),
          onDragStop: function onDragStop(e) {
            return _this78.onResizeEnd(e, side);
          }
        };

        if (isSideResizable || !_this78.isAlive() && !isSideResizable) {
          if (isSideResizable) {
            _this78.dragService.addDragSource(params);

            _this78.resizeListeners.push(params);

            resizerEl.style.pointerEvents = "all";
          } else {
            resizerEl.style.pointerEvents = "none";
          }

          _this78.resizable[side] = isSideResizable;
        }
      });
    }
  }, {
    key: "removeSizeFromEl",
    value: function removeSizeFromEl() {
      this.element.style.removeProperty("height");
      this.element.style.removeProperty("width");
      this.element.style.removeProperty("flex");
    }
  }, {
    key: "restoreLastSize",
    value: function restoreLastSize() {
      this.element.style.flex = "0 0 auto";
      var _this$lastSize = this.lastSize,
          height = _this$lastSize.height,
          width = _this$lastSize.width;

      if (width !== -1) {
        this.element.style.width = "".concat(width, "px");
      }

      if (height !== -1) {
        this.element.style.height = "".concat(height, "px");
      }
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      return this.element.offsetHeight;
    }
  }, {
    key: "setHeight",
    value: function setHeight(height) {
      var popup = this.config.popup;
      var eGui = this.element;
      var isPercent = false;

      if (typeof height === "string" && height.indexOf("%") !== -1) {
        _setFixedHeight(eGui, height);

        height = _getAbsoluteHeight(eGui);
        isPercent = true;
      } else {
        height = Math.max(this.minHeight, height);

        if (this.positioned) {
          var availableHeight = this.getAvailableHeight();

          if (availableHeight && height > availableHeight) {
            height = availableHeight;
          }
        }
      }

      if (this.getHeight() === height) {
        return;
      }

      if (!isPercent) {
        if (popup) {
          _setFixedHeight(eGui, height);
        } else {
          eGui.style.height = "".concat(height, "px");
          eGui.style.flex = "0 0 auto";
          this.lastSize.height = typeof height === "number" ? height : parseFloat(height);
        }
      } else {
        eGui.style.maxHeight = "unset";
        eGui.style.minHeight = "unset";
      }
    }
  }, {
    key: "getAvailableHeight",
    value: function getAvailableHeight() {
      var _this$config2 = this.config,
          popup = _this$config2.popup,
          forcePopupParentAsOffsetParent = _this$config2.forcePopupParentAsOffsetParent;

      if (!this.positioned) {
        this.initialisePosition();
      }

      var clientHeight = this.offsetParent.clientHeight;

      if (!clientHeight) {
        return null;
      }

      var elRect = this.element.getBoundingClientRect();
      var offsetParentRect = this.offsetParent.getBoundingClientRect();
      var yPosition = popup ? this.position.y : elRect.top;
      var parentTop = popup ? 0 : offsetParentRect.top;
      var additionalHeight = 0;

      if (forcePopupParentAsOffsetParent) {
        var parentEl = this.element.parentElement;

        if (parentEl) {
          var _parentEl$getBounding = parentEl.getBoundingClientRect(),
              bottom = _parentEl$getBounding.bottom;

          additionalHeight = bottom - elRect.bottom;
        }
      }

      var availableHeight = clientHeight + parentTop - yPosition - additionalHeight;
      return availableHeight;
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.element.offsetWidth;
    }
  }, {
    key: "setWidth",
    value: function setWidth(width) {
      var eGui = this.element;
      var popup = this.config.popup;
      var isPercent = false;

      if (typeof width === "string" && width.indexOf("%") !== -1) {
        _setFixedWidth(eGui, width);

        width = _getAbsoluteWidth(eGui);
        isPercent = true;
      } else if (this.positioned) {
        width = Math.max(this.minWidth, width);
        var clientWidth = this.offsetParent.clientWidth;
        var xPosition = popup ? this.position.x : this.element.getBoundingClientRect().left;

        if (clientWidth && width + xPosition > clientWidth) {
          width = clientWidth - xPosition;
        }
      }

      if (this.getWidth() === width) {
        return;
      }

      if (!isPercent) {
        if (this.config.popup) {
          _setFixedWidth(eGui, width);
        } else {
          eGui.style.width = "".concat(width, "px");
          eGui.style.flex = " unset";
          this.lastSize.width = typeof width === "number" ? width : parseFloat(width);
        }
      } else {
        eGui.style.maxWidth = "unset";
        eGui.style.minWidth = "unset";
      }
    }
  }, {
    key: "offsetElement",
    value: function offsetElement() {
      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var forcePopupParentAsOffsetParent = this.config.forcePopupParentAsOffsetParent;
      var ePopup = forcePopupParentAsOffsetParent ? this.boundaryEl : this.element;

      if (!ePopup) {
        return;
      }

      this.popupService.positionPopup({
        ePopup: ePopup,
        keepWithinBounds: true,
        skipObserver: this.movable || this.isResizable(),
        updatePosition: function updatePosition() {
          return {
            x: x,
            y: y
          };
        }
      });
      this.setPosition(parseFloat(ePopup.style.left), parseFloat(ePopup.style.top));
    }
  }, {
    key: "constrainSizeToAvailableHeight",
    value: function constrainSizeToAvailableHeight(constrain) {
      var _this79 = this;

      if (!this.config.forcePopupParentAsOffsetParent) {
        return;
      }

      var applyMaxHeightToElement = function applyMaxHeightToElement() {
        var availableHeight = _this79.getAvailableHeight();

        _this79.element.style.setProperty("max-height", "".concat(availableHeight, "px"));
      };

      if (constrain) {
        this.resizeObserverSubscriber = this.resizeObserverService.observeResize(this.popupService.getPopupParent(), applyMaxHeightToElement);
      } else {
        this.element.style.removeProperty("max-height");

        if (this.resizeObserverSubscriber) {
          this.resizeObserverSubscriber();
          this.resizeObserverSubscriber = void 0;
        }
      }
    }
  }, {
    key: "setPosition",
    value: function setPosition(x, y) {
      this.position.x = x;
      this.position.y = y;
    }
  }, {
    key: "updateDragStartPosition",
    value: function updateDragStartPosition(x, y) {
      this.dragStartPosition = {
        x: x,
        y: y
      };
    }
  }, {
    key: "calculateMouseMovement",
    value: function calculateMouseMovement(params) {
      var e = params.e,
          isLeft = params.isLeft,
          isTop = params.isTop,
          anywhereWithin = params.anywhereWithin,
          topBuffer = params.topBuffer;
      var xDiff = e.clientX - this.dragStartPosition.x;
      var yDiff = e.clientY - this.dragStartPosition.y;
      var movementX = this.shouldSkipX(e, !!isLeft, !!anywhereWithin, xDiff) ? 0 : xDiff;
      var movementY = this.shouldSkipY(e, !!isTop, topBuffer, yDiff) ? 0 : yDiff;
      return {
        movementX: movementX,
        movementY: movementY
      };
    }
  }, {
    key: "shouldSkipX",
    value: function shouldSkipX(e, isLeft, anywhereWithin, diff) {
      var elRect = this.element.getBoundingClientRect();
      var parentRect = this.offsetParent.getBoundingClientRect();
      var boundaryElRect = this.boundaryEl.getBoundingClientRect();
      var xPosition = this.config.popup ? this.position.x : elRect.left;
      var skipX = xPosition <= 0 && parentRect.left >= e.clientX || parentRect.right <= e.clientX && parentRect.right <= boundaryElRect.right;

      if (skipX) {
        return true;
      }

      if (isLeft) {
        skipX = // skip if we are moving to the left and the cursor
        // is positioned to the right of the left side anchor
        diff < 0 && e.clientX > xPosition + parentRect.left || // skip if we are moving to the right and the cursor
        // is positioned to the left of the dialog
        diff > 0 && e.clientX < xPosition + parentRect.left;
      } else {
        if (anywhereWithin) {
          skipX = diff < 0 && e.clientX > boundaryElRect.right || diff > 0 && e.clientX < xPosition + parentRect.left;
        } else {
          skipX = // if the movement is bound to the right side of the dialog
          // we skip if we are moving to the left and the cursor
          // is to the right of the dialog
          diff < 0 && e.clientX > boundaryElRect.right || // or skip if we are moving to the right and the cursor
          // is to the left of the right side anchor
          diff > 0 && e.clientX < boundaryElRect.right;
        }
      }

      return skipX;
    }
  }, {
    key: "shouldSkipY",
    value: function shouldSkipY(e, isTop) {
      var topBuffer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var diff = arguments.length > 3 ? arguments[3] : undefined;
      var elRect = this.element.getBoundingClientRect();
      var parentRect = this.offsetParent.getBoundingClientRect();
      var boundaryElRect = this.boundaryEl.getBoundingClientRect();
      var yPosition = this.config.popup ? this.position.y : elRect.top;
      var skipY = yPosition <= 0 && parentRect.top >= e.clientY || parentRect.bottom <= e.clientY && parentRect.bottom <= boundaryElRect.bottom;

      if (skipY) {
        return true;
      }

      if (isTop) {
        skipY = // skip if we are moving to towards top and the cursor is
        // below the top anchor + topBuffer
        // note: topBuffer is used when moving the dialog using the title bar
        diff < 0 && e.clientY > yPosition + parentRect.top + topBuffer || // skip if we are moving to the bottom and the cursor is
        // above the top anchor
        diff > 0 && e.clientY < yPosition + parentRect.top;
      } else {
        skipY = // skip if we are moving towards the top and the cursor
        // is below the bottom anchor
        diff < 0 && e.clientY > boundaryElRect.bottom || // skip if we are moving towards the bottom and the cursor
        // is above the bottom anchor
        diff > 0 && e.clientY < boundaryElRect.bottom;
      }

      return skipY;
    }
  }, {
    key: "createResizeMap",
    value: function createResizeMap() {
      var eGui = this.element;
      this.resizerMap = {
        topLeft: {
          element: eGui.querySelector("[ref=eTopLeftResizer]")
        },
        top: {
          element: eGui.querySelector("[ref=eTopResizer]")
        },
        topRight: {
          element: eGui.querySelector("[ref=eTopRightResizer]")
        },
        right: {
          element: eGui.querySelector("[ref=eRightResizer]")
        },
        bottomRight: {
          element: eGui.querySelector("[ref=eBottomRightResizer]")
        },
        bottom: {
          element: eGui.querySelector("[ref=eBottomResizer]")
        },
        bottomLeft: {
          element: eGui.querySelector("[ref=eBottomLeftResizer]")
        },
        left: {
          element: eGui.querySelector("[ref=eLeftResizer]")
        }
      };
    }
  }, {
    key: "addResizers",
    value: function addResizers() {
      if (this.resizersAdded) {
        return;
      }

      var eGui = this.element;

      if (!eGui) {
        return;
      }

      var parser = new DOMParser();
      var resizers = parser.parseFromString(RESIZE_TEMPLATE, "text/html").body;
      eGui.appendChild(resizers.firstChild);
      this.createResizeMap();
      this.resizersAdded = true;
    }
  }, {
    key: "removeResizers",
    value: function removeResizers() {
      this.resizerMap = void 0;
      var resizerEl = this.element.querySelector(".".concat(RESIZE_CONTAINER_STYLE));

      if (resizerEl) {
        this.element.removeChild(resizerEl);
      }

      this.resizersAdded = false;
    }
  }, {
    key: "getResizerElement",
    value: function getResizerElement(side) {
      return this.resizerMap[side].element;
    }
  }, {
    key: "onResizeStart",
    value: function onResizeStart(e, side) {
      this.boundaryEl = this.findBoundaryElement();

      if (!this.positioned) {
        this.initialisePosition();
      }

      this.currentResizer = {
        isTop: !!side.match(/top/i),
        isRight: !!side.match(/right/i),
        isBottom: !!side.match(/bottom/i),
        isLeft: !!side.match(/left/i)
      };
      this.element.classList.add("ag-resizing");
      this.resizerMap[side].element.classList.add("ag-active");
      var _this$config3 = this.config,
          popup = _this$config3.popup,
          forcePopupParentAsOffsetParent = _this$config3.forcePopupParentAsOffsetParent;

      if (!popup && !forcePopupParentAsOffsetParent) {
        this.applySizeToSiblings(this.currentResizer.isBottom || this.currentResizer.isTop);
      }

      this.isResizing = true;
      this.updateDragStartPosition(e.clientX, e.clientY);
    }
  }, {
    key: "getSiblings",
    value: function getSiblings() {
      var element = this.element;
      var parent = element.parentElement;

      if (!parent) {
        return null;
      }

      return Array.prototype.slice.call(parent.children).filter(function (el) {
        return !el.classList.contains("ag-hidden");
      });
    }
  }, {
    key: "getMinSizeOfSiblings",
    value: function getMinSizeOfSiblings() {
      var siblings = this.getSiblings() || [];
      var height = 0;
      var width = 0;

      for (var i = 0; i < siblings.length; i++) {
        var currentEl = siblings[i];
        var isFlex = !!currentEl.style.flex && currentEl.style.flex !== "0 0 auto";

        if (currentEl === this.element) {
          continue;
        }

        var nextHeight = this.minHeight || 0;
        var nextWidth = this.minWidth || 0;

        if (isFlex) {
          var computedStyle = window.getComputedStyle(currentEl);

          if (computedStyle.minHeight) {
            nextHeight = parseInt(computedStyle.minHeight, 10);
          }

          if (computedStyle.minWidth) {
            nextWidth = parseInt(computedStyle.minWidth, 10);
          }
        } else {
          nextHeight = currentEl.offsetHeight;
          nextWidth = currentEl.offsetWidth;
        }

        height += nextHeight;
        width += nextWidth;
      }

      return {
        height: height,
        width: width
      };
    }
  }, {
    key: "applySizeToSiblings",
    value: function applySizeToSiblings(vertical) {
      var containerToFlex = null;
      var siblings = this.getSiblings();

      if (!siblings) {
        return;
      }

      for (var i = 0; i < siblings.length; i++) {
        var el = siblings[i];

        if (el === containerToFlex) {
          continue;
        }

        if (vertical) {
          el.style.height = "".concat(el.offsetHeight, "px");
        } else {
          el.style.width = "".concat(el.offsetWidth, "px");
        }

        el.style.flex = "0 0 auto";

        if (el === this.element) {
          containerToFlex = siblings[i + 1];
        }
      }

      if (containerToFlex) {
        containerToFlex.style.removeProperty("height");
        containerToFlex.style.removeProperty("min-height");
        containerToFlex.style.removeProperty("max-height");
        containerToFlex.style.flex = "1 1 auto";
      }
    }
  }, {
    key: "isResizable",
    value: function isResizable() {
      return Object.values(this.resizable).some(function (value) {
        return value;
      });
    }
  }, {
    key: "onResize",
    value: function onResize(e) {
      if (!this.isResizing || !this.currentResizer) {
        return;
      }

      var _this$config4 = this.config,
          popup = _this$config4.popup,
          forcePopupParentAsOffsetParent = _this$config4.forcePopupParentAsOffsetParent;
      var _this$currentResizer = this.currentResizer,
          isTop = _this$currentResizer.isTop,
          isRight = _this$currentResizer.isRight,
          isBottom = _this$currentResizer.isBottom,
          isLeft = _this$currentResizer.isLeft;
      var isHorizontal = isRight || isLeft;
      var isVertical = isBottom || isTop;

      var _this$calculateMouseM = this.calculateMouseMovement({
        e: e,
        isLeft: isLeft,
        isTop: isTop
      }),
          movementX = _this$calculateMouseM.movementX,
          movementY = _this$calculateMouseM.movementY;

      var xPosition = this.position.x;
      var yPosition = this.position.y;
      var offsetLeft = 0;
      var offsetTop = 0;

      if (isHorizontal && movementX) {
        var direction = isLeft ? -1 : 1;
        var oldWidth = this.getWidth();
        var newWidth = oldWidth + movementX * direction;
        var skipWidth = false;

        if (isLeft) {
          offsetLeft = oldWidth - newWidth;

          if (xPosition + offsetLeft <= 0 || newWidth <= this.minWidth) {
            skipWidth = true;
            offsetLeft = 0;
          }
        }

        if (!skipWidth) {
          this.setWidth(newWidth);
        }
      }

      if (isVertical && movementY) {
        var _direction = isTop ? -1 : 1;

        var oldHeight = this.getHeight();
        var newHeight = oldHeight + movementY * _direction;
        var skipHeight = false;

        if (isTop) {
          offsetTop = oldHeight - newHeight;

          if (yPosition + offsetTop <= 0 || newHeight <= this.minHeight) {
            skipHeight = true;
            offsetTop = 0;
          }
        } else {
          if (!this.config.popup && !this.config.forcePopupParentAsOffsetParent && oldHeight < newHeight && this.getMinSizeOfSiblings().height + newHeight > this.element.parentElement.offsetHeight) {
            skipHeight = true;
          }
        }

        if (!skipHeight) {
          this.setHeight(newHeight);
        }
      }

      this.updateDragStartPosition(e.clientX, e.clientY);

      if ((popup || forcePopupParentAsOffsetParent) && offsetLeft || offsetTop) {
        this.offsetElement(xPosition + offsetLeft, yPosition + offsetTop);
      }
    }
  }, {
    key: "onResizeEnd",
    value: function onResizeEnd(e, side) {
      this.isResizing = false;
      this.currentResizer = null;
      this.boundaryEl = null;
      var params = {
        type: "resize"
      };
      this.element.classList.remove("ag-resizing");
      this.resizerMap[side].element.classList.remove("ag-active");
      this.dispatchEvent(params);
    }
  }, {
    key: "refreshSize",
    value: function refreshSize() {
      var eGui = this.element;

      if (this.config.popup) {
        if (!this.config.width) {
          this.setWidth(eGui.offsetWidth);
        }

        if (!this.config.height) {
          this.setHeight(eGui.offsetHeight);
        }
      }
    }
  }, {
    key: "onMoveStart",
    value: function onMoveStart(e) {
      this.boundaryEl = this.findBoundaryElement();

      if (!this.positioned) {
        this.initialisePosition();
      }

      this.isMoving = true;
      this.element.classList.add("ag-moving");
      this.updateDragStartPosition(e.clientX, e.clientY);
    }
  }, {
    key: "onMove",
    value: function onMove(e) {
      if (!this.isMoving) {
        return;
      }

      var _this$position = this.position,
          x = _this$position.x,
          y = _this$position.y;
      var topBuffer;

      if (this.config.calculateTopBuffer) {
        topBuffer = this.config.calculateTopBuffer();
      }

      var _this$calculateMouseM2 = this.calculateMouseMovement({
        e: e,
        isTop: true,
        anywhereWithin: true,
        topBuffer: topBuffer
      }),
          movementX = _this$calculateMouseM2.movementX,
          movementY = _this$calculateMouseM2.movementY;

      this.offsetElement(x + movementX, y + movementY);
      this.updateDragStartPosition(e.clientX, e.clientY);
    }
  }, {
    key: "onMoveEnd",
    value: function onMoveEnd() {
      this.isMoving = false;
      this.boundaryEl = null;
      this.element.classList.remove("ag-moving");
    }
  }, {
    key: "setOffsetParent",
    value: function setOffsetParent() {
      if (this.config.forcePopupParentAsOffsetParent) {
        this.offsetParent = this.popupService.getPopupParent();
      } else {
        this.offsetParent = this.element.offsetParent;
      }
    }
  }, {
    key: "findBoundaryElement",
    value: function findBoundaryElement() {
      var el = this.element;

      while (el) {
        if (window.getComputedStyle(el).position !== "static") {
          return el;
        }

        el = el.parentElement;
      }

      return this.element;
    }
  }, {
    key: "clearResizeListeners",
    value: function clearResizeListeners() {
      while (this.resizeListeners.length) {
        var params = this.resizeListeners.pop();
        this.dragService.removeDragSource(params);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(_PositionableFeature.prototype), "destroy", this).call(this);

      if (this.moveElementDragListener) {
        this.dragService.removeDragSource(this.moveElementDragListener);
      }

      this.constrainSizeToAvailableHeight(false);
      this.clearResizeListeners();
      this.removeResizers();
    }
  }]);

  return _PositionableFeature;
}(_BeanStub2);

__decorateClass([_Autowired("popupService")], _PositionableFeature.prototype, "popupService", 2);

__decorateClass([_Autowired("resizeObserverService")], _PositionableFeature.prototype, "resizeObserverService", 2);

__decorateClass([_Autowired("dragService")], _PositionableFeature.prototype, "dragService", 2); // community-modules/core/src/filter/provided/providedFilter.ts


var _ProvidedFilter =
/*#__PURE__*/
function (_Component4) {
  "use strict";

  _inherits(_ProvidedFilter, _Component4);

  function _ProvidedFilter(filterNameKey) {
    var _this80;

    _classCallCheck(this, _ProvidedFilter);

    _this80 = _possibleConstructorReturn(this, _getPrototypeOf(_ProvidedFilter).call(this));
    _this80.filterNameKey = filterNameKey;
    _this80.applyActive = false;
    _this80.hidePopup = null;
    _this80.debouncePending = false; // after the user hits 'apply' the model gets copied to here. this is then the model that we use for
    // all filtering. so if user changes UI but doesn't hit apply, then the UI will be out of sync with this model.
    // this is what we want, as the UI should only become the 'active' filter once it's applied. when apply is
    // inactive, this model will be in sync (following the debounce ms). if the UI is not a valid filter
    // (eg the value is missing so nothing to filter on, or for set filter all checkboxes are checked so filter
    // not active) then this appliedModel will be null/undefined.

    _this80.appliedModel = null;
    _this80.buttonListeners = [];
    return _this80;
  }

  _createClass(_ProvidedFilter, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.resetTemplate();
      this.createManagedBean(new _ManagedFocusFeature2(this.getFocusableElement(), {
        handleKeyDown: this.handleKeyDown.bind(this)
      }));
      this.positionableFeature = new _PositionableFeature(this.getPositionableElement(), {
        forcePopupParentAsOffsetParent: true
      });
      this.createBean(this.positionableFeature);
    } // override

  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {}
  }, {
    key: "getFilterTitle",
    value: function getFilterTitle() {
      return this.translate(this.filterNameKey);
    }
  }, {
    key: "isFilterActive",
    value: function isFilterActive() {
      return !!this.appliedModel;
    }
  }, {
    key: "resetTemplate",
    value: function resetTemplate(paramsMap) {
      var eGui = this.getGui();

      if (eGui) {
        eGui.removeEventListener("submit", this.onFormSubmit);
      }

      var templateString =
      /* html */
      "\n            <form class=\"ag-filter-wrapper\">\n                <div class=\"ag-filter-body-wrapper ag-".concat(this.getCssIdentifier(), "-body-wrapper\" ref=\"eFilterBody\">\n                    ").concat(this.createBodyTemplate(), "\n                </div>\n            </form>");
      this.setTemplate(templateString, paramsMap);
      eGui = this.getGui();

      if (eGui) {
        eGui.addEventListener("submit", this.onFormSubmit);
      }
    }
  }, {
    key: "isReadOnly",
    value: function isReadOnly() {
      return !!this.providedFilterParams.readOnly;
    }
  }, {
    key: "init",
    value: function init(params) {
      var _this81 = this;

      this.setParams(params);
      this.resetUiToDefaults(true).then(function () {
        _this81.updateUiVisibility();

        _this81.setupOnBtApplyDebounce();
      });
    }
  }, {
    key: "setParams",
    value: function setParams(params) {
      this.providedFilterParams = params;
      this.applyActive = _ProvidedFilter.isUseApplyButton(params);
      this.resetButtonsPanel();
    }
  }, {
    key: "updateParams",
    value: function updateParams(params) {
      var _this82 = this;

      this.providedFilterParams = params;
      this.applyActive = _ProvidedFilter.isUseApplyButton(params);
      this.resetUiToActiveModel(this.getModel(), function () {
        _this82.updateUiVisibility();

        _this82.setupOnBtApplyDebounce();
      });
    }
  }, {
    key: "resetButtonsPanel",
    value: function resetButtonsPanel() {
      var _this83 = this;

      var buttons = this.providedFilterParams.buttons;
      var hasButtons = buttons && buttons.length > 0 && !this.isReadOnly();

      if (!this.eButtonsPanel) {
        if (hasButtons) {
          this.eButtonsPanel = document.createElement("div");
          this.eButtonsPanel.classList.add("ag-filter-apply-panel");
        }
      } else {
        _clearElement(this.eButtonsPanel);

        this.buttonListeners.forEach(function (destroyFunc) {
          return destroyFunc == null ? void 0 : destroyFunc();
        });
        this.buttonListeners = [];
      }

      if (!hasButtons) {
        if (this.eButtonsPanel) {
          _removeFromParent(this.eButtonsPanel);
        }

        return;
      }

      var fragment = document.createDocumentFragment();

      var addButton = function addButton(type) {
        var text;
        var clickListener;

        switch (type) {
          case "apply":
            text = _this83.translate("applyFilter");

            clickListener = function clickListener(e) {
              return _this83.onBtApply(false, false, e);
            };

            break;

          case "clear":
            text = _this83.translate("clearFilter");

            clickListener = function clickListener() {
              return _this83.onBtClear();
            };

            break;

          case "reset":
            text = _this83.translate("resetFilter");

            clickListener = function clickListener() {
              return _this83.onBtReset();
            };

            break;

          case "cancel":
            text = _this83.translate("cancelFilter");

            clickListener = function clickListener(e) {
              _this83.onBtCancel(e);
            };

            break;

          default:
            console.warn("AG Grid: Unknown button type specified");
            return;
        }

        var buttonType = type === "apply" ? "submit" : "button";

        var button = _loadTemplate(
        /* html */
        "<button\n                    type=\"".concat(buttonType, "\"\n                    ref=\"").concat(type, "FilterButton\"\n                    class=\"ag-button ag-standard-button ag-filter-apply-panel-button\"\n                >").concat(text, "\n                </button>"));

        _this83.buttonListeners.push(_this83.addManagedListener(button, "click", clickListener));

        fragment.append(button);
      };

      _convertToSet(buttons).forEach(function (type) {
        return addButton(type);
      });

      this.eButtonsPanel.append(fragment);
      this.getGui().appendChild(this.eButtonsPanel);
    } // subclasses can override this to provide alternative debounce defaults

  }, {
    key: "getDefaultDebounceMs",
    value: function getDefaultDebounceMs() {
      return 0;
    }
  }, {
    key: "setupOnBtApplyDebounce",
    value: function setupOnBtApplyDebounce() {
      var _this84 = this;

      var debounceMs = _ProvidedFilter.getDebounceMs(this.providedFilterParams, this.getDefaultDebounceMs());

      var debounceFunc = _debounce(this.checkApplyDebounce.bind(this), debounceMs);

      this.onBtApplyDebounce = function () {
        _this84.debouncePending = true;
        debounceFunc();
      };
    }
  }, {
    key: "checkApplyDebounce",
    value: function checkApplyDebounce() {
      if (this.debouncePending) {
        this.debouncePending = false;
        this.onBtApply();
      }
    }
  }, {
    key: "getModel",
    value: function getModel() {
      return this.appliedModel ? this.appliedModel : null;
    }
  }, {
    key: "setModel",
    value: function setModel(model) {
      var _this85 = this;

      var promise = model != null ? this.setModelIntoUi(model) : this.resetUiToDefaults();
      return promise.then(function () {
        _this85.updateUiVisibility();

        _this85.applyModel("api");
      });
    }
  }, {
    key: "onBtCancel",
    value: function onBtCancel(e) {
      var _this86 = this;

      this.resetUiToActiveModel(this.getModel(), function () {
        _this86.handleCancelEnd(e);
      });
    }
  }, {
    key: "handleCancelEnd",
    value: function handleCancelEnd(e) {
      if (this.providedFilterParams.closeOnApply) {
        this.close(e);
      }
    }
  }, {
    key: "resetUiToActiveModel",
    value: function resetUiToActiveModel(currentModel, afterUiUpdatedFunc) {
      var _this87 = this;

      var afterAppliedFunc = function afterAppliedFunc() {
        _this87.onUiChanged(false, "prevent");

        afterUiUpdatedFunc == null ? void 0 : afterUiUpdatedFunc();
      };

      if (currentModel != null) {
        this.setModelIntoUi(currentModel).then(afterAppliedFunc);
      } else {
        this.resetUiToDefaults().then(afterAppliedFunc);
      }
    }
  }, {
    key: "onBtClear",
    value: function onBtClear() {
      var _this88 = this;

      this.resetUiToDefaults().then(function () {
        return _this88.onUiChanged();
      });
    }
  }, {
    key: "onBtReset",
    value: function onBtReset() {
      this.onBtClear();
      this.onBtApply();
    }
    /**
     * Applies changes made in the UI to the filter, and returns true if the model has changed.
     */

  }, {
    key: "applyModel",
    value: function applyModel() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "api";
      var newModel = this.getModelFromUi();

      if (!this.isModelValid(newModel)) {
        return false;
      }

      var previousModel = this.appliedModel;
      this.appliedModel = newModel;
      return !this.areModelsEqual(previousModel, newModel);
    }
  }, {
    key: "isModelValid",
    value: function isModelValid(model) {
      return true;
    }
  }, {
    key: "onFormSubmit",
    value: function onFormSubmit(e) {
      e.preventDefault();
    }
  }, {
    key: "onBtApply",
    value: function onBtApply() {
      var afterFloatingFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var afterDataChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var e = arguments.length > 2 ? arguments[2] : undefined;

      if (e) {
        e.preventDefault();
      }

      if (this.applyModel(afterDataChange ? "rowDataUpdated" : "ui")) {
        var source = "columnFilter";
        this.providedFilterParams.filterChangedCallback({
          afterFloatingFilter: afterFloatingFilter,
          afterDataChange: afterDataChange,
          source: source
        });
      }

      var closeOnApply = this.providedFilterParams.closeOnApply;

      if (closeOnApply && this.applyActive && !afterFloatingFilter && !afterDataChange) {
        this.close(e);
      }
    }
  }, {
    key: "onNewRowsLoaded",
    value: function onNewRowsLoaded() {}
  }, {
    key: "close",
    value: function close(e) {
      if (!this.hidePopup) {
        return;
      }

      var keyboardEvent = e;
      var key = keyboardEvent && keyboardEvent.key;
      var params;

      if (key === "Enter" || key === "Space") {
        params = {
          keyboardEvent: keyboardEvent
        };
      }

      this.hidePopup(params);
      this.hidePopup = null;
    }
    /**
     * By default, if the change came from a floating filter it will be applied immediately, otherwise if there is no
     * apply button it will be applied after a debounce, otherwise it will not be applied at all. This behaviour can
     * be adjusted by using the apply parameter.
     */

  }, {
    key: "onUiChanged",
    value: function onUiChanged() {
      var fromFloatingFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var apply = arguments.length > 1 ? arguments[1] : undefined;
      this.updateUiVisibility();
      this.providedFilterParams.filterModifiedCallback();

      if (this.applyActive && !this.isReadOnly()) {
        var isValid = this.isModelValid(this.getModelFromUi());
        var applyFilterButton = this.getRefElement("applyFilterButton");

        if (applyFilterButton) {
          _setDisabled(applyFilterButton, !isValid);
        }
      }

      if (fromFloatingFilter && !apply || apply === "immediately") {
        this.onBtApply(fromFloatingFilter);
      } else if (!this.applyActive && !apply || apply === "debounce") {
        this.onBtApplyDebounce();
      }
    }
  }, {
    key: "afterGuiAttached",
    value: function afterGuiAttached(params) {
      if (params) {
        this.hidePopup = params.hidePopup;
      }

      this.refreshFilterResizer(params == null ? void 0 : params.container);
    }
  }, {
    key: "refreshFilterResizer",
    value: function refreshFilterResizer(containerType) {
      if (!this.positionableFeature || containerType === "toolPanel") {
        return;
      }

      var isResizable = containerType === "floatingFilter" || containerType === "columnFilter";
      var positionableFeature = this.positionableFeature,
          gos = this.gos;

      if (isResizable) {
        positionableFeature.restoreLastSize();
        positionableFeature.setResizable(gos.get("enableRtl") ? {
          bottom: true,
          bottomLeft: true,
          left: true
        } : {
          bottom: true,
          bottomRight: true,
          right: true
        });
      } else {
        this.positionableFeature.removeSizeFromEl();
        this.positionableFeature.setResizable(false);
      }

      this.positionableFeature.constrainSizeToAvailableHeight(true);
    }
  }, {
    key: "afterGuiDetached",
    value: function afterGuiDetached() {
      this.checkApplyDebounce();

      if (this.positionableFeature) {
        this.positionableFeature.constrainSizeToAvailableHeight(false);
      }
    } // static, as used by floating filter also

  }, {
    key: "refresh",
    value: function refresh(newParams) {
      this.providedFilterParams = newParams;
      return true;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var eGui = this.getGui();

      if (eGui) {
        eGui.removeEventListener("submit", this.onFormSubmit);
      }

      this.hidePopup = null;

      if (this.positionableFeature) {
        this.positionableFeature = this.destroyBean(this.positionableFeature);
      }

      this.appliedModel = null;

      _get(_getPrototypeOf(_ProvidedFilter.prototype), "destroy", this).call(this);
    }
  }, {
    key: "translate",
    value: function translate(key) {
      var translate = this.localeService.getLocaleTextFunc();
      return translate(key, FILTER_LOCALE_TEXT[key]);
    }
  }, {
    key: "getCellValue",
    value: function getCellValue(rowNode) {
      return this.providedFilterParams.getValue(rowNode);
    } // override to control positionable feature

  }, {
    key: "getPositionableElement",
    value: function getPositionableElement() {
      return this.eFilterBody;
    }
  }], [{
    key: "getDebounceMs",
    value: function getDebounceMs(params, debounceDefault) {
      if (_ProvidedFilter.isUseApplyButton(params)) {
        if (params.debounceMs != null) {
          console.warn("AG Grid: debounceMs is ignored when apply button is present");
        }

        return 0;
      }

      return params.debounceMs != null ? params.debounceMs : debounceDefault;
    } // static, as used by floating filter also

  }, {
    key: "isUseApplyButton",
    value: function isUseApplyButton(params) {
      return !!params.buttons && params.buttons.indexOf("apply") >= 0;
    }
  }]);

  return _ProvidedFilter;
}(_Component2);

__decorateClass([_Autowired("rowModel")], _ProvidedFilter.prototype, "rowModel", 2);

__decorateClass([_RefSelector("eFilterBody")], _ProvidedFilter.prototype, "eFilterBody", 2);

__decorateClass([_PostConstruct], _ProvidedFilter.prototype, "postConstruct", 1);

var _ProvidedFilter2 = _ProvidedFilter; // community-modules/core/src/widgets/agAbstractLabel.ts

var _AgAbstractLabel =
/*#__PURE__*/
function (_Component5) {
  "use strict";

  _inherits(_AgAbstractLabel, _Component5);

  function _AgAbstractLabel(config, template) {
    var _this89;

    _classCallCheck(this, _AgAbstractLabel);

    _this89 = _possibleConstructorReturn(this, _getPrototypeOf(_AgAbstractLabel).call(this, template));
    _this89.labelSeparator = "";
    _this89.labelAlignment = "left";
    _this89.disabled = false;
    _this89.label = "";
    _this89.config = config || {};
    return _this89;
  }

  _createClass(_AgAbstractLabel, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.addCssClass("ag-labeled");
      this.eLabel.classList.add("ag-label");
      var _this$config5 = this.config,
          labelSeparator = _this$config5.labelSeparator,
          label = _this$config5.label,
          labelWidth = _this$config5.labelWidth,
          labelAlignment = _this$config5.labelAlignment,
          disabled = _this$config5.disabled;

      if (disabled != null) {
        this.setDisabled(disabled);
      }

      if (labelSeparator != null) {
        this.setLabelSeparator(labelSeparator);
      }

      if (label != null) {
        this.setLabel(label);
      }

      if (labelWidth != null) {
        this.setLabelWidth(labelWidth);
      }

      this.setLabelAlignment(labelAlignment || this.labelAlignment);
      this.refreshLabel();
    }
  }, {
    key: "refreshLabel",
    value: function refreshLabel() {
      _clearElement(this.eLabel);

      if (typeof this.label === "string") {
        this.eLabel.innerText = this.label + this.labelSeparator;
      } else if (this.label) {
        this.eLabel.appendChild(this.label);
      }

      if (this.label === "") {
        _setDisplayed(this.eLabel, false);

        _setAriaRole(this.eLabel, "presentation");
      } else {
        _setDisplayed(this.eLabel, true);

        _setAriaRole(this.eLabel, null);
      }
    }
  }, {
    key: "setLabelSeparator",
    value: function setLabelSeparator(labelSeparator) {
      if (this.labelSeparator === labelSeparator) {
        return this;
      }

      this.labelSeparator = labelSeparator;

      if (this.label != null) {
        this.refreshLabel();
      }

      return this;
    }
  }, {
    key: "getLabelId",
    value: function getLabelId() {
      this.eLabel.id = this.eLabel.id || "ag-".concat(this.getCompId(), "-label");
      return this.eLabel.id;
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this.label;
    }
  }, {
    key: "setLabel",
    value: function setLabel(label) {
      if (this.label === label) {
        return this;
      }

      this.label = label;
      this.refreshLabel();
      return this;
    }
  }, {
    key: "setLabelAlignment",
    value: function setLabelAlignment(alignment) {
      var eGui = this.getGui();
      var eGuiClassList = eGui.classList;
      eGuiClassList.toggle("ag-label-align-left", alignment === "left");
      eGuiClassList.toggle("ag-label-align-right", alignment === "right");
      eGuiClassList.toggle("ag-label-align-top", alignment === "top");
      return this;
    }
  }, {
    key: "setLabelEllipsis",
    value: function setLabelEllipsis(hasEllipsis) {
      this.eLabel.classList.toggle("ag-label-ellipsis", hasEllipsis);
      return this;
    }
  }, {
    key: "setLabelWidth",
    value: function setLabelWidth(width) {
      if (this.label == null) {
        return this;
      }

      _setElementWidth(this.eLabel, width);

      return this;
    }
  }, {
    key: "setDisabled",
    value: function setDisabled(disabled) {
      disabled = !!disabled;
      var element = this.getGui();

      _setDisabled(element, disabled);

      element.classList.toggle("ag-disabled", disabled);
      this.disabled = disabled;
      return this;
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      return !!this.disabled;
    }
  }]);

  return _AgAbstractLabel;
}(_Component2);

__decorateClass([_PostConstruct], _AgAbstractLabel.prototype, "postConstruct", 1); // community-modules/core/src/widgets/agAbstractField.ts


var _AgAbstractField =
/*#__PURE__*/
function (_AgAbstractLabel2) {
  "use strict";

  _inherits(_AgAbstractField, _AgAbstractLabel2);

  function _AgAbstractField(config, template, className) {
    var _this90;

    _classCallCheck(this, _AgAbstractField);

    _this90 = _possibleConstructorReturn(this, _getPrototypeOf(_AgAbstractField).call(this, config, template));
    _this90.className = className;
    return _this90;
  }

  _createClass(_AgAbstractField, [{
    key: "postConstruct",
    value: function postConstruct() {
      _get(_getPrototypeOf(_AgAbstractField.prototype), "postConstruct", this).call(this);

      var _this$config6 = this.config,
          width = _this$config6.width,
          value = _this$config6.value,
          onValueChange = _this$config6.onValueChange;

      if (width != null) {
        this.setWidth(width);
      }

      if (value != null) {
        this.setValue(value);
      }

      if (onValueChange != null) {
        this.onValueChange(onValueChange);
      }

      if (this.className) {
        this.addCssClass(this.className);
      }

      this.refreshAriaLabelledBy();
    }
  }, {
    key: "refreshAriaLabelledBy",
    value: function refreshAriaLabelledBy() {
      var ariaEl = this.getAriaElement();
      var labelId = this.getLabelId();

      if (_getAriaLabel(ariaEl) !== null) {
        _setAriaLabelledBy(ariaEl, "");
      } else {
        _setAriaLabelledBy(ariaEl, labelId != null ? labelId : "");
      }
    }
  }, {
    key: "setAriaLabel",
    value: function setAriaLabel(label) {
      _setAriaLabel(this.getAriaElement(), label);

      this.refreshAriaLabelledBy();
      return this;
    }
  }, {
    key: "onValueChange",
    value: function onValueChange(callbackFn) {
      var _this91 = this;

      this.addManagedListener(this, _Events.EVENT_FIELD_VALUE_CHANGED, function () {
        return callbackFn(_this91.getValue());
      });
      return this;
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.getGui().clientWidth;
    }
  }, {
    key: "setWidth",
    value: function setWidth(width) {
      _setFixedWidth(this.getGui(), width);

      return this;
    }
  }, {
    key: "getPreviousValue",
    value: function getPreviousValue() {
      return this.previousValue;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "setValue",
    value: function setValue(value, silent) {
      if (this.value === value) {
        return this;
      }

      this.previousValue = this.value;
      this.value = value;

      if (!silent) {
        this.dispatchEvent({
          type: _Events.EVENT_FIELD_VALUE_CHANGED
        });
      }

      return this;
    }
  }]);

  return _AgAbstractField;
}(_AgAbstractLabel); // community-modules/core/src/widgets/agPickerField.ts


var TEMPLATE =
/* html */
"\n    <div class=\"ag-picker-field\" role=\"presentation\">\n        <div ref=\"eLabel\"></div>\n            <div ref=\"eWrapper\" class=\"ag-wrapper ag-picker-field-wrapper ag-picker-collapsed\">\n            <div ref=\"eDisplayField\" class=\"ag-picker-field-display\"></div>\n            <div ref=\"eIcon\" class=\"ag-picker-field-icon\" aria-hidden=\"true\"></div>\n        </div>\n    </div>";

var _AgPickerField =
/*#__PURE__*/
function (_AgAbstractField2) {
  "use strict";

  _inherits(_AgPickerField, _AgAbstractField2);

  function _AgPickerField(config) {
    var _this92;

    _classCallCheck(this, _AgPickerField);

    _this92 = _possibleConstructorReturn(this, _getPrototypeOf(_AgPickerField).call(this, config, (config == null ? void 0 : config.template) || TEMPLATE, config == null ? void 0 : config.className));
    _this92.isPickerDisplayed = false;
    _this92.skipClick = false;
    _this92.pickerGap = 4;
    _this92.hideCurrentPicker = null;
    _this92.ariaRole = config == null ? void 0 : config.ariaRole;
    _this92.onPickerFocusIn = _this92.onPickerFocusIn.bind(_assertThisInitialized(_this92));
    _this92.onPickerFocusOut = _this92.onPickerFocusOut.bind(_assertThisInitialized(_this92));

    if (!config) {
      return _possibleConstructorReturn(_this92);
    }

    var pickerGap = config.pickerGap,
        maxPickerHeight = config.maxPickerHeight,
        variableWidth = config.variableWidth,
        minPickerWidth = config.minPickerWidth,
        maxPickerWidth = config.maxPickerWidth;

    if (pickerGap != null) {
      _this92.pickerGap = pickerGap;
    }

    _this92.variableWidth = !!variableWidth;

    if (maxPickerHeight != null) {
      _this92.setPickerMaxHeight(maxPickerHeight);
    }

    if (minPickerWidth != null) {
      _this92.setPickerMinWidth(minPickerWidth);
    }

    if (maxPickerWidth != null) {
      _this92.setPickerMaxWidth(maxPickerWidth);
    }

    return _this92;
  }

  _createClass(_AgPickerField, [{
    key: "postConstruct",
    value: function postConstruct() {
      _get(_getPrototypeOf(_AgPickerField.prototype), "postConstruct", this).call(this);

      this.setupAria();
      var displayId = "ag-".concat(this.getCompId(), "-display");
      this.eDisplayField.setAttribute("id", displayId);
      var ariaEl = this.getAriaElement();
      this.addManagedListener(ariaEl, "keydown", this.onKeyDown.bind(this));
      this.addManagedListener(this.eLabel, "mousedown", this.onLabelOrWrapperMouseDown.bind(this));
      this.addManagedListener(this.eWrapper, "mousedown", this.onLabelOrWrapperMouseDown.bind(this));
      var _this$config7 = this.config,
          pickerIcon = _this$config7.pickerIcon,
          inputWidth = _this$config7.inputWidth;

      if (pickerIcon) {
        var icon = _createIconNoSpan(pickerIcon, this.gos);

        if (icon) {
          this.eIcon.appendChild(icon);
        }
      }

      if (inputWidth != null) {
        this.setInputWidth(inputWidth);
      }
    }
  }, {
    key: "setupAria",
    value: function setupAria() {
      var ariaEl = this.getAriaElement();
      ariaEl.setAttribute("tabindex", this.gos.get("tabIndex").toString());

      _setAriaExpanded(ariaEl, false);

      if (this.ariaRole) {
        _setAriaRole(ariaEl, this.ariaRole);
      }
    }
  }, {
    key: "onLabelOrWrapperMouseDown",
    value: function onLabelOrWrapperMouseDown(e) {
      if (e) {
        var focusableEl = this.getFocusableElement();

        if (focusableEl !== this.eWrapper && (e == null ? void 0 : e.target) === focusableEl) {
          return;
        }

        e.preventDefault();
        this.getFocusableElement().focus();
      }

      if (this.skipClick) {
        this.skipClick = false;
        return;
      }

      if (this.isDisabled()) {
        return;
      }

      if (this.isPickerDisplayed) {
        this.hidePicker();
      } else {
        this.showPicker();
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      switch (e.key) {
        case _KeyCode.UP:
        case _KeyCode.DOWN:
        case _KeyCode.ENTER:
        case _KeyCode.SPACE:
          e.preventDefault();
          this.onLabelOrWrapperMouseDown();
          break;

        case _KeyCode.ESCAPE:
          if (this.isPickerDisplayed) {
            e.preventDefault();
            e.stopPropagation();

            if (this.hideCurrentPicker) {
              this.hideCurrentPicker();
            }
          }

          break;
      }
    }
  }, {
    key: "showPicker",
    value: function showPicker() {
      this.isPickerDisplayed = true;

      if (!this.pickerComponent) {
        this.pickerComponent = this.createPickerComponent();
      }

      var pickerGui = this.pickerComponent.getGui();
      pickerGui.addEventListener("focusin", this.onPickerFocusIn);
      pickerGui.addEventListener("focusout", this.onPickerFocusOut);
      this.hideCurrentPicker = this.renderAndPositionPicker();
      this.toggleExpandedStyles(true);
    }
  }, {
    key: "renderAndPositionPicker",
    value: function renderAndPositionPicker() {
      var _this93 = this;

      var eDocument = this.gos.getDocument();
      var ePicker = this.pickerComponent.getGui();

      if (!this.gos.get("suppressScrollWhenPopupsAreOpen")) {
        this.destroyMouseWheelFunc = this.addManagedListener(this.eventService, _Events.EVENT_BODY_SCROLL, function () {
          _this93.hidePicker();
        });
      }

      var translate = this.localeService.getLocaleTextFunc();
      var _this$config8 = this.config,
          pickerAriaLabelKey = _this$config8.pickerAriaLabelKey,
          pickerAriaLabelValue = _this$config8.pickerAriaLabelValue,
          _this$config8$modalPi = _this$config8.modalPicker,
          modalPicker = _this$config8$modalPi === void 0 ? true : _this$config8$modalPi;
      var popupParams = {
        modal: modalPicker,
        eChild: ePicker,
        closeOnEsc: true,
        closedCallback: function closedCallback() {
          var activeEl = _this93.gos.getActiveDomElement();

          var shouldRestoreFocus = !activeEl || activeEl === eDocument.body;

          _this93.beforeHidePicker();

          if (shouldRestoreFocus && _this93.isAlive()) {
            _this93.getFocusableElement().focus();
          }
        },
        ariaLabel: translate(pickerAriaLabelKey, pickerAriaLabelValue)
      };
      var addPopupRes = this.popupService.addPopup(popupParams);
      var maxPickerHeight = this.maxPickerHeight,
          minPickerWidth = this.minPickerWidth,
          maxPickerWidth = this.maxPickerWidth,
          variableWidth = this.variableWidth;

      if (variableWidth) {
        if (minPickerWidth) {
          ePicker.style.minWidth = minPickerWidth;
        }

        ePicker.style.width = _formatSize(_getAbsoluteWidth(this.eWrapper));

        if (maxPickerWidth) {
          ePicker.style.maxWidth = maxPickerWidth;
        }
      } else {
        _setElementWidth(ePicker, maxPickerWidth != null ? maxPickerWidth : _getAbsoluteWidth(this.eWrapper));
      }

      var maxHeight = maxPickerHeight != null ? maxPickerHeight : "".concat(_getInnerHeight(this.popupService.getPopupParent()), "px");
      ePicker.style.setProperty("max-height", maxHeight);
      ePicker.style.position = "absolute";
      this.alignPickerToComponent();
      return addPopupRes.hideFunc;
    }
  }, {
    key: "alignPickerToComponent",
    value: function alignPickerToComponent() {
      if (!this.pickerComponent) {
        return;
      }

      var pickerType = this.config.pickerType;
      var pickerGap = this.pickerGap;
      var alignSide = this.gos.get("enableRtl") ? "right" : "left";
      this.popupService.positionPopupByComponent({
        type: pickerType,
        eventSource: this.eWrapper,
        ePopup: this.pickerComponent.getGui(),
        position: "under",
        alignSide: alignSide,
        keepWithinBounds: true,
        nudgeY: pickerGap
      });
    }
  }, {
    key: "beforeHidePicker",
    value: function beforeHidePicker() {
      if (this.destroyMouseWheelFunc) {
        this.destroyMouseWheelFunc();
        this.destroyMouseWheelFunc = void 0;
      }

      this.toggleExpandedStyles(false);
      var pickerGui = this.pickerComponent.getGui();
      pickerGui.removeEventListener("focusin", this.onPickerFocusIn);
      pickerGui.removeEventListener("focusout", this.onPickerFocusOut);
      this.isPickerDisplayed = false;
      this.pickerComponent = void 0;
      this.hideCurrentPicker = null;
    }
  }, {
    key: "toggleExpandedStyles",
    value: function toggleExpandedStyles(expanded) {
      if (!this.isAlive()) {
        return;
      }

      var ariaEl = this.getAriaElement();

      _setAriaExpanded(ariaEl, expanded);

      this.eWrapper.classList.toggle("ag-picker-expanded", expanded);
      this.eWrapper.classList.toggle("ag-picker-collapsed", !expanded);
    }
  }, {
    key: "onPickerFocusIn",
    value: function onPickerFocusIn() {
      this.togglePickerHasFocus(true);
    }
  }, {
    key: "onPickerFocusOut",
    value: function onPickerFocusOut(e) {
      var _a;

      if (!((_a = this.pickerComponent) == null ? void 0 : _a.getGui().contains(e.relatedTarget))) {
        this.togglePickerHasFocus(false);
      }
    }
  }, {
    key: "togglePickerHasFocus",
    value: function togglePickerHasFocus(focused) {
      if (!this.pickerComponent) {
        return;
      }

      this.eWrapper.classList.toggle("ag-picker-has-focus", focused);
    }
  }, {
    key: "hidePicker",
    value: function hidePicker() {
      if (this.hideCurrentPicker) {
        this.hideCurrentPicker();
      }
    }
  }, {
    key: "setInputWidth",
    value: function setInputWidth(width) {
      _setElementWidth(this.eWrapper, width);

      return this;
    }
  }, {
    key: "getFocusableElement",
    value: function getFocusableElement() {
      return this.eWrapper;
    }
  }, {
    key: "setPickerGap",
    value: function setPickerGap(gap) {
      this.pickerGap = gap;
      return this;
    }
  }, {
    key: "setPickerMinWidth",
    value: function setPickerMinWidth(width) {
      if (typeof width === "number") {
        width = "".concat(width, "px");
      }

      this.minPickerWidth = width == null ? void 0 : width;
      return this;
    }
  }, {
    key: "setPickerMaxWidth",
    value: function setPickerMaxWidth(width) {
      if (typeof width === "number") {
        width = "".concat(width, "px");
      }

      this.maxPickerWidth = width == null ? void 0 : width;
      return this;
    }
  }, {
    key: "setPickerMaxHeight",
    value: function setPickerMaxHeight(height) {
      if (typeof height === "number") {
        height = "".concat(height, "px");
      }

      this.maxPickerHeight = height == null ? void 0 : height;
      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.hidePicker();

      _get(_getPrototypeOf(_AgPickerField.prototype), "destroy", this).call(this);
    }
  }]);

  return _AgPickerField;
}(_AgAbstractField);

__decorateClass([_Autowired("popupService")], _AgPickerField.prototype, "popupService", 2);

__decorateClass([_RefSelector("eLabel")], _AgPickerField.prototype, "eLabel", 2);

__decorateClass([_RefSelector("eWrapper")], _AgPickerField.prototype, "eWrapper", 2);

__decorateClass([_RefSelector("eDisplayField")], _AgPickerField.prototype, "eDisplayField", 2);

__decorateClass([_RefSelector("eIcon")], _AgPickerField.prototype, "eIcon", 2); // community-modules/core/src/widgets/agList.ts


var _AgList =
/*#__PURE__*/
function (_Component6) {
  "use strict";

  _inherits(_AgList, _Component6);

  function _AgList() {
    var _this94;

    var cssIdentifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
    var unFocusable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, _AgList);

    _this94 = _possibleConstructorReturn(this, _getPrototypeOf(_AgList).call(this,
    /* html */
    "<div class=\"ag-list ag-".concat(cssIdentifier, "-list\" role=\"listbox\"></div>")));
    _this94.cssIdentifier = cssIdentifier;
    _this94.unFocusable = unFocusable;
    _this94.options = [];
    _this94.itemEls = [];
    return _this94;
  }

  _createClass(_AgList, [{
    key: "init",
    value: function init() {
      var _this95 = this;

      var eGui = this.getGui();
      this.addManagedListener(eGui, "mouseleave", function () {
        return _this95.clearHighlighted();
      });

      if (this.unFocusable) {
        return;
      }

      this.addManagedListener(eGui, "keydown", this.handleKeyDown.bind(this));
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var key = e.key;

      switch (key) {
        case _KeyCode.ENTER:
          if (!this.highlightedEl) {
            this.setValue(this.getValue());
          } else {
            var pos = this.itemEls.indexOf(this.highlightedEl);
            this.setValueByIndex(pos);
          }

          break;

        case _KeyCode.DOWN:
        case _KeyCode.UP:
          e.preventDefault();
          this.navigate(key);
          break;

        case _KeyCode.PAGE_DOWN:
        case _KeyCode.PAGE_UP:
        case _KeyCode.PAGE_HOME:
        case _KeyCode.PAGE_END:
          e.preventDefault();
          this.navigateToPage(key);
          break;
      }
    }
  }, {
    key: "navigate",
    value: function navigate(key) {
      var isDown = key === _KeyCode.DOWN;
      var itemToHighlight;

      if (!this.highlightedEl) {
        itemToHighlight = this.itemEls[isDown ? 0 : this.itemEls.length - 1];
      } else {
        var currentIdx = this.itemEls.indexOf(this.highlightedEl);
        var nextPos = currentIdx + (isDown ? 1 : -1);
        nextPos = Math.min(Math.max(nextPos, 0), this.itemEls.length - 1);
        itemToHighlight = this.itemEls[nextPos];
      }

      this.highlightItem(itemToHighlight);
    }
  }, {
    key: "navigateToPage",
    value: function navigateToPage(key) {
      if (!this.highlightedEl || this.itemEls.length === 0) {
        return;
      }

      var currentIdx = this.itemEls.indexOf(this.highlightedEl);
      var rowCount = this.options.length - 1;
      var itemHeight = this.itemEls[0].clientHeight;
      var pageSize = Math.floor(this.getGui().clientHeight / itemHeight);
      var newIndex = -1;

      if (key === _KeyCode.PAGE_HOME) {
        newIndex = 0;
      } else if (key === _KeyCode.PAGE_END) {
        newIndex = rowCount;
      } else if (key === _KeyCode.PAGE_DOWN) {
        newIndex = Math.min(currentIdx + pageSize, rowCount);
      } else if (key === _KeyCode.PAGE_UP) {
        newIndex = Math.max(currentIdx - pageSize, 0);
      }

      if (newIndex === -1) {
        return;
      }

      this.highlightItem(this.itemEls[newIndex]);
    }
  }, {
    key: "addOptions",
    value: function addOptions(listOptions) {
      var _this96 = this;

      listOptions.forEach(function (listOption) {
        return _this96.addOption(listOption);
      });
      return this;
    }
  }, {
    key: "addOption",
    value: function addOption(listOption) {
      var value = listOption.value,
          text = listOption.text;
      var valueToRender = text || value;
      this.options.push({
        value: value,
        text: valueToRender
      });
      this.renderOption(value, valueToRender);
      this.updateIndices();
      return this;
    }
  }, {
    key: "clearOptions",
    value: function clearOptions() {
      this.options = [];
      this.reset(true);
      this.itemEls.forEach(function (itemEl) {
        _removeFromParent(itemEl);
      });
      this.itemEls = [];
    }
  }, {
    key: "updateIndices",
    value: function updateIndices() {
      var options = this.getGui().querySelectorAll(".ag-list-item");
      options.forEach(function (option, idx) {
        _setAriaPosInSet(option, idx + 1);

        _setAriaSetSize(option, options.length);
      });
    }
  }, {
    key: "renderOption",
    value: function renderOption(value, text) {
      var _this97 = this;

      var eDocument = this.gos.getDocument();
      var itemEl = eDocument.createElement("div");

      _setAriaRole(itemEl, "option");

      itemEl.classList.add("ag-list-item", "ag-".concat(this.cssIdentifier, "-list-item"));
      var span = eDocument.createElement("span");
      itemEl.appendChild(span);
      span.textContent = text;

      if (!this.unFocusable) {
        itemEl.tabIndex = -1;
      }

      this.itemEls.push(itemEl);
      this.addManagedListener(itemEl, "mousemove", function () {
        return _this97.highlightItem(itemEl);
      });
      this.addManagedListener(itemEl, "mousedown", function (e) {
        e.preventDefault();

        _this97.setValue(value);
      });
      this.createManagedBean(new _TooltipFeature({
        getTooltipValue: function getTooltipValue() {
          return text;
        },
        getGui: function getGui() {
          return itemEl;
        },
        getLocation: function getLocation() {
          return "UNKNOWN";
        },
        // only show tooltips for items where the text cannot be fully displayed
        shouldDisplayTooltip: function shouldDisplayTooltip() {
          return span.scrollWidth > span.clientWidth;
        }
      }));
      this.getGui().appendChild(itemEl);
    }
  }, {
    key: "setValue",
    value: function setValue(value, silent) {
      if (this.value === value) {
        this.fireItemSelected();
        return this;
      }

      if (value == null) {
        this.reset(silent);
        return this;
      }

      var idx = this.options.findIndex(function (option) {
        return option.value === value;
      });

      if (idx !== -1) {
        var option = this.options[idx];
        this.value = option.value;
        this.displayValue = option.text;
        this.highlightItem(this.itemEls[idx]);

        if (!silent) {
          this.fireChangeEvent();
        }
      }

      return this;
    }
  }, {
    key: "setValueByIndex",
    value: function setValueByIndex(idx) {
      return this.setValue(this.options[idx].value);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "getDisplayValue",
    value: function getDisplayValue() {
      return this.displayValue;
    }
  }, {
    key: "refreshHighlighted",
    value: function refreshHighlighted() {
      var _this98 = this;

      this.clearHighlighted();
      var idx = this.options.findIndex(function (option) {
        return option.value === _this98.value;
      });

      if (idx !== -1) {
        this.highlightItem(this.itemEls[idx]);
      }
    }
  }, {
    key: "reset",
    value: function reset(silent) {
      this.value = null;
      this.displayValue = null;
      this.clearHighlighted();

      if (!silent) {
        this.fireChangeEvent();
      }
    }
  }, {
    key: "highlightItem",
    value: function highlightItem(el) {
      if (!_isVisible(el)) {
        return;
      }

      this.clearHighlighted();
      this.highlightedEl = el;
      this.highlightedEl.classList.add(_AgList.ACTIVE_CLASS);

      _setAriaSelected(this.highlightedEl, true);

      var eGui = this.getGui();
      var scrollTop = eGui.scrollTop,
          clientHeight = eGui.clientHeight;
      var offsetTop = el.offsetTop,
          offsetHeight = el.offsetHeight;

      if (offsetTop + offsetHeight > scrollTop + clientHeight || offsetTop < scrollTop) {
        this.highlightedEl.scrollIntoView({
          block: "nearest"
        });
      }

      if (!this.unFocusable) {
        this.highlightedEl.focus();
      }
    }
  }, {
    key: "clearHighlighted",
    value: function clearHighlighted() {
      if (!this.highlightedEl || !_isVisible(this.highlightedEl)) {
        return;
      }

      this.highlightedEl.classList.remove(_AgList.ACTIVE_CLASS);

      _setAriaSelected(this.highlightedEl, false);

      this.highlightedEl = null;
    }
  }, {
    key: "fireChangeEvent",
    value: function fireChangeEvent() {
      this.dispatchEvent({
        type: _Events.EVENT_FIELD_VALUE_CHANGED
      });
      this.fireItemSelected();
    }
  }, {
    key: "fireItemSelected",
    value: function fireItemSelected() {
      this.dispatchEvent({
        type: _AgList.EVENT_ITEM_SELECTED
      });
    }
  }]);

  return _AgList;
}(_Component2);

_AgList.EVENT_ITEM_SELECTED = "selectedItem";
_AgList.ACTIVE_CLASS = "ag-active-item";

__decorateClass([_PostConstruct], _AgList.prototype, "init", 1);

var AgList = _AgList; // community-modules/core/src/widgets/agSelect.ts

var _AgSelect =
/*#__PURE__*/
function (_AgPickerField2) {
  "use strict";

  _inherits(_AgSelect, _AgPickerField2);

  function _AgSelect(config) {
    _classCallCheck(this, _AgSelect);

    return _possibleConstructorReturn(this, _getPrototypeOf(_AgSelect).call(this, __spreadValues({
      pickerAriaLabelKey: "ariaLabelSelectField",
      pickerAriaLabelValue: "Select Field",
      pickerType: "ag-list",
      className: "ag-select",
      pickerIcon: "smallDown",
      ariaRole: "combobox"
    }, config)));
  }

  _createClass(_AgSelect, [{
    key: "postConstruct",
    value: function postConstruct() {
      _get(_getPrototypeOf(_AgSelect.prototype), "postConstruct", this).call(this);

      this.createListComponent();
      this.eWrapper.tabIndex = this.gos.get("tabIndex");
      var _this$config9 = this.config,
          options = _this$config9.options,
          value = _this$config9.value,
          placeholder = _this$config9.placeholder;

      if (options != null) {
        this.addOptions(options);
      }

      if (value != null) {
        this.setValue(value, true);
      }

      if (placeholder && value == null) {
        this.eDisplayField.textContent = placeholder;
      }

      this.addManagedListener(this.eWrapper, "focusout", this.onWrapperFocusOut.bind(this));
    }
  }, {
    key: "onWrapperFocusOut",
    value: function onWrapperFocusOut(e) {
      if (!this.eWrapper.contains(e.relatedTarget)) {
        this.hidePicker();
      }
    }
  }, {
    key: "createListComponent",
    value: function createListComponent() {
      var _this99 = this;

      this.listComponent = this.createBean(new AgList("select", true));
      this.listComponent.setParentComponent(this);
      var eListAriaEl = this.listComponent.getAriaElement();
      var listId = "ag-select-list-".concat(this.listComponent.getCompId());
      eListAriaEl.setAttribute("id", listId);

      _setAriaControls(this.getAriaElement(), eListAriaEl);

      this.listComponent.addManagedListener(this.listComponent, AgList.EVENT_ITEM_SELECTED, function () {
        _this99.hidePicker();

        _this99.dispatchEvent({
          type: _AgSelect.EVENT_ITEM_SELECTED
        });
      });
      this.listComponent.addManagedListener(this.listComponent, _Events.EVENT_FIELD_VALUE_CHANGED, function () {
        if (!_this99.listComponent) {
          return;
        }

        _this99.setValue(_this99.listComponent.getValue(), false, true);

        _this99.hidePicker();
      });
    }
  }, {
    key: "createPickerComponent",
    value: function createPickerComponent() {
      return this.listComponent;
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var _a;

      var key = e.key;

      if (key === _KeyCode.TAB) {
        this.hidePicker();
      }

      switch (key) {
        case _KeyCode.ENTER:
        case _KeyCode.UP:
        case _KeyCode.DOWN:
        case _KeyCode.PAGE_UP:
        case _KeyCode.PAGE_DOWN:
        case _KeyCode.PAGE_HOME:
        case _KeyCode.PAGE_END:
          e.preventDefault();

          if (this.isPickerDisplayed) {
            (_a = this.listComponent) == null ? void 0 : _a.handleKeyDown(e);
          } else {
            _get(_getPrototypeOf(_AgSelect.prototype), "onKeyDown", this).call(this, e);
          }

          break;

        case _KeyCode.ESCAPE:
          _get(_getPrototypeOf(_AgSelect.prototype), "onKeyDown", this).call(this, e);

          break;
      }
    }
  }, {
    key: "showPicker",
    value: function showPicker() {
      if (!this.listComponent) {
        return;
      }

      _get(_getPrototypeOf(_AgSelect.prototype), "showPicker", this).call(this);

      this.listComponent.refreshHighlighted();
    }
  }, {
    key: "addOptions",
    value: function addOptions(options) {
      var _this100 = this;

      options.forEach(function (option) {
        return _this100.addOption(option);
      });
      return this;
    }
  }, {
    key: "addOption",
    value: function addOption(option) {
      this.listComponent.addOption(option);
      return this;
    }
  }, {
    key: "clearOptions",
    value: function clearOptions() {
      var _a;

      (_a = this.listComponent) == null ? void 0 : _a.clearOptions();
      return this;
    }
  }, {
    key: "setValue",
    value: function setValue(value, silent, fromPicker) {
      var _this101 = this;

      if (this.value === value || !this.listComponent) {
        return this;
      }

      if (!fromPicker) {
        this.listComponent.setValue(value, true);
      }

      var newValue = this.listComponent.getValue();

      if (newValue === this.getValue()) {
        return this;
      }

      var displayValue = this.listComponent.getDisplayValue();

      if (displayValue == null && this.config.placeholder) {
        displayValue = this.config.placeholder;
      }

      this.eDisplayField.textContent = displayValue;
      this.setTooltip({
        newTooltipText: displayValue != null ? displayValue : null,
        shouldDisplayTooltip: function shouldDisplayTooltip() {
          return _this101.eDisplayField.scrollWidth > _this101.eDisplayField.clientWidth;
        }
      });
      return _get(_getPrototypeOf(_AgSelect.prototype), "setValue", this).call(this, value, silent);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.listComponent) {
        this.destroyBean(this.listComponent);
        this.listComponent = void 0;
      }

      _get(_getPrototypeOf(_AgSelect.prototype), "destroy", this).call(this);
    }
  }]);

  return _AgSelect;
}(_AgPickerField);

_AgSelect.EVENT_ITEM_SELECTED = "selectedItem";
var _AgSelect2 = _AgSelect; // community-modules/core/src/widgets/agAbstractInputField.ts

var AgAbstractInputField =
/*#__PURE__*/
function (_AgAbstractField3) {
  "use strict";

  _inherits(AgAbstractInputField, _AgAbstractField3);

  function AgAbstractInputField(config, className) {
    var _this102;

    var inputType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "text";
    var displayFieldTag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "input";

    _classCallCheck(this, AgAbstractInputField);

    _this102 = _possibleConstructorReturn(this, _getPrototypeOf(AgAbstractInputField).call(this, config,
    /* html */
    "\n            <div role=\"presentation\">\n                <div ref=\"eLabel\" class=\"ag-input-field-label\"></div>\n                <div ref=\"eWrapper\" class=\"ag-wrapper ag-input-wrapper\" role=\"presentation\">\n                    <".concat(displayFieldTag, " ref=\"eInput\" class=\"ag-input-field-input\"></").concat(displayFieldTag, ">\n                </div>\n            </div>"), className));
    _this102.inputType = inputType;
    _this102.displayFieldTag = displayFieldTag;
    return _this102;
  }

  _createClass(AgAbstractInputField, [{
    key: "postConstruct",
    value: function postConstruct() {
      _get(_getPrototypeOf(AgAbstractInputField.prototype), "postConstruct", this).call(this);

      this.setInputType();
      this.eLabel.classList.add("".concat(this.className, "-label"));
      this.eWrapper.classList.add("".concat(this.className, "-input-wrapper"));
      this.eInput.classList.add("".concat(this.className, "-input"));
      this.addCssClass("ag-input-field");
      this.eInput.id = this.eInput.id || "ag-".concat(this.getCompId(), "-input");
      var _this$config10 = this.config,
          inputName = _this$config10.inputName,
          inputWidth = _this$config10.inputWidth;

      if (inputName != null) {
        this.setInputName(inputName);
      }

      if (inputWidth != null) {
        this.setInputWidth(inputWidth);
      }

      this.addInputListeners();
      this.activateTabIndex([this.eInput]);
    }
  }, {
    key: "addInputListeners",
    value: function addInputListeners() {
      var _this103 = this;

      this.addManagedListener(this.eInput, "input", function (e) {
        return _this103.setValue(e.target.value);
      });
    }
  }, {
    key: "setInputType",
    value: function setInputType() {
      if (this.displayFieldTag === "input") {
        this.eInput.setAttribute("type", this.inputType);
      }
    }
  }, {
    key: "getInputElement",
    value: function getInputElement() {
      return this.eInput;
    }
  }, {
    key: "setInputWidth",
    value: function setInputWidth(width) {
      _setElementWidth(this.eWrapper, width);

      return this;
    }
  }, {
    key: "setInputName",
    value: function setInputName(name) {
      this.getInputElement().setAttribute("name", name);
      return this;
    }
  }, {
    key: "getFocusableElement",
    value: function getFocusableElement() {
      return this.eInput;
    }
  }, {
    key: "setMaxLength",
    value: function setMaxLength(length) {
      var eInput = this.eInput;
      eInput.maxLength = length;
      return this;
    }
  }, {
    key: "setInputPlaceholder",
    value: function setInputPlaceholder(placeholder) {
      _addOrRemoveAttribute(this.eInput, "placeholder", placeholder);

      return this;
    }
  }, {
    key: "setInputAriaLabel",
    value: function setInputAriaLabel(label) {
      _setAriaLabel(this.eInput, label);

      this.refreshAriaLabelledBy();
      return this;
    }
  }, {
    key: "setDisabled",
    value: function setDisabled(disabled) {
      _setDisabled(this.eInput, disabled);

      return _get(_getPrototypeOf(AgAbstractInputField.prototype), "setDisabled", this).call(this, disabled);
    }
  }, {
    key: "setAutoComplete",
    value: function setAutoComplete(value) {
      if (value === true) {
        _addOrRemoveAttribute(this.eInput, "autocomplete", null);
      } else {
        var autoCompleteValue = typeof value === "string" ? value : "off";

        _addOrRemoveAttribute(this.eInput, "autocomplete", autoCompleteValue);
      }

      return this;
    }
  }]);

  return AgAbstractInputField;
}(_AgAbstractField);

__decorateClass([_RefSelector("eLabel")], AgAbstractInputField.prototype, "eLabel", 2);

__decorateClass([_RefSelector("eWrapper")], AgAbstractInputField.prototype, "eWrapper", 2);

__decorateClass([_RefSelector("eInput")], AgAbstractInputField.prototype, "eInput", 2); // community-modules/core/src/widgets/agCheckbox.ts


var _AgCheckbox =
/*#__PURE__*/
function (_AgAbstractInputField) {
  "use strict";

  _inherits(_AgCheckbox, _AgAbstractInputField);

  function _AgCheckbox(config) {
    var _this104;

    var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ag-checkbox";
    var inputType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "checkbox";

    _classCallCheck(this, _AgCheckbox);

    _this104 = _possibleConstructorReturn(this, _getPrototypeOf(_AgCheckbox).call(this, config, className, inputType));
    _this104.labelAlignment = "right";
    _this104.selected = false;
    _this104.readOnly = false;
    _this104.passive = false;
    return _this104;
  }

  _createClass(_AgCheckbox, [{
    key: "postConstruct",
    value: function postConstruct() {
      _get(_getPrototypeOf(_AgCheckbox.prototype), "postConstruct", this).call(this);

      var _this$config11 = this.config,
          readOnly = _this$config11.readOnly,
          passive = _this$config11.passive;
      if (typeof readOnly === "boolean") this.setReadOnly(readOnly);
      if (typeof passive === "boolean") this.setPassive(passive);
    }
  }, {
    key: "addInputListeners",
    value: function addInputListeners() {
      this.addManagedListener(this.eInput, "click", this.onCheckboxClick.bind(this));
      this.addManagedListener(this.eLabel, "click", this.toggle.bind(this));
    }
  }, {
    key: "getNextValue",
    value: function getNextValue() {
      return this.selected === void 0 ? true : !this.selected;
    }
  }, {
    key: "setPassive",
    value: function setPassive(passive) {
      this.passive = passive;
    }
  }, {
    key: "isReadOnly",
    value: function isReadOnly() {
      return this.readOnly;
    }
  }, {
    key: "setReadOnly",
    value: function setReadOnly(readOnly) {
      this.eWrapper.classList.toggle("ag-disabled", readOnly);
      this.eInput.disabled = readOnly;
      this.readOnly = readOnly;
    }
  }, {
    key: "setDisabled",
    value: function setDisabled(disabled) {
      this.eWrapper.classList.toggle("ag-disabled", disabled);
      return _get(_getPrototypeOf(_AgCheckbox.prototype), "setDisabled", this).call(this, disabled);
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.eInput.disabled) {
        return;
      }

      var previousValue = this.isSelected();
      var nextValue = this.getNextValue();

      if (this.passive) {
        this.dispatchChange(nextValue, previousValue);
      } else {
        this.setValue(nextValue);
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.isSelected();
    }
  }, {
    key: "setValue",
    value: function setValue(value, silent) {
      this.refreshSelectedClass(value);
      this.setSelected(value, silent);
      return this;
    }
  }, {
    key: "setName",
    value: function setName(name) {
      var input = this.getInputElement();
      input.name = name;
      return this;
    }
  }, {
    key: "isSelected",
    value: function isSelected() {
      return this.selected;
    }
  }, {
    key: "setSelected",
    value: function setSelected(selected, silent) {
      if (this.isSelected() === selected) {
        return;
      }

      this.previousValue = this.isSelected();
      selected = this.selected = typeof selected === "boolean" ? selected : void 0;
      this.eInput.checked = selected;
      this.eInput.indeterminate = selected === void 0;

      if (!silent) {
        this.dispatchChange(this.selected, this.previousValue);
      }
    }
  }, {
    key: "dispatchChange",
    value: function dispatchChange(selected, previousValue, event) {
      this.dispatchEvent({
        type: _Events.EVENT_FIELD_VALUE_CHANGED,
        selected: selected,
        previousValue: previousValue,
        event: event
      });
      var input = this.getInputElement();
      var checkboxChangedEvent = {
        type: _Events.EVENT_CHECKBOX_CHANGED,
        id: input.id,
        name: input.name,
        selected: selected,
        previousValue: previousValue
      };
      this.eventService.dispatchEvent(checkboxChangedEvent);
    }
  }, {
    key: "onCheckboxClick",
    value: function onCheckboxClick(e) {
      if (this.passive || this.eInput.disabled) {
        return;
      }

      var previousValue = this.isSelected();
      var selected = this.selected = e.target.checked;
      this.refreshSelectedClass(selected);
      this.dispatchChange(selected, previousValue, e);
    }
  }, {
    key: "refreshSelectedClass",
    value: function refreshSelectedClass(value) {
      this.eWrapper.classList.toggle("ag-checked", value === true);
      this.eWrapper.classList.toggle("ag-indeterminate", value == null);
    }
  }]);

  return _AgCheckbox;
}(AgAbstractInputField); // community-modules/core/src/widgets/agRadioButton.ts


var _AgRadioButton =
/*#__PURE__*/
function (_AgCheckbox2) {
  "use strict";

  _inherits(_AgRadioButton, _AgCheckbox2);

  function _AgRadioButton(config) {
    _classCallCheck(this, _AgRadioButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(_AgRadioButton).call(this, config, "ag-radio-button", "radio"));
  }

  _createClass(_AgRadioButton, [{
    key: "isSelected",
    value: function isSelected() {
      return this.eInput.checked;
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.eInput.disabled) {
        return;
      }

      if (!this.isSelected()) {
        this.setValue(true);
      }
    }
  }, {
    key: "addInputListeners",
    value: function addInputListeners() {
      _get(_getPrototypeOf(_AgRadioButton.prototype), "addInputListeners", this).call(this);

      this.addManagedListener(this.eventService, _Events.EVENT_CHECKBOX_CHANGED, this.onChange.bind(this));
    }
    /**
     * This ensures that if another radio button in the same named group is selected, we deselect this radio button.
     * By default the browser does this for you, but we are managing classes ourselves in order to ensure input
     * elements are styled correctly in IE11, and the DOM 'changed' event is only fired when a button is selected,
     * not deselected, so we need to use our own event.
     */

  }, {
    key: "onChange",
    value: function onChange(event) {
      if (event.selected && event.name && this.eInput.name && this.eInput.name === event.name && event.id && this.eInput.id !== event.id) {
        this.setValue(false, true);
      }
    }
  }]);

  return _AgRadioButton;
}(_AgCheckbox); // community-modules/core/src/filter/provided/simpleFilter.ts


var SimpleFilterModelFormatter =
/*#__PURE__*/
function () {
  "use strict";

  function SimpleFilterModelFormatter(localeService, optionsFactory, valueFormatter) {
    _classCallCheck(this, SimpleFilterModelFormatter);

    this.localeService = localeService;
    this.optionsFactory = optionsFactory;
    this.valueFormatter = valueFormatter;
  } // used by:
  // 1) NumberFloatingFilter & TextFloatingFilter: Always, for both when editable and read only.
  // 2) DateFloatingFilter: Only when read only (as we show text rather than a date picker when read only)


  _createClass(SimpleFilterModelFormatter, [{
    key: "getModelAsString",
    value: function getModelAsString(model) {
      var _this105 = this;

      if (!model) {
        return null;
      }

      var isCombined = model.operator != null;
      var translate = this.localeService.getLocaleTextFunc();

      if (isCombined) {
        var combinedModel = model;
        var conditions = combinedModel.conditions;

        if (!conditions) {
          var condition1 = combinedModel.condition1,
              condition2 = combinedModel.condition2;
          conditions = [condition1, condition2];
        }

        var customOptions = conditions.map(function (condition) {
          return _this105.getModelAsString(condition);
        });
        var joinOperatorTranslateKey = combinedModel.operator === "AND" ? "andCondition" : "orCondition";
        return customOptions.join(" ".concat(translate(joinOperatorTranslateKey, FILTER_LOCALE_TEXT[joinOperatorTranslateKey]), " "));
      } else if (model.type === _SimpleFilter2.BLANK || model.type === _SimpleFilter2.NOT_BLANK) {
        return translate(model.type, model.type);
      } else {
        var condition = model;
        var customOption = this.optionsFactory.getCustomOption(condition.type);

        var _ref16 = customOption || {},
            displayKey = _ref16.displayKey,
            displayName = _ref16.displayName,
            numberOfInputs = _ref16.numberOfInputs;

        if (displayKey && displayName && numberOfInputs === 0) {
          translate(displayKey, displayName);
          return displayName;
        }

        return this.conditionToString(condition, customOption);
      }
    }
  }, {
    key: "updateParams",
    value: function updateParams(params) {
      this.optionsFactory = params.optionsFactory;
    }
  }, {
    key: "formatValue",
    value: function formatValue(value) {
      var _a;

      return this.valueFormatter ? (_a = this.valueFormatter(value != null ? value : null)) != null ? _a : "" : String(value);
    }
  }]);

  return SimpleFilterModelFormatter;
}();

var _SimpleFilter =
/*#__PURE__*/
function (_ProvidedFilter3) {
  "use strict";

  _inherits(_SimpleFilter, _ProvidedFilter3);

  function _SimpleFilter() {
    var _this106;

    _classCallCheck(this, _SimpleFilter);

    _this106 = _possibleConstructorReturn(this, _getPrototypeOf(_SimpleFilter).apply(this, arguments));
    _this106.eTypes = [];
    _this106.eJoinOperatorPanels = [];
    _this106.eJoinOperatorsAnd = [];
    _this106.eJoinOperatorsOr = [];
    _this106.eConditionBodies = [];

    _this106.listener = function () {
      return _this106.onUiChanged();
    };

    _this106.lastUiCompletePosition = null;
    _this106.joinOperatorId = 0;
    return _this106;
  }

  _createClass(_SimpleFilter, [{
    key: "getNumberOfInputs",
    value: function getNumberOfInputs(type) {
      var customOpts = this.optionsFactory.getCustomOption(type);

      if (customOpts) {
        var numberOfInputs = customOpts.numberOfInputs;
        return numberOfInputs != null ? numberOfInputs : 1;
      }

      var zeroInputTypes = [_SimpleFilter.EMPTY, _SimpleFilter.NOT_BLANK, _SimpleFilter.BLANK];

      if (type && zeroInputTypes.indexOf(type) >= 0) {
        return 0;
      } else if (type === _SimpleFilter.IN_RANGE) {
        return 2;
      }

      return 1;
    } // floating filter calls this when user applies filter from floating filter

  }, {
    key: "onFloatingFilterChanged",
    value: function onFloatingFilterChanged(type, value) {
      this.setTypeFromFloatingFilter(type);
      this.setValueFromFloatingFilter(value);
      this.onUiChanged(true);
    }
  }, {
    key: "setTypeFromFloatingFilter",
    value: function setTypeFromFloatingFilter(type) {
      var _this107 = this;

      this.eTypes.forEach(function (eType, position) {
        if (position === 0) {
          eType.setValue(type, true);
        } else {
          eType.setValue(_this107.optionsFactory.getDefaultOption(), true);
        }
      });
    }
  }, {
    key: "getModelFromUi",
    value: function getModelFromUi() {
      var conditions = this.getUiCompleteConditions();

      if (conditions.length === 0) {
        return null;
      }

      if (this.maxNumConditions > 1 && conditions.length > 1) {
        return {
          filterType: this.getFilterType(),
          operator: this.getJoinOperator(),
          condition1: conditions[0],
          condition2: conditions[1],
          conditions: conditions
        };
      }

      return conditions[0];
    }
  }, {
    key: "getConditionTypes",
    value: function getConditionTypes() {
      return this.eTypes.map(function (eType) {
        return eType.getValue();
      });
    }
  }, {
    key: "getConditionType",
    value: function getConditionType(position) {
      return this.eTypes[position].getValue();
    }
  }, {
    key: "getJoinOperator",
    value: function getJoinOperator() {
      if (this.eJoinOperatorsOr.length === 0) {
        return this.defaultJoinOperator;
      }

      return this.eJoinOperatorsOr[0].getValue() === true ? "OR" : "AND";
    }
  }, {
    key: "areModelsEqual",
    value: function areModelsEqual(a, b) {
      var _this108 = this;

      if (!a && !b) {
        return true;
      }

      if (!a && b || a && !b) {
        return false;
      }

      var aIsSimple = !a.operator;
      var bIsSimple = !b.operator;
      var oneSimpleOneCombined = !aIsSimple && bIsSimple || aIsSimple && !bIsSimple;

      if (oneSimpleOneCombined) {
        return false;
      }

      var res;

      if (aIsSimple) {
        var aSimple = a;
        var bSimple = b;
        res = this.areSimpleModelsEqual(aSimple, bSimple);
      } else {
        var aCombined = a;
        var bCombined = b;
        res = aCombined.operator === bCombined.operator && _areEqual(aCombined.conditions, bCombined.conditions, function (aModel, bModel) {
          return _this108.areSimpleModelsEqual(aModel, bModel);
        });
      }

      return res;
    }
  }, {
    key: "shouldRefresh",
    value: function shouldRefresh(newParams) {
      var _a, _b, _c;

      var model = this.getModel();
      var conditions = model ? (_a = model.conditions) != null ? _a : [model] : null;
      var newOptionsList = (_c = (_b = newParams.filterOptions) == null ? void 0 : _b.map(function (option) {
        return typeof option === "string" ? option : option.displayKey;
      })) != null ? _c : this.getDefaultFilterOptions();
      var allConditionsExistInNewOptionsList = !conditions || conditions.every(function (condition) {
        return newOptionsList.find(function (option) {
          return option === condition.type;
        }) !== void 0;
      });

      if (!allConditionsExistInNewOptionsList) {
        return false;
      }

      if (typeof newParams.maxNumConditions === "number" && conditions && conditions.length > newParams.maxNumConditions) {
        return false;
      }

      return true;
    }
  }, {
    key: "refresh",
    value: function refresh(newParams) {
      if (!this.shouldRefresh(newParams)) {
        return false;
      }

      var parentRefreshed = _get(_getPrototypeOf(_SimpleFilter.prototype), "refresh", this).call(this, newParams);

      if (!parentRefreshed) {
        return false;
      }

      this.setParams(newParams);
      this.removeConditionsAndOperators(0);
      this.createOption();
      this.setModel(this.getModel());
      return true;
    }
  }, {
    key: "setModelIntoUi",
    value: function setModelIntoUi(model) {
      var _this109 = this;

      var isCombined = model.operator;

      if (isCombined) {
        var combinedModel = model;

        if (!combinedModel.conditions) {
          combinedModel.conditions = [combinedModel.condition1, combinedModel.condition2];
        }

        var numConditions = this.validateAndUpdateConditions(combinedModel.conditions);
        var numPrevConditions = this.getNumConditions();

        if (numConditions < numPrevConditions) {
          this.removeConditionsAndOperators(numConditions);
        } else if (numConditions > numPrevConditions) {
          for (var i = numPrevConditions; i < numConditions; i++) {
            this.createJoinOperatorPanel();
            this.createOption();
          }
        }

        var orChecked = combinedModel.operator === "OR";
        this.eJoinOperatorsAnd.forEach(function (eJoinOperatorAnd) {
          return eJoinOperatorAnd.setValue(!orChecked, true);
        });
        this.eJoinOperatorsOr.forEach(function (eJoinOperatorOr) {
          return eJoinOperatorOr.setValue(orChecked, true);
        });
        combinedModel.conditions.forEach(function (condition, position) {
          _this109.eTypes[position].setValue(condition.type, true);

          _this109.setConditionIntoUi(condition, position);
        });
      } else {
        var simpleModel = model;

        if (this.getNumConditions() > 1) {
          this.removeConditionsAndOperators(1);
        }

        this.eTypes[0].setValue(simpleModel.type, true);
        this.setConditionIntoUi(simpleModel, 0);
      }

      this.lastUiCompletePosition = this.getNumConditions() - 1;
      this.createMissingConditionsAndOperators();
      this.onUiChanged();
      return _AgPromise2.resolve();
    }
  }, {
    key: "validateAndUpdateConditions",
    value: function validateAndUpdateConditions(conditions) {
      var numConditions = conditions.length;

      if (numConditions > this.maxNumConditions) {
        conditions.splice(this.maxNumConditions);

        _warnOnce('Filter Model contains more conditions than "filterParams.maxNumConditions". Additional conditions have been ignored.');

        numConditions = this.maxNumConditions;
      }

      return numConditions;
    }
  }, {
    key: "doesFilterPass",
    value: function doesFilterPass(params) {
      var _this110 = this;

      var _a;

      var model = this.getModel();

      if (model == null) {
        return true;
      }

      var operator = model.operator;
      var models = [];

      if (operator) {
        var combinedModel = model;
        models.push.apply(models, _toConsumableArray((_a = combinedModel.conditions) != null ? _a : []));
      } else {
        models.push(model);
      }

      var combineFunction = operator && operator === "OR" ? "some" : "every";
      return models[combineFunction](function (m) {
        return _this110.individualConditionPasses(params, m);
      });
    }
  }, {
    key: "setParams",
    value: function setParams(params) {
      _get(_getPrototypeOf(_SimpleFilter.prototype), "setParams", this).call(this, params);

      this.setNumConditions(params);
      this.defaultJoinOperator = this.getDefaultJoinOperator(params.defaultJoinOperator);
      this.filterPlaceholder = params.filterPlaceholder;
      this.optionsFactory = new OptionsFactory();
      this.optionsFactory.init(params, this.getDefaultFilterOptions());
      this.createFilterListOptions();
      this.createOption();
      this.createMissingConditionsAndOperators();

      if (this.isReadOnly()) {
        this.eFilterBody.setAttribute("tabindex", "-1");
      }
    }
  }, {
    key: "setNumConditions",
    value: function setNumConditions(params) {
      var _a, _b;

      if (params.suppressAndOrCondition != null) {
        _warnOnce('Since v29.2 "filterParams.suppressAndOrCondition" is deprecated. Use "filterParams.maxNumConditions = 1" instead.');
      }

      if (params.alwaysShowBothConditions != null) {
        _warnOnce('Since v29.2 "filterParams.alwaysShowBothConditions" is deprecated. Use "filterParams.numAlwaysVisibleConditions = 2" instead.');
      }

      this.maxNumConditions = (_a = params.maxNumConditions) != null ? _a : params.suppressAndOrCondition ? 1 : 2;

      if (this.maxNumConditions < 1) {
        _warnOnce('"filterParams.maxNumConditions" must be greater than or equal to zero.');

        this.maxNumConditions = 1;
      }

      this.numAlwaysVisibleConditions = (_b = params.numAlwaysVisibleConditions) != null ? _b : params.alwaysShowBothConditions ? 2 : 1;

      if (this.numAlwaysVisibleConditions < 1) {
        _warnOnce('"filterParams.numAlwaysVisibleConditions" must be greater than or equal to zero.');

        this.numAlwaysVisibleConditions = 1;
      }

      if (this.numAlwaysVisibleConditions > this.maxNumConditions) {
        _warnOnce('"filterParams.numAlwaysVisibleConditions" cannot be greater than "filterParams.maxNumConditions".');

        this.numAlwaysVisibleConditions = this.maxNumConditions;
      }
    }
  }, {
    key: "createOption",
    value: function createOption() {
      var _this111 = this;

      var eType = this.createManagedBean(new _AgSelect2());
      this.eTypes.push(eType);
      eType.addCssClass("ag-filter-select");
      this.eFilterBody.appendChild(eType.getGui());
      var eConditionBody = this.createValueElement();
      this.eConditionBodies.push(eConditionBody);
      this.eFilterBody.appendChild(eConditionBody);
      this.putOptionsIntoDropdown(eType);
      this.resetType(eType);
      var position = this.getNumConditions() - 1;
      this.forEachPositionInput(position, function (element) {
        return _this111.resetInput(element);
      });
      this.addChangedListeners(eType, position);
    }
  }, {
    key: "createJoinOperatorPanel",
    value: function createJoinOperatorPanel() {
      var eJoinOperatorPanel = document.createElement("div");
      this.eJoinOperatorPanels.push(eJoinOperatorPanel);
      eJoinOperatorPanel.classList.add("ag-filter-condition");
      var eJoinOperatorAnd = this.createJoinOperator(this.eJoinOperatorsAnd, eJoinOperatorPanel, "and");
      var eJoinOperatorOr = this.createJoinOperator(this.eJoinOperatorsOr, eJoinOperatorPanel, "or");
      this.eFilterBody.appendChild(eJoinOperatorPanel);
      var index = this.eJoinOperatorPanels.length - 1;
      var uniqueGroupId = this.joinOperatorId++;
      this.resetJoinOperatorAnd(eJoinOperatorAnd, index, uniqueGroupId);
      this.resetJoinOperatorOr(eJoinOperatorOr, index, uniqueGroupId);

      if (!this.isReadOnly()) {
        eJoinOperatorAnd.onValueChange(this.listener);
        eJoinOperatorOr.onValueChange(this.listener);
      }
    }
  }, {
    key: "createJoinOperator",
    value: function createJoinOperator(eJoinOperators, eJoinOperatorPanel, andOr) {
      var eJoinOperator = this.createManagedBean(new _AgRadioButton());
      eJoinOperators.push(eJoinOperator);
      eJoinOperator.addCssClass("ag-filter-condition-operator");
      eJoinOperator.addCssClass("ag-filter-condition-operator-".concat(andOr));
      eJoinOperatorPanel.appendChild(eJoinOperator.getGui());
      return eJoinOperator;
    }
  }, {
    key: "getDefaultJoinOperator",
    value: function getDefaultJoinOperator(defaultJoinOperator) {
      return defaultJoinOperator === "AND" || defaultJoinOperator === "OR" ? defaultJoinOperator : "AND";
    }
  }, {
    key: "createFilterListOptions",
    value: function createFilterListOptions() {
      var _this112 = this;

      var filterOptions = this.optionsFactory.getFilterOptions();
      this.filterListOptions = filterOptions.map(function (option) {
        return typeof option === "string" ? _this112.createBoilerplateListOption(option) : _this112.createCustomListOption(option);
      });
    }
  }, {
    key: "putOptionsIntoDropdown",
    value: function putOptionsIntoDropdown(eType) {
      this.filterListOptions.forEach(function (listOption) {
        eType.addOption(listOption);
      });
      eType.setDisabled(this.filterListOptions.length <= 1);
    }
  }, {
    key: "createBoilerplateListOption",
    value: function createBoilerplateListOption(option) {
      return {
        value: option,
        text: this.translate(option)
      };
    }
  }, {
    key: "createCustomListOption",
    value: function createCustomListOption(option) {
      var displayKey = option.displayKey;
      var customOption = this.optionsFactory.getCustomOption(option.displayKey);
      return {
        value: displayKey,
        text: customOption ? this.localeService.getLocaleTextFunc()(customOption.displayKey, customOption.displayName) : this.translate(displayKey)
      };
    }
    /**
     * @deprecated As of v29.2 filters can have more than two conditions. Check `colDef.filterParams.maxNumConditions` instead.
     */

  }, {
    key: "isAllowTwoConditions",
    value: function isAllowTwoConditions() {
      return this.maxNumConditions >= 2;
    }
  }, {
    key: "createBodyTemplate",
    value: function createBodyTemplate() {
      return "";
    }
  }, {
    key: "getCssIdentifier",
    value: function getCssIdentifier() {
      return "simple-filter";
    }
  }, {
    key: "updateUiVisibility",
    value: function updateUiVisibility() {
      var joinOperator = this.getJoinOperator();
      this.updateNumConditions();
      this.updateConditionStatusesAndValues(this.lastUiCompletePosition, joinOperator);
    }
  }, {
    key: "updateNumConditions",
    value: function updateNumConditions() {
      var _a;

      var lastUiCompletePosition = -1;
      var areAllConditionsUiComplete = true;

      for (var position = 0; position < this.getNumConditions(); position++) {
        if (this.isConditionUiComplete(position)) {
          lastUiCompletePosition = position;
        } else {
          areAllConditionsUiComplete = false;
        }
      }

      if (this.shouldAddNewConditionAtEnd(areAllConditionsUiComplete)) {
        this.createJoinOperatorPanel();
        this.createOption();
      } else {
        var activePosition = (_a = this.lastUiCompletePosition) != null ? _a : this.getNumConditions() - 2;

        if (lastUiCompletePosition < activePosition) {
          this.removeConditionsAndOperators(activePosition + 1);
          var removeStartPosition = lastUiCompletePosition + 1;
          var numConditionsToRemove = activePosition - removeStartPosition;

          if (numConditionsToRemove > 0) {
            this.removeConditionsAndOperators(removeStartPosition, numConditionsToRemove);
          }

          this.createMissingConditionsAndOperators();
        }
      }

      this.lastUiCompletePosition = lastUiCompletePosition;
    }
  }, {
    key: "updateConditionStatusesAndValues",
    value: function updateConditionStatusesAndValues(lastUiCompletePosition, joinOperator) {
      var _this113 = this;

      this.eTypes.forEach(function (eType, position) {
        var disabled = _this113.isConditionDisabled(position, lastUiCompletePosition);

        eType.setDisabled(disabled || _this113.filterListOptions.length <= 1);

        if (position === 1) {
          _setDisabled(_this113.eJoinOperatorPanels[0], disabled);

          _this113.eJoinOperatorsAnd[0].setDisabled(disabled);

          _this113.eJoinOperatorsOr[0].setDisabled(disabled);
        }
      });
      this.eConditionBodies.forEach(function (element, index) {
        _setDisplayed(element, _this113.isConditionBodyVisible(index));
      });
      var orChecked = (joinOperator != null ? joinOperator : this.getJoinOperator()) === "OR";
      this.eJoinOperatorsAnd.forEach(function (eJoinOperatorAnd, index) {
        eJoinOperatorAnd.setValue(!orChecked, true);
      });
      this.eJoinOperatorsOr.forEach(function (eJoinOperatorOr, index) {
        eJoinOperatorOr.setValue(orChecked, true);
      });
      this.forEachInput(function (element, index, position, numberOfInputs) {
        _this113.setElementDisplayed(element, index < numberOfInputs);

        _this113.setElementDisabled(element, _this113.isConditionDisabled(position, lastUiCompletePosition));
      });
      this.resetPlaceholder();
    }
  }, {
    key: "shouldAddNewConditionAtEnd",
    value: function shouldAddNewConditionAtEnd(areAllConditionsUiComplete) {
      return areAllConditionsUiComplete && this.getNumConditions() < this.maxNumConditions && !this.isReadOnly();
    }
  }, {
    key: "removeConditionsAndOperators",
    value: function removeConditionsAndOperators(startPosition, deleteCount) {
      if (startPosition >= this.getNumConditions()) {
        return;
      }

      this.removeComponents(this.eTypes, startPosition, deleteCount);
      this.removeElements(this.eConditionBodies, startPosition, deleteCount);
      this.removeValueElements(startPosition, deleteCount);
      var joinOperatorIndex = Math.max(startPosition - 1, 0);
      this.removeElements(this.eJoinOperatorPanels, joinOperatorIndex, deleteCount);
      this.removeComponents(this.eJoinOperatorsAnd, joinOperatorIndex, deleteCount);
      this.removeComponents(this.eJoinOperatorsOr, joinOperatorIndex, deleteCount);
    }
  }, {
    key: "removeElements",
    value: function removeElements(elements, startPosition, deleteCount) {
      var removedElements = this.removeItems(elements, startPosition, deleteCount);
      removedElements.forEach(function (element) {
        return _removeFromParent(element);
      });
    }
  }, {
    key: "removeComponents",
    value: function removeComponents(components, startPosition, deleteCount) {
      var _this114 = this;

      var removedComponents = this.removeItems(components, startPosition, deleteCount);
      removedComponents.forEach(function (comp) {
        _removeFromParent(comp.getGui());

        _this114.destroyBean(comp);
      });
    }
  }, {
    key: "removeItems",
    value: function removeItems(items, startPosition, deleteCount) {
      return deleteCount == null ? items.splice(startPosition) : items.splice(startPosition, deleteCount);
    }
  }, {
    key: "afterGuiAttached",
    value: function afterGuiAttached(params) {
      _get(_getPrototypeOf(_SimpleFilter.prototype), "afterGuiAttached", this).call(this, params);

      this.resetPlaceholder();

      if (!(params == null ? void 0 : params.suppressFocus)) {
        if (this.isReadOnly()) {
          this.eFilterBody.focus();
        } else {
          var firstInput = this.getInputs(0)[0];

          if (!firstInput) {
            return;
          }

          if (firstInput instanceof AgAbstractInputField) {
            firstInput.getInputElement().focus();
          }
        }
      }
    }
  }, {
    key: "afterGuiDetached",
    value: function afterGuiDetached() {
      _get(_getPrototypeOf(_SimpleFilter.prototype), "afterGuiDetached", this).call(this);

      var appliedModel = this.getModel();
      this.resetUiToActiveModel(appliedModel);
      var lastUiCompletePosition = -1;
      var updatedLastUiCompletePosition = -1;
      var conditionsRemoved = false;
      var joinOperator = this.getJoinOperator();

      for (var position = this.getNumConditions() - 1; position >= 0; position--) {
        if (this.isConditionUiComplete(position)) {
          if (lastUiCompletePosition === -1) {
            lastUiCompletePosition = position;
            updatedLastUiCompletePosition = position;
          }
        } else {
          var shouldRemovePositionAtEnd = position >= this.numAlwaysVisibleConditions && !this.isConditionUiComplete(position - 1);
          var positionBeforeLastUiCompletePosition = position < lastUiCompletePosition;

          if (shouldRemovePositionAtEnd || positionBeforeLastUiCompletePosition) {
            this.removeConditionsAndOperators(position, 1);
            conditionsRemoved = true;

            if (positionBeforeLastUiCompletePosition) {
              updatedLastUiCompletePosition--;
            }
          }
        }
      }

      var shouldUpdateConditionStatusesAndValues = false;

      if (this.getNumConditions() < this.numAlwaysVisibleConditions) {
        this.createMissingConditionsAndOperators();
        shouldUpdateConditionStatusesAndValues = true;
      }

      if (this.shouldAddNewConditionAtEnd(updatedLastUiCompletePosition === this.getNumConditions() - 1)) {
        this.createJoinOperatorPanel();
        this.createOption();
        shouldUpdateConditionStatusesAndValues = true;
      }

      if (shouldUpdateConditionStatusesAndValues) {
        this.updateConditionStatusesAndValues(updatedLastUiCompletePosition, joinOperator);
      }

      if (conditionsRemoved) {
        this.updateJoinOperatorsDisabled();
      }

      this.lastUiCompletePosition = updatedLastUiCompletePosition;
    }
  }, {
    key: "getPlaceholderText",
    value: function getPlaceholderText(defaultPlaceholder, position) {
      var placeholder = this.translate(defaultPlaceholder);

      if (_isFunction(this.filterPlaceholder)) {
        var filterPlaceholderFn = this.filterPlaceholder;
        var filterOptionKey = this.eTypes[position].getValue();
        var filterOption = this.translate(filterOptionKey);
        placeholder = filterPlaceholderFn({
          filterOptionKey: filterOptionKey,
          filterOption: filterOption,
          placeholder: placeholder
        });
      } else if (typeof this.filterPlaceholder === "string") {
        placeholder = this.filterPlaceholder;
      }

      return placeholder;
    } // allow sub-classes to reset HTML placeholders after UI update.

  }, {
    key: "resetPlaceholder",
    value: function resetPlaceholder() {
      var _this115 = this;

      var globalTranslate = this.localeService.getLocaleTextFunc();
      this.forEachInput(function (element, index, position, numberOfInputs) {
        if (!(element instanceof AgAbstractInputField)) {
          return;
        }

        var placeholder = index === 0 && numberOfInputs > 1 ? "inRangeStart" : index === 0 ? "filterOoo" : "inRangeEnd";
        var ariaLabel = index === 0 && numberOfInputs > 1 ? globalTranslate("ariaFilterFromValue", "Filter from value") : index === 0 ? globalTranslate("ariaFilterValue", "Filter Value") : globalTranslate("ariaFilterToValue", "Filter to Value");
        element.setInputPlaceholder(_this115.getPlaceholderText(placeholder, position));
        element.setInputAriaLabel(ariaLabel);
      });
    }
  }, {
    key: "setElementValue",
    value: function setElementValue(element, value, fromFloatingFilter) {
      if (element instanceof AgAbstractInputField) {
        element.setValue(value != null ? String(value) : null, true);
      }
    }
  }, {
    key: "setElementDisplayed",
    value: function setElementDisplayed(element, displayed) {
      if (element instanceof _Component2) {
        _setDisplayed(element.getGui(), displayed);
      }
    }
  }, {
    key: "setElementDisabled",
    value: function setElementDisabled(element, disabled) {
      if (element instanceof _Component2) {
        _setDisabled(element.getGui(), disabled);
      }
    }
  }, {
    key: "attachElementOnChange",
    value: function attachElementOnChange(element, listener) {
      if (element instanceof AgAbstractInputField) {
        element.onValueChange(listener);
      }
    }
  }, {
    key: "forEachInput",
    value: function forEachInput(cb) {
      var _this116 = this;

      this.getConditionTypes().forEach(function (type, position) {
        _this116.forEachPositionTypeInput(position, type, cb);
      });
    }
  }, {
    key: "forEachPositionInput",
    value: function forEachPositionInput(position, cb) {
      var type = this.getConditionType(position);
      this.forEachPositionTypeInput(position, type, cb);
    }
  }, {
    key: "forEachPositionTypeInput",
    value: function forEachPositionTypeInput(position, type, cb) {
      var numberOfInputs = this.getNumberOfInputs(type);
      var inputs = this.getInputs(position);

      for (var index = 0; index < inputs.length; index++) {
        var input = inputs[index];

        if (input != null) {
          cb(input, index, position, numberOfInputs);
        }
      }
    }
  }, {
    key: "isConditionDisabled",
    value: function isConditionDisabled(position, lastUiCompletePosition) {
      if (this.isReadOnly()) {
        return true;
      }

      if (position === 0) {
        return false;
      }

      return position > lastUiCompletePosition + 1;
    }
  }, {
    key: "isConditionBodyVisible",
    value: function isConditionBodyVisible(position) {
      var type = this.getConditionType(position);
      var numberOfInputs = this.getNumberOfInputs(type);
      return numberOfInputs > 0;
    } // returns true if the UI represents a working filter, eg all parts are filled out.
    // eg if text filter and textfield blank then returns false.

  }, {
    key: "isConditionUiComplete",
    value: function isConditionUiComplete(position) {
      if (position >= this.getNumConditions()) {
        return false;
      }

      var type = this.getConditionType(position);

      if (type === _SimpleFilter.EMPTY) {
        return false;
      }

      if (this.getValues(position).some(function (v) {
        return v == null;
      })) {
        return false;
      }

      return true;
    }
  }, {
    key: "getNumConditions",
    value: function getNumConditions() {
      return this.eTypes.length;
    }
  }, {
    key: "getUiCompleteConditions",
    value: function getUiCompleteConditions() {
      var conditions = [];

      for (var position = 0; position < this.getNumConditions(); position++) {
        if (this.isConditionUiComplete(position)) {
          conditions.push(this.createCondition(position));
        }
      }

      return conditions;
    }
  }, {
    key: "createMissingConditionsAndOperators",
    value: function createMissingConditionsAndOperators() {
      if (this.isReadOnly()) {
        return;
      }

      for (var i = this.getNumConditions(); i < this.numAlwaysVisibleConditions; i++) {
        this.createJoinOperatorPanel();
        this.createOption();
      }
    }
  }, {
    key: "resetUiToDefaults",
    value: function resetUiToDefaults(silent) {
      var _this117 = this;

      this.removeConditionsAndOperators(this.isReadOnly() ? 1 : this.numAlwaysVisibleConditions);
      this.eTypes.forEach(function (eType) {
        return _this117.resetType(eType);
      });
      this.eJoinOperatorsAnd.forEach(function (eJoinOperatorAnd, index) {
        return _this117.resetJoinOperatorAnd(eJoinOperatorAnd, index, _this117.joinOperatorId + index);
      });
      this.eJoinOperatorsOr.forEach(function (eJoinOperatorOr, index) {
        return _this117.resetJoinOperatorOr(eJoinOperatorOr, index, _this117.joinOperatorId + index);
      });
      this.joinOperatorId++;
      this.forEachInput(function (element) {
        return _this117.resetInput(element);
      });
      this.resetPlaceholder();
      this.createMissingConditionsAndOperators();
      this.lastUiCompletePosition = null;

      if (!silent) {
        this.onUiChanged();
      }

      return _AgPromise2.resolve();
    }
  }, {
    key: "resetType",
    value: function resetType(eType) {
      var translate = this.localeService.getLocaleTextFunc();
      var filteringLabel = translate("ariaFilteringOperator", "Filtering operator");
      eType.setValue(this.optionsFactory.getDefaultOption(), true).setAriaLabel(filteringLabel).setDisabled(this.isReadOnly() || this.filterListOptions.length <= 1);
    }
  }, {
    key: "resetJoinOperatorAnd",
    value: function resetJoinOperatorAnd(eJoinOperatorAnd, index, uniqueGroupId) {
      this.resetJoinOperator(eJoinOperatorAnd, index, this.isDefaultOperator("AND"), this.translate("andCondition"), uniqueGroupId);
    }
  }, {
    key: "resetJoinOperatorOr",
    value: function resetJoinOperatorOr(eJoinOperatorOr, index, uniqueGroupId) {
      this.resetJoinOperator(eJoinOperatorOr, index, this.isDefaultOperator("OR"), this.translate("orCondition"), uniqueGroupId);
    }
  }, {
    key: "resetJoinOperator",
    value: function resetJoinOperator(eJoinOperator, index, value, label, uniqueGroupId) {
      this.updateJoinOperatorDisabled(eJoinOperator.setValue(value, true).setName("ag-simple-filter-and-or-".concat(this.getCompId(), "-").concat(uniqueGroupId)).setLabel(label), index);
    }
  }, {
    key: "updateJoinOperatorsDisabled",
    value: function updateJoinOperatorsDisabled() {
      var _this118 = this;

      this.eJoinOperatorsAnd.forEach(function (eJoinOperator, index) {
        return _this118.updateJoinOperatorDisabled(eJoinOperator, index);
      });
      this.eJoinOperatorsOr.forEach(function (eJoinOperator, index) {
        return _this118.updateJoinOperatorDisabled(eJoinOperator, index);
      });
    }
  }, {
    key: "updateJoinOperatorDisabled",
    value: function updateJoinOperatorDisabled(eJoinOperator, index) {
      eJoinOperator.setDisabled(this.isReadOnly() || index > 0);
    }
  }, {
    key: "resetInput",
    value: function resetInput(element) {
      this.setElementValue(element, null);
      this.setElementDisabled(element, this.isReadOnly());
    } // puts model values into the UI

  }, {
    key: "setConditionIntoUi",
    value: function setConditionIntoUi(model, position) {
      var _this119 = this;

      var values2 = this.mapValuesFromModel(model);
      this.forEachInput(function (element, index, elPosition, _2) {
        if (elPosition !== position) {
          return;
        }

        _this119.setElementValue(element, values2[index] != null ? values2[index] : null);
      });
    } // after floating filter changes, this sets the 'value' section. this is implemented by the base class
    // (as that's where value is controlled), the 'type' part from the floating filter is dealt with in this class.

  }, {
    key: "setValueFromFloatingFilter",
    value: function setValueFromFloatingFilter(value) {
      var _this120 = this;

      this.forEachInput(function (element, index, position, _2) {
        _this120.setElementValue(element, index === 0 && position === 0 ? value : null, true);
      });
    }
  }, {
    key: "isDefaultOperator",
    value: function isDefaultOperator(operator) {
      return operator === this.defaultJoinOperator;
    }
  }, {
    key: "addChangedListeners",
    value: function addChangedListeners(eType, position) {
      var _this121 = this;

      if (this.isReadOnly()) {
        return;
      }

      eType.onValueChange(this.listener);
      this.forEachPositionInput(position, function (element) {
        _this121.attachElementOnChange(element, _this121.listener);
      });
    }
    /** returns true if the row passes the said condition */

  }, {
    key: "individualConditionPasses",
    value: function individualConditionPasses(params, filterModel) {
      var cellValue = this.getCellValue(params.node);
      var values2 = this.mapValuesFromModel(filterModel);
      var customFilterOption = this.optionsFactory.getCustomOption(filterModel.type);
      var customFilterResult = this.evaluateCustomFilter(customFilterOption, values2, cellValue);

      if (customFilterResult != null) {
        return customFilterResult;
      }

      if (cellValue == null) {
        return this.evaluateNullValue(filterModel.type);
      }

      return this.evaluateNonNullValue(values2, cellValue, filterModel, params);
    }
  }, {
    key: "evaluateCustomFilter",
    value: function evaluateCustomFilter(customFilterOption, values2, cellValue) {
      if (customFilterOption == null) {
        return;
      }

      var predicate = customFilterOption.predicate;

      if (predicate != null && !values2.some(function (v) {
        return v == null;
      })) {
        return predicate(values2, cellValue);
      }

      return;
    }
  }, {
    key: "isBlank",
    value: function isBlank(cellValue) {
      return cellValue == null || typeof cellValue === "string" && cellValue.trim().length === 0;
    }
  }, {
    key: "hasInvalidInputs",
    value: function hasInvalidInputs() {
      return false;
    }
  }]);

  return _SimpleFilter;
}(_ProvidedFilter2);

_SimpleFilter.EMPTY = "empty";
_SimpleFilter.BLANK = "blank";
_SimpleFilter.NOT_BLANK = "notBlank";
_SimpleFilter.EQUALS = "equals";
_SimpleFilter.NOT_EQUAL = "notEqual";
_SimpleFilter.LESS_THAN = "lessThan";
_SimpleFilter.LESS_THAN_OR_EQUAL = "lessThanOrEqual";
_SimpleFilter.GREATER_THAN = "greaterThan";
_SimpleFilter.GREATER_THAN_OR_EQUAL = "greaterThanOrEqual";
_SimpleFilter.IN_RANGE = "inRange";
_SimpleFilter.CONTAINS = "contains";
_SimpleFilter.NOT_CONTAINS = "notContains";
_SimpleFilter.STARTS_WITH = "startsWith";
_SimpleFilter.ENDS_WITH = "endsWith";
var _SimpleFilter2 = _SimpleFilter; // community-modules/core/src/filter/provided/scalarFilter.ts

var _ScalarFilter2 =
/*#__PURE__*/
function (_SimpleFilter3) {
  "use strict";

  _inherits(_ScalarFilter, _SimpleFilter3);

  function _ScalarFilter() {
    _classCallCheck(this, _ScalarFilter);

    return _possibleConstructorReturn(this, _getPrototypeOf(_ScalarFilter).apply(this, arguments));
  }

  _createClass(_ScalarFilter, [{
    key: "setParams",
    value: function setParams(params) {
      _get(_getPrototypeOf(_ScalarFilter.prototype), "setParams", this).call(this, params);

      this.scalarFilterParams = params;
    }
  }, {
    key: "evaluateNullValue",
    value: function evaluateNullValue(filterType) {
      switch (filterType) {
        case _ScalarFilter.EQUALS:
        case _ScalarFilter.NOT_EQUAL:
          if (this.scalarFilterParams.includeBlanksInEquals) {
            return true;
          }

          break;

        case _ScalarFilter.GREATER_THAN:
        case _ScalarFilter.GREATER_THAN_OR_EQUAL:
          if (this.scalarFilterParams.includeBlanksInGreaterThan) {
            return true;
          }

          break;

        case _ScalarFilter.LESS_THAN:
        case _ScalarFilter.LESS_THAN_OR_EQUAL:
          if (this.scalarFilterParams.includeBlanksInLessThan) {
            return true;
          }

          break;

        case _ScalarFilter.IN_RANGE:
          if (this.scalarFilterParams.includeBlanksInRange) {
            return true;
          }

          break;

        case _ScalarFilter.BLANK:
          return true;

        case _ScalarFilter.NOT_BLANK:
          return false;
      }

      return false;
    }
  }, {
    key: "evaluateNonNullValue",
    value: function evaluateNonNullValue(values2, cellValue, filterModel) {
      var comparator = this.comparator();
      var compareResult = values2[0] != null ? comparator(values2[0], cellValue) : 0;

      switch (filterModel.type) {
        case _ScalarFilter.EQUALS:
          return compareResult === 0;

        case _ScalarFilter.NOT_EQUAL:
          return compareResult !== 0;

        case _ScalarFilter.GREATER_THAN:
          return compareResult > 0;

        case _ScalarFilter.GREATER_THAN_OR_EQUAL:
          return compareResult >= 0;

        case _ScalarFilter.LESS_THAN:
          return compareResult < 0;

        case _ScalarFilter.LESS_THAN_OR_EQUAL:
          return compareResult <= 0;

        case _ScalarFilter.IN_RANGE:
          {
            var compareToResult = comparator(values2[1], cellValue);
            return this.scalarFilterParams.inRangeInclusive ? compareResult >= 0 && compareToResult <= 0 : compareResult > 0 && compareToResult < 0;
          }

        case _ScalarFilter.BLANK:
          return this.isBlank(cellValue);

        case _ScalarFilter.NOT_BLANK:
          return !this.isBlank(cellValue);

        default:
          console.warn('AG Grid: Unexpected type of filter "' + filterModel.type + '", it looks like the filter was configured with incorrect Filter Options');
          return true;
      }
    }
  }]);

  return _ScalarFilter;
}(_SimpleFilter2); // community-modules/core/src/filter/provided/date/dateFilter.ts


var DEFAULT_MIN_YEAR = 1e3;
var DEFAULT_MAX_YEAR = Infinity;

var DateFilterModelFormatter =
/*#__PURE__*/
function (_SimpleFilterModelFor) {
  "use strict";

  _inherits(DateFilterModelFormatter, _SimpleFilterModelFor);

  function DateFilterModelFormatter(dateFilterParams, localeService, optionsFactory) {
    var _this122;

    _classCallCheck(this, DateFilterModelFormatter);

    _this122 = _possibleConstructorReturn(this, _getPrototypeOf(DateFilterModelFormatter).call(this, localeService, optionsFactory));
    _this122.dateFilterParams = dateFilterParams;
    return _this122;
  }

  _createClass(DateFilterModelFormatter, [{
    key: "conditionToString",
    value: function conditionToString(condition, options) {
      var type = condition.type;

      var _ref17 = options || {},
          numberOfInputs = _ref17.numberOfInputs;

      var isRange = type == _SimpleFilter2.IN_RANGE || numberOfInputs === 2;

      var dateFrom = _parseDateTimeFromString(condition.dateFrom);

      var dateTo = _parseDateTimeFromString(condition.dateTo);

      var format = this.dateFilterParams.inRangeFloatingFilterDateFormat;

      if (isRange) {
        var formattedFrom = dateFrom !== null ? _dateToFormattedString(dateFrom, format) : "null";
        var formattedTo = dateTo !== null ? _dateToFormattedString(dateTo, format) : "null";
        return "".concat(formattedFrom, "-").concat(formattedTo);
      }

      if (dateFrom != null) {
        return _dateToFormattedString(dateFrom, format);
      }

      return "".concat(type);
    }
  }, {
    key: "updateParams",
    value: function updateParams(params) {
      _get(_getPrototypeOf(DateFilterModelFormatter.prototype), "updateParams", this).call(this, params);

      this.dateFilterParams = params.dateFilterParams;
    }
  }]);

  return DateFilterModelFormatter;
}(SimpleFilterModelFormatter);

var _DateFilter =
/*#__PURE__*/
function (_ScalarFilter3) {
  "use strict";

  _inherits(_DateFilter, _ScalarFilter3);

  function _DateFilter() {
    var _this123;

    _classCallCheck(this, _DateFilter);

    _this123 = _possibleConstructorReturn(this, _getPrototypeOf(_DateFilter).call(this, "dateFilter"));
    _this123.eConditionPanelsFrom = [];
    _this123.eConditionPanelsTo = [];
    _this123.dateConditionFromComps = [];
    _this123.dateConditionToComps = [];
    _this123.minValidYear = DEFAULT_MIN_YEAR;
    _this123.maxValidYear = DEFAULT_MAX_YEAR;
    _this123.minValidDate = null;
    _this123.maxValidDate = null;
    return _this123;
  }

  _createClass(_DateFilter, [{
    key: "afterGuiAttached",
    value: function afterGuiAttached(params) {
      _get(_getPrototypeOf(_DateFilter.prototype), "afterGuiAttached", this).call(this, params);

      this.dateConditionFromComps[0].afterGuiAttached(params);
    }
  }, {
    key: "mapValuesFromModel",
    value: function mapValuesFromModel(filterModel) {
      var _ref18 = filterModel || {},
          dateFrom = _ref18.dateFrom,
          dateTo = _ref18.dateTo,
          type = _ref18.type;

      return [dateFrom && _parseDateTimeFromString(dateFrom) || null, dateTo && _parseDateTimeFromString(dateTo) || null].slice(0, this.getNumberOfInputs(type));
    }
  }, {
    key: "comparator",
    value: function comparator() {
      return this.dateFilterParams.comparator ? this.dateFilterParams.comparator : this.defaultComparator.bind(this);
    }
  }, {
    key: "defaultComparator",
    value: function defaultComparator(filterDate, cellValue) {
      var cellAsDate = cellValue;

      if (cellValue == null || cellAsDate < filterDate) {
        return -1;
      }

      if (cellAsDate > filterDate) {
        return 1;
      }

      return 0;
    }
  }, {
    key: "setParams",
    value: function setParams(params) {
      this.dateFilterParams = params;

      _get(_getPrototypeOf(_DateFilter.prototype), "setParams", this).call(this, params);

      var yearParser = function yearParser(param, fallback) {
        if (params[param] != null) {
          if (!isNaN(params[param])) {
            return params[param] == null ? fallback : Number(params[param]);
          } else {
            console.warn("AG Grid: DateFilter ".concat(param, " is not a number"));
          }
        }

        return fallback;
      };

      this.minValidYear = yearParser("minValidYear", DEFAULT_MIN_YEAR);
      this.maxValidYear = yearParser("maxValidYear", DEFAULT_MAX_YEAR);

      if (this.minValidYear > this.maxValidYear) {
        console.warn("AG Grid: DateFilter minValidYear should be <= maxValidYear");
      }

      if (params.minValidDate) {
        this.minValidDate = params.minValidDate instanceof Date ? params.minValidDate : _parseDateTimeFromString(params.minValidDate);
      } else {
        this.minValidDate = null;
      }

      if (params.maxValidDate) {
        this.maxValidDate = params.maxValidDate instanceof Date ? params.maxValidDate : _parseDateTimeFromString(params.maxValidDate);
      } else {
        this.maxValidDate = null;
      }

      if (this.minValidDate && this.maxValidDate && this.minValidDate > this.maxValidDate) {
        console.warn("AG Grid: DateFilter minValidDate should be <= maxValidDate");
      }

      this.filterModelFormatter = new DateFilterModelFormatter(this.dateFilterParams, this.localeService, this.optionsFactory);
    }
  }, {
    key: "createDateCompWrapper",
    value: function createDateCompWrapper(element) {
      var _this124 = this;

      var dateCompWrapper = new DateCompWrapper(this.getContext(), this.userComponentFactory, {
        onDateChanged: function onDateChanged() {
          return _this124.onUiChanged();
        },
        filterParams: this.dateFilterParams
      }, element);
      this.addDestroyFunc(function () {
        return dateCompWrapper.destroy();
      });
      return dateCompWrapper;
    }
  }, {
    key: "setElementValue",
    value: function setElementValue(element, value) {
      element.setDate(value);
    }
  }, {
    key: "setElementDisplayed",
    value: function setElementDisplayed(element, displayed) {
      element.setDisplayed(displayed);
    }
  }, {
    key: "setElementDisabled",
    value: function setElementDisabled(element, disabled) {
      element.setDisabled(disabled);
    }
  }, {
    key: "getDefaultFilterOptions",
    value: function getDefaultFilterOptions() {
      return _DateFilter.DEFAULT_FILTER_OPTIONS;
    }
  }, {
    key: "createValueElement",
    value: function createValueElement() {
      var eDocument = this.gos.getDocument();
      var eCondition = eDocument.createElement("div");
      eCondition.classList.add("ag-filter-body");
      this.createFromToElement(eCondition, this.eConditionPanelsFrom, this.dateConditionFromComps, "from");
      this.createFromToElement(eCondition, this.eConditionPanelsTo, this.dateConditionToComps, "to");
      return eCondition;
    }
  }, {
    key: "createFromToElement",
    value: function createFromToElement(eCondition, eConditionPanels, dateConditionComps, fromTo) {
      var eDocument = this.gos.getDocument();
      var eConditionPanel = eDocument.createElement("div");
      eConditionPanel.classList.add("ag-filter-".concat(fromTo));
      eConditionPanel.classList.add("ag-filter-date-".concat(fromTo));
      eConditionPanels.push(eConditionPanel);
      eCondition.appendChild(eConditionPanel);
      dateConditionComps.push(this.createDateCompWrapper(eConditionPanel));
    }
  }, {
    key: "removeValueElements",
    value: function removeValueElements(startPosition, deleteCount) {
      this.removeDateComps(this.dateConditionFromComps, startPosition, deleteCount);
      this.removeDateComps(this.dateConditionToComps, startPosition, deleteCount);
      this.removeItems(this.eConditionPanelsFrom, startPosition, deleteCount);
      this.removeItems(this.eConditionPanelsTo, startPosition, deleteCount);
    }
  }, {
    key: "removeDateComps",
    value: function removeDateComps(components, startPosition, deleteCount) {
      var removedComponents = this.removeItems(components, startPosition, deleteCount);
      removedComponents.forEach(function (comp) {
        return comp.destroy();
      });
    }
  }, {
    key: "isValidDateValue",
    value: function isValidDateValue(value) {
      if (value === null) {
        return false;
      }

      if (this.minValidDate) {
        if (value < this.minValidDate) {
          return false;
        }
      } else {
        if (value.getUTCFullYear() < this.minValidYear) {
          return false;
        }
      }

      if (this.maxValidDate) {
        if (value > this.maxValidDate) {
          return false;
        }
      } else {
        if (value.getUTCFullYear() > this.maxValidYear) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "isConditionUiComplete",
    value: function isConditionUiComplete(position) {
      var _this125 = this;

      if (!_get(_getPrototypeOf(_DateFilter.prototype), "isConditionUiComplete", this).call(this, position)) {
        return false;
      }

      var valid = true;
      this.forEachInput(function (element, index, elPosition, numberOfInputs) {
        if (elPosition !== position || !valid || index >= numberOfInputs) {
          return;
        }

        valid = valid && _this125.isValidDateValue(element.getDate());
      });
      return valid;
    }
  }, {
    key: "areSimpleModelsEqual",
    value: function areSimpleModelsEqual(aSimple, bSimple) {
      return aSimple.dateFrom === bSimple.dateFrom && aSimple.dateTo === bSimple.dateTo && aSimple.type === bSimple.type;
    }
  }, {
    key: "getFilterType",
    value: function getFilterType() {
      return "date";
    }
  }, {
    key: "createCondition",
    value: function createCondition(position) {
      var type = this.getConditionType(position);
      var model = {};
      var values2 = this.getValues(position);

      if (values2.length > 0) {
        model.dateFrom = _serialiseDate(values2[0]);
      }

      if (values2.length > 1) {
        model.dateTo = _serialiseDate(values2[1]);
      }

      return __spreadValues({
        dateFrom: null,
        dateTo: null,
        filterType: this.getFilterType(),
        type: type
      }, model);
    }
  }, {
    key: "resetPlaceholder",
    value: function resetPlaceholder() {
      var globalTranslate = this.localeService.getLocaleTextFunc();
      var placeholder = this.translate("dateFormatOoo");
      var ariaLabel = globalTranslate("ariaFilterValue", "Filter Value");
      this.forEachInput(function (element) {
        element.setInputPlaceholder(placeholder);
        element.setInputAriaLabel(ariaLabel);
      });
    }
  }, {
    key: "getInputs",
    value: function getInputs(position) {
      if (position >= this.dateConditionFromComps.length) {
        return [null, null];
      }

      return [this.dateConditionFromComps[position], this.dateConditionToComps[position]];
    }
  }, {
    key: "getValues",
    value: function getValues(position) {
      var result = [];
      this.forEachPositionInput(position, function (element, index, _elPosition, numberOfInputs) {
        if (index < numberOfInputs) {
          result.push(element.getDate());
        }
      });
      return result;
    }
  }, {
    key: "translate",
    value: function translate(key) {
      if (key === _ScalarFilter2.LESS_THAN) {
        return _get(_getPrototypeOf(_DateFilter.prototype), "translate", this).call(this, "before");
      }

      if (key === _ScalarFilter2.GREATER_THAN) {
        return _get(_getPrototypeOf(_DateFilter.prototype), "translate", this).call(this, "after");
      }

      return _get(_getPrototypeOf(_DateFilter.prototype), "translate", this).call(this, key);
    }
  }, {
    key: "getModelAsString",
    value: function getModelAsString(model) {
      var _a;

      return (_a = this.filterModelFormatter.getModelAsString(model)) != null ? _a : "";
    }
  }]);

  return _DateFilter;
}(_ScalarFilter2);

_DateFilter.DEFAULT_FILTER_OPTIONS = [_ScalarFilter2.EQUALS, _ScalarFilter2.NOT_EQUAL, _ScalarFilter2.LESS_THAN, _ScalarFilter2.GREATER_THAN, _ScalarFilter2.IN_RANGE, _ScalarFilter2.BLANK, _ScalarFilter2.NOT_BLANK];

__decorateClass([_Autowired("userComponentFactory")], _DateFilter.prototype, "userComponentFactory", 2);

var _DateFilter2 = _DateFilter; // community-modules/core/src/filter/floating/provided/simpleFloatingFilter.ts

var SimpleFloatingFilter =
/*#__PURE__*/
function (_Component7) {
  "use strict";

  _inherits(SimpleFloatingFilter, _Component7);

  function SimpleFloatingFilter() {
    _classCallCheck(this, SimpleFloatingFilter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimpleFloatingFilter).apply(this, arguments));
  }

  _createClass(SimpleFloatingFilter, [{
    key: "getDefaultDebounceMs",
    value: function getDefaultDebounceMs() {
      return 0;
    } // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(SimpleFloatingFilter.prototype), "destroy", this).call(this);
    }
  }, {
    key: "isEventFromFloatingFilter",
    value: function isEventFromFloatingFilter(event) {
      return event && event.afterFloatingFilter;
    }
  }, {
    key: "isEventFromDataChange",
    value: function isEventFromDataChange(event) {
      return event == null ? void 0 : event.afterDataChange;
    }
  }, {
    key: "getLastType",
    value: function getLastType() {
      return this.lastType;
    }
  }, {
    key: "isReadOnly",
    value: function isReadOnly() {
      return this.readOnly;
    }
  }, {
    key: "setLastTypeFromModel",
    value: function setLastTypeFromModel(model) {
      if (!model) {
        this.lastType = this.optionsFactory.getDefaultOption();
        return;
      }

      var isCombined = model.operator;
      var condition;

      if (isCombined) {
        var combinedModel = model;
        condition = combinedModel.conditions[0];
      } else {
        condition = model;
      }

      this.lastType = condition.type;
    }
  }, {
    key: "canWeEditAfterModelFromParentFilter",
    value: function canWeEditAfterModelFromParentFilter(model) {
      if (!model) {
        return this.isTypeEditable(this.lastType);
      }

      var isCombined = model.operator;

      if (isCombined) {
        return false;
      }

      var simpleModel = model;
      return this.isTypeEditable(simpleModel.type);
    }
  }, {
    key: "init",
    value: function init(params) {
      this.setSimpleParams(params, false);
    }
  }, {
    key: "setSimpleParams",
    value: function setSimpleParams(params) {
      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.optionsFactory = new OptionsFactory();
      this.optionsFactory.init(params.filterParams, this.getDefaultFilterOptions());

      if (!update) {
        this.lastType = this.optionsFactory.getDefaultOption();
      }

      this.readOnly = !!params.filterParams.readOnly;
      var editable = this.isTypeEditable(this.optionsFactory.getDefaultOption());
      this.setEditable(editable);
    }
  }, {
    key: "onParamsUpdated",
    value: function onParamsUpdated(params) {
      this.refresh(params);
    }
  }, {
    key: "refresh",
    value: function refresh(params) {
      this.setSimpleParams(params);
    }
  }, {
    key: "doesFilterHaveSingleInput",
    value: function doesFilterHaveSingleInput(filterType) {
      var customFilterOption = this.optionsFactory.getCustomOption(filterType);

      var _ref19 = customFilterOption || {},
          numberOfInputs = _ref19.numberOfInputs;

      return numberOfInputs == null || numberOfInputs == 1;
    }
  }, {
    key: "isTypeEditable",
    value: function isTypeEditable(type) {
      var uneditableTypes = [_SimpleFilter2.IN_RANGE, _SimpleFilter2.EMPTY, _SimpleFilter2.BLANK, _SimpleFilter2.NOT_BLANK];
      return !!type && !this.isReadOnly() && this.doesFilterHaveSingleInput(type) && uneditableTypes.indexOf(type) < 0;
    }
  }, {
    key: "getAriaLabel",
    value: function getAriaLabel(params) {
      var displayName = this.columnModel.getDisplayNameForColumn(params.column, "header", true);
      var translate = this.localeService.getLocaleTextFunc();
      return "".concat(displayName, " ").concat(translate("ariaFilterInput", "Filter Input"));
    }
  }]);

  return SimpleFloatingFilter;
}(_Component2);

__decorateClass([_Autowired("columnModel")], SimpleFloatingFilter.prototype, "columnModel", 2); // community-modules/core/src/filter/provided/date/dateFloatingFilter.ts


var DateFloatingFilter =
/*#__PURE__*/
function (_SimpleFloatingFilter) {
  "use strict";

  _inherits(DateFloatingFilter, _SimpleFloatingFilter);

  function DateFloatingFilter() {
    _classCallCheck(this, DateFloatingFilter);

    return _possibleConstructorReturn(this, _getPrototypeOf(DateFloatingFilter).call(this,
    /* html */
    "\n            <div class=\"ag-floating-filter-input\" role=\"presentation\">\n                <ag-input-text-field ref=\"eReadOnlyText\"></ag-input-text-field>\n                <div ref=\"eDateWrapper\" style=\"display: flex;\"></div>\n            </div>"));
  }

  _createClass(DateFloatingFilter, [{
    key: "getDefaultFilterOptions",
    value: function getDefaultFilterOptions() {
      return _DateFilter2.DEFAULT_FILTER_OPTIONS;
    }
  }, {
    key: "init",
    value: function init(params) {
      _get(_getPrototypeOf(DateFloatingFilter.prototype), "init", this).call(this, params);

      this.params = params;
      this.filterParams = params.filterParams;
      this.createDateComponent();
      this.filterModelFormatter = new DateFilterModelFormatter(this.filterParams, this.localeService, this.optionsFactory);
      var translate = this.localeService.getLocaleTextFunc();
      this.eReadOnlyText.setDisabled(true).setInputAriaLabel(translate("ariaDateFilterInput", "Date Filter Input"));
    }
  }, {
    key: "onParamsUpdated",
    value: function onParamsUpdated(params) {
      this.refresh(params);
    }
  }, {
    key: "refresh",
    value: function refresh(params) {
      _get(_getPrototypeOf(DateFloatingFilter.prototype), "refresh", this).call(this, params);

      this.params = params;
      this.filterParams = params.filterParams;
      this.updateDateComponent();
      this.filterModelFormatter.updateParams({
        optionsFactory: this.optionsFactory,
        dateFilterParams: this.filterParams
      });
      this.updateCompOnModelChange(params.currentParentModel());
    }
  }, {
    key: "updateCompOnModelChange",
    value: function updateCompOnModelChange(model) {
      var allowEditing = !this.isReadOnly() && this.canWeEditAfterModelFromParentFilter(model);
      this.setEditable(allowEditing);

      if (allowEditing) {
        if (model) {
          var dateModel = model;
          this.dateComp.setDate(_parseDateTimeFromString(dateModel.dateFrom));
        } else {
          this.dateComp.setDate(null);
        }

        this.eReadOnlyText.setValue("");
      } else {
        this.eReadOnlyText.setValue(this.filterModelFormatter.getModelAsString(model));
        this.dateComp.setDate(null);
      }
    }
  }, {
    key: "setEditable",
    value: function setEditable(editable) {
      _setDisplayed(this.eDateWrapper, editable);

      _setDisplayed(this.eReadOnlyText.getGui(), !editable);
    }
  }, {
    key: "onParentModelChanged",
    value: function onParentModelChanged(model, event) {
      if (this.isEventFromFloatingFilter(event) || this.isEventFromDataChange(event)) {
        return;
      }

      _get(_getPrototypeOf(DateFloatingFilter.prototype), "setLastTypeFromModel", this).call(this, model);

      this.updateCompOnModelChange(model);
    }
  }, {
    key: "onDateChanged",
    value: function onDateChanged() {
      var _this126 = this;

      var filterValueDate = this.dateComp.getDate();

      var filterValueText = _serialiseDate(filterValueDate);

      this.params.parentFilterInstance(function (filterInstance) {
        if (filterInstance) {
          var date = _parseDateTimeFromString(filterValueText);

          filterInstance.onFloatingFilterChanged(_this126.getLastType() || null, date);
        }
      });
    }
  }, {
    key: "getDateComponentParams",
    value: function getDateComponentParams() {
      var debounceMs = _ProvidedFilter2.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs());

      return {
        onDateChanged: _debounce(this.onDateChanged.bind(this), debounceMs),
        filterParams: this.params.column.getColDef().filterParams
      };
    }
  }, {
    key: "createDateComponent",
    value: function createDateComponent() {
      var _this127 = this;

      this.dateComp = new DateCompWrapper(this.getContext(), this.userComponentFactory, this.getDateComponentParams(), this.eDateWrapper, function (dateComp) {
        dateComp.setInputAriaLabel(_this127.getAriaLabel(_this127.params));
      });
      this.addDestroyFunc(function () {
        return _this127.dateComp.destroy();
      });
    }
  }, {
    key: "updateDateComponent",
    value: function updateDateComponent() {
      var params = this.gos.addGridCommonParams(this.getDateComponentParams());
      this.dateComp.updateParams(params);
    }
  }, {
    key: "getFilterModelFormatter",
    value: function getFilterModelFormatter() {
      return this.filterModelFormatter;
    }
  }]);

  return DateFloatingFilter;
}(SimpleFloatingFilter);

__decorateClass([_Autowired("userComponentFactory")], DateFloatingFilter.prototype, "userComponentFactory", 2);

__decorateClass([_RefSelector("eReadOnlyText")], DateFloatingFilter.prototype, "eReadOnlyText", 2);

__decorateClass([_RefSelector("eDateWrapper")], DateFloatingFilter.prototype, "eDateWrapper", 2); // community-modules/core/src/filter/provided/date/defaultDateComponent.ts


var DefaultDateComponent =
/*#__PURE__*/
function (_Component8) {
  "use strict";

  _inherits(DefaultDateComponent, _Component8);

  function DefaultDateComponent() {
    _classCallCheck(this, DefaultDateComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultDateComponent).call(this,
    /* html */
    "\n            <div class=\"ag-filter-filter\">\n                <ag-input-text-field class=\"ag-date-filter\" ref=\"eDateInput\"></ag-input-text-field>\n            </div>"));
  } // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.


  _createClass(DefaultDateComponent, [{
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(DefaultDateComponent.prototype), "destroy", this).call(this);
    }
  }, {
    key: "init",
    value: function init(params) {
      var _this128 = this;

      this.params = params;
      this.setParams(params);
      var inputElement = this.eDateInput.getInputElement();
      this.addManagedListener(inputElement, "mousedown", function () {
        if (_this128.eDateInput.isDisabled() || _this128.usingSafariDatePicker) {
          return;
        }

        inputElement.focus();
      });
      this.addManagedListener(inputElement, "input", function (e) {
        if (e.target !== _this128.gos.getActiveDomElement()) {
          return;
        }

        if (_this128.eDateInput.isDisabled()) {
          return;
        }

        _this128.params.onDateChanged();
      });
    }
  }, {
    key: "setParams",
    value: function setParams(params) {
      var inputElement = this.eDateInput.getInputElement();
      var shouldUseBrowserDatePicker = this.shouldUseBrowserDatePicker(params);
      this.usingSafariDatePicker = shouldUseBrowserDatePicker && _isBrowserSafari();
      inputElement.type = shouldUseBrowserDatePicker ? "date" : "text";

      var _ref20 = params.filterParams || {},
          minValidYear = _ref20.minValidYear,
          maxValidYear = _ref20.maxValidYear,
          minValidDate = _ref20.minValidDate,
          maxValidDate = _ref20.maxValidDate;

      if (minValidDate && minValidYear) {
        _warnOnce("DateFilter should not have both minValidDate and minValidYear parameters set at the same time! minValidYear will be ignored.");
      }

      if (maxValidDate && maxValidYear) {
        _warnOnce("DateFilter should not have both maxValidDate and maxValidYear parameters set at the same time! maxValidYear will be ignored.");
      }

      if (minValidDate && maxValidDate) {
        var _map = [minValidDate, maxValidDate].map(function (v) {
          return v instanceof Date ? v : _parseDateTimeFromString(v);
        }),
            _map2 = _slicedToArray(_map, 2),
            parsedMinValidDate = _map2[0],
            parsedMaxValidDate = _map2[1];

        if (parsedMinValidDate && parsedMaxValidDate && parsedMinValidDate.getTime() > parsedMaxValidDate.getTime()) {
          _warnOnce("DateFilter parameter minValidDate should always be lower than or equal to parameter maxValidDate.");
        }
      }

      if (minValidDate) {
        if (minValidDate instanceof Date) {
          inputElement.min = _dateToFormattedString(minValidDate);
        } else {
          inputElement.min = minValidDate;
        }
      } else {
        if (minValidYear) {
          inputElement.min = "".concat(minValidYear, "-01-01");
        }
      }

      if (maxValidDate) {
        if (maxValidDate instanceof Date) {
          inputElement.max = _dateToFormattedString(maxValidDate);
        } else {
          inputElement.max = maxValidDate;
        }
      } else {
        if (maxValidYear) {
          inputElement.max = "".concat(maxValidYear, "-12-31");
        }
      }
    }
  }, {
    key: "onParamsUpdated",
    value: function onParamsUpdated(params) {
      this.refresh(params);
    }
  }, {
    key: "refresh",
    value: function refresh(params) {
      this.params = params;
      this.setParams(params);
    }
  }, {
    key: "getDate",
    value: function getDate() {
      return _parseDateTimeFromString(this.eDateInput.getValue());
    }
  }, {
    key: "setDate",
    value: function setDate(date) {
      this.eDateInput.setValue(_serialiseDate(date, false));
    }
  }, {
    key: "setInputPlaceholder",
    value: function setInputPlaceholder(placeholder) {
      this.eDateInput.setInputPlaceholder(placeholder);
    }
  }, {
    key: "setInputAriaLabel",
    value: function setInputAriaLabel(ariaLabel) {
      this.eDateInput.setAriaLabel(ariaLabel);
    }
  }, {
    key: "setDisabled",
    value: function setDisabled(disabled) {
      this.eDateInput.setDisabled(disabled);
    }
  }, {
    key: "afterGuiAttached",
    value: function afterGuiAttached(params) {
      if (!params || !params.suppressFocus) {
        this.eDateInput.getInputElement().focus();
      }
    }
  }, {
    key: "shouldUseBrowserDatePicker",
    value: function shouldUseBrowserDatePicker(params) {
      if (params.filterParams && params.filterParams.browserDatePicker != null) {
        return params.filterParams.browserDatePicker;
      }

      return _isBrowserChrome() || _isBrowserFirefox() || _isBrowserSafari() && _getSafariVersion() >= 14.1;
    }
  }]);

  return DefaultDateComponent;
}(_Component2);

__decorateClass([_RefSelector("eDateInput")], DefaultDateComponent.prototype, "eDateInput", 2); // community-modules/core/src/widgets/agInputTextField.ts


var _AgInputTextField =
/*#__PURE__*/
function (_AgAbstractInputField2) {
  "use strict";

  _inherits(_AgInputTextField, _AgAbstractInputField2);

  function _AgInputTextField(config) {
    var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ag-text-field";
    var inputType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "text";

    _classCallCheck(this, _AgInputTextField);

    return _possibleConstructorReturn(this, _getPrototypeOf(_AgInputTextField).call(this, config, className, inputType));
  }

  _createClass(_AgInputTextField, [{
    key: "postConstruct",
    value: function postConstruct() {
      _get(_getPrototypeOf(_AgInputTextField.prototype), "postConstruct", this).call(this);

      if (this.config.allowedCharPattern) {
        this.preventDisallowedCharacters();
      }
    }
  }, {
    key: "setValue",
    value: function setValue(value, silent) {
      if (this.eInput.value !== value) {
        this.eInput.value = _exists(value) ? value : "";
      }

      return _get(_getPrototypeOf(_AgInputTextField.prototype), "setValue", this).call(this, value, silent);
    }
    /** Used to set an initial value into the input without necessarily setting `this.value` or triggering events (e.g. to set an invalid value) */

  }, {
    key: "setStartValue",
    value: function setStartValue(value) {
      this.setValue(value, true);
    }
  }, {
    key: "preventDisallowedCharacters",
    value: function preventDisallowedCharacters() {
      var pattern = new RegExp("[".concat(this.config.allowedCharPattern, "]"));

      var preventCharacters = function preventCharacters(event) {
        if (!_isEventFromPrintableCharacter(event)) {
          return;
        }

        if (event.key && !pattern.test(event.key)) {
          event.preventDefault();
        }
      };

      this.addManagedListener(this.eInput, "keydown", preventCharacters);
      this.addManagedListener(this.eInput, "paste", function (e) {
        var _a;

        var text = (_a = e.clipboardData) == null ? void 0 : _a.getData("text");

        if (text && text.split("").some(function (c) {
          return !pattern.test(c);
        })) {
          e.preventDefault();
        }
      });
    }
  }]);

  return _AgInputTextField;
}(AgAbstractInputField); // community-modules/core/src/widgets/agInputNumberField.ts


var _AgInputNumberField =
/*#__PURE__*/
function (_AgInputTextField2) {
  "use strict";

  _inherits(_AgInputNumberField, _AgInputTextField2);

  function _AgInputNumberField(config) {
    _classCallCheck(this, _AgInputNumberField);

    return _possibleConstructorReturn(this, _getPrototypeOf(_AgInputNumberField).call(this, config, "ag-number-field", "number"));
  }

  _createClass(_AgInputNumberField, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this129 = this;

      _get(_getPrototypeOf(_AgInputNumberField.prototype), "postConstruct", this).call(this);

      this.addManagedListener(this.eInput, "blur", function () {
        var floatedValue = parseFloat(_this129.eInput.value);
        var value = isNaN(floatedValue) ? "" : _this129.normalizeValue(floatedValue.toString());

        if (_this129.value !== value) {
          _this129.setValue(value);
        }
      });
      this.addManagedListener(this.eInput, "wheel", this.onWheel.bind(this));
      this.eInput.step = "any";
      var _this$config12 = this.config,
          precision = _this$config12.precision,
          min = _this$config12.min,
          max = _this$config12.max,
          step = _this$config12.step;
      if (typeof precision === "number") this.setPrecision(precision);
      if (typeof min === "number") this.setMin(min);
      if (typeof max === "number") this.setMax(max);
      if (typeof step === "number") this.setStep(step);
    }
  }, {
    key: "onWheel",
    value: function onWheel(e) {
      if (this.gos.getActiveDomElement() === this.eInput) {
        e.preventDefault();
      }
    }
  }, {
    key: "normalizeValue",
    value: function normalizeValue(value) {
      if (value === "") {
        return "";
      }

      if (this.precision != null) {
        value = this.adjustPrecision(value);
      }

      var val = parseFloat(value);

      if (this.min != null && val < this.min) {
        value = this.min.toString();
      } else if (this.max != null && val > this.max) {
        value = this.max.toString();
      }

      return value;
    }
  }, {
    key: "adjustPrecision",
    value: function adjustPrecision(value, isScientificNotation) {
      if (this.precision == null) {
        return value;
      }

      if (isScientificNotation) {
        var floatString = parseFloat(value).toFixed(this.precision);
        return parseFloat(floatString).toString();
      }

      var parts = String(value).split(".");

      if (parts.length > 1) {
        if (parts[1].length <= this.precision) {
          return value;
        } else if (this.precision > 0) {
          return "".concat(parts[0], ".").concat(parts[1].slice(0, this.precision));
        }
      }

      return parts[0];
    }
  }, {
    key: "setMin",
    value: function setMin(min) {
      if (this.min === min) {
        return this;
      }

      this.min = min;

      _addOrRemoveAttribute(this.eInput, "min", min);

      return this;
    }
  }, {
    key: "setMax",
    value: function setMax(max) {
      if (this.max === max) {
        return this;
      }

      this.max = max;

      _addOrRemoveAttribute(this.eInput, "max", max);

      return this;
    }
  }, {
    key: "setPrecision",
    value: function setPrecision(precision) {
      this.precision = precision;
      return this;
    }
  }, {
    key: "setStep",
    value: function setStep(step) {
      if (this.step === step) {
        return this;
      }

      this.step = step;

      _addOrRemoveAttribute(this.eInput, "step", step);

      return this;
    }
  }, {
    key: "setValue",
    value: function setValue(value, silent) {
      var _this130 = this;

      return this.setValueOrInputValue(function (v) {
        return _get(_getPrototypeOf(_AgInputNumberField.prototype), "setValue", _this130).call(_this130, v, silent);
      }, function () {
        return _this130;
      }, value);
    }
  }, {
    key: "setStartValue",
    value: function setStartValue(value) {
      var _this131 = this;

      return this.setValueOrInputValue(function (v) {
        return _get(_getPrototypeOf(_AgInputNumberField.prototype), "setValue", _this131).call(_this131, v, true);
      }, function (v) {
        _this131.eInput.value = v;
      }, value);
    }
  }, {
    key: "setValueOrInputValue",
    value: function setValueOrInputValue(setValueFunc, setInputValueOnlyFunc, value) {
      if (_exists(value)) {
        var setInputValueOnly = this.isScientificNotation(value);

        if (setInputValueOnly && this.eInput.validity.valid) {
          return setValueFunc(value);
        }

        if (!setInputValueOnly) {
          value = this.adjustPrecision(value);
          var normalizedValue = this.normalizeValue(value);
          setInputValueOnly = value != normalizedValue;
        }

        if (setInputValueOnly) {
          return setInputValueOnlyFunc(value);
        }
      }

      return setValueFunc(value);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      if (!this.eInput.validity.valid) {
        return void 0;
      }

      var inputValue = this.eInput.value;

      if (this.isScientificNotation(inputValue)) {
        return this.adjustPrecision(inputValue, true);
      }

      return _get(_getPrototypeOf(_AgInputNumberField.prototype), "getValue", this).call(this);
    }
  }, {
    key: "isScientificNotation",
    value: function isScientificNotation(value) {
      return typeof value === "string" && value.includes("e");
    }
  }]);

  return _AgInputNumberField;
}(_AgInputTextField); // community-modules/core/src/filter/provided/number/numberFilter.ts


var NumberFilterModelFormatter =
/*#__PURE__*/
function (_SimpleFilterModelFor2) {
  "use strict";

  _inherits(NumberFilterModelFormatter, _SimpleFilterModelFor2);

  function NumberFilterModelFormatter() {
    _classCallCheck(this, NumberFilterModelFormatter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NumberFilterModelFormatter).apply(this, arguments));
  }

  _createClass(NumberFilterModelFormatter, [{
    key: "conditionToString",
    value: function conditionToString(condition, options) {
      var _ref21 = options || {},
          numberOfInputs = _ref21.numberOfInputs;

      var isRange = condition.type == _SimpleFilter2.IN_RANGE || numberOfInputs === 2;

      if (isRange) {
        return "".concat(this.formatValue(condition.filter), "-").concat(this.formatValue(condition.filterTo));
      }

      if (condition.filter != null) {
        return this.formatValue(condition.filter);
      }

      return "".concat(condition.type);
    }
  }]);

  return NumberFilterModelFormatter;
}(SimpleFilterModelFormatter);

function getAllowedCharPattern(filterParams) {
  var _ref22 = filterParams != null ? filterParams : {},
      allowedCharPattern = _ref22.allowedCharPattern;

  return allowedCharPattern != null ? allowedCharPattern : null;
}

var _NumberFilter =
/*#__PURE__*/
function (_ScalarFilter4) {
  "use strict";

  _inherits(_NumberFilter, _ScalarFilter4);

  function _NumberFilter() {
    var _this132;

    _classCallCheck(this, _NumberFilter);

    _this132 = _possibleConstructorReturn(this, _getPrototypeOf(_NumberFilter).call(this, "numberFilter"));
    _this132.eValuesFrom = [];
    _this132.eValuesTo = [];
    return _this132;
  }

  _createClass(_NumberFilter, [{
    key: "refresh",
    value: function refresh(params) {
      if (this.numberFilterParams.allowedCharPattern !== params.allowedCharPattern) {
        return false;
      }

      return _get(_getPrototypeOf(_NumberFilter.prototype), "refresh", this).call(this, params);
    }
  }, {
    key: "mapValuesFromModel",
    value: function mapValuesFromModel(filterModel) {
      var _ref23 = filterModel || {},
          filter = _ref23.filter,
          filterTo = _ref23.filterTo,
          type = _ref23.type;

      return [this.processValue(filter), this.processValue(filterTo)].slice(0, this.getNumberOfInputs(type));
    }
  }, {
    key: "getDefaultDebounceMs",
    value: function getDefaultDebounceMs() {
      return 500;
    }
  }, {
    key: "comparator",
    value: function comparator() {
      return function (left, right) {
        if (left === right) {
          return 0;
        }

        return left < right ? 1 : -1;
      };
    }
  }, {
    key: "setParams",
    value: function setParams(params) {
      this.numberFilterParams = params;

      _get(_getPrototypeOf(_NumberFilter.prototype), "setParams", this).call(this, params);

      this.filterModelFormatter = new NumberFilterModelFormatter(this.localeService, this.optionsFactory, this.numberFilterParams.numberFormatter);
    }
  }, {
    key: "getDefaultFilterOptions",
    value: function getDefaultFilterOptions() {
      return _NumberFilter.DEFAULT_FILTER_OPTIONS;
    }
  }, {
    key: "setElementValue",
    value: function setElementValue(element, value, fromFloatingFilter) {
      var valueToSet = !fromFloatingFilter && this.numberFilterParams.numberFormatter ? this.numberFilterParams.numberFormatter(value != null ? value : null) : value;

      _get(_getPrototypeOf(_NumberFilter.prototype), "setElementValue", this).call(this, element, valueToSet);
    }
  }, {
    key: "createValueElement",
    value: function createValueElement() {
      var allowedCharPattern = getAllowedCharPattern(this.numberFilterParams);
      var eCondition = document.createElement("div");
      eCondition.classList.add("ag-filter-body");

      _setAriaRole(eCondition, "presentation");

      this.createFromToElement(eCondition, this.eValuesFrom, "from", allowedCharPattern);
      this.createFromToElement(eCondition, this.eValuesTo, "to", allowedCharPattern);
      return eCondition;
    }
  }, {
    key: "createFromToElement",
    value: function createFromToElement(eCondition, eValues, fromTo, allowedCharPattern) {
      var eValue = this.createManagedBean(allowedCharPattern ? new _AgInputTextField({
        allowedCharPattern: allowedCharPattern
      }) : new _AgInputNumberField());
      eValue.addCssClass("ag-filter-".concat(fromTo));
      eValue.addCssClass("ag-filter-filter");
      eValues.push(eValue);
      eCondition.appendChild(eValue.getGui());
    }
  }, {
    key: "removeValueElements",
    value: function removeValueElements(startPosition, deleteCount) {
      this.removeComponents(this.eValuesFrom, startPosition, deleteCount);
      this.removeComponents(this.eValuesTo, startPosition, deleteCount);
    }
  }, {
    key: "getValues",
    value: function getValues(position) {
      var _this133 = this;

      var result = [];
      this.forEachPositionInput(position, function (element, index, _elPosition, numberOfInputs) {
        if (index < numberOfInputs) {
          result.push(_this133.processValue(_this133.stringToFloat(element.getValue())));
        }
      });
      return result;
    }
  }, {
    key: "areSimpleModelsEqual",
    value: function areSimpleModelsEqual(aSimple, bSimple) {
      return aSimple.filter === bSimple.filter && aSimple.filterTo === bSimple.filterTo && aSimple.type === bSimple.type;
    }
  }, {
    key: "getFilterType",
    value: function getFilterType() {
      return "number";
    }
  }, {
    key: "processValue",
    value: function processValue(value) {
      if (value == null) {
        return null;
      }

      return isNaN(value) ? null : value;
    }
  }, {
    key: "stringToFloat",
    value: function stringToFloat(value) {
      if (typeof value === "number") {
        return value;
      }

      var filterText = _makeNull(value);

      if (filterText != null && filterText.trim() === "") {
        filterText = null;
      }

      if (this.numberFilterParams.numberParser) {
        return this.numberFilterParams.numberParser(filterText);
      }

      return filterText == null || filterText.trim() === "-" ? null : parseFloat(filterText);
    }
  }, {
    key: "createCondition",
    value: function createCondition(position) {
      var type = this.getConditionType(position);
      var model = {
        filterType: this.getFilterType(),
        type: type
      };
      var values2 = this.getValues(position);

      if (values2.length > 0) {
        model.filter = values2[0];
      }

      if (values2.length > 1) {
        model.filterTo = values2[1];
      }

      return model;
    }
  }, {
    key: "getInputs",
    value: function getInputs(position) {
      if (position >= this.eValuesFrom.length) {
        return [null, null];
      }

      return [this.eValuesFrom[position], this.eValuesTo[position]];
    }
  }, {
    key: "getModelAsString",
    value: function getModelAsString(model) {
      var _a;

      return (_a = this.filterModelFormatter.getModelAsString(model)) != null ? _a : "";
    }
  }, {
    key: "hasInvalidInputs",
    value: function hasInvalidInputs() {
      var invalidInputs = false;
      this.forEachInput(function (element) {
        if (!element.getInputElement().validity.valid) {
          invalidInputs = true;
          return;
        }
      });
      return invalidInputs;
    }
  }]);

  return _NumberFilter;
}(_ScalarFilter2);

_NumberFilter.DEFAULT_FILTER_OPTIONS = [_ScalarFilter2.EQUALS, _ScalarFilter2.NOT_EQUAL, _ScalarFilter2.GREATER_THAN, _ScalarFilter2.GREATER_THAN_OR_EQUAL, _ScalarFilter2.LESS_THAN, _ScalarFilter2.LESS_THAN_OR_EQUAL, _ScalarFilter2.IN_RANGE, _ScalarFilter2.BLANK, _ScalarFilter2.NOT_BLANK];
var _NumberFilter2 = _NumberFilter; // community-modules/core/src/filter/provided/text/textFilter.ts

var TextFilterModelFormatter =
/*#__PURE__*/
function (_SimpleFilterModelFor3) {
  "use strict";

  _inherits(TextFilterModelFormatter, _SimpleFilterModelFor3);

  function TextFilterModelFormatter() {
    _classCallCheck(this, TextFilterModelFormatter);

    return _possibleConstructorReturn(this, _getPrototypeOf(TextFilterModelFormatter).apply(this, arguments));
  }

  _createClass(TextFilterModelFormatter, [{
    key: "conditionToString",
    value: function conditionToString(condition, options) {
      var _ref24 = options || {},
          numberOfInputs = _ref24.numberOfInputs;

      var isRange = condition.type == _SimpleFilter2.IN_RANGE || numberOfInputs === 2;

      if (isRange) {
        return "".concat(condition.filter, "-").concat(condition.filterTo);
      }

      if (condition.filter != null) {
        return "".concat(condition.filter);
      }

      return "".concat(condition.type);
    }
  }]);

  return TextFilterModelFormatter;
}(SimpleFilterModelFormatter);

var _TextFilter =
/*#__PURE__*/
function (_SimpleFilter4) {
  "use strict";

  _inherits(_TextFilter, _SimpleFilter4);

  function _TextFilter() {
    var _this134;

    _classCallCheck(this, _TextFilter);

    _this134 = _possibleConstructorReturn(this, _getPrototypeOf(_TextFilter).call(this, "textFilter"));
    _this134.eValuesFrom = [];
    _this134.eValuesTo = [];
    return _this134;
  }

  _createClass(_TextFilter, [{
    key: "getDefaultDebounceMs",
    value: function getDefaultDebounceMs() {
      return 500;
    }
  }, {
    key: "setParams",
    value: function setParams(params) {
      this.textFilterParams = params;

      _get(_getPrototypeOf(_TextFilter.prototype), "setParams", this).call(this, params);

      this.matcher = this.getTextMatcher();
      this.formatter = this.textFilterParams.textFormatter || (this.textFilterParams.caseSensitive ? _TextFilter.DEFAULT_FORMATTER : _TextFilter.DEFAULT_LOWERCASE_FORMATTER);
      this.filterModelFormatter = new TextFilterModelFormatter(this.localeService, this.optionsFactory);
    }
  }, {
    key: "getTextMatcher",
    value: function getTextMatcher() {
      var legacyComparator = this.textFilterParams.textCustomComparator;

      if (legacyComparator) {
        _3.warnOnce("textCustomComparator is deprecated, use textMatcher instead.");

        return function (_ref25) {
          var filterOption = _ref25.filterOption,
              value = _ref25.value,
              filterText = _ref25.filterText;
          return legacyComparator(filterOption, value, filterText);
        };
      }

      return this.textFilterParams.textMatcher || _TextFilter.DEFAULT_MATCHER;
    }
  }, {
    key: "createCondition",
    value: function createCondition(position) {
      var type = this.getConditionType(position);
      var model = {
        filterType: this.getFilterType(),
        type: type
      };
      var values2 = this.getValuesWithSideEffects(position, true);

      if (values2.length > 0) {
        model.filter = values2[0];
      }

      if (values2.length > 1) {
        model.filterTo = values2[1];
      }

      return model;
    }
  }, {
    key: "getFilterType",
    value: function getFilterType() {
      return "text";
    }
  }, {
    key: "areSimpleModelsEqual",
    value: function areSimpleModelsEqual(aSimple, bSimple) {
      return aSimple.filter === bSimple.filter && aSimple.filterTo === bSimple.filterTo && aSimple.type === bSimple.type;
    }
  }, {
    key: "getInputs",
    value: function getInputs(position) {
      if (position >= this.eValuesFrom.length) {
        return [null, null];
      }

      return [this.eValuesFrom[position], this.eValuesTo[position]];
    }
  }, {
    key: "getValues",
    value: function getValues(position) {
      return this.getValuesWithSideEffects(position, false);
    }
  }, {
    key: "getValuesWithSideEffects",
    value: function getValuesWithSideEffects(position, applySideEffects) {
      var _this135 = this;

      var result = [];
      this.forEachPositionInput(position, function (element, index, _elPosition, numberOfInputs) {
        var _a;

        if (index < numberOfInputs) {
          var value = _makeNull(element.getValue());

          if (applySideEffects && _this135.textFilterParams.trimInput) {
            value = (_a = _TextFilter.trimInput(value)) != null ? _a : null;
            element.setValue(value, true);
          }

          result.push(value);
        }
      });
      return result;
    }
  }, {
    key: "getDefaultFilterOptions",
    value: function getDefaultFilterOptions() {
      return _TextFilter.DEFAULT_FILTER_OPTIONS;
    }
  }, {
    key: "createValueElement",
    value: function createValueElement() {
      var eCondition = document.createElement("div");
      eCondition.classList.add("ag-filter-body");

      _setAriaRole(eCondition, "presentation");

      this.createFromToElement(eCondition, this.eValuesFrom, "from");
      this.createFromToElement(eCondition, this.eValuesTo, "to");
      return eCondition;
    }
  }, {
    key: "createFromToElement",
    value: function createFromToElement(eCondition, eValues, fromTo) {
      var eValue = this.createManagedBean(new _AgInputTextField());
      eValue.addCssClass("ag-filter-".concat(fromTo));
      eValue.addCssClass("ag-filter-filter");
      eValues.push(eValue);
      eCondition.appendChild(eValue.getGui());
    }
  }, {
    key: "removeValueElements",
    value: function removeValueElements(startPosition, deleteCount) {
      this.removeComponents(this.eValuesFrom, startPosition, deleteCount);
      this.removeComponents(this.eValuesTo, startPosition, deleteCount);
    }
  }, {
    key: "mapValuesFromModel",
    value: function mapValuesFromModel(filterModel) {
      var _ref26 = filterModel || {},
          filter = _ref26.filter,
          filterTo = _ref26.filterTo,
          type = _ref26.type;

      return [filter || null, filterTo || null].slice(0, this.getNumberOfInputs(type));
    }
  }, {
    key: "evaluateNullValue",
    value: function evaluateNullValue(filterType) {
      var filterTypesAllowNulls = [_SimpleFilter2.NOT_EQUAL, _SimpleFilter2.NOT_CONTAINS, _SimpleFilter2.BLANK];
      return filterType ? filterTypesAllowNulls.indexOf(filterType) >= 0 : false;
    }
  }, {
    key: "evaluateNonNullValue",
    value: function evaluateNonNullValue(values2, cellValue, filterModel, params) {
      var _this136 = this;

      var formattedValues = values2.map(function (v) {
        return _this136.formatter(v);
      }) || [];
      var cellValueFormatted = this.formatter(cellValue);
      var _this$textFilterParam = this.textFilterParams,
          api = _this$textFilterParam.api,
          colDef = _this$textFilterParam.colDef,
          column = _this$textFilterParam.column,
          columnApi = _this$textFilterParam.columnApi,
          context = _this$textFilterParam.context,
          textFormatter = _this$textFilterParam.textFormatter;

      if (filterModel.type === _SimpleFilter2.BLANK) {
        return this.isBlank(cellValue);
      } else if (filterModel.type === _SimpleFilter2.NOT_BLANK) {
        return !this.isBlank(cellValue);
      }

      var matcherParams = {
        api: api,
        colDef: colDef,
        column: column,
        columnApi: columnApi,
        context: context,
        node: params.node,
        data: params.data,
        filterOption: filterModel.type,
        value: cellValueFormatted,
        textFormatter: textFormatter
      };
      return formattedValues.some(function (v) {
        return _this136.matcher(__spreadProps(__spreadValues({}, matcherParams), {
          filterText: v
        }));
      });
    }
  }, {
    key: "getModelAsString",
    value: function getModelAsString(model) {
      var _a;

      return (_a = this.filterModelFormatter.getModelAsString(model)) != null ? _a : "";
    }
  }], [{
    key: "trimInput",
    value: function trimInput(value) {
      var trimmedInput = value && value.trim();
      return trimmedInput === "" ? value : trimmedInput;
    }
  }]);

  return _TextFilter;
}(_SimpleFilter2);

_TextFilter.DEFAULT_FILTER_OPTIONS = [_SimpleFilter2.CONTAINS, _SimpleFilter2.NOT_CONTAINS, _SimpleFilter2.EQUALS, _SimpleFilter2.NOT_EQUAL, _SimpleFilter2.STARTS_WITH, _SimpleFilter2.ENDS_WITH, _SimpleFilter2.BLANK, _SimpleFilter2.NOT_BLANK];

_TextFilter.DEFAULT_FORMATTER = function (from) {
  return from;
};

_TextFilter.DEFAULT_LOWERCASE_FORMATTER = function (from) {
  return from == null ? null : from.toString().toLowerCase();
};

_TextFilter.DEFAULT_MATCHER = function (_ref27) {
  var filterOption = _ref27.filterOption,
      value = _ref27.value,
      filterText = _ref27.filterText;

  if (filterText == null) {
    return false;
  }

  switch (filterOption) {
    case _TextFilter.CONTAINS:
      return value.indexOf(filterText) >= 0;

    case _TextFilter.NOT_CONTAINS:
      return value.indexOf(filterText) < 0;

    case _TextFilter.EQUALS:
      return value === filterText;

    case _TextFilter.NOT_EQUAL:
      return value != filterText;

    case _TextFilter.STARTS_WITH:
      return value.indexOf(filterText) === 0;

    case _TextFilter.ENDS_WITH:
      var index = value.lastIndexOf(filterText);
      return index >= 0 && index === value.length - filterText.length;

    default:
      return false;
  }
};

var _TextFilter2 = _TextFilter; // community-modules/core/src/filter/floating/provided/textInputFloatingFilter.ts

var FloatingFilterTextInputService =
/*#__PURE__*/
function (_BeanStub13) {
  "use strict";

  _inherits(FloatingFilterTextInputService, _BeanStub13);

  function FloatingFilterTextInputService(params) {
    var _this137;

    _classCallCheck(this, FloatingFilterTextInputService);

    _this137 = _possibleConstructorReturn(this, _getPrototypeOf(FloatingFilterTextInputService).call(this));
    _this137.params = params;

    _this137.valueChangedListener = function () {};

    return _this137;
  }

  _createClass(FloatingFilterTextInputService, [{
    key: "setupGui",
    value: function setupGui(parentElement) {
      var _this138 = this;

      var _a;

      this.eFloatingFilterTextInput = this.createManagedBean(new _AgInputTextField((_a = this.params) == null ? void 0 : _a.config));
      var eInput = this.eFloatingFilterTextInput.getGui();
      parentElement.appendChild(eInput);
      this.addManagedListener(eInput, "input", function (e) {
        return _this138.valueChangedListener(e);
      });
      this.addManagedListener(eInput, "keydown", function (e) {
        return _this138.valueChangedListener(e);
      });
    }
  }, {
    key: "setEditable",
    value: function setEditable(editable) {
      this.eFloatingFilterTextInput.setDisabled(!editable);
    }
  }, {
    key: "setAutoComplete",
    value: function setAutoComplete(autoComplete) {
      this.eFloatingFilterTextInput.setAutoComplete(autoComplete);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.eFloatingFilterTextInput.getValue();
    }
  }, {
    key: "setValue",
    value: function setValue(value, silent) {
      this.eFloatingFilterTextInput.setValue(value, silent);
    }
  }, {
    key: "setValueChangedListener",
    value: function setValueChangedListener(listener) {
      this.valueChangedListener = listener;
    }
  }, {
    key: "setParams",
    value: function setParams(params) {
      this.setAriaLabel(params.ariaLabel);

      if (params.autoComplete !== void 0) {
        this.setAutoComplete(params.autoComplete);
      }
    }
  }, {
    key: "setAriaLabel",
    value: function setAriaLabel(ariaLabel) {
      this.eFloatingFilterTextInput.setInputAriaLabel(ariaLabel);
    }
  }]);

  return FloatingFilterTextInputService;
}(_BeanStub2);

var TextInputFloatingFilter =
/*#__PURE__*/
function (_SimpleFloatingFilter2) {
  "use strict";

  _inherits(TextInputFloatingFilter, _SimpleFloatingFilter2);

  function TextInputFloatingFilter() {
    _classCallCheck(this, TextInputFloatingFilter);

    return _possibleConstructorReturn(this, _getPrototypeOf(TextInputFloatingFilter).apply(this, arguments));
  }

  _createClass(TextInputFloatingFilter, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.setTemplate(
      /* html */
      "\n            <div class=\"ag-floating-filter-input\" role=\"presentation\" ref=\"eFloatingFilterInputContainer\"></div>\n        ");
    }
  }, {
    key: "getDefaultDebounceMs",
    value: function getDefaultDebounceMs() {
      return 500;
    }
  }, {
    key: "onParentModelChanged",
    value: function onParentModelChanged(model, event) {
      if (this.isEventFromFloatingFilter(event) || this.isEventFromDataChange(event)) {
        return;
      }

      this.setLastTypeFromModel(model);
      this.setEditable(this.canWeEditAfterModelFromParentFilter(model));
      this.floatingFilterInputService.setValue(this.getFilterModelFormatter().getModelAsString(model));
    }
  }, {
    key: "init",
    value: function init(params) {
      this.setupFloatingFilterInputService(params);

      _get(_getPrototypeOf(TextInputFloatingFilter.prototype), "init", this).call(this, params);

      this.setTextInputParams(params);
    }
  }, {
    key: "setupFloatingFilterInputService",
    value: function setupFloatingFilterInputService(params) {
      this.floatingFilterInputService = this.createFloatingFilterInputService(params);
      this.floatingFilterInputService.setupGui(this.eFloatingFilterInputContainer);
    }
  }, {
    key: "setTextInputParams",
    value: function setTextInputParams(params) {
      var _a;

      this.params = params;
      var autoComplete = (_a = params.browserAutoComplete) != null ? _a : false;
      this.floatingFilterInputService.setParams({
        ariaLabel: this.getAriaLabel(params),
        autoComplete: autoComplete
      });
      this.applyActive = _ProvidedFilter2.isUseApplyButton(this.params.filterParams);

      if (!this.isReadOnly()) {
        var debounceMs = _ProvidedFilter2.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs());

        var toDebounce = _debounce(this.syncUpWithParentFilter.bind(this), debounceMs);

        this.floatingFilterInputService.setValueChangedListener(toDebounce);
      }
    }
  }, {
    key: "onParamsUpdated",
    value: function onParamsUpdated(params) {
      this.refresh(params);
    }
  }, {
    key: "refresh",
    value: function refresh(params) {
      _get(_getPrototypeOf(TextInputFloatingFilter.prototype), "refresh", this).call(this, params);

      this.setTextInputParams(params);
    }
  }, {
    key: "recreateFloatingFilterInputService",
    value: function recreateFloatingFilterInputService(params) {
      var value = this.floatingFilterInputService.getValue();

      _clearElement(this.eFloatingFilterInputContainer);

      this.destroyBean(this.floatingFilterInputService);
      this.setupFloatingFilterInputService(params);
      this.floatingFilterInputService.setValue(value, true);
    }
  }, {
    key: "syncUpWithParentFilter",
    value: function syncUpWithParentFilter(e) {
      var _this139 = this;

      var isEnterKey = e.key === _KeyCode.ENTER;

      if (this.applyActive && !isEnterKey) {
        return;
      }

      var value = this.floatingFilterInputService.getValue();

      if (this.params.filterParams.trimInput) {
        value = _TextFilter2.trimInput(value);
        this.floatingFilterInputService.setValue(value, true);
      }

      this.params.parentFilterInstance(function (filterInstance) {
        if (filterInstance) {
          filterInstance.onFloatingFilterChanged(_this139.getLastType() || null, value || null);
        }
      });
    }
  }, {
    key: "setEditable",
    value: function setEditable(editable) {
      this.floatingFilterInputService.setEditable(editable);
    }
  }]);

  return TextInputFloatingFilter;
}(SimpleFloatingFilter);

__decorateClass([_RefSelector("eFloatingFilterInputContainer")], TextInputFloatingFilter.prototype, "eFloatingFilterInputContainer", 2);

__decorateClass([_PostConstruct], TextInputFloatingFilter.prototype, "postConstruct", 1); // community-modules/core/src/filter/provided/number/numberFloatingFilter.ts


var FloatingFilterNumberInputService =
/*#__PURE__*/
function (_BeanStub14) {
  "use strict";

  _inherits(FloatingFilterNumberInputService, _BeanStub14);

  function FloatingFilterNumberInputService() {
    var _this140;

    _classCallCheck(this, FloatingFilterNumberInputService);

    _this140 = _possibleConstructorReturn(this, _getPrototypeOf(FloatingFilterNumberInputService).apply(this, arguments));

    _this140.valueChangedListener = function () {};

    _this140.numberInputActive = true;
    return _this140;
  }

  _createClass(FloatingFilterNumberInputService, [{
    key: "setupGui",
    value: function setupGui(parentElement) {
      var _this141 = this;

      this.eFloatingFilterNumberInput = this.createManagedBean(new _AgInputNumberField());
      this.eFloatingFilterTextInput = this.createManagedBean(new _AgInputTextField());
      this.eFloatingFilterTextInput.setDisabled(true);
      var eNumberInput = this.eFloatingFilterNumberInput.getGui();
      var eTextInput = this.eFloatingFilterTextInput.getGui();
      parentElement.appendChild(eNumberInput);
      parentElement.appendChild(eTextInput);
      this.setupListeners(eNumberInput, function (e) {
        return _this141.valueChangedListener(e);
      });
      this.setupListeners(eTextInput, function (e) {
        return _this141.valueChangedListener(e);
      });
    }
  }, {
    key: "setEditable",
    value: function setEditable(editable) {
      this.numberInputActive = editable;
      this.eFloatingFilterNumberInput.setDisplayed(this.numberInputActive);
      this.eFloatingFilterTextInput.setDisplayed(!this.numberInputActive);
    }
  }, {
    key: "setAutoComplete",
    value: function setAutoComplete(autoComplete) {
      this.eFloatingFilterNumberInput.setAutoComplete(autoComplete);
      this.eFloatingFilterTextInput.setAutoComplete(autoComplete);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.getActiveInputElement().getValue();
    }
  }, {
    key: "setValue",
    value: function setValue(value, silent) {
      this.getActiveInputElement().setValue(value, silent);
    }
  }, {
    key: "getActiveInputElement",
    value: function getActiveInputElement() {
      return this.numberInputActive ? this.eFloatingFilterNumberInput : this.eFloatingFilterTextInput;
    }
  }, {
    key: "setValueChangedListener",
    value: function setValueChangedListener(listener) {
      this.valueChangedListener = listener;
    }
  }, {
    key: "setupListeners",
    value: function setupListeners(element, listener) {
      this.addManagedListener(element, "input", listener);
      this.addManagedListener(element, "keydown", listener);
    }
  }, {
    key: "setParams",
    value: function setParams(params) {
      this.setAriaLabel(params.ariaLabel);

      if (params.autoComplete !== void 0) {
        this.setAutoComplete(params.autoComplete);
      }
    }
  }, {
    key: "setAriaLabel",
    value: function setAriaLabel(ariaLabel) {
      this.eFloatingFilterNumberInput.setInputAriaLabel(ariaLabel);
      this.eFloatingFilterTextInput.setInputAriaLabel(ariaLabel);
    }
  }]);

  return FloatingFilterNumberInputService;
}(_BeanStub2);

var NumberFloatingFilter =
/*#__PURE__*/
function (_TextInputFloatingFil) {
  "use strict";

  _inherits(NumberFloatingFilter, _TextInputFloatingFil);

  function NumberFloatingFilter() {
    _classCallCheck(this, NumberFloatingFilter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NumberFloatingFilter).apply(this, arguments));
  }

  _createClass(NumberFloatingFilter, [{
    key: "init",
    value: function init(params) {
      var _a;

      _get(_getPrototypeOf(NumberFloatingFilter.prototype), "init", this).call(this, params);

      this.filterModelFormatter = new NumberFilterModelFormatter(this.localeService, this.optionsFactory, (_a = params.filterParams) == null ? void 0 : _a.numberFormatter);
    }
  }, {
    key: "onParamsUpdated",
    value: function onParamsUpdated(params) {
      this.refresh(params);
    }
  }, {
    key: "refresh",
    value: function refresh(params) {
      var allowedCharPattern = getAllowedCharPattern(params.filterParams);

      if (allowedCharPattern !== this.allowedCharPattern) {
        this.recreateFloatingFilterInputService(params);
      }

      _get(_getPrototypeOf(NumberFloatingFilter.prototype), "refresh", this).call(this, params);

      this.filterModelFormatter.updateParams({
        optionsFactory: this.optionsFactory
      });
    }
  }, {
    key: "getDefaultFilterOptions",
    value: function getDefaultFilterOptions() {
      return _NumberFilter2.DEFAULT_FILTER_OPTIONS;
    }
  }, {
    key: "getFilterModelFormatter",
    value: function getFilterModelFormatter() {
      return this.filterModelFormatter;
    }
  }, {
    key: "createFloatingFilterInputService",
    value: function createFloatingFilterInputService(params) {
      this.allowedCharPattern = getAllowedCharPattern(params.filterParams);

      if (this.allowedCharPattern) {
        return this.createManagedBean(new FloatingFilterTextInputService({
          config: {
            allowedCharPattern: this.allowedCharPattern
          }
        }));
      }

      return this.createManagedBean(new FloatingFilterNumberInputService());
    }
  }]);

  return NumberFloatingFilter;
}(TextInputFloatingFilter); // community-modules/core/src/filter/provided/text/textFloatingFilter.ts


var _TextFloatingFilter =
/*#__PURE__*/
function (_TextInputFloatingFil2) {
  "use strict";

  _inherits(_TextFloatingFilter, _TextInputFloatingFil2);

  function _TextFloatingFilter() {
    _classCallCheck(this, _TextFloatingFilter);

    return _possibleConstructorReturn(this, _getPrototypeOf(_TextFloatingFilter).apply(this, arguments));
  }

  _createClass(_TextFloatingFilter, [{
    key: "init",
    value: function init(params) {
      _get(_getPrototypeOf(_TextFloatingFilter.prototype), "init", this).call(this, params);

      this.filterModelFormatter = new TextFilterModelFormatter(this.localeService, this.optionsFactory);
    }
  }, {
    key: "onParamsUpdated",
    value: function onParamsUpdated(params) {
      this.refresh(params);
    }
  }, {
    key: "refresh",
    value: function refresh(params) {
      _get(_getPrototypeOf(_TextFloatingFilter.prototype), "refresh", this).call(this, params);

      this.filterModelFormatter.updateParams({
        optionsFactory: this.optionsFactory
      });
    }
  }, {
    key: "getDefaultFilterOptions",
    value: function getDefaultFilterOptions() {
      return _TextFilter2.DEFAULT_FILTER_OPTIONS;
    }
  }, {
    key: "getFilterModelFormatter",
    value: function getFilterModelFormatter() {
      return this.filterModelFormatter;
    }
  }, {
    key: "createFloatingFilterInputService",
    value: function createFloatingFilterInputService() {
      return this.createManagedBean(new FloatingFilterTextInputService());
    }
  }]);

  return _TextFloatingFilter;
}(TextInputFloatingFilter); // community-modules/core/src/widgets/touchListener.ts


var _TouchListener =
/*#__PURE__*/
function () {
  "use strict";

  function _TouchListener(eElement) {
    var _this142 = this;

    var preventMouseClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, _TouchListener);

    this.destroyFuncs = [];
    this.touching = false;
    this.eventService = new _EventService();
    this.eElement = eElement;
    this.preventMouseClick = preventMouseClick;
    var startListener = this.onTouchStart.bind(this);
    var moveListener = this.onTouchMove.bind(this);
    var endListener = this.onTouchEnd.bind(this);
    this.eElement.addEventListener("touchstart", startListener, {
      passive: true
    });
    this.eElement.addEventListener("touchmove", moveListener, {
      passive: true
    });
    this.eElement.addEventListener("touchend", endListener, {
      passive: false
    });
    this.destroyFuncs.push(function () {
      _this142.eElement.removeEventListener("touchstart", startListener, {
        passive: true
      });

      _this142.eElement.removeEventListener("touchmove", moveListener, {
        passive: true
      });

      _this142.eElement.removeEventListener("touchend", endListener, {
        passive: false
      });
    });
  }

  _createClass(_TouchListener, [{
    key: "getActiveTouch",
    value: function getActiveTouch(touchList) {
      for (var i = 0; i < touchList.length; i++) {
        var matches = touchList[i].identifier === this.touchStart.identifier;

        if (matches) {
          return touchList[i];
        }
      }

      return null;
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(eventType, listener) {
      this.eventService.addEventListener(eventType, listener);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventType, listener) {
      this.eventService.removeEventListener(eventType, listener);
    }
  }, {
    key: "onTouchStart",
    value: function onTouchStart(touchEvent) {
      var _this143 = this;

      if (this.touching) {
        return;
      }

      this.touchStart = touchEvent.touches[0];
      this.touching = true;
      this.moved = false;
      var touchStartCopy = this.touchStart;
      window.setTimeout(function () {
        var touchesMatch = _this143.touchStart === touchStartCopy;

        if (_this143.touching && touchesMatch && !_this143.moved) {
          _this143.moved = true;
          var event = {
            type: _TouchListener.EVENT_LONG_TAP,
            touchStart: _this143.touchStart,
            touchEvent: touchEvent
          };

          _this143.eventService.dispatchEvent(event);
        }
      }, 500);
    }
  }, {
    key: "onTouchMove",
    value: function onTouchMove(touchEvent) {
      if (!this.touching) {
        return;
      }

      var touch = this.getActiveTouch(touchEvent.touches);

      if (!touch) {
        return;
      }

      var eventIsFarAway = !_areEventsNear(touch, this.touchStart, 4);

      if (eventIsFarAway) {
        this.moved = true;
      }
    }
  }, {
    key: "onTouchEnd",
    value: function onTouchEnd(touchEvent) {
      if (!this.touching) {
        return;
      }

      if (!this.moved) {
        var event = {
          type: _TouchListener.EVENT_TAP,
          touchStart: this.touchStart
        };
        this.eventService.dispatchEvent(event);
        this.checkForDoubleTap();
      }

      if (this.preventMouseClick && touchEvent.cancelable) {
        touchEvent.preventDefault();
      }

      this.touching = false;
    }
  }, {
    key: "checkForDoubleTap",
    value: function checkForDoubleTap() {
      var now =
      /* @__PURE__ */
      new Date().getTime();

      if (this.lastTapTime && this.lastTapTime > 0) {
        var interval = now - this.lastTapTime;

        if (interval > _TouchListener.DOUBLE_TAP_MILLIS) {
          var event = {
            type: _TouchListener.EVENT_DOUBLE_TAP,
            touchStart: this.touchStart
          };
          this.eventService.dispatchEvent(event);
          this.lastTapTime = null;
        } else {
          this.lastTapTime = now;
        }
      } else {
        this.lastTapTime = now;
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.destroyFuncs.forEach(function (func) {
        return func();
      });
    }
  }]);

  return _TouchListener;
}();

_TouchListener.EVENT_TAP = "tap";
_TouchListener.EVENT_DOUBLE_TAP = "doubleTap";
_TouchListener.EVENT_LONG_TAP = "longTap";
_TouchListener.DOUBLE_TAP_MILLIS = 500;
var _TouchListener2 = _TouchListener; // community-modules/core/src/headerRendering/cells/column/sortIndicatorComp.ts

var _SortIndicatorComp =
/*#__PURE__*/
function (_Component9) {
  "use strict";

  _inherits(_SortIndicatorComp, _Component9);

  function _SortIndicatorComp(skipTemplate) {
    var _this144;

    _classCallCheck(this, _SortIndicatorComp);

    _this144 = _possibleConstructorReturn(this, _getPrototypeOf(_SortIndicatorComp).call(this));

    if (!skipTemplate) {
      _this144.setTemplate(_SortIndicatorComp.TEMPLATE);
    }

    return _this144;
  }

  _createClass(_SortIndicatorComp, [{
    key: "attachCustomElements",
    value: function attachCustomElements(eSortOrder, eSortAsc, eSortDesc, eSortMixed, eSortNone) {
      this.eSortOrder = eSortOrder;
      this.eSortAsc = eSortAsc;
      this.eSortDesc = eSortDesc;
      this.eSortMixed = eSortMixed;
      this.eSortNone = eSortNone;
    }
  }, {
    key: "setupSort",
    value: function setupSort(column) {
      var _this145 = this;

      var suppressOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.column = column;
      this.suppressOrder = suppressOrder;
      this.setupMultiSortIndicator();

      if (!this.column.isSortable() && !this.column.getColDef().showRowGroup) {
        return;
      }

      this.addInIcon("sortAscending", this.eSortAsc, column);
      this.addInIcon("sortDescending", this.eSortDesc, column);
      this.addInIcon("sortUnSort", this.eSortNone, column);
      this.addManagedPropertyListener("unSortIcon", function () {
        return _this145.updateIcons();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_NEW_COLUMNS_LOADED, function () {
        return _this145.updateIcons();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_SORT_CHANGED, function () {
        return _this145.onSortChanged();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_ROW_GROUP_CHANGED, function () {
        return _this145.onSortChanged();
      });
      this.onSortChanged();
    }
  }, {
    key: "addInIcon",
    value: function addInIcon(iconName, eParent, column) {
      if (eParent == null) {
        return;
      }

      var eIcon = _createIconNoSpan(iconName, this.gos, column);

      if (eIcon) {
        eParent.appendChild(eIcon);
      }
    }
  }, {
    key: "onSortChanged",
    value: function onSortChanged() {
      this.updateIcons();

      if (!this.suppressOrder) {
        this.updateSortOrder();
      }
    }
  }, {
    key: "updateIcons",
    value: function updateIcons() {
      var sortDirection = this.sortController.getDisplaySortForColumn(this.column);

      if (this.eSortAsc) {
        var isAscending = sortDirection === "asc";

        _setDisplayed(this.eSortAsc, isAscending, {
          skipAriaHidden: true
        });
      }

      if (this.eSortDesc) {
        var isDescending = sortDirection === "desc";

        _setDisplayed(this.eSortDesc, isDescending, {
          skipAriaHidden: true
        });
      }

      if (this.eSortNone) {
        var alwaysHideNoSort = !this.column.getColDef().unSortIcon && !this.gos.get("unSortIcon");
        var isNone = sortDirection === null || sortDirection === void 0;

        _setDisplayed(this.eSortNone, !alwaysHideNoSort && isNone, {
          skipAriaHidden: true
        });
      }
    }
  }, {
    key: "setupMultiSortIndicator",
    value: function setupMultiSortIndicator() {
      var _this146 = this;

      this.addInIcon("sortUnSort", this.eSortMixed, this.column);
      var isColumnShowingRowGroup = this.column.getColDef().showRowGroup;
      var areGroupsCoupled = this.gos.isColumnsSortingCoupledToGroup();

      if (areGroupsCoupled && isColumnShowingRowGroup) {
        this.addManagedListener(this.eventService, _Events.EVENT_SORT_CHANGED, function () {
          return _this146.updateMultiSortIndicator();
        });
        this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_ROW_GROUP_CHANGED, function () {
          return _this146.updateMultiSortIndicator();
        });
        this.updateMultiSortIndicator();
      }
    }
  }, {
    key: "updateMultiSortIndicator",
    value: function updateMultiSortIndicator() {
      if (this.eSortMixed) {
        var isMixedSort = this.sortController.getDisplaySortForColumn(this.column) === "mixed";

        _setDisplayed(this.eSortMixed, isMixedSort, {
          skipAriaHidden: true
        });
      }
    } // we listen here for global sort events, NOT column sort events, as we want to do this
    // when sorting has been set on all column (if we listened just for our col (where we
    // set the asc / desc icons) then it's possible other cols are yet to get their sorting state.

  }, {
    key: "updateSortOrder",
    value: function updateSortOrder() {
      var _this147 = this;

      var _a;

      if (!this.eSortOrder) {
        return;
      }

      var allColumnsWithSorting = this.sortController.getColumnsWithSortingOrdered();
      var indexThisCol = (_a = this.sortController.getDisplaySortIndexForColumn(this.column)) != null ? _a : -1;
      var moreThanOneColSorting = allColumnsWithSorting.some(function (col) {
        var _a2;

        return (_a2 = _this147.sortController.getDisplaySortIndexForColumn(col)) != null ? _a2 : -1 >= 1;
      });
      var showIndex = indexThisCol >= 0 && moreThanOneColSorting;

      _setDisplayed(this.eSortOrder, showIndex, {
        skipAriaHidden: true
      });

      if (indexThisCol >= 0) {
        this.eSortOrder.textContent = (indexThisCol + 1).toString();
      } else {
        _clearElement(this.eSortOrder);
      }
    }
  }]);

  return _SortIndicatorComp;
}(_Component2);

_SortIndicatorComp.TEMPLATE =
/* html */
"<span class=\"ag-sort-indicator-container\">\n            <span ref=\"eSortOrder\" class=\"ag-sort-indicator-icon ag-sort-order ag-hidden\" aria-hidden=\"true\"></span>\n            <span ref=\"eSortAsc\" class=\"ag-sort-indicator-icon ag-sort-ascending-icon ag-hidden\" aria-hidden=\"true\"></span>\n            <span ref=\"eSortDesc\" class=\"ag-sort-indicator-icon ag-sort-descending-icon ag-hidden\" aria-hidden=\"true\"></span>\n            <span ref=\"eSortMixed\" class=\"ag-sort-indicator-icon ag-sort-mixed-icon ag-hidden\" aria-hidden=\"true\"></span>\n            <span ref=\"eSortNone\" class=\"ag-sort-indicator-icon ag-sort-none-icon ag-hidden\" aria-hidden=\"true\"></span>\n        </span>";

__decorateClass([_RefSelector("eSortOrder")], _SortIndicatorComp.prototype, "eSortOrder", 2);

__decorateClass([_RefSelector("eSortAsc")], _SortIndicatorComp.prototype, "eSortAsc", 2);

__decorateClass([_RefSelector("eSortDesc")], _SortIndicatorComp.prototype, "eSortDesc", 2);

__decorateClass([_RefSelector("eSortMixed")], _SortIndicatorComp.prototype, "eSortMixed", 2);

__decorateClass([_RefSelector("eSortNone")], _SortIndicatorComp.prototype, "eSortNone", 2);

__decorateClass([_Autowired("columnModel")], _SortIndicatorComp.prototype, "columnModel", 2);

__decorateClass([_Autowired("sortController")], _SortIndicatorComp.prototype, "sortController", 2);

var _SortIndicatorComp2 = _SortIndicatorComp; // community-modules/core/src/headerRendering/cells/column/headerComp.ts

var _HeaderComp =
/*#__PURE__*/
function (_Component10) {
  "use strict";

  _inherits(_HeaderComp, _Component10);

  function _HeaderComp() {
    var _this148;

    _classCallCheck(this, _HeaderComp);

    _this148 = _possibleConstructorReturn(this, _getPrototypeOf(_HeaderComp).apply(this, arguments));
    _this148.lastMovingChanged = 0;
    return _this148;
  } // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.


  _createClass(_HeaderComp, [{
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(_HeaderComp.prototype), "destroy", this).call(this);
    }
  }, {
    key: "refresh",
    value: function refresh(params) {
      var oldParams = this.params;
      this.params = params;

      if (this.workOutTemplate() != this.currentTemplate || this.workOutShowMenu() != this.currentShowMenu || this.workOutSort() != this.currentSort || this.shouldSuppressMenuHide() != this.currentSuppressMenuHide || oldParams.enableFilterButton != params.enableFilterButton || oldParams.enableFilterIcon != params.enableFilterIcon) {
        return false;
      }

      this.setDisplayName(params);
      return true;
    }
  }, {
    key: "workOutTemplate",
    value: function workOutTemplate() {
      var _a;

      var template = (_a = this.params.template) != null ? _a : _HeaderComp.TEMPLATE;
      template = template && template.trim ? template.trim() : template;
      return template;
    }
  }, {
    key: "init",
    value: function init(params) {
      this.params = params;
      this.currentTemplate = this.workOutTemplate();
      this.setTemplate(this.currentTemplate);
      this.setupTap();
      this.setMenu();
      this.setupSort();
      this.setupFilterIcon();
      this.setupFilterButton();
      this.setDisplayName(params);
    }
  }, {
    key: "setDisplayName",
    value: function setDisplayName(params) {
      if (this.currentDisplayName != params.displayName) {
        this.currentDisplayName = params.displayName;

        var displayNameSanitised = _escapeString(this.currentDisplayName, true);

        if (this.eText) {
          this.eText.textContent = displayNameSanitised;
        }
      }
    }
  }, {
    key: "addInIcon",
    value: function addInIcon(iconName, eParent, column) {
      if (eParent == null) {
        return;
      }

      var eIcon = _createIconNoSpan(iconName, this.gos, column);

      if (eIcon) {
        eParent.appendChild(eIcon);
      }
    }
  }, {
    key: "setupTap",
    value: function setupTap() {
      var _this149 = this;

      var gos = this.gos;

      if (gos.get("suppressTouch")) {
        return;
      }

      var touchListener = new _TouchListener2(this.getGui(), true);
      var suppressMenuHide = this.shouldSuppressMenuHide();

      var tapMenuButton = suppressMenuHide && _exists(this.eMenu);

      var menuTouchListener = tapMenuButton ? new _TouchListener2(this.eMenu, true) : touchListener;

      if (this.params.enableMenu) {
        var eventType = tapMenuButton ? "EVENT_TAP" : "EVENT_LONG_TAP";

        var showMenuFn = function showMenuFn(event) {
          return _this149.params.showColumnMenuAfterMouseClick(event.touchStart);
        };

        this.addManagedListener(menuTouchListener, _TouchListener2[eventType], showMenuFn);
      }

      if (this.params.enableSorting) {
        var tapListener = function tapListener(event) {
          var _a, _b;

          var target = event.touchStart.target;

          if (suppressMenuHide && (((_a = _this149.eMenu) == null ? void 0 : _a.contains(target)) || ((_b = _this149.eFilterButton) == null ? void 0 : _b.contains(target)))) {
            return;
          }

          _this149.sortController.progressSort(_this149.params.column, false, "uiColumnSorted");
        };

        this.addManagedListener(touchListener, _TouchListener2.EVENT_TAP, tapListener);
      }

      if (this.params.enableFilterButton) {
        var filterButtonTouchListener = new _TouchListener2(this.eFilterButton, true);
        this.addManagedListener(filterButtonTouchListener, "tap", function () {
          return _this149.params.showFilter(_this149.eFilterButton);
        });
        this.addDestroyFunc(function () {
          return filterButtonTouchListener.destroy();
        });
      }

      this.addDestroyFunc(function () {
        return touchListener.destroy();
      });

      if (tapMenuButton) {
        this.addDestroyFunc(function () {
          return menuTouchListener.destroy();
        });
      }
    }
  }, {
    key: "workOutShowMenu",
    value: function workOutShowMenu() {
      return this.params.enableMenu && this.menuService.isHeaderMenuButtonEnabled();
    }
  }, {
    key: "shouldSuppressMenuHide",
    value: function shouldSuppressMenuHide() {
      return this.menuService.isHeaderMenuButtonAlwaysShowEnabled();
    }
  }, {
    key: "setMenu",
    value: function setMenu() {
      var _this150 = this;

      if (!this.eMenu) {
        return;
      }

      this.currentShowMenu = this.workOutShowMenu();

      if (!this.currentShowMenu) {
        _removeFromParent(this.eMenu);

        this.eMenu = void 0;
        return;
      }

      var isLegacyMenu = this.menuService.isLegacyMenuEnabled();
      this.addInIcon(isLegacyMenu ? "menu" : "menuAlt", this.eMenu, this.params.column);
      this.eMenu.classList.toggle("ag-header-menu-icon", !isLegacyMenu);
      this.currentSuppressMenuHide = this.shouldSuppressMenuHide();
      this.addManagedListener(this.eMenu, "click", function () {
        return _this150.params.showColumnMenu(_this150.eMenu);
      });
      this.eMenu.classList.toggle("ag-header-menu-always-show", this.currentSuppressMenuHide);
    }
  }, {
    key: "onMenuKeyboardShortcut",
    value: function onMenuKeyboardShortcut(isFilterShortcut) {
      var _a, _b, _c, _d;

      var column = this.params.column;
      var isLegacyMenuEnabled = this.menuService.isLegacyMenuEnabled();

      if (isFilterShortcut && !isLegacyMenuEnabled) {
        if (this.menuService.isFilterMenuInHeaderEnabled(column)) {
          this.params.showFilter((_b = (_a = this.eFilterButton) != null ? _a : this.eMenu) != null ? _b : this.getGui());
          return true;
        }
      } else if (this.params.enableMenu) {
        this.params.showColumnMenu((_d = (_c = this.eMenu) != null ? _c : this.eFilterButton) != null ? _d : this.getGui());
        return true;
      }

      return false;
    }
  }, {
    key: "workOutSort",
    value: function workOutSort() {
      return this.params.enableSorting;
    }
  }, {
    key: "setupSort",
    value: function setupSort() {
      var _this151 = this;

      this.currentSort = this.params.enableSorting;

      if (!this.eSortIndicator) {
        this.eSortIndicator = this.context.createBean(new _SortIndicatorComp2(true));
        this.eSortIndicator.attachCustomElements(this.eSortOrder, this.eSortAsc, this.eSortDesc, this.eSortMixed, this.eSortNone);
      }

      this.eSortIndicator.setupSort(this.params.column);

      if (!this.currentSort) {
        return;
      }

      this.addManagedListener(this.params.column, _Column2.EVENT_MOVING_CHANGED, function () {
        _this151.lastMovingChanged =
        /* @__PURE__ */
        new Date().getTime();
      });

      if (this.eLabel) {
        this.addManagedListener(this.eLabel, "click", function (event) {
          var moving = _this151.params.column.isMoving();

          var nowTime =
          /* @__PURE__ */
          new Date().getTime();
          var movedRecently = nowTime - _this151.lastMovingChanged < 50;
          var columnMoving = moving || movedRecently;

          if (!columnMoving) {
            var sortUsingCtrl = _this151.gos.get("multiSortKey") === "ctrl";
            var multiSort = sortUsingCtrl ? event.ctrlKey || event.metaKey : event.shiftKey;

            _this151.params.progressSort(multiSort);
          }
        });
      }

      var onSortingChanged = function onSortingChanged() {
        _this151.addOrRemoveCssClass("ag-header-cell-sorted-asc", _this151.params.column.isSortAscending());

        _this151.addOrRemoveCssClass("ag-header-cell-sorted-desc", _this151.params.column.isSortDescending());

        _this151.addOrRemoveCssClass("ag-header-cell-sorted-none", _this151.params.column.isSortNone());

        if (_this151.params.column.getColDef().showRowGroup) {
          var sourceColumns = _this151.columnModel.getSourceColumnsForGroupColumn(_this151.params.column);

          var sortDirectionsMatch = sourceColumns == null ? void 0 : sourceColumns.every(function (sourceCol) {
            return _this151.params.column.getSort() == sourceCol.getSort();
          });
          var isMultiSorting = !sortDirectionsMatch;

          _this151.addOrRemoveCssClass("ag-header-cell-sorted-mixed", isMultiSorting);
        }
      };

      this.addManagedListener(this.eventService, _Events.EVENT_SORT_CHANGED, onSortingChanged);
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_ROW_GROUP_CHANGED, onSortingChanged);
    }
  }, {
    key: "setupFilterIcon",
    value: function setupFilterIcon() {
      if (!this.eFilter) {
        return;
      }

      this.configureFilter(this.params.enableFilterIcon, this.eFilter, this.onFilterChangedIcon.bind(this));
    }
  }, {
    key: "setupFilterButton",
    value: function setupFilterButton() {
      var _this152 = this;

      if (!this.eFilterButton) {
        return;
      }

      var configured = this.configureFilter(this.params.enableFilterButton, this.eFilterButton, this.onFilterChangedButton.bind(this));

      if (configured) {
        this.addManagedListener(this.eFilterButton, "click", function () {
          return _this152.params.showFilter(_this152.eFilterButton);
        });
      } else {
        this.eFilterButton = void 0;
      }
    }
  }, {
    key: "configureFilter",
    value: function configureFilter(enabled, element, filterChangedCallback) {
      if (!enabled) {
        _removeFromParent(element);

        return false;
      }

      var column = this.params.column;
      this.addInIcon("filter", element, column);
      this.addManagedListener(column, _Column2.EVENT_FILTER_CHANGED, filterChangedCallback);
      filterChangedCallback();
      return true;
    }
  }, {
    key: "onFilterChangedIcon",
    value: function onFilterChangedIcon() {
      var filterPresent = this.params.column.isFilterActive();

      _setDisplayed(this.eFilter, filterPresent, {
        skipAriaHidden: true
      });
    }
  }, {
    key: "onFilterChangedButton",
    value: function onFilterChangedButton() {
      var filterPresent = this.params.column.isFilterActive();
      this.eFilterButton.classList.toggle("ag-filter-active", filterPresent);
    }
  }, {
    key: "getAnchorElementForMenu",
    value: function getAnchorElementForMenu(isFilter) {
      var _a, _b, _c, _d;

      if (isFilter) {
        return (_b = (_a = this.eFilterButton) != null ? _a : this.eMenu) != null ? _b : this.getGui();
      }

      return (_d = (_c = this.eMenu) != null ? _c : this.eFilterButton) != null ? _d : this.getGui();
    }
  }]);

  return _HeaderComp;
}(_Component2);

_HeaderComp.TEMPLATE =
/* html */
"<div class=\"ag-cell-label-container\" role=\"presentation\">\n            <span ref=\"eMenu\" class=\"ag-header-icon ag-header-cell-menu-button\" aria-hidden=\"true\"></span>\n            <span ref=\"eFilterButton\" class=\"ag-header-icon ag-header-cell-filter-button\" aria-hidden=\"true\"></span>\n            <div ref=\"eLabel\" class=\"ag-header-cell-label\" role=\"presentation\">\n                <span ref=\"eText\" class=\"ag-header-cell-text\"></span>\n                <span ref=\"eFilter\" class=\"ag-header-icon ag-header-label-icon ag-filter-icon\" aria-hidden=\"true\"></span>\n                <ag-sort-indicator ref=\"eSortIndicator\"></ag-sort-indicator>\n            </div>\n        </div>";

__decorateClass([_Autowired("sortController")], _HeaderComp.prototype, "sortController", 2);

__decorateClass([_Autowired("menuService")], _HeaderComp.prototype, "menuService", 2);

__decorateClass([_Autowired("columnModel")], _HeaderComp.prototype, "columnModel", 2);

__decorateClass([_RefSelector("eFilter")], _HeaderComp.prototype, "eFilter", 2);

__decorateClass([_RefSelector("eFilterButton")], _HeaderComp.prototype, "eFilterButton", 2);

__decorateClass([_RefSelector("eSortIndicator")], _HeaderComp.prototype, "eSortIndicator", 2);

__decorateClass([_RefSelector("eMenu")], _HeaderComp.prototype, "eMenu", 2);

__decorateClass([_RefSelector("eLabel")], _HeaderComp.prototype, "eLabel", 2);

__decorateClass([_RefSelector("eText")], _HeaderComp.prototype, "eText", 2);

__decorateClass([_RefSelector("eSortOrder")], _HeaderComp.prototype, "eSortOrder", 2);

__decorateClass([_RefSelector("eSortAsc")], _HeaderComp.prototype, "eSortAsc", 2);

__decorateClass([_RefSelector("eSortDesc")], _HeaderComp.prototype, "eSortDesc", 2);

__decorateClass([_RefSelector("eSortMixed")], _HeaderComp.prototype, "eSortMixed", 2);

__decorateClass([_RefSelector("eSortNone")], _HeaderComp.prototype, "eSortNone", 2);

var HeaderComp = _HeaderComp; // community-modules/core/src/headerRendering/cells/columnGroup/headerGroupComp.ts

var _HeaderGroupComp =
/*#__PURE__*/
function (_Component11) {
  "use strict";

  _inherits(_HeaderGroupComp, _Component11);

  function _HeaderGroupComp() {
    _classCallCheck(this, _HeaderGroupComp);

    return _possibleConstructorReturn(this, _getPrototypeOf(_HeaderGroupComp).call(this, _HeaderGroupComp.TEMPLATE));
  } // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.


  _createClass(_HeaderGroupComp, [{
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(_HeaderGroupComp.prototype), "destroy", this).call(this);
    }
  }, {
    key: "init",
    value: function init(params) {
      this.params = params;
      this.checkWarnings();
      this.setupLabel();
      this.addGroupExpandIcon();
      this.setupExpandIcons();
    }
  }, {
    key: "checkWarnings",
    value: function checkWarnings() {
      var paramsAny = this.params;

      if (paramsAny.template) {
        _warnOnce("A template was provided for Header Group Comp - templates are only supported for Header Comps (not groups)");
      }
    }
  }, {
    key: "setupExpandIcons",
    value: function setupExpandIcons() {
      var _this153 = this;

      this.addInIcon("columnGroupOpened", "agOpened");
      this.addInIcon("columnGroupClosed", "agClosed");

      var expandAction = function expandAction(event) {
        if (_isStopPropagationForAgGrid(event)) {
          return;
        }

        var newExpandedValue = !_this153.params.columnGroup.isExpanded();

        _this153.columnModel.setColumnGroupOpened(_this153.params.columnGroup.getProvidedColumnGroup(), newExpandedValue, "uiColumnExpanded");
      };

      this.addTouchAndClickListeners(this.eCloseIcon, expandAction);
      this.addTouchAndClickListeners(this.eOpenIcon, expandAction);

      var stopPropagationAction = function stopPropagationAction(event) {
        _stopPropagationForAgGrid(event);
      };

      this.addManagedListener(this.eCloseIcon, "dblclick", stopPropagationAction);
      this.addManagedListener(this.eOpenIcon, "dblclick", stopPropagationAction);
      this.addManagedListener(this.getGui(), "dblclick", expandAction);
      this.updateIconVisibility();
      var providedColumnGroup = this.params.columnGroup.getProvidedColumnGroup();
      this.addManagedListener(providedColumnGroup, _ProvidedColumnGroup2.EVENT_EXPANDED_CHANGED, this.updateIconVisibility.bind(this));
      this.addManagedListener(providedColumnGroup, _ProvidedColumnGroup2.EVENT_EXPANDABLE_CHANGED, this.updateIconVisibility.bind(this));
    }
  }, {
    key: "addTouchAndClickListeners",
    value: function addTouchAndClickListeners(eElement, action) {
      var touchListener = new _TouchListener2(eElement, true);
      this.addManagedListener(touchListener, _TouchListener2.EVENT_TAP, action);
      this.addDestroyFunc(function () {
        return touchListener.destroy();
      });
      this.addManagedListener(eElement, "click", action);
    }
  }, {
    key: "updateIconVisibility",
    value: function updateIconVisibility() {
      var columnGroup = this.params.columnGroup;

      if (columnGroup.isExpandable()) {
        var expanded = this.params.columnGroup.isExpanded();

        _setDisplayed(this.eOpenIcon, expanded);

        _setDisplayed(this.eCloseIcon, !expanded);
      } else {
        _setDisplayed(this.eOpenIcon, false);

        _setDisplayed(this.eCloseIcon, false);
      }
    }
  }, {
    key: "addInIcon",
    value: function addInIcon(iconName, refName) {
      var eIcon = _createIconNoSpan(iconName, this.gos, null);

      if (eIcon) {
        this.getRefElement(refName).appendChild(eIcon);
      }
    }
  }, {
    key: "addGroupExpandIcon",
    value: function addGroupExpandIcon() {
      if (!this.params.columnGroup.isExpandable()) {
        _setDisplayed(this.eOpenIcon, false);

        _setDisplayed(this.eCloseIcon, false);

        return;
      }
    }
  }, {
    key: "setupLabel",
    value: function setupLabel() {
      var _a;

      var _this$params = this.params,
          displayName = _this$params.displayName,
          columnGroup = _this$params.columnGroup;

      if (_exists(displayName)) {
        var displayNameSanitised = _escapeString(displayName, true);

        this.getRefElement("agLabel").textContent = displayNameSanitised;
      }

      this.addOrRemoveCssClass("ag-sticky-label", !((_a = columnGroup.getColGroupDef()) == null ? void 0 : _a.suppressStickyLabel));
    }
  }]);

  return _HeaderGroupComp;
}(_Component2);

_HeaderGroupComp.TEMPLATE =
/* html */
"<div class=\"ag-header-group-cell-label\" ref=\"agContainer\" role=\"presentation\">\n            <span ref=\"agLabel\" class=\"ag-header-group-text\" role=\"presentation\"></span>\n            <span ref=\"agOpened\" class=\"ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded\"></span>\n            <span ref=\"agClosed\" class=\"ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed\"></span>\n        </div>";

__decorateClass([_Autowired("columnModel")], _HeaderGroupComp.prototype, "columnModel", 2);

__decorateClass([_RefSelector("agOpened")], _HeaderGroupComp.prototype, "eOpenIcon", 2);

__decorateClass([_RefSelector("agClosed")], _HeaderGroupComp.prototype, "eCloseIcon", 2);

var HeaderGroupComp = _HeaderGroupComp; // community-modules/core/src/widgets/popupComponent.ts

var _PopupComponent =
/*#__PURE__*/
function (_Component12) {
  "use strict";

  _inherits(_PopupComponent, _Component12);

  function _PopupComponent() {
    _classCallCheck(this, _PopupComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(_PopupComponent).apply(this, arguments));
  }

  _createClass(_PopupComponent, [{
    key: "isPopup",
    value: function isPopup() {
      return true;
    }
  }, {
    key: "setParentComponent",
    value: function setParentComponent(container) {
      container.addCssClass("ag-has-popup");

      _get(_getPrototypeOf(_PopupComponent.prototype), "setParentComponent", this).call(this, container);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var parentComp = this.parentComponent;
      var hasParent = parentComp && parentComp.isAlive();

      if (hasParent) {
        parentComp.getGui().classList.remove("ag-has-popup");
      }

      _get(_getPrototypeOf(_PopupComponent.prototype), "destroy", this).call(this);
    }
  }]);

  return _PopupComponent;
}(_Component2); // community-modules/core/src/rendering/cellEditors/largeTextCellEditor.ts


var _LargeTextCellEditor =
/*#__PURE__*/
function (_PopupComponent2) {
  "use strict";

  _inherits(_LargeTextCellEditor, _PopupComponent2);

  function _LargeTextCellEditor() {
    _classCallCheck(this, _LargeTextCellEditor);

    return _possibleConstructorReturn(this, _getPrototypeOf(_LargeTextCellEditor).call(this, _LargeTextCellEditor.TEMPLATE));
  }

  _createClass(_LargeTextCellEditor, [{
    key: "init",
    value: function init(params) {
      this.params = params;
      this.focusAfterAttached = params.cellStartedEdit;
      this.eTextArea.setMaxLength(params.maxLength || 200).setCols(params.cols || 60).setRows(params.rows || 10);

      if (_exists(params.value, true)) {
        this.eTextArea.setValue(params.value.toString(), true);
      }

      this.addGuiEventListener("keydown", this.onKeyDown.bind(this));
      this.activateTabIndex();
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      var key = event.key;

      if (key === _KeyCode.LEFT || key === _KeyCode.UP || key === _KeyCode.RIGHT || key === _KeyCode.DOWN || event.shiftKey && key === _KeyCode.ENTER) {
        event.stopPropagation();
      }
    }
  }, {
    key: "afterGuiAttached",
    value: function afterGuiAttached() {
      var translate = this.localeService.getLocaleTextFunc();
      this.eTextArea.setInputAriaLabel(translate("ariaInputEditor", "Input Editor"));

      if (this.focusAfterAttached) {
        this.eTextArea.getFocusableElement().focus();
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var value = this.eTextArea.getValue();

      if (!_exists(value) && !_exists(this.params.value)) {
        return this.params.value;
      }

      return this.params.parseValue(value);
    }
  }]);

  return _LargeTextCellEditor;
}(_PopupComponent);

_LargeTextCellEditor.TEMPLATE =
/* html */
"<div class=\"ag-large-text\">\n            <ag-input-text-area ref=\"eTextArea\" class=\"ag-large-text-input\"></ag-input-text-area>\n        </div>";

__decorateClass([_RefSelector("eTextArea")], _LargeTextCellEditor.prototype, "eTextArea", 2);

var _LargeTextCellEditor2 = _LargeTextCellEditor; // community-modules/core/src/rendering/cellEditors/selectCellEditor.ts

var _SelectCellEditor =
/*#__PURE__*/
function (_PopupComponent3) {
  "use strict";

  _inherits(_SelectCellEditor, _PopupComponent3);

  function _SelectCellEditor() {
    var _this154;

    _classCallCheck(this, _SelectCellEditor);

    _this154 = _possibleConstructorReturn(this, _getPrototypeOf(_SelectCellEditor).call(this,
    /* html */
    "<div class=\"ag-cell-edit-wrapper\">\n                <ag-select class=\"ag-cell-editor\" ref=\"eSelect\"></ag-select>\n            </div>"));
    _this154.startedByEnter = false;
    return _this154;
  }

  _createClass(_SelectCellEditor, [{
    key: "init",
    value: function init(params) {
      this.focusAfterAttached = params.cellStartedEdit;
      var eSelect = this.eSelect,
          valueService = this.valueService,
          gos = this.gos;
      var values2 = params.values,
          value = params.value,
          eventKey = params.eventKey;

      if (_missing(values2)) {
        console.warn("AG Grid: no values found for select cellEditor");
        return;
      }

      this.startedByEnter = eventKey != null ? eventKey === _KeyCode.ENTER : false;
      var hasValue = false;
      values2.forEach(function (currentValue) {
        var option = {
          value: currentValue
        };
        var valueFormatted = valueService.formatValue(params.column, null, currentValue);
        var valueFormattedExits = valueFormatted !== null && valueFormatted !== void 0;
        option.text = valueFormattedExits ? valueFormatted : currentValue;
        eSelect.addOption(option);
        hasValue = hasValue || value === currentValue;
      });

      if (hasValue) {
        eSelect.setValue(params.value, true);
      } else if (params.values.length) {
        eSelect.setValue(params.values[0], true);
      }

      var valueListGap = params.valueListGap,
          valueListMaxWidth = params.valueListMaxWidth,
          valueListMaxHeight = params.valueListMaxHeight;

      if (valueListGap != null) {
        eSelect.setPickerGap(valueListGap);
      }

      if (valueListMaxHeight != null) {
        eSelect.setPickerMaxHeight(valueListMaxHeight);
      }

      if (valueListMaxWidth != null) {
        eSelect.setPickerMaxWidth(valueListMaxWidth);
      }

      if (gos.get("editType") !== "fullRow") {
        this.addManagedListener(this.eSelect, _AgSelect2.EVENT_ITEM_SELECTED, function () {
          return params.stopEditing();
        });
      }
    }
  }, {
    key: "afterGuiAttached",
    value: function afterGuiAttached() {
      var _this155 = this;

      if (this.focusAfterAttached) {
        this.eSelect.getFocusableElement().focus();
      }

      if (this.startedByEnter) {
        setTimeout(function () {
          if (_this155.isAlive()) {
            _this155.eSelect.showPicker();
          }
        });
      }
    }
  }, {
    key: "focusIn",
    value: function focusIn() {
      this.eSelect.getFocusableElement().focus();
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.eSelect.getValue();
    }
  }, {
    key: "isPopup",
    value: function isPopup() {
      return false;
    }
  }]);

  return _SelectCellEditor;
}(_PopupComponent);

__decorateClass([_Autowired("valueService")], _SelectCellEditor.prototype, "valueService", 2);

__decorateClass([_RefSelector("eSelect")], _SelectCellEditor.prototype, "eSelect", 2); // community-modules/core/src/rendering/cellEditors/simpleCellEditor.ts


var SimpleCellEditor =
/*#__PURE__*/
function (_PopupComponent4) {
  "use strict";

  _inherits(SimpleCellEditor, _PopupComponent4);

  function SimpleCellEditor(cellEditorInput) {
    var _this156;

    _classCallCheck(this, SimpleCellEditor);

    _this156 = _possibleConstructorReturn(this, _getPrototypeOf(SimpleCellEditor).call(this,
    /* html */
    "\n            <div class=\"ag-cell-edit-wrapper\">\n                ".concat(cellEditorInput.getTemplate(), "\n            </div>")));
    _this156.cellEditorInput = cellEditorInput;
    return _this156;
  }

  _createClass(SimpleCellEditor, [{
    key: "init",
    value: function init(params) {
      this.params = params;
      var eInput = this.eInput;
      this.cellEditorInput.init(eInput, params);
      var startValue;

      if (params.cellStartedEdit) {
        this.focusAfterAttached = true;
        var eventKey = params.eventKey;

        if (eventKey === _KeyCode.BACKSPACE || params.eventKey === _KeyCode.DELETE) {
          startValue = "";
        } else if (eventKey && eventKey.length === 1) {
          startValue = eventKey;
        } else {
          startValue = this.cellEditorInput.getStartValue();

          if (eventKey !== _KeyCode.F2) {
            this.highlightAllOnFocus = true;
          }
        }
      } else {
        this.focusAfterAttached = false;
        startValue = this.cellEditorInput.getStartValue();
      }

      if (startValue != null) {
        eInput.setStartValue(startValue);
      }

      this.addManagedListener(eInput.getGui(), "keydown", function (event) {
        var key = event.key;

        if (key === _KeyCode.PAGE_UP || key === _KeyCode.PAGE_DOWN) {
          event.preventDefault();
        }
      });
    }
  }, {
    key: "afterGuiAttached",
    value: function afterGuiAttached() {
      var _a, _b;

      var translate = this.localeService.getLocaleTextFunc();
      var eInput = this.eInput;
      eInput.setInputAriaLabel(translate("ariaInputEditor", "Input Editor"));

      if (!this.focusAfterAttached) {
        return;
      }

      if (!_isBrowserSafari()) {
        eInput.getFocusableElement().focus();
      }

      var inputEl = eInput.getInputElement();

      if (this.highlightAllOnFocus) {
        inputEl.select();
      } else {
        (_b = (_a = this.cellEditorInput).setCaret) == null ? void 0 : _b.call(_a);
      }
    } // gets called when tabbing through cells and in full row edit mode

  }, {
    key: "focusIn",
    value: function focusIn() {
      var eInput = this.eInput;
      var focusEl = eInput.getFocusableElement();
      var inputEl = eInput.getInputElement();
      focusEl.focus();
      inputEl.select();
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.cellEditorInput.getValue();
    }
  }, {
    key: "isPopup",
    value: function isPopup() {
      return false;
    }
  }]);

  return SimpleCellEditor;
}(_PopupComponent);

__decorateClass([_RefSelector("eInput")], SimpleCellEditor.prototype, "eInput", 2); // community-modules/core/src/rendering/cellEditors/textCellEditor.ts


var TextCellEditorInput =
/*#__PURE__*/
function () {
  "use strict";

  function TextCellEditorInput() {
    _classCallCheck(this, TextCellEditorInput);
  }

  _createClass(TextCellEditorInput, [{
    key: "getTemplate",
    value: function getTemplate() {
      return (
        /* html */
        "<ag-input-text-field class=\"ag-cell-editor\" ref=\"eInput\"></ag-input-text-field>"
      );
    }
  }, {
    key: "init",
    value: function init(eInput, params) {
      this.eInput = eInput;
      this.params = params;

      if (params.maxLength != null) {
        eInput.setMaxLength(params.maxLength);
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var value = this.eInput.getValue();

      if (!_exists(value) && !_exists(this.params.value)) {
        return this.params.value;
      }

      return this.params.parseValue(value);
    }
  }, {
    key: "getStartValue",
    value: function getStartValue() {
      var formatValue = this.params.useFormatter || this.params.column.getColDef().refData;
      return formatValue ? this.params.formatValue(this.params.value) : this.params.value;
    }
  }, {
    key: "setCaret",
    value: function setCaret() {
      var value = this.eInput.getValue();
      var len = _exists(value) && value.length || 0;

      if (len) {
        this.eInput.getInputElement().setSelectionRange(len, len);
      }
    }
  }]);

  return TextCellEditorInput;
}();

var _TextCellEditor =
/*#__PURE__*/
function (_SimpleCellEditor) {
  "use strict";

  _inherits(_TextCellEditor, _SimpleCellEditor);

  function _TextCellEditor() {
    _classCallCheck(this, _TextCellEditor);

    return _possibleConstructorReturn(this, _getPrototypeOf(_TextCellEditor).call(this, new TextCellEditorInput()));
  }

  return _TextCellEditor;
}(SimpleCellEditor); // community-modules/core/src/rendering/cellRenderers/animateShowChangeCellRenderer.ts


var ARROW_UP = "\u2191";
var ARROW_DOWN = "\u2193";

var _AnimateShowChangeCellRenderer =
/*#__PURE__*/
function (_Component13) {
  "use strict";

  _inherits(_AnimateShowChangeCellRenderer, _Component13);

  function _AnimateShowChangeCellRenderer() {
    var _this157;

    _classCallCheck(this, _AnimateShowChangeCellRenderer);

    _this157 = _possibleConstructorReturn(this, _getPrototypeOf(_AnimateShowChangeCellRenderer).call(this));
    _this157.refreshCount = 0;
    var template = document.createElement("span");
    var delta = document.createElement("span");
    delta.setAttribute("class", "ag-value-change-delta");
    var value = document.createElement("span");
    value.setAttribute("class", "ag-value-change-value");
    template.appendChild(delta);
    template.appendChild(value);

    _this157.setTemplateFromElement(template);

    return _this157;
  }

  _createClass(_AnimateShowChangeCellRenderer, [{
    key: "init",
    value: function init(params) {
      this.eValue = this.queryForHtmlElement(".ag-value-change-value");
      this.eDelta = this.queryForHtmlElement(".ag-value-change-delta");
      this.refresh(params, true);
    }
  }, {
    key: "showDelta",
    value: function showDelta(params, delta) {
      var absDelta = Math.abs(delta);
      var valueFormatted = params.formatValue(absDelta);
      var valueToUse = _exists(valueFormatted) ? valueFormatted : absDelta;
      var deltaUp = delta >= 0;

      if (deltaUp) {
        this.eDelta.textContent = ARROW_UP + valueToUse;
      } else {
        this.eDelta.textContent = ARROW_DOWN + valueToUse;
      }

      this.eDelta.classList.toggle("ag-value-change-delta-up", deltaUp);
      this.eDelta.classList.toggle("ag-value-change-delta-down", !deltaUp);
    }
  }, {
    key: "setTimerToRemoveDelta",
    value: function setTimerToRemoveDelta() {
      var _this158 = this;

      this.refreshCount++;
      var refreshCountCopy = this.refreshCount;
      this.getFrameworkOverrides().wrapIncoming(function () {
        window.setTimeout(function () {
          if (refreshCountCopy === _this158.refreshCount) {
            _this158.hideDeltaValue();
          }
        }, 2e3);
      });
    }
  }, {
    key: "hideDeltaValue",
    value: function hideDeltaValue() {
      this.eValue.classList.remove("ag-value-change-value-highlight");

      _clearElement(this.eDelta);
    }
  }, {
    key: "refresh",
    value: function refresh(params) {
      var isInitialRender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var value = params.value;

      if (value === this.lastValue) {
        return false;
      }

      if (_exists(params.valueFormatted)) {
        this.eValue.textContent = params.valueFormatted;
      } else if (_exists(params.value)) {
        this.eValue.textContent = value;
      } else {
        _clearElement(this.eValue);
      }

      if (this.filterManager.isSuppressFlashingCellsBecauseFiltering()) {
        return false;
      }

      if (typeof value === "number" && typeof this.lastValue === "number") {
        var delta = value - this.lastValue;
        this.showDelta(params, delta);
      }

      if (this.lastValue) {
        this.eValue.classList.add("ag-value-change-value-highlight");
      }

      if (!isInitialRender) {
        this.setTimerToRemoveDelta();
      }

      this.lastValue = value;
      return true;
    }
  }]);

  return _AnimateShowChangeCellRenderer;
}(_Component2);

__decorateClass([_Autowired("filterManager")], _AnimateShowChangeCellRenderer.prototype, "filterManager", 2); // community-modules/core/src/rendering/cellRenderers/animateSlideCellRenderer.ts


var _AnimateSlideCellRenderer =
/*#__PURE__*/
function (_Component14) {
  "use strict";

  _inherits(_AnimateSlideCellRenderer, _Component14);

  function _AnimateSlideCellRenderer() {
    var _this159;

    _classCallCheck(this, _AnimateSlideCellRenderer);

    _this159 = _possibleConstructorReturn(this, _getPrototypeOf(_AnimateSlideCellRenderer).call(this));
    _this159.refreshCount = 0;
    var template = document.createElement("span");
    var slide = document.createElement("span");
    slide.setAttribute("class", "ag-value-slide-current");
    template.appendChild(slide);

    _this159.setTemplateFromElement(template);

    _this159.eCurrent = _this159.queryForHtmlElement(".ag-value-slide-current");
    return _this159;
  }

  _createClass(_AnimateSlideCellRenderer, [{
    key: "init",
    value: function init(params) {
      this.refresh(params, true);
    }
  }, {
    key: "addSlideAnimation",
    value: function addSlideAnimation() {
      var _this160 = this;

      this.refreshCount++;
      var refreshCountCopy = this.refreshCount;

      if (this.ePrevious) {
        this.getGui().removeChild(this.ePrevious);
      }

      var prevElement = document.createElement("span");
      prevElement.setAttribute("class", "ag-value-slide-previous ag-value-slide-out");
      this.ePrevious = prevElement;
      this.ePrevious.textContent = this.eCurrent.textContent;
      this.getGui().insertBefore(this.ePrevious, this.eCurrent);
      this.getFrameworkOverrides().wrapIncoming(function () {
        window.setTimeout(function () {
          if (refreshCountCopy !== _this160.refreshCount) {
            return;
          }

          _this160.ePrevious.classList.add("ag-value-slide-out-end");
        }, 50);
        window.setTimeout(function () {
          if (refreshCountCopy !== _this160.refreshCount) {
            return;
          }

          _this160.getGui().removeChild(_this160.ePrevious);

          _this160.ePrevious = null;
        }, 3e3);
      });
    }
  }, {
    key: "refresh",
    value: function refresh(params) {
      var isInitialRender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var value = params.value;

      if (_missing(value)) {
        value = "";
      }

      if (value === this.lastValue) {
        return false;
      }

      if (this.filterManager.isSuppressFlashingCellsBecauseFiltering()) {
        return false;
      }

      if (!isInitialRender) {
        this.addSlideAnimation();
      }

      this.lastValue = value;

      if (_exists(params.valueFormatted)) {
        this.eCurrent.textContent = params.valueFormatted;
      } else if (_exists(params.value)) {
        this.eCurrent.textContent = value;
      } else {
        _clearElement(this.eCurrent);
      }

      return true;
    }
  }]);

  return _AnimateSlideCellRenderer;
}(_Component2);

__decorateClass([_Autowired("filterManager")], _AnimateSlideCellRenderer.prototype, "filterManager", 2); // community-modules/core/src/entities/rowNode.ts


var _RowNode =
/*#__PURE__*/
function () {
  "use strict";

  function _RowNode(beans) {
    _classCallCheck(this, _RowNode);

    /** The current row index. If the row is filtered out or in a collapsed group, this value will be `null`. */
    this.rowIndex = null;
    /** The key for the group eg Ireland, UK, USA */

    this.key = null;
    /** Children mapped by the pivot columns. */

    this.childrenMapped = {};
    /**
     * This will be `true` if it has a rowIndex assigned, otherwise `false`.
     */

    this.displayed = false;
    /** The row top position in pixels. */

    this.rowTop = null;
    /** The top pixel for this row last time, makes sense if data set was ordered or filtered,
     * it is used so new rows can animate in from their old position. */

    this.oldRowTop = null;
    /** `true` by default - can be overridden via gridOptions.isRowSelectable(rowNode) */

    this.selectable = true;
    /** Used by sorting service - to give deterministic sort to groups. Previously we
     * just id for this, however id is a string and had slower sorting compared to numbers. */

    this.__objectId = _RowNode.OBJECT_ID_SEQUENCE++;
    /** When one or more Columns are using autoHeight, this keeps track of height of each autoHeight Cell,
     * indexed by the Column ID. */

    this.__autoHeights = {};
    /** `true` when nodes with the same id are being removed and added as part of the same batch transaction */

    this.alreadyRendered = false;
    this.highlighted = null;
    this.hovered = false;
    this.selected = false;
    this.beans = beans;
  }
  /**
   * Replaces the data on the `rowNode`. When this method is called, the grid will refresh the entire rendered row if it is displayed.
   */


  _createClass(_RowNode, [{
    key: "setData",
    value: function setData(data) {
      this.setDataCommon(data, false);
    } // similar to setRowData, however it is expected that the data is the same data item. this
    // is intended to be used with Redux type stores, where the whole data can be changed. we are
    // guaranteed that the data is the same entity (so grid doesn't need to worry about the id of the
    // underlying data changing, hence doesn't need to worry about selection). the grid, upon receiving
    // dataChanged event, will refresh the cells rather than rip them all out (so user can show transitions).

    /**
     * Updates the data on the `rowNode`. When this method is called, the grid will refresh the entire rendered row if it is displayed.
     */

  }, {
    key: "updateData",
    value: function updateData(data) {
      this.setDataCommon(data, true);
    }
  }, {
    key: "setDataCommon",
    value: function setDataCommon(data, update) {
      var oldData = this.data;
      this.data = data;
      this.beans.valueCache.onDataChanged();
      this.updateDataOnDetailNode();
      this.checkRowSelectable();
      this.resetQuickFilterAggregateText();
      var event = this.createDataChangedEvent(data, oldData, update);
      this.dispatchLocalEvent(event);
    } // when we are doing master / detail, the detail node is lazy created, but then kept around.
    // so if we show / hide the detail, the same detail rowNode is used. so we need to keep the data
    // in sync, otherwise expand/collapse of the detail would still show the old values.

  }, {
    key: "updateDataOnDetailNode",
    value: function updateDataOnDetailNode() {
      if (this.detailNode) {
        this.detailNode.data = this.data;
      }
    }
  }, {
    key: "createDataChangedEvent",
    value: function createDataChangedEvent(newData, oldData, update) {
      return {
        type: _RowNode.EVENT_DATA_CHANGED,
        node: this,
        oldData: oldData,
        newData: newData,
        update: update
      };
    }
  }, {
    key: "createLocalRowEvent",
    value: function createLocalRowEvent(type) {
      return {
        type: type,
        node: this
      };
    }
  }, {
    key: "getRowIndexString",
    value: function getRowIndexString() {
      if (this.rowPinned === "top") {
        return "t-" + this.rowIndex;
      }

      if (this.rowPinned === "bottom") {
        return "b-" + this.rowIndex;
      }

      return this.rowIndex.toString();
    }
  }, {
    key: "createDaemonNode",
    value: function createDaemonNode() {
      var oldNode = new _RowNode(this.beans);
      oldNode.id = this.id;
      oldNode.data = this.data;
      oldNode.__daemon = true;
      oldNode.selected = this.selected;
      oldNode.level = this.level;
      return oldNode;
    }
  }, {
    key: "setDataAndId",
    value: function setDataAndId(data, id) {
      var oldNode = _exists(this.id) ? this.createDaemonNode() : null;
      var oldData = this.data;
      this.data = data;
      this.updateDataOnDetailNode();
      this.setId(id);
      this.checkRowSelectable();
      this.beans.selectionService.syncInRowNode(this, oldNode);
      var event = this.createDataChangedEvent(data, oldData, false);
      this.dispatchLocalEvent(event);
    }
  }, {
    key: "checkRowSelectable",
    value: function checkRowSelectable() {
      var isRowSelectableFunc = this.beans.gos.get("isRowSelectable");
      this.setRowSelectable(isRowSelectableFunc ? isRowSelectableFunc(this) : true);
    }
  }, {
    key: "setRowSelectable",
    value: function setRowSelectable(newVal, suppressSelectionUpdate) {
      if (this.selectable !== newVal) {
        this.selectable = newVal;

        if (this.eventService) {
          this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_SELECTABLE_CHANGED));
        }

        if (suppressSelectionUpdate) {
          return;
        }

        var isGroupSelectsChildren = this.beans.gos.get("groupSelectsChildren");

        if (isGroupSelectsChildren) {
          var selected = this.calculateSelectedFromChildren();
          this.setSelectedParams({
            newValue: selected != null ? selected : false,
            source: "selectableChanged"
          });
          return;
        }

        if (this.isSelected() && !this.selectable) {
          this.setSelectedParams({
            newValue: false,
            source: "selectableChanged"
          });
        }
      }
    }
  }, {
    key: "setId",
    value: function setId(id) {
      var getRowIdFunc = this.beans.gos.getCallback("getRowId");

      if (getRowIdFunc) {
        if (this.data) {
          var parentKeys = this.getGroupKeys(true);
          this.id = getRowIdFunc({
            data: this.data,
            parentKeys: parentKeys.length > 0 ? parentKeys : void 0,
            level: this.level
          });

          if (this.id !== null && typeof this.id === "string" && this.id.startsWith(_RowNode.ID_PREFIX_ROW_GROUP)) {
            console.error("AG Grid: Row IDs cannot start with ".concat(_RowNode.ID_PREFIX_ROW_GROUP, ", this is a reserved prefix for AG Grid's row grouping feature."));
          }

          if (this.id !== null && typeof this.id !== "string") {
            this.id = "" + this.id;
          }
        } else {
          this.id = void 0;
        }
      } else {
        this.id = id;
      }
    }
  }, {
    key: "getGroupKeys",
    value: function getGroupKeys() {
      var excludeSelf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var keys2 = [];
      var pointer = this;

      if (excludeSelf) {
        pointer = pointer.parent;
      }

      while (pointer && pointer.level >= 0) {
        keys2.push(pointer.key);
        pointer = pointer.parent;
      }

      keys2.reverse();
      return keys2;
    }
  }, {
    key: "isPixelInRange",
    value: function isPixelInRange(pixel) {
      if (!_exists(this.rowTop) || !_exists(this.rowHeight)) {
        return false;
      }

      return pixel >= this.rowTop && pixel < this.rowTop + this.rowHeight;
    }
  }, {
    key: "setFirstChild",
    value: function setFirstChild(firstChild) {
      if (this.firstChild === firstChild) {
        return;
      }

      this.firstChild = firstChild;

      if (this.eventService) {
        this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_FIRST_CHILD_CHANGED));
      }
    }
  }, {
    key: "setLastChild",
    value: function setLastChild(lastChild) {
      if (this.lastChild === lastChild) {
        return;
      }

      this.lastChild = lastChild;

      if (this.eventService) {
        this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_LAST_CHILD_CHANGED));
      }
    }
  }, {
    key: "setChildIndex",
    value: function setChildIndex(childIndex) {
      if (this.childIndex === childIndex) {
        return;
      }

      this.childIndex = childIndex;

      if (this.eventService) {
        this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_CHILD_INDEX_CHANGED));
      }
    }
  }, {
    key: "setRowTop",
    value: function setRowTop(rowTop) {
      this.oldRowTop = this.rowTop;

      if (this.rowTop === rowTop) {
        return;
      }

      this.rowTop = rowTop;

      if (this.eventService) {
        this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_TOP_CHANGED));
      }

      this.setDisplayed(rowTop !== null);
    }
  }, {
    key: "clearRowTopAndRowIndex",
    value: function clearRowTopAndRowIndex() {
      this.oldRowTop = null;
      this.setRowTop(null);
      this.setRowIndex(null);
    }
  }, {
    key: "setDisplayed",
    value: function setDisplayed(displayed) {
      if (this.displayed === displayed) {
        return;
      }

      this.displayed = displayed;

      if (this.eventService) {
        this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_DISPLAYED_CHANGED));
      }
    }
  }, {
    key: "setDragging",
    value: function setDragging(dragging) {
      if (this.dragging === dragging) {
        return;
      }

      this.dragging = dragging;

      if (this.eventService) {
        this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_DRAGGING_CHANGED));
      }
    }
  }, {
    key: "setHighlighted",
    value: function setHighlighted(highlighted) {
      if (highlighted === this.highlighted) {
        return;
      }

      this.highlighted = highlighted;

      if (this.eventService) {
        this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_HIGHLIGHT_CHANGED));
      }
    }
  }, {
    key: "setHovered",
    value: function setHovered(hovered) {
      if (this.hovered === hovered) {
        return;
      }

      this.hovered = hovered;
    }
  }, {
    key: "isHovered",
    value: function isHovered() {
      return this.hovered;
    }
  }, {
    key: "setAllChildrenCount",
    value: function setAllChildrenCount(allChildrenCount) {
      if (this.allChildrenCount === allChildrenCount) {
        return;
      }

      this.allChildrenCount = allChildrenCount;

      if (this.eventService) {
        this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED));
      }
    }
  }, {
    key: "setMaster",
    value: function setMaster(master) {
      if (this.master === master) {
        return;
      }

      if (this.master && !master) {
        this.expanded = false;
      }

      this.master = master;

      if (this.eventService) {
        this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_MASTER_CHANGED));
      }
    }
  }, {
    key: "setGroup",
    value: function setGroup(group) {
      if (this.group === group) {
        return;
      }

      if (this.group && !group) {
        this.expanded = false;
      }

      this.group = group;
      this.updateHasChildren();

      if (this.eventService) {
        this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_GROUP_CHANGED));
      }
    }
    /**
     * Sets the row height.
     * Call if you want to change the height initially assigned to the row.
     * After calling, you must call `api.onRowHeightChanged()` so the grid knows it needs to work out the placement of the rows. */

  }, {
    key: "setRowHeight",
    value: function setRowHeight(rowHeight) {
      var estimated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.rowHeight = rowHeight;
      this.rowHeightEstimated = estimated;

      if (this.eventService) {
        this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_HEIGHT_CHANGED));
      }
    }
  }, {
    key: "setRowAutoHeight",
    value: function setRowAutoHeight(cellHeight, column) {
      if (!this.__autoHeights) {
        this.__autoHeights = {};
      }

      this.__autoHeights[column.getId()] = cellHeight;

      if (cellHeight != null) {
        if (this.checkAutoHeightsDebounced == null) {
          this.checkAutoHeightsDebounced = _debounce(this.checkAutoHeights.bind(this), 1);
        }

        this.checkAutoHeightsDebounced();
      }
    }
  }, {
    key: "checkAutoHeights",
    value: function checkAutoHeights() {
      var _this161 = this;

      var notAllPresent = false;
      var nonePresent = true;
      var newRowHeight = 0;
      var autoHeights = this.__autoHeights;

      if (autoHeights == null) {
        return;
      }

      var displayedAutoHeightCols = this.beans.columnModel.getAllDisplayedAutoHeightCols();
      displayedAutoHeightCols.forEach(function (col) {
        var cellHeight = autoHeights[col.getId()];

        if (cellHeight == null) {
          if (_this161.beans.columnModel.isColSpanActive()) {
            var activeColsForRow = [];

            switch (col.getPinned()) {
              case "left":
                activeColsForRow = _this161.beans.columnModel.getDisplayedLeftColumnsForRow(_this161);
                break;

              case "right":
                activeColsForRow = _this161.beans.columnModel.getDisplayedRightColumnsForRow(_this161);
                break;

              case null:
                activeColsForRow = _this161.beans.columnModel.getViewportCenterColumnsForRow(_this161);
                break;
            }

            if (activeColsForRow.includes(col)) {
              notAllPresent = true;
              return;
            }

            cellHeight = -1;
          } else {
            notAllPresent = true;
            return;
          }
        } else {
          nonePresent = false;
        }

        if (cellHeight > newRowHeight) {
          newRowHeight = cellHeight;
        }
      });

      if (notAllPresent) {
        return;
      }

      if (nonePresent || newRowHeight < 10) {
        newRowHeight = this.beans.gos.getRowHeightForNode(this).height;
      }

      if (newRowHeight == this.rowHeight) {
        return;
      }

      this.setRowHeight(newRowHeight);
      var rowModel = this.beans.rowModel;

      if (rowModel.onRowHeightChangedDebounced) {
        rowModel.onRowHeightChangedDebounced();
      }
    }
  }, {
    key: "setRowIndex",
    value: function setRowIndex(rowIndex) {
      if (this.rowIndex === rowIndex) {
        return;
      }

      this.rowIndex = rowIndex;

      if (this.eventService) {
        this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_ROW_INDEX_CHANGED));
      }
    }
  }, {
    key: "setUiLevel",
    value: function setUiLevel(uiLevel) {
      if (this.uiLevel === uiLevel) {
        return;
      }

      this.uiLevel = uiLevel;

      if (this.eventService) {
        this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_UI_LEVEL_CHANGED));
      }
    }
    /**
     * Set the expanded state of this rowNode. Pass `true` to expand and `false` to collapse.
     */

  }, {
    key: "setExpanded",
    value: function setExpanded(expanded, e, forceSync) {
      if (this.expanded === expanded) {
        return;
      }

      this.expanded = expanded;

      if (this.eventService) {
        this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_EXPANDED_CHANGED));
      }

      var event = Object.assign({}, this.createGlobalRowEvent(_Events.EVENT_ROW_GROUP_OPENED), {
        expanded: expanded,
        event: e || null
      });
      this.beans.rowNodeEventThrottle.dispatchExpanded(event, forceSync);
      this.beans.rowRenderer.refreshCells({
        rowNodes: [this]
      });
    }
  }, {
    key: "createGlobalRowEvent",
    value: function createGlobalRowEvent(type) {
      return this.beans.gos.addGridCommonParams({
        type: type,
        node: this,
        data: this.data,
        rowIndex: this.rowIndex,
        rowPinned: this.rowPinned
      });
    }
  }, {
    key: "dispatchLocalEvent",
    value: function dispatchLocalEvent(event) {
      if (this.eventService) {
        this.eventService.dispatchEvent(event);
      }
    }
    /**
     * Replaces the value on the `rowNode` for the specified column. When complete,
     * the grid will refresh the rendered cell on the required row only.
     * **Note**: This method only fires `onCellEditRequest` when the Grid is in **Read Only** mode.
     *
     * @param colKey The column where the value should be updated
     * @param newValue The new value
     * @param eventSource The source of the event
     * @returns `true` if the value was changed, otherwise `false`.
     */

  }, {
    key: "setDataValue",
    value: function setDataValue(colKey, newValue, eventSource) {
      var _this162 = this;

      var getColumnFromKey = function getColumnFromKey() {
        var _a;

        if (typeof colKey !== "string") {
          return colKey;
        }

        return (_a = _this162.beans.columnModel.getGridColumn(colKey)) != null ? _a : _this162.beans.columnModel.getPrimaryColumn(colKey);
      };

      var column = getColumnFromKey();
      var oldValue = this.getValueFromValueService(column);

      if (this.beans.gos.get("readOnlyEdit")) {
        this.dispatchEventForSaveValueReadOnly(column, oldValue, newValue, eventSource);
        return false;
      }

      var valueChanged = this.beans.valueService.setValue(this, column, newValue, eventSource);
      this.dispatchCellChangedEvent(column, newValue, oldValue);
      this.checkRowSelectable();
      return valueChanged;
    }
  }, {
    key: "getValueFromValueService",
    value: function getValueFromValueService(column) {
      var _a, _b;

      var lockedClosedGroup = this.leafGroup && this.beans.columnModel.isPivotMode();
      var isOpenGroup = this.group && this.expanded && !this.footer && !lockedClosedGroup;
      var includeFooter = false;
      var groupIncludeFooterOpt = (_a = this.beans.gos.get("groupTotalRow")) != null ? _a : this.beans.gos.get("groupIncludeFooter");

      if (typeof groupIncludeFooterOpt !== "function") {
        includeFooter = !!groupIncludeFooterOpt;
      } else {
        var groupIncludeFooterCb = (_b = this.beans.gos.getCallback("groupTotalRow")) != null ? _b : this.beans.gos.getCallback("groupIncludeFooter");
        includeFooter = !!groupIncludeFooterCb({
          node: this
        });
      }

      var groupAlwaysShowAggData = this.beans.gos.get("groupSuppressBlankHeader");
      var ignoreAggData = isOpenGroup && includeFooter && !groupAlwaysShowAggData;
      var value = this.beans.valueService.getValue(column, this, false, ignoreAggData);
      return value;
    }
  }, {
    key: "dispatchEventForSaveValueReadOnly",
    value: function dispatchEventForSaveValueReadOnly(column, oldValue, newValue, eventSource) {
      var event = this.beans.gos.addGridCommonParams({
        type: _Events.EVENT_CELL_EDIT_REQUEST,
        event: null,
        rowIndex: this.rowIndex,
        rowPinned: this.rowPinned,
        column: column,
        colDef: column.getColDef(),
        data: this.data,
        node: this,
        oldValue: oldValue,
        newValue: newValue,
        value: newValue,
        source: eventSource
      });
      this.beans.eventService.dispatchEvent(event);
    }
  }, {
    key: "setGroupValue",
    value: function setGroupValue(colKey, newValue) {
      var column = this.beans.columnModel.getGridColumn(colKey);

      if (_missing(this.groupData)) {
        this.groupData = {};
      }

      var columnId = column.getColId();
      var oldValue = this.groupData[columnId];

      if (oldValue === newValue) {
        return;
      }

      this.groupData[columnId] = newValue;
      this.dispatchCellChangedEvent(column, newValue, oldValue);
    } // sets the data for an aggregation

  }, {
    key: "setAggData",
    value: function setAggData(newAggData) {
      var _this163 = this;

      var oldAggData = this.aggData;
      this.aggData = newAggData;

      if (this.eventService) {
        var eventFunc = function eventFunc(colId) {
          var value = _this163.aggData ? _this163.aggData[colId] : void 0;
          var oldValue = oldAggData ? oldAggData[colId] : void 0;

          if (value === oldValue) {
            return;
          }

          var column = _this163.beans.columnModel.lookupGridColumn(colId);

          if (!column) {
            return;
          }

          _this163.dispatchCellChangedEvent(column, value, oldValue);
        };

        for (var key in this.aggData) {
          eventFunc(key);
        }

        for (var _key4 in newAggData) {
          if (_key4 in this.aggData) {
            continue;
          }

          eventFunc(_key4);
        }
      }
    }
  }, {
    key: "updateHasChildren",
    value: function updateHasChildren() {
      var newValue = this.group && !this.footer || this.childrenAfterGroup && this.childrenAfterGroup.length > 0;
      var isSsrm = this.beans.gos.isRowModelType("serverSide");

      if (isSsrm) {
        var isTreeData = this.beans.gos.get("treeData");
        var isGroupFunc = this.beans.gos.get("isServerSideGroup");
        newValue = !this.stub && !this.footer && (isTreeData ? !!isGroupFunc && isGroupFunc(this.data) : !!this.group);
      }

      if (newValue !== this.__hasChildren) {
        this.__hasChildren = !!newValue;

        if (this.eventService) {
          this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_HAS_CHILDREN_CHANGED));
        }
      }
    }
  }, {
    key: "hasChildren",
    value: function hasChildren() {
      if (this.__hasChildren == null) {
        this.updateHasChildren();
      }

      return this.__hasChildren;
    }
  }, {
    key: "isEmptyRowGroupNode",
    value: function isEmptyRowGroupNode() {
      return this.group && _missingOrEmpty(this.childrenAfterGroup);
    }
  }, {
    key: "dispatchCellChangedEvent",
    value: function dispatchCellChangedEvent(column, newValue, oldValue) {
      var cellChangedEvent = {
        type: _RowNode.EVENT_CELL_CHANGED,
        node: this,
        column: column,
        newValue: newValue,
        oldValue: oldValue
      };
      this.dispatchLocalEvent(cellChangedEvent);
    }
    /**
     * The first time `quickFilter` runs, the grid creates a one-off string representation of the row.
     * This string is then used for the quick filter instead of hitting each column separately.
     * When you edit, using grid editing, this string gets cleared down.
     * However if you edit without using grid editing, you will need to clear this string down for the row to be updated with the new values.
     * Otherwise new values will not work with the `quickFilter`. */

  }, {
    key: "resetQuickFilterAggregateText",
    value: function resetQuickFilterAggregateText() {
      this.quickFilterAggregateText = null;
    }
    /** Returns:
    * - `true` if the node can be expanded, i.e it is a group or master row.
    * - `false` if the node cannot be expanded
    */

  }, {
    key: "isExpandable",
    value: function isExpandable() {
      if (this.footer) {
        return false;
      }

      if (this.beans.columnModel.isPivotMode()) {
        return this.hasChildren() && !this.leafGroup;
      }

      return this.hasChildren() || !!this.master;
    }
    /** Returns:
     * - `true` if node is selected,
     * - `false` if the node isn't selected
     * - `undefined` if it's partially selected (group where not all children are selected). */

  }, {
    key: "isSelected",
    value: function isSelected() {
      if (this.footer) {
        return this.sibling.isSelected();
      }

      return this.selected;
    }
    /** Perform a depth-first search of this node and its children. */

  }, {
    key: "depthFirstSearch",
    value: function depthFirstSearch(callback) {
      if (this.childrenAfterGroup) {
        this.childrenAfterGroup.forEach(function (child) {
          return child.depthFirstSearch(callback);
        });
      }

      callback(this);
    } // + selectionController.calculatedSelectedForAllGroupNodes()

  }, {
    key: "calculateSelectedFromChildren",
    value: function calculateSelectedFromChildren() {
      var _a;

      var atLeastOneSelected = false;
      var atLeastOneDeSelected = false;
      var atLeastOneMixed = false;

      if (!((_a = this.childrenAfterGroup) == null ? void 0 : _a.length)) {
        return this.selectable ? this.selected : null;
      }

      for (var i = 0; i < this.childrenAfterGroup.length; i++) {
        var child = this.childrenAfterGroup[i];
        var childState = child.isSelected();

        if (!child.selectable) {
          var selectable = child.calculateSelectedFromChildren();

          if (selectable === null) {
            continue;
          }

          childState = selectable;
        }

        switch (childState) {
          case true:
            atLeastOneSelected = true;
            break;

          case false:
            atLeastOneDeSelected = true;
            break;

          default:
            atLeastOneMixed = true;
            break;
        }
      }

      if (atLeastOneMixed || atLeastOneSelected && atLeastOneDeSelected) {
        return void 0;
      }

      if (atLeastOneSelected) {
        return true;
      }

      if (atLeastOneDeSelected) {
        return false;
      }

      if (!this.selectable) {
        return null;
      }

      return this.selected;
    }
  }, {
    key: "setSelectedInitialValue",
    value: function setSelectedInitialValue(selected) {
      this.selected = selected;
    }
  }, {
    key: "selectThisNode",
    value: function selectThisNode(newValue, e) {
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "api";
      var selectionNotAllowed = !this.selectable && newValue;
      var selectionNotChanged = this.selected === newValue;

      if (selectionNotAllowed || selectionNotChanged) {
        return false;
      }

      this.selected = newValue;

      if (this.eventService) {
        this.dispatchLocalEvent(this.createLocalRowEvent(_RowNode.EVENT_ROW_SELECTED));
        var sibling = this.sibling;

        if (sibling && sibling.footer) {
          sibling.dispatchLocalEvent(sibling.createLocalRowEvent(_RowNode.EVENT_ROW_SELECTED));
        }
      }

      var event = __spreadProps(__spreadValues({}, this.createGlobalRowEvent(_Events.EVENT_ROW_SELECTED)), {
        event: e || null,
        source: source
      });

      this.beans.eventService.dispatchEvent(event);
      return true;
    }
    /**
     * Select (or deselect) the node.
     * @param newValue -`true` for selection, `false` for deselection.
     * @param clearSelection - If selecting, then passing `true` will select the node exclusively (i.e. NOT do multi select). If doing deselection, `clearSelection` has no impact.
     * @param source - Source property that will appear in the `selectionChanged` event.
     */

  }, {
    key: "setSelected",
    value: function setSelected(newValue) {
      var clearSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "api";

      if (typeof source === "boolean") {
        console.warn("AG Grid: since version v30, rowNode.setSelected() property `suppressFinishActions` has been removed, please use `gridApi.setNodesSelected()` for bulk actions, and the event `source` property for ignoring events instead.");
        return;
      }

      this.setSelectedParams({
        newValue: newValue,
        clearSelection: clearSelection,
        rangeSelect: false,
        source: source
      });
    } // this is for internal use only. To make calling code more readable, this is the same method as setSelected except it takes names parameters

  }, {
    key: "setSelectedParams",
    value: function setSelectedParams(params) {
      if (this.rowPinned) {
        console.warn("AG Grid: cannot select pinned rows");
        return 0;
      }

      if (this.id === void 0) {
        console.warn("AG Grid: cannot select node until id for node is known");
        return 0;
      }

      return this.beans.selectionService.setNodesSelected(__spreadProps(__spreadValues({}, params), {
        nodes: [this.footer ? this.sibling : this]
      }));
    }
    /**
     * Returns:
     * - `true` if node is either pinned to the `top` or `bottom`
     * - `false` if the node isn't pinned
     */

  }, {
    key: "isRowPinned",
    value: function isRowPinned() {
      return this.rowPinned === "top" || this.rowPinned === "bottom";
    }
  }, {
    key: "isParentOfNode",
    value: function isParentOfNode(potentialParent) {
      var parentNode = this.parent;

      while (parentNode) {
        if (parentNode === potentialParent) {
          return true;
        }

        parentNode = parentNode.parent;
      }

      return false;
    }
    /** Add an event listener. */

  }, {
    key: "addEventListener",
    value: function addEventListener(eventType, userListener) {
      var _a, _b;

      if (!this.eventService) {
        this.eventService = new _EventService();
      }

      if (this.beans.frameworkOverrides.shouldWrapOutgoing && !this.frameworkEventListenerService) {
        this.eventService.setFrameworkOverrides(this.beans.frameworkOverrides);
        this.frameworkEventListenerService = new FrameworkEventListenerService(this.beans.frameworkOverrides);
      }

      var listener = (_b = (_a = this.frameworkEventListenerService) == null ? void 0 : _a.wrap(userListener)) != null ? _b : userListener;
      this.eventService.addEventListener(eventType, listener);
    }
    /** Remove event listener. */

  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventType, userListener) {
      var _a, _b;

      if (!this.eventService) {
        return;
      }

      var listener = (_b = (_a = this.frameworkEventListenerService) == null ? void 0 : _a.unwrap(userListener)) != null ? _b : userListener;
      this.eventService.removeEventListener(eventType, listener);

      if (this.eventService.noRegisteredListenersExist()) {
        this.eventService = null;
      }
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter() {
      this.dispatchLocalEvent(this.createLocalRowEvent(_RowNode.EVENT_MOUSE_ENTER));
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      this.dispatchLocalEvent(this.createLocalRowEvent(_RowNode.EVENT_MOUSE_LEAVE));
    }
  }, {
    key: "getFirstChildOfFirstChild",
    value: function getFirstChildOfFirstChild(rowGroupColumn) {
      var currentRowNode = this;
      var isCandidate = true;
      var foundFirstChildPath = false;
      var nodeToSwapIn = null;

      while (isCandidate && !foundFirstChildPath) {
        var parentRowNode = currentRowNode.parent;
        var firstChild = _exists(parentRowNode) && currentRowNode.firstChild;

        if (firstChild) {
          if (parentRowNode.rowGroupColumn === rowGroupColumn) {
            foundFirstChildPath = true;
            nodeToSwapIn = parentRowNode;
          }
        } else {
          isCandidate = false;
        }

        currentRowNode = parentRowNode;
      }

      return foundFirstChildPath ? nodeToSwapIn : null;
    }
    /**
     * Returns:
     * - `true` if the node is a full width cell
     * - `false` if the node is not a full width cell
     */

  }, {
    key: "isFullWidthCell",
    value: function isFullWidthCell() {
      if (this.detail) {
        return true;
      }

      var isFullWidthCellFunc = this.beans.gos.getCallback("isFullWidthRow");
      return isFullWidthCellFunc ? isFullWidthCellFunc({
        rowNode: this
      }) : false;
    }
    /**
     * Returns the route of the row node. If the Row Node is a group, it returns the route to that Row Node.
     * If the Row Node is not a group, it returns `undefined`.
     */

  }, {
    key: "getRoute",
    value: function getRoute() {
      if (this.key == null) {
        return;
      }

      var res = [];
      var pointer = this;

      while (pointer.key != null) {
        res.push(pointer.key);
        pointer = pointer.parent;
      }

      return res.reverse();
    }
  }, {
    key: "createFooter",
    value: function createFooter() {
      var _this164 = this;

      if (this.sibling) {
        return;
      }

      var ignoredProperties =
      /* @__PURE__ */
      new Set(["eventService", "__objectId", "sticky"]);
      var footerNode = new _RowNode(this.beans);
      Object.keys(this).forEach(function (key) {
        if (ignoredProperties.has(key)) {
          return;
        }

        footerNode[key] = _this164[key];
      });
      footerNode.footer = true;
      footerNode.setRowTop(null);
      footerNode.setRowIndex(null);
      footerNode.oldRowTop = null;
      footerNode.id = "rowGroupFooter_" + this.id;
      footerNode.sibling = this;
      this.sibling = footerNode;
    } // Only used by SSRM. In CSRM this is never used as footers should always be present for
    // the purpose of exporting collapsed groups. In SSRM it is not possible to export collapsed
    // groups anyway, so can destroy footers.

  }, {
    key: "destroyFooter",
    value: function destroyFooter() {
      if (!this.sibling) {
        return;
      }

      this.sibling.setRowTop(null);
      this.sibling.setRowIndex(null);
      this.sibling = void 0;
    }
  }]);

  return _RowNode;
}();

_RowNode.ID_PREFIX_ROW_GROUP = "row-group-";
_RowNode.ID_PREFIX_TOP_PINNED = "t-";
_RowNode.ID_PREFIX_BOTTOM_PINNED = "b-";
_RowNode.OBJECT_ID_SEQUENCE = 0;
_RowNode.EVENT_ROW_SELECTED = "rowSelected";
_RowNode.EVENT_DATA_CHANGED = "dataChanged";
_RowNode.EVENT_CELL_CHANGED = "cellChanged";
_RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED = "allChildrenCountChanged";
_RowNode.EVENT_MASTER_CHANGED = "masterChanged";
_RowNode.EVENT_GROUP_CHANGED = "groupChanged";
_RowNode.EVENT_MOUSE_ENTER = "mouseEnter";
_RowNode.EVENT_MOUSE_LEAVE = "mouseLeave";
_RowNode.EVENT_HEIGHT_CHANGED = "heightChanged";
_RowNode.EVENT_TOP_CHANGED = "topChanged";
_RowNode.EVENT_DISPLAYED_CHANGED = "displayedChanged";
_RowNode.EVENT_FIRST_CHILD_CHANGED = "firstChildChanged";
_RowNode.EVENT_LAST_CHILD_CHANGED = "lastChildChanged";
_RowNode.EVENT_CHILD_INDEX_CHANGED = "childIndexChanged";
_RowNode.EVENT_ROW_INDEX_CHANGED = "rowIndexChanged";
_RowNode.EVENT_EXPANDED_CHANGED = "expandedChanged";
_RowNode.EVENT_HAS_CHILDREN_CHANGED = "hasChildrenChanged";
_RowNode.EVENT_SELECTABLE_CHANGED = "selectableChanged";
_RowNode.EVENT_UI_LEVEL_CHANGED = "uiLevelChanged";
_RowNode.EVENT_HIGHLIGHT_CHANGED = "rowHighlightChanged";
_RowNode.EVENT_DRAGGING_CHANGED = "draggingChanged";
var _RowNode2 = _RowNode; // community-modules/core/src/rendering/checkboxSelectionComponent.ts

var _CheckboxSelectionComponent =
/*#__PURE__*/
function (_Component15) {
  "use strict";

  _inherits(_CheckboxSelectionComponent, _Component15);

  function _CheckboxSelectionComponent() {
    _classCallCheck(this, _CheckboxSelectionComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(_CheckboxSelectionComponent).call(this,
    /* html*/
    "\n            <div class=\"ag-selection-checkbox\" role=\"presentation\">\n                <ag-checkbox role=\"presentation\" ref=\"eCheckbox\"></ag-checkbox>\n            </div>"));
  }

  _createClass(_CheckboxSelectionComponent, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.eCheckbox.setPassive(true);
    }
  }, {
    key: "getCheckboxId",
    value: function getCheckboxId() {
      return this.eCheckbox.getInputElement().id;
    }
  }, {
    key: "onDataChanged",
    value: function onDataChanged() {
      this.onSelectionChanged();
    }
  }, {
    key: "onSelectableChanged",
    value: function onSelectableChanged() {
      this.showOrHideSelect();
    }
  }, {
    key: "onSelectionChanged",
    value: function onSelectionChanged() {
      var translate = this.localeService.getLocaleTextFunc();
      var state = this.rowNode.isSelected();

      var stateName = _getAriaCheckboxStateName(translate, state);

      var _ref28 = this.rowNode.selectable ? ["ariaRowToggleSelection", "Press Space to toggle row selection"] : ["ariaRowSelectionDisabled", "Row Selection is disabled for this row"],
          _ref29 = _slicedToArray(_ref28, 2),
          ariaKey = _ref29[0],
          ariaLabel = _ref29[1];

      var translatedLabel = translate(ariaKey, ariaLabel);
      this.eCheckbox.setValue(state, true);
      this.eCheckbox.setInputAriaLabel("".concat(translatedLabel, " (").concat(stateName, ")"));
    }
  }, {
    key: "onClicked",
    value: function onClicked(newValue, groupSelectsFiltered, event) {
      return this.rowNode.setSelectedParams({
        newValue: newValue,
        rangeSelect: event.shiftKey,
        groupSelectsFiltered: groupSelectsFiltered,
        event: event,
        source: "checkboxSelected"
      });
    }
  }, {
    key: "init",
    value: function init(params) {
      var _this165 = this;

      this.rowNode = params.rowNode;
      this.column = params.column;
      this.overrides = params.overrides;
      this.onSelectionChanged();
      this.addManagedListener(this.eCheckbox.getInputElement(), "dblclick", function (event) {
        _stopPropagationForAgGrid(event);
      });
      this.addManagedListener(this.eCheckbox.getInputElement(), "click", function (event) {
        _stopPropagationForAgGrid(event);

        var groupSelectsFiltered = _this165.gos.get("groupSelectsFiltered");

        var isSelected = _this165.eCheckbox.getValue();

        if (_this165.shouldHandleIndeterminateState(isSelected, groupSelectsFiltered)) {
          var result = _this165.onClicked(true, groupSelectsFiltered, event || {});

          if (result === 0) {
            _this165.onClicked(false, groupSelectsFiltered, event);
          }
        } else if (isSelected) {
          _this165.onClicked(false, groupSelectsFiltered, event);
        } else {
          _this165.onClicked(true, groupSelectsFiltered, event || {});
        }
      });
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_ROW_SELECTED, this.onSelectionChanged.bind(this));
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_DATA_CHANGED, this.onDataChanged.bind(this));
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_SELECTABLE_CHANGED, this.onSelectableChanged.bind(this));
      var isRowSelectableFunc = this.gos.get("isRowSelectable");
      var checkboxVisibleIsDynamic = isRowSelectableFunc || typeof this.getIsVisible() === "function";

      if (checkboxVisibleIsDynamic) {
        var showOrHideSelectListener = this.showOrHideSelect.bind(this);
        this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_CHANGED, showOrHideSelectListener);
        this.addManagedListener(this.rowNode, _RowNode2.EVENT_DATA_CHANGED, showOrHideSelectListener);
        this.addManagedListener(this.rowNode, _RowNode2.EVENT_CELL_CHANGED, showOrHideSelectListener);
        this.showOrHideSelect();
      }

      this.eCheckbox.getInputElement().setAttribute("tabindex", "-1");
    }
  }, {
    key: "shouldHandleIndeterminateState",
    value: function shouldHandleIndeterminateState(isSelected, groupSelectsFiltered) {
      return groupSelectsFiltered && (this.eCheckbox.getPreviousValue() === void 0 || isSelected === void 0) && this.gos.isRowModelType("clientSide");
    }
  }, {
    key: "showOrHideSelect",
    value: function showOrHideSelect() {
      var _a, _b, _c;

      var selectable = this.rowNode.selectable;
      var isVisible2 = this.getIsVisible();

      if (selectable) {
        if (typeof isVisible2 === "function") {
          var extraParams = (_a = this.overrides) == null ? void 0 : _a.callbackParams;

          if (!this.column) {
            selectable = isVisible2(__spreadProps(__spreadValues({}, extraParams), {
              node: this.rowNode,
              data: this.rowNode.data
            }));
          } else {
            var params = this.column.createColumnFunctionCallbackParams(this.rowNode);
            selectable = isVisible2(__spreadValues(__spreadValues({}, extraParams), params));
          }
        } else {
          selectable = isVisible2 != null ? isVisible2 : false;
        }
      }

      var disableInsteadOfHide = (_b = this.column) == null ? void 0 : _b.getColDef().showDisabledCheckboxes;

      if (disableInsteadOfHide) {
        this.eCheckbox.setDisabled(!selectable);
        this.setVisible(true);
        this.setDisplayed(true);
        return;
      }

      if ((_c = this.overrides) == null ? void 0 : _c.removeHidden) {
        this.setDisplayed(selectable);
        return;
      }

      this.setVisible(selectable);
    }
  }, {
    key: "getIsVisible",
    value: function getIsVisible() {
      var _a, _b;

      if (this.overrides) {
        return this.overrides.isVisible;
      }

      return (_b = (_a = this.column) == null ? void 0 : _a.getColDef()) == null ? void 0 : _b.checkboxSelection;
    }
  }]);

  return _CheckboxSelectionComponent;
}(_Component2);

__decorateClass([_RefSelector("eCheckbox")], _CheckboxSelectionComponent.prototype, "eCheckbox", 2);

__decorateClass([_PostConstruct], _CheckboxSelectionComponent.prototype, "postConstruct", 1); // community-modules/core/src/constants/direction.ts


var _VerticalDirection =
/* @__PURE__ */
function (VerticalDirection2) {
  VerticalDirection2[VerticalDirection2["Up"] = 0] = "Up";
  VerticalDirection2[VerticalDirection2["Down"] = 1] = "Down";
  return VerticalDirection2;
}(_VerticalDirection || {});

var _HorizontalDirection =
/* @__PURE__ */
function (HorizontalDirection2) {
  HorizontalDirection2[HorizontalDirection2["Left"] = 0] = "Left";
  HorizontalDirection2[HorizontalDirection2["Right"] = 1] = "Right";
  return HorizontalDirection2;
}(_HorizontalDirection || {}); // community-modules/core/src/dragAndDrop/dragAndDropService.ts


var _DragSourceType =
/* @__PURE__ */
function (DragSourceType4) {
  DragSourceType4[DragSourceType4["ToolPanel"] = 0] = "ToolPanel";
  DragSourceType4[DragSourceType4["HeaderCell"] = 1] = "HeaderCell";
  DragSourceType4[DragSourceType4["RowDrag"] = 2] = "RowDrag";
  DragSourceType4[DragSourceType4["ChartPanel"] = 3] = "ChartPanel";
  DragSourceType4[DragSourceType4["AdvancedFilterBuilder"] = 4] = "AdvancedFilterBuilder";
  return DragSourceType4;
}(_DragSourceType || {});

var _DragAndDropService2 =
/*#__PURE__*/
function (_BeanStub15) {
  "use strict";

  _inherits(_DragAndDropService, _BeanStub15);

  function _DragAndDropService() {
    var _this166;

    _classCallCheck(this, _DragAndDropService);

    _this166 = _possibleConstructorReturn(this, _getPrototypeOf(_DragAndDropService).apply(this, arguments));
    _this166.dragSourceAndParamsList = [];
    _this166.dropTargets = [];
    return _this166;
  }

  _createClass(_DragAndDropService, [{
    key: "init",
    value: function init() {
      this.ePinnedIcon = _createIcon("columnMovePin", this.gos, null);
      this.eHideIcon = _createIcon("columnMoveHide", this.gos, null);
      this.eMoveIcon = _createIcon("columnMoveMove", this.gos, null);
      this.eLeftIcon = _createIcon("columnMoveLeft", this.gos, null);
      this.eRightIcon = _createIcon("columnMoveRight", this.gos, null);
      this.eGroupIcon = _createIcon("columnMoveGroup", this.gos, null);
      this.eAggregateIcon = _createIcon("columnMoveValue", this.gos, null);
      this.ePivotIcon = _createIcon("columnMovePivot", this.gos, null);
      this.eDropNotAllowedIcon = _createIcon("dropNotAllowed", this.gos, null);
    }
  }, {
    key: "addDragSource",
    value: function addDragSource(dragSource) {
      var allowTouch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var params = {
        eElement: dragSource.eElement,
        dragStartPixels: dragSource.dragStartPixels,
        onDragStart: this.onDragStart.bind(this, dragSource),
        onDragStop: this.onDragStop.bind(this),
        onDragging: this.onDragging.bind(this),
        includeTouch: allowTouch
      };
      this.dragSourceAndParamsList.push({
        params: params,
        dragSource: dragSource
      });
      this.dragService.addDragSource(params);
    }
  }, {
    key: "removeDragSource",
    value: function removeDragSource(dragSource) {
      var sourceAndParams = this.dragSourceAndParamsList.find(function (item) {
        return item.dragSource === dragSource;
      });

      if (sourceAndParams) {
        this.dragService.removeDragSource(sourceAndParams.params);

        _removeFromArray(this.dragSourceAndParamsList, sourceAndParams);
      }
    }
  }, {
    key: "clearDragSourceParamsList",
    value: function clearDragSourceParamsList() {
      var _this167 = this;

      this.dragSourceAndParamsList.forEach(function (sourceAndParams) {
        return _this167.dragService.removeDragSource(sourceAndParams.params);
      });
      this.dragSourceAndParamsList.length = 0;
      this.dropTargets.length = 0;
    }
  }, {
    key: "nudge",
    value: function nudge() {
      if (this.dragging) {
        this.onDragging(this.eventLastTime, true);
      }
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(dragSource, mouseEvent) {
      this.dragging = true;
      this.dragSource = dragSource;
      this.eventLastTime = mouseEvent;
      this.dragItem = this.dragSource.getDragItem();

      if (this.dragSource.onDragStarted) {
        this.dragSource.onDragStarted();
      }

      this.createGhost();
    }
  }, {
    key: "onDragStop",
    value: function onDragStop(mouseEvent) {
      this.eventLastTime = null;
      this.dragging = false;

      if (this.dragSource.onDragStopped) {
        this.dragSource.onDragStopped();
      }

      if (this.lastDropTarget && this.lastDropTarget.onDragStop) {
        var draggingEvent = this.createDropTargetEvent(this.lastDropTarget, mouseEvent, null, null, false);
        this.lastDropTarget.onDragStop(draggingEvent);
      }

      this.lastDropTarget = null;
      this.dragItem = null;
      this.removeGhost();
    }
  }, {
    key: "onDragging",
    value: function onDragging(mouseEvent, fromNudge) {
      var _this168 = this;

      var _a, _b, _c, _d;

      var hDirection = this.getHorizontalDirection(mouseEvent);
      var vDirection = this.getVerticalDirection(mouseEvent);
      this.eventLastTime = mouseEvent;
      this.positionGhost(mouseEvent);
      var validDropTargets = this.dropTargets.filter(function (target) {
        return _this168.isMouseOnDropTarget(mouseEvent, target);
      });
      var dropTarget = this.findCurrentDropTarget(mouseEvent, validDropTargets);

      if (dropTarget !== this.lastDropTarget) {
        this.leaveLastTargetIfExists(mouseEvent, hDirection, vDirection, fromNudge);

        if (this.lastDropTarget !== null && dropTarget === null) {
          (_b = (_a = this.dragSource).onGridExit) == null ? void 0 : _b.call(_a, this.dragItem);
        }

        if (this.lastDropTarget === null && dropTarget !== null) {
          (_d = (_c = this.dragSource).onGridEnter) == null ? void 0 : _d.call(_c, this.dragItem);
        }

        this.enterDragTargetIfExists(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
        this.lastDropTarget = dropTarget;
      } else if (dropTarget && dropTarget.onDragging) {
        var draggingEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
        dropTarget.onDragging(draggingEvent);
      }
    }
  }, {
    key: "getAllContainersFromDropTarget",
    value: function getAllContainersFromDropTarget(dropTarget) {
      var secondaryContainers = dropTarget.getSecondaryContainers ? dropTarget.getSecondaryContainers() : null;
      var containers = [[dropTarget.getContainer()]];
      return secondaryContainers ? containers.concat(secondaryContainers) : containers;
    }
  }, {
    key: "allContainersIntersect",
    value: function allContainersIntersect(mouseEvent, containers) {
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = containers[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var container = _step8.value;
          var rect = container.getBoundingClientRect();

          if (rect.width === 0 || rect.height === 0) {
            return false;
          }

          var horizontalFit = mouseEvent.clientX >= rect.left && mouseEvent.clientX < rect.right;
          var verticalFit = mouseEvent.clientY >= rect.top && mouseEvent.clientY < rect.bottom;

          if (!horizontalFit || !verticalFit) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return true;
    } // checks if the mouse is on the drop target. it checks eContainer and eSecondaryContainers

  }, {
    key: "isMouseOnDropTarget",
    value: function isMouseOnDropTarget(mouseEvent, dropTarget) {
      var allContainersFromDropTarget = this.getAllContainersFromDropTarget(dropTarget);
      var mouseOverTarget = false;
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = allContainersFromDropTarget[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var currentContainers = _step9.value;

          if (this.allContainersIntersect(mouseEvent, currentContainers)) {
            mouseOverTarget = true;
            break;
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      if (dropTarget.targetContainsSource && !dropTarget.getContainer().contains(this.dragSource.eElement)) {
        return false;
      }

      return mouseOverTarget && dropTarget.isInterestedIn(this.dragSource.type, this.dragSource.eElement);
    }
  }, {
    key: "findCurrentDropTarget",
    value: function findCurrentDropTarget(mouseEvent, validDropTargets) {
      var len = validDropTargets.length;

      if (len === 0) {
        return null;
      }

      if (len === 1) {
        return validDropTargets[0];
      }

      var rootNode = this.gos.getRootNode();
      var elementStack = rootNode.elementsFromPoint(mouseEvent.clientX, mouseEvent.clientY);
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = elementStack[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var el = _step10.value;
          var _iteratorNormalCompletion11 = true;
          var _didIteratorError11 = false;
          var _iteratorError11 = undefined;

          try {
            for (var _iterator11 = validDropTargets[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
              var dropTarget = _step11.value;

              var containers = _flatten(this.getAllContainersFromDropTarget(dropTarget));

              if (containers.indexOf(el) !== -1) {
                return dropTarget;
              }
            }
          } catch (err) {
            _didIteratorError11 = true;
            _iteratorError11 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
                _iterator11.return();
              }
            } finally {
              if (_didIteratorError11) {
                throw _iteratorError11;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      return null;
    }
  }, {
    key: "enterDragTargetIfExists",
    value: function enterDragTargetIfExists(dropTarget, mouseEvent, hDirection, vDirection, fromNudge) {
      if (!dropTarget) {
        return;
      }

      if (dropTarget.onDragEnter) {
        var dragEnterEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
        dropTarget.onDragEnter(dragEnterEvent);
      }

      this.setGhostIcon(dropTarget.getIconName ? dropTarget.getIconName() : null);
    }
  }, {
    key: "leaveLastTargetIfExists",
    value: function leaveLastTargetIfExists(mouseEvent, hDirection, vDirection, fromNudge) {
      if (!this.lastDropTarget) {
        return;
      }

      if (this.lastDropTarget.onDragLeave) {
        var dragLeaveEvent = this.createDropTargetEvent(this.lastDropTarget, mouseEvent, hDirection, vDirection, fromNudge);
        this.lastDropTarget.onDragLeave(dragLeaveEvent);
      }

      this.setGhostIcon(null);
    }
  }, {
    key: "addDropTarget",
    value: function addDropTarget(dropTarget) {
      this.dropTargets.push(dropTarget);
    }
  }, {
    key: "removeDropTarget",
    value: function removeDropTarget(dropTarget) {
      this.dropTargets = this.dropTargets.filter(function (target) {
        return target.getContainer() !== dropTarget.getContainer();
      });
    }
  }, {
    key: "hasExternalDropZones",
    value: function hasExternalDropZones() {
      return this.dropTargets.some(function (zones) {
        return zones.external;
      });
    }
  }, {
    key: "findExternalZone",
    value: function findExternalZone(params) {
      var externalTargets = this.dropTargets.filter(function (target) {
        return target.external;
      });
      return externalTargets.find(function (zone) {
        return zone.getContainer() === params.getContainer();
      }) || null;
    }
  }, {
    key: "getHorizontalDirection",
    value: function getHorizontalDirection(event) {
      var clientX = this.eventLastTime && this.eventLastTime.clientX;
      var eClientX = event.clientX;

      if (clientX === eClientX) {
        return null;
      }

      return clientX > eClientX ? 0
      /* Left */
      : 1
      /* Right */
      ;
    }
  }, {
    key: "getVerticalDirection",
    value: function getVerticalDirection(event) {
      var clientY = this.eventLastTime && this.eventLastTime.clientY;
      var eClientY = event.clientY;

      if (clientY === eClientY) {
        return null;
      }

      return clientY > eClientY ? 0
      /* Up */
      : 1
      /* Down */
      ;
    }
  }, {
    key: "createDropTargetEvent",
    value: function createDropTargetEvent(dropTarget, event, hDirection, vDirection, fromNudge) {
      var dropZoneTarget = dropTarget.getContainer();
      var rect = dropZoneTarget.getBoundingClientRect();
      var api = this.gridApi,
          columnApi = this.columnApi,
          dragItem = this.dragItem,
          dragSource = this.dragSource;
      var x = event.clientX - rect.left;
      var y = event.clientY - rect.top;
      return {
        event: event,
        x: x,
        y: y,
        vDirection: vDirection,
        hDirection: hDirection,
        dragSource: dragSource,
        fromNudge: fromNudge,
        dragItem: dragItem,
        api: api,
        columnApi: columnApi,
        dropZoneTarget: dropZoneTarget
      };
    }
  }, {
    key: "positionGhost",
    value: function positionGhost(event) {
      var ghost = this.eGhost;

      if (!ghost) {
        return;
      }

      var ghostRect = ghost.getBoundingClientRect();
      var ghostHeight = ghostRect.height;
      var browserWidth = _getBodyWidth() - 2;
      var browserHeight = _getBodyHeight() - 2;

      var offsetParentSize = _getElementRectWithOffset(ghost.offsetParent);

      var clientY = event.clientY,
          clientX = event.clientX;
      var top = clientY - offsetParentSize.top - ghostHeight / 2;
      var left = clientX - offsetParentSize.left - 10;
      var eDocument = this.gos.getDocument();
      var win = eDocument.defaultView || window;
      var windowScrollY = win.pageYOffset || eDocument.documentElement.scrollTop;
      var windowScrollX = win.pageXOffset || eDocument.documentElement.scrollLeft;

      if (browserWidth > 0 && left + ghost.clientWidth > browserWidth + windowScrollX) {
        left = browserWidth + windowScrollX - ghost.clientWidth;
      }

      if (left < 0) {
        left = 0;
      }

      if (browserHeight > 0 && top + ghost.clientHeight > browserHeight + windowScrollY) {
        top = browserHeight + windowScrollY - ghost.clientHeight;
      }

      if (top < 0) {
        top = 0;
      }

      ghost.style.left = "".concat(left, "px");
      ghost.style.top = "".concat(top, "px");
    }
  }, {
    key: "removeGhost",
    value: function removeGhost() {
      if (this.eGhost && this.eGhostParent) {
        this.eGhostParent.removeChild(this.eGhost);
      }

      this.eGhost = null;
    }
  }, {
    key: "createGhost",
    value: function createGhost() {
      this.eGhost = _loadTemplate(_DragAndDropService2.GHOST_TEMPLATE);
      this.mouseEventService.stampTopLevelGridCompWithGridInstance(this.eGhost);

      var _this$environment$get = this.environment.getTheme(),
          theme = _this$environment$get.theme;

      if (theme) {
        this.eGhost.classList.add(theme);
      }

      this.eGhostIcon = this.eGhost.querySelector(".ag-dnd-ghost-icon");
      this.setGhostIcon(null);
      var eText = this.eGhost.querySelector(".ag-dnd-ghost-label");
      var dragItemName = this.dragSource.dragItemName;

      if (_isFunction(dragItemName)) {
        dragItemName = dragItemName();
      }

      eText.innerHTML = _escapeString(dragItemName) || "";
      this.eGhost.style.height = "25px";
      this.eGhost.style.top = "20px";
      this.eGhost.style.left = "20px";
      var eDocument = this.gos.getDocument();
      var rootNode = null;
      var targetEl = null;

      try {
        rootNode = eDocument.fullscreenElement;
      } catch (e) {} finally {
        if (!rootNode) {
          rootNode = this.gos.getRootNode();
        }

        var body = rootNode.querySelector("body");

        if (body) {
          targetEl = body;
        } else if (rootNode instanceof ShadowRoot) {
          targetEl = rootNode;
        } else if (rootNode instanceof Document) {
          targetEl = rootNode == null ? void 0 : rootNode.documentElement;
        } else {
          targetEl = rootNode;
        }
      }

      this.eGhostParent = targetEl;

      if (!this.eGhostParent) {
        console.warn("AG Grid: could not find document body, it is needed for dragging columns");
      } else {
        this.eGhostParent.appendChild(this.eGhost);
      }
    }
  }, {
    key: "setGhostIcon",
    value: function setGhostIcon(iconName) {
      var shake = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      _clearElement(this.eGhostIcon);

      var eIcon = null;

      if (!iconName) {
        iconName = this.dragSource.getDefaultIconName ? this.dragSource.getDefaultIconName() : _DragAndDropService2.ICON_NOT_ALLOWED;
      }

      switch (iconName) {
        case _DragAndDropService2.ICON_PINNED:
          eIcon = this.ePinnedIcon;
          break;

        case _DragAndDropService2.ICON_MOVE:
          eIcon = this.eMoveIcon;
          break;

        case _DragAndDropService2.ICON_LEFT:
          eIcon = this.eLeftIcon;
          break;

        case _DragAndDropService2.ICON_RIGHT:
          eIcon = this.eRightIcon;
          break;

        case _DragAndDropService2.ICON_GROUP:
          eIcon = this.eGroupIcon;
          break;

        case _DragAndDropService2.ICON_AGGREGATE:
          eIcon = this.eAggregateIcon;
          break;

        case _DragAndDropService2.ICON_PIVOT:
          eIcon = this.ePivotIcon;
          break;

        case _DragAndDropService2.ICON_NOT_ALLOWED:
          eIcon = this.eDropNotAllowedIcon;
          break;

        case _DragAndDropService2.ICON_HIDE:
          eIcon = this.eHideIcon;
          break;
      }

      this.eGhostIcon.classList.toggle("ag-shake-left-to-right", shake);

      if (eIcon === this.eHideIcon && this.gos.get("suppressDragLeaveHidesColumns")) {
        return;
      }

      if (eIcon) {
        this.eGhostIcon.appendChild(eIcon);
      }
    }
  }]);

  return _DragAndDropService;
}(_BeanStub2);

_DragAndDropService2.ICON_PINNED = "pinned";
_DragAndDropService2.ICON_MOVE = "move";
_DragAndDropService2.ICON_LEFT = "left";
_DragAndDropService2.ICON_RIGHT = "right";
_DragAndDropService2.ICON_GROUP = "group";
_DragAndDropService2.ICON_AGGREGATE = "aggregate";
_DragAndDropService2.ICON_PIVOT = "pivot";
_DragAndDropService2.ICON_NOT_ALLOWED = "notAllowed";
_DragAndDropService2.ICON_HIDE = "hide";
_DragAndDropService2.GHOST_TEMPLATE =
/* html */
"<div class=\"ag-dnd-ghost ag-unselectable\">\n            <span class=\"ag-dnd-ghost-icon ag-shake-left-to-right\"></span>\n            <div class=\"ag-dnd-ghost-label\"></div>\n        </div>";

__decorateClass([_Autowired("dragService")], _DragAndDropService2.prototype, "dragService", 2);

__decorateClass([_Autowired("mouseEventService")], _DragAndDropService2.prototype, "mouseEventService", 2);

__decorateClass([_Autowired("columnApi")], _DragAndDropService2.prototype, "columnApi", 2);

__decorateClass([_Autowired("gridApi")], _DragAndDropService2.prototype, "gridApi", 2);

__decorateClass([_PostConstruct], _DragAndDropService2.prototype, "init", 1);

__decorateClass([_PreDestroy], _DragAndDropService2.prototype, "clearDragSourceParamsList", 1);

_DragAndDropService2 = __decorateClass([_Bean("dragAndDropService")], _DragAndDropService2); // community-modules/core/src/rendering/row/rowDragComp.ts

var RowDragComp =
/*#__PURE__*/
function (_Component16) {
  "use strict";

  _inherits(RowDragComp, _Component16);

  function RowDragComp(cellValueFn, rowNode, column, customGui, dragStartPixels, suppressVisibilityChange) {
    var _this169;

    _classCallCheck(this, RowDragComp);

    _this169 = _possibleConstructorReturn(this, _getPrototypeOf(RowDragComp).call(this));
    _this169.cellValueFn = cellValueFn;
    _this169.rowNode = rowNode;
    _this169.column = column;
    _this169.customGui = customGui;
    _this169.dragStartPixels = dragStartPixels;
    _this169.suppressVisibilityChange = suppressVisibilityChange;
    _this169.dragSource = null;
    return _this169;
  }

  _createClass(RowDragComp, [{
    key: "isCustomGui",
    value: function isCustomGui() {
      return this.customGui != null;
    }
  }, {
    key: "postConstruct",
    value: function postConstruct() {
      if (!this.customGui) {
        this.setTemplate(
        /* html */
        "<div class=\"ag-drag-handle ag-row-drag\" aria-hidden=\"true\"></div>");
        this.getGui().appendChild(_createIconNoSpan("rowDrag", this.gos, null));
        this.addDragSource();
      } else {
        this.setDragElement(this.customGui, this.dragStartPixels);
      }

      this.checkCompatibility();

      if (!this.suppressVisibilityChange) {
        var strategy = this.gos.get("rowDragManaged") ? new ManagedVisibilityStrategy(this, this.beans, this.rowNode, this.column) : new NonManagedVisibilityStrategy(this, this.beans, this.rowNode, this.column);
        this.createManagedBean(strategy, this.beans.context);
      }
    }
  }, {
    key: "setDragElement",
    value: function setDragElement(dragElement, dragStartPixels) {
      this.setTemplateFromElement(dragElement);
      this.addDragSource(dragStartPixels);
    }
  }, {
    key: "getSelectedNodes",
    value: function getSelectedNodes() {
      var isRowDragMultiRow = this.gos.get("rowDragMultiRow");

      if (!isRowDragMultiRow) {
        return [this.rowNode];
      }

      var selection = this.beans.selectionService.getSelectedNodes();
      return selection.indexOf(this.rowNode) !== -1 ? selection : [this.rowNode];
    } // returns true if all compatibility items work out

  }, {
    key: "checkCompatibility",
    value: function checkCompatibility() {
      var managed = this.gos.get("rowDragManaged");
      var treeData = this.gos.get("treeData");

      if (treeData && managed) {
        _warnOnce("If using row drag with tree data, you cannot have rowDragManaged=true");
      }
    }
  }, {
    key: "getDragItem",
    value: function getDragItem() {
      return {
        rowNode: this.rowNode,
        rowNodes: this.getSelectedNodes(),
        columns: this.column ? [this.column] : void 0,
        defaultTextValue: this.cellValueFn()
      };
    }
  }, {
    key: "getRowDragText",
    value: function getRowDragText(column) {
      if (column) {
        var colDef = column.getColDef();

        if (colDef.rowDragText) {
          return colDef.rowDragText;
        }
      }

      return this.gos.get("rowDragText");
    }
  }, {
    key: "addDragSource",
    value: function addDragSource() {
      var _this170 = this;

      var dragStartPixels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;

      if (this.dragSource) {
        this.removeDragSource();
      }

      var translate = this.localeService.getLocaleTextFunc();
      this.dragSource = {
        type: 2
        /* RowDrag */
        ,
        eElement: this.getGui(),
        dragItemName: function dragItemName() {
          var _a;

          var dragItem = _this170.getDragItem();

          var dragItemCount = ((_a = dragItem.rowNodes) == null ? void 0 : _a.length) || 1;

          var rowDragText = _this170.getRowDragText(_this170.column);

          if (rowDragText) {
            return rowDragText(dragItem, dragItemCount);
          }

          return dragItemCount === 1 ? _this170.cellValueFn() : "".concat(dragItemCount, " ").concat(translate("rowDragRows", "rows"));
        },
        getDragItem: function getDragItem() {
          return _this170.getDragItem();
        },
        dragStartPixels: dragStartPixels,
        dragSourceDomDataKey: this.gos.getDomDataKey()
      };
      this.beans.dragAndDropService.addDragSource(this.dragSource, true);
    }
  }, {
    key: "removeDragSource",
    value: function removeDragSource() {
      if (this.dragSource) {
        this.beans.dragAndDropService.removeDragSource(this.dragSource);
      }

      this.dragSource = null;
    }
  }]);

  return RowDragComp;
}(_Component2);

__decorateClass([_Autowired("beans")], RowDragComp.prototype, "beans", 2);

__decorateClass([_PostConstruct], RowDragComp.prototype, "postConstruct", 1);

__decorateClass([_PreDestroy], RowDragComp.prototype, "removeDragSource", 1);

var VisibilityStrategy =
/*#__PURE__*/
function (_BeanStub16) {
  "use strict";

  _inherits(VisibilityStrategy, _BeanStub16);

  function VisibilityStrategy(parent, rowNode, column) {
    var _this171;

    _classCallCheck(this, VisibilityStrategy);

    _this171 = _possibleConstructorReturn(this, _getPrototypeOf(VisibilityStrategy).call(this));
    _this171.parent = parent;
    _this171.rowNode = rowNode;
    _this171.column = column;
    return _this171;
  }

  _createClass(VisibilityStrategy, [{
    key: "setDisplayedOrVisible",
    value: function setDisplayedOrVisible(neverDisplayed) {
      var displayedOptions = {
        skipAriaHidden: true
      };

      if (neverDisplayed) {
        this.parent.setDisplayed(false, displayedOptions);
      } else {
        var shown = true;
        var isShownSometimes = false;

        if (this.column) {
          shown = this.column.isRowDrag(this.rowNode) || this.parent.isCustomGui();
          isShownSometimes = _isFunction(this.column.getColDef().rowDrag);
        }

        if (isShownSometimes) {
          this.parent.setDisplayed(true, displayedOptions);
          this.parent.setVisible(shown, displayedOptions);
        } else {
          this.parent.setDisplayed(shown, displayedOptions);
          this.parent.setVisible(true, displayedOptions);
        }
      }
    }
  }]);

  return VisibilityStrategy;
}(_BeanStub2);

var NonManagedVisibilityStrategy =
/*#__PURE__*/
function (_VisibilityStrategy) {
  "use strict";

  _inherits(NonManagedVisibilityStrategy, _VisibilityStrategy);

  function NonManagedVisibilityStrategy(parent, beans, rowNode, column) {
    var _this172;

    _classCallCheck(this, NonManagedVisibilityStrategy);

    _this172 = _possibleConstructorReturn(this, _getPrototypeOf(NonManagedVisibilityStrategy).call(this, parent, rowNode, column));
    _this172.beans = beans;
    return _this172;
  }

  _createClass(NonManagedVisibilityStrategy, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this));
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this));
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this));
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this));
      this.addManagedListener(this.beans.eventService, _Events.EVENT_NEW_COLUMNS_LOADED, this.workOutVisibility.bind(this));
      this.workOutVisibility();
    }
  }, {
    key: "onSuppressRowDrag",
    value: function onSuppressRowDrag() {
      this.workOutVisibility();
    }
  }, {
    key: "workOutVisibility",
    value: function workOutVisibility() {
      var neverDisplayed = this.gos.get("suppressRowDrag");
      this.setDisplayedOrVisible(neverDisplayed);
    }
  }]);

  return NonManagedVisibilityStrategy;
}(VisibilityStrategy);

__decorateClass([_PostConstruct], NonManagedVisibilityStrategy.prototype, "postConstruct", 1);

var ManagedVisibilityStrategy =
/*#__PURE__*/
function (_VisibilityStrategy2) {
  "use strict";

  _inherits(ManagedVisibilityStrategy, _VisibilityStrategy2);

  function ManagedVisibilityStrategy(parent, beans, rowNode, column) {
    var _this173;

    _classCallCheck(this, ManagedVisibilityStrategy);

    _this173 = _possibleConstructorReturn(this, _getPrototypeOf(ManagedVisibilityStrategy).call(this, parent, rowNode, column));
    _this173.beans = beans;
    return _this173;
  }

  _createClass(ManagedVisibilityStrategy, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.addManagedListener(this.beans.eventService, _Events.EVENT_SORT_CHANGED, this.workOutVisibility.bind(this));
      this.addManagedListener(this.beans.eventService, _Events.EVENT_FILTER_CHANGED, this.workOutVisibility.bind(this));
      this.addManagedListener(this.beans.eventService, _Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.workOutVisibility.bind(this));
      this.addManagedListener(this.beans.eventService, _Events.EVENT_NEW_COLUMNS_LOADED, this.workOutVisibility.bind(this));
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this));
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this));
      this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this));
      this.workOutVisibility();
    }
  }, {
    key: "onSuppressRowDrag",
    value: function onSuppressRowDrag() {
      this.workOutVisibility();
    }
  }, {
    key: "workOutVisibility",
    value: function workOutVisibility() {
      var gridBodyCon = this.beans.ctrlsService.getGridBodyCtrl();
      var rowDragFeature = gridBodyCon.getRowDragFeature();
      var shouldPreventRowMove = rowDragFeature && rowDragFeature.shouldPreventRowMove();
      var suppressRowDrag = this.gos.get("suppressRowDrag");
      var hasExternalDropZones = this.beans.dragAndDropService.hasExternalDropZones();
      var neverDisplayed = shouldPreventRowMove && !hasExternalDropZones || suppressRowDrag;
      this.setDisplayedOrVisible(neverDisplayed);
    }
  }]);

  return ManagedVisibilityStrategy;
}(VisibilityStrategy);

__decorateClass([_PostConstruct], ManagedVisibilityStrategy.prototype, "postConstruct", 1); // community-modules/core/src/rendering/cellRenderers/groupCellRendererCtrl.ts


var _GroupCellRendererCtrl =
/*#__PURE__*/
function (_BeanStub17) {
  "use strict";

  _inherits(_GroupCellRendererCtrl, _BeanStub17);

  function _GroupCellRendererCtrl() {
    _classCallCheck(this, _GroupCellRendererCtrl);

    return _possibleConstructorReturn(this, _getPrototypeOf(_GroupCellRendererCtrl).apply(this, arguments));
  }

  _createClass(_GroupCellRendererCtrl, [{
    key: "init",
    value: function init(comp, eGui, eCheckbox, eExpanded, eContracted, compClass, params) {
      var _a, _b, _c, _d;

      this.params = params;
      this.eGui = eGui;
      this.eCheckbox = eCheckbox;
      this.eExpanded = eExpanded;
      this.eContracted = eContracted;
      this.comp = comp;
      this.compClass = compClass;
      var node = params.node,
          value = params.value,
          colDef = params.colDef;
      var topLevelFooter = this.isTopLevelFooter();

      if (!topLevelFooter) {
        var embeddedRowMismatch = this.isEmbeddedRowMismatch();

        if (embeddedRowMismatch) {
          return;
        }

        if (node.footer && this.gos.get("groupHideOpenParents")) {
          var showRowGroup = colDef && colDef.showRowGroup;
          var rowGroupColumnId = node.rowGroupColumn && node.rowGroupColumn.getColId();

          if (showRowGroup !== rowGroupColumnId) {
            return;
          }
        }
      }

      this.setupShowingValueForOpenedParent();
      this.findDisplayedGroupNode();

      if (!topLevelFooter) {
        var showingFooterTotal = params.node.footer && params.node.rowGroupIndex === this.columnModel.getRowGroupColumns().findIndex(function (c) {
          var _a2;

          return c.getColId() === ((_a2 = params.colDef) == null ? void 0 : _a2.showRowGroup);
        });
        var isAlwaysShowing = this.gos.get("groupDisplayType") != "multipleColumns" || this.gos.get("treeData");
        var showOpenGroupValue = isAlwaysShowing || this.gos.get("showOpenedGroup") && !params.node.footer && (!params.node.group || params.node.rowGroupIndex != null && params.node.rowGroupIndex > this.columnModel.getRowGroupColumns().findIndex(function (c) {
          var _a2;

          return c.getColId() === ((_a2 = params.colDef) == null ? void 0 : _a2.showRowGroup);
        }));
        var leafWithValues = !node.group && (((_a = this.params.colDef) == null ? void 0 : _a.field) || ((_b = this.params.colDef) == null ? void 0 : _b.valueGetter));
        var isExpandable = this.isExpandable();
        var showPivotModeLeafValue = this.columnModel.isPivotMode() && node.leafGroup && ((_c = node.rowGroupColumn) == null ? void 0 : _c.getColId()) === ((_d = params.column) == null ? void 0 : _d.getColDef().showRowGroup);
        var canSkipRenderingCell = !this.showingValueForOpenedParent && !isExpandable && !leafWithValues && !showOpenGroupValue && !showingFooterTotal && !showPivotModeLeafValue;

        if (canSkipRenderingCell) {
          return;
        }
      }

      this.addExpandAndContract();
      this.addFullWidthRowDraggerIfNeeded();
      this.addCheckboxIfNeeded();
      this.addValueElement();
      this.setupIndent();
      this.refreshAriaExpanded();
    }
  }, {
    key: "getCellAriaRole",
    value: function getCellAriaRole() {
      var _a, _b;

      var colDefAriaRole = (_a = this.params.colDef) == null ? void 0 : _a.cellAriaRole;
      var columnColDefAriaRole = (_b = this.params.column) == null ? void 0 : _b.getColDef().cellAriaRole;
      return colDefAriaRole || columnColDefAriaRole || "gridcell";
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(_GroupCellRendererCtrl.prototype), "destroy", this).call(this);

      this.expandListener = null;
    }
  }, {
    key: "refreshAriaExpanded",
    value: function refreshAriaExpanded() {
      var _this$params2 = this.params,
          node = _this$params2.node,
          eGridCell = _this$params2.eGridCell;

      if (this.expandListener) {
        this.expandListener = this.expandListener();
      }

      if (!this.isExpandable()) {
        _removeAriaExpanded(eGridCell);

        return;
      }

      var listener = function listener() {
        _setAriaExpanded(eGridCell, !!node.expanded);
      };

      this.expandListener = this.addManagedListener(node, _RowNode2.EVENT_EXPANDED_CHANGED, listener) || null;
      listener();
    }
  }, {
    key: "isTopLevelFooter",
    value: function isTopLevelFooter() {
      var totalRow = this.gos.getGrandTotalRow();

      if (!totalRow) {
        return false;
      }

      if (this.params.value != null || this.params.node.level != -1) {
        return false;
      }

      var colDef = this.params.colDef;
      var doingFullWidth = colDef == null;

      if (doingFullWidth) {
        return true;
      }

      if (colDef.showRowGroup === true) {
        return true;
      }

      var rowGroupCols = this.columnModel.getRowGroupColumns();

      if (!rowGroupCols || rowGroupCols.length === 0) {
        return true;
      }

      var firstRowGroupCol = rowGroupCols[0];
      return firstRowGroupCol.getId() === colDef.showRowGroup;
    } // if we are doing embedded full width rows, we only show the renderer when
    // in the body, or if pinning in the pinned section, or if pinning and RTL,
    // in the right section. otherwise we would have the cell repeated in each section.

  }, {
    key: "isEmbeddedRowMismatch",
    value: function isEmbeddedRowMismatch() {
      if (!this.params.fullWidth || !this.gos.get("embedFullWidthRows")) {
        return false;
      }

      var pinnedLeftCell = this.params.pinned === "left";
      var pinnedRightCell = this.params.pinned === "right";
      var bodyCell = !pinnedLeftCell && !pinnedRightCell;

      if (this.gos.get("enableRtl")) {
        if (this.columnModel.isPinningLeft()) {
          return !pinnedRightCell;
        }

        return !bodyCell;
      }

      if (this.columnModel.isPinningLeft()) {
        return !pinnedLeftCell;
      }

      return !bodyCell;
    }
  }, {
    key: "findDisplayedGroupNode",
    value: function findDisplayedGroupNode() {
      var column = this.params.column;
      var rowNode = this.params.node;

      if (this.showingValueForOpenedParent) {
        var pointer = rowNode.parent;

        while (pointer != null) {
          if (pointer.rowGroupColumn && column.isRowGroupDisplayed(pointer.rowGroupColumn.getId())) {
            this.displayedGroupNode = pointer;
            break;
          }

          pointer = pointer.parent;
        }
      }

      if (_missing(this.displayedGroupNode)) {
        this.displayedGroupNode = rowNode;
      }
    }
  }, {
    key: "setupShowingValueForOpenedParent",
    value: function setupShowingValueForOpenedParent() {
      var rowNode = this.params.node;
      var column = this.params.column;

      if (!this.gos.get("groupHideOpenParents")) {
        this.showingValueForOpenedParent = false;
        return;
      }

      if (!rowNode.groupData) {
        this.showingValueForOpenedParent = false;
        return;
      }

      var showingGroupNode = rowNode.rowGroupColumn != null;

      if (showingGroupNode) {
        var keyOfGroupingColumn = rowNode.rowGroupColumn.getId();
        var configuredToShowThisGroupLevel = column.isRowGroupDisplayed(keyOfGroupingColumn);

        if (configuredToShowThisGroupLevel) {
          this.showingValueForOpenedParent = false;
          return;
        }
      }

      var valPresent = rowNode.groupData[column.getId()] != null;
      this.showingValueForOpenedParent = valPresent;
    }
  }, {
    key: "addValueElement",
    value: function addValueElement() {
      if (this.displayedGroupNode.footer) {
        this.addFooterValue();
      } else {
        this.addGroupValue();
        this.addChildCount();
      }
    }
  }, {
    key: "addGroupValue",
    value: function addGroupValue() {
      var _a;

      var paramsAdjusted = this.adjustParamsWithDetailsFromRelatedColumn();
      var innerCompDetails = this.getInnerCompDetails(paramsAdjusted);
      var valueFormatted = paramsAdjusted.valueFormatted,
          value = paramsAdjusted.value;
      var valueWhenNoRenderer = valueFormatted;

      if (valueWhenNoRenderer == null) {
        var isGroupColForNode = this.displayedGroupNode.rowGroupColumn && ((_a = this.params.column) == null ? void 0 : _a.isRowGroupDisplayed(this.displayedGroupNode.rowGroupColumn.getId()));

        if (this.displayedGroupNode.key === "" && this.displayedGroupNode.group && isGroupColForNode) {
          var localeTextFunc = this.localeService.getLocaleTextFunc();
          valueWhenNoRenderer = localeTextFunc("blanks", "(Blanks)");
        } else {
          valueWhenNoRenderer = value != null ? value : null;
        }
      }

      this.comp.setInnerRenderer(innerCompDetails, valueWhenNoRenderer);
    }
  }, {
    key: "adjustParamsWithDetailsFromRelatedColumn",
    value: function adjustParamsWithDetailsFromRelatedColumn() {
      var relatedColumn = this.displayedGroupNode.rowGroupColumn;
      var column = this.params.column;

      if (!relatedColumn) {
        return this.params;
      }

      var notFullWidth = column != null;

      if (notFullWidth) {
        var showingThisRowGroup = column.isRowGroupDisplayed(relatedColumn.getId());

        if (!showingThisRowGroup) {
          return this.params;
        }
      }

      var params = this.params;
      var _this$params3 = this.params,
          value = _this$params3.value,
          node = _this$params3.node;
      var valueFormatted = this.valueService.formatValue(relatedColumn, node, value);

      var paramsAdjusted = __spreadProps(__spreadValues({}, params), {
        valueFormatted: valueFormatted
      });

      return paramsAdjusted;
    }
  }, {
    key: "addFooterValue",
    value: function addFooterValue() {
      var footerValueGetter = this.params.totalValueGetter;

      if (!footerValueGetter) {
        var legacyGetter = this.params.footerValueGetter;

        if (legacyGetter) {
          footerValueGetter = legacyGetter;

          _warnOnce("As of v31.3, footerValueGetter is deprecated. Use `totalValueGetter` instead.");
        }
      }

      var footerValue = "";

      if (footerValueGetter) {
        var paramsClone = _cloneObject(this.params);

        paramsClone.value = this.params.value;

        if (typeof footerValueGetter === "function") {
          footerValue = footerValueGetter(paramsClone);
        } else if (typeof footerValueGetter === "string") {
          footerValue = this.expressionService.evaluate(footerValueGetter, paramsClone);
        } else {
          console.warn("AG Grid: footerValueGetter should be either a function or a string (expression)");
        }
      } else {
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        var footerTotalPrefix = localeTextFunc("footerTotal", "Total");
        footerValue = footerTotalPrefix + " " + (this.params.value != null ? this.params.value : "");
      }

      var innerCompDetails = this.getInnerCompDetails(this.params);
      this.comp.setInnerRenderer(innerCompDetails, footerValue);
    }
  }, {
    key: "getInnerCompDetails",
    value: function getInnerCompDetails(params) {
      var _this174 = this;

      if (params.fullWidth) {
        return this.userComponentFactory.getFullWidthGroupRowInnerCellRenderer(this.gos.get("groupRowRendererParams"), params);
      }

      var innerCompDetails = this.userComponentFactory.getInnerRendererDetails(params, params);

      var isGroupRowRenderer = function isGroupRowRenderer(details) {
        return details && details.componentClass == _this174.compClass;
      };

      if (innerCompDetails && !isGroupRowRenderer(innerCompDetails)) {
        return innerCompDetails;
      }

      var relatedColumn = this.displayedGroupNode.rowGroupColumn;
      var relatedColDef = relatedColumn ? relatedColumn.getColDef() : void 0;

      if (!relatedColDef) {
        return;
      }

      var relatedCompDetails = this.userComponentFactory.getCellRendererDetails(relatedColDef, params);

      if (relatedCompDetails && !isGroupRowRenderer(relatedCompDetails)) {
        return relatedCompDetails;
      }

      if (isGroupRowRenderer(relatedCompDetails) && relatedColDef.cellRendererParams && relatedColDef.cellRendererParams.innerRenderer) {
        var res = this.userComponentFactory.getInnerRendererDetails(relatedColDef.cellRendererParams, params);
        return res;
      }
    }
  }, {
    key: "addChildCount",
    value: function addChildCount() {
      if (this.params.suppressCount) {
        return;
      }

      this.addManagedListener(this.displayedGroupNode, _RowNode2.EVENT_ALL_CHILDREN_COUNT_CHANGED, this.updateChildCount.bind(this));
      this.updateChildCount();
    }
  }, {
    key: "updateChildCount",
    value: function updateChildCount() {
      var allChildrenCount = this.displayedGroupNode.allChildrenCount;
      var showingGroupForThisNode = this.isShowRowGroupForThisRow();
      var showCount = showingGroupForThisNode && allChildrenCount != null && allChildrenCount >= 0;
      var countString = showCount ? "(".concat(allChildrenCount, ")") : "";
      this.comp.setChildCount(countString);
    }
  }, {
    key: "isShowRowGroupForThisRow",
    value: function isShowRowGroupForThisRow() {
      if (this.gos.get("treeData")) {
        return true;
      }

      var rowGroupColumn = this.displayedGroupNode.rowGroupColumn;

      if (!rowGroupColumn) {
        return false;
      }

      var column = this.params.column;
      var thisColumnIsInterested = column == null || column.isRowGroupDisplayed(rowGroupColumn.getId());
      return thisColumnIsInterested;
    }
  }, {
    key: "addExpandAndContract",
    value: function addExpandAndContract() {
      var _a;

      var params = this.params;

      var eExpandedIcon = _createIconNoSpan("groupExpanded", this.gos, null);

      var eContractedIcon = _createIconNoSpan("groupContracted", this.gos, null);

      if (eExpandedIcon) {
        this.eExpanded.appendChild(eExpandedIcon);
      }

      if (eContractedIcon) {
        this.eContracted.appendChild(eContractedIcon);
      }

      var eGroupCell = params.eGridCell;
      var isDoubleClickEdit = ((_a = this.params.column) == null ? void 0 : _a.isCellEditable(params.node)) && this.gos.get("enableGroupEdit");

      if (!isDoubleClickEdit && this.isExpandable() && !params.suppressDoubleClickExpand) {
        this.addManagedListener(eGroupCell, "dblclick", this.onCellDblClicked.bind(this));
      }

      this.addManagedListener(this.eExpanded, "click", this.onExpandClicked.bind(this));
      this.addManagedListener(this.eContracted, "click", this.onExpandClicked.bind(this));
      this.addManagedListener(eGroupCell, "keydown", this.onKeyDown.bind(this));
      this.addManagedListener(params.node, _RowNode2.EVENT_EXPANDED_CHANGED, this.showExpandAndContractIcons.bind(this));
      this.showExpandAndContractIcons();
      var expandableChangedListener = this.onRowNodeIsExpandableChanged.bind(this);
      this.addManagedListener(this.displayedGroupNode, _RowNode2.EVENT_ALL_CHILDREN_COUNT_CHANGED, expandableChangedListener);
      this.addManagedListener(this.displayedGroupNode, _RowNode2.EVENT_MASTER_CHANGED, expandableChangedListener);
      this.addManagedListener(this.displayedGroupNode, _RowNode2.EVENT_GROUP_CHANGED, expandableChangedListener);
      this.addManagedListener(this.displayedGroupNode, _RowNode2.EVENT_HAS_CHILDREN_CHANGED, expandableChangedListener);
    }
  }, {
    key: "onExpandClicked",
    value: function onExpandClicked(mouseEvent) {
      if (_isStopPropagationForAgGrid(mouseEvent)) {
        return;
      }

      _stopPropagationForAgGrid(mouseEvent);

      this.onExpandOrContract(mouseEvent);
    }
  }, {
    key: "onExpandOrContract",
    value: function onExpandOrContract(e) {
      var rowNode = this.displayedGroupNode;
      var nextExpandState = !rowNode.expanded;

      if (!nextExpandState && rowNode.sticky) {
        this.scrollToStickyNode(rowNode);
      }

      rowNode.setExpanded(nextExpandState, e);
    }
  }, {
    key: "scrollToStickyNode",
    value: function scrollToStickyNode(rowNode) {
      var gridBodyCtrl = this.ctrlsService.getGridBodyCtrl();
      var scrollFeature = gridBodyCtrl.getScrollFeature();
      scrollFeature.setVerticalScrollPosition(rowNode.rowTop - rowNode.stickyRowTop);
    }
  }, {
    key: "isExpandable",
    value: function isExpandable() {
      if (this.showingValueForOpenedParent) {
        return true;
      }

      var rowNode = this.displayedGroupNode;
      var reducedLeafNode = this.columnModel.isPivotMode() && rowNode.leafGroup;
      var expandableGroup = rowNode.isExpandable() && !rowNode.footer && !reducedLeafNode;

      if (!expandableGroup) {
        return false;
      }

      var column = this.params.column;
      var displayingForOneColumnOnly = column != null && typeof column.getColDef().showRowGroup === "string";

      if (displayingForOneColumnOnly) {
        var showing = this.isShowRowGroupForThisRow();
        return showing;
      }

      return true;
    }
  }, {
    key: "showExpandAndContractIcons",
    value: function showExpandAndContractIcons() {
      var params = this.params,
          displayedGroup = this.displayedGroupNode,
          columnModel = this.columnModel;
      var node = params.node;
      var isExpandable = this.isExpandable();

      if (isExpandable) {
        var expanded = this.showingValueForOpenedParent ? true : node.expanded;
        this.comp.setExpandedDisplayed(expanded);
        this.comp.setContractedDisplayed(!expanded);
      } else {
        this.comp.setExpandedDisplayed(false);
        this.comp.setContractedDisplayed(false);
      }

      var pivotMode = columnModel.isPivotMode();
      var pivotModeAndLeafGroup = pivotMode && displayedGroup.leafGroup;
      var addExpandableCss = isExpandable && !pivotModeAndLeafGroup;
      var isTotalFooterNode = node.footer && node.level === -1;
      this.comp.addOrRemoveCssClass("ag-cell-expandable", addExpandableCss);
      this.comp.addOrRemoveCssClass("ag-row-group", addExpandableCss);

      if (pivotMode) {
        this.comp.addOrRemoveCssClass("ag-pivot-leaf-group", pivotModeAndLeafGroup);
      } else if (!isTotalFooterNode) {
        this.comp.addOrRemoveCssClass("ag-row-group-leaf-indent", !addExpandableCss);
      }
    }
  }, {
    key: "onRowNodeIsExpandableChanged",
    value: function onRowNodeIsExpandableChanged() {
      this.showExpandAndContractIcons();
      this.setIndent();
      this.refreshAriaExpanded();
    }
  }, {
    key: "setupIndent",
    value: function setupIndent() {
      var node = this.params.node;
      var suppressPadding = this.params.suppressPadding;

      if (!suppressPadding) {
        this.addManagedListener(node, _RowNode2.EVENT_UI_LEVEL_CHANGED, this.setIndent.bind(this));
        this.setIndent();
      }
    }
  }, {
    key: "setIndent",
    value: function setIndent() {
      if (this.gos.get("groupHideOpenParents")) {
        return;
      }

      var params = this.params;
      var rowNode = params.node;
      var fullWithRow = !!params.colDef;
      var treeData = this.gos.get("treeData");
      var manyDimensionThisColumn = !fullWithRow || treeData || params.colDef.showRowGroup === true;
      var paddingCount = manyDimensionThisColumn ? rowNode.uiLevel : 0;

      if (this.indentClass) {
        this.comp.addOrRemoveCssClass(this.indentClass, false);
      }

      this.indentClass = "ag-row-group-indent-" + paddingCount;
      this.comp.addOrRemoveCssClass(this.indentClass, true);
    }
  }, {
    key: "addFullWidthRowDraggerIfNeeded",
    value: function addFullWidthRowDraggerIfNeeded() {
      var _this175 = this;

      if (!this.params.fullWidth || !this.params.rowDrag) {
        return;
      }

      var rowDragComp = new RowDragComp(function () {
        return _this175.params.value;
      }, this.params.node);
      this.createManagedBean(rowDragComp, this.context);
      this.eGui.insertAdjacentElement("afterbegin", rowDragComp.getGui());
    }
  }, {
    key: "isUserWantsSelected",
    value: function isUserWantsSelected() {
      var paramsCheckbox = this.params.checkbox;
      return typeof paramsCheckbox === "function" || paramsCheckbox === true;
    }
  }, {
    key: "addCheckboxIfNeeded",
    value: function addCheckboxIfNeeded() {
      var _this176 = this;

      var rowNode = this.displayedGroupNode;
      var checkboxNeeded = this.isUserWantsSelected() && // footers cannot be selected
      !rowNode.footer && // pinned rows cannot be selected
      !rowNode.rowPinned && // details cannot be selected
      !rowNode.detail;

      if (checkboxNeeded) {
        var cbSelectionComponent = new _CheckboxSelectionComponent();
        this.getContext().createBean(cbSelectionComponent);
        cbSelectionComponent.init({
          rowNode: this.params.node,
          // when groupHideOpenParents = true and group expanded, we want the checkbox to refer to leaf node state (not group node state)
          column: this.params.column,
          overrides: {
            isVisible: this.params.checkbox,
            callbackParams: this.params,
            removeHidden: true
          }
        });
        this.eCheckbox.appendChild(cbSelectionComponent.getGui());
        this.addDestroyFunc(function () {
          return _this176.getContext().destroyBean(cbSelectionComponent);
        });
      }

      this.comp.setCheckboxVisible(checkboxNeeded);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      var isEnterKey = event.key === _KeyCode.ENTER;

      if (!isEnterKey || this.params.suppressEnterExpand) {
        return;
      }

      var cellEditable = this.params.column && this.params.column.isCellEditable(this.params.node);

      if (cellEditable) {
        return;
      }

      this.onExpandOrContract(event);
    }
  }, {
    key: "onCellDblClicked",
    value: function onCellDblClicked(mouseEvent) {
      if (_isStopPropagationForAgGrid(mouseEvent)) {
        return;
      }

      var targetIsExpandIcon = _isElementInEventPath(this.eExpanded, mouseEvent) || _isElementInEventPath(this.eContracted, mouseEvent);

      if (!targetIsExpandIcon) {
        this.onExpandOrContract(mouseEvent);
      }
    }
  }]);

  return _GroupCellRendererCtrl;
}(_BeanStub2);

__decorateClass([_Autowired("expressionService")], _GroupCellRendererCtrl.prototype, "expressionService", 2);

__decorateClass([_Autowired("valueService")], _GroupCellRendererCtrl.prototype, "valueService", 2);

__decorateClass([_Autowired("columnModel")], _GroupCellRendererCtrl.prototype, "columnModel", 2);

__decorateClass([_Autowired("userComponentFactory")], _GroupCellRendererCtrl.prototype, "userComponentFactory", 2);

__decorateClass([_Autowired("ctrlsService")], _GroupCellRendererCtrl.prototype, "ctrlsService", 2); // community-modules/core/src/rendering/cellRenderers/groupCellRenderer.ts


var _GroupCellRenderer =
/*#__PURE__*/
function (_Component17) {
  "use strict";

  _inherits(_GroupCellRenderer, _Component17);

  function _GroupCellRenderer() {
    _classCallCheck(this, _GroupCellRenderer);

    return _possibleConstructorReturn(this, _getPrototypeOf(_GroupCellRenderer).call(this, _GroupCellRenderer.TEMPLATE));
  }

  _createClass(_GroupCellRenderer, [{
    key: "init",
    value: function init(params) {
      var _this177 = this;

      var compProxy = {
        setInnerRenderer: function setInnerRenderer(compDetails, valueToDisplay) {
          return _this177.setRenderDetails(compDetails, valueToDisplay);
        },
        setChildCount: function setChildCount(count) {
          return _this177.eChildCount.textContent = count;
        },
        addOrRemoveCssClass: function addOrRemoveCssClass(cssClass, value) {
          return _this177.addOrRemoveCssClass(cssClass, value);
        },
        setContractedDisplayed: function setContractedDisplayed(expanded) {
          return _setDisplayed(_this177.eContracted, expanded);
        },
        setExpandedDisplayed: function setExpandedDisplayed(expanded) {
          return _setDisplayed(_this177.eExpanded, expanded);
        },
        setCheckboxVisible: function setCheckboxVisible(visible) {
          return _this177.eCheckbox.classList.toggle("ag-invisible", !visible);
        }
      };
      var ctrl = this.createManagedBean(new _GroupCellRendererCtrl());
      var fullWidth = !params.colDef;
      var eGui = this.getGui();
      ctrl.init(compProxy, eGui, this.eCheckbox, this.eExpanded, this.eContracted, this.constructor, params);

      if (fullWidth) {
        _setAriaRole(eGui, ctrl.getCellAriaRole());
      }
    }
  }, {
    key: "setRenderDetails",
    value: function setRenderDetails(compDetails, valueToDisplay) {
      var _this178 = this;

      if (compDetails) {
        var componentPromise = compDetails.newAgStackInstance();

        if (!componentPromise) {
          return;
        }

        componentPromise.then(function (comp) {
          if (!comp) {
            return;
          }

          var destroyComp = function destroyComp() {
            return _this178.context.destroyBean(comp);
          };

          if (_this178.isAlive()) {
            _this178.eValue.appendChild(comp.getGui());

            _this178.addDestroyFunc(destroyComp);
          } else {
            destroyComp();
          }
        });
      } else {
        this.eValue.innerText = valueToDisplay;
      }
    } // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to have public here instead of private or protected

  }, {
    key: "destroy",
    value: function destroy() {
      this.getContext().destroyBean(this.innerCellRenderer);

      _get(_getPrototypeOf(_GroupCellRenderer.prototype), "destroy", this).call(this);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      return false;
    }
  }]);

  return _GroupCellRenderer;
}(_Component2);

_GroupCellRenderer.TEMPLATE =
/* html */
"<span class=\"ag-cell-wrapper\">\n            <span class=\"ag-group-expanded\" ref=\"eExpanded\"></span>\n            <span class=\"ag-group-contracted\" ref=\"eContracted\"></span>\n            <span class=\"ag-group-checkbox ag-invisible\" ref=\"eCheckbox\"></span>\n            <span class=\"ag-group-value\" ref=\"eValue\"></span>\n            <span class=\"ag-group-child-count\" ref=\"eChildCount\"></span>\n        </span>";

__decorateClass([_RefSelector("eExpanded")], _GroupCellRenderer.prototype, "eExpanded", 2);

__decorateClass([_RefSelector("eContracted")], _GroupCellRenderer.prototype, "eContracted", 2);

__decorateClass([_RefSelector("eCheckbox")], _GroupCellRenderer.prototype, "eCheckbox", 2);

__decorateClass([_RefSelector("eValue")], _GroupCellRenderer.prototype, "eValue", 2);

__decorateClass([_RefSelector("eChildCount")], _GroupCellRenderer.prototype, "eChildCount", 2);

var _GroupCellRenderer2 = _GroupCellRenderer; // community-modules/core/src/rendering/cellRenderers/loadingCellRenderer.ts

var _LoadingCellRenderer =
/*#__PURE__*/
function (_Component18) {
  "use strict";

  _inherits(_LoadingCellRenderer, _Component18);

  function _LoadingCellRenderer() {
    _classCallCheck(this, _LoadingCellRenderer);

    return _possibleConstructorReturn(this, _getPrototypeOf(_LoadingCellRenderer).call(this, _LoadingCellRenderer.TEMPLATE));
  }

  _createClass(_LoadingCellRenderer, [{
    key: "init",
    value: function init(params) {
      params.node.failedLoad ? this.setupFailed() : this.setupLoading();
    }
  }, {
    key: "setupFailed",
    value: function setupFailed() {
      var localeTextFunc = this.localeService.getLocaleTextFunc();
      this.eLoadingText.innerText = localeTextFunc("loadingError", "ERR");
    }
  }, {
    key: "setupLoading",
    value: function setupLoading() {
      var eLoadingIcon = _createIconNoSpan("groupLoading", this.gos, null);

      if (eLoadingIcon) {
        this.eLoadingIcon.appendChild(eLoadingIcon);
      }

      var localeTextFunc = this.localeService.getLocaleTextFunc();
      this.eLoadingText.innerText = localeTextFunc("loadingOoo", "Loading");
    }
  }, {
    key: "refresh",
    value: function refresh(params) {
      return false;
    } // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(_LoadingCellRenderer.prototype), "destroy", this).call(this);
    }
  }]);

  return _LoadingCellRenderer;
}(_Component2);

_LoadingCellRenderer.TEMPLATE = "<div class=\"ag-loading\">\n            <span class=\"ag-loading-icon\" ref=\"eLoadingIcon\"></span>\n            <span class=\"ag-loading-text\" ref=\"eLoadingText\"></span>\n        </div>";

__decorateClass([_RefSelector("eLoadingIcon")], _LoadingCellRenderer.prototype, "eLoadingIcon", 2);

__decorateClass([_RefSelector("eLoadingText")], _LoadingCellRenderer.prototype, "eLoadingText", 2);

var LoadingCellRenderer = _LoadingCellRenderer; // community-modules/core/src/rendering/cellRenderers/skeletonCellRenderer.ts

var _SkeletonCellRenderer =
/*#__PURE__*/
function (_Component19) {
  "use strict";

  _inherits(_SkeletonCellRenderer, _Component19);

  function _SkeletonCellRenderer() {
    _classCallCheck(this, _SkeletonCellRenderer);

    return _possibleConstructorReturn(this, _getPrototypeOf(_SkeletonCellRenderer).call(this, _SkeletonCellRenderer.TEMPLATE));
  }

  _createClass(_SkeletonCellRenderer, [{
    key: "init",
    value: function init(params) {
      var id = "ag-cell-skeleton-renderer-".concat(this.getCompId());
      this.getGui().setAttribute("id", id);
      this.addDestroyFunc(function () {
        return _setAriaLabelledBy(params.eParentOfValue);
      });

      _setAriaLabelledBy(params.eParentOfValue, id);

      params.node.failedLoad ? this.setupFailed() : this.setupLoading();
    }
  }, {
    key: "setupFailed",
    value: function setupFailed() {
      var localeTextFunc = this.localeService.getLocaleTextFunc();
      this.getGui().innerText = localeTextFunc("loadingError", "ERR");
      var ariaFailed = localeTextFunc("ariaSkeletonCellLoadingFailed", "Row failed to load");

      _setAriaLabel(this.getGui(), ariaFailed);
    }
  }, {
    key: "setupLoading",
    value: function setupLoading() {
      var eDocument = this.gos.getDocument();
      var skeletonEffect = eDocument.createElement("div");
      skeletonEffect.classList.add("ag-skeleton-effect");
      this.getGui().appendChild(skeletonEffect);
      var localeTextFunc = this.localeService.getLocaleTextFunc();
      var ariaLoading = localeTextFunc("ariaSkeletonCellLoading", "Row data is loading");

      _setAriaLabel(this.getGui(), ariaLoading);
    }
  }, {
    key: "refresh",
    value: function refresh(params) {
      return false;
    } // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(_SkeletonCellRenderer.prototype), "destroy", this).call(this);
    }
  }]);

  return _SkeletonCellRenderer;
}(_Component2);

_SkeletonCellRenderer.TEMPLATE = "<div class=\"ag-skeleton-container\"></div>";
var SkeletonCellRenderer = _SkeletonCellRenderer; // community-modules/core/src/rendering/overlays/loadingOverlayComponent.ts

var _LoadingOverlayComponent =
/*#__PURE__*/
function (_Component20) {
  "use strict";

  _inherits(_LoadingOverlayComponent, _Component20);

  function _LoadingOverlayComponent() {
    _classCallCheck(this, _LoadingOverlayComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(_LoadingOverlayComponent).call(this));
  } // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.


  _createClass(_LoadingOverlayComponent, [{
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(_LoadingOverlayComponent.prototype), "destroy", this).call(this);
    }
  }, {
    key: "init",
    value: function init(params) {
      var _this179 = this;

      var customTemplate = this.gos.get("overlayLoadingTemplate");
      this.setTemplate(customTemplate != null ? customTemplate : _LoadingOverlayComponent.DEFAULT_LOADING_OVERLAY_TEMPLATE);

      if (!customTemplate) {
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        setTimeout(function () {
          _this179.getGui().textContent = localeTextFunc("loadingOoo", "Loading...");
        });
      }
    }
  }]);

  return _LoadingOverlayComponent;
}(_Component2);

_LoadingOverlayComponent.DEFAULT_LOADING_OVERLAY_TEMPLATE =
/* html */
"<span aria-live=\"polite\" aria-atomic=\"true\" class=\"ag-overlay-loading-center\"></span>";
var LoadingOverlayComponent = _LoadingOverlayComponent; // community-modules/core/src/rendering/overlays/noRowsOverlayComponent.ts

var _NoRowsOverlayComponent =
/*#__PURE__*/
function (_Component21) {
  "use strict";

  _inherits(_NoRowsOverlayComponent, _Component21);

  function _NoRowsOverlayComponent() {
    _classCallCheck(this, _NoRowsOverlayComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(_NoRowsOverlayComponent).call(this));
  } // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.


  _createClass(_NoRowsOverlayComponent, [{
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(_NoRowsOverlayComponent.prototype), "destroy", this).call(this);
    }
  }, {
    key: "init",
    value: function init(params) {
      var _this180 = this;

      var customTemplate = this.gos.get("overlayNoRowsTemplate");
      this.setTemplate(customTemplate != null ? customTemplate : _NoRowsOverlayComponent.DEFAULT_NO_ROWS_TEMPLATE);

      if (!customTemplate) {
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        setTimeout(function () {
          _this180.getGui().textContent = localeTextFunc("noRowsToShow", "No Rows To Show");
        });
      }
    }
  }]);

  return _NoRowsOverlayComponent;
}(_Component2);

_NoRowsOverlayComponent.DEFAULT_NO_ROWS_TEMPLATE =
/* html */
"<span class=\"ag-overlay-no-rows-center\"></span>";
var NoRowsOverlayComponent = _NoRowsOverlayComponent; // community-modules/core/src/rendering/tooltipComponent.ts

var TooltipComponent =
/*#__PURE__*/
function (_PopupComponent5) {
  "use strict";

  _inherits(TooltipComponent, _PopupComponent5);

  function TooltipComponent() {
    _classCallCheck(this, TooltipComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(TooltipComponent).call(this,
    /* html */
    "<div class=\"ag-tooltip\"></div>"));
  } // will need to type params


  _createClass(TooltipComponent, [{
    key: "init",
    value: function init(params) {
      var value = params.value;
      this.getGui().textContent = _escapeString(value, true);
    }
  }]);

  return TooltipComponent;
}(_PopupComponent); // community-modules/core/src/rendering/cellEditors/numberCellEditor.ts


var NumberCellEditorInput =
/*#__PURE__*/
function () {
  "use strict";

  function NumberCellEditorInput() {
    _classCallCheck(this, NumberCellEditorInput);
  }

  _createClass(NumberCellEditorInput, [{
    key: "getTemplate",
    value: function getTemplate() {
      return (
        /* html */
        "<ag-input-number-field class=\"ag-cell-editor\" ref=\"eInput\"></ag-input-number-field>"
      );
    }
  }, {
    key: "init",
    value: function init(eInput, params) {
      this.eInput = eInput;
      this.params = params;

      if (params.max != null) {
        eInput.setMax(params.max);
      }

      if (params.min != null) {
        eInput.setMin(params.min);
      }

      if (params.precision != null) {
        eInput.setPrecision(params.precision);
      }

      if (params.step != null) {
        eInput.setStep(params.step);
      }

      var inputEl = eInput.getInputElement();

      if (params.preventStepping) {
        eInput.addManagedListener(inputEl, "keydown", this.preventStepping);
      } else if (params.showStepperButtons) {
        inputEl.classList.add("ag-number-field-input-stepper");
      }
    }
  }, {
    key: "preventStepping",
    value: function preventStepping(e) {
      if (e.key === _KeyCode.UP || e.key === _KeyCode.DOWN) {
        e.preventDefault();
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var value = this.eInput.getValue();

      if (!_exists(value) && !_exists(this.params.value)) {
        return this.params.value;
      }

      var parsedValue = this.params.parseValue(value);

      if (parsedValue == null) {
        return parsedValue;
      }

      if (typeof parsedValue === "string") {
        if (parsedValue === "") {
          return null;
        }

        parsedValue = Number(parsedValue);
      }

      return isNaN(parsedValue) ? null : parsedValue;
    }
  }, {
    key: "getStartValue",
    value: function getStartValue() {
      return this.params.value;
    }
  }]);

  return NumberCellEditorInput;
}();

var _NumberCellEditor =
/*#__PURE__*/
function (_SimpleCellEditor2) {
  "use strict";

  _inherits(_NumberCellEditor, _SimpleCellEditor2);

  function _NumberCellEditor() {
    _classCallCheck(this, _NumberCellEditor);

    return _possibleConstructorReturn(this, _getPrototypeOf(_NumberCellEditor).call(this, new NumberCellEditorInput()));
  }

  return _NumberCellEditor;
}(SimpleCellEditor); // community-modules/core/src/rendering/cellEditors/dateCellEditor.ts


var DateCellEditorInput =
/*#__PURE__*/
function () {
  "use strict";

  function DateCellEditorInput() {
    _classCallCheck(this, DateCellEditorInput);
  }

  _createClass(DateCellEditorInput, [{
    key: "getTemplate",
    value: function getTemplate() {
      return (
        /* html */
        "<ag-input-date-field class=\"ag-cell-editor\" ref=\"eInput\"></ag-input-date-field>"
      );
    }
  }, {
    key: "init",
    value: function init(eInput, params) {
      this.eInput = eInput;
      this.params = params;

      if (params.min != null) {
        eInput.setMin(params.min);
      }

      if (params.max != null) {
        eInput.setMax(params.max);
      }

      if (params.step != null) {
        eInput.setStep(params.step);
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var value = this.eInput.getDate();

      if (!_exists(value) && !_exists(this.params.value)) {
        return this.params.value;
      }

      return value != null ? value : null;
    }
  }, {
    key: "getStartValue",
    value: function getStartValue() {
      var value = this.params.value;

      if (!(value instanceof Date)) {
        return void 0;
      }

      return _serialiseDate(value, false);
    }
  }]);

  return DateCellEditorInput;
}();

var _DateCellEditor =
/*#__PURE__*/
function (_SimpleCellEditor3) {
  "use strict";

  _inherits(_DateCellEditor, _SimpleCellEditor3);

  function _DateCellEditor() {
    _classCallCheck(this, _DateCellEditor);

    return _possibleConstructorReturn(this, _getPrototypeOf(_DateCellEditor).call(this, new DateCellEditorInput()));
  }

  return _DateCellEditor;
}(SimpleCellEditor); // community-modules/core/src/rendering/cellEditors/dateStringCellEditor.ts


var DateStringCellEditorInput =
/*#__PURE__*/
function () {
  "use strict";

  function DateStringCellEditorInput(getDataTypeService) {
    _classCallCheck(this, DateStringCellEditorInput);

    this.getDataTypeService = getDataTypeService;
  }

  _createClass(DateStringCellEditorInput, [{
    key: "getTemplate",
    value: function getTemplate() {
      return (
        /* html */
        "<ag-input-date-field class=\"ag-cell-editor\" ref=\"eInput\"></ag-input-date-field>"
      );
    }
  }, {
    key: "init",
    value: function init(eInput, params) {
      this.eInput = eInput;
      this.params = params;

      if (params.min != null) {
        eInput.setMin(params.min);
      }

      if (params.max != null) {
        eInput.setMax(params.max);
      }

      if (params.step != null) {
        eInput.setStep(params.step);
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var value = this.formatDate(this.eInput.getDate());

      if (!_exists(value) && !_exists(this.params.value)) {
        return this.params.value;
      }

      return this.params.parseValue(value != null ? value : "");
    }
  }, {
    key: "getStartValue",
    value: function getStartValue() {
      var _a, _b;

      return _serialiseDate((_b = this.parseDate((_a = this.params.value) != null ? _a : void 0)) != null ? _b : null, false);
    }
  }, {
    key: "parseDate",
    value: function parseDate(value) {
      return this.getDataTypeService().getDateParserFunction(this.params.column)(value);
    }
  }, {
    key: "formatDate",
    value: function formatDate(value) {
      return this.getDataTypeService().getDateFormatterFunction(this.params.column)(value);
    }
  }]);

  return DateStringCellEditorInput;
}();

var _DateStringCellEditor =
/*#__PURE__*/
function (_SimpleCellEditor4) {
  "use strict";

  _inherits(_DateStringCellEditor, _SimpleCellEditor4);

  function _DateStringCellEditor() {
    var _this181;

    _classCallCheck(this, _DateStringCellEditor);

    return _this181 = _possibleConstructorReturn(this, _getPrototypeOf(_DateStringCellEditor).call(this, new DateStringCellEditorInput(function () {
      return _this181.dataTypeService;
    })));
  }

  return _DateStringCellEditor;
}(SimpleCellEditor);

__decorateClass([_Autowired("dataTypeService")], _DateStringCellEditor.prototype, "dataTypeService", 2); // community-modules/core/src/rendering/cellRenderers/checkboxCellRenderer.ts


var _CheckboxCellRenderer =
/*#__PURE__*/
function (_Component22) {
  "use strict";

  _inherits(_CheckboxCellRenderer, _Component22);

  function _CheckboxCellRenderer() {
    _classCallCheck(this, _CheckboxCellRenderer);

    return _possibleConstructorReturn(this, _getPrototypeOf(_CheckboxCellRenderer).call(this, _CheckboxCellRenderer.TEMPLATE));
  }

  _createClass(_CheckboxCellRenderer, [{
    key: "init",
    value: function init(params) {
      var _this182 = this;

      this.params = params;
      this.updateCheckbox(params);
      var inputEl = this.eCheckbox.getInputElement();
      inputEl.setAttribute("tabindex", "-1");

      _setAriaLive(inputEl, "polite");

      this.addManagedListener(inputEl, "click", function (event) {
        _stopPropagationForAgGrid(event);

        if (_this182.eCheckbox.isDisabled()) {
          return;
        }

        var isSelected = _this182.eCheckbox.getValue();

        _this182.onCheckboxChanged(isSelected);
      });
      this.addManagedListener(inputEl, "dblclick", function (event) {
        _stopPropagationForAgGrid(event);
      });
      this.addManagedListener(this.params.eGridCell, "keydown", function (event) {
        if (event.key === _KeyCode.SPACE && !_this182.eCheckbox.isDisabled()) {
          if (_this182.params.eGridCell === _this182.gos.getActiveDomElement()) {
            _this182.eCheckbox.toggle();
          }

          var isSelected = _this182.eCheckbox.getValue();

          _this182.onCheckboxChanged(isSelected);

          event.preventDefault();
        }
      });
    }
  }, {
    key: "refresh",
    value: function refresh(params) {
      this.params = params;
      this.updateCheckbox(params);
      return true;
    }
  }, {
    key: "updateCheckbox",
    value: function updateCheckbox(params) {
      var _a, _b, _c;

      var isSelected;
      var displayed = true;

      if (params.node.group && params.column) {
        var colId = params.column.getColId();

        if (colId.startsWith(_GROUP_AUTO_COLUMN_ID)) {
          isSelected = params.value == null || params.value === "" ? void 0 : params.value === "true";
        } else if (params.node.aggData && params.node.aggData[colId] !== void 0) {
          isSelected = (_a = params.value) != null ? _a : void 0;
        } else {
          displayed = false;
        }
      } else {
        isSelected = (_b = params.value) != null ? _b : void 0;
      }

      if (!displayed) {
        this.eCheckbox.setDisplayed(false);
        return;
      }

      this.eCheckbox.setValue(isSelected);
      var disabled = params.disabled != null ? params.disabled : !((_c = params.column) == null ? void 0 : _c.isCellEditable(params.node));
      this.eCheckbox.setDisabled(disabled);
      var translate = this.localeService.getLocaleTextFunc();

      var stateName = _getAriaCheckboxStateName(translate, isSelected);

      var ariaLabel = disabled ? stateName : "".concat(translate("ariaToggleCellValue", "Press SPACE to toggle cell value"), " (").concat(stateName, ")");
      this.eCheckbox.setInputAriaLabel(ariaLabel);
    }
  }, {
    key: "onCheckboxChanged",
    value: function onCheckboxChanged(isSelected) {
      var _this$params4 = this.params,
          column = _this$params4.column,
          node = _this$params4.node,
          rowIndex = _this$params4.rowIndex,
          value = _this$params4.value;
      var eventStarted = {
        type: _Events.EVENT_CELL_EDITING_STARTED,
        column: column,
        colDef: column == null ? void 0 : column.getColDef(),
        data: node.data,
        node: node,
        rowIndex: rowIndex,
        rowPinned: node.rowPinned,
        value: value
      };
      this.eventService.dispatchEvent(eventStarted);
      var valueChanged = this.params.node.setDataValue(this.params.column, isSelected, "edit");
      var eventStopped = {
        type: _Events.EVENT_CELL_EDITING_STOPPED,
        column: column,
        colDef: column == null ? void 0 : column.getColDef(),
        data: node.data,
        node: node,
        rowIndex: rowIndex,
        rowPinned: node.rowPinned,
        value: value,
        oldValue: value,
        newValue: isSelected,
        valueChanged: valueChanged
      };
      this.eventService.dispatchEvent(eventStopped);
    }
  }]);

  return _CheckboxCellRenderer;
}(_Component2);

_CheckboxCellRenderer.TEMPLATE =
/* html*/
"\n        <div class=\"ag-cell-wrapper ag-checkbox-cell\" role=\"presentation\">\n            <ag-checkbox role=\"presentation\" ref=\"eCheckbox\"></ag-checkbox>\n        </div>";

__decorateClass([_RefSelector("eCheckbox")], _CheckboxCellRenderer.prototype, "eCheckbox", 2);

var _CheckboxCellRenderer2 = _CheckboxCellRenderer; // community-modules/core/src/rendering/cellEditors/checkboxCellEditor.ts

var _CheckboxCellEditor =
/*#__PURE__*/
function (_PopupComponent6) {
  "use strict";

  _inherits(_CheckboxCellEditor, _PopupComponent6);

  function _CheckboxCellEditor() {
    _classCallCheck(this, _CheckboxCellEditor);

    return _possibleConstructorReturn(this, _getPrototypeOf(_CheckboxCellEditor).call(this,
    /* html */
    "\n            <div class=\"ag-cell-wrapper ag-cell-edit-wrapper ag-checkbox-edit\">\n                <ag-checkbox role=\"presentation\" ref=\"eCheckbox\"></ag-checkbox>\n            </div>"));
  }

  _createClass(_CheckboxCellEditor, [{
    key: "init",
    value: function init(params) {
      var _this183 = this;

      var _a;

      this.params = params;
      var isSelected = (_a = params.value) != null ? _a : void 0;
      this.eCheckbox.setValue(isSelected);
      var inputEl = this.eCheckbox.getInputElement();
      inputEl.setAttribute("tabindex", "-1");
      this.setAriaLabel(isSelected);
      this.addManagedListener(this.eCheckbox, _Events.EVENT_FIELD_VALUE_CHANGED, function (event) {
        return _this183.setAriaLabel(event.selected);
      });
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.eCheckbox.getValue();
    }
  }, {
    key: "focusIn",
    value: function focusIn() {
      this.eCheckbox.getFocusableElement().focus();
    }
  }, {
    key: "afterGuiAttached",
    value: function afterGuiAttached() {
      if (this.params.cellStartedEdit) {
        this.focusIn();
      }
    }
  }, {
    key: "isPopup",
    value: function isPopup() {
      return false;
    }
  }, {
    key: "setAriaLabel",
    value: function setAriaLabel(isSelected) {
      var translate = this.localeService.getLocaleTextFunc();

      var stateName = _getAriaCheckboxStateName(translate, isSelected);

      var ariaLabel = translate("ariaToggleCellValue", "Press SPACE to toggle cell value");
      this.eCheckbox.setInputAriaLabel("".concat(ariaLabel, " (").concat(stateName, ")"));
    }
  }]);

  return _CheckboxCellEditor;
}(_PopupComponent);

__decorateClass([_RefSelector("eCheckbox")], _CheckboxCellEditor.prototype, "eCheckbox", 2); // community-modules/core/src/widgets/agMenuItemRenderer.ts


var _AgMenuItemRenderer =
/*#__PURE__*/
function (_Component23) {
  "use strict";

  _inherits(_AgMenuItemRenderer, _Component23);

  function _AgMenuItemRenderer() {
    var _this184;

    _classCallCheck(this, _AgMenuItemRenderer);

    _this184 = _possibleConstructorReturn(this, _getPrototypeOf(_AgMenuItemRenderer).call(this));

    _this184.setTemplate(
    /* html */
    "<div></div>");

    return _this184;
  }

  _createClass(_AgMenuItemRenderer, [{
    key: "init",
    value: function init(params) {
      var _a;

      this.params = params;
      this.cssClassPrefix = (_a = this.params.cssClassPrefix) != null ? _a : "ag-menu-option";
      this.addIcon();
      this.addName();
      this.addShortcut();
      this.addSubMenu();
    }
  }, {
    key: "configureDefaults",
    value: function configureDefaults() {
      return true;
    }
  }, {
    key: "addIcon",
    value: function addIcon() {
      if (this.params.isCompact) {
        return;
      }

      var icon = _loadTemplate(
      /* html */
      "<span ref=\"eIcon\" class=\"".concat(this.getClassName("part"), " ").concat(this.getClassName("icon"), "\" role=\"presentation\"></span>"));

      if (this.params.checked) {
        icon.appendChild(_createIconNoSpan("check", this.gos));
      } else if (this.params.icon) {
        if (_isNodeOrElement(this.params.icon)) {
          icon.appendChild(this.params.icon);
        } else if (typeof this.params.icon === "string") {
          icon.innerHTML = this.params.icon;
        } else {
          console.warn("AG Grid: menu item icon must be DOM node or string");
        }
      }

      this.getGui().appendChild(icon);
    }
  }, {
    key: "addName",
    value: function addName() {
      var name = _loadTemplate(
      /* html */
      "<span ref=\"eName\" class=\"".concat(this.getClassName("part"), " ").concat(this.getClassName("text"), "\">").concat(this.params.name || "", "</span>"));

      this.getGui().appendChild(name);
    }
  }, {
    key: "addShortcut",
    value: function addShortcut() {
      if (this.params.isCompact) {
        return;
      }

      var shortcut = _loadTemplate(
      /* html */
      "<span ref=\"eShortcut\" class=\"".concat(this.getClassName("part"), " ").concat(this.getClassName("shortcut"), "\">").concat(this.params.shortcut || "", "</span>"));

      this.getGui().appendChild(shortcut);
    }
  }, {
    key: "addSubMenu",
    value: function addSubMenu() {
      var pointer = _loadTemplate(
      /* html */
      "<span ref=\"ePopupPointer\" class=\"".concat(this.getClassName("part"), " ").concat(this.getClassName("popup-pointer"), "\"></span>"));

      var eGui = this.getGui();

      if (this.params.subMenu) {
        var iconName = this.gos.get("enableRtl") ? "smallLeft" : "smallRight";

        _setAriaExpanded(eGui, false);

        pointer.appendChild(_createIconNoSpan(iconName, this.gos));
      }

      eGui.appendChild(pointer);
    }
  }, {
    key: "getClassName",
    value: function getClassName(suffix) {
      return "".concat(this.cssClassPrefix, "-").concat(suffix);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(_AgMenuItemRenderer.prototype), "destroy", this).call(this);
    }
  }]);

  return _AgMenuItemRenderer;
}(_Component2); // community-modules/core/src/components/framework/userComponentRegistry.ts


var _UserComponentRegistry =
/*#__PURE__*/
function (_BeanStub18) {
  "use strict";

  _inherits(_UserComponentRegistry, _BeanStub18);

  function _UserComponentRegistry() {
    var _this185;

    _classCallCheck(this, _UserComponentRegistry);

    _this185 = _possibleConstructorReturn(this, _getPrototypeOf(_UserComponentRegistry).apply(this, arguments));
    _this185.agGridDefaults = {
      //date
      agDateInput: DefaultDateComponent,
      //header
      agColumnHeader: HeaderComp,
      agColumnGroupHeader: HeaderGroupComp,
      agSortIndicator: _SortIndicatorComp2,
      //floating filters
      agTextColumnFloatingFilter: _TextFloatingFilter,
      agNumberColumnFloatingFilter: NumberFloatingFilter,
      agDateColumnFloatingFilter: DateFloatingFilter,
      agReadOnlyFloatingFilter: ReadOnlyFloatingFilter,
      // renderers
      agAnimateShowChangeCellRenderer: _AnimateShowChangeCellRenderer,
      agAnimateSlideCellRenderer: _AnimateSlideCellRenderer,
      agGroupCellRenderer: _GroupCellRenderer2,
      agGroupRowRenderer: _GroupCellRenderer2,
      agLoadingCellRenderer: LoadingCellRenderer,
      agSkeletonCellRenderer: SkeletonCellRenderer,
      agCheckboxCellRenderer: _CheckboxCellRenderer2,
      //editors
      agCellEditor: _TextCellEditor,
      agTextCellEditor: _TextCellEditor,
      agNumberCellEditor: _NumberCellEditor,
      agDateCellEditor: _DateCellEditor,
      agDateStringCellEditor: _DateStringCellEditor,
      agSelectCellEditor: _SelectCellEditor,
      agLargeTextCellEditor: _LargeTextCellEditor2,
      agCheckboxCellEditor: _CheckboxCellEditor,
      //filter
      agTextColumnFilter: _TextFilter2,
      agNumberColumnFilter: _NumberFilter2,
      agDateColumnFilter: _DateFilter2,
      //overlays
      agLoadingOverlay: LoadingOverlayComponent,
      agNoRowsOverlay: NoRowsOverlayComponent,
      // tooltips
      agTooltipComponent: TooltipComponent,
      // menu item
      agMenuItem: _AgMenuItemRenderer
    };
    /** Used to provide useful error messages if a user is trying to use an enterprise component without loading the module. */

    _this185.enterpriseAgDefaultCompsModule = {
      agSetColumnFilter: "@ag-grid-enterprise/set-filter"
      /* SetFilterModule */
      ,
      agSetColumnFloatingFilter: "@ag-grid-enterprise/set-filter"
      /* SetFilterModule */
      ,
      agMultiColumnFilter: "@ag-grid-enterprise/multi-filter"
      /* MultiFilterModule */
      ,
      agMultiColumnFloatingFilter: "@ag-grid-enterprise/multi-filter"
      /* MultiFilterModule */
      ,
      agGroupColumnFilter: "@ag-grid-enterprise/row-grouping"
      /* RowGroupingModule */
      ,
      agGroupColumnFloatingFilter: "@ag-grid-enterprise/row-grouping"
      /* RowGroupingModule */
      ,
      agRichSelect: "@ag-grid-enterprise/rich-select"
      /* RichSelectModule */
      ,
      agRichSelectCellEditor: "@ag-grid-enterprise/rich-select"
      /* RichSelectModule */
      ,
      agDetailCellRenderer: "@ag-grid-enterprise/master-detail"
      /* MasterDetailModule */
      ,
      agSparklineCellRenderer: "@ag-grid-enterprise/sparklines"
      /* SparklinesModule */

    };
    _this185.jsComps = {};
    return _this185;
  }

  _createClass(_UserComponentRegistry, [{
    key: "init",
    value: function init() {
      var _this186 = this;

      var comps = this.gos.get("components");

      if (comps != null) {
        _iterateObject(comps, function (key, component) {
          return _this186.registerJsComponent(key, component);
        });
      }
    }
  }, {
    key: "registerDefaultComponent",
    value: function registerDefaultComponent(name, component) {
      if (this.agGridDefaults[name]) {
        console.error("Trying to overwrite a default component. You should call registerComponent");
        return;
      }

      this.agGridDefaults[name] = component;
    }
  }, {
    key: "registerJsComponent",
    value: function registerJsComponent(name, component) {
      this.jsComps[name] = component;
    }
  }, {
    key: "retrieve",
    value: function retrieve(propertyName, name) {
      var _this187 = this;

      var createResult = function createResult(component, componentFromFramework) {
        return {
          componentFromFramework: componentFromFramework,
          component: component
        };
      };

      var registeredViaFrameworkComp = this.getFrameworkOverrides().frameworkComponent(name, this.gos.get("components"));

      if (registeredViaFrameworkComp != null) {
        return createResult(registeredViaFrameworkComp, true);
      }

      var jsComponent = this.jsComps[name];

      if (jsComponent) {
        var isFwkComp = this.getFrameworkOverrides().isFrameworkComponent(jsComponent);
        return createResult(jsComponent, isFwkComp);
      }

      var defaultComponent = this.agGridDefaults[name];

      if (defaultComponent) {
        return createResult(defaultComponent, false);
      }

      var moduleForComponent = this.enterpriseAgDefaultCompsModule[name];

      if (moduleForComponent) {
        _ModuleRegistry2.__assertRegistered(moduleForComponent, "AG Grid '".concat(propertyName, "' component: ").concat(name), this.context.getGridId());
      } else {
        _doOnce(function () {
          _this187.warnAboutMissingComponent(propertyName, name);
        }, "MissingComp" + name);
      }

      return null;
    }
  }, {
    key: "warnAboutMissingComponent",
    value: function warnAboutMissingComponent(propertyName, componentName) {
      var validComponents = [].concat(_toConsumableArray(Object.keys(this.agGridDefaults).filter(function (k) {
        return !["agCellEditor", "agGroupRowRenderer", "agSortIndicator"].includes(k);
      })), _toConsumableArray(Object.keys(this.jsComps)));

      var suggestions = _fuzzySuggestions(componentName, validComponents, true, 0.8).values;

      console.warn("AG Grid: Could not find '".concat(componentName, "' component. It was configured as \"").concat(propertyName, ": '").concat(componentName, "'\" but it wasn't found in the list of registered components."));

      if (suggestions.length > 0) {
        console.warn("         Did you mean: [".concat(suggestions.slice(0, 3), "]?"));
      }

      console.warn("If using a custom component check it has been registered as described in: ".concat(this.getFrameworkOverrides().getDocLink("components/")));
    }
  }]);

  return _UserComponentRegistry;
}(_BeanStub2);

__decorateClass([_PostConstruct], _UserComponentRegistry.prototype, "init", 1);

_UserComponentRegistry = __decorateClass([_Bean("userComponentRegistry")], _UserComponentRegistry); // community-modules/core/src/components/framework/componentTypes.ts

var DateComponent = {
  propertyName: "dateComponent",
  cellRenderer: false
};
var HeaderComponent = {
  propertyName: "headerComponent",
  cellRenderer: false
};
var HeaderGroupComponent = {
  propertyName: "headerGroupComponent",
  cellRenderer: false
};
var CellRendererComponent = {
  propertyName: "cellRenderer",
  cellRenderer: true
};
var LoadingCellRendererComponent = {
  propertyName: "loadingCellRenderer",
  cellRenderer: true
};
var CellEditorComponent = {
  propertyName: "cellEditor",
  cellRenderer: false
};
var InnerRendererComponent = {
  propertyName: "innerRenderer",
  cellRenderer: true
};
var LoadingOverlayComponent2 = {
  propertyName: "loadingOverlayComponent",
  cellRenderer: false
};
var NoRowsOverlayComponent2 = {
  propertyName: "noRowsOverlayComponent",
  cellRenderer: false
};
var TooltipComponent2 = {
  propertyName: "tooltipComponent",
  cellRenderer: false
};
var FilterComponent = {
  propertyName: "filter",
  cellRenderer: false
};
var FloatingFilterComponent = {
  propertyName: "floatingFilterComponent",
  cellRenderer: false
};
var ToolPanelComponent = {
  propertyName: "toolPanel",
  cellRenderer: false
};
var StatusPanelComponent = {
  propertyName: "statusPanel",
  cellRenderer: false
};
var FullWidth = {
  propertyName: "fullWidthCellRenderer",
  cellRenderer: true
};
var FullWidthLoading = {
  propertyName: "loadingCellRenderer",
  cellRenderer: true
};
var FullWidthGroup = {
  propertyName: "groupRowRenderer",
  cellRenderer: true
};
var FullWidthDetail = {
  propertyName: "detailCellRenderer",
  cellRenderer: true
};
var MenuItemComponent = {
  propertyName: "menuItem",
  cellRenderer: false
}; // community-modules/core/src/filter/floating/floatingFilterMapper.ts

var _FloatingFilterMapper =
/*#__PURE__*/
function () {
  "use strict";

  function _FloatingFilterMapper() {
    _classCallCheck(this, _FloatingFilterMapper);
  }

  _createClass(_FloatingFilterMapper, null, [{
    key: "getFloatingFilterType",
    value: function getFloatingFilterType(filterType) {
      return this.filterToFloatingFilterMapping[filterType];
    }
  }]);

  return _FloatingFilterMapper;
}();

_FloatingFilterMapper.filterToFloatingFilterMapping = {
  set: "agSetColumnFloatingFilter",
  agSetColumnFilter: "agSetColumnFloatingFilter",
  multi: "agMultiColumnFloatingFilter",
  agMultiColumnFilter: "agMultiColumnFloatingFilter",
  group: "agGroupColumnFloatingFilter",
  agGroupColumnFilter: "agGroupColumnFloatingFilter",
  number: "agNumberColumnFloatingFilter",
  agNumberColumnFilter: "agNumberColumnFloatingFilter",
  date: "agDateColumnFloatingFilter",
  agDateColumnFilter: "agDateColumnFloatingFilter",
  text: "agTextColumnFloatingFilter",
  agTextColumnFilter: "agTextColumnFloatingFilter"
}; // community-modules/core/src/components/framework/userComponentFactory.ts

var _UserComponentFactory =
/*#__PURE__*/
function (_BeanStub19) {
  "use strict";

  _inherits(_UserComponentFactory, _BeanStub19);

  function _UserComponentFactory() {
    _classCallCheck(this, _UserComponentFactory);

    return _possibleConstructorReturn(this, _getPrototypeOf(_UserComponentFactory).apply(this, arguments));
  }

  _createClass(_UserComponentFactory, [{
    key: "getHeaderCompDetails",
    value: function getHeaderCompDetails(colDef, params) {
      return this.getCompDetails(colDef, HeaderComponent, "agColumnHeader", params);
    }
  }, {
    key: "getHeaderGroupCompDetails",
    value: function getHeaderGroupCompDetails(params) {
      var colGroupDef = params.columnGroup.getColGroupDef();
      return this.getCompDetails(colGroupDef, HeaderGroupComponent, "agColumnGroupHeader", params);
    } // this one is unusual, as it can be LoadingCellRenderer, DetailCellRenderer, FullWidthCellRenderer or GroupRowRenderer.
    // so we have to pass the type in.

  }, {
    key: "getFullWidthCellRendererDetails",
    value: function getFullWidthCellRendererDetails(params) {
      return this.getCompDetails(this.gridOptions, FullWidth, null, params, true);
    }
  }, {
    key: "getFullWidthLoadingCellRendererDetails",
    value: function getFullWidthLoadingCellRendererDetails(params) {
      return this.getCompDetails(this.gridOptions, FullWidthLoading, "agLoadingCellRenderer", params, true);
    }
  }, {
    key: "getFullWidthGroupCellRendererDetails",
    value: function getFullWidthGroupCellRendererDetails(params) {
      return this.getCompDetails(this.gridOptions, FullWidthGroup, "agGroupRowRenderer", params, true);
    }
  }, {
    key: "getFullWidthDetailCellRendererDetails",
    value: function getFullWidthDetailCellRendererDetails(params) {
      return this.getCompDetails(this.gridOptions, FullWidthDetail, "agDetailCellRenderer", params, true);
    } // CELL RENDERER

  }, {
    key: "getInnerRendererDetails",
    value: function getInnerRendererDetails(def, params) {
      return this.getCompDetails(def, InnerRendererComponent, null, params);
    }
  }, {
    key: "getFullWidthGroupRowInnerCellRenderer",
    value: function getFullWidthGroupRowInnerCellRenderer(def, params) {
      return this.getCompDetails(def, InnerRendererComponent, null, params);
    }
  }, {
    key: "getCellRendererDetails",
    value: function getCellRendererDetails(def, params) {
      return this.getCompDetails(def, CellRendererComponent, null, params);
    }
  }, {
    key: "getLoadingCellRendererDetails",
    value: function getLoadingCellRendererDetails(def, params) {
      return this.getCompDetails(def, LoadingCellRendererComponent, "agSkeletonCellRenderer", params, true);
    } // CELL EDITOR

  }, {
    key: "getCellEditorDetails",
    value: function getCellEditorDetails(def, params) {
      return this.getCompDetails(def, CellEditorComponent, "agCellEditor", params, true);
    } // FILTER

  }, {
    key: "getFilterDetails",
    value: function getFilterDetails(def, params, defaultFilter) {
      return this.getCompDetails(def, FilterComponent, defaultFilter, params, true);
    }
  }, {
    key: "getDateCompDetails",
    value: function getDateCompDetails(params) {
      return this.getCompDetails(this.gridOptions, DateComponent, "agDateInput", params, true);
    }
  }, {
    key: "getLoadingOverlayCompDetails",
    value: function getLoadingOverlayCompDetails(params) {
      return this.getCompDetails(this.gridOptions, LoadingOverlayComponent2, "agLoadingOverlay", params, true);
    }
  }, {
    key: "getNoRowsOverlayCompDetails",
    value: function getNoRowsOverlayCompDetails(params) {
      return this.getCompDetails(this.gridOptions, NoRowsOverlayComponent2, "agNoRowsOverlay", params, true);
    }
  }, {
    key: "getTooltipCompDetails",
    value: function getTooltipCompDetails(params) {
      return this.getCompDetails(params.colDef, TooltipComponent2, "agTooltipComponent", params, true);
    }
  }, {
    key: "getSetFilterCellRendererDetails",
    value: function getSetFilterCellRendererDetails(def, params) {
      return this.getCompDetails(def, CellRendererComponent, null, params);
    }
  }, {
    key: "getFloatingFilterCompDetails",
    value: function getFloatingFilterCompDetails(def, params, defaultFloatingFilter) {
      return this.getCompDetails(def, FloatingFilterComponent, defaultFloatingFilter, params);
    }
  }, {
    key: "getToolPanelCompDetails",
    value: function getToolPanelCompDetails(toolPanelDef, params) {
      return this.getCompDetails(toolPanelDef, ToolPanelComponent, null, params, true);
    }
  }, {
    key: "getStatusPanelCompDetails",
    value: function getStatusPanelCompDetails(def, params) {
      return this.getCompDetails(def, StatusPanelComponent, null, params, true);
    }
  }, {
    key: "getMenuItemCompDetails",
    value: function getMenuItemCompDetails(def, params) {
      return this.getCompDetails(def, MenuItemComponent, "agMenuItem", params, true);
    }
  }, {
    key: "getCompDetails",
    value: function getCompDetails(defObject, type, defaultName, params) {
      var _this188 = this;

      var mandatory = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var propertyName = type.propertyName,
          cellRenderer = type.cellRenderer;

      var _this$getCompKeys = this.getCompKeys(defObject, type, params),
          compName = _this$getCompKeys.compName,
          jsComp = _this$getCompKeys.jsComp,
          fwComp = _this$getCompKeys.fwComp,
          paramsFromSelector = _this$getCompKeys.paramsFromSelector,
          popupFromSelector = _this$getCompKeys.popupFromSelector,
          popupPositionFromSelector = _this$getCompKeys.popupPositionFromSelector;

      var lookupFromRegistry = function lookupFromRegistry(key) {
        var item = _this188.userComponentRegistry.retrieve(propertyName, key);

        if (item) {
          jsComp = !item.componentFromFramework ? item.component : void 0;
          fwComp = item.componentFromFramework ? item.component : void 0;
        }
      };

      if (compName != null) {
        lookupFromRegistry(compName);
      }

      if (jsComp == null && fwComp == null && defaultName != null) {
        lookupFromRegistry(defaultName);
      }

      if (jsComp && cellRenderer && !this.agComponentUtils.doesImplementIComponent(jsComp)) {
        jsComp = this.agComponentUtils.adaptFunction(propertyName, jsComp);
      }

      if (!jsComp && !fwComp) {
        if (mandatory) {
          console.error("AG Grid: Could not find component ".concat(compName, ", did you forget to configure this component?"));
        }

        return;
      }

      var paramsMerged = this.mergeParamsWithApplicationProvidedParams(defObject, type, params, paramsFromSelector);
      var componentFromFramework = jsComp == null;
      var componentClass = jsComp ? jsComp : fwComp;
      return {
        componentFromFramework: componentFromFramework,
        componentClass: componentClass,
        params: paramsMerged,
        type: type,
        popupFromSelector: popupFromSelector,
        popupPositionFromSelector: popupPositionFromSelector,
        newAgStackInstance: function newAgStackInstance() {
          return _this188.newAgStackInstance(componentClass, componentFromFramework, paramsMerged, type);
        }
      };
    }
  }, {
    key: "getCompKeys",
    value: function getCompKeys(defObject, type, params) {
      var _this189 = this;

      var propertyName = type.propertyName;
      var compName;
      var jsComp;
      var fwComp;
      var paramsFromSelector;
      var popupFromSelector;
      var popupPositionFromSelector;

      if (defObject) {
        var defObjectAny = defObject;
        var selectorFunc = defObjectAny[propertyName + "Selector"];
        var selectorRes = selectorFunc ? selectorFunc(params) : null;

        var assignComp = function assignComp(providedJsComp) {
          if (typeof providedJsComp === "string") {
            compName = providedJsComp;
          } else if (providedJsComp != null && providedJsComp !== true) {
            var isFwkComp = _this189.getFrameworkOverrides().isFrameworkComponent(providedJsComp);

            if (isFwkComp) {
              fwComp = providedJsComp;
            } else {
              jsComp = providedJsComp;
            }
          }
        };

        if (selectorRes) {
          assignComp(selectorRes.component);
          paramsFromSelector = selectorRes.params;
          popupFromSelector = selectorRes.popup;
          popupPositionFromSelector = selectorRes.popupPosition;
        } else {
          assignComp(defObjectAny[propertyName]);
        }
      }

      return {
        compName: compName,
        jsComp: jsComp,
        fwComp: fwComp,
        paramsFromSelector: paramsFromSelector,
        popupFromSelector: popupFromSelector,
        popupPositionFromSelector: popupPositionFromSelector
      };
    }
  }, {
    key: "newAgStackInstance",
    value: function newAgStackInstance(ComponentClass, componentFromFramework, params, type) {
      var propertyName = type.propertyName;
      var jsComponent = !componentFromFramework;
      var instance;

      if (jsComponent) {
        instance = new ComponentClass();
      } else {
        var thisComponentConfig = this.componentMetadataProvider.retrieve(propertyName);
        instance = this.frameworkComponentWrapper.wrap(ComponentClass, thisComponentConfig.mandatoryMethodList, thisComponentConfig.optionalMethodList, type);
      }

      var deferredInit = this.initComponent(instance, params);

      if (deferredInit == null) {
        return _AgPromise2.resolve(instance);
      }

      return deferredInit.then(function () {
        return instance;
      });
    } // used by Floating Filter

  }, {
    key: "mergeParamsWithApplicationProvidedParams",
    value: function mergeParamsWithApplicationProvidedParams(defObject, type, paramsFromGrid) {
      var paramsFromSelector = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var params = this.gos.getGridCommonParams();

      _mergeDeep(params, paramsFromGrid);

      var defObjectAny = defObject;
      var userParams = defObjectAny && defObjectAny[type.propertyName + "Params"];

      if (typeof userParams === "function") {
        var userParamsFromFunc = userParams(paramsFromGrid);

        _mergeDeep(params, userParamsFromFunc);
      } else if (typeof userParams === "object") {
        _mergeDeep(params, userParams);
      }

      _mergeDeep(params, paramsFromSelector);

      return params;
    }
  }, {
    key: "initComponent",
    value: function initComponent(component, params) {
      this.context.createBean(component);

      if (component.init == null) {
        return;
      }

      return component.init(params);
    }
  }, {
    key: "getDefaultFloatingFilterType",
    value: function getDefaultFloatingFilterType(def, getFromDefault) {
      if (def == null) {
        return null;
      }

      var defaultFloatingFilterType = null;

      var _this$getCompKeys2 = this.getCompKeys(def, FilterComponent),
          compName = _this$getCompKeys2.compName,
          jsComp = _this$getCompKeys2.jsComp,
          fwComp = _this$getCompKeys2.fwComp;

      if (compName) {
        defaultFloatingFilterType = _FloatingFilterMapper.getFloatingFilterType(compName);
      } else {
        var usingDefaultFilter = jsComp == null && fwComp == null && def.filter === true;

        if (usingDefaultFilter) {
          defaultFloatingFilterType = getFromDefault();
        }
      }

      return defaultFloatingFilterType;
    }
  }]);

  return _UserComponentFactory;
}(_BeanStub2);

__decorateClass([_Autowired("gridOptions")], _UserComponentFactory.prototype, "gridOptions", 2);

__decorateClass([_Autowired("agComponentUtils")], _UserComponentFactory.prototype, "agComponentUtils", 2);

__decorateClass([_Autowired("componentMetadataProvider")], _UserComponentFactory.prototype, "componentMetadataProvider", 2);

__decorateClass([_Autowired("userComponentRegistry")], _UserComponentFactory.prototype, "userComponentRegistry", 2);

__decorateClass([_Optional("frameworkComponentWrapper")], _UserComponentFactory.prototype, "frameworkComponentWrapper", 2);

_UserComponentFactory = __decorateClass([_Bean("userComponentFactory")], _UserComponentFactory); // community-modules/core/src/interfaces/iExcelCreator.ts

var _ExcelFactoryMode =
/* @__PURE__ */
function (ExcelFactoryMode2) {
  ExcelFactoryMode2[ExcelFactoryMode2["SINGLE_SHEET"] = 0] = "SINGLE_SHEET";
  ExcelFactoryMode2[ExcelFactoryMode2["MULTI_SHEET"] = 1] = "MULTI_SHEET";
  return ExcelFactoryMode2;
}(_ExcelFactoryMode || {}); // community-modules/core/src/interfaces/iRowNode.ts


var _RowHighlightPosition =
/* @__PURE__ */
function (RowHighlightPosition2) {
  RowHighlightPosition2[RowHighlightPosition2["Above"] = 0] = "Above";
  RowHighlightPosition2[RowHighlightPosition2["Below"] = 1] = "Below";
  return RowHighlightPosition2;
}(_RowHighlightPosition || {}); // community-modules/core/src/autoScrollService.ts


var _AutoScrollService =
/*#__PURE__*/
function () {
  "use strict";

  function _AutoScrollService(params) {
    _classCallCheck(this, _AutoScrollService);

    this.tickingInterval = null;
    this.onScrollCallback = null;
    this.scrollContainer = params.scrollContainer;
    this.scrollHorizontally = params.scrollAxis.indexOf("x") !== -1;
    this.scrollVertically = params.scrollAxis.indexOf("y") !== -1;
    this.scrollByTick = params.scrollByTick != null ? params.scrollByTick : 20;

    if (params.onScrollCallback) {
      this.onScrollCallback = params.onScrollCallback;
    }

    if (this.scrollVertically) {
      this.getVerticalPosition = params.getVerticalPosition;
      this.setVerticalPosition = params.setVerticalPosition;
    }

    if (this.scrollHorizontally) {
      this.getHorizontalPosition = params.getHorizontalPosition;
      this.setHorizontalPosition = params.setHorizontalPosition;
    }

    this.shouldSkipVerticalScroll = params.shouldSkipVerticalScroll || function () {
      return false;
    };

    this.shouldSkipHorizontalScroll = params.shouldSkipHorizontalScroll || function () {
      return false;
    };
  }

  _createClass(_AutoScrollService, [{
    key: "check",
    value: function check(mouseEvent) {
      var forceSkipVerticalScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var skipVerticalScroll = forceSkipVerticalScroll || this.shouldSkipVerticalScroll();

      if (skipVerticalScroll && this.shouldSkipHorizontalScroll()) {
        return;
      }

      var rect = this.scrollContainer.getBoundingClientRect();
      var scrollTick = this.scrollByTick;
      this.tickLeft = mouseEvent.clientX < rect.left + scrollTick;
      this.tickRight = mouseEvent.clientX > rect.right - scrollTick;
      this.tickUp = mouseEvent.clientY < rect.top + scrollTick && !skipVerticalScroll;
      this.tickDown = mouseEvent.clientY > rect.bottom - scrollTick && !skipVerticalScroll;

      if (this.tickLeft || this.tickRight || this.tickUp || this.tickDown) {
        this.ensureTickingStarted();
      } else {
        this.ensureCleared();
      }
    }
  }, {
    key: "ensureTickingStarted",
    value: function ensureTickingStarted() {
      if (this.tickingInterval === null) {
        this.tickingInterval = window.setInterval(this.doTick.bind(this), 100);
        this.tickCount = 0;
      }
    }
  }, {
    key: "doTick",
    value: function doTick() {
      this.tickCount++;
      var tickAmount;
      tickAmount = this.tickCount > 20 ? 200 : this.tickCount > 10 ? 80 : 40;

      if (this.scrollVertically) {
        var vScrollPosition = this.getVerticalPosition();

        if (this.tickUp) {
          this.setVerticalPosition(vScrollPosition - tickAmount);
        }

        if (this.tickDown) {
          this.setVerticalPosition(vScrollPosition + tickAmount);
        }
      }

      if (this.scrollHorizontally) {
        var hScrollPosition = this.getHorizontalPosition();

        if (this.tickLeft) {
          this.setHorizontalPosition(hScrollPosition - tickAmount);
        }

        if (this.tickRight) {
          this.setHorizontalPosition(hScrollPosition + tickAmount);
        }
      }

      if (this.onScrollCallback) {
        this.onScrollCallback();
      }
    }
  }, {
    key: "ensureCleared",
    value: function ensureCleared() {
      if (this.tickingInterval) {
        window.clearInterval(this.tickingInterval);
        this.tickingInterval = null;
      }
    }
  }]);

  return _AutoScrollService;
}(); // community-modules/core/src/gridBodyComp/rowDragFeature.ts


var RowDragFeature =
/*#__PURE__*/
function (_BeanStub20) {
  "use strict";

  _inherits(RowDragFeature, _BeanStub20);

  function RowDragFeature(eContainer) {
    var _this190;

    _classCallCheck(this, RowDragFeature);

    _this190 = _possibleConstructorReturn(this, _getPrototypeOf(RowDragFeature).call(this));
    _this190.eContainer = eContainer;
    return _this190;
  }

  _createClass(RowDragFeature, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this191 = this;

      if (this.gos.isRowModelType("clientSide")) {
        this.clientSideRowModel = this.rowModel;
      }

      this.ctrlsService.whenReady(function (p) {
        var gridBodyCon = p.gridBodyCtrl;
        _this191.autoScrollService = new _AutoScrollService({
          scrollContainer: gridBodyCon.getBodyViewportElement(),
          scrollAxis: "y",
          getVerticalPosition: function getVerticalPosition() {
            return gridBodyCon.getScrollFeature().getVScrollPosition().top;
          },
          setVerticalPosition: function setVerticalPosition(position) {
            return gridBodyCon.getScrollFeature().setVerticalScrollPosition(position);
          },
          onScrollCallback: function onScrollCallback() {
            _this191.onDragging(_this191.lastDraggingEvent);
          }
        });
      });
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      return this.eContainer;
    }
  }, {
    key: "isInterestedIn",
    value: function isInterestedIn(type) {
      return type === 2
      /* RowDrag */
      ;
    }
  }, {
    key: "getIconName",
    value: function getIconName() {
      var managedDrag = this.gos.get("rowDragManaged");

      if (managedDrag && this.shouldPreventRowMove()) {
        return _DragAndDropService2.ICON_NOT_ALLOWED;
      }

      return _DragAndDropService2.ICON_MOVE;
    }
  }, {
    key: "shouldPreventRowMove",
    value: function shouldPreventRowMove() {
      var rowGroupCols = this.columnModel.getRowGroupColumns();

      if (rowGroupCols.length) {
        return true;
      }

      var isFilterPresent = this.filterManager.isAnyFilterPresent();

      if (isFilterPresent) {
        return true;
      }

      var isSortActive = this.sortController.isSortActive();

      if (isSortActive) {
        return true;
      }

      return false;
    }
  }, {
    key: "getRowNodes",
    value: function getRowNodes(draggingEvent) {
      var _this192 = this;

      if (!this.isFromThisGrid(draggingEvent)) {
        return draggingEvent.dragItem.rowNodes || [];
      }

      var isRowDragMultiRow = this.gos.get("rowDragMultiRow");

      var selectedNodes = _toConsumableArray(this.selectionService.getSelectedNodes()).sort(function (a, b) {
        if (a.rowIndex == null || b.rowIndex == null) {
          return 0;
        }

        return _this192.getRowIndexNumber(a) - _this192.getRowIndexNumber(b);
      });

      var currentNode = draggingEvent.dragItem.rowNode;

      if (isRowDragMultiRow && selectedNodes.indexOf(currentNode) !== -1) {
        return selectedNodes;
      }

      return [currentNode];
    }
  }, {
    key: "onDragEnter",
    value: function onDragEnter(draggingEvent) {
      draggingEvent.dragItem.rowNodes = this.getRowNodes(draggingEvent);
      this.dispatchGridEvent(_Events.EVENT_ROW_DRAG_ENTER, draggingEvent);
      this.getRowNodes(draggingEvent).forEach(function (rowNode) {
        rowNode.setDragging(true);
      });
      this.onEnterOrDragging(draggingEvent);
    }
  }, {
    key: "onDragging",
    value: function onDragging(draggingEvent) {
      this.onEnterOrDragging(draggingEvent);
    }
  }, {
    key: "isFromThisGrid",
    value: function isFromThisGrid(draggingEvent) {
      var dragSourceDomDataKey = draggingEvent.dragSource.dragSourceDomDataKey;
      return dragSourceDomDataKey === this.gos.getDomDataKey();
    }
  }, {
    key: "isDropZoneWithinThisGrid",
    value: function isDropZoneWithinThisGrid(draggingEvent) {
      var gridBodyCon = this.ctrlsService.getGridBodyCtrl();
      var gridGui = gridBodyCon.getGui();
      var dropZoneTarget = draggingEvent.dropZoneTarget;
      return !gridGui.contains(dropZoneTarget);
    }
  }, {
    key: "onEnterOrDragging",
    value: function onEnterOrDragging(draggingEvent) {
      this.dispatchGridEvent(_Events.EVENT_ROW_DRAG_MOVE, draggingEvent);
      this.lastDraggingEvent = draggingEvent;
      var pixel = this.mouseEventService.getNormalisedPosition(draggingEvent).y;
      var managedDrag = this.gos.get("rowDragManaged");

      if (managedDrag) {
        this.doManagedDrag(draggingEvent, pixel);
      }

      this.autoScrollService.check(draggingEvent.event);
    }
  }, {
    key: "doManagedDrag",
    value: function doManagedDrag(draggingEvent, pixel) {
      var isFromThisGrid = this.isFromThisGrid(draggingEvent);
      var managedDrag = this.gos.get("rowDragManaged");
      var rowNodes = draggingEvent.dragItem.rowNodes;

      if (managedDrag && this.shouldPreventRowMove()) {
        return;
      }

      if (this.gos.get("suppressMoveWhenRowDragging") || !isFromThisGrid) {
        if (!this.isDropZoneWithinThisGrid(draggingEvent)) {
          this.clientSideRowModel.highlightRowAtPixel(rowNodes[0], pixel);
        }
      } else {
        this.moveRows(rowNodes, pixel);
      }
    }
  }, {
    key: "getRowIndexNumber",
    value: function getRowIndexNumber(rowNode) {
      return parseInt(_last(rowNode.getRowIndexString().split("-")), 10);
    }
  }, {
    key: "moveRowAndClearHighlight",
    value: function moveRowAndClearHighlight(draggingEvent) {
      var _this193 = this;

      var lastHighlightedRowNode = this.clientSideRowModel.getLastHighlightedRowNode();
      var isBelow = lastHighlightedRowNode && lastHighlightedRowNode.highlighted === 1
      /* Below */
      ;
      var pixel = this.mouseEventService.getNormalisedPosition(draggingEvent).y;
      var rowNodes = draggingEvent.dragItem.rowNodes;
      var increment = isBelow ? 1 : 0;

      if (this.isFromThisGrid(draggingEvent)) {
        rowNodes.forEach(function (rowNode) {
          if (rowNode.rowTop < pixel) {
            increment -= 1;
          }
        });
        this.moveRows(rowNodes, pixel, increment);
      } else {
        var getRowIdFunc = this.gos.getCallback("getRowId");
        var addIndex = this.clientSideRowModel.getRowIndexAtPixel(pixel) + 1;

        if (this.clientSideRowModel.getHighlightPosition(pixel) === 0
        /* Above */
        ) {
            addIndex--;
          }

        this.clientSideRowModel.updateRowData({
          add: rowNodes.map(function (node) {
            return node.data;
          }).filter(function (data) {
            return !_this193.clientSideRowModel.getRowNode(getRowIdFunc ? getRowIdFunc({
              data: data,
              level: 0
            }) : data.id);
          }),
          addIndex: addIndex
        });
      }

      this.clearRowHighlight();
    }
  }, {
    key: "clearRowHighlight",
    value: function clearRowHighlight() {
      this.clientSideRowModel.highlightRowAtPixel(null);
    }
  }, {
    key: "moveRows",
    value: function moveRows(rowNodes, pixel) {
      var increment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      var _a;

      var rowWasMoved = this.clientSideRowModel.ensureRowsAtPixel(rowNodes, pixel, increment);

      if (rowWasMoved) {
        this.focusService.clearFocusedCell();
        (_a = this.rangeService) == null ? void 0 : _a.removeAllCellRanges();
      }
    }
  }, {
    key: "addRowDropZone",
    value: function addRowDropZone(params) {
      var _this194 = this;

      if (!params.getContainer()) {
        _warnOnce("addRowDropZone - A container target needs to be provided");

        return;
      }

      if (this.dragAndDropService.findExternalZone(params)) {
        console.warn("AG Grid: addRowDropZone - target already exists in the list of DropZones. Use `removeRowDropZone` before adding it again.");
        return;
      }

      var processedParams = {
        getContainer: params.getContainer
      };

      if (params.fromGrid) {
        processedParams = params;
      } else {
        if (params.onDragEnter) {
          processedParams.onDragEnter = function (e) {
            params.onDragEnter(_this194.draggingToRowDragEvent(_Events.EVENT_ROW_DRAG_ENTER, e));
          };
        }

        if (params.onDragLeave) {
          processedParams.onDragLeave = function (e) {
            params.onDragLeave(_this194.draggingToRowDragEvent(_Events.EVENT_ROW_DRAG_LEAVE, e));
          };
        }

        if (params.onDragging) {
          processedParams.onDragging = function (e) {
            params.onDragging(_this194.draggingToRowDragEvent(_Events.EVENT_ROW_DRAG_MOVE, e));
          };
        }

        if (params.onDragStop) {
          processedParams.onDragStop = function (e) {
            params.onDragStop(_this194.draggingToRowDragEvent(_Events.EVENT_ROW_DRAG_END, e));
          };
        }
      }

      this.dragAndDropService.addDropTarget(__spreadValues({
        isInterestedIn: function isInterestedIn(type) {
          return type === 2;
        }
        /* RowDrag */
        ,
        getIconName: function getIconName() {
          return _DragAndDropService2.ICON_MOVE;
        },
        external: true
      }, processedParams));
    }
  }, {
    key: "getRowDropZone",
    value: function getRowDropZone(events) {
      var _this195 = this;

      var getContainer = this.getContainer.bind(this);
      var onDragEnter = this.onDragEnter.bind(this);
      var onDragLeave = this.onDragLeave.bind(this);
      var onDragging = this.onDragging.bind(this);
      var onDragStop = this.onDragStop.bind(this);

      if (!events) {
        return {
          getContainer: getContainer,
          onDragEnter: onDragEnter,
          onDragLeave: onDragLeave,
          onDragging: onDragging,
          onDragStop: onDragStop,

          /* @private */
          fromGrid: true
        };
      }

      return {
        getContainer: getContainer,
        onDragEnter: events.onDragEnter ? function (e) {
          onDragEnter(e);
          events.onDragEnter(_this195.draggingToRowDragEvent(_Events.EVENT_ROW_DRAG_ENTER, e));
        } : onDragEnter,
        onDragLeave: events.onDragLeave ? function (e) {
          onDragLeave(e);
          events.onDragLeave(_this195.draggingToRowDragEvent(_Events.EVENT_ROW_DRAG_LEAVE, e));
        } : onDragLeave,
        onDragging: events.onDragging ? function (e) {
          onDragging(e);
          events.onDragging(_this195.draggingToRowDragEvent(_Events.EVENT_ROW_DRAG_MOVE, e));
        } : onDragging,
        onDragStop: events.onDragStop ? function (e) {
          onDragStop(e);
          events.onDragStop(_this195.draggingToRowDragEvent(_Events.EVENT_ROW_DRAG_END, e));
        } : onDragStop,
        fromGrid: true
        /* @private */

      };
    }
  }, {
    key: "draggingToRowDragEvent",
    value: function draggingToRowDragEvent(type, draggingEvent) {
      var yNormalised = this.mouseEventService.getNormalisedPosition(draggingEvent).y;
      var mouseIsPastLastRow = yNormalised > this.paginationProxy.getCurrentPageHeight();
      var overIndex = -1;
      var overNode;

      if (!mouseIsPastLastRow) {
        overIndex = this.rowModel.getRowIndexAtPixel(yNormalised);
        overNode = this.rowModel.getRow(overIndex);
      }

      var vDirectionString;

      switch (draggingEvent.vDirection) {
        case 1
        /* Down */
        :
          vDirectionString = "down";
          break;

        case 0
        /* Up */
        :
          vDirectionString = "up";
          break;

        default:
          vDirectionString = null;
          break;
      }

      var event = this.gos.addGridCommonParams({
        type: type,
        event: draggingEvent.event,
        node: draggingEvent.dragItem.rowNode,
        nodes: draggingEvent.dragItem.rowNodes,
        overIndex: overIndex,
        overNode: overNode,
        y: yNormalised,
        vDirection: vDirectionString
      });
      return event;
    }
  }, {
    key: "dispatchGridEvent",
    value: function dispatchGridEvent(type, draggingEvent) {
      var event = this.draggingToRowDragEvent(type, draggingEvent);
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "onDragLeave",
    value: function onDragLeave(draggingEvent) {
      this.dispatchGridEvent(_Events.EVENT_ROW_DRAG_LEAVE, draggingEvent);
      this.stopDragging(draggingEvent);

      if (this.gos.get("rowDragManaged")) {
        this.clearRowHighlight();
      }
    }
  }, {
    key: "onDragStop",
    value: function onDragStop(draggingEvent) {
      this.dispatchGridEvent(_Events.EVENT_ROW_DRAG_END, draggingEvent);
      this.stopDragging(draggingEvent);

      if (this.gos.get("rowDragManaged") && (this.gos.get("suppressMoveWhenRowDragging") || !this.isFromThisGrid(draggingEvent)) && !this.isDropZoneWithinThisGrid(draggingEvent)) {
        this.moveRowAndClearHighlight(draggingEvent);
      }
    }
  }, {
    key: "stopDragging",
    value: function stopDragging(draggingEvent) {
      this.autoScrollService.ensureCleared();
      this.getRowNodes(draggingEvent).forEach(function (rowNode) {
        rowNode.setDragging(false);
      });
    }
  }]);

  return RowDragFeature;
}(_BeanStub2);

__decorateClass([_Autowired("dragAndDropService")], RowDragFeature.prototype, "dragAndDropService", 2);

__decorateClass([_Autowired("rowModel")], RowDragFeature.prototype, "rowModel", 2);

__decorateClass([_Autowired("paginationProxy")], RowDragFeature.prototype, "paginationProxy", 2);

__decorateClass([_Autowired("columnModel")], RowDragFeature.prototype, "columnModel", 2);

__decorateClass([_Autowired("focusService")], RowDragFeature.prototype, "focusService", 2);

__decorateClass([_Autowired("sortController")], RowDragFeature.prototype, "sortController", 2);

__decorateClass([_Autowired("filterManager")], RowDragFeature.prototype, "filterManager", 2);

__decorateClass([_Autowired("selectionService")], RowDragFeature.prototype, "selectionService", 2);

__decorateClass([_Autowired("mouseEventService")], RowDragFeature.prototype, "mouseEventService", 2);

__decorateClass([_Autowired("ctrlsService")], RowDragFeature.prototype, "ctrlsService", 2);

__decorateClass([_Optional("rangeService")], RowDragFeature.prototype, "rangeService", 2);

__decorateClass([_PostConstruct], RowDragFeature.prototype, "postConstruct", 1); // community-modules/core/src/dragAndDrop/dragService.ts


var _DragService =
/*#__PURE__*/
function (_BeanStub21) {
  "use strict";

  _inherits(_DragService, _BeanStub21);

  function _DragService() {
    var _this196;

    _classCallCheck(this, _DragService);

    _this196 = _possibleConstructorReturn(this, _getPrototypeOf(_DragService).apply(this, arguments));
    _this196.dragEndFunctions = [];
    _this196.dragSources = [];
    return _this196;
  }

  _createClass(_DragService, [{
    key: "removeAllListeners",
    value: function removeAllListeners() {
      this.dragSources.forEach(this.removeListener.bind(this));
      this.dragSources.length = 0;
    }
  }, {
    key: "removeListener",
    value: function removeListener(dragSourceAndListener) {
      var element = dragSourceAndListener.dragSource.eElement;
      var mouseDownListener = dragSourceAndListener.mouseDownListener;
      element.removeEventListener("mousedown", mouseDownListener);

      if (dragSourceAndListener.touchEnabled) {
        var touchStartListener = dragSourceAndListener.touchStartListener;
        element.removeEventListener("touchstart", touchStartListener, {
          passive: true
        });
      }
    }
  }, {
    key: "removeDragSource",
    value: function removeDragSource(params) {
      var dragSourceAndListener = this.dragSources.find(function (item) {
        return item.dragSource === params;
      });

      if (!dragSourceAndListener) {
        return;
      }

      this.removeListener(dragSourceAndListener);

      _removeFromArray(this.dragSources, dragSourceAndListener);
    }
  }, {
    key: "isDragging",
    value: function isDragging() {
      return this.dragging;
    }
  }, {
    key: "addDragSource",
    value: function addDragSource(params) {
      var _this197 = this;

      var mouseListener = this.onMouseDown.bind(this, params);
      var eElement = params.eElement,
          includeTouch = params.includeTouch,
          stopPropagationForTouch = params.stopPropagationForTouch;
      eElement.addEventListener("mousedown", mouseListener);
      var touchListener = null;
      var suppressTouch = this.gos.get("suppressTouch");

      if (includeTouch && !suppressTouch) {
        touchListener = function touchListener(touchEvent) {
          if (_isFocusableFormField(touchEvent.target)) {
            return;
          }

          if (touchEvent.cancelable) {
            touchEvent.preventDefault();

            if (stopPropagationForTouch) {
              touchEvent.stopPropagation();
            }
          }

          _this197.onTouchStart(params, touchEvent);
        };

        eElement.addEventListener("touchstart", touchListener, {
          passive: false
        });
      }

      this.dragSources.push({
        dragSource: params,
        mouseDownListener: mouseListener,
        touchStartListener: touchListener,
        touchEnabled: !!includeTouch
      });
    }
  }, {
    key: "getStartTarget",
    value: function getStartTarget() {
      return this.startTarget;
    } // gets called whenever mouse down on any drag source

  }, {
    key: "onTouchStart",
    value: function onTouchStart(params, touchEvent) {
      var _this198 = this;

      this.currentDragParams = params;
      this.dragging = false;
      var touch = touchEvent.touches[0];
      this.touchLastTime = touch;
      this.touchStart = touch;

      var touchMoveEvent = function touchMoveEvent(e) {
        return _this198.onTouchMove(e, params.eElement);
      };

      var touchEndEvent = function touchEndEvent(e) {
        return _this198.onTouchUp(e, params.eElement);
      };

      var documentTouchMove = function documentTouchMove(e) {
        if (e.cancelable) {
          e.preventDefault();
        }
      };

      var target = touchEvent.target;
      var events = [// Prevents the page document from moving while we are dragging items around.
      // preventDefault needs to be called in the touchmove listener and never inside the
      // touchstart, because using touchstart causes the click event to be cancelled on touch devices.
      {
        target: this.gos.getRootNode(),
        type: "touchmove",
        listener: documentTouchMove,
        options: {
          passive: false
        }
      }, {
        target: target,
        type: "touchmove",
        listener: touchMoveEvent,
        options: {
          passive: true
        }
      }, {
        target: target,
        type: "touchend",
        listener: touchEndEvent,
        options: {
          passive: true
        }
      }, {
        target: target,
        type: "touchcancel",
        listener: touchEndEvent,
        options: {
          passive: true
        }
      }];
      this.addTemporaryEvents(events);

      if (params.dragStartPixels === 0) {
        this.onCommonMove(touch, this.touchStart, params.eElement);
      }
    } // gets called whenever mouse down on any drag source

  }, {
    key: "onMouseDown",
    value: function onMouseDown(params, mouseEvent) {
      var _this199 = this;

      var e = mouseEvent;

      if (params.skipMouseEvent && params.skipMouseEvent(mouseEvent)) {
        return;
      }

      if (e._alreadyProcessedByDragService) {
        return;
      }

      e._alreadyProcessedByDragService = true;

      if (mouseEvent.button !== 0) {
        return;
      }

      if (this.shouldPreventMouseEvent(mouseEvent)) {
        mouseEvent.preventDefault();
      }

      this.currentDragParams = params;
      this.dragging = false;
      this.mouseStartEvent = mouseEvent;
      this.startTarget = mouseEvent.target;

      var mouseMoveEvent = function mouseMoveEvent(event) {
        return _this199.onMouseMove(event, params.eElement);
      };

      var mouseUpEvent = function mouseUpEvent(event) {
        return _this199.onMouseUp(event, params.eElement);
      };

      var contextEvent = function contextEvent(event) {
        return event.preventDefault();
      };

      var target = this.gos.getRootNode();
      var events = [{
        target: target,
        type: "mousemove",
        listener: mouseMoveEvent
      }, {
        target: target,
        type: "mouseup",
        listener: mouseUpEvent
      }, {
        target: target,
        type: "contextmenu",
        listener: contextEvent
      }];
      this.addTemporaryEvents(events);

      if (params.dragStartPixels === 0) {
        this.onMouseMove(mouseEvent, params.eElement);
      }
    }
  }, {
    key: "addTemporaryEvents",
    value: function addTemporaryEvents(events) {
      events.forEach(function (currentEvent) {
        var target = currentEvent.target,
            type = currentEvent.type,
            listener = currentEvent.listener,
            options = currentEvent.options;
        target.addEventListener(type, listener, options);
      });
      this.dragEndFunctions.push(function () {
        events.forEach(function (currentEvent) {
          var target = currentEvent.target,
              type = currentEvent.type,
              listener = currentEvent.listener,
              options = currentEvent.options;
          target.removeEventListener(type, listener, options);
        });
      });
    } // returns true if the event is close to the original event by X pixels either vertically or horizontally.
    // we only start dragging after X pixels so this allows us to know if we should start dragging yet.

  }, {
    key: "isEventNearStartEvent",
    value: function isEventNearStartEvent(currentEvent, startEvent) {
      var dragStartPixels = this.currentDragParams.dragStartPixels;
      var requiredPixelDiff = _exists(dragStartPixels) ? dragStartPixels : 4;
      return _areEventsNear(currentEvent, startEvent, requiredPixelDiff);
    }
  }, {
    key: "getFirstActiveTouch",
    value: function getFirstActiveTouch(touchList) {
      for (var i = 0; i < touchList.length; i++) {
        if (touchList[i].identifier === this.touchStart.identifier) {
          return touchList[i];
        }
      }

      return null;
    }
  }, {
    key: "onCommonMove",
    value: function onCommonMove(currentEvent, startEvent, el) {
      if (!this.dragging) {
        if (!this.dragging && this.isEventNearStartEvent(currentEvent, startEvent)) {
          return;
        }

        this.dragging = true;
        var event = {
          type: _Events.EVENT_DRAG_STARTED,
          target: el
        };
        this.eventService.dispatchEvent(event);
        this.currentDragParams.onDragStart(startEvent);
        this.currentDragParams.onDragging(startEvent);
      }

      this.currentDragParams.onDragging(currentEvent);
    }
  }, {
    key: "onTouchMove",
    value: function onTouchMove(touchEvent, el) {
      var touch = this.getFirstActiveTouch(touchEvent.touches);

      if (!touch) {
        return;
      }

      this.onCommonMove(touch, this.touchStart, el);
    } // only gets called after a mouse down - as this is only added after mouseDown
    // and is removed when mouseUp happens

  }, {
    key: "onMouseMove",
    value: function onMouseMove(mouseEvent, el) {
      var _a;

      if (_isBrowserSafari()) {
        var eDocument = this.gos.getDocument();
        (_a = eDocument.getSelection()) == null ? void 0 : _a.removeAllRanges();
      }

      if (this.shouldPreventMouseEvent(mouseEvent)) {
        mouseEvent.preventDefault();
      }

      this.onCommonMove(mouseEvent, this.mouseStartEvent, el);
    }
  }, {
    key: "shouldPreventMouseEvent",
    value: function shouldPreventMouseEvent(mouseEvent) {
      var isEnableCellTextSelect = this.gos.get("enableCellTextSelection");
      var isMouseMove = mouseEvent.type === "mousemove";
      return (// when `isEnableCellTextSelect` is `true`, we need to preventDefault on mouseMove
        // to avoid the grid text being selected while dragging components.
        isEnableCellTextSelect && isMouseMove && mouseEvent.cancelable && this.mouseEventService.isEventFromThisGrid(mouseEvent) && !this.isOverFormFieldElement(mouseEvent)
      );
    }
  }, {
    key: "isOverFormFieldElement",
    value: function isOverFormFieldElement(mouseEvent) {
      var el = mouseEvent.target;
      var tagName = el == null ? void 0 : el.tagName.toLocaleLowerCase();
      return !!(tagName == null ? void 0 : tagName.match("^a$|textarea|input|select|button"));
    }
  }, {
    key: "onTouchUp",
    value: function onTouchUp(touchEvent, el) {
      var touch = this.getFirstActiveTouch(touchEvent.changedTouches);

      if (!touch) {
        touch = this.touchLastTime;
      }

      this.onUpCommon(touch, el);
    }
  }, {
    key: "onMouseUp",
    value: function onMouseUp(mouseEvent, el) {
      this.onUpCommon(mouseEvent, el);
    }
  }, {
    key: "onUpCommon",
    value: function onUpCommon(eventOrTouch, el) {
      if (this.dragging) {
        this.dragging = false;
        this.currentDragParams.onDragStop(eventOrTouch);
        var event = {
          type: _Events.EVENT_DRAG_STOPPED,
          target: el
        };
        this.eventService.dispatchEvent(event);
      }

      this.mouseStartEvent = null;
      this.startTarget = null;
      this.touchStart = null;
      this.touchLastTime = null;
      this.currentDragParams = null;
      this.dragEndFunctions.forEach(function (func) {
        return func();
      });
      this.dragEndFunctions.length = 0;
    }
  }]);

  return _DragService;
}(_BeanStub2);

__decorateClass([_Autowired("mouseEventService")], _DragService.prototype, "mouseEventService", 2);

__decorateClass([_PreDestroy], _DragService.prototype, "removeAllListeners", 1);

_DragService = __decorateClass([_Bean("dragService")], _DragService); // community-modules/core/src/dragAndDrop/virtualListDragFeature.ts

var LIST_ITEM_HOVERED = "ag-list-item-hovered";

var _VirtualListDragFeature =
/*#__PURE__*/
function (_BeanStub22) {
  "use strict";

  _inherits(_VirtualListDragFeature, _BeanStub22);

  function _VirtualListDragFeature(comp, virtualList, params) {
    var _this200;

    _classCallCheck(this, _VirtualListDragFeature);

    _this200 = _possibleConstructorReturn(this, _getPrototypeOf(_VirtualListDragFeature).call(this));
    _this200.comp = comp;
    _this200.virtualList = virtualList;
    _this200.params = params;
    _this200.currentDragValue = null;
    _this200.lastHoveredListItem = null;
    return _this200;
  }

  _createClass(_VirtualListDragFeature, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.addManagedListener(this.params.eventSource, this.params.listItemDragStartEvent, this.listItemDragStart.bind(this));
      this.addManagedListener(this.params.eventSource, this.params.listItemDragEndEvent, this.listItemDragEnd.bind(this));
      this.createDropTarget();
      this.createAutoScrollService();
    }
  }, {
    key: "listItemDragStart",
    value: function listItemDragStart(event) {
      this.currentDragValue = this.params.getCurrentDragValue(event);
      this.moveBlocked = this.params.isMoveBlocked(this.currentDragValue);
    }
  }, {
    key: "listItemDragEnd",
    value: function listItemDragEnd() {
      var _this201 = this;

      window.setTimeout(function () {
        _this201.currentDragValue = null;
        _this201.moveBlocked = false;
      }, 10);
    }
  }, {
    key: "createDropTarget",
    value: function createDropTarget() {
      var _this202 = this;

      var dropTarget = {
        isInterestedIn: function isInterestedIn(type) {
          return type === _this202.params.dragSourceType;
        },
        getIconName: function getIconName() {
          return _this202.moveBlocked ? _DragAndDropService2.ICON_PINNED : _DragAndDropService2.ICON_MOVE;
        },
        getContainer: function getContainer() {
          return _this202.comp.getGui();
        },
        onDragging: function onDragging(e) {
          return _this202.onDragging(e);
        },
        onDragStop: function onDragStop() {
          return _this202.onDragStop();
        },
        onDragLeave: function onDragLeave() {
          return _this202.onDragLeave();
        }
      };
      this.dragAndDropService.addDropTarget(dropTarget);
    }
  }, {
    key: "createAutoScrollService",
    value: function createAutoScrollService() {
      var virtualListGui = this.virtualList.getGui();
      this.autoScrollService = new _AutoScrollService({
        scrollContainer: virtualListGui,
        scrollAxis: "y",
        getVerticalPosition: function getVerticalPosition() {
          return virtualListGui.scrollTop;
        },
        setVerticalPosition: function setVerticalPosition(position) {
          return virtualListGui.scrollTop = position;
        }
      });
    }
  }, {
    key: "onDragging",
    value: function onDragging(e) {
      if (!this.currentDragValue || this.moveBlocked) {
        return;
      }

      var hoveredListItem = this.getListDragItem(e);
      var comp = this.virtualList.getComponentAt(hoveredListItem.rowIndex);

      if (!comp) {
        return;
      }

      var el = comp.getGui().parentElement;

      if (this.lastHoveredListItem && this.lastHoveredListItem.rowIndex === hoveredListItem.rowIndex && this.lastHoveredListItem.position === hoveredListItem.position) {
        return;
      }

      this.autoScrollService.check(e.event);
      this.clearHoveredItems();
      this.lastHoveredListItem = hoveredListItem;

      _radioCssClass(el, LIST_ITEM_HOVERED);

      _radioCssClass(el, "ag-item-highlight-".concat(hoveredListItem.position));
    }
  }, {
    key: "getListDragItem",
    value: function getListDragItem(e) {
      var virtualListGui = this.virtualList.getGui();
      var paddingTop = parseFloat(window.getComputedStyle(virtualListGui).paddingTop);
      var rowHeight = this.virtualList.getRowHeight();
      var scrollTop = this.virtualList.getScrollTop();
      var rowIndex = Math.max(0, (e.y - paddingTop + scrollTop) / rowHeight);
      var maxLen = this.params.getNumRows(this.comp) - 1;
      var normalizedRowIndex = Math.min(maxLen, rowIndex) | 0;
      return {
        rowIndex: normalizedRowIndex,
        position: Math.round(rowIndex) > rowIndex || rowIndex > maxLen ? "bottom" : "top",
        component: this.virtualList.getComponentAt(normalizedRowIndex)
      };
    }
  }, {
    key: "onDragStop",
    value: function onDragStop() {
      if (this.moveBlocked) {
        return;
      }

      this.params.moveItem(this.currentDragValue, this.lastHoveredListItem);
      this.clearHoveredItems();
      this.autoScrollService.ensureCleared();
    }
  }, {
    key: "onDragLeave",
    value: function onDragLeave() {
      this.clearHoveredItems();
      this.autoScrollService.ensureCleared();
    }
  }, {
    key: "clearHoveredItems",
    value: function clearHoveredItems() {
      var virtualListGui = this.virtualList.getGui();
      virtualListGui.querySelectorAll(".".concat(LIST_ITEM_HOVERED)).forEach(function (el) {
        [LIST_ITEM_HOVERED, "ag-item-highlight-top", "ag-item-highlight-bottom"].forEach(function (cls) {
          el.classList.remove(cls);
        });
      });
      this.lastHoveredListItem = null;
    }
  }]);

  return _VirtualListDragFeature;
}(_BeanStub2);

__decorateClass([_Autowired("dragAndDropService")], _VirtualListDragFeature.prototype, "dragAndDropService", 2);

__decorateClass([_PostConstruct], _VirtualListDragFeature.prototype, "postConstruct", 1); // community-modules/core/src/gridApi.ts


function unwrapUserComp(comp) {
  var compAsAny = comp;
  var isProxy = compAsAny != null && compAsAny.getFrameworkComponentInstance != null;
  return isProxy ? compAsAny.getFrameworkComponentInstance() : comp;
}

var _GridApi =
/*#__PURE__*/
function () {
  "use strict";

  function _GridApi() {
    _classCallCheck(this, _GridApi);

    this.detailGridInfoMap = {};
    this.destroyCalled = false;
  }

  _createClass(_GridApi, [{
    key: "init",
    value: function init() {
      var _this203 = this;

      switch (this.rowModel.getType()) {
        case "clientSide":
          this.clientSideRowModel = this.rowModel;
          break;

        case "infinite":
          this.infiniteRowModel = this.rowModel;
          break;

        case "serverSide":
          this.serverSideRowModel = this.rowModel;
          break;
      }

      this.ctrlsService.whenReady(function (p) {
        _this203.gridBodyCtrl = p.gridBodyCtrl;
      });
    }
    /** Used internally by grid. Not intended to be used by the client. Interface may change between releases. */

  }, {
    key: "__getAlignedGridService",
    value: function __getAlignedGridService() {
      return this.alignedGridsService;
    }
    /** Returns the `gridId` for the current grid as specified via the gridOptions property `gridId` or the auto assigned grid id if none was provided. */

  }, {
    key: "getGridId",
    value: function getGridId() {
      return this.context.getGridId();
    }
    /** Register a detail grid with the master grid when it is created. */

  }, {
    key: "addDetailGridInfo",
    value: function addDetailGridInfo(id, gridInfo) {
      this.detailGridInfoMap[id] = gridInfo;
    }
    /** Unregister a detail grid from the master grid when it is destroyed. */

  }, {
    key: "removeDetailGridInfo",
    value: function removeDetailGridInfo(id) {
      delete this.detailGridInfoMap[id];
    }
    /** Returns the `DetailGridInfo` corresponding to the supplied `detailGridId`. */

  }, {
    key: "getDetailGridInfo",
    value: function getDetailGridInfo(id) {
      return this.detailGridInfoMap[id];
    }
    /** Iterates through each `DetailGridInfo` in the grid and calls the supplied callback on each. */

  }, {
    key: "forEachDetailGridInfo",
    value: function forEachDetailGridInfo(callback) {
      var index = 0;

      _iterateObject(this.detailGridInfoMap, function (id, gridInfo) {
        if (_exists(gridInfo)) {
          callback(gridInfo, index);
          index++;
        }
      });
    }
    /** Similar to `exportDataAsCsv`, except returns the result as a string rather than download it. */

  }, {
    key: "getDataAsCsv",
    value: function getDataAsCsv(params) {
      if (_ModuleRegistry2.__assertRegistered("@ag-grid-community/csv-export"
      /* CsvExportModule */
      , "api.getDataAsCsv", this.context.getGridId())) {
        return this.csvCreator.getDataAsCsv(params);
      }
    }
    /** Downloads a CSV export of the grid's data. */

  }, {
    key: "exportDataAsCsv",
    value: function exportDataAsCsv(params) {
      if (_ModuleRegistry2.__assertRegistered("@ag-grid-community/csv-export"
      /* CsvExportModule */
      , "api.exportDataAsCsv", this.context.getGridId())) {
        this.csvCreator.exportDataAsCsv(params);
      }
    }
  }, {
    key: "assertNotExcelMultiSheet",
    value: function assertNotExcelMultiSheet(method, params) {
      if (!_ModuleRegistry2.__assertRegistered("@ag-grid-enterprise/excel-export"
      /* ExcelExportModule */
      , "api." + method, this.context.getGridId())) {
        return false;
      }

      if (this.excelCreator.getFactoryMode() === 1
      /* MULTI_SHEET */
      ) {
          console.warn("AG Grid: The Excel Exporter is currently on Multi Sheet mode. End that operation by calling 'api.getMultipleSheetAsExcel()' or 'api.exportMultipleSheetsAsExcel()'");
          return false;
        }

      return true;
    }
    /** Similar to `exportDataAsExcel`, except instead of downloading a file, it will return a [Blob](https://developer.mozilla.org/en-US/docs/Web/API/Blob) to be processed by the user. */

  }, {
    key: "getDataAsExcel",
    value: function getDataAsExcel(params) {
      if (this.assertNotExcelMultiSheet("getDataAsExcel", params)) {
        return this.excelCreator.getDataAsExcel(params);
      }
    }
    /** Downloads an Excel export of the grid's data. */

  }, {
    key: "exportDataAsExcel",
    value: function exportDataAsExcel(params) {
      if (this.assertNotExcelMultiSheet("exportDataAsExcel", params)) {
        this.excelCreator.exportDataAsExcel(params);
      }
    }
    /** This is method to be used to get the grid's data as a sheet, that will later be exported either by `getMultipleSheetsAsExcel()` or `exportMultipleSheetsAsExcel()`. */

  }, {
    key: "getSheetDataForExcel",
    value: function getSheetDataForExcel(params) {
      if (!_ModuleRegistry2.__assertRegistered("@ag-grid-enterprise/excel-export"
      /* ExcelExportModule */
      , "api.getSheetDataForExcel", this.context.getGridId())) {
        return;
      }

      this.excelCreator.setFactoryMode(1
      /* MULTI_SHEET */
      );
      return this.excelCreator.getSheetDataForExcel(params);
    }
    /** Similar to `exportMultipleSheetsAsExcel`, except instead of downloading a file, it will return a [Blob](https://developer.mozilla.org/en-US/docs/Web/API/Blob) to be processed by the user. */

  }, {
    key: "getMultipleSheetsAsExcel",
    value: function getMultipleSheetsAsExcel(params) {
      if (_ModuleRegistry2.__assertRegistered("@ag-grid-enterprise/excel-export"
      /* ExcelExportModule */
      , "api.getMultipleSheetsAsExcel", this.context.getGridId())) {
        return this.excelCreator.getMultipleSheetsAsExcel(params);
      }
    }
    /** Downloads an Excel export of multiple sheets in one file. */

  }, {
    key: "exportMultipleSheetsAsExcel",
    value: function exportMultipleSheetsAsExcel(params) {
      if (_ModuleRegistry2.__assertRegistered("@ag-grid-enterprise/excel-export"
      /* ExcelExportModule */
      , "api.exportMultipleSheetsAsExcel", this.context.getGridId())) {
        this.excelCreator.exportMultipleSheetsAsExcel(params);
      }
    }
    /**
     * Sets an ARIA property in the grid panel (element with `role=\"grid\"`), and removes an ARIA property when the value is null.
     *
     * Example: `api.setGridAriaProperty('label', 'my grid')` will set `aria-label=\"my grid\"`.
     *
     * `api.setGridAriaProperty('label', null)` will remove the `aria-label` attribute from the grid element.
     */

  }, {
    key: "setGridAriaProperty",
    value: function setGridAriaProperty(property, value) {
      if (!property) {
        return;
      }

      var eGrid = this.ctrlsService.getGridBodyCtrl().getGui();
      var ariaProperty = "aria-".concat(property);

      if (value === null) {
        eGrid.removeAttribute(ariaProperty);
      } else {
        eGrid.setAttribute(ariaProperty, value);
      }
    }
  }, {
    key: "logMissingRowModel",
    value: function logMissingRowModel(apiMethod) {
      for (var _len4 = arguments.length, requiredRowModels = new Array(_len4 > 1 ? _len4 - 1 : 0), _key5 = 1; _key5 < _len4; _key5++) {
        requiredRowModels[_key5 - 1] = arguments[_key5];
      }

      console.error("AG Grid: api.".concat(apiMethod, " can only be called when gridOptions.rowModelType is ").concat(requiredRowModels.join(" or ")));
    }
  }, {
    key: "logDeprecation",
    value: function logDeprecation(version, apiMethod, replacement, message) {
      _warnOnce("Since ".concat(version, " api.").concat(apiMethod, " is deprecated. Please use ").concat(replacement, " instead. ").concat(message != null ? message : ""));
    }
    /** Gets the number of top pinned rows. */

  }, {
    key: "getPinnedTopRowCount",
    value: function getPinnedTopRowCount() {
      return this.pinnedRowModel.getPinnedTopRowCount();
    }
    /** Gets the number of bottom pinned rows. */

  }, {
    key: "getPinnedBottomRowCount",
    value: function getPinnedBottomRowCount() {
      return this.pinnedRowModel.getPinnedBottomRowCount();
    }
    /** Gets the top pinned row with the specified index. */

  }, {
    key: "getPinnedTopRow",
    value: function getPinnedTopRow(index) {
      return this.pinnedRowModel.getPinnedTopRow(index);
    }
    /** Gets the bottom pinned row with the specified index. */

  }, {
    key: "getPinnedBottomRow",
    value: function getPinnedBottomRow(index) {
      return this.pinnedRowModel.getPinnedBottomRow(index);
    }
  }, {
    key: "expireValueCache",
    value: function expireValueCache() {
      this.valueCache.expire();
    }
    /**
     * Returns an object with two properties:
     *  - `top`: The top pixel position of the current scroll in the grid
     *  - `bottom`: The bottom pixel position of the current scroll in the grid
     */

  }, {
    key: "getVerticalPixelRange",
    value: function getVerticalPixelRange() {
      return this.gridBodyCtrl.getScrollFeature().getVScrollPosition();
    }
    /**
     * Returns an object with two properties:
     * - `left`: The left pixel position of the current scroll in the grid
     * - `right`: The right pixel position of the current scroll in the grid
     */

  }, {
    key: "getHorizontalPixelRange",
    value: function getHorizontalPixelRange() {
      return this.gridBodyCtrl.getScrollFeature().getHScrollPosition();
    }
    /** Performs change detection on all cells, refreshing cells where required. */

  }, {
    key: "refreshCells",
    value: function refreshCells() {
      var _this204 = this;

      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.frameworkOverrides.wrapIncoming(function () {
        return _this204.rowRenderer.refreshCells(params);
      });
    }
    /** Flash rows, columns or individual cells. */

  }, {
    key: "flashCells",
    value: function flashCells() {
      var _this205 = this;

      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var warning = function warning(prop) {
        return _warnOnce("Since v31.1 api.flashCells parameter '".concat(prop, "Delay' is deprecated. Please use '").concat(prop, "Duration' instead."));
      };

      if (_exists(params.fadeDelay)) {
        warning("fade");
      }

      if (_exists(params.flashDelay)) {
        warning("flash");
      }

      this.frameworkOverrides.wrapIncoming(function () {
        return _this205.rowRenderer.flashCells(params);
      });
    }
    /** Remove row(s) from the DOM and recreate them again from scratch. */

  }, {
    key: "redrawRows",
    value: function redrawRows() {
      var _this206 = this;

      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var rowNodes = params ? params.rowNodes : void 0;
      this.frameworkOverrides.wrapIncoming(function () {
        return _this206.rowRenderer.redrawRows(rowNodes);
      });
    }
    /** Redraws the header. Useful if a column name changes, or something else that changes how the column header is displayed. */

  }, {
    key: "refreshHeader",
    value: function refreshHeader() {
      var _this207 = this;

      this.frameworkOverrides.wrapIncoming(function () {
        return _this207.ctrlsService.getHeaderRowContainerCtrls().forEach(function (c) {
          return c.refresh();
        });
      });
    }
    /** Returns `true` if any filter is set. This includes quick filter, column filter, external filter or advanced filter. */

  }, {
    key: "isAnyFilterPresent",
    value: function isAnyFilterPresent() {
      return this.filterManager.isAnyFilterPresent();
    }
    /** Returns `true` if any column filter is set, otherwise `false`. */

  }, {
    key: "isColumnFilterPresent",
    value: function isColumnFilterPresent() {
      return this.filterManager.isColumnFilterPresent() || this.filterManager.isAggregateFilterPresent();
    }
    /** Returns `true` if the Quick Filter is set, otherwise `false`. */

  }, {
    key: "isQuickFilterPresent",
    value: function isQuickFilterPresent() {
      return this.filterManager.isQuickFilterPresent();
    }
    /**
     * Returns the row model inside the table.
     * From here you can see the original rows, rows after filter has been applied,
     * rows after aggregation has been applied, and the final set of 'to be displayed' rows.
     *
     * @deprecated As of v31.1, getModel() is deprecated and will not be available in future versions.
     * Please use the appropriate grid API methods instead
     */

  }, {
    key: "getModel",
    value: function getModel() {
      _warnOnce("Since v31.1 getModel() is deprecated. Please use the appropriate grid API methods instead.");

      return this.rowModel;
    }
    /** 
     * Expand or collapse a specific row node, optionally expanding/collapsing all of its parent nodes.
     * By default rows are expanded asynchronously for best performance. Set forceSync: `true` if you need to interact with the expanded row immediately after this function.
     */

  }, {
    key: "setRowNodeExpanded",
    value: function setRowNodeExpanded(rowNode, expanded, expandParents, forceSync) {
      this.expansionService.setRowNodeExpanded(rowNode, expanded, expandParents, forceSync);
    }
    /**
     * Informs the grid that row group expanded state has changed and it needs to rerender the group nodes.
     * Typically called after updating the row node expanded state explicitly, i.e `rowNode.expanded = false`,
     * across multiple groups and you want to update the grid view in a single rerender instead of on every group change.
     */

  }, {
    key: "onGroupExpandedOrCollapsed",
    value: function onGroupExpandedOrCollapsed() {
      if (_missing(this.clientSideRowModel)) {
        this.logMissingRowModel("onGroupExpandedOrCollapsed", "clientSide");
        return;
      }

      this.expansionService.onGroupExpandedOrCollapsed();
    }
    /**
     * Refresh the Client-Side Row Model, executing the grouping, filtering and sorting again.
     * Optionally provide the step you wish the refresh to apply from. Defaults to `everything`.
     */

  }, {
    key: "refreshClientSideRowModel",
    value: function refreshClientSideRowModel(step) {
      if (_missing(this.clientSideRowModel)) {
        this.logMissingRowModel("refreshClientSideRowModel", "clientSide");
        return;
      }

      this.clientSideRowModel.refreshModel(step);
    }
    /** Returns `true` when there are no more animation frames left to process. */

  }, {
    key: "isAnimationFrameQueueEmpty",
    value: function isAnimationFrameQueueEmpty() {
      return this.animationFrameService.isQueueEmpty();
    }
  }, {
    key: "flushAllAnimationFrames",
    value: function flushAllAnimationFrames() {
      this.animationFrameService.flushAllFrames();
    }
    /**
     * Returns the row node with the given ID.
     * The row node ID is the one you provide from the callback `getRowId(params)`,
     * otherwise the ID is a number (cast as string) auto-generated by the grid when
     * the row data is set.
     */

  }, {
    key: "getRowNode",
    value: function getRowNode(id) {
      return this.rowModel.getRowNode(id);
    }
    /**
     * Gets the sizes that various UI elements will be rendered at with the current theme.
     * If you override the row or header height using `gridOptions`, the override value you provided will be returned.
     */

  }, {
    key: "getSizesForCurrentTheme",
    value: function getSizesForCurrentTheme() {
      return {
        rowHeight: this.gos.getRowHeightAsNumber(),
        headerHeight: this.columnModel.getHeaderHeight()
      };
    }
    /** Expand all groups. */

  }, {
    key: "expandAll",
    value: function expandAll() {
      if (this.clientSideRowModel || this.serverSideRowModel) {
        this.expansionService.expandAll(true);
      } else {
        this.logMissingRowModel("expandAll", "clientSide", "serverSide");
      }
    }
    /** Collapse all groups. */

  }, {
    key: "collapseAll",
    value: function collapseAll() {
      if (this.clientSideRowModel || this.serverSideRowModel) {
        this.expansionService.expandAll(false);
      } else {
        this.logMissingRowModel("collapseAll", "clientSide", "serverSide");
      }
    }
    /**
     * Registers a callback to a virtual row.
     * A virtual row is a row that is visually rendered on the screen (rows that are not visible because of the scroll position are not rendered).
     * Unlike normal events, you do not need to unregister rendered row listeners.
     * When the rendered row is removed from the grid, all associated rendered row listeners will also be removed.
     * listen for this event if your `cellRenderer` needs to do cleanup when the row no longer exists.
     */

  }, {
    key: "addRenderedRowListener",
    value: function addRenderedRowListener(eventName, rowIndex, callback) {
      this.rowRenderer.addRenderedRowListener(eventName, rowIndex, callback);
    }
    /** Get the current Quick Filter text from the grid, or `undefined` if none is set. */

  }, {
    key: "getQuickFilter",
    value: function getQuickFilter() {
      return this.gos.get("quickFilterText");
    }
    /** Get the state of the Advanced Filter. Used for saving Advanced Filter state */

  }, {
    key: "getAdvancedFilterModel",
    value: function getAdvancedFilterModel() {
      if (_ModuleRegistry2.__assertRegistered("@ag-grid-enterprise/advanced-filter"
      /* AdvancedFilterModule */
      , "api.getAdvancedFilterModel", this.context.getGridId())) {
        return this.filterManager.getAdvancedFilterModel();
      }

      return null;
    }
    /** Set the state of the Advanced Filter. Used for restoring Advanced Filter state */

  }, {
    key: "setAdvancedFilterModel",
    value: function setAdvancedFilterModel(advancedFilterModel) {
      this.filterManager.setAdvancedFilterModel(advancedFilterModel);
    }
    /** Open the Advanced Filter Builder dialog (if enabled). */

  }, {
    key: "showAdvancedFilterBuilder",
    value: function showAdvancedFilterBuilder() {
      if (_ModuleRegistry2.__assertRegistered("@ag-grid-enterprise/advanced-filter"
      /* AdvancedFilterModule */
      , "api.setAdvancedFilterModel", this.context.getGridId())) {
        this.filterManager.showAdvancedFilterBuilder("api");
      }
    }
    /**
     * Set all of the provided nodes selection state to the provided value.
     */

  }, {
    key: "setNodesSelected",
    value: function setNodesSelected(params) {
      var allNodesValid = params.nodes.every(function (node) {
        if (node.rowPinned) {
          console.warn("AG Grid: cannot select pinned rows");
          return false;
        }

        if (node.id === void 0) {
          console.warn("AG Grid: cannot select node until id for node is known");
          return false;
        }

        return true;
      });

      if (!allNodesValid) {
        return;
      }

      var nodes = params.nodes,
          source = params.source,
          newValue = params.newValue;
      var nodesAsRowNode = nodes;
      this.selectionService.setNodesSelected({
        nodes: nodesAsRowNode,
        source: source != null ? source : "api",
        newValue: newValue
      });
    }
    /**
     * Select all rows, regardless of filtering and rows that are not visible due to grouping being enabled and their groups not expanded.
     * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAll'`
     */

  }, {
    key: "selectAll",
    value: function selectAll() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "apiSelectAll";
      this.selectionService.selectAllRowNodes({
        source: source
      });
    }
    /**
     * Clear all row selections, regardless of filtering.
     * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAll'`
     */

  }, {
    key: "deselectAll",
    value: function deselectAll() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "apiSelectAll";
      this.selectionService.deselectAllRowNodes({
        source: source
      });
    }
    /**
     * Select all filtered rows.
     * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAllFiltered'`
     */

  }, {
    key: "selectAllFiltered",
    value: function selectAllFiltered() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "apiSelectAllFiltered";
      this.selectionService.selectAllRowNodes({
        source: source,
        justFiltered: true
      });
    }
    /**
     * Clear all filtered selections.
     * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAllFiltered'`
     */

  }, {
    key: "deselectAllFiltered",
    value: function deselectAllFiltered() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "apiSelectAllFiltered";
      this.selectionService.deselectAllRowNodes({
        source: source,
        justFiltered: true
      });
    }
    /**
     * Returns an object containing rules matching the selected rows in the SSRM.
     * 
     * If `groupSelectsChildren=false` the returned object will be flat, and will conform to IServerSideSelectionState.
     * If `groupSelectsChildren=true` the returned object will be hierarchical, and will conform to IServerSideGroupSelectionState.
     */

  }, {
    key: "getServerSideSelectionState",
    value: function getServerSideSelectionState() {
      if (_missing(this.serverSideRowModel)) {
        this.logMissingRowModel("getServerSideSelectionState", "serverSide");
        return null;
      }

      return this.selectionService.getSelectionState();
    }
    /**
     * Set the rules matching the selected rows in the SSRM.
     * 
     * If `groupSelectsChildren=false` the param will be flat, and should conform to IServerSideSelectionState.
     * If `groupSelectsChildren=true` the param will be hierarchical, and should conform to IServerSideGroupSelectionState.
     */

  }, {
    key: "setServerSideSelectionState",
    value: function setServerSideSelectionState(state) {
      if (_missing(this.serverSideRowModel)) {
        this.logMissingRowModel("setServerSideSelectionState", "serverSide");
        return;
      }

      this.selectionService.setSelectionState(state, "api");
    }
    /**
     * Select all rows on the current page.
     * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAllCurrentPage'`
     */

  }, {
    key: "selectAllOnCurrentPage",
    value: function selectAllOnCurrentPage() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "apiSelectAllCurrentPage";
      this.selectionService.selectAllRowNodes({
        source: source,
        justCurrentPage: true
      });
    }
    /**
     * Clear all filtered on the current page.
     * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAllCurrentPage'`
     */

  }, {
    key: "deselectAllOnCurrentPage",
    value: function deselectAllOnCurrentPage() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "apiSelectAllCurrentPage";
      this.selectionService.deselectAllRowNodes({
        source: source,
        justCurrentPage: true
      });
    }
    /** Show the 'loading' overlay. */

  }, {
    key: "showLoadingOverlay",
    value: function showLoadingOverlay() {
      this.overlayService.showLoadingOverlay();
    }
    /** Show the 'no rows' overlay. */

  }, {
    key: "showNoRowsOverlay",
    value: function showNoRowsOverlay() {
      this.overlayService.showNoRowsOverlay();
    }
    /** Hides the overlay if showing. */

  }, {
    key: "hideOverlay",
    value: function hideOverlay() {
      this.overlayService.hideOverlay();
    }
    /**
     * Returns an unsorted list of selected nodes.
     * Getting the underlying node (rather than the data) is useful when working with tree / aggregated data,
     * as the node can be traversed.
     */

  }, {
    key: "getSelectedNodes",
    value: function getSelectedNodes() {
      return this.selectionService.getSelectedNodes();
    }
    /** Returns an unsorted list of selected rows (i.e. row data that you provided). */

  }, {
    key: "getSelectedRows",
    value: function getSelectedRows() {
      return this.selectionService.getSelectedRows();
    }
    /**
     * Returns a list of all selected nodes at 'best cost', a feature to be used with groups / trees.
     * If a group has all its children selected, then the group appears in the result, but not the children.
     * Designed for use with `'children'` as the group selection type, where groups don't actually appear in the selection normally.
     */

  }, {
    key: "getBestCostNodeSelection",
    value: function getBestCostNodeSelection() {
      if (_missing(this.clientSideRowModel)) {
        this.logMissingRowModel("getBestCostNodeSelection", "clientSide");
        return;
      }

      return this.selectionService.getBestCostNodeSelection();
    }
    /** Retrieve rendered nodes. Due to virtualisation this will contain only the current visible rows and those in the buffer. */

  }, {
    key: "getRenderedNodes",
    value: function getRenderedNodes() {
      return this.rowRenderer.getRenderedNodes();
    }
    /**
     *  Ensures the column is visible by scrolling the table if needed.
     *
     * This will have no effect before the firstDataRendered event has fired.
     *
     * @param key - The column to ensure visible
     * @param position - Where the column will be positioned.
     * - `auto` - Scrolls the minimum amount to make sure the column is visible.
     * - `start` - Scrolls the column to the start of the viewport.
     * - `middle` - Scrolls the column to the middle of the viewport.
     * - `end` - Scrolls the column to the end of the viewport.
    */

  }, {
    key: "ensureColumnVisible",
    value: function ensureColumnVisible(key) {
      var _this208 = this;

      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "auto";
      this.frameworkOverrides.wrapIncoming(function () {
        return _this208.gridBodyCtrl.getScrollFeature().ensureColumnVisible(key, position);
      }, "ensureVisible");
    }
    /**
     * Vertically scrolls the grid until the provided row index is inside the visible viewport.
     * If a position is provided, the grid will attempt to scroll until the row is at the given position within the viewport.
     * This will have no effect before the firstDataRendered event has fired.
     */

  }, {
    key: "ensureIndexVisible",
    value: function ensureIndexVisible(index, position) {
      var _this209 = this;

      this.frameworkOverrides.wrapIncoming(function () {
        return _this209.gridBodyCtrl.getScrollFeature().ensureIndexVisible(index, position);
      }, "ensureVisible");
    }
    /**
     * Vertically scrolls the grid until the provided row (or a row matching the provided comparator) is inside the visible viewport.
     * If a position is provided, the grid will attempt to scroll until the row is at the given position within the viewport.
     * This will have no effect before the firstDataRendered event has fired.
     */

  }, {
    key: "ensureNodeVisible",
    value: function ensureNodeVisible(nodeSelector) {
      var _this210 = this;

      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.frameworkOverrides.wrapIncoming(function () {
        return _this210.gridBodyCtrl.getScrollFeature().ensureNodeVisible(nodeSelector, position);
      }, "ensureVisible");
    }
    /**
     * Similar to `forEachNode`, except lists all the leaf nodes.
     * This effectively goes through all the data that you provided to the grid before the grid performed any grouping.
     * If using tree data, goes through all the nodes for the data you provided, including nodes that have children,
     * but excluding groups the grid created where gaps were missing in the hierarchy.
     */

  }, {
    key: "forEachLeafNode",
    value: function forEachLeafNode(callback) {
      if (_missing(this.clientSideRowModel)) {
        this.logMissingRowModel("forEachLeafNode", "clientSide");
        return;
      }

      this.clientSideRowModel.forEachLeafNode(callback);
    }
    /**
     * Iterates through each node (row) in the grid and calls the callback for each node.
     * This works similar to the `forEach` method on a JavaScript array.
     * This is called for every node, ignoring any filtering or sorting applied within the grid.
     * If using the Infinite Row Model, then this gets called for each page loaded in the page cache.
     */

  }, {
    key: "forEachNode",
    value: function forEachNode(callback, includeFooterNodes) {
      this.rowModel.forEachNode(callback, includeFooterNodes);
    }
    /** Similar to `forEachNode`, except skips any filtered out data. */

  }, {
    key: "forEachNodeAfterFilter",
    value: function forEachNodeAfterFilter(callback) {
      if (_missing(this.clientSideRowModel)) {
        this.logMissingRowModel("forEachNodeAfterFilter", "clientSide");
        return;
      }

      this.clientSideRowModel.forEachNodeAfterFilter(callback);
    }
    /** Similar to `forEachNodeAfterFilter`, except the callbacks are called in the order the rows are displayed in the grid. */

  }, {
    key: "forEachNodeAfterFilterAndSort",
    value: function forEachNodeAfterFilterAndSort(callback) {
      if (_missing(this.clientSideRowModel)) {
        this.logMissingRowModel("forEachNodeAfterFilterAndSort", "clientSide");
        return;
      }

      this.clientSideRowModel.forEachNodeAfterFilterAndSort(callback);
    }
    /**
     * @deprecated v31.1 To get/set individual filter models, use `getColumnFilterModel` or `setColumnFilterModel` instead.
     * To get hold of the filter instance, use `getColumnFilterInstance` which returns the instance asynchronously.
     */

  }, {
    key: "getFilterInstance",
    value: function getFilterInstance(key, callback) {
      _warnOnce("'getFilterInstance' is deprecated. To get/set individual filter models, use 'getColumnFilterModel' or 'setColumnFilterModel' instead. To get hold of the filter instance, use 'getColumnFilterInstance' which returns the instance asynchronously.");

      return this.filterManager.getFilterInstance(key, callback);
    }
    /**
     * Returns the filter component instance for a column.
     * For getting/setting models for individual column filters, use `getColumnFilterModel` and `setColumnFilterModel` instead of this.
     * `key` can be a column ID or a `Column` object.
     */

  }, {
    key: "getColumnFilterInstance",
    value: function getColumnFilterInstance(key) {
      return this.filterManager.getColumnFilterInstance(key);
    }
    /** Destroys a filter. Useful to force a particular filter to be created from scratch again. */

  }, {
    key: "destroyFilter",
    value: function destroyFilter(key) {
      var column = this.columnModel.getPrimaryColumn(key);

      if (column) {
        return this.filterManager.destroyFilter(column, "api");
      }
    }
    /** Gets the status panel instance corresponding to the supplied `id`. */

  }, {
    key: "getStatusPanel",
    value: function getStatusPanel(key) {
      if (!_ModuleRegistry2.__assertRegistered("@ag-grid-enterprise/status-bar"
      /* StatusBarModule */
      , "api.getStatusPanel", this.context.getGridId())) {
        return;
      }

      var comp = this.statusBarService.getStatusPanel(key);
      return unwrapUserComp(comp);
    }
  }, {
    key: "getColumnDef",
    value: function getColumnDef(key) {
      var column = this.columnModel.getPrimaryColumn(key);

      if (column) {
        return column.getColDef();
      }

      return null;
    }
    /**
     * Returns the current column definitions.
    */

  }, {
    key: "getColumnDefs",
    value: function getColumnDefs() {
      return this.columnModel.getColumnDefs();
    }
    /**
     * Informs the grid that a filter has changed. This is typically called after a filter change through one of the filter APIs.
     * @param source The source of the filter change event. If not specified defaults to `'api'`.
     */

  }, {
    key: "onFilterChanged",
    value: function onFilterChanged() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "api";
      this.filterManager.onFilterChanged({
        source: source
      });
    }
    /**
     * Gets the grid to act as if the sort was changed.
     * Useful if you update some values and want to get the grid to reorder them according to the new values.
     */

  }, {
    key: "onSortChanged",
    value: function onSortChanged() {
      this.sortController.onSortChanged("api");
    }
    /**
     * Sets the state of all the column filters. Provide it with what you get from `getFilterModel()` to restore filter state.
     * If inferring cell data types, and row data is provided asynchronously and is yet to be set,
     * the filter model will be applied asynchronously after row data is added.
     * To always perform this synchronously, set `cellDataType = false` on the default column definition,
     * or provide cell data types for every column.
     */

  }, {
    key: "setFilterModel",
    value: function setFilterModel(model) {
      var _this211 = this;

      this.frameworkOverrides.wrapIncoming(function () {
        return _this211.filterManager.setFilterModel(model);
      });
    }
    /** Gets the current state of all the column filters. Used for saving filter state. */

  }, {
    key: "getFilterModel",
    value: function getFilterModel() {
      return this.filterManager.getFilterModel();
    }
    /**
     * Gets the current filter model for the specified column.
     * Will return `null` if no active filter.
     */

  }, {
    key: "getColumnFilterModel",
    value: function getColumnFilterModel(column) {
      return this.filterManager.getColumnFilterModel(column);
    }
    /**
     * Sets the filter model for the specified column.
     * Setting a `model` of `null` will reset the filter (make inactive).
     * Must wait on the response before calling `api.onFilterChanged()`.
     */

  }, {
    key: "setColumnFilterModel",
    value: function setColumnFilterModel(column, model) {
      return this.filterManager.setColumnFilterModel(column, model);
    }
    /** Returns the focused cell (or the last focused cell if the grid lost focus). */

  }, {
    key: "getFocusedCell",
    value: function getFocusedCell() {
      return this.focusService.getFocusedCell();
    }
    /** Clears the focused cell. */

  }, {
    key: "clearFocusedCell",
    value: function clearFocusedCell() {
      return this.focusService.clearFocusedCell();
    }
    /** Sets the focus to the specified cell. `rowPinned` can be either 'top', 'bottom' or null (for not pinned). */

  }, {
    key: "setFocusedCell",
    value: function setFocusedCell(rowIndex, colKey, rowPinned) {
      this.focusService.setFocusedCell({
        rowIndex: rowIndex,
        column: colKey,
        rowPinned: rowPinned,
        forceBrowserFocus: true
      });
    }
    /** Adds a drop zone outside of the grid where rows can be dropped. */

  }, {
    key: "addRowDropZone",
    value: function addRowDropZone(params) {
      this.gridBodyCtrl.getRowDragFeature().addRowDropZone(params);
    }
    /** Removes an external drop zone added by `addRowDropZone`. */

  }, {
    key: "removeRowDropZone",
    value: function removeRowDropZone(params) {
      var activeDropTarget = this.dragAndDropService.findExternalZone(params);

      if (activeDropTarget) {
        this.dragAndDropService.removeDropTarget(activeDropTarget);
      }
    }
    /** Returns the `RowDropZoneParams` to be used by another grid's `addRowDropZone` method. */

  }, {
    key: "getRowDropZoneParams",
    value: function getRowDropZoneParams(events) {
      return this.gridBodyCtrl.getRowDragFeature().getRowDropZone(events);
    }
  }, {
    key: "assertSideBarLoaded",
    value: function assertSideBarLoaded(apiMethod) {
      return _ModuleRegistry2.__assertRegistered("@ag-grid-enterprise/side-bar"
      /* SideBarModule */
      , "api." + apiMethod, this.context.getGridId());
    }
    /** Returns `true` if the side bar is visible. */

  }, {
    key: "isSideBarVisible",
    value: function isSideBarVisible() {
      return this.assertSideBarLoaded("isSideBarVisible") && this.sideBarService.getSideBarComp().isDisplayed();
    }
    /** Show/hide the entire side bar, including any visible panel and the tab buttons. */

  }, {
    key: "setSideBarVisible",
    value: function setSideBarVisible(show) {
      if (this.assertSideBarLoaded("setSideBarVisible")) {
        this.sideBarService.getSideBarComp().setDisplayed(show);
      }
    }
    /** Sets the side bar position relative to the grid. Possible values are `'left'` or `'right'`. */

  }, {
    key: "setSideBarPosition",
    value: function setSideBarPosition(position) {
      if (this.assertSideBarLoaded("setSideBarPosition")) {
        this.sideBarService.getSideBarComp().setSideBarPosition(position);
      }
    }
    /** Opens a particular tool panel. Provide the ID of the tool panel to open. */

  }, {
    key: "openToolPanel",
    value: function openToolPanel(key) {
      if (this.assertSideBarLoaded("openToolPanel")) {
        this.sideBarService.getSideBarComp().openToolPanel(key, "api");
      }
    }
    /** Closes the currently open tool panel (if any). */

  }, {
    key: "closeToolPanel",
    value: function closeToolPanel() {
      if (this.assertSideBarLoaded("closeToolPanel")) {
        this.sideBarService.getSideBarComp().close("api");
      }
    }
    /** Returns the ID of the currently shown tool panel if any, otherwise `null`. */

  }, {
    key: "getOpenedToolPanel",
    value: function getOpenedToolPanel() {
      if (this.assertSideBarLoaded("getOpenedToolPanel")) {
        return this.sideBarService.getSideBarComp().openedItem();
      }

      return null;
    }
    /** Force refresh all tool panels by calling their `refresh` method. */

  }, {
    key: "refreshToolPanel",
    value: function refreshToolPanel() {
      if (this.assertSideBarLoaded("refreshToolPanel")) {
        this.sideBarService.getSideBarComp().refresh();
      }
    }
    /** Returns `true` if the tool panel is showing, otherwise `false`. */

  }, {
    key: "isToolPanelShowing",
    value: function isToolPanelShowing() {
      return this.assertSideBarLoaded("isToolPanelShowing") && this.sideBarService.getSideBarComp().isToolPanelShowing();
    }
    /** Gets the tool panel instance corresponding to the supplied `id`. */

  }, {
    key: "getToolPanelInstance",
    value: function getToolPanelInstance(id) {
      if (this.assertSideBarLoaded("getToolPanelInstance")) {
        var comp = this.sideBarService.getSideBarComp().getToolPanelInstance(id);
        return unwrapUserComp(comp);
      }
    }
    /** Returns the current side bar configuration. If a shortcut was used, returns the detailed long form. */

  }, {
    key: "getSideBar",
    value: function getSideBar() {
      if (this.assertSideBarLoaded("getSideBar")) {
        return this.sideBarService.getSideBarComp().getDef();
      }

      return void 0;
    }
    /** Tells the grid to recalculate the row heights. */

  }, {
    key: "resetRowHeights",
    value: function resetRowHeights() {
      if (_exists(this.clientSideRowModel)) {
        if (this.columnModel.isAutoRowHeightActive()) {
          console.warn("AG Grid: calling gridApi.resetRowHeights() makes no sense when using Auto Row Height.");
          return;
        }

        this.clientSideRowModel.resetRowHeights();
      }
    }
    /**
     * Sets the `rowCount` and `maxRowFound` properties.
     * The second parameter, `maxRowFound`, is optional and if left out, only `rowCount` is set.
     * Set `rowCount` to adjust the height of the vertical scroll.
     * Set `maxRowFound` to enable / disable searching for more rows.
     * Use this method if you add or remove rows into the dataset and need to reset the number of rows or instruct the grid that the entire row count is no longer known.
     */

  }, {
    key: "setRowCount",
    value: function setRowCount(rowCount, maxRowFound) {
      if (this.serverSideRowModel) {
        if (this.columnModel.isRowGroupEmpty()) {
          this.serverSideRowModel.setRowCount(rowCount, maxRowFound);
          return;
        }

        console.error("AG Grid: setRowCount cannot be used while using row grouping.");
        return;
      }

      if (this.infiniteRowModel) {
        this.infiniteRowModel.setRowCount(rowCount, maxRowFound);
        return;
      }

      this.logMissingRowModel("setRowCount", "infinite", "serverSide");
    }
    /** Tells the grid a row height has changed. To be used after calling `rowNode.setRowHeight(newHeight)`. */

  }, {
    key: "onRowHeightChanged",
    value: function onRowHeightChanged() {
      if (this.clientSideRowModel) {
        this.clientSideRowModel.onRowHeightChanged();
      } else if (this.serverSideRowModel) {
        this.serverSideRowModel.onRowHeightChanged();
      }
    }
    /**
     * @deprecated v31.3 Use `getCellValue` instead.
     */

  }, {
    key: "getValue",
    value: function getValue(colKey, rowNode) {
      this.logDeprecation("31.3", "getValue", "getCellValue");
      return this.getCellValue({
        colKey: colKey,
        rowNode: rowNode
      });
    }
  }, {
    key: "getCellValue",
    value: function getCellValue(params) {
      var _a;

      var colKey = params.colKey,
          rowNode = params.rowNode,
          useFormatter = params.useFormatter;
      var column = (_a = this.columnModel.getPrimaryColumn(colKey)) != null ? _a : this.columnModel.getGridColumn(colKey);

      if (_missing(column)) {
        return null;
      }

      var value = this.valueService.getValue(column, rowNode);

      if (useFormatter) {
        var formattedValue = this.valueService.formatValue(column, rowNode, value);
        return formattedValue != null ? formattedValue : _escapeString(value, true);
      }

      return value;
    }
    /**
     * Add an event listener for the specified `eventType`.
     * Works similar to `addEventListener` for a browser DOM element.
     * Listeners will be automatically removed when the grid is destroyed.
     */

  }, {
    key: "addEventListener",
    value: function addEventListener(eventType, listener) {
      this.apiEventService.addEventListener(eventType, listener);
    }
    /**
     * Add an event listener for all event types coming from the grid.
     * Listeners will be automatically removed when the grid is destroyed.
     */

  }, {
    key: "addGlobalListener",
    value: function addGlobalListener(listener) {
      this.apiEventService.addGlobalListener(listener);
    }
    /** Remove an event listener. */

  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventType, listener) {
      this.apiEventService.removeEventListener(eventType, listener);
    }
    /** Remove a global event listener. */

  }, {
    key: "removeGlobalListener",
    value: function removeGlobalListener(listener) {
      this.apiEventService.removeGlobalListener(listener);
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      this.eventService.dispatchEvent(event);
    }
    /** Will destroy the grid and release resources. If you are using a framework you do not need to call this, as the grid links in with the framework lifecycle. However if you are using Web Components or native JavaScript, you do need to call this, to avoid a memory leak in your application. */

  }, {
    key: "destroy",
    value: function destroy() {
      var _a;

      var preDestroyLink = "See ".concat(this.frameworkOverrides.getDocLink("grid-lifecycle/#grid-pre-destroyed"));

      if (this.destroyCalled) {
        return;
      }

      var event = {
        type: _Events.EVENT_GRID_PRE_DESTROYED,
        state: this.getState()
      };
      this.dispatchEvent(event);
      this.destroyCalled = true;
      (_a = this.ctrlsService.get("gridCtrl")) == null ? void 0 : _a.destroyGridUi();
      this.context.destroy();
      this.detailGridInfoMap = {};

      _removeAllReferences(this, ["isDestroyed"], preDestroyLink);
    }
    /** Returns `true` if the grid has been destroyed. */

  }, {
    key: "isDestroyed",
    value: function isDestroyed() {
      return this.destroyCalled;
    }
    /** Reset the Quick Filter cache text on every rowNode. */

  }, {
    key: "resetQuickFilter",
    value: function resetQuickFilter() {
      this.filterManager.resetQuickFilterCache();
    }
    /** Returns the list of selected cell ranges. */

  }, {
    key: "getCellRanges",
    value: function getCellRanges() {
      if (this.rangeService) {
        return this.rangeService.getCellRanges();
      }

      _ModuleRegistry2.__assertRegistered("@ag-grid-enterprise/range-selection"
      /* RangeSelectionModule */
      , "api.getCellRanges", this.context.getGridId());

      return null;
    }
    /** Adds the provided cell range to the selected ranges. */

  }, {
    key: "addCellRange",
    value: function addCellRange(params) {
      if (this.rangeService) {
        this.rangeService.addCellRange(params);
        return;
      }

      _ModuleRegistry2.__assertRegistered("@ag-grid-enterprise/range-selection"
      /* RangeSelectionModule */
      , "api.addCellRange", this.context.getGridId());
    }
    /** Clears the selected ranges. */

  }, {
    key: "clearRangeSelection",
    value: function clearRangeSelection() {
      if (this.rangeService) {
        this.rangeService.removeAllCellRanges();
      }

      _ModuleRegistry2.__assertRegistered("@ag-grid-enterprise/range-selection"
      /* RangeSelectionModule */
      , "gridApi.clearRangeSelection", this.context.getGridId());
    }
    /** Reverts the last cell edit. */

  }, {
    key: "undoCellEditing",
    value: function undoCellEditing() {
      this.undoRedoService.undo("api");
    }
    /** Re-applies the most recently undone cell edit. */

  }, {
    key: "redoCellEditing",
    value: function redoCellEditing() {
      this.undoRedoService.redo("api");
    }
    /** Returns current number of available cell edit undo operations. */

  }, {
    key: "getCurrentUndoSize",
    value: function getCurrentUndoSize() {
      return this.undoRedoService.getCurrentUndoStackSize();
    }
    /** Returns current number of available cell edit redo operations. */

  }, {
    key: "getCurrentRedoSize",
    value: function getCurrentRedoSize() {
      return this.undoRedoService.getCurrentRedoStackSize();
    }
  }, {
    key: "assertChart",
    value: function assertChart(methodName, func) {
      if (_ModuleRegistry2.__assertRegistered("@ag-grid-enterprise/charts"
      /* GridChartsModule */
      , "api." + methodName, this.context.getGridId())) {
        return this.frameworkOverrides.wrapIncoming(function () {
          return func();
        });
      }
    }
    /** Returns a list of models with information about the charts that are currently rendered from the grid. */

  }, {
    key: "getChartModels",
    value: function getChartModels() {
      var _this212 = this;

      return this.assertChart("getChartModels", function () {
        return _this212.chartService.getChartModels();
      });
    }
    /** Returns the `ChartRef` using the supplied `chartId`. */

  }, {
    key: "getChartRef",
    value: function getChartRef(chartId) {
      var _this213 = this;

      return this.assertChart("getChartRef", function () {
        return _this213.chartService.getChartRef(chartId);
      });
    }
    /** Returns a base64-encoded image data URL for the referenced chartId. */

  }, {
    key: "getChartImageDataURL",
    value: function getChartImageDataURL(params) {
      var _this214 = this;

      return this.assertChart("getChartImageDataURL", function () {
        return _this214.chartService.getChartImageDataURL(params);
      });
    }
    /** Starts a browser-based image download for the referenced chartId. */

  }, {
    key: "downloadChart",
    value: function downloadChart(params) {
      var _this215 = this;

      return this.assertChart("downloadChart", function () {
        return _this215.chartService.downloadChart(params);
      });
    }
    /** Open the Chart Tool Panel. */

  }, {
    key: "openChartToolPanel",
    value: function openChartToolPanel(params) {
      var _this216 = this;

      return this.assertChart("openChartToolPanel", function () {
        return _this216.chartService.openChartToolPanel(params);
      });
    }
    /** Close the Chart Tool Panel. */

  }, {
    key: "closeChartToolPanel",
    value: function closeChartToolPanel(params) {
      var _this217 = this;

      return this.assertChart("closeChartToolPanel", function () {
        return _this217.chartService.closeChartToolPanel(params.chartId);
      });
    }
    /** Used to programmatically create charts from a range. */

  }, {
    key: "createRangeChart",
    value: function createRangeChart(params) {
      var _this218 = this;

      return this.assertChart("createRangeChart", function () {
        return _this218.chartService.createRangeChart(params);
      });
    }
    /** Used to programmatically create pivot charts from a grid. */

  }, {
    key: "createPivotChart",
    value: function createPivotChart(params) {
      var _this219 = this;

      return this.assertChart("createPivotChart", function () {
        return _this219.chartService.createPivotChart(params);
      });
    }
    /** Used to programmatically create cross filter charts from a range. */

  }, {
    key: "createCrossFilterChart",
    value: function createCrossFilterChart(params) {
      var _this220 = this;

      return this.assertChart("createCrossFilterChart", function () {
        return _this220.chartService.createCrossFilterChart(params);
      });
    }
    /** Used to programmatically update a chart. */

  }, {
    key: "updateChart",
    value: function updateChart(params) {
      var _this221 = this;

      return this.assertChart("updateChart", function () {
        return _this221.chartService.updateChart(params);
      });
    }
    /** Restores a chart using the `ChartModel` that was previously obtained from `getChartModels()`. */

  }, {
    key: "restoreChart",
    value: function restoreChart(chartModel, chartContainer) {
      var _this222 = this;

      return this.assertChart("restoreChart", function () {
        return _this222.chartService.restoreChart(chartModel, chartContainer);
      });
    }
  }, {
    key: "assertClipboard",
    value: function assertClipboard(methodName, func) {
      if (_ModuleRegistry2.__assertRegistered("@ag-grid-enterprise/clipboard"
      /* ClipboardModule */
      , "api" + methodName, this.context.getGridId())) {
        func();
      }
    }
    /** Copies data to clipboard by following the same rules as pressing Ctrl+C. */

  }, {
    key: "copyToClipboard",
    value: function copyToClipboard(params) {
      var _this223 = this;

      this.assertClipboard("copyToClipboard", function () {
        return _this223.clipboardService.copyToClipboard(params);
      });
    }
    /** Cuts data to clipboard by following the same rules as pressing Ctrl+X. */

  }, {
    key: "cutToClipboard",
    value: function cutToClipboard(params) {
      var _this224 = this;

      this.assertClipboard("cutToClipboard", function () {
        return _this224.clipboardService.cutToClipboard(params);
      });
    }
    /** Copies the selected rows to the clipboard. */

  }, {
    key: "copySelectedRowsToClipboard",
    value: function copySelectedRowsToClipboard(params) {
      var _this225 = this;

      this.assertClipboard("copySelectedRowsToClipboard", function () {
        return _this225.clipboardService.copySelectedRowsToClipboard(params);
      });
    }
    /** Copies the selected ranges to the clipboard. */

  }, {
    key: "copySelectedRangeToClipboard",
    value: function copySelectedRangeToClipboard(params) {
      var _this226 = this;

      this.assertClipboard("copySelectedRangeToClipboard", function () {
        return _this226.clipboardService.copySelectedRangeToClipboard(params);
      });
    }
    /** Copies the selected range down, similar to `Ctrl + D` in Excel. */

  }, {
    key: "copySelectedRangeDown",
    value: function copySelectedRangeDown() {
      var _this227 = this;

      this.assertClipboard("copySelectedRangeDown", function () {
        return _this227.clipboardService.copyRangeDown();
      });
    }
    /** Pastes the data from the Clipboard into the focused cell of the grid. If no grid cell is focused, calling this method has no effect. */

  }, {
    key: "pasteFromClipboard",
    value: function pasteFromClipboard() {
      var _this228 = this;

      this.assertClipboard("pasteFromClipboard", function () {
        return _this228.clipboardService.pasteFromClipboard();
      });
    }
    /** @deprecated v31.1 Use `IHeaderParams.showColumnMenu` within a header component, or `api.showColumnMenu` elsewhere. */

  }, {
    key: "showColumnMenuAfterButtonClick",
    value: function showColumnMenuAfterButtonClick(colKey, buttonElement) {
      _warnOnce("'showColumnMenuAfterButtonClick' is deprecated. Use 'IHeaderParams.showColumnMenu' within a header component, or 'api.showColumnMenu' elsewhere.");

      var column = this.columnModel.getGridColumn(colKey);
      this.menuService.showColumnMenu({
        column: column,
        buttonElement: buttonElement,
        positionBy: "button"
      });
    }
    /** @deprecated v31.1 Use `IHeaderParams.showColumnMenuAfterMouseClick` within a header component, or `api.showColumnMenu` elsewhere. */

  }, {
    key: "showColumnMenuAfterMouseClick",
    value: function showColumnMenuAfterMouseClick(colKey, mouseEvent) {
      _warnOnce("'showColumnMenuAfterMouseClick' is deprecated. Use 'IHeaderParams.showColumnMenuAfterMouseClick' within a header component, or 'api.showColumnMenu' elsewhere.");

      var column = this.columnModel.getGridColumn(colKey);

      if (!column) {
        column = this.columnModel.getPrimaryColumn(colKey);
      }

      if (!column) {
        console.error("AG Grid: column '".concat(colKey, "' not found"));
        return;
      }

      this.menuService.showColumnMenu({
        column: column,
        mouseEvent: mouseEvent,
        positionBy: "mouse"
      });
    }
    /**
     * Displays the AG Grid context menu
     */

  }, {
    key: "showContextMenu",
    value: function showContextMenu(params) {
      var _ref30 = params || {},
          rowNode = _ref30.rowNode,
          column = _ref30.column,
          value = _ref30.value,
          x = _ref30.x,
          y = _ref30.y;

      var _this$menuService$get = this.menuService.getContextMenuPosition(rowNode, column),
          clientX = _this$menuService$get.x,
          clientY = _this$menuService$get.y;

      if (x != null) {
        clientX = x;
      }

      if (y != null) {
        clientY = y;
      }

      this.menuService.showContextMenu({
        mouseEvent: new MouseEvent("mousedown", {
          clientX: clientX,
          clientY: clientY
        }),
        rowNode: rowNode,
        column: column,
        value: value
      });
    }
    /** Show the column chooser. */

  }, {
    key: "showColumnChooser",
    value: function showColumnChooser(params) {
      this.menuService.showColumnChooser({
        chooserParams: params
      });
    }
    /** Show the filter for the provided column. */

  }, {
    key: "showColumnFilter",
    value: function showColumnFilter(colKey) {
      var column = this.columnModel.getGridColumn(colKey);

      if (!column) {
        console.error("AG Grid: column '".concat(colKey, "' not found"));
        return;
      }

      this.menuService.showFilterMenu({
        column: column,
        containerType: "columnFilter",
        positionBy: "auto"
      });
    }
    /** Show the column menu for the provided column. */

  }, {
    key: "showColumnMenu",
    value: function showColumnMenu(colKey) {
      var column = this.columnModel.getGridColumn(colKey);

      if (!column) {
        console.error("AG Grid: column '".concat(colKey, "' not found"));
        return;
      }

      this.menuService.showColumnMenu({
        column: column,
        positionBy: "auto"
      });
    }
    /** Hides any visible context menu or column menu. */

  }, {
    key: "hidePopupMenu",
    value: function hidePopupMenu() {
      this.menuService.hidePopupMenu();
    }
    /** Hide the column chooser if visible. */

  }, {
    key: "hideColumnChooser",
    value: function hideColumnChooser() {
      this.menuService.hideColumnChooser();
    }
    /** Navigates the grid focus to the next cell, as if tabbing. */

  }, {
    key: "tabToNextCell",
    value: function tabToNextCell(event) {
      return this.navigationService.tabToNextCell(false, event);
    }
    /** Navigates the grid focus to the previous cell, as if shift-tabbing. */

  }, {
    key: "tabToPreviousCell",
    value: function tabToPreviousCell(event) {
      return this.navigationService.tabToNextCell(true, event);
    }
    /** Returns the list of active cell renderer instances. */

  }, {
    key: "getCellRendererInstances",
    value: function getCellRendererInstances() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var res = this.rowRenderer.getCellRendererInstances(params);
      var unwrapped = res.map(unwrapUserComp);
      return unwrapped;
    }
    /** Returns the list of active cell editor instances. Optionally provide parameters to restrict to certain columns / row nodes. */

  }, {
    key: "getCellEditorInstances",
    value: function getCellEditorInstances() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var res = this.rowRenderer.getCellEditorInstances(params);
      var unwrapped = res.map(unwrapUserComp);
      return unwrapped;
    }
    /** If the grid is editing, returns back details of the editing cell(s). */

  }, {
    key: "getEditingCells",
    value: function getEditingCells() {
      return this.rowRenderer.getEditingCells();
    }
    /** If a cell is editing, it stops the editing. Pass `true` if you want to cancel the editing (i.e. don't accept changes). */

  }, {
    key: "stopEditing",
    value: function stopEditing() {
      var cancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.rowRenderer.stopEditing(cancel);
    }
    /** Start editing the provided cell. If another cell is editing, the editing will be stopped in that other cell. */

  }, {
    key: "startEditingCell",
    value: function startEditingCell(params) {
      var column = this.columnModel.getGridColumn(params.colKey);

      if (!column) {
        console.warn("AG Grid: no column found for ".concat(params.colKey));
        return;
      }

      var cellPosition = {
        rowIndex: params.rowIndex,
        rowPinned: params.rowPinned || null,
        column: column
      };
      var notPinned = params.rowPinned == null;

      if (notPinned) {
        this.ensureIndexVisible(params.rowIndex);
      }

      this.ensureColumnVisible(params.colKey);
      var cell = this.navigationService.getCellByPosition(cellPosition);

      if (!cell) {
        return;
      }

      if (!this.focusService.isCellFocused(cellPosition)) {
        this.focusService.setFocusedCell(cellPosition);
      }

      cell.startRowOrCellEdit(params.key);
    }
    /** @deprecated v31.1 addAggFunc(key, func) is  deprecated, please use addAggFuncs({ key: func }) instead. */

  }, {
    key: "addAggFunc",
    value: function addAggFunc(key, aggFunc) {
      this.logDeprecation("v31.1", "addAggFunc(key, func)", "addAggFuncs({ key: func })");

      if (this.aggFuncService) {
        this.aggFuncService.addAggFuncs({
          key: aggFunc
        });
      }
    }
    /** Add aggregations function with the specified keys. */

  }, {
    key: "addAggFuncs",
    value: function addAggFuncs(aggFuncs) {
      if (this.aggFuncService) {
        this.aggFuncService.addAggFuncs(aggFuncs);
      }
    }
    /** Clears all aggregation functions (including those provided by the grid). */

  }, {
    key: "clearAggFuncs",
    value: function clearAggFuncs() {
      if (this.aggFuncService) {
        this.aggFuncService.clear();
      }
    }
    /** Apply transactions to the server side row model. */

  }, {
    key: "applyServerSideTransaction",
    value: function applyServerSideTransaction(transaction) {
      if (!this.serverSideTransactionManager) {
        this.logMissingRowModel("applyServerSideTransaction", "serverSide");
        return;
      }

      return this.serverSideTransactionManager.applyTransaction(transaction);
    }
    /** Batch apply transactions to the server side row model. */

  }, {
    key: "applyServerSideTransactionAsync",
    value: function applyServerSideTransactionAsync(transaction, callback) {
      if (!this.serverSideTransactionManager) {
        this.logMissingRowModel("applyServerSideTransactionAsync", "serverSide");
        return;
      }

      return this.serverSideTransactionManager.applyTransactionAsync(transaction, callback);
    }
    /**
     * Applies row data to a server side store.
     * New rows will overwrite rows at the same index in the same way as if provided by a datasource success callback.
    */

  }, {
    key: "applyServerSideRowData",
    value: function applyServerSideRowData(params) {
      var _a, _b;

      var startRow = (_a = params.startRow) != null ? _a : 0;
      var route = (_b = params.route) != null ? _b : [];

      if (startRow < 0) {
        console.warn("AG Grid: invalid value ".concat(params.startRow, " for startRow, the value should be >= 0"));
        return;
      }

      if (this.serverSideRowModel) {
        this.serverSideRowModel.applyRowData(params.successParams, startRow, route);
      } else {
        this.logMissingRowModel("setServerSideDatasource", "serverSide");
      }
    }
    /** Gets all failed server side loads to retry. */

  }, {
    key: "retryServerSideLoads",
    value: function retryServerSideLoads() {
      if (!this.serverSideRowModel) {
        this.logMissingRowModel("retryServerSideLoads", "serverSide");
        return;
      }

      this.serverSideRowModel.retryLoads();
    }
  }, {
    key: "flushServerSideAsyncTransactions",
    value: function flushServerSideAsyncTransactions() {
      if (!this.serverSideTransactionManager) {
        this.logMissingRowModel("flushServerSideAsyncTransactions", "serverSide");
        return;
      }

      return this.serverSideTransactionManager.flushAsyncTransactions();
    }
    /** Update row data. Pass a transaction object with lists for `add`, `remove` and `update`. */

  }, {
    key: "applyTransaction",
    value: function applyTransaction(rowDataTransaction) {
      var _this229 = this;

      if (!this.clientSideRowModel) {
        this.logMissingRowModel("applyTransaction", "clientSide");
        return;
      }

      return this.frameworkOverrides.wrapIncoming(function () {
        return _this229.clientSideRowModel.updateRowData(rowDataTransaction);
      });
    }
    /** Same as `applyTransaction` except executes asynchronously for efficiency. */

  }, {
    key: "applyTransactionAsync",
    value: function applyTransactionAsync(rowDataTransaction, callback) {
      var _this230 = this;

      if (!this.clientSideRowModel) {
        this.logMissingRowModel("applyTransactionAsync", "clientSide");
        return;
      }

      this.frameworkOverrides.wrapIncoming(function () {
        return _this230.clientSideRowModel.batchUpdateRowData(rowDataTransaction, callback);
      });
    }
    /** Executes any remaining asynchronous grid transactions, if any are waiting to be executed. */

  }, {
    key: "flushAsyncTransactions",
    value: function flushAsyncTransactions() {
      var _this231 = this;

      if (!this.clientSideRowModel) {
        this.logMissingRowModel("flushAsyncTransactions", "clientSide");
        return;
      }

      this.frameworkOverrides.wrapIncoming(function () {
        return _this231.clientSideRowModel.flushAsyncTransactions();
      });
    }
    /**
     * Marks all the currently loaded blocks in the cache for reload.
     * If you have 10 blocks in the cache, all 10 will be marked for reload.
     * The old data will continue to be displayed until the new data is loaded.
     */

  }, {
    key: "refreshInfiniteCache",
    value: function refreshInfiniteCache() {
      if (this.infiniteRowModel) {
        this.infiniteRowModel.refreshCache();
      } else {
        this.logMissingRowModel("refreshInfiniteCache", "infinite");
      }
    }
    /**
     * Purges the cache.
     * The grid is then told to refresh. Only the blocks required to display the current data on screen are fetched (typically no more than 2).
     * The grid will display nothing while the new blocks are loaded.
     * Use this to immediately remove the old data from the user.
     */

  }, {
    key: "purgeInfiniteCache",
    value: function purgeInfiniteCache() {
      if (this.infiniteRowModel) {
        this.infiniteRowModel.purgeCache();
      } else {
        this.logMissingRowModel("purgeInfiniteCache", "infinite");
      }
    }
    /**
     * Refresh a server-side store level.
     * If you pass no parameters, then the top level store is refreshed.
     * To refresh a child level, pass in the string of keys to get to the desired level.
     * Once the store refresh is complete, the storeRefreshed event is fired.
     */

  }, {
    key: "refreshServerSide",
    value: function refreshServerSide(params) {
      if (!this.serverSideRowModel) {
        this.logMissingRowModel("refreshServerSide", "serverSide");
        return;
      }

      this.serverSideRowModel.refreshStore(params);
    }
    /** Returns info on all server side group levels. */

  }, {
    key: "getServerSideGroupLevelState",
    value: function getServerSideGroupLevelState() {
      if (!this.serverSideRowModel) {
        this.logMissingRowModel("getServerSideGroupLevelState", "serverSide");
        return [];
      }

      return this.serverSideRowModel.getStoreState();
    }
    /** The row count defines how many rows the grid allows scrolling to. */

  }, {
    key: "getInfiniteRowCount",
    value: function getInfiniteRowCount() {
      if (this.infiniteRowModel) {
        return this.infiniteRowModel.getRowCount();
      } else {
        this.logMissingRowModel("getInfiniteRowCount", "infinite");
      }
    }
    /** Returns `true` if grid allows for scrolling past the last row to load more rows, thus providing infinite scroll. */

  }, {
    key: "isLastRowIndexKnown",
    value: function isLastRowIndexKnown() {
      if (this.infiniteRowModel) {
        return this.infiniteRowModel.isLastRowIndexKnown();
      } else {
        this.logMissingRowModel("isLastRowIndexKnown", "infinite");
      }
    }
    /**
     * Returns an object representing the state of the cache. This is useful for debugging and understanding how the cache is working.
     */

  }, {
    key: "getCacheBlockState",
    value: function getCacheBlockState() {
      return this.rowNodeBlockLoader.getBlockState();
    }
    /** @deprecated v31.1 `getFirstDisplayedRow` is deprecated. Please use `getFirstDisplayedRowIndex` instead. */

  }, {
    key: "getFirstDisplayedRow",
    value: function getFirstDisplayedRow() {
      this.logDeprecation("v31.1", "getFirstDisplayedRow", "getFirstDisplayedRowIndex");
      return this.getFirstDisplayedRowIndex();
    }
    /** Get the index of the first displayed row due to scrolling (includes invisible rendered rows in the buffer). */

  }, {
    key: "getFirstDisplayedRowIndex",
    value: function getFirstDisplayedRowIndex() {
      return this.rowRenderer.getFirstVirtualRenderedRow();
    }
    /** @deprecated v31.1 `getLastDisplayedRow` is deprecated. Please use `getLastDisplayedRowIndex` instead. */

  }, {
    key: "getLastDisplayedRow",
    value: function getLastDisplayedRow() {
      this.logDeprecation("v31.1", "getLastDisplayedRow", "getLastDisplayedRowIndex");
      return this.getLastDisplayedRowIndex();
    }
    /** Get the index of the last displayed row due to scrolling (includes invisible rendered rows in the buffer). */

  }, {
    key: "getLastDisplayedRowIndex",
    value: function getLastDisplayedRowIndex() {
      return this.rowRenderer.getLastVirtualRenderedRow();
    }
    /** Returns the displayed `RowNode` at the given `index`. */

  }, {
    key: "getDisplayedRowAtIndex",
    value: function getDisplayedRowAtIndex(index) {
      return this.rowModel.getRow(index);
    }
    /** Returns the total number of displayed rows. */

  }, {
    key: "getDisplayedRowCount",
    value: function getDisplayedRowCount() {
      return this.rowModel.getRowCount();
    }
    /**
     * Returns `true` when the last page is known.
     * This will always be `true` if you are using the Client-Side Row Model for pagination.
     * Returns `false` when the last page is not known; this only happens when using Infinite Row Model.
     */

  }, {
    key: "paginationIsLastPageFound",
    value: function paginationIsLastPageFound() {
      return this.paginationProxy.isLastPageFound();
    }
    /** Returns how many rows are being shown per page. */

  }, {
    key: "paginationGetPageSize",
    value: function paginationGetPageSize() {
      return this.paginationProxy.getPageSize();
    }
    /** Returns the 0-based index of the page which is showing. */

  }, {
    key: "paginationGetCurrentPage",
    value: function paginationGetCurrentPage() {
      return this.paginationProxy.getCurrentPage();
    }
    /** Returns the total number of pages. Returns `null` if `paginationIsLastPageFound() === false`. */

  }, {
    key: "paginationGetTotalPages",
    value: function paginationGetTotalPages() {
      return this.paginationProxy.getTotalPages();
    }
    /** The total number of rows. Returns `null` if `paginationIsLastPageFound() === false`. */

  }, {
    key: "paginationGetRowCount",
    value: function paginationGetRowCount() {
      return this.paginationProxy.getMasterRowCount();
    }
    /** Navigates to the next page. */

  }, {
    key: "paginationGoToNextPage",
    value: function paginationGoToNextPage() {
      this.paginationProxy.goToNextPage();
    }
    /** Navigates to the previous page. */

  }, {
    key: "paginationGoToPreviousPage",
    value: function paginationGoToPreviousPage() {
      this.paginationProxy.goToPreviousPage();
    }
    /** Navigates to the first page. */

  }, {
    key: "paginationGoToFirstPage",
    value: function paginationGoToFirstPage() {
      this.paginationProxy.goToFirstPage();
    }
    /** Navigates to the last page. */

  }, {
    key: "paginationGoToLastPage",
    value: function paginationGoToLastPage() {
      this.paginationProxy.goToLastPage();
    }
    /** Goes to the specified page. If the page requested doesn't exist, it will go to the last page. */

  }, {
    key: "paginationGoToPage",
    value: function paginationGoToPage(page) {
      this.paginationProxy.goToPage(page);
    } // Methods migrated from old ColumnApi

    /**
     * Adjusts the size of columns to fit the available horizontal space.
     *
     * Note: it is not recommended to call this method rapidly e.g. in response
     * to window resize events or as the container size is animated. This can
     * cause the scrollbar to flicker. Use column flex for smoother results.
     * 
     * If inferring cell data types with custom column types
     * and row data is provided asynchronously, the column sizing will happen asynchronously when row data is added.
     * To always perform this synchronously, set `cellDataType = false` on the default column definition.
     **/

  }, {
    key: "sizeColumnsToFit",
    value: function sizeColumnsToFit(paramsOrGridWidth) {
      if (typeof paramsOrGridWidth === "number") {
        this.columnModel.sizeColumnsToFit(paramsOrGridWidth, "api");
      } else {
        this.gridBodyCtrl.sizeColumnsToFit(paramsOrGridWidth);
      }
    }
    /** Call this if you want to open or close a column group. */

  }, {
    key: "setColumnGroupOpened",
    value: function setColumnGroupOpened(group, newValue) {
      this.columnModel.setColumnGroupOpened(group, newValue, "api");
    }
    /** Returns the column group with the given name. */

  }, {
    key: "getColumnGroup",
    value: function getColumnGroup(name, instanceId) {
      return this.columnModel.getColumnGroup(name, instanceId);
    }
    /** Returns the provided column group with the given name. */

  }, {
    key: "getProvidedColumnGroup",
    value: function getProvidedColumnGroup(name) {
      return this.columnModel.getProvidedColumnGroup(name);
    }
    /** Returns the display name for a column. Useful if you are doing your own header rendering and want the grid to work out if `headerValueGetter` is used, or if you are doing your own column management GUI, to know what to show as the column name. */

  }, {
    key: "getDisplayNameForColumn",
    value: function getDisplayNameForColumn(column, location) {
      return this.columnModel.getDisplayNameForColumn(column, location) || "";
    }
    /** Returns the display name for a column group (when grouping columns). */

  }, {
    key: "getDisplayNameForColumnGroup",
    value: function getDisplayNameForColumnGroup(columnGroup, location) {
      return this.columnModel.getDisplayNameForColumnGroup(columnGroup, location) || "";
    }
    /** Returns the column with the given `colKey`, which can either be the `colId` (a string) or the `colDef` (an object). */

  }, {
    key: "getColumn",
    value: function getColumn(key) {
      return this.columnModel.getPrimaryColumn(key);
    }
    /** Returns all the columns, regardless of visible or not. */

  }, {
    key: "getColumns",
    value: function getColumns() {
      return this.columnModel.getAllPrimaryColumns();
    }
    /** Applies the state of the columns from a previous state. Returns `false` if one or more columns could not be found. */

  }, {
    key: "applyColumnState",
    value: function applyColumnState(params) {
      return this.columnModel.applyColumnState(params, "api");
    }
    /** Gets the state of the columns. Typically used when saving column state. */

  }, {
    key: "getColumnState",
    value: function getColumnState() {
      return this.columnModel.getColumnState();
    }
    /** Sets the state back to match the originally provided column definitions. */

  }, {
    key: "resetColumnState",
    value: function resetColumnState() {
      this.columnModel.resetColumnState("api");
    }
    /** Gets the state of the column groups. Typically used when saving column group state. */

  }, {
    key: "getColumnGroupState",
    value: function getColumnGroupState() {
      return this.columnModel.getColumnGroupState();
    }
    /** Sets the state of the column group state from a previous state. */

  }, {
    key: "setColumnGroupState",
    value: function setColumnGroupState(stateItems) {
      this.columnModel.setColumnGroupState(stateItems, "api");
    }
    /** Sets the state back to match the originally provided column definitions. */

  }, {
    key: "resetColumnGroupState",
    value: function resetColumnGroupState() {
      this.columnModel.resetColumnGroupState("api");
    }
    /** Returns `true` if pinning left or right, otherwise `false`. */

  }, {
    key: "isPinning",
    value: function isPinning() {
      return this.columnModel.isPinningLeft() || this.columnModel.isPinningRight();
    }
    /** Returns `true` if pinning left, otherwise `false`. */

  }, {
    key: "isPinningLeft",
    value: function isPinningLeft() {
      return this.columnModel.isPinningLeft();
    }
    /** Returns `true` if pinning right, otherwise `false`. */

  }, {
    key: "isPinningRight",
    value: function isPinningRight() {
      return this.columnModel.isPinningRight();
    }
    /** Returns the column to the right of the provided column, taking into consideration open / closed column groups and visible columns. This is useful if you need to know what column is beside yours e.g. if implementing your own cell navigation. */

  }, {
    key: "getDisplayedColAfter",
    value: function getDisplayedColAfter(col) {
      return this.columnModel.getDisplayedColAfter(col);
    }
    /** Same as `getVisibleColAfter` except gives column to the left. */

  }, {
    key: "getDisplayedColBefore",
    value: function getDisplayedColBefore(col) {
      return this.columnModel.getDisplayedColBefore(col);
    }
    /** @deprecated v31.1 setColumnVisible(key, visible) deprecated, please use setColumnsVisible([key], visible) instead. */

  }, {
    key: "setColumnVisible",
    value: function setColumnVisible(key, visible) {
      this.logDeprecation("v31.1", "setColumnVisible(key,visible)", "setColumnsVisible([key],visible)");
      this.columnModel.setColumnsVisible([key], visible, "api");
    }
    /** Sets the visibility of columns. Key can be the column ID or `Column` object. */

  }, {
    key: "setColumnsVisible",
    value: function setColumnsVisible(keys2, visible) {
      this.columnModel.setColumnsVisible(keys2, visible, "api");
    }
    /** @deprecated v31.1 setColumnPinned(key, pinned) deprecated, please use setColumnsPinned([key], pinned) instead. */

  }, {
    key: "setColumnPinned",
    value: function setColumnPinned(key, pinned) {
      this.logDeprecation("v31.1", "setColumnPinned(key,pinned)", "setColumnsPinned([key],pinned)");
      this.columnModel.setColumnsPinned([key], pinned, "api");
    }
    /** Set a column's pinned / unpinned state. Key can be the column ID, field, `ColDef` object or `Column` object. */

  }, {
    key: "setColumnsPinned",
    value: function setColumnsPinned(keys2, pinned) {
      this.columnModel.setColumnsPinned(keys2, pinned, "api");
    }
    /**
     * Returns all the grid columns, same as `getColumns()`, except
     *
     *  a) it has the order of the columns that are presented in the grid
     *
     *  b) it's after the 'pivot' step, so if pivoting, has the value columns for the pivot.
     */

  }, {
    key: "getAllGridColumns",
    value: function getAllGridColumns() {
      return this.columnModel.getAllGridColumns();
    }
    /** Same as `getAllDisplayedColumns` but just for the pinned left portion of the grid. */

  }, {
    key: "getDisplayedLeftColumns",
    value: function getDisplayedLeftColumns() {
      return this.columnModel.getDisplayedLeftColumns();
    }
    /** Same as `getAllDisplayedColumns` but just for the center portion of the grid. */

  }, {
    key: "getDisplayedCenterColumns",
    value: function getDisplayedCenterColumns() {
      return this.columnModel.getDisplayedCenterColumns();
    }
    /** Same as `getAllDisplayedColumns` but just for the pinned right portion of the grid. */

  }, {
    key: "getDisplayedRightColumns",
    value: function getDisplayedRightColumns() {
      return this.columnModel.getDisplayedRightColumns();
    }
    /** Returns all columns currently displayed (e.g. are visible and if in a group, the group is showing the columns) for the pinned left, centre and pinned right portions of the grid. */

  }, {
    key: "getAllDisplayedColumns",
    value: function getAllDisplayedColumns() {
      return this.columnModel.getAllDisplayedColumns();
    }
    /** Same as `getAllGridColumns()`, except only returns rendered columns, i.e. columns that are not within the viewport and therefore not rendered, due to column virtualisation, are not displayed. */

  }, {
    key: "getAllDisplayedVirtualColumns",
    value: function getAllDisplayedVirtualColumns() {
      return this.columnModel.getViewportColumns();
    }
    /** @deprecated v31.1 moveColumn(key, toIndex) deprecated, please use moveColumns([key], toIndex) instead. */

  }, {
    key: "moveColumn",
    value: function moveColumn(key, toIndex) {
      this.logDeprecation("v31.1", "moveColumn(key, toIndex)", "moveColumns([key], toIndex)");
      this.columnModel.moveColumns([key], toIndex, "api");
    }
    /** Moves the column at `fromIdex` to `toIndex`. The column is first removed, then added at the `toIndex` location, thus index locations will change to the right of the column after the removal. */

  }, {
    key: "moveColumnByIndex",
    value: function moveColumnByIndex(fromIndex, toIndex) {
      this.columnModel.moveColumnByIndex(fromIndex, toIndex, "api");
    }
    /** Moves columns to `toIndex`. The columns are first removed, then added at the `toIndex` location, thus index locations will change to the right of the column after the removal. */

  }, {
    key: "moveColumns",
    value: function moveColumns(columnsToMoveKeys, toIndex) {
      this.columnModel.moveColumns(columnsToMoveKeys, toIndex, "api");
    }
    /** Move the column to a new position in the row grouping order. */

  }, {
    key: "moveRowGroupColumn",
    value: function moveRowGroupColumn(fromIndex, toIndex) {
      this.columnModel.moveRowGroupColumn(fromIndex, toIndex, "api");
    }
    /** Sets the agg function for a column. `aggFunc` can be one of the built-in aggregations or a custom aggregation by name or direct function. */

  }, {
    key: "setColumnAggFunc",
    value: function setColumnAggFunc(key, aggFunc) {
      this.columnModel.setColumnAggFunc(key, aggFunc, "api");
    }
    /** @deprecated v31.1 setColumnWidths(key, newWidth) deprecated, please use setColumnWidths( [{key: newWidth}] ) instead. */

  }, {
    key: "setColumnWidth",
    value: function setColumnWidth(key, newWidth) {
      var finished = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "api";
      this.logDeprecation("v31.1", "setColumnWidth(col, width)", "setColumnWidths([{key: col, newWidth: width}])");
      this.columnModel.setColumnWidths([{
        key: key,
        newWidth: newWidth
      }], false, finished, source);
    }
    /** Sets the column widths of the columns provided. The finished flag gets included in the resulting event and not used internally by the grid. The finished flag is intended for dragging, where a dragging action will produce many `columnWidth` events, so the consumer of events knows when it receives the last event in a stream. The finished parameter is optional, and defaults to `true`. */

  }, {
    key: "setColumnWidths",
    value: function setColumnWidths(columnWidths) {
      var finished = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "api";
      this.columnModel.setColumnWidths(columnWidths, false, finished, source);
    }
    /** Get the pivot mode. */

  }, {
    key: "isPivotMode",
    value: function isPivotMode() {
      return this.columnModel.isPivotMode();
    }
    /** Returns the pivot result column for the given `pivotKeys` and `valueColId`. Useful to then call operations on the pivot column. */

  }, {
    key: "getPivotResultColumn",
    value: function getPivotResultColumn(pivotKeys, valueColKey) {
      return this.columnModel.getSecondaryPivotColumn(pivotKeys, valueColKey);
    }
    /** Set the value columns to the provided list of columns. */

  }, {
    key: "setValueColumns",
    value: function setValueColumns(colKeys) {
      this.columnModel.setValueColumns(colKeys, "api");
    }
    /** Get a list of the existing value columns. */

  }, {
    key: "getValueColumns",
    value: function getValueColumns() {
      return this.columnModel.getValueColumns();
    }
    /** @deprecated v31.1 removeValueColumn(colKey) deprecated, please use removeValueColumns([colKey]) instead. */

  }, {
    key: "removeValueColumn",
    value: function removeValueColumn(colKey) {
      this.logDeprecation("v31.1", "removeValueColumn(colKey)", "removeValueColumns([colKey])");
      this.columnModel.removeValueColumns([colKey], "api");
    }
    /** Remove the given list of columns from the existing set of value columns. */

  }, {
    key: "removeValueColumns",
    value: function removeValueColumns(colKeys) {
      this.columnModel.removeValueColumns(colKeys, "api");
    }
    /** @deprecated v31.1 addValueColumn(colKey) deprecated, please use addValueColumns([colKey]) instead. */

  }, {
    key: "addValueColumn",
    value: function addValueColumn(colKey) {
      this.logDeprecation("v31.1", "addValueColumn(colKey)", "addValueColumns([colKey])");
      this.columnModel.addValueColumns([colKey], "api");
    }
    /** Add the given list of columns to the existing set of value columns. */

  }, {
    key: "addValueColumns",
    value: function addValueColumns(colKeys) {
      this.columnModel.addValueColumns(colKeys, "api");
    }
    /** Set the row group columns. */

  }, {
    key: "setRowGroupColumns",
    value: function setRowGroupColumns(colKeys) {
      this.columnModel.setRowGroupColumns(colKeys, "api");
    }
    /** @deprecated v31.1 removeRowGroupColumn(colKey) deprecated, please use removeRowGroupColumns([colKey]) instead. */

  }, {
    key: "removeRowGroupColumn",
    value: function removeRowGroupColumn(colKey) {
      this.logDeprecation("v31.1", "removeRowGroupColumn(colKey)", "removeRowGroupColumns([colKey])");
      this.columnModel.removeRowGroupColumns([colKey], "api");
    }
    /** Remove columns from the row groups. */

  }, {
    key: "removeRowGroupColumns",
    value: function removeRowGroupColumns(colKeys) {
      this.columnModel.removeRowGroupColumns(colKeys, "api");
    }
    /** @deprecated v31.1 addRowGroupColumn(colKey) deprecated, please use addRowGroupColumns([colKey]) instead. */

  }, {
    key: "addRowGroupColumn",
    value: function addRowGroupColumn(colKey) {
      this.logDeprecation("v31.1", "addRowGroupColumn(colKey)", "addRowGroupColumns([colKey])");
      this.columnModel.addRowGroupColumns([colKey], "api");
    }
    /** Add columns to the row groups. */

  }, {
    key: "addRowGroupColumns",
    value: function addRowGroupColumns(colKeys) {
      this.columnModel.addRowGroupColumns(colKeys, "api");
    }
    /** Get row group columns. */

  }, {
    key: "getRowGroupColumns",
    value: function getRowGroupColumns() {
      return this.columnModel.getRowGroupColumns();
    }
    /** Set the pivot columns. */

  }, {
    key: "setPivotColumns",
    value: function setPivotColumns(colKeys) {
      this.columnModel.setPivotColumns(colKeys, "api");
    }
    /** @deprecated v31.1 removePivotColumn(colKey) deprecated, please use removePivotColumns([colKey]) instead. */

  }, {
    key: "removePivotColumn",
    value: function removePivotColumn(colKey) {
      this.logDeprecation("v31.1", "removePivotColumn(colKey)", "removePivotColumns([colKey])");
      this.columnModel.removePivotColumns([colKey], "api");
    }
    /** Remove pivot columns. */

  }, {
    key: "removePivotColumns",
    value: function removePivotColumns(colKeys) {
      this.columnModel.removePivotColumns(colKeys, "api");
    }
    /** @deprecated v31.1 addPivotColumn(colKey) deprecated, please use addPivotColumns([colKey]) instead. */

  }, {
    key: "addPivotColumn",
    value: function addPivotColumn(colKey) {
      this.logDeprecation("v31.1", "addPivotColumn(colKey)", "addPivotColumns([colKey])");
      this.columnModel.addPivotColumns([colKey], "api");
    }
    /** Add pivot columns. */

  }, {
    key: "addPivotColumns",
    value: function addPivotColumns(colKeys) {
      this.columnModel.addPivotColumns(colKeys, "api");
    }
    /** Get the pivot columns. */

  }, {
    key: "getPivotColumns",
    value: function getPivotColumns() {
      return this.columnModel.getPivotColumns();
    }
    /** Same as `getAllDisplayedColumnGroups` but just for the pinned left portion of the grid. */

  }, {
    key: "getLeftDisplayedColumnGroups",
    value: function getLeftDisplayedColumnGroups() {
      return this.columnModel.getDisplayedTreeLeft();
    }
    /** Same as `getAllDisplayedColumnGroups` but just for the center portion of the grid. */

  }, {
    key: "getCenterDisplayedColumnGroups",
    value: function getCenterDisplayedColumnGroups() {
      return this.columnModel.getDisplayedTreeCentre();
    }
    /** Same as `getAllDisplayedColumnGroups` but just for the pinned right portion of the grid. */

  }, {
    key: "getRightDisplayedColumnGroups",
    value: function getRightDisplayedColumnGroups() {
      return this.columnModel.getDisplayedTreeRight();
    }
    /** Returns all 'root' column headers. If you are not grouping columns, these return the columns. If you are grouping, these return the top level groups - you can navigate down through each one to get the other lower level headers and finally the columns at the bottom. */

  }, {
    key: "getAllDisplayedColumnGroups",
    value: function getAllDisplayedColumnGroups() {
      return this.columnModel.getAllDisplayedTrees();
    }
    /** @deprecated v31.1 autoSizeColumn(key) deprecated, please use autoSizeColumns([colKey]) instead. */

  }, {
    key: "autoSizeColumn",
    value: function autoSizeColumn(key, skipHeader) {
      this.logDeprecation("v31.1", "autoSizeColumn(key, skipHeader)", "autoSizeColumns([key], skipHeader)");
      return this.columnModel.autoSizeColumns({
        columns: [key],
        skipHeader: skipHeader,
        source: "api"
      });
    }
    /**
     * Auto-sizes columns based on their contents. If inferring cell data types with custom column types
     * and row data is provided asynchronously, the column sizing will happen asynchronously when row data is added.
     * To always perform this synchronously, set `cellDataType = false` on the default column definition.
     */

  }, {
    key: "autoSizeColumns",
    value: function autoSizeColumns(keys2, skipHeader) {
      this.columnModel.autoSizeColumns({
        columns: keys2,
        skipHeader: skipHeader,
        source: "api"
      });
    }
    /**
     * Calls `autoSizeColumns` on all displayed columns. If inferring cell data types with custom column types
     * and row data is provided asynchronously, the column sizing will happen asynchronously when row data is added.
     * To always perform this synchronously, set `cellDataType = false` on the default column definition.
     */

  }, {
    key: "autoSizeAllColumns",
    value: function autoSizeAllColumns(skipHeader) {
      this.columnModel.autoSizeAllColumns("api", skipHeader);
    }
    /** Set the pivot result columns. */

  }, {
    key: "setPivotResultColumns",
    value: function setPivotResultColumns(colDefs) {
      this.columnModel.setSecondaryColumns(colDefs, "api");
    }
    /** Returns the grid's pivot result columns. */

  }, {
    key: "getPivotResultColumns",
    value: function getPivotResultColumns() {
      return this.columnModel.getSecondaryColumns();
    }
    /** Get the current state of the grid. Can be used in conjunction with the `initialState` grid option to save and restore grid state. */

  }, {
    key: "getState",
    value: function getState() {
      return this.stateService.getState();
    }
    /**
     * Returns the grid option value for a provided key.
     */

  }, {
    key: "getGridOption",
    value: function getGridOption(key) {
      return this.gos.get(key);
    }
    /**
     * Updates a single gridOption to the new value provided. (Cannot be used on `Initial` properties.)
     * If updating multiple options, it is recommended to instead use `api.updateGridOptions()` which batches update logic.
     */

  }, {
    key: "setGridOption",
    value: function setGridOption(key, value) {
      this.updateGridOptions(_defineProperty({}, key, value));
    }
    /**
     * Updates the provided subset of gridOptions with the provided values. (Cannot be used on `Initial` properties.)
     */

  }, {
    key: "updateGridOptions",
    value: function updateGridOptions(options) {
      this.gos.updateGridOptions({
        options: options
      });
    }
    /** Used internally by grid. Not intended to be used by the client. Interface may change between releases. */

  }, {
    key: "__internalUpdateGridOptions",
    value: function __internalUpdateGridOptions(options) {
      this.gos.updateGridOptions({
        options: options,
        source: "gridOptionsUpdated"
      });
    }
  }, {
    key: "deprecatedUpdateGridOption",
    value: function deprecatedUpdateGridOption(key, value) {
      _warnOnce("set".concat(key.charAt(0).toUpperCase()).concat(key.slice(1, key.length), " is deprecated. Please use 'api.setGridOption('").concat(key, "', newValue)' or 'api.updateGridOptions({ ").concat(key, ": newValue })' instead."));

      this.setGridOption(key, value);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Set the top pinned rows. Call with no rows / undefined to clear top pinned rows. 
     **/

  }, {
    key: "setPivotMode",
    value: function setPivotMode(pivotMode) {
      this.deprecatedUpdateGridOption("pivotMode", pivotMode);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Set the top pinned rows. Call with no rows / undefined to clear top pinned rows. 
     **/

  }, {
    key: "setPinnedTopRowData",
    value: function setPinnedTopRowData(rows) {
      this.deprecatedUpdateGridOption("pinnedTopRowData", rows);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Set the bottom pinned rows. Call with no rows / undefined to clear bottom pinned rows.
     * */

  }, {
    key: "setPinnedBottomRowData",
    value: function setPinnedBottomRowData(rows) {
      this.deprecatedUpdateGridOption("pinnedBottomRowData", rows);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * DOM element to use as the popup parent for grid popups (context menu, column menu etc).
     * */

  }, {
    key: "setPopupParent",
    value: function setPopupParent(ePopupParent) {
      this.deprecatedUpdateGridOption("popupParent", ePopupParent);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     */

  }, {
    key: "setSuppressModelUpdateAfterUpdateTransaction",
    value: function setSuppressModelUpdateAfterUpdateTransaction(value) {
      this.deprecatedUpdateGridOption("suppressModelUpdateAfterUpdateTransaction", value);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Resets the data type definitions. This will update the columns in the grid.
     * */

  }, {
    key: "setDataTypeDefinitions",
    value: function setDataTypeDefinitions(dataTypeDefinitions) {
      this.deprecatedUpdateGridOption("dataTypeDefinitions", dataTypeDefinitions);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Set whether the grid paginates the data or not.
     *  - `true` to enable pagination
     *  - `false` to disable pagination
     */

  }, {
    key: "setPagination",
    value: function setPagination(value) {
      this.deprecatedUpdateGridOption("pagination", value);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Sets the `paginationPageSize`, then re-paginates the grid so the changes are applied immediately.
     * */

  }, {
    key: "paginationSetPageSize",
    value: function paginationSetPageSize(size) {
      this.deprecatedUpdateGridOption("paginationPageSize", size);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Resets the side bar to the provided configuration. The parameter is the same as the sideBar grid property. The side bar is re-created from scratch with the new config.
     * */

  }, {
    key: "setSideBar",
    value: function setSideBar(def) {
      this.deprecatedUpdateGridOption("sideBar", def);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     */

  }, {
    key: "setSuppressClipboardPaste",
    value: function setSuppressClipboardPaste(value) {
      this.deprecatedUpdateGridOption("suppressClipboardPaste", value);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     */

  }, {
    key: "setGroupRemoveSingleChildren",
    value: function setGroupRemoveSingleChildren(value) {
      this.deprecatedUpdateGridOption("groupRemoveSingleChildren", value);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     */

  }, {
    key: "setGroupRemoveLowestSingleChildren",
    value: function setGroupRemoveLowestSingleChildren(value) {
      this.deprecatedUpdateGridOption("groupRemoveLowestSingleChildren", value);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     */

  }, {
    key: "setGroupDisplayType",
    value: function setGroupDisplayType(value) {
      this.deprecatedUpdateGridOption("groupDisplayType", value);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Sets the `groupIncludeFooter` property
     */

  }, {
    key: "setGroupIncludeFooter",
    value: function setGroupIncludeFooter(value) {
      this.deprecatedUpdateGridOption("groupIncludeFooter", value);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Sets the `groupIncludeTotalFooter` property
     */

  }, {
    key: "setGroupIncludeTotalFooter",
    value: function setGroupIncludeTotalFooter(value) {
      this.deprecatedUpdateGridOption("groupIncludeTotalFooter", value);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     */

  }, {
    key: "setRowClass",
    value: function setRowClass(className) {
      this.deprecatedUpdateGridOption("rowClass", className);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Sets the `deltaSort` property
     * */

  }, {
    key: "setDeltaSort",
    value: function setDeltaSort(enable) {
      this.deprecatedUpdateGridOption("deltaSort", enable);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Sets the `suppressRowDrag` property.
     * */

  }, {
    key: "setSuppressRowDrag",
    value: function setSuppressRowDrag(value) {
      this.deprecatedUpdateGridOption("suppressRowDrag", value);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Sets the `suppressMoveWhenRowDragging` property.
     * */

  }, {
    key: "setSuppressMoveWhenRowDragging",
    value: function setSuppressMoveWhenRowDragging(value) {
      this.deprecatedUpdateGridOption("suppressMoveWhenRowDragging", value);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Sets the `suppressRowClickSelection` property.
     * */

  }, {
    key: "setSuppressRowClickSelection",
    value: function setSuppressRowClickSelection(value) {
      this.deprecatedUpdateGridOption("suppressRowClickSelection", value);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Enable/disable the Advanced Filter
     * */

  }, {
    key: "setEnableAdvancedFilter",
    value: function setEnableAdvancedFilter(enabled) {
      this.deprecatedUpdateGridOption("enableAdvancedFilter", enabled);
    }
    /** 
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Updates the `includeHiddenColumnsInAdvancedFilter` grid option.
     * By default hidden columns are excluded from the Advanced Filter.
     * Set to `true` to include them.
     */

  }, {
    key: "setIncludeHiddenColumnsInAdvancedFilter",
    value: function setIncludeHiddenColumnsInAdvancedFilter(value) {
      this.deprecatedUpdateGridOption("includeHiddenColumnsInAdvancedFilter", value);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * DOM element to use as the parent for the Advanced Filter, to allow it to appear outside of the grid.
     * Set to `null` to appear inside the grid.
     */

  }, {
    key: "setAdvancedFilterParent",
    value: function setAdvancedFilterParent(advancedFilterParent) {
      this.deprecatedUpdateGridOption("advancedFilterParent", advancedFilterParent);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Updates the Advanced Filter Builder parameters.
     * */

  }, {
    key: "setAdvancedFilterBuilderParams",
    value: function setAdvancedFilterBuilderParams(params) {
      this.deprecatedUpdateGridOption("advancedFilterBuilderParams", params);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Pass a Quick Filter text into the grid for filtering.
     * */

  }, {
    key: "setQuickFilter",
    value: function setQuickFilter(newFilter) {
      _warnOnce("setQuickFilter is deprecated. Please use 'api.setGridOption('quickFilterText', newValue)' or 'api.updateGridOptions({ quickFilterText: newValue })' instead.");

      this.gos.updateGridOptions({
        options: {
          quickFilterText: newFilter
        }
      });
    }
    /** 
     * @deprecated As of v30, hidden columns are excluded from the Quick Filter by default. To include hidden columns, use `setIncludeHiddenColumnsInQuickFilter` instead.
     */

  }, {
    key: "setExcludeHiddenColumnsFromQuickFilter",
    value: function setExcludeHiddenColumnsFromQuickFilter(value) {
      this.deprecatedUpdateGridOption("includeHiddenColumnsInQuickFilter", !value);
    }
    /** 
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Updates the `includeHiddenColumnsInQuickFilter` grid option.
     * By default hidden columns are excluded from the Quick Filter.
     * Set to `true` to include them.
     */

  }, {
    key: "setIncludeHiddenColumnsInQuickFilter",
    value: function setIncludeHiddenColumnsInQuickFilter(value) {
      this.deprecatedUpdateGridOption("includeHiddenColumnsInQuickFilter", value);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Updates the `quickFilterParser` grid option,
     * which changes how the Quick Filter splits the Quick Filter text into search terms.
     */

  }, {
    key: "setQuickFilterParser",
    value: function setQuickFilterParser(quickFilterParser) {
      this.deprecatedUpdateGridOption("quickFilterParser", quickFilterParser);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Updates the `quickFilterMatcher` grid option,
     * which changes the matching logic for whether a row passes the Quick Filter.
     */

  }, {
    key: "setQuickFilterMatcher",
    value: function setQuickFilterMatcher(quickFilterMatcher) {
      this.deprecatedUpdateGridOption("quickFilterMatcher", quickFilterMatcher);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * If `true`, the horizontal scrollbar will always be present, even if not required. Otherwise, it will only be displayed when necessary.
     * */

  }, {
    key: "setAlwaysShowHorizontalScroll",
    value: function setAlwaysShowHorizontalScroll(show) {
      this.deprecatedUpdateGridOption("alwaysShowHorizontalScroll", show);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * If `true`, the vertical scrollbar will always be present, even if not required. Otherwise it will only be displayed when necessary.
     * */

  }, {
    key: "setAlwaysShowVerticalScroll",
    value: function setAlwaysShowVerticalScroll(show) {
      this.deprecatedUpdateGridOption("alwaysShowVerticalScroll", show);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     */

  }, {
    key: "setFunctionsReadOnly",
    value: function setFunctionsReadOnly(readOnly) {
      this.deprecatedUpdateGridOption("functionsReadOnly", readOnly);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Call to set new column definitions. The grid will redraw all the column headers, and then redraw all of the rows.
     */

  }, {
    key: "setColumnDefs",
    value: function setColumnDefs(colDefs) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "api";

      _warnOnce("setColumnDefs is deprecated. Please use 'api.setGridOption('columnDefs', newValue)' or 'api.updateGridOptions({ columnDefs: newValue })' instead.");

      this.gos.updateGridOptions({
        options: {
          columnDefs: colDefs
        },
        source: source
      });
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Call to set new auto group column definition. The grid will recreate any auto-group columns if present.
     * */

  }, {
    key: "setAutoGroupColumnDef",
    value: function setAutoGroupColumnDef(colDef) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "api";

      _warnOnce("setAutoGroupColumnDef is deprecated. Please use 'api.setGridOption('autoGroupColumnDef', newValue)' or 'api.updateGridOptions({ autoGroupColumnDef: newValue })' instead.");

      this.gos.updateGridOptions({
        options: {
          autoGroupColumnDef: colDef
        },
        source: source
      });
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Call to set new Default Column Definition.
     * */

  }, {
    key: "setDefaultColDef",
    value: function setDefaultColDef(colDef) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "api";

      _warnOnce("setDefaultColDef is deprecated. Please use 'api.setGridOption('defaultColDef', newValue)' or 'api.updateGridOptions({ defaultColDef: newValue })' instead.");

      this.gos.updateGridOptions({
        options: {
          defaultColDef: colDef
        },
        source: source
      });
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Call to set new Column Types.
     * */

  }, {
    key: "setColumnTypes",
    value: function setColumnTypes(columnTypes) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "api";

      _warnOnce("setColumnTypes is deprecated. Please use 'api.setGridOption('columnTypes', newValue)' or 'api.updateGridOptions({ columnTypes: newValue })' instead.");

      this.gos.updateGridOptions({
        options: {
          columnTypes: columnTypes
        },
        source: source
      });
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Sets the `treeData` property.
     * */

  }, {
    key: "setTreeData",
    value: function setTreeData(newTreeData) {
      this.deprecatedUpdateGridOption("treeData", newTreeData);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Set new datasource for Server-Side Row Model.
     * */

  }, {
    key: "setServerSideDatasource",
    value: function setServerSideDatasource(datasource) {
      this.deprecatedUpdateGridOption("serverSideDatasource", datasource);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * 
     * Note this purges all the cached data and reloads all the rows of the grid.
     * */

  }, {
    key: "setCacheBlockSize",
    value: function setCacheBlockSize(blockSize) {
      this.deprecatedUpdateGridOption("cacheBlockSize", blockSize);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Set new datasource for Infinite Row Model.
     * */

  }, {
    key: "setDatasource",
    value: function setDatasource(datasource) {
      this.deprecatedUpdateGridOption("datasource", datasource);
    }
    /** 
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Set new datasource for Viewport Row Model.
     * */

  }, {
    key: "setViewportDatasource",
    value: function setViewportDatasource(viewportDatasource) {
      this.deprecatedUpdateGridOption("viewportDatasource", viewportDatasource);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Set the row data.
     * */

  }, {
    key: "setRowData",
    value: function setRowData(rowData) {
      this.deprecatedUpdateGridOption("rowData", rowData);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Sets the `enableCellTextSelection` property.
     * */

  }, {
    key: "setEnableCellTextSelection",
    value: function setEnableCellTextSelection(selectable) {
      this.deprecatedUpdateGridOption("enableCellTextSelection", selectable);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Sets the height in pixels for the row containing the column label header.
     * */

  }, {
    key: "setHeaderHeight",
    value: function setHeaderHeight(headerHeight) {
      this.deprecatedUpdateGridOption("headerHeight", headerHeight);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Switch between layout options: `normal`, `autoHeight`, `print`.
     * Defaults to `normal` if no domLayout provided.
     */

  }, {
    key: "setDomLayout",
    value: function setDomLayout(domLayout) {
      this.deprecatedUpdateGridOption("domLayout", domLayout);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Sets the preferred direction for the selection fill handle.
     * */

  }, {
    key: "setFillHandleDirection",
    value: function setFillHandleDirection(direction) {
      this.deprecatedUpdateGridOption("fillHandleDirection", direction);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Sets the height in pixels for the rows containing header column groups.
     * */

  }, {
    key: "setGroupHeaderHeight",
    value: function setGroupHeaderHeight(headerHeight) {
      this.deprecatedUpdateGridOption("groupHeaderHeight", headerHeight);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Sets the height in pixels for the row containing the floating filters.
     * */

  }, {
    key: "setFloatingFiltersHeight",
    value: function setFloatingFiltersHeight(headerHeight) {
      this.deprecatedUpdateGridOption("floatingFiltersHeight", headerHeight);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Sets the height in pixels for the row containing the columns when in pivot mode.
     * */

  }, {
    key: "setPivotHeaderHeight",
    value: function setPivotHeaderHeight(headerHeight) {
      this.deprecatedUpdateGridOption("pivotHeaderHeight", headerHeight);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     * Sets the height in pixels for the row containing header column groups when in pivot mode.
     * */

  }, {
    key: "setPivotGroupHeaderHeight",
    value: function setPivotGroupHeaderHeight(headerHeight) {
      this.deprecatedUpdateGridOption("pivotGroupHeaderHeight", headerHeight);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setAnimateRows",
    value: function setAnimateRows(animateRows) {
      this.deprecatedUpdateGridOption("animateRows", animateRows);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setIsExternalFilterPresent",
    value: function setIsExternalFilterPresent(isExternalFilterPresentFunc) {
      this.deprecatedUpdateGridOption("isExternalFilterPresent", isExternalFilterPresentFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setDoesExternalFilterPass",
    value: function setDoesExternalFilterPass(doesExternalFilterPassFunc) {
      this.deprecatedUpdateGridOption("doesExternalFilterPass", doesExternalFilterPassFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setNavigateToNextCell",
    value: function setNavigateToNextCell(navigateToNextCellFunc) {
      this.deprecatedUpdateGridOption("navigateToNextCell", navigateToNextCellFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setTabToNextCell",
    value: function setTabToNextCell(tabToNextCellFunc) {
      this.deprecatedUpdateGridOption("tabToNextCell", tabToNextCellFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setTabToNextHeader",
    value: function setTabToNextHeader(tabToNextHeaderFunc) {
      this.deprecatedUpdateGridOption("tabToNextHeader", tabToNextHeaderFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setNavigateToNextHeader",
    value: function setNavigateToNextHeader(navigateToNextHeaderFunc) {
      this.deprecatedUpdateGridOption("navigateToNextHeader", navigateToNextHeaderFunc);
    }
  }, {
    key: "setRowGroupPanelShow",
    value: function setRowGroupPanelShow(rowGroupPanelShow) {
      this.deprecatedUpdateGridOption("rowGroupPanelShow", rowGroupPanelShow);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setGetGroupRowAgg",
    value: function setGetGroupRowAgg(getGroupRowAggFunc) {
      this.deprecatedUpdateGridOption("getGroupRowAgg", getGroupRowAggFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setGetBusinessKeyForNode",
    value: function setGetBusinessKeyForNode(getBusinessKeyForNodeFunc) {
      this.deprecatedUpdateGridOption("getBusinessKeyForNode", getBusinessKeyForNodeFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setGetChildCount",
    value: function setGetChildCount(getChildCountFunc) {
      this.deprecatedUpdateGridOption("getChildCount", getChildCountFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setProcessRowPostCreate",
    value: function setProcessRowPostCreate(processRowPostCreateFunc) {
      this.deprecatedUpdateGridOption("processRowPostCreate", processRowPostCreateFunc);
    }
    /**
     * @deprecated v31 `getRowId` is a static property and cannot be updated.
     *  */

  }, {
    key: "setGetRowId",
    value: function setGetRowId(getRowIdFunc) {
      _warnOnce("getRowId is a static property and can no longer be updated.");
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setGetRowClass",
    value: function setGetRowClass(rowClassFunc) {
      this.deprecatedUpdateGridOption("getRowClass", rowClassFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setIsFullWidthRow",
    value: function setIsFullWidthRow(isFullWidthRowFunc) {
      this.deprecatedUpdateGridOption("isFullWidthRow", isFullWidthRowFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setIsRowSelectable",
    value: function setIsRowSelectable(isRowSelectableFunc) {
      this.deprecatedUpdateGridOption("isRowSelectable", isRowSelectableFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setIsRowMaster",
    value: function setIsRowMaster(isRowMasterFunc) {
      this.deprecatedUpdateGridOption("isRowMaster", isRowMasterFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setPostSortRows",
    value: function setPostSortRows(postSortRowsFunc) {
      this.deprecatedUpdateGridOption("postSortRows", postSortRowsFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setGetDocument",
    value: function setGetDocument(getDocumentFunc) {
      this.deprecatedUpdateGridOption("getDocument", getDocumentFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setGetContextMenuItems",
    value: function setGetContextMenuItems(getContextMenuItemsFunc) {
      this.deprecatedUpdateGridOption("getContextMenuItems", getContextMenuItemsFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setGetMainMenuItems",
    value: function setGetMainMenuItems(getMainMenuItemsFunc) {
      this.deprecatedUpdateGridOption("getMainMenuItems", getMainMenuItemsFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setProcessCellForClipboard",
    value: function setProcessCellForClipboard(processCellForClipboardFunc) {
      this.deprecatedUpdateGridOption("processCellForClipboard", processCellForClipboardFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setSendToClipboard",
    value: function setSendToClipboard(sendToClipboardFunc) {
      this.deprecatedUpdateGridOption("sendToClipboard", sendToClipboardFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setProcessCellFromClipboard",
    value: function setProcessCellFromClipboard(processCellFromClipboardFunc) {
      this.deprecatedUpdateGridOption("processCellFromClipboard", processCellFromClipboardFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setProcessPivotResultColDef",
    value: function setProcessPivotResultColDef(processPivotResultColDefFunc) {
      this.deprecatedUpdateGridOption("processPivotResultColDef", processPivotResultColDefFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setProcessPivotResultColGroupDef",
    value: function setProcessPivotResultColGroupDef(processPivotResultColGroupDefFunc) {
      this.deprecatedUpdateGridOption("processPivotResultColGroupDef", processPivotResultColGroupDefFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setPostProcessPopup",
    value: function setPostProcessPopup(postProcessPopupFunc) {
      this.deprecatedUpdateGridOption("postProcessPopup", postProcessPopupFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setInitialGroupOrderComparator",
    value: function setInitialGroupOrderComparator(initialGroupOrderComparatorFunc) {
      this.deprecatedUpdateGridOption("initialGroupOrderComparator", initialGroupOrderComparatorFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setGetChartToolbarItems",
    value: function setGetChartToolbarItems(getChartToolbarItemsFunc) {
      this.deprecatedUpdateGridOption("getChartToolbarItems", getChartToolbarItemsFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setPaginationNumberFormatter",
    value: function setPaginationNumberFormatter(paginationNumberFormatterFunc) {
      this.deprecatedUpdateGridOption("paginationNumberFormatter", paginationNumberFormatterFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setGetServerSideGroupLevelParams",
    value: function setGetServerSideGroupLevelParams(getServerSideGroupLevelParamsFunc) {
      this.deprecatedUpdateGridOption("getServerSideGroupLevelParams", getServerSideGroupLevelParamsFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setIsServerSideGroupOpenByDefault",
    value: function setIsServerSideGroupOpenByDefault(isServerSideGroupOpenByDefaultFunc) {
      this.deprecatedUpdateGridOption("isServerSideGroupOpenByDefault", isServerSideGroupOpenByDefaultFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setIsApplyServerSideTransaction",
    value: function setIsApplyServerSideTransaction(isApplyServerSideTransactionFunc) {
      this.deprecatedUpdateGridOption("isApplyServerSideTransaction", isApplyServerSideTransactionFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setIsServerSideGroup",
    value: function setIsServerSideGroup(isServerSideGroupFunc) {
      this.deprecatedUpdateGridOption("isServerSideGroup", isServerSideGroupFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setGetServerSideGroupKey",
    value: function setGetServerSideGroupKey(getServerSideGroupKeyFunc) {
      this.deprecatedUpdateGridOption("getServerSideGroupKey", getServerSideGroupKeyFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setGetRowStyle",
    value: function setGetRowStyle(rowStyleFunc) {
      this.deprecatedUpdateGridOption("getRowStyle", rowStyleFunc);
    }
    /**
     * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
     *  */

  }, {
    key: "setGetRowHeight",
    value: function setGetRowHeight(rowHeightFunc) {
      this.deprecatedUpdateGridOption("getRowHeight", rowHeightFunc);
    }
  }]);

  return _GridApi;
}();

__decorateClass([_Autowired("rowRenderer")], _GridApi.prototype, "rowRenderer", 2);

__decorateClass([_Autowired("navigationService")], _GridApi.prototype, "navigationService", 2);

__decorateClass([_Autowired("filterManager")], _GridApi.prototype, "filterManager", 2);

__decorateClass([_Autowired("columnModel")], _GridApi.prototype, "columnModel", 2);

__decorateClass([_Autowired("selectionService")], _GridApi.prototype, "selectionService", 2);

__decorateClass([_Autowired("gridOptionsService")], _GridApi.prototype, "gos", 2);

__decorateClass([_Autowired("valueService")], _GridApi.prototype, "valueService", 2);

__decorateClass([_Autowired("alignedGridsService")], _GridApi.prototype, "alignedGridsService", 2);

__decorateClass([_Autowired("eventService")], _GridApi.prototype, "eventService", 2);

__decorateClass([_Autowired("pinnedRowModel")], _GridApi.prototype, "pinnedRowModel", 2);

__decorateClass([_Autowired("context")], _GridApi.prototype, "context", 2);

__decorateClass([_Autowired("rowModel")], _GridApi.prototype, "rowModel", 2);

__decorateClass([_Autowired("sortController")], _GridApi.prototype, "sortController", 2);

__decorateClass([_Autowired("paginationProxy")], _GridApi.prototype, "paginationProxy", 2);

__decorateClass([_Autowired("focusService")], _GridApi.prototype, "focusService", 2);

__decorateClass([_Autowired("dragAndDropService")], _GridApi.prototype, "dragAndDropService", 2);

__decorateClass([_Autowired("menuService")], _GridApi.prototype, "menuService", 2);

__decorateClass([_Autowired("valueCache")], _GridApi.prototype, "valueCache", 2);

__decorateClass([_Autowired("animationFrameService")], _GridApi.prototype, "animationFrameService", 2);

__decorateClass([_Autowired("ctrlsService")], _GridApi.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("overlayService")], _GridApi.prototype, "overlayService", 2);

__decorateClass([_Autowired("stateService")], _GridApi.prototype, "stateService", 2);

__decorateClass([_Autowired("expansionService")], _GridApi.prototype, "expansionService", 2);

__decorateClass([_Autowired("apiEventService")], _GridApi.prototype, "apiEventService", 2);

__decorateClass([_Autowired("frameworkOverrides")], _GridApi.prototype, "frameworkOverrides", 2);

__decorateClass([_Autowired("undoRedoService")], _GridApi.prototype, "undoRedoService", 2);

__decorateClass([_Autowired("rowNodeBlockLoader")], _GridApi.prototype, "rowNodeBlockLoader", 2);

__decorateClass([_Optional("csvCreator")], _GridApi.prototype, "csvCreator", 2);

__decorateClass([_Optional("excelCreator")], _GridApi.prototype, "excelCreator", 2);

__decorateClass([_Optional("rangeService")], _GridApi.prototype, "rangeService", 2);

__decorateClass([_Optional("clipboardService")], _GridApi.prototype, "clipboardService", 2);

__decorateClass([_Optional("aggFuncService")], _GridApi.prototype, "aggFuncService", 2);

__decorateClass([_Optional("statusBarService")], _GridApi.prototype, "statusBarService", 2);

__decorateClass([_Optional("chartService")], _GridApi.prototype, "chartService", 2);

__decorateClass([_Optional("ssrmTransactionManager")], _GridApi.prototype, "serverSideTransactionManager", 2);

__decorateClass([_Optional("sideBarService")], _GridApi.prototype, "sideBarService", 2);

__decorateClass([_PostConstruct], _GridApi.prototype, "init", 1);

_GridApi = __decorateClass([_Bean("gridApi")], _GridApi); // community-modules/core/src/filter/quickFilterService.ts

var _QuickFilterService =
/*#__PURE__*/
function (_BeanStub23) {
  "use strict";

  _inherits(QuickFilterService, _BeanStub23);

  function QuickFilterService() {
    var _this232;

    _classCallCheck(this, QuickFilterService);

    _this232 = _possibleConstructorReturn(this, _getPrototypeOf(QuickFilterService).apply(this, arguments));
    _this232.quickFilter = null;
    _this232.quickFilterParts = null;
    return _this232;
  }

  _createClass(QuickFilterService, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this233 = this;

      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, function () {
        return _this233.resetQuickFilterCache();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_NEW_COLUMNS_LOADED, function () {
        return _this233.resetQuickFilterCache();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_ROW_GROUP_CHANGED, function () {
        return _this233.resetQuickFilterCache();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_VISIBLE, function () {
        if (!_this233.gos.get("includeHiddenColumnsInQuickFilter")) {
          _this233.resetQuickFilterCache();
        }
      });
      this.addManagedPropertyListener("quickFilterText", function (e) {
        return _this233.setQuickFilter(e.currentValue);
      });
      this.addManagedPropertyListeners(["includeHiddenColumnsInQuickFilter", "applyQuickFilterBeforePivotOrAgg"], function () {
        return _this233.onQuickFilterColumnConfigChanged();
      });
      this.quickFilter = this.parseQuickFilter(this.gos.get("quickFilterText"));
      this.parser = this.gos.get("quickFilterParser");
      this.matcher = this.gos.get("quickFilterMatcher");
      this.setQuickFilterParts();
      this.addManagedPropertyListeners(["quickFilterMatcher", "quickFilterParser"], function () {
        return _this233.setQuickFilterParserAndMatcher();
      });
    }
  }, {
    key: "isQuickFilterPresent",
    value: function isQuickFilterPresent() {
      return this.quickFilter !== null;
    }
  }, {
    key: "doesRowPassQuickFilter",
    value: function doesRowPassQuickFilter(node) {
      var _this234 = this;

      var usingCache = this.gos.get("cacheQuickFilter");

      if (this.matcher) {
        return this.doesRowPassQuickFilterMatcher(usingCache, node);
      }

      return this.quickFilterParts.every(function (part) {
        return usingCache ? _this234.doesRowPassQuickFilterCache(node, part) : _this234.doesRowPassQuickFilterNoCache(node, part);
      });
    }
  }, {
    key: "resetQuickFilterCache",
    value: function resetQuickFilterCache() {
      this.rowModel.forEachNode(function (node) {
        return node.quickFilterAggregateText = null;
      });
    }
  }, {
    key: "setQuickFilterParts",
    value: function setQuickFilterParts() {
      var quickFilter = this.quickFilter,
          parser = this.parser;

      if (quickFilter) {
        this.quickFilterParts = parser ? parser(quickFilter) : quickFilter.split(" ");
      } else {
        this.quickFilterParts = null;
      }
    }
  }, {
    key: "parseQuickFilter",
    value: function parseQuickFilter(newFilter) {
      if (!_exists(newFilter)) {
        return null;
      }

      if (!this.gos.isRowModelType("clientSide")) {
        console.warn("AG Grid - Quick filtering only works with the Client-Side Row Model");
        return null;
      }

      return newFilter.toUpperCase();
    }
  }, {
    key: "setQuickFilter",
    value: function setQuickFilter(newFilter) {
      if (newFilter != null && typeof newFilter !== "string") {
        console.warn("AG Grid - Grid option quickFilterText only supports string inputs, received: ".concat(typeof newFilter));
        return;
      }

      var parsedFilter = this.parseQuickFilter(newFilter);

      if (this.quickFilter !== parsedFilter) {
        this.quickFilter = parsedFilter;
        this.setQuickFilterParts();
        this.dispatchEvent({
          type: _QuickFilterService.EVENT_QUICK_FILTER_CHANGED
        });
      }
    }
  }, {
    key: "setQuickFilterParserAndMatcher",
    value: function setQuickFilterParserAndMatcher() {
      var parser = this.gos.get("quickFilterParser");
      var matcher = this.gos.get("quickFilterMatcher");
      var hasChanged = parser !== this.parser || matcher !== this.matcher;
      this.parser = parser;
      this.matcher = matcher;

      if (hasChanged) {
        this.setQuickFilterParts();
        this.dispatchEvent({
          type: _QuickFilterService.EVENT_QUICK_FILTER_CHANGED
        });
      }
    }
  }, {
    key: "onQuickFilterColumnConfigChanged",
    value: function onQuickFilterColumnConfigChanged() {
      this.columnModel.refreshQuickFilterColumns();
      this.resetQuickFilterCache();

      if (this.isQuickFilterPresent()) {
        this.dispatchEvent({
          type: _QuickFilterService.EVENT_QUICK_FILTER_CHANGED
        });
      }
    }
  }, {
    key: "doesRowPassQuickFilterNoCache",
    value: function doesRowPassQuickFilterNoCache(node, filterPart) {
      var _this235 = this;

      var columns = this.columnModel.getAllColumnsForQuickFilter();
      return columns.some(function (column) {
        var part = _this235.getQuickFilterTextForColumn(column, node);

        return _exists(part) && part.indexOf(filterPart) >= 0;
      });
    }
  }, {
    key: "doesRowPassQuickFilterCache",
    value: function doesRowPassQuickFilterCache(node, filterPart) {
      this.checkGenerateQuickFilterAggregateText(node);
      return node.quickFilterAggregateText.indexOf(filterPart) >= 0;
    }
  }, {
    key: "doesRowPassQuickFilterMatcher",
    value: function doesRowPassQuickFilterMatcher(usingCache, node) {
      var quickFilterAggregateText;

      if (usingCache) {
        this.checkGenerateQuickFilterAggregateText(node);
        quickFilterAggregateText = node.quickFilterAggregateText;
      } else {
        quickFilterAggregateText = this.getQuickFilterAggregateText(node);
      }

      var quickFilterParts = this.quickFilterParts,
          matcher = this.matcher;
      return matcher(quickFilterParts, quickFilterAggregateText);
    }
  }, {
    key: "checkGenerateQuickFilterAggregateText",
    value: function checkGenerateQuickFilterAggregateText(node) {
      if (!node.quickFilterAggregateText) {
        node.quickFilterAggregateText = this.getQuickFilterAggregateText(node);
      }
    }
  }, {
    key: "getQuickFilterTextForColumn",
    value: function getQuickFilterTextForColumn(column, node) {
      var value = this.valueService.getValue(column, node, true);
      var colDef = column.getColDef();

      if (colDef.getQuickFilterText) {
        var params = this.gos.addGridCommonParams({
          value: value,
          node: node,
          data: node.data,
          column: column,
          colDef: colDef
        });
        value = colDef.getQuickFilterText(params);
      }

      return _exists(value) ? value.toString().toUpperCase() : null;
    }
  }, {
    key: "getQuickFilterAggregateText",
    value: function getQuickFilterAggregateText(node) {
      var _this236 = this;

      var stringParts = [];
      var columns = this.columnModel.getAllColumnsForQuickFilter();
      columns.forEach(function (column) {
        var part = _this236.getQuickFilterTextForColumn(column, node);

        if (_exists(part)) {
          stringParts.push(part);
        }
      });
      return stringParts.join(_QuickFilterService.QUICK_FILTER_SEPARATOR);
    }
  }]);

  return QuickFilterService;
}(_BeanStub2);

_QuickFilterService.EVENT_QUICK_FILTER_CHANGED = "quickFilterChanged";
_QuickFilterService.QUICK_FILTER_SEPARATOR = "\n";

__decorateClass([_Autowired("valueService")], _QuickFilterService.prototype, "valueService", 2);

__decorateClass([_Autowired("columnModel")], _QuickFilterService.prototype, "columnModel", 2);

__decorateClass([_Autowired("rowModel")], _QuickFilterService.prototype, "rowModel", 2);

__decorateClass([_PostConstruct], _QuickFilterService.prototype, "postConstruct", 1);

_QuickFilterService = __decorateClass([_Bean("quickFilterService")], _QuickFilterService); // community-modules/core/src/filter/filterManager.ts

var _FilterManager =
/*#__PURE__*/
function (_BeanStub24) {
  "use strict";

  _inherits(_FilterManager, _BeanStub24);

  function _FilterManager() {
    var _this237;

    _classCallCheck(this, _FilterManager);

    _this237 = _possibleConstructorReturn(this, _getPrototypeOf(_FilterManager).apply(this, arguments));
    _this237.allColumnFilters =
    /* @__PURE__ */
    new Map();
    _this237.allColumnListeners =
    /* @__PURE__ */
    new Map();
    _this237.activeAggregateFilters = [];
    _this237.activeColumnFilters = []; // this is true when the grid is processing the filter change. this is used by the cell comps, so that they
    // don't flash when data changes due to filter changes. there is no need to flash when filter changes as the
    // user is in control, so doesn't make sense to show flashing changes. for example, go to main demo where
    // this feature is turned off (hack code to always return false for isSuppressFlashingCellsBecauseFiltering(), put in)
    // 100,000 rows and group by country. then do some filtering. all the cells flash, which is silly.

    _this237.processingFilterChange = false; // when we're waiting for cell data types to be inferred, we need to defer filter model updates

    _this237.filterModelUpdateQueue = [];
    _this237.columnFilterModelUpdateQueue = [];
    _this237.advancedFilterModelUpdateQueue = [];
    return _this237;
  }

  _createClass(_FilterManager, [{
    key: "init",
    value: function init() {
      var _this238 = this;

      var _a, _b, _c;

      this.addManagedListener(this.eventService, _Events.EVENT_GRID_COLUMNS_CHANGED, function () {
        return _this238.onColumnsChanged();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_VALUE_CHANGED, function () {
        return _this238.refreshFiltersForAggregations();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_PIVOT_CHANGED, function () {
        return _this238.refreshFiltersForAggregations();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, function () {
        return _this238.refreshFiltersForAggregations();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_NEW_COLUMNS_LOADED, function () {
        return _this238.updateAdvancedFilterColumns();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_VISIBLE, function () {
        return _this238.updateAdvancedFilterColumns();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_ROW_DATA_UPDATED, function () {
        return _this238.onNewRowsLoaded("rowDataUpdated");
      });
      this.externalFilterPresent = this.isExternalFilterPresentCallback();
      this.addManagedPropertyListeners(["isExternalFilterPresent", "doesExternalFilterPass"], function () {
        _this238.onFilterChanged({
          source: "api"
        });
      });
      this.updateAggFiltering();
      this.addManagedPropertyListener("groupAggFiltering", function () {
        _this238.updateAggFiltering();

        _this238.onFilterChanged();
      });
      this.addManagedPropertyListener("advancedFilterModel", function (event) {
        return _this238.setAdvancedFilterModel(event.currentValue);
      });
      this.addManagedListener(this.eventService, _Events.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, function (_ref31) {
        var enabled = _ref31.enabled;
        return _this238.onAdvancedFilterEnabledChanged(enabled);
      });
      this.addManagedListener(this.eventService, _Events.EVENT_DATA_TYPES_INFERRED, function () {
        return _this238.processFilterModelUpdateQueue();
      });
      this.addManagedListener(this.quickFilterService, _QuickFilterService.EVENT_QUICK_FILTER_CHANGED, function () {
        return _this238.onFilterChanged({
          source: "quickFilter"
        });
      });
      this.initialFilterModel = __spreadValues({}, (_c = (_b = (_a = this.gos.get("initialState")) == null ? void 0 : _a.filter) == null ? void 0 : _b.filterModel) != null ? _c : {});
    }
  }, {
    key: "isExternalFilterPresentCallback",
    value: function isExternalFilterPresentCallback() {
      var isFilterPresent = this.gos.getCallback("isExternalFilterPresent");

      if (typeof isFilterPresent === "function") {
        return isFilterPresent({});
      }

      return false;
    }
  }, {
    key: "doesExternalFilterPass",
    value: function doesExternalFilterPass(node) {
      var doesFilterPass = this.gos.get("doesExternalFilterPass");

      if (typeof doesFilterPass === "function") {
        return doesFilterPass(node);
      }

      return false;
    }
  }, {
    key: "setFilterModel",
    value: function setFilterModel(model) {
      var _this239 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "api";

      if (this.isAdvancedFilterEnabled()) {
        this.warnAdvancedFilters();
        return;
      }

      if (this.dataTypeService.isPendingInference()) {
        this.filterModelUpdateQueue.push({
          model: model,
          source: source
        });
        return;
      }

      var allPromises = [];
      var previousModel = this.getFilterModel();

      if (model) {
        var modelKeys = _convertToSet(Object.keys(model));

        this.allColumnFilters.forEach(function (filterWrapper, colId) {
          var newModel = model[colId];
          allPromises.push(_this239.setModelOnFilterWrapper(filterWrapper.filterPromise, newModel));
          modelKeys.delete(colId);
        });
        modelKeys.forEach(function (colId) {
          var column = _this239.columnModel.getPrimaryColumn(colId) || _this239.columnModel.getGridColumn(colId);

          if (!column) {
            console.warn("AG Grid: setFilterModel() - no column found for colId: " + colId);
            return;
          }

          if (!column.isFilterAllowed()) {
            console.warn("AG Grid: setFilterModel() - unable to fully apply model, filtering disabled for colId: " + colId);
            return;
          }

          var filterWrapper = _this239.getOrCreateFilterWrapper(column, "NO_UI");

          if (!filterWrapper) {
            console.warn("AG-Grid: setFilterModel() - unable to fully apply model, unable to create filter for colId: " + colId);
            return;
          }

          allPromises.push(_this239.setModelOnFilterWrapper(filterWrapper.filterPromise, model[colId]));
        });
      } else {
        this.allColumnFilters.forEach(function (filterWrapper) {
          allPromises.push(_this239.setModelOnFilterWrapper(filterWrapper.filterPromise, null));
        });
      }

      _AgPromise2.all(allPromises).then(function () {
        var currentModel = _this239.getFilterModel();

        var columns = [];

        _this239.allColumnFilters.forEach(function (filterWrapper, colId) {
          var before = previousModel ? previousModel[colId] : null;
          var after = currentModel ? currentModel[colId] : null;

          if (!_3.jsonEquals(before, after)) {
            columns.push(filterWrapper.column);
          }
        });

        if (columns.length > 0) {
          _this239.onFilterChanged({
            columns: columns,
            source: source
          });
        }
      });
    }
  }, {
    key: "setModelOnFilterWrapper",
    value: function setModelOnFilterWrapper(filterPromise, newModel) {
      return new _AgPromise2(function (resolve) {
        filterPromise.then(function (filter) {
          if (typeof filter.setModel !== "function") {
            console.warn("AG Grid: filter missing setModel method, which is needed for setFilterModel");
            resolve();
          }

          (filter.setModel(newModel) || _AgPromise2.resolve()).then(function () {
            return resolve();
          });
        });
      });
    }
  }, {
    key: "getFilterModel",
    value: function getFilterModel() {
      var _this240 = this;

      var result = {};
      this.allColumnFilters.forEach(function (filterWrapper, key) {
        var model = _this240.getModelFromFilterWrapper(filterWrapper);

        if (_exists(model)) {
          result[key] = model;
        }
      });
      return result;
    }
  }, {
    key: "getModelFromFilterWrapper",
    value: function getModelFromFilterWrapper(filterWrapper) {
      var _a;

      var filterPromise = filterWrapper.filterPromise;
      var filter = filterPromise.resolveNow(null, function (promiseFilter) {
        return promiseFilter;
      });

      if (filter == null) {
        return (_a = this.initialFilterModel[filterWrapper.column.getColId()]) != null ? _a : null;
      }

      if (typeof filter.getModel !== "function") {
        console.warn("AG Grid: filter API missing getModel method, which is needed for getFilterModel");
        return null;
      }

      return filter.getModel();
    }
  }, {
    key: "isColumnFilterPresent",
    value: function isColumnFilterPresent() {
      return this.activeColumnFilters.length > 0;
    }
  }, {
    key: "isAggregateFilterPresent",
    value: function isAggregateFilterPresent() {
      return !!this.activeAggregateFilters.length;
    }
  }, {
    key: "isExternalFilterPresent",
    value: function isExternalFilterPresent() {
      return this.externalFilterPresent;
    }
  }, {
    key: "isChildFilterPresent",
    value: function isChildFilterPresent() {
      return this.isColumnFilterPresent() || this.isQuickFilterPresent() || this.isExternalFilterPresent() || this.isAdvancedFilterPresent();
    }
  }, {
    key: "isAdvancedFilterPresent",
    value: function isAdvancedFilterPresent() {
      return this.isAdvancedFilterEnabled() && this.advancedFilterService.isFilterPresent();
    }
  }, {
    key: "onAdvancedFilterEnabledChanged",
    value: function onAdvancedFilterEnabledChanged(enabled) {
      var _this241 = this;

      var _a;

      if (enabled) {
        if (this.allColumnFilters.size) {
          this.allColumnFilters.forEach(function (filterWrapper) {
            return _this241.disposeFilterWrapper(filterWrapper, "advancedFilterEnabled");
          });
          this.onFilterChanged({
            source: "advancedFilter"
          });
        }
      } else {
        if ((_a = this.advancedFilterService) == null ? void 0 : _a.isFilterPresent()) {
          this.advancedFilterService.setModel(null);
          this.onFilterChanged({
            source: "advancedFilter"
          });
        }
      }
    }
  }, {
    key: "isAdvancedFilterEnabled",
    value: function isAdvancedFilterEnabled() {
      var _a;

      return !!((_a = this.advancedFilterService) == null ? void 0 : _a.isEnabled());
    }
  }, {
    key: "isAdvancedFilterHeaderActive",
    value: function isAdvancedFilterHeaderActive() {
      return this.isAdvancedFilterEnabled() && this.advancedFilterService.isHeaderActive();
    }
  }, {
    key: "doAggregateFiltersPass",
    value: function doAggregateFiltersPass(node, filterToSkip) {
      return this.doColumnFiltersPass(node, filterToSkip, true);
    } // called by:
    // 1) onFilterChanged()
    // 2) onNewRowsLoaded()

  }, {
    key: "updateActiveFilters",
    value: function updateActiveFilters() {
      var _this242 = this;

      this.activeColumnFilters.length = 0;
      this.activeAggregateFilters.length = 0;

      var isFilterActive = function isFilterActive(filter) {
        if (!filter) {
          return false;
        }

        if (!filter.isFilterActive) {
          console.warn("AG Grid: Filter is missing isFilterActive() method");
          return false;
        }

        return filter.isFilterActive();
      };

      var groupFilterEnabled = !!this.gos.getGroupAggFiltering();

      var isAggFilter = function isAggFilter(column) {
        var isSecondary = !column.isPrimary();

        if (isSecondary) {
          return true;
        }

        var isShowingPrimaryColumns = !_this242.columnModel.isPivotActive();
        var isValueActive = column.isValueActive();

        if (!isValueActive || !isShowingPrimaryColumns) {
          return false;
        }

        if (_this242.columnModel.isPivotMode()) {
          return true;
        }

        return groupFilterEnabled;
      };

      this.allColumnFilters.forEach(function (filterWrapper) {
        if (filterWrapper.filterPromise.resolveNow(false, isFilterActive)) {
          var filterComp = filterWrapper.filterPromise.resolveNow(null, function (filter) {
            return filter;
          });

          if (isAggFilter(filterWrapper.column)) {
            _this242.activeAggregateFilters.push(filterComp);
          } else {
            _this242.activeColumnFilters.push(filterComp);
          }
        }
      });
    }
  }, {
    key: "updateFilterFlagInColumns",
    value: function updateFilterFlagInColumns(source, additionalEventAttributes) {
      this.allColumnFilters.forEach(function (filterWrapper) {
        var isFilterActive = filterWrapper.filterPromise.resolveNow(false, function (filter) {
          return filter.isFilterActive();
        });
        filterWrapper.column.setFilterActive(isFilterActive, source, additionalEventAttributes);
      });
    }
  }, {
    key: "isAnyFilterPresent",
    value: function isAnyFilterPresent() {
      return this.isQuickFilterPresent() || this.isColumnFilterPresent() || this.isAggregateFilterPresent() || this.isExternalFilterPresent() || this.isAdvancedFilterPresent();
    }
  }, {
    key: "doColumnFiltersPass",
    value: function doColumnFiltersPass(node, filterToSkip, targetAggregates) {
      var data = node.data,
          aggData = node.aggData;
      var targetedFilters = targetAggregates ? this.activeAggregateFilters : this.activeColumnFilters;
      var targetedData = targetAggregates ? aggData : data;

      for (var i = 0; i < targetedFilters.length; i++) {
        var filter = targetedFilters[i];

        if (filter == null || filter === filterToSkip) {
          continue;
        }

        if (typeof filter.doesFilterPass !== "function") {
          throw new Error("Filter is missing method doesFilterPass");
        }

        if (!filter.doesFilterPass({
          node: node,
          data: targetedData
        })) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "resetQuickFilterCache",
    value: function resetQuickFilterCache() {
      this.quickFilterService.resetQuickFilterCache();
    }
  }, {
    key: "refreshFiltersForAggregations",
    value: function refreshFiltersForAggregations() {
      var isAggFiltering = this.gos.getGroupAggFiltering();

      if (isAggFiltering) {
        this.onFilterChanged();
      }
    } // sometimes (especially in React) the filter can call onFilterChanged when we are in the middle
    // of a render cycle. this would be bad, so we wait for render cycle to complete when this happens.
    // this happens in react when we change React State in the grid (eg setting RowCtrl's in RowContainer)
    // which results in React State getting applied in the main application, triggering a useEffect() to
    // be kicked off adn then the application calling the grid's API. in AG-6554, the custom filter was
    // getting it's useEffect() triggered in this way.

  }, {
    key: "callOnFilterChangedOutsideRenderCycle",
    value: function callOnFilterChangedOutsideRenderCycle(params) {
      var _this243 = this;

      var action = function action() {
        return _this243.onFilterChanged(params);
      };

      if (this.rowRenderer.isRefreshInProgress()) {
        setTimeout(action, 0);
      } else {
        action();
      }
    }
  }, {
    key: "onFilterChanged",
    value: function onFilterChanged() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var source = params.source,
          filterInstance = params.filterInstance,
          additionalEventAttributes = params.additionalEventAttributes,
          columns = params.columns;
      this.updateDependantFilters();
      this.updateActiveFilters();
      this.updateFilterFlagInColumns("filterChanged", additionalEventAttributes);
      this.externalFilterPresent = this.isExternalFilterPresentCallback();
      this.allColumnFilters.forEach(function (filterWrapper) {
        if (!filterWrapper.filterPromise) {
          return;
        }

        filterWrapper.filterPromise.then(function (filter) {
          if (filter && filter !== filterInstance && filter.onAnyFilterChanged) {
            filter.onAnyFilterChanged();
          }
        });
      });
      var filterChangedEvent = {
        source: source,
        type: _Events.EVENT_FILTER_CHANGED,
        columns: columns || []
      };

      if (additionalEventAttributes) {
        _mergeDeep(filterChangedEvent, additionalEventAttributes);
      }

      this.processingFilterChange = true;
      this.eventService.dispatchEvent(filterChangedEvent);
      this.processingFilterChange = false;
    }
  }, {
    key: "isSuppressFlashingCellsBecauseFiltering",
    value: function isSuppressFlashingCellsBecauseFiltering() {
      var _a;

      var allowShowChangeAfterFilter = (_a = this.gos.get("allowShowChangeAfterFilter")) != null ? _a : false;
      return !allowShowChangeAfterFilter && this.processingFilterChange;
    }
  }, {
    key: "isQuickFilterPresent",
    value: function isQuickFilterPresent() {
      return this.quickFilterService.isQuickFilterPresent();
    }
  }, {
    key: "updateAggFiltering",
    value: function updateAggFiltering() {
      this.aggFiltering = !!this.gos.getGroupAggFiltering();
    }
  }, {
    key: "isAggregateQuickFilterPresent",
    value: function isAggregateQuickFilterPresent() {
      return this.isQuickFilterPresent() && this.shouldApplyQuickFilterAfterAgg();
    }
  }, {
    key: "isNonAggregateQuickFilterPresent",
    value: function isNonAggregateQuickFilterPresent() {
      return this.isQuickFilterPresent() && !this.shouldApplyQuickFilterAfterAgg();
    }
  }, {
    key: "shouldApplyQuickFilterAfterAgg",
    value: function shouldApplyQuickFilterAfterAgg() {
      return (this.aggFiltering || this.columnModel.isPivotMode()) && !this.gos.get("applyQuickFilterBeforePivotOrAgg");
    }
  }, {
    key: "doesRowPassOtherFilters",
    value: function doesRowPassOtherFilters(filterToSkip, node) {
      return this.doesRowPassFilter({
        rowNode: node,
        filterInstanceToSkip: filterToSkip
      });
    }
  }, {
    key: "doesRowPassAggregateFilters",
    value: function doesRowPassAggregateFilters(params) {
      if (this.isAggregateQuickFilterPresent() && !this.quickFilterService.doesRowPassQuickFilter(params.rowNode)) {
        return false;
      }

      if (this.isAggregateFilterPresent() && !this.doAggregateFiltersPass(params.rowNode, params.filterInstanceToSkip)) {
        return false;
      }

      return true;
    }
  }, {
    key: "doesRowPassFilter",
    value: function doesRowPassFilter(params) {
      if (this.isNonAggregateQuickFilterPresent() && !this.quickFilterService.doesRowPassQuickFilter(params.rowNode)) {
        return false;
      }

      if (this.isExternalFilterPresent() && !this.doesExternalFilterPass(params.rowNode)) {
        return false;
      }

      if (this.isColumnFilterPresent() && !this.doColumnFiltersPass(params.rowNode, params.filterInstanceToSkip)) {
        return false;
      }

      if (this.isAdvancedFilterPresent() && !this.advancedFilterService.doesFilterPass(params.rowNode)) {
        return false;
      }

      return true;
    }
  }, {
    key: "onNewRowsLoaded",
    value: function onNewRowsLoaded(source) {
      this.allColumnFilters.forEach(function (filterWrapper) {
        filterWrapper.filterPromise.then(function (filter) {
          if (filter.onNewRowsLoaded) {
            filter.onNewRowsLoaded();
          }
        });
      });
      this.updateFilterFlagInColumns(source, {
        afterDataChange: true
      });
      this.updateActiveFilters();
    }
  }, {
    key: "createValueGetter",
    value: function createValueGetter(column) {
      var _this244 = this;

      return function (_ref32) {
        var node = _ref32.node;
        return _this244.valueService.getValue(column, node, true);
      };
    }
  }, {
    key: "createGetValue",
    value: function createGetValue(filterColumn) {
      var _this245 = this;

      return function (rowNode, column) {
        var columnToUse = column ? _this245.columnModel.getGridColumn(column) : filterColumn;
        return columnToUse ? _this245.valueService.getValue(columnToUse, rowNode, true) : void 0;
      };
    }
  }, {
    key: "getFilterComponent",
    value: function getFilterComponent(column, source) {
      var createIfDoesNotExist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var _a;

      if (createIfDoesNotExist) {
        return ((_a = this.getOrCreateFilterWrapper(column, source)) == null ? void 0 : _a.filterPromise) || null;
      }

      var filterWrapper = this.cachedFilter(column);
      return filterWrapper ? filterWrapper.filterPromise : null;
    }
  }, {
    key: "isFilterActive",
    value: function isFilterActive(column) {
      var filterWrapper = this.cachedFilter(column);
      return !!filterWrapper && filterWrapper.filterPromise.resolveNow(false, function (filter) {
        return filter.isFilterActive();
      });
    }
  }, {
    key: "getOrCreateFilterWrapper",
    value: function getOrCreateFilterWrapper(column, source) {
      if (!column.isFilterAllowed()) {
        return null;
      }

      var filterWrapper = this.cachedFilter(column);

      if (!filterWrapper) {
        filterWrapper = this.createFilterWrapper(column, source);
        this.setColumnFilterWrapper(column, filterWrapper);
      }

      return filterWrapper;
    }
  }, {
    key: "cachedFilter",
    value: function cachedFilter(column) {
      return this.allColumnFilters.get(column.getColId());
    }
  }, {
    key: "getDefaultFilter",
    value: function getDefaultFilter(column) {
      var defaultFilter;

      if (_ModuleRegistry2.__isRegistered("@ag-grid-enterprise/set-filter"
      /* SetFilterModule */
      , this.context.getGridId())) {
        defaultFilter = "agSetColumnFilter";
      } else {
        var cellDataType = this.dataTypeService.getBaseDataType(column);

        if (cellDataType === "number") {
          defaultFilter = "agNumberColumnFilter";
        } else if (cellDataType === "date" || cellDataType === "dateString") {
          defaultFilter = "agDateColumnFilter";
        } else {
          defaultFilter = "agTextColumnFilter";
        }
      }

      return defaultFilter;
    }
  }, {
    key: "getDefaultFloatingFilter",
    value: function getDefaultFloatingFilter(column) {
      var defaultFloatingFilterType;

      if (_ModuleRegistry2.__isRegistered("@ag-grid-enterprise/set-filter"
      /* SetFilterModule */
      , this.context.getGridId())) {
        defaultFloatingFilterType = "agSetColumnFloatingFilter";
      } else {
        var cellDataType = this.dataTypeService.getBaseDataType(column);

        if (cellDataType === "number") {
          defaultFloatingFilterType = "agNumberColumnFloatingFilter";
        } else if (cellDataType === "date" || cellDataType === "dateString") {
          defaultFloatingFilterType = "agDateColumnFloatingFilter";
        } else {
          defaultFloatingFilterType = "agTextColumnFloatingFilter";
        }
      }

      return defaultFloatingFilterType;
    }
  }, {
    key: "createFilterInstance",
    value: function createFilterInstance(column) {
      var _this246 = this;

      var defaultFilter = this.getDefaultFilter(column);
      var colDef = column.getColDef();
      var filterInstance;

      var params = __spreadProps(__spreadValues({}, this.createFilterParams(column, colDef)), {
        filterModifiedCallback: function filterModifiedCallback() {
          return _this246.filterModifiedCallbackFactory(filterInstance, column)();
        },
        filterChangedCallback: function filterChangedCallback(additionalEventAttributes) {
          return _this246.filterChangedCallbackFactory(filterInstance, column)(additionalEventAttributes);
        },
        doesRowPassOtherFilter: function doesRowPassOtherFilter(node) {
          return _this246.doesRowPassOtherFilters(filterInstance, node);
        }
      });

      var compDetails = this.userComponentFactory.getFilterDetails(colDef, params, defaultFilter);

      if (!compDetails) {
        return {
          filterPromise: null,
          compDetails: null
        };
      }

      return {
        filterPromise: function filterPromise() {
          var filterPromise = compDetails.newAgStackInstance();

          if (filterPromise) {
            filterPromise.then(function (r) {
              return filterInstance = r;
            });
          }

          return filterPromise;
        },
        compDetails: compDetails
      };
    }
  }, {
    key: "createFilterParams",
    value: function createFilterParams(column, colDef) {
      var params = this.gos.addGridCommonParams({
        column: column,
        colDef: _cloneObject(colDef),
        rowModel: this.rowModel,
        filterChangedCallback: function filterChangedCallback() {},
        filterModifiedCallback: function filterModifiedCallback() {},
        valueGetter: this.createValueGetter(column),
        getValue: this.createGetValue(column),
        doesRowPassOtherFilter: function doesRowPassOtherFilter() {
          return true;
        }
      });
      return params;
    }
  }, {
    key: "createFilterWrapper",
    value: function createFilterWrapper(column, source) {
      var _a;

      var filterWrapper = {
        column: column,
        filterPromise: null,
        compiledElement: null,
        compDetails: null
      };

      var _this$createFilterIns = this.createFilterInstance(column),
          filterPromise = _this$createFilterIns.filterPromise,
          compDetails = _this$createFilterIns.compDetails;

      filterWrapper.filterPromise = (_a = filterPromise == null ? void 0 : filterPromise()) != null ? _a : null;
      filterWrapper.compDetails = compDetails;
      return filterWrapper;
    }
  }, {
    key: "onColumnsChanged",
    value: function onColumnsChanged() {
      var _this247 = this;

      var columns = [];
      this.allColumnFilters.forEach(function (wrapper, colId) {
        var currentColumn;

        if (wrapper.column.isPrimary()) {
          currentColumn = _this247.columnModel.getPrimaryColumn(colId);
        } else {
          currentColumn = _this247.columnModel.getGridColumn(colId);
        }

        if (currentColumn && currentColumn === wrapper.column) {
          return;
        }

        columns.push(wrapper.column);

        _this247.disposeFilterWrapper(wrapper, "columnChanged");

        _this247.disposeColumnListener(colId);
      });

      if (columns.length > 0) {
        this.onFilterChanged({
          columns: columns,
          source: "api"
        });
      } else {
        this.updateDependantFilters();
      }
    }
  }, {
    key: "updateDependantFilters",
    value: function updateDependantFilters() {
      var _this248 = this;

      var groupColumns = this.columnModel.getGroupAutoColumns();
      groupColumns == null ? void 0 : groupColumns.forEach(function (groupColumn) {
        if (groupColumn.getColDef().filter === "agGroupColumnFilter") {
          _this248.getOrCreateFilterWrapper(groupColumn, "NO_UI");
        }
      });
    } // for group filters, can change dynamically whether they are allowed or not

  }, {
    key: "isFilterAllowed",
    value: function isFilterAllowed(column) {
      var _a, _b;

      if (this.isAdvancedFilterEnabled()) {
        return false;
      }

      var isFilterAllowed = column.isFilterAllowed();

      if (!isFilterAllowed) {
        return false;
      }

      var filterWrapper = this.allColumnFilters.get(column.getColId());
      return (_b = (_a = filterWrapper == null ? void 0 : filterWrapper.filterPromise) == null ? void 0 : _a.resolveNow(true, // defer to filter component isFilterAllowed if it exists
      function (filter) {
        return typeof (filter == null ? void 0 : filter.isFilterAllowed) === "function" ? filter == null ? void 0 : filter.isFilterAllowed() : true;
      })) != null ? _b : true;
    }
  }, {
    key: "getFloatingFilterCompDetails",
    value: function getFloatingFilterCompDetails(column, showParentFilter) {
      var _this249 = this;

      var parentFilterInstance = function parentFilterInstance(callback) {
        var filterComponent = _this249.getFilterComponent(column, "NO_UI");

        if (filterComponent == null) {
          return;
        }

        filterComponent.then(function (instance) {
          callback(unwrapUserComp(instance));
        });
      };

      var colDef = column.getColDef();

      var filterParams = __spreadProps(__spreadValues({}, this.createFilterParams(column, colDef)), {
        filterChangedCallback: function filterChangedCallback() {
          return parentFilterInstance(function (filterInstance) {
            return _this249.filterChangedCallbackFactory(filterInstance, column)();
          });
        }
      });

      var finalFilterParams = this.userComponentFactory.mergeParamsWithApplicationProvidedParams(colDef, FilterComponent, filterParams);
      var defaultFloatingFilterType = this.userComponentFactory.getDefaultFloatingFilterType(colDef, function () {
        return _this249.getDefaultFloatingFilter(column);
      });

      if (defaultFloatingFilterType == null) {
        defaultFloatingFilterType = "agReadOnlyFloatingFilter";
      }

      var params = {
        column: column,
        filterParams: finalFilterParams,
        currentParentModel: function currentParentModel() {
          return _this249.getCurrentFloatingFilterParentModel(column);
        },
        parentFilterInstance: parentFilterInstance,
        showParentFilter: showParentFilter,
        suppressFilterButton: false // This one might be overridden from the colDef

      };
      return this.userComponentFactory.getFloatingFilterCompDetails(colDef, params, defaultFloatingFilterType);
    }
  }, {
    key: "getCurrentFloatingFilterParentModel",
    value: function getCurrentFloatingFilterParentModel(column) {
      var filterComponent = this.getFilterComponent(column, "NO_UI", false);
      return filterComponent ? filterComponent.resolveNow(null, function (filter) {
        return filter && filter.getModel();
      }) : null;
    } // destroys the filter, so it no longer takes part

  }, {
    key: "destroyFilter",
    value: function destroyFilter(column) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "api";
      var colId = column.getColId();
      var filterWrapper = this.allColumnFilters.get(colId);
      this.disposeColumnListener(colId);
      delete this.initialFilterModel[colId];

      if (filterWrapper) {
        this.disposeFilterWrapper(filterWrapper, source);
        this.onFilterChanged({
          columns: [column],
          source: "api"
        });
      }
    }
  }, {
    key: "disposeColumnListener",
    value: function disposeColumnListener(colId) {
      var columnListener = this.allColumnListeners.get(colId);

      if (columnListener) {
        this.allColumnListeners.delete(colId);
        columnListener();
      }
    }
  }, {
    key: "disposeFilterWrapper",
    value: function disposeFilterWrapper(filterWrapper, source) {
      var _this250 = this;

      filterWrapper.filterPromise.then(function (filter) {
        _this250.getContext().destroyBean(filter);

        filterWrapper.column.setFilterActive(false, "filterDestroyed");

        _this250.allColumnFilters.delete(filterWrapper.column.getColId());

        var event = {
          type: _Events.EVENT_FILTER_DESTROYED,
          source: source,
          column: filterWrapper.column
        };

        _this250.eventService.dispatchEvent(event);
      });
    }
  }, {
    key: "filterModifiedCallbackFactory",
    value: function filterModifiedCallbackFactory(filter, column) {
      var _this251 = this;

      return function () {
        var event = {
          type: _Events.EVENT_FILTER_MODIFIED,
          column: column,
          filterInstance: filter
        };

        _this251.eventService.dispatchEvent(event);
      };
    }
  }, {
    key: "filterChangedCallbackFactory",
    value: function filterChangedCallbackFactory(filter, column) {
      var _this252 = this;

      return function (additionalEventAttributes) {
        var _a;

        var source = (_a = additionalEventAttributes == null ? void 0 : additionalEventAttributes.source) != null ? _a : "api";
        var params = {
          filter: filter,
          additionalEventAttributes: additionalEventAttributes,
          columns: [column],
          source: source
        };

        _this252.callOnFilterChangedOutsideRenderCycle(params);
      };
    }
  }, {
    key: "checkDestroyFilter",
    value: function checkDestroyFilter(colId) {
      var _this253 = this;

      var filterWrapper = this.allColumnFilters.get(colId);

      if (!filterWrapper) {
        return;
      }

      var column = filterWrapper.column;

      var _ref33 = column.isFilterAllowed() ? this.createFilterInstance(column) : {
        compDetails: null
      },
          compDetails = _ref33.compDetails;

      if (this.areFilterCompsDifferent(filterWrapper.compDetails, compDetails)) {
        this.destroyFilter(column, "paramsUpdated");
        return;
      }

      var newFilterParams = column.getColDef().filterParams;

      if (!filterWrapper.filterPromise) {
        this.destroyFilter(column, "paramsUpdated");
        return;
      }

      filterWrapper.filterPromise.then(function (filter) {
        var shouldRefreshFilter = (filter == null ? void 0 : filter.refresh) ? filter.refresh(__spreadValues(__spreadProps(__spreadValues({}, _this253.createFilterParams(column, column.getColDef())), {
          filterModifiedCallback: _this253.filterModifiedCallbackFactory(filter, column),
          filterChangedCallback: _this253.filterChangedCallbackFactory(filter, column),
          doesRowPassOtherFilter: function doesRowPassOtherFilter(node) {
            return _this253.doesRowPassOtherFilters(filter, node);
          }
        }), newFilterParams)) : true;

        if (shouldRefreshFilter === false) {
          _this253.destroyFilter(column, "paramsUpdated");
        }
      });
    }
  }, {
    key: "setColumnFilterWrapper",
    value: function setColumnFilterWrapper(column, filterWrapper) {
      var _this254 = this;

      var colId = column.getColId();
      this.allColumnFilters.set(colId, filterWrapper);
      this.allColumnListeners.set(colId, this.addManagedListener(column, _Column2.EVENT_COL_DEF_CHANGED, function () {
        return _this254.checkDestroyFilter(colId);
      }));
    }
  }, {
    key: "areFilterCompsDifferent",
    value: function areFilterCompsDifferent(oldCompDetails, newCompDetails) {
      if (!newCompDetails || !oldCompDetails) {
        return true;
      }

      var oldComponentClass = oldCompDetails.componentClass;
      var newComponentClass = newCompDetails.componentClass;
      var isSameComponentClass = oldComponentClass === newComponentClass || // react hooks returns new wrappers, so check nested render method
      (oldComponentClass == null ? void 0 : oldComponentClass.render) && (newComponentClass == null ? void 0 : newComponentClass.render) && oldComponentClass.render === newComponentClass.render;
      return !isSameComponentClass;
    }
  }, {
    key: "getAdvancedFilterModel",
    value: function getAdvancedFilterModel() {
      return this.isAdvancedFilterEnabled() ? this.advancedFilterService.getModel() : null;
    }
  }, {
    key: "setAdvancedFilterModel",
    value: function setAdvancedFilterModel(expression) {
      if (!this.isAdvancedFilterEnabled()) {
        return;
      }

      if (this.dataTypeService.isPendingInference()) {
        this.advancedFilterModelUpdateQueue.push(expression);
        return;
      }

      this.advancedFilterService.setModel(expression != null ? expression : null);
      this.onFilterChanged({
        source: "advancedFilter"
      });
    }
  }, {
    key: "showAdvancedFilterBuilder",
    value: function showAdvancedFilterBuilder(source) {
      if (!this.isAdvancedFilterEnabled()) {
        return;
      }

      this.advancedFilterService.getCtrl().toggleFilterBuilder(source, true);
    }
  }, {
    key: "updateAdvancedFilterColumns",
    value: function updateAdvancedFilterColumns() {
      if (!this.isAdvancedFilterEnabled()) {
        return;
      }

      if (this.advancedFilterService.updateValidity()) {
        this.onFilterChanged({
          source: "advancedFilter"
        });
      }
    }
  }, {
    key: "hasFloatingFilters",
    value: function hasFloatingFilters() {
      if (this.isAdvancedFilterEnabled()) {
        return false;
      }

      var gridColumns = this.columnModel.getAllGridColumns();
      return gridColumns.some(function (col) {
        return col.getColDef().floatingFilter;
      });
    }
  }, {
    key: "getFilterInstance",
    value: function getFilterInstance(key, callback) {
      if (this.isAdvancedFilterEnabled()) {
        this.warnAdvancedFilters();
        return void 0;
      }

      var res = this.getFilterInstanceImpl(key, function (instance) {
        if (!callback) {
          return;
        }

        var unwrapped2 = unwrapUserComp(instance);
        callback(unwrapped2);
      });
      var unwrapped = unwrapUserComp(res);
      return unwrapped;
    }
  }, {
    key: "getColumnFilterInstance",
    value: function getColumnFilterInstance(key) {
      var _this255 = this;

      return new Promise(function (resolve) {
        _this255.getFilterInstance(key, function (filter) {
          resolve(filter);
        });
      });
    }
  }, {
    key: "getFilterInstanceImpl",
    value: function getFilterInstanceImpl(key, callback) {
      var column = this.columnModel.getPrimaryColumn(key);

      if (!column) {
        return void 0;
      }

      var filterPromise = this.getFilterComponent(column, "NO_UI");
      var currentValue = filterPromise && filterPromise.resolveNow(null, function (filterComp) {
        return filterComp;
      });

      if (currentValue) {
        setTimeout(callback, 0, currentValue);
      } else if (filterPromise) {
        filterPromise.then(function (comp) {
          callback(comp);
        });
      }

      return currentValue;
    }
  }, {
    key: "warnAdvancedFilters",
    value: function warnAdvancedFilters() {
      _warnOnce("Column Filter API methods have been disabled as Advanced Filters are enabled.");
    }
  }, {
    key: "setupAdvancedFilterHeaderComp",
    value: function setupAdvancedFilterHeaderComp(eCompToInsertBefore) {
      var _a;

      (_a = this.advancedFilterService) == null ? void 0 : _a.getCtrl().setupHeaderComp(eCompToInsertBefore);
    }
  }, {
    key: "getHeaderRowCount",
    value: function getHeaderRowCount() {
      return this.isAdvancedFilterHeaderActive() ? 1 : 0;
    }
  }, {
    key: "getHeaderHeight",
    value: function getHeaderHeight() {
      return this.isAdvancedFilterHeaderActive() ? this.advancedFilterService.getCtrl().getHeaderHeight() : 0;
    }
  }, {
    key: "processFilterModelUpdateQueue",
    value: function processFilterModelUpdateQueue() {
      var _this256 = this;

      this.filterModelUpdateQueue.forEach(function (_ref34) {
        var model = _ref34.model,
            source = _ref34.source;
        return _this256.setFilterModel(model, source);
      });
      this.filterModelUpdateQueue = [];
      this.columnFilterModelUpdateQueue.forEach(function (_ref35) {
        var key = _ref35.key,
            model = _ref35.model,
            resolve = _ref35.resolve;

        _this256.setColumnFilterModel(key, model).then(function () {
          return resolve();
        });
      });
      this.columnFilterModelUpdateQueue = [];
      this.advancedFilterModelUpdateQueue.forEach(function (model) {
        return _this256.setAdvancedFilterModel(model);
      });
      this.advancedFilterModelUpdateQueue = [];
    }
  }, {
    key: "getColumnFilterModel",
    value: function getColumnFilterModel(key) {
      var filterWrapper = this.getFilterWrapper(key);
      return filterWrapper ? this.getModelFromFilterWrapper(filterWrapper) : null;
    }
  }, {
    key: "setColumnFilterModel",
    value: function setColumnFilterModel(key, model) {
      if (this.isAdvancedFilterEnabled()) {
        this.warnAdvancedFilters();
        return Promise.resolve();
      }

      if (this.dataTypeService.isPendingInference()) {
        var resolve = function resolve() {};

        var promise = new Promise(function (res) {
          resolve = res;
        });
        this.columnFilterModelUpdateQueue.push({
          key: key,
          model: model,
          resolve: resolve
        });
        return promise;
      }

      var column = this.columnModel.getPrimaryColumn(key);
      var filterWrapper = column ? this.getOrCreateFilterWrapper(column, "NO_UI") : null;

      var convertPromise = function convertPromise(promise) {
        return new Promise(function (resolve) {
          promise.then(function (result) {
            return resolve(result);
          });
        });
      };

      return filterWrapper ? convertPromise(this.setModelOnFilterWrapper(filterWrapper.filterPromise, model)) : Promise.resolve();
    }
  }, {
    key: "getFilterWrapper",
    value: function getFilterWrapper(key) {
      var _a;

      var column = this.columnModel.getPrimaryColumn(key);
      return column ? (_a = this.cachedFilter(column)) != null ? _a : null : null;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this257 = this;

      _get(_getPrototypeOf(_FilterManager.prototype), "destroy", this).call(this);

      this.allColumnFilters.forEach(function (filterWrapper) {
        return _this257.disposeFilterWrapper(filterWrapper, "gridDestroyed");
      });
      this.allColumnListeners.clear();
    }
  }]);

  return _FilterManager;
}(_BeanStub2);

__decorateClass([_Autowired("valueService")], _FilterManager.prototype, "valueService", 2);

__decorateClass([_Autowired("columnModel")], _FilterManager.prototype, "columnModel", 2);

__decorateClass([_Autowired("rowModel")], _FilterManager.prototype, "rowModel", 2);

__decorateClass([_Autowired("userComponentFactory")], _FilterManager.prototype, "userComponentFactory", 2);

__decorateClass([_Autowired("rowRenderer")], _FilterManager.prototype, "rowRenderer", 2);

__decorateClass([_Autowired("dataTypeService")], _FilterManager.prototype, "dataTypeService", 2);

__decorateClass([_Autowired("quickFilterService")], _FilterManager.prototype, "quickFilterService", 2);

__decorateClass([_Optional("advancedFilterService")], _FilterManager.prototype, "advancedFilterService", 2);

__decorateClass([_PostConstruct], _FilterManager.prototype, "init", 1);

_FilterManager = __decorateClass([_Bean("filterManager")], _FilterManager); // community-modules/core/src/filter/filterWrapperComp.ts

var _FilterWrapperComp =
/*#__PURE__*/
function (_Component24) {
  "use strict";

  _inherits(_FilterWrapperComp, _Component24);

  function _FilterWrapperComp(column, source) {
    var _this258;

    _classCallCheck(this, _FilterWrapperComp);

    _this258 = _possibleConstructorReturn(this, _getPrototypeOf(_FilterWrapperComp).call(this,
    /* html */
    "<div class=\"ag-filter\"></div>"));
    _this258.column = column;
    _this258.source = source;
    _this258.filterWrapper = null;
    return _this258;
  }

  _createClass(_FilterWrapperComp, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.createFilter(true);
      this.addManagedListener(this.eventService, _Events.EVENT_FILTER_DESTROYED, this.onFilterDestroyed.bind(this));
    }
  }, {
    key: "hasFilter",
    value: function hasFilter() {
      return !!this.filterWrapper;
    }
  }, {
    key: "getFilter",
    value: function getFilter() {
      var _a, _b;

      return (_b = (_a = this.filterWrapper) == null ? void 0 : _a.filterPromise) != null ? _b : null;
    }
  }, {
    key: "afterInit",
    value: function afterInit() {
      var _a, _b, _c;

      return (_c = (_b = (_a = this.filterWrapper) == null ? void 0 : _a.filterPromise) == null ? void 0 : _b.then(function () {})) != null ? _c : _AgPromise2.resolve();
    }
  }, {
    key: "afterGuiAttached",
    value: function afterGuiAttached(params) {
      var _a, _b;

      (_b = (_a = this.filterWrapper) == null ? void 0 : _a.filterPromise) == null ? void 0 : _b.then(function (filter) {
        var _a2;

        (_a2 = filter == null ? void 0 : filter.afterGuiAttached) == null ? void 0 : _a2.call(filter, params);
      });
    }
  }, {
    key: "afterGuiDetached",
    value: function afterGuiDetached() {
      var _a, _b;

      (_b = (_a = this.filterWrapper) == null ? void 0 : _a.filterPromise) == null ? void 0 : _b.then(function (filter) {
        var _a2;

        (_a2 = filter == null ? void 0 : filter.afterGuiDetached) == null ? void 0 : _a2.call(filter);
      });
    }
  }, {
    key: "createFilter",
    value: function createFilter(init) {
      var _this259 = this;

      var _a;

      var column = this.column,
          source = this.source;
      this.filterWrapper = this.filterManager.getOrCreateFilterWrapper(column, source);

      if (!((_a = this.filterWrapper) == null ? void 0 : _a.filterPromise)) {
        return;
      }

      this.filterWrapper.filterPromise.then(function (filter) {
        var guiFromFilter = filter.getGui();

        if (!_exists(guiFromFilter)) {
          console.warn("AG Grid: getGui method from filter returned ".concat(guiFromFilter, ", it should be a DOM element or an HTML template string."));
        }

        if (typeof guiFromFilter === "string") {
          guiFromFilter = _loadTemplate(guiFromFilter);
        }

        _this259.appendChild(guiFromFilter);

        if (init) {
          var event = {
            type: _Events.EVENT_FILTER_OPENED,
            column: column,
            source: source,
            eGui: _this259.getGui()
          };

          _this259.eventService.dispatchEvent(event);
        }
      });
    }
  }, {
    key: "onFilterDestroyed",
    value: function onFilterDestroyed(event) {
      if ((event.source === "api" || event.source === "paramsUpdated") && event.column.getId() === this.column.getId() && this.columnModel.getPrimaryColumn(this.column)) {
        _clearElement(this.getGui());

        this.createFilter();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.filterWrapper = null;

      _get(_getPrototypeOf(_FilterWrapperComp.prototype), "destroy", this).call(this);
    }
  }]);

  return _FilterWrapperComp;
}(_Component2);

__decorateClass([_Autowired("filterManager")], _FilterWrapperComp.prototype, "filterManager", 2);

__decorateClass([_Autowired("columnModel")], _FilterWrapperComp.prototype, "columnModel", 2);

__decorateClass([_PostConstruct], _FilterWrapperComp.prototype, "postConstruct", 1); // community-modules/core/src/headerRendering/cells/abstractCell/abstractHeaderCellComp.ts


var AbstractHeaderCellComp =
/*#__PURE__*/
function (_Component25) {
  "use strict";

  _inherits(AbstractHeaderCellComp, _Component25);

  function AbstractHeaderCellComp(template, ctrl) {
    var _this260;

    _classCallCheck(this, AbstractHeaderCellComp);

    _this260 = _possibleConstructorReturn(this, _getPrototypeOf(AbstractHeaderCellComp).call(this, template));
    _this260.ctrl = ctrl;
    return _this260;
  }

  _createClass(AbstractHeaderCellComp, [{
    key: "getCtrl",
    value: function getCtrl() {
      return this.ctrl;
    }
  }]);

  return AbstractHeaderCellComp;
}(_Component2); // community-modules/core/src/headerRendering/cells/floatingFilter/headerFilterCellComp.ts


var _HeaderFilterCellComp =
/*#__PURE__*/
function (_AbstractHeaderCellCo) {
  "use strict";

  _inherits(_HeaderFilterCellComp, _AbstractHeaderCellCo);

  function _HeaderFilterCellComp(ctrl) {
    _classCallCheck(this, _HeaderFilterCellComp);

    return _possibleConstructorReturn(this, _getPrototypeOf(_HeaderFilterCellComp).call(this, _HeaderFilterCellComp.TEMPLATE, ctrl));
  }

  _createClass(_HeaderFilterCellComp, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this261 = this;

      var eGui = this.getGui();
      var compProxy = {
        addOrRemoveCssClass: function addOrRemoveCssClass(cssClassName, on) {
          return _this261.addOrRemoveCssClass(cssClassName, on);
        },
        addOrRemoveBodyCssClass: function addOrRemoveBodyCssClass(cssClassName, on) {
          return _this261.eFloatingFilterBody.classList.toggle(cssClassName, on);
        },
        setButtonWrapperDisplayed: function setButtonWrapperDisplayed(displayed) {
          return _setDisplayed(_this261.eButtonWrapper, displayed);
        },
        setCompDetails: function setCompDetails(compDetails) {
          return _this261.setCompDetails(compDetails);
        },
        getFloatingFilterComp: function getFloatingFilterComp() {
          return _this261.compPromise;
        },
        setWidth: function setWidth(width) {
          return eGui.style.width = width;
        },
        setMenuIcon: function setMenuIcon(eIcon) {
          return _this261.eButtonShowMainFilter.appendChild(eIcon);
        }
      };
      this.ctrl.setComp(compProxy, eGui, this.eButtonShowMainFilter, this.eFloatingFilterBody);
    }
  }, {
    key: "setCompDetails",
    value: function setCompDetails(compDetails) {
      var _this262 = this;

      if (!compDetails) {
        this.destroyFloatingFilterComp();
        this.compPromise = null;
        return;
      }

      this.compPromise = compDetails.newAgStackInstance();
      this.compPromise.then(function (comp) {
        return _this262.afterCompCreated(comp);
      });
    }
  }, {
    key: "destroyFloatingFilterComp",
    value: function destroyFloatingFilterComp() {
      if (this.floatingFilterComp) {
        this.eFloatingFilterBody.removeChild(this.floatingFilterComp.getGui());
        this.floatingFilterComp = this.destroyBean(this.floatingFilterComp);
      }
    }
  }, {
    key: "afterCompCreated",
    value: function afterCompCreated(comp) {
      if (!comp) {
        return;
      }

      if (!this.isAlive()) {
        this.destroyBean(comp);
        return;
      }

      this.destroyFloatingFilterComp();
      this.floatingFilterComp = comp;
      this.eFloatingFilterBody.appendChild(comp.getGui());

      if (comp.afterGuiAttached) {
        comp.afterGuiAttached();
      }
    }
  }]);

  return _HeaderFilterCellComp;
}(AbstractHeaderCellComp);

_HeaderFilterCellComp.TEMPLATE =
/* html */
"<div class=\"ag-header-cell ag-floating-filter\" role=\"gridcell\">\n            <div ref=\"eFloatingFilterBody\" role=\"presentation\"></div>\n            <div class=\"ag-floating-filter-button ag-hidden\" ref=\"eButtonWrapper\" role=\"presentation\">\n                <button type=\"button\" class=\"ag-button ag-floating-filter-button-button\" ref=\"eButtonShowMainFilter\" tabindex=\"-1\"></button>\n            </div>\n        </div>";

__decorateClass([_RefSelector("eFloatingFilterBody")], _HeaderFilterCellComp.prototype, "eFloatingFilterBody", 2);

__decorateClass([_RefSelector("eButtonWrapper")], _HeaderFilterCellComp.prototype, "eButtonWrapper", 2);

__decorateClass([_RefSelector("eButtonShowMainFilter")], _HeaderFilterCellComp.prototype, "eButtonShowMainFilter", 2);

__decorateClass([_PostConstruct], _HeaderFilterCellComp.prototype, "postConstruct", 1);

__decorateClass([_PreDestroy], _HeaderFilterCellComp.prototype, "destroyFloatingFilterComp", 1);

var _HeaderFilterCellComp2 = _HeaderFilterCellComp; // community-modules/core/src/styling/layoutFeature.ts

var _LayoutCssClasses =
/* @__PURE__ */
function (LayoutCssClasses2) {
  LayoutCssClasses2["AUTO_HEIGHT"] = "ag-layout-auto-height";
  LayoutCssClasses2["NORMAL"] = "ag-layout-normal";
  LayoutCssClasses2["PRINT"] = "ag-layout-print";
  return LayoutCssClasses2;
}(_LayoutCssClasses || {});

var LayoutFeature =
/*#__PURE__*/
function (_BeanStub25) {
  "use strict";

  _inherits(LayoutFeature, _BeanStub25);

  function LayoutFeature(view) {
    var _this263;

    _classCallCheck(this, LayoutFeature);

    _this263 = _possibleConstructorReturn(this, _getPrototypeOf(LayoutFeature).call(this));
    _this263.view = view;
    return _this263;
  }

  _createClass(LayoutFeature, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.addManagedPropertyListener("domLayout", this.updateLayoutClasses.bind(this));
      this.updateLayoutClasses();
    }
  }, {
    key: "updateLayoutClasses",
    value: function updateLayoutClasses() {
      var domLayout = this.getDomLayout();
      var params = {
        autoHeight: domLayout === "autoHeight",
        normal: domLayout === "normal",
        print: domLayout === "print"
      };
      var cssClass = params.autoHeight ? "ag-layout-auto-height"
      /* AUTO_HEIGHT */
      : params.print ? "ag-layout-print"
      /* PRINT */
      : "ag-layout-normal"
      /* NORMAL */
      ;
      this.view.updateLayoutClasses(cssClass, params);
    } // returns either 'print', 'autoHeight' or 'normal' (normal is the default)

  }, {
    key: "getDomLayout",
    value: function getDomLayout() {
      var _a;

      var domLayout = (_a = this.gos.get("domLayout")) != null ? _a : "normal";
      var validLayouts = ["normal", "print", "autoHeight"];

      if (validLayouts.indexOf(domLayout) === -1) {
        _warnOnce("".concat(domLayout, " is not valid for DOM Layout, valid values are 'normal', 'autoHeight', 'print'."));

        return "normal";
      }

      return domLayout;
    }
  }]);

  return LayoutFeature;
}(_BeanStub2);

__decorateClass([_PostConstruct], LayoutFeature.prototype, "postConstruct", 1); // community-modules/core/src/gridBodyComp/gridBodyScrollFeature.ts


var GridBodyScrollFeature =
/*#__PURE__*/
function (_BeanStub26) {
  "use strict";

  _inherits(GridBodyScrollFeature, _BeanStub26);

  function GridBodyScrollFeature(eBodyViewport) {
    var _this264;

    _classCallCheck(this, GridBodyScrollFeature);

    _this264 = _possibleConstructorReturn(this, _getPrototypeOf(GridBodyScrollFeature).call(this));
    _this264.lastScrollSource = [null, null];
    _this264.scrollLeft = -1;
    _this264.nextScrollTop = -1;
    _this264.scrollTop = -1; // Used to provide approximate values of scrollTop and offsetHeight
    // without forcing the browser to recalculate styles.

    _this264.lastOffsetHeight = -1;
    _this264.lastScrollTop = -1;
    _this264.eBodyViewport = eBodyViewport;
    _this264.resetLastHScrollDebounced = _debounce(function () {
      return _this264.lastScrollSource[1
      /* Horizontal */
      ] = null;
    }, 500);
    _this264.resetLastVScrollDebounced = _debounce(function () {
      return _this264.lastScrollSource[0
      /* Vertical */
      ] = null;
    }, 500);
    return _this264;
  }

  _createClass(GridBodyScrollFeature, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this265 = this;

      this.enableRtl = this.gos.get("enableRtl");
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
      this.ctrlsService.whenReady(function (p) {
        _this265.centerRowsCtrl = p.center;

        _this265.onDisplayedColumnsWidthChanged();

        _this265.addScrollListener();
      });
    }
  }, {
    key: "addScrollListener",
    value: function addScrollListener() {
      var _this$ctrlsService$ge = this.ctrlsService.getParams(),
          fakeHScrollComp = _this$ctrlsService$ge.fakeHScrollComp,
          fakeVScrollComp = _this$ctrlsService$ge.fakeVScrollComp;

      this.addManagedListener(this.centerRowsCtrl.getViewportElement(), "scroll", this.onHScroll.bind(this));
      fakeHScrollComp.onScrollCallback(this.onFakeHScroll.bind(this));
      var isDebounce = this.gos.get("debounceVerticalScrollbar");
      var onVScroll = isDebounce ? _debounce(this.onVScroll.bind(this), 100) : this.onVScroll.bind(this);
      var onFakeVScroll = isDebounce ? _debounce(this.onFakeVScroll.bind(this), 100) : this.onFakeVScroll.bind(this);
      this.addManagedListener(this.eBodyViewport, "scroll", onVScroll);
      fakeVScrollComp.onScrollCallback(onFakeVScroll);
    }
  }, {
    key: "onDisplayedColumnsWidthChanged",
    value: function onDisplayedColumnsWidthChanged() {
      if (this.enableRtl) {
        this.horizontallyScrollHeaderCenterAndFloatingCenter();
      }
    }
  }, {
    key: "horizontallyScrollHeaderCenterAndFloatingCenter",
    value: function horizontallyScrollHeaderCenterAndFloatingCenter(scrollLeft) {
      var notYetInitialised = this.centerRowsCtrl == null;

      if (notYetInitialised) {
        return;
      }

      if (scrollLeft === void 0) {
        scrollLeft = this.centerRowsCtrl.getCenterViewportScrollLeft();
      }

      var offset = this.enableRtl ? scrollLeft : -scrollLeft;

      var _this$ctrlsService$ge2 = this.ctrlsService.getParams(),
          topCenter = _this$ctrlsService$ge2.topCenter,
          stickyTopCenter = _this$ctrlsService$ge2.stickyTopCenter,
          centerHeader = _this$ctrlsService$ge2.centerHeader,
          bottomCenter = _this$ctrlsService$ge2.bottomCenter,
          fakeHScrollComp = _this$ctrlsService$ge2.fakeHScrollComp;

      centerHeader.setHorizontalScroll(-offset);
      bottomCenter.setContainerTranslateX(offset);
      topCenter.setContainerTranslateX(offset);
      stickyTopCenter.setContainerTranslateX(offset);
      var centerViewport = this.centerRowsCtrl.getViewportElement();
      var isCenterViewportLastHorizontal = this.lastScrollSource[1
      /* Horizontal */
      ] === 0
      /* Container */
      ;
      scrollLeft = Math.abs(scrollLeft);

      if (isCenterViewportLastHorizontal) {
        fakeHScrollComp.setScrollPosition(scrollLeft);
      } else {
        _setScrollLeft(centerViewport, scrollLeft, this.enableRtl);
      }
    }
  }, {
    key: "isControllingScroll",
    value: function isControllingScroll(source, direction) {
      if (this.lastScrollSource[direction] == null) {
        this.lastScrollSource[direction] = source;
        return true;
      }

      return this.lastScrollSource[direction] === source;
    }
  }, {
    key: "onFakeHScroll",
    value: function onFakeHScroll() {
      if (!this.isControllingScroll(1
      /* FakeContainer */
      , 1
      /* Horizontal */
      )) {
        return;
      }

      this.onHScrollCommon(1
      /* FakeContainer */
      );
    }
  }, {
    key: "onHScroll",
    value: function onHScroll() {
      if (!this.isControllingScroll(0
      /* Container */
      , 1
      /* Horizontal */
      )) {
        return;
      }

      this.onHScrollCommon(0
      /* Container */
      );
    }
  }, {
    key: "onHScrollCommon",
    value: function onHScrollCommon(source) {
      var centerContainerViewport = this.centerRowsCtrl.getViewportElement();
      var scrollLeft = centerContainerViewport.scrollLeft;

      if (this.shouldBlockScrollUpdate(1
      /* Horizontal */
      , scrollLeft, true)) {
        return;
      }

      var newScrollLeft;

      if (source === 0
      /* Container */
      ) {
          newScrollLeft = _getScrollLeft(centerContainerViewport, this.enableRtl);
        } else {
        newScrollLeft = this.ctrlsService.get("fakeHScrollComp").getScrollPosition();
      }

      this.doHorizontalScroll(Math.round(newScrollLeft));
      this.resetLastHScrollDebounced();
    }
  }, {
    key: "onFakeVScroll",
    value: function onFakeVScroll() {
      if (!this.isControllingScroll(1
      /* FakeContainer */
      , 0
      /* Vertical */
      )) {
        return;
      }

      this.onVScrollCommon(1
      /* FakeContainer */
      );
    }
  }, {
    key: "onVScroll",
    value: function onVScroll() {
      if (!this.isControllingScroll(0
      /* Container */
      , 0
      /* Vertical */
      )) {
        return;
      }

      this.onVScrollCommon(0
      /* Container */
      );
    }
  }, {
    key: "onVScrollCommon",
    value: function onVScrollCommon(source) {
      var scrollTop;

      if (source === 0
      /* Container */
      ) {
          scrollTop = this.eBodyViewport.scrollTop;
        } else {
        scrollTop = this.ctrlsService.get("fakeVScrollComp").getScrollPosition();
      }

      if (this.shouldBlockScrollUpdate(0
      /* Vertical */
      , scrollTop, true)) {
        return;
      }

      this.animationFrameService.setScrollTop(scrollTop);
      this.nextScrollTop = scrollTop;

      if (source === 0
      /* Container */
      ) {
          this.ctrlsService.get("fakeVScrollComp").setScrollPosition(scrollTop);
        } else {
        this.eBodyViewport.scrollTop = scrollTop;
      }

      if (this.gos.get("suppressAnimationFrame")) {
        this.scrollGridIfNeeded();
      } else {
        this.animationFrameService.schedule();
      }

      this.resetLastVScrollDebounced();
    }
  }, {
    key: "doHorizontalScroll",
    value: function doHorizontalScroll(scrollLeft) {
      var fakeScrollLeft = this.ctrlsService.get("fakeHScrollComp").getScrollPosition();

      if (this.scrollLeft === scrollLeft && scrollLeft === fakeScrollLeft) {
        return;
      }

      this.scrollLeft = scrollLeft;
      this.fireScrollEvent(1
      /* Horizontal */
      );
      this.horizontallyScrollHeaderCenterAndFloatingCenter(scrollLeft);
      this.centerRowsCtrl.onHorizontalViewportChanged(true);
    }
  }, {
    key: "fireScrollEvent",
    value: function fireScrollEvent(direction) {
      var _this266 = this;

      var bodyScrollEvent = {
        type: _Events.EVENT_BODY_SCROLL,
        direction: direction === 1
        /* Horizontal */
        ? "horizontal" : "vertical",
        left: this.scrollLeft,
        top: this.scrollTop
      };
      this.eventService.dispatchEvent(bodyScrollEvent);
      window.clearTimeout(this.scrollTimer);
      this.scrollTimer = void 0;
      this.scrollTimer = window.setTimeout(function () {
        var bodyScrollEndEvent = __spreadProps(__spreadValues({}, bodyScrollEvent), {
          type: _Events.EVENT_BODY_SCROLL_END
        });

        _this266.eventService.dispatchEvent(bodyScrollEndEvent);
      }, 100);
    }
  }, {
    key: "shouldBlockScrollUpdate",
    value: function shouldBlockScrollUpdate(direction, scrollTo) {
      var touchOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (touchOnly && !_isIOSUserAgent()) {
        return false;
      }

      if (direction === 0
      /* Vertical */
      ) {
          return this.shouldBlockVerticalScroll(scrollTo);
        }

      return this.shouldBlockHorizontalScroll(scrollTo);
    }
  }, {
    key: "shouldBlockVerticalScroll",
    value: function shouldBlockVerticalScroll(scrollTo) {
      var clientHeight = _getInnerHeight(this.eBodyViewport);

      var scrollHeight = this.eBodyViewport.scrollHeight;

      if (scrollTo < 0 || scrollTo + clientHeight > scrollHeight) {
        return true;
      }

      return false;
    }
  }, {
    key: "shouldBlockHorizontalScroll",
    value: function shouldBlockHorizontalScroll(scrollTo) {
      var clientWidth = this.centerRowsCtrl.getCenterWidth();

      var _this$centerRowsCtrl$ = this.centerRowsCtrl.getViewportElement(),
          scrollWidth = _this$centerRowsCtrl$.scrollWidth;

      if (this.enableRtl && _isRtlNegativeScroll()) {
        if (scrollTo > 0) {
          return true;
        }
      } else if (scrollTo < 0) {
        return true;
      }

      if (Math.abs(scrollTo) + clientWidth > scrollWidth) {
        return true;
      }

      return false;
    }
  }, {
    key: "redrawRowsAfterScroll",
    value: function redrawRowsAfterScroll() {
      this.fireScrollEvent(0
      /* Vertical */
      );
    } // this is to cater for AG-3274, where grid is removed from the dom and then inserted back in again.
    // (which happens with some implementations of tabbing). this can result in horizontal scroll getting
    // reset back to the left, however no scroll event is fired. so we need to get header to also scroll
    // back to the left to be kept in sync.
    // adding and removing the grid from the DOM both resets the scroll position and
    // triggers a resize event, so notify listeners if the scroll position has changed

  }, {
    key: "checkScrollLeft",
    value: function checkScrollLeft() {
      if (this.scrollLeft !== this.centerRowsCtrl.getCenterViewportScrollLeft()) {
        this.onHScrollCommon(0
        /* Container */
        );
      }
    }
  }, {
    key: "scrollGridIfNeeded",
    value: function scrollGridIfNeeded() {
      var frameNeeded = this.scrollTop != this.nextScrollTop;

      if (frameNeeded) {
        this.scrollTop = this.nextScrollTop;
        this.redrawRowsAfterScroll();
      }

      return frameNeeded;
    } // called by scrollHorizontally method and alignedGridsService

  }, {
    key: "setHorizontalScrollPosition",
    value: function setHorizontalScrollPosition(hScrollPosition) {
      var fromAlignedGridsService = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var minScrollLeft = 0;
      var maxScrollLeft = this.centerRowsCtrl.getViewportElement().scrollWidth - this.centerRowsCtrl.getCenterWidth();

      if (!fromAlignedGridsService && this.shouldBlockScrollUpdate(1
      /* Horizontal */
      , hScrollPosition)) {
        if (this.enableRtl && _isRtlNegativeScroll()) {
          hScrollPosition = hScrollPosition > 0 ? 0 : maxScrollLeft;
        } else {
          hScrollPosition = Math.min(Math.max(hScrollPosition, minScrollLeft), maxScrollLeft);
        }
      }

      _setScrollLeft(this.centerRowsCtrl.getViewportElement(), Math.abs(hScrollPosition), this.enableRtl);

      this.doHorizontalScroll(hScrollPosition);
    }
  }, {
    key: "setVerticalScrollPosition",
    value: function setVerticalScrollPosition(vScrollPosition) {
      this.eBodyViewport.scrollTop = vScrollPosition;
    }
  }, {
    key: "getVScrollPosition",
    value: function getVScrollPosition() {
      this.lastScrollTop = this.eBodyViewport.scrollTop;
      this.lastOffsetHeight = this.eBodyViewport.offsetHeight;
      var result = {
        top: this.lastScrollTop,
        bottom: this.lastScrollTop + this.lastOffsetHeight
      };
      return result;
    }
    /** Get an approximate scroll position that returns the last real value read.
     * This is useful for avoiding repeated DOM reads that force the browser to recalculate styles.
     * This can have big performance improvements but may not be 100% accurate so only use if this is acceptable.
     */

  }, {
    key: "getApproximateVScollPosition",
    value: function getApproximateVScollPosition() {
      if (this.lastScrollTop >= 0 && this.lastOffsetHeight >= 0) {
        return {
          top: this.scrollTop,
          bottom: this.scrollTop + this.lastOffsetHeight
        };
      }

      return this.getVScrollPosition();
    }
  }, {
    key: "getHScrollPosition",
    value: function getHScrollPosition() {
      return this.centerRowsCtrl.getHScrollPosition();
    }
  }, {
    key: "isHorizontalScrollShowing",
    value: function isHorizontalScrollShowing() {
      return this.centerRowsCtrl.isHorizontalScrollShowing();
    } // called by the headerRootComp and moveColumnController

  }, {
    key: "scrollHorizontally",
    value: function scrollHorizontally(pixels) {
      var oldScrollPosition = this.centerRowsCtrl.getViewportElement().scrollLeft;
      this.setHorizontalScrollPosition(oldScrollPosition + pixels);
      return this.centerRowsCtrl.getViewportElement().scrollLeft - oldScrollPosition;
    } // gets called by rowRenderer when new data loaded, as it will want to scroll to the top

  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      this.eBodyViewport.scrollTop = 0;
    } // Valid values for position are bottom, middle and top

  }, {
    key: "ensureNodeVisible",
    value: function ensureNodeVisible(comparator) {
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var rowCount = this.rowModel.getRowCount();
      var indexToSelect = -1;

      for (var i = 0; i < rowCount; i++) {
        var node = this.rowModel.getRow(i);

        if (typeof comparator === "function") {
          var predicate = comparator;

          if (node && predicate(node)) {
            indexToSelect = i;
            break;
          }
        } else {
          if (comparator === node || comparator === node.data) {
            indexToSelect = i;
            break;
          }
        }
      }

      if (indexToSelect >= 0) {
        this.ensureIndexVisible(indexToSelect, position);
      }
    } // Valid values for position are bottom, middle and top
    // position should be {'top','middle','bottom', or undefined/null}.
    // if undefined/null, then the grid will to the minimal amount of scrolling,
    // eg if grid needs to scroll up, it scrolls until row is on top,
    //    if grid needs to scroll down, it scrolls until row is on bottom,
    //    if row is already in view, grid does not scroll

  }, {
    key: "ensureIndexVisible",
    value: function ensureIndexVisible(index, position) {
      var _this267 = this;

      if (this.gos.isDomLayout("print")) {
        return;
      }

      var rowCount = this.paginationProxy.getRowCount();

      if (typeof index !== "number" || index < 0 || index >= rowCount) {
        console.warn("AG Grid: Invalid row index for ensureIndexVisible: " + index);
        return;
      }

      var isPaging = this.gos.get("pagination");
      var paginationPanelEnabled = isPaging && !this.gos.get("suppressPaginationPanel");
      this.getFrameworkOverrides().wrapIncoming(function () {
        if (!paginationPanelEnabled) {
          _this267.paginationProxy.goToPageWithIndex(index);
        }

        var gridBodyCtrl = _this267.ctrlsService.getGridBodyCtrl();

        var stickyTopHeight = gridBodyCtrl.getStickyTopHeight();
        var stickyBottomHeight = gridBodyCtrl.getStickyBottomHeight();

        var rowNode = _this267.paginationProxy.getRow(index);

        var rowGotShiftedDuringOperation;

        do {
          var startingRowTop = rowNode.rowTop;
          var startingRowHeight = rowNode.rowHeight;

          var paginationOffset = _this267.paginationProxy.getPixelOffset();

          var rowTopPixel = rowNode.rowTop - paginationOffset;
          var rowBottomPixel = rowTopPixel + rowNode.rowHeight;

          var scrollPosition = _this267.getVScrollPosition();

          var heightOffset = _this267.heightScaler.getDivStretchOffset();

          var vScrollTop = scrollPosition.top + heightOffset;
          var vScrollBottom = scrollPosition.bottom + heightOffset;
          var viewportHeight = vScrollBottom - vScrollTop;

          var pxTop = _this267.heightScaler.getScrollPositionForPixel(rowTopPixel);

          var pxBottom = _this267.heightScaler.getScrollPositionForPixel(rowBottomPixel - viewportHeight);

          var pxMiddle = Math.min((pxTop + pxBottom) / 2, rowTopPixel);
          var rowAboveViewport = vScrollTop + stickyTopHeight > rowTopPixel;
          var rowBelowViewport = vScrollBottom - stickyBottomHeight < rowBottomPixel;
          var newScrollPosition = null;

          if (position === "top") {
            newScrollPosition = pxTop;
          } else if (position === "bottom") {
            newScrollPosition = pxBottom;
          } else if (position === "middle") {
            newScrollPosition = pxMiddle;
          } else if (rowAboveViewport) {
            newScrollPosition = pxTop - stickyTopHeight;
          } else if (rowBelowViewport) {
            newScrollPosition = pxBottom + stickyBottomHeight;
          }

          if (newScrollPosition !== null) {
            _this267.setVerticalScrollPosition(newScrollPosition);

            _this267.rowRenderer.redraw({
              afterScroll: true
            });
          }

          rowGotShiftedDuringOperation = startingRowTop !== rowNode.rowTop || startingRowHeight !== rowNode.rowHeight;
        } while (rowGotShiftedDuringOperation);

        _this267.animationFrameService.flushAllFrames();
      });
    }
  }, {
    key: "ensureColumnVisible",
    value: function ensureColumnVisible(key) {
      var _this268 = this;

      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "auto";
      var column = this.columnModel.getGridColumn(key);

      if (!column) {
        return;
      }

      if (column.isPinned()) {
        return;
      }

      if (!this.columnModel.isColumnDisplayed(column)) {
        return;
      }

      var newHorizontalScroll = this.getPositionedHorizontalScroll(column, position);
      this.getFrameworkOverrides().wrapIncoming(function () {
        if (newHorizontalScroll !== null) {
          _this268.centerRowsCtrl.setCenterViewportScrollLeft(newHorizontalScroll);
        }

        _this268.centerRowsCtrl.onHorizontalViewportChanged();

        _this268.animationFrameService.flushAllFrames();
      });
    }
  }, {
    key: "setScrollPosition",
    value: function setScrollPosition(top, left) {
      var _this269 = this;

      this.getFrameworkOverrides().wrapIncoming(function () {
        _this269.centerRowsCtrl.setCenterViewportScrollLeft(left);

        _this269.setVerticalScrollPosition(top);

        _this269.rowRenderer.redraw({
          afterScroll: true
        });

        _this269.animationFrameService.flushAllFrames();
      });
    }
  }, {
    key: "getPositionedHorizontalScroll",
    value: function getPositionedHorizontalScroll(column, position) {
      var _this$isColumnOutside = this.isColumnOutsideViewport(column),
          columnBeforeStart = _this$isColumnOutside.columnBeforeStart,
          columnAfterEnd = _this$isColumnOutside.columnAfterEnd;

      var viewportTooSmallForColumn = this.centerRowsCtrl.getCenterWidth() < column.getActualWidth();
      var viewportWidth = this.centerRowsCtrl.getCenterWidth();
      var isRtl = this.enableRtl;
      var alignColToStart = (isRtl ? columnBeforeStart : columnAfterEnd) || viewportTooSmallForColumn;
      var alignColToEnd = isRtl ? columnAfterEnd : columnBeforeStart;

      if (position !== "auto") {
        alignColToStart = position === "start";
        alignColToEnd = position === "end";
      }

      var isMiddle = position === "middle";

      if (alignColToStart || alignColToEnd || isMiddle) {
        var _this$getColumnBounds = this.getColumnBounds(column),
            colLeft = _this$getColumnBounds.colLeft,
            colMiddle = _this$getColumnBounds.colMiddle,
            colRight = _this$getColumnBounds.colRight;

        if (isMiddle) {
          return colMiddle - viewportWidth / 2;
        }

        if (alignColToStart) {
          return isRtl ? colRight : colLeft;
        }

        return isRtl ? colLeft - viewportWidth : colRight - viewportWidth;
      }

      return null;
    }
  }, {
    key: "isColumnOutsideViewport",
    value: function isColumnOutsideViewport(column) {
      var _this$getViewportBoun = this.getViewportBounds(),
          viewportStart = _this$getViewportBoun.start,
          viewportEnd = _this$getViewportBoun.end;

      var _this$getColumnBounds2 = this.getColumnBounds(column),
          colLeft = _this$getColumnBounds2.colLeft,
          colRight = _this$getColumnBounds2.colRight;

      var isRtl = this.enableRtl;
      var columnBeforeStart = isRtl ? viewportStart > colRight : viewportEnd < colRight;
      var columnAfterEnd = isRtl ? viewportEnd < colLeft : viewportStart > colLeft;
      return {
        columnBeforeStart: columnBeforeStart,
        columnAfterEnd: columnAfterEnd
      };
    }
  }, {
    key: "getColumnBounds",
    value: function getColumnBounds(column) {
      var isRtl = this.enableRtl;
      var bodyWidth = this.columnModel.getBodyContainerWidth();
      var colWidth = column.getActualWidth();
      var colLeft = column.getLeft();
      var multiplier = isRtl ? -1 : 1;
      var colLeftPixel = isRtl ? bodyWidth - colLeft : colLeft;
      var colRightPixel = colLeftPixel + colWidth * multiplier;
      var colMidPixel = colLeftPixel + colWidth / 2 * multiplier;
      return {
        colLeft: colLeftPixel,
        colMiddle: colMidPixel,
        colRight: colRightPixel
      };
    }
  }, {
    key: "getViewportBounds",
    value: function getViewportBounds() {
      var viewportWidth = this.centerRowsCtrl.getCenterWidth();
      var scrollPosition = this.centerRowsCtrl.getCenterViewportScrollLeft();
      var viewportStartPixel = scrollPosition;
      var viewportEndPixel = viewportWidth + scrollPosition;
      return {
        start: viewportStartPixel,
        end: viewportEndPixel,
        width: viewportWidth
      };
    }
  }]);

  return GridBodyScrollFeature;
}(_BeanStub2);

__decorateClass([_Autowired("ctrlsService")], GridBodyScrollFeature.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("animationFrameService")], GridBodyScrollFeature.prototype, "animationFrameService", 2);

__decorateClass([_Autowired("paginationProxy")], GridBodyScrollFeature.prototype, "paginationProxy", 2);

__decorateClass([_Autowired("rowModel")], GridBodyScrollFeature.prototype, "rowModel", 2);

__decorateClass([_Autowired("rowContainerHeightService")], GridBodyScrollFeature.prototype, "heightScaler", 2);

__decorateClass([_Autowired("rowRenderer")], GridBodyScrollFeature.prototype, "rowRenderer", 2);

__decorateClass([_Autowired("columnModel")], GridBodyScrollFeature.prototype, "columnModel", 2);

__decorateClass([_PostConstruct], GridBodyScrollFeature.prototype, "postConstruct", 1); // community-modules/core/src/gridBodyComp/gridBodyCtrl.ts


var _RowAnimationCssClasses =
/* @__PURE__ */
function (RowAnimationCssClasses2) {
  RowAnimationCssClasses2["ANIMATION_ON"] = "ag-row-animation";
  RowAnimationCssClasses2["ANIMATION_OFF"] = "ag-row-no-animation";
  return RowAnimationCssClasses2;
}(_RowAnimationCssClasses || {});

var CSS_CLASS_FORCE_VERTICAL_SCROLL = "ag-force-vertical-scroll";
var CSS_CLASS_CELL_SELECTABLE = "ag-selectable";
var CSS_CLASS_COLUMN_MOVING = "ag-column-moving";

var _GridBodyCtrl =
/*#__PURE__*/
function (_BeanStub27) {
  "use strict";

  _inherits(_GridBodyCtrl, _BeanStub27);

  function _GridBodyCtrl() {
    var _this270;

    _classCallCheck(this, _GridBodyCtrl);

    _this270 = _possibleConstructorReturn(this, _getPrototypeOf(_GridBodyCtrl).apply(this, arguments));
    _this270.stickyTopHeight = 0;
    _this270.stickyBottomHeight = 0;
    return _this270;
  }

  _createClass(_GridBodyCtrl, [{
    key: "getScrollFeature",
    value: function getScrollFeature() {
      return this.bodyScrollFeature;
    }
  }, {
    key: "getBodyViewportElement",
    value: function getBodyViewportElement() {
      return this.eBodyViewport;
    }
  }, {
    key: "setComp",
    value: function setComp(comp, eGridBody, eBodyViewport, eTop, eBottom, eStickyTop, eStickyBottom) {
      var _this271 = this;

      this.comp = comp;
      this.eGridBody = eGridBody;
      this.eBodyViewport = eBodyViewport;
      this.eTop = eTop;
      this.eBottom = eBottom;
      this.eStickyTop = eStickyTop;
      this.eStickyBottom = eStickyBottom;
      this.setCellTextSelection(this.gos.get("enableCellTextSelection"));
      this.addManagedPropertyListener("enableCellTextSelection", function (props) {
        return _this271.setCellTextSelection(props.currentValue);
      });
      this.createManagedBean(new LayoutFeature(this.comp));
      this.bodyScrollFeature = this.createManagedBean(new GridBodyScrollFeature(this.eBodyViewport));
      this.addRowDragListener();
      this.setupRowAnimationCssClass();
      this.addEventListeners();
      this.addFocusListeners([eTop, eBodyViewport, eBottom, eStickyTop, eStickyBottom]);
      this.onGridColumnsChanged();
      this.addBodyViewportListener();
      this.setFloatingHeights();
      this.disableBrowserDragging();
      this.addStopEditingWhenGridLosesFocus();
      this.filterManager.setupAdvancedFilterHeaderComp(eTop);
      this.ctrlsService.register("gridBodyCtrl", this);
    }
  }, {
    key: "getComp",
    value: function getComp() {
      return this.comp;
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      this.addManagedListener(this.eventService, _Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_HEADER_HEIGHT_CHANGED, this.onHeaderHeightChanged.bind(this));
    }
  }, {
    key: "addFocusListeners",
    value: function addFocusListeners(elements) {
      var _this272 = this;

      elements.forEach(function (element) {
        _this272.addManagedListener(element, "focusin", function (e) {
          var target = e.target;

          var isFocusedElementNested = _isElementChildOfClass(target, "ag-root", element);

          element.classList.toggle("ag-has-focus", !isFocusedElementNested);
        });

        _this272.addManagedListener(element, "focusout", function (e) {
          var target = e.target,
              relatedTarget = e.relatedTarget;
          var gridContainRelatedTarget = element.contains(relatedTarget);

          var isNestedRelatedTarget = _isElementChildOfClass(relatedTarget, "ag-root", element);

          var isNestedTarget = _isElementChildOfClass(target, "ag-root", element);

          if (isNestedTarget) {
            return;
          }

          if (!gridContainRelatedTarget || isNestedRelatedTarget) {
            element.classList.remove("ag-has-focus");
          }
        });
      });
    } // used by ColumnAnimationService

  }, {
    key: "setColumnMovingCss",
    value: function setColumnMovingCss(moving) {
      this.comp.setColumnMovingCss(CSS_CLASS_COLUMN_MOVING, moving);
    }
  }, {
    key: "setCellTextSelection",
    value: function setCellTextSelection() {
      var selectable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.comp.setCellSelectableCss(CSS_CLASS_CELL_SELECTABLE, selectable);
    }
  }, {
    key: "onScrollVisibilityChanged",
    value: function onScrollVisibilityChanged() {
      var _this273 = this;

      var visible = this.scrollVisibleService.isVerticalScrollShowing();
      this.setVerticalScrollPaddingVisible(visible);
      this.setStickyWidth(visible);
      this.setStickyBottomOffsetBottom();
      var scrollbarWidth = visible ? this.gos.getScrollbarWidth() || 0 : 0;
      var pad = _isInvisibleScrollbar() ? 16 : 0;
      var width = "calc(100% + ".concat(scrollbarWidth + pad, "px)");
      this.animationFrameService.requestAnimationFrame(function () {
        return _this273.comp.setBodyViewportWidth(width);
      });
    }
  }, {
    key: "onGridColumnsChanged",
    value: function onGridColumnsChanged() {
      var columns = this.columnModel.getAllGridColumns();
      this.comp.setColumnCount(columns.length);
    } // if we do not do this, then the user can select a pic in the grid (eg an image in a custom cell renderer)
    // and then that will start the browser native drag n' drop, which messes up with our own drag and drop.

  }, {
    key: "disableBrowserDragging",
    value: function disableBrowserDragging() {
      this.addManagedListener(this.eGridBody, "dragstart", function (event) {
        if (event.target instanceof HTMLImageElement) {
          event.preventDefault();
          return false;
        }
      });
    }
  }, {
    key: "addStopEditingWhenGridLosesFocus",
    value: function addStopEditingWhenGridLosesFocus() {
      var _this274 = this;

      if (!this.gos.get("stopEditingWhenCellsLoseFocus")) {
        return;
      }

      var focusOutListener = function focusOutListener(event) {
        var elementWithFocus = event.relatedTarget;

        if (_getTabIndex(elementWithFocus) === null) {
          _this274.rowRenderer.stopEditing();

          return;
        }

        var clickInsideGrid = // see if click came from inside the viewports
        viewports.some(function (viewport) {
          return viewport.contains(elementWithFocus);
        }) && _this274.mouseEventService.isElementInThisGrid(elementWithFocus);

        if (!clickInsideGrid) {
          var popupService = _this274.popupService;
          clickInsideGrid = popupService.getActivePopups().some(function (popup) {
            return popup.contains(elementWithFocus);
          }) || popupService.isElementWithinCustomPopup(elementWithFocus);
        }

        if (!clickInsideGrid) {
          _this274.rowRenderer.stopEditing();
        }
      };

      var viewports = [this.eBodyViewport, this.eBottom, this.eTop, this.eStickyTop, this.eStickyBottom];
      viewports.forEach(function (viewport) {
        return _this274.addManagedListener(viewport, "focusout", focusOutListener);
      });
    }
  }, {
    key: "updateRowCount",
    value: function updateRowCount() {
      var headerCount = this.headerNavigationService.getHeaderRowCount() + this.filterManager.getHeaderRowCount();
      var rowCount = this.rowModel.isLastRowIndexKnown() ? this.rowModel.getRowCount() : -1;
      var total = rowCount === -1 ? -1 : headerCount + rowCount;
      this.comp.setRowCount(total);
    }
  }, {
    key: "registerBodyViewportResizeListener",
    value: function registerBodyViewportResizeListener(listener) {
      this.comp.registerBodyViewportResizeListener(listener);
    }
  }, {
    key: "setVerticalScrollPaddingVisible",
    value: function setVerticalScrollPaddingVisible(visible) {
      var overflowY = visible ? "scroll" : "hidden";
      this.comp.setPinnedTopBottomOverflowY(overflowY);
    }
  }, {
    key: "isVerticalScrollShowing",
    value: function isVerticalScrollShowing() {
      var show = this.gos.get("alwaysShowVerticalScroll");
      var cssClass = show ? CSS_CLASS_FORCE_VERTICAL_SCROLL : null;
      var allowVerticalScroll = this.gos.isDomLayout("normal");
      this.comp.setAlwaysVerticalScrollClass(cssClass, show);
      return show || allowVerticalScroll && _isVerticalScrollShowing(this.eBodyViewport);
    }
  }, {
    key: "setupRowAnimationCssClass",
    value: function setupRowAnimationCssClass() {
      var _this275 = this;

      var listener = function listener() {
        var animateRows = _this275.gos.isAnimateRows() && !_this275.rowContainerHeightService.isStretching();
        var animateRowsCssClass = animateRows ? "ag-row-animation"
        /* ANIMATION_ON */
        : "ag-row-no-animation"
        /* ANIMATION_OFF */
        ;

        _this275.comp.setRowAnimationCssOnBodyViewport(animateRowsCssClass, animateRows);
      };

      listener();
      this.addManagedListener(this.eventService, _Events.EVENT_HEIGHT_SCALE_CHANGED, listener);
      this.addManagedPropertyListener("animateRows", listener);
    }
  }, {
    key: "getGridBodyElement",
    value: function getGridBodyElement() {
      return this.eGridBody;
    }
  }, {
    key: "addBodyViewportListener",
    value: function addBodyViewportListener() {
      var listener = this.onBodyViewportContextMenu.bind(this);
      this.addManagedListener(this.eBodyViewport, "contextmenu", listener);
      this.mockContextMenuForIPad(listener);
      this.addManagedListener(this.eBodyViewport, "wheel", this.onBodyViewportWheel.bind(this));
      this.addManagedListener(this.eStickyTop, "wheel", this.onStickyWheel.bind(this));
      this.addManagedListener(this.eStickyBottom, "wheel", this.onStickyWheel.bind(this));
      this.addFullWidthContainerWheelListener();
    }
  }, {
    key: "addFullWidthContainerWheelListener",
    value: function addFullWidthContainerWheelListener() {
      var _this276 = this;

      var fullWidthContainer = this.eBodyViewport.querySelector(".ag-full-width-container");
      var eCenterColsViewport = this.eBodyViewport.querySelector(".ag-center-cols-viewport");

      if (fullWidthContainer && eCenterColsViewport) {
        this.addManagedListener(fullWidthContainer, "wheel", function (e) {
          return _this276.onFullWidthContainerWheel(e, eCenterColsViewport);
        });
      }
    }
  }, {
    key: "onFullWidthContainerWheel",
    value: function onFullWidthContainerWheel(e, eCenterColsViewport) {
      if (!e.deltaX || Math.abs(e.deltaY) > Math.abs(e.deltaX) || !this.mouseEventService.isEventFromThisGrid(e)) {
        return;
      }

      e.preventDefault();
      eCenterColsViewport.scrollBy({
        left: e.deltaX
      });
    }
  }, {
    key: "onBodyViewportContextMenu",
    value: function onBodyViewportContextMenu(mouseEvent, touch, touchEvent) {
      if (!mouseEvent && !touchEvent) {
        return;
      }

      if (this.gos.get("preventDefaultOnContextMenu")) {
        var event = mouseEvent || touchEvent;
        event.preventDefault();
      }

      var _ref36 = mouseEvent || touch,
          target = _ref36.target;

      if (target === this.eBodyViewport || target === this.ctrlsService.get("center").getViewportElement()) {
        this.menuService.showContextMenu({
          mouseEvent: mouseEvent,
          touchEvent: touchEvent,
          value: null,
          anchorToElement: this.eGridBody
        });
      }
    }
  }, {
    key: "mockContextMenuForIPad",
    value: function mockContextMenuForIPad(listener) {
      if (!_isIOSUserAgent()) {
        return;
      }

      var touchListener = new _TouchListener2(this.eBodyViewport);

      var longTapListener = function longTapListener(event) {
        listener(void 0, event.touchStart, event.touchEvent);
      };

      this.addManagedListener(touchListener, _TouchListener2.EVENT_LONG_TAP, longTapListener);
      this.addDestroyFunc(function () {
        return touchListener.destroy();
      });
    }
  }, {
    key: "onBodyViewportWheel",
    value: function onBodyViewportWheel(e) {
      if (!this.gos.get("suppressScrollWhenPopupsAreOpen")) {
        return;
      }

      if (this.popupService.hasAnchoredPopup()) {
        e.preventDefault();
      }
    }
  }, {
    key: "onStickyWheel",
    value: function onStickyWheel(e) {
      e.preventDefault();

      if (e.offsetY) {
        this.scrollVertically(e.deltaY);
      }
    }
  }, {
    key: "getGui",
    value: function getGui() {
      return this.eGridBody;
    } // called by rowDragFeature

  }, {
    key: "scrollVertically",
    value: function scrollVertically(pixels) {
      var oldScrollPosition = this.eBodyViewport.scrollTop;
      this.bodyScrollFeature.setVerticalScrollPosition(oldScrollPosition + pixels);
      return this.eBodyViewport.scrollTop - oldScrollPosition;
    }
  }, {
    key: "addRowDragListener",
    value: function addRowDragListener() {
      this.rowDragFeature = this.createManagedBean(new RowDragFeature(this.eBodyViewport));
      this.dragAndDropService.addDropTarget(this.rowDragFeature);
    }
  }, {
    key: "getRowDragFeature",
    value: function getRowDragFeature() {
      return this.rowDragFeature;
    }
  }, {
    key: "onPinnedRowDataChanged",
    value: function onPinnedRowDataChanged() {
      this.setFloatingHeights();
    }
  }, {
    key: "setFloatingHeights",
    value: function setFloatingHeights() {
      var pinnedRowModel = this.pinnedRowModel;
      var floatingTopHeight = pinnedRowModel.getPinnedTopTotalHeight();
      var floatingBottomHeight = pinnedRowModel.getPinnedBottomTotalHeight();
      this.comp.setTopHeight(floatingTopHeight);
      this.comp.setBottomHeight(floatingBottomHeight);
      this.comp.setTopDisplay(floatingTopHeight ? "inherit" : "none");
      this.comp.setBottomDisplay(floatingBottomHeight ? "inherit" : "none");
      this.setStickyTopOffsetTop();
      this.setStickyBottomOffsetBottom();
    }
  }, {
    key: "setStickyTopHeight",
    value: function setStickyTopHeight() {
      var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.comp.setStickyTopHeight("".concat(height, "px"));
      this.stickyTopHeight = height;
    }
  }, {
    key: "getStickyTopHeight",
    value: function getStickyTopHeight() {
      return this.stickyTopHeight;
    }
  }, {
    key: "setStickyBottomHeight",
    value: function setStickyBottomHeight() {
      var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.comp.setStickyBottomHeight("".concat(height, "px"));
      this.stickyBottomHeight = height;
    }
  }, {
    key: "getStickyBottomHeight",
    value: function getStickyBottomHeight() {
      return this.stickyBottomHeight;
    }
  }, {
    key: "setStickyWidth",
    value: function setStickyWidth(vScrollVisible) {
      if (!vScrollVisible) {
        this.comp.setStickyTopWidth("100%");
        this.comp.setStickyBottomWidth("100%");
      } else {
        var scrollbarWidth = this.gos.getScrollbarWidth();
        this.comp.setStickyTopWidth("calc(100% - ".concat(scrollbarWidth, "px)"));
        this.comp.setStickyBottomWidth("calc(100% - ".concat(scrollbarWidth, "px)"));
      }
    }
  }, {
    key: "onHeaderHeightChanged",
    value: function onHeaderHeightChanged() {
      this.setStickyTopOffsetTop();
    }
  }, {
    key: "setStickyTopOffsetTop",
    value: function setStickyTopOffsetTop() {
      var headerCtrl = this.ctrlsService.get("gridHeaderCtrl");
      var headerHeight = headerCtrl.getHeaderHeight() + this.filterManager.getHeaderHeight();
      var pinnedTopHeight = this.pinnedRowModel.getPinnedTopTotalHeight();
      var height = 0;

      if (headerHeight > 0) {
        height += headerHeight;
      }

      if (pinnedTopHeight > 0) {
        height += pinnedTopHeight;
      }

      if (height > 0) {
        height += 1;
      }

      this.comp.setStickyTopTop("".concat(height, "px"));
    }
  }, {
    key: "setStickyBottomOffsetBottom",
    value: function setStickyBottomOffsetBottom() {
      var pinnedBottomHeight = this.pinnedRowModel.getPinnedBottomTotalHeight();
      var hScrollShowing = this.scrollVisibleService.isHorizontalScrollShowing();
      var scrollbarWidth = hScrollShowing ? this.gos.getScrollbarWidth() || 0 : 0;
      var height = pinnedBottomHeight + scrollbarWidth;
      this.comp.setStickyBottomBottom("".concat(height, "px"));
    } // method will call itself if no available width. this covers if the grid
    // isn't visible, but is just about to be visible.

  }, {
    key: "sizeColumnsToFit",
    value: function sizeColumnsToFit(params, nextTimeout) {
      var _this277 = this;

      var removeScrollWidth = this.isVerticalScrollShowing();
      var scrollWidthToRemove = removeScrollWidth ? this.gos.getScrollbarWidth() : 0;

      var bodyViewportWidth = _getInnerWidth(this.eGridBody);

      var availableWidth = bodyViewportWidth - scrollWidthToRemove;

      if (availableWidth > 0) {
        this.columnModel.sizeColumnsToFit(availableWidth, "sizeColumnsToFit", false, params);
        return;
      }

      if (nextTimeout === void 0) {
        window.setTimeout(function () {
          _this277.sizeColumnsToFit(params, 100);
        }, 0);
      } else if (nextTimeout === 100) {
        window.setTimeout(function () {
          _this277.sizeColumnsToFit(params, 500);
        }, 100);
      } else if (nextTimeout === 500) {
        window.setTimeout(function () {
          _this277.sizeColumnsToFit(params, -1);
        }, 500);
      } else {
        console.warn("AG Grid: tried to call sizeColumnsToFit() but the grid is coming back with zero width, maybe the grid is not visible yet on the screen?");
      }
    } // + rangeService

  }, {
    key: "addScrollEventListener",
    value: function addScrollEventListener(listener) {
      this.eBodyViewport.addEventListener("scroll", listener, {
        passive: true
      });
    } // + focusService

  }, {
    key: "removeScrollEventListener",
    value: function removeScrollEventListener(listener) {
      this.eBodyViewport.removeEventListener("scroll", listener);
    }
  }]);

  return _GridBodyCtrl;
}(_BeanStub2);

__decorateClass([_Autowired("animationFrameService")], _GridBodyCtrl.prototype, "animationFrameService", 2);

__decorateClass([_Autowired("rowContainerHeightService")], _GridBodyCtrl.prototype, "rowContainerHeightService", 2);

__decorateClass([_Autowired("ctrlsService")], _GridBodyCtrl.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("columnModel")], _GridBodyCtrl.prototype, "columnModel", 2);

__decorateClass([_Autowired("scrollVisibleService")], _GridBodyCtrl.prototype, "scrollVisibleService", 2);

__decorateClass([_Autowired("menuService")], _GridBodyCtrl.prototype, "menuService", 2);

__decorateClass([_Autowired("headerNavigationService")], _GridBodyCtrl.prototype, "headerNavigationService", 2);

__decorateClass([_Autowired("dragAndDropService")], _GridBodyCtrl.prototype, "dragAndDropService", 2);

__decorateClass([_Autowired("pinnedRowModel")], _GridBodyCtrl.prototype, "pinnedRowModel", 2);

__decorateClass([_Autowired("rowRenderer")], _GridBodyCtrl.prototype, "rowRenderer", 2);

__decorateClass([_Autowired("popupService")], _GridBodyCtrl.prototype, "popupService", 2);

__decorateClass([_Autowired("mouseEventService")], _GridBodyCtrl.prototype, "mouseEventService", 2);

__decorateClass([_Autowired("rowModel")], _GridBodyCtrl.prototype, "rowModel", 2);

__decorateClass([_Autowired("filterManager")], _GridBodyCtrl.prototype, "filterManager", 2); // community-modules/core/src/interfaces/IRangeService.ts


var _SelectionHandleType =
/* @__PURE__ */
function (SelectionHandleType2) {
  SelectionHandleType2[SelectionHandleType2["FILL"] = 0] = "FILL";
  SelectionHandleType2[SelectionHandleType2["RANGE"] = 1] = "RANGE";
  return SelectionHandleType2;
}(_SelectionHandleType || {});

var _CellRangeType =
/* @__PURE__ */
function (CellRangeType2) {
  CellRangeType2[CellRangeType2["VALUE"] = 0] = "VALUE";
  CellRangeType2[CellRangeType2["DIMENSION"] = 1] = "DIMENSION";
  return CellRangeType2;
}(_CellRangeType || {}); // community-modules/core/src/rendering/cell/cellRangeFeature.ts


var CSS_CELL_RANGE_SELECTED = "ag-cell-range-selected";
var CSS_CELL_RANGE_CHART = "ag-cell-range-chart";
var CSS_CELL_RANGE_SINGLE_CELL = "ag-cell-range-single-cell";
var CSS_CELL_RANGE_CHART_CATEGORY = "ag-cell-range-chart-category";
var CSS_CELL_RANGE_HANDLE = "ag-cell-range-handle";
var CSS_CELL_RANGE_TOP = "ag-cell-range-top";
var CSS_CELL_RANGE_RIGHT = "ag-cell-range-right";
var CSS_CELL_RANGE_BOTTOM = "ag-cell-range-bottom";
var CSS_CELL_RANGE_LEFT = "ag-cell-range-left";

var CellRangeFeature =
/*#__PURE__*/
function () {
  "use strict";

  function CellRangeFeature(beans, ctrl) {
    _classCallCheck(this, CellRangeFeature);

    this.beans = beans;
    this.rangeService = beans.rangeService;
    this.selectionHandleFactory = beans.selectionHandleFactory;
    this.cellCtrl = ctrl;
  }

  _createClass(CellRangeFeature, [{
    key: "setComp",
    value: function setComp(cellComp, eGui) {
      this.cellComp = cellComp;
      this.eGui = eGui;
      this.onRangeSelectionChanged();
    }
  }, {
    key: "onRangeSelectionChanged",
    value: function onRangeSelectionChanged() {
      if (!this.cellComp) {
        return;
      }

      this.rangeCount = this.rangeService.getCellRangeCount(this.cellCtrl.getCellPosition());
      this.hasChartRange = this.getHasChartRange();
      this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_SELECTED, this.rangeCount !== 0);
      this.cellComp.addOrRemoveCssClass("".concat(CSS_CELL_RANGE_SELECTED, "-1"), this.rangeCount === 1);
      this.cellComp.addOrRemoveCssClass("".concat(CSS_CELL_RANGE_SELECTED, "-2"), this.rangeCount === 2);
      this.cellComp.addOrRemoveCssClass("".concat(CSS_CELL_RANGE_SELECTED, "-3"), this.rangeCount === 3);
      this.cellComp.addOrRemoveCssClass("".concat(CSS_CELL_RANGE_SELECTED, "-4"), this.rangeCount >= 4);
      this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_CHART, this.hasChartRange);

      _setAriaSelected(this.eGui, this.rangeCount > 0 ? true : void 0);

      this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_SINGLE_CELL, this.isSingleCell());
      this.updateRangeBorders();
      this.refreshHandle();
    }
  }, {
    key: "updateRangeBorders",
    value: function updateRangeBorders() {
      var rangeBorders = this.getRangeBorders();
      var isSingleCell = this.isSingleCell();
      var isTop = !isSingleCell && rangeBorders.top;
      var isRight = !isSingleCell && rangeBorders.right;
      var isBottom = !isSingleCell && rangeBorders.bottom;
      var isLeft = !isSingleCell && rangeBorders.left;
      this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_TOP, isTop);
      this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_RIGHT, isRight);
      this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_BOTTOM, isBottom);
      this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_LEFT, isLeft);
    }
  }, {
    key: "isSingleCell",
    value: function isSingleCell() {
      var rangeService = this.beans.rangeService;
      return this.rangeCount === 1 && !!rangeService && !rangeService.isMoreThanOneCell();
    }
  }, {
    key: "getHasChartRange",
    value: function getHasChartRange() {
      var rangeService = this.beans.rangeService;

      if (!this.rangeCount || !rangeService) {
        return false;
      }

      var cellRanges = rangeService.getCellRanges();
      return cellRanges.length > 0 && cellRanges.every(function (range) {
        return _includes([1
        /* DIMENSION */
        , 0
        /* VALUE */
        ], range.type);
      });
    }
  }, {
    key: "updateRangeBordersIfRangeCount",
    value: function updateRangeBordersIfRangeCount() {
      if (this.rangeCount > 0) {
        this.updateRangeBorders();
        this.refreshHandle();
      }
    }
  }, {
    key: "getRangeBorders",
    value: function getRangeBorders() {
      var _this278 = this;

      var isRtl = this.beans.gos.get("enableRtl");
      var top = false;
      var right = false;
      var bottom = false;
      var left = false;
      var thisCol = this.cellCtrl.getCellPosition().column;
      var columnModel = this.beans.columnModel;
      var leftCol;
      var rightCol;

      if (isRtl) {
        leftCol = columnModel.getDisplayedColAfter(thisCol);
        rightCol = columnModel.getDisplayedColBefore(thisCol);
      } else {
        leftCol = columnModel.getDisplayedColBefore(thisCol);
        rightCol = columnModel.getDisplayedColAfter(thisCol);
      }

      var ranges = this.rangeService.getCellRanges().filter(function (range) {
        return _this278.rangeService.isCellInSpecificRange(_this278.cellCtrl.getCellPosition(), range);
      });

      if (!leftCol) {
        left = true;
      }

      if (!rightCol) {
        right = true;
      }

      for (var i = 0; i < ranges.length; i++) {
        if (top && right && bottom && left) {
          break;
        }

        var range = ranges[i];
        var startRow = this.rangeService.getRangeStartRow(range);
        var endRow = this.rangeService.getRangeEndRow(range);

        if (!top && this.beans.rowPositionUtils.sameRow(startRow, this.cellCtrl.getCellPosition())) {
          top = true;
        }

        if (!bottom && this.beans.rowPositionUtils.sameRow(endRow, this.cellCtrl.getCellPosition())) {
          bottom = true;
        }

        if (!left && leftCol && range.columns.indexOf(leftCol) < 0) {
          left = true;
        }

        if (!right && rightCol && range.columns.indexOf(rightCol) < 0) {
          right = true;
        }
      }

      return {
        top: top,
        right: right,
        bottom: bottom,
        left: left
      };
    }
  }, {
    key: "refreshHandle",
    value: function refreshHandle() {
      if (this.beans.context.isDestroyed()) {
        return;
      }

      var shouldHaveSelectionHandle = this.shouldHaveSelectionHandle();

      if (this.selectionHandle && !shouldHaveSelectionHandle) {
        this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle);
      }

      if (shouldHaveSelectionHandle) {
        this.addSelectionHandle();
      }

      this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_HANDLE, !!this.selectionHandle);
    }
  }, {
    key: "shouldHaveSelectionHandle",
    value: function shouldHaveSelectionHandle() {
      var gos = this.beans.gos;
      var cellRanges = this.rangeService.getCellRanges();
      var rangesLen = cellRanges.length;

      if (this.rangeCount < 1 || rangesLen < 1) {
        return false;
      }

      var cellRange = _last(cellRanges);

      var cellPosition = this.cellCtrl.getCellPosition();
      var isFillHandleAvailable = gos.get("enableFillHandle") && !this.cellCtrl.isSuppressFillHandle();
      var isRangeHandleAvailable = gos.get("enableRangeHandle");
      var handleIsAvailable = rangesLen === 1 && !this.cellCtrl.isEditing() && (isFillHandleAvailable || isRangeHandleAvailable);

      if (this.hasChartRange) {
        var hasCategoryRange = cellRanges[0].type === 1
        /* DIMENSION */
        ;
        var isCategoryCell = hasCategoryRange && this.rangeService.isCellInSpecificRange(cellPosition, cellRanges[0]);
        this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_CHART_CATEGORY, isCategoryCell);
        handleIsAvailable = cellRange.type === 0
        /* VALUE */
        ;
      }

      return handleIsAvailable && cellRange.endRow != null && this.rangeService.isContiguousRange(cellRange) && this.rangeService.isBottomRightCell(cellRange, cellPosition);
    }
  }, {
    key: "addSelectionHandle",
    value: function addSelectionHandle() {
      var gos = this.beans.gos;

      var cellRangeType = _last(this.rangeService.getCellRanges()).type;

      var selectionHandleFill = gos.get("enableFillHandle") && _missing(cellRangeType);

      var type = selectionHandleFill ? 0
      /* FILL */
      : 1
      /* RANGE */
      ;

      if (this.selectionHandle && this.selectionHandle.getType() !== type) {
        this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle);
      }

      if (!this.selectionHandle) {
        this.selectionHandle = this.selectionHandleFactory.createSelectionHandle(type);
      }

      this.selectionHandle.refresh(this.cellCtrl);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.beans.context.destroyBean(this.selectionHandle);
    }
  }]);

  return CellRangeFeature;
}(); // community-modules/core/src/rendering/cell/cellPositionFeature.ts


var CellPositionFeature =
/*#__PURE__*/
function (_BeanStub28) {
  "use strict";

  _inherits(CellPositionFeature, _BeanStub28);

  function CellPositionFeature(ctrl, beans) {
    var _this279;

    _classCallCheck(this, CellPositionFeature);

    _this279 = _possibleConstructorReturn(this, _getPrototypeOf(CellPositionFeature).call(this));
    _this279.cellCtrl = ctrl;
    _this279.beans = beans;
    _this279.column = ctrl.getColumn();
    _this279.rowNode = ctrl.getRowNode();
    return _this279;
  }

  _createClass(CellPositionFeature, [{
    key: "setupRowSpan",
    value: function setupRowSpan() {
      var _this280 = this;

      this.rowSpan = this.column.getRowSpan(this.rowNode);
      this.addManagedListener(this.beans.eventService, _Events.EVENT_NEW_COLUMNS_LOADED, function () {
        return _this280.onNewColumnsLoaded();
      });
    }
  }, {
    key: "setComp",
    value: function setComp(eGui) {
      this.eGui = eGui;
      this.setupColSpan();
      this.setupRowSpan();
      this.onLeftChanged();
      this.onWidthChanged();
      this.applyRowSpan();
    }
  }, {
    key: "onNewColumnsLoaded",
    value: function onNewColumnsLoaded() {
      var rowSpan = this.column.getRowSpan(this.rowNode);

      if (this.rowSpan === rowSpan) {
        return;
      }

      this.rowSpan = rowSpan;
      this.applyRowSpan(true);
    }
  }, {
    key: "onDisplayColumnsChanged",
    value: function onDisplayColumnsChanged() {
      var colsSpanning = this.getColSpanningList();

      if (!_areEqual(this.colsSpanning, colsSpanning)) {
        this.colsSpanning = colsSpanning;
        this.onWidthChanged();
        this.onLeftChanged();
      }
    }
  }, {
    key: "setupColSpan",
    value: function setupColSpan() {
      if (this.column.getColDef().colSpan == null) {
        return;
      }

      this.colsSpanning = this.getColSpanningList();
      this.addManagedListener(this.beans.eventService, _Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayColumnsChanged.bind(this));
      this.addManagedListener(this.beans.eventService, _Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onWidthChanged.bind(this));
    }
  }, {
    key: "onWidthChanged",
    value: function onWidthChanged() {
      if (!this.eGui) {
        return;
      }

      var width = this.getCellWidth();
      this.eGui.style.width = "".concat(width, "px");
    }
  }, {
    key: "getCellWidth",
    value: function getCellWidth() {
      if (!this.colsSpanning) {
        return this.column.getActualWidth();
      }

      return this.colsSpanning.reduce(function (width, col) {
        return width + col.getActualWidth();
      }, 0);
    }
  }, {
    key: "getColSpanningList",
    value: function getColSpanningList() {
      var colSpan = this.column.getColSpan(this.rowNode);
      var colsSpanning = [];

      if (colSpan === 1) {
        colsSpanning.push(this.column);
      } else {
        var pointer = this.column;
        var pinned = this.column.getPinned();

        for (var i = 0; pointer && i < colSpan; i++) {
          colsSpanning.push(pointer);
          pointer = this.beans.columnModel.getDisplayedColAfter(pointer);

          if (!pointer || _missing(pointer)) {
            break;
          }

          if (pinned !== pointer.getPinned()) {
            break;
          }
        }
      }

      return colsSpanning;
    }
  }, {
    key: "onLeftChanged",
    value: function onLeftChanged() {
      if (!this.eGui) {
        return;
      }

      var left = this.modifyLeftForPrintLayout(this.getCellLeft());
      this.eGui.style.left = left + "px";
    }
  }, {
    key: "getCellLeft",
    value: function getCellLeft() {
      var mostLeftCol;

      if (this.beans.gos.get("enableRtl") && this.colsSpanning) {
        mostLeftCol = _last(this.colsSpanning);
      } else {
        mostLeftCol = this.column;
      }

      return mostLeftCol.getLeft();
    }
  }, {
    key: "modifyLeftForPrintLayout",
    value: function modifyLeftForPrintLayout(leftPosition) {
      if (!this.cellCtrl.isPrintLayout() || this.column.getPinned() === "left") {
        return leftPosition;
      }

      var leftWidth = this.beans.columnModel.getDisplayedColumnsLeftWidth();

      if (this.column.getPinned() === "right") {
        var bodyWidth = this.beans.columnModel.getBodyContainerWidth();
        return leftWidth + bodyWidth + (leftPosition || 0);
      }

      return leftWidth + (leftPosition || 0);
    }
  }, {
    key: "applyRowSpan",
    value: function applyRowSpan(force) {
      if (this.rowSpan === 1 && !force) {
        return;
      }

      var singleRowHeight = this.beans.gos.getRowHeightAsNumber();
      var totalRowHeight = singleRowHeight * this.rowSpan;
      this.eGui.style.height = "".concat(totalRowHeight, "px");
      this.eGui.style.zIndex = "1";
    } // overriding to make public, as we don't dispose this bean via context

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(CellPositionFeature.prototype), "destroy", this).call(this);
    }
  }]);

  return CellPositionFeature;
}(_BeanStub2); // community-modules/core/src/rendering/cell/cellCustomStyleFeature.ts


var CellCustomStyleFeature =
/*#__PURE__*/
function (_BeanStub29) {
  "use strict";

  _inherits(CellCustomStyleFeature, _BeanStub29);

  function CellCustomStyleFeature(ctrl, beans) {
    var _this281;

    _classCallCheck(this, CellCustomStyleFeature);

    _this281 = _possibleConstructorReturn(this, _getPrototypeOf(CellCustomStyleFeature).call(this));
    _this281.staticClasses = [];
    _this281.cellCtrl = ctrl;
    _this281.beans = beans;
    _this281.column = ctrl.getColumn();
    _this281.rowNode = ctrl.getRowNode();
    return _this281;
  }

  _createClass(CellCustomStyleFeature, [{
    key: "setComp",
    value: function setComp(comp) {
      this.cellComp = comp;
      this.applyUserStyles();
      this.applyCellClassRules();
      this.applyClassesFromColDef();
    }
  }, {
    key: "applyCellClassRules",
    value: function applyCellClassRules() {
      var _this282 = this;

      var colDef = this.column.getColDef();
      var cellClassRules = colDef.cellClassRules;
      var cellClassParams = this.beans.gos.addGridCommonParams({
        value: this.cellCtrl.getValue(),
        data: this.rowNode.data,
        node: this.rowNode,
        colDef: colDef,
        column: this.column,
        rowIndex: this.rowNode.rowIndex
      });
      this.beans.stylingService.processClassRules( // if current was previous, skip
      cellClassRules === this.cellClassRules ? void 0 : this.cellClassRules, cellClassRules, cellClassParams, function (className) {
        return _this282.cellComp.addOrRemoveCssClass(className, true);
      }, function (className) {
        return _this282.cellComp.addOrRemoveCssClass(className, false);
      });
      this.cellClassRules = cellClassRules;
    }
  }, {
    key: "applyUserStyles",
    value: function applyUserStyles() {
      var colDef = this.column.getColDef();

      if (!colDef.cellStyle) {
        return;
      }

      var styles;

      if (typeof colDef.cellStyle === "function") {
        var cellStyleParams = this.beans.gos.addGridCommonParams({
          column: this.column,
          value: this.cellCtrl.getValue(),
          colDef: colDef,
          data: this.rowNode.data,
          node: this.rowNode,
          rowIndex: this.rowNode.rowIndex
        });
        var cellStyleFunc = colDef.cellStyle;
        styles = cellStyleFunc(cellStyleParams);
      } else {
        styles = colDef.cellStyle;
      }

      if (styles) {
        this.cellComp.setUserStyles(styles);
      }
    }
  }, {
    key: "applyClassesFromColDef",
    value: function applyClassesFromColDef() {
      var _this283 = this;

      var colDef = this.column.getColDef();
      var cellClassParams = this.beans.gos.addGridCommonParams({
        value: this.cellCtrl.getValue(),
        data: this.rowNode.data,
        node: this.rowNode,
        column: this.column,
        colDef: colDef,
        rowIndex: this.rowNode.rowIndex
      });

      if (this.staticClasses.length) {
        this.staticClasses.forEach(function (className) {
          return _this283.cellComp.addOrRemoveCssClass(className, false);
        });
      }

      this.staticClasses = this.beans.stylingService.getStaticCellClasses(colDef, cellClassParams);

      if (this.staticClasses.length) {
        this.staticClasses.forEach(function (className) {
          return _this283.cellComp.addOrRemoveCssClass(className, true);
        });
      }
    } // overriding to make public, as we don't dispose this bean via context

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(CellCustomStyleFeature.prototype), "destroy", this).call(this);
    }
  }]);

  return CellCustomStyleFeature;
}(_BeanStub2); // community-modules/core/src/rendering/beans.ts


var _Beans =
/*#__PURE__*/
function () {
  "use strict";

  function _Beans() {
    _classCallCheck(this, _Beans);
  }

  _createClass(_Beans, [{
    key: "postConstruct",
    value: function postConstruct() {
      if (this.gos.isRowModelType("clientSide")) {
        this.clientSideRowModel = this.rowModel;
      }

      if (this.gos.isRowModelType("serverSide")) {
        this.serverSideRowModel = this.rowModel;
      }
    }
  }]);

  return _Beans;
}();

__decorateClass([_Autowired("resizeObserverService")], _Beans.prototype, "resizeObserverService", 2);

__decorateClass([_Autowired("paginationProxy")], _Beans.prototype, "paginationProxy", 2);

__decorateClass([_Autowired("context")], _Beans.prototype, "context", 2);

__decorateClass([_Autowired("gridOptionsService")], _Beans.prototype, "gos", 2);

__decorateClass([_Autowired("environment")], _Beans.prototype, "environment", 2);

__decorateClass([_Autowired("rowRenderer")], _Beans.prototype, "rowRenderer", 2);

__decorateClass([_Autowired("valueService")], _Beans.prototype, "valueService", 2);

__decorateClass([_Autowired("eventService")], _Beans.prototype, "eventService", 2);

__decorateClass([_Autowired("columnModel")], _Beans.prototype, "columnModel", 2);

__decorateClass([_Autowired("headerNavigationService")], _Beans.prototype, "headerNavigationService", 2);

__decorateClass([_Autowired("navigationService")], _Beans.prototype, "navigationService", 2);

__decorateClass([_Autowired("columnAnimationService")], _Beans.prototype, "columnAnimationService", 2);

__decorateClass([_Autowired("focusService")], _Beans.prototype, "focusService", 2);

__decorateClass([_Autowired("popupService")], _Beans.prototype, "popupService", 2);

__decorateClass([_Autowired("stylingService")], _Beans.prototype, "stylingService", 2);

__decorateClass([_Autowired("columnHoverService")], _Beans.prototype, "columnHoverService", 2);

__decorateClass([_Autowired("userComponentFactory")], _Beans.prototype, "userComponentFactory", 2);

__decorateClass([_Autowired("userComponentRegistry")], _Beans.prototype, "userComponentRegistry", 2);

__decorateClass([_Autowired("animationFrameService")], _Beans.prototype, "animationFrameService", 2);

__decorateClass([_Autowired("dragService")], _Beans.prototype, "dragService", 2);

__decorateClass([_Autowired("dragAndDropService")], _Beans.prototype, "dragAndDropService", 2);

__decorateClass([_Autowired("sortController")], _Beans.prototype, "sortController", 2);

__decorateClass([_Autowired("filterManager")], _Beans.prototype, "filterManager", 2);

__decorateClass([_Autowired("rowContainerHeightService")], _Beans.prototype, "rowContainerHeightService", 2);

__decorateClass([_Autowired("frameworkOverrides")], _Beans.prototype, "frameworkOverrides", 2);

__decorateClass([_Autowired("cellPositionUtils")], _Beans.prototype, "cellPositionUtils", 2);

__decorateClass([_Autowired("rowPositionUtils")], _Beans.prototype, "rowPositionUtils", 2);

__decorateClass([_Autowired("selectionService")], _Beans.prototype, "selectionService", 2);

__decorateClass([_Autowired("rowCssClassCalculator")], _Beans.prototype, "rowCssClassCalculator", 2);

__decorateClass([_Autowired("rowModel")], _Beans.prototype, "rowModel", 2);

__decorateClass([_Autowired("ctrlsService")], _Beans.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("ctrlsFactory")], _Beans.prototype, "ctrlsFactory", 2);

__decorateClass([_Autowired("agStackComponentsRegistry")], _Beans.prototype, "agStackComponentsRegistry", 2);

__decorateClass([_Autowired("valueCache")], _Beans.prototype, "valueCache", 2);

__decorateClass([_Autowired("rowNodeEventThrottle")], _Beans.prototype, "rowNodeEventThrottle", 2);

__decorateClass([_Autowired("localeService")], _Beans.prototype, "localeService", 2);

__decorateClass([_Autowired("syncService")], _Beans.prototype, "syncService", 2);

__decorateClass([_Autowired("ariaAnnouncementService")], _Beans.prototype, "ariaAnnouncementService", 2);

__decorateClass([_Optional("rangeService")], _Beans.prototype, "rangeService", 2);

__decorateClass([_Optional("selectionHandleFactory")], _Beans.prototype, "selectionHandleFactory", 2);

__decorateClass([_PostConstruct], _Beans.prototype, "postConstruct", 1);

_Beans = __decorateClass([_Bean("beans")], _Beans); // community-modules/core/src/rendering/cell/cellMouseListenerFeature.ts

var CellMouseListenerFeature =
/*#__PURE__*/
function (_Beans2) {
  "use strict";

  _inherits(CellMouseListenerFeature, _Beans2);

  function CellMouseListenerFeature(ctrl, beans, column) {
    var _this284;

    _classCallCheck(this, CellMouseListenerFeature);

    _this284 = _possibleConstructorReturn(this, _getPrototypeOf(CellMouseListenerFeature).call(this));
    _this284.cellCtrl = ctrl;
    _this284.beans = beans;
    _this284.column = column;
    return _this284;
  }

  _createClass(CellMouseListenerFeature, [{
    key: "onMouseEvent",
    value: function onMouseEvent(eventName, mouseEvent) {
      if (_isStopPropagationForAgGrid(mouseEvent)) {
        return;
      }

      switch (eventName) {
        case "click":
          this.onCellClicked(mouseEvent);
          break;

        case "mousedown":
        case "touchstart":
          this.onMouseDown(mouseEvent);
          break;

        case "dblclick":
          this.onCellDoubleClicked(mouseEvent);
          break;

        case "mouseout":
          this.onMouseOut(mouseEvent);
          break;

        case "mouseover":
          this.onMouseOver(mouseEvent);
          break;
      }
    }
  }, {
    key: "onCellClicked",
    value: function onCellClicked(mouseEvent) {
      var _this285 = this;

      if (this.isDoubleClickOnIPad()) {
        this.onCellDoubleClicked(mouseEvent);
        mouseEvent.preventDefault();
        return;
      }

      var _this$beans = this.beans,
          eventService = _this$beans.eventService,
          rangeService = _this$beans.rangeService,
          gos = _this$beans.gos;
      var isMultiKey = mouseEvent.ctrlKey || mouseEvent.metaKey;

      if (rangeService && isMultiKey) {
        if (rangeService.getCellRangeCount(this.cellCtrl.getCellPosition()) > 1) {
          rangeService.intersectLastRange(true);
        }
      }

      var cellClickedEvent = this.cellCtrl.createEvent(mouseEvent, _Events.EVENT_CELL_CLICKED);
      eventService.dispatchEvent(cellClickedEvent);
      var colDef = this.column.getColDef();

      if (colDef.onCellClicked) {
        window.setTimeout(function () {
          _this285.beans.frameworkOverrides.wrapOutgoing(function () {
            colDef.onCellClicked(cellClickedEvent);
          });
        }, 0);
      }

      var editOnSingleClick = (gos.get("singleClickEdit") || colDef.singleClickEdit) && !gos.get("suppressClickEdit");

      if (editOnSingleClick && !(mouseEvent.shiftKey && (rangeService == null ? void 0 : rangeService.getCellRanges().length) != 0)) {
        this.cellCtrl.startRowOrCellEdit();
      }
    } // returns true if on iPad and this is second 'click' event in 200ms

  }, {
    key: "isDoubleClickOnIPad",
    value: function isDoubleClickOnIPad() {
      if (!_isIOSUserAgent() || _isEventSupported("dblclick")) {
        return false;
      }

      var nowMillis =
      /* @__PURE__ */
      new Date().getTime();
      var res = nowMillis - this.lastIPadMouseClickEvent < 200;
      this.lastIPadMouseClickEvent = nowMillis;
      return res;
    }
  }, {
    key: "onCellDoubleClicked",
    value: function onCellDoubleClicked(mouseEvent) {
      var _this286 = this;

      var colDef = this.column.getColDef();
      var cellDoubleClickedEvent = this.cellCtrl.createEvent(mouseEvent, _Events.EVENT_CELL_DOUBLE_CLICKED);
      this.beans.eventService.dispatchEvent(cellDoubleClickedEvent);

      if (typeof colDef.onCellDoubleClicked === "function") {
        window.setTimeout(function () {
          _this286.beans.frameworkOverrides.wrapOutgoing(function () {
            colDef.onCellDoubleClicked(cellDoubleClickedEvent);
          });
        }, 0);
      }

      var editOnDoubleClick = !this.beans.gos.get("singleClickEdit") && !this.beans.gos.get("suppressClickEdit");

      if (editOnDoubleClick) {
        this.cellCtrl.startRowOrCellEdit(null, mouseEvent);
      }
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(mouseEvent) {
      var ctrlKey = mouseEvent.ctrlKey,
          metaKey = mouseEvent.metaKey,
          shiftKey = mouseEvent.shiftKey;
      var target = mouseEvent.target;
      var cellCtrl = this.cellCtrl,
          beans = this.beans;
      var eventService = beans.eventService,
          rangeService = beans.rangeService,
          focusService = beans.focusService;

      if (this.isRightClickInExistingRange(mouseEvent)) {
        return;
      }

      var ranges = rangeService && rangeService.getCellRanges().length != 0;

      if (!shiftKey || !ranges) {
        var forceBrowserFocus = _isBrowserSafari() && !cellCtrl.isEditing() && !_isFocusableFormField(target);
        cellCtrl.focusCell(forceBrowserFocus);
      }

      if (shiftKey && ranges && !focusService.isCellFocused(cellCtrl.getCellPosition())) {
        mouseEvent.preventDefault();
        var focusedCellPosition = focusService.getFocusedCell();

        if (focusedCellPosition) {
          var column = focusedCellPosition.column,
              rowIndex = focusedCellPosition.rowIndex,
              rowPinned = focusedCellPosition.rowPinned;
          var focusedRowCtrl = beans.rowRenderer.getRowByPosition({
            rowIndex: rowIndex,
            rowPinned: rowPinned
          });
          var focusedCellCtrl = focusedRowCtrl == null ? void 0 : focusedRowCtrl.getCellCtrl(column);

          if (focusedCellCtrl == null ? void 0 : focusedCellCtrl.isEditing()) {
            focusedCellCtrl.stopEditing();
          }

          focusService.setFocusedCell({
            column: column,
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            forceBrowserFocus: true,
            preventScrollOnBrowserFocus: true
          });
        }
      }

      if (this.containsWidget(target)) {
        return;
      }

      if (rangeService) {
        var thisCell = this.cellCtrl.getCellPosition();

        if (shiftKey) {
          rangeService.extendLatestRangeToCell(thisCell);
        } else {
          var isMultiKey = ctrlKey || metaKey;
          rangeService.setRangeToCell(thisCell, isMultiKey);
        }
      }

      eventService.dispatchEvent(this.cellCtrl.createEvent(mouseEvent, _Events.EVENT_CELL_MOUSE_DOWN));
    }
  }, {
    key: "isRightClickInExistingRange",
    value: function isRightClickInExistingRange(mouseEvent) {
      var rangeService = this.beans.rangeService;

      if (rangeService) {
        var cellInRange = rangeService.isCellInAnyRange(this.cellCtrl.getCellPosition());
        var isRightClick = mouseEvent.button === 2 || mouseEvent.ctrlKey && this.beans.gos.get("allowContextMenuWithControlKey");

        if (cellInRange && isRightClick) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "containsWidget",
    value: function containsWidget(target) {
      return _isElementChildOfClass(target, "ag-selection-checkbox", 3);
    }
  }, {
    key: "onMouseOut",
    value: function onMouseOut(mouseEvent) {
      if (this.mouseStayingInsideCell(mouseEvent)) {
        return;
      }

      var cellMouseOutEvent = this.cellCtrl.createEvent(mouseEvent, _Events.EVENT_CELL_MOUSE_OUT);
      this.beans.eventService.dispatchEvent(cellMouseOutEvent);
      this.beans.columnHoverService.clearMouseOver();
    }
  }, {
    key: "onMouseOver",
    value: function onMouseOver(mouseEvent) {
      if (this.mouseStayingInsideCell(mouseEvent)) {
        return;
      }

      var cellMouseOverEvent = this.cellCtrl.createEvent(mouseEvent, _Events.EVENT_CELL_MOUSE_OVER);
      this.beans.eventService.dispatchEvent(cellMouseOverEvent);
      this.beans.columnHoverService.setMouseOver([this.column]);
    }
  }, {
    key: "mouseStayingInsideCell",
    value: function mouseStayingInsideCell(e) {
      if (!e.target || !e.relatedTarget) {
        return false;
      }

      var eGui = this.cellCtrl.getGui();
      var cellContainsTarget = eGui.contains(e.target);
      var cellContainsRelatedTarget = eGui.contains(e.relatedTarget);
      return cellContainsTarget && cellContainsRelatedTarget;
    }
  }, {
    key: "destroy",
    value: function destroy() {}
  }]);

  return CellMouseListenerFeature;
}(_Beans); // community-modules/core/src/rendering/cell/cellKeyboardListenerFeature.ts


var CellKeyboardListenerFeature =
/*#__PURE__*/
function (_BeanStub30) {
  "use strict";

  _inherits(CellKeyboardListenerFeature, _BeanStub30);

  function CellKeyboardListenerFeature(ctrl, beans, column, rowNode, rowCtrl) {
    var _this287;

    _classCallCheck(this, CellKeyboardListenerFeature);

    _this287 = _possibleConstructorReturn(this, _getPrototypeOf(CellKeyboardListenerFeature).call(this));
    _this287.cellCtrl = ctrl;
    _this287.beans = beans;
    _this287.rowNode = rowNode;
    _this287.rowCtrl = rowCtrl;
    return _this287;
  }

  _createClass(CellKeyboardListenerFeature, [{
    key: "setComp",
    value: function setComp(eGui) {
      this.eGui = eGui;
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      var key = event.key;

      switch (key) {
        case _KeyCode.ENTER:
          this.onEnterKeyDown(event);
          break;

        case _KeyCode.F2:
          this.onF2KeyDown(event);
          break;

        case _KeyCode.ESCAPE:
          this.onEscapeKeyDown(event);
          break;

        case _KeyCode.TAB:
          this.onTabKeyDown(event);
          break;

        case _KeyCode.BACKSPACE:
        case _KeyCode.DELETE:
          this.onBackspaceOrDeleteKeyDown(key, event);
          break;

        case _KeyCode.DOWN:
        case _KeyCode.UP:
        case _KeyCode.RIGHT:
        case _KeyCode.LEFT:
          this.onNavigationKeyDown(event, key);
          break;
      }
    }
  }, {
    key: "onNavigationKeyDown",
    value: function onNavigationKeyDown(event, key) {
      if (this.cellCtrl.isEditing()) {
        return;
      }

      if (event.shiftKey && this.cellCtrl.isRangeSelectionEnabled()) {
        this.onShiftRangeSelect(event);
      } else {
        this.beans.navigationService.navigateToNextCell(event, key, this.cellCtrl.getCellPosition(), true);
      }

      event.preventDefault();
    }
  }, {
    key: "onShiftRangeSelect",
    value: function onShiftRangeSelect(event) {
      if (!this.beans.rangeService) {
        return;
      }

      var endCell = this.beans.rangeService.extendLatestRangeInDirection(event);

      if (endCell) {
        this.beans.navigationService.ensureCellVisible(endCell);
      }
    }
  }, {
    key: "onTabKeyDown",
    value: function onTabKeyDown(event) {
      this.beans.navigationService.onTabKeyDown(this.cellCtrl, event);
    }
  }, {
    key: "onBackspaceOrDeleteKeyDown",
    value: function onBackspaceOrDeleteKeyDown(key, event) {
      var _a;

      var cellCtrl = this.cellCtrl,
          beans = this.beans,
          rowNode = this.rowNode;
      var gos = beans.gos,
          rangeService = beans.rangeService,
          eventService = beans.eventService;

      if (cellCtrl.isEditing()) {
        return;
      }

      eventService.dispatchEvent({
        type: _Events.EVENT_KEY_SHORTCUT_CHANGED_CELL_START
      });

      if (_isDeleteKey(key, gos.get("enableCellEditingOnBackspace"))) {
        if (rangeService && gos.get("enableRangeSelection")) {
          rangeService.clearCellRangeCellValues({
            dispatchWrapperEvents: true,
            wrapperEventSource: "deleteKey"
          });
        } else if (cellCtrl.isCellEditable()) {
          var column = cellCtrl.getColumn();
          var emptyValue = (_a = this.beans.valueService.parseValue(column, rowNode, "", rowNode.getValueFromValueService(column))) != null ? _a : null;
          rowNode.setDataValue(column, emptyValue, "cellClear");
        }
      } else {
        cellCtrl.startRowOrCellEdit(key, event);
      }

      eventService.dispatchEvent({
        type: _Events.EVENT_KEY_SHORTCUT_CHANGED_CELL_END
      });
    }
  }, {
    key: "onEnterKeyDown",
    value: function onEnterKeyDown(e) {
      if (this.cellCtrl.isEditing() || this.rowCtrl.isEditing()) {
        this.cellCtrl.stopEditingAndFocus(false, e.shiftKey);
      } else {
        if (this.beans.gos.get("enterNavigatesVertically")) {
          var key = e.shiftKey ? _KeyCode.UP : _KeyCode.DOWN;
          this.beans.navigationService.navigateToNextCell(null, key, this.cellCtrl.getCellPosition(), false);
        } else {
          this.cellCtrl.startRowOrCellEdit(_KeyCode.ENTER, e);

          if (this.cellCtrl.isEditing()) {
            e.preventDefault();
          }
        }
      }
    }
  }, {
    key: "onF2KeyDown",
    value: function onF2KeyDown(event) {
      if (!this.cellCtrl.isEditing()) {
        this.cellCtrl.startRowOrCellEdit(_KeyCode.F2, event);
      }
    }
  }, {
    key: "onEscapeKeyDown",
    value: function onEscapeKeyDown(event) {
      if (this.cellCtrl.isEditing()) {
        this.cellCtrl.stopRowOrCellEdit(true);
        this.cellCtrl.focusCell(true);
      }
    }
  }, {
    key: "processCharacter",
    value: function processCharacter(event) {
      var eventTarget = event.target;
      var eventOnChildComponent = eventTarget !== this.eGui;

      if (eventOnChildComponent || this.cellCtrl.isEditing()) {
        return;
      }

      var key = event.key;

      if (key === " ") {
        this.onSpaceKeyDown(event);
      } else {
        this.cellCtrl.startRowOrCellEdit(key, event);
        event.preventDefault();
      }
    }
  }, {
    key: "onSpaceKeyDown",
    value: function onSpaceKeyDown(event) {
      var gos = this.beans.gos;

      if (!this.cellCtrl.isEditing() && gos.isRowSelection()) {
        var currentSelection = this.rowNode.isSelected();
        var newSelection = !currentSelection;

        if (newSelection || !gos.get("suppressRowDeselection")) {
          var groupSelectsFiltered = this.beans.gos.get("groupSelectsFiltered");
          var updatedCount = this.rowNode.setSelectedParams({
            newValue: newSelection,
            rangeSelect: event.shiftKey,
            groupSelectsFiltered: groupSelectsFiltered,
            event: event,
            source: "spaceKey"
          });

          if (currentSelection === void 0 && updatedCount === 0) {
            this.rowNode.setSelectedParams({
              newValue: false,
              rangeSelect: event.shiftKey,
              groupSelectsFiltered: groupSelectsFiltered,
              event: event,
              source: "spaceKey"
            });
          }
        }
      }

      event.preventDefault();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(CellKeyboardListenerFeature.prototype), "destroy", this).call(this);
    }
  }]);

  return CellKeyboardListenerFeature;
}(_BeanStub2); // community-modules/core/src/rendering/dndSourceComp.ts


var DndSourceComp =
/*#__PURE__*/
function (_Component26) {
  "use strict";

  _inherits(DndSourceComp, _Component26);

  function DndSourceComp(rowNode, column, eCell) {
    var _this288;

    _classCallCheck(this, DndSourceComp);

    _this288 = _possibleConstructorReturn(this, _getPrototypeOf(DndSourceComp).call(this,
    /* html */
    "<div class=\"ag-drag-handle ag-row-drag\" draggable=\"true\"></div>"));
    _this288.rowNode = rowNode;
    _this288.column = column;
    _this288.eCell = eCell;
    return _this288;
  }

  _createClass(DndSourceComp, [{
    key: "postConstruct",
    value: function postConstruct() {
      var eGui = this.getGui();
      eGui.appendChild(_createIconNoSpan("rowDrag", this.gos, null));
      this.addGuiEventListener("mousedown", function (e) {
        e.stopPropagation();
      });
      this.addDragSource();
      this.checkVisibility();
    }
  }, {
    key: "addDragSource",
    value: function addDragSource() {
      this.addGuiEventListener("dragstart", this.onDragStart.bind(this));
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(dragEvent) {
      var _this289 = this;

      var providedOnRowDrag = this.column.getColDef().dndSourceOnRowDrag;
      dragEvent.dataTransfer.setDragImage(this.eCell, 0, 0);

      var defaultOnRowDrag = function defaultOnRowDrag() {
        try {
          var jsonData = JSON.stringify(_this289.rowNode.data);
          dragEvent.dataTransfer.setData("application/json", jsonData);
          dragEvent.dataTransfer.setData("text/plain", jsonData);
        } catch (e) {}
      };

      if (providedOnRowDrag) {
        var params = this.gos.addGridCommonParams({
          rowNode: this.rowNode,
          dragEvent: dragEvent
        });
        providedOnRowDrag(params);
      } else {
        defaultOnRowDrag();
      }
    }
  }, {
    key: "checkVisibility",
    value: function checkVisibility() {
      var visible = this.column.isDndSource(this.rowNode);
      this.setDisplayed(visible);
    }
  }]);

  return DndSourceComp;
}(_Component2);

__decorateClass([_PostConstruct], DndSourceComp.prototype, "postConstruct", 1); // community-modules/core/src/headerRendering/cells/cssClassApplier.ts


var CSS_FIRST_COLUMN = "ag-column-first";
var CSS_LAST_COLUMN = "ag-column-last";

var _CssClassApplier =
/*#__PURE__*/
function () {
  "use strict";

  function _CssClassApplier() {
    _classCallCheck(this, _CssClassApplier);
  }

  _createClass(_CssClassApplier, null, [{
    key: "getHeaderClassesFromColDef",
    value: function getHeaderClassesFromColDef(abstractColDef, gos, column, columnGroup) {
      if (_missing(abstractColDef)) {
        return [];
      }

      return this.getColumnClassesFromCollDef(abstractColDef.headerClass, abstractColDef, gos, column, columnGroup);
    }
  }, {
    key: "getToolPanelClassesFromColDef",
    value: function getToolPanelClassesFromColDef(abstractColDef, gos, column, columnGroup) {
      if (_missing(abstractColDef)) {
        return [];
      }

      return this.getColumnClassesFromCollDef(abstractColDef.toolPanelClass, abstractColDef, gos, column, columnGroup);
    }
  }, {
    key: "refreshFirstAndLastStyles",
    value: function refreshFirstAndLastStyles(comp, column, columnModel) {
      comp.addOrRemoveCssClass(CSS_FIRST_COLUMN, columnModel.isColumnAtEdge(column, "first"));
      comp.addOrRemoveCssClass(CSS_LAST_COLUMN, columnModel.isColumnAtEdge(column, "last"));
    }
  }, {
    key: "getClassParams",
    value: function getClassParams(abstractColDef, gos, column, columnGroup) {
      return gos.addGridCommonParams({
        // bad naming, as colDef here can be a group or a column,
        // however most people won't appreciate the difference,
        // so keeping it as colDef to avoid confusion.
        colDef: abstractColDef,
        column: column,
        columnGroup: columnGroup
      });
    }
  }, {
    key: "getColumnClassesFromCollDef",
    value: function getColumnClassesFromCollDef(classesOrFunc, abstractColDef, gos, column, columnGroup) {
      if (_missing(classesOrFunc)) {
        return [];
      }

      var classToUse;

      if (typeof classesOrFunc === "function") {
        var params = this.getClassParams(abstractColDef, gos, column, columnGroup);
        classToUse = classesOrFunc(params);
      } else {
        classToUse = classesOrFunc;
      }

      if (typeof classToUse === "string") {
        return [classToUse];
      }

      if (Array.isArray(classToUse)) {
        return _toConsumableArray(classToUse);
      }

      return [];
    }
  }]);

  return _CssClassApplier;
}(); // community-modules/core/src/rendering/cell/cellCtrl.ts


var CSS_CELL = "ag-cell";
var CSS_AUTO_HEIGHT = "ag-cell-auto-height";
var CSS_NORMAL_HEIGHT = "ag-cell-normal-height";
var CSS_CELL_FOCUS = "ag-cell-focus";
var CSS_CELL_FIRST_RIGHT_PINNED = "ag-cell-first-right-pinned";
var CSS_CELL_LAST_LEFT_PINNED = "ag-cell-last-left-pinned";
var CSS_CELL_NOT_INLINE_EDITING = "ag-cell-not-inline-editing";
var CSS_COLUMN_HOVER = "ag-column-hover";
var CSS_CELL_WRAP_TEXT = "ag-cell-wrap-text";
var instanceIdSequence2 = 0;

var _CellCtrl =
/*#__PURE__*/
function (_BeanStub31) {
  "use strict";

  _inherits(_CellCtrl, _BeanStub31);

  function _CellCtrl(column, rowNode, beans, rowCtrl) {
    var _this290;

    _classCallCheck(this, _CellCtrl);

    _this290 = _possibleConstructorReturn(this, _getPrototypeOf(_CellCtrl).call(this));
    _this290.cellRangeFeature = null;
    _this290.cellPositionFeature = null;
    _this290.cellCustomStyleFeature = null;
    _this290.tooltipFeature = null;
    _this290.cellMouseListenerFeature = null;
    _this290.cellKeyboardListenerFeature = null;
    _this290.suppressRefreshCell = false;
    _this290.onCellCompAttachedFuncs = [];
    _this290.column = column;
    _this290.rowNode = rowNode;
    _this290.beans = beans;
    _this290.rowCtrl = rowCtrl;
    _this290.instanceId = column.getId() + "-" + instanceIdSequence2++;
    _this290.colIdSanitised = _escapeString(_this290.column.getId());

    if (!beans.gos.get("suppressCellFocus")) {
      _this290.tabIndex = -1;
    }

    _this290.createCellPosition();

    _this290.addFeatures();

    _this290.updateAndFormatValue(false);

    return _this290;
  }

  _createClass(_CellCtrl, [{
    key: "shouldRestoreFocus",
    value: function shouldRestoreFocus() {
      return this.beans.focusService.shouldRestoreFocus(this.cellPosition);
    }
  }, {
    key: "addFeatures",
    value: function addFeatures() {
      var _this291 = this;

      this.cellPositionFeature = new CellPositionFeature(this, this.beans);
      this.addDestroyFunc(function () {
        var _a;

        (_a = _this291.cellPositionFeature) == null ? void 0 : _a.destroy();
        _this291.cellPositionFeature = null;
      });
      this.cellCustomStyleFeature = new CellCustomStyleFeature(this, this.beans);
      this.addDestroyFunc(function () {
        var _a;

        (_a = _this291.cellCustomStyleFeature) == null ? void 0 : _a.destroy();
        _this291.cellCustomStyleFeature = null;
      });
      this.cellMouseListenerFeature = new CellMouseListenerFeature(this, this.beans, this.column);
      this.addDestroyFunc(function () {
        var _a;

        (_a = _this291.cellMouseListenerFeature) == null ? void 0 : _a.destroy();
        _this291.cellMouseListenerFeature = null;
      });
      this.cellKeyboardListenerFeature = new CellKeyboardListenerFeature(this, this.beans, this.column, this.rowNode, this.rowCtrl);
      this.addDestroyFunc(function () {
        var _a;

        (_a = _this291.cellKeyboardListenerFeature) == null ? void 0 : _a.destroy();
        _this291.cellKeyboardListenerFeature = null;
      });

      if (this.column.isTooltipEnabled()) {
        this.enableTooltipFeature();
        this.addDestroyFunc(function () {
          _this291.disableTooltipFeature();
        });
      }

      var rangeSelectionEnabled = this.beans.rangeService && this.beans.gos.get("enableRangeSelection");

      if (rangeSelectionEnabled) {
        this.cellRangeFeature = new CellRangeFeature(this.beans, this);
        this.addDestroyFunc(function () {
          var _a;

          (_a = _this291.cellRangeFeature) == null ? void 0 : _a.destroy();
          _this291.cellRangeFeature = null;
        });
      }
    }
  }, {
    key: "enableTooltipFeature",
    value: function enableTooltipFeature(value, shouldDisplayTooltip) {
      var _this292 = this;

      var getTooltipValue = function getTooltipValue() {
        var colDef = _this292.column.getColDef();

        var data = _this292.rowNode.data;

        if (colDef.tooltipField && _exists(data)) {
          return _getValueUsingField(data, colDef.tooltipField, _this292.column.isTooltipFieldContainsDots());
        }

        var valueGetter = colDef.tooltipValueGetter;

        if (valueGetter) {
          return valueGetter(_this292.beans.gos.addGridCommonParams({
            location: "cell",
            colDef: _this292.column.getColDef(),
            column: _this292.column,
            rowIndex: _this292.cellPosition.rowIndex,
            node: _this292.rowNode,
            data: _this292.rowNode.data,
            value: _this292.value,
            valueFormatted: _this292.valueFormatted
          }));
        }

        return null;
      };

      var isTooltipWhenTruncated = this.beans.gos.get("tooltipShowMode") === "whenTruncated";

      if (!shouldDisplayTooltip && isTooltipWhenTruncated && !this.isCellRenderer()) {
        shouldDisplayTooltip = function shouldDisplayTooltip() {
          var eGui = _this292.getGui();

          var textEl = eGui.children.length === 0 ? eGui : eGui.querySelector(".ag-cell-value");

          if (!textEl) {
            return true;
          }

          return textEl.scrollWidth > textEl.clientWidth;
        };
      }

      var tooltipCtrl = {
        getColumn: function getColumn() {
          return _this292.column;
        },
        getColDef: function getColDef() {
          return _this292.column.getColDef();
        },
        getRowIndex: function getRowIndex() {
          return _this292.cellPosition.rowIndex;
        },
        getRowNode: function getRowNode() {
          return _this292.rowNode;
        },
        getGui: function getGui() {
          return _this292.getGui();
        },
        getLocation: function getLocation() {
          return "cell";
        },
        getTooltipValue: value != null ? function () {
          return value;
        } : getTooltipValue,
        // this makes no sense, why is the cell formatted value passed to the tooltip???
        getValueFormatted: function getValueFormatted() {
          return _this292.valueFormatted;
        },
        shouldDisplayTooltip: shouldDisplayTooltip
      };
      this.tooltipFeature = new _TooltipFeature(tooltipCtrl, this.beans);
    }
  }, {
    key: "disableTooltipFeature",
    value: function disableTooltipFeature() {
      if (!this.tooltipFeature) {
        return;
      }

      this.tooltipFeature.destroy();
      this.tooltipFeature = null;
    }
  }, {
    key: "setComp",
    value: function setComp(comp, eGui, eCellWrapper, printLayout, startEditing) {
      var _a, _b, _c, _d;

      this.cellComp = comp;
      this.eGui = eGui;
      this.printLayout = printLayout;
      this.addDomData();
      this.onCellFocused(this.focusEventToRestore);
      this.applyStaticCssClasses();
      this.setWrapText();
      this.onFirstRightPinnedChanged();
      this.onLastLeftPinnedChanged();
      this.onColumnHover();
      this.setupControlComps();
      this.setupAutoHeight(eCellWrapper);
      this.refreshFirstAndLastStyles();
      this.refreshAriaColIndex();
      (_a = this.cellPositionFeature) == null ? void 0 : _a.setComp(eGui);
      (_b = this.cellCustomStyleFeature) == null ? void 0 : _b.setComp(comp);
      (_c = this.tooltipFeature) == null ? void 0 : _c.refreshToolTip();
      (_d = this.cellKeyboardListenerFeature) == null ? void 0 : _d.setComp(this.eGui);

      if (this.cellRangeFeature) {
        this.cellRangeFeature.setComp(comp, eGui);
      }

      if (startEditing && this.isCellEditable()) {
        this.startEditing();
      } else {
        this.showValue();
      }

      if (this.onCellCompAttachedFuncs.length) {
        this.onCellCompAttachedFuncs.forEach(function (func) {
          return func();
        });
        this.onCellCompAttachedFuncs = [];
      }
    }
  }, {
    key: "setupAutoHeight",
    value: function setupAutoHeight(eCellWrapper) {
      var _this293 = this;

      this.isAutoHeight = this.column.isAutoHeight();

      if (!this.isAutoHeight || !eCellWrapper) {
        return;
      }

      var eParentCell = eCellWrapper.parentElement;
      var minRowHeight = this.beans.gos.getRowHeightForNode(this.rowNode).height;

      var measureHeight = function measureHeight(timesCalled) {
        if (_this293.editing) {
          return;
        }

        if (!_this293.isAlive()) {
          return;
        }

        var _getElementSize3 = _getElementSize(eParentCell),
            paddingTop = _getElementSize3.paddingTop,
            paddingBottom = _getElementSize3.paddingBottom,
            borderBottomWidth = _getElementSize3.borderBottomWidth,
            borderTopWidth = _getElementSize3.borderTopWidth;

        var extraHeight = paddingTop + paddingBottom + borderBottomWidth + borderTopWidth;
        var wrapperHeight = eCellWrapper.offsetHeight;
        var autoHeight = wrapperHeight + extraHeight;

        if (timesCalled < 5) {
          var doc = _this293.beans.gos.getDocument();

          var notYetInDom = !doc || !doc.contains(eCellWrapper);
          var possiblyNoContentYet = autoHeight == 0;

          if (notYetInDom || possiblyNoContentYet) {
            window.setTimeout(function () {
              return measureHeight(timesCalled + 1);
            }, 0);
            return;
          }
        }

        var newHeight = Math.max(autoHeight, minRowHeight);

        _this293.rowNode.setRowAutoHeight(newHeight, _this293.column);
      };

      var listener = function listener() {
        return measureHeight(0);
      };

      listener();
      var destroyResizeObserver = this.beans.resizeObserverService.observeResize(eCellWrapper, listener);
      this.addDestroyFunc(function () {
        destroyResizeObserver();

        _this293.rowNode.setRowAutoHeight(void 0, _this293.column);
      });
    }
  }, {
    key: "getCellAriaRole",
    value: function getCellAriaRole() {
      var _a;

      return (_a = this.column.getColDef().cellAriaRole) != null ? _a : "gridcell";
    }
  }, {
    key: "getInstanceId",
    value: function getInstanceId() {
      return this.instanceId;
    }
  }, {
    key: "getColumnIdSanitised",
    value: function getColumnIdSanitised() {
      return this.colIdSanitised;
    }
  }, {
    key: "getTabIndex",
    value: function getTabIndex() {
      return this.tabIndex;
    }
  }, {
    key: "isCellRenderer",
    value: function isCellRenderer() {
      var colDef = this.column.getColDef();
      return colDef.cellRenderer != null || colDef.cellRendererSelector != null;
    }
  }, {
    key: "getValueToDisplay",
    value: function getValueToDisplay() {
      var _a;

      return (_a = this.valueFormatted) != null ? _a : this.value;
    }
  }, {
    key: "showValue",
    value: function showValue() {
      var forceNewCellRendererInstance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var _a;

      var valueToDisplay = this.getValueToDisplay();
      var compDetails;

      if (this.rowNode.stub) {
        var params = this.createCellRendererParams();
        compDetails = this.beans.userComponentFactory.getLoadingCellRendererDetails(this.column.getColDef(), params);
      } else if (this.isCellRenderer()) {
        var _params = this.createCellRendererParams();

        compDetails = this.beans.userComponentFactory.getCellRendererDetails(this.column.getColDef(), _params);
      }

      this.cellComp.setRenderDetails(compDetails, valueToDisplay, forceNewCellRendererInstance);
      (_a = this.cellRangeFeature) == null ? void 0 : _a.refreshHandle();
    }
  }, {
    key: "setupControlComps",
    value: function setupControlComps() {
      var colDef = this.column.getColDef();
      this.includeSelection = this.isIncludeControl(colDef.checkboxSelection);
      this.includeRowDrag = this.isIncludeControl(colDef.rowDrag);
      this.includeDndSource = this.isIncludeControl(colDef.dndSource);
      this.cellComp.setIncludeSelection(this.includeSelection);
      this.cellComp.setIncludeDndSource(this.includeDndSource);
      this.cellComp.setIncludeRowDrag(this.includeRowDrag);
    }
  }, {
    key: "isForceWrapper",
    value: function isForceWrapper() {
      var forceWrapper = this.beans.gos.get("enableCellTextSelection") || this.column.isAutoHeight();
      return forceWrapper;
    }
  }, {
    key: "isIncludeControl",
    value: function isIncludeControl(value) {
      var rowNodePinned = this.rowNode.rowPinned != null;
      var isFunc = typeof value === "function";
      var res = rowNodePinned ? false : isFunc || value === true;
      return res;
    }
  }, {
    key: "refreshShouldDestroy",
    value: function refreshShouldDestroy() {
      var colDef = this.column.getColDef();
      var selectionChanged = this.includeSelection != this.isIncludeControl(colDef.checkboxSelection);
      var rowDragChanged = this.includeRowDrag != this.isIncludeControl(colDef.rowDrag);
      var dndSourceChanged = this.includeDndSource != this.isIncludeControl(colDef.dndSource);
      var autoHeightChanged = this.isAutoHeight != this.column.isAutoHeight();
      return selectionChanged || rowDragChanged || dndSourceChanged || autoHeightChanged;
    } // either called internally if single cell editing, or called by rowRenderer if row editing

  }, {
    key: "startEditing",
    value: function startEditing() {
      var _this294 = this;

      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var cellStartedEdit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var event = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (!this.isCellEditable() || this.editing) {
        return;
      }

      if (!this.cellComp) {
        this.onCellCompAttachedFuncs.push(function () {
          _this294.startEditing(key, cellStartedEdit, event);
        });
        return;
      }

      var editorParams = this.createCellEditorParams(key, cellStartedEdit);
      var colDef = this.column.getColDef();
      var compDetails = this.beans.userComponentFactory.getCellEditorDetails(colDef, editorParams);
      this.editCompDetails = compDetails;
      var popup = (compDetails == null ? void 0 : compDetails.popupFromSelector) != null ? compDetails.popupFromSelector : !!colDef.cellEditorPopup;
      var position = (compDetails == null ? void 0 : compDetails.popupPositionFromSelector) != null ? compDetails.popupPositionFromSelector : colDef.cellEditorPopupPosition;
      this.setEditing(true);
      this.cellComp.setEditDetails(compDetails, popup, position, this.beans.gos.get("reactiveCustomComponents"));
      var e = this.createEvent(event, _Events.EVENT_CELL_EDITING_STARTED);
      this.beans.eventService.dispatchEvent(e);
    }
  }, {
    key: "setEditing",
    value: function setEditing(editing) {
      var _a;

      if (this.editing === editing) {
        return;
      }

      this.editing = editing;
      (_a = this.cellRangeFeature) == null ? void 0 : _a.refreshHandle();
    } // pass in 'true' to cancel the editing.

  }, {
    key: "stopRowOrCellEdit",
    value: function stopRowOrCellEdit() {
      var cancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.beans.gos.get("editType") === "fullRow") {
        this.rowCtrl.stopEditing(cancel);
      } else {
        this.stopEditing(cancel);
      }
    }
  }, {
    key: "onPopupEditorClosed",
    value: function onPopupEditorClosed() {
      if (!this.isEditing()) {
        return;
      }

      this.stopEditingAndFocus();
    }
  }, {
    key: "takeValueFromCellEditor",
    value: function takeValueFromCellEditor(cancel) {
      var noValueResult = {
        newValueExists: false
      };

      if (cancel) {
        return noValueResult;
      }

      var cellEditor = this.cellComp.getCellEditor();

      if (!cellEditor) {
        return noValueResult;
      }

      var userWantsToCancel = cellEditor.isCancelAfterEnd && cellEditor.isCancelAfterEnd();

      if (userWantsToCancel) {
        return noValueResult;
      }

      var newValue = cellEditor.getValue();
      return {
        newValue: newValue,
        newValueExists: true
      };
    }
    /**
     * @returns `True` if the value changes, otherwise `False`.
     */

  }, {
    key: "saveNewValue",
    value: function saveNewValue(oldValue, newValue) {
      if (newValue === oldValue) {
        return false;
      }

      this.suppressRefreshCell = true;
      var valueChanged = this.rowNode.setDataValue(this.column, newValue, "edit");
      this.suppressRefreshCell = false;
      return valueChanged;
    }
    /**
     * Ends the Cell Editing
     * @param cancel `True` if the edit process is being canceled.
     * @returns `True` if the value of the `GridCell` has been updated, otherwise `False`.
     */

  }, {
    key: "stopEditing",
    value: function stopEditing() {
      var cancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.editing) {
        return false;
      }

      var _this$takeValueFromCe = this.takeValueFromCellEditor(cancel),
          newValue = _this$takeValueFromCe.newValue,
          newValueExists = _this$takeValueFromCe.newValueExists;

      var oldValue = this.rowNode.getValueFromValueService(this.column);
      var valueChanged = false;

      if (newValueExists) {
        valueChanged = this.saveNewValue(oldValue, newValue);
      }

      this.setEditing(false);
      this.cellComp.setEditDetails();
      this.editCompDetails = void 0;
      this.updateAndFormatValue(false);
      this.refreshCell({
        forceRefresh: true,
        suppressFlash: true
      });
      this.dispatchEditingStoppedEvent(oldValue, newValue, !cancel && !!valueChanged);
      return valueChanged;
    }
  }, {
    key: "dispatchEditingStoppedEvent",
    value: function dispatchEditingStoppedEvent(oldValue, newValue, valueChanged) {
      var editingStoppedEvent = __spreadProps(__spreadValues({}, this.createEvent(null, _Events.EVENT_CELL_EDITING_STOPPED)), {
        oldValue: oldValue,
        newValue: newValue,
        valueChanged: valueChanged
      });

      this.beans.eventService.dispatchEvent(editingStoppedEvent);
    }
  }, {
    key: "createCellEditorParams",
    value: function createCellEditorParams(key, cellStartedEdit) {
      return this.beans.gos.addGridCommonParams({
        value: this.rowNode.getValueFromValueService(this.column),
        eventKey: key,
        column: this.column,
        colDef: this.column.getColDef(),
        rowIndex: this.getCellPosition().rowIndex,
        node: this.rowNode,
        data: this.rowNode.data,
        cellStartedEdit: cellStartedEdit,
        onKeyDown: this.onKeyDown.bind(this),
        stopEditing: this.stopEditingAndFocus.bind(this),
        eGridCell: this.getGui(),
        parseValue: this.parseValue.bind(this),
        formatValue: this.formatValue.bind(this)
      });
    }
  }, {
    key: "createCellRendererParams",
    value: function createCellRendererParams() {
      var _this295 = this;

      var res = this.beans.gos.addGridCommonParams({
        value: this.value,
        valueFormatted: this.valueFormatted,
        getValue: function getValue() {
          return _this295.rowNode.getValueFromValueService(_this295.column);
        },
        setValue: function setValue(value) {
          return _this295.beans.valueService.setValue(_this295.rowNode, _this295.column, value);
        },
        formatValue: this.formatValue.bind(this),
        data: this.rowNode.data,
        node: this.rowNode,
        pinned: this.column.getPinned(),
        colDef: this.column.getColDef(),
        column: this.column,
        rowIndex: this.getCellPosition().rowIndex,
        refreshCell: this.refreshCell.bind(this),
        eGridCell: this.getGui(),
        eParentOfValue: this.cellComp.getParentOfValue(),
        registerRowDragger: function registerRowDragger(rowDraggerElement, dragStartPixels, value, suppressVisibilityChange) {
          return _this295.registerRowDragger(rowDraggerElement, dragStartPixels, suppressVisibilityChange);
        },
        setTooltip: function setTooltip(value, shouldDisplayTooltip) {
          var _a;

          if (_this295.tooltipFeature) {
            _this295.disableTooltipFeature();
          }

          _this295.enableTooltipFeature(value, shouldDisplayTooltip);

          (_a = _this295.tooltipFeature) == null ? void 0 : _a.refreshToolTip();
        }
      });
      return res;
    }
  }, {
    key: "parseValue",
    value: function parseValue(newValue) {
      return this.beans.valueService.parseValue(this.column, this.rowNode, newValue, this.getValue());
    }
  }, {
    key: "setFocusOutOnEditor",
    value: function setFocusOutOnEditor() {
      if (!this.editing) {
        return;
      }

      var cellEditor = this.cellComp.getCellEditor();

      if (cellEditor && cellEditor.focusOut) {
        cellEditor.focusOut();
      }
    }
  }, {
    key: "setFocusInOnEditor",
    value: function setFocusInOnEditor() {
      if (!this.editing) {
        return;
      }

      var cellEditor = this.cellComp.getCellEditor();

      if (cellEditor && cellEditor.focusIn) {
        cellEditor.focusIn();
      } else {
        this.focusCell(true);
      }
    }
  }, {
    key: "onCellChanged",
    value: function onCellChanged(event) {
      var eventImpactsThisCell = event.column === this.column;

      if (eventImpactsThisCell) {
        this.refreshCell({});
      }
    }
  }, {
    key: "refreshOrDestroyCell",
    value: function refreshOrDestroyCell(params) {
      var _a;

      if (this.refreshShouldDestroy()) {
        (_a = this.rowCtrl) == null ? void 0 : _a.recreateCell(this);
      } else {
        this.refreshCell(params);
      }
    } // + stop editing {forceRefresh: true, suppressFlash: true}
    // + event cellChanged {}
    // + cellRenderer.params.refresh() {} -> method passes 'as is' to the cellRenderer, so params could be anything
    // + rowCtrl: event dataChanged {suppressFlash: !update, newData: !update}
    // + rowCtrl: api refreshCells() {animate: true/false}
    // + rowRenderer: api softRefreshView() {}

  }, {
    key: "refreshCell",
    value: function refreshCell(params) {
      var _a, _b, _c, _d;

      if (this.suppressRefreshCell || this.editing) {
        return;
      }

      var colDef = this.column.getColDef();
      var newData = params != null && !!params.newData;
      var suppressFlash = params != null && !!params.suppressFlash || !!colDef.suppressCellFlash;
      var noValueProvided = colDef.field == null && colDef.valueGetter == null && colDef.showRowGroup == null;
      var forceRefresh = params && params.forceRefresh || noValueProvided || newData;
      var isCellCompReady = !!this.cellComp;
      var valuesDifferent = this.updateAndFormatValue(isCellCompReady);
      var dataNeedsUpdating = forceRefresh || valuesDifferent;

      if (!isCellCompReady) {
        return;
      }

      if (dataNeedsUpdating) {
        this.showValue(newData);
        var processingFilterChange = this.beans.filterManager.isSuppressFlashingCellsBecauseFiltering();
        var flashCell = !suppressFlash && !processingFilterChange && (this.beans.gos.get("enableCellChangeFlash") || colDef.enableCellChangeFlash);

        if (flashCell) {
          this.flashCell();
        }

        (_a = this.cellCustomStyleFeature) == null ? void 0 : _a.applyUserStyles();
        (_b = this.cellCustomStyleFeature) == null ? void 0 : _b.applyClassesFromColDef();
      }

      (_c = this.tooltipFeature) == null ? void 0 : _c.refreshToolTip();
      (_d = this.cellCustomStyleFeature) == null ? void 0 : _d.applyCellClassRules();
    } // cell editors call this, when they want to stop for reasons other
    // than what we pick up on. eg selecting from a dropdown ends editing.

  }, {
    key: "stopEditingAndFocus",
    value: function stopEditingAndFocus() {
      var suppressNavigateAfterEdit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var shiftKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.stopRowOrCellEdit();
      this.focusCell(true);

      if (!suppressNavigateAfterEdit) {
        this.navigateAfterEdit(shiftKey);
      }
    }
  }, {
    key: "navigateAfterEdit",
    value: function navigateAfterEdit(shiftKey) {
      var enterNavigatesVerticallyAfterEdit = this.beans.gos.get("enterNavigatesVerticallyAfterEdit");

      if (enterNavigatesVerticallyAfterEdit) {
        var key = shiftKey ? _KeyCode.UP : _KeyCode.DOWN;
        this.beans.navigationService.navigateToNextCell(null, key, this.getCellPosition(), false);
      }
    } // user can also call this via API

  }, {
    key: "flashCell",
    value: function flashCell(delays) {
      var _a, _b;

      var flashDuration = (_a = delays == null ? void 0 : delays.flashDuration) != null ? _a : delays == null ? void 0 : delays.flashDelay;
      var fadeDuration = (_b = delays == null ? void 0 : delays.fadeDuration) != null ? _b : delays == null ? void 0 : delays.fadeDelay;
      this.animateCell("data-changed", flashDuration, fadeDuration);
    }
  }, {
    key: "animateCell",
    value: function animateCell(cssName, flashDuration, fadeDuration) {
      var _this296 = this;

      if (!this.cellComp) {
        return;
      }

      var fullName = "ag-cell-".concat(cssName);
      var animationFullName = "ag-cell-".concat(cssName, "-animation");
      var gos = this.beans.gos;

      if (!flashDuration) {
        flashDuration = gos.get("cellFlashDuration");
      }

      if (!_exists(fadeDuration)) {
        fadeDuration = gos.get("cellFadeDuration");
      }

      this.cellComp.addOrRemoveCssClass(fullName, true);
      this.cellComp.addOrRemoveCssClass(animationFullName, false);
      this.beans.frameworkOverrides.wrapIncoming(function () {
        window.setTimeout(function () {
          if (!_this296.isAlive()) {
            return;
          }

          _this296.cellComp.addOrRemoveCssClass(fullName, false);

          _this296.cellComp.addOrRemoveCssClass(animationFullName, true);

          _this296.eGui.style.transition = "background-color ".concat(fadeDuration, "ms");
          window.setTimeout(function () {
            if (!_this296.isAlive()) {
              return;
            }

            _this296.cellComp.addOrRemoveCssClass(animationFullName, false);

            _this296.eGui.style.transition = "";
          }, fadeDuration);
        }, flashDuration);
      });
    }
  }, {
    key: "onFlashCells",
    value: function onFlashCells(event) {
      if (!this.cellComp) {
        return;
      }

      var cellId = this.beans.cellPositionUtils.createId(this.getCellPosition());
      var shouldFlash = event.cells[cellId];

      if (shouldFlash) {
        this.animateCell("highlight");
      }
    }
  }, {
    key: "isCellEditable",
    value: function isCellEditable() {
      return this.column.isCellEditable(this.rowNode);
    }
  }, {
    key: "isSuppressFillHandle",
    value: function isSuppressFillHandle() {
      return this.column.isSuppressFillHandle();
    }
  }, {
    key: "formatValue",
    value: function formatValue(value) {
      var _a;

      return (_a = this.callValueFormatter(value)) != null ? _a : value;
    }
  }, {
    key: "callValueFormatter",
    value: function callValueFormatter(value) {
      return this.beans.valueService.formatValue(this.column, this.rowNode, value);
    }
  }, {
    key: "updateAndFormatValue",
    value: function updateAndFormatValue(compareValues) {
      var oldValue = this.value;
      var oldValueFormatted = this.valueFormatted;
      this.value = this.rowNode.getValueFromValueService(this.column);
      this.valueFormatted = this.callValueFormatter(this.value);

      if (compareValues) {
        return !this.valuesAreEqual(oldValue, this.value) || this.valueFormatted != oldValueFormatted;
      }

      return true;
    }
  }, {
    key: "valuesAreEqual",
    value: function valuesAreEqual(val1, val2) {
      var colDef = this.column.getColDef();
      return colDef.equals ? colDef.equals(val1, val2) : val1 === val2;
    }
  }, {
    key: "getComp",
    value: function getComp() {
      return this.cellComp;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "addDomData",
    value: function addDomData() {
      var _this297 = this;

      var element = this.getGui();
      this.beans.gos.setDomData(element, _CellCtrl.DOM_DATA_KEY_CELL_CTRL, this);
      this.addDestroyFunc(function () {
        return _this297.beans.gos.setDomData(element, _CellCtrl.DOM_DATA_KEY_CELL_CTRL, null);
      });
    }
  }, {
    key: "createEvent",
    value: function createEvent(domEvent, eventType) {
      var event = this.beans.gos.addGridCommonParams({
        type: eventType,
        node: this.rowNode,
        data: this.rowNode.data,
        value: this.value,
        column: this.column,
        colDef: this.column.getColDef(),
        rowPinned: this.rowNode.rowPinned,
        event: domEvent,
        rowIndex: this.rowNode.rowIndex
      });
      return event;
    }
  }, {
    key: "processCharacter",
    value: function processCharacter(event) {
      var _a;

      (_a = this.cellKeyboardListenerFeature) == null ? void 0 : _a.processCharacter(event);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      var _a;

      (_a = this.cellKeyboardListenerFeature) == null ? void 0 : _a.onKeyDown(event);
    }
  }, {
    key: "onMouseEvent",
    value: function onMouseEvent(eventName, mouseEvent) {
      var _a;

      (_a = this.cellMouseListenerFeature) == null ? void 0 : _a.onMouseEvent(eventName, mouseEvent);
    }
  }, {
    key: "getGui",
    value: function getGui() {
      return this.eGui;
    }
  }, {
    key: "getColSpanningList",
    value: function getColSpanningList() {
      return this.cellPositionFeature.getColSpanningList();
    }
  }, {
    key: "onLeftChanged",
    value: function onLeftChanged() {
      var _a;

      if (!this.cellComp) {
        return;
      }

      (_a = this.cellPositionFeature) == null ? void 0 : _a.onLeftChanged();
    }
  }, {
    key: "onDisplayedColumnsChanged",
    value: function onDisplayedColumnsChanged() {
      if (!this.eGui) {
        return;
      }

      this.refreshAriaColIndex();
      this.refreshFirstAndLastStyles();
    }
  }, {
    key: "refreshFirstAndLastStyles",
    value: function refreshFirstAndLastStyles() {
      var cellComp = this.cellComp,
          column = this.column,
          beans = this.beans;

      _CssClassApplier.refreshFirstAndLastStyles(cellComp, column, beans.columnModel);
    }
  }, {
    key: "refreshAriaColIndex",
    value: function refreshAriaColIndex() {
      var colIdx = this.beans.columnModel.getAriaColumnIndex(this.column);

      _setAriaColIndex(this.getGui(), colIdx);
    }
  }, {
    key: "isSuppressNavigable",
    value: function isSuppressNavigable() {
      return this.column.isSuppressNavigable(this.rowNode);
    }
  }, {
    key: "onWidthChanged",
    value: function onWidthChanged() {
      var _a;

      return (_a = this.cellPositionFeature) == null ? void 0 : _a.onWidthChanged();
    }
  }, {
    key: "getColumn",
    value: function getColumn() {
      return this.column;
    }
  }, {
    key: "getRowNode",
    value: function getRowNode() {
      return this.rowNode;
    }
  }, {
    key: "isPrintLayout",
    value: function isPrintLayout() {
      return this.printLayout;
    }
  }, {
    key: "getCellPosition",
    value: function getCellPosition() {
      return this.cellPosition;
    }
  }, {
    key: "isEditing",
    value: function isEditing() {
      return this.editing;
    } // called by rowRenderer when user navigates via tab key

  }, {
    key: "startRowOrCellEdit",
    value: function startRowOrCellEdit(key) {
      var _this298 = this;

      var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!this.cellComp) {
        this.onCellCompAttachedFuncs.push(function () {
          _this298.startRowOrCellEdit(key, event);
        });
        return;
      }

      if (this.beans.gos.get("editType") === "fullRow") {
        this.rowCtrl.startRowEditing(key, this);
      } else {
        this.startEditing(key, true, event);
      }
    }
  }, {
    key: "getRowCtrl",
    value: function getRowCtrl() {
      return this.rowCtrl;
    }
  }, {
    key: "getRowPosition",
    value: function getRowPosition() {
      return {
        rowIndex: this.cellPosition.rowIndex,
        rowPinned: this.cellPosition.rowPinned
      };
    }
  }, {
    key: "updateRangeBordersIfRangeCount",
    value: function updateRangeBordersIfRangeCount() {
      if (!this.cellComp) {
        return;
      }

      if (this.cellRangeFeature) {
        this.cellRangeFeature.updateRangeBordersIfRangeCount();
      }
    }
  }, {
    key: "onRangeSelectionChanged",
    value: function onRangeSelectionChanged() {
      if (!this.cellComp) {
        return;
      }

      if (this.cellRangeFeature) {
        this.cellRangeFeature.onRangeSelectionChanged();
      }
    }
  }, {
    key: "isRangeSelectionEnabled",
    value: function isRangeSelectionEnabled() {
      return this.cellRangeFeature != null;
    }
  }, {
    key: "focusCell",
    value: function focusCell() {
      var forceBrowserFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.beans.focusService.setFocusedCell({
        rowIndex: this.getCellPosition().rowIndex,
        column: this.column,
        rowPinned: this.rowNode.rowPinned,
        forceBrowserFocus: forceBrowserFocus
      });
    }
  }, {
    key: "onRowIndexChanged",
    value: function onRowIndexChanged() {
      this.createCellPosition();
      this.onCellFocused();

      if (this.cellRangeFeature) {
        this.cellRangeFeature.onRangeSelectionChanged();
      }
    }
  }, {
    key: "onFirstRightPinnedChanged",
    value: function onFirstRightPinnedChanged() {
      if (!this.cellComp) {
        return;
      }

      var firstRightPinned = this.column.isFirstRightPinned();
      this.cellComp.addOrRemoveCssClass(CSS_CELL_FIRST_RIGHT_PINNED, firstRightPinned);
    }
  }, {
    key: "onLastLeftPinnedChanged",
    value: function onLastLeftPinnedChanged() {
      if (!this.cellComp) {
        return;
      }

      var lastLeftPinned = this.column.isLastLeftPinned();
      this.cellComp.addOrRemoveCssClass(CSS_CELL_LAST_LEFT_PINNED, lastLeftPinned);
    }
  }, {
    key: "onCellFocused",
    value: function onCellFocused(event) {
      if (this.beans.gos.get("suppressCellFocus")) {
        return;
      }

      var cellFocused = this.beans.focusService.isCellFocused(this.cellPosition);

      if (!this.cellComp) {
        if (cellFocused && (event == null ? void 0 : event.forceBrowserFocus)) {
          this.focusEventToRestore = event;
        }

        return;
      }

      this.focusEventToRestore = void 0;
      this.cellComp.addOrRemoveCssClass(CSS_CELL_FOCUS, cellFocused);

      if (cellFocused && event && event.forceBrowserFocus) {
        var focusEl = this.cellComp.getFocusableElement();
        focusEl.focus({
          preventScroll: !!event.preventScrollOnBrowserFocus
        });
      }

      var fullRowEdit = this.beans.gos.get("editType") === "fullRow";

      if (!cellFocused && !fullRowEdit && this.editing) {
        this.stopRowOrCellEdit();
      }

      if (cellFocused) {
        this.rowCtrl.announceDescription();
      }
    }
  }, {
    key: "createCellPosition",
    value: function createCellPosition() {
      this.cellPosition = {
        rowIndex: this.rowNode.rowIndex,
        rowPinned: _makeNull(this.rowNode.rowPinned),
        column: this.column
      };
    } // CSS Classes that only get applied once, they never change

  }, {
    key: "applyStaticCssClasses",
    value: function applyStaticCssClasses() {
      this.cellComp.addOrRemoveCssClass(CSS_CELL, true);
      this.cellComp.addOrRemoveCssClass(CSS_CELL_NOT_INLINE_EDITING, true);
      var autoHeight = this.column.isAutoHeight() == true;
      this.cellComp.addOrRemoveCssClass(CSS_AUTO_HEIGHT, autoHeight);
      this.cellComp.addOrRemoveCssClass(CSS_NORMAL_HEIGHT, !autoHeight);
    }
  }, {
    key: "onColumnHover",
    value: function onColumnHover() {
      if (!this.cellComp) {
        return;
      }

      if (!this.beans.gos.get("columnHoverHighlight")) {
        return;
      }

      var isHovered = this.beans.columnHoverService.isHovered(this.column);
      this.cellComp.addOrRemoveCssClass(CSS_COLUMN_HOVER, isHovered);
    }
  }, {
    key: "onColDefChanged",
    value: function onColDefChanged() {
      if (!this.cellComp) {
        return;
      }

      var isTooltipEnabled = this.column.isTooltipEnabled();

      if (isTooltipEnabled) {
        this.disableTooltipFeature();
        this.enableTooltipFeature();
      } else {
        this.disableTooltipFeature();
      }

      this.setWrapText();

      if (!this.editing) {
        this.refreshOrDestroyCell({
          forceRefresh: true,
          suppressFlash: true
        });
      } else {
        var cellEditor = this.getCellEditor();

        if (cellEditor == null ? void 0 : cellEditor.refresh) {
          var _this$editCompDetails = this.editCompDetails.params,
              eventKey = _this$editCompDetails.eventKey,
              cellStartedEdit = _this$editCompDetails.cellStartedEdit;
          var editorParams = this.createCellEditorParams(eventKey, cellStartedEdit);
          var colDef = this.column.getColDef();
          var compDetails = this.beans.userComponentFactory.getCellEditorDetails(colDef, editorParams);
          cellEditor.refresh(compDetails.params);
        }
      }
    }
  }, {
    key: "setWrapText",
    value: function setWrapText() {
      var value = this.column.getColDef().wrapText == true;
      this.cellComp.addOrRemoveCssClass(CSS_CELL_WRAP_TEXT, value);
    }
  }, {
    key: "dispatchCellContextMenuEvent",
    value: function dispatchCellContextMenuEvent(event) {
      var _this299 = this;

      var colDef = this.column.getColDef();
      var cellContextMenuEvent = this.createEvent(event, _Events.EVENT_CELL_CONTEXT_MENU);
      this.beans.eventService.dispatchEvent(cellContextMenuEvent);

      if (colDef.onCellContextMenu) {
        window.setTimeout(function () {
          _this299.beans.frameworkOverrides.wrapOutgoing(function () {
            colDef.onCellContextMenu(cellContextMenuEvent);
          });
        }, 0);
      }
    }
  }, {
    key: "getCellRenderer",
    value: function getCellRenderer() {
      return this.cellComp ? this.cellComp.getCellRenderer() : null;
    }
  }, {
    key: "getCellEditor",
    value: function getCellEditor() {
      return this.cellComp ? this.cellComp.getCellEditor() : null;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.onCellCompAttachedFuncs = [];

      _get(_getPrototypeOf(_CellCtrl.prototype), "destroy", this).call(this);
    }
  }, {
    key: "createSelectionCheckbox",
    value: function createSelectionCheckbox() {
      var cbSelectionComponent = new _CheckboxSelectionComponent();
      this.beans.context.createBean(cbSelectionComponent);
      cbSelectionComponent.init({
        rowNode: this.rowNode,
        column: this.column
      });
      return cbSelectionComponent;
    }
  }, {
    key: "createDndSource",
    value: function createDndSource() {
      var dndSourceComp = new DndSourceComp(this.rowNode, this.column, this.eGui);
      this.beans.context.createBean(dndSourceComp);
      return dndSourceComp;
    }
  }, {
    key: "registerRowDragger",
    value: function registerRowDragger(customElement, dragStartPixels, suppressVisibilityChange) {
      var _this300 = this;

      if (this.customRowDragComp) {
        this.customRowDragComp.setDragElement(customElement, dragStartPixels);
        return;
      }

      var newComp = this.createRowDragComp(customElement, dragStartPixels, suppressVisibilityChange);

      if (newComp) {
        this.customRowDragComp = newComp;
        this.addDestroyFunc(function () {
          _this300.beans.context.destroyBean(newComp);

          _this300.customRowDragComp = null;
        });
      }
    }
  }, {
    key: "createRowDragComp",
    value: function createRowDragComp(customElement, dragStartPixels, suppressVisibilityChange) {
      var _this301 = this;

      var pagination = this.beans.gos.get("pagination");
      var rowDragManaged = this.beans.gos.get("rowDragManaged");
      var clientSideRowModelActive = this.beans.gos.isRowModelType("clientSide");

      if (rowDragManaged) {
        if (!clientSideRowModelActive) {
          _warnOnce("managed row dragging is only allowed in the Client Side Row Model");

          return;
        }

        if (pagination) {
          _warnOnce("managed row dragging is not possible when doing pagination");

          return;
        }
      }

      var rowDragComp = new RowDragComp(function () {
        return _this301.value;
      }, this.rowNode, this.column, customElement, dragStartPixels, suppressVisibilityChange);
      this.beans.context.createBean(rowDragComp);
      return rowDragComp;
    }
  }]);

  return _CellCtrl;
}(_BeanStub2);

_CellCtrl.DOM_DATA_KEY_CELL_CTRL = "cellCtrl";
var _CellCtrl2 = _CellCtrl; // community-modules/core/src/rendering/row/rowCtrl.ts

var instanceIdSequence3 = 0;

var _RowCtrl =
/*#__PURE__*/
function (_BeanStub32) {
  "use strict";

  _inherits(_RowCtrl, _BeanStub32);

  function _RowCtrl(rowNode, beans, animateIn, useAnimationFrameForCreate, printLayout) {
    var _this302;

    _classCallCheck(this, _RowCtrl);

    _this302 = _possibleConstructorReturn(this, _getPrototypeOf(_RowCtrl).call(this));
    _this302.allRowGuis = [];
    _this302.active = true;
    _this302.centerCellCtrls = {
      list: [],
      map: {}
    };
    _this302.leftCellCtrls = {
      list: [],
      map: {}
    };
    _this302.rightCellCtrls = {
      list: [],
      map: {}
    };
    _this302.slideInAnimation = {
      left: false,
      center: false,
      right: false,
      fullWidth: false
    };
    _this302.fadeInAnimation = {
      left: false,
      center: false,
      right: false,
      fullWidth: false
    };
    _this302.rowDragComps = [];
    _this302.lastMouseDownOnDragger = false;
    _this302.emptyStyle = {};
    _this302.updateColumnListsPending = false;
    _this302.rowId = null;
    _this302.businessKeySanitised = null;
    _this302.beans = beans;
    _this302.gos = beans.gos;
    _this302.rowNode = rowNode;
    _this302.paginationPage = beans.paginationProxy.getCurrentPage();
    _this302.useAnimationFrameForCreate = useAnimationFrameForCreate;
    _this302.printLayout = printLayout;
    _this302.suppressRowTransform = _this302.gos.get("suppressRowTransform");
    _this302.instanceId = rowNode.id + "-" + instanceIdSequence3++;
    _this302.rowId = _escapeString(rowNode.id);

    _this302.initRowBusinessKey();

    _this302.rowFocused = beans.focusService.isRowFocused(_this302.rowNode.rowIndex, _this302.rowNode.rowPinned);
    _this302.rowLevel = beans.rowCssClassCalculator.calculateRowLevel(_this302.rowNode);

    _this302.setRowType();

    _this302.setAnimateFlags(animateIn);

    _this302.rowStyles = _this302.processStylesFromGridOptions();

    if (_this302.isFullWidth() && !_this302.gos.get("suppressCellFocus")) {
      _this302.tabIndex = -1;
    }

    _this302.addListeners();

    return _this302;
  }

  _createClass(_RowCtrl, [{
    key: "initRowBusinessKey",
    value: function initRowBusinessKey() {
      this.businessKeyForNodeFunc = this.gos.get("getBusinessKeyForNode");
      this.updateRowBusinessKey();
    }
  }, {
    key: "updateRowBusinessKey",
    value: function updateRowBusinessKey() {
      if (typeof this.businessKeyForNodeFunc !== "function") {
        return;
      }

      var businessKey = this.businessKeyForNodeFunc(this.rowNode);
      this.businessKeySanitised = _escapeString(businessKey);
    }
  }, {
    key: "getRowId",
    value: function getRowId() {
      return this.rowId;
    }
  }, {
    key: "getRowStyles",
    value: function getRowStyles() {
      return this.rowStyles;
    }
  }, {
    key: "getTabIndex",
    value: function getTabIndex() {
      return this.tabIndex;
    }
  }, {
    key: "isSticky",
    value: function isSticky() {
      return this.rowNode.sticky;
    }
  }, {
    key: "getInstanceId",
    value: function getInstanceId() {
      return this.instanceId;
    }
  }, {
    key: "setComp",
    value: function setComp(rowComp, element, containerType) {
      var gui = {
        rowComp: rowComp,
        element: element,
        containerType: containerType
      };
      this.allRowGuis.push(gui);

      if (containerType === "left"
      /* LEFT */
      ) {
          this.leftGui = gui;
        } else if (containerType === "right"
      /* RIGHT */
      ) {
          this.rightGui = gui;
        } else if (containerType === "fullWidth"
      /* FULL_WIDTH */
      ) {
          this.fullWidthGui = gui;
        } else {
        this.centerGui = gui;
      }

      this.initialiseRowComp(gui);

      if (this.rowType !== "FullWidthLoading" && !this.rowNode.rowPinned) {
        this.beans.rowRenderer.dispatchFirstDataRenderedEvent();
      }
    }
  }, {
    key: "unsetComp",
    value: function unsetComp(containerType) {
      this.allRowGuis = this.allRowGuis.filter(function (rowGui) {
        return rowGui.containerType !== containerType;
      });

      switch (containerType) {
        case "left"
        /* LEFT */
        :
          this.leftGui = void 0;
          break;

        case "right"
        /* RIGHT */
        :
          this.rightGui = void 0;
          break;

        case "fullWidth"
        /* FULL_WIDTH */
        :
          this.fullWidthGui = void 0;
          break;

        case "center"
        /* CENTER */
        :
          this.centerGui = void 0;
          break;

        default:
      }
    }
  }, {
    key: "isCacheable",
    value: function isCacheable() {
      return this.rowType === "FullWidthDetail"
      /* FullWidthDetail */
      && this.gos.get("keepDetailRows");
    }
  }, {
    key: "setCached",
    value: function setCached(cached) {
      var displayValue = cached ? "none" : "";
      this.allRowGuis.forEach(function (rg) {
        return rg.element.style.display = displayValue;
      });
    }
  }, {
    key: "initialiseRowComp",
    value: function initialiseRowComp(gui) {
      var _this303 = this;

      var gos = this.gos;
      this.listenOnDomOrder(gui);

      if (this.beans.columnModel.wasAutoRowHeightEverActive()) {
        this.rowNode.checkAutoHeights();
      }

      this.onRowHeightChanged(gui);
      this.updateRowIndexes(gui);
      this.setFocusedClasses(gui);
      this.setStylesFromGridOptions(false, gui);

      if (gos.isRowSelection() && this.rowNode.selectable) {
        this.onRowSelected(gui);
      }

      this.updateColumnLists(!this.useAnimationFrameForCreate);
      var comp = gui.rowComp;
      var initialRowClasses = this.getInitialRowClasses(gui.containerType);
      initialRowClasses.forEach(function (name) {
        return comp.addOrRemoveCssClass(name, true);
      });
      this.executeSlideAndFadeAnimations(gui);

      if (this.rowNode.group) {
        _setAriaExpanded(gui.element, this.rowNode.expanded == true);
      }

      this.setRowCompRowId(comp);
      this.setRowCompRowBusinessKey(comp);
      gos.setDomData(gui.element, _RowCtrl.DOM_DATA_KEY_ROW_CTRL, this);
      this.addDestroyFunc(function () {
        return gos.setDomData(gui.element, _RowCtrl.DOM_DATA_KEY_ROW_CTRL, null);
      });

      if (this.useAnimationFrameForCreate) {
        this.beans.animationFrameService.createTask(this.addHoverFunctionality.bind(this, gui.element), this.rowNode.rowIndex, "createTasksP2");
      } else {
        this.addHoverFunctionality(gui.element);
      }

      if (this.isFullWidth()) {
        this.setupFullWidth(gui);
      }

      if (gos.get("rowDragEntireRow")) {
        this.addRowDraggerToRow(gui);
      }

      if (this.useAnimationFrameForCreate) {
        this.beans.animationFrameService.addDestroyTask(function () {
          if (!_this303.isAlive()) {
            return;
          }

          gui.rowComp.addOrRemoveCssClass("ag-after-created", true);
        });
      }

      this.executeProcessRowPostCreateFunc();
    }
  }, {
    key: "setRowCompRowBusinessKey",
    value: function setRowCompRowBusinessKey(comp) {
      if (this.businessKeySanitised == null) {
        return;
      }

      comp.setRowBusinessKey(this.businessKeySanitised);
    }
  }, {
    key: "getBusinessKey",
    value: function getBusinessKey() {
      return this.businessKeySanitised;
    }
  }, {
    key: "setRowCompRowId",
    value: function setRowCompRowId(comp) {
      this.rowId = _escapeString(this.rowNode.id);

      if (this.rowId == null) {
        return;
      }

      comp.setRowId(this.rowId);
    }
  }, {
    key: "executeSlideAndFadeAnimations",
    value: function executeSlideAndFadeAnimations(gui) {
      var _this304 = this;

      var containerType = gui.containerType;
      var shouldSlide = this.slideInAnimation[containerType];

      if (shouldSlide) {
        _executeNextVMTurn(function () {
          _this304.onTopChanged();
        });

        this.slideInAnimation[containerType] = false;
      }

      var shouldFade = this.fadeInAnimation[containerType];

      if (shouldFade) {
        _executeNextVMTurn(function () {
          gui.rowComp.addOrRemoveCssClass("ag-opacity-zero", false);
        });

        this.fadeInAnimation[containerType] = false;
      }
    }
  }, {
    key: "addRowDraggerToRow",
    value: function addRowDraggerToRow(gui) {
      if (this.gos.get("enableRangeSelection")) {
        _warnOnce("Setting `rowDragEntireRow: true` in the gridOptions doesn't work with `enableRangeSelection: true`");

        return;
      }

      var translate = this.beans.localeService.getLocaleTextFunc();
      var rowDragComp = new RowDragComp(function () {
        return "1 ".concat(translate("rowDragRow", "row"));
      }, this.rowNode, void 0, gui.element, void 0, true);
      var rowDragBean = this.createBean(rowDragComp, this.beans.context);
      this.rowDragComps.push(rowDragBean);
    }
  }, {
    key: "setupFullWidth",
    value: function setupFullWidth(gui) {
      var pinned = this.getPinnedForContainer(gui.containerType);

      if (this.rowType == "FullWidthDetail"
      /* FullWidthDetail */
      ) {
          if (!_ModuleRegistry2.__assertRegistered("@ag-grid-enterprise/master-detail"
          /* MasterDetailModule */
          , "cell renderer 'agDetailCellRenderer' (for master detail)", this.beans.context.getGridId())) {
            return;
          }
        }

      var compDetails = this.createFullWidthCompDetails(gui.element, pinned);
      gui.rowComp.showFullWidth(compDetails);
    }
  }, {
    key: "isPrintLayout",
    value: function isPrintLayout() {
      return this.printLayout;
    }
  }, {
    key: "getFullWidthCellRenderers",
    value: function getFullWidthCellRenderers() {
      var _a, _b;

      if (this.gos.get("embedFullWidthRows")) {
        return this.allRowGuis.map(function (gui) {
          var _a2;

          return (_a2 = gui == null ? void 0 : gui.rowComp) == null ? void 0 : _a2.getFullWidthCellRenderer();
        });
      }

      return [(_b = (_a = this.fullWidthGui) == null ? void 0 : _a.rowComp) == null ? void 0 : _b.getFullWidthCellRenderer()];
    } // use by autoWidthCalculator, as it clones the elements

  }, {
    key: "getCellElement",
    value: function getCellElement(column) {
      var cellCtrl = this.getCellCtrl(column);
      return cellCtrl ? cellCtrl.getGui() : null;
    }
  }, {
    key: "executeProcessRowPostCreateFunc",
    value: function executeProcessRowPostCreateFunc() {
      var func = this.gos.getCallback("processRowPostCreate");

      if (!func || !this.areAllContainersReady()) {
        return;
      }

      var params = {
        // areAllContainersReady asserts that centerGui is not null
        eRow: this.centerGui.element,
        ePinnedLeftRow: this.leftGui ? this.leftGui.element : void 0,
        ePinnedRightRow: this.rightGui ? this.rightGui.element : void 0,
        node: this.rowNode,
        rowIndex: this.rowNode.rowIndex,
        addRenderedRowListener: this.addEventListener.bind(this)
      };
      func(params);
    }
  }, {
    key: "areAllContainersReady",
    value: function areAllContainersReady() {
      var isLeftReady = !!this.leftGui || !this.beans.columnModel.isPinningLeft();
      var isCenterReady = !!this.centerGui;
      var isRightReady = !!this.rightGui || !this.beans.columnModel.isPinningRight();
      return isLeftReady && isCenterReady && isRightReady;
    }
  }, {
    key: "setRowType",
    value: function setRowType() {
      var isStub = this.rowNode.stub && !this.gos.get("suppressServerSideFullWidthLoadingRow");
      var isFullWidthCell = this.rowNode.isFullWidthCell();
      var isDetailCell = this.gos.get("masterDetail") && this.rowNode.detail;
      var pivotMode = this.beans.columnModel.isPivotMode();
      var isGroupRow = !!this.rowNode.group && !this.rowNode.footer;
      var isFullWidthGroup = isGroupRow && this.gos.isGroupUseEntireRow(pivotMode);

      if (isStub) {
        this.rowType = "FullWidthLoading"
        /* FullWidthLoading */
        ;
      } else if (isDetailCell) {
        this.rowType = "FullWidthDetail"
        /* FullWidthDetail */
        ;
      } else if (isFullWidthCell) {
        this.rowType = "FullWidth"
        /* FullWidth */
        ;
      } else if (isFullWidthGroup) {
        this.rowType = "FullWidthGroup"
        /* FullWidthGroup */
        ;
      } else {
        this.rowType = "Normal"
        /* Normal */
        ;
      }
    }
  }, {
    key: "updateColumnLists",
    value: function updateColumnLists() {
      var _this305 = this;

      var suppressAnimationFrame = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var useFlushSync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.isFullWidth()) {
        return;
      }

      var noAnimation = suppressAnimationFrame || this.gos.get("suppressAnimationFrame") || this.printLayout;

      if (noAnimation) {
        this.updateColumnListsImpl(useFlushSync);
        return;
      }

      if (this.updateColumnListsPending) {
        return;
      }

      this.beans.animationFrameService.createTask(function () {
        if (!_this305.active) {
          return;
        }

        _this305.updateColumnListsImpl(true);
      }, this.rowNode.rowIndex, "createTasksP1");
      this.updateColumnListsPending = true;
    }
  }, {
    key: "createCellCtrls",
    value: function createCellCtrls(prev, cols) {
      var _this306 = this;

      var pinned = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var res = {
        list: [],
        map: {}
      };

      var addCell = function addCell(colInstanceId, cellCtrl) {
        res.list.push(cellCtrl);
        res.map[colInstanceId] = cellCtrl;
      };

      cols.forEach(function (col) {
        var colInstanceId = col.getInstanceId();
        var cellCtrl = prev.map[colInstanceId];

        if (!cellCtrl) {
          cellCtrl = new _CellCtrl2(col, _this306.rowNode, _this306.beans, _this306);
        }

        addCell(colInstanceId, cellCtrl);
      });
      prev.list.forEach(function (prevCellCtrl) {
        var cellInResult = res.map[prevCellCtrl.getColumn().getInstanceId()] != null;

        if (cellInResult) {
          return;
        }

        var keepCell = !_this306.isCellEligibleToBeRemoved(prevCellCtrl, pinned);

        if (keepCell) {
          addCell(prevCellCtrl.getColumn().getInstanceId(), prevCellCtrl);
          return;
        }

        prevCellCtrl.destroy();
      });
      return res;
    }
  }, {
    key: "updateColumnListsImpl",
    value: function updateColumnListsImpl(useFlushSync) {
      this.updateColumnListsPending = false;
      this.createAllCellCtrls();
      this.setCellCtrls(useFlushSync);
    }
  }, {
    key: "setCellCtrls",
    value: function setCellCtrls(useFlushSync) {
      var _this307 = this;

      this.allRowGuis.forEach(function (item) {
        var cellControls = _this307.getCellCtrlsForContainer(item.containerType);

        item.rowComp.setCellCtrls(cellControls, useFlushSync);
      });
    }
  }, {
    key: "getCellCtrlsForContainer",
    value: function getCellCtrlsForContainer(containerType) {
      switch (containerType) {
        case "left"
        /* LEFT */
        :
          return this.leftCellCtrls.list;

        case "right"
        /* RIGHT */
        :
          return this.rightCellCtrls.list;

        case "fullWidth"
        /* FULL_WIDTH */
        :
          return [];

        case "center"
        /* CENTER */
        :
          return this.centerCellCtrls.list;

        default:
          var exhaustiveCheck = containerType;
          throw new Error("Unhandled case: ".concat(exhaustiveCheck));
      }
    }
  }, {
    key: "createAllCellCtrls",
    value: function createAllCellCtrls() {
      var columnModel = this.beans.columnModel;

      if (this.printLayout) {
        this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, columnModel.getAllDisplayedColumns());
        this.leftCellCtrls = {
          list: [],
          map: {}
        };
        this.rightCellCtrls = {
          list: [],
          map: {}
        };
      } else {
        var centerCols = columnModel.getViewportCenterColumnsForRow(this.rowNode);
        this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, centerCols);
        var leftCols = columnModel.getDisplayedLeftColumnsForRow(this.rowNode);
        this.leftCellCtrls = this.createCellCtrls(this.leftCellCtrls, leftCols, "left");
        var rightCols = columnModel.getDisplayedRightColumnsForRow(this.rowNode);
        this.rightCellCtrls = this.createCellCtrls(this.rightCellCtrls, rightCols, "right");
      }
    }
  }, {
    key: "isCellEligibleToBeRemoved",
    value: function isCellEligibleToBeRemoved(cellCtrl, nextContainerPinned) {
      var REMOVE_CELL = true;
      var KEEP_CELL = false;
      var column = cellCtrl.getColumn();

      if (column.getPinned() != nextContainerPinned) {
        return REMOVE_CELL;
      }

      var editing = cellCtrl.isEditing();
      var focused = this.beans.focusService.isCellFocused(cellCtrl.getCellPosition());
      var mightWantToKeepCell = editing || focused;

      if (mightWantToKeepCell) {
        var column2 = cellCtrl.getColumn();
        var displayedColumns = this.beans.columnModel.getAllDisplayedColumns();
        var cellStillDisplayed = displayedColumns.indexOf(column2) >= 0;
        return cellStillDisplayed ? KEEP_CELL : REMOVE_CELL;
      }

      return REMOVE_CELL;
    }
  }, {
    key: "getDomOrder",
    value: function getDomOrder() {
      var isEnsureDomOrder = this.gos.get("ensureDomOrder");
      return isEnsureDomOrder || this.gos.isDomLayout("print");
    }
  }, {
    key: "listenOnDomOrder",
    value: function listenOnDomOrder(gui) {
      var _this308 = this;

      var listener = function listener() {
        gui.rowComp.setDomOrder(_this308.getDomOrder());
      };

      this.addManagedPropertyListener("domLayout", listener);
      this.addManagedPropertyListener("ensureDomOrder", listener);
    }
  }, {
    key: "setAnimateFlags",
    value: function setAnimateFlags(animateIn) {
      if (this.isSticky() || !animateIn) {
        return;
      }

      var oldRowTopExists = _exists(this.rowNode.oldRowTop);

      var pinningLeft = this.beans.columnModel.isPinningLeft();
      var pinningRight = this.beans.columnModel.isPinningRight();

      if (oldRowTopExists) {
        if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
          this.slideInAnimation.fullWidth = true;
          return;
        }

        this.slideInAnimation.center = true;
        this.slideInAnimation.left = pinningLeft;
        this.slideInAnimation.right = pinningRight;
      } else {
        if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
          this.fadeInAnimation.fullWidth = true;
          return;
        }

        this.fadeInAnimation.center = true;
        this.fadeInAnimation.left = pinningLeft;
        this.fadeInAnimation.right = pinningRight;
      }
    }
  }, {
    key: "isEditing",
    value: function isEditing() {
      return this.editingRow;
    }
  }, {
    key: "isFullWidth",
    value: function isFullWidth() {
      return this.rowType !== "Normal"
      /* Normal */
      ;
    }
  }, {
    key: "refreshFullWidth",
    value: function refreshFullWidth() {
      var _this309 = this;

      var tryRefresh = function tryRefresh(gui, pinned) {
        if (!gui) {
          return true;
        }

        return gui.rowComp.refreshFullWidth(function () {
          var compDetails = _this309.createFullWidthCompDetails(gui.element, pinned);

          return compDetails.params;
        });
      };

      var fullWidthSuccess = tryRefresh(this.fullWidthGui, null);
      var centerSuccess = tryRefresh(this.centerGui, null);
      var leftSuccess = tryRefresh(this.leftGui, "left");
      var rightSuccess = tryRefresh(this.rightGui, "right");
      var allFullWidthRowsRefreshed = fullWidthSuccess && centerSuccess && leftSuccess && rightSuccess;
      return allFullWidthRowsRefreshed;
    }
  }, {
    key: "addListeners",
    value: function addListeners() {
      var _this310 = this;

      this.addManagedListener(this.rowNode, _RowNode2.EVENT_HEIGHT_CHANGED, function () {
        return _this310.onRowHeightChanged();
      });
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_ROW_SELECTED, function () {
        return _this310.onRowSelected();
      });
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_ROW_INDEX_CHANGED, this.onRowIndexChanged.bind(this));
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_TOP_CHANGED, this.onTopChanged.bind(this));
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_EXPANDED_CHANGED, this.updateExpandedCss.bind(this));
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_HAS_CHILDREN_CHANGED, this.updateExpandedCss.bind(this));

      if (this.rowNode.detail) {
        this.addManagedListener(this.rowNode.parent, _RowNode2.EVENT_DATA_CHANGED, this.onRowNodeDataChanged.bind(this));
      }

      this.addManagedListener(this.rowNode, _RowNode2.EVENT_DATA_CHANGED, this.onRowNodeDataChanged.bind(this));
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_CELL_CHANGED, this.postProcessCss.bind(this));
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_HIGHLIGHT_CHANGED, this.onRowNodeHighlightChanged.bind(this));
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_DRAGGING_CHANGED, this.postProcessRowDragging.bind(this));
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_UI_LEVEL_CHANGED, this.onUiLevelChanged.bind(this));
      var eventService = this.beans.eventService;
      this.addManagedListener(eventService, _Events.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED, this.onPaginationPixelOffsetChanged.bind(this));
      this.addManagedListener(eventService, _Events.EVENT_HEIGHT_SCALE_CHANGED, this.onTopChanged.bind(this));
      this.addManagedListener(eventService, _Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
      this.addManagedListener(eventService, _Events.EVENT_VIRTUAL_COLUMNS_CHANGED, this.onVirtualColumnsChanged.bind(this));
      this.addManagedListener(eventService, _Events.EVENT_CELL_FOCUSED, this.onCellFocusChanged.bind(this));
      this.addManagedListener(eventService, _Events.EVENT_CELL_FOCUS_CLEARED, this.onCellFocusChanged.bind(this));
      this.addManagedListener(eventService, _Events.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this));
      this.addManagedListener(eventService, _Events.EVENT_MODEL_UPDATED, this.refreshFirstAndLastRowStyles.bind(this));
      this.addManagedListener(eventService, _Events.EVENT_COLUMN_MOVED, this.updateColumnLists.bind(this));
      this.addDestroyFunc(function () {
        _this310.destroyBeans(_this310.rowDragComps, _this310.beans.context);

        if (_this310.tooltipFeature) {
          _this310.tooltipFeature = _this310.destroyBean(_this310.tooltipFeature, _this310.beans.context);
        }
      });
      this.addManagedPropertyListeners(["rowDragEntireRow"], function () {
        var useRowDragEntireRow = _this310.gos.get("rowDragEntireRow");

        if (useRowDragEntireRow) {
          _this310.allRowGuis.forEach(function (gui) {
            _this310.addRowDraggerToRow(gui);
          });

          return;
        }

        _this310.destroyBeans(_this310.rowDragComps, _this310.beans.context);

        _this310.rowDragComps = [];
      });
      this.addListenersForCellComps();
    }
  }, {
    key: "addListenersForCellComps",
    value: function addListenersForCellComps() {
      var _this311 = this;

      this.addManagedListener(this.rowNode, _RowNode2.EVENT_ROW_INDEX_CHANGED, function () {
        _this311.getAllCellCtrls().forEach(function (cellCtrl) {
          return cellCtrl.onRowIndexChanged();
        });
      });
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_CELL_CHANGED, function (event) {
        _this311.getAllCellCtrls().forEach(function (cellCtrl) {
          return cellCtrl.onCellChanged(event);
        });
      });
    }
  }, {
    key: "onRowNodeDataChanged",
    value: function onRowNodeDataChanged(event) {
      var _this312 = this;

      var fullWidthChanged = this.isFullWidth() !== !!this.rowNode.isFullWidthCell();

      if (fullWidthChanged) {
        this.beans.rowRenderer.redrawRow(this.rowNode);
        return;
      }

      if (this.isFullWidth()) {
        var refresh = this.refreshFullWidth();

        if (!refresh) {
          this.beans.rowRenderer.redrawRow(this.rowNode);
        }

        return;
      }

      this.getAllCellCtrls().forEach(function (cellCtrl) {
        return cellCtrl.refreshCell({
          suppressFlash: !event.update,
          newData: !event.update
        });
      });
      this.allRowGuis.forEach(function (gui) {
        _this312.setRowCompRowId(gui.rowComp);

        _this312.updateRowBusinessKey();

        _this312.setRowCompRowBusinessKey(gui.rowComp);
      });
      this.onRowSelected();
      this.postProcessCss();
    }
  }, {
    key: "postProcessCss",
    value: function postProcessCss() {
      this.setStylesFromGridOptions(true);
      this.postProcessClassesFromGridOptions();
      this.postProcessRowClassRules();
      this.postProcessRowDragging();
    }
  }, {
    key: "onRowNodeHighlightChanged",
    value: function onRowNodeHighlightChanged() {
      var highlighted = this.rowNode.highlighted;
      this.allRowGuis.forEach(function (gui) {
        var aboveOn = highlighted === 0
        /* Above */
        ;
        var belowOn = highlighted === 1
        /* Below */
        ;
        gui.rowComp.addOrRemoveCssClass("ag-row-highlight-above", aboveOn);
        gui.rowComp.addOrRemoveCssClass("ag-row-highlight-below", belowOn);
      });
    }
  }, {
    key: "postProcessRowDragging",
    value: function postProcessRowDragging() {
      var dragging = this.rowNode.dragging;
      this.allRowGuis.forEach(function (gui) {
        return gui.rowComp.addOrRemoveCssClass("ag-row-dragging", dragging);
      });
    }
  }, {
    key: "updateExpandedCss",
    value: function updateExpandedCss() {
      var expandable = this.rowNode.isExpandable();
      var expanded = this.rowNode.expanded == true;
      this.allRowGuis.forEach(function (gui) {
        gui.rowComp.addOrRemoveCssClass("ag-row-group", expandable);
        gui.rowComp.addOrRemoveCssClass("ag-row-group-expanded", expandable && expanded);
        gui.rowComp.addOrRemoveCssClass("ag-row-group-contracted", expandable && !expanded);

        _setAriaExpanded(gui.element, expandable && expanded);
      });
    }
  }, {
    key: "onDisplayedColumnsChanged",
    value: function onDisplayedColumnsChanged() {
      this.updateColumnLists(true);

      if (this.beans.columnModel.wasAutoRowHeightEverActive()) {
        this.rowNode.checkAutoHeights();
      }
    }
  }, {
    key: "onVirtualColumnsChanged",
    value: function onVirtualColumnsChanged() {
      this.updateColumnLists(false, true);
    }
  }, {
    key: "getRowPosition",
    value: function getRowPosition() {
      return {
        rowPinned: _makeNull(this.rowNode.rowPinned),
        rowIndex: this.rowNode.rowIndex
      };
    }
  }, {
    key: "onKeyboardNavigate",
    value: function onKeyboardNavigate(keyboardEvent) {
      var currentFullWidthComp = this.allRowGuis.find(function (c) {
        return c.element.contains(keyboardEvent.target);
      });
      var currentFullWidthContainer = currentFullWidthComp ? currentFullWidthComp.element : null;
      var isFullWidthContainerFocused = currentFullWidthContainer === keyboardEvent.target;

      if (!isFullWidthContainerFocused) {
        return;
      }

      var node = this.rowNode;
      var lastFocusedCell = this.beans.focusService.getFocusedCell();
      var cellPosition = {
        rowIndex: node.rowIndex,
        rowPinned: node.rowPinned,
        column: lastFocusedCell && lastFocusedCell.column
      };
      this.beans.navigationService.navigateToNextCell(keyboardEvent, keyboardEvent.key, cellPosition, true);
      keyboardEvent.preventDefault();
    }
  }, {
    key: "onTabKeyDown",
    value: function onTabKeyDown(keyboardEvent) {
      if (keyboardEvent.defaultPrevented || _isStopPropagationForAgGrid(keyboardEvent)) {
        return;
      }

      var currentFullWidthComp = this.allRowGuis.find(function (c) {
        return c.element.contains(keyboardEvent.target);
      });
      var currentFullWidthContainer = currentFullWidthComp ? currentFullWidthComp.element : null;
      var isFullWidthContainerFocused = currentFullWidthContainer === keyboardEvent.target;
      var nextEl = null;

      if (!isFullWidthContainerFocused) {
        nextEl = this.beans.focusService.findNextFocusableElement(currentFullWidthContainer, false, keyboardEvent.shiftKey);
      }

      if (this.isFullWidth() && isFullWidthContainerFocused || !nextEl) {
        this.beans.navigationService.onTabKeyDown(this, keyboardEvent);
      }
    }
  }, {
    key: "getFullWidthElement",
    value: function getFullWidthElement() {
      if (this.fullWidthGui) {
        return this.fullWidthGui.element;
      }

      return null;
    }
  }, {
    key: "getRowYPosition",
    value: function getRowYPosition() {
      var _a;

      var displayedEl = (_a = this.allRowGuis.find(function (el) {
        return _isVisible(el.element);
      })) == null ? void 0 : _a.element;

      if (displayedEl) {
        return displayedEl.getBoundingClientRect().top;
      }

      return 0;
    }
  }, {
    key: "onFullWidthRowFocused",
    value: function onFullWidthRowFocused(event) {
      var _a;

      var node = this.rowNode;
      var isFocused = !event ? false : this.isFullWidth() && event.rowIndex === node.rowIndex && event.rowPinned == node.rowPinned;
      var element = this.fullWidthGui ? this.fullWidthGui.element : (_a = this.centerGui) == null ? void 0 : _a.element;

      if (!element) {
        return;
      }

      element.classList.toggle("ag-full-width-focus", isFocused);

      if (isFocused) {
        element.focus({
          preventScroll: true
        });
      }
    }
  }, {
    key: "recreateCell",
    value: function recreateCell(cellCtrl) {
      this.centerCellCtrls = this.removeCellCtrl(this.centerCellCtrls, cellCtrl);
      this.leftCellCtrls = this.removeCellCtrl(this.leftCellCtrls, cellCtrl);
      this.rightCellCtrls = this.removeCellCtrl(this.rightCellCtrls, cellCtrl);
      cellCtrl.destroy();
      this.updateColumnLists();
    }
  }, {
    key: "removeCellCtrl",
    value: function removeCellCtrl(prev, cellCtrlToRemove) {
      var res = {
        list: [],
        map: {}
      };
      prev.list.forEach(function (cellCtrl) {
        if (cellCtrl === cellCtrlToRemove) {
          return;
        }

        res.list.push(cellCtrl);
        res.map[cellCtrl.getColumn().getInstanceId()] = cellCtrl;
      });
      return res;
    }
  }, {
    key: "onMouseEvent",
    value: function onMouseEvent(eventName, mouseEvent) {
      switch (eventName) {
        case "dblclick":
          this.onRowDblClick(mouseEvent);
          break;

        case "click":
          this.onRowClick(mouseEvent);
          break;

        case "touchstart":
        case "mousedown":
          this.onRowMouseDown(mouseEvent);
          break;
      }
    }
  }, {
    key: "createRowEvent",
    value: function createRowEvent(type, domEvent) {
      return this.gos.addGridCommonParams({
        type: type,
        node: this.rowNode,
        data: this.rowNode.data,
        rowIndex: this.rowNode.rowIndex,
        rowPinned: this.rowNode.rowPinned,
        event: domEvent
      });
    }
  }, {
    key: "createRowEventWithSource",
    value: function createRowEventWithSource(type, domEvent) {
      var event = this.createRowEvent(type, domEvent);
      event.source = this;
      return event;
    }
  }, {
    key: "onRowDblClick",
    value: function onRowDblClick(mouseEvent) {
      if (_isStopPropagationForAgGrid(mouseEvent)) {
        return;
      }

      var agEvent = this.createRowEventWithSource(_Events.EVENT_ROW_DOUBLE_CLICKED, mouseEvent);
      this.beans.eventService.dispatchEvent(agEvent);
    }
  }, {
    key: "onRowMouseDown",
    value: function onRowMouseDown(mouseEvent) {
      this.lastMouseDownOnDragger = _isElementChildOfClass(mouseEvent.target, "ag-row-drag", 3);

      if (!this.isFullWidth()) {
        return;
      }

      var node = this.rowNode;
      var columnModel = this.beans.columnModel;

      if (this.beans.rangeService) {
        this.beans.rangeService.removeAllCellRanges();
      }

      this.beans.focusService.setFocusedCell({
        rowIndex: node.rowIndex,
        column: columnModel.getAllDisplayedColumns()[0],
        rowPinned: node.rowPinned,
        forceBrowserFocus: true
      });
    }
  }, {
    key: "onRowClick",
    value: function onRowClick(mouseEvent) {
      var stop = _isStopPropagationForAgGrid(mouseEvent) || this.lastMouseDownOnDragger;

      if (stop) {
        return;
      }

      var agEvent = this.createRowEventWithSource(_Events.EVENT_ROW_CLICKED, mouseEvent);
      this.beans.eventService.dispatchEvent(agEvent);
      var isMultiKey = mouseEvent.ctrlKey || mouseEvent.metaKey;
      var isShiftKey = mouseEvent.shiftKey;
      var groupSelectsChildren = this.gos.get("groupSelectsChildren");

      if ( // we do not allow selecting groups by clicking (as the click here expands the group), or if it's a detail row,
      // so return if it's a group row
      groupSelectsChildren && this.rowNode.group || this.isRowSelectionBlocked() || // if click selection suppressed, do nothing
      this.gos.get("suppressRowClickSelection")) {
        return;
      }

      var multiSelectOnClick = this.gos.get("rowMultiSelectWithClick");
      var rowDeselectionWithCtrl = !this.gos.get("suppressRowDeselection");
      var source = "rowClicked";

      if (this.rowNode.isSelected()) {
        if (multiSelectOnClick) {
          this.rowNode.setSelectedParams({
            newValue: false,
            event: mouseEvent,
            source: source
          });
        } else if (isMultiKey) {
          if (rowDeselectionWithCtrl) {
            this.rowNode.setSelectedParams({
              newValue: false,
              event: mouseEvent,
              source: source
            });
          }
        } else {
          this.rowNode.setSelectedParams({
            newValue: true,
            clearSelection: !isShiftKey,
            rangeSelect: isShiftKey,
            event: mouseEvent,
            source: source
          });
        }
      } else {
        var clearSelection = multiSelectOnClick ? false : !isMultiKey;
        this.rowNode.setSelectedParams({
          newValue: true,
          clearSelection: clearSelection,
          rangeSelect: isShiftKey,
          event: mouseEvent,
          source: source
        });
      }
    }
  }, {
    key: "isRowSelectionBlocked",
    value: function isRowSelectionBlocked() {
      return !this.rowNode.selectable || !!this.rowNode.rowPinned || !this.gos.isRowSelection();
    }
  }, {
    key: "setupDetailRowAutoHeight",
    value: function setupDetailRowAutoHeight(eDetailGui) {
      var _this313 = this;

      if (this.rowType !== "FullWidthDetail"
      /* FullWidthDetail */
      ) {
          return;
        }

      if (!this.gos.get("detailRowAutoHeight")) {
        return;
      }

      var checkRowSizeFunc = function checkRowSizeFunc() {
        var clientHeight = eDetailGui.clientHeight;

        if (clientHeight != null && clientHeight > 0) {
          var updateRowHeightFunc = function updateRowHeightFunc() {
            _this313.rowNode.setRowHeight(clientHeight);

            if (_this313.beans.clientSideRowModel) {
              _this313.beans.clientSideRowModel.onRowHeightChanged();
            } else if (_this313.beans.serverSideRowModel) {
              _this313.beans.serverSideRowModel.onRowHeightChanged();
            }
          };

          window.setTimeout(updateRowHeightFunc, 0);
        }
      };

      var resizeObserverDestroyFunc = this.beans.resizeObserverService.observeResize(eDetailGui, checkRowSizeFunc);
      this.addDestroyFunc(resizeObserverDestroyFunc);
      checkRowSizeFunc();
    }
  }, {
    key: "createFullWidthCompDetails",
    value: function createFullWidthCompDetails(eRow, pinned) {
      var _this314 = this;

      var params = this.gos.addGridCommonParams({
        fullWidth: true,
        data: this.rowNode.data,
        node: this.rowNode,
        value: this.rowNode.key,
        valueFormatted: this.rowNode.key,
        rowIndex: this.rowNode.rowIndex,
        // these need to be taken out, as part of 'afterAttached' now
        eGridCell: eRow,
        eParentOfValue: eRow,
        pinned: pinned,
        addRenderedRowListener: this.addEventListener.bind(this),
        registerRowDragger: function registerRowDragger(rowDraggerElement, dragStartPixels, value, suppressVisibilityChange) {
          return _this314.addFullWidthRowDragging(rowDraggerElement, dragStartPixels, value, suppressVisibilityChange);
        },
        setTooltip: function setTooltip(value, shouldDisplayTooltip) {
          return _this314.refreshRowTooltip(value, shouldDisplayTooltip);
        }
      });

      switch (this.rowType) {
        case "FullWidthDetail"
        /* FullWidthDetail */
        :
          return this.beans.userComponentFactory.getFullWidthDetailCellRendererDetails(params);

        case "FullWidthGroup"
        /* FullWidthGroup */
        :
          return this.beans.userComponentFactory.getFullWidthGroupCellRendererDetails(params);

        case "FullWidthLoading"
        /* FullWidthLoading */
        :
          return this.beans.userComponentFactory.getFullWidthLoadingCellRendererDetails(params);

        default:
          return this.beans.userComponentFactory.getFullWidthCellRendererDetails(params);
      }
    }
  }, {
    key: "refreshRowTooltip",
    value: function refreshRowTooltip(value, shouldDisplayTooltip) {
      var _this315 = this;

      if (!this.fullWidthGui) {
        return;
      }

      var tooltipParams = {
        getGui: function getGui() {
          return _this315.fullWidthGui.element;
        },
        getTooltipValue: function getTooltipValue() {
          return value;
        },
        getLocation: function getLocation() {
          return "fullWidthRow";
        },
        shouldDisplayTooltip: shouldDisplayTooltip
      };

      if (this.tooltipFeature) {
        this.destroyBean(this.tooltipFeature, this.beans.context);
      }

      this.tooltipFeature = this.createBean(new _TooltipFeature(tooltipParams, this.beans));
    }
  }, {
    key: "addFullWidthRowDragging",
    value: function addFullWidthRowDragging(rowDraggerElement, dragStartPixels) {
      var _this316 = this;

      var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var suppressVisibilityChange = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.isFullWidth()) {
        return;
      }

      var rowDragComp = new RowDragComp(function () {
        return value;
      }, this.rowNode, void 0, rowDraggerElement, dragStartPixels, suppressVisibilityChange);
      this.createBean(rowDragComp, this.beans.context);
      this.addDestroyFunc(function () {
        _this316.destroyBean(rowDragComp, _this316.beans.context);
      });
    }
  }, {
    key: "onUiLevelChanged",
    value: function onUiLevelChanged() {
      var newLevel = this.beans.rowCssClassCalculator.calculateRowLevel(this.rowNode);

      if (this.rowLevel != newLevel) {
        var classToAdd = "ag-row-level-" + newLevel;
        var classToRemove = "ag-row-level-" + this.rowLevel;
        this.allRowGuis.forEach(function (gui) {
          gui.rowComp.addOrRemoveCssClass(classToAdd, true);
          gui.rowComp.addOrRemoveCssClass(classToRemove, false);
        });
      }

      this.rowLevel = newLevel;
    }
  }, {
    key: "isFirstRowOnPage",
    value: function isFirstRowOnPage() {
      return this.rowNode.rowIndex === this.beans.paginationProxy.getPageFirstRow();
    }
  }, {
    key: "isLastRowOnPage",
    value: function isLastRowOnPage() {
      return this.rowNode.rowIndex === this.beans.paginationProxy.getPageLastRow();
    }
  }, {
    key: "refreshFirstAndLastRowStyles",
    value: function refreshFirstAndLastRowStyles() {
      var newFirst = this.isFirstRowOnPage();
      var newLast = this.isLastRowOnPage();

      if (this.firstRowOnPage !== newFirst) {
        this.firstRowOnPage = newFirst;
        this.allRowGuis.forEach(function (gui) {
          return gui.rowComp.addOrRemoveCssClass("ag-row-first", newFirst);
        });
      }

      if (this.lastRowOnPage !== newLast) {
        this.lastRowOnPage = newLast;
        this.allRowGuis.forEach(function (gui) {
          return gui.rowComp.addOrRemoveCssClass("ag-row-last", newLast);
        });
      }
    }
  }, {
    key: "stopEditing",
    value: function stopEditing() {
      var cancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.stoppingRowEdit) {
        return;
      }

      var cellControls = this.getAllCellCtrls();
      var isRowEdit = this.editingRow;
      this.stoppingRowEdit = true;
      var fireRowEditEvent = false;
      var _iteratorNormalCompletion12 = true;
      var _didIteratorError12 = false;
      var _iteratorError12 = undefined;

      try {
        for (var _iterator12 = cellControls[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
          var ctrl = _step12.value;
          var valueChanged = ctrl.stopEditing(cancel);

          if (isRowEdit && !cancel && !fireRowEditEvent && valueChanged) {
            fireRowEditEvent = true;
          }
        }
      } catch (err) {
        _didIteratorError12 = true;
        _iteratorError12 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
            _iterator12.return();
          }
        } finally {
          if (_didIteratorError12) {
            throw _iteratorError12;
          }
        }
      }

      if (fireRowEditEvent) {
        var event = this.createRowEvent(_Events.EVENT_ROW_VALUE_CHANGED);
        this.beans.eventService.dispatchEvent(event);
      }

      if (isRowEdit) {
        this.setEditingRow(false);
      }

      this.stoppingRowEdit = false;
    }
  }, {
    key: "setInlineEditingCss",
    value: function setInlineEditingCss(editing) {
      this.allRowGuis.forEach(function (gui) {
        gui.rowComp.addOrRemoveCssClass("ag-row-inline-editing", editing);
        gui.rowComp.addOrRemoveCssClass("ag-row-not-inline-editing", !editing);
      });
    }
  }, {
    key: "setEditingRow",
    value: function setEditingRow(value) {
      this.editingRow = value;
      this.allRowGuis.forEach(function (gui) {
        return gui.rowComp.addOrRemoveCssClass("ag-row-editing", value);
      });
      var event = value ? this.createRowEvent(_Events.EVENT_ROW_EDITING_STARTED) : this.createRowEvent(_Events.EVENT_ROW_EDITING_STOPPED);
      this.beans.eventService.dispatchEvent(event);
    }
  }, {
    key: "startRowEditing",
    value: function startRowEditing() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var sourceRenderedCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var event = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (this.editingRow) {
        return;
      }

      var atLeastOneEditing = this.getAllCellCtrls().reduce(function (prev, cellCtrl) {
        var cellStartedEdit = cellCtrl === sourceRenderedCell;

        if (cellStartedEdit) {
          cellCtrl.startEditing(key, cellStartedEdit, event);
        } else {
          cellCtrl.startEditing(null, cellStartedEdit, event);
        }

        if (prev) {
          return true;
        }

        return cellCtrl.isEditing();
      }, false);

      if (atLeastOneEditing) {
        this.setEditingRow(true);
      }
    }
  }, {
    key: "getAllCellCtrls",
    value: function getAllCellCtrls() {
      if (this.leftCellCtrls.list.length === 0 && this.rightCellCtrls.list.length === 0) {
        return this.centerCellCtrls.list;
      }

      var res = [].concat(_toConsumableArray(this.centerCellCtrls.list), _toConsumableArray(this.leftCellCtrls.list), _toConsumableArray(this.rightCellCtrls.list));
      return res;
    }
  }, {
    key: "postProcessClassesFromGridOptions",
    value: function postProcessClassesFromGridOptions() {
      var _this317 = this;

      var cssClasses = this.beans.rowCssClassCalculator.processClassesFromGridOptions(this.rowNode);

      if (!cssClasses || !cssClasses.length) {
        return;
      }

      cssClasses.forEach(function (classStr) {
        _this317.allRowGuis.forEach(function (c) {
          return c.rowComp.addOrRemoveCssClass(classStr, true);
        });
      });
    }
  }, {
    key: "postProcessRowClassRules",
    value: function postProcessRowClassRules() {
      var _this318 = this;

      this.beans.rowCssClassCalculator.processRowClassRules(this.rowNode, function (className) {
        _this318.allRowGuis.forEach(function (gui) {
          return gui.rowComp.addOrRemoveCssClass(className, true);
        });
      }, function (className) {
        _this318.allRowGuis.forEach(function (gui) {
          return gui.rowComp.addOrRemoveCssClass(className, false);
        });
      });
    }
  }, {
    key: "setStylesFromGridOptions",
    value: function setStylesFromGridOptions(updateStyles, gui) {
      var _this319 = this;

      if (updateStyles) {
        this.rowStyles = this.processStylesFromGridOptions();
      }

      this.forEachGui(gui, function (gui2) {
        return gui2.rowComp.setUserStyles(_this319.rowStyles);
      });
    }
  }, {
    key: "getPinnedForContainer",
    value: function getPinnedForContainer(rowContainerType) {
      var pinned = rowContainerType === "left"
      /* LEFT */
      ? "left" : rowContainerType === "right"
      /* RIGHT */
      ? "right" : null;
      return pinned;
    }
  }, {
    key: "getInitialRowClasses",
    value: function getInitialRowClasses(rowContainerType) {
      var pinned = this.getPinnedForContainer(rowContainerType);
      var params = {
        rowNode: this.rowNode,
        rowFocused: this.rowFocused,
        fadeRowIn: this.fadeInAnimation[rowContainerType],
        rowIsEven: this.rowNode.rowIndex % 2 === 0,
        rowLevel: this.rowLevel,
        fullWidthRow: this.isFullWidth(),
        firstRowOnPage: this.isFirstRowOnPage(),
        lastRowOnPage: this.isLastRowOnPage(),
        printLayout: this.printLayout,
        expandable: this.rowNode.isExpandable(),
        pinned: pinned
      };
      return this.beans.rowCssClassCalculator.getInitialRowClasses(params);
    }
  }, {
    key: "processStylesFromGridOptions",
    value: function processStylesFromGridOptions() {
      var rowStyle = this.gos.get("rowStyle");

      if (rowStyle && typeof rowStyle === "function") {
        console.warn("AG Grid: rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead");
        return;
      }

      var rowStyleFunc = this.gos.getCallback("getRowStyle");
      var rowStyleFuncResult;

      if (rowStyleFunc) {
        var params = {
          data: this.rowNode.data,
          node: this.rowNode,
          rowIndex: this.rowNode.rowIndex
        };
        rowStyleFuncResult = rowStyleFunc(params);
      }

      if (rowStyleFuncResult || rowStyle) {
        return Object.assign({}, rowStyle, rowStyleFuncResult);
      }

      return this.emptyStyle;
    }
  }, {
    key: "onRowSelected",
    value: function onRowSelected(gui) {
      var _this320 = this;

      var selected = !!this.rowNode.isSelected();
      this.forEachGui(gui, function (gui2) {
        gui2.rowComp.addOrRemoveCssClass("ag-row-selected", selected);

        _setAriaSelected(gui2.element, selected);

        var hasFocus = gui2.element.contains(_this320.beans.gos.getActiveDomElement());

        if (hasFocus && (gui2 === _this320.centerGui || gui2 === _this320.fullWidthGui)) {
          _this320.announceDescription();
        }
      });
    }
  }, {
    key: "announceDescription",
    value: function announceDescription() {
      if (this.isRowSelectionBlocked()) {
        return;
      }

      var selected = this.rowNode.isSelected();

      if (selected && this.beans.gos.get("suppressRowDeselection")) {
        return;
      }

      var translate = this.beans.localeService.getLocaleTextFunc();
      var label = translate(selected ? "ariaRowDeselect" : "ariaRowSelect", "Press SPACE to ".concat(selected ? "deselect" : "select", " this row."));
      this.beans.ariaAnnouncementService.announceValue(label);
    }
  }, {
    key: "addHoverFunctionality",
    value: function addHoverFunctionality(eRow) {
      var _this321 = this;

      if (!this.active) {
        return;
      }

      this.addManagedListener(eRow, "mouseenter", function () {
        return _this321.rowNode.onMouseEnter();
      });
      this.addManagedListener(eRow, "mouseleave", function () {
        return _this321.rowNode.onMouseLeave();
      });
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_MOUSE_ENTER, function () {
        if (!_this321.beans.dragService.isDragging() && !_this321.gos.get("suppressRowHoverHighlight")) {
          eRow.classList.add("ag-row-hover");

          _this321.rowNode.setHovered(true);
        }
      });
      this.addManagedListener(this.rowNode, _RowNode2.EVENT_MOUSE_LEAVE, function () {
        eRow.classList.remove("ag-row-hover");

        _this321.rowNode.setHovered(false);
      });
    } // for animation, we don't want to animate entry or exit to a very far away pixel,
    // otherwise the row would move so fast, it would appear to disappear. so this method
    // moves the row closer to the viewport if it is far away, so the row slide in / out
    // at a speed the user can see.

  }, {
    key: "roundRowTopToBounds",
    value: function roundRowTopToBounds(rowTop) {
      var range = this.beans.ctrlsService.getGridBodyCtrl().getScrollFeature().getApproximateVScollPosition();
      var minPixel = this.applyPaginationOffset(range.top, true) - 100;
      var maxPixel = this.applyPaginationOffset(range.bottom, true) + 100;
      return Math.min(Math.max(minPixel, rowTop), maxPixel);
    }
  }, {
    key: "getFrameworkOverrides",
    value: function getFrameworkOverrides() {
      return this.beans.frameworkOverrides;
    }
  }, {
    key: "forEachGui",
    value: function forEachGui(gui, callback) {
      if (gui) {
        callback(gui);
      } else {
        this.allRowGuis.forEach(callback);
      }
    }
  }, {
    key: "onRowHeightChanged",
    value: function onRowHeightChanged(gui) {
      if (this.rowNode.rowHeight == null) {
        return;
      }

      var rowHeight = this.rowNode.rowHeight;
      var defaultRowHeight = this.beans.environment.getDefaultRowHeight();
      var isHeightFromFunc = this.gos.isGetRowHeightFunction();
      var heightFromFunc = isHeightFromFunc ? this.gos.getRowHeightForNode(this.rowNode).height : void 0;
      var lineHeight = heightFromFunc ? "".concat(Math.min(defaultRowHeight, heightFromFunc) - 2, "px") : void 0;
      this.forEachGui(gui, function (gui2) {
        gui2.element.style.height = "".concat(rowHeight, "px");

        if (lineHeight) {
          gui2.element.style.setProperty("--ag-line-height", lineHeight);
        }
      });
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(eventType, listener) {
      _get(_getPrototypeOf(_RowCtrl.prototype), "addEventListener", this).call(this, eventType, listener);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventType, listener) {
      _get(_getPrototypeOf(_RowCtrl.prototype), "removeEventListener", this).call(this, eventType, listener);
    } // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.

  }, {
    key: "destroyFirstPass",
    value: function destroyFirstPass() {
      var suppressAnimation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.active = false;

      if (!suppressAnimation && this.gos.isAnimateRows() && !this.isSticky()) {
        var rowStillVisibleJustNotInViewport = this.rowNode.rowTop != null;

        if (rowStillVisibleJustNotInViewport) {
          var rowTop = this.roundRowTopToBounds(this.rowNode.rowTop);
          this.setRowTop(rowTop);
        } else {
          this.allRowGuis.forEach(function (gui) {
            return gui.rowComp.addOrRemoveCssClass("ag-opacity-zero", true);
          });
        }
      }

      this.rowNode.setHovered(false);
      var event = this.createRowEvent(_Events.EVENT_VIRTUAL_ROW_REMOVED);
      this.dispatchEvent(event);
      this.beans.eventService.dispatchEvent(event);

      _get(_getPrototypeOf(_RowCtrl.prototype), "destroy", this).call(this);
    }
  }, {
    key: "destroySecondPass",
    value: function destroySecondPass() {
      this.allRowGuis.length = 0;
      this.stopEditing();

      var destroyCellCtrls = function destroyCellCtrls(ctrls) {
        ctrls.list.forEach(function (c) {
          return c.destroy();
        });
        return {
          list: [],
          map: {}
        };
      };

      this.centerCellCtrls = destroyCellCtrls(this.centerCellCtrls);
      this.leftCellCtrls = destroyCellCtrls(this.leftCellCtrls);
      this.rightCellCtrls = destroyCellCtrls(this.rightCellCtrls);
    }
  }, {
    key: "setFocusedClasses",
    value: function setFocusedClasses(gui) {
      var _this322 = this;

      this.forEachGui(gui, function (gui2) {
        gui2.rowComp.addOrRemoveCssClass("ag-row-focus", _this322.rowFocused);
        gui2.rowComp.addOrRemoveCssClass("ag-row-no-focus", !_this322.rowFocused);
      });
    }
  }, {
    key: "onCellFocusChanged",
    value: function onCellFocusChanged() {
      var rowFocused = this.beans.focusService.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);

      if (rowFocused !== this.rowFocused) {
        this.rowFocused = rowFocused;
        this.setFocusedClasses();
      }

      if (!rowFocused && this.editingRow) {
        this.stopEditing(false);
      }
    }
  }, {
    key: "onPaginationChanged",
    value: function onPaginationChanged() {
      var currentPage = this.beans.paginationProxy.getCurrentPage();

      if (this.paginationPage !== currentPage) {
        this.paginationPage = currentPage;
        this.onTopChanged();
      }

      this.refreshFirstAndLastRowStyles();
    }
  }, {
    key: "onTopChanged",
    value: function onTopChanged() {
      this.setRowTop(this.rowNode.rowTop);
    }
  }, {
    key: "onPaginationPixelOffsetChanged",
    value: function onPaginationPixelOffsetChanged() {
      this.onTopChanged();
    } // applies pagination offset, eg if on second page, and page height is 500px, then removes
    // 500px from the top position, so a row with rowTop 600px is displayed at location 100px.
    // reverse will take the offset away rather than add.

  }, {
    key: "applyPaginationOffset",
    value: function applyPaginationOffset(topPx) {
      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.rowNode.isRowPinned() || this.rowNode.sticky) {
        return topPx;
      }

      var pixelOffset = this.beans.paginationProxy.getPixelOffset();
      var multiplier = reverse ? 1 : -1;
      return topPx + pixelOffset * multiplier;
    }
  }, {
    key: "setRowTop",
    value: function setRowTop(pixels) {
      if (this.printLayout) {
        return;
      }

      if (_exists(pixels)) {
        var afterPaginationPixels = this.applyPaginationOffset(pixels);
        var skipScaling = this.rowNode.isRowPinned() || this.rowNode.sticky;
        var afterScalingPixels = skipScaling ? afterPaginationPixels : this.beans.rowContainerHeightService.getRealPixelPosition(afterPaginationPixels);
        var topPx = "".concat(afterScalingPixels, "px");
        this.setRowTopStyle(topPx);
      }
    } // the top needs to be set into the DOM element when the element is created, not updated afterwards.
    // otherwise the transition would not work, as it would be transitioning from zero (the unset value).
    // for example, suppose a row that is outside the viewport, then user does a filter to remove other rows
    // and this row now appears in the viewport, and the row moves up (ie it was under the viewport and not rendered,
    // but now is in the viewport) then a new RowComp is created, however it should have it's position initialised
    // to below the viewport, so the row will appear to animate up. if we didn't set the initial position at creation
    // time, the row would animate down (ie from position zero).

  }, {
    key: "getInitialRowTop",
    value: function getInitialRowTop(rowContainerType) {
      return this.suppressRowTransform ? this.getInitialRowTopShared(rowContainerType) : void 0;
    }
  }, {
    key: "getInitialTransform",
    value: function getInitialTransform(rowContainerType) {
      return this.suppressRowTransform ? void 0 : "translateY(".concat(this.getInitialRowTopShared(rowContainerType), ")");
    }
  }, {
    key: "getInitialRowTopShared",
    value: function getInitialRowTopShared(rowContainerType) {
      if (this.printLayout) {
        return "";
      }

      var rowTop;

      if (this.isSticky()) {
        rowTop = this.rowNode.stickyRowTop;
      } else {
        var pixels = this.slideInAnimation[rowContainerType] ? this.roundRowTopToBounds(this.rowNode.oldRowTop) : this.rowNode.rowTop;
        var afterPaginationPixels = this.applyPaginationOffset(pixels);
        rowTop = this.rowNode.isRowPinned() ? afterPaginationPixels : this.beans.rowContainerHeightService.getRealPixelPosition(afterPaginationPixels);
      }

      return rowTop + "px";
    }
  }, {
    key: "setRowTopStyle",
    value: function setRowTopStyle(topPx) {
      var _this323 = this;

      this.allRowGuis.forEach(function (gui) {
        return _this323.suppressRowTransform ? gui.rowComp.setTop(topPx) : gui.rowComp.setTransform("translateY(".concat(topPx, ")"));
      });
    }
  }, {
    key: "getRowNode",
    value: function getRowNode() {
      return this.rowNode;
    }
  }, {
    key: "getCellCtrl",
    value: function getCellCtrl(column) {
      var res = null;
      this.getAllCellCtrls().forEach(function (cellCtrl) {
        if (cellCtrl.getColumn() == column) {
          res = cellCtrl;
        }
      });

      if (res != null) {
        return res;
      }

      this.getAllCellCtrls().forEach(function (cellCtrl) {
        if (cellCtrl.getColSpanningList().indexOf(column) >= 0) {
          res = cellCtrl;
        }
      });
      return res;
    }
  }, {
    key: "onRowIndexChanged",
    value: function onRowIndexChanged() {
      if (this.rowNode.rowIndex != null) {
        this.onCellFocusChanged();
        this.updateRowIndexes();
        this.postProcessCss();
      }
    }
  }, {
    key: "getRowIndex",
    value: function getRowIndex() {
      return this.rowNode.getRowIndexString();
    }
  }, {
    key: "updateRowIndexes",
    value: function updateRowIndexes(gui) {
      var rowIndexStr = this.rowNode.getRowIndexString();
      var headerRowCount = this.beans.headerNavigationService.getHeaderRowCount() + this.beans.filterManager.getHeaderRowCount();
      var rowIsEven = this.rowNode.rowIndex % 2 === 0;
      var ariaRowIndex = headerRowCount + this.rowNode.rowIndex + 1;
      this.forEachGui(gui, function (c) {
        c.rowComp.setRowIndex(rowIndexStr);
        c.rowComp.addOrRemoveCssClass("ag-row-even", rowIsEven);
        c.rowComp.addOrRemoveCssClass("ag-row-odd", !rowIsEven);

        _setAriaRowIndex(c.element, ariaRowIndex);
      });
    }
  }]);

  return _RowCtrl;
}(_BeanStub2);

_RowCtrl.DOM_DATA_KEY_ROW_CTRL = "renderedRow";
var _RowCtrl2 = _RowCtrl; // community-modules/core/src/gridBodyComp/rowContainer/rowContainerEventsFeature.ts

var RowContainerEventsFeature =
/*#__PURE__*/
function (_BeanStub33) {
  "use strict";

  _inherits(RowContainerEventsFeature, _BeanStub33);

  function RowContainerEventsFeature(element) {
    var _this324;

    _classCallCheck(this, RowContainerEventsFeature);

    _this324 = _possibleConstructorReturn(this, _getPrototypeOf(RowContainerEventsFeature).call(this));
    _this324.element = element;
    return _this324;
  }

  _createClass(RowContainerEventsFeature, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.addKeyboardListeners();
      this.addMouseListeners();
      this.mockContextMenuForIPad();
    }
  }, {
    key: "addKeyboardListeners",
    value: function addKeyboardListeners() {
      var eventName = "keydown";
      var listener = this.processKeyboardEvent.bind(this, eventName);
      this.addManagedListener(this.element, eventName, listener);
    }
  }, {
    key: "addMouseListeners",
    value: function addMouseListeners() {
      var _this325 = this;

      var mouseDownEvent = _isEventSupported("touchstart") ? "touchstart" : "mousedown";
      var eventNames = ["dblclick", "contextmenu", "mouseover", "mouseout", "click", mouseDownEvent];
      eventNames.forEach(function (eventName) {
        var listener = _this325.processMouseEvent.bind(_this325, eventName);

        _this325.addManagedListener(_this325.element, eventName, listener);
      });
    }
  }, {
    key: "processMouseEvent",
    value: function processMouseEvent(eventName, mouseEvent) {
      if (!this.mouseEventService.isEventFromThisGrid(mouseEvent) || _isStopPropagationForAgGrid(mouseEvent)) {
        return;
      }

      var rowComp = this.getRowForEvent(mouseEvent);
      var cellCtrl = this.mouseEventService.getRenderedCellForEvent(mouseEvent);

      if (eventName === "contextmenu") {
        this.handleContextMenuMouseEvent(mouseEvent, void 0, rowComp, cellCtrl);
      } else {
        if (cellCtrl) {
          cellCtrl.onMouseEvent(eventName, mouseEvent);
        }

        if (rowComp) {
          rowComp.onMouseEvent(eventName, mouseEvent);
        }
      }
    }
  }, {
    key: "mockContextMenuForIPad",
    value: function mockContextMenuForIPad() {
      var _this326 = this;

      if (!_isIOSUserAgent()) {
        return;
      }

      var touchListener = new _TouchListener2(this.element);

      var longTapListener = function longTapListener(event) {
        var rowComp = _this326.getRowForEvent(event.touchEvent);

        var cellComp = _this326.mouseEventService.getRenderedCellForEvent(event.touchEvent);

        _this326.handleContextMenuMouseEvent(void 0, event.touchEvent, rowComp, cellComp);
      };

      this.addManagedListener(touchListener, _TouchListener2.EVENT_LONG_TAP, longTapListener);
      this.addDestroyFunc(function () {
        return touchListener.destroy();
      });
    }
  }, {
    key: "getRowForEvent",
    value: function getRowForEvent(event) {
      var sourceElement = event.target;

      while (sourceElement) {
        var rowCon = this.gos.getDomData(sourceElement, _RowCtrl2.DOM_DATA_KEY_ROW_CTRL);

        if (rowCon) {
          return rowCon;
        }

        sourceElement = sourceElement.parentElement;
      }

      return null;
    }
  }, {
    key: "handleContextMenuMouseEvent",
    value: function handleContextMenuMouseEvent(mouseEvent, touchEvent, rowComp, cellCtrl) {
      var rowNode = rowComp ? rowComp.getRowNode() : null;
      var column = cellCtrl ? cellCtrl.getColumn() : null;
      var value = null;

      if (column) {
        var event = mouseEvent ? mouseEvent : touchEvent;
        cellCtrl.dispatchCellContextMenuEvent(event != null ? event : null);
        value = this.valueService.getValue(column, rowNode);
      }

      var gridBodyCon = this.ctrlsService.getGridBodyCtrl();
      var anchorToElement = cellCtrl ? cellCtrl.getGui() : gridBodyCon.getGridBodyElement();
      this.menuService.showContextMenu({
        mouseEvent: mouseEvent,
        touchEvent: touchEvent,
        rowNode: rowNode,
        column: column,
        value: value,
        anchorToElement: anchorToElement
      });
    }
  }, {
    key: "getControlsForEventTarget",
    value: function getControlsForEventTarget(target) {
      return {
        cellCtrl: _getCtrlForEventTarget(this.gos, target, _CellCtrl2.DOM_DATA_KEY_CELL_CTRL),
        rowCtrl: _getCtrlForEventTarget(this.gos, target, _RowCtrl2.DOM_DATA_KEY_ROW_CTRL)
      };
    }
  }, {
    key: "processKeyboardEvent",
    value: function processKeyboardEvent(eventName, keyboardEvent) {
      var _this$getControlsForE = this.getControlsForEventTarget(keyboardEvent.target),
          cellCtrl = _this$getControlsForE.cellCtrl,
          rowCtrl = _this$getControlsForE.rowCtrl;

      if (keyboardEvent.defaultPrevented) {
        return;
      }

      if (cellCtrl) {
        this.processCellKeyboardEvent(cellCtrl, eventName, keyboardEvent);
      } else if (rowCtrl && rowCtrl.isFullWidth()) {
        this.processFullWidthRowKeyboardEvent(rowCtrl, eventName, keyboardEvent);
      }
    }
  }, {
    key: "processCellKeyboardEvent",
    value: function processCellKeyboardEvent(cellCtrl, eventName, keyboardEvent) {
      var rowNode = cellCtrl.getRowNode();
      var column = cellCtrl.getColumn();
      var editing = cellCtrl.isEditing();
      var gridProcessingAllowed = !_isUserSuppressingKeyboardEvent(this.gos, keyboardEvent, rowNode, column, editing);

      if (gridProcessingAllowed) {
        if (eventName === "keydown") {
          var wasScrollKey = !editing && this.navigationService.handlePageScrollingKey(keyboardEvent);

          if (!wasScrollKey) {
            cellCtrl.onKeyDown(keyboardEvent);
          }

          this.doGridOperations(keyboardEvent, cellCtrl.isEditing());

          if (_isEventFromPrintableCharacter(keyboardEvent)) {
            cellCtrl.processCharacter(keyboardEvent);
          }
        }
      }

      if (eventName === "keydown") {
        var cellKeyDownEvent = cellCtrl.createEvent(keyboardEvent, _Events.EVENT_CELL_KEY_DOWN);
        this.eventService.dispatchEvent(cellKeyDownEvent);
      }
    }
  }, {
    key: "processFullWidthRowKeyboardEvent",
    value: function processFullWidthRowKeyboardEvent(rowComp, eventName, keyboardEvent) {
      var rowNode = rowComp.getRowNode();
      var focusedCell = this.focusService.getFocusedCell();
      var column = focusedCell && focusedCell.column;
      var gridProcessingAllowed = !_isUserSuppressingKeyboardEvent(this.gos, keyboardEvent, rowNode, column, false);

      if (gridProcessingAllowed) {
        var key = keyboardEvent.key;

        if (eventName === "keydown") {
          switch (key) {
            case _KeyCode.PAGE_HOME:
            case _KeyCode.PAGE_END:
            case _KeyCode.PAGE_UP:
            case _KeyCode.PAGE_DOWN:
              this.navigationService.handlePageScrollingKey(keyboardEvent, true);
              break;

            case _KeyCode.UP:
            case _KeyCode.DOWN:
              rowComp.onKeyboardNavigate(keyboardEvent);
              break;

            case _KeyCode.TAB:
              rowComp.onTabKeyDown(keyboardEvent);
              break;

            default:
          }
        }
      }

      if (eventName === "keydown") {
        var cellKeyDownEvent = rowComp.createRowEvent(_Events.EVENT_CELL_KEY_DOWN, keyboardEvent);
        this.eventService.dispatchEvent(cellKeyDownEvent);
      }
    }
  }, {
    key: "doGridOperations",
    value: function doGridOperations(keyboardEvent, editing) {
      if (!keyboardEvent.ctrlKey && !keyboardEvent.metaKey) {
        return;
      }

      if (editing) {
        return;
      }

      if (!this.mouseEventService.isEventFromThisGrid(keyboardEvent)) {
        return;
      }

      var keyCode = _normaliseQwertyAzerty(keyboardEvent);

      if (keyCode === _KeyCode.A) {
        return this.onCtrlAndA(keyboardEvent);
      }

      if (keyCode === _KeyCode.C) {
        return this.onCtrlAndC(keyboardEvent);
      }

      if (keyCode === _KeyCode.D) {
        return this.onCtrlAndD(keyboardEvent);
      }

      if (keyCode === _KeyCode.V) {
        return this.onCtrlAndV(keyboardEvent);
      }

      if (keyCode === _KeyCode.X) {
        return this.onCtrlAndX(keyboardEvent);
      }

      if (keyCode === _KeyCode.Y) {
        return this.onCtrlAndY();
      }

      if (keyCode === _KeyCode.Z) {
        return this.onCtrlAndZ(keyboardEvent);
      }
    }
  }, {
    key: "onCtrlAndA",
    value: function onCtrlAndA(event) {
      var pinnedRowModel = this.pinnedRowModel,
          paginationProxy = this.paginationProxy,
          rangeService = this.rangeService;

      if (rangeService && paginationProxy.isRowsToRender()) {
        var _ref37 = [pinnedRowModel.isEmpty("top"), pinnedRowModel.isEmpty("bottom")],
            isEmptyPinnedTop = _ref37[0],
            isEmptyPinnedBottom = _ref37[1];
        var floatingStart = isEmptyPinnedTop ? null : "top";
        var floatingEnd;
        var rowEnd;

        if (isEmptyPinnedBottom) {
          floatingEnd = null;
          rowEnd = this.paginationProxy.getRowCount() - 1;
        } else {
          floatingEnd = "bottom";
          rowEnd = pinnedRowModel.getPinnedBottomRowData().length - 1;
        }

        var allDisplayedColumns = this.columnModel.getAllDisplayedColumns();

        if (_missingOrEmpty(allDisplayedColumns)) {
          return;
        }

        rangeService.setCellRange({
          rowStartIndex: 0,
          rowStartPinned: floatingStart,
          rowEndIndex: rowEnd,
          rowEndPinned: floatingEnd,
          columnStart: allDisplayedColumns[0],
          columnEnd: _last(allDisplayedColumns)
        });
      }

      event.preventDefault();
    }
  }, {
    key: "onCtrlAndC",
    value: function onCtrlAndC(event) {
      if (!this.clipboardService || this.gos.get("enableCellTextSelection")) {
        return;
      }

      var _this$getControlsForE2 = this.getControlsForEventTarget(event.target),
          cellCtrl = _this$getControlsForE2.cellCtrl,
          rowCtrl = _this$getControlsForE2.rowCtrl;

      if ((cellCtrl == null ? void 0 : cellCtrl.isEditing()) || (rowCtrl == null ? void 0 : rowCtrl.isEditing())) {
        return;
      }

      event.preventDefault();
      this.clipboardService.copyToClipboard();
    }
  }, {
    key: "onCtrlAndX",
    value: function onCtrlAndX(event) {
      if (!this.clipboardService || this.gos.get("enableCellTextSelection") || this.gos.get("suppressCutToClipboard")) {
        return;
      }

      var _this$getControlsForE3 = this.getControlsForEventTarget(event.target),
          cellCtrl = _this$getControlsForE3.cellCtrl,
          rowCtrl = _this$getControlsForE3.rowCtrl;

      if ((cellCtrl == null ? void 0 : cellCtrl.isEditing()) || (rowCtrl == null ? void 0 : rowCtrl.isEditing())) {
        return;
      }

      event.preventDefault();
      this.clipboardService.cutToClipboard(void 0, "ui");
    }
  }, {
    key: "onCtrlAndV",
    value: function onCtrlAndV(event) {
      var _this$getControlsForE4 = this.getControlsForEventTarget(event.target),
          cellCtrl = _this$getControlsForE4.cellCtrl,
          rowCtrl = _this$getControlsForE4.rowCtrl;

      if ((cellCtrl == null ? void 0 : cellCtrl.isEditing()) || (rowCtrl == null ? void 0 : rowCtrl.isEditing())) {
        return;
      }

      if (this.clipboardService && !this.gos.get("suppressClipboardPaste")) {
        this.clipboardService.pasteFromClipboard();
      }
    }
  }, {
    key: "onCtrlAndD",
    value: function onCtrlAndD(event) {
      if (this.clipboardService && !this.gos.get("suppressClipboardPaste")) {
        this.clipboardService.copyRangeDown();
      }

      event.preventDefault();
    }
  }, {
    key: "onCtrlAndZ",
    value: function onCtrlAndZ(event) {
      if (!this.gos.get("undoRedoCellEditing")) {
        return;
      }

      event.preventDefault();

      if (event.shiftKey) {
        this.undoRedoService.redo("ui");
      } else {
        this.undoRedoService.undo("ui");
      }
    }
  }, {
    key: "onCtrlAndY",
    value: function onCtrlAndY() {
      this.undoRedoService.redo("ui");
    }
  }]);

  return RowContainerEventsFeature;
}(_BeanStub2);

__decorateClass([_Autowired("mouseEventService")], RowContainerEventsFeature.prototype, "mouseEventService", 2);

__decorateClass([_Autowired("valueService")], RowContainerEventsFeature.prototype, "valueService", 2);

__decorateClass([_Autowired("menuService")], RowContainerEventsFeature.prototype, "menuService", 2);

__decorateClass([_Autowired("ctrlsService")], RowContainerEventsFeature.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("navigationService")], RowContainerEventsFeature.prototype, "navigationService", 2);

__decorateClass([_Autowired("focusService")], RowContainerEventsFeature.prototype, "focusService", 2);

__decorateClass([_Autowired("undoRedoService")], RowContainerEventsFeature.prototype, "undoRedoService", 2);

__decorateClass([_Autowired("columnModel")], RowContainerEventsFeature.prototype, "columnModel", 2);

__decorateClass([_Autowired("paginationProxy")], RowContainerEventsFeature.prototype, "paginationProxy", 2);

__decorateClass([_Autowired("pinnedRowModel")], RowContainerEventsFeature.prototype, "pinnedRowModel", 2);

__decorateClass([_Optional("rangeService")], RowContainerEventsFeature.prototype, "rangeService", 2);

__decorateClass([_Optional("clipboardService")], RowContainerEventsFeature.prototype, "clipboardService", 2);

__decorateClass([_PostConstruct], RowContainerEventsFeature.prototype, "postConstruct", 1); // community-modules/core/src/gridBodyComp/viewportSizeFeature.ts


var ViewportSizeFeature =
/*#__PURE__*/
function (_BeanStub34) {
  "use strict";

  _inherits(ViewportSizeFeature, _BeanStub34);

  function ViewportSizeFeature(centerContainerCtrl) {
    var _this327;

    _classCallCheck(this, ViewportSizeFeature);

    _this327 = _possibleConstructorReturn(this, _getPrototypeOf(ViewportSizeFeature).call(this));
    _this327.centerContainerCtrl = centerContainerCtrl;
    return _this327;
  }

  _createClass(ViewportSizeFeature, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this328 = this;

      this.ctrlsService.whenReady(function (p) {
        _this328.gridBodyCtrl = p.gridBodyCtrl;

        _this328.listenForResize();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_SCROLLBAR_WIDTH_CHANGED, this.onScrollbarWidthChanged.bind(this));
      this.addManagedPropertyListeners(["alwaysShowHorizontalScroll", "alwaysShowVerticalScroll"], function () {
        _this328.checkViewportAndScrolls();
      });
    }
  }, {
    key: "listenForResize",
    value: function listenForResize() {
      var _this329 = this;

      var listener = function listener() {
        return _this329.onCenterViewportResized();
      };

      this.centerContainerCtrl.registerViewportResizeListener(listener);
      this.gridBodyCtrl.registerBodyViewportResizeListener(listener);
    }
  }, {
    key: "onScrollbarWidthChanged",
    value: function onScrollbarWidthChanged() {
      this.checkViewportAndScrolls();
    }
  }, {
    key: "onCenterViewportResized",
    value: function onCenterViewportResized() {
      if (this.centerContainerCtrl.isViewportInTheDOMTree()) {
        this.keepPinnedColumnsNarrowerThanViewport();
        this.checkViewportAndScrolls();
        var newWidth = this.centerContainerCtrl.getCenterWidth();

        if (newWidth !== this.centerWidth) {
          this.centerWidth = newWidth;
          this.columnModel.refreshFlexedColumns({
            viewportWidth: this.centerWidth,
            updateBodyWidths: true,
            fireResizedEvent: true
          });
        }
      } else {
        this.bodyHeight = 0;
      }
    }
  }, {
    key: "keepPinnedColumnsNarrowerThanViewport",
    value: function keepPinnedColumnsNarrowerThanViewport() {
      var eBodyViewport = this.gridBodyCtrl.getBodyViewportElement();

      var bodyWidth = _getInnerWidth(eBodyViewport);

      if (bodyWidth <= 50) {
        return;
      }

      var columnsToRemove = this.getPinnedColumnsOverflowingViewport(bodyWidth - 50);
      var processUnpinnedColumns = this.gos.getCallback("processUnpinnedColumns");

      if (!columnsToRemove.length) {
        return;
      }

      if (processUnpinnedColumns) {
        var params = {
          columns: columnsToRemove,
          viewportWidth: bodyWidth
        };
        columnsToRemove = processUnpinnedColumns(params);
      }

      this.columnModel.setColumnsPinned(columnsToRemove, null, "viewportSizeFeature");
    }
  }, {
    key: "getPinnedColumnsOverflowingViewport",
    value: function getPinnedColumnsOverflowingViewport(viewportWidth) {
      var pinnedRightWidth = this.pinnedWidthService.getPinnedRightWidth();
      var pinnedLeftWidth = this.pinnedWidthService.getPinnedLeftWidth();
      var totalPinnedWidth = pinnedRightWidth + pinnedLeftWidth;

      if (totalPinnedWidth < viewportWidth) {
        return [];
      }

      var pinnedLeftColumns = _toConsumableArray(this.columnModel.getDisplayedLeftColumns());

      var pinnedRightColumns = _toConsumableArray(this.columnModel.getDisplayedRightColumns());

      var indexRight = 0;
      var indexLeft = 0;
      var totalWidthRemoved = 0;
      var columnsToRemove = [];
      var spaceNecessary = totalPinnedWidth - totalWidthRemoved - viewportWidth;

      while ((indexLeft < pinnedLeftColumns.length || indexRight < pinnedRightColumns.length) && spaceNecessary > 0) {
        if (indexRight < pinnedRightColumns.length) {
          var currentColumn = pinnedRightColumns[indexRight++];
          spaceNecessary -= currentColumn.getActualWidth();
          columnsToRemove.push(currentColumn);
        }

        if (indexLeft < pinnedLeftColumns.length && spaceNecessary > 0) {
          var _currentColumn = pinnedLeftColumns[indexLeft++];
          spaceNecessary -= _currentColumn.getActualWidth();
          columnsToRemove.push(_currentColumn);
        }
      }

      return columnsToRemove;
    } // gets called every time the viewport size changes. we use this to check visibility of scrollbars
    // in the grid panel, and also to check size and position of viewport for row and column virtualisation.

  }, {
    key: "checkViewportAndScrolls",
    value: function checkViewportAndScrolls() {
      this.updateScrollVisibleService();
      this.checkBodyHeight();
      this.onHorizontalViewportChanged();
      this.gridBodyCtrl.getScrollFeature().checkScrollLeft();
    }
  }, {
    key: "getBodyHeight",
    value: function getBodyHeight() {
      return this.bodyHeight;
    }
  }, {
    key: "checkBodyHeight",
    value: function checkBodyHeight() {
      var eBodyViewport = this.gridBodyCtrl.getBodyViewportElement();

      var bodyHeight = _getInnerHeight(eBodyViewport);

      if (this.bodyHeight !== bodyHeight) {
        this.bodyHeight = bodyHeight;
        var event = {
          type: _Events.EVENT_BODY_HEIGHT_CHANGED
        };
        this.eventService.dispatchEvent(event);
      }
    }
  }, {
    key: "updateScrollVisibleService",
    value: function updateScrollVisibleService() {
      this.updateScrollVisibleServiceImpl();
      setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
    }
  }, {
    key: "updateScrollVisibleServiceImpl",
    value: function updateScrollVisibleServiceImpl() {
      var params = {
        horizontalScrollShowing: this.isHorizontalScrollShowing(),
        verticalScrollShowing: this.gridBodyCtrl.isVerticalScrollShowing()
      };
      this.scrollVisibleService.setScrollsVisible(params);
    }
  }, {
    key: "isHorizontalScrollShowing",
    value: function isHorizontalScrollShowing() {
      return this.centerContainerCtrl.isHorizontalScrollShowing();
    } // this gets called whenever a change in the viewport, so we can inform column controller it has to work
    // out the virtual columns again. gets called from following locations:
    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged

  }, {
    key: "onHorizontalViewportChanged",
    value: function onHorizontalViewportChanged() {
      var scrollWidth = this.centerContainerCtrl.getCenterWidth();
      var scrollPosition = this.centerContainerCtrl.getViewportScrollLeft();
      this.columnModel.setViewportPosition(scrollWidth, scrollPosition);
    }
  }]);

  return ViewportSizeFeature;
}(_BeanStub2);

__decorateClass([_Autowired("ctrlsService")], ViewportSizeFeature.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("pinnedWidthService")], ViewportSizeFeature.prototype, "pinnedWidthService", 2);

__decorateClass([_Autowired("columnModel")], ViewportSizeFeature.prototype, "columnModel", 2);

__decorateClass([_Autowired("scrollVisibleService")], ViewportSizeFeature.prototype, "scrollVisibleService", 2);

__decorateClass([_PostConstruct], ViewportSizeFeature.prototype, "postConstruct", 1); // community-modules/core/src/gridBodyComp/rowContainer/setPinnedLeftWidthFeature.ts


var SetPinnedLeftWidthFeature =
/*#__PURE__*/
function (_BeanStub35) {
  "use strict";

  _inherits(SetPinnedLeftWidthFeature, _BeanStub35);

  function SetPinnedLeftWidthFeature(element) {
    var _this330;

    _classCallCheck(this, SetPinnedLeftWidthFeature);

    _this330 = _possibleConstructorReturn(this, _getPrototypeOf(SetPinnedLeftWidthFeature).call(this));
    _this330.element = element;
    return _this330;
  }

  _createClass(SetPinnedLeftWidthFeature, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.addManagedListener(this.eventService, _Events.EVENT_LEFT_PINNED_WIDTH_CHANGED, this.onPinnedLeftWidthChanged.bind(this));
    }
  }, {
    key: "onPinnedLeftWidthChanged",
    value: function onPinnedLeftWidthChanged() {
      var leftWidth = this.pinnedWidthService.getPinnedLeftWidth();
      var displayed = leftWidth > 0;

      _setDisplayed(this.element, displayed);

      _setFixedWidth(this.element, leftWidth);
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.pinnedWidthService.getPinnedLeftWidth();
    }
  }]);

  return SetPinnedLeftWidthFeature;
}(_BeanStub2);

__decorateClass([_Autowired("pinnedWidthService")], SetPinnedLeftWidthFeature.prototype, "pinnedWidthService", 2);

__decorateClass([_PostConstruct], SetPinnedLeftWidthFeature.prototype, "postConstruct", 1); // community-modules/core/src/gridBodyComp/rowContainer/setPinnedRightWidthFeature.ts


var SetPinnedRightWidthFeature =
/*#__PURE__*/
function (_BeanStub36) {
  "use strict";

  _inherits(SetPinnedRightWidthFeature, _BeanStub36);

  function SetPinnedRightWidthFeature(element) {
    var _this331;

    _classCallCheck(this, SetPinnedRightWidthFeature);

    _this331 = _possibleConstructorReturn(this, _getPrototypeOf(SetPinnedRightWidthFeature).call(this));
    _this331.element = element;
    return _this331;
  }

  _createClass(SetPinnedRightWidthFeature, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.addManagedListener(this.eventService, _Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED, this.onPinnedRightWidthChanged.bind(this));
    }
  }, {
    key: "onPinnedRightWidthChanged",
    value: function onPinnedRightWidthChanged() {
      var rightWidth = this.pinnedWidthService.getPinnedRightWidth();
      var displayed = rightWidth > 0;

      _setDisplayed(this.element, displayed);

      _setFixedWidth(this.element, rightWidth);
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.pinnedWidthService.getPinnedRightWidth();
    }
  }]);

  return SetPinnedRightWidthFeature;
}(_BeanStub2);

__decorateClass([_Autowired("pinnedWidthService")], SetPinnedRightWidthFeature.prototype, "pinnedWidthService", 2);

__decorateClass([_PostConstruct], SetPinnedRightWidthFeature.prototype, "postConstruct", 1); // community-modules/core/src/gridBodyComp/rowContainer/setHeightFeature.ts


var SetHeightFeature =
/*#__PURE__*/
function (_BeanStub37) {
  "use strict";

  _inherits(SetHeightFeature, _BeanStub37);

  function SetHeightFeature(eContainer, eViewport) {
    var _this332;

    _classCallCheck(this, SetHeightFeature);

    _this332 = _possibleConstructorReturn(this, _getPrototypeOf(SetHeightFeature).call(this));
    _this332.eContainer = eContainer;
    _this332.eViewport = eViewport;
    return _this332;
  }

  _createClass(SetHeightFeature, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.addManagedListener(this.eventService, _Events.EVENT_ROW_CONTAINER_HEIGHT_CHANGED, this.onHeightChanged.bind(this));
    }
  }, {
    key: "onHeightChanged",
    value: function onHeightChanged() {
      var height = this.maxDivHeightScaler.getUiContainerHeight();
      var heightString = height != null ? "".concat(height, "px") : "";
      this.eContainer.style.height = heightString;

      if (this.eViewport) {
        this.eViewport.style.height = heightString;
      }
    }
  }]);

  return SetHeightFeature;
}(_BeanStub2);

__decorateClass([_Autowired("rowContainerHeightService")], SetHeightFeature.prototype, "maxDivHeightScaler", 2);

__decorateClass([_PostConstruct], SetHeightFeature.prototype, "postConstruct", 1); // community-modules/core/src/gridBodyComp/rowContainer/dragListenerFeature.ts


var DragListenerFeature =
/*#__PURE__*/
function (_BeanStub38) {
  "use strict";

  _inherits(DragListenerFeature, _BeanStub38);

  function DragListenerFeature(eContainer) {
    var _this333;

    _classCallCheck(this, DragListenerFeature);

    _this333 = _possibleConstructorReturn(this, _getPrototypeOf(DragListenerFeature).call(this));
    _this333.eContainer = eContainer;
    return _this333;
  }

  _createClass(DragListenerFeature, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this334 = this;

      if (!this.rangeService) {
        return;
      }

      this.params = {
        eElement: this.eContainer,
        onDragStart: this.rangeService.onDragStart.bind(this.rangeService),
        onDragStop: this.rangeService.onDragStop.bind(this.rangeService),
        onDragging: this.rangeService.onDragging.bind(this.rangeService)
      };
      this.addManagedPropertyListener("enableRangeSelection", function (props) {
        var isEnabled = props.currentValue;

        if (isEnabled) {
          _this334.enableFeature();

          return;
        }

        _this334.disableFeature();
      });
      this.addDestroyFunc(function () {
        return _this334.disableFeature();
      });
      var isRangeSelection = this.gos.get("enableRangeSelection");

      if (isRangeSelection) {
        this.enableFeature();
      }
    }
  }, {
    key: "enableFeature",
    value: function enableFeature() {
      this.dragService.addDragSource(this.params);
    }
  }, {
    key: "disableFeature",
    value: function disableFeature() {
      this.dragService.removeDragSource(this.params);
    }
  }]);

  return DragListenerFeature;
}(_BeanStub2);

__decorateClass([_Autowired("dragService")], DragListenerFeature.prototype, "dragService", 2);

__decorateClass([_Optional("rangeService")], DragListenerFeature.prototype, "rangeService", 2);

__decorateClass([_PostConstruct], DragListenerFeature.prototype, "postConstruct", 1); // community-modules/core/src/gridBodyComp/centerWidthFeature.ts


var CenterWidthFeature =
/*#__PURE__*/
function (_BeanStub39) {
  "use strict";

  _inherits(CenterWidthFeature, _BeanStub39);

  function CenterWidthFeature(callback) {
    var _this335;

    var addSpacer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, CenterWidthFeature);

    _this335 = _possibleConstructorReturn(this, _getPrototypeOf(CenterWidthFeature).call(this));
    _this335.callback = callback;
    _this335.addSpacer = addSpacer;
    return _this335;
  }

  _createClass(CenterWidthFeature, [{
    key: "postConstruct",
    value: function postConstruct() {
      var listener = this.setWidth.bind(this);
      this.addManagedPropertyListener("domLayout", listener);
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_CONTAINER_WIDTH_CHANGED, listener);
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
      this.addManagedListener(this.eventService, _Events.EVENT_LEFT_PINNED_WIDTH_CHANGED, listener);

      if (this.addSpacer) {
        this.addManagedListener(this.eventService, _Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED, listener);
        this.addManagedListener(this.eventService, _Events.EVENT_SCROLL_VISIBILITY_CHANGED, listener);
        this.addManagedListener(this.eventService, _Events.EVENT_SCROLLBAR_WIDTH_CHANGED, listener);
      }

      this.setWidth();
    }
  }, {
    key: "setWidth",
    value: function setWidth() {
      var columnModel = this.columnModel;
      var printLayout = this.gos.isDomLayout("print");
      var centerWidth = columnModel.getBodyContainerWidth();
      var leftWidth = columnModel.getDisplayedColumnsLeftWidth();
      var rightWidth = columnModel.getDisplayedColumnsRightWidth();
      var totalWidth;

      if (printLayout) {
        totalWidth = centerWidth + leftWidth + rightWidth;
      } else {
        totalWidth = centerWidth;

        if (this.addSpacer) {
          var relevantWidth = this.gos.get("enableRtl") ? leftWidth : rightWidth;

          if (relevantWidth === 0 && this.scrollVisibleService.isVerticalScrollShowing()) {
            totalWidth += this.gos.getScrollbarWidth();
          }
        }
      }

      this.callback(totalWidth);
    }
  }]);

  return CenterWidthFeature;
}(_BeanStub2);

__decorateClass([_Autowired("columnModel")], CenterWidthFeature.prototype, "columnModel", 2);

__decorateClass([_Autowired("scrollVisibleService")], CenterWidthFeature.prototype, "scrollVisibleService", 2);

__decorateClass([_PostConstruct], CenterWidthFeature.prototype, "postConstruct", 1); // community-modules/core/src/gridBodyComp/rowContainer/rowContainerCtrl.ts


var _RowContainerName =
/* @__PURE__ */
function (RowContainerName2) {
  RowContainerName2["LEFT"] = "left";
  RowContainerName2["RIGHT"] = "right";
  RowContainerName2["CENTER"] = "center";
  RowContainerName2["FULL_WIDTH"] = "fullWidth";
  RowContainerName2["TOP_LEFT"] = "topLeft";
  RowContainerName2["TOP_RIGHT"] = "topRight";
  RowContainerName2["TOP_CENTER"] = "topCenter";
  RowContainerName2["TOP_FULL_WIDTH"] = "topFullWidth";
  RowContainerName2["STICKY_TOP_LEFT"] = "stickyTopLeft";
  RowContainerName2["STICKY_TOP_RIGHT"] = "stickyTopRight";
  RowContainerName2["STICKY_TOP_CENTER"] = "stickyTopCenter";
  RowContainerName2["STICKY_TOP_FULL_WIDTH"] = "stickyTopFullWidth";
  RowContainerName2["STICKY_BOTTOM_LEFT"] = "stickyBottomLeft";
  RowContainerName2["STICKY_BOTTOM_RIGHT"] = "stickyBottomRight";
  RowContainerName2["STICKY_BOTTOM_CENTER"] = "stickyBottomCenter";
  RowContainerName2["STICKY_BOTTOM_FULL_WIDTH"] = "stickyBottomFullWidth";
  RowContainerName2["BOTTOM_LEFT"] = "bottomLeft";
  RowContainerName2["BOTTOM_RIGHT"] = "bottomRight";
  RowContainerName2["BOTTOM_CENTER"] = "bottomCenter";
  RowContainerName2["BOTTOM_FULL_WIDTH"] = "bottomFullWidth";
  return RowContainerName2;
}(_RowContainerName || {});

var _RowContainerType =
/* @__PURE__ */
function (RowContainerType3) {
  RowContainerType3["LEFT"] = "left";
  RowContainerType3["RIGHT"] = "right";
  RowContainerType3["CENTER"] = "center";
  RowContainerType3["FULL_WIDTH"] = "fullWidth";
  return RowContainerType3;
}(_RowContainerType || {});

function _getRowContainerTypeForName(name) {
  switch (name) {
    case "center"
    /* CENTER */
    :
    case "topCenter"
    /* TOP_CENTER */
    :
    case "stickyTopCenter"
    /* STICKY_TOP_CENTER */
    :
    case "bottomCenter"
    /* BOTTOM_CENTER */
    :
    case "stickyBottomCenter"
    /* STICKY_BOTTOM_CENTER */
    :
      return "center"
      /* CENTER */
      ;

    case "left"
    /* LEFT */
    :
    case "topLeft"
    /* TOP_LEFT */
    :
    case "stickyTopLeft"
    /* STICKY_TOP_LEFT */
    :
    case "bottomLeft"
    /* BOTTOM_LEFT */
    :
    case "stickyBottomLeft"
    /* STICKY_BOTTOM_LEFT */
    :
      return "left"
      /* LEFT */
      ;

    case "right"
    /* RIGHT */
    :
    case "topRight"
    /* TOP_RIGHT */
    :
    case "stickyTopRight"
    /* STICKY_TOP_RIGHT */
    :
    case "bottomRight"
    /* BOTTOM_RIGHT */
    :
    case "stickyBottomRight"
    /* STICKY_BOTTOM_RIGHT */
    :
      return "right"
      /* RIGHT */
      ;

    case "fullWidth"
    /* FULL_WIDTH */
    :
    case "topFullWidth"
    /* TOP_FULL_WIDTH */
    :
    case "stickyTopFullWidth"
    /* STICKY_TOP_FULL_WIDTH */
    :
    case "bottomFullWidth"
    /* BOTTOM_FULL_WIDTH */
    :
    case "stickyBottomFullWidth"
    /* STICKY_BOTTOM_FULL_WIDTH */
    :
      return "fullWidth"
      /* FULL_WIDTH */
      ;

    default:
      throw Error("Invalid Row Container Type");
  }
}

var ContainerCssClasses = _convertToMap([["center"
/* CENTER */
, "ag-center-cols-container"], ["left"
/* LEFT */
, "ag-pinned-left-cols-container"], ["right"
/* RIGHT */
, "ag-pinned-right-cols-container"], ["fullWidth"
/* FULL_WIDTH */
, "ag-full-width-container"], ["topCenter"
/* TOP_CENTER */
, "ag-floating-top-container"], ["topLeft"
/* TOP_LEFT */
, "ag-pinned-left-floating-top"], ["topRight"
/* TOP_RIGHT */
, "ag-pinned-right-floating-top"], ["topFullWidth"
/* TOP_FULL_WIDTH */
, "ag-floating-top-full-width-container"], ["stickyTopCenter"
/* STICKY_TOP_CENTER */
, "ag-sticky-top-container"], ["stickyTopLeft"
/* STICKY_TOP_LEFT */
, "ag-pinned-left-sticky-top"], ["stickyTopRight"
/* STICKY_TOP_RIGHT */
, "ag-pinned-right-sticky-top"], ["stickyTopFullWidth"
/* STICKY_TOP_FULL_WIDTH */
, "ag-sticky-top-full-width-container"], ["stickyBottomCenter"
/* STICKY_BOTTOM_CENTER */
, "ag-sticky-bottom-container"], ["stickyBottomLeft"
/* STICKY_BOTTOM_LEFT */
, "ag-pinned-left-sticky-bottom"], ["stickyBottomRight"
/* STICKY_BOTTOM_RIGHT */
, "ag-pinned-right-sticky-bottom"], ["stickyBottomFullWidth"
/* STICKY_BOTTOM_FULL_WIDTH */
, "ag-sticky-bottom-full-width-container"], ["bottomCenter"
/* BOTTOM_CENTER */
, "ag-floating-bottom-container"], ["bottomLeft"
/* BOTTOM_LEFT */
, "ag-pinned-left-floating-bottom"], ["bottomRight"
/* BOTTOM_RIGHT */
, "ag-pinned-right-floating-bottom"], ["bottomFullWidth"
/* BOTTOM_FULL_WIDTH */
, "ag-floating-bottom-full-width-container"]]);

var ViewportCssClasses = _convertToMap([["center"
/* CENTER */
, "ag-center-cols-viewport"], ["topCenter"
/* TOP_CENTER */
, "ag-floating-top-viewport"], ["stickyTopCenter"
/* STICKY_TOP_CENTER */
, "ag-sticky-top-viewport"], ["bottomCenter"
/* BOTTOM_CENTER */
, "ag-floating-bottom-viewport"], ["stickyBottomCenter"
/* STICKY_BOTTOM_CENTER */
, "ag-sticky-bottom-viewport"]]);

var _RowContainerCtrl =
/*#__PURE__*/
function (_BeanStub40) {
  "use strict";

  _inherits(_RowContainerCtrl, _BeanStub40);

  function _RowContainerCtrl(name) {
    var _this336;

    _classCallCheck(this, _RowContainerCtrl);

    _this336 = _possibleConstructorReturn(this, _getPrototypeOf(_RowContainerCtrl).call(this));
    _this336.visible = true; // Maintaining a constant reference enables optimization in React.

    _this336.EMPTY_CTRLS = [];
    _this336.name = name;
    _this336.isFullWithContainer = _this336.name === "topFullWidth"
    /* TOP_FULL_WIDTH */
    || _this336.name === "stickyTopFullWidth"
    /* STICKY_TOP_FULL_WIDTH */
    || _this336.name === "stickyBottomFullWidth"
    /* STICKY_BOTTOM_FULL_WIDTH */
    || _this336.name === "bottomFullWidth"
    /* BOTTOM_FULL_WIDTH */
    || _this336.name === "fullWidth"
    /* FULL_WIDTH */
    ;
    return _this336;
  }

  _createClass(_RowContainerCtrl, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this337 = this;

      this.enableRtl = this.gos.get("enableRtl");
      this.forContainers(["center"
      /* CENTER */
      ], function () {
        return _this337.viewportSizeFeature = _this337.createManagedBean(new ViewportSizeFeature(_this337));
      });
    }
  }, {
    key: "registerWithCtrlsService",
    value: function registerWithCtrlsService() {
      switch (this.name) {
        case "fullWidth"
        /* FULL_WIDTH */
        :
        case "topFullWidth"
        /* TOP_FULL_WIDTH */
        :
        case "stickyTopFullWidth"
        /* STICKY_TOP_FULL_WIDTH */
        :
        case "bottomFullWidth"
        /* BOTTOM_FULL_WIDTH */
        :
        case "stickyBottomFullWidth"
        /* STICKY_BOTTOM_FULL_WIDTH */
        :
          return;

        default:
          {
            this.ctrlsService.register(this.name, this);
          }
      }
    }
  }, {
    key: "forContainers",
    value: function forContainers(names, callback) {
      if (names.indexOf(this.name) >= 0) {
        callback();
      }
    }
  }, {
    key: "getContainerElement",
    value: function getContainerElement() {
      return this.eContainer;
    }
  }, {
    key: "getViewportSizeFeature",
    value: function getViewportSizeFeature() {
      return this.viewportSizeFeature;
    }
  }, {
    key: "setComp",
    value: function setComp(view, eContainer, eViewport) {
      var _this338 = this;

      this.comp = view;
      this.eContainer = eContainer;
      this.eViewport = eViewport;
      this.createManagedBean(new RowContainerEventsFeature(this.eContainer));
      this.addPreventScrollWhileDragging();
      this.listenOnDomOrder();
      this.stopHScrollOnPinnedRows();
      var allTopNoFW = ["topCenter"
      /* TOP_CENTER */
      , "topLeft"
      /* TOP_LEFT */
      , "topRight"
      /* TOP_RIGHT */
      ];
      var allStickyTopNoFW = ["stickyTopCenter"
      /* STICKY_TOP_CENTER */
      , "stickyTopLeft"
      /* STICKY_TOP_LEFT */
      , "stickyTopRight"
      /* STICKY_TOP_RIGHT */
      ];
      var allStickyBottomNoFW = ["stickyBottomCenter"
      /* STICKY_BOTTOM_CENTER */
      , "stickyBottomLeft"
      /* STICKY_BOTTOM_LEFT */
      , "stickyBottomRight"
      /* STICKY_BOTTOM_RIGHT */
      ];
      var allBottomNoFW = ["bottomCenter"
      /* BOTTOM_CENTER */
      , "bottomLeft"
      /* BOTTOM_LEFT */
      , "bottomRight"
      /* BOTTOM_RIGHT */
      ];
      var allMiddleNoFW = ["center"
      /* CENTER */
      , "left"
      /* LEFT */
      , "right"
      /* RIGHT */
      ];
      var allNoFW = [].concat(allTopNoFW, allBottomNoFW, allMiddleNoFW, allStickyTopNoFW, allStickyBottomNoFW);
      var allMiddle = ["center"
      /* CENTER */
      , "left"
      /* LEFT */
      , "right"
      /* RIGHT */
      , "fullWidth"
      /* FULL_WIDTH */
      ];
      var allCenter = ["center"
      /* CENTER */
      , "topCenter"
      /* TOP_CENTER */
      , "stickyTopCenter"
      /* STICKY_TOP_CENTER */
      , "bottomCenter"
      /* BOTTOM_CENTER */
      , "stickyBottomCenter"
      /* STICKY_BOTTOM_CENTER */
      ];
      var allLeft = ["left"
      /* LEFT */
      , "bottomLeft"
      /* BOTTOM_LEFT */
      , "topLeft"
      /* TOP_LEFT */
      , "stickyTopLeft"
      /* STICKY_TOP_LEFT */
      , "stickyBottomLeft"
      /* STICKY_BOTTOM_LEFT */
      ];
      var allRight = ["right"
      /* RIGHT */
      , "bottomRight"
      /* BOTTOM_RIGHT */
      , "topRight"
      /* TOP_RIGHT */
      , "stickyTopRight"
      /* STICKY_TOP_RIGHT */
      , "stickyBottomRight"
      /* STICKY_BOTTOM_RIGHT */
      ];
      this.forContainers(allLeft, function () {
        _this338.pinnedWidthFeature = _this338.createManagedBean(new SetPinnedLeftWidthFeature(_this338.eContainer));

        _this338.addManagedListener(_this338.eventService, _Events.EVENT_LEFT_PINNED_WIDTH_CHANGED, function () {
          return _this338.onPinnedWidthChanged();
        });
      });
      this.forContainers(allRight, function () {
        _this338.pinnedWidthFeature = _this338.createManagedBean(new SetPinnedRightWidthFeature(_this338.eContainer));

        _this338.addManagedListener(_this338.eventService, _Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED, function () {
          return _this338.onPinnedWidthChanged();
        });
      });
      this.forContainers(allMiddle, function () {
        return _this338.createManagedBean(new SetHeightFeature(_this338.eContainer, _this338.name === "center"
        /* CENTER */
        ? eViewport : void 0));
      });
      this.forContainers(allNoFW, function () {
        return _this338.createManagedBean(new DragListenerFeature(_this338.eContainer));
      });
      this.forContainers(allCenter, function () {
        return _this338.createManagedBean(new CenterWidthFeature(function (width) {
          return _this338.comp.setContainerWidth("".concat(width, "px"));
        }));
      });
      this.addListeners();
      this.registerWithCtrlsService();
    }
  }, {
    key: "addListeners",
    value: function addListeners() {
      var _this339 = this;

      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_CHANGED, function () {
        return _this339.onDisplayedColumnsChanged();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, function () {
        return _this339.onDisplayedColumnsWidthChanged();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_ROWS_CHANGED, function (params) {
        return _this339.onDisplayedRowsChanged(params.afterScroll);
      });
      this.onDisplayedColumnsChanged();
      this.onDisplayedColumnsWidthChanged();
      this.onDisplayedRowsChanged();
    }
  }, {
    key: "listenOnDomOrder",
    value: function listenOnDomOrder() {
      var _this340 = this;

      var allStickyContainers = ["stickyTopCenter"
      /* STICKY_TOP_CENTER */
      , "stickyTopLeft"
      /* STICKY_TOP_LEFT */
      , "stickyTopRight"
      /* STICKY_TOP_RIGHT */
      , "stickyTopFullWidth"
      /* STICKY_TOP_FULL_WIDTH */
      , "stickyBottomCenter"
      /* STICKY_BOTTOM_CENTER */
      , "stickyBottomLeft"
      /* STICKY_BOTTOM_LEFT */
      , "stickyBottomRight"
      /* STICKY_BOTTOM_RIGHT */
      , "stickyBottomFullWidth"
      /* STICKY_BOTTOM_FULL_WIDTH */
      ];
      var isStickContainer = allStickyContainers.indexOf(this.name) >= 0;

      if (isStickContainer) {
        this.comp.setDomOrder(true);
        return;
      }

      var listener = function listener() {
        var isEnsureDomOrder = _this340.gos.get("ensureDomOrder");

        var isPrintLayout = _this340.gos.isDomLayout("print");

        _this340.comp.setDomOrder(isEnsureDomOrder || isPrintLayout);
      };

      this.addManagedPropertyListener("domLayout", listener);
      listener();
    } // when editing a pinned row, if the cell is half outside the scrollable area, the browser can
    // scroll the column into view. we do not want this, the pinned sections should never scroll.
    // so we listen to scrolls on these containers and reset the scroll if we find one.

  }, {
    key: "stopHScrollOnPinnedRows",
    value: function stopHScrollOnPinnedRows() {
      var _this341 = this;

      this.forContainers(["topCenter"
      /* TOP_CENTER */
      , "stickyTopCenter"
      /* STICKY_TOP_CENTER */
      , "bottomCenter"
      /* BOTTOM_CENTER */
      , "stickyBottomCenter"
      /* STICKY_BOTTOM_CENTER */
      ], function () {
        var resetScrollLeft = function resetScrollLeft() {
          return _this341.eViewport.scrollLeft = 0;
        };

        _this341.addManagedListener(_this341.eViewport, "scroll", resetScrollLeft);
      });
    }
  }, {
    key: "onDisplayedColumnsChanged",
    value: function onDisplayedColumnsChanged() {
      var _this342 = this;

      this.forContainers(["center"
      /* CENTER */
      ], function () {
        return _this342.onHorizontalViewportChanged();
      });
    }
  }, {
    key: "onDisplayedColumnsWidthChanged",
    value: function onDisplayedColumnsWidthChanged() {
      var _this343 = this;

      this.forContainers(["center"
      /* CENTER */
      ], function () {
        return _this343.onHorizontalViewportChanged();
      });
    } // this methods prevents the grid views from being scrolled while the dragService is being used
    // eg. the view should not scroll up and down while dragging rows using the rowDragComp.

  }, {
    key: "addPreventScrollWhileDragging",
    value: function addPreventScrollWhileDragging() {
      var _this344 = this;

      var preventScroll = function preventScroll(e) {
        if (_this344.dragService.isDragging()) {
          if (e.cancelable) {
            e.preventDefault();
          }
        }
      };

      this.eContainer.addEventListener("touchmove", preventScroll, {
        passive: false
      });
      this.addDestroyFunc(function () {
        return _this344.eContainer.removeEventListener("touchmove", preventScroll);
      });
    } // this gets called whenever a change in the viewport, so we can inform column controller it has to work
    // out the virtual columns again. gets called from following locations:
    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged

  }, {
    key: "onHorizontalViewportChanged",
    value: function onHorizontalViewportChanged() {
      var afterScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var scrollWidth = this.getCenterWidth();
      var scrollPosition = this.getCenterViewportScrollLeft();
      this.columnModel.setViewportPosition(scrollWidth, scrollPosition, afterScroll);
    }
  }, {
    key: "getCenterWidth",
    value: function getCenterWidth() {
      return _getInnerWidth(this.eViewport);
    }
  }, {
    key: "getCenterViewportScrollLeft",
    value: function getCenterViewportScrollLeft() {
      return _getScrollLeft(this.eViewport, this.enableRtl);
    }
  }, {
    key: "registerViewportResizeListener",
    value: function registerViewportResizeListener(listener) {
      var unsubscribeFromResize = this.resizeObserverService.observeResize(this.eViewport, listener);
      this.addDestroyFunc(function () {
        return unsubscribeFromResize();
      });
    }
  }, {
    key: "isViewportInTheDOMTree",
    value: function isViewportInTheDOMTree() {
      return _isInDOM(this.eViewport);
    }
  }, {
    key: "getViewportScrollLeft",
    value: function getViewportScrollLeft() {
      return _getScrollLeft(this.eViewport, this.enableRtl);
    }
  }, {
    key: "isHorizontalScrollShowing",
    value: function isHorizontalScrollShowing() {
      var isAlwaysShowHorizontalScroll = this.gos.get("alwaysShowHorizontalScroll");
      return isAlwaysShowHorizontalScroll || _isHorizontalScrollShowing(this.eViewport);
    }
  }, {
    key: "getViewportElement",
    value: function getViewportElement() {
      return this.eViewport;
    }
  }, {
    key: "setContainerTranslateX",
    value: function setContainerTranslateX(amount) {
      this.eContainer.style.transform = "translateX(".concat(amount, "px)");
    }
  }, {
    key: "getHScrollPosition",
    value: function getHScrollPosition() {
      var res = {
        left: this.eViewport.scrollLeft,
        right: this.eViewport.scrollLeft + this.eViewport.offsetWidth
      };
      return res;
    }
  }, {
    key: "setCenterViewportScrollLeft",
    value: function setCenterViewportScrollLeft(value) {
      _setScrollLeft(this.eViewport, value, this.enableRtl);
    }
  }, {
    key: "isContainerVisible",
    value: function isContainerVisible() {
      var pinned = _RowContainerCtrl.getPinned(this.name);

      return !pinned || !!this.pinnedWidthFeature && this.pinnedWidthFeature.getWidth() > 0;
    }
  }, {
    key: "onPinnedWidthChanged",
    value: function onPinnedWidthChanged() {
      var visible = this.isContainerVisible();

      if (this.visible != visible) {
        this.visible = visible;
        this.onDisplayedRowsChanged();
      }
    }
  }, {
    key: "onDisplayedRowsChanged",
    value: function onDisplayedRowsChanged() {
      var _this345 = this;

      var afterScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var rows = this.getRowCtrls();

      if (!this.visible || rows.length === 0) {
        this.comp.setRowCtrls({
          rowCtrls: this.EMPTY_CTRLS
        });
        return;
      }

      var printLayout = this.gos.isDomLayout("print");
      var embedFullWidthRows = this.gos.get("embedFullWidthRows");
      var embedFW = embedFullWidthRows || printLayout;
      var rowsThisContainer = rows.filter(function (rowCtrl) {
        var fullWidthRow = rowCtrl.isFullWidth();
        var match = _this345.isFullWithContainer ? !embedFW && fullWidthRow : embedFW || !fullWidthRow;
        return match;
      });
      this.comp.setRowCtrls({
        rowCtrls: rowsThisContainer,
        useFlushSync: afterScroll
      });
    }
  }, {
    key: "getRowCtrls",
    value: function getRowCtrls() {
      switch (this.name) {
        case "topCenter"
        /* TOP_CENTER */
        :
        case "topLeft"
        /* TOP_LEFT */
        :
        case "topRight"
        /* TOP_RIGHT */
        :
        case "topFullWidth"
        /* TOP_FULL_WIDTH */
        :
          return this.rowRenderer.getTopRowCtrls();

        case "stickyTopCenter"
        /* STICKY_TOP_CENTER */
        :
        case "stickyTopLeft"
        /* STICKY_TOP_LEFT */
        :
        case "stickyTopRight"
        /* STICKY_TOP_RIGHT */
        :
        case "stickyTopFullWidth"
        /* STICKY_TOP_FULL_WIDTH */
        :
          return this.rowRenderer.getStickyTopRowCtrls();

        case "stickyBottomCenter"
        /* STICKY_BOTTOM_CENTER */
        :
        case "stickyBottomLeft"
        /* STICKY_BOTTOM_LEFT */
        :
        case "stickyBottomRight"
        /* STICKY_BOTTOM_RIGHT */
        :
        case "stickyBottomFullWidth"
        /* STICKY_BOTTOM_FULL_WIDTH */
        :
          return this.rowRenderer.getStickyBottomRowCtrls();

        case "bottomCenter"
        /* BOTTOM_CENTER */
        :
        case "bottomLeft"
        /* BOTTOM_LEFT */
        :
        case "bottomRight"
        /* BOTTOM_RIGHT */
        :
        case "bottomFullWidth"
        /* BOTTOM_FULL_WIDTH */
        :
          return this.rowRenderer.getBottomRowCtrls();

        default:
          return this.rowRenderer.getCentreRowCtrls();
      }
    }
  }], [{
    key: "getRowContainerCssClasses",
    value: function getRowContainerCssClasses(name) {
      var containerClass = ContainerCssClasses.get(name);
      var viewportClass = ViewportCssClasses.get(name);
      return {
        container: containerClass,
        viewport: viewportClass
      };
    }
  }, {
    key: "getPinned",
    value: function getPinned(name) {
      switch (name) {
        case "bottomLeft"
        /* BOTTOM_LEFT */
        :
        case "topLeft"
        /* TOP_LEFT */
        :
        case "stickyTopLeft"
        /* STICKY_TOP_LEFT */
        :
        case "stickyBottomLeft"
        /* STICKY_BOTTOM_LEFT */
        :
        case "left"
        /* LEFT */
        :
          return "left";

        case "bottomRight"
        /* BOTTOM_RIGHT */
        :
        case "topRight"
        /* TOP_RIGHT */
        :
        case "stickyTopRight"
        /* STICKY_TOP_RIGHT */
        :
        case "stickyBottomRight"
        /* STICKY_BOTTOM_RIGHT */
        :
        case "right"
        /* RIGHT */
        :
          return "right";

        default:
          return null;
      }
    }
  }]);

  return _RowContainerCtrl;
}(_BeanStub2);

__decorateClass([_Autowired("dragService")], _RowContainerCtrl.prototype, "dragService", 2);

__decorateClass([_Autowired("ctrlsService")], _RowContainerCtrl.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("columnModel")], _RowContainerCtrl.prototype, "columnModel", 2);

__decorateClass([_Autowired("resizeObserverService")], _RowContainerCtrl.prototype, "resizeObserverService", 2);

__decorateClass([_Autowired("rowRenderer")], _RowContainerCtrl.prototype, "rowRenderer", 2);

__decorateClass([_PostConstruct], _RowContainerCtrl.prototype, "postConstruct", 1);

var _RowContainerCtrl2 = _RowContainerCtrl; // community-modules/core/src/gridBodyComp/gridBodyComp.ts

var GRID_BODY_TEMPLATE =
/* html */
"<div class=\"ag-root ag-unselectable\" role=\"treegrid\">\n        <ag-header-root ref=\"gridHeader\"></ag-header-root>\n        <div class=\"ag-floating-top\" ref=\"eTop\" role=\"presentation\">\n            <ag-row-container ref=\"topLeftContainer\" name=\"".concat("topLeft"
/* TOP_LEFT */
, "\"></ag-row-container>\n            <ag-row-container ref=\"topCenterContainer\" name=\"", "topCenter"
/* TOP_CENTER */
, "\"></ag-row-container>\n            <ag-row-container ref=\"topRightContainer\" name=\"", "topRight"
/* TOP_RIGHT */
, "\"></ag-row-container>\n            <ag-row-container ref=\"topFullWidthContainer\" name=\"", "topFullWidth"
/* TOP_FULL_WIDTH */
, "\"></ag-row-container>\n        </div>\n        <div class=\"ag-body\" ref=\"eBody\" role=\"presentation\">\n            <div class=\"ag-body-viewport\" ref=\"eBodyViewport\" role=\"presentation\">\n                <ag-row-container ref=\"leftContainer\" name=\"", "left"
/* LEFT */
, "\"></ag-row-container>\n                <ag-row-container ref=\"centerContainer\" name=\"", "center"
/* CENTER */
, "\"></ag-row-container>\n                <ag-row-container ref=\"rightContainer\" name=\"", "right"
/* RIGHT */
, "\"></ag-row-container>\n                <ag-row-container ref=\"fullWidthContainer\" name=\"", "fullWidth"
/* FULL_WIDTH */
, "\"></ag-row-container>\n            </div>\n            <ag-fake-vertical-scroll></ag-fake-vertical-scroll>\n        </div>\n        <div class=\"ag-sticky-top\" ref=\"eStickyTop\" role=\"presentation\">\n            <ag-row-container ref=\"stickyTopLeftContainer\" name=\"", "stickyTopLeft"
/* STICKY_TOP_LEFT */
, "\"></ag-row-container>\n            <ag-row-container ref=\"stickyTopCenterContainer\" name=\"", "stickyTopCenter"
/* STICKY_TOP_CENTER */
, "\"></ag-row-container>\n            <ag-row-container ref=\"stickyTopRightContainer\" name=\"", "stickyTopRight"
/* STICKY_TOP_RIGHT */
, "\"></ag-row-container>\n            <ag-row-container ref=\"stickyTopFullWidthContainer\" name=\"", "stickyTopFullWidth"
/* STICKY_TOP_FULL_WIDTH */
, "\"></ag-row-container>\n        </div>\n        <div class=\"ag-sticky-bottom\" ref=\"eStickyBottom\" role=\"presentation\">\n            <ag-row-container ref=\"stickyBottomLeftContainer\" name=\"", "stickyBottomLeft"
/* STICKY_BOTTOM_LEFT */
, "\"></ag-row-container>\n            <ag-row-container ref=\"stickyBottomCenterContainer\" name=\"", "stickyBottomCenter"
/* STICKY_BOTTOM_CENTER */
, "\"></ag-row-container>\n            <ag-row-container ref=\"stickyBottomRightContainer\" name=\"", "stickyBottomRight"
/* STICKY_BOTTOM_RIGHT */
, "\"></ag-row-container>\n            <ag-row-container ref=\"stickyBottomFullWidthContainer\" name=\"", "stickyBottomFullWidth"
/* STICKY_BOTTOM_FULL_WIDTH */
, "\"></ag-row-container>\n        </div>\n        <div class=\"ag-floating-bottom\" ref=\"eBottom\" role=\"presentation\">\n            <ag-row-container ref=\"bottomLeftContainer\" name=\"", "bottomLeft"
/* BOTTOM_LEFT */
, "\"></ag-row-container>\n            <ag-row-container ref=\"bottomCenterContainer\" name=\"", "bottomCenter"
/* BOTTOM_CENTER */
, "\"></ag-row-container>\n            <ag-row-container ref=\"bottomRightContainer\" name=\"", "bottomRight"
/* BOTTOM_RIGHT */
, "\"></ag-row-container>\n            <ag-row-container ref=\"bottomFullWidthContainer\" name=\"", "bottomFullWidth"
/* BOTTOM_FULL_WIDTH */
, "\"></ag-row-container>\n        </div>\n        <ag-fake-horizontal-scroll></ag-fake-horizontal-scroll>\n        <ag-overlay-wrapper></ag-overlay-wrapper>\n    </div>");

var _GridBodyComp =
/*#__PURE__*/
function (_Component27) {
  "use strict";

  _inherits(_GridBodyComp, _Component27);

  function _GridBodyComp() {
    _classCallCheck(this, _GridBodyComp);

    return _possibleConstructorReturn(this, _getPrototypeOf(_GridBodyComp).call(this, GRID_BODY_TEMPLATE));
  }

  _createClass(_GridBodyComp, [{
    key: "init",
    value: function init() {
      var _this346 = this;

      var setHeight = function setHeight(height, element) {
        var heightString = "".concat(height, "px");
        element.style.minHeight = heightString;
        element.style.height = heightString;
      };

      var compProxy = {
        setRowAnimationCssOnBodyViewport: function setRowAnimationCssOnBodyViewport(cssClass, animate) {
          return _this346.setRowAnimationCssOnBodyViewport(cssClass, animate);
        },
        setColumnCount: function setColumnCount(count) {
          return _setAriaColCount(_this346.getGui(), count);
        },
        setRowCount: function setRowCount(count) {
          return _setAriaRowCount(_this346.getGui(), count);
        },
        setTopHeight: function setTopHeight(height) {
          return setHeight(height, _this346.eTop);
        },
        setBottomHeight: function setBottomHeight(height) {
          return setHeight(height, _this346.eBottom);
        },
        setTopDisplay: function setTopDisplay(display) {
          return _this346.eTop.style.display = display;
        },
        setBottomDisplay: function setBottomDisplay(display) {
          return _this346.eBottom.style.display = display;
        },
        setStickyTopHeight: function setStickyTopHeight(height) {
          return _this346.eStickyTop.style.height = height;
        },
        setStickyTopTop: function setStickyTopTop(top) {
          return _this346.eStickyTop.style.top = top;
        },
        setStickyTopWidth: function setStickyTopWidth(width) {
          return _this346.eStickyTop.style.width = width;
        },
        setStickyBottomHeight: function setStickyBottomHeight(height) {
          return _this346.eStickyBottom.style.height = height;
        },
        setStickyBottomBottom: function setStickyBottomBottom(bottom) {
          return _this346.eStickyBottom.style.bottom = bottom;
        },
        setStickyBottomWidth: function setStickyBottomWidth(width) {
          return _this346.eStickyBottom.style.width = width;
        },
        setColumnMovingCss: function setColumnMovingCss(cssClass, flag) {
          return _this346.addOrRemoveCssClass(cssClass, flag);
        },
        updateLayoutClasses: function updateLayoutClasses(cssClass, params) {
          var classLists = [_this346.eBodyViewport.classList, _this346.eBody.classList];
          classLists.forEach(function (classList) {
            classList.toggle("ag-layout-auto-height"
            /* AUTO_HEIGHT */
            , params.autoHeight);
            classList.toggle("ag-layout-normal"
            /* NORMAL */
            , params.normal);
            classList.toggle("ag-layout-print"
            /* PRINT */
            , params.print);
          });

          _this346.addOrRemoveCssClass("ag-layout-auto-height"
          /* AUTO_HEIGHT */
          , params.autoHeight);

          _this346.addOrRemoveCssClass("ag-layout-normal"
          /* NORMAL */
          , params.normal);

          _this346.addOrRemoveCssClass("ag-layout-print"
          /* PRINT */
          , params.print);
        },
        setAlwaysVerticalScrollClass: function setAlwaysVerticalScrollClass(cssClass, on) {
          return _this346.eBodyViewport.classList.toggle(CSS_CLASS_FORCE_VERTICAL_SCROLL, on);
        },
        registerBodyViewportResizeListener: function registerBodyViewportResizeListener(listener) {
          var unsubscribeFromResize = _this346.resizeObserverService.observeResize(_this346.eBodyViewport, listener);

          _this346.addDestroyFunc(function () {
            return unsubscribeFromResize();
          });
        },
        setPinnedTopBottomOverflowY: function setPinnedTopBottomOverflowY(overflow) {
          return _this346.eTop.style.overflowY = _this346.eBottom.style.overflowY = overflow;
        },
        setCellSelectableCss: function setCellSelectableCss(cssClass, selectable) {
          [_this346.eTop, _this346.eBodyViewport, _this346.eBottom].forEach(function (ct) {
            return ct.classList.toggle(cssClass, selectable);
          });
        },
        setBodyViewportWidth: function setBodyViewportWidth(width) {
          return _this346.eBodyViewport.style.width = width;
        }
      };
      this.ctrl = this.createManagedBean(new _GridBodyCtrl());
      this.ctrl.setComp(compProxy, this.getGui(), this.eBodyViewport, this.eTop, this.eBottom, this.eStickyTop, this.eStickyBottom);

      if (this.rangeService && this.gos.get("enableRangeSelection") || this.gos.get("rowSelection") === "multiple") {
        _setAriaMultiSelectable(this.getGui(), true);
      }
    }
  }, {
    key: "setRowAnimationCssOnBodyViewport",
    value: function setRowAnimationCssOnBodyViewport(cssClass, animateRows) {
      var bodyViewportClassList = this.eBodyViewport.classList;
      bodyViewportClassList.toggle("ag-row-animation"
      /* ANIMATION_ON */
      , animateRows);
      bodyViewportClassList.toggle("ag-row-no-animation"
      /* ANIMATION_OFF */
      , !animateRows);
    }
  }, {
    key: "getFloatingTopBottom",
    value: function getFloatingTopBottom() {
      return [this.eTop, this.eBottom];
    }
  }]);

  return _GridBodyComp;
}(_Component2);

__decorateClass([_Autowired("resizeObserverService")], _GridBodyComp.prototype, "resizeObserverService", 2);

__decorateClass([_Optional("rangeService")], _GridBodyComp.prototype, "rangeService", 2);

__decorateClass([_RefSelector("eBodyViewport")], _GridBodyComp.prototype, "eBodyViewport", 2);

__decorateClass([_RefSelector("eStickyTop")], _GridBodyComp.prototype, "eStickyTop", 2);

__decorateClass([_RefSelector("eStickyBottom")], _GridBodyComp.prototype, "eStickyBottom", 2);

__decorateClass([_RefSelector("eTop")], _GridBodyComp.prototype, "eTop", 2);

__decorateClass([_RefSelector("eBottom")], _GridBodyComp.prototype, "eBottom", 2);

__decorateClass([_RefSelector("gridHeader")], _GridBodyComp.prototype, "headerRootComp", 2);

__decorateClass([_RefSelector("eBody")], _GridBodyComp.prototype, "eBody", 2);

__decorateClass([_PostConstruct], _GridBodyComp.prototype, "init", 1); // community-modules/core/src/gridBodyComp/scrollVisibleService.ts


var _ScrollVisibleService =
/*#__PURE__*/
function (_BeanStub41) {
  "use strict";

  _inherits(_ScrollVisibleService, _BeanStub41);

  function _ScrollVisibleService() {
    _classCallCheck(this, _ScrollVisibleService);

    return _possibleConstructorReturn(this, _getPrototypeOf(_ScrollVisibleService).apply(this, arguments));
  }

  _createClass(_ScrollVisibleService, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
    }
  }, {
    key: "onDisplayedColumnsChanged",
    value: function onDisplayedColumnsChanged() {
      this.update();
    }
  }, {
    key: "onDisplayedColumnsWidthChanged",
    value: function onDisplayedColumnsWidthChanged() {
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      var _this347 = this;

      if (this.columnAnimationService.isActive()) {
        this.columnAnimationService.executeLaterVMTurn(function () {
          _this347.columnAnimationService.executeLaterVMTurn(function () {
            return _this347.updateImpl();
          });
        });
      } else {
        this.updateImpl();
      }
    }
  }, {
    key: "updateImpl",
    value: function updateImpl() {
      var centerRowCtrl = this.ctrlsService.get("center");

      if (!centerRowCtrl || this.columnAnimationService.isActive()) {
        return;
      }

      var params = {
        horizontalScrollShowing: centerRowCtrl.isHorizontalScrollShowing(),
        verticalScrollShowing: this.isVerticalScrollShowing()
      };
      this.setScrollsVisible(params);
    }
  }, {
    key: "setScrollsVisible",
    value: function setScrollsVisible(params) {
      var atLeastOneDifferent = this.horizontalScrollShowing !== params.horizontalScrollShowing || this.verticalScrollShowing !== params.verticalScrollShowing;

      if (atLeastOneDifferent) {
        this.horizontalScrollShowing = params.horizontalScrollShowing;
        this.verticalScrollShowing = params.verticalScrollShowing;
        var event = {
          type: _Events.EVENT_SCROLL_VISIBILITY_CHANGED
        };
        this.eventService.dispatchEvent(event);
      }
    } // used by pagination service - to know page height

  }, {
    key: "isHorizontalScrollShowing",
    value: function isHorizontalScrollShowing() {
      return this.horizontalScrollShowing;
    } // used by header container

  }, {
    key: "isVerticalScrollShowing",
    value: function isVerticalScrollShowing() {
      return this.verticalScrollShowing;
    }
  }]);

  return _ScrollVisibleService;
}(_BeanStub2);

__decorateClass([_Autowired("ctrlsService")], _ScrollVisibleService.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("columnAnimationService")], _ScrollVisibleService.prototype, "columnAnimationService", 2);

__decorateClass([_PostConstruct], _ScrollVisibleService.prototype, "postConstruct", 1);

_ScrollVisibleService = __decorateClass([_Bean("scrollVisibleService")], _ScrollVisibleService); // community-modules/core/src/gridBodyComp/mouseEventService.ts

var _MouseEventService2 =
/*#__PURE__*/
function (_BeanStub42) {
  "use strict";

  _inherits(_MouseEventService, _BeanStub42);

  function _MouseEventService() {
    var _this348;

    _classCallCheck(this, _MouseEventService);

    _this348 = _possibleConstructorReturn(this, _getPrototypeOf(_MouseEventService).apply(this, arguments));
    _this348.gridInstanceId = _MouseEventService2.gridInstanceSequence.next();
    return _this348;
  } // we put the instance id onto the main DOM element. this is used for events, when grids are inside grids,
  // so the grid can work out if the even came from this grid or a grid inside this one. see the ctrl+v logic
  // for where this is used.


  _createClass(_MouseEventService, [{
    key: "stampTopLevelGridCompWithGridInstance",
    value: function stampTopLevelGridCompWithGridInstance(eGridDiv) {
      eGridDiv[_MouseEventService2.GRID_DOM_KEY] = this.gridInstanceId;
    }
  }, {
    key: "getRenderedCellForEvent",
    value: function getRenderedCellForEvent(event) {
      return _getCtrlForEventTarget(this.gos, event.target, _CellCtrl2.DOM_DATA_KEY_CELL_CTRL);
    } // walks the path of the event, and returns true if this grid is the first one that it finds. if doing
    // master / detail grids, and a child grid is found, then it returns false. this stops things like copy/paste
    // getting executed on many grids at the same time.

  }, {
    key: "isEventFromThisGrid",
    value: function isEventFromThisGrid(event) {
      var res = this.isElementInThisGrid(event.target);
      return res;
    }
  }, {
    key: "isElementInThisGrid",
    value: function isElementInThisGrid(element) {
      var pointer = element;

      while (pointer) {
        var instanceId = pointer[_MouseEventService2.GRID_DOM_KEY];

        if (_exists(instanceId)) {
          var eventFromThisGrid = instanceId === this.gridInstanceId;
          return eventFromThisGrid;
        }

        pointer = pointer.parentElement;
      }

      return false;
    }
  }, {
    key: "getCellPositionForEvent",
    value: function getCellPositionForEvent(event) {
      var cellComp = this.getRenderedCellForEvent(event);
      return cellComp ? cellComp.getCellPosition() : null;
    }
  }, {
    key: "getNormalisedPosition",
    value: function getNormalisedPosition(event) {
      var gridPanelHasScrolls = this.gos.isDomLayout("normal");
      var e = event;
      var x;
      var y;

      if (e.clientX != null || e.clientY != null) {
        x = e.clientX;
        y = e.clientY;
      } else {
        x = e.x;
        y = e.y;
      }

      if (gridPanelHasScrolls) {
        var gridBodyCon = this.ctrlsService.getGridBodyCtrl();
        var vRange = gridBodyCon.getScrollFeature().getVScrollPosition();
        var hRange = gridBodyCon.getScrollFeature().getHScrollPosition();
        x += hRange.left;
        y += vRange.top;
      }

      return {
        x: x,
        y: y
      };
    }
  }]);

  return _MouseEventService;
}(_BeanStub2);

_MouseEventService2.gridInstanceSequence = new _NumberSequence();
_MouseEventService2.GRID_DOM_KEY = "__ag_grid_instance";

__decorateClass([_Autowired("ctrlsService")], _MouseEventService2.prototype, "ctrlsService", 2);

_MouseEventService2 = __decorateClass([_Bean("mouseEventService")], _MouseEventService2); // community-modules/core/src/gridBodyComp/navigationService.ts

var _NavigationService =
/*#__PURE__*/
function (_BeanStub43) {
  "use strict";

  _inherits(_NavigationService, _BeanStub43);

  function _NavigationService() {
    var _this349;

    _classCallCheck(this, _NavigationService);

    _this349 = _possibleConstructorReturn(this, _getPrototypeOf(_NavigationService).call(this));
    _this349.onPageDown = _throttle(_this349.onPageDown, 100);
    _this349.onPageUp = _throttle(_this349.onPageUp, 100);
    return _this349;
  }

  _createClass(_NavigationService, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this350 = this;

      this.ctrlsService.whenReady(function (p) {
        _this350.gridBodyCon = p.gridBodyCtrl;
      });
    }
  }, {
    key: "handlePageScrollingKey",
    value: function handlePageScrollingKey(event) {
      var fromFullWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var key = event.key;
      var alt = event.altKey;
      var ctrl = event.ctrlKey || event.metaKey;
      var rangeServiceShouldHandleShift = !!this.rangeService && event.shiftKey;
      var currentCell = this.mouseEventService.getCellPositionForEvent(event);
      var processed = false;

      switch (key) {
        case _KeyCode.PAGE_HOME:
        case _KeyCode.PAGE_END:
          if (!ctrl && !alt) {
            this.onHomeOrEndKey(key);
            processed = true;
          }

          break;

        case _KeyCode.LEFT:
        case _KeyCode.RIGHT:
        case _KeyCode.UP:
        case _KeyCode.DOWN:
          if (!currentCell) {
            return false;
          }

          if (ctrl && !alt && !rangeServiceShouldHandleShift) {
            this.onCtrlUpDownLeftRight(key, currentCell);
            processed = true;
          }

          break;

        case _KeyCode.PAGE_DOWN:
        case _KeyCode.PAGE_UP:
          if (!ctrl && !alt) {
            processed = this.handlePageUpDown(key, currentCell, fromFullWidth);
          }

          break;
      }

      if (processed) {
        event.preventDefault();
      }

      return processed;
    }
  }, {
    key: "handlePageUpDown",
    value: function handlePageUpDown(key, currentCell, fromFullWidth) {
      if (fromFullWidth) {
        currentCell = this.focusService.getFocusedCell();
      }

      if (!currentCell) {
        return false;
      }

      if (key === _KeyCode.PAGE_UP) {
        this.onPageUp(currentCell);
      } else {
        this.onPageDown(currentCell);
      }

      return true;
    }
  }, {
    key: "navigateTo",
    value: function navigateTo(navigateParams) {
      var _a;

      var scrollIndex = navigateParams.scrollIndex,
          scrollType = navigateParams.scrollType,
          scrollColumn = navigateParams.scrollColumn,
          focusIndex = navigateParams.focusIndex,
          focusColumn = navigateParams.focusColumn;

      if (_exists(scrollColumn) && !scrollColumn.isPinned()) {
        this.gridBodyCon.getScrollFeature().ensureColumnVisible(scrollColumn);
      }

      if (_exists(scrollIndex)) {
        this.gridBodyCon.getScrollFeature().ensureIndexVisible(scrollIndex, scrollType);
      }

      if (!navigateParams.isAsync) {
        this.gridBodyCon.getScrollFeature().ensureIndexVisible(focusIndex);
      }

      this.focusService.setFocusedCell({
        rowIndex: focusIndex,
        column: focusColumn,
        rowPinned: null,
        forceBrowserFocus: true
      });
      (_a = this.rangeService) == null ? void 0 : _a.setRangeToCell({
        rowIndex: focusIndex,
        rowPinned: null,
        column: focusColumn
      });
    } // this method is throttled, see the `constructor`

  }, {
    key: "onPageDown",
    value: function onPageDown(gridCell) {
      var gridBodyCon = this.ctrlsService.getGridBodyCtrl();
      var scrollPosition = gridBodyCon.getScrollFeature().getVScrollPosition();
      var pixelsInOnePage = this.getViewportHeight();
      var pagingPixelOffset = this.paginationProxy.getPixelOffset();
      var currentPageBottomPixel = scrollPosition.top + pixelsInOnePage;
      var currentPageBottomRow = this.paginationProxy.getRowIndexAtPixel(currentPageBottomPixel + pagingPixelOffset);

      if (this.columnModel.isAutoRowHeightActive()) {
        this.navigateToNextPageWithAutoHeight(gridCell, currentPageBottomRow);
      } else {
        this.navigateToNextPage(gridCell, currentPageBottomRow);
      }
    } // this method is throttled, see the `constructor`

  }, {
    key: "onPageUp",
    value: function onPageUp(gridCell) {
      var gridBodyCon = this.ctrlsService.getGridBodyCtrl();
      var scrollPosition = gridBodyCon.getScrollFeature().getVScrollPosition();
      var pagingPixelOffset = this.paginationProxy.getPixelOffset();
      var currentPageTopPixel = scrollPosition.top;
      var currentPageTopRow = this.paginationProxy.getRowIndexAtPixel(currentPageTopPixel + pagingPixelOffset);

      if (this.columnModel.isAutoRowHeightActive()) {
        this.navigateToNextPageWithAutoHeight(gridCell, currentPageTopRow, true);
      } else {
        this.navigateToNextPage(gridCell, currentPageTopRow, true);
      }
    }
  }, {
    key: "navigateToNextPage",
    value: function navigateToNextPage(gridCell, scrollIndex) {
      var up = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var pixelsInOnePage = this.getViewportHeight();
      var firstRow = this.paginationProxy.getPageFirstRow();
      var lastRow = this.paginationProxy.getPageLastRow();
      var pagingPixelOffset = this.paginationProxy.getPixelOffset();
      var currentRowNode = this.paginationProxy.getRow(gridCell.rowIndex);
      var rowPixelDiff = up ? (currentRowNode == null ? void 0 : currentRowNode.rowHeight) - pixelsInOnePage - pagingPixelOffset : pixelsInOnePage - pagingPixelOffset;
      var nextCellPixel = (currentRowNode == null ? void 0 : currentRowNode.rowTop) + rowPixelDiff;
      var focusIndex = this.paginationProxy.getRowIndexAtPixel(nextCellPixel + pagingPixelOffset);

      if (focusIndex === gridCell.rowIndex) {
        var diff = up ? -1 : 1;
        scrollIndex = focusIndex = gridCell.rowIndex + diff;
      }

      var scrollType;

      if (up) {
        scrollType = "bottom";

        if (focusIndex < firstRow) {
          focusIndex = firstRow;
        }

        if (scrollIndex < firstRow) {
          scrollIndex = firstRow;
        }
      } else {
        scrollType = "top";

        if (focusIndex > lastRow) {
          focusIndex = lastRow;
        }

        if (scrollIndex > lastRow) {
          scrollIndex = lastRow;
        }
      }

      if (this.isRowTallerThanView(focusIndex)) {
        scrollIndex = focusIndex;
        scrollType = "top";
      }

      this.navigateTo({
        scrollIndex: scrollIndex,
        scrollType: scrollType,
        scrollColumn: null,
        focusIndex: focusIndex,
        focusColumn: gridCell.column
      });
    }
  }, {
    key: "navigateToNextPageWithAutoHeight",
    value: function navigateToNextPageWithAutoHeight(gridCell, scrollIndex) {
      var _this351 = this;

      var up = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      this.navigateTo({
        scrollIndex: scrollIndex,
        scrollType: up ? "bottom" : "top",
        scrollColumn: null,
        focusIndex: scrollIndex,
        focusColumn: gridCell.column
      });
      setTimeout(function () {
        var focusIndex = _this351.getNextFocusIndexForAutoHeight(gridCell, up);

        _this351.navigateTo({
          scrollIndex: scrollIndex,
          scrollType: up ? "bottom" : "top",
          scrollColumn: null,
          focusIndex: focusIndex,
          focusColumn: gridCell.column,
          isAsync: true
        });
      }, 50);
    }
  }, {
    key: "getNextFocusIndexForAutoHeight",
    value: function getNextFocusIndexForAutoHeight(gridCell) {
      var up = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var _a;

      var step = up ? -1 : 1;
      var pixelsInOnePage = this.getViewportHeight();
      var lastRowIndex = this.paginationProxy.getPageLastRow();
      var pixelSum = 0;
      var currentIndex = gridCell.rowIndex;

      while (currentIndex >= 0 && currentIndex <= lastRowIndex) {
        var currentCell = this.paginationProxy.getRow(currentIndex);

        if (currentCell) {
          var currentCellHeight = (_a = currentCell.rowHeight) != null ? _a : 0;

          if (pixelSum + currentCellHeight > pixelsInOnePage) {
            break;
          }

          pixelSum += currentCellHeight;
        }

        currentIndex += step;
      }

      return Math.max(0, Math.min(currentIndex, lastRowIndex));
    }
  }, {
    key: "getViewportHeight",
    value: function getViewportHeight() {
      var _this$ctrlsService$ge3 = this.ctrlsService.getParams(),
          gridBodyCtrl = _this$ctrlsService$ge3.gridBodyCtrl,
          center = _this$ctrlsService$ge3.center;

      var scrollPosition = gridBodyCtrl.getScrollFeature().getVScrollPosition();
      var scrollbarWidth = this.gos.getScrollbarWidth();
      var pixelsInOnePage = scrollPosition.bottom - scrollPosition.top;

      if (center.isHorizontalScrollShowing()) {
        pixelsInOnePage -= scrollbarWidth;
      }

      return pixelsInOnePage;
    }
  }, {
    key: "isRowTallerThanView",
    value: function isRowTallerThanView(rowIndex) {
      var rowNode = this.paginationProxy.getRow(rowIndex);

      if (!rowNode) {
        return false;
      }

      var rowHeight = rowNode.rowHeight;

      if (typeof rowHeight !== "number") {
        return false;
      }

      return rowHeight > this.getViewportHeight();
    }
  }, {
    key: "onCtrlUpDownLeftRight",
    value: function onCtrlUpDownLeftRight(key, gridCell) {
      var cellToFocus = this.cellNavigationService.getNextCellToFocus(key, gridCell, true);
      var rowIndex = cellToFocus.rowIndex,
          column = cellToFocus.column;
      this.navigateTo({
        scrollIndex: rowIndex,
        scrollType: null,
        scrollColumn: column,
        focusIndex: rowIndex,
        focusColumn: column
      });
    } // home brings focus to top left cell, end brings focus to bottom right, grid scrolled to bring
    // same cell into view (which means either scroll all the way up, or all the way down).

  }, {
    key: "onHomeOrEndKey",
    value: function onHomeOrEndKey(key) {
      var homeKey = key === _KeyCode.PAGE_HOME;
      var allColumns = this.columnModel.getAllDisplayedColumns();
      var columnToSelect = homeKey ? allColumns[0] : _last(allColumns);
      var scrollIndex = homeKey ? this.paginationProxy.getPageFirstRow() : this.paginationProxy.getPageLastRow();
      this.navigateTo({
        scrollIndex: scrollIndex,
        scrollType: null,
        scrollColumn: columnToSelect,
        focusIndex: scrollIndex,
        focusColumn: columnToSelect
      });
    } // result of keyboard event

  }, {
    key: "onTabKeyDown",
    value: function onTabKeyDown(previous, keyboardEvent) {
      var backwards = keyboardEvent.shiftKey;
      var movedToNextCell = this.tabToNextCellCommon(previous, backwards, keyboardEvent);

      if (movedToNextCell !== false) {
        if (movedToNextCell) {
          keyboardEvent.preventDefault();
        }

        return;
      }

      if (backwards) {
        var _previous$getRowPosit = previous.getRowPosition(),
            rowIndex = _previous$getRowPosit.rowIndex,
            rowPinned = _previous$getRowPosit.rowPinned;

        var firstRow = rowPinned ? rowIndex === 0 : rowIndex === this.paginationProxy.getPageFirstRow();

        if (firstRow) {
          if (this.gos.get("headerHeight") === 0 || this.gos.get("suppressHeaderFocus")) {
            this.focusService.focusNextGridCoreContainer(true, true);
          } else {
            keyboardEvent.preventDefault();
            this.focusService.focusPreviousFromFirstCell(keyboardEvent);
          }
        }
      } else {
        if (previous instanceof _CellCtrl2) {
          previous.focusCell(true);
        }

        if (this.focusService.focusNextGridCoreContainer(backwards)) {
          keyboardEvent.preventDefault();
        }
      }
    } // comes from API

  }, {
    key: "tabToNextCell",
    value: function tabToNextCell(backwards, event) {
      var focusedCell = this.focusService.getFocusedCell();

      if (!focusedCell) {
        return false;
      }

      var cellOrRow = this.getCellByPosition(focusedCell);

      if (!cellOrRow) {
        cellOrRow = this.rowRenderer.getRowByPosition(focusedCell);

        if (!cellOrRow || !cellOrRow.isFullWidth()) {
          return false;
        }
      }

      return !!this.tabToNextCellCommon(cellOrRow, backwards, event);
    }
  }, {
    key: "tabToNextCellCommon",
    value: function tabToNextCellCommon(previous, backwards, event) {
      var editing = previous.isEditing();

      if (!editing && previous instanceof _CellCtrl2) {
        var cell = previous;
        var row = cell.getRowCtrl();

        if (row) {
          editing = row.isEditing();
        }
      }

      var res;

      if (editing) {
        if (this.gos.get("editType") === "fullRow") {
          res = this.moveToNextEditingRow(previous, backwards, event);
        } else {
          res = this.moveToNextEditingCell(previous, backwards, event);
        }
      } else {
        res = this.moveToNextCellNotEditing(previous, backwards);
      }

      if (res === null) {
        return res;
      }

      return res || !!this.focusService.getFocusedHeader();
    } // returns null if no navigation should be performed

  }, {
    key: "moveToNextEditingCell",
    value: function moveToNextEditingCell(previousCell, backwards) {
      var event = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var previousPos = previousCell.getCellPosition();
      previousCell.getGui().focus();
      previousCell.stopEditing();
      var nextCell = this.findNextCellToFocusOn(previousPos, backwards, true);

      if (nextCell === false) {
        return null;
      }

      if (nextCell == null) {
        return false;
      }

      nextCell.startEditing(null, true, event);
      nextCell.focusCell(false);
      return true;
    } // returns null if no navigation should be performed

  }, {
    key: "moveToNextEditingRow",
    value: function moveToNextEditingRow(previousCell, backwards) {
      var event = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var previousPos = previousCell.getCellPosition();
      var nextCell = this.findNextCellToFocusOn(previousPos, backwards, true);

      if (nextCell === false) {
        return null;
      }

      if (nextCell == null) {
        return false;
      }

      var nextPos = nextCell.getCellPosition();
      var previousEditable = this.isCellEditable(previousPos);
      var nextEditable = this.isCellEditable(nextPos);
      var rowsMatch = nextPos && previousPos.rowIndex === nextPos.rowIndex && previousPos.rowPinned === nextPos.rowPinned;

      if (previousEditable) {
        previousCell.setFocusOutOnEditor();
      }

      if (!rowsMatch) {
        var pRow = previousCell.getRowCtrl();
        pRow.stopEditing();
        var nRow = nextCell.getRowCtrl();
        nRow.startRowEditing(void 0, void 0, event);
      }

      if (nextEditable) {
        nextCell.setFocusInOnEditor();
        nextCell.focusCell();
      } else {
        nextCell.focusCell(true);
      }

      return true;
    } // returns null if no navigation should be performed

  }, {
    key: "moveToNextCellNotEditing",
    value: function moveToNextCellNotEditing(previousCell, backwards) {
      var displayedColumns = this.columnModel.getAllDisplayedColumns();
      var cellPos;

      if (previousCell instanceof _RowCtrl2) {
        cellPos = __spreadProps(__spreadValues({}, previousCell.getRowPosition()), {
          column: backwards ? displayedColumns[0] : _last(displayedColumns)
        });
      } else {
        cellPos = previousCell.getCellPosition();
      }

      var nextCell = this.findNextCellToFocusOn(cellPos, backwards, false);

      if (nextCell === false) {
        return null;
      }

      if (nextCell instanceof _CellCtrl2) {
        nextCell.focusCell(true);
      } else if (nextCell) {
        return this.tryToFocusFullWidthRow(nextCell.getRowPosition(), backwards);
      }

      return _exists(nextCell);
    }
    /**
     * called by the cell, when tab is pressed while editing.
     * @return: RenderedCell when navigation successful, false if navigation should not be performed, otherwise null
     */

  }, {
    key: "findNextCellToFocusOn",
    value: function findNextCellToFocusOn(previousPosition, backwards, startEditing) {
      var _a;

      var nextPosition = previousPosition;

      while (true) {
        if (previousPosition !== nextPosition) {
          previousPosition = nextPosition;
        }

        if (!backwards) {
          nextPosition = this.getLastCellOfColSpan(nextPosition);
        }

        nextPosition = this.cellNavigationService.getNextTabbedCell(nextPosition, backwards);
        var userFunc = this.gos.getCallback("tabToNextCell");

        if (_exists(userFunc)) {
          var params = {
            backwards: backwards,
            editing: startEditing,
            previousCellPosition: previousPosition,
            nextCellPosition: nextPosition ? nextPosition : null
          };
          var userResult = userFunc(params);

          if (userResult === true || userResult === null) {
            if (userResult === null) {
              _warnOnce("Returning `null` from tabToNextCell is deprecated. Return `true` to stay on the current cell, or `false` to let the browser handle the tab behaviour.");
            }

            nextPosition = previousPosition;
          } else if (userResult === false) {
            return false;
          } else {
            if (userResult.floating) {
              _warnOnce("tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?");

              userResult.rowPinned = userResult.floating;
            }

            nextPosition = {
              rowIndex: userResult.rowIndex,
              column: userResult.column,
              rowPinned: userResult.rowPinned
            };
          }
        }

        if (!nextPosition) {
          return null;
        }

        if (nextPosition.rowIndex < 0) {
          var headerLen = this.headerNavigationService.getHeaderRowCount();
          this.focusService.focusHeaderPosition({
            headerPosition: {
              headerRowIndex: headerLen + nextPosition.rowIndex,
              column: nextPosition.column
            },
            fromCell: true
          });
          return null;
        }

        var fullRowEdit = this.gos.get("editType") === "fullRow";

        if (startEditing && !fullRowEdit) {
          var cellIsEditable = this.isCellEditable(nextPosition);

          if (!cellIsEditable) {
            continue;
          }
        }

        this.ensureCellVisible(nextPosition);
        var nextCell = this.getCellByPosition(nextPosition);

        if (!nextCell) {
          var row = this.rowRenderer.getRowByPosition(nextPosition);

          if (!row || !row.isFullWidth() || startEditing) {
            continue;
          }

          return row;
        }

        if (nextCell.isSuppressNavigable()) {
          continue;
        }

        (_a = this.rangeService) == null ? void 0 : _a.setRangeToCell(nextPosition);
        return nextCell;
      }
    }
  }, {
    key: "isCellEditable",
    value: function isCellEditable(cell) {
      var rowNode = this.lookupRowNodeForCell(cell);

      if (rowNode) {
        return cell.column.isCellEditable(rowNode);
      }

      return false;
    }
  }, {
    key: "getCellByPosition",
    value: function getCellByPosition(cellPosition) {
      var rowCtrl = this.rowRenderer.getRowByPosition(cellPosition);

      if (!rowCtrl) {
        return null;
      }

      return rowCtrl.getCellCtrl(cellPosition.column);
    }
  }, {
    key: "lookupRowNodeForCell",
    value: function lookupRowNodeForCell(cell) {
      if (cell.rowPinned === "top") {
        return this.pinnedRowModel.getPinnedTopRow(cell.rowIndex);
      }

      if (cell.rowPinned === "bottom") {
        return this.pinnedRowModel.getPinnedBottomRow(cell.rowIndex);
      }

      return this.paginationProxy.getRow(cell.rowIndex);
    } // we use index for rows, but column object for columns, as the next column (by index) might not
    // be visible (header grouping) so it's not reliable, so using the column object instead.

  }, {
    key: "navigateToNextCell",
    value: function navigateToNextCell(event, key, currentCell, allowUserOverride) {
      var nextCell = currentCell;
      var hitEdgeOfGrid = false;

      while (nextCell && (nextCell === currentCell || !this.isValidNavigateCell(nextCell))) {
        if (this.gos.get("enableRtl")) {
          if (key === _KeyCode.LEFT) {
            nextCell = this.getLastCellOfColSpan(nextCell);
          }
        } else if (key === _KeyCode.RIGHT) {
          nextCell = this.getLastCellOfColSpan(nextCell);
        }

        nextCell = this.cellNavigationService.getNextCellToFocus(key, nextCell);
        hitEdgeOfGrid = _missing(nextCell);
      }

      if (hitEdgeOfGrid && event && event.key === _KeyCode.UP) {
        nextCell = {
          rowIndex: -1,
          rowPinned: null,
          column: currentCell.column
        };
      }

      if (allowUserOverride) {
        var userFunc = this.gos.getCallback("navigateToNextCell");

        if (_exists(userFunc)) {
          var params = {
            key: key,
            previousCellPosition: currentCell,
            nextCellPosition: nextCell ? nextCell : null,
            event: event
          };
          var userCell = userFunc(params);

          if (_exists(userCell)) {
            if (userCell.floating) {
              _warnOnce("tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?");

              userCell.rowPinned = userCell.floating;
            }

            nextCell = {
              rowPinned: userCell.rowPinned,
              rowIndex: userCell.rowIndex,
              column: userCell.column
            };
          } else {
            nextCell = null;
          }
        }
      }

      if (!nextCell) {
        return;
      }

      if (nextCell.rowIndex < 0) {
        var headerLen = this.headerNavigationService.getHeaderRowCount();
        this.focusService.focusHeaderPosition({
          headerPosition: {
            headerRowIndex: headerLen + nextCell.rowIndex,
            column: currentCell.column
          },
          event: event || void 0,
          fromCell: true
        });
        return;
      }

      var normalisedPosition = this.getNormalisedPosition(nextCell);

      if (normalisedPosition) {
        this.focusPosition(normalisedPosition);
      } else {
        this.tryToFocusFullWidthRow(nextCell);
      }
    }
  }, {
    key: "getNormalisedPosition",
    value: function getNormalisedPosition(cellPosition) {
      this.ensureCellVisible(cellPosition);
      var cellCtrl = this.getCellByPosition(cellPosition);

      if (!cellCtrl) {
        return null;
      }

      cellPosition = cellCtrl.getCellPosition();
      this.ensureCellVisible(cellPosition);
      return cellPosition;
    }
  }, {
    key: "tryToFocusFullWidthRow",
    value: function tryToFocusFullWidthRow(position) {
      var backwards = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var displayedColumns = this.columnModel.getAllDisplayedColumns();
      var rowComp = this.rowRenderer.getRowByPosition(position);

      if (!rowComp || !rowComp.isFullWidth()) {
        return false;
      }

      var currentCellFocused = this.focusService.getFocusedCell();
      var cellPosition = {
        rowIndex: position.rowIndex,
        rowPinned: position.rowPinned,
        column: position.column || (backwards ? _last(displayedColumns) : displayedColumns[0])
      };
      this.focusPosition(cellPosition);
      var fromBelow = currentCellFocused != null ? this.rowPositionUtils.before(cellPosition, currentCellFocused) : false;
      var focusEvent = {
        type: _Events.EVENT_FULL_WIDTH_ROW_FOCUSED,
        rowIndex: cellPosition.rowIndex,
        rowPinned: cellPosition.rowPinned,
        column: cellPosition.column,
        isFullWidthCell: true,
        floating: cellPosition.rowPinned,
        fromBelow: fromBelow
      };
      this.eventService.dispatchEvent(focusEvent);
      return true;
    }
  }, {
    key: "focusPosition",
    value: function focusPosition(cellPosition) {
      var _a;

      this.focusService.setFocusedCell({
        rowIndex: cellPosition.rowIndex,
        column: cellPosition.column,
        rowPinned: cellPosition.rowPinned,
        forceBrowserFocus: true
      });
      (_a = this.rangeService) == null ? void 0 : _a.setRangeToCell(cellPosition);
    }
  }, {
    key: "isValidNavigateCell",
    value: function isValidNavigateCell(cell) {
      var rowNode = this.rowPositionUtils.getRowNode(cell);
      return !!rowNode;
    }
  }, {
    key: "getLastCellOfColSpan",
    value: function getLastCellOfColSpan(cell) {
      var cellCtrl = this.getCellByPosition(cell);

      if (!cellCtrl) {
        return cell;
      }

      var colSpanningList = cellCtrl.getColSpanningList();

      if (colSpanningList.length === 1) {
        return cell;
      }

      return {
        rowIndex: cell.rowIndex,
        column: _last(colSpanningList),
        rowPinned: cell.rowPinned
      };
    }
  }, {
    key: "ensureCellVisible",
    value: function ensureCellVisible(gridCell) {
      var isGroupStickyEnabled = this.gos.isGroupRowsSticky();
      var rowNode = this.rowModel.getRow(gridCell.rowIndex);
      var skipScrollToRow = isGroupStickyEnabled && (rowNode == null ? void 0 : rowNode.sticky);

      if (!skipScrollToRow && _missing(gridCell.rowPinned)) {
        this.gridBodyCon.getScrollFeature().ensureIndexVisible(gridCell.rowIndex);
      }

      if (!gridCell.column.isPinned()) {
        this.gridBodyCon.getScrollFeature().ensureColumnVisible(gridCell.column);
      }
    }
  }]);

  return _NavigationService;
}(_BeanStub2);

__decorateClass([_Autowired("mouseEventService")], _NavigationService.prototype, "mouseEventService", 2);

__decorateClass([_Autowired("paginationProxy")], _NavigationService.prototype, "paginationProxy", 2);

__decorateClass([_Autowired("focusService")], _NavigationService.prototype, "focusService", 2);

__decorateClass([_Autowired("columnModel")], _NavigationService.prototype, "columnModel", 2);

__decorateClass([_Autowired("rowModel")], _NavigationService.prototype, "rowModel", 2);

__decorateClass([_Autowired("ctrlsService")], _NavigationService.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("rowRenderer")], _NavigationService.prototype, "rowRenderer", 2);

__decorateClass([_Autowired("headerNavigationService")], _NavigationService.prototype, "headerNavigationService", 2);

__decorateClass([_Autowired("rowPositionUtils")], _NavigationService.prototype, "rowPositionUtils", 2);

__decorateClass([_Autowired("cellNavigationService")], _NavigationService.prototype, "cellNavigationService", 2);

__decorateClass([_Autowired("pinnedRowModel")], _NavigationService.prototype, "pinnedRowModel", 2);

__decorateClass([_Optional("rangeService")], _NavigationService.prototype, "rangeService", 2);

__decorateClass([_PostConstruct], _NavigationService.prototype, "postConstruct", 1);

_NavigationService = __decorateClass([_Bean("navigationService")], _NavigationService); // community-modules/core/src/rendering/cellEditors/popupEditorWrapper.ts

var _PopupEditorWrapper =
/*#__PURE__*/
function (_PopupComponent7) {
  "use strict";

  _inherits(_PopupEditorWrapper, _PopupComponent7);

  function _PopupEditorWrapper(params) {
    var _this352;

    _classCallCheck(this, _PopupEditorWrapper);

    _this352 = _possibleConstructorReturn(this, _getPrototypeOf(_PopupEditorWrapper).call(this,
    /* html */
    "<div class=\"ag-popup-editor\" tabindex=\"-1\"/>"));
    _this352.params = params;
    return _this352;
  }

  _createClass(_PopupEditorWrapper, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.gos.setDomData(this.getGui(), _PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER, true);
      this.addKeyDownListener();
    }
  }, {
    key: "addKeyDownListener",
    value: function addKeyDownListener() {
      var _this353 = this;

      var eGui = this.getGui();
      var params = this.params;

      var listener = function listener(event) {
        if (!_isUserSuppressingKeyboardEvent(_this353.gos, event, params.node, params.column, true)) {
          params.onKeyDown(event);
        }
      };

      this.addManagedListener(eGui, "keydown", listener);
    }
  }]);

  return _PopupEditorWrapper;
}(_PopupComponent);

_PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER = "popupEditorWrapper";

__decorateClass([_PostConstruct], _PopupEditorWrapper.prototype, "postConstruct", 1);

var _PopupEditorWrapper2 = _PopupEditorWrapper; // community-modules/core/src/rendering/cell/cellComp.ts

var _CellComp =
/*#__PURE__*/
function (_Component28) {
  "use strict";

  _inherits(_CellComp, _Component28);

  function _CellComp(beans, cellCtrl, printLayout, eRow, editingRow) {
    var _this354;

    _classCallCheck(this, _CellComp);

    _this354 = _possibleConstructorReturn(this, _getPrototypeOf(_CellComp).call(this)); // every time we go into edit mode, or back again, this gets incremented.
    // it's the components way of dealing with the async nature of framework components,
    // so if a framework component takes a while to be created, we know if the object
    // is still relevant when creating is finished. eg we could click edit / un-edit 20
    // times before the first React edit component comes back - we should discard
    // the first 19.

    _this354.rendererVersion = 0;
    _this354.editorVersion = 0;
    _this354.beans = beans;
    _this354.column = cellCtrl.getColumn();
    _this354.rowNode = cellCtrl.getRowNode();
    _this354.rowCtrl = cellCtrl.getRowCtrl();
    _this354.eRow = eRow;
    _this354.cellCtrl = cellCtrl;
    var cellDiv = document.createElement("div");
    cellDiv.setAttribute("comp-id", "".concat(_this354.getCompId()));

    _this354.setTemplateFromElement(cellDiv);

    var eGui = _this354.getGui();

    _this354.forceWrapper = cellCtrl.isForceWrapper();

    _this354.refreshWrapper(false);

    var setAttribute = function setAttribute(name, value) {
      if (value != null && value != "") {
        eGui.setAttribute(name, value);
      } else {
        eGui.removeAttribute(name);
      }
    };

    _setAriaRole(eGui, cellCtrl.getCellAriaRole());

    setAttribute("col-id", cellCtrl.getColumnIdSanitised());
    var tabIndex = cellCtrl.getTabIndex();

    if (tabIndex !== void 0) {
      setAttribute("tabindex", tabIndex.toString());
    }

    var compProxy = {
      addOrRemoveCssClass: function addOrRemoveCssClass(cssClassName, on) {
        return _this354.addOrRemoveCssClass(cssClassName, on);
      },
      setUserStyles: function setUserStyles(styles) {
        return _addStylesToElement(eGui, styles);
      },
      getFocusableElement: function getFocusableElement() {
        return _this354.getFocusableElement();
      },
      setIncludeSelection: function setIncludeSelection(include) {
        return _this354.includeSelection = include;
      },
      setIncludeRowDrag: function setIncludeRowDrag(include) {
        return _this354.includeRowDrag = include;
      },
      setIncludeDndSource: function setIncludeDndSource(include) {
        return _this354.includeDndSource = include;
      },
      setRenderDetails: function setRenderDetails(compDetails, valueToDisplay, force) {
        return _this354.setRenderDetails(compDetails, valueToDisplay, force);
      },
      setEditDetails: function setEditDetails(compDetails, popup, position) {
        return _this354.setEditDetails(compDetails, popup, position);
      },
      getCellEditor: function getCellEditor() {
        return _this354.cellEditor || null;
      },
      getCellRenderer: function getCellRenderer() {
        return _this354.cellRenderer || null;
      },
      getParentOfValue: function getParentOfValue() {
        return _this354.getParentOfValue();
      }
    };
    cellCtrl.setComp(compProxy, _this354.getGui(), _this354.eCellWrapper, printLayout, editingRow);
    return _this354;
  }

  _createClass(_CellComp, [{
    key: "getParentOfValue",
    value: function getParentOfValue() {
      if (this.eCellValue) {
        return this.eCellValue;
      }

      if (this.eCellWrapper) {
        return this.eCellWrapper;
      }

      return this.getGui();
    }
  }, {
    key: "setRenderDetails",
    value: function setRenderDetails(compDetails, valueToDisplay, forceNewCellRendererInstance) {
      var isInlineEditing = this.cellEditor && !this.cellEditorPopupWrapper;

      if (isInlineEditing) {
        return;
      }

      this.firstRender = this.firstRender == null;
      var controlWrapperChanged = this.refreshWrapper(false);
      this.refreshEditStyles(false);

      if (compDetails) {
        var neverRefresh = forceNewCellRendererInstance || controlWrapperChanged;
        var cellRendererRefreshSuccessful = neverRefresh ? false : this.refreshCellRenderer(compDetails);

        if (!cellRendererRefreshSuccessful) {
          this.destroyRenderer();
          this.createCellRendererInstance(compDetails);
        }
      } else {
        this.destroyRenderer();
        this.insertValueWithoutCellRenderer(valueToDisplay);
      }
    }
  }, {
    key: "setEditDetails",
    value: function setEditDetails(compDetails, popup, position) {
      if (compDetails) {
        this.createCellEditorInstance(compDetails, popup, position);
      } else {
        this.destroyEditor();
      }
    }
  }, {
    key: "removeControls",
    value: function removeControls() {
      this.checkboxSelectionComp = this.beans.context.destroyBean(this.checkboxSelectionComp);
      this.dndSourceComp = this.beans.context.destroyBean(this.dndSourceComp);
      this.rowDraggingComp = this.beans.context.destroyBean(this.rowDraggingComp);
    } // returns true if wrapper was changed

  }, {
    key: "refreshWrapper",
    value: function refreshWrapper(editing) {
      var providingControls = this.includeRowDrag || this.includeDndSource || this.includeSelection;
      var usingWrapper = providingControls || this.forceWrapper;
      var putWrapperIn = usingWrapper && this.eCellWrapper == null;

      if (putWrapperIn) {
        var wrapperDiv = document.createElement("div");
        wrapperDiv.setAttribute("role", "presentation");
        wrapperDiv.setAttribute("class", "ag-cell-wrapper");
        this.eCellWrapper = wrapperDiv;
        this.getGui().appendChild(this.eCellWrapper);
      }

      var takeWrapperOut = !usingWrapper && this.eCellWrapper != null;

      if (takeWrapperOut) {
        _removeFromParent(this.eCellWrapper);

        this.eCellWrapper = void 0;
      }

      this.addOrRemoveCssClass("ag-cell-value", !usingWrapper);
      var usingCellValue = !editing && usingWrapper;
      var putCellValueIn = usingCellValue && this.eCellValue == null;

      if (putCellValueIn) {
        var cellSpan = document.createElement("span");
        cellSpan.setAttribute("role", "presentation");
        cellSpan.setAttribute("class", "ag-cell-value");
        this.eCellValue = cellSpan;
        this.eCellWrapper.appendChild(this.eCellValue);
      }

      var takeCellValueOut = !usingCellValue && this.eCellValue != null;

      if (takeCellValueOut) {
        _removeFromParent(this.eCellValue);

        this.eCellValue = void 0;
      }

      var templateChanged = putWrapperIn || takeWrapperOut || putCellValueIn || takeCellValueOut;

      if (templateChanged) {
        this.removeControls();
      }

      if (!editing) {
        if (providingControls) {
          this.addControls();
        }
      }

      return templateChanged;
    }
  }, {
    key: "addControls",
    value: function addControls() {
      if (this.includeRowDrag) {
        if (this.rowDraggingComp == null) {
          this.rowDraggingComp = this.cellCtrl.createRowDragComp();

          if (this.rowDraggingComp) {
            this.eCellWrapper.insertBefore(this.rowDraggingComp.getGui(), this.eCellValue);
          }
        }
      }

      if (this.includeDndSource) {
        if (this.dndSourceComp == null) {
          this.dndSourceComp = this.cellCtrl.createDndSource();
          this.eCellWrapper.insertBefore(this.dndSourceComp.getGui(), this.eCellValue);
        }
      }

      if (this.includeSelection) {
        if (this.checkboxSelectionComp == null) {
          this.checkboxSelectionComp = this.cellCtrl.createSelectionCheckbox();
          this.eCellWrapper.insertBefore(this.checkboxSelectionComp.getGui(), this.eCellValue);
        }
      }
    }
  }, {
    key: "createCellEditorInstance",
    value: function createCellEditorInstance(compDetails, popup, position) {
      var _this355 = this;

      var versionCopy = this.editorVersion;
      var cellEditorPromise = compDetails.newAgStackInstance();

      if (!cellEditorPromise) {
        return;
      }

      var params = compDetails.params;
      cellEditorPromise.then(function (c) {
        return _this355.afterCellEditorCreated(versionCopy, c, params, popup, position);
      });

      var cellEditorAsync = _missing(this.cellEditor);

      if (cellEditorAsync && params.cellStartedEdit) {
        this.cellCtrl.focusCell(true);
      }
    }
  }, {
    key: "insertValueWithoutCellRenderer",
    value: function insertValueWithoutCellRenderer(valueToDisplay) {
      var eParent = this.getParentOfValue();

      _clearElement(eParent);

      var escapedValue = valueToDisplay != null ? _escapeString(valueToDisplay, true) : null;

      if (escapedValue != null) {
        eParent.textContent = escapedValue;
      }
    }
  }, {
    key: "destroyEditorAndRenderer",
    value: function destroyEditorAndRenderer() {
      this.destroyRenderer();
      this.destroyEditor();
    }
  }, {
    key: "destroyRenderer",
    value: function destroyRenderer() {
      var context = this.beans.context;
      this.cellRenderer = context.destroyBean(this.cellRenderer);

      _removeFromParent(this.cellRendererGui);

      this.cellRendererGui = null;
      this.rendererVersion++;
    }
  }, {
    key: "destroyEditor",
    value: function destroyEditor() {
      var context = this.beans.context;

      if (this.hideEditorPopup) {
        this.hideEditorPopup();
      }

      this.hideEditorPopup = void 0;
      this.cellEditor = context.destroyBean(this.cellEditor);
      this.cellEditorPopupWrapper = context.destroyBean(this.cellEditorPopupWrapper);

      _removeFromParent(this.cellEditorGui);

      this.cellEditorGui = null;
      this.editorVersion++;
    }
  }, {
    key: "refreshCellRenderer",
    value: function refreshCellRenderer(compClassAndParams) {
      if (this.cellRenderer == null || this.cellRenderer.refresh == null) {
        return false;
      }

      if (this.cellRendererClass !== compClassAndParams.componentClass) {
        return false;
      }

      var result = this.cellRenderer.refresh(compClassAndParams.params);
      return result === true || result === void 0;
    }
  }, {
    key: "createCellRendererInstance",
    value: function createCellRendererInstance(compDetails) {
      var _this356 = this;

      var suppressAnimationFrame = this.beans.gos.get("suppressAnimationFrame");
      var useTaskService = !suppressAnimationFrame;
      var displayComponentVersionCopy = this.rendererVersion;
      var componentClass = compDetails.componentClass;

      var createCellRendererFunc = function createCellRendererFunc() {
        var staleTask = _this356.rendererVersion !== displayComponentVersionCopy || !_this356.isAlive();

        if (staleTask) {
          return;
        }

        var componentPromise = compDetails.newAgStackInstance();

        var callback = _this356.afterCellRendererCreated.bind(_this356, displayComponentVersionCopy, componentClass);

        if (componentPromise) {
          componentPromise.then(callback);
        }
      };

      if (useTaskService && this.firstRender) {
        this.beans.animationFrameService.createTask(createCellRendererFunc, this.rowNode.rowIndex, "createTasksP2");
      } else {
        createCellRendererFunc();
      }
    }
  }, {
    key: "getCtrl",
    value: function getCtrl() {
      return this.cellCtrl;
    }
  }, {
    key: "getRowCtrl",
    value: function getRowCtrl() {
      return this.rowCtrl;
    }
  }, {
    key: "getCellRenderer",
    value: function getCellRenderer() {
      return this.cellRenderer;
    }
  }, {
    key: "getCellEditor",
    value: function getCellEditor() {
      return this.cellEditor;
    }
  }, {
    key: "afterCellRendererCreated",
    value: function afterCellRendererCreated(cellRendererVersion, cellRendererClass, cellRenderer) {
      var staleTask = !this.isAlive() || cellRendererVersion !== this.rendererVersion;

      if (staleTask) {
        this.beans.context.destroyBean(cellRenderer);
        return;
      }

      this.cellRenderer = cellRenderer;
      this.cellRendererClass = cellRendererClass;
      this.cellRendererGui = this.cellRenderer.getGui();

      if (this.cellRendererGui != null) {
        var eParent = this.getParentOfValue();

        _clearElement(eParent);

        eParent.appendChild(this.cellRendererGui);
      }
    }
  }, {
    key: "afterCellEditorCreated",
    value: function afterCellEditorCreated(requestVersion, cellEditor, params, popup, position) {
      var staleComp = requestVersion !== this.editorVersion;

      if (staleComp) {
        this.beans.context.destroyBean(cellEditor);
        return;
      }

      var editingCancelledByUserComp = cellEditor.isCancelBeforeStart && cellEditor.isCancelBeforeStart();

      if (editingCancelledByUserComp) {
        this.beans.context.destroyBean(cellEditor);
        this.cellCtrl.stopEditing(true);
        return;
      }

      if (!cellEditor.getGui) {
        console.warn("AG Grid: cellEditor for column ".concat(this.column.getId(), " is missing getGui() method"));
        this.beans.context.destroyBean(cellEditor);
        return;
      }

      this.cellEditor = cellEditor;
      this.cellEditorGui = cellEditor.getGui();
      var cellEditorInPopup = popup || cellEditor.isPopup !== void 0 && cellEditor.isPopup();

      if (cellEditorInPopup) {
        this.addPopupCellEditor(params, position);
      } else {
        this.addInCellEditor();
      }

      this.refreshEditStyles(true, cellEditorInPopup);

      if (cellEditor.afterGuiAttached) {
        cellEditor.afterGuiAttached();
      }
    }
  }, {
    key: "refreshEditStyles",
    value: function refreshEditStyles(editing, isPopup) {
      var _a;

      this.addOrRemoveCssClass("ag-cell-inline-editing", editing && !isPopup);
      this.addOrRemoveCssClass("ag-cell-popup-editing", editing && !!isPopup);
      this.addOrRemoveCssClass("ag-cell-not-inline-editing", !editing || !!isPopup);
      (_a = this.rowCtrl) == null ? void 0 : _a.setInlineEditingCss(editing);
    }
  }, {
    key: "addInCellEditor",
    value: function addInCellEditor() {
      var eGui = this.getGui();

      if (eGui.contains(this.beans.gos.getActiveDomElement())) {
        eGui.focus();
      }

      this.destroyRenderer();
      this.refreshWrapper(true);
      this.clearParentOfValue();

      if (this.cellEditorGui) {
        var eParent = this.getParentOfValue();
        eParent.appendChild(this.cellEditorGui);
      }
    }
  }, {
    key: "addPopupCellEditor",
    value: function addPopupCellEditor(params, position) {
      var _this357 = this;

      if (this.beans.gos.get("editType") === "fullRow") {
        console.warn("AG Grid: popup cellEditor does not work with fullRowEdit - you cannot use them both - either turn off fullRowEdit, or stop using popup editors.");
      }

      var cellEditor = this.cellEditor;
      this.cellEditorPopupWrapper = this.beans.context.createBean(new _PopupEditorWrapper2(params));
      var ePopupGui = this.cellEditorPopupWrapper.getGui();

      if (this.cellEditorGui) {
        ePopupGui.appendChild(this.cellEditorGui);
      }

      var popupService = this.beans.popupService;
      var useModelPopup = this.beans.gos.get("stopEditingWhenCellsLoseFocus");
      var positionToUse = position != null ? position : cellEditor.getPopupPosition ? cellEditor.getPopupPosition() : "over";
      var isRtl = this.beans.gos.get("enableRtl");
      var positionParams = {
        ePopup: ePopupGui,
        column: this.column,
        rowNode: this.rowNode,
        type: "popupCellEditor",
        eventSource: this.getGui(),
        position: positionToUse,
        alignSide: isRtl ? "right" : "left",
        keepWithinBounds: true
      };
      var positionCallback = popupService.positionPopupByComponent.bind(popupService, positionParams);
      var translate = this.beans.localeService.getLocaleTextFunc();
      var addPopupRes = popupService.addPopup({
        modal: useModelPopup,
        eChild: ePopupGui,
        closeOnEsc: true,
        closedCallback: function closedCallback() {
          _this357.cellCtrl.onPopupEditorClosed();
        },
        anchorToElement: this.getGui(),
        positionCallback: positionCallback,
        ariaLabel: translate("ariaLabelCellEditor", "Cell Editor")
      });

      if (addPopupRes) {
        this.hideEditorPopup = addPopupRes.hideFunc;
      }
    }
  }, {
    key: "detach",
    value: function detach() {
      this.eRow.removeChild(this.getGui());
    } // if the row is also getting destroyed, then we don't need to remove from dom,
    // as the row will also get removed, so no need to take out the cells from the row
    // if the row is going (removing is an expensive operation, so only need to remove
    // the top part)
    //
    // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.

  }, {
    key: "destroy",
    value: function destroy() {
      this.cellCtrl.stopEditing();
      this.destroyEditorAndRenderer();
      this.removeControls();

      _get(_getPrototypeOf(_CellComp.prototype), "destroy", this).call(this);
    }
  }, {
    key: "clearParentOfValue",
    value: function clearParentOfValue() {
      var eGui = this.getGui();

      if (eGui.contains(this.beans.gos.getActiveDomElement()) && _browserSupportsPreventScroll()) {
        eGui.focus({
          preventScroll: true
        });
      }

      _clearElement(this.getParentOfValue());
    }
  }]);

  return _CellComp;
}(_Component2); // community-modules/core/src/rendering/row/rowComp.ts


var RowComp =
/*#__PURE__*/
function (_Component29) {
  "use strict";

  _inherits(RowComp, _Component29);

  function RowComp(ctrl, beans, containerType) {
    var _this358;

    _classCallCheck(this, RowComp);

    _this358 = _possibleConstructorReturn(this, _getPrototypeOf(RowComp).call(this));
    _this358.cellComps = {};
    _this358.beans = beans;
    _this358.rowCtrl = ctrl;
    var rowDiv = document.createElement("div");
    rowDiv.setAttribute("comp-id", "".concat(_this358.getCompId()));
    rowDiv.setAttribute("style", _this358.getInitialStyle(containerType));

    _this358.setTemplateFromElement(rowDiv);

    var eGui = _this358.getGui();

    var style = eGui.style;
    _this358.domOrder = _this358.rowCtrl.getDomOrder();

    _setAriaRole(eGui, "row");

    var tabIndex = _this358.rowCtrl.getTabIndex();

    if (tabIndex != null) {
      eGui.setAttribute("tabindex", tabIndex.toString());
    }

    var compProxy = {
      setDomOrder: function setDomOrder(domOrder) {
        return _this358.domOrder = domOrder;
      },
      setCellCtrls: function setCellCtrls(cellCtrls) {
        return _this358.setCellCtrls(cellCtrls);
      },
      showFullWidth: function showFullWidth(compDetails) {
        return _this358.showFullWidth(compDetails);
      },
      getFullWidthCellRenderer: function getFullWidthCellRenderer() {
        return _this358.getFullWidthCellRenderer();
      },
      addOrRemoveCssClass: function addOrRemoveCssClass(name, on) {
        return _this358.addOrRemoveCssClass(name, on);
      },
      setUserStyles: function setUserStyles(styles) {
        return _addStylesToElement(eGui, styles);
      },
      setTop: function setTop(top) {
        return style.top = top;
      },
      setTransform: function setTransform(transform) {
        return style.transform = transform;
      },
      setRowIndex: function setRowIndex(rowIndex) {
        return eGui.setAttribute("row-index", rowIndex);
      },
      setRowId: function setRowId(rowId) {
        return eGui.setAttribute("row-id", rowId);
      },
      setRowBusinessKey: function setRowBusinessKey(businessKey) {
        return eGui.setAttribute("row-business-key", businessKey);
      },
      refreshFullWidth: function refreshFullWidth(getUpdatedParams) {
        return _this358.refreshFullWidth(getUpdatedParams);
      }
    };
    ctrl.setComp(compProxy, _this358.getGui(), containerType);

    _this358.addDestroyFunc(function () {
      ctrl.unsetComp(containerType);
    });

    return _this358;
  }

  _createClass(RowComp, [{
    key: "getInitialStyle",
    value: function getInitialStyle(containerType) {
      var transform = this.rowCtrl.getInitialTransform(containerType);
      return transform ? "transform: ".concat(transform) : "top: ".concat(this.rowCtrl.getInitialRowTop(containerType));
    }
  }, {
    key: "showFullWidth",
    value: function showFullWidth(compDetails) {
      var _this359 = this;

      var callback = function callback(cellRenderer) {
        if (_this359.isAlive()) {
          var eGui = cellRenderer.getGui();

          _this359.getGui().appendChild(eGui);

          _this359.rowCtrl.setupDetailRowAutoHeight(eGui);

          _this359.setFullWidthRowComp(cellRenderer);
        } else {
          _this359.beans.context.destroyBean(cellRenderer);
        }
      };

      var res = compDetails.newAgStackInstance();

      if (!res) {
        return;
      }

      res.then(callback);
    }
  }, {
    key: "setCellCtrls",
    value: function setCellCtrls(cellCtrls) {
      var _this360 = this;

      var cellsToRemove = Object.assign({}, this.cellComps);
      cellCtrls.forEach(function (cellCtrl) {
        var key = cellCtrl.getInstanceId();
        var existingCellComp = _this360.cellComps[key];

        if (existingCellComp == null) {
          _this360.newCellComp(cellCtrl);
        } else {
          cellsToRemove[key] = null;
        }
      });

      var cellCompsToRemove = _getAllValuesInObject(cellsToRemove).filter(function (cellComp) {
        return cellComp != null;
      });

      this.destroyCells(cellCompsToRemove);
      this.ensureDomOrder(cellCtrls);
    }
  }, {
    key: "ensureDomOrder",
    value: function ensureDomOrder(cellCtrls) {
      var _this361 = this;

      if (!this.domOrder) {
        return;
      }

      var elementsInOrder = [];
      cellCtrls.forEach(function (cellCtrl) {
        var cellComp = _this361.cellComps[cellCtrl.getInstanceId()];

        if (cellComp) {
          elementsInOrder.push(cellComp.getGui());
        }
      });

      _setDomChildOrder(this.getGui(), elementsInOrder);
    }
  }, {
    key: "newCellComp",
    value: function newCellComp(cellCtrl) {
      var cellComp = new _CellComp(this.beans, cellCtrl, this.rowCtrl.isPrintLayout(), this.getGui(), this.rowCtrl.isEditing());
      this.cellComps[cellCtrl.getInstanceId()] = cellComp;
      this.getGui().appendChild(cellComp.getGui());
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(RowComp.prototype), "destroy", this).call(this);

      this.destroyAllCells();
    }
  }, {
    key: "destroyAllCells",
    value: function destroyAllCells() {
      var cellsToDestroy = _getAllValuesInObject(this.cellComps).filter(function (cp) {
        return cp != null;
      });

      this.destroyCells(cellsToDestroy);
    }
  }, {
    key: "setFullWidthRowComp",
    value: function setFullWidthRowComp(fullWidthRowComponent) {
      var _this362 = this;

      if (this.fullWidthCellRenderer) {
        console.error("AG Grid - should not be setting fullWidthRowComponent twice");
      }

      this.fullWidthCellRenderer = fullWidthRowComponent;
      this.addDestroyFunc(function () {
        _this362.fullWidthCellRenderer = _this362.beans.context.destroyBean(_this362.fullWidthCellRenderer);
      });
    }
  }, {
    key: "getFullWidthCellRenderer",
    value: function getFullWidthCellRenderer() {
      return this.fullWidthCellRenderer;
    }
  }, {
    key: "destroyCells",
    value: function destroyCells(cellComps) {
      var _this363 = this;

      cellComps.forEach(function (cellComp) {
        if (!cellComp) {
          return;
        }

        var instanceId = cellComp.getCtrl().getInstanceId();

        if (_this363.cellComps[instanceId] !== cellComp) {
          return;
        }

        cellComp.detach();
        cellComp.destroy();
        _this363.cellComps[instanceId] = null;
      });
    }
  }, {
    key: "refreshFullWidth",
    value: function refreshFullWidth(getUpdatedParams) {
      var fullWidthCellRenderer = this.fullWidthCellRenderer;

      if (!fullWidthCellRenderer || !fullWidthCellRenderer.refresh) {
        return false;
      }

      var params = getUpdatedParams();
      return fullWidthCellRenderer.refresh(params);
    }
  }]);

  return RowComp;
}(_Component2); // community-modules/core/src/gridBodyComp/rowContainer/rowContainerComp.ts


function templateFactory() {
  var name = _Component2.elementGettingCreated.getAttribute("name");

  var cssClasses = _RowContainerCtrl2.getRowContainerCssClasses(name);

  var res;
  var centerTemplate = name === "center"
  /* CENTER */
  || name === "topCenter"
  /* TOP_CENTER */
  || name === "stickyTopCenter"
  /* STICKY_TOP_CENTER */
  || name === "bottomCenter"
  /* BOTTOM_CENTER */
  || name === "stickyBottomCenter"
  /* STICKY_BOTTOM_CENTER */
  ;

  if (centerTemplate) {
    res =
    /* html */
    "<div class=\"".concat(cssClasses.viewport, "\" ref=\"eViewport\" role=\"presentation\">\n                <div class=\"").concat(cssClasses.container, "\" ref=\"eContainer\"></div>\n            </div>");
  } else {
    res =
    /* html */
    "<div class=\"".concat(cssClasses.container, "\" ref=\"eContainer\"></div>");
  }

  return res;
}

var _RowContainerComp =
/*#__PURE__*/
function (_Component30) {
  "use strict";

  _inherits(_RowContainerComp, _Component30);

  function _RowContainerComp() {
    var _this364;

    _classCallCheck(this, _RowContainerComp);

    _this364 = _possibleConstructorReturn(this, _getPrototypeOf(_RowContainerComp).call(this, templateFactory()));
    _this364.rowComps = {};
    _this364.name = _Component2.elementGettingCreated.getAttribute("name");
    _this364.type = _getRowContainerTypeForName(_this364.name);
    return _this364;
  }

  _createClass(_RowContainerComp, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this365 = this;

      var compProxy = {
        setViewportHeight: function setViewportHeight(height) {
          return _this365.eViewport.style.height = height;
        },
        setRowCtrls: function setRowCtrls(_ref38) {
          var rowCtrls = _ref38.rowCtrls;
          return _this365.setRowCtrls(rowCtrls);
        },
        setDomOrder: function setDomOrder(domOrder) {
          _this365.domOrder = domOrder;
        },
        setContainerWidth: function setContainerWidth(width) {
          return _this365.eContainer.style.width = width;
        }
      };
      var ctrl = this.createManagedBean(new _RowContainerCtrl2(this.name));
      ctrl.setComp(compProxy, this.eContainer, this.eViewport);
    }
  }, {
    key: "preDestroy",
    value: function preDestroy() {
      this.setRowCtrls([]);
    }
  }, {
    key: "setRowCtrls",
    value: function setRowCtrls(rowCtrls) {
      var _this366 = this;

      var oldRows = __spreadValues({}, this.rowComps);

      this.rowComps = {};
      this.lastPlacedElement = null;

      var processRow = function processRow(rowCon) {
        var instanceId = rowCon.getInstanceId();
        var existingRowComp = oldRows[instanceId];

        if (existingRowComp) {
          _this366.rowComps[instanceId] = existingRowComp;
          delete oldRows[instanceId];

          _this366.ensureDomOrder(existingRowComp.getGui());
        } else {
          if (!rowCon.getRowNode().displayed) {
            return;
          }

          var rowComp = new RowComp(rowCon, _this366.beans, _this366.type);
          _this366.rowComps[instanceId] = rowComp;

          _this366.appendRow(rowComp.getGui());
        }
      };

      rowCtrls.forEach(processRow);

      _getAllValuesInObject(oldRows).forEach(function (oldRowComp) {
        _this366.eContainer.removeChild(oldRowComp.getGui());

        oldRowComp.destroy();
      });

      _setAriaRole(this.eContainer, "rowgroup");
    }
  }, {
    key: "appendRow",
    value: function appendRow(element) {
      if (this.domOrder) {
        _insertWithDomOrder(this.eContainer, element, this.lastPlacedElement);
      } else {
        this.eContainer.appendChild(element);
      }

      this.lastPlacedElement = element;
    }
  }, {
    key: "ensureDomOrder",
    value: function ensureDomOrder(eRow) {
      if (this.domOrder) {
        _ensureDomOrder(this.eContainer, eRow, this.lastPlacedElement);

        this.lastPlacedElement = eRow;
      }
    }
  }]);

  return _RowContainerComp;
}(_Component2);

__decorateClass([_Autowired("beans")], _RowContainerComp.prototype, "beans", 2);

__decorateClass([_RefSelector("eViewport")], _RowContainerComp.prototype, "eViewport", 2);

__decorateClass([_RefSelector("eContainer")], _RowContainerComp.prototype, "eContainer", 2);

__decorateClass([_PostConstruct], _RowContainerComp.prototype, "postConstruct", 1);

__decorateClass([_PreDestroy], _RowContainerComp.prototype, "preDestroy", 1); // community-modules/core/src/headerRendering/columnDrag/bodyDropPivotTarget.ts


var _BodyDropPivotTarget =
/*#__PURE__*/
function () {
  "use strict";

  function _BodyDropPivotTarget(pinned) {
    _classCallCheck(this, _BodyDropPivotTarget);

    this.columnsToAggregate = [];
    this.columnsToGroup = [];
    this.columnsToPivot = [];
    this.pinned = pinned;
  }
  /** Callback for when drag enters */


  _createClass(_BodyDropPivotTarget, [{
    key: "onDragEnter",
    value: function onDragEnter(draggingEvent) {
      var _this367 = this;

      this.clearColumnsList();

      if (this.gos.get("functionsReadOnly")) {
        return;
      }

      var dragColumns = draggingEvent.dragItem.columns;

      if (!dragColumns) {
        return;
      }

      dragColumns.forEach(function (column) {
        if (!column.isPrimary()) {
          return;
        }

        if (column.isAnyFunctionActive()) {
          return;
        }

        if (column.isAllowValue()) {
          _this367.columnsToAggregate.push(column);
        } else if (column.isAllowRowGroup()) {
          _this367.columnsToGroup.push(column);
        } else if (column.isAllowPivot()) {
          _this367.columnsToPivot.push(column);
        }
      });
    }
  }, {
    key: "getIconName",
    value: function getIconName() {
      var totalColumns = this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length;

      if (totalColumns > 0) {
        return this.pinned ? _DragAndDropService2.ICON_PINNED : _DragAndDropService2.ICON_MOVE;
      }

      return null;
    }
    /** Callback for when drag leaves */

  }, {
    key: "onDragLeave",
    value: function onDragLeave(draggingEvent) {
      this.clearColumnsList();
    }
  }, {
    key: "clearColumnsList",
    value: function clearColumnsList() {
      this.columnsToAggregate.length = 0;
      this.columnsToGroup.length = 0;
      this.columnsToPivot.length = 0;
    }
    /** Callback for when dragging */

  }, {
    key: "onDragging",
    value: function onDragging(draggingEvent) {}
    /** Callback for when drag stops */

  }, {
    key: "onDragStop",
    value: function onDragStop(draggingEvent) {
      if (this.columnsToAggregate.length > 0) {
        this.columnModel.addValueColumns(this.columnsToAggregate, "toolPanelDragAndDrop");
      }

      if (this.columnsToGroup.length > 0) {
        this.columnModel.addRowGroupColumns(this.columnsToGroup, "toolPanelDragAndDrop");
      }

      if (this.columnsToPivot.length > 0) {
        this.columnModel.addPivotColumns(this.columnsToPivot, "toolPanelDragAndDrop");
      }
    }
  }]);

  return _BodyDropPivotTarget;
}();

__decorateClass([_Autowired("columnModel")], _BodyDropPivotTarget.prototype, "columnModel", 2);

__decorateClass([_Autowired("gridOptionsService")], _BodyDropPivotTarget.prototype, "gos", 2); // community-modules/core/src/headerRendering/columnMoveHelper.ts


var ColumnMoveHelper =
/*#__PURE__*/
function () {
  "use strict";

  function ColumnMoveHelper() {
    _classCallCheck(this, ColumnMoveHelper);
  }

  _createClass(ColumnMoveHelper, null, [{
    key: "attemptMoveColumns",
    value: function attemptMoveColumns(params) {
      var isFromHeader = params.isFromHeader,
          hDirection = params.hDirection,
          xPosition = params.xPosition,
          fromEnter = params.fromEnter,
          fakeEvent = params.fakeEvent,
          pinned = params.pinned,
          gos = params.gos,
          columnModel = params.columnModel;
      var draggingLeft = hDirection === 0
      /* Left */
      ;
      var draggingRight = hDirection === 1
      /* Right */
      ;
      var allMovingColumns = params.allMovingColumns;

      if (isFromHeader) {
        var newCols = [];
        allMovingColumns.forEach(function (col) {
          var _a;

          var movingGroup = null;
          var parent = col.getParent();

          while (parent != null && parent.getDisplayedLeafColumns().length === 1) {
            movingGroup = parent;
            parent = parent.getParent();
          }

          if (movingGroup != null) {
            var isMarryChildren = !!((_a = movingGroup.getColGroupDef()) == null ? void 0 : _a.marryChildren);
            var columnsToMove = isMarryChildren ? movingGroup.getProvidedColumnGroup().getLeafColumns() : movingGroup.getLeafColumns();
            columnsToMove.forEach(function (newCol) {
              if (!newCols.includes(newCol)) {
                newCols.push(newCol);
              }
            });
          } else if (!newCols.includes(col)) {
            newCols.push(col);
          }
        });
        allMovingColumns = newCols;
      }

      var allMovingColumnsOrdered = allMovingColumns.slice();
      columnModel.sortColumnsLikeGridColumns(allMovingColumnsOrdered);
      var validMoves = this.calculateValidMoves({
        movingCols: allMovingColumnsOrdered,
        draggingRight: draggingRight,
        xPosition: xPosition,
        pinned: pinned,
        gos: gos,
        columnModel: columnModel
      });
      var oldIndex = this.calculateOldIndex(allMovingColumnsOrdered, columnModel);

      if (validMoves.length === 0) {
        return;
      }

      var firstValidMove = validMoves[0];
      var constrainDirection = oldIndex !== null && !fromEnter;

      if (isFromHeader) {
        constrainDirection = oldIndex !== null;
      }

      if (constrainDirection && !fakeEvent) {
        if (draggingLeft && firstValidMove >= oldIndex) {
          return;
        }

        if (draggingRight && firstValidMove <= oldIndex) {
          return;
        }
      }

      var displayedCols = columnModel.getAllDisplayedColumns();
      var potentialMoves = [];
      var targetOrder = null;

      for (var i = 0; i < validMoves.length; i++) {
        var move = validMoves[i];
        var order = columnModel.getProposedColumnOrder(allMovingColumnsOrdered, move);

        if (!columnModel.doesOrderPassRules(order)) {
          continue;
        }

        var displayedOrder = order.filter(function (col) {
          return displayedCols.includes(col);
        });

        if (targetOrder === null) {
          targetOrder = displayedOrder;
        } else if (!_areEqual(displayedOrder, targetOrder)) {
          break;
        }

        var fragCount = this.groupFragCount(order);
        potentialMoves.push({
          move: move,
          fragCount: fragCount
        });
      }

      if (potentialMoves.length === 0) {
        return;
      }

      potentialMoves.sort(function (a, b) {
        return a.fragCount - b.fragCount;
      });
      return this.moveColumns(allMovingColumns, potentialMoves[0].move, "uiColumnMoved", false, columnModel);
    }
  }, {
    key: "moveColumns",
    value: function moveColumns(columns, toIndex, source, finished, columnModel) {
      columnModel.moveColumns(columns, toIndex, source, finished);
      return finished ? null : {
        columns: columns,
        toIndex: toIndex
      };
    } // returns the index of the first column in the list ONLY if the cols are all beside
    // each other. if the cols are not beside each other, then returns null

  }, {
    key: "calculateOldIndex",
    value: function calculateOldIndex(movingCols, columnModel) {
      var gridCols = columnModel.getAllGridColumns();

      var indexes = _sortNumerically(movingCols.map(function (col) {
        return gridCols.indexOf(col);
      }));

      var firstIndex = indexes[0];

      var lastIndex = _last(indexes);

      var spread = lastIndex - firstIndex;
      var gapsExist = spread !== indexes.length - 1;
      return gapsExist ? null : firstIndex;
    } // A measure of how fragmented in terms of groups an order of columns is

  }, {
    key: "groupFragCount",
    value: function groupFragCount(columns) {
      function parents(col) {
        var result = [];
        var parent = col.getOriginalParent();

        while (parent != null) {
          result.push(parent);
          parent = parent.getOriginalParent();
        }

        return result;
      }

      var count = 0;

      var _loop4 = function _loop4(i) {
        var a = parents(columns[i]);
        var b = parents(columns[i + 1]);

        var _ref39 = a.length > b.length ? [a, b] : [b, a];

        var _ref40 = _slicedToArray(_ref39, 2);

        a = _ref40[0];
        b = _ref40[1];
        a.forEach(function (parent) {
          if (b.indexOf(parent) === -1) {
            count++;
          }
        });
      };

      for (var i = 0; i < columns.length - 1; i++) {
        _loop4(i);
      }

      return count;
    }
  }, {
    key: "getDisplayedColumns",
    value: function getDisplayedColumns(columnModel, type) {
      switch (type) {
        case "left":
          return columnModel.getDisplayedLeftColumns();

        case "right":
          return columnModel.getDisplayedRightColumns();

        default:
          return columnModel.getDisplayedCenterColumns();
      }
    }
  }, {
    key: "calculateValidMoves",
    value: function calculateValidMoves(params) {
      var movingCols = params.movingCols,
          draggingRight = params.draggingRight,
          xPosition = params.xPosition,
          pinned = params.pinned,
          gos = params.gos,
          columnModel = params.columnModel;
      var isMoveBlocked = gos.get("suppressMovableColumns") || movingCols.some(function (col) {
        return col.getColDef().suppressMovable;
      });

      if (isMoveBlocked) {
        return [];
      }

      var allDisplayedCols = this.getDisplayedColumns(columnModel, pinned);
      var allGridCols = columnModel.getAllGridColumns();
      var movingDisplayedCols = allDisplayedCols.filter(function (col) {
        return _includes(movingCols, col);
      });
      var otherDisplayedCols = allDisplayedCols.filter(function (col) {
        return !_includes(movingCols, col);
      });
      var otherGridCols = allGridCols.filter(function (col) {
        return !_includes(movingCols, col);
      });
      var displayIndex = 0;
      var availableWidth = xPosition;

      if (draggingRight) {
        var widthOfMovingDisplayedCols = 0;
        movingDisplayedCols.forEach(function (col) {
          return widthOfMovingDisplayedCols += col.getActualWidth();
        });
        availableWidth -= widthOfMovingDisplayedCols;
      }

      if (availableWidth > 0) {
        for (var i = 0; i < otherDisplayedCols.length; i++) {
          var col = otherDisplayedCols[i];
          availableWidth -= col.getActualWidth();

          if (availableWidth < 0) {
            break;
          }

          displayIndex++;
        }

        if (draggingRight) {
          displayIndex++;
        }
      }

      var firstValidMove;

      if (displayIndex > 0) {
        var leftColumn = otherDisplayedCols[displayIndex - 1];
        firstValidMove = otherGridCols.indexOf(leftColumn) + 1;
      } else {
        firstValidMove = otherGridCols.indexOf(otherDisplayedCols[0]);

        if (firstValidMove === -1) {
          firstValidMove = 0;
        }
      }

      var validMoves = [firstValidMove];

      var numberComparator = function numberComparator(a, b) {
        return a - b;
      };

      if (draggingRight) {
        var pointer = firstValidMove + 1;
        var lastIndex = allGridCols.length - 1;

        while (pointer <= lastIndex) {
          validMoves.push(pointer);
          pointer++;
        }

        validMoves.sort(numberComparator);
      } else {
        var _pointer = firstValidMove;

        var _lastIndex = allGridCols.length - 1;

        var displacedCol = allGridCols[_pointer];

        while (_pointer <= _lastIndex && allDisplayedCols.indexOf(displacedCol) < 0) {
          _pointer++;
          validMoves.push(_pointer);
          displacedCol = allGridCols[_pointer];
        }

        _pointer = firstValidMove - 1;
        var firstDisplayIndex = 0;

        while (_pointer >= firstDisplayIndex) {
          validMoves.push(_pointer);
          _pointer--;
        }

        validMoves.sort(numberComparator).reverse();
      }

      return validMoves;
    }
  }, {
    key: "normaliseX",
    value: function normaliseX(x, pinned, fromKeyboard, gos, ctrlsService) {
      var eViewport = ctrlsService.getHeaderRowContainerCtrl(pinned).getViewport();

      if (fromKeyboard) {
        x -= eViewport.getBoundingClientRect().left;
      }

      if (gos.get("enableRtl")) {
        var clientWidth = eViewport.clientWidth;
        x = clientWidth - x;
      }

      if (pinned == null) {
        x += ctrlsService.get("center").getCenterViewportScrollLeft();
      }

      return x;
    }
  }]);

  return ColumnMoveHelper;
}(); // community-modules/core/src/headerRendering/columnDrag/moveColumnFeature.ts


var _MoveColumnFeature =
/*#__PURE__*/
function () {
  "use strict";

  function _MoveColumnFeature(pinned) {
    _classCallCheck(this, _MoveColumnFeature);

    this.needToMoveLeft = false;
    this.needToMoveRight = false;
    this.lastMovedInfo = null;
    this.pinned = pinned;
    this.isCenterContainer = !_exists(pinned);
  }

  _createClass(_MoveColumnFeature, [{
    key: "init",
    value: function init() {
      var _this368 = this;

      this.ctrlsService.whenReady(function (p) {
        _this368.gridBodyCon = p.gridBodyCtrl;
      });
    }
  }, {
    key: "getIconName",
    value: function getIconName() {
      return this.pinned ? _DragAndDropService2.ICON_PINNED : _DragAndDropService2.ICON_MOVE;
    }
  }, {
    key: "onDragEnter",
    value: function onDragEnter(draggingEvent) {
      var columns = draggingEvent.dragItem.columns;
      var dragCameFromToolPanel = draggingEvent.dragSource.type === 0
      /* ToolPanel */
      ;

      if (dragCameFromToolPanel) {
        this.setColumnsVisible(columns, true, "uiColumnDragged");
      } else {
        var visibleState = draggingEvent.dragItem.visibleState;
        var visibleColumns = (columns || []).filter(function (column) {
          return visibleState[column.getId()];
        });
        this.setColumnsVisible(visibleColumns, true, "uiColumnDragged");
      }

      this.setColumnsPinned(columns, this.pinned, "uiColumnDragged");
      this.onDragging(draggingEvent, true, true);
    }
  }, {
    key: "onDragLeave",
    value: function onDragLeave() {
      this.ensureIntervalCleared();
      this.lastMovedInfo = null;
    }
  }, {
    key: "setColumnsVisible",
    value: function setColumnsVisible(columns, visible, source) {
      if (columns) {
        var allowedCols = columns.filter(function (c) {
          return !c.getColDef().lockVisible;
        });
        this.columnModel.setColumnsVisible(allowedCols, visible, source);
      }
    }
  }, {
    key: "setColumnsPinned",
    value: function setColumnsPinned(columns, pinned, source) {
      if (columns) {
        var allowedCols = columns.filter(function (c) {
          return !c.getColDef().lockPinned;
        });
        this.columnModel.setColumnsPinned(allowedCols, pinned, source);
      }
    }
  }, {
    key: "onDragStop",
    value: function onDragStop() {
      this.onDragging(this.lastDraggingEvent, false, true, true);
      this.ensureIntervalCleared();
      this.lastMovedInfo = null;
    }
  }, {
    key: "checkCenterForScrolling",
    value: function checkCenterForScrolling(xAdjustedForScroll) {
      if (this.isCenterContainer) {
        var centerCtrl = this.ctrlsService.get("center");
        var firstVisiblePixel = centerCtrl.getCenterViewportScrollLeft();
        var lastVisiblePixel = firstVisiblePixel + centerCtrl.getCenterWidth();

        if (this.gos.get("enableRtl")) {
          this.needToMoveRight = xAdjustedForScroll < firstVisiblePixel + 50;
          this.needToMoveLeft = xAdjustedForScroll > lastVisiblePixel - 50;
        } else {
          this.needToMoveLeft = xAdjustedForScroll < firstVisiblePixel + 50;
          this.needToMoveRight = xAdjustedForScroll > lastVisiblePixel - 50;
        }

        if (this.needToMoveLeft || this.needToMoveRight) {
          this.ensureIntervalStarted();
        } else {
          this.ensureIntervalCleared();
        }
      }
    }
  }, {
    key: "onDragging",
    value: function onDragging() {
      var _this369 = this;

      var draggingEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.lastDraggingEvent;
      var fromEnter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var fakeEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var finished = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var _a;

      if (finished) {
        if (this.lastMovedInfo) {
          var _this$lastMovedInfo = this.lastMovedInfo,
              columns = _this$lastMovedInfo.columns,
              toIndex = _this$lastMovedInfo.toIndex;
          ColumnMoveHelper.moveColumns(columns, toIndex, "uiColumnMoved", true, this.columnModel);
        }

        return;
      }

      this.lastDraggingEvent = draggingEvent;

      if (_missing(draggingEvent.hDirection)) {
        return;
      }

      var mouseX = ColumnMoveHelper.normaliseX(draggingEvent.x, this.pinned, false, this.gos, this.ctrlsService);

      if (!fromEnter) {
        this.checkCenterForScrolling(mouseX);
      }

      var hDirection = this.normaliseDirection(draggingEvent.hDirection);
      var dragSourceType = draggingEvent.dragSource.type;
      var allMovingColumns = ((_a = draggingEvent.dragSource.getDragItem().columns) == null ? void 0 : _a.filter(function (col) {
        if (col.getColDef().lockPinned) {
          return col.getPinned() == _this369.pinned;
        }

        return true;
      })) || [];
      var lastMovedInfo = ColumnMoveHelper.attemptMoveColumns({
        allMovingColumns: allMovingColumns,
        isFromHeader: dragSourceType === 1
        /* HeaderCell */
        ,
        hDirection: hDirection,
        xPosition: mouseX,
        pinned: this.pinned,
        fromEnter: fromEnter,
        fakeEvent: fakeEvent,
        gos: this.gos,
        columnModel: this.columnModel
      });

      if (lastMovedInfo) {
        this.lastMovedInfo = lastMovedInfo;
      }
    }
  }, {
    key: "normaliseDirection",
    value: function normaliseDirection(hDirection) {
      if (this.gos.get("enableRtl")) {
        switch (hDirection) {
          case 0
          /* Left */
          :
            return 1
            /* Right */
            ;

          case 1
          /* Right */
          :
            return 0
            /* Left */
            ;

          default:
            console.error("AG Grid: Unknown direction ".concat(hDirection));
        }
      } else {
        return hDirection;
      }
    }
  }, {
    key: "ensureIntervalStarted",
    value: function ensureIntervalStarted() {
      if (!this.movingIntervalId) {
        this.intervalCount = 0;
        this.failedMoveAttempts = 0;
        this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), 100);

        if (this.needToMoveLeft) {
          this.dragAndDropService.setGhostIcon(_DragAndDropService2.ICON_LEFT, true);
        } else {
          this.dragAndDropService.setGhostIcon(_DragAndDropService2.ICON_RIGHT, true);
        }
      }
    }
  }, {
    key: "ensureIntervalCleared",
    value: function ensureIntervalCleared() {
      if (this.movingIntervalId) {
        window.clearInterval(this.movingIntervalId);
        this.movingIntervalId = null;
        this.dragAndDropService.setGhostIcon(_DragAndDropService2.ICON_MOVE);
      }
    }
  }, {
    key: "moveInterval",
    value: function moveInterval() {
      var pixelsToMove;
      this.intervalCount++;
      pixelsToMove = 10 + this.intervalCount * 5;

      if (pixelsToMove > 100) {
        pixelsToMove = 100;
      }

      var pixelsMoved = null;
      var scrollFeature = this.gridBodyCon.getScrollFeature();

      if (this.needToMoveLeft) {
        pixelsMoved = scrollFeature.scrollHorizontally(-pixelsToMove);
      } else if (this.needToMoveRight) {
        pixelsMoved = scrollFeature.scrollHorizontally(pixelsToMove);
      }

      if (pixelsMoved !== 0) {
        this.onDragging(this.lastDraggingEvent);
        this.failedMoveAttempts = 0;
      } else {
        this.failedMoveAttempts++;
        var columns = this.lastDraggingEvent.dragItem.columns;
        var columnsThatCanPin = columns.filter(function (c) {
          return !c.getColDef().lockPinned;
        });

        if (columnsThatCanPin.length > 0) {
          this.dragAndDropService.setGhostIcon(_DragAndDropService2.ICON_PINNED);

          if (this.failedMoveAttempts > 7) {
            var pinType = this.needToMoveLeft ? "left" : "right";
            this.setColumnsPinned(columnsThatCanPin, pinType, "uiColumnDragged");
            this.dragAndDropService.nudge();
          }
        }
      }
    }
  }]);

  return _MoveColumnFeature;
}();

__decorateClass([_Autowired("columnModel")], _MoveColumnFeature.prototype, "columnModel", 2);

__decorateClass([_Autowired("dragAndDropService")], _MoveColumnFeature.prototype, "dragAndDropService", 2);

__decorateClass([_Autowired("gridOptionsService")], _MoveColumnFeature.prototype, "gos", 2);

__decorateClass([_Autowired("ctrlsService")], _MoveColumnFeature.prototype, "ctrlsService", 2);

__decorateClass([_PostConstruct], _MoveColumnFeature.prototype, "init", 1); // community-modules/core/src/headerRendering/columnDrag/bodyDropTarget.ts


var _BodyDropTarget =
/*#__PURE__*/
function (_BeanStub44) {
  "use strict";

  _inherits(_BodyDropTarget, _BeanStub44);

  function _BodyDropTarget(pinned, eContainer) {
    var _this370;

    _classCallCheck(this, _BodyDropTarget);

    _this370 = _possibleConstructorReturn(this, _getPrototypeOf(_BodyDropTarget).call(this));
    _this370.pinned = pinned;
    _this370.eContainer = eContainer;
    return _this370;
  }

  _createClass(_BodyDropTarget, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this371 = this;

      this.ctrlsService.whenReady(function (p) {
        switch (_this371.pinned) {
          case "left":
            _this371.eSecondaryContainers = [[p.gridBodyCtrl.getBodyViewportElement(), p.left.getContainerElement()], [p.bottomLeft.getContainerElement()], [p.topLeft.getContainerElement()]];
            break;

          case "right":
            _this371.eSecondaryContainers = [[p.gridBodyCtrl.getBodyViewportElement(), p.right.getContainerElement()], [p.bottomRight.getContainerElement()], [p.topRight.getContainerElement()]];
            break;

          default:
            _this371.eSecondaryContainers = [[p.gridBodyCtrl.getBodyViewportElement(), p.center.getViewportElement()], [p.bottomCenter.getViewportElement()], [p.topCenter.getViewportElement()]];
            break;
        }
      });
    }
  }, {
    key: "isInterestedIn",
    value: function isInterestedIn(type) {
      return type === 1
      /* HeaderCell */
      || type === 0
      /* ToolPanel */
      && this.gos.get("allowDragFromColumnsToolPanel");
    }
  }, {
    key: "getSecondaryContainers",
    value: function getSecondaryContainers() {
      return this.eSecondaryContainers;
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      return this.eContainer;
    }
  }, {
    key: "init",
    value: function init() {
      this.moveColumnFeature = this.createManagedBean(new _MoveColumnFeature(this.pinned));
      this.bodyDropPivotTarget = this.createManagedBean(new _BodyDropPivotTarget(this.pinned));
      this.dragAndDropService.addDropTarget(this);
    }
  }, {
    key: "getIconName",
    value: function getIconName() {
      return this.currentDropListener.getIconName();
    } // we want to use the bodyPivotTarget if the user is dragging columns in from the toolPanel
    // and we are in pivot mode, as it has to logic to set pivot/value/group on the columns when
    // dropped into the grid's body.

  }, {
    key: "isDropColumnInPivotMode",
    value: function isDropColumnInPivotMode(draggingEvent) {
      return this.columnModel.isPivotMode() && draggingEvent.dragSource.type === 0
      /* ToolPanel */
      ;
    }
  }, {
    key: "onDragEnter",
    value: function onDragEnter(draggingEvent) {
      this.currentDropListener = this.isDropColumnInPivotMode(draggingEvent) ? this.bodyDropPivotTarget : this.moveColumnFeature;
      this.currentDropListener.onDragEnter(draggingEvent);
    }
  }, {
    key: "onDragLeave",
    value: function onDragLeave(params) {
      this.currentDropListener.onDragLeave(params);
    }
  }, {
    key: "onDragging",
    value: function onDragging(params) {
      this.currentDropListener.onDragging(params);
    }
  }, {
    key: "onDragStop",
    value: function onDragStop(params) {
      this.currentDropListener.onDragStop(params);
    }
  }]);

  return _BodyDropTarget;
}(_BeanStub2);

__decorateClass([_Autowired("dragAndDropService")], _BodyDropTarget.prototype, "dragAndDropService", 2);

__decorateClass([_Autowired("columnModel")], _BodyDropTarget.prototype, "columnModel", 2);

__decorateClass([_Autowired("ctrlsService")], _BodyDropTarget.prototype, "ctrlsService", 2);

__decorateClass([_PostConstruct], _BodyDropTarget.prototype, "postConstruct", 1);

__decorateClass([_PostConstruct], _BodyDropTarget.prototype, "init", 1); // community-modules/core/src/headerRendering/cells/column/headerCellComp.ts


var _HeaderCellComp =
/*#__PURE__*/
function (_AbstractHeaderCellCo2) {
  "use strict";

  _inherits(_HeaderCellComp, _AbstractHeaderCellCo2);

  function _HeaderCellComp(ctrl) {
    var _this372;

    _classCallCheck(this, _HeaderCellComp);

    _this372 = _possibleConstructorReturn(this, _getPrototypeOf(_HeaderCellComp).call(this, _HeaderCellComp.TEMPLATE, ctrl));
    _this372.headerCompVersion = 0;
    _this372.column = ctrl.getColumnGroupChild();
    _this372.pinned = ctrl.getPinned();
    return _this372;
  }

  _createClass(_HeaderCellComp, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this373 = this;

      var eGui = this.getGui();

      var setAttribute = function setAttribute(name, value) {
        if (value != null && value != "") {
          eGui.setAttribute(name, value);
        } else {
          eGui.removeAttribute(name);
        }
      };

      setAttribute("col-id", this.column.getColId());
      var compProxy = {
        setWidth: function setWidth(width) {
          return eGui.style.width = width;
        },
        addOrRemoveCssClass: function addOrRemoveCssClass(cssClassName, on) {
          return _this373.addOrRemoveCssClass(cssClassName, on);
        },
        setAriaSort: function setAriaSort(sort) {
          return sort ? _setAriaSort(eGui, sort) : _removeAriaSort(eGui);
        },
        setUserCompDetails: function setUserCompDetails(compDetails) {
          return _this373.setUserCompDetails(compDetails);
        },
        getUserCompInstance: function getUserCompInstance() {
          return _this373.headerComp;
        }
      };
      this.ctrl.setComp(compProxy, this.getGui(), this.eResize, this.eHeaderCompWrapper);
      var selectAllGui = this.ctrl.getSelectAllGui();
      this.eResize.insertAdjacentElement("afterend", selectAllGui);
    }
  }, {
    key: "destroyHeaderComp",
    value: function destroyHeaderComp() {
      if (this.headerComp) {
        this.eHeaderCompWrapper.removeChild(this.headerCompGui);
        this.headerComp = this.destroyBean(this.headerComp);
        this.headerCompGui = void 0;
      }
    }
  }, {
    key: "setUserCompDetails",
    value: function setUserCompDetails(compDetails) {
      var _this374 = this;

      this.headerCompVersion++;
      var versionCopy = this.headerCompVersion;
      compDetails.newAgStackInstance().then(function (comp) {
        return _this374.afterCompCreated(versionCopy, comp);
      });
    }
  }, {
    key: "afterCompCreated",
    value: function afterCompCreated(version, headerComp) {
      if (version != this.headerCompVersion || !this.isAlive()) {
        this.destroyBean(headerComp);
        return;
      }

      this.destroyHeaderComp();
      this.headerComp = headerComp;
      this.headerCompGui = headerComp.getGui();
      this.eHeaderCompWrapper.appendChild(this.headerCompGui);
      this.ctrl.setDragSource(this.getGui());
    }
  }]);

  return _HeaderCellComp;
}(AbstractHeaderCellComp);

_HeaderCellComp.TEMPLATE =
/* html */
"<div class=\"ag-header-cell\" role=\"columnheader\">\n            <div ref=\"eResize\" class=\"ag-header-cell-resize\" role=\"presentation\"></div>\n            <div ref=\"eHeaderCompWrapper\" class=\"ag-header-cell-comp-wrapper\" role=\"presentation\"></div>\n        </div>";

__decorateClass([_RefSelector("eResize")], _HeaderCellComp.prototype, "eResize", 2);

__decorateClass([_RefSelector("eHeaderCompWrapper")], _HeaderCellComp.prototype, "eHeaderCompWrapper", 2);

__decorateClass([_PostConstruct], _HeaderCellComp.prototype, "postConstruct", 1);

__decorateClass([_PreDestroy], _HeaderCellComp.prototype, "destroyHeaderComp", 1);

var HeaderCellComp = _HeaderCellComp; // community-modules/core/src/headerRendering/cells/columnGroup/headerGroupCellComp.ts

var _HeaderGroupCellComp =
/*#__PURE__*/
function (_AbstractHeaderCellCo3) {
  "use strict";

  _inherits(_HeaderGroupCellComp, _AbstractHeaderCellCo3);

  function _HeaderGroupCellComp(ctrl) {
    _classCallCheck(this, _HeaderGroupCellComp);

    return _possibleConstructorReturn(this, _getPrototypeOf(_HeaderGroupCellComp).call(this, _HeaderGroupCellComp.TEMPLATE, ctrl));
  }

  _createClass(_HeaderGroupCellComp, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this375 = this;

      var eGui = this.getGui();

      var setAttribute = function setAttribute(key, value) {
        return value != void 0 ? eGui.setAttribute(key, value) : eGui.removeAttribute(key);
      };

      eGui.setAttribute("col-id", this.ctrl.getColId());
      var compProxy = {
        addOrRemoveCssClass: function addOrRemoveCssClass(cssClassName, on) {
          return _this375.addOrRemoveCssClass(cssClassName, on);
        },
        setResizableDisplayed: function setResizableDisplayed(displayed) {
          return _setDisplayed(_this375.eResize, displayed);
        },
        setWidth: function setWidth(width) {
          return eGui.style.width = width;
        },
        setAriaExpanded: function setAriaExpanded(expanded) {
          return setAttribute("aria-expanded", expanded);
        },
        setUserCompDetails: function setUserCompDetails(details) {
          return _this375.setUserCompDetails(details);
        },
        getUserCompInstance: function getUserCompInstance() {
          return _this375.headerGroupComp;
        }
      };
      this.ctrl.setComp(compProxy, eGui, this.eResize);
    }
  }, {
    key: "setUserCompDetails",
    value: function setUserCompDetails(details) {
      var _this376 = this;

      details.newAgStackInstance().then(function (comp) {
        return _this376.afterHeaderCompCreated(comp);
      });
    }
  }, {
    key: "afterHeaderCompCreated",
    value: function afterHeaderCompCreated(headerGroupComp) {
      var _this377 = this;

      var destroyFunc = function destroyFunc() {
        return _this377.destroyBean(headerGroupComp);
      };

      if (!this.isAlive()) {
        destroyFunc();
        return;
      }

      var eGui = this.getGui();
      var eHeaderGroupGui = headerGroupComp.getGui();
      eGui.appendChild(eHeaderGroupGui);
      this.addDestroyFunc(destroyFunc);
      this.headerGroupComp = headerGroupComp;
      this.ctrl.setDragSource(eGui);
    }
  }]);

  return _HeaderGroupCellComp;
}(AbstractHeaderCellComp);

_HeaderGroupCellComp.TEMPLATE =
/* html */
"<div class=\"ag-header-group-cell\" role=\"columnheader\">\n            <div ref=\"eResize\" class=\"ag-header-cell-resize\" role=\"presentation\"></div>\n        </div>";

__decorateClass([_RefSelector("eResize")], _HeaderGroupCellComp.prototype, "eResize", 2);

__decorateClass([_PostConstruct], _HeaderGroupCellComp.prototype, "postConstruct", 1);

var HeaderGroupCellComp = _HeaderGroupCellComp; // community-modules/core/src/headerRendering/row/headerRowComp.ts

var _HeaderRowType =
/* @__PURE__ */
function (HeaderRowType2) {
  HeaderRowType2["COLUMN_GROUP"] = "group";
  HeaderRowType2["COLUMN"] = "column";
  HeaderRowType2["FLOATING_FILTER"] = "filter";
  return HeaderRowType2;
}(_HeaderRowType || {});

var _HeaderRowComp =
/*#__PURE__*/
function (_Component31) {
  "use strict";

  _inherits(_HeaderRowComp, _Component31);

  function _HeaderRowComp(ctrl) {
    var _this378;

    _classCallCheck(this, _HeaderRowComp);

    _this378 = _possibleConstructorReturn(this, _getPrototypeOf(_HeaderRowComp).call(this));
    _this378.headerComps = {};
    _this378.ctrl = ctrl;

    _this378.setTemplate(
    /* html */
    "<div class=\"".concat(_this378.ctrl.getHeaderRowClass(), "\" role=\"row\"></div>"));

    return _this378;
  }

  _createClass(_HeaderRowComp, [{
    key: "init",
    value: function init() {
      var _this379 = this;

      _setAriaRowIndex(this.getGui(), this.ctrl.getAriaRowIndex());

      var compProxy = {
        setHeight: function setHeight(height) {
          return _this379.getGui().style.height = height;
        },
        setTop: function setTop(top) {
          return _this379.getGui().style.top = top;
        },
        setHeaderCtrls: function setHeaderCtrls(ctrls, forceOrder) {
          return _this379.setHeaderCtrls(ctrls, forceOrder);
        },
        setWidth: function setWidth(width) {
          return _this379.getGui().style.width = width;
        }
      };
      this.ctrl.setComp(compProxy);
    }
  }, {
    key: "destroyHeaderCtrls",
    value: function destroyHeaderCtrls() {
      this.setHeaderCtrls([], false);
    }
  }, {
    key: "setHeaderCtrls",
    value: function setHeaderCtrls(ctrls, forceOrder) {
      var _this380 = this;

      if (!this.isAlive()) {
        return;
      }

      var oldComps = this.headerComps;
      this.headerComps = {};
      ctrls.forEach(function (ctrl) {
        var id = ctrl.getInstanceId();
        var comp = oldComps[id];
        delete oldComps[id];

        if (comp == null) {
          comp = _this380.createHeaderComp(ctrl);

          _this380.getGui().appendChild(comp.getGui());
        }

        _this380.headerComps[id] = comp;
      });

      _iterateObject(oldComps, function (id, comp) {
        _this380.getGui().removeChild(comp.getGui());

        _this380.destroyBean(comp);
      });

      if (forceOrder) {
        var comps = _getAllValuesInObject(this.headerComps);

        comps.sort(function (a, b) {
          var leftA = a.getCtrl().getColumnGroupChild().getLeft();
          var leftB = b.getCtrl().getColumnGroupChild().getLeft();
          return leftA - leftB;
        });
        var elementsInOrder = comps.map(function (c) {
          return c.getGui();
        });

        _setDomChildOrder(this.getGui(), elementsInOrder);
      }
    }
  }, {
    key: "createHeaderComp",
    value: function createHeaderComp(headerCtrl) {
      var result;

      switch (this.ctrl.getType()) {
        case "group"
        /* COLUMN_GROUP */
        :
          result = new HeaderGroupCellComp(headerCtrl);
          break;

        case "filter"
        /* FLOATING_FILTER */
        :
          result = new _HeaderFilterCellComp2(headerCtrl);
          break;

        default:
          result = new HeaderCellComp(headerCtrl);
          break;
      }

      this.createBean(result);
      result.setParentComponent(this);
      return result;
    }
  }]);

  return _HeaderRowComp;
}(_Component2);

__decorateClass([_PostConstruct], _HeaderRowComp.prototype, "init", 1);

__decorateClass([_PreDestroy], _HeaderRowComp.prototype, "destroyHeaderCtrls", 1); // community-modules/core/src/headerRendering/cells/abstractCell/abstractHeaderCellCtrl.ts


var instanceIdSequence4 = 0;

var _AbstractHeaderCellCtrl =
/*#__PURE__*/
function (_BeanStub45) {
  "use strict";

  _inherits(_AbstractHeaderCellCtrl, _BeanStub45);

  function _AbstractHeaderCellCtrl(columnGroupChild, beans, parentRowCtrl) {
    var _this381;

    _classCallCheck(this, _AbstractHeaderCellCtrl);

    _this381 = _possibleConstructorReturn(this, _getPrototypeOf(_AbstractHeaderCellCtrl).call(this));
    _this381.resizeToggleTimeout = 0;
    _this381.resizeMultiplier = 1;
    _this381.resizeFeature = null;
    _this381.lastFocusEvent = null;
    _this381.dragSource = null;
    _this381.columnGroupChild = columnGroupChild;
    _this381.parentRowCtrl = parentRowCtrl;
    _this381.beans = beans;
    _this381.instanceId = columnGroupChild.getUniqueId() + "-" + instanceIdSequence4++;
    return _this381;
  }

  _createClass(_AbstractHeaderCellCtrl, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this382 = this;

      this.addManagedPropertyListeners(["suppressHeaderFocus"], function () {
        return _this382.refreshTabIndex();
      });
    }
  }, {
    key: "shouldStopEventPropagation",
    value: function shouldStopEventPropagation(e) {
      var _this$focusService$ge = this.focusService.getFocusedHeader(),
          headerRowIndex = _this$focusService$ge.headerRowIndex,
          column = _this$focusService$ge.column;

      return _isUserSuppressingHeaderKeyboardEvent(this.gos, e, headerRowIndex, column);
    }
  }, {
    key: "getWrapperHasFocus",
    value: function getWrapperHasFocus() {
      var activeEl = this.gos.getActiveDomElement();
      return activeEl === this.eGui;
    }
  }, {
    key: "setGui",
    value: function setGui(eGui) {
      this.eGui = eGui;
      this.addDomData();
      this.addManagedListener(this.beans.eventService, _Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
      this.onDisplayedColumnsChanged();
      this.refreshTabIndex();
    }
  }, {
    key: "onDisplayedColumnsChanged",
    value: function onDisplayedColumnsChanged() {
      if (!this.comp || !this.column) {
        return;
      }

      this.refreshFirstAndLastStyles();
      this.refreshAriaColIndex();
    }
  }, {
    key: "refreshFirstAndLastStyles",
    value: function refreshFirstAndLastStyles() {
      var comp = this.comp,
          column = this.column,
          beans = this.beans;

      _CssClassApplier.refreshFirstAndLastStyles(comp, column, beans.columnModel);
    }
  }, {
    key: "refreshAriaColIndex",
    value: function refreshAriaColIndex() {
      var beans = this.beans,
          column = this.column;
      var colIdx = beans.columnModel.getAriaColumnIndex(column);

      _setAriaColIndex(this.eGui, colIdx);
    }
  }, {
    key: "addResizeAndMoveKeyboardListeners",
    value: function addResizeAndMoveKeyboardListeners() {
      if (!this.resizeFeature) {
        return;
      }

      this.addManagedListener(this.eGui, "keydown", this.onGuiKeyDown.bind(this));
      this.addManagedListener(this.eGui, "keyup", this.onGuiKeyUp.bind(this));
    }
  }, {
    key: "refreshTabIndex",
    value: function refreshTabIndex() {
      var suppressHeaderFocus = this.gos.get("suppressHeaderFocus");

      if (suppressHeaderFocus) {
        this.eGui.removeAttribute("tabindex");
      } else {
        this.eGui.setAttribute("tabindex", "-1");
      }
    }
  }, {
    key: "onGuiKeyDown",
    value: function onGuiKeyDown(e) {
      var _a;

      var activeEl = this.gos.getActiveDomElement();
      var isLeftOrRight = e.key === _KeyCode.LEFT || e.key === _KeyCode.RIGHT;

      if (this.isResizing) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }

      if ( // if elements within the header are focused, we don't process the event
      activeEl !== this.eGui || // if shiftKey and altKey are not pressed, it's cell navigation so we don't process the event
      !e.shiftKey && !e.altKey) {
        return;
      }

      if (this.isResizing || isLeftOrRight) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }

      if (!isLeftOrRight) {
        return;
      }

      var isLeft = e.key === _KeyCode.LEFT !== this.gos.get("enableRtl");
      var direction = _HorizontalDirection[isLeft ? "Left" : "Right"];

      if (e.altKey) {
        this.isResizing = true;
        this.resizeMultiplier += 1;
        var diff = this.getViewportAdjustedResizeDiff(e);
        this.resizeHeader(diff, e.shiftKey);
        (_a = this.resizeFeature) == null ? void 0 : _a.toggleColumnResizing(true);
      } else {
        this.moveHeader(direction);
      }
    }
  }, {
    key: "getViewportAdjustedResizeDiff",
    value: function getViewportAdjustedResizeDiff(e) {
      var diff = this.getResizeDiff(e);
      var pinned = this.column.getPinned();

      if (pinned) {
        var leftWidth = this.pinnedWidthService.getPinnedLeftWidth();
        var rightWidth = this.pinnedWidthService.getPinnedRightWidth();
        var bodyWidth = _getInnerWidth(this.ctrlsService.getGridBodyCtrl().getBodyViewportElement()) - 50;

        if (leftWidth + rightWidth + diff > bodyWidth) {
          if (bodyWidth > leftWidth + rightWidth) {
            diff = bodyWidth - leftWidth - rightWidth;
          } else {
            return 0;
          }
        }
      }

      return diff;
    }
  }, {
    key: "getResizeDiff",
    value: function getResizeDiff(e) {
      var isLeft = e.key === _KeyCode.LEFT !== this.gos.get("enableRtl");
      var pinned = this.column.getPinned();
      var isRtl = this.gos.get("enableRtl");

      if (pinned) {
        if (isRtl !== (pinned === "right")) {
          isLeft = !isLeft;
        }
      }

      return (isLeft ? -1 : 1) * this.resizeMultiplier;
    }
  }, {
    key: "onGuiKeyUp",
    value: function onGuiKeyUp() {
      var _this383 = this;

      if (!this.isResizing) {
        return;
      }

      if (this.resizeToggleTimeout) {
        window.clearTimeout(this.resizeToggleTimeout);
        this.resizeToggleTimeout = 0;
      }

      this.isResizing = false;
      this.resizeMultiplier = 1;
      this.resizeToggleTimeout = setTimeout(function () {
        var _a;

        (_a = _this383.resizeFeature) == null ? void 0 : _a.toggleColumnResizing(false);
      }, 150);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var wrapperHasFocus = this.getWrapperHasFocus();

      switch (e.key) {
        case _KeyCode.PAGE_DOWN:
        case _KeyCode.PAGE_UP:
        case _KeyCode.PAGE_HOME:
        case _KeyCode.PAGE_END:
          if (wrapperHasFocus) {
            e.preventDefault();
          }

      }
    }
  }, {
    key: "addDomData",
    value: function addDomData() {
      var _this384 = this;

      var key = _AbstractHeaderCellCtrl.DOM_DATA_KEY_HEADER_CTRL;
      this.gos.setDomData(this.eGui, key, this);
      this.addDestroyFunc(function () {
        return _this384.gos.setDomData(_this384.eGui, key, null);
      });
    }
  }, {
    key: "getGui",
    value: function getGui() {
      return this.eGui;
    }
  }, {
    key: "focus",
    value: function focus(event) {
      if (!this.eGui) {
        return false;
      }

      this.lastFocusEvent = event || null;
      this.eGui.focus();
      return true;
    }
  }, {
    key: "getRowIndex",
    value: function getRowIndex() {
      return this.parentRowCtrl.getRowIndex();
    }
  }, {
    key: "getParentRowCtrl",
    value: function getParentRowCtrl() {
      return this.parentRowCtrl;
    }
  }, {
    key: "getPinned",
    value: function getPinned() {
      return this.parentRowCtrl.getPinned();
    }
  }, {
    key: "getInstanceId",
    value: function getInstanceId() {
      return this.instanceId;
    }
  }, {
    key: "getColumnGroupChild",
    value: function getColumnGroupChild() {
      return this.columnGroupChild;
    }
  }, {
    key: "removeDragSource",
    value: function removeDragSource() {
      if (this.dragSource) {
        this.dragAndDropService.removeDragSource(this.dragSource);
        this.dragSource = null;
      }
    }
  }, {
    key: "handleContextMenuMouseEvent",
    value: function handleContextMenuMouseEvent(mouseEvent, touchEvent, column) {
      var event = mouseEvent != null ? mouseEvent : touchEvent;

      if (this.gos.get("preventDefaultOnContextMenu")) {
        event.preventDefault();
      }

      var columnToUse = column instanceof _Column2 ? column : void 0;

      if (this.menuService.isHeaderContextMenuEnabled(columnToUse)) {
        this.menuService.showHeaderContextMenu(columnToUse, mouseEvent, touchEvent);
      }

      this.dispatchColumnMouseEvent(_Events.EVENT_COLUMN_HEADER_CONTEXT_MENU, column);
    }
  }, {
    key: "dispatchColumnMouseEvent",
    value: function dispatchColumnMouseEvent(eventType, column) {
      var event = {
        type: eventType,
        column: column
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(_AbstractHeaderCellCtrl.prototype), "destroy", this).call(this);

      this.removeDragSource();
      this.comp = null;
      this.column = null;
      this.resizeFeature = null;
      this.lastFocusEvent = null;
      this.columnGroupChild = null;
      this.parentRowCtrl = null;
      this.eGui = null;
    }
  }]);

  return _AbstractHeaderCellCtrl;
}(_BeanStub2);

_AbstractHeaderCellCtrl.DOM_DATA_KEY_HEADER_CTRL = "headerCtrl";

__decorateClass([_Autowired("pinnedWidthService")], _AbstractHeaderCellCtrl.prototype, "pinnedWidthService", 2);

__decorateClass([_Autowired("focusService")], _AbstractHeaderCellCtrl.prototype, "focusService", 2);

__decorateClass([_Autowired("userComponentFactory")], _AbstractHeaderCellCtrl.prototype, "userComponentFactory", 2);

__decorateClass([_Autowired("ctrlsService")], _AbstractHeaderCellCtrl.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("dragAndDropService")], _AbstractHeaderCellCtrl.prototype, "dragAndDropService", 2);

__decorateClass([_Autowired("menuService")], _AbstractHeaderCellCtrl.prototype, "menuService", 2);

__decorateClass([_PostConstruct], _AbstractHeaderCellCtrl.prototype, "postConstruct", 1);

var _AbstractHeaderCellCtrl2 = _AbstractHeaderCellCtrl; // community-modules/core/src/rendering/features/setLeftFeature.ts

var _SetLeftFeature =
/*#__PURE__*/
function (_BeanStub46) {
  "use strict";

  _inherits(_SetLeftFeature, _BeanStub46);

  function _SetLeftFeature(columnOrGroup, eCell, beans, colsSpanning) {
    var _this385;

    _classCallCheck(this, _SetLeftFeature);

    _this385 = _possibleConstructorReturn(this, _getPrototypeOf(_SetLeftFeature).call(this));
    _this385.columnOrGroup = columnOrGroup;
    _this385.eCell = eCell;
    _this385.ariaEl = _this385.eCell.querySelector("[role=columnheader]") || _this385.eCell;
    _this385.colsSpanning = colsSpanning;
    _this385.beans = beans;
    return _this385;
  }

  _createClass(_SetLeftFeature, [{
    key: "setColsSpanning",
    value: function setColsSpanning(colsSpanning) {
      this.colsSpanning = colsSpanning;
      this.onLeftChanged();
    }
  }, {
    key: "getColumnOrGroup",
    value: function getColumnOrGroup() {
      if (this.beans.gos.get("enableRtl") && this.colsSpanning) {
        return _last(this.colsSpanning);
      }

      return this.columnOrGroup;
    }
  }, {
    key: "postConstruct",
    value: function postConstruct() {
      this.addManagedListener(this.columnOrGroup, _Column2.EVENT_LEFT_CHANGED, this.onLeftChanged.bind(this));
      this.setLeftFirstTime();
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onLeftChanged.bind(this));
      this.addManagedPropertyListener("domLayout", this.onLeftChanged.bind(this));
    }
  }, {
    key: "setLeftFirstTime",
    value: function setLeftFirstTime() {
      var suppressMoveAnimation = this.beans.gos.get("suppressColumnMoveAnimation");

      var oldLeftExists = _exists(this.columnOrGroup.getOldLeft());

      var animateColumnMove = this.beans.columnAnimationService.isActive() && oldLeftExists && !suppressMoveAnimation;

      if (animateColumnMove) {
        this.animateInLeft();
      } else {
        this.onLeftChanged();
      }
    }
  }, {
    key: "animateInLeft",
    value: function animateInLeft() {
      var _this386 = this;

      var colOrGroup = this.getColumnOrGroup();
      var left = colOrGroup.getLeft();
      var oldLeft = colOrGroup.getOldLeft();
      var oldActualLeft = this.modifyLeftForPrintLayout(colOrGroup, oldLeft);
      var actualLeft = this.modifyLeftForPrintLayout(colOrGroup, left);
      this.setLeft(oldActualLeft);
      this.actualLeft = actualLeft;
      this.beans.columnAnimationService.executeNextVMTurn(function () {
        if (_this386.actualLeft === actualLeft) {
          _this386.setLeft(actualLeft);
        }
      });
    }
  }, {
    key: "onLeftChanged",
    value: function onLeftChanged() {
      var colOrGroup = this.getColumnOrGroup();
      var left = colOrGroup.getLeft();
      this.actualLeft = this.modifyLeftForPrintLayout(colOrGroup, left);
      this.setLeft(this.actualLeft);
    }
  }, {
    key: "modifyLeftForPrintLayout",
    value: function modifyLeftForPrintLayout(colOrGroup, leftPosition) {
      var printLayout = this.beans.gos.isDomLayout("print");

      if (!printLayout) {
        return leftPosition;
      }

      if (colOrGroup.getPinned() === "left") {
        return leftPosition;
      }

      var leftWidth = this.beans.columnModel.getDisplayedColumnsLeftWidth();

      if (colOrGroup.getPinned() === "right") {
        var bodyWidth = this.beans.columnModel.getBodyContainerWidth();
        return leftWidth + bodyWidth + leftPosition;
      }

      return leftWidth + leftPosition;
    }
  }, {
    key: "setLeft",
    value: function setLeft(value) {
      if (_exists(value)) {
        this.eCell.style.left = "".concat(value, "px");
      }

      var indexColumn;

      if (this.columnOrGroup instanceof _Column2) {
        indexColumn = this.columnOrGroup;
      } else {
        var columnGroup = this.columnOrGroup;
        var children = columnGroup.getLeafColumns();

        if (!children.length) {
          return;
        }

        if (children.length > 1) {
          _setAriaColSpan(this.ariaEl, children.length);
        }

        indexColumn = children[0];
      }
    }
  }]);

  return _SetLeftFeature;
}(_BeanStub2);

__decorateClass([_PostConstruct], _SetLeftFeature.prototype, "postConstruct", 1); // community-modules/core/src/headerRendering/cells/hoverFeature.ts


var HoverFeature =
/*#__PURE__*/
function (_BeanStub47) {
  "use strict";

  _inherits(HoverFeature, _BeanStub47);

  function HoverFeature(columns, element) {
    var _this387;

    _classCallCheck(this, HoverFeature);

    _this387 = _possibleConstructorReturn(this, _getPrototypeOf(HoverFeature).call(this));
    _this387.columns = columns;
    _this387.element = element;
    return _this387;
  }

  _createClass(HoverFeature, [{
    key: "postConstruct",
    value: function postConstruct() {
      if (this.gos.get("columnHoverHighlight")) {
        this.addMouseHoverListeners();
      }
    }
  }, {
    key: "addMouseHoverListeners",
    value: function addMouseHoverListeners() {
      this.addManagedListener(this.element, "mouseout", this.onMouseOut.bind(this));
      this.addManagedListener(this.element, "mouseover", this.onMouseOver.bind(this));
    }
  }, {
    key: "onMouseOut",
    value: function onMouseOut() {
      this.columnHoverService.clearMouseOver();
    }
  }, {
    key: "onMouseOver",
    value: function onMouseOver() {
      this.columnHoverService.setMouseOver(this.columns);
    }
  }]);

  return HoverFeature;
}(_BeanStub2);

__decorateClass([_Autowired("columnHoverService")], HoverFeature.prototype, "columnHoverService", 2);

__decorateClass([_PostConstruct], HoverFeature.prototype, "postConstruct", 1); // community-modules/core/src/headerRendering/cells/floatingFilter/headerFilterCellCtrl.ts


var _HeaderFilterCellCtrl =
/*#__PURE__*/
function (_AbstractHeaderCellCt) {
  "use strict";

  _inherits(_HeaderFilterCellCtrl, _AbstractHeaderCellCt);

  function _HeaderFilterCellCtrl(column, beans, parentRowCtrl) {
    var _this388;

    _classCallCheck(this, _HeaderFilterCellCtrl);

    _this388 = _possibleConstructorReturn(this, _getPrototypeOf(_HeaderFilterCellCtrl).call(this, column, beans, parentRowCtrl));
    _this388.iconCreated = false;
    _this388.column = column;
    return _this388;
  }

  _createClass(_HeaderFilterCellCtrl, [{
    key: "setComp",
    value: function setComp(comp, eGui, eButtonShowMainFilter, eFloatingFilterBody) {
      this.comp = comp;
      this.eButtonShowMainFilter = eButtonShowMainFilter;
      this.eFloatingFilterBody = eFloatingFilterBody;
      this.setGui(eGui);
      this.setupActive();
      this.setupWidth();
      this.setupLeft();
      this.setupHover();
      this.setupFocus();
      this.setupAria();
      this.setupFilterButton();
      this.setupUserComp();
      this.setupSyncWithFilter();
      this.setupUi();
      this.addManagedListener(this.eButtonShowMainFilter, "click", this.showParentFilter.bind(this));
      this.setupFilterChangedListener();
      this.addManagedListener(this.column, _Column2.EVENT_COL_DEF_CHANGED, this.onColDefChanged.bind(this));
    } // empty abstract method

  }, {
    key: "resizeHeader",
    value: function resizeHeader() {} // empty abstract method

  }, {
    key: "moveHeader",
    value: function moveHeader() {}
  }, {
    key: "setupActive",
    value: function setupActive() {
      var colDef = this.column.getColDef();
      var filterExists = !!colDef.filter;
      var floatingFilterExists = !!colDef.floatingFilter;
      this.active = filterExists && floatingFilterExists;
    }
  }, {
    key: "setupUi",
    value: function setupUi() {
      this.comp.setButtonWrapperDisplayed(!this.suppressFilterButton && this.active);
      this.comp.addOrRemoveBodyCssClass("ag-floating-filter-full-body", this.suppressFilterButton);
      this.comp.addOrRemoveBodyCssClass("ag-floating-filter-body", !this.suppressFilterButton);

      if (!this.active || this.iconCreated) {
        return;
      }

      var eMenuIcon = _createIconNoSpan("filter", this.gos, this.column);

      if (eMenuIcon) {
        this.iconCreated = true;
        this.eButtonShowMainFilter.appendChild(eMenuIcon);
      }
    }
  }, {
    key: "setupFocus",
    value: function setupFocus() {
      this.createManagedBean(new _ManagedFocusFeature2(this.eGui, {
        shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this)
      }));
    }
  }, {
    key: "setupAria",
    value: function setupAria() {
      var localeTextFunc = this.localeService.getLocaleTextFunc();

      _setAriaLabel(this.eButtonShowMainFilter, localeTextFunc("ariaFilterMenuOpen", "Open Filter Menu"));
    }
  }, {
    key: "onTabKeyDown",
    value: function onTabKeyDown(e) {
      var activeEl = this.gos.getActiveDomElement();
      var wrapperHasFocus = activeEl === this.eGui;

      if (wrapperHasFocus) {
        return;
      }

      var nextFocusableEl = this.focusService.findNextFocusableElement(this.eGui, null, e.shiftKey);

      if (nextFocusableEl) {
        this.beans.headerNavigationService.scrollToColumn(this.column);
        e.preventDefault();
        nextFocusableEl.focus();
        return;
      }

      var nextFocusableColumn = this.findNextColumnWithFloatingFilter(e.shiftKey);

      if (!nextFocusableColumn) {
        return;
      }

      if (this.focusService.focusHeaderPosition({
        headerPosition: {
          headerRowIndex: this.getParentRowCtrl().getRowIndex(),
          column: nextFocusableColumn
        },
        event: e
      })) {
        e.preventDefault();
      }
    }
  }, {
    key: "findNextColumnWithFloatingFilter",
    value: function findNextColumnWithFloatingFilter(backwards) {
      var columnModel = this.beans.columnModel;
      var nextCol = this.column;

      do {
        nextCol = backwards ? columnModel.getDisplayedColBefore(nextCol) : columnModel.getDisplayedColAfter(nextCol);

        if (!nextCol) {
          break;
        }
      } while (!nextCol.getColDef().filter || !nextCol.getColDef().floatingFilter);

      return nextCol;
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      _get(_getPrototypeOf(_HeaderFilterCellCtrl.prototype), "handleKeyDown", this).call(this, e);

      var wrapperHasFocus = this.getWrapperHasFocus();

      switch (e.key) {
        case _KeyCode.UP:
        case _KeyCode.DOWN:
          if (!wrapperHasFocus) {
            e.preventDefault();
          }

        case _KeyCode.LEFT:
        case _KeyCode.RIGHT:
          if (wrapperHasFocus) {
            return;
          }

          e.stopPropagation();

        case _KeyCode.ENTER:
          if (wrapperHasFocus) {
            if (this.focusService.focusInto(this.eGui)) {
              e.preventDefault();
            }
          }

          break;

        case _KeyCode.ESCAPE:
          if (!wrapperHasFocus) {
            this.eGui.focus();
          }

      }
    }
  }, {
    key: "onFocusIn",
    value: function onFocusIn(e) {
      var isRelatedWithin = this.eGui.contains(e.relatedTarget);

      if (isRelatedWithin) {
        return;
      }

      var notFromHeaderWrapper = !!e.relatedTarget && !e.relatedTarget.classList.contains("ag-floating-filter");

      var fromWithinHeader = !!e.relatedTarget && _isElementChildOfClass(e.relatedTarget, "ag-floating-filter");

      if (notFromHeaderWrapper && fromWithinHeader && e.target === this.eGui) {
        var lastFocusEvent = this.lastFocusEvent;
        var fromTab = !!(lastFocusEvent && lastFocusEvent.key === _KeyCode.TAB);

        if (lastFocusEvent && fromTab) {
          var shouldFocusLast = lastFocusEvent.shiftKey;
          this.focusService.focusInto(this.eGui, shouldFocusLast);
        }
      }

      var rowIndex = this.getRowIndex();
      this.beans.focusService.setFocusedHeader(rowIndex, this.column);
    }
  }, {
    key: "setupHover",
    value: function setupHover() {
      var _this389 = this;

      this.createManagedBean(new HoverFeature([this.column], this.eGui));

      var listener = function listener() {
        if (!_this389.gos.get("columnHoverHighlight")) {
          return;
        }

        var hovered = _this389.beans.columnHoverService.isHovered(_this389.column);

        _this389.comp.addOrRemoveCssClass("ag-column-hover", hovered);
      };

      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_HOVER_CHANGED, listener);
      listener();
    }
  }, {
    key: "setupLeft",
    value: function setupLeft() {
      var setLeftFeature = new _SetLeftFeature(this.column, this.eGui, this.beans);
      this.createManagedBean(setLeftFeature);
    }
  }, {
    key: "setupFilterButton",
    value: function setupFilterButton() {
      this.suppressFilterButton = !this.menuService.isFloatingFilterButtonEnabled(this.column);
      this.highlightFilterButtonWhenActive = !this.menuService.isLegacyMenuEnabled();
    }
  }, {
    key: "setupUserComp",
    value: function setupUserComp() {
      var _this390 = this;

      if (!this.active) {
        return;
      }

      var compDetails = this.beans.filterManager.getFloatingFilterCompDetails(this.column, function () {
        return _this390.showParentFilter();
      });

      if (compDetails) {
        this.setCompDetails(compDetails);
      }
    }
  }, {
    key: "setCompDetails",
    value: function setCompDetails(compDetails) {
      this.userCompDetails = compDetails;
      this.comp.setCompDetails(compDetails);
    }
  }, {
    key: "showParentFilter",
    value: function showParentFilter() {
      var eventSource = this.suppressFilterButton ? this.eFloatingFilterBody : this.eButtonShowMainFilter;
      this.menuService.showFilterMenu({
        column: this.column,
        buttonElement: eventSource,
        containerType: "floatingFilter",
        positionBy: "button"
      });
    }
  }, {
    key: "setupSyncWithFilter",
    value: function setupSyncWithFilter() {
      var _this391 = this;

      if (!this.active) {
        return;
      }

      var filterManager = this.beans.filterManager;

      var syncWithFilter = function syncWithFilter(event) {
        if ((event == null ? void 0 : event.source) === "filterDestroyed" && _this391.context.isDestroyed()) {
          return;
        }

        var compPromise = _this391.comp.getFloatingFilterComp();

        if (!compPromise) {
          return;
        }

        compPromise.then(function (comp) {
          var _a;

          if (comp) {
            var parentModel = filterManager.getCurrentFloatingFilterParentModel(_this391.column);
            comp.onParentModelChanged(parentModel, event ? _this391.gos.addGridCommonParams({
              columns: (_a = event.columns) != null ? _a : [],
              type: _Events.EVENT_FILTER_CHANGED,
              source: event.source === "api" ? "api" : "columnFilter"
            }) : null);
          }
        });
      };

      this.destroySyncListener = this.addManagedListener(this.column, _Column2.EVENT_FILTER_CHANGED, syncWithFilter);

      if (filterManager.isFilterActive(this.column)) {
        syncWithFilter(null);
      }
    }
  }, {
    key: "setupWidth",
    value: function setupWidth() {
      var _this392 = this;

      var listener = function listener() {
        var width = "".concat(_this392.column.getActualWidth(), "px");

        _this392.comp.setWidth(width);
      };

      this.addManagedListener(this.column, _Column2.EVENT_WIDTH_CHANGED, listener);
      listener();
    }
  }, {
    key: "setupFilterChangedListener",
    value: function setupFilterChangedListener() {
      if (this.active) {
        this.destroyFilterChangedListener = this.addManagedListener(this.column, _Column2.EVENT_FILTER_CHANGED, this.updateFilterButton.bind(this));
        this.updateFilterButton();
      }
    }
  }, {
    key: "updateFilterButton",
    value: function updateFilterButton() {
      if (!this.suppressFilterButton && this.comp) {
        var isFilterAllowed = this.beans.filterManager.isFilterAllowed(this.column);
        this.comp.setButtonWrapperDisplayed(isFilterAllowed);

        if (this.highlightFilterButtonWhenActive && isFilterAllowed) {
          this.eButtonShowMainFilter.classList.toggle("ag-filter-active", this.column.isFilterActive());
        }
      }
    }
  }, {
    key: "onColDefChanged",
    value: function onColDefChanged() {
      var _this393 = this;

      var _a, _b;

      var wasActive = this.active;
      this.setupActive();
      var becomeActive = !wasActive && this.active;

      if (wasActive && !this.active) {
        (_a = this.destroySyncListener) == null ? void 0 : _a.call(this);
        (_b = this.destroyFilterChangedListener) == null ? void 0 : _b.call(this);
      }

      var newCompDetails = this.active ? this.beans.filterManager.getFloatingFilterCompDetails(this.column, function () {
        return _this393.showParentFilter();
      }) : null;
      var compPromise = this.comp.getFloatingFilterComp();

      if (!compPromise || !newCompDetails) {
        this.updateCompDetails(newCompDetails, becomeActive);
      } else {
        compPromise.then(function (compInstance) {
          var _a2;

          if (!compInstance || _this393.beans.filterManager.areFilterCompsDifferent((_a2 = _this393.userCompDetails) != null ? _a2 : null, newCompDetails)) {
            _this393.updateCompDetails(newCompDetails, becomeActive);
          } else {
            _this393.updateFloatingFilterParams(newCompDetails);
          }
        });
      }
    }
  }, {
    key: "updateCompDetails",
    value: function updateCompDetails(compDetails, becomeActive) {
      if (!this.isAlive()) {
        return;
      }

      this.setCompDetails(compDetails);
      this.setupFilterButton();
      this.setupUi();

      if (becomeActive) {
        this.setupSyncWithFilter();
        this.setupFilterChangedListener();
      }
    }
  }, {
    key: "updateFloatingFilterParams",
    value: function updateFloatingFilterParams(userCompDetails) {
      var _a;

      if (!userCompDetails) {
        return;
      }

      var params = userCompDetails.params;
      (_a = this.comp.getFloatingFilterComp()) == null ? void 0 : _a.then(function (floatingFilter) {
        var hasRefreshed = false;

        if ((floatingFilter == null ? void 0 : floatingFilter.refresh) && typeof floatingFilter.refresh === "function") {
          var result = floatingFilter.refresh(params);

          if (result !== null) {
            hasRefreshed = true;
          }
        }

        if (!hasRefreshed && (floatingFilter == null ? void 0 : floatingFilter.onParamsUpdated) && typeof floatingFilter.onParamsUpdated === "function") {
          var _result2 = floatingFilter.onParamsUpdated(params);

          if (_result2 !== null) {
            _warnOnce("Custom floating filter method 'onParamsUpdated' is deprecated. Use 'refresh' instead.");
          }
        }
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(_HeaderFilterCellCtrl.prototype), "destroy", this).call(this);

      this.eButtonShowMainFilter = null;
      this.eFloatingFilterBody = null;
      this.userCompDetails = null;
      this.destroySyncListener = null;
      this.destroyFilterChangedListener = null;
    }
  }]);

  return _HeaderFilterCellCtrl;
}(_AbstractHeaderCellCtrl2); // community-modules/core/src/headerRendering/cells/column/resizeFeature.ts


var ResizeFeature =
/*#__PURE__*/
function (_BeanStub48) {
  "use strict";

  _inherits(ResizeFeature, _BeanStub48);

  function ResizeFeature(pinned, column, eResize, comp, ctrl) {
    var _this394;

    _classCallCheck(this, ResizeFeature);

    _this394 = _possibleConstructorReturn(this, _getPrototypeOf(ResizeFeature).call(this));
    _this394.pinned = pinned;
    _this394.column = column;
    _this394.eResize = eResize;
    _this394.comp = comp;
    _this394.ctrl = ctrl;
    return _this394;
  }

  _createClass(ResizeFeature, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this395 = this;

      var destroyResizeFuncs = [];
      var canResize;
      var canAutosize;

      var addResize = function addResize() {
        _setDisplayed(_this395.eResize, canResize);

        if (!canResize) {
          return;
        }

        var finishedWithResizeFunc = _this395.horizontalResizeService.addResizeBar({
          eResizeBar: _this395.eResize,
          onResizeStart: _this395.onResizeStart.bind(_this395),
          onResizing: _this395.onResizing.bind(_this395, false),
          onResizeEnd: _this395.onResizing.bind(_this395, true)
        });

        destroyResizeFuncs.push(finishedWithResizeFunc);

        if (canAutosize) {
          var skipHeaderOnAutoSize = _this395.gos.get("skipHeaderOnAutoSize");

          var autoSizeColListener = function autoSizeColListener() {
            _this395.columnModel.autoSizeColumn(_this395.column, "uiColumnResized", skipHeaderOnAutoSize);
          };

          _this395.eResize.addEventListener("dblclick", autoSizeColListener);

          var touchListener = new _TouchListener2(_this395.eResize);
          touchListener.addEventListener(_TouchListener2.EVENT_DOUBLE_TAP, autoSizeColListener);
          destroyResizeFuncs.push(function () {
            _this395.eResize.removeEventListener("dblclick", autoSizeColListener);

            touchListener.removeEventListener(_TouchListener2.EVENT_DOUBLE_TAP, autoSizeColListener);
            touchListener.destroy();
          });
        }
      };

      var removeResize = function removeResize() {
        destroyResizeFuncs.forEach(function (f) {
          return f();
        });
        destroyResizeFuncs.length = 0;
      };

      var refresh = function refresh() {
        var resize = _this395.column.isResizable();

        var autoSize = !_this395.gos.get("suppressAutoSize") && !_this395.column.getColDef().suppressAutoSize;
        var propertyChange = resize !== canResize || autoSize !== canAutosize;

        if (propertyChange) {
          canResize = resize;
          canAutosize = autoSize;
          removeResize();
          addResize();
        }
      };

      refresh();
      this.addDestroyFunc(removeResize);
      this.ctrl.addRefreshFunction(refresh);
    }
  }, {
    key: "onResizing",
    value: function onResizing(finished, resizeAmount) {
      var key = this.column,
          lastResizeAmount = this.lastResizeAmount,
          resizeStartWidth = this.resizeStartWidth;
      var resizeAmountNormalised = this.normaliseResizeAmount(resizeAmount);
      var newWidth = resizeStartWidth + resizeAmountNormalised;
      var columnWidths = [{
        key: key,
        newWidth: newWidth
      }];

      if (this.column.getPinned()) {
        var leftWidth = this.pinnedWidthService.getPinnedLeftWidth();
        var rightWidth = this.pinnedWidthService.getPinnedRightWidth();
        var bodyWidth = _getInnerWidth(this.ctrlsService.getGridBodyCtrl().getBodyViewportElement()) - 50;

        if (leftWidth + rightWidth + (resizeAmountNormalised - lastResizeAmount) > bodyWidth) {
          return;
        }
      }

      this.lastResizeAmount = resizeAmountNormalised;
      this.columnModel.setColumnWidths(columnWidths, this.resizeWithShiftKey, finished, "uiColumnResized");

      if (finished) {
        this.toggleColumnResizing(false);
      }
    }
  }, {
    key: "onResizeStart",
    value: function onResizeStart(shiftKey) {
      this.resizeStartWidth = this.column.getActualWidth();
      this.lastResizeAmount = 0;
      this.resizeWithShiftKey = shiftKey;
      this.toggleColumnResizing(true);
    }
  }, {
    key: "toggleColumnResizing",
    value: function toggleColumnResizing(resizing) {
      this.comp.addOrRemoveCssClass("ag-column-resizing", resizing);
    } // optionally inverts the drag, depending on pinned and RTL
    // note - this method is duplicated in RenderedHeaderGroupCell - should refactor out?

  }, {
    key: "normaliseResizeAmount",
    value: function normaliseResizeAmount(dragChange) {
      var result = dragChange;
      var notPinningLeft = this.pinned !== "left";
      var pinningRight = this.pinned === "right";

      if (this.gos.get("enableRtl")) {
        if (notPinningLeft) {
          result *= -1;
        }
      } else {
        if (pinningRight) {
          result *= -1;
        }
      }

      return result;
    }
  }]);

  return ResizeFeature;
}(_BeanStub2);

__decorateClass([_Autowired("horizontalResizeService")], ResizeFeature.prototype, "horizontalResizeService", 2);

__decorateClass([_Autowired("pinnedWidthService")], ResizeFeature.prototype, "pinnedWidthService", 2);

__decorateClass([_Autowired("ctrlsService")], ResizeFeature.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("columnModel")], ResizeFeature.prototype, "columnModel", 2);

__decorateClass([_PostConstruct], ResizeFeature.prototype, "postConstruct", 1); // community-modules/core/src/headerRendering/cells/column/selectAllFeature.ts


var SelectAllFeature =
/*#__PURE__*/
function (_BeanStub49) {
  "use strict";

  _inherits(SelectAllFeature, _BeanStub49);

  function SelectAllFeature(column) {
    var _this396;

    _classCallCheck(this, SelectAllFeature);

    _this396 = _possibleConstructorReturn(this, _getPrototypeOf(SelectAllFeature).call(this));
    _this396.cbSelectAllVisible = false;
    _this396.processingEventFromCheckbox = false;
    _this396.column = column;
    return _this396;
  }

  _createClass(SelectAllFeature, [{
    key: "onSpaceKeyDown",
    value: function onSpaceKeyDown(e) {
      var checkbox = this.cbSelectAll;

      if (checkbox.isDisplayed() && !checkbox.getGui().contains(this.gos.getActiveDomElement())) {
        e.preventDefault();
        checkbox.setValue(!checkbox.getValue());
      }
    }
  }, {
    key: "getCheckboxGui",
    value: function getCheckboxGui() {
      return this.cbSelectAll.getGui();
    }
  }, {
    key: "setComp",
    value: function setComp(ctrl) {
      this.headerCellCtrl = ctrl;
      this.cbSelectAll = this.createManagedBean(new _AgCheckbox());
      this.cbSelectAll.addCssClass("ag-header-select-all");

      _setAriaRole(this.cbSelectAll.getGui(), "presentation");

      this.showOrHideSelectAll();
      this.addManagedListener(this.eventService, _Events.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_SELECTION_CHANGED, this.onSelectionChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_PAGINATION_CHANGED, this.onSelectionChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_MODEL_UPDATED, this.onModelChanged.bind(this));
      this.addManagedListener(this.cbSelectAll, _Events.EVENT_FIELD_VALUE_CHANGED, this.onCbSelectAll.bind(this));

      _setAriaHidden(this.cbSelectAll.getGui(), true);

      this.cbSelectAll.getInputElement().setAttribute("tabindex", "-1");
      this.refreshSelectAllLabel();
    }
  }, {
    key: "onNewColumnsLoaded",
    value: function onNewColumnsLoaded() {
      this.showOrHideSelectAll();
    }
  }, {
    key: "onDisplayedColumnsChanged",
    value: function onDisplayedColumnsChanged() {
      if (!this.isAlive()) {
        return;
      }

      this.showOrHideSelectAll();
    }
  }, {
    key: "showOrHideSelectAll",
    value: function showOrHideSelectAll() {
      this.cbSelectAllVisible = this.isCheckboxSelection();
      this.cbSelectAll.setDisplayed(this.cbSelectAllVisible, {
        skipAriaHidden: true
      });

      if (this.cbSelectAllVisible) {
        this.checkRightRowModelType("selectAllCheckbox");
        this.checkSelectionType("selectAllCheckbox");
        this.updateStateOfCheckbox();
      }

      this.refreshSelectAllLabel();
    }
  }, {
    key: "onModelChanged",
    value: function onModelChanged() {
      if (!this.cbSelectAllVisible) {
        return;
      }

      this.updateStateOfCheckbox();
    }
  }, {
    key: "onSelectionChanged",
    value: function onSelectionChanged() {
      if (!this.cbSelectAllVisible) {
        return;
      }

      this.updateStateOfCheckbox();
    }
  }, {
    key: "updateStateOfCheckbox",
    value: function updateStateOfCheckbox() {
      if (this.processingEventFromCheckbox) {
        return;
      }

      this.processingEventFromCheckbox = true;
      var allSelected = this.selectionService.getSelectAllState(this.isFilteredOnly(), this.isCurrentPageOnly());
      this.cbSelectAll.setValue(allSelected);
      var hasNodesToSelect = this.selectionService.hasNodesToSelect(this.isFilteredOnly(), this.isCurrentPageOnly());
      this.cbSelectAll.setDisabled(!hasNodesToSelect);
      this.refreshSelectAllLabel();
      this.processingEventFromCheckbox = false;
    }
  }, {
    key: "refreshSelectAllLabel",
    value: function refreshSelectAllLabel() {
      var translate = this.localeService.getLocaleTextFunc();
      var checked = this.cbSelectAll.getValue();
      var ariaStatus = checked ? translate("ariaChecked", "checked") : translate("ariaUnchecked", "unchecked");
      var ariaLabel = translate("ariaRowSelectAll", "Press Space to toggle all rows selection");

      if (!this.cbSelectAllVisible) {
        this.headerCellCtrl.setAriaDescriptionProperty("selectAll", null);
      } else {
        this.headerCellCtrl.setAriaDescriptionProperty("selectAll", "".concat(ariaLabel, " (").concat(ariaStatus, ")"));
      }

      this.cbSelectAll.setInputAriaLabel("".concat(ariaLabel, " (").concat(ariaStatus, ")"));
      this.headerCellCtrl.announceAriaDescription();
    }
  }, {
    key: "checkSelectionType",
    value: function checkSelectionType(feature) {
      var isMultiSelect = this.gos.get("rowSelection") === "multiple";

      if (!isMultiSelect) {
        console.warn("AG Grid: ".concat(feature, " is only available if using 'multiple' rowSelection."));
        return false;
      }

      return true;
    }
  }, {
    key: "checkRightRowModelType",
    value: function checkRightRowModelType(feature) {
      var rowModelType = this.rowModel.getType();
      var rowModelMatches = rowModelType === "clientSide" || rowModelType === "serverSide";

      if (!rowModelMatches) {
        console.warn("AG Grid: ".concat(feature, " is only available if using 'clientSide' or 'serverSide' rowModelType, you are using ").concat(rowModelType, "."));
        return false;
      }

      return true;
    }
  }, {
    key: "onCbSelectAll",
    value: function onCbSelectAll() {
      if (this.processingEventFromCheckbox) {
        return;
      }

      if (!this.cbSelectAllVisible) {
        return;
      }

      var value = this.cbSelectAll.getValue();
      var justFiltered = this.isFilteredOnly();
      var justCurrentPage = this.isCurrentPageOnly();
      var source = "uiSelectAll";

      if (justCurrentPage) {
        source = "uiSelectAllCurrentPage";
      } else if (justFiltered) {
        source = "uiSelectAllFiltered";
      }

      var params = {
        source: source,
        justFiltered: justFiltered,
        justCurrentPage: justCurrentPage
      };

      if (value) {
        this.selectionService.selectAllRowNodes(params);
      } else {
        this.selectionService.deselectAllRowNodes(params);
      }
    }
  }, {
    key: "isCheckboxSelection",
    value: function isCheckboxSelection() {
      var result = this.column.getColDef().headerCheckboxSelection;

      if (typeof result === "function") {
        var func = result;
        var params = this.gos.addGridCommonParams({
          column: this.column,
          colDef: this.column.getColDef()
        });
        result = func(params);
      }

      if (result) {
        return this.checkRightRowModelType("headerCheckboxSelection") && this.checkSelectionType("headerCheckboxSelection");
      }

      return false;
    }
  }, {
    key: "isFilteredOnly",
    value: function isFilteredOnly() {
      return !!this.column.getColDef().headerCheckboxSelectionFilteredOnly;
    }
  }, {
    key: "isCurrentPageOnly",
    value: function isCurrentPageOnly() {
      return !!this.column.getColDef().headerCheckboxSelectionCurrentPageOnly;
    }
  }]);

  return SelectAllFeature;
}(_BeanStub2);

__decorateClass([_Autowired("rowModel")], SelectAllFeature.prototype, "rowModel", 2);

__decorateClass([_Autowired("selectionService")], SelectAllFeature.prototype, "selectionService", 2); // community-modules/core/src/headerRendering/cells/column/headerCellCtrl.ts


var _HeaderCellCtrl =
/*#__PURE__*/
function (_AbstractHeaderCellCt2) {
  "use strict";

  _inherits(_HeaderCellCtrl, _AbstractHeaderCellCt2);

  function _HeaderCellCtrl(column, beans, parentRowCtrl) {
    var _this397;

    _classCallCheck(this, _HeaderCellCtrl);

    _this397 = _possibleConstructorReturn(this, _getPrototypeOf(_HeaderCellCtrl).call(this, column, beans, parentRowCtrl));
    _this397.refreshFunctions = [];
    _this397.userHeaderClasses =
    /* @__PURE__ */
    new Set();
    _this397.ariaDescriptionProperties =
    /* @__PURE__ */
    new Map();
    _this397.column = column;
    return _this397;
  }

  _createClass(_HeaderCellCtrl, [{
    key: "setComp",
    value: function setComp(comp, eGui, eResize, eHeaderCompWrapper) {
      var _this398 = this;

      this.comp = comp;
      this.setGui(eGui);
      this.updateState();
      this.setupWidth();
      this.setupMovingCss();
      this.setupMenuClass();
      this.setupSortableClass();
      this.setupWrapTextClass();
      this.refreshSpanHeaderHeight();
      this.setupAutoHeight(eHeaderCompWrapper);
      this.addColumnHoverListener();
      this.setupFilterClass();
      this.setupClassesFromColDef();
      this.setupTooltip();
      this.addActiveHeaderMouseListeners();
      this.setupSelectAll();
      this.setupUserComp();
      this.refreshAria();
      this.resizeFeature = this.createManagedBean(new ResizeFeature(this.getPinned(), this.column, eResize, comp, this));
      this.createManagedBean(new HoverFeature([this.column], eGui));
      this.createManagedBean(new _SetLeftFeature(this.column, eGui, this.beans));
      this.createManagedBean(new _ManagedFocusFeature2(eGui, {
        shouldStopEventPropagation: function shouldStopEventPropagation(e) {
          return _this398.shouldStopEventPropagation(e);
        },
        onTabKeyDown: function onTabKeyDown() {
          return null;
        },
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this),
        onFocusOut: this.onFocusOut.bind(this)
      }));
      this.addResizeAndMoveKeyboardListeners();
      this.addManagedPropertyListeners(["suppressMovableColumns", "suppressMenuHide", "suppressAggFuncInHeader"], this.refresh.bind(this));
      this.addManagedListener(this.column, _Column2.EVENT_COL_DEF_CHANGED, this.refresh.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_VALUE_CHANGED, this.onColumnValueChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onColumnRowGroupChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_PIVOT_CHANGED, this.onColumnPivotChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_HEADER_HEIGHT_CHANGED, this.onHeaderHeightChanged.bind(this));
    }
  }, {
    key: "resizeHeader",
    value: function resizeHeader(delta, shiftKey) {
      var _a, _b;

      if (!this.column.isResizable()) {
        return;
      }

      var actualWidth = this.column.getActualWidth();
      var minWidth = (_a = this.column.getMinWidth()) != null ? _a : 0;
      var maxWidth = (_b = this.column.getMaxWidth()) != null ? _b : Number.MAX_SAFE_INTEGER;
      var newWidth = Math.min(Math.max(actualWidth + delta, minWidth), maxWidth);
      this.beans.columnModel.setColumnWidths([{
        key: this.column,
        newWidth: newWidth
      }], shiftKey, true, "uiColumnResized");
    }
  }, {
    key: "moveHeader",
    value: function moveHeader(hDirection) {
      var eGui = this.eGui,
          column = this.column,
          gos = this.gos,
          ctrlsService = this.ctrlsService;
      var pinned = this.getPinned();
      var left = eGui.getBoundingClientRect().left;
      var width = column.getActualWidth();
      var isRtl = gos.get("enableRtl");
      var isLeft = hDirection === 0
      /* Left */
      !== isRtl;
      var xPosition = ColumnMoveHelper.normaliseX(isLeft ? left - 20 : left + width + 20, pinned, true, gos, ctrlsService);
      ColumnMoveHelper.attemptMoveColumns({
        allMovingColumns: [column],
        isFromHeader: true,
        hDirection: hDirection,
        xPosition: xPosition,
        pinned: pinned,
        fromEnter: false,
        fakeEvent: false,
        gos: gos,
        columnModel: this.beans.columnModel
      });
      ctrlsService.getGridBodyCtrl().getScrollFeature().ensureColumnVisible(column, "auto");
    }
  }, {
    key: "setupUserComp",
    value: function setupUserComp() {
      var compDetails = this.lookupUserCompDetails();
      this.setCompDetails(compDetails);
    }
  }, {
    key: "setCompDetails",
    value: function setCompDetails(compDetails) {
      this.userCompDetails = compDetails;
      this.comp.setUserCompDetails(compDetails);
    }
  }, {
    key: "lookupUserCompDetails",
    value: function lookupUserCompDetails() {
      var params = this.createParams();
      var colDef = this.column.getColDef();
      return this.userComponentFactory.getHeaderCompDetails(colDef, params);
    }
  }, {
    key: "createParams",
    value: function createParams() {
      var _this399 = this;

      var params = this.gos.addGridCommonParams({
        column: this.column,
        displayName: this.displayName,
        enableSorting: this.column.isSortable(),
        enableMenu: this.menuEnabled,
        enableFilterButton: this.openFilterEnabled && this.menuService.isHeaderFilterButtonEnabled(this.column),
        enableFilterIcon: !this.openFilterEnabled || this.menuService.isLegacyMenuEnabled(),
        showColumnMenu: function showColumnMenu(buttonElement) {
          _this399.menuService.showColumnMenu({
            column: _this399.column,
            buttonElement: buttonElement,
            positionBy: "button"
          });
        },
        showColumnMenuAfterMouseClick: function showColumnMenuAfterMouseClick(mouseEvent) {
          _this399.menuService.showColumnMenu({
            column: _this399.column,
            mouseEvent: mouseEvent,
            positionBy: "mouse"
          });
        },
        showFilter: function showFilter(buttonElement) {
          _this399.menuService.showFilterMenu({
            column: _this399.column,
            buttonElement: buttonElement,
            containerType: "columnFilter",
            positionBy: "button"
          });
        },
        progressSort: function progressSort(multiSort) {
          _this399.beans.sortController.progressSort(_this399.column, !!multiSort, "uiColumnSorted");
        },
        setSort: function setSort(sort, multiSort) {
          _this399.beans.sortController.setSortForColumn(_this399.column, sort, !!multiSort, "uiColumnSorted");
        },
        eGridHeader: this.getGui(),
        setTooltip: function setTooltip(value, shouldDisplayTooltip) {
          _this399.setupTooltip(value, shouldDisplayTooltip);
        }
      });
      return params;
    }
  }, {
    key: "setupSelectAll",
    value: function setupSelectAll() {
      this.selectAllFeature = this.createManagedBean(new SelectAllFeature(this.column));
      this.selectAllFeature.setComp(this);
    }
  }, {
    key: "getSelectAllGui",
    value: function getSelectAllGui() {
      return this.selectAllFeature.getCheckboxGui();
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      _get(_getPrototypeOf(_HeaderCellCtrl.prototype), "handleKeyDown", this).call(this, e);

      if (e.key === _KeyCode.SPACE) {
        this.selectAllFeature.onSpaceKeyDown(e);
      }

      if (e.key === _KeyCode.ENTER) {
        this.onEnterKeyDown(e);
      }

      if (e.key === _KeyCode.DOWN && e.altKey) {
        this.showMenuOnKeyPress(e, false);
      }
    }
  }, {
    key: "onEnterKeyDown",
    value: function onEnterKeyDown(e) {
      if (e.ctrlKey || e.metaKey) {
        this.showMenuOnKeyPress(e, true);
      } else if (this.sortable) {
        var multiSort = e.shiftKey;
        this.beans.sortController.progressSort(this.column, multiSort, "uiColumnSorted");
      }
    }
  }, {
    key: "showMenuOnKeyPress",
    value: function showMenuOnKeyPress(e, isFilterShortcut) {
      var headerComp = this.comp.getUserCompInstance();

      if (!headerComp || !(headerComp instanceof HeaderComp)) {
        return;
      }

      if (headerComp.onMenuKeyboardShortcut(isFilterShortcut)) {
        e.preventDefault();
      }
    }
  }, {
    key: "onFocusIn",
    value: function onFocusIn(e) {
      if (!this.getGui().contains(e.relatedTarget)) {
        var rowIndex = this.getRowIndex();
        this.focusService.setFocusedHeader(rowIndex, this.column);
        this.announceAriaDescription();
      }

      if (this.focusService.isKeyboardMode()) {
        this.setActiveHeader(true);
      }
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut(e) {
      if (this.getGui().contains(e.relatedTarget)) {
        return;
      }

      this.setActiveHeader(false);
    }
  }, {
    key: "setupTooltip",
    value: function setupTooltip(value, shouldDisplayTooltip) {
      var _this400 = this;

      if (this.tooltipFeature) {
        this.tooltipFeature = this.destroyBean(this.tooltipFeature);
      }

      var isTooltipWhenTruncated = this.gos.get("tooltipShowMode") === "whenTruncated";
      var eGui = this.eGui;
      var colDef = this.column.getColDef();

      if (!shouldDisplayTooltip && isTooltipWhenTruncated && !colDef.headerComponent) {
        shouldDisplayTooltip = function shouldDisplayTooltip() {
          var textEl = eGui.querySelector(".ag-header-cell-text");

          if (!textEl) {
            return true;
          }

          return textEl.scrollWidth > textEl.clientWidth;
        };
      }

      var tooltipCtrl = {
        getColumn: function getColumn() {
          return _this400.column;
        },
        getColDef: function getColDef() {
          return _this400.column.getColDef();
        },
        getGui: function getGui() {
          return eGui;
        },
        getLocation: function getLocation() {
          return "header";
        },
        getTooltipValue: function getTooltipValue() {
          if (value != null) {
            return value;
          }

          var res = _this400.column.getColDef().headerTooltip;

          return res;
        },
        shouldDisplayTooltip: shouldDisplayTooltip
      };
      var tooltipFeature = this.createManagedBean(new _TooltipFeature(tooltipCtrl));
      this.refreshFunctions.push(function () {
        return tooltipFeature.refreshToolTip();
      });
    }
  }, {
    key: "setupClassesFromColDef",
    value: function setupClassesFromColDef() {
      var _this401 = this;

      var refreshHeaderClasses = function refreshHeaderClasses() {
        var colDef = _this401.column.getColDef();

        var classes = _CssClassApplier.getHeaderClassesFromColDef(colDef, _this401.gos, _this401.column, null);

        var oldClasses = _this401.userHeaderClasses;
        _this401.userHeaderClasses = new Set(classes);
        classes.forEach(function (c) {
          if (oldClasses.has(c)) {
            oldClasses.delete(c);
          } else {
            _this401.comp.addOrRemoveCssClass(c, true);
          }
        });
        oldClasses.forEach(function (c) {
          return _this401.comp.addOrRemoveCssClass(c, false);
        });
      };

      this.refreshFunctions.push(refreshHeaderClasses);
      refreshHeaderClasses();
    }
  }, {
    key: "setDragSource",
    value: function setDragSource(eSource) {
      var _this402 = this;

      this.dragSourceElement = eSource;
      this.removeDragSource();

      if (!eSource || !this.draggable) {
        return;
      }

      var column = this.column,
          beans = this.beans,
          displayName = this.displayName,
          dragAndDropService = this.dragAndDropService,
          gos = this.gos;
      var columnModel = beans.columnModel;
      var hideColumnOnExit = !this.gos.get("suppressDragLeaveHidesColumns");
      var dragSource = this.dragSource = {
        type: 1
        /* HeaderCell */
        ,
        eElement: eSource,
        getDefaultIconName: function getDefaultIconName() {
          return hideColumnOnExit ? _DragAndDropService2.ICON_HIDE : _DragAndDropService2.ICON_NOT_ALLOWED;
        },
        getDragItem: function getDragItem() {
          return _this402.createDragItem(column);
        },
        dragItemName: displayName,
        onDragStarted: function onDragStarted() {
          hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
          column.setMoving(true, "uiColumnMoved");
        },
        onDragStopped: function onDragStopped() {
          return column.setMoving(false, "uiColumnMoved");
        },
        onGridEnter: function onGridEnter(dragItem) {
          var _a;

          if (hideColumnOnExit) {
            var unlockedColumns = ((_a = dragItem == null ? void 0 : dragItem.columns) == null ? void 0 : _a.filter(function (col) {
              return !col.getColDef().lockVisible;
            })) || [];
            columnModel.setColumnsVisible(unlockedColumns, true, "uiColumnMoved");
          }
        },
        onGridExit: function onGridExit(dragItem) {
          var _a;

          if (hideColumnOnExit) {
            var unlockedColumns = ((_a = dragItem == null ? void 0 : dragItem.columns) == null ? void 0 : _a.filter(function (col) {
              return !col.getColDef().lockVisible;
            })) || [];
            columnModel.setColumnsVisible(unlockedColumns, false, "uiColumnMoved");
          }
        }
      };
      dragAndDropService.addDragSource(dragSource, true);
    }
  }, {
    key: "createDragItem",
    value: function createDragItem(column) {
      var visibleState = {};
      visibleState[column.getId()] = column.isVisible();
      return {
        columns: [column],
        visibleState: visibleState
      };
    }
  }, {
    key: "updateState",
    value: function updateState() {
      this.menuEnabled = this.menuService.isColumnMenuInHeaderEnabled(this.column);
      this.openFilterEnabled = this.menuService.isFilterMenuInHeaderEnabled(this.column);
      this.sortable = this.column.isSortable();
      this.displayName = this.calculateDisplayName();
      this.draggable = this.workOutDraggable();
    }
  }, {
    key: "addRefreshFunction",
    value: function addRefreshFunction(func) {
      this.refreshFunctions.push(func);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.updateState();
      this.refreshHeaderComp();
      this.refreshAria();
      this.refreshFunctions.forEach(function (f) {
        return f();
      });
    }
  }, {
    key: "refreshHeaderComp",
    value: function refreshHeaderComp() {
      var newCompDetails = this.lookupUserCompDetails();
      var compInstance = this.comp.getUserCompInstance();
      var attemptRefresh = compInstance != null && this.userCompDetails.componentClass == newCompDetails.componentClass;
      var headerCompRefreshed = attemptRefresh ? this.attemptHeaderCompRefresh(newCompDetails.params) : false;

      if (headerCompRefreshed) {
        this.setDragSource(this.dragSourceElement);
      } else {
        this.setCompDetails(newCompDetails);
      }
    }
  }, {
    key: "attemptHeaderCompRefresh",
    value: function attemptHeaderCompRefresh(params) {
      var headerComp = this.comp.getUserCompInstance();

      if (!headerComp) {
        return false;
      }

      if (!headerComp.refresh) {
        return false;
      }

      var res = headerComp.refresh(params);
      return res;
    }
  }, {
    key: "calculateDisplayName",
    value: function calculateDisplayName() {
      return this.beans.columnModel.getDisplayNameForColumn(this.column, "header", true);
    }
  }, {
    key: "checkDisplayName",
    value: function checkDisplayName() {
      if (this.displayName !== this.calculateDisplayName()) {
        this.refresh();
      }
    }
  }, {
    key: "workOutDraggable",
    value: function workOutDraggable() {
      var colDef = this.column.getColDef();
      var isSuppressMovableColumns = this.gos.get("suppressMovableColumns");
      var colCanMove = !isSuppressMovableColumns && !colDef.suppressMovable && !colDef.lockPosition;
      return !!colCanMove || !!colDef.enableRowGroup || !!colDef.enablePivot;
    }
  }, {
    key: "onColumnRowGroupChanged",
    value: function onColumnRowGroupChanged() {
      this.checkDisplayName();
    }
  }, {
    key: "onColumnPivotChanged",
    value: function onColumnPivotChanged() {
      this.checkDisplayName();
    }
  }, {
    key: "onColumnValueChanged",
    value: function onColumnValueChanged() {
      this.checkDisplayName();
    }
  }, {
    key: "setupWidth",
    value: function setupWidth() {
      var _this403 = this;

      var listener = function listener() {
        var columnWidth = _this403.column.getActualWidth();

        _this403.comp.setWidth("".concat(columnWidth, "px"));
      };

      this.addManagedListener(this.column, _Column2.EVENT_WIDTH_CHANGED, listener);
      listener();
    }
  }, {
    key: "setupMovingCss",
    value: function setupMovingCss() {
      var _this404 = this;

      var listener = function listener() {
        _this404.comp.addOrRemoveCssClass("ag-header-cell-moving", _this404.column.isMoving());
      };

      this.addManagedListener(this.column, _Column2.EVENT_MOVING_CHANGED, listener);
      listener();
    }
  }, {
    key: "setupMenuClass",
    value: function setupMenuClass() {
      var _this405 = this;

      var listener = function listener() {
        _this405.comp.addOrRemoveCssClass("ag-column-menu-visible", _this405.column.isMenuVisible());
      };

      this.addManagedListener(this.column, _Column2.EVENT_MENU_VISIBLE_CHANGED, listener);
      listener();
    }
  }, {
    key: "setupSortableClass",
    value: function setupSortableClass() {
      var _this406 = this;

      var updateSortableCssClass = function updateSortableCssClass() {
        _this406.comp.addOrRemoveCssClass("ag-header-cell-sortable", !!_this406.sortable);
      };

      updateSortableCssClass();
      this.addRefreshFunction(updateSortableCssClass);
      this.addManagedListener(this.eventService, _Column2.EVENT_SORT_CHANGED, this.refreshAriaSort.bind(this));
    }
  }, {
    key: "setupFilterClass",
    value: function setupFilterClass() {
      var _this407 = this;

      var listener = function listener() {
        var isFilterActive = _this407.column.isFilterActive();

        _this407.comp.addOrRemoveCssClass("ag-header-cell-filtered", isFilterActive);

        _this407.refreshAria();
      };

      this.addManagedListener(this.column, _Column2.EVENT_FILTER_ACTIVE_CHANGED, listener);
      listener();
    }
  }, {
    key: "setupWrapTextClass",
    value: function setupWrapTextClass() {
      var _this408 = this;

      var listener = function listener() {
        var wrapText = !!_this408.column.getColDef().wrapHeaderText;

        _this408.comp.addOrRemoveCssClass("ag-header-cell-wrap-text", wrapText);
      };

      listener();
      this.addRefreshFunction(listener);
    }
  }, {
    key: "onDisplayedColumnsChanged",
    value: function onDisplayedColumnsChanged() {
      _get(_getPrototypeOf(_HeaderCellCtrl.prototype), "onDisplayedColumnsChanged", this).call(this);

      if (!this.isAlive()) {
        return;
      }

      this.onHeaderHeightChanged();
    }
  }, {
    key: "onHeaderHeightChanged",
    value: function onHeaderHeightChanged() {
      this.refreshSpanHeaderHeight();
    }
  }, {
    key: "refreshSpanHeaderHeight",
    value: function refreshSpanHeaderHeight() {
      var eGui = this.eGui,
          column = this.column,
          comp = this.comp,
          beans = this.beans;

      if (!column.isSpanHeaderHeight()) {
        eGui.style.removeProperty("top");
        eGui.style.removeProperty("height");
        comp.addOrRemoveCssClass("ag-header-span-height", false);
        comp.addOrRemoveCssClass("ag-header-span-total", false);
        return;
      }

      var _this$column$getColum = this.column.getColumnGroupPaddingInfo(),
          numberOfParents = _this$column$getColum.numberOfParents,
          isSpanningTotal = _this$column$getColum.isSpanningTotal;

      comp.addOrRemoveCssClass("ag-header-span-height", numberOfParents > 0);
      var columnModel = beans.columnModel;
      var headerHeight = columnModel.getColumnHeaderRowHeight();

      if (numberOfParents === 0) {
        comp.addOrRemoveCssClass("ag-header-span-total", false);
        eGui.style.setProperty("top", "0px");
        eGui.style.setProperty("height", "".concat(headerHeight, "px"));
        return;
      }

      comp.addOrRemoveCssClass("ag-header-span-total", isSpanningTotal);
      var pivotMode = columnModel.isPivotMode();
      var groupHeaderHeight = pivotMode ? columnModel.getPivotGroupHeaderHeight() : columnModel.getGroupHeaderHeight();
      var extraHeight = numberOfParents * groupHeaderHeight;
      eGui.style.setProperty("top", "".concat(-extraHeight, "px"));
      eGui.style.setProperty("height", "".concat(headerHeight + extraHeight, "px"));
    }
  }, {
    key: "setupAutoHeight",
    value: function setupAutoHeight(wrapperElement) {
      var _this409 = this;

      var _this$beans2 = this.beans,
          columnModel = _this$beans2.columnModel,
          resizeObserverService = _this$beans2.resizeObserverService;

      var measureHeight = function measureHeight(timesCalled) {
        if (!_this409.isAlive()) {
          return;
        }

        var _getElementSize4 = _getElementSize(_this409.getGui()),
            paddingTop = _getElementSize4.paddingTop,
            paddingBottom = _getElementSize4.paddingBottom,
            borderBottomWidth = _getElementSize4.borderBottomWidth,
            borderTopWidth = _getElementSize4.borderTopWidth;

        var extraHeight = paddingTop + paddingBottom + borderBottomWidth + borderTopWidth;
        var wrapperHeight = wrapperElement.offsetHeight;
        var autoHeight = wrapperHeight + extraHeight;

        if (timesCalled < 5) {
          var doc = _this409.beans.gos.getDocument();

          var notYetInDom = !doc || !doc.contains(wrapperElement);
          var possiblyNoContentYet = autoHeight == 0;

          if (notYetInDom || possiblyNoContentYet) {
            window.setTimeout(function () {
              return measureHeight(timesCalled + 1);
            }, 0);
            return;
          }
        }

        columnModel.setColumnHeaderHeight(_this409.column, autoHeight);
      };

      var isMeasuring = false;
      var stopResizeObserver;

      var checkMeasuring = function checkMeasuring() {
        var newValue = _this409.column.isAutoHeaderHeight();

        if (newValue && !isMeasuring) {
          startMeasuring();
        }

        if (!newValue && isMeasuring) {
          stopMeasuring();
        }
      };

      var startMeasuring = function startMeasuring() {
        isMeasuring = true;
        measureHeight(0);

        _this409.comp.addOrRemoveCssClass("ag-header-cell-auto-height", true);

        stopResizeObserver = resizeObserverService.observeResize(wrapperElement, function () {
          return measureHeight(0);
        });
      };

      var stopMeasuring = function stopMeasuring() {
        isMeasuring = false;

        if (stopResizeObserver) {
          stopResizeObserver();
        }

        _this409.comp.addOrRemoveCssClass("ag-header-cell-auto-height", false);

        stopResizeObserver = void 0;
      };

      checkMeasuring();
      this.addDestroyFunc(function () {
        return stopMeasuring();
      });
      this.addManagedListener(this.column, _Column2.EVENT_WIDTH_CHANGED, function () {
        return isMeasuring && measureHeight(0);
      });
      this.addManagedListener(this.eventService, _Column2.EVENT_SORT_CHANGED, function () {
        if (isMeasuring) {
          window.setTimeout(function () {
            return measureHeight(0);
          });
        }
      });
      this.addRefreshFunction(checkMeasuring);
    }
  }, {
    key: "refreshAriaSort",
    value: function refreshAriaSort() {
      if (this.sortable) {
        var translate = this.localeService.getLocaleTextFunc();
        var sort = this.beans.sortController.getDisplaySortForColumn(this.column) || null;
        this.comp.setAriaSort(_getAriaSortState(sort));
        this.setAriaDescriptionProperty("sort", translate("ariaSortableColumn", "Press ENTER to sort"));
      } else {
        this.comp.setAriaSort();
        this.setAriaDescriptionProperty("sort", null);
      }
    }
  }, {
    key: "refreshAriaMenu",
    value: function refreshAriaMenu() {
      if (this.menuEnabled) {
        var translate = this.localeService.getLocaleTextFunc();
        this.setAriaDescriptionProperty("menu", translate("ariaMenuColumn", "Press ALT DOWN to open column menu"));
      } else {
        this.setAriaDescriptionProperty("menu", null);
      }
    }
  }, {
    key: "refreshAriaFilterButton",
    value: function refreshAriaFilterButton() {
      if (this.openFilterEnabled && !this.menuService.isLegacyMenuEnabled()) {
        var translate = this.localeService.getLocaleTextFunc();
        this.setAriaDescriptionProperty("filterButton", translate("ariaFilterColumn", "Press CTRL ENTER to open filter"));
      } else {
        this.setAriaDescriptionProperty("filterButton", null);
      }
    }
  }, {
    key: "refreshAriaFiltered",
    value: function refreshAriaFiltered() {
      var translate = this.localeService.getLocaleTextFunc();
      var isFilterActive = this.column.isFilterActive();

      if (isFilterActive) {
        this.setAriaDescriptionProperty("filter", translate("ariaColumnFiltered", "Column Filtered"));
      } else {
        this.setAriaDescriptionProperty("filter", null);
      }
    }
  }, {
    key: "setAriaDescriptionProperty",
    value: function setAriaDescriptionProperty(property, value) {
      if (value != null) {
        this.ariaDescriptionProperties.set(property, value);
      } else {
        this.ariaDescriptionProperties.delete(property);
      }
    }
  }, {
    key: "announceAriaDescription",
    value: function announceAriaDescription() {
      var _this410 = this;

      if (!this.eGui.contains(this.beans.gos.getActiveDomElement())) {
        return;
      }

      var ariaDescription = Array.from(this.ariaDescriptionProperties.keys()).sort(function (a, b) {
        return a === "filter" ? -1 : b.charCodeAt(0) - a.charCodeAt(0);
      }).map(function (key) {
        return _this410.ariaDescriptionProperties.get(key);
      }).join(". ");
      this.beans.ariaAnnouncementService.announceValue(ariaDescription);
    }
  }, {
    key: "refreshAria",
    value: function refreshAria() {
      this.refreshAriaSort();
      this.refreshAriaMenu();
      this.refreshAriaFilterButton();
      this.refreshAriaFiltered();
    }
  }, {
    key: "addColumnHoverListener",
    value: function addColumnHoverListener() {
      var _this411 = this;

      var listener = function listener() {
        if (!_this411.gos.get("columnHoverHighlight")) {
          return;
        }

        var isHovered = _this411.beans.columnHoverService.isHovered(_this411.column);

        _this411.comp.addOrRemoveCssClass("ag-column-hover", isHovered);
      };

      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_HOVER_CHANGED, listener);
      listener();
    }
  }, {
    key: "getColId",
    value: function getColId() {
      return this.column.getColId();
    }
  }, {
    key: "addActiveHeaderMouseListeners",
    value: function addActiveHeaderMouseListeners() {
      var _this412 = this;

      var listener = function listener(e) {
        return _this412.handleMouseOverChange(e.type === "mouseenter");
      };

      var clickListener = function clickListener() {
        return _this412.dispatchColumnMouseEvent(_Events.EVENT_COLUMN_HEADER_CLICKED, _this412.column);
      };

      var contextMenuListener = function contextMenuListener(event) {
        return _this412.handleContextMenuMouseEvent(event, void 0, _this412.column);
      };

      this.addManagedListener(this.getGui(), "mouseenter", listener);
      this.addManagedListener(this.getGui(), "mouseleave", listener);
      this.addManagedListener(this.getGui(), "click", clickListener);
      this.addManagedListener(this.getGui(), "contextmenu", contextMenuListener);
    }
  }, {
    key: "handleMouseOverChange",
    value: function handleMouseOverChange(isMouseOver) {
      this.setActiveHeader(isMouseOver);
      var eventType = isMouseOver ? _Events.EVENT_COLUMN_HEADER_MOUSE_OVER : _Events.EVENT_COLUMN_HEADER_MOUSE_LEAVE;
      var event = {
        type: eventType,
        column: this.column
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "setActiveHeader",
    value: function setActiveHeader(active) {
      this.comp.addOrRemoveCssClass("ag-header-active", active);
    }
  }, {
    key: "getAnchorElementForMenu",
    value: function getAnchorElementForMenu(isFilter) {
      var headerComp = this.comp.getUserCompInstance();

      if (headerComp instanceof HeaderComp) {
        return headerComp.getAnchorElementForMenu(isFilter);
      }

      return this.getGui();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(_HeaderCellCtrl.prototype), "destroy", this).call(this);

      this.refreshFunctions = null;
      this.selectAllFeature = null;
      this.dragSourceElement = null;
      this.userCompDetails = null;
      this.userHeaderClasses = null;
      this.ariaDescriptionProperties = null;
    }
  }]);

  return _HeaderCellCtrl;
}(_AbstractHeaderCellCtrl2); // community-modules/core/src/headerRendering/cells/columnGroup/groupResizeFeature.ts


var GroupResizeFeature =
/*#__PURE__*/
function (_BeanStub50) {
  "use strict";

  _inherits(GroupResizeFeature, _BeanStub50);

  function GroupResizeFeature(comp, eResize, pinned, columnGroup) {
    var _this413;

    _classCallCheck(this, GroupResizeFeature);

    _this413 = _possibleConstructorReturn(this, _getPrototypeOf(GroupResizeFeature).call(this));
    _this413.eResize = eResize;
    _this413.comp = comp;
    _this413.pinned = pinned;
    _this413.columnGroup = columnGroup;
    return _this413;
  }

  _createClass(GroupResizeFeature, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this414 = this;

      if (!this.columnGroup.isResizable()) {
        this.comp.setResizableDisplayed(false);
        return;
      }

      var finishedWithResizeFunc = this.horizontalResizeService.addResizeBar({
        eResizeBar: this.eResize,
        onResizeStart: this.onResizeStart.bind(this),
        onResizing: this.onResizing.bind(this, false),
        onResizeEnd: this.onResizing.bind(this, true)
      });
      this.addDestroyFunc(finishedWithResizeFunc);

      if (!this.gos.get("suppressAutoSize")) {
        var skipHeaderOnAutoSize = this.gos.get("skipHeaderOnAutoSize");
        this.eResize.addEventListener("dblclick", function () {
          var keys2 = [];

          var leafCols = _this414.columnGroup.getDisplayedLeafColumns();

          leafCols.forEach(function (column) {
            if (!column.getColDef().suppressAutoSize) {
              keys2.push(column.getColId());
            }
          });

          if (keys2.length > 0) {
            _this414.columnModel.autoSizeColumns({
              columns: keys2,
              skipHeader: skipHeaderOnAutoSize,
              stopAtGroup: _this414.columnGroup,
              source: "uiColumnResized"
            });
          }

          _this414.resizeLeafColumnsToFit("uiColumnResized");
        });
      }
    }
  }, {
    key: "onResizeStart",
    value: function onResizeStart(shiftKey) {
      var initialValues = this.getInitialValues(shiftKey);
      this.storeLocalValues(initialValues);
      this.toggleColumnResizing(true);
    }
  }, {
    key: "onResizing",
    value: function onResizing(finished, resizeAmount) {
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "uiColumnResized";
      var resizeAmountNormalised = this.normaliseDragChange(resizeAmount);
      var width = this.resizeStartWidth + resizeAmountNormalised;
      this.resizeColumnsFromLocalValues(width, source, finished);
    }
  }, {
    key: "getInitialValues",
    value: function getInitialValues(shiftKey) {
      var columnsToResize = this.getColumnsToResize();
      var resizeStartWidth = this.getInitialSizeOfColumns(columnsToResize);
      var resizeRatios = this.getSizeRatiosOfColumns(columnsToResize, resizeStartWidth);
      var columnSizeAndRatios = {
        columnsToResize: columnsToResize,
        resizeStartWidth: resizeStartWidth,
        resizeRatios: resizeRatios
      };
      var groupAfter = null;

      if (shiftKey) {
        groupAfter = this.columnModel.getDisplayedGroupAtDirection(this.columnGroup, "After");
      }

      if (groupAfter) {
        var takeFromLeafCols = groupAfter.getDisplayedLeafColumns();
        var groupAfterColumns = columnSizeAndRatios.groupAfterColumns = takeFromLeafCols.filter(function (col) {
          return col.isResizable();
        });
        var groupAfterStartWidth = columnSizeAndRatios.groupAfterStartWidth = this.getInitialSizeOfColumns(groupAfterColumns);
        columnSizeAndRatios.groupAfterRatios = this.getSizeRatiosOfColumns(groupAfterColumns, groupAfterStartWidth);
      } else {
        columnSizeAndRatios.groupAfterColumns = void 0;
        columnSizeAndRatios.groupAfterStartWidth = void 0;
        columnSizeAndRatios.groupAfterRatios = void 0;
      }

      return columnSizeAndRatios;
    }
  }, {
    key: "storeLocalValues",
    value: function storeLocalValues(initialValues) {
      var columnsToResize = initialValues.columnsToResize,
          resizeStartWidth = initialValues.resizeStartWidth,
          resizeRatios = initialValues.resizeRatios,
          groupAfterColumns = initialValues.groupAfterColumns,
          groupAfterStartWidth = initialValues.groupAfterStartWidth,
          groupAfterRatios = initialValues.groupAfterRatios;
      this.resizeCols = columnsToResize;
      this.resizeStartWidth = resizeStartWidth;
      this.resizeRatios = resizeRatios;
      this.resizeTakeFromCols = groupAfterColumns;
      this.resizeTakeFromStartWidth = groupAfterStartWidth;
      this.resizeTakeFromRatios = groupAfterRatios;
    }
  }, {
    key: "clearLocalValues",
    value: function clearLocalValues() {
      this.resizeCols = void 0;
      this.resizeRatios = void 0;
      this.resizeTakeFromCols = void 0;
      this.resizeTakeFromRatios = void 0;
    }
  }, {
    key: "resizeLeafColumnsToFit",
    value: function resizeLeafColumnsToFit(source) {
      var preferredSize = this.autoWidthCalculator.getPreferredWidthForColumnGroup(this.columnGroup);
      var initialValues = this.getInitialValues();

      if (preferredSize > initialValues.resizeStartWidth) {
        this.resizeColumns(initialValues, preferredSize, source, true);
      }
    }
  }, {
    key: "resizeColumnsFromLocalValues",
    value: function resizeColumnsFromLocalValues(totalWidth, source) {
      var finished = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var _a, _b, _c;

      if (!this.resizeCols || !this.resizeRatios) {
        return;
      }

      var initialValues = {
        columnsToResize: this.resizeCols,
        resizeStartWidth: this.resizeStartWidth,
        resizeRatios: this.resizeRatios,
        groupAfterColumns: (_a = this.resizeTakeFromCols) != null ? _a : void 0,
        groupAfterStartWidth: (_b = this.resizeTakeFromStartWidth) != null ? _b : void 0,
        groupAfterRatios: (_c = this.resizeTakeFromRatios) != null ? _c : void 0
      };
      this.resizeColumns(initialValues, totalWidth, source, finished);
    }
  }, {
    key: "resizeColumns",
    value: function resizeColumns(initialValues, totalWidth, source) {
      var finished = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var columnsToResize = initialValues.columnsToResize,
          resizeStartWidth = initialValues.resizeStartWidth,
          resizeRatios = initialValues.resizeRatios,
          groupAfterColumns = initialValues.groupAfterColumns,
          groupAfterStartWidth = initialValues.groupAfterStartWidth,
          groupAfterRatios = initialValues.groupAfterRatios;
      var resizeSets = [];
      resizeSets.push({
        columns: columnsToResize,
        ratios: resizeRatios,
        width: totalWidth
      });

      if (groupAfterColumns) {
        var diff = totalWidth - resizeStartWidth;
        resizeSets.push({
          columns: groupAfterColumns,
          ratios: groupAfterRatios,
          width: groupAfterStartWidth - diff
        });
      }

      this.columnModel.resizeColumnSets({
        resizeSets: resizeSets,
        finished: finished,
        source: source
      });

      if (finished) {
        this.toggleColumnResizing(false);
      }
    }
  }, {
    key: "toggleColumnResizing",
    value: function toggleColumnResizing(resizing) {
      this.comp.addOrRemoveCssClass("ag-column-resizing", resizing);
    }
  }, {
    key: "getColumnsToResize",
    value: function getColumnsToResize() {
      var leafCols = this.columnGroup.getDisplayedLeafColumns();
      return leafCols.filter(function (col) {
        return col.isResizable();
      });
    }
  }, {
    key: "getInitialSizeOfColumns",
    value: function getInitialSizeOfColumns(columns) {
      return columns.reduce(function (totalWidth, column) {
        return totalWidth + column.getActualWidth();
      }, 0);
    }
  }, {
    key: "getSizeRatiosOfColumns",
    value: function getSizeRatiosOfColumns(columns, initialSizeOfColumns) {
      return columns.map(function (column) {
        return column.getActualWidth() / initialSizeOfColumns;
      });
    } // optionally inverts the drag, depending on pinned and RTL
    // note - this method is duplicated in RenderedHeaderCell - should refactor out?

  }, {
    key: "normaliseDragChange",
    value: function normaliseDragChange(dragChange) {
      var result = dragChange;

      if (this.gos.get("enableRtl")) {
        if (this.pinned !== "left") {
          result *= -1;
        }
      } else if (this.pinned === "right") {
        result *= -1;
      }

      return result;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(GroupResizeFeature.prototype), "destroy", this).call(this);

      this.clearLocalValues();
    }
  }]);

  return GroupResizeFeature;
}(_BeanStub2);

__decorateClass([_Autowired("horizontalResizeService")], GroupResizeFeature.prototype, "horizontalResizeService", 2);

__decorateClass([_Autowired("autoWidthCalculator")], GroupResizeFeature.prototype, "autoWidthCalculator", 2);

__decorateClass([_Autowired("columnModel")], GroupResizeFeature.prototype, "columnModel", 2);

__decorateClass([_PostConstruct], GroupResizeFeature.prototype, "postConstruct", 1); // community-modules/core/src/headerRendering/cells/columnGroup/groupWidthFeature.ts


var GroupWidthFeature =
/*#__PURE__*/
function (_BeanStub51) {
  "use strict";

  _inherits(GroupWidthFeature, _BeanStub51);

  function GroupWidthFeature(comp, columnGroup) {
    var _this415;

    _classCallCheck(this, GroupWidthFeature);

    _this415 = _possibleConstructorReturn(this, _getPrototypeOf(GroupWidthFeature).call(this)); // the children can change, we keep destroy functions related to listening to the children here

    _this415.removeChildListenersFuncs = [];
    _this415.columnGroup = columnGroup;
    _this415.comp = comp;
    return _this415;
  }

  _createClass(GroupWidthFeature, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.addListenersToChildrenColumns();
      this.addManagedListener(this.columnGroup, _ColumnGroup2.EVENT_DISPLAYED_CHILDREN_CHANGED, this.onDisplayedChildrenChanged.bind(this));
      this.onWidthChanged();
      this.addDestroyFunc(this.removeListenersOnChildrenColumns.bind(this));
    }
  }, {
    key: "addListenersToChildrenColumns",
    value: function addListenersToChildrenColumns() {
      var _this416 = this;

      this.removeListenersOnChildrenColumns();
      var widthChangedListener = this.onWidthChanged.bind(this);
      this.columnGroup.getLeafColumns().forEach(function (column) {
        column.addEventListener("widthChanged", widthChangedListener);
        column.addEventListener("visibleChanged", widthChangedListener);

        _this416.removeChildListenersFuncs.push(function () {
          column.removeEventListener("widthChanged", widthChangedListener);
          column.removeEventListener("visibleChanged", widthChangedListener);
        });
      });
    }
  }, {
    key: "removeListenersOnChildrenColumns",
    value: function removeListenersOnChildrenColumns() {
      this.removeChildListenersFuncs.forEach(function (func) {
        return func();
      });
      this.removeChildListenersFuncs = [];
    }
  }, {
    key: "onDisplayedChildrenChanged",
    value: function onDisplayedChildrenChanged() {
      this.addListenersToChildrenColumns();
      this.onWidthChanged();
    }
  }, {
    key: "onWidthChanged",
    value: function onWidthChanged() {
      var columnWidth = this.columnGroup.getActualWidth();
      this.comp.setWidth("".concat(columnWidth, "px"));
      this.comp.addOrRemoveCssClass("ag-hidden", columnWidth === 0);
    }
  }]);

  return GroupWidthFeature;
}(_BeanStub2);

__decorateClass([_PostConstruct], GroupWidthFeature.prototype, "postConstruct", 1); // community-modules/core/src/headerRendering/cells/columnGroup/headerGroupCellCtrl.ts


var _HeaderGroupCellCtrl =
/*#__PURE__*/
function (_AbstractHeaderCellCt3) {
  "use strict";

  _inherits(_HeaderGroupCellCtrl, _AbstractHeaderCellCt3);

  function _HeaderGroupCellCtrl(columnGroup, beans, parentRowCtrl) {
    var _this417;

    _classCallCheck(this, _HeaderGroupCellCtrl);

    _this417 = _possibleConstructorReturn(this, _getPrototypeOf(_HeaderGroupCellCtrl).call(this, columnGroup, beans, parentRowCtrl));

    _this417.onSuppressColMoveChange = function () {
      if (!_this417.isAlive() || _this417.isSuppressMoving()) {
        _this417.removeDragSource();
      } else {
        if (!_this417.dragSource) {
          var eGui = _this417.getGui();

          _this417.setDragSource(eGui);
        }
      }
    };

    _this417.column = columnGroup;
    return _this417;
  }

  _createClass(_HeaderGroupCellCtrl, [{
    key: "setComp",
    value: function setComp(comp, eGui, eResize) {
      var _this418 = this;

      this.comp = comp;
      this.setGui(eGui);
      this.displayName = this.beans.columnModel.getDisplayNameForColumnGroup(this.column, "header");
      this.addClasses();
      this.setupMovingCss();
      this.setupExpandable();
      this.setupTooltip();
      this.addDestroyFunc(function () {
        if (_this418.tooltipFeature) {
          _this418.tooltipFeature = _this418.destroyBean(_this418.tooltipFeature);
        }
      });
      this.setupUserComp();
      this.addHeaderMouseListeners();
      var pinned = this.getParentRowCtrl().getPinned();
      var leafCols = this.column.getProvidedColumnGroup().getLeafColumns();
      this.createManagedBean(new HoverFeature(leafCols, eGui));
      this.createManagedBean(new _SetLeftFeature(this.column, eGui, this.beans));
      this.createManagedBean(new GroupWidthFeature(comp, this.column));
      this.resizeFeature = this.createManagedBean(new GroupResizeFeature(comp, eResize, pinned, this.column));
      this.createManagedBean(new _ManagedFocusFeature2(eGui, {
        shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
        onTabKeyDown: function onTabKeyDown() {
          return void 0;
        },
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this)
      }));
      this.addManagedPropertyListener(_Events.EVENT_SUPPRESS_COLUMN_MOVE_CHANGED, this.onSuppressColMoveChange);
      this.addResizeAndMoveKeyboardListeners();
    }
  }, {
    key: "resizeHeader",
    value: function resizeHeader(delta, shiftKey) {
      if (!this.resizeFeature) {
        return;
      }

      var initialValues = this.resizeFeature.getInitialValues(shiftKey);
      this.resizeFeature.resizeColumns(initialValues, initialValues.resizeStartWidth + delta, "uiColumnResized", true);
    }
  }, {
    key: "moveHeader",
    value: function moveHeader(hDirection) {
      var beans = this.beans,
          eGui = this.eGui,
          column = this.column,
          gos = this.gos,
          ctrlsService = this.ctrlsService;
      var isRtl = gos.get("enableRtl");
      var isLeft = hDirection === 0
      /* Left */
      ;
      var pinned = this.getPinned();
      var rect = eGui.getBoundingClientRect();
      var left = rect.left;
      var width = rect.width;
      var xPosition = ColumnMoveHelper.normaliseX(isLeft !== isRtl ? left - 20 : left + width + 20, pinned, true, gos, ctrlsService);
      var id = column.getGroupId();
      var headerPosition = this.focusService.getFocusedHeader();
      ColumnMoveHelper.attemptMoveColumns({
        allMovingColumns: this.column.getLeafColumns(),
        isFromHeader: true,
        hDirection: hDirection,
        xPosition: xPosition,
        pinned: pinned,
        fromEnter: false,
        fakeEvent: false,
        gos: gos,
        columnModel: beans.columnModel
      });
      var displayedLeafColumns = column.getDisplayedLeafColumns();
      var targetColumn = isLeft ? displayedLeafColumns[0] : _last(displayedLeafColumns);
      this.ctrlsService.getGridBodyCtrl().getScrollFeature().ensureColumnVisible(targetColumn, "auto");

      if (!this.isAlive() && headerPosition) {
        this.restoreFocus(id, column, headerPosition);
      }
    }
  }, {
    key: "restoreFocus",
    value: function restoreFocus(groupId, previousColumnGroup, previousPosition) {
      var leafCols = previousColumnGroup.getLeafColumns();

      if (!leafCols.length) {
        return;
      }

      var parent = leafCols[0].getParent();

      if (!parent) {
        return;
      }

      var newColumnGroup = this.findGroupWidthId(parent, groupId);

      if (newColumnGroup) {
        this.focusService.focusHeaderPosition({
          headerPosition: __spreadProps(__spreadValues({}, previousPosition), {
            column: newColumnGroup
          })
        });
      }
    }
  }, {
    key: "findGroupWidthId",
    value: function findGroupWidthId(columnGroup, id) {
      while (columnGroup) {
        if (columnGroup.getGroupId() === id) {
          return columnGroup;
        }

        columnGroup = columnGroup.getParent();
      }

      return null;
    }
  }, {
    key: "resizeLeafColumnsToFit",
    value: function resizeLeafColumnsToFit(source) {
      if (!this.resizeFeature) {
        return;
      }

      this.resizeFeature.resizeLeafColumnsToFit(source);
    }
  }, {
    key: "setupUserComp",
    value: function setupUserComp() {
      var _this419 = this;

      var params = this.gos.addGridCommonParams({
        displayName: this.displayName,
        columnGroup: this.column,
        setExpanded: function setExpanded(expanded) {
          _this419.beans.columnModel.setColumnGroupOpened(_this419.column.getProvidedColumnGroup(), expanded, "gridInitializing");
        },
        setTooltip: function setTooltip(value, shouldDisplayTooltip) {
          _this419.setupTooltip(value, shouldDisplayTooltip);
        }
      });
      var compDetails = this.userComponentFactory.getHeaderGroupCompDetails(params);
      this.comp.setUserCompDetails(compDetails);
    }
  }, {
    key: "addHeaderMouseListeners",
    value: function addHeaderMouseListeners() {
      var _this420 = this;

      var listener = function listener(e) {
        return _this420.handleMouseOverChange(e.type === "mouseenter");
      };

      var clickListener = function clickListener() {
        return _this420.dispatchColumnMouseEvent(_Events.EVENT_COLUMN_HEADER_CLICKED, _this420.column.getProvidedColumnGroup());
      };

      var contextMenuListener = function contextMenuListener(event) {
        return _this420.handleContextMenuMouseEvent(event, void 0, _this420.column.getProvidedColumnGroup());
      };

      this.addManagedListener(this.getGui(), "mouseenter", listener);
      this.addManagedListener(this.getGui(), "mouseleave", listener);
      this.addManagedListener(this.getGui(), "click", clickListener);
      this.addManagedListener(this.getGui(), "contextmenu", contextMenuListener);
    }
  }, {
    key: "handleMouseOverChange",
    value: function handleMouseOverChange(isMouseOver) {
      var eventType = isMouseOver ? _Events.EVENT_COLUMN_HEADER_MOUSE_OVER : _Events.EVENT_COLUMN_HEADER_MOUSE_LEAVE;
      var event = {
        type: eventType,
        column: this.column.getProvidedColumnGroup()
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "setupTooltip",
    value: function setupTooltip(value, shouldDisplayTooltip) {
      var _this421 = this;

      if (this.tooltipFeature) {
        this.tooltipFeature = this.destroyBean(this.tooltipFeature);
      }

      var colGroupDef = this.column.getColGroupDef();
      var isTooltipWhenTruncated = this.gos.get("tooltipShowMode") === "whenTruncated";
      var eGui = this.eGui;

      if (!shouldDisplayTooltip && isTooltipWhenTruncated && !(colGroupDef == null ? void 0 : colGroupDef.headerGroupComponent)) {
        shouldDisplayTooltip = function shouldDisplayTooltip() {
          var textEl = eGui.querySelector(".ag-header-group-text");

          if (!textEl) {
            return true;
          }

          return textEl.scrollWidth > textEl.clientWidth;
        };
      }

      var tooltipCtrl = {
        getColumn: function getColumn() {
          return _this421.column;
        },
        getGui: function getGui() {
          return eGui;
        },
        getLocation: function getLocation() {
          return "headerGroup";
        },
        getTooltipValue: function getTooltipValue() {
          return value != null ? value : colGroupDef && colGroupDef.headerTooltip;
        },
        shouldDisplayTooltip: shouldDisplayTooltip
      };

      if (colGroupDef) {
        tooltipCtrl.getColDef = function () {
          return colGroupDef;
        };
      }

      this.createBean(new _TooltipFeature(tooltipCtrl));
    }
  }, {
    key: "setupExpandable",
    value: function setupExpandable() {
      var providedColGroup = this.column.getProvidedColumnGroup();
      this.refreshExpanded();
      this.addManagedListener(providedColGroup, _ProvidedColumnGroup2.EVENT_EXPANDABLE_CHANGED, this.refreshExpanded.bind(this));
      this.addManagedListener(providedColGroup, _ProvidedColumnGroup2.EVENT_EXPANDED_CHANGED, this.refreshExpanded.bind(this));
    }
  }, {
    key: "refreshExpanded",
    value: function refreshExpanded() {
      var column = this.column;
      this.expandable = column.isExpandable();
      var expanded = column.isExpanded();

      if (this.expandable) {
        this.comp.setAriaExpanded(expanded ? "true" : "false");
      } else {
        this.comp.setAriaExpanded(void 0);
      }
    }
  }, {
    key: "getColId",
    value: function getColId() {
      return this.column.getUniqueId();
    }
  }, {
    key: "addClasses",
    value: function addClasses() {
      var _this422 = this;

      var colGroupDef = this.column.getColGroupDef();

      var classes = _CssClassApplier.getHeaderClassesFromColDef(colGroupDef, this.gos, null, this.column);

      if (this.column.isPadding()) {
        classes.push("ag-header-group-cell-no-group");
        var leafCols = this.column.getLeafColumns();

        if (leafCols.every(function (col) {
          return col.isSpanHeaderHeight();
        })) {
          classes.push("ag-header-span-height");
        }
      } else {
        classes.push("ag-header-group-cell-with-group");
      }

      classes.forEach(function (c) {
        return _this422.comp.addOrRemoveCssClass(c, true);
      });
    }
  }, {
    key: "setupMovingCss",
    value: function setupMovingCss() {
      var _this423 = this;

      var providedColumnGroup = this.column.getProvidedColumnGroup();
      var leafColumns = providedColumnGroup.getLeafColumns();

      var listener = function listener() {
        return _this423.comp.addOrRemoveCssClass("ag-header-cell-moving", _this423.column.isMoving());
      };

      leafColumns.forEach(function (col) {
        _this423.addManagedListener(col, _Column2.EVENT_MOVING_CHANGED, listener);
      });
      listener();
    }
  }, {
    key: "onFocusIn",
    value: function onFocusIn(e) {
      if (!this.eGui.contains(e.relatedTarget)) {
        var rowIndex = this.getRowIndex();
        this.beans.focusService.setFocusedHeader(rowIndex, this.column);
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      _get(_getPrototypeOf(_HeaderGroupCellCtrl.prototype), "handleKeyDown", this).call(this, e);

      var wrapperHasFocus = this.getWrapperHasFocus();

      if (!this.expandable || !wrapperHasFocus) {
        return;
      }

      if (e.key === _KeyCode.ENTER) {
        var column = this.column;
        var newExpandedValue = !column.isExpanded();
        this.beans.columnModel.setColumnGroupOpened(column.getProvidedColumnGroup(), newExpandedValue, "uiColumnExpanded");
      }
    } // unlike columns, this will only get called once, as we don't react on props on column groups
    // (we will always destroy and recreate this comp if something changes)

  }, {
    key: "setDragSource",
    value: function setDragSource(eHeaderGroup) {
      var _this424 = this;

      if (!this.isAlive() || this.isSuppressMoving()) {
        return;
      }

      this.removeDragSource();

      if (!eHeaderGroup) {
        return;
      }

      var beans = this.beans,
          column = this.column,
          displayName = this.displayName,
          gos = this.gos,
          dragAndDropService = this.dragAndDropService;
      var columnModel = beans.columnModel;
      var allLeafColumns = column.getProvidedColumnGroup().getLeafColumns();
      var hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
      var dragSource = this.dragSource = {
        type: 1
        /* HeaderCell */
        ,
        eElement: eHeaderGroup,
        getDefaultIconName: function getDefaultIconName() {
          return hideColumnOnExit ? _DragAndDropService2.ICON_HIDE : _DragAndDropService2.ICON_NOT_ALLOWED;
        },
        dragItemName: displayName,
        // we add in the original group leaf columns, so we move both visible and non-visible items
        getDragItem: function getDragItem() {
          return _this424.getDragItemForGroup(column);
        },
        onDragStarted: function onDragStarted() {
          hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
          allLeafColumns.forEach(function (col) {
            return col.setMoving(true, "uiColumnDragged");
          });
        },
        onDragStopped: function onDragStopped() {
          return allLeafColumns.forEach(function (col) {
            return col.setMoving(false, "uiColumnDragged");
          });
        },
        onGridEnter: function onGridEnter(dragItem) {
          var _a;

          if (hideColumnOnExit) {
            var unlockedColumns = ((_a = dragItem == null ? void 0 : dragItem.columns) == null ? void 0 : _a.filter(function (col) {
              return !col.getColDef().lockVisible;
            })) || [];
            columnModel.setColumnsVisible(unlockedColumns, true, "uiColumnMoved");
          }
        },
        onGridExit: function onGridExit(dragItem) {
          var _a;

          if (hideColumnOnExit) {
            var unlockedColumns = ((_a = dragItem == null ? void 0 : dragItem.columns) == null ? void 0 : _a.filter(function (col) {
              return !col.getColDef().lockVisible;
            })) || [];
            columnModel.setColumnsVisible(unlockedColumns, false, "uiColumnMoved");
          }
        }
      };
      dragAndDropService.addDragSource(dragSource, true);
    } // when moving the columns, we want to move all the columns (contained within the DragItem) in this group in one go,
    // and in the order they are currently in the screen.

  }, {
    key: "getDragItemForGroup",
    value: function getDragItemForGroup(columnGroup) {
      var allColumnsOriginalOrder = columnGroup.getProvidedColumnGroup().getLeafColumns();
      var visibleState = {};
      allColumnsOriginalOrder.forEach(function (column) {
        return visibleState[column.getId()] = column.isVisible();
      });
      var allColumnsCurrentOrder = [];
      this.beans.columnModel.getAllDisplayedColumns().forEach(function (column) {
        if (allColumnsOriginalOrder.indexOf(column) >= 0) {
          allColumnsCurrentOrder.push(column);

          _removeFromArray(allColumnsOriginalOrder, column);
        }
      });
      allColumnsOriginalOrder.forEach(function (column) {
        return allColumnsCurrentOrder.push(column);
      });
      return {
        columns: allColumnsCurrentOrder,
        visibleState: visibleState
      };
    }
  }, {
    key: "isSuppressMoving",
    value: function isSuppressMoving() {
      var childSuppressesMoving = false;
      this.column.getLeafColumns().forEach(function (column) {
        if (column.getColDef().suppressMovable || column.getColDef().lockPosition) {
          childSuppressesMoving = true;
        }
      });
      var result = childSuppressesMoving || this.gos.get("suppressMovableColumns");
      return result;
    }
  }]);

  return _HeaderGroupCellCtrl;
}(_AbstractHeaderCellCtrl2); // community-modules/core/src/headerRendering/row/headerRowCtrl.ts


var instanceIdSequence5 = 0;

var _HeaderRowCtrl =
/*#__PURE__*/
function (_BeanStub52) {
  "use strict";

  _inherits(_HeaderRowCtrl, _BeanStub52);

  function _HeaderRowCtrl(rowIndex, pinned, type) {
    var _this425;

    _classCallCheck(this, _HeaderRowCtrl);

    _this425 = _possibleConstructorReturn(this, _getPrototypeOf(_HeaderRowCtrl).call(this));
    _this425.instanceId = instanceIdSequence5++;
    _this425.rowIndex = rowIndex;
    _this425.pinned = pinned;
    _this425.type = type;
    var typeClass = type == "group"
    /* COLUMN_GROUP */
    ? "ag-header-row-column-group" : type == "filter"
    /* FLOATING_FILTER */
    ? "ag-header-row-column-filter" : "ag-header-row-column";
    _this425.headerRowClass = "ag-header-row ".concat(typeClass);
    return _this425;
  }

  _createClass(_HeaderRowCtrl, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.isPrintLayout = this.gos.isDomLayout("print");
      this.isEnsureDomOrder = this.gos.get("ensureDomOrder");
    }
  }, {
    key: "getInstanceId",
    value: function getInstanceId() {
      return this.instanceId;
    }
    /**
     * 
     * @param comp Proxy to the actual component
     * @param initCompState Should the component be initialised with the current state of the controller. Default: true
     */

  }, {
    key: "setComp",
    value: function setComp(comp) {
      var initCompState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.comp = comp;

      if (initCompState) {
        this.onRowHeightChanged();
        this.onVirtualColumnsChanged();
      }

      this.setWidth();
      this.addEventListeners();
    }
  }, {
    key: "getHeaderRowClass",
    value: function getHeaderRowClass() {
      return this.headerRowClass;
    }
  }, {
    key: "getAriaRowIndex",
    value: function getAriaRowIndex() {
      return this.rowIndex + 1;
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this426 = this;

      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_VIRTUAL_COLUMNS_CHANGED, function (params) {
        return _this426.onVirtualColumnsChanged(params.afterScroll);
      });
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_HEADER_HEIGHT_CHANGED, this.onRowHeightChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_GRID_STYLES_CHANGED, this.onRowHeightChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, this.onRowHeightChanged.bind(this));
      this.addManagedPropertyListener("domLayout", this.onDisplayedColumnsChanged.bind(this));
      this.addManagedPropertyListener("ensureDomOrder", function (e) {
        return _this426.isEnsureDomOrder = e.currentValue;
      });
      this.addManagedPropertyListener("headerHeight", this.onRowHeightChanged.bind(this));
      this.addManagedPropertyListener("pivotHeaderHeight", this.onRowHeightChanged.bind(this));
      this.addManagedPropertyListener("groupHeaderHeight", this.onRowHeightChanged.bind(this));
      this.addManagedPropertyListener("pivotGroupHeaderHeight", this.onRowHeightChanged.bind(this));
      this.addManagedPropertyListener("floatingFiltersHeight", this.onRowHeightChanged.bind(this));
    }
  }, {
    key: "getHeaderCellCtrl",
    value: function getHeaderCellCtrl(column) {
      if (!this.headerCellCtrls) {
        return;
      }

      return _values(this.headerCellCtrls).find(function (cellCtrl) {
        return cellCtrl.getColumnGroupChild() === column;
      });
    }
  }, {
    key: "onDisplayedColumnsChanged",
    value: function onDisplayedColumnsChanged() {
      this.isPrintLayout = this.gos.isDomLayout("print");
      this.onVirtualColumnsChanged();
      this.setWidth();
      this.onRowHeightChanged();
    }
  }, {
    key: "getType",
    value: function getType() {
      return this.type;
    }
  }, {
    key: "onColumnResized",
    value: function onColumnResized() {
      this.setWidth();
    }
  }, {
    key: "setWidth",
    value: function setWidth() {
      var width = this.getWidthForRow();
      this.comp.setWidth("".concat(width, "px"));
    }
  }, {
    key: "getWidthForRow",
    value: function getWidthForRow() {
      var columnModel = this.beans.columnModel;

      if (this.isPrintLayout) {
        var pinned = this.pinned != null;

        if (pinned) {
          return 0;
        }

        return columnModel.getContainerWidth("right") + columnModel.getContainerWidth("left") + columnModel.getContainerWidth(null);
      }

      return columnModel.getContainerWidth(this.pinned);
    }
  }, {
    key: "onRowHeightChanged",
    value: function onRowHeightChanged() {
      var _this$getTopAndHeight = this.getTopAndHeight(),
          topOffset = _this$getTopAndHeight.topOffset,
          rowHeight = _this$getTopAndHeight.rowHeight;

      this.comp.setTop(topOffset + "px");
      this.comp.setHeight(rowHeight + "px");
    }
  }, {
    key: "getTopAndHeight",
    value: function getTopAndHeight() {
      var _this$beans3 = this.beans,
          columnModel = _this$beans3.columnModel,
          filterManager = _this$beans3.filterManager;
      var headerRowCount = columnModel.getHeaderRowCount();
      var sizes = [];
      var numberOfFloating = 0;

      if (filterManager.hasFloatingFilters()) {
        headerRowCount++;
        numberOfFloating = 1;
      }

      var groupHeight = columnModel.getColumnGroupHeaderRowHeight();
      var headerHeight = columnModel.getColumnHeaderRowHeight();
      var numberOfNonGroups = 1 + numberOfFloating;
      var numberOfGroups = headerRowCount - numberOfNonGroups;

      for (var i = 0; i < numberOfGroups; i++) {
        sizes.push(groupHeight);
      }

      sizes.push(headerHeight);

      for (var _i7 = 0; _i7 < numberOfFloating; _i7++) {
        sizes.push(columnModel.getFloatingFiltersHeight());
      }

      var topOffset = 0;

      for (var _i8 = 0; _i8 < this.rowIndex; _i8++) {
        topOffset += sizes[_i8];
      }

      var rowHeight = sizes[this.rowIndex];
      return {
        topOffset: topOffset,
        rowHeight: rowHeight
      };
    }
  }, {
    key: "getPinned",
    value: function getPinned() {
      return this.pinned;
    }
  }, {
    key: "getRowIndex",
    value: function getRowIndex() {
      return this.rowIndex;
    }
  }, {
    key: "onVirtualColumnsChanged",
    value: function onVirtualColumnsChanged() {
      var afterScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var ctrlsToDisplay = this.getHeaderCtrls();
      var forceOrder = this.isEnsureDomOrder || this.isPrintLayout;
      this.comp.setHeaderCtrls(ctrlsToDisplay, forceOrder, afterScroll);
    }
  }, {
    key: "getHeaderCtrls",
    value: function getHeaderCtrls() {
      var _this427 = this;

      var oldCtrls = this.headerCellCtrls;
      this.headerCellCtrls =
      /* @__PURE__ */
      new Map();
      var columns = this.getColumnsInViewport();
      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = columns[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var child = _step13.value;
          this.recycleAndCreateHeaderCtrls(child, oldCtrls);
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }

      var isFocusedAndDisplayed = function isFocusedAndDisplayed(ctrl) {
        var _this427$beans = _this427.beans,
            focusService = _this427$beans.focusService,
            columnModel = _this427$beans.columnModel;
        var isFocused = focusService.isHeaderWrapperFocused(ctrl);

        if (!isFocused) {
          return false;
        }

        var isDisplayed = columnModel.isDisplayed(ctrl.getColumnGroupChild());
        return isDisplayed;
      };

      if (oldCtrls) {
        var _iteratorNormalCompletion14 = true;
        var _didIteratorError14 = false;
        var _iteratorError14 = undefined;

        try {
          for (var _iterator14 = oldCtrls[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
            var _ref43 = _step14.value;

            var _ref42 = _slicedToArray(_ref43, 2);

            var id = _ref42[0];
            var oldCtrl = _ref42[1];
            var keepCtrl = isFocusedAndDisplayed(oldCtrl);

            if (keepCtrl) {
              this.headerCellCtrls.set(id, oldCtrl);
            } else {
              this.destroyBean(oldCtrl);
            }
          }
        } catch (err) {
          _didIteratorError14 = true;
          _iteratorError14 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
              _iterator14.return();
            }
          } finally {
            if (_didIteratorError14) {
              throw _iteratorError14;
            }
          }
        }
      }

      var ctrlsToDisplay = Array.from(this.headerCellCtrls.values());
      return ctrlsToDisplay;
    }
  }, {
    key: "recycleAndCreateHeaderCtrls",
    value: function recycleAndCreateHeaderCtrls(headerColumn, oldCtrls) {
      if (!this.headerCellCtrls) {
        return;
      }

      if (headerColumn.isEmptyGroup()) {
        return;
      }

      var idOfChild = headerColumn.getUniqueId();
      var headerCtrl;

      if (oldCtrls) {
        headerCtrl = oldCtrls.get(idOfChild);
        oldCtrls.delete(idOfChild);
      }

      var forOldColumn = headerCtrl && headerCtrl.getColumnGroupChild() != headerColumn;

      if (forOldColumn) {
        this.destroyBean(headerCtrl);
        headerCtrl = void 0;
      }

      if (headerCtrl == null) {
        switch (this.type) {
          case "filter"
          /* FLOATING_FILTER */
          :
            headerCtrl = this.createBean(new _HeaderFilterCellCtrl(headerColumn, this.beans, this));
            break;

          case "group"
          /* COLUMN_GROUP */
          :
            headerCtrl = this.createBean(new _HeaderGroupCellCtrl(headerColumn, this.beans, this));
            break;

          default:
            headerCtrl = this.createBean(new _HeaderCellCtrl(headerColumn, this.beans, this));
            break;
        }
      }

      this.headerCellCtrls.set(idOfChild, headerCtrl);
    }
  }, {
    key: "getColumnsInViewport",
    value: function getColumnsInViewport() {
      return this.isPrintLayout ? this.getColumnsInViewportPrintLayout() : this.getColumnsInViewportNormalLayout();
    }
  }, {
    key: "getColumnsInViewportPrintLayout",
    value: function getColumnsInViewportPrintLayout() {
      if (this.pinned != null) {
        return [];
      }

      var viewportColumns = [];
      var actualDepth = this.getActualDepth();
      var columnModel = this.beans.columnModel;
      ["left", null, "right"].forEach(function (pinned) {
        var items = columnModel.getVirtualHeaderGroupRow(pinned, actualDepth);
        viewportColumns = viewportColumns.concat(items);
      });
      return viewportColumns;
    }
  }, {
    key: "getActualDepth",
    value: function getActualDepth() {
      return this.type == "filter"
      /* FLOATING_FILTER */
      ? this.rowIndex - 1 : this.rowIndex;
    }
  }, {
    key: "getColumnsInViewportNormalLayout",
    value: function getColumnsInViewportNormalLayout() {
      return this.beans.columnModel.getVirtualHeaderGroupRow(this.pinned, this.getActualDepth());
    }
  }, {
    key: "focusHeader",
    value: function focusHeader(column, event) {
      if (!this.headerCellCtrls) {
        return false;
      }

      var allCtrls = Array.from(this.headerCellCtrls.values());
      var ctrl = allCtrls.find(function (ctrl2) {
        return ctrl2.getColumnGroupChild() == column;
      });

      if (!ctrl) {
        return false;
      }

      return ctrl.focus(event);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this428 = this;

      if (this.headerCellCtrls) {
        this.headerCellCtrls.forEach(function (ctrl) {
          _this428.destroyBean(ctrl);
        });
      }

      this.headerCellCtrls = void 0;

      _get(_getPrototypeOf(_HeaderRowCtrl.prototype), "destroy", this).call(this);
    }
  }]);

  return _HeaderRowCtrl;
}(_BeanStub2);

__decorateClass([_Autowired("beans")], _HeaderRowCtrl.prototype, "beans", 2);

__decorateClass([_PostConstruct], _HeaderRowCtrl.prototype, "postConstruct", 1); // community-modules/core/src/headerRendering/rowContainer/headerRowContainerCtrl.ts


var _HeaderRowContainerCtrl =
/*#__PURE__*/
function (_BeanStub53) {
  "use strict";

  _inherits(_HeaderRowContainerCtrl, _BeanStub53);

  function _HeaderRowContainerCtrl(pinned) {
    var _this429;

    _classCallCheck(this, _HeaderRowContainerCtrl);

    _this429 = _possibleConstructorReturn(this, _getPrototypeOf(_HeaderRowContainerCtrl).call(this));
    _this429.hidden = false;
    _this429.includeFloatingFilter = false;
    _this429.groupsRowCtrls = [];
    _this429.pinned = pinned;
    return _this429;
  }

  _createClass(_HeaderRowContainerCtrl, [{
    key: "setComp",
    value: function setComp(comp, eGui) {
      this.comp = comp;
      this.eViewport = eGui;
      this.setupCenterWidth();
      this.setupPinnedWidth();
      this.setupDragAndDrop(this.eViewport);
      this.addManagedListener(this.eventService, _Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, this.onDisplayedColumnsChanged.bind(this));
      this.ctrlsService.registerHeaderContainer(this, this.pinned);

      if (this.columnModel.isReady()) {
        this.refresh();
      }
    }
  }, {
    key: "setupDragAndDrop",
    value: function setupDragAndDrop(dropContainer) {
      var bodyDropTarget = new _BodyDropTarget(this.pinned, dropContainer);
      this.createManagedBean(bodyDropTarget);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var _this430 = this;

      var keepColumns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var sequence = new _NumberSequence();
      var focusedHeaderPosition = this.focusService.getFocusHeaderToUseAfterRefresh();

      var refreshColumnGroups = function refreshColumnGroups() {
        var groupRowCount = _this430.columnModel.getHeaderRowCount() - 1;
        _this430.groupsRowCtrls = _this430.destroyBeans(_this430.groupsRowCtrls);

        for (var i = 0; i < groupRowCount; i++) {
          var ctrl = _this430.createBean(new _HeaderRowCtrl(sequence.next(), _this430.pinned, "group"
          /* COLUMN_GROUP */
          ));

          _this430.groupsRowCtrls.push(ctrl);
        }
      };

      var refreshColumns = function refreshColumns() {
        var rowIndex = sequence.next();
        var needNewInstance = !_this430.hidden && (_this430.columnsRowCtrl == null || !keepColumns || _this430.columnsRowCtrl.getRowIndex() !== rowIndex);
        var shouldDestroyInstance = needNewInstance || _this430.hidden;

        if (shouldDestroyInstance) {
          _this430.columnsRowCtrl = _this430.destroyBean(_this430.columnsRowCtrl);
        }

        if (needNewInstance) {
          _this430.columnsRowCtrl = _this430.createBean(new _HeaderRowCtrl(rowIndex, _this430.pinned, "column"
          /* COLUMN */
          ));
        }
      };

      var refreshFilters = function refreshFilters() {
        _this430.includeFloatingFilter = _this430.filterManager.hasFloatingFilters() && !_this430.hidden;

        var destroyPreviousComp = function destroyPreviousComp() {
          _this430.filtersRowCtrl = _this430.destroyBean(_this430.filtersRowCtrl);
        };

        if (!_this430.includeFloatingFilter) {
          destroyPreviousComp();
          return;
        }

        var rowIndex = sequence.next();

        if (_this430.filtersRowCtrl) {
          var rowIndexMismatch = _this430.filtersRowCtrl.getRowIndex() !== rowIndex;

          if (!keepColumns || rowIndexMismatch) {
            destroyPreviousComp();
          }
        }

        if (!_this430.filtersRowCtrl) {
          _this430.filtersRowCtrl = _this430.createBean(new _HeaderRowCtrl(rowIndex, _this430.pinned, "filter"
          /* FLOATING_FILTER */
          ));
        }
      };

      refreshColumnGroups();
      refreshColumns();
      refreshFilters();
      var allCtrls = this.getAllCtrls();
      this.comp.setCtrls(allCtrls);
      this.restoreFocusOnHeader(focusedHeaderPosition);
    }
  }, {
    key: "restoreFocusOnHeader",
    value: function restoreFocusOnHeader(position) {
      if (position == null || position.column.getPinned() != this.pinned) {
        return;
      }

      this.focusService.focusHeaderPosition({
        headerPosition: position
      });
    }
  }, {
    key: "getAllCtrls",
    value: function getAllCtrls() {
      var res = _toConsumableArray(this.groupsRowCtrls);

      if (this.columnsRowCtrl) {
        res.push(this.columnsRowCtrl);
      }

      if (this.filtersRowCtrl) {
        res.push(this.filtersRowCtrl);
      }

      return res;
    } // grid cols have changed - this also means the number of rows in the header can have
    // changed. so we remove all the old rows and insert new ones for a complete refresh

  }, {
    key: "onGridColumnsChanged",
    value: function onGridColumnsChanged() {
      this.refresh(true);
    }
  }, {
    key: "onDisplayedColumnsChanged",
    value: function onDisplayedColumnsChanged() {
      var includeFloatingFilter = this.filterManager.hasFloatingFilters() && !this.hidden;

      if (this.includeFloatingFilter !== includeFloatingFilter) {
        this.refresh(true);
      }
    }
  }, {
    key: "setupCenterWidth",
    value: function setupCenterWidth() {
      var _this431 = this;

      if (this.pinned != null) {
        return;
      }

      this.createManagedBean(new CenterWidthFeature(function (width) {
        return _this431.comp.setCenterWidth("".concat(width, "px"));
      }, true));
    }
  }, {
    key: "setHorizontalScroll",
    value: function setHorizontalScroll(offset) {
      this.comp.setViewportScrollLeft(offset);
    }
  }, {
    key: "setupPinnedWidth",
    value: function setupPinnedWidth() {
      var _this432 = this;

      if (this.pinned == null) {
        return;
      }

      var pinningLeft = this.pinned === "left";
      var pinningRight = this.pinned === "right";
      this.hidden = true;

      var listener = function listener() {
        var width = pinningLeft ? _this432.pinnedWidthService.getPinnedLeftWidth() : _this432.pinnedWidthService.getPinnedRightWidth();

        if (width == null) {
          return;
        }

        var hidden = width == 0;
        var hiddenChanged = _this432.hidden !== hidden;

        var isRtl = _this432.gos.get("enableRtl");

        var scrollbarWidth = _this432.gos.getScrollbarWidth();

        var addPaddingForScrollbar = _this432.scrollVisibleService.isVerticalScrollShowing() && (isRtl && pinningLeft || !isRtl && pinningRight);
        var widthWithPadding = addPaddingForScrollbar ? width + scrollbarWidth : width;

        _this432.comp.setPinnedContainerWidth("".concat(widthWithPadding, "px"));

        _this432.comp.setDisplayed(!hidden);

        if (hiddenChanged) {
          _this432.hidden = hidden;

          _this432.refresh();
        }
      };

      this.addManagedListener(this.eventService, _Events.EVENT_LEFT_PINNED_WIDTH_CHANGED, listener);
      this.addManagedListener(this.eventService, _Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED, listener);
      this.addManagedListener(this.eventService, _Events.EVENT_SCROLL_VISIBILITY_CHANGED, listener);
      this.addManagedListener(this.eventService, _Events.EVENT_SCROLLBAR_WIDTH_CHANGED, listener);
    }
  }, {
    key: "getHeaderCtrlForColumn",
    value: function getHeaderCtrlForColumn(column) {
      if (column instanceof _Column2) {
        if (!this.columnsRowCtrl) {
          return;
        }

        return this.columnsRowCtrl.getHeaderCellCtrl(column);
      }

      if (this.groupsRowCtrls.length === 0) {
        return;
      }

      for (var i = 0; i < this.groupsRowCtrls.length; i++) {
        var ctrl = this.groupsRowCtrls[i].getHeaderCellCtrl(column);

        if (ctrl) {
          return ctrl;
        }
      }
    }
  }, {
    key: "getHtmlElementForColumnHeader",
    value: function getHtmlElementForColumnHeader(column) {
      var cellCtrl = this.getHeaderCtrlForColumn(column);

      if (!cellCtrl) {
        return null;
      }

      return cellCtrl.getGui();
    }
  }, {
    key: "getRowType",
    value: function getRowType(rowIndex) {
      var allCtrls = this.getAllCtrls();
      var ctrl = allCtrls[rowIndex];
      return ctrl ? ctrl.getType() : void 0;
    }
  }, {
    key: "focusHeader",
    value: function focusHeader(rowIndex, column, event) {
      var allCtrls = this.getAllCtrls();
      var ctrl = allCtrls[rowIndex];

      if (!ctrl) {
        return false;
      }

      return ctrl.focusHeader(column, event);
    }
  }, {
    key: "getViewport",
    value: function getViewport() {
      return this.eViewport;
    }
  }, {
    key: "getRowCount",
    value: function getRowCount() {
      return this.groupsRowCtrls.length + (this.columnsRowCtrl ? 1 : 0) + (this.filtersRowCtrl ? 1 : 0);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.filtersRowCtrl) {
        this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
      }

      if (this.columnsRowCtrl) {
        this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
      }

      if (this.groupsRowCtrls && this.groupsRowCtrls.length) {
        this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls);
      }

      _get(_getPrototypeOf(_HeaderRowContainerCtrl.prototype), "destroy", this).call(this);
    }
  }]);

  return _HeaderRowContainerCtrl;
}(_BeanStub2);

__decorateClass([_Autowired("ctrlsService")], _HeaderRowContainerCtrl.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("scrollVisibleService")], _HeaderRowContainerCtrl.prototype, "scrollVisibleService", 2);

__decorateClass([_Autowired("pinnedWidthService")], _HeaderRowContainerCtrl.prototype, "pinnedWidthService", 2);

__decorateClass([_Autowired("columnModel")], _HeaderRowContainerCtrl.prototype, "columnModel", 2);

__decorateClass([_Autowired("focusService")], _HeaderRowContainerCtrl.prototype, "focusService", 2);

__decorateClass([_Autowired("filterManager")], _HeaderRowContainerCtrl.prototype, "filterManager", 2); // community-modules/core/src/headerRendering/rowContainer/headerRowContainerComp.ts


var _HeaderRowContainerComp =
/*#__PURE__*/
function (_Component32) {
  "use strict";

  _inherits(_HeaderRowContainerComp, _Component32);

  function _HeaderRowContainerComp(pinned) {
    var _this433;

    _classCallCheck(this, _HeaderRowContainerComp);

    _this433 = _possibleConstructorReturn(this, _getPrototypeOf(_HeaderRowContainerComp).call(this));
    _this433.headerRowComps = {};
    _this433.rowCompsList = [];
    _this433.pinned = pinned;
    return _this433;
  }

  _createClass(_HeaderRowContainerComp, [{
    key: "init",
    value: function init() {
      var _this434 = this;

      this.selectAndSetTemplate();
      var compProxy = {
        setDisplayed: function setDisplayed(displayed) {
          return _this434.setDisplayed(displayed);
        },
        setCtrls: function setCtrls(ctrls) {
          return _this434.setCtrls(ctrls);
        },
        // only gets called for center section
        setCenterWidth: function setCenterWidth(width) {
          return _this434.eCenterContainer.style.width = width;
        },
        setViewportScrollLeft: function setViewportScrollLeft(left) {
          return _this434.getGui().scrollLeft = left;
        },
        // only gets called for pinned sections
        setPinnedContainerWidth: function setPinnedContainerWidth(width) {
          var eGui = _this434.getGui();

          eGui.style.width = width;
          eGui.style.maxWidth = width;
          eGui.style.minWidth = width;
        }
      };
      var ctrl = this.createManagedBean(new _HeaderRowContainerCtrl(this.pinned));
      ctrl.setComp(compProxy, this.getGui());
    }
  }, {
    key: "selectAndSetTemplate",
    value: function selectAndSetTemplate() {
      var pinnedLeft = this.pinned == "left";
      var pinnedRight = this.pinned == "right";
      var template = pinnedLeft ? _HeaderRowContainerComp.PINNED_LEFT_TEMPLATE : pinnedRight ? _HeaderRowContainerComp.PINNED_RIGHT_TEMPLATE : _HeaderRowContainerComp.CENTER_TEMPLATE;
      this.setTemplate(template);
      this.eRowContainer = this.eCenterContainer ? this.eCenterContainer : this.getGui();
    }
  }, {
    key: "destroyRowComps",
    value: function destroyRowComps() {
      this.setCtrls([]);
    }
  }, {
    key: "destroyRowComp",
    value: function destroyRowComp(rowComp) {
      this.destroyBean(rowComp);
      this.eRowContainer.removeChild(rowComp.getGui());
    }
  }, {
    key: "setCtrls",
    value: function setCtrls(ctrls) {
      var _this435 = this;

      var oldRowComps = this.headerRowComps;
      this.headerRowComps = {};
      this.rowCompsList = [];
      var prevGui;

      var appendEnsuringDomOrder = function appendEnsuringDomOrder(rowComp) {
        var eGui = rowComp.getGui();
        var notAlreadyIn = eGui.parentElement != _this435.eRowContainer;

        if (notAlreadyIn) {
          _this435.eRowContainer.appendChild(eGui);
        }

        if (prevGui) {
          _ensureDomOrder(_this435.eRowContainer, eGui, prevGui);
        }

        prevGui = eGui;
      };

      ctrls.forEach(function (ctrl) {
        var ctrlId = ctrl.getInstanceId();
        var existingComp = oldRowComps[ctrlId];
        delete oldRowComps[ctrlId];
        var rowComp = existingComp ? existingComp : _this435.createBean(new _HeaderRowComp(ctrl));
        _this435.headerRowComps[ctrlId] = rowComp;

        _this435.rowCompsList.push(rowComp);

        appendEnsuringDomOrder(rowComp);
      });

      _getAllValuesInObject(oldRowComps).forEach(function (c) {
        return _this435.destroyRowComp(c);
      });
    }
  }]);

  return _HeaderRowContainerComp;
}(_Component2);

_HeaderRowContainerComp.PINNED_LEFT_TEMPLATE =
/* html */
"<div class=\"ag-pinned-left-header\" role=\"rowgroup\"></div>";
_HeaderRowContainerComp.PINNED_RIGHT_TEMPLATE =
/* html */
"<div class=\"ag-pinned-right-header\" role=\"rowgroup\"></div>";
_HeaderRowContainerComp.CENTER_TEMPLATE =
/* html */
"<div class=\"ag-header-viewport\" role=\"presentation\">\n            <div class=\"ag-header-container\" ref=\"eCenterContainer\" role=\"rowgroup\"></div>\n        </div>";

__decorateClass([_RefSelector("eCenterContainer")], _HeaderRowContainerComp.prototype, "eCenterContainer", 2);

__decorateClass([_PostConstruct], _HeaderRowContainerComp.prototype, "init", 1);

__decorateClass([_PreDestroy], _HeaderRowContainerComp.prototype, "destroyRowComps", 1);

var _HeaderRowContainerComp2 = _HeaderRowContainerComp; // community-modules/core/src/headerRendering/common/headerNavigationService.ts

var _HeaderNavigationDirection =
/* @__PURE__ */
function (HeaderNavigationDirection2) {
  HeaderNavigationDirection2[HeaderNavigationDirection2["UP"] = 0] = "UP";
  HeaderNavigationDirection2[HeaderNavigationDirection2["DOWN"] = 1] = "DOWN";
  HeaderNavigationDirection2[HeaderNavigationDirection2["LEFT"] = 2] = "LEFT";
  HeaderNavigationDirection2[HeaderNavigationDirection2["RIGHT"] = 3] = "RIGHT";
  return HeaderNavigationDirection2;
}(_HeaderNavigationDirection || {});

var _HeaderNavigationService =
/*#__PURE__*/
function (_BeanStub54) {
  "use strict";

  _inherits(_HeaderNavigationService, _BeanStub54);

  function _HeaderNavigationService() {
    var _this436;

    _classCallCheck(this, _HeaderNavigationService);

    _this436 = _possibleConstructorReturn(this, _getPrototypeOf(_HeaderNavigationService).apply(this, arguments));
    _this436.currentHeaderRowWithoutSpan = -1;
    return _this436;
  }

  _createClass(_HeaderNavigationService, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this437 = this;

      this.ctrlsService.whenReady(function (p) {
        _this437.gridBodyCon = p.gridBodyCtrl;
      });
      var eDocument = this.gos.getDocument();
      this.addManagedListener(eDocument, "mousedown", function () {
        return _this437.setCurrentHeaderRowWithoutSpan(-1);
      });
    }
  }, {
    key: "getHeaderRowCount",
    value: function getHeaderRowCount() {
      var centerHeaderContainer = this.ctrlsService.getHeaderRowContainerCtrl();
      return centerHeaderContainer ? centerHeaderContainer.getRowCount() : 0;
    }
    /*
     * This method navigates grid header vertically
     * @return {boolean} true to preventDefault on the event that caused this navigation.
     */

  }, {
    key: "navigateVertically",
    value: function navigateVertically(direction, fromHeader, event) {
      if (!fromHeader) {
        fromHeader = this.focusService.getFocusedHeader();
      }

      if (!fromHeader) {
        return false;
      }

      var _fromHeader = fromHeader,
          headerRowIndex = _fromHeader.headerRowIndex,
          column = _fromHeader.column;
      var rowLen = this.getHeaderRowCount();
      var isUp = direction === 0
      /* UP */
      ;

      var _ref44 = isUp ? this.headerPositionUtils.getColumnVisibleParent(column, headerRowIndex) : this.headerPositionUtils.getColumnVisibleChild(column, headerRowIndex),
          nextRow = _ref44.headerRowIndex,
          nextFocusColumn = _ref44.column,
          headerRowIndexWithoutSpan = _ref44.headerRowIndexWithoutSpan;

      var skipColumn = false;

      if (nextRow < 0) {
        nextRow = 0;
        nextFocusColumn = column;
        skipColumn = true;
      }

      if (nextRow >= rowLen) {
        nextRow = -1;
        this.setCurrentHeaderRowWithoutSpan(-1);
      } else if (headerRowIndexWithoutSpan !== void 0) {
        this.currentHeaderRowWithoutSpan = headerRowIndexWithoutSpan;
      }

      if (!skipColumn && !nextFocusColumn) {
        return false;
      }

      return this.focusService.focusHeaderPosition({
        headerPosition: {
          headerRowIndex: nextRow,
          column: nextFocusColumn
        },
        allowUserOverride: true,
        event: event
      });
    }
  }, {
    key: "setCurrentHeaderRowWithoutSpan",
    value: function setCurrentHeaderRowWithoutSpan(row) {
      this.currentHeaderRowWithoutSpan = row;
    }
    /*
     * This method navigates grid header horizontally
     * @return {boolean} true to preventDefault on the event that caused this navigation.
     */

  }, {
    key: "navigateHorizontally",
    value: function navigateHorizontally(direction) {
      var fromTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var event = arguments.length > 2 ? arguments[2] : undefined;
      var focusedHeader = this.focusService.getFocusedHeader();
      var isLeft = direction === 2
      /* LEFT */
      ;
      var isRtl = this.gos.get("enableRtl");
      var nextHeader;
      var normalisedDirection;

      if (this.currentHeaderRowWithoutSpan !== -1) {
        focusedHeader.headerRowIndex = this.currentHeaderRowWithoutSpan;
      } else {
        this.currentHeaderRowWithoutSpan = focusedHeader.headerRowIndex;
      }

      if (isLeft !== isRtl) {
        normalisedDirection = "Before";
        nextHeader = this.headerPositionUtils.findHeader(focusedHeader, normalisedDirection);
      } else {
        normalisedDirection = "After";
        nextHeader = this.headerPositionUtils.findHeader(focusedHeader, normalisedDirection);
      }

      if (nextHeader || !fromTab) {
        return this.focusService.focusHeaderPosition({
          headerPosition: nextHeader,
          direction: normalisedDirection,
          fromTab: fromTab,
          allowUserOverride: true,
          event: event
        });
      } else if (fromTab) {
        var userFunc = this.gos.getCallback("tabToNextHeader");

        if (userFunc) {
          return this.focusService.focusHeaderPositionFromUserFunc({
            userFunc: userFunc,
            headerPosition: nextHeader,
            direction: normalisedDirection
          });
        }
      }

      return this.focusNextHeaderRow(focusedHeader, normalisedDirection, event);
    }
  }, {
    key: "focusNextHeaderRow",
    value: function focusNextHeaderRow(focusedHeader, direction, event) {
      var currentIndex = focusedHeader.headerRowIndex;
      var nextPosition = null;
      var nextRowIndex;

      if (direction === "Before") {
        if (currentIndex > 0) {
          nextRowIndex = currentIndex - 1;
          this.currentHeaderRowWithoutSpan -= 1;
          nextPosition = this.headerPositionUtils.findColAtEdgeForHeaderRow(nextRowIndex, "end");
        }
      } else {
        nextRowIndex = currentIndex + 1;

        if (this.currentHeaderRowWithoutSpan < this.getHeaderRowCount()) {
          this.currentHeaderRowWithoutSpan += 1;
        } else {
          this.setCurrentHeaderRowWithoutSpan(-1);
        }

        nextPosition = this.headerPositionUtils.findColAtEdgeForHeaderRow(nextRowIndex, "start");
      }

      if (!nextPosition) {
        return false;
      }

      var _this$headerPositionU = this.headerPositionUtils.getHeaderIndexToFocus(nextPosition.column, nextPosition == null ? void 0 : nextPosition.headerRowIndex),
          column = _this$headerPositionU.column,
          headerRowIndex = _this$headerPositionU.headerRowIndex;

      return this.focusService.focusHeaderPosition({
        headerPosition: {
          column: column,
          headerRowIndex: headerRowIndex
        },
        direction: direction,
        fromTab: true,
        allowUserOverride: true,
        event: event
      });
    }
  }, {
    key: "scrollToColumn",
    value: function scrollToColumn(column) {
      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "After";

      if (column.getPinned()) {
        return;
      }

      var columnToScrollTo;

      if (column instanceof _ColumnGroup2) {
        var columns = column.getDisplayedLeafColumns();
        columnToScrollTo = direction === "Before" ? _last(columns) : columns[0];
      } else {
        columnToScrollTo = column;
      }

      this.gridBodyCon.getScrollFeature().ensureColumnVisible(columnToScrollTo);
    }
  }]);

  return _HeaderNavigationService;
}(_BeanStub2);

__decorateClass([_Autowired("focusService")], _HeaderNavigationService.prototype, "focusService", 2);

__decorateClass([_Autowired("headerPositionUtils")], _HeaderNavigationService.prototype, "headerPositionUtils", 2);

__decorateClass([_Autowired("ctrlsService")], _HeaderNavigationService.prototype, "ctrlsService", 2);

__decorateClass([_PostConstruct], _HeaderNavigationService.prototype, "postConstruct", 1);

_HeaderNavigationService = __decorateClass([_Bean("headerNavigationService")], _HeaderNavigationService); // community-modules/core/src/headerRendering/gridHeaderCtrl.ts

var _GridHeaderCtrl =
/*#__PURE__*/
function (_BeanStub55) {
  "use strict";

  _inherits(_GridHeaderCtrl, _BeanStub55);

  function _GridHeaderCtrl() {
    _classCallCheck(this, _GridHeaderCtrl);

    return _possibleConstructorReturn(this, _getPrototypeOf(_GridHeaderCtrl).apply(this, arguments));
  }

  _createClass(_GridHeaderCtrl, [{
    key: "setComp",
    value: function setComp(comp, eGui, eFocusableElement) {
      this.comp = comp;
      this.eGui = eGui;
      this.createManagedBean(new _ManagedFocusFeature2(eFocusableElement, {
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusOut: this.onFocusOut.bind(this)
      }));
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onPivotModeChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
      this.onPivotModeChanged();
      this.setupHeaderHeight();
      var listener = this.onHeaderContextMenu.bind(this);
      this.addManagedListener(this.eGui, "contextmenu", listener);
      this.mockContextMenuForIPad(listener);
      this.ctrlsService.register("gridHeaderCtrl", this);
    }
  }, {
    key: "setupHeaderHeight",
    value: function setupHeaderHeight() {
      var listener = this.setHeaderHeight.bind(this);
      listener();
      this.addManagedPropertyListener("headerHeight", listener);
      this.addManagedPropertyListener("pivotHeaderHeight", listener);
      this.addManagedPropertyListener("groupHeaderHeight", listener);
      this.addManagedPropertyListener("pivotGroupHeaderHeight", listener);
      this.addManagedPropertyListener("floatingFiltersHeight", listener);
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_HEADER_HEIGHT_CHANGED, listener);
      this.addManagedListener(this.eventService, _Events.EVENT_GRID_STYLES_CHANGED, listener);
      this.addManagedListener(this.eventService, _Events.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, listener);
    }
  }, {
    key: "getHeaderHeight",
    value: function getHeaderHeight() {
      return this.headerHeight;
    }
  }, {
    key: "setHeaderHeight",
    value: function setHeaderHeight() {
      var columnModel = this.columnModel;
      var numberOfFloating = 0;
      var headerRowCount = columnModel.getHeaderRowCount();
      var totalHeaderHeight;
      var hasFloatingFilters = this.filterManager.hasFloatingFilters();

      if (hasFloatingFilters) {
        headerRowCount++;
        numberOfFloating = 1;
      }

      var groupHeight = this.columnModel.getColumnGroupHeaderRowHeight();
      var headerHeight = this.columnModel.getColumnHeaderRowHeight();
      var numberOfNonGroups = 1 + numberOfFloating;
      var numberOfGroups = headerRowCount - numberOfNonGroups;
      totalHeaderHeight = numberOfFloating * columnModel.getFloatingFiltersHeight();
      totalHeaderHeight += numberOfGroups * groupHeight;
      totalHeaderHeight += headerHeight;

      if (this.headerHeight === totalHeaderHeight) {
        return;
      }

      this.headerHeight = totalHeaderHeight;
      var px = "".concat(totalHeaderHeight + 1, "px");
      this.comp.setHeightAndMinHeight(px);
      this.eventService.dispatchEvent({
        type: _Events.EVENT_HEADER_HEIGHT_CHANGED
      });
    }
  }, {
    key: "onPivotModeChanged",
    value: function onPivotModeChanged() {
      var pivotMode = this.columnModel.isPivotMode();
      this.comp.addOrRemoveCssClass("ag-pivot-on", pivotMode);
      this.comp.addOrRemoveCssClass("ag-pivot-off", !pivotMode);
    }
  }, {
    key: "onDisplayedColumnsChanged",
    value: function onDisplayedColumnsChanged() {
      var columns = this.columnModel.getAllDisplayedColumns();
      var shouldAllowOverflow = columns.some(function (col) {
        return col.isSpanHeaderHeight();
      });
      this.comp.addOrRemoveCssClass("ag-header-allow-overflow", shouldAllowOverflow);
    }
  }, {
    key: "onTabKeyDown",
    value: function onTabKeyDown(e) {
      var isRtl = this.gos.get("enableRtl");
      var direction = e.shiftKey !== isRtl ? 2
      /* LEFT */
      : 3
      /* RIGHT */
      ;

      if (this.headerNavigationService.navigateHorizontally(direction, true, e) || this.focusService.focusNextGridCoreContainer(e.shiftKey)) {
        e.preventDefault();
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var direction = null;

      switch (e.key) {
        case _KeyCode.LEFT:
          direction = 2
          /* LEFT */
          ;

        case _KeyCode.RIGHT:
          if (!_exists(direction)) {
            direction = 3
            /* RIGHT */
            ;
          }

          this.headerNavigationService.navigateHorizontally(direction, false, e);
          break;

        case _KeyCode.UP:
          direction = 0
          /* UP */
          ;

        case _KeyCode.DOWN:
          if (!_exists(direction)) {
            direction = 1
            /* DOWN */
            ;
          }

          if (this.headerNavigationService.navigateVertically(direction, null, e)) {
            e.preventDefault();
          }

          break;

        default:
          return;
      }
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut(e) {
      var relatedTarget = e.relatedTarget;

      if (!relatedTarget && this.eGui.contains(this.gos.getActiveDomElement())) {
        return;
      }

      if (!this.eGui.contains(relatedTarget)) {
        this.focusService.clearFocusedHeader();
      }
    }
  }, {
    key: "onHeaderContextMenu",
    value: function onHeaderContextMenu(mouseEvent, touch, touchEvent) {
      if (!mouseEvent && !touchEvent || !this.menuService.isHeaderContextMenuEnabled()) {
        return;
      }

      var _ref45 = mouseEvent != null ? mouseEvent : touch,
          target = _ref45.target;

      if (target === this.eGui || target === this.ctrlsService.getHeaderRowContainerCtrl().getViewport()) {
        this.menuService.showHeaderContextMenu(void 0, mouseEvent, touchEvent);
      }
    }
  }, {
    key: "mockContextMenuForIPad",
    value: function mockContextMenuForIPad(listener) {
      if (!_isIOSUserAgent()) {
        return;
      }

      var touchListener = new _TouchListener2(this.eGui);

      var longTapListener = function longTapListener(event) {
        listener(void 0, event.touchStart, event.touchEvent);
      };

      this.addManagedListener(touchListener, _TouchListener2.EVENT_LONG_TAP, longTapListener);
      this.addDestroyFunc(function () {
        return touchListener.destroy();
      });
    }
  }]);

  return _GridHeaderCtrl;
}(_BeanStub2);

__decorateClass([_Autowired("headerNavigationService")], _GridHeaderCtrl.prototype, "headerNavigationService", 2);

__decorateClass([_Autowired("focusService")], _GridHeaderCtrl.prototype, "focusService", 2);

__decorateClass([_Autowired("columnModel")], _GridHeaderCtrl.prototype, "columnModel", 2);

__decorateClass([_Autowired("ctrlsService")], _GridHeaderCtrl.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("filterManager")], _GridHeaderCtrl.prototype, "filterManager", 2);

__decorateClass([_Autowired("menuService")], _GridHeaderCtrl.prototype, "menuService", 2); // community-modules/core/src/headerRendering/gridHeaderComp.ts


var _GridHeaderComp =
/*#__PURE__*/
function (_Component33) {
  "use strict";

  _inherits(_GridHeaderComp, _Component33);

  function _GridHeaderComp() {
    _classCallCheck(this, _GridHeaderComp);

    return _possibleConstructorReturn(this, _getPrototypeOf(_GridHeaderComp).call(this, _GridHeaderComp.TEMPLATE));
  }

  _createClass(_GridHeaderComp, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this438 = this;

      var compProxy = {
        addOrRemoveCssClass: function addOrRemoveCssClass(cssClassName, on) {
          return _this438.addOrRemoveCssClass(cssClassName, on);
        },
        setHeightAndMinHeight: function setHeightAndMinHeight(height) {
          _this438.getGui().style.height = height;
          _this438.getGui().style.minHeight = height;
        }
      };
      var ctrl = this.createManagedBean(new _GridHeaderCtrl());
      ctrl.setComp(compProxy, this.getGui(), this.getFocusableElement());

      var addContainer = function addContainer(container) {
        _this438.createManagedBean(container);

        _this438.appendChild(container);
      };

      addContainer(new _HeaderRowContainerComp2("left"));
      addContainer(new _HeaderRowContainerComp2(null));
      addContainer(new _HeaderRowContainerComp2("right"));
    }
  }]);

  return _GridHeaderComp;
}(_Component2);

_GridHeaderComp.TEMPLATE =
/* html */
"<div class=\"ag-header\" role=\"presentation\"/>";

__decorateClass([_PostConstruct], _GridHeaderComp.prototype, "postConstruct", 1);

var _GridHeaderComp2 = _GridHeaderComp; // community-modules/core/src/headerRendering/common/horizontalResizeService.ts

var _HorizontalResizeService =
/*#__PURE__*/
function (_BeanStub56) {
  "use strict";

  _inherits(_HorizontalResizeService, _BeanStub56);

  function _HorizontalResizeService() {
    _classCallCheck(this, _HorizontalResizeService);

    return _possibleConstructorReturn(this, _getPrototypeOf(_HorizontalResizeService).apply(this, arguments));
  }

  _createClass(_HorizontalResizeService, [{
    key: "addResizeBar",
    value: function addResizeBar(params) {
      var _this439 = this;

      var dragSource = {
        dragStartPixels: params.dragStartPixels || 0,
        eElement: params.eResizeBar,
        onDragStart: this.onDragStart.bind(this, params),
        onDragStop: this.onDragStop.bind(this, params),
        onDragging: this.onDragging.bind(this, params),
        includeTouch: true,
        stopPropagationForTouch: true
      };
      this.dragService.addDragSource(dragSource);

      var finishedWithResizeFunc = function finishedWithResizeFunc() {
        return _this439.dragService.removeDragSource(dragSource);
      };

      return finishedWithResizeFunc;
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(params, mouseEvent) {
      this.dragStartX = mouseEvent.clientX;
      this.setResizeIcons();
      var shiftKey = mouseEvent instanceof MouseEvent && mouseEvent.shiftKey === true;
      params.onResizeStart(shiftKey);
    }
  }, {
    key: "setResizeIcons",
    value: function setResizeIcons() {
      var ctrl = this.ctrlsService.get("gridCtrl");
      ctrl.setResizeCursor(true);
      ctrl.disableUserSelect(true);
    }
  }, {
    key: "onDragStop",
    value: function onDragStop(params, mouseEvent) {
      params.onResizeEnd(this.resizeAmount);
      this.resetIcons();
    }
  }, {
    key: "resetIcons",
    value: function resetIcons() {
      var ctrl = this.ctrlsService.get("gridCtrl");
      ctrl.setResizeCursor(false);
      ctrl.disableUserSelect(false);
    }
  }, {
    key: "onDragging",
    value: function onDragging(params, mouseEvent) {
      this.resizeAmount = mouseEvent.clientX - this.dragStartX;
      params.onResizing(this.resizeAmount);
    }
  }]);

  return _HorizontalResizeService;
}(_BeanStub2);

__decorateClass([_Autowired("dragService")], _HorizontalResizeService.prototype, "dragService", 2);

__decorateClass([_Autowired("ctrlsService")], _HorizontalResizeService.prototype, "ctrlsService", 2);

_HorizontalResizeService = __decorateClass([_Bean("horizontalResizeService")], _HorizontalResizeService); // community-modules/core/src/headerRendering/cells/column/standardMenu.ts

var _StandardMenuFactory =
/*#__PURE__*/
function (_BeanStub57) {
  "use strict";

  _inherits(_StandardMenuFactory, _BeanStub57);

  function _StandardMenuFactory() {
    _classCallCheck(this, _StandardMenuFactory);

    return _possibleConstructorReturn(this, _getPrototypeOf(_StandardMenuFactory).apply(this, arguments));
  }

  _createClass(_StandardMenuFactory, [{
    key: "hideActiveMenu",
    value: function hideActiveMenu() {
      if (this.hidePopup) {
        this.hidePopup();
      }
    }
  }, {
    key: "showMenuAfterMouseEvent",
    value: function showMenuAfterMouseEvent(column, mouseEvent, containerType) {
      var _this440 = this;

      this.showPopup(column, function (eMenu) {
        _this440.popupService.positionPopupUnderMouseEvent({
          column: column,
          type: containerType,
          mouseEvent: mouseEvent,
          ePopup: eMenu
        });
      }, containerType, mouseEvent.target, this.menuService.isLegacyMenuEnabled());
    }
  }, {
    key: "showMenuAfterButtonClick",
    value: function showMenuAfterButtonClick(column, eventSource, containerType) {
      var _this441 = this;

      var multiplier = -1;
      var alignSide = "left";
      var isLegacyMenuEnabled = this.menuService.isLegacyMenuEnabled();

      if (!isLegacyMenuEnabled && this.gos.get("enableRtl")) {
        multiplier = 1;
        alignSide = "right";
      }

      var nudgeX = isLegacyMenuEnabled ? void 0 : 4 * multiplier;
      var nudgeY = isLegacyMenuEnabled ? void 0 : 4;
      this.showPopup(column, function (eMenu) {
        _this441.popupService.positionPopupByComponent({
          type: containerType,
          eventSource: eventSource,
          ePopup: eMenu,
          nudgeX: nudgeX,
          nudgeY: nudgeY,
          alignSide: alignSide,
          keepWithinBounds: true,
          position: "under",
          column: column
        });
      }, containerType, eventSource, isLegacyMenuEnabled);
    }
  }, {
    key: "showPopup",
    value: function showPopup(column, _positionCallback, containerType, eventSource, isLegacyMenuEnabled) {
      var _this442 = this;

      var comp = column ? this.createBean(new _FilterWrapperComp(column, "COLUMN_MENU")) : void 0;
      this.activeMenu = comp;

      if (!(comp == null ? void 0 : comp.hasFilter()) || !column) {
        throw new Error("AG Grid - unable to show popup filter, filter instantiation failed");
      }

      var eMenu = document.createElement("div");

      _setAriaRole(eMenu, "presentation");

      eMenu.classList.add("ag-menu");

      if (!isLegacyMenuEnabled) {
        eMenu.classList.add("ag-filter-menu");
      }

      this.tabListener = this.addManagedListener(eMenu, "keydown", function (e) {
        return _this442.trapFocusWithin(e, eMenu);
      });
      eMenu.appendChild(comp == null ? void 0 : comp.getGui());
      var hidePopup;

      var afterGuiDetached = function afterGuiDetached() {
        return comp == null ? void 0 : comp.afterGuiDetached();
      };

      var anchorToElement = this.menuService.isColumnMenuAnchoringEnabled() ? eventSource != null ? eventSource : this.ctrlsService.getGridBodyCtrl().getGui() : void 0;

      var closedCallback = function closedCallback(e) {
        column.setMenuVisible(false, "contextMenu");
        var isKeyboardEvent = e instanceof KeyboardEvent;

        if (_this442.tabListener) {
          _this442.tabListener = _this442.tabListener();
        }

        if (isKeyboardEvent && eventSource && _isVisible(eventSource)) {
          var focusableEl = _this442.focusService.findTabbableParent(eventSource);

          if (focusableEl) {
            focusableEl.focus();
          }
        }

        afterGuiDetached();

        _this442.destroyBean(_this442.activeMenu);

        _this442.dispatchVisibleChangedEvent(false, containerType, column);
      };

      var translate = this.localeService.getLocaleTextFunc();
      var ariaLabel = isLegacyMenuEnabled && containerType !== "columnFilter" ? translate("ariaLabelColumnMenu", "Column Menu") : translate("ariaLabelColumnFilter", "Column Filter");
      var addPopupRes = this.popupService.addPopup({
        modal: true,
        eChild: eMenu,
        closeOnEsc: true,
        closedCallback: closedCallback,
        positionCallback: function positionCallback() {
          return _positionCallback(eMenu);
        },
        anchorToElement: anchorToElement,
        ariaLabel: ariaLabel
      });

      if (addPopupRes) {
        this.hidePopup = hidePopup = addPopupRes.hideFunc;
      }

      comp.afterInit().then(function () {
        _positionCallback(eMenu);

        comp.afterGuiAttached({
          container: containerType,
          hidePopup: hidePopup
        });
      });
      column.setMenuVisible(true, "contextMenu");
      this.dispatchVisibleChangedEvent(true, containerType, column);
    }
  }, {
    key: "trapFocusWithin",
    value: function trapFocusWithin(e, menu) {
      if (e.key !== _KeyCode.TAB || e.defaultPrevented || this.focusService.findNextFocusableElement(menu, false, e.shiftKey)) {
        return;
      }

      e.preventDefault();
      this.focusService.focusInto(menu, e.shiftKey);
    }
  }, {
    key: "dispatchVisibleChangedEvent",
    value: function dispatchVisibleChangedEvent(visible, containerType, column) {
      var displayedEvent = {
        type: _Events.EVENT_COLUMN_MENU_VISIBLE_CHANGED,
        visible: visible,
        switchingTab: false,
        key: containerType,
        column: column != null ? column : null
      };
      this.eventService.dispatchEvent(displayedEvent);
    }
  }, {
    key: "isMenuEnabled",
    value: function isMenuEnabled(column) {
      var _a;

      return column.isFilterAllowed() && ((_a = column.getColDef().menuTabs) != null ? _a : ["filterMenuTab"]).includes("filterMenuTab");
    }
  }, {
    key: "showMenuAfterContextMenuEvent",
    value: function showMenuAfterContextMenuEvent() {}
  }, {
    key: "destroy",
    value: function destroy() {
      this.destroyBean(this.activeMenu);

      _get(_getPrototypeOf(_StandardMenuFactory.prototype), "destroy", this).call(this);
    }
  }]);

  return _StandardMenuFactory;
}(_BeanStub2);

__decorateClass([_Autowired("filterManager")], _StandardMenuFactory.prototype, "filterManager", 2);

__decorateClass([_Autowired("popupService")], _StandardMenuFactory.prototype, "popupService", 2);

__decorateClass([_Autowired("focusService")], _StandardMenuFactory.prototype, "focusService", 2);

__decorateClass([_Autowired("ctrlsService")], _StandardMenuFactory.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("menuService")], _StandardMenuFactory.prototype, "menuService", 2);

_StandardMenuFactory = __decorateClass([_Bean("filterMenuFactory")], _StandardMenuFactory); // community-modules/core/src/widgets/tabGuardCtrl.ts

var _TabGuardClassNames =
/* @__PURE__ */
function (TabGuardClassNames2) {
  TabGuardClassNames2["TAB_GUARD"] = "ag-tab-guard";
  TabGuardClassNames2["TAB_GUARD_TOP"] = "ag-tab-guard-top";
  TabGuardClassNames2["TAB_GUARD_BOTTOM"] = "ag-tab-guard-bottom";
  return TabGuardClassNames2;
}(_TabGuardClassNames || {});

var _TabGuardCtrl =
/*#__PURE__*/
function (_BeanStub58) {
  "use strict";

  _inherits(_TabGuardCtrl, _BeanStub58);

  function _TabGuardCtrl(params) {
    var _this443;

    _classCallCheck(this, _TabGuardCtrl);

    _this443 = _possibleConstructorReturn(this, _getPrototypeOf(_TabGuardCtrl).call(this));
    _this443.skipTabGuardFocus = false;
    _this443.forcingFocusOut = false;
    var comp = params.comp,
        eTopGuard = params.eTopGuard,
        eBottomGuard = params.eBottomGuard,
        focusTrapActive = params.focusTrapActive,
        forceFocusOutWhenTabGuardsAreEmpty = params.forceFocusOutWhenTabGuardsAreEmpty,
        focusInnerElement = params.focusInnerElement,
        onFocusIn = params.onFocusIn,
        onFocusOut = params.onFocusOut,
        shouldStopEventPropagation = params.shouldStopEventPropagation,
        onTabKeyDown = params.onTabKeyDown,
        handleKeyDown = params.handleKeyDown,
        eFocusableElement = params.eFocusableElement;
    _this443.comp = comp;
    _this443.eTopGuard = eTopGuard;
    _this443.eBottomGuard = eBottomGuard;
    _this443.providedFocusInnerElement = focusInnerElement;
    _this443.eFocusableElement = eFocusableElement;
    _this443.focusTrapActive = !!focusTrapActive;
    _this443.forceFocusOutWhenTabGuardsAreEmpty = !!forceFocusOutWhenTabGuardsAreEmpty;
    _this443.providedFocusIn = onFocusIn;
    _this443.providedFocusOut = onFocusOut;
    _this443.providedShouldStopEventPropagation = shouldStopEventPropagation;
    _this443.providedOnTabKeyDown = onTabKeyDown;
    _this443.providedHandleKeyDown = handleKeyDown;
    return _this443;
  }

  _createClass(_TabGuardCtrl, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this444 = this;

      this.createManagedBean(new _ManagedFocusFeature2(this.eFocusableElement, {
        shouldStopEventPropagation: function shouldStopEventPropagation() {
          return _this444.shouldStopEventPropagation();
        },
        onTabKeyDown: function onTabKeyDown(e) {
          return _this444.onTabKeyDown(e);
        },
        handleKeyDown: function handleKeyDown(e) {
          return _this444.handleKeyDown(e);
        },
        onFocusIn: function onFocusIn(e) {
          return _this444.onFocusIn(e);
        },
        onFocusOut: function onFocusOut(e) {
          return _this444.onFocusOut(e);
        }
      }));
      this.activateTabGuards();
      [this.eTopGuard, this.eBottomGuard].forEach(function (guard) {
        return _this444.addManagedListener(guard, "focus", _this444.onFocus.bind(_this444));
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      if (this.providedHandleKeyDown) {
        this.providedHandleKeyDown(e);
      }
    }
  }, {
    key: "tabGuardsAreActive",
    value: function tabGuardsAreActive() {
      return !!this.eTopGuard && this.eTopGuard.hasAttribute("tabIndex");
    }
  }, {
    key: "shouldStopEventPropagation",
    value: function shouldStopEventPropagation() {
      if (this.providedShouldStopEventPropagation) {
        return this.providedShouldStopEventPropagation();
      }

      return false;
    }
  }, {
    key: "activateTabGuards",
    value: function activateTabGuards() {
      if (this.forcingFocusOut) {
        return;
      }

      var tabIndex = this.gos.get("tabIndex");
      this.comp.setTabIndex(tabIndex.toString());
    }
  }, {
    key: "deactivateTabGuards",
    value: function deactivateTabGuards() {
      this.comp.setTabIndex();
    }
  }, {
    key: "onFocus",
    value: function onFocus(e) {
      if (this.skipTabGuardFocus) {
        this.skipTabGuardFocus = false;
        return;
      }

      if (this.forceFocusOutWhenTabGuardsAreEmpty) {
        var isEmpty = this.focusService.findFocusableElements(this.eFocusableElement, ".ag-tab-guard").length === 0;

        if (isEmpty) {
          this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
          return;
        }
      }

      var fromBottom = e.target === this.eBottomGuard;

      if (this.providedFocusInnerElement) {
        this.providedFocusInnerElement(fromBottom);
      } else {
        this.focusInnerElement(fromBottom);
      }
    }
  }, {
    key: "findNextElementOutsideAndFocus",
    value: function findNextElementOutsideAndFocus(up) {
      var eDocument = this.gos.getDocument();
      var focusableEls = this.focusService.findFocusableElements(eDocument.body, null, true);
      var index = focusableEls.indexOf(up ? this.eTopGuard : this.eBottomGuard);

      if (index === -1) {
        return;
      }

      var start;
      var end;

      if (up) {
        start = 0;
        end = index;
      } else {
        start = index + 1;
        end = focusableEls.length;
      }

      var focusableRange = focusableEls.slice(start, end);
      var targetTabIndex = this.gos.get("tabIndex");
      focusableRange.sort(function (a, b) {
        var indexA = parseInt(a.getAttribute("tabindex") || "0");
        var indexB = parseInt(b.getAttribute("tabindex") || "0");

        if (indexB === targetTabIndex) {
          return 1;
        }

        if (indexA === targetTabIndex) {
          return -1;
        }

        if (indexA === 0) {
          return 1;
        }

        if (indexB === 0) {
          return -1;
        }

        return indexA - indexB;
      });
      focusableRange[up ? focusableRange.length - 1 : 0].focus();
    }
  }, {
    key: "onFocusIn",
    value: function onFocusIn(e) {
      if (this.focusTrapActive) {
        return;
      }

      if (this.providedFocusIn) {
        this.providedFocusIn(e);
      }

      this.deactivateTabGuards();
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut(e) {
      if (this.focusTrapActive) {
        return;
      }

      if (this.providedFocusOut) {
        this.providedFocusOut(e);
      }

      if (!this.eFocusableElement.contains(e.relatedTarget)) {
        this.activateTabGuards();
      }
    }
  }, {
    key: "onTabKeyDown",
    value: function onTabKeyDown(e) {
      var _this445 = this;

      if (this.providedOnTabKeyDown) {
        this.providedOnTabKeyDown(e);
        return;
      }

      if (this.focusTrapActive) {
        return;
      }

      if (e.defaultPrevented) {
        return;
      }

      var tabGuardsAreActive = this.tabGuardsAreActive();

      if (tabGuardsAreActive) {
        this.deactivateTabGuards();
      }

      var nextRoot = this.getNextFocusableElement(e.shiftKey);

      if (tabGuardsAreActive) {
        setTimeout(function () {
          return _this445.activateTabGuards();
        }, 0);
      }

      if (!nextRoot) {
        return;
      }

      nextRoot.focus();
      e.preventDefault();
    }
  }, {
    key: "focusInnerElement",
    value: function focusInnerElement() {
      var fromBottom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var focusable = this.focusService.findFocusableElements(this.eFocusableElement);

      if (this.tabGuardsAreActive()) {
        focusable.splice(0, 1);
        focusable.splice(focusable.length - 1, 1);
      }

      if (!focusable.length) {
        return;
      }

      focusable[fromBottom ? focusable.length - 1 : 0].focus({
        preventScroll: true
      });
    }
  }, {
    key: "getNextFocusableElement",
    value: function getNextFocusableElement(backwards) {
      return this.focusService.findNextFocusableElement(this.eFocusableElement, false, backwards);
    }
  }, {
    key: "forceFocusOutOfContainer",
    value: function forceFocusOutOfContainer() {
      var _this446 = this;

      var up = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.forcingFocusOut) {
        return;
      }

      var tabGuardToFocus = up ? this.eTopGuard : this.eBottomGuard;
      this.activateTabGuards();
      this.skipTabGuardFocus = true;
      this.forcingFocusOut = true;
      tabGuardToFocus.focus();
      window.setTimeout(function () {
        _this446.forcingFocusOut = false;

        _this446.activateTabGuards();
      });
    }
  }, {
    key: "isTabGuard",
    value: function isTabGuard(element) {
      return element === this.eTopGuard || element === this.eBottomGuard;
    }
  }]);

  return _TabGuardCtrl;
}(_BeanStub2);

__decorateClass([_Autowired("focusService")], _TabGuardCtrl.prototype, "focusService", 2);

__decorateClass([_PostConstruct], _TabGuardCtrl.prototype, "postConstruct", 1); // community-modules/core/src/widgets/tabGuardComp.ts


var _TabGuardComp =
/*#__PURE__*/
function (_Component34) {
  "use strict";

  _inherits(_TabGuardComp, _Component34);

  function _TabGuardComp() {
    _classCallCheck(this, _TabGuardComp);

    return _possibleConstructorReturn(this, _getPrototypeOf(_TabGuardComp).apply(this, arguments));
  }

  _createClass(_TabGuardComp, [{
    key: "initialiseTabGuard",
    value: function initialiseTabGuard(params) {
      this.eTopGuard = this.createTabGuard("top");
      this.eBottomGuard = this.createTabGuard("bottom");
      this.eFocusableElement = this.getFocusableElement();
      var tabGuards = [this.eTopGuard, this.eBottomGuard];
      var compProxy = {
        setTabIndex: function setTabIndex(tabIndex) {
          tabGuards.forEach(function (tabGuard) {
            return tabIndex != null ? tabGuard.setAttribute("tabindex", tabIndex) : tabGuard.removeAttribute("tabindex");
          });
        }
      };
      this.addTabGuards(this.eTopGuard, this.eBottomGuard);
      this.tabGuardCtrl = this.createManagedBean(new _TabGuardCtrl({
        comp: compProxy,
        focusTrapActive: !!params.focusTrapActive,
        eTopGuard: this.eTopGuard,
        eBottomGuard: this.eBottomGuard,
        eFocusableElement: this.eFocusableElement,
        onFocusIn: params.onFocusIn,
        onFocusOut: params.onFocusOut,
        focusInnerElement: params.focusInnerElement,
        handleKeyDown: params.handleKeyDown,
        onTabKeyDown: params.onTabKeyDown,
        shouldStopEventPropagation: params.shouldStopEventPropagation,
        forceFocusOutWhenTabGuardsAreEmpty: params.forceFocusOutWhenTabGuardsAreEmpty
      }));
    }
  }, {
    key: "createTabGuard",
    value: function createTabGuard(side) {
      var tabGuard = document.createElement("div");
      var cls = side === "top" ? "ag-tab-guard-top"
      /* TAB_GUARD_TOP */
      : "ag-tab-guard-bottom"
      /* TAB_GUARD_BOTTOM */
      ;
      tabGuard.classList.add("ag-tab-guard"
      /* TAB_GUARD */
      , cls);

      _setAriaRole(tabGuard, "presentation");

      return tabGuard;
    }
  }, {
    key: "addTabGuards",
    value: function addTabGuards(topTabGuard, bottomTabGuard) {
      this.eFocusableElement.insertAdjacentElement("afterbegin", topTabGuard);
      this.eFocusableElement.insertAdjacentElement("beforeend", bottomTabGuard);
    }
  }, {
    key: "removeAllChildrenExceptTabGuards",
    value: function removeAllChildrenExceptTabGuards() {
      var tabGuards = [this.eTopGuard, this.eBottomGuard];

      _clearElement(this.getFocusableElement());

      this.addTabGuards.apply(this, tabGuards);
    }
  }, {
    key: "forceFocusOutOfContainer",
    value: function forceFocusOutOfContainer() {
      var up = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.tabGuardCtrl.forceFocusOutOfContainer(up);
    }
  }, {
    key: "appendChild",
    value: function appendChild(newChild, container) {
      if (!_isNodeOrElement(newChild)) {
        newChild = newChild.getGui();
      }

      var bottomTabGuard = this.eBottomGuard;

      if (bottomTabGuard) {
        bottomTabGuard.insertAdjacentElement("beforebegin", newChild);
      } else {
        _get(_getPrototypeOf(_TabGuardComp.prototype), "appendChild", this).call(this, newChild, container);
      }
    }
  }]);

  return _TabGuardComp;
}(_Component2); // community-modules/core/src/layout/tabbedLayout.ts


var _TabbedLayout =
/*#__PURE__*/
function (_TabGuardComp2) {
  "use strict";

  _inherits(_TabbedLayout, _TabGuardComp2);

  function _TabbedLayout(params) {
    var _this447;

    _classCallCheck(this, _TabbedLayout);

    _this447 = _possibleConstructorReturn(this, _getPrototypeOf(_TabbedLayout).call(this, _TabbedLayout.getTemplate(params.cssClass)));
    _this447.items = [];
    _this447.tabbedItemScrollMap =
    /* @__PURE__ */
    new Map();
    _this447.params = params;
    return _this447;
  }

  _createClass(_TabbedLayout, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this448 = this;

      this.setupHeader();

      if (this.params.items) {
        this.params.items.forEach(function (item) {
          return _this448.addItem(item);
        });
      }

      this.initialiseTabGuard({
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this),
        focusInnerElement: this.focusInnerElement.bind(this),
        focusTrapActive: true
      });
      this.addDestroyFunc(function () {
        var _a, _b, _c;

        return (_c = (_b = (_a = _this448.activeItem) == null ? void 0 : _a.tabbedItem) == null ? void 0 : _b.afterDetachedCallback) == null ? void 0 : _c.call(_b);
      });
    }
  }, {
    key: "setupHeader",
    value: function setupHeader() {
      var _this$params5 = this.params,
          enableCloseButton = _this$params5.enableCloseButton,
          cssClass = _this$params5.cssClass;

      var addCssClasses = function addCssClasses(el, suffix) {
        el.classList.add("ag-tabs-".concat(suffix));

        if (cssClass) {
          el.classList.add("".concat(cssClass, "-").concat(suffix));
        }
      };

      if (enableCloseButton) {
        this.setupCloseButton(addCssClasses);
        this.eTabHeader = this.gos.getDocument().createElement("div");
        addCssClasses(this.eHeader, "header-wrapper");

        _setAriaRole(this.eHeader, "presentation");

        this.eHeader.appendChild(this.eTabHeader);
      } else {
        this.eTabHeader = this.eHeader;
      }

      _setAriaRole(this.eTabHeader, "tablist");

      addCssClasses(this.eTabHeader, "header");
    }
  }, {
    key: "setupCloseButton",
    value: function setupCloseButton(addCssClasses) {
      var _this449 = this;

      var eDocument = this.gos.getDocument();
      var eCloseButton = eDocument.createElement("button");
      addCssClasses(eCloseButton, "close-button");

      var eIcon = _createIconNoSpan("close", this.gos, void 0, true);

      _setAriaLabel(eCloseButton, this.params.closeButtonAriaLabel);

      eCloseButton.appendChild(eIcon);
      this.addManagedListener(eCloseButton, "click", function () {
        var _a, _b;

        return (_b = (_a = _this449.params).onCloseClicked) == null ? void 0 : _b.call(_a);
      });
      var eCloseButtonWrapper = eDocument.createElement("div");
      addCssClasses(eCloseButtonWrapper, "close-button-wrapper");

      _setAriaRole(eCloseButtonWrapper, "presentation");

      eCloseButtonWrapper.appendChild(eCloseButton);
      this.eHeader.appendChild(eCloseButtonWrapper);
      this.eCloseButton = eCloseButton;
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      switch (e.key) {
        case _KeyCode.RIGHT:
        case _KeyCode.LEFT:
          if (!this.eTabHeader.contains(this.gos.getActiveDomElement())) {
            return;
          }

          var isRightKey = e.key === _KeyCode.RIGHT;
          var isRtl = this.gos.get("enableRtl");
          var currentPosition = this.items.indexOf(this.activeItem);
          var nextPosition = isRightKey !== isRtl ? Math.min(currentPosition + 1, this.items.length - 1) : Math.max(currentPosition - 1, 0);

          if (currentPosition === nextPosition) {
            return;
          }

          e.preventDefault();
          var nextItem = this.items[nextPosition];
          this.showItemWrapper(nextItem);
          nextItem.eHeaderButton.focus();
          break;

        case _KeyCode.UP:
        case _KeyCode.DOWN:
          e.stopPropagation();
          break;
      }
    }
  }, {
    key: "onTabKeyDown",
    value: function onTabKeyDown(e) {
      var _a, _b, _c, _d;

      if (e.defaultPrevented) {
        return;
      }

      var focusService = this.focusService,
          eHeader = this.eHeader,
          eBody = this.eBody,
          activeItem = this.activeItem,
          params = this.params;
      var suppressTrapFocus = params.suppressTrapFocus,
          enableCloseButton = params.enableCloseButton;
      var activeElement = this.gos.getActiveDomElement();
      var target = e.target;
      var backwards = e.shiftKey;

      if (eHeader.contains(activeElement)) {
        e.preventDefault();

        if (enableCloseButton && backwards && !((_a = this.eCloseButton) == null ? void 0 : _a.contains(activeElement))) {
          (_b = this.eCloseButton) == null ? void 0 : _b.focus();
        } else if (suppressTrapFocus && backwards) {
          (_c = this.focusService.findFocusableElementBeforeTabGuard(this.gos.getDocument().body, target)) == null ? void 0 : _c.focus();
        } else {
          this.focusBody(e.shiftKey);
        }

        return;
      }

      var nextEl = null;

      if (focusService.isTargetUnderManagedComponent(eBody, target)) {
        if (backwards) {
          nextEl = this.focusService.findFocusableElementBeforeTabGuard(eBody, target);
        }

        if (!nextEl && !suppressTrapFocus) {
          nextEl = activeItem.eHeaderButton;
        }
      }

      if (!nextEl && eBody.contains(activeElement)) {
        nextEl = focusService.findNextFocusableElement(eBody, false, backwards);

        if (!nextEl) {
          e.preventDefault();

          if (suppressTrapFocus && !backwards) {
            this.forceFocusOutOfContainer(backwards);
          } else if (enableCloseButton && !backwards) {
            (_d = this.eCloseButton) == null ? void 0 : _d.focus();
          } else {
            this.focusHeader();
          }

          return;
        }
      }

      if (nextEl) {
        e.preventDefault();
        nextEl.focus();
      }
    }
  }, {
    key: "focusInnerElement",
    value: function focusInnerElement(fromBottom) {
      if (fromBottom) {
        this.focusHeader();
      } else {
        this.focusBody(true);
      }
    }
  }, {
    key: "focusHeader",
    value: function focusHeader(preventScroll) {
      this.activeItem.eHeaderButton.focus({
        preventScroll: preventScroll
      });
    }
  }, {
    key: "focusBody",
    value: function focusBody(fromBottom) {
      this.focusService.focusInto(this.eBody, fromBottom);
    }
  }, {
    key: "setAfterAttachedParams",
    value: function setAfterAttachedParams(params) {
      this.afterAttachedParams = params;
    }
  }, {
    key: "showFirstItem",
    value: function showFirstItem() {
      if (this.items.length > 0) {
        this.showItemWrapper(this.items[0]);
      }
    }
  }, {
    key: "addItem",
    value: function addItem(item) {
      var eHeaderButton = document.createElement("span");

      _setAriaRole(eHeaderButton, "tab");

      eHeaderButton.setAttribute("tabindex", "-1");
      eHeaderButton.appendChild(item.title);
      eHeaderButton.classList.add("ag-tab");
      this.eTabHeader.appendChild(eHeaderButton);

      _setAriaLabel(eHeaderButton, item.titleLabel);

      var wrapper = {
        tabbedItem: item,
        eHeaderButton: eHeaderButton
      };
      this.items.push(wrapper);
      eHeaderButton.addEventListener("click", this.showItemWrapper.bind(this, wrapper));
    }
  }, {
    key: "showItem",
    value: function showItem(tabbedItem) {
      var itemWrapper = this.items.find(function (wrapper) {
        return wrapper.tabbedItem === tabbedItem;
      });

      if (itemWrapper) {
        this.showItemWrapper(itemWrapper);
      }
    }
  }, {
    key: "showItemWrapper",
    value: function showItemWrapper(wrapper) {
      var _this450 = this;

      var _a, _b, _c, _d, _e, _f;

      var tabbedItem = wrapper.tabbedItem,
          eHeaderButton = wrapper.eHeaderButton;
      (_b = (_a = this.params).onItemClicked) == null ? void 0 : _b.call(_a, {
        item: tabbedItem
      });

      if (this.activeItem === wrapper) {
        (_d = (_c = this.params).onActiveItemClicked) == null ? void 0 : _d.call(_c);
        return;
      }

      if (this.lastScrollListener) {
        this.lastScrollListener = this.lastScrollListener();
      }

      _clearElement(this.eBody);

      tabbedItem.bodyPromise.then(function (body) {
        _this450.eBody.appendChild(body);

        var onlyUnmanaged = !_this450.focusService.isKeyboardMode();

        if (!_this450.params.suppressFocusBodyOnOpen) {
          _this450.focusService.focusInto(_this450.eBody, false, onlyUnmanaged);
        }

        if (tabbedItem.afterAttachedCallback) {
          tabbedItem.afterAttachedCallback(_this450.afterAttachedParams);
        }

        if (_this450.params.keepScrollPosition) {
          var scrollableContainer = tabbedItem.getScrollableContainer && tabbedItem.getScrollableContainer() || body;
          _this450.lastScrollListener = _this450.addManagedListener(scrollableContainer, "scroll", function () {
            _this450.tabbedItemScrollMap.set(tabbedItem.name, scrollableContainer.scrollTop);
          });

          var scrollPosition = _this450.tabbedItemScrollMap.get(tabbedItem.name);

          if (scrollPosition !== void 0) {
            setTimeout(function () {
              scrollableContainer.scrollTop = scrollPosition;
            }, 0);
          }
        }
      });

      if (this.activeItem) {
        this.activeItem.eHeaderButton.classList.remove("ag-tab-selected");
        (_f = (_e = this.activeItem.tabbedItem).afterDetachedCallback) == null ? void 0 : _f.call(_e);
      }

      eHeaderButton.classList.add("ag-tab-selected");
      this.activeItem = wrapper;
    }
  }], [{
    key: "getTemplate",
    value: function getTemplate(cssClass) {
      return (
        /* html */
        "<div class=\"ag-tabs ".concat(cssClass, "\">\n            <div ref=\"eHeader\"></div>\n            <div ref=\"eBody\" role=\"presentation\" class=\"ag-tabs-body ").concat(cssClass ? "".concat(cssClass, "-body") : "", "\"></div>\n        </div>")
      );
    }
  }]);

  return _TabbedLayout;
}(_TabGuardComp);

__decorateClass([_Autowired("focusService")], _TabbedLayout.prototype, "focusService", 2);

__decorateClass([_RefSelector("eHeader")], _TabbedLayout.prototype, "eHeader", 2);

__decorateClass([_RefSelector("eBody")], _TabbedLayout.prototype, "eBody", 2);

__decorateClass([_PostConstruct], _TabbedLayout.prototype, "postConstruct", 1);

var _TabbedLayout2 = _TabbedLayout; // community-modules/core/src/misc/resizeObserverService.ts

var DEBOUNCE_DELAY = 50;

var _ResizeObserverService =
/*#__PURE__*/
function (_BeanStub59) {
  "use strict";

  _inherits(_ResizeObserverService, _BeanStub59);

  function _ResizeObserverService() {
    var _this451;

    _classCallCheck(this, _ResizeObserverService);

    _this451 = _possibleConstructorReturn(this, _getPrototypeOf(_ResizeObserverService).apply(this, arguments));
    _this451.polyfillFunctions = [];
    return _this451;
  }

  _createClass(_ResizeObserverService, [{
    key: "observeResize",
    value: function observeResize(element, callback) {
      var _this452 = this;

      var win = this.gos.getWindow();

      var useBrowserResizeObserver = function useBrowserResizeObserver() {
        var resizeObserver = new win.ResizeObserver(callback);
        resizeObserver.observe(element);
        return function () {
          return resizeObserver.disconnect();
        };
      };

      var usePolyfill = function usePolyfill() {
        var _a, _b;

        var widthLastTime = (_a = element == null ? void 0 : element.clientWidth) != null ? _a : 0;
        var heightLastTime = (_b = element == null ? void 0 : element.clientHeight) != null ? _b : 0;
        var running = true;

        var periodicallyCheckWidthAndHeight = function periodicallyCheckWidthAndHeight() {
          var _a2, _b2;

          if (running) {
            var newWidth = (_a2 = element == null ? void 0 : element.clientWidth) != null ? _a2 : 0;
            var newHeight = (_b2 = element == null ? void 0 : element.clientHeight) != null ? _b2 : 0;
            var changed = newWidth !== widthLastTime || newHeight !== heightLastTime;

            if (changed) {
              widthLastTime = newWidth;
              heightLastTime = newHeight;
              callback();
            }

            _this452.doNextPolyfillTurn(periodicallyCheckWidthAndHeight);
          }
        };

        periodicallyCheckWidthAndHeight();
        return function () {
          return running = false;
        };
      };

      var suppressResize = this.gos.get("suppressBrowserResizeObserver");
      var resizeObserverExists = !!win.ResizeObserver;

      if (resizeObserverExists && !suppressResize) {
        return useBrowserResizeObserver();
      }

      return this.getFrameworkOverrides().wrapIncoming(function () {
        return usePolyfill();
      }, "resize-observer");
    }
  }, {
    key: "doNextPolyfillTurn",
    value: function doNextPolyfillTurn(func) {
      this.polyfillFunctions.push(func);
      this.schedulePolyfill();
    }
  }, {
    key: "schedulePolyfill",
    value: function schedulePolyfill() {
      var _this453 = this;

      if (this.polyfillScheduled) {
        return;
      }

      var executeAllFuncs = function executeAllFuncs() {
        var funcs = _this453.polyfillFunctions;
        _this453.polyfillScheduled = false;
        _this453.polyfillFunctions = [];
        funcs.forEach(function (f) {
          return f();
        });
      };

      this.polyfillScheduled = true;
      window.setTimeout(executeAllFuncs, DEBOUNCE_DELAY);
    }
  }]);

  return _ResizeObserverService;
}(_BeanStub2);

_ResizeObserverService = __decorateClass([_Bean("resizeObserverService")], _ResizeObserverService); // community-modules/core/src/misc/animationFrameService.ts

var _AnimationFrameService =
/*#__PURE__*/
function (_BeanStub60) {
  "use strict";

  _inherits(_AnimationFrameService, _BeanStub60);

  function _AnimationFrameService() {
    var _this454;

    _classCallCheck(this, _AnimationFrameService);

    _this454 = _possibleConstructorReturn(this, _getPrototypeOf(_AnimationFrameService).apply(this, arguments)); // p1 and p2 are create tasks are to do with row and cell creation.
    // for them we want to execute according to row order, so we use
    // TaskItem so we know what index the item is for.

    _this454.createTasksP1 = {
      list: [],
      sorted: false
    }; // eg drawing back-ground of rows

    _this454.createTasksP2 = {
      list: [],
      sorted: false
    }; // eg cell renderers, adding hover functionality
    // destroy tasks are to do with row removal. they are done after row creation as the user will need to see new
    // rows first (as blank is scrolled into view), when we remove the old rows (no longer in view) is not as
    // important.

    _this454.destroyTasks = [];
    _this454.ticking = false; // we need to know direction of scroll, to build up rows in the direction of
    // the scroll. eg if user scrolls down, we extend the rows by building down.

    _this454.scrollGoingDown = true;
    _this454.lastPage = 0;
    _this454.lastScrollTop = 0;
    _this454.taskCount = 0;
    _this454.cancelledTasks =
    /* @__PURE__ */
    new Set();
    return _this454;
  }

  _createClass(_AnimationFrameService, [{
    key: "setScrollTop",
    value: function setScrollTop(scrollTop) {
      var isPaginationActive = this.gos.get("pagination");
      this.scrollGoingDown = scrollTop >= this.lastScrollTop;

      if (isPaginationActive && scrollTop === 0) {
        var currentPage = this.paginationProxy.getCurrentPage();

        if (currentPage !== this.lastPage) {
          this.lastPage = currentPage;
          this.scrollGoingDown = true;
        }
      }

      this.lastScrollTop = scrollTop;
    }
  }, {
    key: "init",
    value: function init() {
      this.useAnimationFrame = !this.gos.get("suppressAnimationFrame");
    }
  }, {
    key: "isOn",
    value: function isOn() {
      return this.useAnimationFrame;
    } // this method is for our AG Grid sanity only - if animation frames are turned off,
    // then no place in the code should be looking to add any work to be done in animation
    // frames. this stops bugs - where some code is asking for a frame to be executed
    // when it should not.

  }, {
    key: "verifyAnimationFrameOn",
    value: function verifyAnimationFrameOn(methodName) {
      if (this.useAnimationFrame === false) {
        console.warn("AG Grid: AnimationFrameService.".concat(methodName, " called but animation frames are off"));
      }
    }
  }, {
    key: "createTask",
    value: function createTask(task, index, list) {
      this.verifyAnimationFrameOn(list);
      var taskItem = {
        task: task,
        index: index,
        createOrder: ++this.taskCount
      };
      this.addTaskToList(this[list], taskItem);
      this.schedule();
    }
  }, {
    key: "cancelTask",
    value: function cancelTask(task) {
      this.cancelledTasks.add(task);
    }
  }, {
    key: "addTaskToList",
    value: function addTaskToList(taskList, task) {
      taskList.list.push(task);
      taskList.sorted = false;
    }
  }, {
    key: "sortTaskList",
    value: function sortTaskList(taskList) {
      if (taskList.sorted) {
        return;
      }

      var sortDirection = this.scrollGoingDown ? 1 : -1;
      taskList.list.sort(function (a, b) {
        return a.index !== b.index ? sortDirection * (b.index - a.index) : b.createOrder - a.createOrder;
      });
      taskList.sorted = true;
    }
  }, {
    key: "addDestroyTask",
    value: function addDestroyTask(task) {
      this.verifyAnimationFrameOn("createTasksP3");
      this.destroyTasks.push(task);
      this.schedule();
    }
  }, {
    key: "executeFrame",
    value: function executeFrame(millis) {
      this.verifyAnimationFrameOn("executeFrame");
      var p1TaskList = this.createTasksP1;
      var p1Tasks = p1TaskList.list;
      var p2TaskList = this.createTasksP2;
      var p2Tasks = p2TaskList.list;
      var destroyTasks = this.destroyTasks;
      var frameStart =
      /* @__PURE__ */
      new Date().getTime();
      var duration =
      /* @__PURE__ */
      new Date().getTime() - frameStart;
      var noMaxMillis = millis <= 0;
      var gridBodyCon = this.ctrlsService.getGridBodyCtrl();

      while (noMaxMillis || duration < millis) {
        var gridBodyDidSomething = gridBodyCon.getScrollFeature().scrollGridIfNeeded();

        if (!gridBodyDidSomething) {
          var task = void 0;

          if (p1Tasks.length) {
            this.sortTaskList(p1TaskList);
            task = p1Tasks.pop().task;
          } else if (p2Tasks.length) {
            this.sortTaskList(p2TaskList);
            task = p2Tasks.pop().task;
          } else if (destroyTasks.length) {
            task = destroyTasks.pop();
          } else {
            this.cancelledTasks.clear();
            break;
          }

          if (!this.cancelledTasks.has(task)) {
            task();
          }
        }

        duration =
        /* @__PURE__ */
        new Date().getTime() - frameStart;
      }

      if (p1Tasks.length || p2Tasks.length || destroyTasks.length) {
        this.requestFrame();
      } else {
        this.stopTicking();
      }
    }
  }, {
    key: "stopTicking",
    value: function stopTicking() {
      this.ticking = false;
    }
  }, {
    key: "flushAllFrames",
    value: function flushAllFrames() {
      if (!this.useAnimationFrame) {
        return;
      }

      this.executeFrame(-1);
    }
  }, {
    key: "schedule",
    value: function schedule() {
      if (!this.useAnimationFrame) {
        return;
      }

      if (!this.ticking) {
        this.ticking = true;
        this.requestFrame();
      }
    }
  }, {
    key: "requestFrame",
    value: function requestFrame() {
      var callback = this.executeFrame.bind(this, 60);
      this.requestAnimationFrame(callback);
    }
  }, {
    key: "requestAnimationFrame",
    value: function requestAnimationFrame(callback) {
      var win = this.gos.getWindow();

      if (win.requestAnimationFrame) {
        win.requestAnimationFrame(callback);
      } else if (win.webkitRequestAnimationFrame) {
        win.webkitRequestAnimationFrame(callback);
      } else {
        win.setTimeout(callback, 0);
      }
    }
  }, {
    key: "isQueueEmpty",
    value: function isQueueEmpty() {
      return !this.ticking;
    } // a debounce utility used for parts of the app involved with rendering.
    // the advantage over normal debounce is the client can call flushAllFrames()
    // to make sure all rendering is complete. we don't wait any milliseconds,
    // as this is intended to batch calls in one VM turn.

  }, {
    key: "debounce",
    value: function debounce(func) {
      var _this455 = this;

      var pending = false;
      return function () {
        if (!_this455.isOn()) {
          window.setTimeout(func, 0);
          return;
        }

        if (pending) {
          return;
        }

        pending = true;

        _this455.addDestroyTask(function () {
          pending = false;
          func();
        });
      };
    }
  }]);

  return _AnimationFrameService;
}(_BeanStub2);

__decorateClass([_Autowired("ctrlsService")], _AnimationFrameService.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("paginationProxy")], _AnimationFrameService.prototype, "paginationProxy", 2);

__decorateClass([_PostConstruct], _AnimationFrameService.prototype, "init", 1);

_AnimationFrameService = __decorateClass([_Bean("animationFrameService")], _AnimationFrameService); // community-modules/core/src/interfaces/iClientSideRowModel.ts

var _ClientSideRowModelSteps =
/* @__PURE__ */
function (ClientSideRowModelSteps2) {
  ClientSideRowModelSteps2["EVERYTHING"] = "group";
  ClientSideRowModelSteps2["FILTER"] = "filter";
  ClientSideRowModelSteps2["SORT"] = "sort";
  ClientSideRowModelSteps2["MAP"] = "map";
  ClientSideRowModelSteps2["AGGREGATE"] = "aggregate";
  ClientSideRowModelSteps2["FILTER_AGGREGATES"] = "filter_aggregates";
  ClientSideRowModelSteps2["PIVOT"] = "pivot";
  ClientSideRowModelSteps2["NOTHING"] = "nothing";
  return ClientSideRowModelSteps2;
}(_ClientSideRowModelSteps || {}); // community-modules/core/src/misc/expansionService.ts


var _ExpansionService =
/*#__PURE__*/
function (_BeanStub61) {
  "use strict";

  _inherits(_ExpansionService, _BeanStub61);

  function _ExpansionService() {
    _classCallCheck(this, _ExpansionService);

    return _possibleConstructorReturn(this, _getPrototypeOf(_ExpansionService).apply(this, arguments));
  }

  _createClass(_ExpansionService, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.isClientSideRowModel = this.rowModel.getType() === "clientSide";
    }
  }, {
    key: "expandRows",
    value: function expandRows(rowIds) {
      if (!this.isClientSideRowModel) {
        return;
      }

      var rowIdSet = new Set(rowIds);
      this.rowModel.forEachNode(function (node) {
        if (node.id && rowIdSet.has(node.id)) {
          node.expanded = true;
        }
      });
      this.onGroupExpandedOrCollapsed();
    }
  }, {
    key: "getExpandedRows",
    value: function getExpandedRows() {
      var expandedRows = [];
      this.rowModel.forEachNode(function (_ref46) {
        var expanded = _ref46.expanded,
            id = _ref46.id;

        if (expanded && id) {
          expandedRows.push(id);
        }
      });
      return expandedRows;
    }
  }, {
    key: "expandAll",
    value: function expandAll(value) {
      if (!this.isClientSideRowModel) {
        return;
      }

      this.rowModel.expandOrCollapseAll(value);
    }
  }, {
    key: "setRowNodeExpanded",
    value: function setRowNodeExpanded(rowNode, expanded, expandParents, forceSync) {
      if (rowNode) {
        if (expandParents && rowNode.parent && rowNode.parent.level !== -1) {
          this.setRowNodeExpanded(rowNode.parent, expanded, expandParents, forceSync);
        }

        rowNode.setExpanded(expanded, void 0, forceSync);
      }
    }
  }, {
    key: "onGroupExpandedOrCollapsed",
    value: function onGroupExpandedOrCollapsed() {
      if (!this.isClientSideRowModel) {
        return;
      }

      this.rowModel.refreshModel({
        step: "map"
        /* MAP */

      });
    }
  }]);

  return _ExpansionService;
}(_BeanStub2);

__decorateClass([_Autowired("rowModel")], _ExpansionService.prototype, "rowModel", 2);

__decorateClass([_PostConstruct], _ExpansionService.prototype, "postConstruct", 1);

_ExpansionService = __decorateClass([_Bean("expansionService")], _ExpansionService); // community-modules/core/src/misc/menuService.ts

var _MenuService =
/*#__PURE__*/
function (_BeanStub62) {
  "use strict";

  _inherits(_MenuService, _BeanStub62);

  function _MenuService() {
    _classCallCheck(this, _MenuService);

    return _possibleConstructorReturn(this, _getPrototypeOf(_MenuService).apply(this, arguments));
  }

  _createClass(_MenuService, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _a;

      this.activeMenuFactory = (_a = this.enterpriseMenuFactory) != null ? _a : this.filterMenuFactory;
    }
  }, {
    key: "showColumnMenu",
    value: function showColumnMenu(params) {
      this.showColumnMenuCommon(this.activeMenuFactory, params, "columnMenu");
    }
  }, {
    key: "showFilterMenu",
    value: function showFilterMenu(params) {
      var menuFactory = this.enterpriseMenuFactory && this.isLegacyMenuEnabled() ? this.enterpriseMenuFactory : this.filterMenuFactory;
      this.showColumnMenuCommon(menuFactory, params, params.containerType, true);
    }
  }, {
    key: "showHeaderContextMenu",
    value: function showHeaderContextMenu(column, mouseEvent, touchEvent) {
      this.activeMenuFactory.showMenuAfterContextMenuEvent(column, mouseEvent, touchEvent);
    }
  }, {
    key: "getContextMenuPosition",
    value: function getContextMenuPosition(rowNode, column) {
      var rowCtrl = this.getRowCtrl(rowNode);
      var eGui = this.getCellGui(rowCtrl, column);

      if (!eGui) {
        if (rowCtrl) {
          return {
            x: 0,
            y: rowCtrl.getRowYPosition()
          };
        }

        return {
          x: 0,
          y: 0
        };
      }

      var rect = eGui.getBoundingClientRect();
      return {
        x: rect.x + rect.width / 2,
        y: rect.y + rect.height / 2
      };
    }
  }, {
    key: "showContextMenu",
    value: function showContextMenu(params) {
      var _a, _b, _c;

      var column = params.column,
          rowNode = params.rowNode;
      var anchorToElement = params.anchorToElement,
          value = params.value;

      if (rowNode && column && value == null) {
        value = rowNode.getValueFromValueService(column);
      }

      if (anchorToElement == null) {
        anchorToElement = this.getContextMenuAnchorElement(rowNode, column);
      }

      (_c = this.contextMenuFactory) == null ? void 0 : _c.onContextMenu((_a = params.mouseEvent) != null ? _a : null, (_b = params.touchEvent) != null ? _b : null, rowNode != null ? rowNode : null, column != null ? column : null, value, anchorToElement);
    }
  }, {
    key: "showColumnChooser",
    value: function showColumnChooser(params) {
      var _a;

      (_a = this.columnChooserFactory) == null ? void 0 : _a.showColumnChooser(params);
    }
  }, {
    key: "hidePopupMenu",
    value: function hidePopupMenu() {
      var _a;

      (_a = this.contextMenuFactory) == null ? void 0 : _a.hideActiveMenu();
      this.activeMenuFactory.hideActiveMenu();
    }
  }, {
    key: "hideColumnChooser",
    value: function hideColumnChooser() {
      var _a;

      (_a = this.columnChooserFactory) == null ? void 0 : _a.hideActiveColumnChooser();
    }
  }, {
    key: "isColumnMenuInHeaderEnabled",
    value: function isColumnMenuInHeaderEnabled(column) {
      var _column$getColDef = column.getColDef(),
          suppressMenu = _column$getColDef.suppressMenu,
          suppressHeaderMenuButton = _column$getColDef.suppressHeaderMenuButton;

      var isSuppressMenuButton = suppressHeaderMenuButton != null ? suppressHeaderMenuButton : suppressMenu;
      return !isSuppressMenuButton && this.activeMenuFactory.isMenuEnabled(column) && (this.isLegacyMenuEnabled() || !!this.enterpriseMenuFactory);
    }
  }, {
    key: "isFilterMenuInHeaderEnabled",
    value: function isFilterMenuInHeaderEnabled(column) {
      return !column.getColDef().suppressHeaderFilterButton && this.filterManager.isFilterAllowed(column);
    }
  }, {
    key: "isHeaderContextMenuEnabled",
    value: function isHeaderContextMenuEnabled(column) {
      return !(column == null ? void 0 : column.getColDef().suppressHeaderContextMenu) && this.getColumnMenuType() === "new";
    }
  }, {
    key: "isHeaderMenuButtonAlwaysShowEnabled",
    value: function isHeaderMenuButtonAlwaysShowEnabled() {
      return this.isSuppressMenuHide();
    }
  }, {
    key: "isHeaderMenuButtonEnabled",
    value: function isHeaderMenuButtonEnabled() {
      var menuHides = !this.isSuppressMenuHide();
      var onIpadAndMenuHides = _isIOSUserAgent() && menuHides;
      return !onIpadAndMenuHides;
    }
  }, {
    key: "isHeaderFilterButtonEnabled",
    value: function isHeaderFilterButtonEnabled(column) {
      return this.isFilterMenuInHeaderEnabled(column) && !this.isLegacyMenuEnabled() && !this.isFloatingFilterButtonDisplayed(column);
    }
  }, {
    key: "isFilterMenuItemEnabled",
    value: function isFilterMenuItemEnabled(column) {
      return this.filterManager.isFilterAllowed(column) && !this.isLegacyMenuEnabled() && !this.isFilterMenuInHeaderEnabled(column) && !this.isFloatingFilterButtonDisplayed(column);
    }
  }, {
    key: "isColumnMenuAnchoringEnabled",
    value: function isColumnMenuAnchoringEnabled() {
      return !this.isLegacyMenuEnabled();
    }
  }, {
    key: "areAdditionalColumnMenuItemsEnabled",
    value: function areAdditionalColumnMenuItemsEnabled() {
      return this.getColumnMenuType() === "new";
    }
  }, {
    key: "isLegacyMenuEnabled",
    value: function isLegacyMenuEnabled() {
      return this.getColumnMenuType() === "legacy";
    }
  }, {
    key: "isFloatingFilterButtonEnabled",
    value: function isFloatingFilterButtonEnabled(column) {
      var _a;

      var colDef = column.getColDef();
      var legacySuppressFilterButton = (_a = colDef.floatingFilterComponentParams) == null ? void 0 : _a.suppressFilterButton;

      if (legacySuppressFilterButton != null) {
        _warnOnce("As of v31.1, 'colDef.floatingFilterComponentParams.suppressFilterButton' is deprecated. Use 'colDef.suppressFloatingFilterButton' instead.");
      }

      return colDef.suppressFloatingFilterButton == null ? !legacySuppressFilterButton : !colDef.suppressFloatingFilterButton;
    }
  }, {
    key: "getColumnMenuType",
    value: function getColumnMenuType() {
      var _a;

      return (_a = this.gos.get("columnMenu")) != null ? _a : "legacy";
    }
  }, {
    key: "isFloatingFilterButtonDisplayed",
    value: function isFloatingFilterButtonDisplayed(column) {
      return !!column.getColDef().floatingFilter && this.isFloatingFilterButtonEnabled(column);
    }
  }, {
    key: "isSuppressMenuHide",
    value: function isSuppressMenuHide() {
      var suppressMenuHide = this.gos.get("suppressMenuHide");

      if (this.isLegacyMenuEnabled()) {
        return suppressMenuHide;
      } else {
        return this.gos.exists("suppressMenuHide") ? suppressMenuHide : true;
      }
    }
  }, {
    key: "showColumnMenuCommon",
    value: function showColumnMenuCommon(menuFactory, params, containerType, filtersOnly) {
      var _this456 = this;

      var column = params.column,
          positionBy = params.positionBy;

      if (positionBy === "button") {
        var buttonElement = params.buttonElement;
        menuFactory.showMenuAfterButtonClick(column, buttonElement, containerType, filtersOnly);
      } else if (positionBy === "mouse") {
        var mouseEvent = params.mouseEvent;
        menuFactory.showMenuAfterMouseEvent(column, mouseEvent, containerType, filtersOnly);
      } else if (column) {
        this.ctrlsService.getGridBodyCtrl().getScrollFeature().ensureColumnVisible(column, "auto");
        this.animationFrameService.requestAnimationFrame(function () {
          var headerCellCtrl = _this456.ctrlsService.getHeaderRowContainerCtrl(column.getPinned()).getHeaderCtrlForColumn(column);

          menuFactory.showMenuAfterButtonClick(column, headerCellCtrl.getAnchorElementForMenu(filtersOnly), containerType, true);
        });
      }
    }
  }, {
    key: "getRowCtrl",
    value: function getRowCtrl(rowNode) {
      var _ref47 = rowNode || {},
          rowIndex = _ref47.rowIndex,
          rowPinned = _ref47.rowPinned;

      if (rowIndex == null) {
        return;
      }

      return this.rowRenderer.getRowByPosition({
        rowIndex: rowIndex,
        rowPinned: rowPinned
      }) || void 0;
    }
  }, {
    key: "getCellGui",
    value: function getCellGui(rowCtrl, column) {
      if (!rowCtrl || !column) {
        return;
      }

      var cellCtrl = rowCtrl.getCellCtrl(column);
      return (cellCtrl == null ? void 0 : cellCtrl.getGui()) || void 0;
    }
  }, {
    key: "getContextMenuAnchorElement",
    value: function getContextMenuAnchorElement(rowNode, column) {
      var gridBodyEl = this.ctrlsService.getGridBodyCtrl().getGridBodyElement();
      var rowCtrl = this.getRowCtrl(rowNode);

      if (!rowCtrl) {
        return gridBodyEl;
      }

      var cellGui = this.getCellGui(rowCtrl, column);

      if (cellGui) {
        return cellGui;
      }

      if (rowCtrl.isFullWidth()) {
        return rowCtrl.getFullWidthElement();
      }

      return gridBodyEl;
    }
  }]);

  return _MenuService;
}(_BeanStub2);

__decorateClass([_Autowired("filterMenuFactory")], _MenuService.prototype, "filterMenuFactory", 2);

__decorateClass([_Autowired("ctrlsService")], _MenuService.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("animationFrameService")], _MenuService.prototype, "animationFrameService", 2);

__decorateClass([_Autowired("filterManager")], _MenuService.prototype, "filterManager", 2);

__decorateClass([_Autowired("rowRenderer")], _MenuService.prototype, "rowRenderer", 2);

__decorateClass([_Optional("columnChooserFactory")], _MenuService.prototype, "columnChooserFactory", 2);

__decorateClass([_Optional("contextMenuFactory")], _MenuService.prototype, "contextMenuFactory", 2);

__decorateClass([_Optional("enterpriseMenuFactory")], _MenuService.prototype, "enterpriseMenuFactory", 2);

__decorateClass([_PostConstruct], _MenuService.prototype, "postConstruct", 1);

_MenuService = __decorateClass([_Bean("menuService")], _MenuService); // community-modules/core/src/rendering/autoWidthCalculator.ts

var _AutoWidthCalculator =
/*#__PURE__*/
function (_BeanStub63) {
  "use strict";

  _inherits(_AutoWidthCalculator, _BeanStub63);

  function _AutoWidthCalculator() {
    _classCallCheck(this, _AutoWidthCalculator);

    return _possibleConstructorReturn(this, _getPrototypeOf(_AutoWidthCalculator).apply(this, arguments));
  }

  _createClass(_AutoWidthCalculator, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this457 = this;

      this.ctrlsService.whenReady(function (p) {
        _this457.centerRowContainerCtrl = p.center;
      });
    } // this is the trick: we create a dummy container and clone all the cells
    // into the dummy, then check the dummy's width. then destroy the dummy
    // as we don't need it any more.
    // drawback: only the cells visible on the screen are considered

  }, {
    key: "getPreferredWidthForColumn",
    value: function getPreferredWidthForColumn(column, skipHeader) {
      var eHeaderCell = this.getHeaderCellForColumn(column);

      if (!eHeaderCell) {
        return -1;
      }

      var elements = this.rowRenderer.getAllCellsForColumn(column);

      if (!skipHeader) {
        elements.push(eHeaderCell);
      }

      return this.addElementsToContainerAndGetWidth(elements);
    }
  }, {
    key: "getPreferredWidthForColumnGroup",
    value: function getPreferredWidthForColumnGroup(columnGroup) {
      var eHeaderCell = this.getHeaderCellForColumn(columnGroup);

      if (!eHeaderCell) {
        return -1;
      }

      return this.addElementsToContainerAndGetWidth([eHeaderCell]);
    }
  }, {
    key: "addElementsToContainerAndGetWidth",
    value: function addElementsToContainerAndGetWidth(elements) {
      var _this458 = this;

      var eDummyContainer = document.createElement("form");
      eDummyContainer.style.position = "fixed";
      var eBodyContainer = this.centerRowContainerCtrl.getContainerElement();
      elements.forEach(function (el) {
        return _this458.cloneItemIntoDummy(el, eDummyContainer);
      });
      eBodyContainer.appendChild(eDummyContainer);
      var dummyContainerWidth = eDummyContainer.offsetWidth;
      eBodyContainer.removeChild(eDummyContainer);
      var autoSizePadding = this.getAutoSizePadding();
      return dummyContainerWidth + autoSizePadding;
    }
  }, {
    key: "getAutoSizePadding",
    value: function getAutoSizePadding() {
      return this.gos.get("autoSizePadding");
    }
  }, {
    key: "getHeaderCellForColumn",
    value: function getHeaderCellForColumn(column) {
      var element = null;
      this.ctrlsService.getHeaderRowContainerCtrls().forEach(function (container) {
        var res = container.getHtmlElementForColumnHeader(column);

        if (res != null) {
          element = res;
        }
      });
      return element;
    }
  }, {
    key: "cloneItemIntoDummy",
    value: function cloneItemIntoDummy(eCell, eDummyContainer) {
      var eCellClone = eCell.cloneNode(true);
      eCellClone.style.width = "";
      eCellClone.style.position = "static";
      eCellClone.style.left = "";
      var eCloneParent = document.createElement("div");
      var eCloneParentClassList = eCloneParent.classList;
      var isHeader = ["ag-header-cell", "ag-header-group-cell"].some(function (cls) {
        return eCellClone.classList.contains(cls);
      });

      if (isHeader) {
        eCloneParentClassList.add("ag-header", "ag-header-row");
        eCloneParent.style.position = "static";
      } else {
        eCloneParentClassList.add("ag-row");
      }

      var pointer = eCell.parentElement;

      while (pointer) {
        var isRow = ["ag-header-row", "ag-row"].some(function (cls) {
          return pointer.classList.contains(cls);
        });

        if (isRow) {
          for (var i = 0; i < pointer.classList.length; i++) {
            var item = pointer.classList[i];

            if (item != "ag-row-position-absolute") {
              eCloneParentClassList.add(item);
            }
          }

          break;
        }

        pointer = pointer.parentElement;
      }

      eCloneParent.appendChild(eCellClone);
      eDummyContainer.appendChild(eCloneParent);
    }
  }]);

  return _AutoWidthCalculator;
}(_BeanStub2);

__decorateClass([_Autowired("rowRenderer")], _AutoWidthCalculator.prototype, "rowRenderer", 2);

__decorateClass([_Autowired("ctrlsService")], _AutoWidthCalculator.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("rowCssClassCalculator")], _AutoWidthCalculator.prototype, "rowCssClassCalculator", 2);

__decorateClass([_PostConstruct], _AutoWidthCalculator.prototype, "postConstruct", 1);

_AutoWidthCalculator = __decorateClass([_Bean("autoWidthCalculator")], _AutoWidthCalculator); // community-modules/core/src/rendering/features/stickyRowFeature.ts

var StickyRowFeature =
/*#__PURE__*/
function (_BeanStub64) {
  "use strict";

  _inherits(StickyRowFeature, _BeanStub64);

  function StickyRowFeature(createRowCon, destroyRowCtrls) {
    var _this459;

    _classCallCheck(this, StickyRowFeature);

    _this459 = _possibleConstructorReturn(this, _getPrototypeOf(StickyRowFeature).call(this));
    _this459.createRowCon = createRowCon;
    _this459.destroyRowCtrls = destroyRowCtrls;
    _this459.stickyTopRowCtrls = [];
    _this459.stickyBottomRowCtrls = [];
    _this459.topContainerHeight = 0;
    _this459.bottomContainerHeight = 0;
    return _this459;
  }

  _createClass(StickyRowFeature, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this460 = this;

      this.isClientSide = this.rowModel.getType() === "clientSide";
      this.ctrlsService.whenReady(function (params) {
        _this460.gridBodyCtrl = params.gridBodyCtrl;
      });
    }
  }, {
    key: "getStickyTopRowCtrls",
    value: function getStickyTopRowCtrls() {
      return this.stickyTopRowCtrls;
    }
  }, {
    key: "getStickyBottomRowCtrls",
    value: function getStickyBottomRowCtrls() {
      return this.stickyBottomRowCtrls;
    }
    /**
     * Get the last pixel of the group, this pixel is used to push the sticky node up out of the viewport.
     */

  }, {
    key: "getLastPixelOfGroup",
    value: function getLastPixelOfGroup(row) {
      return this.isClientSide ? this.getClientSideLastPixelOfGroup(row) : this.getServerSideLastPixelOfGroup(row);
    }
    /**
     * Get the first pixel of the group, this pixel is used to push the sticky node down out of the viewport
     */

  }, {
    key: "getFirstPixelOfGroup",
    value: function getFirstPixelOfGroup(row) {
      if (row.footer) {
        return row.sibling.rowTop + row.sibling.rowHeight - 1;
      }

      if (row.group) {
        return row.rowTop - 1;
      }

      return 0;
    }
  }, {
    key: "getServerSideLastPixelOfGroup",
    value: function getServerSideLastPixelOfGroup(row) {
      var _a, _b, _c, _d;

      if (this.isClientSide) {
        throw new Error("This func should only be called in server side row model.");
      }

      if (row.isExpandable() || row.footer) {
        if (row.master) {
          return row.detailNode.rowTop + row.detailNode.rowHeight;
        }

        var noOrContiguousSiblings = !row.sibling || Math.abs(row.sibling.rowIndex - row.rowIndex) === 1;

        if (noOrContiguousSiblings) {
          var storeBounds = (_a = row.childStore) == null ? void 0 : _a.getStoreBounds();

          if (row.footer) {
            storeBounds = (_b = row.sibling.childStore) == null ? void 0 : _b.getStoreBounds();
          }

          return ((_c = storeBounds == null ? void 0 : storeBounds.heightPx) != null ? _c : 0) + ((_d = storeBounds == null ? void 0 : storeBounds.topPx) != null ? _d : 0);
        }

        if (row.footer) {
          return row.rowTop + row.rowHeight;
        }

        return row.sibling.rowTop + row.sibling.rowHeight;
      }

      return Number.MAX_SAFE_INTEGER;
    }
  }, {
    key: "getClientSideLastPixelOfGroup",
    value: function getClientSideLastPixelOfGroup(row) {
      if (!this.isClientSide) {
        throw new Error("This func should only be called in client side row model.");
      }

      if (row.isExpandable() || row.footer) {
        var grandTotalAtTop = row.footer && row.rowIndex === 0;
        var noOrContiguousSiblings = !row.sibling || Math.abs(row.sibling.rowIndex - row.rowIndex) === 1;

        if (grandTotalAtTop || noOrContiguousSiblings) {
          var lastAncestor = row.footer ? row.sibling : row;

          while (lastAncestor.isExpandable() && lastAncestor.expanded) {
            if (lastAncestor.master) {
              lastAncestor = lastAncestor.detailNode;
            } else if (lastAncestor.childrenAfterSort) {
              if (lastAncestor.childrenAfterSort.length === 0) {
                break;
              }

              lastAncestor = _last(lastAncestor.childrenAfterSort);
            }
          }

          return lastAncestor.rowTop + lastAncestor.rowHeight;
        }

        if (row.footer) {
          return row.rowTop + row.rowHeight;
        }

        return row.sibling.rowTop + row.sibling.rowHeight;
      }

      return Number.MAX_SAFE_INTEGER;
    }
  }, {
    key: "updateStickyRows",
    value: function updateStickyRows(container) {
      var _this461 = this;

      var isTop = container === "top";
      var newStickyContainerHeight = 0;

      if (!this.canRowsBeSticky()) {
        return this.refreshNodesAndContainerHeight(container,
        /* @__PURE__ */
        new Set(), newStickyContainerHeight);
      }

      var pixelAtContainerBoundary = isTop ? this.rowRenderer.getFirstVisibleVerticalPixel() : this.rowRenderer.getLastVisibleVerticalPixel();
      var newStickyRows =
      /* @__PURE__ */
      new Set();

      var addStickyRow = function addStickyRow(stickyRow) {
        newStickyRows.add(stickyRow);

        if (isTop) {
          var lastChildBottom = _this461.getLastPixelOfGroup(stickyRow);

          var stickRowBottom = pixelAtContainerBoundary + newStickyContainerHeight + stickyRow.rowHeight;

          if (lastChildBottom < stickRowBottom) {
            stickyRow.stickyRowTop = newStickyContainerHeight + (lastChildBottom - stickRowBottom);
          } else {
            stickyRow.stickyRowTop = newStickyContainerHeight;
          }
        } else {
          var _lastChildBottom = _this461.getFirstPixelOfGroup(stickyRow);

          var stickRowTop = pixelAtContainerBoundary - (newStickyContainerHeight + stickyRow.rowHeight);

          if (_lastChildBottom > stickRowTop) {
            stickyRow.stickyRowTop = newStickyContainerHeight - (_lastChildBottom - stickRowTop);
          } else {
            stickyRow.stickyRowTop = newStickyContainerHeight;
          }
        }

        newStickyContainerHeight = 0;
        newStickyRows.forEach(function (rowNode) {
          var thisRowLastPx = rowNode.stickyRowTop + rowNode.rowHeight;

          if (newStickyContainerHeight < thisRowLastPx) {
            newStickyContainerHeight = thisRowLastPx;
          }
        });
      };

      var suppressFootersSticky = this.areFooterRowsStickySuppressed();
      var suppressGroupsSticky = this.gos.get("suppressGroupRowsSticky");

      var isRowSticky = function isRowSticky(row) {
        if (row.footer) {
          if (suppressFootersSticky === true) {
            return false;
          }

          if (suppressFootersSticky === "grand" && row.level === -1) {
            return false;
          }

          ;

          if (suppressFootersSticky === "group" && row.level > -1) {
            return false;
          }

          ;
          var alreadySticking = newStickyRows.has(row);
          return !alreadySticking && row.displayed;
        }

        if (row.isExpandable()) {
          if (suppressGroupsSticky === true) {
            return false;
          }

          ;

          var _alreadySticking = newStickyRows.has(row);

          return !_alreadySticking && row.displayed && row.expanded;
        }

        return false;
      };

      var _loop6 = function _loop6(i) {
        var firstPixelAfterStickyRows = pixelAtContainerBoundary + newStickyContainerHeight;

        if (!isTop) {
          firstPixelAfterStickyRows = pixelAtContainerBoundary - newStickyContainerHeight;
        }

        var firstIndex = _this461.rowModel.getRowIndexAtPixel(firstPixelAfterStickyRows);

        var firstRow = _this461.rowModel.getRow(firstIndex);

        if (firstRow == null) {
          return "break";
        }

        var ancestors = _this461.getStickyAncestors(firstRow);

        var firstMissingParent = ancestors.find(function (parent) {
          return (isTop ? parent.rowIndex < firstIndex : parent.rowIndex > firstIndex) && isRowSticky(parent);
        });

        if (firstMissingParent) {
          addStickyRow(firstMissingParent);
          return "continue";
        }

        var isFirstRowOutsideViewport = isTop ? firstRow.rowTop < firstPixelAfterStickyRows : firstRow.rowTop + firstRow.rowHeight > firstPixelAfterStickyRows;

        if (isFirstRowOutsideViewport && isRowSticky(firstRow)) {
          addStickyRow(firstRow);
          return "continue";
        }

        return "break";
      };

      _loop5: for (var i = 0; i < 100; i++) {
        var _ret2 = _loop6(i);

        switch (_ret2) {
          case "break":
            break _loop5;

          case "continue":
            continue;
        }
      }

      if (!isTop) {
        newStickyRows.forEach(function (rowNode) {
          rowNode.stickyRowTop = newStickyContainerHeight - (rowNode.stickyRowTop + rowNode.rowHeight);
        });
      }

      return this.refreshNodesAndContainerHeight(container, newStickyRows, newStickyContainerHeight);
    }
  }, {
    key: "areFooterRowsStickySuppressed",
    value: function areFooterRowsStickySuppressed() {
      var suppressFootersSticky = this.gos.get("suppressStickyTotalRow");

      if (suppressFootersSticky === true) {
        return true;
      }

      var suppressGroupRows = !!this.gos.get("groupIncludeFooter") || suppressFootersSticky === "group";
      var suppressGrandRows = !!this.gos.get("groupIncludeTotalFooter") || suppressFootersSticky === "grand";

      if (suppressGroupRows && suppressGrandRows) {
        return true;
      }

      if (suppressGrandRows) {
        return "grand";
      }

      if (suppressGroupRows) {
        return "group";
      }

      return false;
    }
  }, {
    key: "canRowsBeSticky",
    value: function canRowsBeSticky() {
      var isStickyEnabled = this.gos.isGroupRowsSticky();
      var suppressFootersSticky = this.areFooterRowsStickySuppressed();
      var suppressGroupsSticky = this.gos.get("suppressGroupRowsSticky");
      return isStickyEnabled && (!suppressFootersSticky || !suppressGroupsSticky);
    }
  }, {
    key: "getStickyAncestors",
    value: function getStickyAncestors(rowNode) {
      var ancestors = [];
      var p = rowNode.footer ? rowNode.sibling : rowNode.parent;

      while (p) {
        if (p.sibling) {
          ancestors.push(p.sibling);
        }

        ancestors.push(p);
        p = p.parent;
      }

      return ancestors.reverse();
    }
  }, {
    key: "checkStickyRows",
    value: function checkStickyRows() {
      var hasTopUpdated = this.updateStickyRows("top");
      var hasBottomUpdated = this.updateStickyRows("bottom");
      return hasTopUpdated || hasBottomUpdated;
    }
  }, {
    key: "refreshStickyNode",
    value: function refreshStickyNode(stickRowNode) {
      var allStickyNodes =
      /* @__PURE__ */
      new Set();

      if (this.stickyTopRowCtrls.some(function (ctrl) {
        return ctrl.getRowNode() === stickRowNode;
      })) {
        for (var i = 0; i < this.stickyTopRowCtrls.length; i++) {
          var currentNode = this.stickyTopRowCtrls[i].getRowNode();

          if (currentNode !== stickRowNode) {
            allStickyNodes.add(currentNode);
          }
        }

        if (this.refreshNodesAndContainerHeight("top", allStickyNodes, this.topContainerHeight)) {
          this.checkStickyRows();
        }

        return;
      }

      for (var _i9 = 0; _i9 < this.stickyBottomRowCtrls.length; _i9++) {
        var _currentNode = this.stickyBottomRowCtrls[_i9].getRowNode();

        if (_currentNode !== stickRowNode) {
          allStickyNodes.add(_currentNode);
        }
      }

      if (this.refreshNodesAndContainerHeight("bottom", allStickyNodes, this.bottomContainerHeight)) {
        this.checkStickyRows();
      }
    }
    /**
     * Destroy old ctrls and create new ctrls where necessary.
     */

  }, {
    key: "refreshNodesAndContainerHeight",
    value: function refreshNodesAndContainerHeight(container, newStickyNodes, height) {
      var _this462 = this;

      var isTop = container === "top";
      var previousCtrls = isTop ? this.stickyTopRowCtrls : this.stickyBottomRowCtrls;
      var removedCtrlsMap = {};
      var remainingCtrls = [];

      for (var i = 0; i < previousCtrls.length; i++) {
        var node = previousCtrls[i].getRowNode();
        var hasBeenRemoved = !newStickyNodes.has(node);

        if (hasBeenRemoved) {
          removedCtrlsMap[node.id] = previousCtrls[i];
          node.sticky = false;
          continue;
        }

        remainingCtrls.push(previousCtrls[i]);
      }

      var existingNodes =
      /* @__PURE__ */
      new Set();

      for (var _i10 = 0; _i10 < remainingCtrls.length; _i10++) {
        existingNodes.add(remainingCtrls[_i10].getRowNode());
      }

      var newCtrls = [];
      newStickyNodes.forEach(function (node) {
        if (existingNodes.has(node)) {
          return;
        }

        node.sticky = true;
        newCtrls.push(_this462.createRowCon(node, false, false));
      });
      var hasSomethingChanged = !!newCtrls.length || remainingCtrls.length !== previousCtrls.length;

      if (isTop) {
        if (this.topContainerHeight !== height) {
          this.topContainerHeight = height;
          this.gridBodyCtrl.setStickyTopHeight(height);
          hasSomethingChanged = true;
        }
      } else {
        if (this.bottomContainerHeight !== height) {
          this.bottomContainerHeight = height;
          this.gridBodyCtrl.setStickyBottomHeight(height);
          hasSomethingChanged = true;
        }
      }

      this.destroyRowCtrls(removedCtrlsMap, false);
      var newCtrlsList = [].concat(remainingCtrls, newCtrls);
      newCtrlsList.sort(function (a, b) {
        return b.getRowNode().rowIndex - a.getRowNode().rowIndex;
      });

      if (!isTop) {
        newCtrlsList.reverse();
      }

      newCtrlsList.forEach(function (ctrl) {
        return ctrl.setRowTop(ctrl.getRowNode().stickyRowTop);
      });

      if (!hasSomethingChanged) {
        return false;
      }

      if (isTop) {
        this.stickyTopRowCtrls = newCtrlsList;
      } else {
        this.stickyBottomRowCtrls = newCtrlsList;
      }

      return true;
    }
  }]);

  return StickyRowFeature;
}(_BeanStub2);

__decorateClass([_Autowired("rowModel")], StickyRowFeature.prototype, "rowModel", 2);

__decorateClass([_Autowired("rowRenderer")], StickyRowFeature.prototype, "rowRenderer", 2);

__decorateClass([_Autowired("ctrlsService")], StickyRowFeature.prototype, "ctrlsService", 2);

__decorateClass([_PostConstruct], StickyRowFeature.prototype, "postConstruct", 1); // community-modules/core/src/rendering/rowRenderer.ts


var _RowRenderer =
/*#__PURE__*/
function (_BeanStub65) {
  "use strict";

  _inherits(_RowRenderer, _BeanStub65);

  function _RowRenderer() {
    var _this463;

    _classCallCheck(this, _RowRenderer);

    _this463 = _possibleConstructorReturn(this, _getPrototypeOf(_RowRenderer).apply(this, arguments));
    _this463.destroyFuncsForColumnListeners = []; // map of row ids to row objects. keeps track of which elements
    // are rendered for which rows in the dom.

    _this463.rowCtrlsByRowIndex = {};
    _this463.zombieRowCtrls = {};
    _this463.allRowCtrls = [];
    _this463.topRowCtrls = [];
    _this463.bottomRowCtrls = []; // we only allow one refresh at a time, otherwise the internal memory structure here
    // will get messed up. this can happen if the user has a cellRenderer, and inside the
    // renderer they call an API method that results in another pass of the refresh,
    // then it will be trying to draw rows in the middle of a refresh.

    _this463.refreshInProgress = false;
    _this463.dataFirstRenderedFired = false;

    _this463.setupRangeSelectionListeners = function () {
      var onRangeSelectionChanged = function onRangeSelectionChanged() {
        _this463.getAllCellCtrls().forEach(function (cellCtrl) {
          return cellCtrl.onRangeSelectionChanged();
        });
      };

      var onColumnMovedPinnedVisible = function onColumnMovedPinnedVisible() {
        _this463.getAllCellCtrls().forEach(function (cellCtrl) {
          return cellCtrl.updateRangeBordersIfRangeCount();
        });
      };

      var addRangeSelectionListeners = function addRangeSelectionListeners() {
        _this463.eventService.addEventListener(_Events.EVENT_RANGE_SELECTION_CHANGED, onRangeSelectionChanged);

        _this463.eventService.addEventListener(_Events.EVENT_COLUMN_MOVED, onColumnMovedPinnedVisible);

        _this463.eventService.addEventListener(_Events.EVENT_COLUMN_PINNED, onColumnMovedPinnedVisible);

        _this463.eventService.addEventListener(_Events.EVENT_COLUMN_VISIBLE, onColumnMovedPinnedVisible);
      };

      var removeRangeSelectionListeners = function removeRangeSelectionListeners() {
        _this463.eventService.removeEventListener(_Events.EVENT_RANGE_SELECTION_CHANGED, onRangeSelectionChanged);

        _this463.eventService.removeEventListener(_Events.EVENT_COLUMN_MOVED, onColumnMovedPinnedVisible);

        _this463.eventService.removeEventListener(_Events.EVENT_COLUMN_PINNED, onColumnMovedPinnedVisible);

        _this463.eventService.removeEventListener(_Events.EVENT_COLUMN_VISIBLE, onColumnMovedPinnedVisible);
      };

      _this463.addDestroyFunc(function () {
        return removeRangeSelectionListeners();
      });

      _this463.addManagedPropertyListener("enableRangeSelection", function (params) {
        var isEnabled = params.currentValue;

        if (isEnabled) {
          addRangeSelectionListeners();
        } else {
          removeRangeSelectionListeners();
        }
      });

      var rangeSelectionEnabled = _this463.gos.get("enableRangeSelection");

      if (rangeSelectionEnabled) {
        addRangeSelectionListeners();
      }
    };

    return _this463;
  }

  _createClass(_RowRenderer, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this464 = this;

      this.ctrlsService.whenReady(function (p) {
        _this464.gridBodyCtrl = p.gridBodyCtrl;

        _this464.initialise();
      });
    }
  }, {
    key: "initialise",
    value: function initialise() {
      var _this465 = this;

      this.addManagedListener(this.eventService, _Events.EVENT_PAGINATION_CHANGED, this.onPageLoaded.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_BODY_SCROLL, this.onBodyScroll.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_BODY_HEIGHT_CHANGED, this.redraw.bind(this));
      this.addManagedPropertyListeners(["domLayout", "embedFullWidthRows"], function () {
        return _this465.onDomLayoutChanged();
      });
      this.addManagedPropertyListeners(["suppressMaxRenderedRowRestriction", "rowBuffer"], function () {
        return _this465.redraw();
      });
      this.addManagedPropertyListeners(["suppressCellFocus", "getBusinessKeyForNode", "fullWidthCellRenderer", "fullWidthCellRendererParams", "rowStyle", "getRowStyle", "rowClass", "getRowClass", "rowClassRules", "suppressStickyTotalRow", "groupRowRenderer", "groupRowRendererParams", // maybe only needs to refresh FW rows...
      "loadingCellRenderer", "loadingCellRendererParams", "detailCellRenderer", "detailCellRendererParams", "enableRangeSelection", "enableCellTextSelection"], function () {
        return _this465.redrawRows();
      });

      if (this.gos.isGroupRowsSticky()) {
        var rowModelType = this.rowModel.getType();

        if (rowModelType === "clientSide" || rowModelType === "serverSide") {
          this.stickyRowFeature = this.createManagedBean(new StickyRowFeature(this.createRowCon.bind(this), this.destroyRowCtrls.bind(this)));
        }
      }

      this.registerCellEventListeners();
      this.initialiseCache();
      this.printLayout = this.gos.isDomLayout("print");
      this.embedFullWidthRows = this.printLayout || this.gos.get("embedFullWidthRows");
      this.redrawAfterModelUpdate();
    }
  }, {
    key: "initialiseCache",
    value: function initialiseCache() {
      if (this.gos.get("keepDetailRows")) {
        var countProp = this.getKeepDetailRowsCount();
        var count = countProp != null ? countProp : 3;
        this.cachedRowCtrls = new RowCtrlCache(count);
      }
    }
  }, {
    key: "getKeepDetailRowsCount",
    value: function getKeepDetailRowsCount() {
      return this.gos.get("keepDetailRowsCount");
    }
  }, {
    key: "getStickyTopRowCtrls",
    value: function getStickyTopRowCtrls() {
      if (!this.stickyRowFeature) {
        return [];
      }

      return this.stickyRowFeature.getStickyTopRowCtrls();
    }
  }, {
    key: "getStickyBottomRowCtrls",
    value: function getStickyBottomRowCtrls() {
      if (!this.stickyRowFeature) {
        return [];
      }

      return this.stickyRowFeature.getStickyBottomRowCtrls();
    }
  }, {
    key: "updateAllRowCtrls",
    value: function updateAllRowCtrls() {
      var liveList = _getAllValuesInObject(this.rowCtrlsByRowIndex);

      var zombieList = _getAllValuesInObject(this.zombieRowCtrls);

      var cachedList = this.cachedRowCtrls ? this.cachedRowCtrls.getEntries() : [];

      if (zombieList.length > 0 || cachedList.length > 0) {
        this.allRowCtrls = [].concat(_toConsumableArray(liveList), _toConsumableArray(zombieList), _toConsumableArray(cachedList));
      } else {
        this.allRowCtrls = liveList;
      }
    }
  }, {
    key: "onCellFocusChanged",
    value: function onCellFocusChanged(event) {
      this.getAllCellCtrls().forEach(function (cellCtrl) {
        return cellCtrl.onCellFocused(event);
      });
      this.getFullWidthRowCtrls().forEach(function (rowCtrl) {
        return rowCtrl.onFullWidthRowFocused(event);
      });
    } // in a clean design, each cell would register for each of these events. however when scrolling, all the cells
    // registering and de-registering for events is a performance bottleneck. so we register here once and inform
    // all active cells.

  }, {
    key: "registerCellEventListeners",
    value: function registerCellEventListeners() {
      var _this466 = this;

      this.addManagedListener(this.eventService, _Events.EVENT_CELL_FOCUSED, function (event) {
        _this466.onCellFocusChanged(event);
      });
      this.addManagedListener(this.eventService, _Events.EVENT_CELL_FOCUS_CLEARED, function () {
        _this466.onCellFocusChanged();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_FLASH_CELLS, function (event) {
        _this466.getAllCellCtrls().forEach(function (cellCtrl) {
          return cellCtrl.onFlashCells(event);
        });
      });
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_HOVER_CHANGED, function () {
        _this466.getAllCellCtrls().forEach(function (cellCtrl) {
          return cellCtrl.onColumnHover();
        });
      });
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_CHANGED, function () {
        _this466.getAllCellCtrls().forEach(function (cellCtrl) {
          return cellCtrl.onDisplayedColumnsChanged();
        });
      });
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, function () {
        if (_this466.printLayout) {
          _this466.getAllCellCtrls().forEach(function (cellCtrl) {
            return cellCtrl.onLeftChanged();
          });
        }
      });
      this.setupRangeSelectionListeners();
      this.refreshListenersToColumnsForCellComps();
      this.addManagedListener(this.eventService, _Events.EVENT_GRID_COLUMNS_CHANGED, this.refreshListenersToColumnsForCellComps.bind(this));
      this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
    } // executes all functions in destroyFuncsForColumnListeners and then clears the list

  }, {
    key: "removeGridColumnListeners",
    value: function removeGridColumnListeners() {
      this.destroyFuncsForColumnListeners.forEach(function (func) {
        return func();
      });
      this.destroyFuncsForColumnListeners.length = 0;
    } // this function adds listeners onto all the grid columns, which are the column that we could have cellComps for.
    // when the grid columns change, we add listeners again. in an ideal design, each CellComp would just register to
    // the column it belongs to on creation, however this was a bottleneck with the number of cells, so do it here
    // once instead.

  }, {
    key: "refreshListenersToColumnsForCellComps",
    value: function refreshListenersToColumnsForCellComps() {
      var _this467 = this;

      this.removeGridColumnListeners();
      var cols = this.columnModel.getAllGridColumns();
      cols.forEach(function (col) {
        var forEachCellWithThisCol = function forEachCellWithThisCol(callback) {
          _this467.getAllCellCtrls().forEach(function (cellCtrl) {
            if (cellCtrl.getColumn() === col) {
              callback(cellCtrl);
            }
          });
        };

        var leftChangedListener = function leftChangedListener() {
          forEachCellWithThisCol(function (cellCtrl) {
            return cellCtrl.onLeftChanged();
          });
        };

        var widthChangedListener = function widthChangedListener() {
          forEachCellWithThisCol(function (cellCtrl) {
            return cellCtrl.onWidthChanged();
          });
        };

        var firstRightPinnedChangedListener = function firstRightPinnedChangedListener() {
          forEachCellWithThisCol(function (cellCtrl) {
            return cellCtrl.onFirstRightPinnedChanged();
          });
        };

        var lastLeftPinnedChangedListener = function lastLeftPinnedChangedListener() {
          forEachCellWithThisCol(function (cellCtrl) {
            return cellCtrl.onLastLeftPinnedChanged();
          });
        };

        var colDefChangedListener = function colDefChangedListener() {
          forEachCellWithThisCol(function (cellCtrl) {
            return cellCtrl.onColDefChanged();
          });
        };

        col.addEventListener("leftChanged", leftChangedListener);
        col.addEventListener("widthChanged", widthChangedListener);
        col.addEventListener("firstRightPinnedChanged", firstRightPinnedChangedListener);
        col.addEventListener("lastLeftPinnedChanged", lastLeftPinnedChangedListener);
        col.addEventListener("colDefChanged", colDefChangedListener);

        _this467.destroyFuncsForColumnListeners.push(function () {
          col.removeEventListener("leftChanged", leftChangedListener);
          col.removeEventListener("widthChanged", widthChangedListener);
          col.removeEventListener("firstRightPinnedChanged", firstRightPinnedChangedListener);
          col.removeEventListener("lastLeftPinnedChanged", lastLeftPinnedChangedListener);
          col.removeEventListener("colDefChanged", colDefChangedListener);
        });
      });
    }
  }, {
    key: "onDomLayoutChanged",
    value: function onDomLayoutChanged() {
      var printLayout = this.gos.isDomLayout("print");
      var embedFullWidthRows = printLayout || this.gos.get("embedFullWidthRows");
      var destroyRows = embedFullWidthRows !== this.embedFullWidthRows || this.printLayout !== printLayout;
      this.printLayout = printLayout;
      this.embedFullWidthRows = embedFullWidthRows;

      if (destroyRows) {
        this.redrawAfterModelUpdate({
          domLayoutChanged: true
        });
      }
    } // for row models that have datasources, when we update the datasource, we need to force the rowRenderer
    // to redraw all rows. otherwise the old rows from the old datasource will stay displayed.

  }, {
    key: "datasourceChanged",
    value: function datasourceChanged() {
      this.firstRenderedRow = 0;
      this.lastRenderedRow = -1;
      var rowIndexesToRemove = Object.keys(this.rowCtrlsByRowIndex);
      this.removeRowCtrls(rowIndexesToRemove);
    }
  }, {
    key: "onPageLoaded",
    value: function onPageLoaded(event) {
      var params = {
        recycleRows: event.keepRenderedRows,
        animate: event.animate,
        newData: event.newData,
        newPage: event.newPage,
        // because this is a model updated event (not pinned rows), we
        // can skip updating the pinned rows. this is needed so that if user
        // is doing transaction updates, the pinned rows are not getting constantly
        // trashed - or editing cells in pinned rows are not refreshed and put into read mode
        onlyBody: true
      };
      this.redrawAfterModelUpdate(params);
    }
  }, {
    key: "getAllCellsForColumn",
    value: function getAllCellsForColumn(column) {
      var res = [];
      this.getAllRowCtrls().forEach(function (rowCtrl) {
        var eCell = rowCtrl.getCellElement(column);

        if (eCell) {
          res.push(eCell);
        }
      });
      return res;
    }
  }, {
    key: "refreshFloatingRowComps",
    value: function refreshFloatingRowComps() {
      this.refreshFloatingRows(this.topRowCtrls, this.pinnedRowModel.getPinnedTopRowData());
      this.refreshFloatingRows(this.bottomRowCtrls, this.pinnedRowModel.getPinnedBottomRowData());
    }
  }, {
    key: "getTopRowCtrls",
    value: function getTopRowCtrls() {
      return this.topRowCtrls;
    }
  }, {
    key: "getCentreRowCtrls",
    value: function getCentreRowCtrls() {
      return this.allRowCtrls;
    }
  }, {
    key: "getBottomRowCtrls",
    value: function getBottomRowCtrls() {
      return this.bottomRowCtrls;
    }
  }, {
    key: "refreshFloatingRows",
    value: function refreshFloatingRows(rowComps, rowNodes) {
      var _this468 = this;

      rowComps.forEach(function (row) {
        row.destroyFirstPass();
        row.destroySecondPass();
      });
      rowComps.length = 0;

      if (!rowNodes) {
        return;
      }

      rowNodes.forEach(function (rowNode) {
        var rowCtrl = new _RowCtrl2(rowNode, _this468.beans, false, false, _this468.printLayout);
        rowComps.push(rowCtrl);
      });
    }
  }, {
    key: "onPinnedRowDataChanged",
    value: function onPinnedRowDataChanged() {
      var params = {
        recycleRows: true
      };
      this.redrawAfterModelUpdate(params);
    }
  }, {
    key: "redrawRow",
    value: function redrawRow(rowNode) {
      var _this469 = this;

      var suppressEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var _a;

      if (rowNode.sticky) {
        this.stickyRowFeature.refreshStickyNode(rowNode);
      } else if ((_a = this.cachedRowCtrls) == null ? void 0 : _a.has(rowNode)) {
        this.cachedRowCtrls.removeRow(rowNode);
        return;
      } else {
        var destroyAndRecreateCtrl = function destroyAndRecreateCtrl(dataStruct) {
          var ctrl = dataStruct[rowNode.rowIndex];

          if (!ctrl) {
            return;
          }

          if (ctrl.getRowNode() !== rowNode) {
            return;
          }

          ctrl.destroyFirstPass();
          ctrl.destroySecondPass();
          dataStruct[rowNode.rowIndex] = _this469.createRowCon(rowNode, false, false);
        };

        switch (rowNode.rowPinned) {
          case "top":
            destroyAndRecreateCtrl(this.topRowCtrls);
            break;

          case "bottom":
            destroyAndRecreateCtrl(this.bottomRowCtrls);
            break;

          default:
            destroyAndRecreateCtrl(this.rowCtrlsByRowIndex);
            this.updateAllRowCtrls();
        }
      }

      if (!suppressEvent) {
        this.dispatchDisplayedRowsChanged(false);
      }
    }
  }, {
    key: "redrawRows",
    value: function redrawRows(rowNodes) {
      var _this470 = this;

      var partialRefresh = rowNodes != null;

      if (partialRefresh) {
        rowNodes == null ? void 0 : rowNodes.forEach(function (node) {
          return _this470.redrawRow(node, true);
        });
        this.dispatchDisplayedRowsChanged(false);
        return;
      }

      this.redrawAfterModelUpdate();
    }
  }, {
    key: "getCellToRestoreFocusToAfterRefresh",
    value: function getCellToRestoreFocusToAfterRefresh(params) {
      var focusedCell = (params == null ? void 0 : params.suppressKeepFocus) ? null : this.focusService.getFocusCellToUseAfterRefresh();

      if (focusedCell == null) {
        return null;
      }

      var activeElement = this.gos.getActiveDomElement();
      var cellDomData = this.gos.getDomData(activeElement, _CellCtrl2.DOM_DATA_KEY_CELL_CTRL);
      var rowDomData = this.gos.getDomData(activeElement, _RowCtrl2.DOM_DATA_KEY_ROW_CTRL);
      var gridElementFocused = cellDomData || rowDomData;
      return gridElementFocused ? focusedCell : null;
    } // gets called from:
    // +) initialisation (in registerGridComp) params = null
    // +) onDomLayoutChanged, params = null
    // +) onPageLoaded, recycleRows, animate, newData, newPage from event, onlyBody=true
    // +) onPinnedRowDataChanged, recycleRows = true
    // +) redrawRows (from Grid API), recycleRows = true/false

  }, {
    key: "redrawAfterModelUpdate",
    value: function redrawAfterModelUpdate() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.getLockOnRefresh();
      var focusedCell = this.getCellToRestoreFocusToAfterRefresh(params);
      this.updateContainerHeights();
      this.scrollToTopIfNewData(params);
      var recycleRows = !params.domLayoutChanged && !!params.recycleRows;
      var animate = params.animate && this.gos.isAnimateRows();
      var rowsToRecycle = recycleRows ? this.getRowsToRecycle() : null;

      if (!recycleRows) {
        this.removeAllRowComps();
      }

      this.workOutFirstAndLastRowsToRender();

      if (this.stickyRowFeature) {
        this.stickyRowFeature.checkStickyRows();
      }

      this.recycleRows(rowsToRecycle, animate);
      this.gridBodyCtrl.updateRowCount();

      if (!params.onlyBody) {
        this.refreshFloatingRowComps();
      }

      this.dispatchDisplayedRowsChanged();

      if (focusedCell != null) {
        this.restoreFocusedCell(focusedCell);
      }

      this.releaseLockOnRefresh();
    }
  }, {
    key: "scrollToTopIfNewData",
    value: function scrollToTopIfNewData(params) {
      var scrollToTop = params.newData || params.newPage;
      var suppressScrollToTop = this.gos.get("suppressScrollOnNewData");

      if (scrollToTop && !suppressScrollToTop) {
        this.gridBodyCtrl.getScrollFeature().scrollToTop();
      }
    }
  }, {
    key: "updateContainerHeights",
    value: function updateContainerHeights() {
      if (this.printLayout) {
        this.rowContainerHeightService.setModelHeight(null);
        return;
      }

      var containerHeight = this.paginationProxy.getCurrentPageHeight();

      if (containerHeight === 0) {
        containerHeight = 1;
      }

      this.rowContainerHeightService.setModelHeight(containerHeight);
    }
  }, {
    key: "getLockOnRefresh",
    value: function getLockOnRefresh() {
      if (this.refreshInProgress) {
        throw new Error("AG Grid: cannot get grid to draw rows when it is in the middle of drawing rows. Your code probably called a grid API method while the grid was in the render stage. To overcome this, put the API call into a timeout, e.g. instead of api.redrawRows(), call setTimeout(function() { api.redrawRows(); }, 0). To see what part of your code that caused the refresh check this stacktrace.");
      }

      this.refreshInProgress = true;
    }
  }, {
    key: "releaseLockOnRefresh",
    value: function releaseLockOnRefresh() {
      this.refreshInProgress = false;
    }
  }, {
    key: "isRefreshInProgress",
    value: function isRefreshInProgress() {
      return this.refreshInProgress;
    } // sets the focus to the provided cell, if the cell is provided. this way, the user can call refresh without
    // worry about the focus been lost. this is important when the user is using keyboard navigation to do edits
    // and the cellEditor is calling 'refresh' to get other cells to update (as other cells might depend on the
    // edited cell).

  }, {
    key: "restoreFocusedCell",
    value: function restoreFocusedCell(cellPosition) {
      if (cellPosition) {
        this.focusService.setRestoreFocusedCell(cellPosition);
        this.onCellFocusChanged(this.beans.gos.addGridCommonParams({
          rowIndex: cellPosition.rowIndex,
          column: cellPosition.column,
          rowPinned: cellPosition.rowPinned,
          forceBrowserFocus: true,
          preventScrollOnBrowserFocus: true,
          type: "mock"
        }));
      }
    }
  }, {
    key: "stopEditing",
    value: function stopEditing() {
      var cancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.getAllRowCtrls().forEach(function (rowCtrl) {
        rowCtrl.stopEditing(cancel);
      });
    }
  }, {
    key: "getAllCellCtrls",
    value: function getAllCellCtrls() {
      var res = [];
      var rowCtrls = this.getAllRowCtrls();
      var rowCtrlsLength = rowCtrls.length;

      for (var i = 0; i < rowCtrlsLength; i++) {
        var cellCtrls = rowCtrls[i].getAllCellCtrls();
        var cellCtrlsLength = cellCtrls.length;

        for (var j = 0; j < cellCtrlsLength; j++) {
          res.push(cellCtrls[j]);
        }
      }

      return res;
    }
  }, {
    key: "getAllRowCtrls",
    value: function getAllRowCtrls() {
      var stickyTopRowCtrls = this.stickyRowFeature && this.stickyRowFeature.getStickyTopRowCtrls() || [];
      var stickyBottomRowCtrls = this.stickyRowFeature && this.stickyRowFeature.getStickyBottomRowCtrls() || [];
      var res = [].concat(_toConsumableArray(this.topRowCtrls), _toConsumableArray(this.bottomRowCtrls), _toConsumableArray(stickyTopRowCtrls), _toConsumableArray(stickyBottomRowCtrls));

      for (var key in this.rowCtrlsByRowIndex) {
        res.push(this.rowCtrlsByRowIndex[key]);
      }

      return res;
    }
  }, {
    key: "addRenderedRowListener",
    value: function addRenderedRowListener(eventName, rowIndex, callback) {
      var rowComp = this.rowCtrlsByRowIndex[rowIndex];

      if (rowComp) {
        rowComp.addEventListener(eventName, callback);
      }
    }
  }, {
    key: "flashCells",
    value: function flashCells() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.getCellCtrls(params.rowNodes, params.columns).forEach(function (cellCtrl) {
        return cellCtrl.flashCell(params);
      });
    }
  }, {
    key: "refreshCells",
    value: function refreshCells() {
      var _this471 = this;

      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var refreshCellParams = {
        forceRefresh: params.force,
        newData: false,
        suppressFlash: params.suppressFlash
      };
      this.getCellCtrls(params.rowNodes, params.columns).forEach(function (cellCtrl) {
        return cellCtrl.refreshOrDestroyCell(refreshCellParams);
      });

      if (params.rowNodes) {
        this.getRowCtrls(params.rowNodes).forEach(function (rowCtrl) {
          if (!rowCtrl.isFullWidth()) {
            return;
          }

          var refreshed = rowCtrl.refreshFullWidth();

          if (!refreshed) {
            _this471.redrawRow(rowCtrl.getRowNode(), true);
          }
        });
        this.dispatchDisplayedRowsChanged(false);
      }
    }
  }, {
    key: "getCellRendererInstances",
    value: function getCellRendererInstances(params) {
      var _this472 = this;

      var _a;

      var cellRenderers = this.getCellCtrls(params.rowNodes, params.columns).map(function (cellCtrl) {
        return cellCtrl.getCellRenderer();
      }).filter(function (renderer) {
        return renderer != null;
      });

      if ((_a = params.columns) == null ? void 0 : _a.length) {
        return cellRenderers;
      }

      var fullWidthRenderers = [];
      var rowIdMap = this.mapRowNodes(params.rowNodes);
      this.getAllRowCtrls().forEach(function (rowCtrl) {
        if (rowIdMap && !_this472.isRowInMap(rowCtrl.getRowNode(), rowIdMap)) {
          return;
        }

        if (!rowCtrl.isFullWidth()) {
          return;
        }

        var renderers = rowCtrl.getFullWidthCellRenderers();

        for (var i = 0; i < renderers.length; i++) {
          var renderer = renderers[i];

          if (renderer != null) {
            fullWidthRenderers.push(renderer);
          }
        }
      });
      return [].concat(fullWidthRenderers, _toConsumableArray(cellRenderers));
    }
  }, {
    key: "getCellEditorInstances",
    value: function getCellEditorInstances(params) {
      var res = [];
      this.getCellCtrls(params.rowNodes, params.columns).forEach(function (cellCtrl) {
        var cellEditor = cellCtrl.getCellEditor();

        if (cellEditor) {
          res.push(cellEditor);
        }
      });
      return res;
    }
  }, {
    key: "getEditingCells",
    value: function getEditingCells() {
      var res = [];
      this.getAllCellCtrls().forEach(function (cellCtrl) {
        if (cellCtrl.isEditing()) {
          var cellPosition = cellCtrl.getCellPosition();
          res.push(cellPosition);
        }
      });
      return res;
    }
  }, {
    key: "mapRowNodes",
    value: function mapRowNodes(rowNodes) {
      if (!rowNodes) {
        return;
      }

      var res = {
        top: {},
        bottom: {},
        normal: {}
      };
      rowNodes.forEach(function (rowNode) {
        var id = rowNode.id;

        switch (rowNode.rowPinned) {
          case "top":
            res.top[id] = rowNode;
            break;

          case "bottom":
            res.bottom[id] = rowNode;
            break;

          default:
            res.normal[id] = rowNode;
            break;
        }
      });
      return res;
    }
  }, {
    key: "isRowInMap",
    value: function isRowInMap(rowNode, rowIdsMap) {
      var id = rowNode.id;
      var floating = rowNode.rowPinned;

      switch (floating) {
        case "top":
          return rowIdsMap.top[id] != null;

        case "bottom":
          return rowIdsMap.bottom[id] != null;

        default:
          return rowIdsMap.normal[id] != null;
      }
    }
    /**
     * @param rowNodes if provided, returns the RowCtrls for the provided rowNodes. otherwise returns all RowCtrls.
     */

  }, {
    key: "getRowCtrls",
    value: function getRowCtrls(rowNodes) {
      var _this473 = this;

      var rowIdsMap = this.mapRowNodes(rowNodes);
      var allRowCtrls = this.getAllRowCtrls();

      if (!rowNodes || !rowIdsMap) {
        return allRowCtrls;
      }

      return allRowCtrls.filter(function (rowCtrl) {
        var rowNode = rowCtrl.getRowNode();
        return _this473.isRowInMap(rowNode, rowIdsMap);
      });
    } // returns CellCtrl's that match the provided rowNodes and columns. eg if one row node
    // and two columns provided, that identifies 4 cells, so 4 CellCtrl's returned.

  }, {
    key: "getCellCtrls",
    value: function getCellCtrls(rowNodes, columns) {
      var _this474 = this;

      var colIdsMap;

      if (_exists(columns)) {
        colIdsMap = {};
        columns.forEach(function (colKey) {
          var column = _this474.columnModel.getGridColumn(colKey);

          if (_exists(column)) {
            colIdsMap[column.getId()] = true;
          }
        });
      }

      var res = [];
      this.getRowCtrls(rowNodes).forEach(function (rowCtrl) {
        rowCtrl.getAllCellCtrls().forEach(function (cellCtrl) {
          var colId = cellCtrl.getColumn().getId();
          var excludeColFromRefresh = colIdsMap && !colIdsMap[colId];

          if (excludeColFromRefresh) {
            return;
          }

          res.push(cellCtrl);
        });
      });
      return res;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.removeAllRowComps();

      _get(_getPrototypeOf(_RowRenderer.prototype), "destroy", this).call(this);
    }
  }, {
    key: "removeAllRowComps",
    value: function removeAllRowComps() {
      var rowIndexesToRemove = Object.keys(this.rowCtrlsByRowIndex);
      this.removeRowCtrls(rowIndexesToRemove);
    }
  }, {
    key: "getRowsToRecycle",
    value: function getRowsToRecycle() {
      var stubNodeIndexes = [];

      _iterateObject(this.rowCtrlsByRowIndex, function (index, rowCtrl) {
        var stubNode = rowCtrl.getRowNode().id == null;

        if (stubNode) {
          stubNodeIndexes.push(index);
        }
      });

      this.removeRowCtrls(stubNodeIndexes);
      var ctrlsByIdMap = {};

      _iterateObject(this.rowCtrlsByRowIndex, function (index, rowCtrl) {
        var rowNode = rowCtrl.getRowNode();
        ctrlsByIdMap[rowNode.id] = rowCtrl;
      });

      this.rowCtrlsByRowIndex = {};
      return ctrlsByIdMap;
    } // takes array of row indexes

  }, {
    key: "removeRowCtrls",
    value: function removeRowCtrls(rowsToRemove) {
      var _this475 = this;

      var suppressAnimation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      rowsToRemove.forEach(function (indexToRemove) {
        var rowCtrl = _this475.rowCtrlsByRowIndex[indexToRemove];

        if (rowCtrl) {
          rowCtrl.destroyFirstPass(suppressAnimation);
          rowCtrl.destroySecondPass();
        }

        delete _this475.rowCtrlsByRowIndex[indexToRemove];
      });
    }
  }, {
    key: "onBodyScroll",
    value: function onBodyScroll(e) {
      if (e.direction !== "vertical") {
        return;
      }

      this.redraw({
        afterScroll: true
      });
    } // gets called when rows don't change, but viewport does, so after:
    // 1) height of grid body changes, ie number of displayed rows has changed
    // 2) grid scrolled to new position
    // 3) ensure index visible (which is a scroll)

  }, {
    key: "redraw",
    value: function redraw() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var afterScroll = params.afterScroll;
      var cellFocused;

      if (this.stickyRowFeature && _browserSupportsPreventScroll()) {
        cellFocused = this.getCellToRestoreFocusToAfterRefresh() || void 0;
      }

      var oldFirstRow = this.firstRenderedRow;
      var oldLastRow = this.lastRenderedRow;
      this.workOutFirstAndLastRowsToRender();
      var hasStickyRowChanges = false;

      if (this.stickyRowFeature) {
        hasStickyRowChanges = this.stickyRowFeature.checkStickyRows();
      }

      var rangeChanged = this.firstRenderedRow !== oldFirstRow || this.lastRenderedRow !== oldLastRow;

      if (afterScroll && !hasStickyRowChanges && !rangeChanged) {
        return;
      }

      this.getLockOnRefresh();
      this.recycleRows(null, false, afterScroll);
      this.releaseLockOnRefresh();
      this.dispatchDisplayedRowsChanged(afterScroll && !hasStickyRowChanges);

      if (cellFocused != null) {
        var newFocusedCell = this.getCellToRestoreFocusToAfterRefresh();

        if (cellFocused != null && newFocusedCell == null) {
          this.animationFrameService.flushAllFrames();
          this.restoreFocusedCell(cellFocused);
        }
      }
    }
  }, {
    key: "removeRowCompsNotToDraw",
    value: function removeRowCompsNotToDraw(indexesToDraw, suppressAnimation) {
      var indexesToDrawMap = {};
      indexesToDraw.forEach(function (index) {
        return indexesToDrawMap[index] = true;
      });
      var existingIndexes = Object.keys(this.rowCtrlsByRowIndex);
      var indexesNotToDraw = existingIndexes.filter(function (index) {
        return !indexesToDrawMap[index];
      });
      this.removeRowCtrls(indexesNotToDraw, suppressAnimation);
    }
  }, {
    key: "calculateIndexesToDraw",
    value: function calculateIndexesToDraw(rowsToRecycle) {
      var _this476 = this;

      var indexesToDraw = _createArrayOfNumbers(this.firstRenderedRow, this.lastRenderedRow);

      var checkRowToDraw = function checkRowToDraw(indexStr, rowComp) {
        var index = rowComp.getRowNode().rowIndex;

        if (index == null) {
          return;
        }

        if (index < _this476.firstRenderedRow || index > _this476.lastRenderedRow) {
          if (_this476.doNotUnVirtualiseRow(rowComp)) {
            indexesToDraw.push(index);
          }
        }
      };

      _iterateObject(this.rowCtrlsByRowIndex, checkRowToDraw);

      _iterateObject(rowsToRecycle, checkRowToDraw);

      indexesToDraw.sort(function (a, b) {
        return a - b;
      });
      var ret = [];

      for (var i = 0; i < indexesToDraw.length; i++) {
        var currRow = indexesToDraw[i];
        var rowNode = this.paginationProxy.getRow(currRow);

        if (rowNode && !rowNode.sticky) {
          ret.push(currRow);
        }
      }

      return ret;
    }
  }, {
    key: "recycleRows",
    value: function recycleRows(rowsToRecycle) {
      var _this477 = this;

      var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var afterScroll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var indexesToDraw = this.calculateIndexesToDraw(rowsToRecycle);

      if (this.printLayout || afterScroll) {
        animate = false;
      }

      this.removeRowCompsNotToDraw(indexesToDraw, !animate);
      var rowCtrls = [];
      indexesToDraw.forEach(function (rowIndex) {
        var rowCtrl = _this477.createOrUpdateRowCtrl(rowIndex, rowsToRecycle, animate, afterScroll);

        if (_exists(rowCtrl)) {
          rowCtrls.push(rowCtrl);
        }
      });

      if (rowsToRecycle) {
        var useAnimationFrame = afterScroll && !this.gos.get("suppressAnimationFrame") && !this.printLayout;

        if (useAnimationFrame) {
          this.beans.animationFrameService.addDestroyTask(function () {
            _this477.destroyRowCtrls(rowsToRecycle, animate);

            _this477.updateAllRowCtrls();

            _this477.dispatchDisplayedRowsChanged();
          });
        } else {
          this.destroyRowCtrls(rowsToRecycle, animate);
        }
      }

      this.updateAllRowCtrls();
    }
  }, {
    key: "dispatchDisplayedRowsChanged",
    value: function dispatchDisplayedRowsChanged() {
      var afterScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var event = {
        type: _Events.EVENT_DISPLAYED_ROWS_CHANGED,
        afterScroll: afterScroll
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "onDisplayedColumnsChanged",
    value: function onDisplayedColumnsChanged() {
      var pinningLeft = this.columnModel.isPinningLeft();
      var pinningRight = this.columnModel.isPinningRight();
      var atLeastOneChanged = this.pinningLeft !== pinningLeft || pinningRight !== this.pinningRight;

      if (atLeastOneChanged) {
        this.pinningLeft = pinningLeft;
        this.pinningRight = pinningRight;

        if (this.embedFullWidthRows) {
          this.redrawFullWidthEmbeddedRows();
        }
      }
    } // when embedding, what gets showed in each section depends on what is pinned. eg if embedding group expand / collapse,
    // then it should go into the pinned left area if pinning left, or the center area if not pinning.

  }, {
    key: "redrawFullWidthEmbeddedRows",
    value: function redrawFullWidthEmbeddedRows() {
      var rowsToRemove = [];
      this.getFullWidthRowCtrls().forEach(function (fullWidthCtrl) {
        var rowIndex = fullWidthCtrl.getRowNode().rowIndex;
        rowsToRemove.push(rowIndex.toString());
      });
      this.refreshFloatingRowComps();
      this.removeRowCtrls(rowsToRemove);
      this.redraw({
        afterScroll: true
      });
    }
  }, {
    key: "getFullWidthRowCtrls",
    value: function getFullWidthRowCtrls(rowNodes) {
      var _this478 = this;

      var rowNodesMap = this.mapRowNodes(rowNodes);
      return this.getAllRowCtrls().filter(function (rowCtrl) {
        if (!rowCtrl.isFullWidth()) {
          return false;
        }

        var rowNode = rowCtrl.getRowNode();

        if (rowNodesMap != null && !_this478.isRowInMap(rowNode, rowNodesMap)) {
          return false;
        }

        return true;
      });
    }
  }, {
    key: "createOrUpdateRowCtrl",
    value: function createOrUpdateRowCtrl(rowIndex, rowsToRecycle, animate, afterScroll) {
      var rowNode;
      var rowCtrl = this.rowCtrlsByRowIndex[rowIndex];

      if (!rowCtrl) {
        rowNode = this.paginationProxy.getRow(rowIndex);

        if (_exists(rowNode) && _exists(rowsToRecycle) && rowsToRecycle[rowNode.id] && rowNode.alreadyRendered) {
          rowCtrl = rowsToRecycle[rowNode.id];
          rowsToRecycle[rowNode.id] = null;
        }
      }

      var creatingNewRowCtrl = !rowCtrl;

      if (creatingNewRowCtrl) {
        if (!rowNode) {
          rowNode = this.paginationProxy.getRow(rowIndex);
        }

        if (_exists(rowNode)) {
          rowCtrl = this.createRowCon(rowNode, animate, afterScroll);
        } else {
          return;
        }
      }

      if (rowNode) {
        rowNode.alreadyRendered = true;
      }

      this.rowCtrlsByRowIndex[rowIndex] = rowCtrl;
      return rowCtrl;
    }
  }, {
    key: "destroyRowCtrls",
    value: function destroyRowCtrls(rowCtrlsMap, animate) {
      var _this479 = this;

      var executeInAWhileFuncs = [];

      _iterateObject(rowCtrlsMap, function (nodeId, rowCtrl) {
        if (!rowCtrl) {
          return;
        }

        if (_this479.cachedRowCtrls && rowCtrl.isCacheable()) {
          _this479.cachedRowCtrls.addRow(rowCtrl);

          return;
        }

        rowCtrl.destroyFirstPass(!animate);

        if (animate) {
          _this479.zombieRowCtrls[rowCtrl.getInstanceId()] = rowCtrl;
          executeInAWhileFuncs.push(function () {
            rowCtrl.destroySecondPass();
            delete _this479.zombieRowCtrls[rowCtrl.getInstanceId()];
          });
        } else {
          rowCtrl.destroySecondPass();
        }
      });

      if (animate) {
        executeInAWhileFuncs.push(function () {
          _this479.updateAllRowCtrls();

          _this479.dispatchDisplayedRowsChanged();
        });

        _executeInAWhile(executeInAWhileFuncs);
      }
    }
  }, {
    key: "getRowBuffer",
    value: function getRowBuffer() {
      return this.gos.get("rowBuffer");
    }
  }, {
    key: "getRowBufferInPixels",
    value: function getRowBufferInPixels() {
      var rowsToBuffer = this.getRowBuffer();
      var defaultRowHeight = this.gos.getRowHeightAsNumber();
      return rowsToBuffer * defaultRowHeight;
    }
  }, {
    key: "workOutFirstAndLastRowsToRender",
    value: function workOutFirstAndLastRowsToRender() {
      this.rowContainerHeightService.updateOffset();
      var newFirst;
      var newLast;

      if (!this.paginationProxy.isRowsToRender()) {
        newFirst = 0;
        newLast = -1;
      } else if (this.printLayout) {
        this.environment.refreshRowHeightVariable();
        newFirst = this.paginationProxy.getPageFirstRow();
        newLast = this.paginationProxy.getPageLastRow();
      } else {
        var bufferPixels = this.getRowBufferInPixels();
        var gridBodyCtrl = this.ctrlsService.getGridBodyCtrl();
        var suppressRowVirtualisation = this.gos.get("suppressRowVirtualisation");
        var rowHeightsChanged = false;
        var firstPixel;
        var lastPixel;

        do {
          var paginationOffset = this.paginationProxy.getPixelOffset();

          var _this$paginationProxy = this.paginationProxy.getCurrentPagePixelRange(),
              pageFirstPixel = _this$paginationProxy.pageFirstPixel,
              pageLastPixel = _this$paginationProxy.pageLastPixel;

          var divStretchOffset = this.rowContainerHeightService.getDivStretchOffset();
          var bodyVRange = gridBodyCtrl.getScrollFeature().getVScrollPosition();
          var bodyTopPixel = bodyVRange.top;
          var bodyBottomPixel = bodyVRange.bottom;

          if (suppressRowVirtualisation) {
            firstPixel = pageFirstPixel + divStretchOffset;
            lastPixel = pageLastPixel + divStretchOffset;
          } else {
            firstPixel = Math.max(bodyTopPixel + paginationOffset - bufferPixels, pageFirstPixel) + divStretchOffset;
            lastPixel = Math.min(bodyBottomPixel + paginationOffset + bufferPixels, pageLastPixel) + divStretchOffset;
          }

          this.firstVisibleVPixel = Math.max(bodyTopPixel + paginationOffset, pageFirstPixel) + divStretchOffset;
          this.lastVisibleVPixel = Math.min(bodyBottomPixel + paginationOffset, pageLastPixel) + divStretchOffset;
          rowHeightsChanged = this.ensureAllRowsInRangeHaveHeightsCalculated(firstPixel, lastPixel);
        } while (rowHeightsChanged);

        var firstRowIndex = this.paginationProxy.getRowIndexAtPixel(firstPixel);
        var lastRowIndex = this.paginationProxy.getRowIndexAtPixel(lastPixel);
        var pageFirstRow = this.paginationProxy.getPageFirstRow();
        var pageLastRow = this.paginationProxy.getPageLastRow();

        if (firstRowIndex < pageFirstRow) {
          firstRowIndex = pageFirstRow;
        }

        if (lastRowIndex > pageLastRow) {
          lastRowIndex = pageLastRow;
        }

        newFirst = firstRowIndex;
        newLast = lastRowIndex;
      }

      var rowLayoutNormal = this.gos.isDomLayout("normal");
      var suppressRowCountRestriction = this.gos.get("suppressMaxRenderedRowRestriction");
      var rowBufferMaxSize = Math.max(this.getRowBuffer(), 500);

      if (rowLayoutNormal && !suppressRowCountRestriction) {
        if (newLast - newFirst > rowBufferMaxSize) {
          newLast = newFirst + rowBufferMaxSize;
        }
      }

      var firstDiffers = newFirst !== this.firstRenderedRow;
      var lastDiffers = newLast !== this.lastRenderedRow;

      if (firstDiffers || lastDiffers) {
        this.firstRenderedRow = newFirst;
        this.lastRenderedRow = newLast;
        var event = {
          type: _Events.EVENT_VIEWPORT_CHANGED,
          firstRow: newFirst,
          lastRow: newLast
        };
        this.eventService.dispatchEvent(event);
      }
    }
    /**
     * This event will only be fired once, and is queued until after the browser next renders.
     * This allows us to fire an event during the start of the render cycle, when we first see data being rendered
     * but not execute the event until all of the data has finished being rendered to the dom.
     */

  }, {
    key: "dispatchFirstDataRenderedEvent",
    value: function dispatchFirstDataRenderedEvent() {
      var _this480 = this;

      if (this.dataFirstRenderedFired) {
        return;
      }

      this.dataFirstRenderedFired = true;
      var event = {
        type: _Events.EVENT_FIRST_DATA_RENDERED,
        firstRow: this.firstRenderedRow,
        lastRow: this.lastRenderedRow
      };
      window.requestAnimationFrame(function () {
        _this480.beans.eventService.dispatchEvent(event);
      });
    }
  }, {
    key: "ensureAllRowsInRangeHaveHeightsCalculated",
    value: function ensureAllRowsInRangeHaveHeightsCalculated(topPixel, bottomPixel) {
      var res = this.paginationProxy.ensureRowHeightsValid(topPixel, bottomPixel, -1, -1);

      if (res) {
        this.updateContainerHeights();
      }

      return res;
    }
  }, {
    key: "getFirstVisibleVerticalPixel",
    value: function getFirstVisibleVerticalPixel() {
      return this.firstVisibleVPixel;
    }
  }, {
    key: "getLastVisibleVerticalPixel",
    value: function getLastVisibleVerticalPixel() {
      return this.lastVisibleVPixel;
    }
  }, {
    key: "getFirstVirtualRenderedRow",
    value: function getFirstVirtualRenderedRow() {
      return this.firstRenderedRow;
    }
  }, {
    key: "getLastVirtualRenderedRow",
    value: function getLastVirtualRenderedRow() {
      return this.lastRenderedRow;
    } // check that none of the rows to remove are editing or focused as:
    // a) if editing, we want to keep them, otherwise the user will loose the context of the edit,
    //    eg user starts editing, enters some text, then scrolls down and then up, next time row rendered
    //    the edit is reset - so we want to keep it rendered.
    // b) if focused, we want ot keep keyboard focus, so if user ctrl+c, it goes to clipboard,
    //    otherwise the user can range select and drag (with focus cell going out of the viewport)
    //    and then ctrl+c, nothing will happen if cell is removed from dom.
    // c) if detail record of master detail, as users complained that the context of detail rows
    //    was getting lost when detail row out of view. eg user expands to show detail row,
    //    then manipulates the detail panel (eg sorts the detail grid), then context is lost
    //    after detail panel is scrolled out of / into view.

  }, {
    key: "doNotUnVirtualiseRow",
    value: function doNotUnVirtualiseRow(rowComp) {
      var REMOVE_ROW = false;
      var KEEP_ROW = true;
      var rowNode = rowComp.getRowNode();
      var rowHasFocus = this.focusService.isRowNodeFocused(rowNode);
      var rowIsEditing = rowComp.isEditing();
      var rowIsDetail = rowNode.detail;
      var mightWantToKeepRow = rowHasFocus || rowIsEditing || rowIsDetail;

      if (!mightWantToKeepRow) {
        return REMOVE_ROW;
      }

      var rowNodePresent = this.paginationProxy.isRowPresent(rowNode);
      return rowNodePresent ? KEEP_ROW : REMOVE_ROW;
    }
  }, {
    key: "createRowCon",
    value: function createRowCon(rowNode, animate, afterScroll) {
      var rowCtrlFromCache = this.cachedRowCtrls ? this.cachedRowCtrls.getRow(rowNode) : null;

      if (rowCtrlFromCache) {
        return rowCtrlFromCache;
      }

      var suppressAnimationFrame = this.gos.get("suppressAnimationFrame");
      var useAnimationFrameForCreate = afterScroll && !suppressAnimationFrame && !this.printLayout;
      var res = new _RowCtrl2(rowNode, this.beans, animate, useAnimationFrameForCreate, this.printLayout);
      return res;
    }
  }, {
    key: "getRenderedNodes",
    value: function getRenderedNodes() {
      var renderedRows = this.rowCtrlsByRowIndex;
      return Object.values(renderedRows).map(function (rowCtrl) {
        return rowCtrl.getRowNode();
      });
    }
  }, {
    key: "getRowByPosition",
    value: function getRowByPosition(rowPosition) {
      var rowCtrl;
      var rowIndex = rowPosition.rowIndex;

      switch (rowPosition.rowPinned) {
        case "top":
          rowCtrl = this.topRowCtrls[rowIndex];
          break;

        case "bottom":
          rowCtrl = this.bottomRowCtrls[rowIndex];
          break;

        default:
          rowCtrl = this.rowCtrlsByRowIndex[rowIndex];

          if (!rowCtrl) {
            rowCtrl = this.getStickyTopRowCtrls().find(function (ctrl) {
              return ctrl.getRowNode().rowIndex === rowIndex;
            }) || null;

            if (!rowCtrl) {
              rowCtrl = this.getStickyBottomRowCtrls().find(function (ctrl) {
                return ctrl.getRowNode().rowIndex === rowIndex;
              }) || null;
            }
          }

          break;
      }

      return rowCtrl;
    } // returns true if any row between startIndex and endIndex is rendered. used by
    // SSRM or IRM, as they don't want to purge visible blocks from cache.

  }, {
    key: "isRangeInRenderedViewport",
    value: function isRangeInRenderedViewport(startIndex, endIndex) {
      var parentClosed = startIndex == null || endIndex == null;

      if (parentClosed) {
        return false;
      }

      var blockAfterViewport = startIndex > this.lastRenderedRow;
      var blockBeforeViewport = endIndex < this.firstRenderedRow;
      var blockInsideViewport = !blockBeforeViewport && !blockAfterViewport;
      return blockInsideViewport;
    }
  }]);

  return _RowRenderer;
}(_BeanStub2);

__decorateClass([_Autowired("animationFrameService")], _RowRenderer.prototype, "animationFrameService", 2);

__decorateClass([_Autowired("paginationProxy")], _RowRenderer.prototype, "paginationProxy", 2);

__decorateClass([_Autowired("columnModel")], _RowRenderer.prototype, "columnModel", 2);

__decorateClass([_Autowired("pinnedRowModel")], _RowRenderer.prototype, "pinnedRowModel", 2);

__decorateClass([_Autowired("rowModel")], _RowRenderer.prototype, "rowModel", 2);

__decorateClass([_Autowired("focusService")], _RowRenderer.prototype, "focusService", 2);

__decorateClass([_Autowired("beans")], _RowRenderer.prototype, "beans", 2);

__decorateClass([_Autowired("rowContainerHeightService")], _RowRenderer.prototype, "rowContainerHeightService", 2);

__decorateClass([_Autowired("ctrlsService")], _RowRenderer.prototype, "ctrlsService", 2);

__decorateClass([_PostConstruct], _RowRenderer.prototype, "postConstruct", 1);

_RowRenderer = __decorateClass([_Bean("rowRenderer")], _RowRenderer);

var RowCtrlCache =
/*#__PURE__*/
function () {
  "use strict";

  function RowCtrlCache(maxCount) {
    _classCallCheck(this, RowCtrlCache);

    // map for fast access
    this.entriesMap = {}; // list for keeping order

    this.entriesList = [];
    this.maxCount = maxCount;
  }

  _createClass(RowCtrlCache, [{
    key: "addRow",
    value: function addRow(rowCtrl) {
      this.entriesMap[rowCtrl.getRowNode().id] = rowCtrl;
      this.entriesList.push(rowCtrl);
      rowCtrl.setCached(true);

      if (this.entriesList.length > this.maxCount) {
        var rowCtrlToDestroy = this.entriesList[0];
        rowCtrlToDestroy.destroyFirstPass();
        rowCtrlToDestroy.destroySecondPass();
        this.removeFromCache(rowCtrlToDestroy);
      }
    }
  }, {
    key: "getRow",
    value: function getRow(rowNode) {
      if (rowNode == null || rowNode.id == null) {
        return null;
      }

      var res = this.entriesMap[rowNode.id];

      if (!res) {
        return null;
      }

      this.removeFromCache(res);
      res.setCached(false);
      var rowNodeMismatch = res.getRowNode() != rowNode;
      return rowNodeMismatch ? null : res;
    }
  }, {
    key: "has",
    value: function has(rowNode) {
      return this.entriesMap[rowNode.id] != null;
    }
  }, {
    key: "removeRow",
    value: function removeRow(rowNode) {
      var rowNodeId = rowNode.id;
      var ctrl = this.entriesMap[rowNodeId];
      delete this.entriesMap[rowNodeId];

      _removeFromArray(this.entriesList, ctrl);
    }
  }, {
    key: "removeFromCache",
    value: function removeFromCache(rowCtrl) {
      var rowNodeId = rowCtrl.getRowNode().id;
      delete this.entriesMap[rowNodeId];

      _removeFromArray(this.entriesList, rowCtrl);
    }
  }, {
    key: "getEntries",
    value: function getEntries() {
      return this.entriesList;
    }
  }]);

  return RowCtrlCache;
}(); // community-modules/core/src/pinnedRowModel/pinnedRowModel.ts


var _PinnedRowModel =
/*#__PURE__*/
function (_BeanStub66) {
  "use strict";

  _inherits(_PinnedRowModel, _BeanStub66);

  function _PinnedRowModel() {
    _classCallCheck(this, _PinnedRowModel);

    return _possibleConstructorReturn(this, _getPrototypeOf(_PinnedRowModel).apply(this, arguments));
  }

  _createClass(_PinnedRowModel, [{
    key: "init",
    value: function init() {
      var _this481 = this;

      this.setPinnedTopRowData();
      this.setPinnedBottomRowData();
      this.addManagedPropertyListener("pinnedTopRowData", function () {
        return _this481.setPinnedTopRowData();
      });
      this.addManagedPropertyListener("pinnedBottomRowData", function () {
        return _this481.setPinnedBottomRowData();
      });
    }
  }, {
    key: "isEmpty",
    value: function isEmpty(floating) {
      var rows = floating === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
      return _missingOrEmpty(rows);
    }
  }, {
    key: "isRowsToRender",
    value: function isRowsToRender(floating) {
      return !this.isEmpty(floating);
    }
  }, {
    key: "getRowAtPixel",
    value: function getRowAtPixel(pixel, floating) {
      var rows = floating === "top" ? this.pinnedTopRows : this.pinnedBottomRows;

      if (_missingOrEmpty(rows)) {
        return 0;
      }

      for (var i = 0; i < rows.length; i++) {
        var rowNode = rows[i];
        var rowTopPixel = rowNode.rowTop + rowNode.rowHeight - 1;

        if (rowTopPixel >= pixel) {
          return i;
        }
      }

      return rows.length - 1;
    }
  }, {
    key: "setPinnedTopRowData",
    value: function setPinnedTopRowData() {
      var rowData = this.gos.get("pinnedTopRowData");
      this.pinnedTopRows = this.createNodesFromData(rowData, true);
      var event = {
        type: _Events.EVENT_PINNED_ROW_DATA_CHANGED
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "setPinnedBottomRowData",
    value: function setPinnedBottomRowData() {
      var rowData = this.gos.get("pinnedBottomRowData");
      this.pinnedBottomRows = this.createNodesFromData(rowData, false);
      var event = {
        type: _Events.EVENT_PINNED_ROW_DATA_CHANGED
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "createNodesFromData",
    value: function createNodesFromData(allData, isTop) {
      var _this482 = this;

      var rowNodes = [];

      if (allData) {
        var nextRowTop = 0;
        allData.forEach(function (dataItem, index) {
          var rowNode = new _RowNode2(_this482.beans);
          rowNode.data = dataItem;
          var idPrefix = isTop ? _RowNode2.ID_PREFIX_TOP_PINNED : _RowNode2.ID_PREFIX_BOTTOM_PINNED;
          rowNode.id = idPrefix + index;
          rowNode.rowPinned = isTop ? "top" : "bottom";
          rowNode.setRowTop(nextRowTop);
          rowNode.setRowHeight(_this482.gos.getRowHeightForNode(rowNode).height);
          rowNode.setRowIndex(index);
          nextRowTop += rowNode.rowHeight;
          rowNodes.push(rowNode);
        });
      }

      return rowNodes;
    }
  }, {
    key: "getPinnedTopRowData",
    value: function getPinnedTopRowData() {
      return this.pinnedTopRows;
    }
  }, {
    key: "getPinnedBottomRowData",
    value: function getPinnedBottomRowData() {
      return this.pinnedBottomRows;
    }
  }, {
    key: "getPinnedTopTotalHeight",
    value: function getPinnedTopTotalHeight() {
      return this.getTotalHeight(this.pinnedTopRows);
    }
  }, {
    key: "getPinnedTopRowCount",
    value: function getPinnedTopRowCount() {
      return this.pinnedTopRows ? this.pinnedTopRows.length : 0;
    }
  }, {
    key: "getPinnedBottomRowCount",
    value: function getPinnedBottomRowCount() {
      return this.pinnedBottomRows ? this.pinnedBottomRows.length : 0;
    }
  }, {
    key: "getPinnedTopRow",
    value: function getPinnedTopRow(index) {
      return this.pinnedTopRows[index];
    }
  }, {
    key: "getPinnedBottomRow",
    value: function getPinnedBottomRow(index) {
      return this.pinnedBottomRows[index];
    }
  }, {
    key: "forEachPinnedTopRow",
    value: function forEachPinnedTopRow(callback) {
      if (_missingOrEmpty(this.pinnedTopRows)) {
        return;
      }

      this.pinnedTopRows.forEach(callback);
    }
  }, {
    key: "forEachPinnedBottomRow",
    value: function forEachPinnedBottomRow(callback) {
      if (_missingOrEmpty(this.pinnedBottomRows)) {
        return;
      }

      this.pinnedBottomRows.forEach(callback);
    }
  }, {
    key: "getPinnedBottomTotalHeight",
    value: function getPinnedBottomTotalHeight() {
      return this.getTotalHeight(this.pinnedBottomRows);
    }
  }, {
    key: "getTotalHeight",
    value: function getTotalHeight(rowNodes) {
      if (!rowNodes || rowNodes.length === 0) {
        return 0;
      }

      var lastNode = _last(rowNodes);

      return lastNode.rowTop + lastNode.rowHeight;
    }
  }]);

  return _PinnedRowModel;
}(_BeanStub2);

__decorateClass([_Autowired("beans")], _PinnedRowModel.prototype, "beans", 2);

__decorateClass([_PostConstruct], _PinnedRowModel.prototype, "init", 1);

_PinnedRowModel = __decorateClass([_Bean("pinnedRowModel")], _PinnedRowModel); // community-modules/core/src/interfaces/serverSideTransaction.ts

var _ServerSideTransactionResultStatus =
/* @__PURE__ */
function (ServerSideTransactionResultStatus2) {
  ServerSideTransactionResultStatus2["Applied"] = "Applied";
  ServerSideTransactionResultStatus2["StoreNotFound"] = "StoreNotFound";
  ServerSideTransactionResultStatus2["StoreLoading"] = "StoreLoading";
  ServerSideTransactionResultStatus2["StoreWaitingToLoad"] = "StoreWaitingToLoad";
  ServerSideTransactionResultStatus2["StoreLoadingFailed"] = "StoreLoadingFailed";
  ServerSideTransactionResultStatus2["StoreWrongType"] = "StoreWrongType";
  ServerSideTransactionResultStatus2["Cancelled"] = "Cancelled";
  ServerSideTransactionResultStatus2["StoreNotStarted"] = "StoreNotStarted";
  return ServerSideTransactionResultStatus2;
}(_ServerSideTransactionResultStatus || {}); // community-modules/core/src/utils/changedPath.ts


var _ChangedPath =
/*#__PURE__*/
function () {
  "use strict";

  function _ChangedPath(keepingColumns, rootNode) {
    _classCallCheck(this, _ChangedPath);

    // whether changed path is active of not. it is active when a) doing
    // a transaction update or b) doing change detection. if we are doing
    // a CSRM refresh for other reasons (after sort or filter, or user calling
    // setRowData() without delta mode) then we are not active. we are also
    // marked as not active if secondary columns change in pivot (as this impacts
    // aggregations)
    this.active = true; // for each node in the change path, we also store which columns need
    // to be re-aggregated.

    this.nodeIdsToColumns = {}; // for quick lookup, all items in the change path are mapped by nodeId

    this.mapToItems = {};
    this.keepingColumns = keepingColumns;
    this.pathRoot = {
      rowNode: rootNode,
      children: null
    };
    this.mapToItems[rootNode.id] = this.pathRoot;
  } // can be set inactive by:
  // a) ClientSideRowModel, if no transactions or
  // b) PivotService, if secondary columns changed


  _createClass(_ChangedPath, [{
    key: "setInactive",
    value: function setInactive() {
      this.active = false;
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.active;
    }
  }, {
    key: "depthFirstSearchChangedPath",
    value: function depthFirstSearchChangedPath(pathItem, callback) {
      if (pathItem.children) {
        for (var i = 0; i < pathItem.children.length; i++) {
          this.depthFirstSearchChangedPath(pathItem.children[i], callback);
        }
      }

      callback(pathItem.rowNode);
    }
  }, {
    key: "depthFirstSearchEverything",
    value: function depthFirstSearchEverything(rowNode, callback, traverseEverything) {
      if (rowNode.childrenAfterGroup) {
        for (var i = 0; i < rowNode.childrenAfterGroup.length; i++) {
          var childNode = rowNode.childrenAfterGroup[i];

          if (childNode.childrenAfterGroup) {
            this.depthFirstSearchEverything(rowNode.childrenAfterGroup[i], callback, traverseEverything);
          } else if (traverseEverything) {
            callback(childNode);
          }
        }
      }

      callback(rowNode);
    } // traverseLeafNodes -> used when NOT doing changed path, ie traversing everything. the callback
    // will be called for child nodes in addition to parent nodes.

  }, {
    key: "forEachChangedNodeDepthFirst",
    value: function forEachChangedNodeDepthFirst(callback) {
      var traverseLeafNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var includeUnchangedNodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (this.active && !includeUnchangedNodes) {
        this.depthFirstSearchChangedPath(this.pathRoot, callback);
      } else {
        this.depthFirstSearchEverything(this.pathRoot.rowNode, callback, traverseLeafNodes);
      }
    }
  }, {
    key: "executeFromRootNode",
    value: function executeFromRootNode(callback) {
      callback(this.pathRoot.rowNode);
    }
  }, {
    key: "createPathItems",
    value: function createPathItems(rowNode) {
      var pointer = rowNode;
      var newEntryCount = 0;

      while (!this.mapToItems[pointer.id]) {
        var newEntry = {
          rowNode: pointer,
          children: null
        };
        this.mapToItems[pointer.id] = newEntry;
        newEntryCount++;
        pointer = pointer.parent;
      }

      return newEntryCount;
    }
  }, {
    key: "populateColumnsMap",
    value: function populateColumnsMap(rowNode, columns) {
      var _this483 = this;

      if (!this.keepingColumns || !columns) {
        return;
      }

      var pointer = rowNode;

      while (pointer) {
        if (!this.nodeIdsToColumns[pointer.id]) {
          this.nodeIdsToColumns[pointer.id] = {};
        }

        columns.forEach(function (col) {
          return _this483.nodeIdsToColumns[pointer.id][col.getId()] = true;
        });
        pointer = pointer.parent;
      }
    }
  }, {
    key: "linkPathItems",
    value: function linkPathItems(rowNode, newEntryCount) {
      var pointer = rowNode;

      for (var i = 0; i < newEntryCount; i++) {
        var thisItem = this.mapToItems[pointer.id];
        var parentItem = this.mapToItems[pointer.parent.id];

        if (!parentItem.children) {
          parentItem.children = [];
        }

        parentItem.children.push(thisItem);
        pointer = pointer.parent;
      }
    } // called by
    // 1) change detection (provides cols) and
    // 2) groupStage if doing transaction update (doesn't provide cols)

  }, {
    key: "addParentNode",
    value: function addParentNode(rowNode, columns) {
      if (!rowNode || rowNode.isRowPinned()) {
        return;
      }

      var newEntryCount = this.createPathItems(rowNode);
      this.linkPathItems(rowNode, newEntryCount);
      this.populateColumnsMap(rowNode, columns);
    }
  }, {
    key: "canSkip",
    value: function canSkip(rowNode) {
      return this.active && !this.mapToItems[rowNode.id];
    }
  }, {
    key: "getValueColumnsForNode",
    value: function getValueColumnsForNode(rowNode, valueColumns) {
      if (!this.keepingColumns) {
        return valueColumns;
      }

      var colsForThisNode = this.nodeIdsToColumns[rowNode.id];
      var result = valueColumns.filter(function (col) {
        return colsForThisNode[col.getId()];
      });
      return result;
    }
  }, {
    key: "getNotValueColumnsForNode",
    value: function getNotValueColumnsForNode(rowNode, valueColumns) {
      if (!this.keepingColumns) {
        return null;
      }

      var colsForThisNode = this.nodeIdsToColumns[rowNode.id];
      var result = valueColumns.filter(function (col) {
        return !colsForThisNode[col.getId()];
      });
      return result;
    }
  }]);

  return _ChangedPath;
}(); // community-modules/core/src/rowNodeCache/rowNodeBlock.ts


var _RowNodeBlock =
/*#__PURE__*/
function (_BeanStub67) {
  "use strict";

  _inherits(_RowNodeBlock, _BeanStub67);

  function _RowNodeBlock(id) {
    var _this484;

    _classCallCheck(this, _RowNodeBlock);

    _this484 = _possibleConstructorReturn(this, _getPrototypeOf(_RowNodeBlock).call(this));
    _this484.state = _RowNodeBlock.STATE_WAITING_TO_LOAD;
    _this484.version = 0;
    _this484.id = id;
    return _this484;
  }

  _createClass(_RowNodeBlock, [{
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "load",
    value: function load() {
      this.state = _RowNodeBlock.STATE_LOADING;
      this.loadFromDatasource();
    }
  }, {
    key: "getVersion",
    value: function getVersion() {
      return this.version;
    }
  }, {
    key: "setStateWaitingToLoad",
    value: function setStateWaitingToLoad() {
      this.version++;
      this.state = _RowNodeBlock.STATE_WAITING_TO_LOAD;
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.state;
    }
  }, {
    key: "pageLoadFailed",
    value: function pageLoadFailed(version) {
      var requestMostRecentAndLive = this.isRequestMostRecentAndLive(version);

      if (requestMostRecentAndLive) {
        this.state = _RowNodeBlock.STATE_FAILED;
        this.processServerFail();
      }

      this.dispatchLoadCompleted(false);
    }
  }, {
    key: "success",
    value: function success(version, params) {
      this.successCommon(version, params);
    }
  }, {
    key: "pageLoaded",
    value: function pageLoaded(version, rows, lastRow) {
      this.successCommon(version, {
        rowData: rows,
        rowCount: lastRow
      });
    }
  }, {
    key: "isRequestMostRecentAndLive",
    value: function isRequestMostRecentAndLive(version) {
      var thisIsMostRecentRequest = version === this.version;
      var weAreNotDestroyed = this.isAlive();
      return thisIsMostRecentRequest && weAreNotDestroyed;
    }
  }, {
    key: "successCommon",
    value: function successCommon(version, params) {
      this.dispatchLoadCompleted();
      var requestMostRecentAndLive = this.isRequestMostRecentAndLive(version);

      if (requestMostRecentAndLive) {
        this.state = _RowNodeBlock.STATE_LOADED;
        this.processServerResult(params);
      }
    }
  }, {
    key: "dispatchLoadCompleted",
    value: function dispatchLoadCompleted() {
      var success = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var event = {
        type: _RowNodeBlock.EVENT_LOAD_COMPLETE,
        success: success,
        block: this
      };
      this.dispatchEvent(event);
    }
  }]);

  return _RowNodeBlock;
}(_BeanStub2);

_RowNodeBlock.EVENT_LOAD_COMPLETE = "loadComplete";
_RowNodeBlock.STATE_WAITING_TO_LOAD = "needsLoading";
_RowNodeBlock.STATE_LOADING = "loading";
_RowNodeBlock.STATE_LOADED = "loaded";
_RowNodeBlock.STATE_FAILED = "failed";
var _RowNodeBlock2 = _RowNodeBlock; // community-modules/core/src/rowNodeCache/rowNodeBlockLoader.ts

var _RowNodeBlockLoader2 =
/*#__PURE__*/
function (_BeanStub68) {
  "use strict";

  _inherits(_RowNodeBlockLoader, _BeanStub68);

  function _RowNodeBlockLoader() {
    var _this485;

    _classCallCheck(this, _RowNodeBlockLoader);

    _this485 = _possibleConstructorReturn(this, _getPrototypeOf(_RowNodeBlockLoader).apply(this, arguments));
    _this485.activeBlockLoadsCount = 0;
    _this485.blocks = [];
    _this485.active = true;
    return _this485;
  }

  _createClass(_RowNodeBlockLoader, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.maxConcurrentRequests = this.getMaxConcurrentDatasourceRequests();
      var blockLoadDebounceMillis = this.gos.get("blockLoadDebounceMillis");

      if (blockLoadDebounceMillis && blockLoadDebounceMillis > 0) {
        this.checkBlockToLoadDebounce = _3.debounce(this.performCheckBlocksToLoad.bind(this), blockLoadDebounceMillis);
      }
    }
  }, {
    key: "setBeans",
    value: function setBeans(loggerFactory) {
      this.logger = loggerFactory.create("RowNodeBlockLoader");
    }
  }, {
    key: "getMaxConcurrentDatasourceRequests",
    value: function getMaxConcurrentDatasourceRequests() {
      var res = this.gos.get("maxConcurrentDatasourceRequests");

      if (res == null) {
        return 2;
      }

      if (res <= 0) {
        return;
      }

      return res;
    }
  }, {
    key: "addBlock",
    value: function addBlock(block) {
      this.blocks.push(block);
      block.addEventListener(_RowNodeBlock2.EVENT_LOAD_COMPLETE, this.loadComplete.bind(this));
      this.checkBlockToLoad();
    }
  }, {
    key: "removeBlock",
    value: function removeBlock(block) {
      _3.removeFromArray(this.blocks, block);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(_RowNodeBlockLoader.prototype), "destroy", this).call(this);

      this.active = false;
    }
  }, {
    key: "loadComplete",
    value: function loadComplete() {
      this.activeBlockLoadsCount--;
      this.checkBlockToLoad();
      this.dispatchEvent({
        type: _RowNodeBlockLoader2.BLOCK_LOADED_EVENT
      });

      if (this.activeBlockLoadsCount == 0) {
        this.dispatchEvent({
          type: _RowNodeBlockLoader2.BLOCK_LOADER_FINISHED_EVENT
        });
      }
    }
  }, {
    key: "checkBlockToLoad",
    value: function checkBlockToLoad() {
      if (this.checkBlockToLoadDebounce) {
        this.checkBlockToLoadDebounce();
      } else {
        this.performCheckBlocksToLoad();
      }
    }
  }, {
    key: "performCheckBlocksToLoad",
    value: function performCheckBlocksToLoad() {
      if (!this.active) {
        return;
      }

      this.printCacheStatus();

      if (this.maxConcurrentRequests != null && this.activeBlockLoadsCount >= this.maxConcurrentRequests) {
        this.logger.log("checkBlockToLoad: max loads exceeded");
        return;
      }

      var loadAvailability = this.getAvailableLoadingCount();
      var blocksToLoad = this.blocks.filter(function (block) {
        return block.getState() === _RowNodeBlock2.STATE_WAITING_TO_LOAD;
      }).slice(0, loadAvailability);
      this.registerLoads(blocksToLoad.length);
      blocksToLoad.forEach(function (block) {
        return block.load();
      });
      this.printCacheStatus();
    }
  }, {
    key: "getBlockState",
    value: function getBlockState() {
      if (this.gos.isRowModelType("serverSide")) {
        var ssrm = this.rowModel;
        return ssrm.getBlockStates();
      }

      var result = {};
      this.blocks.forEach(function (block) {
        var _block$getBlockStateJ = block.getBlockStateJson(),
            id = _block$getBlockStateJ.id,
            state = _block$getBlockStateJ.state;

        result[id] = state;
      });
      return result;
    }
  }, {
    key: "printCacheStatus",
    value: function printCacheStatus() {
      if (this.logger.isLogging()) {
        this.logger.log("printCacheStatus: activePageLoadsCount = ".concat(this.activeBlockLoadsCount, ", blocks = ").concat(JSON.stringify(this.getBlockState())));
      }
    }
  }, {
    key: "isLoading",
    value: function isLoading() {
      return this.activeBlockLoadsCount > 0;
    }
  }, {
    key: "registerLoads",
    value: function registerLoads(count) {
      this.activeBlockLoadsCount += count;
    }
  }, {
    key: "getAvailableLoadingCount",
    value: function getAvailableLoadingCount() {
      return this.maxConcurrentRequests !== void 0 ? this.maxConcurrentRequests - this.activeBlockLoadsCount : void 0;
    }
  }]);

  return _RowNodeBlockLoader;
}(_BeanStub2);

_RowNodeBlockLoader2.BLOCK_LOADED_EVENT = "blockLoaded";
_RowNodeBlockLoader2.BLOCK_LOADER_FINISHED_EVENT = "blockLoaderFinished";

__decorateClass([_Autowired("rowModel")], _RowNodeBlockLoader2.prototype, "rowModel", 2);

__decorateClass([_PostConstruct], _RowNodeBlockLoader2.prototype, "postConstruct", 1);

__decorateClass([__decorateParam(0, _Qualifier("loggerFactory"))], _RowNodeBlockLoader2.prototype, "setBeans", 1);

_RowNodeBlockLoader2 = __decorateClass([_Bean("rowNodeBlockLoader")], _RowNodeBlockLoader2); // community-modules/core/src/pagination/paginationProxy.ts

var _PaginationProxy =
/*#__PURE__*/
function (_BeanStub69) {
  "use strict";

  _inherits(_PaginationProxy, _BeanStub69);

  function _PaginationProxy() {
    var _this486;

    _classCallCheck(this, _PaginationProxy);

    _this486 = _possibleConstructorReturn(this, _getPrototypeOf(_PaginationProxy).apply(this, arguments));
    _this486.currentPage = 0;
    _this486.topDisplayedRowIndex = 0;
    _this486.bottomDisplayedRowIndex = 0;
    _this486.pixelOffset = 0;
    _this486.masterRowCount = 0;
    return _this486;
  }

  _createClass(_PaginationProxy, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.active = this.gos.get("pagination");
      this.pageSizeFromGridOptions = this.gos.get("paginationPageSize");
      this.paginateChildRows = this.isPaginateChildRows();
      this.addManagedListener(this.eventService, _Events.EVENT_MODEL_UPDATED, this.onModelUpdated.bind(this));
      this.addManagedPropertyListener("pagination", this.onPaginationGridOptionChanged.bind(this));
      this.addManagedPropertyListener("paginationPageSize", this.onPageSizeGridOptionChanged.bind(this));
      this.onModelUpdated();
    }
  }, {
    key: "ensureRowHeightsValid",
    value: function ensureRowHeightsValid(startPixel, endPixel, startLimitIndex, endLimitIndex) {
      var res = this.rowModel.ensureRowHeightsValid(startPixel, endPixel, this.getPageFirstRow(), this.getPageLastRow());

      if (res) {
        this.calculatePages();
      }

      return res;
    }
  }, {
    key: "isPaginateChildRows",
    value: function isPaginateChildRows() {
      var shouldPaginate = this.gos.get("groupRemoveSingleChildren") || this.gos.get("groupRemoveLowestSingleChildren");

      if (shouldPaginate) {
        return true;
      }

      return this.gos.get("paginateChildRows");
    }
  }, {
    key: "onModelUpdated",
    value: function onModelUpdated(modelUpdatedEvent) {
      this.calculatePages();
      var paginationChangedEvent = {
        type: _Events.EVENT_PAGINATION_CHANGED,
        animate: modelUpdatedEvent ? modelUpdatedEvent.animate : false,
        newData: modelUpdatedEvent ? modelUpdatedEvent.newData : false,
        newPage: modelUpdatedEvent ? modelUpdatedEvent.newPage : false,
        newPageSize: modelUpdatedEvent ? modelUpdatedEvent.newPageSize : false,
        keepRenderedRows: modelUpdatedEvent ? modelUpdatedEvent.keepRenderedRows : false
      };
      this.eventService.dispatchEvent(paginationChangedEvent);
    }
  }, {
    key: "onPaginationGridOptionChanged",
    value: function onPaginationGridOptionChanged() {
      this.active = this.gos.get("pagination");
      this.calculatePages();
      var paginationChangedEvent = {
        type: _Events.EVENT_PAGINATION_CHANGED,
        animate: false,
        newData: false,
        newPage: false,
        newPageSize: false,
        // important to keep rendered rows, otherwise every time grid is resized,
        // we would destroy all the rows.
        keepRenderedRows: true
      };
      this.eventService.dispatchEvent(paginationChangedEvent);
    }
  }, {
    key: "onPageSizeGridOptionChanged",
    value: function onPageSizeGridOptionChanged() {
      this.setPageSize(this.gos.get("paginationPageSize"), "gridOptions");
    }
  }, {
    key: "goToPage",
    value: function goToPage(page) {
      if (!this.active || this.currentPage === page || typeof this.currentPage !== "number") {
        return;
      }

      this.currentPage = page;
      var event = {
        type: _Events.EVENT_MODEL_UPDATED,
        animate: false,
        keepRenderedRows: false,
        newData: false,
        newPage: true,
        newPageSize: false
      };
      this.onModelUpdated(event);
    }
  }, {
    key: "getPixelOffset",
    value: function getPixelOffset() {
      return this.pixelOffset;
    }
  }, {
    key: "getRow",
    value: function getRow(index) {
      return this.rowModel.getRow(index);
    }
  }, {
    key: "getRowNode",
    value: function getRowNode(id) {
      return this.rowModel.getRowNode(id);
    }
  }, {
    key: "getRowIndexAtPixel",
    value: function getRowIndexAtPixel(pixel) {
      return this.rowModel.getRowIndexAtPixel(pixel);
    }
  }, {
    key: "getCurrentPageHeight",
    value: function getCurrentPageHeight() {
      if (_missing(this.topRowBounds) || _missing(this.bottomRowBounds)) {
        return 0;
      }

      return Math.max(this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight - this.topRowBounds.rowTop, 0);
    }
  }, {
    key: "getCurrentPagePixelRange",
    value: function getCurrentPagePixelRange() {
      var pageFirstPixel = this.topRowBounds ? this.topRowBounds.rowTop : 0;
      var pageLastPixel = this.bottomRowBounds ? this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight : 0;
      return {
        pageFirstPixel: pageFirstPixel,
        pageLastPixel: pageLastPixel
      };
    }
  }, {
    key: "isRowPresent",
    value: function isRowPresent(rowNode) {
      if (!this.rowModel.isRowPresent(rowNode)) {
        return false;
      }

      var nodeIsInPage = rowNode.rowIndex >= this.topDisplayedRowIndex && rowNode.rowIndex <= this.bottomDisplayedRowIndex;
      return nodeIsInPage;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.rowModel.isEmpty();
    }
  }, {
    key: "isRowsToRender",
    value: function isRowsToRender() {
      return this.rowModel.isRowsToRender();
    }
  }, {
    key: "forEachNode",
    value: function forEachNode(callback) {
      return this.rowModel.forEachNode(callback);
    }
  }, {
    key: "forEachNodeOnPage",
    value: function forEachNodeOnPage(callback) {
      var firstRow = this.getPageFirstRow();
      var lastRow = this.getPageLastRow();

      for (var i = firstRow; i <= lastRow; i++) {
        var node = this.getRow(i);

        if (node) {
          callback(node);
        }
      }
    }
  }, {
    key: "getType",
    value: function getType() {
      return this.rowModel.getType();
    }
  }, {
    key: "getRowBounds",
    value: function getRowBounds(index) {
      var res = this.rowModel.getRowBounds(index);
      res.rowIndex = index;
      return res;
    }
  }, {
    key: "getPageFirstRow",
    value: function getPageFirstRow() {
      return this.topRowBounds ? this.topRowBounds.rowIndex : -1;
    }
  }, {
    key: "getPageLastRow",
    value: function getPageLastRow() {
      return this.bottomRowBounds ? this.bottomRowBounds.rowIndex : -1;
    }
  }, {
    key: "getRowCount",
    value: function getRowCount() {
      return this.rowModel.getRowCount();
    }
  }, {
    key: "getPageForIndex",
    value: function getPageForIndex(index) {
      return Math.floor(index / this.pageSize);
    }
  }, {
    key: "goToPageWithIndex",
    value: function goToPageWithIndex(index) {
      if (!this.active) {
        return;
      }

      var pageNumber = this.getPageForIndex(index);
      this.goToPage(pageNumber);
    }
  }, {
    key: "isRowInPage",
    value: function isRowInPage(row) {
      if (!this.active) {
        return true;
      }

      var rowPage = this.getPageForIndex(row.rowIndex);
      return rowPage === this.currentPage;
    }
  }, {
    key: "isLastPageFound",
    value: function isLastPageFound() {
      return this.rowModel.isLastRowIndexKnown();
    }
  }, {
    key: "getCurrentPage",
    value: function getCurrentPage() {
      return this.currentPage;
    }
  }, {
    key: "goToNextPage",
    value: function goToNextPage() {
      this.goToPage(this.currentPage + 1);
    }
  }, {
    key: "goToPreviousPage",
    value: function goToPreviousPage() {
      this.goToPage(this.currentPage - 1);
    }
  }, {
    key: "goToFirstPage",
    value: function goToFirstPage() {
      this.goToPage(0);
    }
  }, {
    key: "goToLastPage",
    value: function goToLastPage() {
      var rowCount = this.rowModel.getRowCount();
      var lastPage = Math.floor(rowCount / this.pageSize);
      this.goToPage(lastPage);
    }
  }, {
    key: "getPageSize",
    value: function getPageSize() {
      return this.pageSize;
    }
  }, {
    key: "getTotalPages",
    value: function getTotalPages() {
      return this.totalPages;
    }
    /** This is only for state setting before data has been loaded */

  }, {
    key: "setPage",
    value: function setPage(page) {
      this.currentPage = page;
    }
  }, {
    key: "unsetAutoCalculatedPageSize",
    value: function unsetAutoCalculatedPageSize() {
      if (this.pageSizeAutoCalculated === void 0) {
        return;
      }

      var oldPageSize = this.pageSizeAutoCalculated;
      this.pageSizeAutoCalculated = void 0;

      if (this.pageSize === oldPageSize) {
        return;
      }

      this.onModelUpdated({
        type: _Events.EVENT_MODEL_UPDATED,
        animate: false,
        keepRenderedRows: false,
        newData: false,
        newPage: false,
        newPageSize: true
      });
    }
  }, {
    key: "setPageSize",
    value: function setPageSize(size, source) {
      var currentSize = this.pageSize;

      switch (source) {
        case "autoCalculated":
          this.pageSizeAutoCalculated = size;
          break;

        case "pageSizeSelector":
          this.pageSizeFromPageSizeSelector = size;

          if (this.currentPage !== 0) {
            this.goToFirstPage();
          }

          break;

        case "initialState":
          this.pageSizeFromInitialState = size;
          break;

        case "gridOptions":
          this.pageSizeFromGridOptions = size;
          this.pageSizeFromInitialState = void 0;
          this.pageSizeFromPageSizeSelector = void 0;

          if (this.currentPage !== 0) {
            this.goToFirstPage();
          }

          break;
      }

      if (currentSize !== this.pageSize) {
        var event = {
          type: _Events.EVENT_MODEL_UPDATED,
          animate: false,
          keepRenderedRows: false,
          newData: false,
          newPage: false,
          newPageSize: true
        };
        this.onModelUpdated(event);
      }
    }
  }, {
    key: "calculatePages",
    value: function calculatePages() {
      if (this.active) {
        if (this.paginateChildRows) {
          this.calculatePagesAllRows();
        } else {
          this.calculatePagesMasterRowsOnly();
        }
      } else {
        this.calculatedPagesNotActive();
      }

      this.topRowBounds = this.rowModel.getRowBounds(this.topDisplayedRowIndex);

      if (this.topRowBounds) {
        this.topRowBounds.rowIndex = this.topDisplayedRowIndex;
      }

      this.bottomRowBounds = this.rowModel.getRowBounds(this.bottomDisplayedRowIndex);

      if (this.bottomRowBounds) {
        this.bottomRowBounds.rowIndex = this.bottomDisplayedRowIndex;
      }

      this.setPixelOffset(_exists(this.topRowBounds) ? this.topRowBounds.rowTop : 0);
    }
  }, {
    key: "setPixelOffset",
    value: function setPixelOffset(value) {
      if (this.pixelOffset === value) {
        return;
      }

      this.pixelOffset = value;
      this.eventService.dispatchEvent({
        type: _Events.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED
      });
    }
  }, {
    key: "setZeroRows",
    value: function setZeroRows() {
      this.masterRowCount = 0;
      this.topDisplayedRowIndex = 0;
      this.bottomDisplayedRowIndex = -1;
      this.currentPage = 0;
      this.totalPages = 0;
    }
  }, {
    key: "adjustCurrentPageIfInvalid",
    value: function adjustCurrentPageIfInvalid() {
      if (this.currentPage >= this.totalPages) {
        this.currentPage = this.totalPages - 1;
      }

      if (!isFinite(this.currentPage) || isNaN(this.currentPage) || this.currentPage < 0) {
        this.currentPage = 0;
      }
    }
  }, {
    key: "calculatePagesMasterRowsOnly",
    value: function calculatePagesMasterRowsOnly() {
      this.masterRowCount = this.rowModel.getTopLevelRowCount();

      if (this.masterRowCount <= 0) {
        this.setZeroRows();
        return;
      }

      var masterLastRowIndex = this.masterRowCount - 1;
      this.totalPages = Math.floor(masterLastRowIndex / this.pageSize) + 1;
      this.adjustCurrentPageIfInvalid();
      var masterPageStartIndex = this.pageSize * this.currentPage;
      var masterPageEndIndex = this.pageSize * (this.currentPage + 1) - 1;

      if (masterPageEndIndex > masterLastRowIndex) {
        masterPageEndIndex = masterLastRowIndex;
      }

      this.topDisplayedRowIndex = this.rowModel.getTopLevelRowDisplayedIndex(masterPageStartIndex);

      if (masterPageEndIndex === masterLastRowIndex) {
        this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
      } else {
        var firstIndexNotToShow = this.rowModel.getTopLevelRowDisplayedIndex(masterPageEndIndex + 1);
        this.bottomDisplayedRowIndex = firstIndexNotToShow - 1;
      }
    }
  }, {
    key: "getMasterRowCount",
    value: function getMasterRowCount() {
      return this.masterRowCount;
    }
  }, {
    key: "calculatePagesAllRows",
    value: function calculatePagesAllRows() {
      this.masterRowCount = this.rowModel.getRowCount();

      if (this.masterRowCount === 0) {
        this.setZeroRows();
        return;
      }

      var maxRowIndex = this.masterRowCount - 1;
      this.totalPages = Math.floor(maxRowIndex / this.pageSize) + 1;
      this.adjustCurrentPageIfInvalid();
      this.topDisplayedRowIndex = this.pageSize * this.currentPage;
      this.bottomDisplayedRowIndex = this.pageSize * (this.currentPage + 1) - 1;

      if (this.bottomDisplayedRowIndex > maxRowIndex) {
        this.bottomDisplayedRowIndex = maxRowIndex;
      }
    }
  }, {
    key: "calculatedPagesNotActive",
    value: function calculatedPagesNotActive() {
      this.setPageSize(this.masterRowCount, "autoCalculated");
      this.totalPages = 1;
      this.currentPage = 0;
      this.topDisplayedRowIndex = 0;
      this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
    }
  }, {
    key: "pageSize",
    get: function get() {
      if (_exists(this.pageSizeAutoCalculated)) {
        return this.pageSizeAutoCalculated;
      }

      if (_exists(this.pageSizeFromPageSizeSelector)) {
        return this.pageSizeFromPageSizeSelector;
      }

      if (_exists(this.pageSizeFromInitialState)) {
        return this.pageSizeFromInitialState;
      }

      if (_exists(this.pageSizeFromGridOptions)) {
        return this.pageSizeFromGridOptions;
      }

      return this.defaultPageSize;
    }
  }]);

  return _PaginationProxy;
}(_BeanStub2);

__decorateClass([_Autowired("rowModel")], _PaginationProxy.prototype, "rowModel", 2);

__decorateClass([_PostConstruct], _PaginationProxy.prototype, "postConstruct", 1);

_PaginationProxy = __decorateClass([_Bean("paginationProxy")], _PaginationProxy); // community-modules/core/src/styling/stylingService.ts

var _StylingService =
/*#__PURE__*/
function (_BeanStub70) {
  "use strict";

  _inherits(_StylingService, _BeanStub70);

  function _StylingService() {
    _classCallCheck(this, _StylingService);

    return _possibleConstructorReturn(this, _getPrototypeOf(_StylingService).apply(this, arguments));
  }

  _createClass(_StylingService, [{
    key: "processAllCellClasses",
    value: function processAllCellClasses(colDef, params, onApplicableClass, onNotApplicableClass) {
      this.processClassRules(void 0, colDef.cellClassRules, params, onApplicableClass, onNotApplicableClass);
      this.processStaticCellClasses(colDef, params, onApplicableClass);
    }
  }, {
    key: "processClassRules",
    value: function processClassRules(previousClassRules, classRules, params, onApplicableClass, onNotApplicableClass) {
      var _this487 = this;

      if (classRules == null && previousClassRules == null) {
        return;
      }

      var classesToApply = {};
      var classesToRemove = {};

      var forEachSingleClass = function forEachSingleClass(className, callback) {
        className.split(" ").forEach(function (singleClass) {
          if (singleClass.trim() == "") return;
          callback(singleClass);
        });
      };

      if (classRules) {
        var classNames = Object.keys(classRules);

        var _loop7 = function _loop7(i) {
          var className = classNames[i];
          var rule = classRules[className];
          var resultOfRule = void 0;

          if (typeof rule === "string") {
            resultOfRule = _this487.expressionService.evaluate(rule, params);
          } else if (typeof rule === "function") {
            resultOfRule = rule(params);
          }

          forEachSingleClass(className, function (singleClass) {
            resultOfRule ? classesToApply[singleClass] = true : classesToRemove[singleClass] = true;
          });
        };

        for (var i = 0; i < classNames.length; i++) {
          _loop7(i);
        }
      }

      if (previousClassRules && onNotApplicableClass) {
        Object.keys(previousClassRules).forEach(function (className) {
          return forEachSingleClass(className, function (singleClass) {
            if (!classesToApply[singleClass]) {
              classesToRemove[singleClass] = true;
            }
          });
        });
      }

      if (onNotApplicableClass) {
        Object.keys(classesToRemove).forEach(onNotApplicableClass);
      }

      Object.keys(classesToApply).forEach(onApplicableClass);
    }
  }, {
    key: "getStaticCellClasses",
    value: function getStaticCellClasses(colDef, params) {
      var cellClass = colDef.cellClass;

      if (!cellClass) {
        return [];
      }

      var classOrClasses;

      if (typeof cellClass === "function") {
        var cellClassFunc = cellClass;
        classOrClasses = cellClassFunc(params);
      } else {
        classOrClasses = cellClass;
      }

      if (typeof classOrClasses === "string") {
        classOrClasses = [classOrClasses];
      }

      return classOrClasses || [];
    }
  }, {
    key: "processStaticCellClasses",
    value: function processStaticCellClasses(colDef, params, onApplicableClass) {
      var classOrClasses = this.getStaticCellClasses(colDef, params);
      classOrClasses.forEach(function (cssClassItem) {
        onApplicableClass(cssClassItem);
      });
    }
  }]);

  return _StylingService;
}(_BeanStub2);

__decorateClass([_Autowired("expressionService")], _StylingService.prototype, "expressionService", 2);

_StylingService = __decorateClass([_Bean("stylingService")], _StylingService); // community-modules/core/src/widgets/agToggleButton.ts

var _AgToggleButton =
/*#__PURE__*/
function (_AgCheckbox3) {
  "use strict";

  _inherits(_AgToggleButton, _AgCheckbox3);

  function _AgToggleButton(config) {
    _classCallCheck(this, _AgToggleButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(_AgToggleButton).call(this, config, "ag-toggle-button"));
  }

  _createClass(_AgToggleButton, [{
    key: "setValue",
    value: function setValue(value, silent) {
      _get(_getPrototypeOf(_AgToggleButton.prototype), "setValue", this).call(this, value, silent);

      this.addOrRemoveCssClass("ag-selected", this.getValue());
      return this;
    }
  }]);

  return _AgToggleButton;
}(_AgCheckbox); // community-modules/core/src/widgets/agInputTextArea.ts


var _AgInputTextArea =
/*#__PURE__*/
function (_AgAbstractInputField3) {
  "use strict";

  _inherits(_AgInputTextArea, _AgAbstractInputField3);

  function _AgInputTextArea(config) {
    _classCallCheck(this, _AgInputTextArea);

    return _possibleConstructorReturn(this, _getPrototypeOf(_AgInputTextArea).call(this, config, "ag-text-area", null, "textarea"));
  }

  _createClass(_AgInputTextArea, [{
    key: "setValue",
    value: function setValue(value, silent) {
      var ret = _get(_getPrototypeOf(_AgInputTextArea.prototype), "setValue", this).call(this, value, silent);

      this.eInput.value = value;
      return ret;
    }
  }, {
    key: "setCols",
    value: function setCols(cols) {
      this.eInput.cols = cols;
      return this;
    }
  }, {
    key: "setRows",
    value: function setRows(rows) {
      this.eInput.rows = rows;
      return this;
    }
  }]);

  return _AgInputTextArea;
}(AgAbstractInputField); // community-modules/core/src/widgets/agInputDateField.ts


var _AgInputDateField =
/*#__PURE__*/
function (_AgInputTextField3) {
  "use strict";

  _inherits(_AgInputDateField, _AgInputTextField3);

  function _AgInputDateField(config) {
    _classCallCheck(this, _AgInputDateField);

    return _possibleConstructorReturn(this, _getPrototypeOf(_AgInputDateField).call(this, config, "ag-date-field", "date"));
  }

  _createClass(_AgInputDateField, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this488 = this;

      _get(_getPrototypeOf(_AgInputDateField.prototype), "postConstruct", this).call(this);

      this.addManagedListener(this.eInput, "wheel", this.onWheel.bind(this));

      var usingSafari = _isBrowserSafari();

      this.addManagedListener(this.eInput, "mousedown", function () {
        if (_this488.isDisabled() || usingSafari) {
          return;
        }

        _this488.eInput.focus();
      });
      this.eInput.step = "any";
    }
  }, {
    key: "onWheel",
    value: function onWheel(e) {
      if (this.gos.getActiveDomElement() === this.eInput) {
        e.preventDefault();
      }
    }
  }, {
    key: "setMin",
    value: function setMin(minDate) {
      var _a;

      var min = minDate instanceof Date ? (_a = _serialiseDate(minDate != null ? minDate : null, false)) != null ? _a : void 0 : minDate;

      if (this.min === min) {
        return this;
      }

      this.min = min;

      _addOrRemoveAttribute(this.eInput, "min", min);

      return this;
    }
  }, {
    key: "setMax",
    value: function setMax(maxDate) {
      var _a;

      var max = maxDate instanceof Date ? (_a = _serialiseDate(maxDate != null ? maxDate : null, false)) != null ? _a : void 0 : maxDate;

      if (this.max === max) {
        return this;
      }

      this.max = max;

      _addOrRemoveAttribute(this.eInput, "max", max);

      return this;
    }
  }, {
    key: "setStep",
    value: function setStep(step) {
      if (this.step === step) {
        return this;
      }

      this.step = step;

      _addOrRemoveAttribute(this.eInput, "step", step);

      return this;
    }
  }, {
    key: "getDate",
    value: function getDate() {
      var _a;

      if (!this.eInput.validity.valid) {
        return void 0;
      }

      return (_a = _parseDateTimeFromString(this.getValue())) != null ? _a : void 0;
    }
  }, {
    key: "setDate",
    value: function setDate(date, silent) {
      this.setValue(_serialiseDate(date != null ? date : null, false), silent);
    }
  }]);

  return _AgInputDateField;
}(_AgInputTextField); // community-modules/core/src/widgets/agInputRange.ts


var _AgInputRange =
/*#__PURE__*/
function (_AgAbstractInputField4) {
  "use strict";

  _inherits(_AgInputRange, _AgAbstractInputField4);

  function _AgInputRange(config) {
    _classCallCheck(this, _AgInputRange);

    return _possibleConstructorReturn(this, _getPrototypeOf(_AgInputRange).call(this, config, "ag-range-field", "range"));
  }

  _createClass(_AgInputRange, [{
    key: "postConstruct",
    value: function postConstruct() {
      _get(_getPrototypeOf(_AgInputRange.prototype), "postConstruct", this).call(this);

      var _this$config13 = this.config,
          min = _this$config13.min,
          max = _this$config13.max,
          step = _this$config13.step;

      if (min != null) {
        this.setMinValue(min);
      }

      if (max != null) {
        this.setMaxValue(max);
      }

      this.setStep(step || 1);
    }
  }, {
    key: "addInputListeners",
    value: function addInputListeners() {
      var _this489 = this;

      this.addManagedListener(this.eInput, "input", function (e) {
        var value = e.target.value;

        _this489.setValue(value);
      });
    }
  }, {
    key: "setMinValue",
    value: function setMinValue(value) {
      this.min = value;
      this.eInput.setAttribute("min", value.toString());
      return this;
    }
  }, {
    key: "setMaxValue",
    value: function setMaxValue(value) {
      this.max = value;
      this.eInput.setAttribute("max", value.toString());
      return this;
    }
  }, {
    key: "setStep",
    value: function setStep(value) {
      this.eInput.setAttribute("step", value.toString());
      return this;
    }
  }, {
    key: "setValue",
    value: function setValue(value, silent) {
      if (this.min != null) {
        value = Math.max(parseFloat(value), this.min).toString();
      }

      if (this.max != null) {
        value = Math.min(parseFloat(value), this.max).toString();
      }

      var ret = _get(_getPrototypeOf(_AgInputRange.prototype), "setValue", this).call(this, value, silent);

      this.eInput.value = value;
      return ret;
    }
  }]);

  return _AgInputRange;
}(AgAbstractInputField); // community-modules/core/src/widgets/agRichSelectRow.ts


var RichSelectRow =
/*#__PURE__*/
function (_Component35) {
  "use strict";

  _inherits(RichSelectRow, _Component35);

  function RichSelectRow(params, wrapperEl) {
    var _this490;

    _classCallCheck(this, RichSelectRow);

    _this490 = _possibleConstructorReturn(this, _getPrototypeOf(RichSelectRow).call(this,
    /* html */
    "<div class=\"ag-rich-select-row\" role=\"presentation\"></div>"));
    _this490.params = params;
    _this490.wrapperEl = wrapperEl;
    return _this490;
  }

  _createClass(RichSelectRow, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.addManagedListener(this.getGui(), "click", this.onClick.bind(this));
    }
  }, {
    key: "setState",
    value: function setState(value) {
      var formattedValue = "";

      if (this.params.valueFormatter) {
        formattedValue = this.params.valueFormatter(value);
      }

      var rendererSuccessful = this.populateWithRenderer(value, formattedValue);

      if (!rendererSuccessful) {
        this.populateWithoutRenderer(value, formattedValue);
      }

      this.value = value;
    }
  }, {
    key: "highlightString",
    value: function highlightString(matchString) {
      var parsedValue = this.parsedValue;

      if (this.params.cellRenderer || !_exists(parsedValue)) {
        return;
      }

      var hasMatch = _exists(matchString);

      if (hasMatch) {
        var index = parsedValue == null ? void 0 : parsedValue.toLocaleLowerCase().indexOf(matchString.toLocaleLowerCase());

        if (index >= 0) {
          var highlightEndIndex = index + matchString.length;

          var startPart = _escapeString(parsedValue.slice(0, index), true);

          var highlightedPart = _escapeString(parsedValue.slice(index, highlightEndIndex), true);

          var endPart = _escapeString(parsedValue.slice(highlightEndIndex));

          this.renderValueWithoutRenderer("".concat(startPart, "<span class=\"ag-rich-select-row-text-highlight\">").concat(highlightedPart, "</span>").concat(endPart));
        } else {
          hasMatch = false;
        }
      }

      if (!hasMatch) {
        this.renderValueWithoutRenderer(parsedValue);
      }
    }
  }, {
    key: "updateHighlighted",
    value: function updateHighlighted(highlighted) {
      var _a;

      var eGui = this.getGui();
      var parentId = "ag-rich-select-row-".concat(this.getCompId());
      (_a = eGui.parentElement) == null ? void 0 : _a.setAttribute("id", parentId);

      if (highlighted) {
        var parentAriaEl = this.getParentComponent().getAriaElement();

        _setAriaActiveDescendant(parentAriaEl, parentId);

        this.wrapperEl.setAttribute("data-active-option", parentId);
      }

      _setAriaSelected(eGui.parentElement, highlighted);

      this.addOrRemoveCssClass("ag-rich-select-row-selected", highlighted);
    }
  }, {
    key: "populateWithoutRenderer",
    value: function populateWithoutRenderer(value, valueFormatted) {
      var eDocument = this.gos.getDocument();
      var eGui = this.getGui();
      var span = eDocument.createElement("span");
      span.style.overflow = "hidden";
      span.style.textOverflow = "ellipsis";

      var parsedValue = _escapeString(_exists(valueFormatted) ? valueFormatted : value, true);

      this.parsedValue = _exists(parsedValue) ? parsedValue : null;
      eGui.appendChild(span);
      this.renderValueWithoutRenderer(parsedValue);
      this.setTooltip({
        newTooltipText: this.parsedValue,
        shouldDisplayTooltip: function shouldDisplayTooltip() {
          return span.scrollWidth > span.clientWidth;
        }
      });
    }
  }, {
    key: "renderValueWithoutRenderer",
    value: function renderValueWithoutRenderer(value) {
      var span = this.getGui().querySelector("span");

      if (!span) {
        return;
      }

      span.innerHTML = _exists(value) ? value : "&nbsp;";
    }
  }, {
    key: "populateWithRenderer",
    value: function populateWithRenderer(value, valueFormatted) {
      var _this491 = this;

      var cellRendererPromise;
      var userCompDetails;

      if (this.params.cellRenderer) {
        userCompDetails = this.userComponentFactory.getCellRendererDetails(this.params, {
          value: value,
          valueFormatted: valueFormatted,
          setTooltip: function setTooltip(value2, shouldDisplayTooltip) {
            _this491.setTooltip({
              newTooltipText: value2,
              shouldDisplayTooltip: shouldDisplayTooltip
            });
          }
        });
      }

      if (userCompDetails) {
        cellRendererPromise = userCompDetails.newAgStackInstance();
      }

      if (cellRendererPromise) {
        _bindCellRendererToHtmlElement(cellRendererPromise, this.getGui());
      }

      if (cellRendererPromise) {
        cellRendererPromise.then(function (childComponent) {
          _this491.addDestroyFunc(function () {
            _this491.getContext().destroyBean(childComponent);
          });
        });
        return true;
      }

      return false;
    }
  }, {
    key: "onClick",
    value: function onClick() {
      var parent = this.getParentComponent();
      var event = {
        type: _Events.EVENT_FIELD_PICKER_VALUE_SELECTED,
        fromEnterKey: false,
        value: this.value
      };
      parent == null ? void 0 : parent.dispatchEvent(event);
    }
  }]);

  return RichSelectRow;
}(_Component2);

__decorateClass([_Autowired("userComponentFactory")], RichSelectRow.prototype, "userComponentFactory", 2);

__decorateClass([_PostConstruct], RichSelectRow.prototype, "postConstruct", 1); // community-modules/core/src/widgets/virtualList.ts


var _VirtualList =
/*#__PURE__*/
function (_TabGuardComp3) {
  "use strict";

  _inherits(_VirtualList, _TabGuardComp3);

  function _VirtualList(params) {
    var _this492;

    _classCallCheck(this, _VirtualList);

    _this492 = _possibleConstructorReturn(this, _getPrototypeOf(_VirtualList).call(this, _VirtualList.getTemplate((params == null ? void 0 : params.cssIdentifier) || "default")));
    _this492.renderedRows =
    /* @__PURE__ */
    new Map();
    _this492.rowHeight = 20;
    _this492.pageSize = -1;
    _this492.isScrolling = false;
    _this492.isHeightFromTheme = true;

    var _ref48 = params || {},
        _ref48$cssIdentifier = _ref48.cssIdentifier,
        cssIdentifier = _ref48$cssIdentifier === void 0 ? "default" : _ref48$cssIdentifier,
        _ref48$ariaRole = _ref48.ariaRole,
        ariaRole = _ref48$ariaRole === void 0 ? "listbox" : _ref48$ariaRole,
        listName = _ref48.listName;

    _this492.cssIdentifier = cssIdentifier;
    _this492.ariaRole = ariaRole;
    _this492.listName = listName;
    return _this492;
  }

  _createClass(_VirtualList, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this493 = this;

      this.addScrollListener();
      this.rowHeight = this.getItemHeight();
      this.addResizeObserver();
      this.initialiseTabGuard({
        onFocusIn: function onFocusIn(e) {
          return _this493.onFocusIn(e);
        },
        onFocusOut: function onFocusOut(e) {
          return _this493.onFocusOut(e);
        },
        focusInnerElement: function focusInnerElement(fromBottom) {
          return _this493.focusInnerElement(fromBottom);
        },
        onTabKeyDown: function onTabKeyDown(e) {
          return _this493.onTabKeyDown(e);
        },
        handleKeyDown: function handleKeyDown(e) {
          return _this493.handleKeyDown(e);
        }
      });
      this.setAriaProperties();
      this.addManagedListener(this.eventService, _Events.EVENT_GRID_STYLES_CHANGED, this.onGridStylesChanged.bind(this));
    }
  }, {
    key: "onGridStylesChanged",
    value: function onGridStylesChanged() {
      this.rowHeight = this.getItemHeight();
      this.refresh();
    }
  }, {
    key: "setAriaProperties",
    value: function setAriaProperties() {
      var translate = this.localeService.getLocaleTextFunc();
      var listName = translate("ariaDefaultListName", this.listName || "List");
      var ariaEl = this.eContainer;

      _setAriaRole(ariaEl, this.ariaRole);

      _setAriaLabel(ariaEl, listName);
    }
  }, {
    key: "addResizeObserver",
    value: function addResizeObserver() {
      var _this494 = this;

      var listener = function listener() {
        return _this494.animationFrameService.requestAnimationFrame(function () {
          return _this494.drawVirtualRows();
        });
      };

      var destroyObserver = this.resizeObserverService.observeResize(this.getGui(), listener);
      this.addDestroyFunc(destroyObserver);
    }
  }, {
    key: "focusInnerElement",
    value: function focusInnerElement(fromBottom) {
      this.focusRow(fromBottom ? this.model.getRowCount() - 1 : 0);
    }
  }, {
    key: "onFocusIn",
    value: function onFocusIn(e) {
      var target = e.target;

      if (target.classList.contains("ag-virtual-list-item")) {
        this.lastFocusedRowIndex = _getAriaPosInSet(target) - 1;
      }
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut(e) {
      if (!this.getFocusableElement().contains(e.relatedTarget)) {
        this.lastFocusedRowIndex = null;
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      switch (e.key) {
        case _KeyCode.UP:
        case _KeyCode.DOWN:
          if (this.navigate(e.key === _KeyCode.UP)) {
            e.preventDefault();
          }

          break;

        case _KeyCode.PAGE_HOME:
        case _KeyCode.PAGE_END:
        case _KeyCode.PAGE_UP:
        case _KeyCode.PAGE_DOWN:
          if (this.navigateToPage(e.key) !== null) {
            e.preventDefault();
          }

          break;
      }
    }
  }, {
    key: "onTabKeyDown",
    value: function onTabKeyDown(e) {
      if (this.navigate(e.shiftKey)) {
        e.preventDefault();
      } else {
        _stopPropagationForAgGrid(e);

        this.forceFocusOutOfContainer(e.shiftKey);
      }
    }
  }, {
    key: "navigate",
    value: function navigate(up) {
      if (this.lastFocusedRowIndex == null) {
        return false;
      }

      var nextRow = this.lastFocusedRowIndex + (up ? -1 : 1);

      if (nextRow < 0 || nextRow >= this.model.getRowCount()) {
        return false;
      }

      this.focusRow(nextRow);
      return true;
    }
  }, {
    key: "navigateToPage",
    value: function navigateToPage(key) {
      var fromItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "focused";
      var hasFocus = false;

      if (fromItem === "focused") {
        fromItem = this.getLastFocusedRow();
        hasFocus = true;
      }

      var rowCount = this.model.getRowCount() - 1;
      var newIndex = -1;

      if (key === _KeyCode.PAGE_HOME) {
        newIndex = 0;
      } else if (key === _KeyCode.PAGE_END) {
        newIndex = rowCount;
      } else if (key === _KeyCode.PAGE_DOWN) {
        newIndex = Math.min(fromItem + this.pageSize, rowCount);
      } else if (key === _KeyCode.PAGE_UP) {
        newIndex = Math.max(fromItem - this.pageSize, 0);
      }

      if (newIndex === -1) {
        return null;
      }

      if (hasFocus) {
        this.focusRow(newIndex);
      } else {
        this.ensureIndexVisible(newIndex);
      }

      return newIndex;
    }
  }, {
    key: "getLastFocusedRow",
    value: function getLastFocusedRow() {
      return this.lastFocusedRowIndex;
    }
  }, {
    key: "focusRow",
    value: function focusRow(rowNumber) {
      var _this495 = this;

      if (this.isScrolling) {
        return;
      }

      this.isScrolling = true;
      this.ensureIndexVisible(rowNumber);
      this.animationFrameService.requestAnimationFrame(function () {
        _this495.isScrolling = false;

        if (!_this495.isAlive()) {
          return;
        }

        var renderedRow = _this495.renderedRows.get(rowNumber);

        if (renderedRow) {
          renderedRow.eDiv.focus();
        }
      });
    }
  }, {
    key: "getComponentAt",
    value: function getComponentAt(rowIndex) {
      var comp = this.renderedRows.get(rowIndex);
      return comp && comp.rowComponent;
    }
  }, {
    key: "forEachRenderedRow",
    value: function forEachRenderedRow(func) {
      this.renderedRows.forEach(function (value, key) {
        return func(value.rowComponent, key);
      });
    }
  }, {
    key: "getItemHeight",
    value: function getItemHeight() {
      if (!this.isHeightFromTheme) {
        return this.rowHeight;
      }

      return this.environment.getListItemHeight();
    }
    /**
     * Returns true if the view had to be scrolled, otherwise, false.
     */

  }, {
    key: "ensureIndexVisible",
    value: function ensureIndexVisible(index) {
      var scrollPartialIntoView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var lastRow = this.model.getRowCount();

      if (typeof index !== "number" || index < 0 || index >= lastRow) {
        console.warn("AG Grid: invalid row index for ensureIndexVisible: " + index);
        return false;
      }

      var rowTopPixel = index * this.rowHeight;
      var rowBottomPixel = rowTopPixel + this.rowHeight;
      var eGui = this.getGui();
      var viewportTopPixel = eGui.scrollTop;
      var viewportHeight = eGui.offsetHeight;
      var viewportBottomPixel = viewportTopPixel + viewportHeight;
      var diff = scrollPartialIntoView ? 0 : this.rowHeight;
      var viewportScrolledPastRow = viewportTopPixel > rowTopPixel + diff;
      var viewportScrolledBeforeRow = viewportBottomPixel < rowBottomPixel - diff;

      if (viewportScrolledPastRow) {
        eGui.scrollTop = rowTopPixel;
        return true;
      }

      if (viewportScrolledBeforeRow) {
        var newScrollPosition = rowBottomPixel - viewportHeight;
        eGui.scrollTop = newScrollPosition;
        return true;
      }

      return false;
    }
  }, {
    key: "setComponentCreator",
    value: function setComponentCreator(componentCreator) {
      this.componentCreator = componentCreator;
    }
  }, {
    key: "setComponentUpdater",
    value: function setComponentUpdater(componentUpdater) {
      this.componentUpdater = componentUpdater;
    }
  }, {
    key: "getRowHeight",
    value: function getRowHeight() {
      return this.rowHeight;
    }
  }, {
    key: "getScrollTop",
    value: function getScrollTop() {
      return this.getGui().scrollTop;
    }
  }, {
    key: "setRowHeight",
    value: function setRowHeight(rowHeight) {
      this.isHeightFromTheme = false;
      this.rowHeight = rowHeight;
      this.refresh();
    }
  }, {
    key: "refresh",
    value: function refresh(softRefresh) {
      var _this496 = this;

      if (this.model == null || !this.isAlive()) {
        return;
      }

      var rowCount = this.model.getRowCount();
      this.eContainer.style.height = "".concat(rowCount * this.rowHeight, "px");

      _waitUntil(function () {
        return _this496.eContainer.clientHeight >= rowCount * _this496.rowHeight;
      }, function () {
        if (!_this496.isAlive()) {
          return;
        }

        if (_this496.canSoftRefresh(softRefresh)) {
          _this496.drawVirtualRows(true);
        } else {
          _this496.clearVirtualRows();

          _this496.drawVirtualRows();
        }
      });
    }
  }, {
    key: "canSoftRefresh",
    value: function canSoftRefresh(softRefresh) {
      return !!(softRefresh && this.renderedRows.size && typeof this.model.areRowsEqual === "function" && this.componentUpdater);
    }
  }, {
    key: "clearVirtualRows",
    value: function clearVirtualRows() {
      var _this497 = this;

      this.renderedRows.forEach(function (_2, rowIndex) {
        return _this497.removeRow(rowIndex);
      });
    }
  }, {
    key: "drawVirtualRows",
    value: function drawVirtualRows(softRefresh) {
      if (!this.isAlive() || !this.model) {
        return;
      }

      var gui = this.getGui();
      var topPixel = gui.scrollTop;
      var bottomPixel = topPixel + gui.offsetHeight;
      var firstRow = Math.floor(topPixel / this.rowHeight);
      var lastRow = Math.floor(bottomPixel / this.rowHeight);
      this.pageSize = Math.floor((bottomPixel - topPixel) / this.rowHeight);
      this.ensureRowsRendered(firstRow, lastRow, softRefresh);
    }
  }, {
    key: "ensureRowsRendered",
    value: function ensureRowsRendered(start, finish, softRefresh) {
      var _this498 = this;

      this.renderedRows.forEach(function (_2, rowIndex) {
        if ((rowIndex < start || rowIndex > finish) && rowIndex !== _this498.lastFocusedRowIndex) {
          _this498.removeRow(rowIndex);
        }
      });

      if (softRefresh) {
        this.refreshRows();
      }

      for (var rowIndex = start; rowIndex <= finish; rowIndex++) {
        if (this.renderedRows.has(rowIndex)) {
          continue;
        }

        if (rowIndex < this.model.getRowCount()) {
          this.insertRow(rowIndex);
        }
      }
    }
  }, {
    key: "insertRow",
    value: function insertRow(rowIndex) {
      var _this499 = this;

      var value = this.model.getRow(rowIndex);
      var eDiv = document.createElement("div");
      eDiv.classList.add("ag-virtual-list-item", "ag-".concat(this.cssIdentifier, "-virtual-list-item"));

      _setAriaRole(eDiv, this.ariaRole === "tree" ? "treeitem" : "option");

      _setAriaSetSize(eDiv, this.model.getRowCount());

      _setAriaPosInSet(eDiv, rowIndex + 1);

      eDiv.setAttribute("tabindex", "-1");
      eDiv.style.height = "".concat(this.rowHeight, "px");
      eDiv.style.top = "".concat(this.rowHeight * rowIndex, "px");
      var rowComponent = this.componentCreator(value, eDiv);
      rowComponent.addGuiEventListener("focusin", function () {
        return _this499.lastFocusedRowIndex = rowIndex;
      });
      eDiv.appendChild(rowComponent.getGui());

      if (this.renderedRows.has(rowIndex - 1)) {
        this.renderedRows.get(rowIndex - 1).eDiv.insertAdjacentElement("afterend", eDiv);
      } else if (this.renderedRows.has(rowIndex + 1)) {
        this.renderedRows.get(rowIndex + 1).eDiv.insertAdjacentElement("beforebegin", eDiv);
      } else {
        this.eContainer.appendChild(eDiv);
      }

      this.renderedRows.set(rowIndex, {
        rowComponent: rowComponent,
        eDiv: eDiv,
        value: value
      });
    }
  }, {
    key: "removeRow",
    value: function removeRow(rowIndex) {
      var component = this.renderedRows.get(rowIndex);
      this.eContainer.removeChild(component.eDiv);
      this.destroyBean(component.rowComponent);
      this.renderedRows.delete(rowIndex);
    }
  }, {
    key: "refreshRows",
    value: function refreshRows() {
      var _this500 = this;

      var rowCount = this.model.getRowCount();
      this.renderedRows.forEach(function (row, rowIndex) {
        var _a, _b;

        if (rowIndex >= rowCount) {
          _this500.removeRow(rowIndex);
        } else {
          var newValue = _this500.model.getRow(rowIndex);

          if ((_b = (_a = _this500.model).areRowsEqual) == null ? void 0 : _b.call(_a, row.value, newValue)) {
            _this500.componentUpdater(newValue, row.rowComponent);
          } else {
            _this500.removeRow(rowIndex);
          }
        }
      });
    }
  }, {
    key: "addScrollListener",
    value: function addScrollListener() {
      var _this501 = this;

      this.addGuiEventListener("scroll", function () {
        return _this501.drawVirtualRows();
      }, {
        passive: true
      });
    }
  }, {
    key: "setModel",
    value: function setModel(model) {
      this.model = model;
    }
  }, {
    key: "getAriaElement",
    value: function getAriaElement() {
      return this.eContainer;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (!this.isAlive()) {
        return;
      }

      this.clearVirtualRows();

      _get(_getPrototypeOf(_VirtualList.prototype), "destroy", this).call(this);
    }
  }], [{
    key: "getTemplate",
    value: function getTemplate(cssIdentifier) {
      return (
        /* html */
        "<div class=\"ag-virtual-list-viewport ag-".concat(cssIdentifier, "-virtual-list-viewport\" role=\"presentation\">\n                <div class=\"ag-virtual-list-container ag-").concat(cssIdentifier, "-virtual-list-container\" ref=\"eContainer\"></div>\n            </div>")
      );
    }
  }]);

  return _VirtualList;
}(_TabGuardComp);

__decorateClass([_Autowired("resizeObserverService")], _VirtualList.prototype, "resizeObserverService", 2);

__decorateClass([_Autowired("animationFrameService")], _VirtualList.prototype, "animationFrameService", 2);

__decorateClass([_RefSelector("eContainer")], _VirtualList.prototype, "eContainer", 2);

__decorateClass([_PostConstruct], _VirtualList.prototype, "postConstruct", 1);

var _VirtualList2 = _VirtualList; // community-modules/core/src/widgets/agRichSelect.ts

var TEMPLATE2 =
/* html */
"\n    <div class=\"ag-picker-field\" role=\"presentation\">\n        <div ref=\"eLabel\"></div>\n            <div ref=\"eWrapper\" class=\"ag-wrapper ag-picker-field-wrapper ag-rich-select-value ag-picker-collapsed\">\n            <div ref=\"eDisplayField\" class=\"ag-picker-field-display\"></div>\n            <ag-input-text-field ref=\"eInput\" class=\"ag-rich-select-field-input\"></ag-input-text-field>\n            <div ref=\"eIcon\" class=\"ag-picker-field-icon\" aria-hidden=\"true\"></div>\n        </div>\n    </div>";

var _AgRichSelect =
/*#__PURE__*/
function (_AgPickerField3) {
  "use strict";

  _inherits(_AgRichSelect, _AgPickerField3);

  function _AgRichSelect(config) {
    var _this502;

    _classCallCheck(this, _AgRichSelect);

    var _a, _b;

    _this502 = _possibleConstructorReturn(this, _getPrototypeOf(_AgRichSelect).call(this, __spreadProps(__spreadValues({
      pickerAriaLabelKey: "ariaLabelRichSelectField",
      pickerAriaLabelValue: "Rich Select Field",
      pickerType: "ag-list",
      className: "ag-rich-select",
      pickerIcon: "smallDown",
      ariaRole: "combobox",
      template: (_a = config == null ? void 0 : config.template) != null ? _a : TEMPLATE2,
      modalPicker: false
    }, config), {
      // maxPickerHeight needs to be set after expanding `config`
      maxPickerHeight: (_b = config == null ? void 0 : config.maxPickerHeight) != null ? _b : "calc(var(--ag-row-height) * 6.5)"
    })));
    _this502.searchString = "";
    _this502.highlightedItem = -1;
    _this502.lastRowHovered = -1;
    _this502.searchStringCreator = null;

    var _ref49 = config || {},
        cellRowHeight = _ref49.cellRowHeight,
        value = _ref49.value,
        valueList = _ref49.valueList,
        searchStringCreator = _ref49.searchStringCreator;

    if (cellRowHeight != null) {
      _this502.cellRowHeight = cellRowHeight;
    }

    if (value !== void 0) {
      _this502.value = value;
    }

    if (valueList != null) {
      _this502.values = valueList;
    }

    if (searchStringCreator) {
      _this502.searchStringCreator = searchStringCreator;
    }

    return _this502;
  }

  _createClass(_AgRichSelect, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this503 = this;

      _get(_getPrototypeOf(_AgRichSelect.prototype), "postConstruct", this).call(this);

      this.createLoadingElement();
      this.createListComponent();
      var _this$config14 = this.config,
          allowTyping = _this$config14.allowTyping,
          placeholder = _this$config14.placeholder;

      if (allowTyping) {
        this.eInput.setAutoComplete(false).setInputPlaceholder(placeholder);
        this.eDisplayField.classList.add("ag-hidden");
      } else {
        this.eInput.setDisplayed(false);
      }

      this.eWrapper.tabIndex = this.gos.get("tabIndex");
      var _this$config$searchDe = this.config.searchDebounceDelay,
          searchDebounceDelay = _this$config$searchDe === void 0 ? 300 : _this$config$searchDe;
      this.clearSearchString = _debounce(this.clearSearchString, searchDebounceDelay);
      this.renderSelectedValue();

      if (allowTyping) {
        this.eInput.onValueChange(function (value) {
          return _this503.searchTextFromString(value);
        });
        this.addManagedListener(this.eWrapper, "focus", this.onWrapperFocus.bind(this));
      }

      this.addManagedListener(this.eWrapper, "focusout", this.onWrapperFocusOut.bind(this));
    }
  }, {
    key: "createLoadingElement",
    value: function createLoadingElement() {
      var eDocument = this.gos.getDocument();
      var translate = this.localeService.getLocaleTextFunc();
      var el = eDocument.createElement("div");
      el.classList.add("ag-loading-text");
      el.innerText = translate("loadingOoo", "Loading...");
      this.eLoading = el;
    }
  }, {
    key: "createListComponent",
    value: function createListComponent() {
      var _this504 = this;

      this.listComponent = this.createBean(new _VirtualList2({
        cssIdentifier: "rich-select"
      }));
      this.listComponent.setComponentCreator(this.createRowComponent.bind(this));

      var componentUpdater = function componentUpdater(item, component) {};

      this.listComponent.setComponentUpdater(componentUpdater);
      this.listComponent.setParentComponent(this);
      this.addManagedListener(this.listComponent, _Events.EVENT_FIELD_PICKER_VALUE_SELECTED, function (e) {
        _this504.onListValueSelected(e.value, e.fromEnterKey);
      });
      var cellRowHeight = this.cellRowHeight;

      if (cellRowHeight) {
        this.listComponent.setRowHeight(cellRowHeight);
      }

      var eListGui = this.listComponent.getGui();
      var eListAriaEl = this.listComponent.getAriaElement();
      this.addManagedListener(eListGui, "mousemove", this.onPickerMouseMove.bind(this));
      this.addManagedListener(eListGui, "mousedown", function (e) {
        return e.preventDefault();
      });
      eListGui.classList.add("ag-rich-select-list");
      var listId = "ag-rich-select-list-".concat(this.listComponent.getCompId());
      eListAriaEl.setAttribute("id", listId);
      var translate = this.localeService.getLocaleTextFunc();
      var ariaLabel = translate(this.config.pickerAriaLabelKey, this.config.pickerAriaLabelValue);

      _setAriaLabel(eListAriaEl, ariaLabel);

      _setAriaControls(this.eWrapper, eListAriaEl);
    }
  }, {
    key: "renderSelectedValue",
    value: function renderSelectedValue() {
      var _this505 = this;

      var value = this.value,
          eDisplayField = this.eDisplayField,
          config = this.config;
      var _this$config15 = this.config,
          allowTyping = _this$config15.allowTyping,
          initialInputValue = _this$config15.initialInputValue;
      var valueFormatted = this.config.valueFormatter ? this.config.valueFormatter(value) : value;

      if (allowTyping) {
        this.eInput.setValue(initialInputValue != null ? initialInputValue : valueFormatted);
        return;
      }

      var userCompDetails;

      if (config.cellRenderer) {
        userCompDetails = this.userComponentFactory.getCellRendererDetails(this.config, {
          value: value,
          valueFormatted: valueFormatted
        });
      }

      var userCompDetailsPromise;

      if (userCompDetails) {
        userCompDetailsPromise = userCompDetails.newAgStackInstance();
      }

      if (userCompDetailsPromise) {
        _clearElement(eDisplayField);

        _bindCellRendererToHtmlElement(userCompDetailsPromise, eDisplayField);

        userCompDetailsPromise.then(function (renderer) {
          _this505.addDestroyFunc(function () {
            return _this505.getContext().destroyBean(renderer);
          });
        });
      } else {
        if (_exists(this.value)) {
          eDisplayField.innerText = valueFormatted;
          eDisplayField.classList.remove("ag-display-as-placeholder");
        } else {
          var placeholder = config.placeholder;

          if (_exists(placeholder)) {
            eDisplayField.innerHTML = "".concat(_escapeString(placeholder));
            eDisplayField.classList.add("ag-display-as-placeholder");
          } else {
            _clearElement(eDisplayField);
          }
        }

        this.setTooltip({
          newTooltipText: valueFormatted != null ? valueFormatted : null,
          shouldDisplayTooltip: function shouldDisplayTooltip() {
            return _this505.eDisplayField.scrollWidth > _this505.eDisplayField.clientWidth;
          }
        });
      }
    }
  }, {
    key: "getCurrentValueIndex",
    value: function getCurrentValueIndex() {
      var currentList = this.currentList,
          value = this.value;

      if (value == null || !currentList) {
        return -1;
      }

      for (var i = 0; i < currentList.length; i++) {
        if (currentList[i] === value) {
          return i;
        }
      }

      return -1;
    }
  }, {
    key: "highlightFilterMatch",
    value: function highlightFilterMatch() {
      var _this506 = this;

      var _a;

      (_a = this.listComponent) == null ? void 0 : _a.forEachRenderedRow(function (cmp, idx) {
        cmp.highlightString(_this506.searchString);
      });
    }
  }, {
    key: "highlightSelectedValue",
    value: function highlightSelectedValue(index) {
      var _this507 = this;

      var _a;

      if (index == null) {
        index = this.getCurrentValueIndex();
      }

      this.highlightedItem = index;
      (_a = this.listComponent) == null ? void 0 : _a.forEachRenderedRow(function (cmp, idx) {
        var highlighted = index === -1 ? false : _this507.highlightedItem === idx;
        cmp.updateHighlighted(highlighted);
      });
    }
  }, {
    key: "setRowHeight",
    value: function setRowHeight(height) {
      if (height !== this.cellRowHeight) {
        this.cellRowHeight = height;
      }

      if (this.listComponent) {
        this.listComponent.setRowHeight(height);
      }
    }
  }, {
    key: "createPickerComponent",
    value: function createPickerComponent() {
      var values2 = this.values;

      if (values2) {
        this.setValueList({
          valueList: values2
        });
      }

      return this.listComponent;
    }
  }, {
    key: "setSearchStringCreator",
    value: function setSearchStringCreator(searchStringFn) {
      this.searchStringCreator = searchStringFn;
    }
  }, {
    key: "setValueList",
    value: function setValueList(params) {
      var valueList = params.valueList,
          refresh = params.refresh;

      if (!this.listComponent) {
        return;
      }

      if (this.currentList === valueList) {
        return;
      }

      this.currentList = valueList;
      this.listComponent.setModel({
        getRowCount: function getRowCount() {
          return valueList.length;
        },
        getRow: function getRow(index) {
          return valueList[index];
        },
        areRowsEqual: function areRowsEqual(oldRow, newRow) {
          return oldRow === newRow;
        }
      });

      if (refresh) {
        if (!this.values) {
          this.values = valueList;

          if (this.isPickerDisplayed) {
            this.showCurrentValueInPicker();
          }
        } else {
          this.listComponent.refresh(true);
        }
      }
    }
  }, {
    key: "showPicker",
    value: function showPicker() {
      _get(_getPrototypeOf(_AgRichSelect.prototype), "showPicker", this).call(this);

      this.showCurrentValueInPicker();
      this.displayOrHidePicker();
    }
  }, {
    key: "showCurrentValueInPicker",
    value: function showCurrentValueInPicker() {
      var _a, _b;

      if (!this.listComponent) {
        return;
      }

      if (!this.currentList) {
        if (this.isPickerDisplayed && this.eLoading) {
          this.listComponent.appendChild(this.eLoading);
        }

        return;
      }

      if ((_a = this.eLoading) == null ? void 0 : _a.offsetParent) {
        (_b = this.eLoading.parentElement) == null ? void 0 : _b.removeChild(this.eLoading);
      }

      var currentValueIndex = this.getCurrentValueIndex();

      if (currentValueIndex !== -1) {
        this.listComponent.refresh();
        this.listComponent.ensureIndexVisible(currentValueIndex);
        this.listComponent.refresh(true);
        this.highlightSelectedValue(currentValueIndex);
      } else {
        this.listComponent.refresh();
      }
    }
  }, {
    key: "beforeHidePicker",
    value: function beforeHidePicker() {
      this.highlightedItem = -1;

      _get(_getPrototypeOf(_AgRichSelect.prototype), "beforeHidePicker", this).call(this);
    }
  }, {
    key: "onWrapperFocus",
    value: function onWrapperFocus() {
      if (!this.eInput) {
        return;
      }

      var focusableEl = this.eInput.getFocusableElement();
      focusableEl.focus();
      focusableEl.select();
    }
  }, {
    key: "onWrapperFocusOut",
    value: function onWrapperFocusOut(e) {
      if (!this.eWrapper.contains(e.relatedTarget)) {
        this.hidePicker();
      }
    }
  }, {
    key: "buildSearchStringFromKeyboardEvent",
    value: function buildSearchStringFromKeyboardEvent(searchKey) {
      var key = searchKey.key;

      if (key === _KeyCode.BACKSPACE) {
        this.searchString = this.searchString.slice(0, -1);
        key = "";
      } else if (!_isEventFromPrintableCharacter(searchKey)) {
        return;
      }

      searchKey.preventDefault();
      this.searchTextFromCharacter(key);
    }
  }, {
    key: "searchTextFromCharacter",
    value: function searchTextFromCharacter(char) {
      this.searchString += char;
      this.runSearch();
      this.clearSearchString();
    }
  }, {
    key: "searchTextFromString",
    value: function searchTextFromString(str) {
      if (str == null) {
        str = "";
      }

      this.searchString = str;
      this.runSearch();
    }
  }, {
    key: "buildSearchStrings",
    value: function buildSearchStrings(values2) {
      var _this$config$valueFor = this.config.valueFormatter,
          valueFormatter = _this$config$valueFor === void 0 ? function (value) {
        return value;
      } : _this$config$valueFor;
      var searchStrings;

      if (typeof values2[0] === "number" || typeof values2[0] === "string") {
        searchStrings = values2.map(function (v) {
          return valueFormatter(v);
        });
      } else if (typeof values2[0] === "object" && this.searchStringCreator) {
        searchStrings = this.searchStringCreator(values2);
      }

      return searchStrings;
    }
  }, {
    key: "getSuggestionsAndFilteredValues",
    value: function getSuggestionsAndFilteredValues(searchValue, valueList) {
      var _this508 = this;

      var suggestions = [];
      var filteredValues = [];

      if (!searchValue.length) {
        return {
          suggestions: suggestions,
          filteredValues: filteredValues
        };
      }

      ;
      var _this$config16 = this.config,
          _this$config16$search = _this$config16.searchType,
          searchType = _this$config16$search === void 0 ? "fuzzy" : _this$config16$search,
          filterList = _this$config16.filterList;

      if (searchType === "fuzzy") {
        var fuzzySearchResult = _fuzzySuggestions(this.searchString, valueList, true);

        suggestions = fuzzySearchResult.values;
        var indices = fuzzySearchResult.indices;

        if (filterList && indices.length) {
          for (var i = 0; i < indices.length; i++) {
            filteredValues.push(this.values[indices[i]]);
          }
        }
      } else {
        suggestions = valueList.filter(function (val, idx) {
          var currentValue = val.toLocaleLowerCase();

          var valueToMatch = _this508.searchString.toLocaleLowerCase();

          var isMatch = searchType === "match" ? currentValue.startsWith(valueToMatch) : currentValue.indexOf(valueToMatch) !== -1;

          if (filterList && isMatch) {
            filteredValues.push(_this508.values[idx]);
          }

          return isMatch;
        });
      }

      return {
        suggestions: suggestions,
        filteredValues: filteredValues
      };
    }
  }, {
    key: "filterListModel",
    value: function filterListModel(filteredValues) {
      var filterList = this.config.filterList;

      if (!filterList) {
        return;
      }

      this.setValueList({
        valueList: filteredValues,
        refresh: true
      });
      this.alignPickerToComponent();
    }
  }, {
    key: "runSearch",
    value: function runSearch() {
      var _a, _b;

      var values2 = this.values;
      var searchStrings = this.buildSearchStrings(values2);

      if (!searchStrings) {
        this.highlightSelectedValue(-1);
        return;
      }

      var _this$getSuggestionsA = this.getSuggestionsAndFilteredValues(this.searchString, searchStrings),
          suggestions = _this$getSuggestionsA.suggestions,
          filteredValues = _this$getSuggestionsA.filteredValues;

      var _this$config17 = this.config,
          filterList = _this$config17.filterList,
          highlightMatch = _this$config17.highlightMatch,
          _this$config17$search = _this$config17.searchType,
          searchType = _this$config17$search === void 0 ? "fuzzy" : _this$config17$search;
      var filterValueLen = filteredValues.length;
      var shouldFilter = !!(filterList && this.searchString !== "");
      this.filterListModel(shouldFilter ? filteredValues : values2);

      if (suggestions.length) {
        var topSuggestionIndex = shouldFilter ? 0 : searchStrings.indexOf(suggestions[0]);
        this.selectListItem(topSuggestionIndex);
      } else {
        this.highlightSelectedValue(-1);

        if (!shouldFilter || filterValueLen) {
          (_a = this.listComponent) == null ? void 0 : _a.ensureIndexVisible(0);
        } else if (shouldFilter) {
          this.getAriaElement().removeAttribute("data-active-option");
          var eListAriaEl = (_b = this.listComponent) == null ? void 0 : _b.getAriaElement();

          if (eListAriaEl) {
            _setAriaActiveDescendant(eListAriaEl, null);
          }
        }
      }

      if (highlightMatch && searchType !== "fuzzy") {
        this.highlightFilterMatch();
      }

      this.displayOrHidePicker();
    }
  }, {
    key: "displayOrHidePicker",
    value: function displayOrHidePicker() {
      var _a;

      var eListGui = (_a = this.listComponent) == null ? void 0 : _a.getGui();
      var toggleValue = this.currentList ? this.currentList.length === 0 : false;
      eListGui == null ? void 0 : eListGui.classList.toggle("ag-hidden", toggleValue);
    }
  }, {
    key: "clearSearchString",
    value: function clearSearchString() {
      this.searchString = "";
    }
  }, {
    key: "selectListItem",
    value: function selectListItem(index, preventUnnecessaryScroll) {
      if (!this.isPickerDisplayed || !this.currentList || !this.listComponent || index < 0 || index >= this.currentList.length) {
        return;
      }

      var wasScrolled = this.listComponent.ensureIndexVisible(index, !preventUnnecessaryScroll);

      if (wasScrolled && !preventUnnecessaryScroll) {
        this.listComponent.refresh(true);
      }

      this.highlightSelectedValue(index);
    }
  }, {
    key: "setValue",
    value: function setValue(value, silent, fromPicker) {
      var index = this.currentList ? this.currentList.indexOf(value) : -1;

      if (index === -1) {
        return this;
      }

      this.value = value;

      if (!fromPicker) {
        this.selectListItem(index);
      }

      this.renderSelectedValue();
      return _get(_getPrototypeOf(_AgRichSelect.prototype), "setValue", this).call(this, value, silent);
    }
  }, {
    key: "createRowComponent",
    value: function createRowComponent(value) {
      var row = new RichSelectRow(this.config, this.eWrapper);
      row.setParentComponent(this.listComponent);
      this.getContext().createBean(row);
      row.setState(value);
      var _this$config18 = this.config,
          highlightMatch = _this$config18.highlightMatch,
          _this$config18$search = _this$config18.searchType,
          searchType = _this$config18$search === void 0 ? "fuzzy" : _this$config18$search;

      if (highlightMatch && searchType !== "fuzzy") {
        row.highlightString(this.searchString);
      }

      return row;
    }
  }, {
    key: "getRowForMouseEvent",
    value: function getRowForMouseEvent(e) {
      var listComponent = this.listComponent;

      if (!listComponent) {
        return -1;
      }

      var eGui = listComponent == null ? void 0 : listComponent.getGui();
      var rect = eGui.getBoundingClientRect();
      var scrollTop = listComponent.getScrollTop();
      var mouseY = e.clientY - rect.top + scrollTop;
      return Math.floor(mouseY / listComponent.getRowHeight());
    }
  }, {
    key: "onPickerMouseMove",
    value: function onPickerMouseMove(e) {
      if (!this.listComponent) {
        return;
      }

      var row = this.getRowForMouseEvent(e);

      if (row !== -1 && row != this.lastRowHovered) {
        this.lastRowHovered = row;
        this.selectListItem(row, true);
      }
    }
  }, {
    key: "onNavigationKeyDown",
    value: function onNavigationKeyDown(event, key) {
      event.preventDefault();
      var isDown = key === _KeyCode.DOWN;

      if (!this.isPickerDisplayed && isDown) {
        this.showPicker();
        return;
      }

      var oldIndex = this.highlightedItem;
      var diff = isDown ? 1 : -1;
      var newIndex = oldIndex === -1 ? 0 : oldIndex + diff;
      this.selectListItem(newIndex);
    }
  }, {
    key: "onPageNavigation",
    value: function onPageNavigation(key) {
      var _this509 = this;

      var _a;

      if (!this.isPickerDisplayed) {
        return;
      }

      var newIndex = (_a = this.listComponent) == null ? void 0 : _a.navigateToPage(key, this.highlightedItem);

      if (newIndex != null) {
        this.animationFrameService.requestAnimationFrame(function () {
          if (!_this509.isAlive()) {
            return null;
          }

          _this509.highlightSelectedValue(newIndex);
        });
      }
    }
  }, {
    key: "onEnterKeyDown",
    value: function onEnterKeyDown(e) {
      if (!this.isPickerDisplayed) {
        return;
      }

      e.preventDefault();

      if (this.currentList) {
        this.onListValueSelected(this.currentList[this.highlightedItem], true);
      }
    }
  }, {
    key: "onTabKeyDown",
    value: function onTabKeyDown() {
      if (!this.isPickerDisplayed || !this.currentList) {
        return;
      }

      this.setValue(this.currentList[this.highlightedItem], false, true);
    }
  }, {
    key: "onListValueSelected",
    value: function onListValueSelected(value, fromEnterKey) {
      this.setValue(value, false, true);
      this.dispatchPickerEvent(value, fromEnterKey);
      this.hidePicker();
    }
  }, {
    key: "dispatchPickerEvent",
    value: function dispatchPickerEvent(value, fromEnterKey) {
      var event = {
        type: _Events.EVENT_FIELD_PICKER_VALUE_SELECTED,
        fromEnterKey: fromEnterKey,
        value: value
      };
      this.dispatchEvent(event);
    }
  }, {
    key: "getFocusableElement",
    value: function getFocusableElement() {
      var allowTyping = this.config.allowTyping;

      if (allowTyping) {
        return this.eInput.getFocusableElement();
      }

      return _get(_getPrototypeOf(_AgRichSelect.prototype), "getFocusableElement", this).call(this);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      var key = event.key;
      var allowTyping = this.config.allowTyping;

      switch (key) {
        case _KeyCode.LEFT:
        case _KeyCode.RIGHT:
          if (!allowTyping) {
            event.preventDefault();
          }

          break;

        case _KeyCode.PAGE_HOME:
        case _KeyCode.PAGE_END:
          if (allowTyping) {
            event.preventDefault();
            var inputEl = this.eInput.getInputElement();
            var target = key === _KeyCode.PAGE_HOME ? 0 : inputEl.value.length;
            inputEl.setSelectionRange(target, target);
            break;
          }

        case _KeyCode.PAGE_UP:
        case _KeyCode.PAGE_DOWN:
          event.preventDefault();
          this.onPageNavigation(key);
          break;

        case _KeyCode.DOWN:
        case _KeyCode.UP:
          this.onNavigationKeyDown(event, key);
          break;

        case _KeyCode.ESCAPE:
          if (this.isPickerDisplayed) {
            if (_isVisible(this.listComponent.getGui())) {
              event.preventDefault();

              _stopPropagationForAgGrid(event);
            }

            this.hidePicker();
          }

          break;

        case _KeyCode.ENTER:
          this.onEnterKeyDown(event);
          break;

        case _KeyCode.TAB:
          this.onTabKeyDown();
          break;

        default:
          if (!allowTyping) {
            this.buildSearchStringFromKeyboardEvent(event);
          }

      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.listComponent) {
        this.destroyBean(this.listComponent);
        this.listComponent = void 0;
      }

      this.eLoading = void 0;

      _get(_getPrototypeOf(_AgRichSelect.prototype), "destroy", this).call(this);
    }
  }]);

  return _AgRichSelect;
}(_AgPickerField);

__decorateClass([_Autowired("userComponentFactory")], _AgRichSelect.prototype, "userComponentFactory", 2);

__decorateClass([_Autowired("animationFrameService")], _AgRichSelect.prototype, "animationFrameService", 2);

__decorateClass([_RefSelector("eInput")], _AgRichSelect.prototype, "eInput", 2); // community-modules/core/src/widgets/agSlider.ts


var _AgSlider =
/*#__PURE__*/
function (_AgAbstractLabel3) {
  "use strict";

  _inherits(_AgSlider, _AgAbstractLabel3);

  function _AgSlider(config) {
    var _this510;

    _classCallCheck(this, _AgSlider);

    _this510 = _possibleConstructorReturn(this, _getPrototypeOf(_AgSlider).call(this, config, _AgSlider.TEMPLATE));
    _this510.labelAlignment = "top";
    return _this510;
  }

  _createClass(_AgSlider, [{
    key: "init",
    value: function init() {
      this.eSlider.addCssClass("ag-slider-field");
      var _this$config19 = this.config,
          minValue = _this$config19.minValue,
          maxValue = _this$config19.maxValue,
          textFieldWidth = _this$config19.textFieldWidth,
          step = _this$config19.step,
          value = _this$config19.value,
          onValueChange = _this$config19.onValueChange;

      if (minValue != null) {
        this.setMinValue(minValue);
      }

      if (maxValue != null) {
        this.setMaxValue(maxValue);
      }

      if (textFieldWidth != null) {
        this.setTextFieldWidth(textFieldWidth);
      }

      if (step != null) {
        this.setStep(step);
      }

      if (value != null) {
        this.setValue(value);
      }

      if (onValueChange != null) {
        this.onValueChange(onValueChange);
      }
    }
  }, {
    key: "onValueChange",
    value: function onValueChange(callbackFn) {
      var _this511 = this;

      var eventChanged = _Events.EVENT_FIELD_VALUE_CHANGED;
      this.addManagedListener(this.eText, eventChanged, function () {
        var textValue = parseFloat(_this511.eText.getValue());

        _this511.eSlider.setValue(textValue.toString(), true);

        callbackFn(textValue || 0);
      });
      this.addManagedListener(this.eSlider, eventChanged, function () {
        var sliderValue = _this511.eSlider.getValue();

        _this511.eText.setValue(sliderValue, true);

        callbackFn(parseFloat(sliderValue));
      });
      return this;
    }
  }, {
    key: "setSliderWidth",
    value: function setSliderWidth(width) {
      this.eSlider.setWidth(width);
      return this;
    }
  }, {
    key: "setTextFieldWidth",
    value: function setTextFieldWidth(width) {
      this.eText.setWidth(width);
      return this;
    }
  }, {
    key: "setMinValue",
    value: function setMinValue(minValue) {
      this.eSlider.setMinValue(minValue);
      this.eText.setMin(minValue);
      return this;
    }
  }, {
    key: "setMaxValue",
    value: function setMaxValue(maxValue) {
      this.eSlider.setMaxValue(maxValue);
      this.eText.setMax(maxValue);
      return this;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.eText.getValue();
    }
  }, {
    key: "setValue",
    value: function setValue(value, silent) {
      if (this.getValue() === value) {
        return this;
      }

      this.eText.setValue(value, true);
      this.eSlider.setValue(value, true);

      if (!silent) {
        this.dispatchEvent({
          type: _Events.EVENT_FIELD_VALUE_CHANGED
        });
      }

      return this;
    }
  }, {
    key: "setStep",
    value: function setStep(step) {
      this.eSlider.setStep(step);
      this.eText.setStep(step);
      return this;
    }
  }]);

  return _AgSlider;
}(_AgAbstractLabel);

_AgSlider.TEMPLATE =
/* html */
"<div class=\"ag-slider\">\n            <label ref=\"eLabel\"></label>\n            <div class=\"ag-wrapper ag-slider-wrapper\">\n                <ag-input-range ref=\"eSlider\"></ag-input-range>\n                <ag-input-number-field ref=\"eText\"></ag-input-number-field>\n            </div>\n        </div>";

__decorateClass([_RefSelector("eLabel")], _AgSlider.prototype, "eLabel", 2);

__decorateClass([_RefSelector("eSlider")], _AgSlider.prototype, "eSlider", 2);

__decorateClass([_RefSelector("eText")], _AgSlider.prototype, "eText", 2);

__decorateClass([_PostConstruct], _AgSlider.prototype, "init", 1);

var _AgSlider2 = _AgSlider; // community-modules/core/src/widgets/agGroupComponent.ts

var _AgGroupComponent =
/*#__PURE__*/
function (_Component36) {
  "use strict";

  _inherits(_AgGroupComponent, _Component36);

  function _AgGroupComponent() {
    var _this512;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, _AgGroupComponent);

    _this512 = _possibleConstructorReturn(this, _getPrototypeOf(_AgGroupComponent).call(this, _AgGroupComponent.getTemplate(params)));
    _this512.params = params;
    _this512.suppressEnabledCheckbox = true;
    _this512.suppressToggleExpandOnEnableChange = false;
    var enabled = params.enabled,
        items = params.items,
        suppressEnabledCheckbox = params.suppressEnabledCheckbox,
        expanded = params.expanded,
        suppressToggleExpandOnEnableChange = params.suppressToggleExpandOnEnableChange,
        toggleMode = params.useToggle;
    _this512.cssIdentifier = params.cssIdentifier || "default";
    _this512.enabled = enabled != null ? enabled : true;
    _this512.items = items || [];
    _this512.useToggle = toggleMode != null ? toggleMode : false;
    _this512.alignItems = params.alignItems || "center";
    _this512.expanded = expanded == null ? true : expanded;

    if (suppressEnabledCheckbox != null) {
      _this512.suppressEnabledCheckbox = suppressEnabledCheckbox;
    }

    if (suppressToggleExpandOnEnableChange != null) {
      _this512.suppressToggleExpandOnEnableChange = suppressToggleExpandOnEnableChange;
    }

    return _this512;
  }

  _createClass(_AgGroupComponent, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this513 = this;

      this.setupTitleBar();

      if (this.items.length) {
        var initialItems = this.items;
        this.items = [];
        this.addItems(initialItems);
      }

      var localeTextFunc = this.localeService.getLocaleTextFunc();
      this.cbGroupEnabled.setLabel(localeTextFunc("enabled", "Enabled"));

      if (this.enabled) {
        this.setEnabled(this.enabled, void 0, true);
      }

      this.setAlignItems(this.alignItems);
      var _this$params6 = this.params,
          onEnableChange = _this$params6.onEnableChange,
          suppressOpenCloseIcons = _this$params6.suppressOpenCloseIcons;
      this.hideEnabledCheckbox(this.suppressEnabledCheckbox);
      this.hideOpenCloseIcons(suppressOpenCloseIcons != null ? suppressOpenCloseIcons : false);
      this.refreshChildDisplay();

      _setDisplayed(this.eContainer, this.expanded);

      this.cbGroupEnabled.onValueChange(function (newSelection) {
        _this513.setEnabled(newSelection, true, _this513.suppressToggleExpandOnEnableChange);

        _this513.dispatchEnableChangeEvent(newSelection);
      });

      if (onEnableChange != null) {
        this.onEnableChange(onEnableChange);
      }
    }
  }, {
    key: "refreshChildDisplay",
    value: function refreshChildDisplay() {
      var _a;

      _setDisplayed(this.eToolbar, this.expanded && !this.suppressEnabledCheckbox);

      (_a = this.eTitleBar) == null ? void 0 : _a.refreshOnExpand(this.expanded);
    }
  }, {
    key: "isExpanded",
    value: function isExpanded() {
      return this.expanded;
    }
  }, {
    key: "setAlignItems",
    value: function setAlignItems(alignment) {
      if (this.alignItems !== alignment) {
        this.removeCssClass("ag-group-item-alignment-".concat(this.alignItems));
      }

      this.alignItems = alignment;
      var newCls = "ag-group-item-alignment-".concat(this.alignItems);
      this.addCssClass(newCls);
      return this;
    }
  }, {
    key: "toggleGroupExpand",
    value: function toggleGroupExpand(expanded) {
      var _a;

      var silent = false;

      if (((_a = this.eTitleBar) == null ? void 0 : _a.isSuppressCollapse()) && !this.useToggle) {
        expanded = true;
        silent = true;
      } else {
        expanded = expanded != null ? expanded : !this.expanded;

        if (this.expanded === expanded) {
          return this;
        }
      }

      this.expanded = expanded;
      this.refreshChildDisplay();

      _setDisplayed(this.eContainer, expanded);

      if (!silent) {
        this.dispatchEvent({
          type: expanded ? _AgGroupComponent.EVENT_EXPANDED : _AgGroupComponent.EVENT_COLLAPSED
        });
      }

      return this;
    }
  }, {
    key: "addItems",
    value: function addItems(items) {
      var _this514 = this;

      items.forEach(function (item) {
        return _this514.addItem(item);
      });
    }
  }, {
    key: "prependItem",
    value: function prependItem(item) {
      this.insertItem(item, true);
    }
  }, {
    key: "addItem",
    value: function addItem(item) {
      this.insertItem(item, false);
    }
  }, {
    key: "insertItem",
    value: function insertItem(item, prepend) {
      var container = this.eContainer;
      var el = item instanceof _Component2 ? item.getGui() : item;
      el.classList.add("ag-group-item", "ag-".concat(this.cssIdentifier, "-group-item"));

      if (prepend) {
        container.insertAdjacentElement("afterbegin", el);
        this.items.unshift(el);
      } else {
        container.appendChild(el);
        this.items.push(el);
      }
    }
  }, {
    key: "hideItem",
    value: function hideItem(hide, index) {
      var itemToHide = this.items[index];

      _setDisplayed(itemToHide, !hide);
    }
  }, {
    key: "getItemIndex",
    value: function getItemIndex(item) {
      var el = item instanceof _Component2 ? item.getGui() : item;
      return this.items.indexOf(el);
    }
  }, {
    key: "setTitle",
    value: function setTitle(title) {
      var _a;

      (_a = this.eTitleBar) == null ? void 0 : _a.setTitle(title);
      return this;
    }
  }, {
    key: "addTitleBarWidget",
    value: function addTitleBarWidget(el) {
      var _a;

      (_a = this.eTitleBar) == null ? void 0 : _a.addWidget(el);
      return this;
    }
  }, {
    key: "addCssClassToTitleBar",
    value: function addCssClassToTitleBar(cssClass) {
      var _a;

      (_a = this.eTitleBar) == null ? void 0 : _a.addCssClass(cssClass);
    }
  }, {
    key: "dispatchEnableChangeEvent",
    value: function dispatchEnableChangeEvent(enabled) {
      var event = {
        type: _AgGroupComponent.EVENT_ENABLE_CHANGE,
        enabled: enabled
      };
      this.dispatchEvent(event);
    }
  }, {
    key: "setEnabled",
    value: function setEnabled(enabled, skipToggle, skipExpand) {
      var _a;

      this.enabled = enabled;
      this.refreshDisabledStyles();

      if (!skipExpand) {
        this.toggleGroupExpand(enabled);
      }

      if (!skipToggle) {
        this.cbGroupEnabled.setValue(enabled);
        (_a = this.eToggle) == null ? void 0 : _a.setValue(enabled);
      }

      return this;
    }
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return this.enabled;
    }
  }, {
    key: "onEnableChange",
    value: function onEnableChange(callbackFn) {
      this.addManagedListener(this, _AgGroupComponent.EVENT_ENABLE_CHANGE, function (event) {
        return callbackFn(event.enabled);
      });
      return this;
    }
  }, {
    key: "hideEnabledCheckbox",
    value: function hideEnabledCheckbox(hide) {
      this.suppressEnabledCheckbox = hide;
      this.refreshChildDisplay();
      this.refreshDisabledStyles();
      return this;
    }
  }, {
    key: "hideOpenCloseIcons",
    value: function hideOpenCloseIcons(hide) {
      var _a;

      (_a = this.eTitleBar) == null ? void 0 : _a.hideOpenCloseIcons(hide);
      return this;
    }
  }, {
    key: "refreshDisabledStyles",
    value: function refreshDisabledStyles() {
      var _a;

      var disabled = !this.enabled;
      this.eContainer.classList.toggle("ag-disabled", disabled);
      (_a = this.eTitleBar) == null ? void 0 : _a.refreshDisabledStyles(this.suppressEnabledCheckbox && disabled);
      this.eContainer.classList.toggle("ag-disabled-group-container", disabled);
    }
  }, {
    key: "setupTitleBar",
    value: function setupTitleBar() {
      var titleBar = this.useToggle ? this.createToggleTitleBar() : this.createDefaultTitleBar();
      this.eToolbar.insertAdjacentElement("beforebegin", titleBar.getGui());
    }
  }, {
    key: "createDefaultTitleBar",
    value: function createDefaultTitleBar() {
      var _this515 = this;

      var titleBar = this.createManagedBean(new DefaultTitleBar(this.params));
      this.eTitleBar = titleBar;
      titleBar.refreshOnExpand(this.expanded);
      this.addManagedListener(titleBar, DefaultTitleBar.EVENT_EXPAND_CHANGED, function (event) {
        return _this515.toggleGroupExpand(event.expanded);
      });
      return titleBar;
    }
  }, {
    key: "createToggleTitleBar",
    value: function createToggleTitleBar() {
      var _this516 = this;

      var _a;

      var eToggle = this.createManagedBean(new _AgToggleButton({
        value: this.enabled,
        label: this.params.title,
        labelAlignment: "left",
        labelWidth: "flex",
        onValueChange: function onValueChange(enabled) {
          _this516.setEnabled(enabled, true);

          _this516.dispatchEnableChangeEvent(enabled);
        }
      }));
      eToggle.addCssClass("ag-group-title-bar");
      eToggle.addCssClass("ag-".concat((_a = this.params.cssIdentifier) != null ? _a : "default", "-group-title-bar ag-unselectable"));
      this.eToggle = eToggle;
      this.toggleGroupExpand(this.enabled);
      return eToggle;
    }
  }], [{
    key: "getTemplate",
    value: function getTemplate(params) {
      var cssIdentifier = params.cssIdentifier || "default";
      var direction = params.direction || "vertical";
      return (
        /* html */
        "\n            <div class=\"ag-group ag-".concat(cssIdentifier, "-group\" role=\"presentation\">\n                <div ref=\"eToolbar\" class=\"ag-group-toolbar ag-").concat(cssIdentifier, "-group-toolbar\">\n                    <ag-checkbox ref=\"cbGroupEnabled\"></ag-checkbox>\n                </div>\n                <div ref=\"eContainer\" class=\"ag-group-container ag-group-container-").concat(direction, " ag-").concat(cssIdentifier, "-group-container\"></div>\n            </div>\n        ")
      );
    }
  }]);

  return _AgGroupComponent;
}(_Component2);

_AgGroupComponent.EVENT_EXPANDED = "expanded";
_AgGroupComponent.EVENT_COLLAPSED = "collapsed";
_AgGroupComponent.EVENT_ENABLE_CHANGE = "enableChange";

__decorateClass([_RefSelector("eToolbar")], _AgGroupComponent.prototype, "eToolbar", 2);

__decorateClass([_RefSelector("cbGroupEnabled")], _AgGroupComponent.prototype, "cbGroupEnabled", 2);

__decorateClass([_RefSelector("eContainer")], _AgGroupComponent.prototype, "eContainer", 2);

__decorateClass([_PostConstruct], _AgGroupComponent.prototype, "postConstruct", 1);

var _AgGroupComponent2 = _AgGroupComponent;
var TITLE_BAR_DISABLED_CLASS = "ag-disabled-group-title-bar";

var _DefaultTitleBar =
/*#__PURE__*/
function (_Component37) {
  "use strict";

  _inherits(_DefaultTitleBar, _Component37);

  function _DefaultTitleBar() {
    var _this517;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, _DefaultTitleBar);

    _this517 = _possibleConstructorReturn(this, _getPrototypeOf(_DefaultTitleBar).call(this, _DefaultTitleBar.getTemplate(params)));
    _this517.suppressOpenCloseIcons = false;
    var title = params.title,
        suppressOpenCloseIcons = params.suppressOpenCloseIcons;

    if (!!title && title.length > 0) {
      _this517.title = title;
    }

    if (suppressOpenCloseIcons != null) {
      _this517.suppressOpenCloseIcons = suppressOpenCloseIcons;
    }

    return _this517;
  }

  _createClass(_DefaultTitleBar, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.setTitle(this.title);
      this.hideOpenCloseIcons(this.suppressOpenCloseIcons);
      this.setupExpandContract();
    }
  }, {
    key: "setupExpandContract",
    value: function setupExpandContract() {
      var _this518 = this;

      this.eGroupClosedIcon.appendChild(_createIcon("columnSelectClosed", this.gos, null));
      this.eGroupOpenedIcon.appendChild(_createIcon("columnSelectOpen", this.gos, null));
      this.addManagedListener(this.getGui(), "click", function () {
        return _this518.dispatchExpandChanged();
      });
      this.addManagedListener(this.getGui(), "keydown", function (e) {
        switch (e.key) {
          case _KeyCode.ENTER:
          case _KeyCode.SPACE:
            e.preventDefault();

            _this518.dispatchExpandChanged();

            break;

          case _KeyCode.RIGHT:
          case _KeyCode.LEFT:
            e.preventDefault();

            _this518.dispatchExpandChanged(e.key === _KeyCode.RIGHT);

            break;
        }
      });
    }
  }, {
    key: "refreshOnExpand",
    value: function refreshOnExpand(expanded) {
      this.refreshAriaStatus(expanded);
      this.refreshOpenCloseIcons(expanded);
    }
  }, {
    key: "refreshAriaStatus",
    value: function refreshAriaStatus(expanded) {
      if (!this.suppressOpenCloseIcons) {
        _setAriaExpanded(this.getGui(), expanded);
      }
    }
  }, {
    key: "refreshOpenCloseIcons",
    value: function refreshOpenCloseIcons(expanded) {
      var showIcon = !this.suppressOpenCloseIcons;

      _setDisplayed(this.eGroupOpenedIcon, showIcon && expanded);

      _setDisplayed(this.eGroupClosedIcon, showIcon && !expanded);
    }
  }, {
    key: "isSuppressCollapse",
    value: function isSuppressCollapse() {
      return this.suppressOpenCloseIcons;
    }
  }, {
    key: "dispatchExpandChanged",
    value: function dispatchExpandChanged(expanded) {
      var event = {
        type: _DefaultTitleBar.EVENT_EXPAND_CHANGED,
        expanded: expanded
      };
      this.dispatchEvent(event);
    }
  }, {
    key: "setTitle",
    value: function setTitle(title) {
      var eGui = this.getGui();
      var hasTitle = !!title && title.length > 0;
      title = hasTitle ? title : void 0;
      this.eTitle.textContent = title != null ? title : "";

      _setDisplayed(eGui, hasTitle);

      if (title !== this.title) {
        this.title = title;
      }

      var disabled = eGui.classList.contains(TITLE_BAR_DISABLED_CLASS);
      this.refreshDisabledStyles(disabled);
      return this;
    }
  }, {
    key: "addWidget",
    value: function addWidget(el) {
      this.getGui().appendChild(el);
      return this;
    }
  }, {
    key: "hideOpenCloseIcons",
    value: function hideOpenCloseIcons(hide) {
      this.suppressOpenCloseIcons = hide;

      if (hide) {
        this.dispatchExpandChanged(true);
      }

      return this;
    }
  }, {
    key: "refreshDisabledStyles",
    value: function refreshDisabledStyles(disabled) {
      var eGui = this.getGui();

      if (disabled) {
        eGui.classList.add(TITLE_BAR_DISABLED_CLASS);
        eGui.removeAttribute("tabindex");
      } else {
        eGui.classList.remove(TITLE_BAR_DISABLED_CLASS);

        if (typeof this.title === "string") {
          eGui.setAttribute("tabindex", "0");
        } else {
          eGui.removeAttribute("tabindex");
        }
      }
    }
  }], [{
    key: "getTemplate",
    value: function getTemplate(params) {
      var _a;

      var cssIdentifier = (_a = params.cssIdentifier) != null ? _a : "default";
      return (
        /* html */
        "\n            <div class=\"ag-group-title-bar ag-".concat(cssIdentifier, "-group-title-bar ag-unselectable\" role=\"button\">\n                <span class=\"ag-group-title-bar-icon ag-").concat(cssIdentifier, "-group-title-bar-icon\" ref=\"eGroupOpenedIcon\" role=\"presentation\"></span>\n                <span class=\"ag-group-title-bar-icon ag-").concat(cssIdentifier, "-group-title-bar-icon\" ref=\"eGroupClosedIcon\" role=\"presentation\"></span>\n                <span ref=\"eTitle\" class=\"ag-group-title ag-").concat(cssIdentifier, "-group-title\"></span>\n            </div>\n        ")
      );
    }
  }]);

  return _DefaultTitleBar;
}(_Component2);

_DefaultTitleBar.EVENT_EXPAND_CHANGED = "expandedChanged";

__decorateClass([_RefSelector("eGroupOpenedIcon")], _DefaultTitleBar.prototype, "eGroupOpenedIcon", 2);

__decorateClass([_RefSelector("eGroupClosedIcon")], _DefaultTitleBar.prototype, "eGroupClosedIcon", 2);

__decorateClass([_RefSelector("eTitle")], _DefaultTitleBar.prototype, "eTitle", 2);

__decorateClass([_PostConstruct], _DefaultTitleBar.prototype, "postConstruct", 1);

var DefaultTitleBar = _DefaultTitleBar; // community-modules/core/src/widgets/agMenuList.ts

var _AgMenuList =
/*#__PURE__*/
function (_TabGuardComp4) {
  "use strict";

  _inherits(_AgMenuList, _TabGuardComp4);

  function _AgMenuList() {
    var _this519;

    var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var params = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, _AgMenuList);

    _this519 = _possibleConstructorReturn(this, _getPrototypeOf(_AgMenuList).call(this,
    /* html */
    "<div class=\"ag-menu-list\" role=\"tree\"></div>"));
    _this519.level = level;
    _this519.menuItems = [];
    _this519.params = params != null ? params : {
      column: null,
      node: null,
      value: null
    };
    return _this519;
  }

  _createClass(_AgMenuList, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this520 = this;

      this.initialiseTabGuard({
        onTabKeyDown: function onTabKeyDown(e) {
          return _this520.onTabKeyDown(e);
        },
        handleKeyDown: function handleKeyDown(e) {
          return _this520.handleKeyDown(e);
        },
        onFocusIn: function onFocusIn(e) {
          return _this520.handleFocusIn(e);
        },
        onFocusOut: function onFocusOut(e) {
          return _this520.handleFocusOut(e);
        }
      });
    }
  }, {
    key: "onTabKeyDown",
    value: function onTabKeyDown(e) {
      var parent = this.getParentComponent();
      var parentGui = parent && parent.getGui();
      var isManaged = parentGui && parentGui.classList.contains("ag-focus-managed");

      if (!isManaged) {
        e.preventDefault();
      }

      if (e.shiftKey) {
        this.closeIfIsChild(e);
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      switch (e.key) {
        case _KeyCode.UP:
        case _KeyCode.RIGHT:
        case _KeyCode.DOWN:
        case _KeyCode.LEFT:
          e.preventDefault();
          this.handleNavKey(e.key);
          break;

        case _KeyCode.ESCAPE:
          if (this.closeIfIsChild()) {
            _stopPropagationForAgGrid(e);
          }

          break;
      }
    }
  }, {
    key: "handleFocusIn",
    value: function handleFocusIn(e) {
      var _a, _b;

      var oldFocusedElement = e.relatedTarget;

      if (!this.tabGuardCtrl.isTabGuard(oldFocusedElement) && (this.getGui().contains(oldFocusedElement) || ((_b = (_a = this.activeMenuItem) == null ? void 0 : _a.getSubMenuGui()) == null ? void 0 : _b.contains(oldFocusedElement)))) {
        return;
      }

      if (this.activeMenuItem) {
        this.activeMenuItem.activate();
      } else {
        this.activateFirstItem();
      }
    }
  }, {
    key: "handleFocusOut",
    value: function handleFocusOut(e) {
      var _a;

      var newFocusedElement = e.relatedTarget;

      if (!this.activeMenuItem || this.getGui().contains(newFocusedElement) || ((_a = this.activeMenuItem.getSubMenuGui()) == null ? void 0 : _a.contains(newFocusedElement))) {
        return;
      }

      if (!this.activeMenuItem.isSubMenuOpening()) {
        this.activeMenuItem.deactivate();
      }
    }
  }, {
    key: "clearActiveItem",
    value: function clearActiveItem() {
      if (this.activeMenuItem) {
        this.activeMenuItem.deactivate();
        this.activeMenuItem = null;
      }
    }
  }, {
    key: "addMenuItems",
    value: function addMenuItems(menuItems) {
      var _this521 = this;

      if (menuItems == null) {
        return;
      }

      _AgPromise2.all(menuItems.map(function (menuItemOrString) {
        if (menuItemOrString === "separator") {
          return _AgPromise2.resolve({
            eGui: _this521.createSeparator()
          });
        } else if (typeof menuItemOrString === "string") {
          console.warn("AG Grid: unrecognised menu item ".concat(menuItemOrString));
          return _AgPromise2.resolve({
            eGui: null
          });
        } else {
          return _this521.addItem(menuItemOrString);
        }
      })).then(function (elements) {
        elements.forEach(function (element) {
          if (element == null ? void 0 : element.eGui) {
            _this521.appendChild(element.eGui);

            if (element.comp) {
              _this521.menuItems.push(element.comp);
            }
          }
        });
      });
    }
  }, {
    key: "addItem",
    value: function addItem(menuItemDef) {
      var _this522 = this;

      var menuItem = this.createManagedBean(new _AgMenuItemComponent2());
      return menuItem.init({
        menuItemDef: menuItemDef,
        isAnotherSubMenuOpen: function isAnotherSubMenuOpen() {
          return _this522.menuItems.some(function (m) {
            return m.isSubMenuOpen();
          });
        },
        level: this.level,
        contextParams: this.params
      }).then(function () {
        menuItem.setParentComponent(_this522);

        _this522.addManagedListener(menuItem, _AgMenuItemComponent2.EVENT_CLOSE_MENU, function (event) {
          _this522.dispatchEvent(event);
        });

        _this522.addManagedListener(menuItem, _AgMenuItemComponent2.EVENT_MENU_ITEM_ACTIVATED, function (event) {
          if (_this522.activeMenuItem && _this522.activeMenuItem !== event.menuItem) {
            _this522.activeMenuItem.deactivate();
          }

          _this522.activeMenuItem = event.menuItem;
        });

        return {
          comp: menuItem,
          eGui: menuItem.getGui()
        };
      });
    }
  }, {
    key: "activateFirstItem",
    value: function activateFirstItem() {
      var item = this.menuItems.filter(function (currentItem) {
        return !currentItem.isDisabled();
      })[0];

      if (!item) {
        return;
      }

      item.activate();
    }
  }, {
    key: "createSeparator",
    value: function createSeparator() {
      var separatorHtml =
      /* html */
      "\n            <div class=\"ag-menu-separator\" aria-hidden=\"true\">\n                <div class=\"ag-menu-separator-part\"></div>\n                <div class=\"ag-menu-separator-part\"></div>\n                <div class=\"ag-menu-separator-part\"></div>\n                <div class=\"ag-menu-separator-part\"></div>\n            </div>";
      return _loadTemplate(separatorHtml);
    }
  }, {
    key: "handleNavKey",
    value: function handleNavKey(key) {
      switch (key) {
        case _KeyCode.UP:
        case _KeyCode.DOWN:
          var nextItem = this.findNextItem(key === _KeyCode.UP);

          if (nextItem && nextItem !== this.activeMenuItem) {
            nextItem.activate();
          }

          return;
      }

      var left = this.gos.get("enableRtl") ? _KeyCode.RIGHT : _KeyCode.LEFT;

      if (key === left) {
        this.closeIfIsChild();
      } else {
        this.openChild();
      }
    }
  }, {
    key: "closeIfIsChild",
    value: function closeIfIsChild(e) {
      var parentItem = this.getParentComponent();

      if (parentItem && parentItem instanceof _AgMenuItemComponent2) {
        if (e) {
          e.preventDefault();
        }

        parentItem.closeSubMenu();
        parentItem.getGui().focus();
        return true;
      }

      return false;
    }
  }, {
    key: "openChild",
    value: function openChild() {
      if (this.activeMenuItem) {
        this.activeMenuItem.openSubMenu(true);
      }
    }
  }, {
    key: "findNextItem",
    value: function findNextItem(up) {
      var items = this.menuItems.filter(function (item) {
        return !item.isDisabled();
      });

      if (!items.length) {
        return;
      }

      if (!this.activeMenuItem) {
        return up ? _last(items) : items[0];
      }

      if (up) {
        items.reverse();
      }

      var nextItem;
      var foundCurrent = false;

      for (var i = 0; i < items.length; i++) {
        var item = items[i];

        if (!foundCurrent) {
          if (item === this.activeMenuItem) {
            foundCurrent = true;
          }

          continue;
        }

        nextItem = item;
        break;
      }

      if (foundCurrent && !nextItem) {
        return items[0];
      }

      return nextItem || this.activeMenuItem;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.clearActiveItem();

      _get(_getPrototypeOf(_AgMenuList.prototype), "destroy", this).call(this);
    }
  }]);

  return _AgMenuList;
}(_TabGuardComp);

__decorateClass([_Autowired("focusService")], _AgMenuList.prototype, "focusService", 2);

__decorateClass([_PostConstruct], _AgMenuList.prototype, "postConstruct", 1); // community-modules/core/src/widgets/agMenuPanel.ts


var _AgMenuPanel =
/*#__PURE__*/
function (_TabGuardComp5) {
  "use strict";

  _inherits(_AgMenuPanel, _TabGuardComp5);

  function _AgMenuPanel(wrappedComponent) {
    var _this523;

    _classCallCheck(this, _AgMenuPanel);

    _this523 = _possibleConstructorReturn(this, _getPrototypeOf(_AgMenuPanel).call(this));
    _this523.wrappedComponent = wrappedComponent;

    _this523.setTemplateFromElement(wrappedComponent.getGui());

    return _this523;
  }

  _createClass(_AgMenuPanel, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this524 = this;

      this.initialiseTabGuard({
        onTabKeyDown: function onTabKeyDown(e) {
          return _this524.onTabKeyDown(e);
        },
        handleKeyDown: function handleKeyDown(e) {
          return _this524.handleKeyDown(e);
        }
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      if (e.key === _KeyCode.ESCAPE) {
        this.closePanel();
      }
    }
  }, {
    key: "onTabKeyDown",
    value: function onTabKeyDown(e) {
      if (e.defaultPrevented) {
        return;
      }

      this.closePanel();
      e.preventDefault();
    }
  }, {
    key: "closePanel",
    value: function closePanel() {
      var menuItem = this.parentComponent;
      menuItem.closeSubMenu();
      setTimeout(function () {
        return menuItem.getGui().focus();
      }, 0);
    }
  }]);

  return _AgMenuPanel;
}(_TabGuardComp);

__decorateClass([_PostConstruct], _AgMenuPanel.prototype, "postConstruct", 1); // community-modules/core/src/widgets/agMenuItemComponent.ts


var _AgMenuItemComponent =
/*#__PURE__*/
function (_BeanStub71) {
  "use strict";

  _inherits(_AgMenuItemComponent, _BeanStub71);

  function _AgMenuItemComponent() {
    var _this525;

    _classCallCheck(this, _AgMenuItemComponent);

    _this525 = _possibleConstructorReturn(this, _getPrototypeOf(_AgMenuItemComponent).apply(this, arguments));
    _this525.isActive = false;
    _this525.subMenuIsOpen = false;
    _this525.subMenuIsOpening = false;
    _this525.suppressRootStyles = true;
    _this525.suppressAria = true;
    _this525.suppressFocus = true;
    return _this525;
  }

  _createClass(_AgMenuItemComponent, [{
    key: "init",
    value: function init(params) {
      var _this526 = this;

      var _a, _b;

      var menuItemDef = params.menuItemDef,
          isAnotherSubMenuOpen = params.isAnotherSubMenuOpen,
          level = params.level,
          childComponent = params.childComponent,
          contextParams = params.contextParams;
      this.params = params.menuItemDef;
      this.level = level;
      this.isAnotherSubMenuOpen = isAnotherSubMenuOpen;
      this.childComponent = childComponent;
      this.contextParams = contextParams;
      this.cssClassPrefix = (_b = (_a = this.params.menuItemParams) == null ? void 0 : _a.cssClassPrefix) != null ? _b : "ag-menu-option";
      var compDetails = this.userComponentFactory.getMenuItemCompDetails(this.params, __spreadProps(__spreadValues({}, menuItemDef), {
        level: level,
        isAnotherSubMenuOpen: isAnotherSubMenuOpen,
        openSubMenu: function openSubMenu(activateFirstItem) {
          return _this526.openSubMenu(activateFirstItem);
        },
        closeSubMenu: function closeSubMenu() {
          return _this526.closeSubMenu();
        },
        closeMenu: function closeMenu(event) {
          return _this526.closeMenu(event);
        },
        updateTooltip: function updateTooltip(tooltip, shouldDisplayTooltip) {
          return _this526.refreshTooltip(tooltip, shouldDisplayTooltip);
        },
        onItemActivated: function onItemActivated() {
          return _this526.onItemActivated();
        }
      }));
      return compDetails.newAgStackInstance().then(function (comp) {
        var _a2;

        _this526.menuItemComp = comp;
        var configureDefaults = (_a2 = comp.configureDefaults) == null ? void 0 : _a2.call(comp);

        if (configureDefaults) {
          _this526.configureDefaults(configureDefaults === true ? void 0 : configureDefaults);
        }
      });
    }
  }, {
    key: "addListeners",
    value: function addListeners(eGui, params) {
      var _this527 = this;

      if (!(params == null ? void 0 : params.suppressClick)) {
        this.addManagedListener(eGui, "click", function (e) {
          return _this527.onItemSelected(e);
        });
      }

      if (!(params == null ? void 0 : params.suppressKeyboardSelect)) {
        this.addManagedListener(eGui, "keydown", function (e) {
          if (e.key === _KeyCode.ENTER || e.key === _KeyCode.SPACE) {
            e.preventDefault();

            _this527.onItemSelected(e);
          }
        });
      }

      if (!(params == null ? void 0 : params.suppressMouseDown)) {
        this.addManagedListener(eGui, "mousedown", function (e) {
          e.stopPropagation();
          e.preventDefault();
        });
      }

      if (!(params == null ? void 0 : params.suppressMouseOver)) {
        this.addManagedListener(eGui, "mouseenter", function () {
          return _this527.onMouseEnter();
        });
        this.addManagedListener(eGui, "mouseleave", function () {
          return _this527.onMouseLeave();
        });
      }
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      return !!this.params.disabled;
    }
  }, {
    key: "openSubMenu",
    value: function openSubMenu() {
      var _this528 = this;

      var activateFirstItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var _a, _b;

      this.closeSubMenu();

      if (!this.params.subMenu) {
        return;
      }

      this.subMenuIsOpening = true;

      var ePopup = _loadTemplate(
      /* html */
      "<div class=\"ag-menu\" role=\"presentation\"></div>");

      this.eSubMenuGui = ePopup;
      var destroySubMenu;

      var afterGuiAttached = function afterGuiAttached() {
        _this528.subMenuIsOpening = false;
      };

      if (this.childComponent) {
        var menuPanel = this.createBean(new _AgMenuPanel(this.childComponent));
        menuPanel.setParentComponent(this);
        var subMenuGui = menuPanel.getGui();
        var mouseEvent = "mouseenter";

        var mouseEnterListener = function mouseEnterListener() {
          return _this528.cancelDeactivate();
        };

        subMenuGui.addEventListener(mouseEvent, mouseEnterListener);

        destroySubMenu = function destroySubMenu() {
          return subMenuGui.removeEventListener(mouseEvent, mouseEnterListener);
        };

        ePopup.appendChild(subMenuGui);

        if (this.childComponent.afterGuiAttached) {
          afterGuiAttached = function afterGuiAttached() {
            _this528.childComponent.afterGuiAttached();

            _this528.subMenuIsOpening = false;
          };
        }
      } else if (this.params.subMenu) {
        var childMenu = this.createBean(new _AgMenuList(this.level + 1, this.contextParams));
        childMenu.setParentComponent(this);
        childMenu.addMenuItems(this.params.subMenu);
        ePopup.appendChild(childMenu.getGui());
        this.addManagedListener(childMenu, _AgMenuItemComponent.EVENT_CLOSE_MENU, function (e) {
          return _this528.dispatchEvent(e);
        });
        childMenu.addGuiEventListener("mouseenter", function () {
          return _this528.cancelDeactivate();
        });

        destroySubMenu = function destroySubMenu() {
          return _this528.destroyBean(childMenu);
        };

        if (activateFirstItem) {
          afterGuiAttached = function afterGuiAttached() {
            childMenu.activateFirstItem();
            _this528.subMenuIsOpening = false;
          };
        }
      }

      var positionCallback = this.popupService.positionPopupForMenu.bind(this.popupService, {
        eventSource: this.eGui,
        ePopup: ePopup
      });
      var translate = this.localeService.getLocaleTextFunc();
      var addPopupRes = this.popupService.addPopup({
        modal: true,
        eChild: ePopup,
        positionCallback: positionCallback,
        anchorToElement: this.eGui,
        ariaLabel: translate("ariaLabelSubMenu", "SubMenu"),
        afterGuiAttached: afterGuiAttached
      });
      this.subMenuIsOpen = true;
      this.setAriaExpanded(true);

      this.hideSubMenu = function () {
        var _a2, _b2;

        if (addPopupRes) {
          addPopupRes.hideFunc();
        }

        _this528.subMenuIsOpen = false;

        _this528.setAriaExpanded(false);

        destroySubMenu();
        (_b2 = (_a2 = _this528.menuItemComp).setExpanded) == null ? void 0 : _b2.call(_a2, false);
        _this528.eSubMenuGui = void 0;
      };

      (_b = (_a = this.menuItemComp).setExpanded) == null ? void 0 : _b.call(_a, true);
    }
  }, {
    key: "setAriaExpanded",
    value: function setAriaExpanded(expanded) {
      if (!this.suppressAria) {
        _setAriaExpanded(this.eGui, expanded);
      }
    }
  }, {
    key: "closeSubMenu",
    value: function closeSubMenu() {
      if (!this.hideSubMenu) {
        return;
      }

      this.hideSubMenu();
      this.hideSubMenu = null;
      this.setAriaExpanded(false);
    }
  }, {
    key: "isSubMenuOpen",
    value: function isSubMenuOpen() {
      return this.subMenuIsOpen;
    }
  }, {
    key: "isSubMenuOpening",
    value: function isSubMenuOpening() {
      return this.subMenuIsOpening;
    }
  }, {
    key: "activate",
    value: function activate(openSubMenu) {
      var _this529 = this;

      var _a, _b;

      this.cancelActivate();

      if (this.params.disabled) {
        return;
      }

      this.isActive = true;

      if (!this.suppressRootStyles) {
        this.eGui.classList.add("".concat(this.cssClassPrefix, "-active"));
      }

      (_b = (_a = this.menuItemComp).setActive) == null ? void 0 : _b.call(_a, true);

      if (!this.suppressFocus) {
        this.eGui.focus({
          preventScroll: true
        });
      }

      if (openSubMenu && this.params.subMenu) {
        window.setTimeout(function () {
          if (_this529.isAlive() && _this529.isActive) {
            _this529.openSubMenu();
          }
        }, 300);
      }

      this.onItemActivated();
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      var _a, _b;

      this.cancelDeactivate();

      if (!this.suppressRootStyles) {
        this.eGui.classList.remove("".concat(this.cssClassPrefix, "-active"));
      }

      (_b = (_a = this.menuItemComp).setActive) == null ? void 0 : _b.call(_a, false);
      this.isActive = false;

      if (this.subMenuIsOpen) {
        this.hideSubMenu();
      }
    }
  }, {
    key: "getGui",
    value: function getGui() {
      return this.menuItemComp.getGui();
    }
  }, {
    key: "getParentComponent",
    value: function getParentComponent() {
      return this.parentComponent;
    }
  }, {
    key: "setParentComponent",
    value: function setParentComponent(component) {
      this.parentComponent = component;
    }
  }, {
    key: "getSubMenuGui",
    value: function getSubMenuGui() {
      return this.eSubMenuGui;
    }
  }, {
    key: "onItemSelected",
    value: function onItemSelected(event) {
      var _this530 = this;

      var _a, _b;

      (_b = (_a = this.menuItemComp).select) == null ? void 0 : _b.call(_a);

      if (this.params.action) {
        this.getFrameworkOverrides().wrapOutgoing(function () {
          return _this530.params.action(_this530.gos.addGridCommonParams(__spreadValues({}, _this530.contextParams)));
        });
      } else {
        this.openSubMenu(event && event.type === "keydown");
      }

      if (this.params.subMenu && !this.params.action || this.params.suppressCloseOnSelect) {
        return;
      }

      this.closeMenu(event);
    }
  }, {
    key: "closeMenu",
    value: function closeMenu(event) {
      var e = {
        type: _AgMenuItemComponent.EVENT_CLOSE_MENU
      };

      if (event) {
        if (event instanceof MouseEvent) {
          e.mouseEvent = event;
        } else {
          e.keyboardEvent = event;
        }
      }

      this.dispatchEvent(e);
    }
  }, {
    key: "onItemActivated",
    value: function onItemActivated() {
      var event = {
        type: _AgMenuItemComponent.EVENT_MENU_ITEM_ACTIVATED,
        menuItem: this
      };
      this.dispatchEvent(event);
    }
  }, {
    key: "cancelActivate",
    value: function cancelActivate() {
      if (this.activateTimeoutId) {
        window.clearTimeout(this.activateTimeoutId);
        this.activateTimeoutId = 0;
      }
    }
  }, {
    key: "cancelDeactivate",
    value: function cancelDeactivate() {
      if (this.deactivateTimeoutId) {
        window.clearTimeout(this.deactivateTimeoutId);
        this.deactivateTimeoutId = 0;
      }
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter() {
      var _this531 = this;

      this.cancelDeactivate();

      if (this.isAnotherSubMenuOpen()) {
        this.activateTimeoutId = window.setTimeout(function () {
          return _this531.activate(true);
        }, _AgMenuItemComponent.ACTIVATION_DELAY);
      } else {
        this.activate(true);
      }
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      var _this532 = this;

      this.cancelActivate();

      if (this.isSubMenuOpen()) {
        this.deactivateTimeoutId = window.setTimeout(function () {
          return _this532.deactivate();
        }, _AgMenuItemComponent.ACTIVATION_DELAY);
      } else {
        this.deactivate();
      }
    }
  }, {
    key: "configureDefaults",
    value: function configureDefaults(params) {
      var _this533 = this;

      var _a, _b, _c;

      if (!this.menuItemComp) {
        setTimeout(function () {
          return _this533.configureDefaults(params);
        });
        return;
      }

      var eGui = this.menuItemComp.getGui();
      var rootElement = (_b = (_a = this.menuItemComp).getRootElement) == null ? void 0 : _b.call(_a);

      if (rootElement) {
        if (!(params == null ? void 0 : params.suppressRootStyles)) {
          eGui.classList.add("ag-menu-option-custom");
        }

        eGui = rootElement;
      }

      this.eGui = eGui;
      this.suppressRootStyles = !!(params == null ? void 0 : params.suppressRootStyles);

      if (!this.suppressRootStyles) {
        eGui.classList.add(this.cssClassPrefix);
        (_c = this.params.cssClasses) == null ? void 0 : _c.forEach(function (it) {
          return eGui.classList.add(it);
        });

        if (this.params.disabled) {
          eGui.classList.add("".concat(this.cssClassPrefix, "-disabled"));
        }
      }

      if (!(params == null ? void 0 : params.suppressTooltip)) {
        this.refreshTooltip(this.params.tooltip);
      }

      this.suppressAria = !!(params == null ? void 0 : params.suppressAria);

      if (!this.suppressAria) {
        _setAriaRole(eGui, "treeitem");

        _setAriaLevel(eGui, this.level + 1);

        if (this.params.disabled) {
          _setAriaDisabled(eGui, true);
        }
      }

      if (!(params == null ? void 0 : params.suppressTabIndex)) {
        eGui.setAttribute("tabindex", "-1");
      }

      if (!this.params.disabled) {
        this.addListeners(eGui, params);
      }

      this.suppressFocus = !!(params == null ? void 0 : params.suppressFocus);
    }
  }, {
    key: "refreshTooltip",
    value: function refreshTooltip(tooltip, shouldDisplayTooltip) {
      var _this534 = this;

      this.tooltip = tooltip;

      if (this.tooltipFeature) {
        this.tooltipFeature = this.destroyBean(this.tooltipFeature);
      }

      if (!tooltip || !this.menuItemComp) {
        return;
      }

      this.tooltipFeature = this.createBean(new _TooltipFeature({
        getGui: function getGui() {
          return _this534.getGui();
        },
        getTooltipValue: function getTooltipValue() {
          return _this534.tooltip;
        },
        getLocation: function getLocation() {
          return "menu";
        },
        shouldDisplayTooltip: shouldDisplayTooltip
      }));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.tooltipFeature) {
        this.tooltipFeature = this.destroyBean(this.tooltipFeature);
      }

      _get(_getPrototypeOf(_AgMenuItemComponent.prototype), "destroy", this).call(this);
    }
  }]);

  return _AgMenuItemComponent;
}(_BeanStub2);

_AgMenuItemComponent.EVENT_CLOSE_MENU = "closeMenu";
_AgMenuItemComponent.EVENT_MENU_ITEM_ACTIVATED = "menuItemActivated";
_AgMenuItemComponent.ACTIVATION_DELAY = 80;

__decorateClass([_Autowired("popupService")], _AgMenuItemComponent.prototype, "popupService", 2);

__decorateClass([_Autowired("userComponentFactory")], _AgMenuItemComponent.prototype, "userComponentFactory", 2);

var _AgMenuItemComponent2 = _AgMenuItemComponent; // community-modules/core/src/widgets/agPanel.ts

var _AgPanel =
/*#__PURE__*/
function (_Component38) {
  "use strict";

  _inherits(_AgPanel, _Component38);

  function _AgPanel(config) {
    var _this535;

    _classCallCheck(this, _AgPanel);

    _this535 = _possibleConstructorReturn(this, _getPrototypeOf(_AgPanel).call(this, _AgPanel.getTemplate(config)));
    _this535.config = config;
    _this535.closable = true;
    return _this535;
  }

  _createClass(_AgPanel, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this536 = this;

      var _this$config20 = this.config,
          component = _this$config20.component,
          closable = _this$config20.closable,
          hideTitleBar = _this$config20.hideTitleBar,
          title = _this$config20.title,
          _this$config20$minWid = _this$config20.minWidth,
          minWidth = _this$config20$minWid === void 0 ? 250 : _this$config20$minWid,
          width = _this$config20.width,
          _this$config20$minHei = _this$config20.minHeight,
          minHeight = _this$config20$minHei === void 0 ? 250 : _this$config20$minHei,
          height = _this$config20.height,
          centered = _this$config20.centered,
          popup = _this$config20.popup,
          x = _this$config20.x,
          y = _this$config20.y;
      this.positionableFeature = new _PositionableFeature(this.getGui(), {
        minWidth: minWidth,
        width: width,
        minHeight: minHeight,
        height: height,
        centered: centered,
        x: x,
        y: y,
        popup: popup,
        calculateTopBuffer: function calculateTopBuffer() {
          return _this536.positionableFeature.getHeight() - _this536.getBodyHeight();
        }
      });
      this.createManagedBean(this.positionableFeature);
      var eGui = this.getGui();

      if (component) {
        this.setBodyComponent(component);
      }

      if (!hideTitleBar) {
        if (title) {
          this.setTitle(title);
        }

        this.setClosable(closable != null ? closable : this.closable);
      } else {
        _setDisplayed(this.eTitleBar, false);
      }

      this.addManagedListener(this.eTitleBar, "mousedown", function (e) {
        if (eGui.contains(e.relatedTarget) || eGui.contains(_this536.gos.getActiveDomElement()) || _this536.eTitleBarButtons.contains(e.target)) {
          e.preventDefault();
          return;
        }

        var focusEl = _this536.eContentWrapper.querySelector("button, [href], input, select, textarea, [tabindex]");

        if (focusEl) {
          focusEl.focus();
        }
      });

      if (popup && this.positionableFeature.isPositioned()) {
        return;
      }

      if (this.renderComponent) {
        this.renderComponent();
      }

      this.positionableFeature.initialisePosition();
      this.eContentWrapper.style.height = "0";
    }
  }, {
    key: "renderComponent",
    value: function renderComponent() {
      var _this537 = this;

      var eGui = this.getGui();
      eGui.focus();

      this.close = function () {
        eGui.parentElement.removeChild(eGui);

        _this537.destroy();
      };
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      return this.positionableFeature.getHeight();
    }
  }, {
    key: "setHeight",
    value: function setHeight(height) {
      this.positionableFeature.setHeight(height);
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.positionableFeature.getWidth();
    }
  }, {
    key: "setWidth",
    value: function setWidth(width) {
      this.positionableFeature.setWidth(width);
    }
  }, {
    key: "setClosable",
    value: function setClosable(closable) {
      if (closable !== this.closable) {
        this.closable = closable;
      }

      if (closable) {
        var closeButtonComp = this.closeButtonComp = new _Component2(_AgPanel.CLOSE_BTN_TEMPLATE);
        this.getContext().createBean(closeButtonComp);
        var eGui = closeButtonComp.getGui();

        var child = _createIconNoSpan("close", this.gos);

        child.classList.add("ag-panel-title-bar-button-icon");
        eGui.appendChild(child);
        this.addTitleBarButton(closeButtonComp);
        closeButtonComp.addManagedListener(eGui, "click", this.onBtClose.bind(this));
      } else if (this.closeButtonComp) {
        var _eGui = this.closeButtonComp.getGui();

        _eGui.parentElement.removeChild(_eGui);

        this.closeButtonComp = this.destroyBean(this.closeButtonComp);
      }
    }
  }, {
    key: "setBodyComponent",
    value: function setBodyComponent(bodyComponent) {
      bodyComponent.setParentComponent(this);
      this.eContentWrapper.appendChild(bodyComponent.getGui());
    }
  }, {
    key: "addTitleBarButton",
    value: function addTitleBarButton(button, position) {
      var eTitleBarButtons = this.eTitleBarButtons;
      var buttons = eTitleBarButtons.children;
      var len = buttons.length;

      if (position == null) {
        position = len;
      }

      position = Math.max(0, Math.min(position, len));
      button.addCssClass("ag-panel-title-bar-button");
      var eGui = button.getGui();

      if (position === 0) {
        eTitleBarButtons.insertAdjacentElement("afterbegin", eGui);
      } else if (position === len) {
        eTitleBarButtons.insertAdjacentElement("beforeend", eGui);
      } else {
        buttons[position - 1].insertAdjacentElement("afterend", eGui);
      }

      button.setParentComponent(this);
    }
  }, {
    key: "getBodyHeight",
    value: function getBodyHeight() {
      return _getInnerHeight(this.eContentWrapper);
    }
  }, {
    key: "getBodyWidth",
    value: function getBodyWidth() {
      return _getInnerWidth(this.eContentWrapper);
    }
  }, {
    key: "setTitle",
    value: function setTitle(title) {
      this.eTitle.innerText = title;
    } // called when user hits the 'x' in the top right

  }, {
    key: "onBtClose",
    value: function onBtClose() {
      this.close();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.closeButtonComp) {
        this.closeButtonComp = this.destroyBean(this.closeButtonComp);
      }

      var eGui = this.getGui();

      if (eGui && _isVisible(eGui)) {
        this.close();
      }

      _get(_getPrototypeOf(_AgPanel.prototype), "destroy", this).call(this);
    }
  }], [{
    key: "getTemplate",
    value: function getTemplate(config) {
      var cssIdentifier = config.cssIdentifier || "default";
      return (
        /* html */
        "<div class=\"ag-panel ag-".concat(cssIdentifier, "-panel\" tabindex=\"-1\">\n            <div ref=\"eTitleBar\" class=\"ag-panel-title-bar ag-").concat(cssIdentifier, "-panel-title-bar ag-unselectable\">\n                <span ref=\"eTitle\" class=\"ag-panel-title-bar-title ag-").concat(cssIdentifier, "-panel-title-bar-title\"></span>\n                <div ref=\"eTitleBarButtons\" class=\"ag-panel-title-bar-buttons ag-").concat(cssIdentifier, "-panel-title-bar-buttons\"></div>\n            </div>\n            <div ref=\"eContentWrapper\" class=\"ag-panel-content-wrapper ag-").concat(cssIdentifier, "-panel-content-wrapper\"></div>\n        </div>")
      );
    }
  }]);

  return _AgPanel;
}(_Component2);

_AgPanel.CLOSE_BTN_TEMPLATE =
/* html */
"<div class=\"ag-button\"></div>";

__decorateClass([_RefSelector("eContentWrapper")], _AgPanel.prototype, "eContentWrapper", 2);

__decorateClass([_RefSelector("eTitleBar")], _AgPanel.prototype, "eTitleBar", 2);

__decorateClass([_RefSelector("eTitleBarButtons")], _AgPanel.prototype, "eTitleBarButtons", 2);

__decorateClass([_RefSelector("eTitle")], _AgPanel.prototype, "eTitle", 2);

__decorateClass([_PostConstruct], _AgPanel.prototype, "postConstruct", 1);

var _AgPanel2 = _AgPanel; // community-modules/core/src/widgets/agDialog.ts

var _AgDialog =
/*#__PURE__*/
function (_AgPanel3) {
  "use strict";

  _inherits(_AgDialog, _AgPanel3);

  function _AgDialog(config) {
    var _this538;

    _classCallCheck(this, _AgDialog);

    _this538 = _possibleConstructorReturn(this, _getPrototypeOf(_AgDialog).call(this, __spreadProps(__spreadValues({}, config), {
      popup: true
    })));
    _this538.isMaximizable = false;
    _this538.isMaximized = false;
    _this538.maximizeListeners = [];
    _this538.resizeListenerDestroy = null;
    _this538.lastPosition = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
    return _this538;
  }

  _createClass(_AgDialog, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this539 = this;

      var eGui = this.getGui();
      var _this$config21 = this.config,
          movable = _this$config21.movable,
          resizable = _this$config21.resizable,
          maximizable = _this$config21.maximizable;
      this.addCssClass("ag-dialog");

      _get(_getPrototypeOf(_AgDialog.prototype), "postConstruct", this).call(this);

      this.addManagedListener(eGui, "focusin", function (e) {
        _this539.popupService.bringPopupToFront(eGui);
      });

      if (movable) {
        this.setMovable(movable);
      }

      if (maximizable) {
        this.setMaximizable(maximizable);
      }

      if (resizable) {
        this.setResizable(resizable);
      }
    }
  }, {
    key: "renderComponent",
    value: function renderComponent() {
      var eGui = this.getGui();
      var _this$config22 = this.config,
          alwaysOnTop = _this$config22.alwaysOnTop,
          modal = _this$config22.modal,
          title = _this$config22.title,
          afterGuiAttached = _this$config22.afterGuiAttached;
      var translate = this.localeService.getLocaleTextFunc();
      var addPopupRes = this.popupService.addPopup({
        modal: modal,
        eChild: eGui,
        closeOnEsc: true,
        closedCallback: this.onClosed.bind(this),
        alwaysOnTop: alwaysOnTop,
        ariaLabel: title || translate("ariaLabelDialog", "Dialog"),
        afterGuiAttached: afterGuiAttached
      });

      if (addPopupRes) {
        this.close = addPopupRes.hideFunc;
      }
    }
  }, {
    key: "onClosed",
    value: function onClosed(event) {
      var _a, _b;

      this.destroy();
      (_b = (_a = this.config).closedCallback) == null ? void 0 : _b.call(_a, event);
    }
  }, {
    key: "toggleMaximize",
    value: function toggleMaximize() {
      var position = this.positionableFeature.getPosition();

      if (this.isMaximized) {
        var _this$lastPosition = this.lastPosition,
            x = _this$lastPosition.x,
            y = _this$lastPosition.y,
            width = _this$lastPosition.width,
            height = _this$lastPosition.height;
        this.setWidth(width);
        this.setHeight(height);
        this.positionableFeature.offsetElement(x, y);
      } else {
        this.lastPosition.width = this.getWidth();
        this.lastPosition.height = this.getHeight();
        this.lastPosition.x = position.x;
        this.lastPosition.y = position.y;
        this.positionableFeature.offsetElement(0, 0);
        this.setHeight("100%");
        this.setWidth("100%");
      }

      this.isMaximized = !this.isMaximized;
      this.refreshMaximizeIcon();
    }
  }, {
    key: "refreshMaximizeIcon",
    value: function refreshMaximizeIcon() {
      _setDisplayed(this.maximizeIcon, !this.isMaximized);

      _setDisplayed(this.minimizeIcon, this.isMaximized);
    }
  }, {
    key: "clearMaximizebleListeners",
    value: function clearMaximizebleListeners() {
      if (this.maximizeListeners.length) {
        this.maximizeListeners.forEach(function (destroyListener) {
          return destroyListener();
        });
        this.maximizeListeners.length = 0;
      }

      if (this.resizeListenerDestroy) {
        this.resizeListenerDestroy();
        this.resizeListenerDestroy = null;
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.maximizeButtonComp = this.destroyBean(this.maximizeButtonComp);
      this.clearMaximizebleListeners();

      _get(_getPrototypeOf(_AgDialog.prototype), "destroy", this).call(this);
    }
  }, {
    key: "setResizable",
    value: function setResizable(resizable) {
      this.positionableFeature.setResizable(resizable);
    }
  }, {
    key: "setMovable",
    value: function setMovable(movable) {
      this.positionableFeature.setMovable(movable, this.eTitleBar);
    }
  }, {
    key: "setMaximizable",
    value: function setMaximizable(maximizable) {
      var _this540 = this;

      if (!maximizable) {
        this.clearMaximizebleListeners();

        if (this.maximizeButtonComp) {
          this.destroyBean(this.maximizeButtonComp);
          this.maximizeButtonComp = this.maximizeIcon = this.minimizeIcon = void 0;
        }

        return;
      }

      var eTitleBar = this.eTitleBar;

      if (!eTitleBar || maximizable === this.isMaximizable) {
        return;
      }

      var maximizeButtonComp = this.buildMaximizeAndMinimizeElements();
      this.refreshMaximizeIcon();
      maximizeButtonComp.addManagedListener(maximizeButtonComp.getGui(), "click", this.toggleMaximize.bind(this));
      this.addTitleBarButton(maximizeButtonComp, 0);
      this.maximizeListeners.push(this.addManagedListener(eTitleBar, "dblclick", this.toggleMaximize.bind(this)));
      this.resizeListenerDestroy = this.addManagedListener(this, "resize", function () {
        _this540.isMaximized = false;

        _this540.refreshMaximizeIcon();
      });
    }
  }, {
    key: "buildMaximizeAndMinimizeElements",
    value: function buildMaximizeAndMinimizeElements() {
      var maximizeButtonComp = this.maximizeButtonComp = this.createBean(new _Component2(
      /* html */
      "<div class=\"ag-dialog-button\"></span>"));
      var eGui = maximizeButtonComp.getGui();
      this.maximizeIcon = _createIconNoSpan("maximize", this.gos);
      eGui.appendChild(this.maximizeIcon);
      this.maximizeIcon.classList.add("ag-panel-title-bar-button-icon");
      this.minimizeIcon = _createIconNoSpan("minimize", this.gos);
      eGui.appendChild(this.minimizeIcon);
      this.minimizeIcon.classList.add("ag-panel-title-bar-button-icon");
      return maximizeButtonComp;
    }
  }]);

  return _AgDialog;
}(_AgPanel2);

__decorateClass([_Autowired("popupService")], _AgDialog.prototype, "popupService", 2); // community-modules/core/src/widgets/popupService.ts


var instanceIdSeq = 0;

var _PopupService2 =
/*#__PURE__*/
function (_BeanStub72) {
  "use strict";

  _inherits(_PopupService, _BeanStub72);

  function _PopupService() {
    var _this541;

    _classCallCheck(this, _PopupService);

    _this541 = _possibleConstructorReturn(this, _getPrototypeOf(_PopupService).apply(this, arguments));
    _this541.popupList = [];
    return _this541;
  }

  _createClass(_PopupService, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this542 = this;

      this.ctrlsService.whenReady(function (p) {
        _this542.gridCtrl = p.gridCtrl;
      });
      this.addManagedListener(this.eventService, _Events.EVENT_GRID_STYLES_CHANGED, this.handleThemeChange.bind(this));
    }
  }, {
    key: "getPopupParent",
    value: function getPopupParent() {
      var ePopupParent = this.gos.get("popupParent");

      if (ePopupParent) {
        return ePopupParent;
      }

      return this.gridCtrl.getGui();
    }
  }, {
    key: "positionPopupForMenu",
    value: function positionPopupForMenu(params) {
      var eventSource = params.eventSource,
          ePopup = params.ePopup;
      var popupIdx = this.getPopupIndex(ePopup);

      if (popupIdx !== -1) {
        var popup = this.popupList[popupIdx];
        popup.alignedToElement = eventSource;
      }

      var sourceRect = eventSource.getBoundingClientRect();
      var parentRect = this.getParentRect();
      var y = this.keepXYWithinBounds(ePopup, sourceRect.top - parentRect.top, 0
      /* vertical */
      );
      var minWidth = ePopup.clientWidth > 0 ? ePopup.clientWidth : 200;
      ePopup.style.minWidth = "".concat(minWidth, "px");
      var widthOfParent = parentRect.right - parentRect.left;
      var maxX = widthOfParent - minWidth;
      var x;

      if (this.gos.get("enableRtl")) {
        x = xLeftPosition();

        if (x < 0) {
          x = xRightPosition();
          this.setAlignedStyles(ePopup, "left");
        }

        if (x > maxX) {
          x = 0;
          this.setAlignedStyles(ePopup, "right");
        }
      } else {
        x = xRightPosition();

        if (x > maxX) {
          x = xLeftPosition();
          this.setAlignedStyles(ePopup, "right");
        }

        if (x < 0) {
          x = 0;
          this.setAlignedStyles(ePopup, "left");
        }
      }

      ePopup.style.left = "".concat(x, "px");
      ePopup.style.top = "".concat(y, "px");

      function xRightPosition() {
        return sourceRect.right - parentRect.left - 2;
      }

      function xLeftPosition() {
        return sourceRect.left - parentRect.left - minWidth;
      }
    }
  }, {
    key: "positionPopupUnderMouseEvent",
    value: function positionPopupUnderMouseEvent(params) {
      var _this543 = this;

      var ePopup = params.ePopup,
          nudgeX = params.nudgeX,
          nudgeY = params.nudgeY,
          skipObserver = params.skipObserver;
      this.positionPopup({
        ePopup: ePopup,
        nudgeX: nudgeX,
        nudgeY: nudgeY,
        keepWithinBounds: true,
        skipObserver: skipObserver,
        updatePosition: function updatePosition() {
          return _this543.calculatePointerAlign(params.mouseEvent);
        },
        postProcessCallback: function postProcessCallback() {
          return _this543.callPostProcessPopup(params.type, params.ePopup, null, params.mouseEvent, params.column, params.rowNode);
        }
      });
    }
  }, {
    key: "calculatePointerAlign",
    value: function calculatePointerAlign(e) {
      var parentRect = this.getParentRect();
      return {
        x: e.clientX - parentRect.left,
        y: e.clientY - parentRect.top
      };
    }
  }, {
    key: "positionPopupByComponent",
    value: function positionPopupByComponent(params) {
      var _this544 = this;

      var ePopup = params.ePopup,
          nudgeX = params.nudgeX,
          nudgeY = params.nudgeY,
          keepWithinBounds = params.keepWithinBounds,
          eventSource = params.eventSource,
          _params$alignSide = params.alignSide,
          alignSide = _params$alignSide === void 0 ? "left" : _params$alignSide,
          _params$position = params.position,
          position = _params$position === void 0 ? "over" : _params$position,
          column = params.column,
          rowNode = params.rowNode,
          type = params.type;
      var sourceRect = eventSource.getBoundingClientRect();
      var parentRect = this.getParentRect();
      var popupIdx = this.getPopupIndex(ePopup);

      if (popupIdx !== -1) {
        var popup = this.popupList[popupIdx];
        popup.alignedToElement = eventSource;
      }

      var updatePosition = function updatePosition() {
        var x = sourceRect.left - parentRect.left;

        if (alignSide === "right") {
          x -= ePopup.offsetWidth - sourceRect.width;
        }

        var y;

        if (position === "over") {
          y = sourceRect.top - parentRect.top;

          _this544.setAlignedStyles(ePopup, "over");
        } else {
          _this544.setAlignedStyles(ePopup, "under");

          var alignSide2 = _this544.shouldRenderUnderOrAbove(ePopup, sourceRect, parentRect, params.nudgeY || 0);

          if (alignSide2 === "under") {
            y = sourceRect.top - parentRect.top + sourceRect.height;
          } else {
            y = sourceRect.top - ePopup.offsetHeight - (nudgeY || 0) * 2 - parentRect.top;
          }
        }

        return {
          x: x,
          y: y
        };
      };

      this.positionPopup({
        ePopup: ePopup,
        nudgeX: nudgeX,
        nudgeY: nudgeY,
        keepWithinBounds: keepWithinBounds,
        updatePosition: updatePosition,
        postProcessCallback: function postProcessCallback() {
          return _this544.callPostProcessPopup(type, ePopup, eventSource, null, column, rowNode);
        }
      });
    }
  }, {
    key: "shouldRenderUnderOrAbove",
    value: function shouldRenderUnderOrAbove(ePopup, targetCompRect, parentRect, nudgeY) {
      var spaceAvailableUnder = parentRect.bottom - targetCompRect.bottom;
      var spaceAvailableAbove = targetCompRect.top - parentRect.top;
      var spaceRequired = ePopup.offsetHeight + nudgeY;

      if (spaceAvailableUnder > spaceRequired) {
        return "under";
      }

      if (spaceAvailableAbove > spaceRequired || spaceAvailableAbove > spaceAvailableUnder) {
        return "above";
      }

      return "under";
    }
  }, {
    key: "setAlignedStyles",
    value: function setAlignedStyles(ePopup, positioned) {
      var popupIdx = this.getPopupIndex(ePopup);

      if (popupIdx === -1) {
        return;
      }

      var popup = this.popupList[popupIdx];
      var alignedToElement = popup.alignedToElement;

      if (!alignedToElement) {
        return;
      }

      var positions = ["right", "left", "over", "above", "under"];
      positions.forEach(function (position) {
        alignedToElement.classList.remove("ag-has-popup-positioned-".concat(position));
        ePopup.classList.remove("ag-popup-positioned-".concat(position));
      });

      if (!positioned) {
        return;
      }

      alignedToElement.classList.add("ag-has-popup-positioned-".concat(positioned));
      ePopup.classList.add("ag-popup-positioned-".concat(positioned));
    }
  }, {
    key: "callPostProcessPopup",
    value: function callPostProcessPopup(type, ePopup, eventSource, mouseEvent, column, rowNode) {
      var callback = this.gos.getCallback("postProcessPopup");

      if (callback) {
        var params = {
          column: column,
          rowNode: rowNode,
          ePopup: ePopup,
          type: type,
          eventSource: eventSource,
          mouseEvent: mouseEvent
        };
        callback(params);
      }
    }
  }, {
    key: "positionPopup",
    value: function positionPopup(params) {
      var _this545 = this;

      var ePopup = params.ePopup,
          keepWithinBounds = params.keepWithinBounds,
          nudgeX = params.nudgeX,
          nudgeY = params.nudgeY,
          skipObserver = params.skipObserver,
          updatePosition = params.updatePosition;
      var lastSize = {
        width: 0,
        height: 0
      };

      var updatePopupPosition = function updatePopupPosition() {
        var fromResizeObserver = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var _updatePosition = updatePosition(),
            x = _updatePosition.x,
            y = _updatePosition.y;

        if (fromResizeObserver && ePopup.clientWidth === lastSize.width && ePopup.clientHeight === lastSize.height) {
          return;
        }

        lastSize.width = ePopup.clientWidth;
        lastSize.height = ePopup.clientHeight;

        if (nudgeX) {
          x += nudgeX;
        }

        if (nudgeY) {
          y += nudgeY;
        }

        if (keepWithinBounds) {
          x = _this545.keepXYWithinBounds(ePopup, x, 1
          /* horizontal */
          );
          y = _this545.keepXYWithinBounds(ePopup, y, 0
          /* vertical */
          );
        }

        ePopup.style.left = "".concat(x, "px");
        ePopup.style.top = "".concat(y, "px");

        if (params.postProcessCallback) {
          params.postProcessCallback();
        }
      };

      updatePopupPosition();

      if (!skipObserver) {
        var resizeObserverDestroyFunc = this.resizeObserverService.observeResize(ePopup, function () {
          return updatePopupPosition(true);
        });
        setTimeout(function () {
          return resizeObserverDestroyFunc();
        }, _PopupService2.WAIT_FOR_POPUP_CONTENT_RESIZE);
      }
    }
  }, {
    key: "getActivePopups",
    value: function getActivePopups() {
      return this.popupList.map(function (popup) {
        return popup.element;
      });
    }
  }, {
    key: "getPopupList",
    value: function getPopupList() {
      return this.popupList;
    }
  }, {
    key: "getParentRect",
    value: function getParentRect() {
      var eDocument = this.gos.getDocument();
      var popupParent = this.getPopupParent();

      if (popupParent === eDocument.body) {
        popupParent = eDocument.documentElement;
      } else if (getComputedStyle(popupParent).position === "static") {
        popupParent = popupParent.offsetParent;
      }

      return _getElementRectWithOffset(popupParent);
    }
  }, {
    key: "keepXYWithinBounds",
    value: function keepXYWithinBounds(ePopup, position, direction) {
      var isVertical = direction === 0
      /* vertical */
      ;
      var sizeProperty = isVertical ? "clientHeight" : "clientWidth";
      var anchorProperty = isVertical ? "top" : "left";
      var offsetProperty = isVertical ? "offsetHeight" : "offsetWidth";
      var scrollPositionProperty = isVertical ? "scrollTop" : "scrollLeft";
      var eDocument = this.gos.getDocument();
      var docElement = eDocument.documentElement;
      var popupParent = this.getPopupParent();
      var parentRect = popupParent.getBoundingClientRect();
      var documentRect = eDocument.documentElement.getBoundingClientRect();
      var isBody = popupParent === eDocument.body;
      var offsetSize = ePopup[offsetProperty];
      var getSize = isVertical ? _getAbsoluteHeight : _getAbsoluteWidth;
      var sizeOfParent = isBody ? getSize(docElement) + docElement[scrollPositionProperty] : popupParent[sizeProperty];

      if (isBody) {
        sizeOfParent -= Math.abs(documentRect[anchorProperty] - parentRect[anchorProperty]);
      }

      var max = sizeOfParent - offsetSize;
      return Math.min(Math.max(position, 0), Math.abs(max));
    }
  }, {
    key: "addPopup",
    value: function addPopup(params) {
      var eDocument = this.gos.getDocument();
      var eChild = params.eChild,
          ariaLabel = params.ariaLabel,
          alwaysOnTop = params.alwaysOnTop,
          positionCallback = params.positionCallback,
          anchorToElement = params.anchorToElement;

      if (!eDocument) {
        console.warn("AG Grid: could not find the document, document is empty");
        return {
          hideFunc: function hideFunc() {}
        };
      }

      var pos = this.getPopupIndex(eChild);

      if (pos !== -1) {
        var popup = this.popupList[pos];
        return {
          hideFunc: popup.hideFunc
        };
      }

      this.initialisePopupPosition(eChild);
      var wrapperEl = this.createPopupWrapper(eChild, ariaLabel, !!alwaysOnTop);
      var removeListeners = this.addEventListenersToPopup(__spreadProps(__spreadValues({}, params), {
        wrapperEl: wrapperEl
      }));

      if (positionCallback) {
        positionCallback();
      }

      this.addPopupToPopupList(eChild, wrapperEl, removeListeners, anchorToElement);
      return {
        hideFunc: removeListeners
      };
    }
  }, {
    key: "initialisePopupPosition",
    value: function initialisePopupPosition(element) {
      var ePopupParent = this.getPopupParent();
      var ePopupParentRect = ePopupParent.getBoundingClientRect();

      if (!_exists(element.style.top)) {
        element.style.top = "".concat(ePopupParentRect.top * -1, "px");
      }

      if (!_exists(element.style.left)) {
        element.style.left = "".concat(ePopupParentRect.left * -1, "px");
      }
    }
  }, {
    key: "createPopupWrapper",
    value: function createPopupWrapper(element, ariaLabel, alwaysOnTop) {
      var ePopupParent = this.getPopupParent();
      var eWrapper = document.createElement("div");

      var _this$environment$get2 = this.environment.getTheme(),
          allThemes = _this$environment$get2.allThemes;

      if (allThemes.length) {
        var _eWrapper$classList;

        (_eWrapper$classList = eWrapper.classList).add.apply(_eWrapper$classList, _toConsumableArray(allThemes));
      }

      eWrapper.classList.add("ag-popup");
      element.classList.add(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr", "ag-popup-child");

      if (!element.hasAttribute("role")) {
        _setAriaRole(element, "dialog");
      }

      _setAriaLabel(element, ariaLabel);

      eWrapper.appendChild(element);
      ePopupParent.appendChild(eWrapper);

      if (alwaysOnTop) {
        this.setAlwaysOnTop(element, true);
      } else {
        this.bringPopupToFront(element);
      }

      return eWrapper;
    }
  }, {
    key: "handleThemeChange",
    value: function handleThemeChange() {
      var _this$environment$get3 = this.environment.getTheme(),
          allThemes = _this$environment$get3.allThemes;

      var _iteratorNormalCompletion15 = true;
      var _didIteratorError15 = false;
      var _iteratorError15 = undefined;

      try {
        for (var _iterator15 = this.popupList[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
          var popup = _step15.value;

          for (var _i11 = 0, _Array$from = Array.from(popup.wrapper.classList); _i11 < _Array$from.length; _i11++) {
            var className = _Array$from[_i11];

            if (className.startsWith("ag-theme-")) {
              popup.wrapper.classList.remove(className);
            }
          }

          if (allThemes.length) {
            var _popup$wrapper$classL;

            (_popup$wrapper$classL = popup.wrapper.classList).add.apply(_popup$wrapper$classL, _toConsumableArray(allThemes));
          }
        }
      } catch (err) {
        _didIteratorError15 = true;
        _iteratorError15 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion15 && _iterator15.return != null) {
            _iterator15.return();
          }
        } finally {
          if (_didIteratorError15) {
            throw _iteratorError15;
          }
        }
      }
    }
  }, {
    key: "addEventListenersToPopup",
    value: function addEventListenersToPopup(params) {
      var _this546 = this;

      var eDocument = this.gos.getDocument();
      var ePopupParent = this.getPopupParent();
      var wrapperEl = params.wrapperEl,
          popupEl = params.eChild,
          closedCallback = params.closedCallback,
          afterGuiAttached = params.afterGuiAttached,
          closeOnEsc = params.closeOnEsc,
          modal = params.modal;
      var popupHidden = false;

      var hidePopupOnKeyboardEvent = function hidePopupOnKeyboardEvent(event) {
        if (!wrapperEl.contains(_this546.gos.getActiveDomElement())) {
          return;
        }

        var key = event.key;

        if (key === _KeyCode.ESCAPE && !_isStopPropagationForAgGrid(event)) {
          removeListeners({
            keyboardEvent: event
          });
        }
      };

      var hidePopupOnMouseEvent = function hidePopupOnMouseEvent(event) {
        return removeListeners({
          mouseEvent: event
        });
      };

      var hidePopupOnTouchEvent = function hidePopupOnTouchEvent(event) {
        return removeListeners({
          touchEvent: event
        });
      };

      var removeListeners = function removeListeners() {
        var popupParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var mouseEvent = popupParams.mouseEvent,
            touchEvent = popupParams.touchEvent,
            keyboardEvent = popupParams.keyboardEvent,
            forceHide = popupParams.forceHide;

        if (!forceHide && ( // we don't hide popup if the event was on the child, or any
        // children of this child
        _this546.isEventFromCurrentPopup({
          mouseEvent: mouseEvent,
          touchEvent: touchEvent
        }, popupEl) || // this method should only be called once. the client can have different
        // paths, each one wanting to close, so this method may be called multiple times.
        popupHidden)) {
          return;
        }

        popupHidden = true;
        ePopupParent.removeChild(wrapperEl);
        eDocument.removeEventListener("keydown", hidePopupOnKeyboardEvent);
        eDocument.removeEventListener("mousedown", hidePopupOnMouseEvent);
        eDocument.removeEventListener("touchstart", hidePopupOnTouchEvent);
        eDocument.removeEventListener("contextmenu", hidePopupOnMouseEvent);

        _this546.eventService.removeEventListener(_Events.EVENT_DRAG_STARTED, hidePopupOnMouseEvent);

        if (closedCallback) {
          closedCallback(mouseEvent || touchEvent || keyboardEvent);
        }

        _this546.removePopupFromPopupList(popupEl);
      };

      if (afterGuiAttached) {
        afterGuiAttached({
          hidePopup: removeListeners
        });
      }

      window.setTimeout(function () {
        if (closeOnEsc) {
          eDocument.addEventListener("keydown", hidePopupOnKeyboardEvent);
        }

        if (modal) {
          eDocument.addEventListener("mousedown", hidePopupOnMouseEvent);

          _this546.eventService.addEventListener(_Events.EVENT_DRAG_STARTED, hidePopupOnMouseEvent);

          eDocument.addEventListener("touchstart", hidePopupOnTouchEvent);
          eDocument.addEventListener("contextmenu", hidePopupOnMouseEvent);
        }
      }, 0);
      return removeListeners;
    }
  }, {
    key: "addPopupToPopupList",
    value: function addPopupToPopupList(element, wrapperEl, removeListeners, anchorToElement) {
      this.popupList.push({
        element: element,
        wrapper: wrapperEl,
        hideFunc: removeListeners,
        instanceId: instanceIdSeq++,
        isAnchored: !!anchorToElement
      });

      if (anchorToElement) {
        this.setPopupPositionRelatedToElement(element, anchorToElement);
      }
    }
  }, {
    key: "getPopupIndex",
    value: function getPopupIndex(el) {
      return this.popupList.findIndex(function (p) {
        return p.element === el;
      });
    }
  }, {
    key: "setPopupPositionRelatedToElement",
    value: function setPopupPositionRelatedToElement(popupEl, relativeElement) {
      var popupIndex = this.getPopupIndex(popupEl);

      if (popupIndex === -1) {
        return;
      }

      var popup = this.popupList[popupIndex];

      if (popup.stopAnchoringPromise) {
        popup.stopAnchoringPromise.then(function (destroyFunc) {
          return destroyFunc && destroyFunc();
        });
      }

      popup.stopAnchoringPromise = void 0;
      popup.isAnchored = false;

      if (!relativeElement) {
        return;
      }

      var destroyPositionTracker = this.keepPopupPositionedRelativeTo({
        element: relativeElement,
        ePopup: popupEl,
        hidePopup: popup.hideFunc
      });
      popup.stopAnchoringPromise = destroyPositionTracker;
      popup.isAnchored = true;
      return destroyPositionTracker;
    }
  }, {
    key: "removePopupFromPopupList",
    value: function removePopupFromPopupList(element) {
      this.setAlignedStyles(element, null);
      this.setPopupPositionRelatedToElement(element, null);
      this.popupList = this.popupList.filter(function (p) {
        return p.element !== element;
      });
    }
  }, {
    key: "keepPopupPositionedRelativeTo",
    value: function keepPopupPositionedRelativeTo(params) {
      var _this547 = this;

      var eParent = this.getPopupParent();
      var parentRect = eParent.getBoundingClientRect();
      var element = params.element,
          ePopup = params.ePopup;
      var sourceRect = element.getBoundingClientRect();
      var initialDiffTop = parentRect.top - sourceRect.top;
      var initialDiffLeft = parentRect.left - sourceRect.left;
      var lastDiffTop = initialDiffTop;
      var lastDiffLeft = initialDiffLeft;
      var topPx = ePopup.style.top;
      var top = parseInt(topPx.substring(0, topPx.length - 1), 10);
      var leftPx = ePopup.style.left;
      var left = parseInt(leftPx.substring(0, leftPx.length - 1), 10);
      return new _AgPromise2(function (resolve) {
        _this547.getFrameworkOverrides().setInterval(function () {
          var pRect = eParent.getBoundingClientRect();
          var sRect = element.getBoundingClientRect();
          var elementNotInDom = sRect.top == 0 && sRect.left == 0 && sRect.height == 0 && sRect.width == 0;

          if (elementNotInDom) {
            params.hidePopup();
            return;
          }

          var currentDiffTop = pRect.top - sRect.top;

          if (currentDiffTop != lastDiffTop) {
            var newTop = _this547.keepXYWithinBounds(ePopup, top + initialDiffTop - currentDiffTop, 0
            /* vertical */
            );

            ePopup.style.top = "".concat(newTop, "px");
          }

          lastDiffTop = currentDiffTop;
          var currentDiffLeft = pRect.left - sRect.left;

          if (currentDiffLeft != lastDiffLeft) {
            var newLeft = _this547.keepXYWithinBounds(ePopup, left + initialDiffLeft - currentDiffLeft, 1
            /* horizontal */
            );

            ePopup.style.left = "".concat(newLeft, "px");
          }

          lastDiffLeft = currentDiffLeft;
        }, 200).then(function (intervalId) {
          var result = function result() {
            if (intervalId != null) {
              window.clearInterval(intervalId);
            }
          };

          resolve(result);
        });
      });
    }
  }, {
    key: "hasAnchoredPopup",
    value: function hasAnchoredPopup() {
      return this.popupList.some(function (popup) {
        return popup.isAnchored;
      });
    }
  }, {
    key: "isEventFromCurrentPopup",
    value: function isEventFromCurrentPopup(params, target) {
      var mouseEvent = params.mouseEvent,
          touchEvent = params.touchEvent;
      var event = mouseEvent ? mouseEvent : touchEvent;

      if (!event) {
        return false;
      }

      var indexOfThisChild = this.getPopupIndex(target);

      if (indexOfThisChild === -1) {
        return false;
      }

      for (var i = indexOfThisChild; i < this.popupList.length; i++) {
        var popup = this.popupList[i];

        if (_isElementInEventPath(popup.element, event)) {
          return true;
        }
      }

      return this.isElementWithinCustomPopup(event.target);
    }
  }, {
    key: "isElementWithinCustomPopup",
    value: function isElementWithinCustomPopup(el) {
      var eDocument = this.gos.getDocument();

      while (el && el !== eDocument.body) {
        if (el.classList.contains("ag-custom-component-popup") || el.parentElement === null) {
          return true;
        }

        el = el.parentElement;
      }

      return false;
    }
  }, {
    key: "getWrapper",
    value: function getWrapper(ePopup) {
      while (!ePopup.classList.contains("ag-popup") && ePopup.parentElement) {
        ePopup = ePopup.parentElement;
      }

      return ePopup.classList.contains("ag-popup") ? ePopup : null;
    }
  }, {
    key: "setAlwaysOnTop",
    value: function setAlwaysOnTop(ePopup, alwaysOnTop) {
      var eWrapper = this.getWrapper(ePopup);

      if (!eWrapper) {
        return;
      }

      eWrapper.classList.toggle("ag-always-on-top", !!alwaysOnTop);

      if (alwaysOnTop) {
        this.bringPopupToFront(eWrapper);
      }
    }
  }, {
    key: "bringPopupToFront",
    value: function bringPopupToFront(ePopup) {
      var parent = this.getPopupParent();
      var popupList = Array.prototype.slice.call(parent.querySelectorAll(".ag-popup"));
      var popupLen = popupList.length;
      var alwaysOnTopList = Array.prototype.slice.call(parent.querySelectorAll(".ag-popup.ag-always-on-top"));
      var onTopLength = alwaysOnTopList.length;
      var eWrapper = this.getWrapper(ePopup);

      if (!eWrapper || popupLen <= 1 || !parent.contains(ePopup)) {
        return;
      }

      var pos = popupList.indexOf(eWrapper);
      var innerEls = eWrapper.querySelectorAll("div");
      var innerElsScrollMap = [];
      innerEls.forEach(function (el) {
        if (el.scrollTop !== 0) {
          innerElsScrollMap.push([el, el.scrollTop]);
        }
      });

      if (onTopLength) {
        var isPopupAlwaysOnTop = eWrapper.classList.contains("ag-always-on-top");

        if (isPopupAlwaysOnTop) {
          if (pos !== popupLen - 1) {
            _last(alwaysOnTopList).insertAdjacentElement("afterend", eWrapper);
          }
        } else if (pos !== popupLen - onTopLength - 1) {
          alwaysOnTopList[0].insertAdjacentElement("beforebegin", eWrapper);
        }
      } else if (pos !== popupLen - 1) {
        _last(popupList).insertAdjacentElement("afterend", eWrapper);
      }

      while (innerElsScrollMap.length) {
        var currentEl = innerElsScrollMap.pop();
        currentEl[0].scrollTop = currentEl[1];
      }
    }
  }]);

  return _PopupService;
}(_BeanStub2);

_PopupService2.WAIT_FOR_POPUP_CONTENT_RESIZE = 200;

__decorateClass([_Autowired("focusService")], _PopupService2.prototype, "focusService", 2);

__decorateClass([_Autowired("ctrlsService")], _PopupService2.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("resizeObserverService")], _PopupService2.prototype, "resizeObserverService", 2);

__decorateClass([_PostConstruct], _PopupService2.prototype, "postConstruct", 1);

_PopupService2 = __decorateClass([_Bean("popupService")], _PopupService2); // community-modules/core/src/widgets/agAutocompleteRow.ts

var AgAutocompleteRow =
/*#__PURE__*/
function (_Component39) {
  "use strict";

  _inherits(AgAutocompleteRow, _Component39);

  function AgAutocompleteRow() {
    var _this548;

    _classCallCheck(this, AgAutocompleteRow);

    _this548 = _possibleConstructorReturn(this, _getPrototypeOf(AgAutocompleteRow).call(this,
    /* html */
    "\n        <div class=\"ag-autocomplete-row\" role=\"presentation\">\n            <div class=\"ag-autocomplete-row-label\"></div>\n        </div>"));
    _this548.hasHighlighting = false;
    return _this548;
  }

  _createClass(AgAutocompleteRow, [{
    key: "setState",
    value: function setState(value, selected) {
      this.value = value;
      this.render();
      this.updateSelected(selected);
    }
  }, {
    key: "updateSelected",
    value: function updateSelected(selected) {
      this.addOrRemoveCssClass("ag-autocomplete-row-selected", selected);
    }
  }, {
    key: "setSearchString",
    value: function setSearchString(searchString) {
      var _a;

      var keepHighlighting = false;

      if (_exists(searchString)) {
        var index = (_a = this.value) == null ? void 0 : _a.toLocaleLowerCase().indexOf(searchString.toLocaleLowerCase());

        if (index >= 0) {
          keepHighlighting = true;
          this.hasHighlighting = true;
          var highlightEndIndex = index + searchString.length;

          var startPart = _escapeString(this.value.slice(0, index));

          var highlightedPart = _escapeString(this.value.slice(index, highlightEndIndex));

          var endPart = _escapeString(this.value.slice(highlightEndIndex));

          this.getGui().lastElementChild.innerHTML = "".concat(startPart, "<b>").concat(highlightedPart, "</b>").concat(endPart);
        }
      }

      if (!keepHighlighting && this.hasHighlighting) {
        this.hasHighlighting = false;
        this.render();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _a;

      this.getGui().lastElementChild.innerHTML = (_a = _escapeString(this.value)) != null ? _a : "&nbsp;";
    }
  }]);

  return AgAutocompleteRow;
}(_Component2); // community-modules/core/src/widgets/agAutocompleteList.ts


var _AgAutocompleteList =
/*#__PURE__*/
function (_PopupComponent8) {
  "use strict";

  _inherits(_AgAutocompleteList, _PopupComponent8);

  function _AgAutocompleteList(params) {
    var _this549;

    _classCallCheck(this, _AgAutocompleteList);

    _this549 = _possibleConstructorReturn(this, _getPrototypeOf(_AgAutocompleteList).call(this, _AgAutocompleteList.TEMPLATE));
    _this549.params = params;
    _this549.searchString = "";
    return _this549;
  }

  _createClass(_AgAutocompleteList, [{
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(_AgAutocompleteList.prototype), "destroy", this).call(this);
    }
  }, {
    key: "init",
    value: function init() {
      var _this550 = this;

      this.autocompleteEntries = this.params.autocompleteEntries;
      this.virtualList = this.createManagedBean(new _VirtualList2({
        cssIdentifier: "autocomplete"
      }));
      this.virtualList.setComponentCreator(this.createRowComponent.bind(this));
      this.eList.appendChild(this.virtualList.getGui());
      this.virtualList.setModel({
        getRowCount: function getRowCount() {
          return _this550.autocompleteEntries.length;
        },
        getRow: function getRow(index) {
          return _this550.autocompleteEntries[index];
        }
      });
      var virtualListGui = this.virtualList.getGui();
      this.addManagedListener(virtualListGui, "click", function () {
        return _this550.params.onConfirmed();
      });
      this.addManagedListener(virtualListGui, "mousemove", this.onMouseMove.bind(this));
      this.addManagedListener(virtualListGui, "mousedown", function (e) {
        return e.preventDefault();
      });
      this.setSelectedValue(0);
    }
  }, {
    key: "onNavigationKeyDown",
    value: function onNavigationKeyDown(event, key) {
      event.preventDefault();
      var oldIndex = this.autocompleteEntries.indexOf(this.selectedValue);
      var newIndex = key === _KeyCode.UP ? oldIndex - 1 : oldIndex + 1;
      this.checkSetSelectedValue(newIndex);
    }
  }, {
    key: "setSearch",
    value: function setSearch(searchString) {
      this.searchString = searchString;

      if (_exists(searchString)) {
        this.runSearch();
      } else {
        this.autocompleteEntries = this.params.autocompleteEntries;
        this.virtualList.refresh();
        this.checkSetSelectedValue(0);
      }

      this.updateSearchInList();
    }
  }, {
    key: "runContainsSearch",
    value: function runContainsSearch(searchString, searchStrings) {
      var topMatch;
      var topMatchStartsWithSearchString = false;
      var lowerCaseSearchString = searchString.toLocaleLowerCase();
      var allMatches = searchStrings.filter(function (string) {
        var lowerCaseString = string.toLocaleLowerCase();
        var index = lowerCaseString.indexOf(lowerCaseSearchString);
        var startsWithSearchString = index === 0;
        var isMatch = index >= 0;

        if (isMatch && (!topMatch || !topMatchStartsWithSearchString && startsWithSearchString || topMatchStartsWithSearchString === startsWithSearchString && string.length < topMatch.length)) {
          topMatch = string;
          topMatchStartsWithSearchString = startsWithSearchString;
        }

        return isMatch;
      });

      if (!topMatch && allMatches.length) {
        topMatch = allMatches[0];
      }

      return {
        topMatch: topMatch,
        allMatches: allMatches
      };
    }
  }, {
    key: "runSearch",
    value: function runSearch() {
      var _a, _b;

      var autocompleteEntries = this.params.autocompleteEntries;
      var searchStrings = autocompleteEntries.map(function (v) {
        var _a2;

        return (_a2 = v.displayValue) != null ? _a2 : v.key;
      });
      var matchingStrings;
      var topSuggestion;

      if (this.params.useFuzzySearch) {
        matchingStrings = _fuzzySuggestions(this.searchString, searchStrings, true).values;
        topSuggestion = matchingStrings.length ? matchingStrings[0] : void 0;
      } else {
        var containsMatches = this.runContainsSearch(this.searchString, searchStrings);
        matchingStrings = containsMatches.allMatches;
        topSuggestion = containsMatches.topMatch;
      }

      var filteredEntries = autocompleteEntries.filter(function (_ref50) {
        var key = _ref50.key,
            displayValue = _ref50.displayValue;
        return matchingStrings.includes(displayValue != null ? displayValue : key);
      });

      if (!filteredEntries.length && this.selectedValue && ((_b = (_a = this.params) == null ? void 0 : _a.forceLastSelection) == null ? void 0 : _b.call(_a, this.selectedValue, this.searchString))) {
        filteredEntries = [this.selectedValue];
      }

      this.autocompleteEntries = filteredEntries;
      this.virtualList.refresh();

      if (!topSuggestion) {
        return;
      }

      var topSuggestionIndex = matchingStrings.indexOf(topSuggestion);
      this.checkSetSelectedValue(topSuggestionIndex);
    }
  }, {
    key: "updateSearchInList",
    value: function updateSearchInList() {
      var _this551 = this;

      this.virtualList.forEachRenderedRow(function (row) {
        return row.setSearchString(_this551.searchString);
      });
    }
  }, {
    key: "checkSetSelectedValue",
    value: function checkSetSelectedValue(index) {
      if (index >= 0 && index < this.autocompleteEntries.length) {
        this.setSelectedValue(index);
      }
    }
  }, {
    key: "setSelectedValue",
    value: function setSelectedValue(index) {
      var value = this.autocompleteEntries[index];

      if (this.selectedValue === value) {
        return;
      }

      this.selectedValue = value;
      this.virtualList.ensureIndexVisible(index);
      this.virtualList.forEachRenderedRow(function (cmp, idx) {
        cmp.updateSelected(index === idx);
      });
    }
  }, {
    key: "createRowComponent",
    value: function createRowComponent(value) {
      var _a;

      var row = new AgAutocompleteRow();
      this.getContext().createBean(row);
      row.setState((_a = value.displayValue) != null ? _a : value.key, value === this.selectedValue);
      return row;
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove(mouseEvent) {
      var rect = this.virtualList.getGui().getBoundingClientRect();
      var scrollTop = this.virtualList.getScrollTop();
      var mouseY = mouseEvent.clientY - rect.top + scrollTop;
      var row = Math.floor(mouseY / this.virtualList.getRowHeight());
      this.checkSetSelectedValue(row);
    }
  }, {
    key: "afterGuiAttached",
    value: function afterGuiAttached() {
      this.virtualList.refresh();
    }
  }, {
    key: "getSelectedValue",
    value: function getSelectedValue() {
      var _a;

      if (!this.autocompleteEntries.length) {
        return null;
      }

      ;
      return (_a = this.selectedValue) != null ? _a : null;
    }
  }]);

  return _AgAutocompleteList;
}(_PopupComponent);

_AgAutocompleteList.TEMPLATE =
/* html */
"<div class=\"ag-autocomplete-list-popup\">\n            <div ref=\"eList\" class=\"ag-autocomplete-list\"></div>\n        <div>";

__decorateClass([_RefSelector("eList")], _AgAutocompleteList.prototype, "eList", 2);

__decorateClass([_PostConstruct], _AgAutocompleteList.prototype, "init", 1);

var AgAutocompleteList = _AgAutocompleteList; // community-modules/core/src/widgets/agAutocomplete.ts

var _AgAutocomplete =
/*#__PURE__*/
function (_Component40) {
  "use strict";

  _inherits(_AgAutocomplete, _Component40);

  function _AgAutocomplete() {
    var _this552;

    _classCallCheck(this, _AgAutocomplete);

    _this552 = _possibleConstructorReturn(this, _getPrototypeOf(_AgAutocomplete).call(this,
    /* html */
    "\n            <div class=\"ag-autocomplete\" role=\"presentation\">\n                <ag-input-text-field ref=\"eAutocompleteInput\"></ag-input-text-field>\n            </div>"));
    _this552.isListOpen = false;
    _this552.lastPosition = 0;
    _this552.valid = true;
    return _this552;
  }

  _createClass(_AgAutocomplete, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this553 = this;

      this.eAutocompleteInput.onValueChange(function (value) {
        return _this553.onValueChanged(value);
      });
      this.eAutocompleteInput.getInputElement().setAttribute("autocomplete", "off");
      this.addGuiEventListener("keydown", this.onKeyDown.bind(this));
      this.addGuiEventListener("click", this.updatePositionAndList.bind(this));
      this.addDestroyFunc(function () {
        _this553.destroyBean(_this553.autocompleteList);
      });
      this.addGuiEventListener("focusout", function () {
        return _this553.onFocusOut();
      });
    }
  }, {
    key: "onValueChanged",
    value: function onValueChanged(value) {
      var parsedValue = _makeNull(value);

      this.updateValue(parsedValue);
      this.updateAutocompleteList(parsedValue);
    }
  }, {
    key: "updateValue",
    value: function updateValue(value) {
      this.updateLastPosition();
      this.dispatchEvent({
        type: _AgAutocomplete.EVENT_VALUE_CHANGED,
        value: value
      });
      this.validate(value);
    }
  }, {
    key: "updateAutocompleteList",
    value: function updateAutocompleteList(value) {
      var _a, _b, _c, _d;

      var autocompleteListParams = (_b = (_a = this.listGenerator) == null ? void 0 : _a.call(this, value, this.lastPosition)) != null ? _b : {
        enabled: false
      };

      if (!autocompleteListParams.type || autocompleteListParams.type !== ((_c = this.autocompleteListParams) == null ? void 0 : _c.type)) {
        if (this.isListOpen) {
          this.closeList();
        }
      }

      this.autocompleteListParams = autocompleteListParams;

      if ((_d = this.autocompleteListParams) == null ? void 0 : _d.enabled) {
        if (!this.isListOpen) {
          this.openList();
        }

        var searchString = this.autocompleteListParams.searchString;
        this.autocompleteList.setSearch(searchString != null ? searchString : "");
      } else {
        if (this.isListOpen) {
          this.closeList();
        }
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      var _this554 = this;

      var key = event.key;
      this.updateLastPosition();

      switch (key) {
        case _KeyCode.ENTER:
          this.onEnterKeyDown(event);
          break;

        case _KeyCode.TAB:
          this.onTabKeyDown(event);
          break;

        case _KeyCode.DOWN:
        case _KeyCode.UP:
          this.onUpDownKeyDown(event, key);
          break;

        case _KeyCode.LEFT:
        case _KeyCode.RIGHT:
        case _KeyCode.PAGE_HOME:
        case _KeyCode.PAGE_END:
          setTimeout(function () {
            _this554.updatePositionAndList();
          });
          break;

        case _KeyCode.ESCAPE:
          this.onEscapeKeyDown(event);
          break;

        case _KeyCode.SPACE:
          if (event.ctrlKey && !this.isListOpen) {
            event.preventDefault();
            this.forceOpenList();
          }

          break;
      }
    }
  }, {
    key: "confirmSelection",
    value: function confirmSelection() {
      var _a;

      var selectedValue = (_a = this.autocompleteList) == null ? void 0 : _a.getSelectedValue();

      if (selectedValue) {
        this.closeList();
        this.dispatchEvent({
          type: _AgAutocomplete.EVENT_OPTION_SELECTED,
          value: this.getValue(),
          position: this.lastPosition,
          updateEntry: selectedValue,
          autocompleteType: this.autocompleteListParams.type
        });
      }
    }
  }, {
    key: "onTabKeyDown",
    value: function onTabKeyDown(event) {
      if (this.isListOpen) {
        event.preventDefault();
        event.stopPropagation();
        this.confirmSelection();
      }
    }
  }, {
    key: "onEnterKeyDown",
    value: function onEnterKeyDown(event) {
      event.preventDefault();

      if (this.isListOpen) {
        this.confirmSelection();
      } else {
        this.onCompleted();
      }
    }
  }, {
    key: "onUpDownKeyDown",
    value: function onUpDownKeyDown(event, key) {
      var _a;

      event.preventDefault();

      if (!this.isListOpen) {
        this.forceOpenList();
      } else {
        (_a = this.autocompleteList) == null ? void 0 : _a.onNavigationKeyDown(event, key);
      }
    }
  }, {
    key: "onEscapeKeyDown",
    value: function onEscapeKeyDown(event) {
      if (this.isListOpen) {
        event.preventDefault();
        event.stopPropagation();
        this.closeList();
        this.setCaret(this.lastPosition, true);
      }
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut() {
      if (this.isListOpen) {
        this.closeList();
      }
    }
  }, {
    key: "updatePositionAndList",
    value: function updatePositionAndList() {
      var _a;

      this.updateLastPosition();
      this.updateAutocompleteList((_a = this.eAutocompleteInput.getValue()) != null ? _a : null);
    }
  }, {
    key: "setCaret",
    value: function setCaret(position, setFocus) {
      var eDocument = this.gos.getDocument();
      var activeEl = this.gos.getActiveDomElement();

      if (setFocus && (!activeEl || activeEl === eDocument.body)) {
        this.eAutocompleteInput.getFocusableElement().focus();
      }

      var eInput = this.eAutocompleteInput.getInputElement();
      eInput.setSelectionRange(position, position);

      if (position === eInput.value.length) {
        eInput.scrollLeft = eInput.scrollWidth;
      }
    }
  }, {
    key: "forceOpenList",
    value: function forceOpenList() {
      this.onValueChanged(this.eAutocompleteInput.getValue());
    }
  }, {
    key: "updateLastPosition",
    value: function updateLastPosition() {
      var _a;

      this.lastPosition = (_a = this.eAutocompleteInput.getInputElement().selectionStart) != null ? _a : 0;
    }
  }, {
    key: "validate",
    value: function validate(value) {
      var _a;

      if (!this.validator) {
        return;
      }

      this.validationMessage = this.validator(value);
      this.eAutocompleteInput.getInputElement().setCustomValidity((_a = this.validationMessage) != null ? _a : "");
      this.valid = !this.validationMessage;
      this.dispatchEvent({
        type: _AgAutocomplete.EVENT_VALID_CHANGED,
        isValid: this.valid,
        validationMessage: this.validationMessage
      });
    }
  }, {
    key: "openList",
    value: function openList() {
      var _this555 = this;

      this.isListOpen = true;
      this.autocompleteList = this.createBean(new AgAutocompleteList({
        autocompleteEntries: this.autocompleteListParams.entries,
        onConfirmed: function onConfirmed() {
          return _this555.confirmSelection();
        },
        forceLastSelection: this.forceLastSelection
      }));
      var ePopupGui = this.autocompleteList.getGui();
      var positionParams = {
        ePopup: ePopupGui,
        type: "autocomplete",
        eventSource: this.getGui(),
        position: "under",
        alignSide: this.gos.get("enableRtl") ? "right" : "left",
        keepWithinBounds: true
      };
      var addPopupRes = this.popupService.addPopup({
        eChild: ePopupGui,
        anchorToElement: this.getGui(),
        positionCallback: function positionCallback() {
          return _this555.popupService.positionPopupByComponent(positionParams);
        },
        ariaLabel: this.listAriaLabel
      });
      this.hidePopup = addPopupRes.hideFunc;
      this.autocompleteList.afterGuiAttached();
    }
  }, {
    key: "closeList",
    value: function closeList() {
      this.isListOpen = false;
      this.hidePopup();
      this.destroyBean(this.autocompleteList);
      this.autocompleteList = null;
    }
  }, {
    key: "onCompleted",
    value: function onCompleted() {
      if (this.isListOpen) {
        this.closeList();
      }

      this.dispatchEvent({
        type: _AgAutocomplete.EVENT_VALUE_CONFIRMED,
        value: this.getValue(),
        isValid: this.isValid()
      });
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return _makeNull(this.eAutocompleteInput.getValue());
    }
  }, {
    key: "setInputPlaceholder",
    value: function setInputPlaceholder(placeholder) {
      this.eAutocompleteInput.setInputPlaceholder(placeholder);
      return this;
    }
  }, {
    key: "setInputAriaLabel",
    value: function setInputAriaLabel(label) {
      this.eAutocompleteInput.setInputAriaLabel(label);
      return this;
    }
  }, {
    key: "setListAriaLabel",
    value: function setListAriaLabel(label) {
      this.listAriaLabel = label;
      return this;
    }
  }, {
    key: "setListGenerator",
    value: function setListGenerator(listGenerator) {
      this.listGenerator = listGenerator;
      return this;
    }
  }, {
    key: "setValidator",
    value: function setValidator(validator) {
      this.validator = validator;
      return this;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return this.valid;
    }
  }, {
    key: "setValue",
    value: function setValue(params) {
      var value = params.value,
          position = params.position,
          silent = params.silent,
          updateListOnlyIfOpen = params.updateListOnlyIfOpen,
          restoreFocus = params.restoreFocus;
      this.eAutocompleteInput.setValue(value, true);
      this.setCaret(position != null ? position : this.lastPosition, restoreFocus);

      if (!silent) {
        this.updateValue(value);
      }

      if (!updateListOnlyIfOpen || this.isListOpen) {
        this.updateAutocompleteList(value);
      }
    }
  }, {
    key: "setForceLastSelection",
    value: function setForceLastSelection(forceLastSelection) {
      this.forceLastSelection = forceLastSelection;
      return this;
    }
  }, {
    key: "setInputDisabled",
    value: function setInputDisabled(disabled) {
      this.eAutocompleteInput.setDisabled(disabled);
      return this;
    }
  }]);

  return _AgAutocomplete;
}(_Component2);

_AgAutocomplete.EVENT_VALUE_CHANGED = "eventValueChanged";
_AgAutocomplete.EVENT_VALUE_CONFIRMED = "eventValueConfirmed";
_AgAutocomplete.EVENT_OPTION_SELECTED = "eventOptionSelected";
_AgAutocomplete.EVENT_VALID_CHANGED = "eventValidChanged";

__decorateClass([_Autowired("popupService")], _AgAutocomplete.prototype, "popupService", 2);

__decorateClass([_RefSelector("eAutocompleteInput")], _AgAutocomplete.prototype, "eAutocompleteInput", 2);

__decorateClass([_PostConstruct], _AgAutocomplete.prototype, "postConstruct", 1);

var _AgAutocomplete2 = _AgAutocomplete; // community-modules/core/src/widgets/pillDragComp.ts

var _PillDragComp =
/*#__PURE__*/
function (_Component41) {
  "use strict";

  _inherits(_PillDragComp, _Component41);

  function _PillDragComp(dragSourceDropTarget, ghost, horizontal, template) {
    var _this556;

    _classCallCheck(this, _PillDragComp);

    _this556 = _possibleConstructorReturn(this, _getPrototypeOf(_PillDragComp).call(this));
    _this556.dragSourceDropTarget = dragSourceDropTarget;
    _this556.ghost = ghost;
    _this556.horizontal = horizontal;
    _this556.template = template;
    return _this556;
  }

  _createClass(_PillDragComp, [{
    key: "init",
    value: function init() {
      var _a;

      this.setTemplate((_a = this.template) != null ? _a : _PillDragComp.TEMPLATE);
      var eGui = this.getGui();
      this.addElementClasses(eGui);
      this.addElementClasses(this.eDragHandle, "drag-handle");
      this.addElementClasses(this.eText, "text");
      this.addElementClasses(this.eButton, "button");
      this.eDragHandle.appendChild(_createIconNoSpan("columnDrag", this.gos));
      this.eButton.appendChild(_createIconNoSpan("cancel", this.gos));
      this.setupComponents();

      if (!this.ghost && this.isDraggable()) {
        this.addDragSource();
      }

      this.setupAria();
      this.setupTooltip();
      this.activateTabIndex();
      this.refreshDraggable();
    }
  }, {
    key: "isDraggable",
    value: function isDraggable() {
      return true;
    }
  }, {
    key: "refreshDraggable",
    value: function refreshDraggable() {
      this.eDragHandle.classList.toggle("ag-column-select-column-readonly", !this.isDraggable());
    }
  }, {
    key: "setupAria",
    value: function setupAria() {
      var translate = this.localeService.getLocaleTextFunc();
      var ariaInstructions = [this.getAriaDisplayName()];
      this.addAdditionalAriaInstructions(ariaInstructions, translate);

      _setAriaLabel(this.getGui(), ariaInstructions.join(". "));
    }
  }, {
    key: "addAdditionalAriaInstructions",
    value: function addAdditionalAriaInstructions(ariaInstructions, translate) {
      if (this.isRemovable()) {
        var deleteAria = translate("ariaDropZoneColumnComponentDescription", "Press DELETE to remove");
        ariaInstructions.push(deleteAria);
      }
    }
  }, {
    key: "setupTooltip",
    value: function setupTooltip() {
      var _this557 = this;

      var refresh = function refresh() {
        var newTooltipText = _this557.getTooltip();

        _this557.setTooltip({
          newTooltipText: newTooltipText
        });
      };

      refresh();
      this.addManagedListener(this.eventService, _Events.EVENT_NEW_COLUMNS_LOADED, refresh);
    }
  }, {
    key: "getDragSourceId",
    value: function getDragSourceId() {
      return void 0;
    }
  }, {
    key: "getDefaultIconName",
    value: function getDefaultIconName() {
      return _DragAndDropService2.ICON_NOT_ALLOWED;
    }
  }, {
    key: "addDragSource",
    value: function addDragSource() {
      var dragAndDropService = this.dragAndDropService,
          eDragHandle = this.eDragHandle;
      var getDragItem = this.createGetDragItem();
      var defaultIconName = this.getDefaultIconName();
      var dragSource = {
        type: this.getDragSourceType(),
        sourceId: this.getDragSourceId(),
        eElement: eDragHandle,
        getDefaultIconName: function getDefaultIconName() {
          return defaultIconName;
        },
        getDragItem: getDragItem,
        dragItemName: this.getDisplayName()
      };
      dragAndDropService.addDragSource(dragSource, true);
      this.addDestroyFunc(function () {
        return dragAndDropService.removeDragSource(dragSource);
      });
    }
  }, {
    key: "setupComponents",
    value: function setupComponents() {
      this.setTextValue();
      this.setupRemove();

      if (this.ghost) {
        this.addCssClass("ag-column-drop-cell-ghost");
      }
    }
  }, {
    key: "isRemovable",
    value: function isRemovable() {
      return true;
    }
  }, {
    key: "refreshRemove",
    value: function refreshRemove() {
      _setDisplayed(this.eButton, this.isRemovable());
    }
  }, {
    key: "setupRemove",
    value: function setupRemove() {
      var _this558 = this;

      this.refreshRemove();
      var agEvent = {
        type: _PillDragComp.EVENT_COLUMN_REMOVE
      };
      this.addGuiEventListener("keydown", function (e) {
        return _this558.onKeyDown(e);
      });
      this.addManagedListener(this.eButton, "click", function (mouseEvent) {
        _this558.dispatchEvent(agEvent);

        mouseEvent.stopPropagation();
      });
      var touchListener = new _TouchListener2(this.eButton);
      this.addManagedListener(touchListener, _TouchListener2.EVENT_TAP, function () {
        _this558.dispatchEvent(agEvent);
      });
      this.addDestroyFunc(touchListener.destroy.bind(touchListener));
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var isDelete = e.key === _KeyCode.DELETE;

      if (isDelete) {
        if (this.isRemovable()) {
          e.preventDefault();
          this.dispatchEvent({
            type: _PillDragComp.EVENT_COLUMN_REMOVE
          });
        }
      }
    }
  }, {
    key: "getDisplayValue",
    value: function getDisplayValue() {
      return this.getDisplayName();
    }
  }, {
    key: "setTextValue",
    value: function setTextValue() {
      var displayValue = this.getDisplayValue();

      var displayValueSanitised = _escapeString(displayValue);

      this.eText.innerHTML = displayValueSanitised;
    }
  }, {
    key: "addElementClasses",
    value: function addElementClasses(el, suffix) {
      suffix = suffix ? "-".concat(suffix) : "";
      var direction = this.horizontal ? "horizontal" : "vertical";
      el.classList.add("ag-column-drop-cell".concat(suffix), "ag-column-drop-".concat(direction, "-cell").concat(suffix));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(_PillDragComp.prototype), "destroy", this).call(this);

      this.dragSourceDropTarget = null;
    }
  }]);

  return _PillDragComp;
}(_Component2);

_PillDragComp.EVENT_COLUMN_REMOVE = "columnRemove";
_PillDragComp.TEMPLATE =
/* html */
"<span role=\"option\">\n          <span ref=\"eDragHandle\" class=\"ag-drag-handle ag-column-drop-cell-drag-handle\" role=\"presentation\"></span>\n          <span ref=\"eText\" class=\"ag-column-drop-cell-text\" aria-hidden=\"true\"></span>\n          <span ref=\"eButton\" class=\"ag-column-drop-cell-button\" role=\"presentation\"></span>\n        </span>";

__decorateClass([_Autowired("dragAndDropService")], _PillDragComp.prototype, "dragAndDropService", 2);

__decorateClass([_RefSelector("eText")], _PillDragComp.prototype, "eText", 2);

__decorateClass([_RefSelector("eDragHandle")], _PillDragComp.prototype, "eDragHandle", 2);

__decorateClass([_RefSelector("eButton")], _PillDragComp.prototype, "eButton", 2);

__decorateClass([_PostConstruct], _PillDragComp.prototype, "init", 1);

var _PillDragComp2 = _PillDragComp; // community-modules/core/src/widgets/pillDropZonePanel.ts

var _PillDropZonePanel =
/*#__PURE__*/
function (_Component42) {
  "use strict";

  _inherits(_PillDropZonePanel, _Component42);

  function _PillDropZonePanel(horizontal) {
    var _this559;

    _classCallCheck(this, _PillDropZonePanel);

    _this559 = _possibleConstructorReturn(this, _getPrototypeOf(_PillDropZonePanel).call(this,
    /* html */
    "<div class=\"ag-unselectable\" role=\"presentation\"></div>"));
    _this559.horizontal = horizontal;
    _this559.state = _PillDropZonePanel.STATE_NOT_DRAGGING;
    _this559.guiDestroyFunctions = [];
    _this559.childPillComponents = [];
    _this559.resizeEnabled = false;

    _this559.addElementClasses(_this559.getGui());

    _this559.ePillDropList = document.createElement("div");

    _this559.addElementClasses(_this559.ePillDropList, "list");

    _setAriaRole(_this559.ePillDropList, "listbox");

    return _this559;
  }

  _createClass(_PillDropZonePanel, [{
    key: "isHorizontal",
    value: function isHorizontal() {
      return this.horizontal;
    }
  }, {
    key: "toggleResizable",
    value: function toggleResizable(resizable) {
      this.positionableFeature.setResizable(resizable ? {
        bottom: true
      } : false);
      this.resizeEnabled = resizable;
    }
  }, {
    key: "isSourceEventFromTarget",
    value: function isSourceEventFromTarget(draggingEvent) {
      var dropZoneTarget = draggingEvent.dropZoneTarget,
          dragSource = draggingEvent.dragSource;
      return dropZoneTarget.contains(dragSource.eElement);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.destroyGui();

      _get(_getPrototypeOf(_PillDropZonePanel.prototype), "destroy", this).call(this);
    }
  }, {
    key: "destroyGui",
    value: function destroyGui() {
      this.guiDestroyFunctions.forEach(function (func) {
        return func();
      });
      this.guiDestroyFunctions.length = 0;
      this.childPillComponents.length = 0;

      _clearElement(this.getGui());

      _clearElement(this.ePillDropList);
    }
  }, {
    key: "init",
    value: function init(params) {
      this.params = params != null ? params : {};
      this.createManagedBean(new _ManagedFocusFeature2(this.getFocusableElement(), {
        handleKeyDown: this.handleKeyDown.bind(this)
      }));
      this.setupDropTarget();
      this.positionableFeature = new _PositionableFeature(this.getGui(), {
        minHeight: 100
      });
      this.createManagedBean(this.positionableFeature);
      this.refreshGui();

      _setAriaLabel(this.ePillDropList, this.getAriaLabel());
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var isVertical = !this.horizontal;
      var isNext = e.key === _KeyCode.DOWN;
      var isPrevious = e.key === _KeyCode.UP;

      if (!isVertical) {
        var isRtl = this.gos.get("enableRtl");
        isNext = !isRtl && e.key === _KeyCode.RIGHT || isRtl && e.key === _KeyCode.LEFT;
        isPrevious = !isRtl && e.key === _KeyCode.LEFT || isRtl && e.key === _KeyCode.RIGHT;
      }

      if (!isNext && !isPrevious) {
        return;
      }

      var el = this.focusService.findNextFocusableElement(this.getFocusableElement(), false, isPrevious);

      if (el) {
        e.preventDefault();
        el.focus();
      }
    }
  }, {
    key: "addElementClasses",
    value: function addElementClasses(el, suffix) {
      suffix = suffix ? "-".concat(suffix) : "";
      var direction = this.horizontal ? "horizontal" : "vertical";
      el.classList.add("ag-column-drop".concat(suffix), "ag-column-drop-".concat(direction).concat(suffix));
    }
  }, {
    key: "setupDropTarget",
    value: function setupDropTarget() {
      this.dropTarget = {
        getContainer: this.getGui.bind(this),
        getIconName: this.getIconName.bind(this),
        onDragging: this.onDragging.bind(this),
        onDragEnter: this.onDragEnter.bind(this),
        onDragLeave: this.onDragLeave.bind(this),
        onDragStop: this.onDragStop.bind(this),
        isInterestedIn: this.isInterestedIn.bind(this)
      };
      this.dragAndDropService.addDropTarget(this.dropTarget);
    }
  }, {
    key: "minimumAllowedNewInsertIndex",
    value: function minimumAllowedNewInsertIndex() {
      return 0;
    }
  }, {
    key: "checkInsertIndex",
    value: function checkInsertIndex(draggingEvent) {
      var newIndex = this.getNewInsertIndex(draggingEvent);

      if (newIndex < 0) {
        return false;
      }

      var minimumAllowedIndex = this.minimumAllowedNewInsertIndex();
      var newAdjustedIndex = Math.max(minimumAllowedIndex, newIndex);
      var changed = newAdjustedIndex !== this.insertIndex;

      if (changed) {
        this.insertIndex = newAdjustedIndex;
      }

      return changed;
    }
  }, {
    key: "getNewInsertIndex",
    value: function getNewInsertIndex(draggingEvent) {
      var _this560 = this;

      var mouseEvent = draggingEvent.event;
      var mouseLocation = this.horizontal ? mouseEvent.clientX : mouseEvent.clientY;
      var boundsList = this.childPillComponents.map(function (comp) {
        return comp.getGui().getBoundingClientRect();
      });
      var hoveredIndex = boundsList.findIndex(function (rect) {
        return _this560.horizontal ? rect.right > mouseLocation && rect.left < mouseLocation : rect.top < mouseLocation && rect.bottom > mouseLocation;
      });

      if (hoveredIndex === -1) {
        var enableRtl = this.gos.get("enableRtl");
        var isLast = boundsList.every(function (rect) {
          return mouseLocation > (_this560.horizontal ? rect.right : rect.bottom);
        });

        if (isLast) {
          return enableRtl && this.horizontal ? 0 : this.childPillComponents.length;
        }

        var isFirst = boundsList.every(function (rect) {
          return mouseLocation < (_this560.horizontal ? rect.left : rect.top);
        });

        if (isFirst) {
          return enableRtl && this.horizontal ? this.childPillComponents.length : 0;
        }

        return this.insertIndex;
      }

      if (this.insertIndex <= hoveredIndex) {
        return hoveredIndex + 1;
      }

      return hoveredIndex;
    }
  }, {
    key: "checkDragStartedBySelf",
    value: function checkDragStartedBySelf(draggingEvent) {
      if (this.state !== _PillDropZonePanel.STATE_NOT_DRAGGING) {
        return;
      }

      this.state = _PillDropZonePanel.STATE_REARRANGE_ITEMS;
      this.potentialDndItems = this.getItems(draggingEvent.dragSource.getDragItem());
      this.refreshGui();
      this.checkInsertIndex(draggingEvent);
      this.refreshGui();
    }
  }, {
    key: "onDragging",
    value: function onDragging(draggingEvent) {
      this.checkDragStartedBySelf(draggingEvent);

      if (this.checkInsertIndex(draggingEvent)) {
        this.refreshGui();
      }
    }
  }, {
    key: "handleDragEnterEnd",
    value: function handleDragEnterEnd(draggingEvent) {}
  }, {
    key: "onDragEnter",
    value: function onDragEnter(draggingEvent) {
      var _this561 = this;

      var dragItems = this.getItems(draggingEvent.dragSource.getDragItem());
      this.state = _PillDropZonePanel.STATE_NEW_ITEMS_IN;
      var goodDragItems = dragItems.filter(function (item) {
        return _this561.isItemDroppable(item, draggingEvent);
      });
      var alreadyPresent = goodDragItems.every(function (item) {
        return _this561.childPillComponents.map(function (cmp) {
          return cmp.getItem();
        }).indexOf(item) !== -1;
      });

      if (goodDragItems.length === 0) {
        return;
      }

      this.potentialDndItems = goodDragItems;

      if (alreadyPresent) {
        this.state = _PillDropZonePanel.STATE_NOT_DRAGGING;
        return;
      }

      this.handleDragEnterEnd(draggingEvent);
      this.checkInsertIndex(draggingEvent);
      this.refreshGui();
    }
  }, {
    key: "isPotentialDndItems",
    value: function isPotentialDndItems() {
      return _existsAndNotEmpty(this.potentialDndItems);
    }
  }, {
    key: "handleDragLeaveEnd",
    value: function handleDragLeaveEnd(draggingEvent) {}
  }, {
    key: "onDragLeave",
    value: function onDragLeave(draggingEvent) {
      if (this.state === _PillDropZonePanel.STATE_REARRANGE_ITEMS) {
        var items = this.getItems(draggingEvent.dragSource.getDragItem());
        this.removeItems(items);
      }

      if (this.isPotentialDndItems()) {
        this.handleDragLeaveEnd(draggingEvent);
        this.potentialDndItems = [];
        this.refreshGui();
      }

      this.state = _PillDropZonePanel.STATE_NOT_DRAGGING;
    }
  }, {
    key: "refreshOnDragStop",
    value: function refreshOnDragStop() {
      return true;
    }
  }, {
    key: "onDragStop",
    value: function onDragStop() {
      if (this.isPotentialDndItems()) {
        var success = false;

        if (this.state === _PillDropZonePanel.STATE_NEW_ITEMS_IN) {
          this.addItems(this.potentialDndItems);
          success = true;
        } else {
          success = this.rearrangeItems(this.potentialDndItems);
        }

        this.potentialDndItems = [];

        if (this.refreshOnDragStop() || !success) {
          this.refreshGui();
        }
      }

      this.state = _PillDropZonePanel.STATE_NOT_DRAGGING;
    }
  }, {
    key: "removeItems",
    value: function removeItems(itemsToRemove) {
      var newItemList = this.getExistingItems().filter(function (item) {
        return !_includes(itemsToRemove, item);
      });
      this.updateItems(newItemList);
    }
  }, {
    key: "addItems",
    value: function addItems(itemsToAdd) {
      if (!itemsToAdd) {
        return;
      }

      var newItemList = this.getExistingItems().slice();
      var itemsToAddNoDuplicates = itemsToAdd.filter(function (item) {
        return newItemList.indexOf(item) < 0;
      });

      _insertArrayIntoArray(newItemList, itemsToAddNoDuplicates, this.insertIndex);

      this.updateItems(newItemList);
    }
  }, {
    key: "addItem",
    value: function addItem(item) {
      this.insertIndex = this.getExistingItems().length;
      this.addItems([item]);
      this.refreshGui();
    }
  }, {
    key: "rearrangeItems",
    value: function rearrangeItems(itemsToAdd) {
      var newItemList = this.getNonGhostItems().slice();

      _insertArrayIntoArray(newItemList, itemsToAdd, this.insertIndex);

      if (_areEqual(newItemList, this.getExistingItems())) {
        return false;
      }

      this.updateItems(newItemList);
      return true;
    }
  }, {
    key: "refreshGui",
    value: function refreshGui() {
      var scrollTop = this.ePillDropList.scrollTop;
      var resizeEnabled = this.resizeEnabled;
      var focusedIndex = this.getFocusedItem();
      var alternateElement = this.focusService.findNextFocusableElement();

      if (!alternateElement) {
        alternateElement = this.focusService.findNextFocusableElement(void 0, false, true);
      }

      this.toggleResizable(false);
      this.destroyGui();
      this.addIconAndTitleToGui();
      this.addEmptyMessageToGui();
      this.addItemsToGui();

      if (!this.isHorizontal()) {
        this.ePillDropList.scrollTop = scrollTop;
      }

      if (resizeEnabled) {
        this.toggleResizable(resizeEnabled);
      }

      if (this.focusService.isKeyboardMode()) {
        this.restoreFocus(focusedIndex, alternateElement);
      }
    }
  }, {
    key: "getFocusedItem",
    value: function getFocusedItem() {
      var eGui = this.getGui();
      var activeElement = this.gos.getActiveDomElement();

      if (!eGui.contains(activeElement)) {
        return -1;
      }

      var items = Array.from(eGui.querySelectorAll(".ag-column-drop-cell"));
      return items.indexOf(activeElement);
    }
  }, {
    key: "restoreFocus",
    value: function restoreFocus(index, alternateElement) {
      var eGui = this.getGui();
      var items = Array.from(eGui.querySelectorAll(".ag-column-drop-cell"));

      if (index === -1) {
        return;
      }

      if (items.length === 0) {
        alternateElement.focus();
      }

      var indexToFocus = Math.min(items.length - 1, index);
      var el = items[indexToFocus];

      if (el) {
        el.focus();
      }
    }
  }, {
    key: "focusList",
    value: function focusList(fromBottom) {
      var index = fromBottom ? this.childPillComponents.length - 1 : 0;
      this.restoreFocus(index, this.getFocusableElement());
    }
  }, {
    key: "getNonGhostItems",
    value: function getNonGhostItems() {
      var _this562 = this;

      var existingItems = this.getExistingItems();

      if (this.isPotentialDndItems()) {
        return existingItems.filter(function (item) {
          return !_includes(_this562.potentialDndItems, item);
        });
      }

      return existingItems;
    }
  }, {
    key: "addItemsToGui",
    value: function addItemsToGui() {
      var _this563 = this;

      var nonGhostItems = this.getNonGhostItems();
      var itemsToAddToGui = nonGhostItems.map(function (item) {
        return _this563.createItemComponent(item, false);
      });

      if (this.isPotentialDndItems()) {
        var dndItems = this.potentialDndItems.map(function (item) {
          return _this563.createItemComponent(item, true);
        });

        if (this.insertIndex >= itemsToAddToGui.length) {
          itemsToAddToGui.push.apply(itemsToAddToGui, _toConsumableArray(dndItems));
        } else {
          itemsToAddToGui.splice.apply(itemsToAddToGui, [this.insertIndex, 0].concat(_toConsumableArray(dndItems)));
        }
      }

      this.appendChild(this.ePillDropList);
      itemsToAddToGui.forEach(function (itemComponent, index) {
        if (index > 0) {
          _this563.addArrow(_this563.ePillDropList);
        }

        _this563.ePillDropList.appendChild(itemComponent.getGui());
      });
      this.addAriaLabelsToComponents();
    }
  }, {
    key: "addAriaLabelsToComponents",
    value: function addAriaLabelsToComponents() {
      var _this564 = this;

      this.childPillComponents.forEach(function (comp, idx) {
        var eGui = comp.getGui();

        _setAriaPosInSet(eGui, idx + 1);

        _setAriaSetSize(eGui, _this564.childPillComponents.length);
      });
    }
  }, {
    key: "createItemComponent",
    value: function createItemComponent(item, ghost) {
      var _this565 = this;

      var itemComponent = this.createPillComponent(item, this.dropTarget, ghost, this.horizontal);
      itemComponent.addEventListener(_PillDragComp2.EVENT_COLUMN_REMOVE, this.removeItems.bind(this, [item]));
      this.context.createBean(itemComponent);
      this.guiDestroyFunctions.push(function () {
        return _this565.destroyBean(itemComponent);
      });

      if (!ghost) {
        this.childPillComponents.push(itemComponent);
      }

      return itemComponent;
    }
  }, {
    key: "addIconAndTitleToGui",
    value: function addIconAndTitleToGui() {
      var _this$params7 = this.params,
          title = _this$params7.title,
          eGroupIcon = _this$params7.icon;

      if (!title || !eGroupIcon) {
        return;
      }

      var eTitleBar = document.createElement("div");

      _setAriaHidden(eTitleBar, true);

      this.addElementClasses(eTitleBar, "title-bar");
      this.addElementClasses(eGroupIcon, "icon");
      this.addOrRemoveCssClass("ag-column-drop-empty", this.isExistingItemsEmpty());
      eTitleBar.appendChild(eGroupIcon);

      if (!this.horizontal) {
        var eTitle = document.createElement("span");
        this.addElementClasses(eTitle, "title");
        eTitle.innerHTML = title;
        eTitleBar.appendChild(eTitle);
      }

      this.appendChild(eTitleBar);
    }
  }, {
    key: "isExistingItemsEmpty",
    value: function isExistingItemsEmpty() {
      return this.getExistingItems().length === 0;
    }
  }, {
    key: "addEmptyMessageToGui",
    value: function addEmptyMessageToGui() {
      var emptyMessage = this.params.emptyMessage;

      if (!emptyMessage || !this.isExistingItemsEmpty() || this.isPotentialDndItems()) {
        return;
      }

      var eMessage = document.createElement("span");
      eMessage.innerHTML = emptyMessage;
      this.addElementClasses(eMessage, "empty-message");
      this.ePillDropList.appendChild(eMessage);
    }
  }, {
    key: "addArrow",
    value: function addArrow(eParent) {
      if (this.horizontal) {
        var enableRtl = this.gos.get("enableRtl");

        var icon = _createIconNoSpan(enableRtl ? "smallLeft" : "smallRight", this.gos);

        this.addElementClasses(icon, "cell-separator");
        eParent.appendChild(icon);
      }
    }
  }]);

  return _PillDropZonePanel;
}(_Component2);

_PillDropZonePanel.STATE_NOT_DRAGGING = "notDragging";
_PillDropZonePanel.STATE_NEW_ITEMS_IN = "newItemsIn";
_PillDropZonePanel.STATE_REARRANGE_ITEMS = "rearrangeItems";

__decorateClass([_Autowired("focusService")], _PillDropZonePanel.prototype, "focusService", 2);

__decorateClass([_Autowired("dragAndDropService")], _PillDropZonePanel.prototype, "dragAndDropService", 2);

var _PillDropZonePanel2 = _PillDropZonePanel; // community-modules/core/src/vanillaFrameworkOverrides.ts

var PASSIVE_EVENTS2 = ["touchstart", "touchend", "touchmove", "touchcancel"];

var _VanillaFrameworkOverrides =
/*#__PURE__*/
function () {
  "use strict";

  function _VanillaFrameworkOverrides() {
    var frameworkName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "javascript";

    _classCallCheck(this, _VanillaFrameworkOverrides);

    this.frameworkName = frameworkName;
    this.renderingEngine = "vanilla";

    this.wrapIncoming = function (callback) {
      return callback();
    };

    this.wrapOutgoing = function (callback) {
      return callback();
    };
  }

  _createClass(_VanillaFrameworkOverrides, [{
    key: "setInterval",
    value: function setInterval(action, timeout) {
      return new _AgPromise2(function (resolve) {
        resolve(window.setInterval(action, timeout));
      });
    } // for Vanilla JS, we just add the event to the element

  }, {
    key: "addEventListener",
    value: function addEventListener(element, type, listener, useCapture) {
      var isPassive = _includes(PASSIVE_EVENTS2, type);

      element.addEventListener(type, listener, {
        capture: !!useCapture,
        passive: isPassive
      });
    }
  }, {
    key: "frameworkComponent",
    value: function frameworkComponent(name) {
      return null;
    }
  }, {
    key: "isFrameworkComponent",
    value: function isFrameworkComponent(comp) {
      return false;
    }
  }, {
    key: "getDocLink",
    value: function getDocLink(path) {
      var framework = this.frameworkName === "solid" ? "react" : this.frameworkName;
      return "https://www.ag-grid.com/".concat(framework, "-data-grid").concat(path ? "/".concat(path) : "");
    }
  }, {
    key: "shouldWrapOutgoing",
    get: function get() {
      return false;
    }
  }]);

  return _VanillaFrameworkOverrides;
}(); // community-modules/core/src/cellNavigationService.ts


var _CellNavigationService =
/*#__PURE__*/
function (_BeanStub73) {
  "use strict";

  _inherits(_CellNavigationService, _BeanStub73);

  function _CellNavigationService() {
    _classCallCheck(this, _CellNavigationService);

    return _possibleConstructorReturn(this, _getPrototypeOf(_CellNavigationService).apply(this, arguments));
  }

  _createClass(_CellNavigationService, [{
    key: "getNextCellToFocus",
    // returns null if no cell to focus on, ie at the end of the grid
    value: function getNextCellToFocus(key, focusedCell) {
      var ctrlPressed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (ctrlPressed) {
        return this.getNextCellToFocusWithCtrlPressed(key, focusedCell);
      }

      return this.getNextCellToFocusWithoutCtrlPressed(key, focusedCell);
    }
  }, {
    key: "getNextCellToFocusWithCtrlPressed",
    value: function getNextCellToFocusWithCtrlPressed(key, focusedCell) {
      var upKey = key === _KeyCode.UP;
      var downKey = key === _KeyCode.DOWN;
      var leftKey = key === _KeyCode.LEFT;
      var column;
      var rowIndex;

      if (upKey || downKey) {
        rowIndex = upKey ? this.paginationProxy.getPageFirstRow() : this.paginationProxy.getPageLastRow();
        column = focusedCell.column;
      } else {
        var allColumns = this.columnModel.getAllDisplayedColumns();
        var isRtl = this.gos.get("enableRtl");
        rowIndex = focusedCell.rowIndex;
        column = leftKey !== isRtl ? allColumns[0] : _last(allColumns);
      }

      return {
        rowIndex: rowIndex,
        rowPinned: null,
        column: column
      };
    }
  }, {
    key: "getNextCellToFocusWithoutCtrlPressed",
    value: function getNextCellToFocusWithoutCtrlPressed(key, focusedCell) {
      var pointer = focusedCell;
      var finished = false;

      while (!finished) {
        switch (key) {
          case _KeyCode.UP:
            pointer = this.getCellAbove(pointer);
            break;

          case _KeyCode.DOWN:
            pointer = this.getCellBelow(pointer);
            break;

          case _KeyCode.RIGHT:
            if (this.gos.get("enableRtl")) {
              pointer = this.getCellToLeft(pointer);
            } else {
              pointer = this.getCellToRight(pointer);
            }

            break;

          case _KeyCode.LEFT:
            if (this.gos.get("enableRtl")) {
              pointer = this.getCellToRight(pointer);
            } else {
              pointer = this.getCellToLeft(pointer);
            }

            break;

          default:
            pointer = null;
            console.warn("AG Grid: unknown key for navigation " + key);
            break;
        }

        if (pointer) {
          finished = this.isCellGoodToFocusOn(pointer);
        } else {
          finished = true;
        }
      }

      return pointer;
    }
  }, {
    key: "isCellGoodToFocusOn",
    value: function isCellGoodToFocusOn(gridCell) {
      var column = gridCell.column;
      var rowNode;

      switch (gridCell.rowPinned) {
        case "top":
          rowNode = this.pinnedRowModel.getPinnedTopRow(gridCell.rowIndex);
          break;

        case "bottom":
          rowNode = this.pinnedRowModel.getPinnedBottomRow(gridCell.rowIndex);
          break;

        default:
          rowNode = this.rowModel.getRow(gridCell.rowIndex);
          break;
      }

      if (!rowNode) {
        return false;
      }

      var suppressNavigable = column.isSuppressNavigable(rowNode);
      return !suppressNavigable;
    }
  }, {
    key: "getCellToLeft",
    value: function getCellToLeft(lastCell) {
      if (!lastCell) {
        return null;
      }

      var colToLeft = this.columnModel.getDisplayedColBefore(lastCell.column);

      if (!colToLeft) {
        return null;
      }

      return {
        rowIndex: lastCell.rowIndex,
        column: colToLeft,
        rowPinned: lastCell.rowPinned
      };
    }
  }, {
    key: "getCellToRight",
    value: function getCellToRight(lastCell) {
      if (!lastCell) {
        return null;
      }

      var colToRight = this.columnModel.getDisplayedColAfter(lastCell.column);

      if (!colToRight) {
        return null;
      }

      return {
        rowIndex: lastCell.rowIndex,
        column: colToRight,
        rowPinned: lastCell.rowPinned
      };
    }
  }, {
    key: "getRowBelow",
    value: function getRowBelow(rowPosition) {
      var index = rowPosition.rowIndex;
      var pinned = rowPosition.rowPinned;

      if (this.isLastRowInContainer(rowPosition)) {
        switch (pinned) {
          case "bottom":
            return null;

          case "top":
            if (this.rowModel.isRowsToRender()) {
              return {
                rowIndex: this.paginationProxy.getPageFirstRow(),
                rowPinned: null
              };
            }

            if (this.pinnedRowModel.isRowsToRender("bottom")) {
              return {
                rowIndex: 0,
                rowPinned: "bottom"
              };
            }

            return null;

          default:
            if (this.pinnedRowModel.isRowsToRender("bottom")) {
              return {
                rowIndex: 0,
                rowPinned: "bottom"
              };
            }

            return null;
        }
      }

      var rowNode = this.rowModel.getRow(rowPosition.rowIndex);
      var nextStickyPosition = this.getNextStickyPosition(rowNode);

      if (nextStickyPosition) {
        return nextStickyPosition;
      }

      return {
        rowIndex: index + 1,
        rowPinned: pinned
      };
    }
  }, {
    key: "getNextStickyPosition",
    value: function getNextStickyPosition(rowNode, up) {
      if (!this.gos.isGroupRowsSticky() || !rowNode || !rowNode.sticky) {
        return;
      }

      var isTopCtrls = this.rowRenderer.getStickyTopRowCtrls().some(function (ctrl) {
        return ctrl.getRowNode().rowIndex === rowNode.rowIndex;
      });
      var stickyRowCtrls = [];

      if (isTopCtrls) {
        stickyRowCtrls = _toConsumableArray(this.rowRenderer.getStickyTopRowCtrls()).sort(function (a, b) {
          return a.getRowNode().rowIndex - b.getRowNode().rowIndex;
        });
      } else {
        stickyRowCtrls = _toConsumableArray(this.rowRenderer.getStickyBottomRowCtrls()).sort(function (a, b) {
          return b.getRowNode().rowIndex - a.getRowNode().rowIndex;
        });
      }

      var diff = up ? -1 : 1;
      var idx = stickyRowCtrls.findIndex(function (ctrl) {
        return ctrl.getRowNode().rowIndex === rowNode.rowIndex;
      });
      var nextCtrl = stickyRowCtrls[idx + diff];

      if (nextCtrl) {
        return {
          rowIndex: nextCtrl.getRowNode().rowIndex,
          rowPinned: null
        };
      }
    }
  }, {
    key: "getCellBelow",
    value: function getCellBelow(lastCell) {
      if (!lastCell) {
        return null;
      }

      var rowBelow = this.getRowBelow(lastCell);

      if (rowBelow) {
        return {
          rowIndex: rowBelow.rowIndex,
          column: lastCell.column,
          rowPinned: rowBelow.rowPinned
        };
      }

      return null;
    }
  }, {
    key: "isLastRowInContainer",
    value: function isLastRowInContainer(rowPosition) {
      var pinned = rowPosition.rowPinned;
      var index = rowPosition.rowIndex;

      if (pinned === "top") {
        var lastTopIndex = this.pinnedRowModel.getPinnedTopRowData().length - 1;
        return lastTopIndex <= index;
      }

      if (pinned === "bottom") {
        var lastBottomIndex = this.pinnedRowModel.getPinnedBottomRowData().length - 1;
        return lastBottomIndex <= index;
      }

      var lastBodyIndex = this.paginationProxy.getPageLastRow();
      return lastBodyIndex <= index;
    }
  }, {
    key: "getRowAbove",
    value: function getRowAbove(rowPosition) {
      var index = rowPosition.rowIndex;
      var pinned = rowPosition.rowPinned;
      var isFirstRow = pinned ? index === 0 : index === this.paginationProxy.getPageFirstRow();

      if (isFirstRow) {
        if (pinned === "top") {
          return null;
        }

        if (!pinned) {
          if (this.pinnedRowModel.isRowsToRender("top")) {
            return this.getLastFloatingTopRow();
          }

          return null;
        }

        if (this.rowModel.isRowsToRender()) {
          return this.getLastBodyCell();
        }

        if (this.pinnedRowModel.isRowsToRender("top")) {
          return this.getLastFloatingTopRow();
        }

        return null;
      }

      var rowNode = this.rowModel.getRow(rowPosition.rowIndex);
      var nextStickyPosition = this.getNextStickyPosition(rowNode, true);

      if (nextStickyPosition) {
        return nextStickyPosition;
      }

      return {
        rowIndex: index - 1,
        rowPinned: pinned
      };
    }
  }, {
    key: "getCellAbove",
    value: function getCellAbove(lastCell) {
      if (!lastCell) {
        return null;
      }

      var rowAbove = this.getRowAbove({
        rowIndex: lastCell.rowIndex,
        rowPinned: lastCell.rowPinned
      });

      if (rowAbove) {
        return {
          rowIndex: rowAbove.rowIndex,
          column: lastCell.column,
          rowPinned: rowAbove.rowPinned
        };
      }

      return null;
    }
  }, {
    key: "getLastBodyCell",
    value: function getLastBodyCell() {
      var lastBodyRow = this.paginationProxy.getPageLastRow();
      return {
        rowIndex: lastBodyRow,
        rowPinned: null
      };
    }
  }, {
    key: "getLastFloatingTopRow",
    value: function getLastFloatingTopRow() {
      var lastFloatingRow = this.pinnedRowModel.getPinnedTopRowData().length - 1;
      return {
        rowIndex: lastFloatingRow,
        rowPinned: "top"
      };
    }
  }, {
    key: "getNextTabbedCell",
    value: function getNextTabbedCell(gridCell, backwards) {
      if (backwards) {
        return this.getNextTabbedCellBackwards(gridCell);
      }

      return this.getNextTabbedCellForwards(gridCell);
    }
  }, {
    key: "getNextTabbedCellForwards",
    value: function getNextTabbedCellForwards(gridCell) {
      var displayedColumns = this.columnModel.getAllDisplayedColumns();
      var newRowIndex = gridCell.rowIndex;
      var newFloating = gridCell.rowPinned;
      var newColumn = this.columnModel.getDisplayedColAfter(gridCell.column);

      if (!newColumn) {
        newColumn = displayedColumns[0];
        var rowBelow = this.getRowBelow(gridCell);

        if (_missing(rowBelow)) {
          return null;
        }

        if (!rowBelow.rowPinned && !this.paginationProxy.isRowInPage(rowBelow)) {
          return null;
        }

        newRowIndex = rowBelow ? rowBelow.rowIndex : null;
        newFloating = rowBelow ? rowBelow.rowPinned : null;
      }

      return {
        rowIndex: newRowIndex,
        column: newColumn,
        rowPinned: newFloating
      };
    }
  }, {
    key: "getNextTabbedCellBackwards",
    value: function getNextTabbedCellBackwards(gridCell) {
      var displayedColumns = this.columnModel.getAllDisplayedColumns();
      var newRowIndex = gridCell.rowIndex;
      var newFloating = gridCell.rowPinned;
      var newColumn = this.columnModel.getDisplayedColBefore(gridCell.column);

      if (!newColumn) {
        newColumn = _last(displayedColumns);
        var rowAbove = this.getRowAbove({
          rowIndex: gridCell.rowIndex,
          rowPinned: gridCell.rowPinned
        });

        if (_missing(rowAbove)) {
          return null;
        }

        if (!rowAbove.rowPinned && !this.paginationProxy.isRowInPage(rowAbove)) {
          return null;
        }

        newRowIndex = rowAbove ? rowAbove.rowIndex : null;
        newFloating = rowAbove ? rowAbove.rowPinned : null;
      }

      return {
        rowIndex: newRowIndex,
        column: newColumn,
        rowPinned: newFloating
      };
    }
  }]);

  return _CellNavigationService;
}(_BeanStub2);

__decorateClass([_Autowired("columnModel")], _CellNavigationService.prototype, "columnModel", 2);

__decorateClass([_Autowired("rowModel")], _CellNavigationService.prototype, "rowModel", 2);

__decorateClass([_Autowired("rowRenderer")], _CellNavigationService.prototype, "rowRenderer", 2);

__decorateClass([_Autowired("pinnedRowModel")], _CellNavigationService.prototype, "pinnedRowModel", 2);

__decorateClass([_Autowired("paginationProxy")], _CellNavigationService.prototype, "paginationProxy", 2);

_CellNavigationService = __decorateClass([_Bean("cellNavigationService")], _CellNavigationService); // community-modules/core/src/alignedGridsService.ts

var _AlignedGridsService =
/*#__PURE__*/
function (_BeanStub74) {
  "use strict";

  _inherits(_AlignedGridsService, _BeanStub74);

  function _AlignedGridsService() {
    var _this566;

    _classCallCheck(this, _AlignedGridsService);

    _this566 = _possibleConstructorReturn(this, _getPrototypeOf(_AlignedGridsService).apply(this, arguments)); // flag to mark if we are consuming. to avoid cyclic events (ie other grid firing back to master
    // while processing a master event) we mark this if consuming an event, and if we are, then
    // we don't fire back any events.

    _this566.consuming = false;
    return _this566;
  }

  _createClass(_AlignedGridsService, [{
    key: "setBeans",
    value: function setBeans(loggerFactory) {
      this.logger = loggerFactory.create("AlignedGridsService");
    }
  }, {
    key: "getAlignedGridApis",
    value: function getAlignedGridApis() {
      var _this567 = this;

      var _a;

      var alignedGrids = (_a = this.gos.get("alignedGrids")) != null ? _a : [];
      var isCallbackConfig = typeof alignedGrids === "function";

      if (typeof alignedGrids === "function") {
        alignedGrids = alignedGrids();
      }

      var seeUrl = function seeUrl() {
        return "See ".concat(_this567.getFrameworkOverrides().getDocLink("aligned-grids"));
      };

      var apis = alignedGrids.map(function (alignedGrid) {
        var _a2;

        if (!alignedGrid) {
          _errorOnce("alignedGrids contains an undefined option.");

          if (!isCallbackConfig) {
            _errorOnce("You may want to configure via a callback to avoid setup race conditions:\n                     \"alignedGrids: () => [linkedGrid]\"");
          }

          _errorOnce(seeUrl());

          return;
        }

        if (alignedGrid instanceof _GridApi) {
          return alignedGrid;
        }

        var refOrComp = alignedGrid;

        if ("current" in refOrComp) {
          return (_a2 = refOrComp.current) == null ? void 0 : _a2.api;
        } else {
          if (!refOrComp.api) {
            _errorOnce("alignedGrids - No api found on the linked grid. If you are passing gridOptions to alignedGrids since v31 this is no longer valid. ".concat(seeUrl()));
          }

          return refOrComp.api;
        }
      }).filter(function (api) {
        return !!api && !api.isDestroyed();
      });
      return apis;
    }
  }, {
    key: "init",
    value: function init() {
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_MOVED, this.fireColumnEvent.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_VISIBLE, this.fireColumnEvent.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_PINNED, this.fireColumnEvent.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_GROUP_OPENED, this.fireColumnEvent.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_RESIZED, this.fireColumnEvent.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_BODY_SCROLL, this.fireScrollEvent.bind(this));
    } // common logic across all the fire methods

  }, {
    key: "fireEvent",
    value: function fireEvent(callback) {
      if (this.consuming) {
        return;
      }

      this.getAlignedGridApis().forEach(function (api) {
        if (api.isDestroyed()) {
          return;
        }

        var alignedGridService = api.__getAlignedGridService();

        callback(alignedGridService);
      });
    } // common logic across all consume methods. very little common logic, however extracting
    // guarantees consistency across the methods.

  }, {
    key: "onEvent",
    value: function onEvent(callback) {
      this.consuming = true;
      callback();
      this.consuming = false;
    }
  }, {
    key: "fireColumnEvent",
    value: function fireColumnEvent(event) {
      this.fireEvent(function (alignedGridsService) {
        alignedGridsService.onColumnEvent(event);
      });
    }
  }, {
    key: "fireScrollEvent",
    value: function fireScrollEvent(event) {
      if (event.direction !== "horizontal") {
        return;
      }

      this.fireEvent(function (alignedGridsService) {
        alignedGridsService.onScrollEvent(event);
      });
    }
  }, {
    key: "onScrollEvent",
    value: function onScrollEvent(event) {
      var _this568 = this;

      this.onEvent(function () {
        var gridBodyCon = _this568.ctrlsService.getGridBodyCtrl();

        gridBodyCon.getScrollFeature().setHorizontalScrollPosition(event.left, true);
      });
    }
  }, {
    key: "getMasterColumns",
    value: function getMasterColumns(event) {
      var result = [];

      if (event.columns) {
        event.columns.forEach(function (column) {
          result.push(column);
        });
      } else if (event.column) {
        result.push(event.column);
      }

      return result;
    }
  }, {
    key: "getColumnIds",
    value: function getColumnIds(event) {
      var result = [];

      if (event.columns) {
        event.columns.forEach(function (column) {
          result.push(column.getColId());
        });
      } else if (event.column) {
        result.push(event.column.getColId());
      }

      return result;
    }
  }, {
    key: "onColumnEvent",
    value: function onColumnEvent(event) {
      var _this569 = this;

      this.onEvent(function () {
        switch (event.type) {
          case _Events.EVENT_COLUMN_MOVED:
          case _Events.EVENT_COLUMN_VISIBLE:
          case _Events.EVENT_COLUMN_PINNED:
          case _Events.EVENT_COLUMN_RESIZED:
            var colEvent = event;

            _this569.processColumnEvent(colEvent);

            break;

          case _Events.EVENT_COLUMN_GROUP_OPENED:
            var groupOpenedEvent = event;

            _this569.processGroupOpenedEvent(groupOpenedEvent);

            break;

          case _Events.EVENT_COLUMN_PIVOT_CHANGED:
            console.warn("AG Grid: pivoting is not supported with aligned grids. You can only use one of these features at a time in a grid.");
            break;
        }
      });
    }
  }, {
    key: "processGroupOpenedEvent",
    value: function processGroupOpenedEvent(groupOpenedEvent) {
      var _this570 = this;

      groupOpenedEvent.columnGroups.forEach(function (masterGroup) {
        var otherColumnGroup = null;

        if (masterGroup) {
          var groupId = masterGroup.getGroupId();
          otherColumnGroup = _this570.columnModel.getProvidedColumnGroup(groupId);
        }

        if (masterGroup && !otherColumnGroup) {
          return;
        }

        _this570.logger.log("onColumnEvent-> processing " + groupOpenedEvent + " expanded = " + masterGroup.isExpanded());

        _this570.columnModel.setColumnGroupOpened(otherColumnGroup, masterGroup.isExpanded(), "alignedGridChanged");
      });
    }
  }, {
    key: "processColumnEvent",
    value: function processColumnEvent(colEvent) {
      var _this571 = this;

      var _a;

      var masterColumn = colEvent.column;
      var otherColumn = null;

      if (masterColumn) {
        otherColumn = this.columnModel.getPrimaryColumn(masterColumn.getColId());
      }

      if (masterColumn && !otherColumn) {
        return;
      }

      var masterColumns = this.getMasterColumns(colEvent);

      switch (colEvent.type) {
        case _Events.EVENT_COLUMN_MOVED:
          {
            var movedEvent = colEvent;
            var srcColState = colEvent.api.getColumnState();
            var destColState = srcColState.map(function (s) {
              return {
                colId: s.colId
              };
            });
            this.columnModel.applyColumnState({
              state: destColState,
              applyOrder: true
            }, "alignedGridChanged");
            this.logger.log("onColumnEvent-> processing ".concat(colEvent.type, " toIndex = ").concat(movedEvent.toIndex));
          }
          break;

        case _Events.EVENT_COLUMN_VISIBLE:
          {
            var visibleEvent = colEvent;

            var _srcColState = colEvent.api.getColumnState();

            var _destColState = _srcColState.map(function (s) {
              return {
                colId: s.colId,
                hide: s.hide
              };
            });

            this.columnModel.applyColumnState({
              state: _destColState
            }, "alignedGridChanged");
            this.logger.log("onColumnEvent-> processing ".concat(colEvent.type, " visible = ").concat(visibleEvent.visible));
          }
          break;

        case _Events.EVENT_COLUMN_PINNED:
          {
            var pinnedEvent = colEvent;

            var _srcColState2 = colEvent.api.getColumnState();

            var _destColState2 = _srcColState2.map(function (s) {
              return {
                colId: s.colId,
                pinned: s.pinned
              };
            });

            this.columnModel.applyColumnState({
              state: _destColState2
            }, "alignedGridChanged");
            this.logger.log("onColumnEvent-> processing ".concat(colEvent.type, " pinned = ").concat(pinnedEvent.pinned));
          }
          break;

        case _Events.EVENT_COLUMN_RESIZED:
          var resizedEvent = colEvent;
          var columnWidths = {};
          masterColumns.forEach(function (column) {
            _this571.logger.log("onColumnEvent-> processing ".concat(colEvent.type, " actualWidth = ").concat(column.getActualWidth()));

            columnWidths[column.getId()] = {
              key: column.getColId(),
              newWidth: column.getActualWidth()
            };
          });
          (_a = resizedEvent.flexColumns) == null ? void 0 : _a.forEach(function (col) {
            if (columnWidths[col.getId()]) {
              delete columnWidths[col.getId()];
            }
          });
          this.columnModel.setColumnWidths(Object.values(columnWidths), false, resizedEvent.finished, "alignedGridChanged");
          break;
      }

      var gridBodyCon = this.ctrlsService.getGridBodyCtrl();
      var isVerticalScrollShowing2 = gridBodyCon.isVerticalScrollShowing();
      this.getAlignedGridApis().forEach(function (api) {
        api.setGridOption("alwaysShowVerticalScroll", isVerticalScrollShowing2);
      });
    }
  }]);

  return _AlignedGridsService;
}(_BeanStub2);

__decorateClass([_Autowired("columnModel")], _AlignedGridsService.prototype, "columnModel", 2);

__decorateClass([_Autowired("ctrlsService")], _AlignedGridsService.prototype, "ctrlsService", 2);

__decorateClass([__decorateParam(0, _Qualifier("loggerFactory"))], _AlignedGridsService.prototype, "setBeans", 1);

__decorateClass([_PostConstruct], _AlignedGridsService.prototype, "init", 1);

_AlignedGridsService = __decorateClass([_Bean("alignedGridsService")], _AlignedGridsService); // community-modules/core/src/selectionService.ts

var SelectionService =
/*#__PURE__*/
function (_BeanStub75) {
  "use strict";

  _inherits(SelectionService, _BeanStub75);

  function SelectionService() {
    var _this572;

    _classCallCheck(this, SelectionService);

    _this572 = _possibleConstructorReturn(this, _getPrototypeOf(SelectionService).apply(this, arguments));
    _this572.selectedNodes =
    /* @__PURE__ */
    new Map();
    _this572.lastRowNode = null;
    return _this572;
  }

  _createClass(SelectionService, [{
    key: "init",
    value: function init() {
      var _this573 = this;

      this.rowSelection = this.gos.get("rowSelection");
      this.groupSelectsChildren = this.gos.get("groupSelectsChildren");
      this.addManagedPropertyListeners(["groupSelectsChildren", "rowSelection"], function () {
        _this573.groupSelectsChildren = _this573.gos.get("groupSelectsChildren");
        _this573.rowSelection = _this573.gos.get("rowSelection");

        _this573.deselectAllRowNodes({
          source: "api"
        });
      });
      this.addManagedListener(this.eventService, _Events.EVENT_ROW_SELECTED, this.onRowSelected.bind(this));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(SelectionService.prototype), "destroy", this).call(this);

      this.resetNodes();
      this.lastRowNode = null;
    }
  }, {
    key: "isMultiselect",
    value: function isMultiselect() {
      return this.rowSelection === "multiple";
    }
  }, {
    key: "setNodesSelected",
    value: function setNodesSelected(params) {
      var _a;

      var newValue = params.newValue,
          clearSelection = params.clearSelection,
          suppressFinishActions = params.suppressFinishActions,
          rangeSelect = params.rangeSelect,
          nodes = params.nodes,
          event = params.event,
          _params$source2 = params.source,
          source = _params$source2 === void 0 ? "api" : _params$source2;
      if (nodes.length === 0) return 0;

      if (nodes.length > 1 && !this.isMultiselect()) {
        console.warn("AG Grid: cannot multi select while rowSelection='single'");
        return 0;
      }

      var groupSelectsFiltered = this.groupSelectsChildren && params.groupSelectsFiltered === true;
      var filteredNodes = nodes.map(function (node) {
        return node.footer ? node.sibling : node;
      });

      if (rangeSelect) {
        if (nodes.length > 1) {
          console.warn("AG Grid: cannot range select while selecting multiple rows");
          return 0;
        }

        var toNode = null;

        if (source === "checkboxSelected" && newValue === false && this.lastRowNode) {
          if (this.lastRowNode.id) {
            toNode = this.lastRowNode;
          } else {
            this.lastRowNode = null;
          }
        }

        if (toNode == null) {
          toNode = this.getLastSelectedNode();
        }

        if (toNode) {
          var fromNode = filteredNodes[0];
          var newRowClicked = fromNode !== toNode;

          if (newRowClicked && this.isMultiselect()) {
            return this.selectRange(fromNode, toNode, newValue, source);
          }
        }
      }

      this.lastRowNode = newValue ? null : filteredNodes[0];
      var updatedCount = 0;

      for (var i = 0; i < filteredNodes.length; i++) {
        var node = filteredNodes[i];
        var skipThisNode = groupSelectsFiltered && node.group;

        if (!skipThisNode) {
          var thisNodeWasSelected = node.selectThisNode(newValue, event, source);

          if (thisNodeWasSelected) {
            updatedCount++;
          }
        }

        if (this.groupSelectsChildren && ((_a = node.childrenAfterGroup) == null ? void 0 : _a.length)) {
          updatedCount += this.selectChildren(node, newValue, groupSelectsFiltered, source);
        }
      }

      if (!suppressFinishActions) {
        var clearOtherNodes = newValue && (clearSelection || !this.isMultiselect());

        if (clearOtherNodes) {
          updatedCount += this.clearOtherNodes(filteredNodes[0], source);
        }

        if (updatedCount > 0) {
          this.updateGroupsFromChildrenSelections(source);
          var event2 = {
            type: _Events.EVENT_SELECTION_CHANGED,
            source: source
          };
          this.eventService.dispatchEvent(event2);
        }
      }

      return updatedCount;
    } // selects all rows between this node and the last selected node (or the top if this is the first selection).
    // not to be mixed up with 'cell range selection' where you drag the mouse, this is row range selection, by
    // holding down 'shift'.

  }, {
    key: "selectRange",
    value: function selectRange(fromNode, toNode) {
      var _this574 = this;

      var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var source = arguments.length > 3 ? arguments[3] : undefined;
      var nodesToSelect = this.rowModel.getNodesInRangeForSelection(fromNode, toNode);
      var updatedCount = 0;
      nodesToSelect.forEach(function (rowNode) {
        if (rowNode.group && _this574.groupSelectsChildren) {
          return;
        }

        var nodeWasSelected = rowNode.selectThisNode(value, void 0, source);

        if (nodeWasSelected) {
          updatedCount++;
        }
      });
      this.updateGroupsFromChildrenSelections(source);
      var event = {
        type: _Events.EVENT_SELECTION_CHANGED,
        source: source
      };
      this.eventService.dispatchEvent(event);
      return updatedCount;
    }
  }, {
    key: "selectChildren",
    value: function selectChildren(node, newValue, groupSelectsFiltered, source) {
      var children = groupSelectsFiltered ? node.childrenAfterAggFilter : node.childrenAfterGroup;

      if (_missing(children)) {
        return 0;
      }

      return this.setNodesSelected({
        newValue: newValue,
        clearSelection: false,
        suppressFinishActions: true,
        groupSelectsFiltered: groupSelectsFiltered,
        source: source,
        nodes: children
      });
    }
  }, {
    key: "getLastSelectedNode",
    value: function getLastSelectedNode() {
      var selectedKeys = Array.from(this.selectedNodes.keys());

      if (selectedKeys.length == 0) {
        return null;
      }

      var node = this.selectedNodes.get(_last(selectedKeys));

      if (node) {
        return node;
      }

      return null;
    }
  }, {
    key: "getSelectedNodes",
    value: function getSelectedNodes() {
      var selectedNodes = [];
      this.selectedNodes.forEach(function (rowNode) {
        if (rowNode) {
          selectedNodes.push(rowNode);
        }
      });
      return selectedNodes;
    }
  }, {
    key: "getSelectedRows",
    value: function getSelectedRows() {
      var selectedRows = [];
      this.selectedNodes.forEach(function (rowNode) {
        if (rowNode && rowNode.data) {
          selectedRows.push(rowNode.data);
        }
      });
      return selectedRows;
    }
  }, {
    key: "getSelectionCount",
    value: function getSelectionCount() {
      return this.selectedNodes.size;
    }
    /**
     * This method is used by the CSRM to remove groups which are being disposed of,
     * events do not need fired in this case
     */

  }, {
    key: "filterFromSelection",
    value: function filterFromSelection(predicate) {
      var newSelectedNodes =
      /* @__PURE__ */
      new Map();
      this.selectedNodes.forEach(function (rowNode, key) {
        var passesPredicate = rowNode && predicate(rowNode);

        if (passesPredicate) {
          newSelectedNodes.set(key, rowNode);
        }
      });
      this.selectedNodes = newSelectedNodes;
    } // should only be called if groupSelectsChildren=true

  }, {
    key: "updateGroupsFromChildrenSelections",
    value: function updateGroupsFromChildrenSelections(source, changedPath) {
      if (!this.groupSelectsChildren) {
        return false;
      }

      if (this.rowModel.getType() !== "clientSide") {
        return false;
      }

      var clientSideRowModel = this.rowModel;
      var rootNode = clientSideRowModel.getRootNode();

      if (!changedPath) {
        changedPath = new _ChangedPath(true, rootNode);
        changedPath.setInactive();
      }

      var selectionChanged = false;
      changedPath.forEachChangedNodeDepthFirst(function (rowNode) {
        if (rowNode !== rootNode) {
          var selected = rowNode.calculateSelectedFromChildren();
          selectionChanged = rowNode.selectThisNode(selected === null ? false : selected, void 0, source) || selectionChanged;
        }
      });
      return selectionChanged;
    }
  }, {
    key: "clearOtherNodes",
    value: function clearOtherNodes(rowNodeToKeepSelected, source) {
      var _this575 = this;

      var groupsToRefresh =
      /* @__PURE__ */
      new Map();
      var updatedCount = 0;
      this.selectedNodes.forEach(function (otherRowNode) {
        if (otherRowNode && otherRowNode.id !== rowNodeToKeepSelected.id) {
          var rowNode = _this575.selectedNodes.get(otherRowNode.id);

          updatedCount += rowNode.setSelectedParams({
            newValue: false,
            clearSelection: false,
            suppressFinishActions: true,
            source: source
          });

          if (_this575.groupSelectsChildren && otherRowNode.parent) {
            groupsToRefresh.set(otherRowNode.parent.id, otherRowNode.parent);
          }
        }
      });
      groupsToRefresh.forEach(function (group) {
        var selected = group.calculateSelectedFromChildren();
        group.selectThisNode(selected === null ? false : selected, void 0, source);
      });
      return updatedCount;
    }
  }, {
    key: "onRowSelected",
    value: function onRowSelected(event) {
      var rowNode = event.node;

      if (this.groupSelectsChildren && rowNode.group) {
        return;
      }

      if (rowNode.isSelected()) {
        this.selectedNodes.set(rowNode.id, rowNode);
      } else {
        this.selectedNodes.delete(rowNode.id);
      }
    }
  }, {
    key: "syncInRowNode",
    value: function syncInRowNode(rowNode, oldNode) {
      this.syncInOldRowNode(rowNode, oldNode);
      this.syncInNewRowNode(rowNode);
    } // if the id has changed for the node, then this means the rowNode
    // is getting used for a different data item, which breaks
    // our selectedNodes, as the node now is mapped by the old id
    // which is inconsistent. so to keep the old node as selected,
    // we swap in the clone (with the old id and old data). this means
    // the oldNode is effectively a daemon we keep a reference to,
    // so if client calls api.getSelectedNodes(), it gets the daemon
    // in the result. when the client un-selects, the reference to the
    // daemon is removed. the daemon, because it's an oldNode, is not
    // used by the grid for rendering, it's a copy of what the node used
    // to be like before the id was changed.

  }, {
    key: "syncInOldRowNode",
    value: function syncInOldRowNode(rowNode, oldNode) {
      var oldNodeHasDifferentId = _exists(oldNode) && rowNode.id !== oldNode.id;

      if (oldNodeHasDifferentId && oldNode) {
        var id = oldNode.id;
        var oldNodeSelected = this.selectedNodes.get(id) == rowNode;

        if (oldNodeSelected) {
          this.selectedNodes.set(oldNode.id, oldNode);
        }
      }
    }
  }, {
    key: "syncInNewRowNode",
    value: function syncInNewRowNode(rowNode) {
      if (this.selectedNodes.has(rowNode.id)) {
        rowNode.setSelectedInitialValue(true);
        this.selectedNodes.set(rowNode.id, rowNode);
      } else {
        rowNode.setSelectedInitialValue(false);
      }
    }
  }, {
    key: "reset",
    value: function reset(source) {
      var selectionCount = this.getSelectionCount();
      this.resetNodes();

      if (selectionCount) {
        var event = {
          type: _Events.EVENT_SELECTION_CHANGED,
          source: source
        };
        this.eventService.dispatchEvent(event);
      }
    }
  }, {
    key: "resetNodes",
    value: function resetNodes() {
      var _a;

      (_a = this.selectedNodes) == null ? void 0 : _a.clear();
    } // returns a list of all nodes at 'best cost' - a feature to be used
    // with groups / trees. if a group has all it's children selected,
    // then the group appears in the result, but not the children.
    // Designed for use with 'children' as the group selection type,
    // where groups don't actually appear in the selection normally.

  }, {
    key: "getBestCostNodeSelection",
    value: function getBestCostNodeSelection() {
      if (this.rowModel.getType() !== "clientSide") {
        return;
      }

      var clientSideRowModel = this.rowModel;
      var topLevelNodes = clientSideRowModel.getTopLevelNodes();

      if (topLevelNodes === null) {
        return;
      }

      var result = [];

      function traverse(nodes) {
        for (var i = 0, l = nodes.length; i < l; i++) {
          var node = nodes[i];

          if (node.isSelected()) {
            result.push(node);
          } else {
            var maybeGroup = node;

            if (maybeGroup.group && maybeGroup.children) {
              traverse(maybeGroup.children);
            }
          }
        }
      }

      traverse(topLevelNodes);
      return result;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      var count = 0;
      this.selectedNodes.forEach(function (rowNode) {
        if (rowNode) {
          count++;
        }
      });
      return count === 0;
    }
  }, {
    key: "deselectAllRowNodes",
    value: function deselectAllRowNodes(params) {
      var callback = function callback(rowNode) {
        return rowNode.selectThisNode(false, void 0, source);
      };

      var rowModelClientSide = this.rowModel.getType() === "clientSide";
      var source = params.source,
          justFiltered = params.justFiltered,
          justCurrentPage = params.justCurrentPage;

      if (justCurrentPage || justFiltered) {
        if (!rowModelClientSide) {
          console.error("AG Grid: selecting just filtered only works when gridOptions.rowModelType='clientSide'");
          return;
        }

        this.getNodesToSelect(justFiltered, justCurrentPage).forEach(callback);
      } else {
        this.selectedNodes.forEach(function (rowNode) {
          if (rowNode) {
            callback(rowNode);
          }
        });
        this.reset(source);
      }

      if (rowModelClientSide && this.groupSelectsChildren) {
        this.updateGroupsFromChildrenSelections(source);
      }

      var event = {
        type: _Events.EVENT_SELECTION_CHANGED,
        source: source
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "getSelectedCounts",
    value: function getSelectedCounts(justFiltered, justCurrentPage) {
      var _this576 = this;

      var selectedCount = 0;
      var notSelectedCount = 0;

      var callback = function callback(node) {
        if (_this576.groupSelectsChildren && node.group) {
          return;
        }

        if (node.isSelected()) {
          selectedCount++;
        } else if (!node.selectable) {} else {
          notSelectedCount++;
        }
      };

      this.getNodesToSelect(justFiltered, justCurrentPage).forEach(callback);
      return {
        selectedCount: selectedCount,
        notSelectedCount: notSelectedCount
      };
    }
  }, {
    key: "getSelectAllState",
    value: function getSelectAllState(justFiltered, justCurrentPage) {
      var _this$getSelectedCoun = this.getSelectedCounts(justFiltered, justCurrentPage),
          selectedCount = _this$getSelectedCoun.selectedCount,
          notSelectedCount = _this$getSelectedCoun.notSelectedCount;

      if (selectedCount === 0 && notSelectedCount === 0) {
        return false;
      }

      if (selectedCount > 0 && notSelectedCount > 0) {
        return null;
      }

      return selectedCount > 0;
    }
  }, {
    key: "hasNodesToSelect",
    value: function hasNodesToSelect() {
      var justFiltered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var justCurrentPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.getNodesToSelect(justFiltered, justCurrentPage).filter(function (node) {
        return node.selectable;
      }).length > 0;
    }
    /**
     * @param justFiltered whether to just include nodes which have passed the filter
     * @param justCurrentPage whether to just include nodes on the current page
     * @returns all nodes including unselectable nodes which are the target of this selection attempt
     */

  }, {
    key: "getNodesToSelect",
    value: function getNodesToSelect() {
      var _this577 = this;

      var justFiltered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var justCurrentPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.rowModel.getType() !== "clientSide") {
        throw new Error("selectAll only available when rowModelType='clientSide', ie not ".concat(this.rowModel.getType()));
      }

      var nodes = [];

      if (justCurrentPage) {
        this.paginationProxy.forEachNodeOnPage(function (node) {
          if (!node.group) {
            nodes.push(node);
            return;
          }

          if (!node.expanded) {
            var recursivelyAddChildren = function recursivelyAddChildren(child) {
              var _a;

              nodes.push(child);

              if ((_a = child.childrenAfterFilter) == null ? void 0 : _a.length) {
                child.childrenAfterFilter.forEach(recursivelyAddChildren);
              }
            };

            recursivelyAddChildren(node);
            return;
          }

          if (!_this577.groupSelectsChildren) {
            nodes.push(node);
          }
        });
        return nodes;
      }

      var clientSideRowModel = this.rowModel;

      if (justFiltered) {
        clientSideRowModel.forEachNodeAfterFilter(function (node) {
          nodes.push(node);
        });
        return nodes;
      }

      clientSideRowModel.forEachNode(function (node) {
        nodes.push(node);
      });
      return nodes;
    }
  }, {
    key: "selectAllRowNodes",
    value: function selectAllRowNodes(params) {
      if (this.rowModel.getType() !== "clientSide") {
        throw new Error("selectAll only available when rowModelType='clientSide', ie not ".concat(this.rowModel.getType()));
      }

      var source = params.source,
          justFiltered = params.justFiltered,
          justCurrentPage = params.justCurrentPage;

      var callback = function callback(rowNode) {
        return rowNode.selectThisNode(true, void 0, source);
      };

      this.getNodesToSelect(justFiltered, justCurrentPage).forEach(callback);

      if (this.rowModel.getType() === "clientSide" && this.groupSelectsChildren) {
        this.updateGroupsFromChildrenSelections(source);
      }

      var event = {
        type: _Events.EVENT_SELECTION_CHANGED,
        source: source
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "getSelectionState",
    value: function getSelectionState() {
      var selectedIds = [];
      this.selectedNodes.forEach(function (node) {
        if (node == null ? void 0 : node.id) {
          selectedIds.push(node.id);
        }
      });
      return selectedIds.length ? selectedIds : null;
    }
  }, {
    key: "setSelectionState",
    value: function setSelectionState(state, source) {
      if (!Array.isArray(state)) {
        return;
      }

      var rowIds = new Set(state);
      var nodes = [];
      this.rowModel.forEachNode(function (node) {
        if (rowIds.has(node.id)) {
          nodes.push(node);
        }
      });
      this.setNodesSelected({
        newValue: true,
        nodes: nodes,
        source: source
      });
    }
  }]);

  return SelectionService;
}(_BeanStub2);

__decorateClass([_Autowired("rowModel")], SelectionService.prototype, "rowModel", 2);

__decorateClass([_Autowired("paginationProxy")], SelectionService.prototype, "paginationProxy", 2);

__decorateClass([_PostConstruct], SelectionService.prototype, "init", 1);

SelectionService = __decorateClass([_Bean("selectionService")], SelectionService); // community-modules/core/src/columns/columnApi.ts

var _ColumnApi =
/*#__PURE__*/
function () {
  "use strict";

  function _ColumnApi(gridAp) {
    var _this578 = this;

    _classCallCheck(this, _ColumnApi);

    this.viaApi = function (funcName) {
      var _this578$api;

      _warnOnce("Since v31, 'columnApi.".concat(funcName, "' is deprecated and moved to 'api.").concat(funcName, "'."));

      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key6 = 1; _key6 < _len5; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }

      return (_this578$api = _this578.api)[funcName].apply(_this578$api, args);
    };

    this.api = gridAp;
  }
  /** @deprecated v31 use `api.sizeColumnsToFit()` instead.   */


  _createClass(_ColumnApi, [{
    key: "sizeColumnsToFit",
    value: function sizeColumnsToFit(gridWidth) {
      this.viaApi("sizeColumnsToFit", gridWidth);
    }
    /** @deprecated v31 use `api.setColumnGroupOpened() instead. */

  }, {
    key: "setColumnGroupOpened",
    value: function setColumnGroupOpened(group, newValue) {
      this.viaApi("setColumnGroupOpened", group, newValue);
    }
    /** @deprecated v31 use `api.getColumnGroup() instead. */

  }, {
    key: "getColumnGroup",
    value: function getColumnGroup(name, instanceId) {
      return this.viaApi("getColumnGroup", name, instanceId);
    }
    /** @deprecated v31 use `api.getProvidedColumnGroup() instead. */

  }, {
    key: "getProvidedColumnGroup",
    value: function getProvidedColumnGroup(name) {
      return this.viaApi("getProvidedColumnGroup", name);
    }
    /** @deprecated v31 use `api.getDisplayNameForColumn() instead. */

  }, {
    key: "getDisplayNameForColumn",
    value: function getDisplayNameForColumn(column, location) {
      return this.viaApi("getDisplayNameForColumn", column, location);
    }
    /** @deprecated v31 use `api.getDisplayNameForColumnGroup() instead. */

  }, {
    key: "getDisplayNameForColumnGroup",
    value: function getDisplayNameForColumnGroup(columnGroup, location) {
      return this.viaApi("getDisplayNameForColumnGroup", columnGroup, location);
    }
    /** @deprecated v31 use `api.getColumn() instead. */

  }, {
    key: "getColumn",
    value: function getColumn(key) {
      return this.viaApi("getColumn", key);
    }
    /** @deprecated v31 use `api.getColumns() instead. */

  }, {
    key: "getColumns",
    value: function getColumns() {
      return this.viaApi("getColumns");
    }
    /** @deprecated v31 use `api.applyColumnState() instead. */

  }, {
    key: "applyColumnState",
    value: function applyColumnState(params) {
      return this.viaApi("applyColumnState", params);
    }
    /** @deprecated v31 use `api.getColumnState() instead. */

  }, {
    key: "getColumnState",
    value: function getColumnState() {
      return this.viaApi("getColumnState");
    }
    /** @deprecated v31 use `api.resetColumnState() instead. */

  }, {
    key: "resetColumnState",
    value: function resetColumnState() {
      this.viaApi("resetColumnState");
    }
    /** @deprecated v31 use `api.getColumnGroupState() instead. */

  }, {
    key: "getColumnGroupState",
    value: function getColumnGroupState() {
      return this.viaApi("getColumnGroupState");
    }
    /** @deprecated v31 use `api.setColumnGroupState() instead. */

  }, {
    key: "setColumnGroupState",
    value: function setColumnGroupState(stateItems) {
      this.viaApi("setColumnGroupState", stateItems);
    }
    /** @deprecated v31 use `api.resetColumnGroupState() instead. */

  }, {
    key: "resetColumnGroupState",
    value: function resetColumnGroupState() {
      this.viaApi("resetColumnGroupState");
    }
    /** @deprecated v31 use `api.isPinning() instead. */

  }, {
    key: "isPinning",
    value: function isPinning() {
      return this.viaApi("isPinning");
    }
    /** @deprecated v31 use `api.isPinningLeft() instead. */

  }, {
    key: "isPinningLeft",
    value: function isPinningLeft() {
      return this.viaApi("isPinningLeft");
    }
    /** @deprecated v31 use `api.isPinningRight() instead. */

  }, {
    key: "isPinningRight",
    value: function isPinningRight() {
      return this.viaApi("isPinningRight");
    }
    /** @deprecated v31 use `api.getDisplayedColAfter() instead. */

  }, {
    key: "getDisplayedColAfter",
    value: function getDisplayedColAfter(col) {
      return this.viaApi("getDisplayedColAfter", col);
    }
    /** @deprecated v31 use `api.getDisplayedColBefore() instead. */

  }, {
    key: "getDisplayedColBefore",
    value: function getDisplayedColBefore(col) {
      return this.viaApi("getDisplayedColBefore", col);
    }
    /** @deprecated v31 use `api.setColumnVisible() instead. */

  }, {
    key: "setColumnVisible",
    value: function setColumnVisible(key, visible) {
      this.viaApi("setColumnVisible", key, visible);
    }
    /** @deprecated v31 use `api.setColumnsVisible() instead. */

  }, {
    key: "setColumnsVisible",
    value: function setColumnsVisible(keys2, visible) {
      this.viaApi("setColumnsVisible", keys2, visible);
    }
    /** @deprecated v31 use `api.setColumnPinned() instead. */

  }, {
    key: "setColumnPinned",
    value: function setColumnPinned(key, pinned) {
      this.viaApi("setColumnPinned", key, pinned);
    }
    /** @deprecated v31 use `api.setColumnsPinned() instead. */

  }, {
    key: "setColumnsPinned",
    value: function setColumnsPinned(keys2, pinned) {
      this.viaApi("setColumnsPinned", keys2, pinned);
    }
    /** @deprecated v31 use `api.getAllGridColumns() instead. */

  }, {
    key: "getAllGridColumns",
    value: function getAllGridColumns() {
      return this.viaApi("getAllGridColumns");
    }
    /** @deprecated v31 use `api.getDisplayedLeftColumns() instead. */

  }, {
    key: "getDisplayedLeftColumns",
    value: function getDisplayedLeftColumns() {
      return this.viaApi("getDisplayedLeftColumns");
    }
    /** @deprecated v31 use `api.getDisplayedCenterColumns() instead. */

  }, {
    key: "getDisplayedCenterColumns",
    value: function getDisplayedCenterColumns() {
      return this.viaApi("getDisplayedCenterColumns");
    }
    /** @deprecated v31 use `api.getDisplayedRightColumns() instead. */

  }, {
    key: "getDisplayedRightColumns",
    value: function getDisplayedRightColumns() {
      return this.viaApi("getDisplayedRightColumns");
    }
    /** @deprecated v31 use `api.getAllDisplayedColumns() instead. */

  }, {
    key: "getAllDisplayedColumns",
    value: function getAllDisplayedColumns() {
      return this.viaApi("getAllDisplayedColumns");
    }
    /** @deprecated v31 use `api.getAllDisplayedVirtualColumns() instead. */

  }, {
    key: "getAllDisplayedVirtualColumns",
    value: function getAllDisplayedVirtualColumns() {
      return this.viaApi("getAllDisplayedVirtualColumns");
    }
    /** @deprecated v31 use `api.moveColumn() instead. */

  }, {
    key: "moveColumn",
    value: function moveColumn(key, toIndex) {
      this.viaApi("moveColumn", key, toIndex);
    }
    /** @deprecated v31 use `api.moveColumnByIndex() instead. */

  }, {
    key: "moveColumnByIndex",
    value: function moveColumnByIndex(fromIndex, toIndex) {
      this.viaApi("moveColumnByIndex", fromIndex, toIndex);
    }
    /** @deprecated v31 use `api.moveColumns() instead. */

  }, {
    key: "moveColumns",
    value: function moveColumns(columnsToMoveKeys, toIndex) {
      this.viaApi("moveColumns", columnsToMoveKeys, toIndex);
    }
    /** @deprecated v31 use `api.moveRowGroupColumn() instead. */

  }, {
    key: "moveRowGroupColumn",
    value: function moveRowGroupColumn(fromIndex, toIndex) {
      this.viaApi("moveRowGroupColumn", fromIndex, toIndex);
    }
    /** @deprecated v31 use `api.setColumnAggFunc() instead. */

  }, {
    key: "setColumnAggFunc",
    value: function setColumnAggFunc(key, aggFunc) {
      this.viaApi("setColumnAggFunc", key, aggFunc);
    }
    /** @deprecated v31 use `api.setColumnWidth() instead. */

  }, {
    key: "setColumnWidth",
    value: function setColumnWidth(key, newWidth) {
      var finished = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var source = arguments.length > 3 ? arguments[3] : undefined;
      this.viaApi("setColumnWidth", key, newWidth, finished, source);
    }
    /** @deprecated v31 use `api.setColumnWidths() instead. */

  }, {
    key: "setColumnWidths",
    value: function setColumnWidths(columnWidths) {
      var finished = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var source = arguments.length > 2 ? arguments[2] : undefined;
      this.viaApi("setColumnWidths", columnWidths, finished, source);
    }
    /** @deprecated v31 use `api.setPivotMode() instead. */

  }, {
    key: "setPivotMode",
    value: function setPivotMode(pivotMode) {
      this.viaApi("setPivotMode", pivotMode);
    }
    /** @deprecated v31 use `api.isPivotMode() instead. */

  }, {
    key: "isPivotMode",
    value: function isPivotMode() {
      return this.viaApi("isPivotMode");
    }
    /** @deprecated v31 use `api.getPivotResultColumn() instead. */

  }, {
    key: "getPivotResultColumn",
    value: function getPivotResultColumn(pivotKeys, valueColKey) {
      return this.viaApi("getPivotResultColumn", pivotKeys, valueColKey);
    }
    /** @deprecated v31 use `api.setValueColumns() instead. */

  }, {
    key: "setValueColumns",
    value: function setValueColumns(colKeys) {
      this.viaApi("setValueColumns", colKeys);
    }
    /** @deprecated v31 use `api.getValueColumns() instead. */

  }, {
    key: "getValueColumns",
    value: function getValueColumns() {
      return this.viaApi("getValueColumns");
    }
    /** @deprecated v31 use `api.removeValueColumn() instead. */

  }, {
    key: "removeValueColumn",
    value: function removeValueColumn(colKey) {
      this.viaApi("removeValueColumn", colKey);
    }
    /** @deprecated v31 use `api.removeValueColumns() instead. */

  }, {
    key: "removeValueColumns",
    value: function removeValueColumns(colKeys) {
      this.viaApi("removeValueColumns", colKeys);
    }
    /** @deprecated v31 use `api.addValueColumn() instead. */

  }, {
    key: "addValueColumn",
    value: function addValueColumn(colKey) {
      this.viaApi("addValueColumn", colKey);
    }
    /** @deprecated v31 use `api.addValueColumns() instead. */

  }, {
    key: "addValueColumns",
    value: function addValueColumns(colKeys) {
      this.viaApi("addValueColumns", colKeys);
    }
    /** @deprecated v31 use `api.setRowGroupColumns() instead. */

  }, {
    key: "setRowGroupColumns",
    value: function setRowGroupColumns(colKeys) {
      this.viaApi("setRowGroupColumns", colKeys);
    }
    /** @deprecated v31 use `api.removeRowGroupColumn() instead. */

  }, {
    key: "removeRowGroupColumn",
    value: function removeRowGroupColumn(colKey) {
      this.viaApi("removeRowGroupColumn", colKey);
    }
    /** @deprecated v31 use `api.removeRowGroupColumns() instead. */

  }, {
    key: "removeRowGroupColumns",
    value: function removeRowGroupColumns(colKeys) {
      this.viaApi("removeRowGroupColumns", colKeys);
    }
    /** @deprecated v31 use `api.addRowGroupColumn() instead. */

  }, {
    key: "addRowGroupColumn",
    value: function addRowGroupColumn(colKey) {
      this.viaApi("addRowGroupColumn", colKey);
    }
    /** @deprecated v31 use `api.addRowGroupColumns() instead. */

  }, {
    key: "addRowGroupColumns",
    value: function addRowGroupColumns(colKeys) {
      this.viaApi("addRowGroupColumns", colKeys);
    }
    /** @deprecated v31 use `api.getRowGroupColumns() instead. */

  }, {
    key: "getRowGroupColumns",
    value: function getRowGroupColumns() {
      return this.viaApi("getRowGroupColumns");
    }
    /** @deprecated v31 use `api.setPivotColumns() instead. */

  }, {
    key: "setPivotColumns",
    value: function setPivotColumns(colKeys) {
      this.viaApi("setPivotColumns", colKeys);
    }
    /** @deprecated v31 use `api.removePivotColumn() instead. */

  }, {
    key: "removePivotColumn",
    value: function removePivotColumn(colKey) {
      this.viaApi("removePivotColumn", colKey);
    }
    /** @deprecated v31 use `api.removePivotColumns() instead. */

  }, {
    key: "removePivotColumns",
    value: function removePivotColumns(colKeys) {
      this.viaApi("removePivotColumns", colKeys);
    }
    /** @deprecated v31 use `api.addPivotColumn() instead. */

  }, {
    key: "addPivotColumn",
    value: function addPivotColumn(colKey) {
      this.viaApi("addPivotColumn", colKey);
    }
    /** @deprecated v31 use `api.addPivotColumns() instead. */

  }, {
    key: "addPivotColumns",
    value: function addPivotColumns(colKeys) {
      this.viaApi("addPivotColumns", colKeys);
    }
    /** @deprecated v31 use `api.getPivotColumns() instead. */

  }, {
    key: "getPivotColumns",
    value: function getPivotColumns() {
      return this.viaApi("getPivotColumns");
    }
    /** @deprecated v31 use `api.getLeftDisplayedColumnGroups() instead. */

  }, {
    key: "getLeftDisplayedColumnGroups",
    value: function getLeftDisplayedColumnGroups() {
      return this.viaApi("getLeftDisplayedColumnGroups");
    }
    /** @deprecated v31 use `api.getCenterDisplayedColumnGroups() instead. */

  }, {
    key: "getCenterDisplayedColumnGroups",
    value: function getCenterDisplayedColumnGroups() {
      return this.viaApi("getCenterDisplayedColumnGroups");
    }
    /** @deprecated v31 use `api.getRightDisplayedColumnGroups() instead. */

  }, {
    key: "getRightDisplayedColumnGroups",
    value: function getRightDisplayedColumnGroups() {
      return this.viaApi("getRightDisplayedColumnGroups");
    }
    /** @deprecated v31 use `api.getAllDisplayedColumnGroups() instead. */

  }, {
    key: "getAllDisplayedColumnGroups",
    value: function getAllDisplayedColumnGroups() {
      return this.viaApi("getAllDisplayedColumnGroups");
    }
    /** @deprecated v31 use `api.autoSizeColumn() instead. */

  }, {
    key: "autoSizeColumn",
    value: function autoSizeColumn(key, skipHeader) {
      return this.viaApi("autoSizeColumn", key, skipHeader);
    }
    /** @deprecated v31 use `api.autoSizeColumns() instead. */

  }, {
    key: "autoSizeColumns",
    value: function autoSizeColumns(keys2, skipHeader) {
      this.viaApi("autoSizeColumns", keys2, skipHeader);
    }
    /** @deprecated v31 use `api.autoSizeAllColumns() instead. */

  }, {
    key: "autoSizeAllColumns",
    value: function autoSizeAllColumns(skipHeader) {
      this.viaApi("autoSizeAllColumns", skipHeader);
    }
    /** @deprecated v31 use `api.setPivotResultColumns() instead. */

  }, {
    key: "setPivotResultColumns",
    value: function setPivotResultColumns(colDefs) {
      this.viaApi("setPivotResultColumns", colDefs);
    }
    /** @deprecated v31 use `api.getPivotResultColumns() instead. */

  }, {
    key: "getPivotResultColumns",
    value: function getPivotResultColumns() {
      return this.viaApi("getPivotResultColumns");
    }
  }]);

  return _ColumnApi;
}();

__decorateClass([_Autowired("gridApi")], _ColumnApi.prototype, "api", 2);

_ColumnApi = __decorateClass([_Bean("columnApi")], _ColumnApi); // community-modules/core/src/valueService/valueService.ts

var _ValueService =
/*#__PURE__*/
function (_BeanStub76) {
  "use strict";

  _inherits(_ValueService, _BeanStub76);

  function _ValueService() {
    var _this579;

    _classCallCheck(this, _ValueService);

    _this579 = _possibleConstructorReturn(this, _getPrototypeOf(_ValueService).apply(this, arguments));
    _this579.initialised = false;
    _this579.isSsrm = false;
    return _this579;
  }

  _createClass(_ValueService, [{
    key: "init",
    value: function init() {
      var _this580 = this;

      this.isSsrm = this.gos.isRowModelType("serverSide");
      this.cellExpressions = this.gos.get("enableCellExpressions");
      this.isTreeData = this.gos.get("treeData");
      this.initialised = true;

      var listener = function listener(event) {
        return _this580.callColumnCellValueChangedHandler(event);
      };

      var async = this.gos.useAsyncEvents();
      this.eventService.addEventListener(_Events.EVENT_CELL_VALUE_CHANGED, listener, async);
      this.addDestroyFunc(function () {
        return _this580.eventService.removeEventListener(_Events.EVENT_CELL_VALUE_CHANGED, listener, async);
      });
      this.addManagedPropertyListener("treeData", function (propChange) {
        return _this580.isTreeData = propChange.currentValue;
      });
    }
  }, {
    key: "getValue",
    value: function getValue(column, rowNode) {
      var forFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var ignoreAggData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (!this.initialised) {
        this.init();
      }

      if (!rowNode) {
        return;
      }

      var colDef = column.getColDef();
      var field = colDef.field;
      var colId = column.getColId();
      var data = rowNode.data;
      var result;
      var groupDataExists = rowNode.groupData && rowNode.groupData[colId] !== void 0;
      var aggDataExists = !ignoreAggData && rowNode.aggData && rowNode.aggData[colId] !== void 0;
      var ignoreSsrmAggData = this.isSsrm && ignoreAggData && !!column.getColDef().aggFunc;
      var ssrmFooterGroupCol = this.isSsrm && rowNode.footer && rowNode.field && (column.getColDef().showRowGroup === true || column.getColDef().showRowGroup === rowNode.field);

      if (forFilter && colDef.filterValueGetter) {
        result = this.executeFilterValueGetter(colDef.filterValueGetter, data, column, rowNode);
      } else if (this.isTreeData && aggDataExists) {
        result = rowNode.aggData[colId];
      } else if (this.isTreeData && colDef.valueGetter) {
        result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
      } else if (this.isTreeData && field && data) {
        result = _getValueUsingField(data, field, column.isFieldContainsDots());
      } else if (groupDataExists) {
        result = rowNode.groupData[colId];
      } else if (aggDataExists) {
        result = rowNode.aggData[colId];
      } else if (colDef.valueGetter) {
        result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
      } else if (ssrmFooterGroupCol) {
        result = _getValueUsingField(data, rowNode.field, column.isFieldContainsDots());
      } else if (field && data && !ignoreSsrmAggData) {
        result = _getValueUsingField(data, field, column.isFieldContainsDots());
      }

      if (this.cellExpressions && typeof result === "string" && result.indexOf("=") === 0) {
        var cellValueGetter = result.substring(1);
        result = this.executeValueGetter(cellValueGetter, data, column, rowNode);
      }

      if (result == null) {
        var openedGroup = this.getOpenedGroup(rowNode, column);

        if (openedGroup != null) {
          return openedGroup;
        }
      }

      return result;
    }
  }, {
    key: "parseValue",
    value: function parseValue(column, rowNode, newValue, oldValue) {
      var colDef = column.getColDef();
      var params = this.gos.addGridCommonParams({
        node: rowNode,
        data: rowNode == null ? void 0 : rowNode.data,
        oldValue: oldValue,
        newValue: newValue,
        colDef: colDef,
        column: column
      });
      var valueParser = colDef.valueParser;

      if (_exists(valueParser)) {
        if (typeof valueParser === "function") {
          return valueParser(params);
        }

        return this.expressionService.evaluate(valueParser, params);
      }

      return newValue;
    }
  }, {
    key: "formatValue",
    value: function formatValue(column, node, value, suppliedFormatter) {
      var useFormatterFromColumn = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var result = null;
      var formatter;
      var colDef = column.getColDef();

      if (suppliedFormatter) {
        formatter = suppliedFormatter;
      } else if (useFormatterFromColumn) {
        formatter = colDef.valueFormatter;
      }

      if (formatter) {
        var params = this.gos.addGridCommonParams({
          value: value,
          node: node,
          data: node ? node.data : null,
          colDef: colDef,
          column: column
        });

        if (typeof formatter === "function") {
          result = formatter(params);
        } else {
          result = this.expressionService.evaluate(formatter, params);
        }
      } else if (colDef.refData) {
        return colDef.refData[value] || "";
      }

      if (result == null && Array.isArray(value)) {
        result = value.join(", ");
      }

      return result;
    }
  }, {
    key: "getOpenedGroup",
    value: function getOpenedGroup(rowNode, column) {
      if (!this.gos.get("showOpenedGroup")) {
        return;
      }

      var colDef = column.getColDef();

      if (!colDef.showRowGroup) {
        return;
      }

      var showRowGroup = column.getColDef().showRowGroup;
      var pointer = rowNode.parent;

      while (pointer != null) {
        if (pointer.rowGroupColumn && (showRowGroup === true || showRowGroup === pointer.rowGroupColumn.getColId())) {
          return pointer.key;
        }

        pointer = pointer.parent;
      }

      return void 0;
    }
    /**
     * Sets the value of a GridCell
     * @param rowNode The `RowNode` to be updated
     * @param colKey The `Column` to be updated
     * @param newValue The new value to be set
     * @param eventSource The event source
     * @returns `True` if the value has been updated, otherwise`False`.
     */

  }, {
    key: "setValue",
    value: function setValue(rowNode, colKey, newValue, eventSource) {
      var column = this.columnModel.getPrimaryColumn(colKey);

      if (!rowNode || !column) {
        return false;
      }

      if (_missing(rowNode.data)) {
        rowNode.data = {};
      }

      var _column$getColDef2 = column.getColDef(),
          field = _column$getColDef2.field,
          valueSetter = _column$getColDef2.valueSetter;

      if (_missing(field) && _missing(valueSetter)) {
        console.warn("AG Grid: you need either field or valueSetter set on colDef for editing to work");
        return false;
      }

      if (!this.dataTypeService.checkType(column, newValue)) {
        console.warn("AG Grid: Data type of the new value does not match the cell data type of the column");
        return false;
      }

      var params = this.gos.addGridCommonParams({
        node: rowNode,
        data: rowNode.data,
        oldValue: this.getValue(column, rowNode),
        newValue: newValue,
        colDef: column.getColDef(),
        column: column
      });
      params.newValue = newValue;
      var valueWasDifferent;

      if (_exists(valueSetter)) {
        if (typeof valueSetter === "function") {
          valueWasDifferent = valueSetter(params);
        } else {
          valueWasDifferent = this.expressionService.evaluate(valueSetter, params);
        }
      } else {
        valueWasDifferent = this.setValueUsingField(rowNode.data, field, newValue, column.isFieldContainsDots());
      }

      if (valueWasDifferent === void 0) {
        valueWasDifferent = true;
      }

      if (!valueWasDifferent) {
        return false;
      }

      rowNode.resetQuickFilterAggregateText();
      this.valueCache.onDataChanged();
      params.newValue = this.getValue(column, rowNode);
      var event = {
        type: _Events.EVENT_CELL_VALUE_CHANGED,
        event: null,
        rowIndex: rowNode.rowIndex,
        rowPinned: rowNode.rowPinned,
        column: params.column,
        api: params.api,
        columnApi: params.columnApi,
        colDef: params.colDef,
        context: params.context,
        data: rowNode.data,
        node: rowNode,
        oldValue: params.oldValue,
        newValue: params.newValue,
        value: params.newValue,
        source: eventSource
      };
      this.eventService.dispatchEvent(event);
      return true;
    }
  }, {
    key: "callColumnCellValueChangedHandler",
    value: function callColumnCellValueChangedHandler(event) {
      var onCellValueChanged = event.colDef.onCellValueChanged;

      if (typeof onCellValueChanged === "function") {
        this.getFrameworkOverrides().wrapOutgoing(function () {
          onCellValueChanged({
            node: event.node,
            data: event.data,
            oldValue: event.oldValue,
            newValue: event.newValue,
            colDef: event.colDef,
            column: event.column,
            api: event.api,
            columnApi: event.columnApi,
            context: event.context
          });
        });
      }
    }
  }, {
    key: "setValueUsingField",
    value: function setValueUsingField(data, field, newValue, isFieldContainsDots) {
      if (!field) {
        return false;
      }

      var valuesAreSame = false;

      if (!isFieldContainsDots) {
        valuesAreSame = data[field] === newValue;

        if (!valuesAreSame) {
          data[field] = newValue;
        }
      } else {
        var fieldPieces = field.split(".");
        var currentObject = data;

        while (fieldPieces.length > 0 && currentObject) {
          var fieldPiece = fieldPieces.shift();

          if (fieldPieces.length === 0) {
            valuesAreSame = currentObject[fieldPiece] === newValue;

            if (!valuesAreSame) {
              currentObject[fieldPiece] = newValue;
            }
          } else {
            currentObject = currentObject[fieldPiece];
          }
        }
      }

      return !valuesAreSame;
    }
  }, {
    key: "executeFilterValueGetter",
    value: function executeFilterValueGetter(valueGetter, data, column, rowNode) {
      var params = this.gos.addGridCommonParams({
        data: data,
        node: rowNode,
        column: column,
        colDef: column.getColDef(),
        getValue: this.getValueCallback.bind(this, rowNode)
      });

      if (typeof valueGetter === "function") {
        return valueGetter(params);
      }

      return this.expressionService.evaluate(valueGetter, params);
    }
  }, {
    key: "executeValueGetter",
    value: function executeValueGetter(valueGetter, data, column, rowNode) {
      var colId = column.getColId();
      var valueFromCache = this.valueCache.getValue(rowNode, colId);

      if (valueFromCache !== void 0) {
        return valueFromCache;
      }

      var params = this.gos.addGridCommonParams({
        data: data,
        node: rowNode,
        column: column,
        colDef: column.getColDef(),
        getValue: this.getValueCallback.bind(this, rowNode)
      });
      var result;

      if (typeof valueGetter === "function") {
        result = valueGetter(params);
      } else {
        result = this.expressionService.evaluate(valueGetter, params);
      }

      this.valueCache.setValue(rowNode, colId, result);
      return result;
    }
  }, {
    key: "getValueCallback",
    value: function getValueCallback(node, field) {
      var otherColumn = this.columnModel.getPrimaryColumn(field);

      if (otherColumn) {
        return this.getValue(otherColumn, node);
      }

      return null;
    } // used by row grouping and pivot, to get key for a row. col can be a pivot col or a row grouping col

  }, {
    key: "getKeyForNode",
    value: function getKeyForNode(col, rowNode) {
      var value = this.getValue(col, rowNode);
      var keyCreator = col.getColDef().keyCreator;
      var result = value;

      if (keyCreator) {
        var keyParams = this.gos.addGridCommonParams({
          value: value,
          colDef: col.getColDef(),
          column: col,
          node: rowNode,
          data: rowNode.data
        });
        result = keyCreator(keyParams);
      }

      if (typeof result === "string" || result == null) {
        return result;
      }

      result = String(result);

      if (result === "[object Object]") {
        _warnOnce("a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (se AG Grid docs) or b) to toString() on the object to return a key");
      }

      return result;
    }
  }]);

  return _ValueService;
}(_BeanStub2);

__decorateClass([_Autowired("expressionService")], _ValueService.prototype, "expressionService", 2);

__decorateClass([_Autowired("columnModel")], _ValueService.prototype, "columnModel", 2);

__decorateClass([_Autowired("valueCache")], _ValueService.prototype, "valueCache", 2);

__decorateClass([_Autowired("dataTypeService")], _ValueService.prototype, "dataTypeService", 2);

__decorateClass([_PostConstruct], _ValueService.prototype, "init", 1);

_ValueService = __decorateClass([_Bean("valueService")], _ValueService); // community-modules/core/src/valueService/expressionService.ts

var _ExpressionService =
/*#__PURE__*/
function (_BeanStub77) {
  "use strict";

  _inherits(_ExpressionService, _BeanStub77);

  function _ExpressionService() {
    var _this581;

    _classCallCheck(this, _ExpressionService);

    _this581 = _possibleConstructorReturn(this, _getPrototypeOf(_ExpressionService).apply(this, arguments));
    _this581.expressionToFunctionCache = {};
    return _this581;
  }

  _createClass(_ExpressionService, [{
    key: "setBeans",
    value: function setBeans(loggerFactory) {
      this.logger = loggerFactory.create("ExpressionService");
    }
  }, {
    key: "evaluate",
    value: function evaluate(expression, params) {
      if (typeof expression === "string") {
        return this.evaluateExpression(expression, params);
      } else {
        console.error("AG Grid: value should be either a string or a function", expression);
      }
    }
  }, {
    key: "evaluateExpression",
    value: function evaluateExpression(expression, params) {
      try {
        var javaScriptFunction = this.createExpressionFunction(expression);
        var result = javaScriptFunction(params.value, params.context, params.oldValue, params.newValue, params.value, params.node, params.data, params.colDef, params.rowIndex, params.api, params.columnApi, params.getValue, params.column, params.columnGroup);
        return result;
      } catch (e) {
        console.log("Processing of the expression failed");
        console.log("Expression = " + expression);
        console.log("Params =", params);
        console.log("Exception = " + e);
        return null;
      }
    }
  }, {
    key: "createExpressionFunction",
    value: function createExpressionFunction(expression) {
      if (this.expressionToFunctionCache[expression]) {
        return this.expressionToFunctionCache[expression];
      }

      var functionBody = this.createFunctionBody(expression);
      var theFunction = new Function("x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, columnApi, getValue, column, columnGroup", functionBody);
      this.expressionToFunctionCache[expression] = theFunction;
      return theFunction;
    }
  }, {
    key: "createFunctionBody",
    value: function createFunctionBody(expression) {
      if (expression.indexOf("return") >= 0) {
        return expression;
      } else {
        return "return " + expression + ";";
      }
    }
  }]);

  return _ExpressionService;
}(_BeanStub2);

__decorateClass([__decorateParam(0, _Qualifier("loggerFactory"))], _ExpressionService.prototype, "setBeans", 1);

_ExpressionService = __decorateClass([_Bean("expressionService")], _ExpressionService); // community-modules/core/src/logger.ts

var _LoggerFactory =
/*#__PURE__*/
function (_BeanStub78) {
  "use strict";

  _inherits(_LoggerFactory, _BeanStub78);

  function _LoggerFactory() {
    _classCallCheck(this, _LoggerFactory);

    return _possibleConstructorReturn(this, _getPrototypeOf(_LoggerFactory).apply(this, arguments));
  }

  _createClass(_LoggerFactory, [{
    key: "setBeans",
    value: function setBeans(gos) {
      this.logging = gos.get("debug");
    }
  }, {
    key: "create",
    value: function create(name) {
      return new _Logger(name, this.isLogging.bind(this));
    }
  }, {
    key: "isLogging",
    value: function isLogging() {
      return this.logging;
    }
  }]);

  return _LoggerFactory;
}(_BeanStub2);

__decorateClass([__decorateParam(0, _Qualifier("gridOptionsService"))], _LoggerFactory.prototype, "setBeans", 1);

_LoggerFactory = __decorateClass([_Bean("loggerFactory")], _LoggerFactory);

var _Logger =
/*#__PURE__*/
function () {
  "use strict";

  function _Logger(name, isLoggingFunc) {
    _classCallCheck(this, _Logger);

    this.name = name;
    this.isLoggingFunc = isLoggingFunc;
  }

  _createClass(_Logger, [{
    key: "isLogging",
    value: function isLogging() {
      return this.isLoggingFunc();
    }
  }, {
    key: "log",
    value: function log(message) {
      if (this.isLoggingFunc()) {
        console.log("AG Grid." + this.name + ": " + message);
      }
    }
  }]);

  return _Logger;
}(); // community-modules/core/src/gridComp/gridCtrl.ts


var _GridCtrl =
/*#__PURE__*/
function (_BeanStub79) {
  "use strict";

  _inherits(_GridCtrl, _BeanStub79);

  function _GridCtrl() {
    _classCallCheck(this, _GridCtrl);

    return _possibleConstructorReturn(this, _getPrototypeOf(_GridCtrl).apply(this, arguments));
  }

  _createClass(_GridCtrl, [{
    key: "setComp",
    value: function setComp(view, eGridDiv, eGui) {
      var _this582 = this;

      this.view = view;
      this.eGridHostDiv = eGridDiv;
      this.eGui = eGui;
      this.eGui.setAttribute("grid-id", this.context.getGridId());
      this.dragAndDropService.addDropTarget({
        getContainer: function getContainer() {
          return _this582.eGui;
        },
        isInterestedIn: function isInterestedIn(type) {
          return type === 1
          /* HeaderCell */
          || type === 0;
        }
        /* ToolPanel */
        ,
        getIconName: function getIconName() {
          return _DragAndDropService2.ICON_NOT_ALLOWED;
        }
      });
      this.mouseEventService.stampTopLevelGridCompWithGridInstance(eGridDiv);
      this.createManagedBean(new LayoutFeature(this.view));
      this.addRtlSupport();
      var unsubscribeFromResize = this.resizeObserverService.observeResize(this.eGridHostDiv, this.onGridSizeChanged.bind(this));
      this.addDestroyFunc(function () {
        return unsubscribeFromResize();
      });
      this.ctrlsService.register("gridCtrl", this);
    }
  }, {
    key: "isDetailGrid",
    value: function isDetailGrid() {
      var _a;

      var el = this.focusService.findTabbableParent(this.getGui());
      return ((_a = el == null ? void 0 : el.getAttribute("row-id")) == null ? void 0 : _a.startsWith("detail")) || false;
    }
  }, {
    key: "showDropZones",
    value: function showDropZones() {
      return _ModuleRegistry2.__isRegistered("@ag-grid-enterprise/row-grouping"
      /* RowGroupingModule */
      , this.context.getGridId());
    }
  }, {
    key: "showSideBar",
    value: function showSideBar() {
      return _ModuleRegistry2.__isRegistered("@ag-grid-enterprise/side-bar"
      /* SideBarModule */
      , this.context.getGridId());
    }
  }, {
    key: "showStatusBar",
    value: function showStatusBar() {
      return _ModuleRegistry2.__isRegistered("@ag-grid-enterprise/status-bar"
      /* StatusBarModule */
      , this.context.getGridId());
    }
  }, {
    key: "showWatermark",
    value: function showWatermark() {
      return _ModuleRegistry2.__isRegistered("@ag-grid-enterprise/core"
      /* EnterpriseCoreModule */
      , this.context.getGridId());
    }
  }, {
    key: "onGridSizeChanged",
    value: function onGridSizeChanged() {
      var event = {
        type: _Events.EVENT_GRID_SIZE_CHANGED,
        clientWidth: this.eGridHostDiv.clientWidth,
        clientHeight: this.eGridHostDiv.clientHeight
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "addRtlSupport",
    value: function addRtlSupport() {
      var cssClass = this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr";
      this.view.setRtlClass(cssClass);
    }
  }, {
    key: "destroyGridUi",
    value: function destroyGridUi() {
      this.view.destroyGridUi();
    }
  }, {
    key: "getGui",
    value: function getGui() {
      return this.eGui;
    }
  }, {
    key: "setResizeCursor",
    value: function setResizeCursor(on) {
      this.view.setCursor(on ? "ew-resize" : null);
    }
  }, {
    key: "disableUserSelect",
    value: function disableUserSelect(on) {
      this.view.setUserSelect(on ? "none" : null);
    }
  }, {
    key: "focusNextInnerContainer",
    value: function focusNextInnerContainer(backwards) {
      var focusableContainers = this.view.getFocusableContainers();
      var activeEl = this.gos.getActiveDomElement();
      var idxWithFocus = focusableContainers.findIndex(function (container) {
        return container.contains(activeEl);
      });
      var nextIdx = idxWithFocus + (backwards ? -1 : 1);

      if (nextIdx <= 0 || nextIdx >= focusableContainers.length) {
        return false;
      }

      return this.focusService.focusInto(focusableContainers[nextIdx]);
    }
  }, {
    key: "focusInnerElement",
    value: function focusInnerElement(fromBottom) {
      var focusableContainers = this.view.getFocusableContainers();
      var allColumns = this.columnModel.getAllDisplayedColumns();

      if (fromBottom) {
        if (focusableContainers.length > 1) {
          return this.focusService.focusInto(_last(focusableContainers), true);
        }

        var lastColumn = _last(allColumns);

        if (this.focusService.focusGridView(lastColumn, true)) {
          return true;
        }
      }

      if (this.gos.get("headerHeight") === 0 || this.gos.get("suppressHeaderFocus")) {
        if (this.focusService.focusGridView(allColumns[0])) {
          return true;
        }

        for (var i = 1; i < focusableContainers.length; i++) {
          if (this.focusService.focusInto(focusableContainers[i])) {
            return true;
          }
        }

        return false;
      }

      return this.focusService.focusFirstHeader();
    }
  }, {
    key: "forceFocusOutOfContainer",
    value: function forceFocusOutOfContainer() {
      var up = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.view.forceFocusOutOfContainer(up);
    }
  }]);

  return _GridCtrl;
}(_BeanStub2);

__decorateClass([_Autowired("focusService")], _GridCtrl.prototype, "focusService", 2);

__decorateClass([_Autowired("resizeObserverService")], _GridCtrl.prototype, "resizeObserverService", 2);

__decorateClass([_Autowired("columnModel")], _GridCtrl.prototype, "columnModel", 2);

__decorateClass([_Autowired("ctrlsService")], _GridCtrl.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("mouseEventService")], _GridCtrl.prototype, "mouseEventService", 2);

__decorateClass([_Autowired("dragAndDropService")], _GridCtrl.prototype, "dragAndDropService", 2); // community-modules/core/src/gridComp/gridComp.ts


var _GridComp =
/*#__PURE__*/
function (_TabGuardComp6) {
  "use strict";

  _inherits(_GridComp, _TabGuardComp6);

  function _GridComp(eGridDiv) {
    var _this583;

    _classCallCheck(this, _GridComp);

    _this583 = _possibleConstructorReturn(this, _getPrototypeOf(_GridComp).call(this));
    _this583.eGridDiv = eGridDiv;
    return _this583;
  }

  _createClass(_GridComp, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this584 = this;

      this.logger = this.loggerFactory.create("GridComp");
      var compProxy = {
        destroyGridUi: function destroyGridUi() {
          return _this584.destroyBean(_this584);
        },
        setRtlClass: function setRtlClass(cssClass) {
          return _this584.addCssClass(cssClass);
        },
        forceFocusOutOfContainer: this.forceFocusOutOfContainer.bind(this),
        updateLayoutClasses: this.updateLayoutClasses.bind(this),
        getFocusableContainers: this.getFocusableContainers.bind(this),
        setUserSelect: function setUserSelect(value) {
          _this584.getGui().style.userSelect = value != null ? value : "";
          _this584.getGui().style.webkitUserSelect = value != null ? value : "";
        },
        setCursor: function setCursor(value) {
          _this584.getGui().style.cursor = value != null ? value : "";
        }
      };
      this.ctrl = this.createManagedBean(new _GridCtrl());
      var template = this.createTemplate();
      this.setTemplate(template);
      this.ctrl.setComp(compProxy, this.eGridDiv, this.getGui());
      this.insertGridIntoDom();
      this.initialiseTabGuard({
        // we want to override the default behaviour to do nothing for onTabKeyDown
        onTabKeyDown: function onTabKeyDown() {
          return void 0;
        },
        focusInnerElement: function focusInnerElement(fromBottom) {
          return _this584.ctrl.focusInnerElement(fromBottom);
        },
        forceFocusOutWhenTabGuardsAreEmpty: true
      });
    }
  }, {
    key: "insertGridIntoDom",
    value: function insertGridIntoDom() {
      var _this585 = this;

      var eGui = this.getGui();
      this.eGridDiv.appendChild(eGui);
      this.addDestroyFunc(function () {
        _this585.eGridDiv.removeChild(eGui);

        _this585.logger.log("Grid removed from DOM");
      });
    }
  }, {
    key: "updateLayoutClasses",
    value: function updateLayoutClasses(cssClass, params) {
      var eRootWrapperBodyClassList = this.eRootWrapperBody.classList;
      eRootWrapperBodyClassList.toggle("ag-layout-auto-height"
      /* AUTO_HEIGHT */
      , params.autoHeight);
      eRootWrapperBodyClassList.toggle("ag-layout-normal"
      /* NORMAL */
      , params.normal);
      eRootWrapperBodyClassList.toggle("ag-layout-print"
      /* PRINT */
      , params.print);
      this.addOrRemoveCssClass("ag-layout-auto-height"
      /* AUTO_HEIGHT */
      , params.autoHeight);
      this.addOrRemoveCssClass("ag-layout-normal"
      /* NORMAL */
      , params.normal);
      this.addOrRemoveCssClass("ag-layout-print"
      /* PRINT */
      , params.print);
    }
  }, {
    key: "createTemplate",
    value: function createTemplate() {
      var dropZones = this.ctrl.showDropZones() ? "<ag-grid-header-drop-zones></ag-grid-header-drop-zones>" : "";
      var sideBar = this.ctrl.showSideBar() ? '<ag-side-bar ref="sideBar"></ag-side-bar>' : "";
      var statusBar = this.ctrl.showStatusBar() ? '<ag-status-bar ref="statusBar"></ag-status-bar>' : "";
      var watermark = this.ctrl.showWatermark() ? "<ag-watermark></ag-watermark>" : "";
      var template =
      /* html */
      "<div class=\"ag-root-wrapper\" role=\"presentation\">\n                ".concat(dropZones, "\n                <div class=\"ag-root-wrapper-body\" ref=\"rootWrapperBody\" role=\"presentation\">\n                    <ag-grid-body ref=\"gridBody\"></ag-grid-body>\n                    ").concat(sideBar, "\n                </div>\n                ").concat(statusBar, "\n                <ag-pagination></ag-pagination>\n                ").concat(watermark, "\n            </div>");
      return template;
    }
  }, {
    key: "getFocusableElement",
    value: function getFocusableElement() {
      return this.eRootWrapperBody;
    }
  }, {
    key: "getFocusableContainers",
    value: function getFocusableContainers() {
      var focusableContainers = [this.gridBodyComp.getGui()];

      if (this.sideBarComp) {
        focusableContainers.push(this.sideBarComp.getGui());
      }

      return focusableContainers.filter(function (el) {
        return _isVisible(el);
      });
    }
  }]);

  return _GridComp;
}(_TabGuardComp);

__decorateClass([_Autowired("loggerFactory")], _GridComp.prototype, "loggerFactory", 2);

__decorateClass([_RefSelector("gridBody")], _GridComp.prototype, "gridBodyComp", 2);

__decorateClass([_RefSelector("sideBar")], _GridComp.prototype, "sideBarComp", 2);

__decorateClass([_RefSelector("rootWrapperBody")], _GridComp.prototype, "eRootWrapperBody", 2);

__decorateClass([_PostConstruct], _GridComp.prototype, "postConstruct", 1); // community-modules/core/src/sortController.ts


var _SortController2 =
/*#__PURE__*/
function (_BeanStub80) {
  "use strict";

  _inherits(_SortController, _BeanStub80);

  function _SortController() {
    _classCallCheck(this, _SortController);

    return _possibleConstructorReturn(this, _getPrototypeOf(_SortController).apply(this, arguments));
  }

  _createClass(_SortController, [{
    key: "progressSort",
    value: function progressSort(column, multiSort, source) {
      var nextDirection = this.getNextSortDirection(column);
      this.setSortForColumn(column, nextDirection, multiSort, source);
    }
  }, {
    key: "setSortForColumn",
    value: function setSortForColumn(column, sort, multiSort, source) {
      if (sort !== "asc" && sort !== "desc") {
        sort = null;
      }

      var isColumnsSortingCoupledToGroup = this.gos.isColumnsSortingCoupledToGroup();
      var columnsToUpdate = [column];

      if (isColumnsSortingCoupledToGroup) {
        if (column.getColDef().showRowGroup) {
          var rowGroupColumns = this.columnModel.getSourceColumnsForGroupColumn(column);
          var sortableRowGroupColumns = rowGroupColumns == null ? void 0 : rowGroupColumns.filter(function (col) {
            return col.isSortable();
          });

          if (sortableRowGroupColumns) {
            columnsToUpdate = [column].concat(_toConsumableArray(sortableRowGroupColumns));
          }
        }
      }

      columnsToUpdate.forEach(function (col) {
        return col.setSort(sort, source);
      });
      var doingMultiSort = (multiSort || this.gos.get("alwaysMultiSort")) && !this.gos.get("suppressMultiSort");
      var updatedColumns = [];

      if (!doingMultiSort) {
        var clearedColumns = this.clearSortBarTheseColumns(columnsToUpdate, source);
        updatedColumns.push.apply(updatedColumns, _toConsumableArray(clearedColumns));
      }

      this.updateSortIndex(column);
      updatedColumns.push.apply(updatedColumns, _toConsumableArray(columnsToUpdate));
      this.dispatchSortChangedEvents(source, updatedColumns);
    }
  }, {
    key: "updateSortIndex",
    value: function updateSortIndex(lastColToChange) {
      var isCoupled = this.gos.isColumnsSortingCoupledToGroup();
      var groupParent = this.columnModel.getGroupDisplayColumnForGroup(lastColToChange.getId());
      var lastSortIndexCol = isCoupled ? groupParent || lastColToChange : lastColToChange;
      var allSortedCols = this.getColumnsWithSortingOrdered();
      this.columnModel.getPrimaryAndSecondaryAndAutoColumns().forEach(function (col) {
        return col.setSortIndex(null);
      });
      var allSortedColsWithoutChangesOrGroups = allSortedCols.filter(function (col) {
        if (isCoupled && col.getColDef().showRowGroup) {
          return false;
        }

        return col !== lastSortIndexCol;
      });
      var sortedColsWithIndices = !!lastSortIndexCol.getSort() ? [].concat(_toConsumableArray(allSortedColsWithoutChangesOrGroups), [lastSortIndexCol]) : allSortedColsWithoutChangesOrGroups;
      sortedColsWithIndices.forEach(function (col, idx) {
        col.setSortIndex(idx);
      });
    } // gets called by API, so if data changes, use can call this, which will end up
    // working out the sort order again of the rows.

  }, {
    key: "onSortChanged",
    value: function onSortChanged(source, columns) {
      this.dispatchSortChangedEvents(source, columns);
    }
  }, {
    key: "isSortActive",
    value: function isSortActive() {
      var allCols = this.columnModel.getPrimaryAndSecondaryAndAutoColumns();
      var sortedCols = allCols.filter(function (column) {
        return !!column.getSort();
      });
      return sortedCols && sortedCols.length > 0;
    }
  }, {
    key: "dispatchSortChangedEvents",
    value: function dispatchSortChangedEvents(source, columns) {
      var event = {
        type: _Events.EVENT_SORT_CHANGED,
        source: source
      };

      if (columns) {
        event.columns = columns;
      }

      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "clearSortBarTheseColumns",
    value: function clearSortBarTheseColumns(columnsToSkip, source) {
      var clearedColumns = [];
      this.columnModel.getPrimaryAndSecondaryAndAutoColumns().forEach(function (columnToClear) {
        if (!columnsToSkip.includes(columnToClear)) {
          if (!!columnToClear.getSort()) {
            clearedColumns.push(columnToClear);
          }

          columnToClear.setSort(void 0, source);
        }
      });
      return clearedColumns;
    }
  }, {
    key: "getNextSortDirection",
    value: function getNextSortDirection(column) {
      var sortingOrder;

      if (column.getColDef().sortingOrder) {
        sortingOrder = column.getColDef().sortingOrder;
      } else if (this.gos.get("sortingOrder")) {
        sortingOrder = this.gos.get("sortingOrder");
      } else {
        sortingOrder = _SortController2.DEFAULT_SORTING_ORDER;
      }

      if (!Array.isArray(sortingOrder) || sortingOrder.length <= 0) {
        console.warn("AG Grid: sortingOrder must be an array with at least one element, currently it's ".concat(sortingOrder));
        return null;
      }

      var currentIndex = sortingOrder.indexOf(column.getSort());
      var notInArray = currentIndex < 0;
      var lastItemInArray = currentIndex == sortingOrder.length - 1;
      var result;

      if (notInArray || lastItemInArray) {
        result = sortingOrder[0];
      } else {
        result = sortingOrder[currentIndex + 1];
      }

      if (_SortController2.DEFAULT_SORTING_ORDER.indexOf(result) < 0) {
        console.warn("AG Grid: invalid sort type " + result);
        return null;
      }

      return result;
    }
    /**
     * @returns a map of sort indexes for every sorted column, if groups sort primaries then they will have equivalent indices
     */

  }, {
    key: "getIndexedSortMap",
    value: function getIndexedSortMap() {
      var _this586 = this;

      var allSortedCols = this.columnModel.getPrimaryAndSecondaryAndAutoColumns().filter(function (col) {
        return !!col.getSort();
      });

      if (this.columnModel.isPivotMode()) {
        var isSortingLinked = this.gos.isColumnsSortingCoupledToGroup();
        allSortedCols = allSortedCols.filter(function (col) {
          var isAggregated = !!col.getAggFunc();
          var isSecondary = !col.isPrimary();
          var isGroup = isSortingLinked ? _this586.columnModel.getGroupDisplayColumnForGroup(col.getId()) : col.getColDef().showRowGroup;
          return isAggregated || isSecondary || isGroup;
        });
      }

      var sortedRowGroupCols = this.columnModel.getRowGroupColumns().filter(function (col) {
        return !!col.getSort();
      });
      var allColsIndexes = {};
      allSortedCols.forEach(function (col, index) {
        return allColsIndexes[col.getId()] = index;
      });
      allSortedCols.sort(function (a, b) {
        var iA = a.getSortIndex();
        var iB = b.getSortIndex();

        if (iA != null && iB != null) {
          return iA - iB;
        } else if (iA == null && iB == null) {
          var posA = allColsIndexes[a.getId()];
          var posB = allColsIndexes[b.getId()];
          return posA > posB ? 1 : -1;
        } else if (iB == null) {
          return -1;
        } else {
          return 1;
        }
      });
      var isSortLinked = this.gos.isColumnsSortingCoupledToGroup() && !!sortedRowGroupCols.length;

      if (isSortLinked) {
        allSortedCols = _toConsumableArray(new Set( // if linked sorting, replace all columns with the display group column for index purposes, and ensure uniqueness
        allSortedCols.map(function (col) {
          var _a;

          return (_a = _this586.columnModel.getGroupDisplayColumnForGroup(col.getId())) != null ? _a : col;
        })));
      }

      var indexMap =
      /* @__PURE__ */
      new Map();
      allSortedCols.forEach(function (col, idx) {
        return indexMap.set(col, idx);
      });

      if (isSortLinked) {
        sortedRowGroupCols.forEach(function (col) {
          var groupDisplayCol = _this586.columnModel.getGroupDisplayColumnForGroup(col.getId());

          indexMap.set(col, indexMap.get(groupDisplayCol));
        });
      }

      return indexMap;
    }
  }, {
    key: "getColumnsWithSortingOrdered",
    value: function getColumnsWithSortingOrdered() {
      return _toConsumableArray(this.getIndexedSortMap().entries()).sort(function (_ref51, _ref52) {
        var _ref53 = _slicedToArray(_ref51, 2),
            col1 = _ref53[0],
            idx1 = _ref53[1];

        var _ref54 = _slicedToArray(_ref52, 2),
            col2 = _ref54[0],
            idx2 = _ref54[1];

        return idx1 - idx2;
      }).map(function (_ref55) {
        var _ref56 = _slicedToArray(_ref55, 1),
            col = _ref56[0];

        return col;
      });
    } // used by server side row models, to sent sort to server

  }, {
    key: "getSortModel",
    value: function getSortModel() {
      return this.getColumnsWithSortingOrdered().filter(function (column) {
        return column.getSort();
      }).map(function (column) {
        return {
          sort: column.getSort(),
          colId: column.getId()
        };
      });
    }
  }, {
    key: "getSortOptions",
    value: function getSortOptions() {
      return this.getColumnsWithSortingOrdered().filter(function (column) {
        return column.getSort();
      }).map(function (column) {
        return {
          sort: column.getSort(),
          column: column
        };
      });
    }
  }, {
    key: "canColumnDisplayMixedSort",
    value: function canColumnDisplayMixedSort(column) {
      var isColumnSortCouplingActive = this.gos.isColumnsSortingCoupledToGroup();
      var isGroupDisplayColumn = !!column.getColDef().showRowGroup;
      return isColumnSortCouplingActive && isGroupDisplayColumn;
    }
  }, {
    key: "getDisplaySortForColumn",
    value: function getDisplaySortForColumn(column) {
      var linkedColumns = this.columnModel.getSourceColumnsForGroupColumn(column);

      if (!this.canColumnDisplayMixedSort(column) || !(linkedColumns == null ? void 0 : linkedColumns.length)) {
        return column.getSort();
      }

      var columnHasUniqueData = column.getColDef().field != null || !!column.getColDef().valueGetter;
      var sortableColumns = columnHasUniqueData ? [column].concat(_toConsumableArray(linkedColumns)) : linkedColumns;
      var firstSort = sortableColumns[0].getSort();
      var allMatch = sortableColumns.every(function (col) {
        return col.getSort() == firstSort;
      });

      if (!allMatch) {
        return "mixed";
      }

      return firstSort;
    }
  }, {
    key: "getDisplaySortIndexForColumn",
    value: function getDisplaySortIndexForColumn(column) {
      return this.getIndexedSortMap().get(column);
    }
  }]);

  return _SortController;
}(_BeanStub2);

_SortController2.DEFAULT_SORTING_ORDER = ["asc", "desc", null];

__decorateClass([_Autowired("columnModel")], _SortController2.prototype, "columnModel", 2);

_SortController2 = __decorateClass([_Bean("sortController")], _SortController2); // community-modules/core/src/focusService.ts

var _FocusService2 =
/*#__PURE__*/
function (_BeanStub81) {
  "use strict";

  _inherits(_FocusService, _BeanStub81);

  function _FocusService() {
    _classCallCheck(this, _FocusService);

    return _possibleConstructorReturn(this, _getPrototypeOf(_FocusService).apply(this, arguments));
  }

  _createClass(_FocusService, [{
    key: "init",
    value: function init() {
      var _this587 = this;

      var clearFocusedCellListener = this.clearFocusedCell.bind(this);
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, clearFocusedCellListener);
      this.addManagedListener(this.eventService, _Events.EVENT_NEW_COLUMNS_LOADED, this.onColumnEverythingChanged.bind(this));
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_GROUP_OPENED, clearFocusedCellListener);
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_ROW_GROUP_CHANGED, clearFocusedCellListener);
      this.registerKeyboardFocusEvents();
      this.ctrlsService.whenReady(function (p) {
        _this587.gridCtrl = p.gridCtrl;
      });
    }
  }, {
    key: "registerKeyboardFocusEvents",
    value: function registerKeyboardFocusEvents() {
      var eDocument = this.gos.getDocument();

      _FocusService2.addKeyboardModeEvents(eDocument);

      _FocusService2.instanceCount++;
      this.addDestroyFunc(function () {
        _FocusService2.instanceCount--;

        _FocusService2.unregisterGridCompController(eDocument);
      });
    }
  }, {
    key: "onColumnEverythingChanged",
    value: function onColumnEverythingChanged() {
      if (!this.focusedCellPosition) {
        return;
      }

      var col = this.focusedCellPosition.column;
      var colFromColumnModel = this.columnModel.getGridColumn(col.getId());

      if (col !== colFromColumnModel) {
        this.clearFocusedCell();
      }
    }
  }, {
    key: "isKeyboardMode",
    value: function isKeyboardMode() {
      return _FocusService2.keyboardModeActive;
    } // we check if the browser is focusing something, and if it is, and
    // it's the cell we think is focused, then return the cell. so this
    // methods returns the cell if a) we think it has focus and b) the
    // browser thinks it has focus. this then returns nothing if we
    // first focus a cell, then second click outside the grid, as then the
    // grid cell will still be focused as far as the grid is concerned,
    // however the browser focus will have moved somewhere else.

  }, {
    key: "getFocusCellToUseAfterRefresh",
    value: function getFocusCellToUseAfterRefresh() {
      if (this.gos.get("suppressFocusAfterRefresh") || !this.focusedCellPosition) {
        return null;
      }

      if (this.isDomDataMissingInHierarchy(this.gos.getActiveDomElement(), _RowCtrl2.DOM_DATA_KEY_ROW_CTRL)) {
        return null;
      }

      return this.focusedCellPosition;
    }
  }, {
    key: "getFocusHeaderToUseAfterRefresh",
    value: function getFocusHeaderToUseAfterRefresh() {
      if (this.gos.get("suppressFocusAfterRefresh") || !this.focusedHeaderPosition) {
        return null;
      }

      if (this.isDomDataMissingInHierarchy(this.gos.getActiveDomElement(), _AbstractHeaderCellCtrl2.DOM_DATA_KEY_HEADER_CTRL)) {
        return null;
      }

      return this.focusedHeaderPosition;
    }
  }, {
    key: "isDomDataMissingInHierarchy",
    value: function isDomDataMissingInHierarchy(eBrowserCell, key) {
      var ePointer = eBrowserCell;

      while (ePointer) {
        var data = this.gos.getDomData(ePointer, key);

        if (data) {
          return false;
        }

        ePointer = ePointer.parentNode;
      }

      return true;
    }
  }, {
    key: "getFocusedCell",
    value: function getFocusedCell() {
      return this.focusedCellPosition;
    }
  }, {
    key: "shouldRestoreFocus",
    value: function shouldRestoreFocus(cell) {
      var _this588 = this;

      if (this.isCellRestoreFocused(cell)) {
        setTimeout(function () {
          _this588.restoredFocusedCellPosition = null;
        }, 0);
        return true;
      }

      return false;
    }
  }, {
    key: "isCellRestoreFocused",
    value: function isCellRestoreFocused(cellPosition) {
      if (this.restoredFocusedCellPosition == null) {
        return false;
      }

      return this.cellPositionUtils.equals(cellPosition, this.restoredFocusedCellPosition);
    }
  }, {
    key: "setRestoreFocusedCell",
    value: function setRestoreFocusedCell(cellPosition) {
      if (this.getFrameworkOverrides().renderingEngine === "react") {
        this.restoredFocusedCellPosition = cellPosition;
      }
    }
  }, {
    key: "getFocusEventParams",
    value: function getFocusEventParams() {
      var _this$focusedCellPosi = this.focusedCellPosition,
          rowIndex = _this$focusedCellPosi.rowIndex,
          rowPinned = _this$focusedCellPosi.rowPinned,
          column = _this$focusedCellPosi.column;
      var params = {
        rowIndex: rowIndex,
        rowPinned: rowPinned,
        column: column,
        isFullWidthCell: false
      };
      var rowCtrl = this.rowRenderer.getRowByPosition({
        rowIndex: rowIndex,
        rowPinned: rowPinned
      });

      if (rowCtrl) {
        params.isFullWidthCell = rowCtrl.isFullWidth();
      }

      return params;
    }
  }, {
    key: "clearFocusedCell",
    value: function clearFocusedCell() {
      this.restoredFocusedCellPosition = null;

      if (this.focusedCellPosition == null) {
        return;
      }

      var event = __spreadValues({
        type: _Events.EVENT_CELL_FOCUS_CLEARED
      }, this.getFocusEventParams());

      this.focusedCellPosition = null;
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "setFocusedCell",
    value: function setFocusedCell(params) {
      var column = params.column,
          rowIndex = params.rowIndex,
          rowPinned = params.rowPinned,
          _params$forceBrowserF = params.forceBrowserFocus,
          forceBrowserFocus = _params$forceBrowserF === void 0 ? false : _params$forceBrowserF,
          _params$preventScroll = params.preventScrollOnBrowserFocus,
          preventScrollOnBrowserFocus = _params$preventScroll === void 0 ? false : _params$preventScroll;
      var gridColumn = this.columnModel.getGridColumn(column);

      if (!gridColumn) {
        this.focusedCellPosition = null;
        return;
      }

      this.focusedCellPosition = gridColumn ? {
        rowIndex: rowIndex,
        rowPinned: _makeNull(rowPinned),
        column: gridColumn
      } : null;

      var event = __spreadProps(__spreadValues({
        type: _Events.EVENT_CELL_FOCUSED
      }, this.getFocusEventParams()), {
        forceBrowserFocus: forceBrowserFocus,
        preventScrollOnBrowserFocus: preventScrollOnBrowserFocus,
        floating: null
      });

      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "isCellFocused",
    value: function isCellFocused(cellPosition) {
      if (this.focusedCellPosition == null) {
        return false;
      }

      return this.cellPositionUtils.equals(cellPosition, this.focusedCellPosition);
    }
  }, {
    key: "isRowNodeFocused",
    value: function isRowNodeFocused(rowNode) {
      return this.isRowFocused(rowNode.rowIndex, rowNode.rowPinned);
    }
  }, {
    key: "isHeaderWrapperFocused",
    value: function isHeaderWrapperFocused(headerCtrl) {
      if (this.focusedHeaderPosition == null) {
        return false;
      }

      var column = headerCtrl.getColumnGroupChild();
      var headerRowIndex = headerCtrl.getRowIndex();
      var pinned = headerCtrl.getPinned();
      var _this$focusedHeaderPo = this.focusedHeaderPosition,
          focusedColumn = _this$focusedHeaderPo.column,
          focusedHeaderRowIndex = _this$focusedHeaderPo.headerRowIndex;
      return column === focusedColumn && headerRowIndex === focusedHeaderRowIndex && pinned == focusedColumn.getPinned();
    }
  }, {
    key: "clearFocusedHeader",
    value: function clearFocusedHeader() {
      this.focusedHeaderPosition = null;
    }
  }, {
    key: "getFocusedHeader",
    value: function getFocusedHeader() {
      return this.focusedHeaderPosition;
    }
  }, {
    key: "setFocusedHeader",
    value: function setFocusedHeader(headerRowIndex, column) {
      this.focusedHeaderPosition = {
        headerRowIndex: headerRowIndex,
        column: column
      };
    }
  }, {
    key: "focusHeaderPosition",
    value: function focusHeaderPosition(params) {
      if (this.gos.get("suppressHeaderFocus")) {
        return false;
      }

      var direction = params.direction,
          fromTab = params.fromTab,
          allowUserOverride = params.allowUserOverride,
          event = params.event,
          fromCell = params.fromCell,
          rowWithoutSpanValue = params.rowWithoutSpanValue;
      var headerPosition = params.headerPosition;

      if (fromCell && this.filterManager.isAdvancedFilterHeaderActive()) {
        return this.focusAdvancedFilter(headerPosition);
      }

      if (allowUserOverride) {
        var currentPosition = this.getFocusedHeader();
        var headerRowCount = this.headerNavigationService.getHeaderRowCount();

        if (fromTab) {
          var userFunc = this.gos.getCallback("tabToNextHeader");

          if (userFunc) {
            headerPosition = this.getHeaderPositionFromUserFunc({
              userFunc: userFunc,
              direction: direction,
              currentPosition: currentPosition,
              headerPosition: headerPosition,
              headerRowCount: headerRowCount
            });
          }
        } else {
          var _userFunc = this.gos.getCallback("navigateToNextHeader");

          if (_userFunc && event) {
            var params2 = {
              key: event.key,
              previousHeaderPosition: currentPosition,
              nextHeaderPosition: headerPosition,
              headerRowCount: headerRowCount,
              event: event
            };
            headerPosition = _userFunc(params2);
          }
        }
      }

      if (!headerPosition) {
        return false;
      }

      return this.focusProvidedHeaderPosition({
        headerPosition: headerPosition,
        direction: direction,
        event: event,
        fromCell: fromCell,
        rowWithoutSpanValue: rowWithoutSpanValue
      });
    }
  }, {
    key: "focusHeaderPositionFromUserFunc",
    value: function focusHeaderPositionFromUserFunc(params) {
      if (this.gos.get("suppressHeaderFocus")) {
        return false;
      }

      var userFunc = params.userFunc,
          headerPosition = params.headerPosition,
          direction = params.direction,
          event = params.event;
      var currentPosition = this.getFocusedHeader();
      var headerRowCount = this.headerNavigationService.getHeaderRowCount();
      var newHeaderPosition = this.getHeaderPositionFromUserFunc({
        userFunc: userFunc,
        direction: direction,
        currentPosition: currentPosition,
        headerPosition: headerPosition,
        headerRowCount: headerRowCount
      });
      return !!newHeaderPosition && this.focusProvidedHeaderPosition({
        headerPosition: newHeaderPosition,
        direction: direction,
        event: event
      });
    }
  }, {
    key: "getHeaderPositionFromUserFunc",
    value: function getHeaderPositionFromUserFunc(params) {
      var userFunc = params.userFunc,
          direction = params.direction,
          currentPosition = params.currentPosition,
          headerPosition = params.headerPosition,
          headerRowCount = params.headerRowCount;
      var userFuncParams = {
        backwards: direction === "Before",
        previousHeaderPosition: currentPosition,
        nextHeaderPosition: headerPosition,
        headerRowCount: headerRowCount
      };
      var userResult = userFunc(userFuncParams);

      if (userResult === true || userResult === null) {
        if (userResult === null) {
          _warnOnce("Returning `null` from tabToNextHeader is deprecated. Return `true` to stay on the current header, or `false` to let the browser handle the tab behaviour.");
        }

        return currentPosition;
      }

      if (userResult === false) {
        return null;
      }

      return userResult;
    }
  }, {
    key: "focusProvidedHeaderPosition",
    value: function focusProvidedHeaderPosition(params) {
      var headerPosition = params.headerPosition,
          direction = params.direction,
          fromCell = params.fromCell,
          rowWithoutSpanValue = params.rowWithoutSpanValue,
          event = params.event;

      if (headerPosition.headerRowIndex === -1) {
        if (this.filterManager.isAdvancedFilterHeaderActive()) {
          return this.focusAdvancedFilter(headerPosition);
        }

        return this.focusGridView(headerPosition.column);
      }

      this.headerNavigationService.scrollToColumn(headerPosition.column, direction);
      var headerRowContainerCtrl = this.ctrlsService.getHeaderRowContainerCtrl(headerPosition.column.getPinned());
      var focusSuccess = headerRowContainerCtrl.focusHeader(headerPosition.headerRowIndex, headerPosition.column, event);

      if (focusSuccess && (rowWithoutSpanValue != null || fromCell)) {
        this.headerNavigationService.setCurrentHeaderRowWithoutSpan(rowWithoutSpanValue != null ? rowWithoutSpanValue : -1);
      }

      return focusSuccess;
    }
  }, {
    key: "focusFirstHeader",
    value: function focusFirstHeader() {
      var firstColumn = this.columnModel.getAllDisplayedColumns()[0];

      if (!firstColumn) {
        return false;
      }

      if (firstColumn.getParent()) {
        firstColumn = this.columnModel.getColumnGroupAtLevel(firstColumn, 0);
      }

      var headerPosition = this.headerPositionUtils.getHeaderIndexToFocus(firstColumn, 0);
      return this.focusHeaderPosition({
        headerPosition: headerPosition,
        rowWithoutSpanValue: 0
      });
    }
  }, {
    key: "focusLastHeader",
    value: function focusLastHeader(event) {
      var headerRowIndex = this.headerNavigationService.getHeaderRowCount() - 1;

      var column = _last(this.columnModel.getAllDisplayedColumns());

      return this.focusHeaderPosition({
        headerPosition: {
          headerRowIndex: headerRowIndex,
          column: column
        },
        rowWithoutSpanValue: -1,
        event: event
      });
    }
  }, {
    key: "focusPreviousFromFirstCell",
    value: function focusPreviousFromFirstCell(event) {
      if (this.filterManager.isAdvancedFilterHeaderActive()) {
        return this.focusAdvancedFilter(null);
      }

      return this.focusLastHeader(event);
    }
  }, {
    key: "isAnyCellFocused",
    value: function isAnyCellFocused() {
      return !!this.focusedCellPosition;
    }
  }, {
    key: "isRowFocused",
    value: function isRowFocused(rowIndex, floating) {
      if (this.focusedCellPosition == null) {
        return false;
      }

      return this.focusedCellPosition.rowIndex === rowIndex && this.focusedCellPosition.rowPinned === _makeNull(floating);
    }
  }, {
    key: "findFocusableElements",
    value: function findFocusableElements(rootNode, exclude) {
      var onlyUnmanaged = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var focusableString = _FOCUSABLE_SELECTOR;
      var excludeString = _FOCUSABLE_EXCLUDE;

      if (exclude) {
        excludeString += ", " + exclude;
      }

      if (onlyUnmanaged) {
        excludeString += ', [tabindex="-1"]';
      }

      var nodes = Array.prototype.slice.apply(rootNode.querySelectorAll(focusableString)).filter(function (node) {
        return _isVisible(node);
      });
      var excludeNodes = Array.prototype.slice.apply(rootNode.querySelectorAll(excludeString));

      if (!excludeNodes.length) {
        return nodes;
      }

      var diff = function diff(a, b) {
        return a.filter(function (element) {
          return b.indexOf(element) === -1;
        });
      };

      return diff(nodes, excludeNodes);
    }
  }, {
    key: "focusInto",
    value: function focusInto(rootNode) {
      var up = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var onlyUnmanaged = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var focusableElements = this.findFocusableElements(rootNode, null, onlyUnmanaged);
      var toFocus = up ? _last(focusableElements) : focusableElements[0];

      if (toFocus) {
        toFocus.focus({
          preventScroll: true
        });
        return true;
      }

      return false;
    }
  }, {
    key: "findFocusableElementBeforeTabGuard",
    value: function findFocusableElementBeforeTabGuard(rootNode, referenceElement) {
      if (!referenceElement) {
        return null;
      }

      var focusableElements = this.findFocusableElements(rootNode);
      var referenceIndex = focusableElements.indexOf(referenceElement);

      if (referenceIndex === -1) {
        return null;
      }

      var lastTabGuardIndex = -1;

      for (var i = referenceIndex - 1; i >= 0; i--) {
        if (focusableElements[i].classList.contains("ag-tab-guard-top"
        /* TAB_GUARD_TOP */
        )) {
          lastTabGuardIndex = i;
          break;
        }
      }

      if (lastTabGuardIndex <= 0) {
        return null;
      }

      return focusableElements[lastTabGuardIndex - 1];
    }
  }, {
    key: "findNextFocusableElement",
    value: function findNextFocusableElement() {
      var rootNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.eGridDiv;
      var onlyManaged = arguments.length > 1 ? arguments[1] : undefined;
      var backwards = arguments.length > 2 ? arguments[2] : undefined;
      var focusable = this.findFocusableElements(rootNode, onlyManaged ? ':not([tabindex="-1"])' : null);
      var activeEl = this.gos.getActiveDomElement();
      var currentIndex;

      if (onlyManaged) {
        currentIndex = focusable.findIndex(function (el) {
          return el.contains(activeEl);
        });
      } else {
        currentIndex = focusable.indexOf(activeEl);
      }

      var nextIndex = currentIndex + (backwards ? -1 : 1);

      if (nextIndex < 0 || nextIndex >= focusable.length) {
        return null;
      }

      return focusable[nextIndex];
    }
  }, {
    key: "isTargetUnderManagedComponent",
    value: function isTargetUnderManagedComponent(rootNode, target) {
      if (!target) {
        return false;
      }

      var managedContainers = rootNode.querySelectorAll(".".concat(_ManagedFocusFeature2.FOCUS_MANAGED_CLASS));

      if (!managedContainers.length) {
        return false;
      }

      for (var i = 0; i < managedContainers.length; i++) {
        if (managedContainers[i].contains(target)) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "findTabbableParent",
    value: function findTabbableParent(node) {
      var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
      var counter = 0;

      while (node && _getTabIndex(node) === null && ++counter <= limit) {
        node = node.parentElement;
      }

      if (_getTabIndex(node) === null) {
        return null;
      }

      return node;
    }
  }, {
    key: "focusGridView",
    value: function focusGridView(column, backwards) {
      var _a;

      if (this.gos.get("suppressCellFocus")) {
        if (backwards) {
          if (!this.gos.get("suppressHeaderFocus")) {
            return this.focusLastHeader();
          }

          return this.focusNextGridCoreContainer(true, true);
        }

        return this.focusNextGridCoreContainer(false);
      }

      var nextRow = backwards ? this.rowPositionUtils.getLastRow() : this.rowPositionUtils.getFirstRow();

      if (!nextRow) {
        return false;
      }

      var rowIndex = nextRow.rowIndex,
          rowPinned = nextRow.rowPinned;
      var focusedHeader = this.getFocusedHeader();

      if (!column && focusedHeader) {
        column = focusedHeader.column;
      }

      if (rowIndex == null || !column) {
        return false;
      }

      this.navigationService.ensureCellVisible({
        rowIndex: rowIndex,
        column: column,
        rowPinned: rowPinned
      });
      this.setFocusedCell({
        rowIndex: rowIndex,
        column: column,
        rowPinned: _makeNull(rowPinned),
        forceBrowserFocus: true
      });
      (_a = this.rangeService) == null ? void 0 : _a.setRangeToCell({
        rowIndex: rowIndex,
        rowPinned: rowPinned,
        column: column
      });
      return true;
    }
  }, {
    key: "focusNextGridCoreContainer",
    value: function focusNextGridCoreContainer(backwards) {
      var forceOut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!forceOut && this.gridCtrl.focusNextInnerContainer(backwards)) {
        return true;
      }

      if (forceOut || !backwards && !this.gridCtrl.isDetailGrid()) {
        this.gridCtrl.forceFocusOutOfContainer(backwards);
      }

      return false;
    }
  }, {
    key: "focusAdvancedFilter",
    value: function focusAdvancedFilter(position) {
      var _a, _b;

      this.advancedFilterFocusColumn = position == null ? void 0 : position.column;
      return (_b = (_a = this.advancedFilterService) == null ? void 0 : _a.getCtrl().focusHeaderComp()) != null ? _b : false;
    }
  }, {
    key: "focusNextFromAdvancedFilter",
    value: function focusNextFromAdvancedFilter(backwards, forceFirstColumn) {
      var _a, _b;

      var column = (_b = forceFirstColumn ? void 0 : this.advancedFilterFocusColumn) != null ? _b : (_a = this.columnModel.getAllDisplayedColumns()) == null ? void 0 : _a[0];

      if (backwards) {
        return this.focusHeaderPosition({
          headerPosition: {
            column: column,
            headerRowIndex: this.headerNavigationService.getHeaderRowCount() - 1
          }
        });
      } else {
        return this.focusGridView(column);
      }
    }
  }, {
    key: "clearAdvancedFilterColumn",
    value: function clearAdvancedFilterColumn() {
      this.advancedFilterFocusColumn = void 0;
    }
  }], [{
    key: "addKeyboardModeEvents",
    value: function addKeyboardModeEvents(doc) {
      if (this.instanceCount > 0) {
        return;
      }

      doc.addEventListener("keydown", _FocusService2.toggleKeyboardMode);
      doc.addEventListener("mousedown", _FocusService2.toggleKeyboardMode);
    }
  }, {
    key: "removeKeyboardModeEvents",
    value: function removeKeyboardModeEvents(doc) {
      if (this.instanceCount > 0) return;
      doc.addEventListener("keydown", _FocusService2.toggleKeyboardMode);
      doc.addEventListener("mousedown", _FocusService2.toggleKeyboardMode);
    }
  }, {
    key: "toggleKeyboardMode",
    value: function toggleKeyboardMode(event) {
      var isKeyboardActive = _FocusService2.keyboardModeActive;
      var isKeyboardEvent = event.type === "keydown";

      if (isKeyboardEvent) {
        if (event.ctrlKey || event.metaKey || event.altKey) {
          return;
        }
      }

      if (isKeyboardActive === isKeyboardEvent) {
        return;
      }

      _FocusService2.keyboardModeActive = isKeyboardEvent;
    }
  }, {
    key: "unregisterGridCompController",
    value: function unregisterGridCompController(doc) {
      _FocusService2.removeKeyboardModeEvents(doc);
    }
  }]);

  return _FocusService;
}(_BeanStub2);

_FocusService2.keyboardModeActive = false;
_FocusService2.instanceCount = 0;

__decorateClass([_Autowired("eGridDiv")], _FocusService2.prototype, "eGridDiv", 2);

__decorateClass([_Autowired("columnModel")], _FocusService2.prototype, "columnModel", 2);

__decorateClass([_Autowired("headerNavigationService")], _FocusService2.prototype, "headerNavigationService", 2);

__decorateClass([_Autowired("headerPositionUtils")], _FocusService2.prototype, "headerPositionUtils", 2);

__decorateClass([_Autowired("rowRenderer")], _FocusService2.prototype, "rowRenderer", 2);

__decorateClass([_Autowired("rowPositionUtils")], _FocusService2.prototype, "rowPositionUtils", 2);

__decorateClass([_Autowired("cellPositionUtils")], _FocusService2.prototype, "cellPositionUtils", 2);

__decorateClass([_Autowired("navigationService")], _FocusService2.prototype, "navigationService", 2);

__decorateClass([_Autowired("ctrlsService")], _FocusService2.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("filterManager")], _FocusService2.prototype, "filterManager", 2);

__decorateClass([_Optional("rangeService")], _FocusService2.prototype, "rangeService", 2);

__decorateClass([_Optional("advancedFilterService")], _FocusService2.prototype, "advancedFilterService", 2);

__decorateClass([_PostConstruct], _FocusService2.prototype, "init", 1);

_FocusService2 = __decorateClass([_Bean("focusService")], _FocusService2); // community-modules/core/src/rendering/columnHoverService.ts

var ColumnHoverService =
/*#__PURE__*/
function (_BeanStub82) {
  "use strict";

  _inherits(ColumnHoverService, _BeanStub82);

  function ColumnHoverService() {
    _classCallCheck(this, ColumnHoverService);

    return _possibleConstructorReturn(this, _getPrototypeOf(ColumnHoverService).apply(this, arguments));
  }

  _createClass(ColumnHoverService, [{
    key: "setMouseOver",
    value: function setMouseOver(columns) {
      this.selectedColumns = columns;
      var event = {
        type: _Events.EVENT_COLUMN_HOVER_CHANGED
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "clearMouseOver",
    value: function clearMouseOver() {
      this.selectedColumns = null;
      var event = {
        type: _Events.EVENT_COLUMN_HOVER_CHANGED
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "isHovered",
    value: function isHovered(column) {
      return !!this.selectedColumns && this.selectedColumns.indexOf(column) >= 0;
    }
  }]);

  return ColumnHoverService;
}(_BeanStub2);

ColumnHoverService = __decorateClass([_Bean("columnHoverService")], ColumnHoverService); // community-modules/core/src/rendering/columnAnimationService.ts

var ColumnAnimationService =
/*#__PURE__*/
function (_BeanStub83) {
  "use strict";

  _inherits(ColumnAnimationService, _BeanStub83);

  function ColumnAnimationService() {
    var _this589;

    _classCallCheck(this, ColumnAnimationService);

    _this589 = _possibleConstructorReturn(this, _getPrototypeOf(ColumnAnimationService).apply(this, arguments));
    _this589.executeNextFuncs = [];
    _this589.executeLaterFuncs = [];
    _this589.active = false;
    _this589.suppressAnimation = false;
    _this589.animationThreadCount = 0;
    return _this589;
  }

  _createClass(ColumnAnimationService, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this590 = this;

      this.ctrlsService.whenReady(function (p) {
        return _this590.gridBodyCtrl = p.gridBodyCtrl;
      });
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.active && !this.suppressAnimation;
    }
  }, {
    key: "setSuppressAnimation",
    value: function setSuppressAnimation(suppress) {
      this.suppressAnimation = suppress;
    }
  }, {
    key: "start",
    value: function start() {
      if (this.active) {
        return;
      }

      if (this.gos.get("suppressColumnMoveAnimation")) {
        return;
      }

      if (this.gos.get("enableRtl")) {
        return;
      }

      this.ensureAnimationCssClassPresent();
      this.active = true;
    }
  }, {
    key: "finish",
    value: function finish() {
      var _this591 = this;

      if (!this.active) {
        return;
      }

      this.flush(function () {
        _this591.active = false;
      });
    }
  }, {
    key: "executeNextVMTurn",
    value: function executeNextVMTurn(func) {
      if (this.active) {
        this.executeNextFuncs.push(func);
      } else {
        func();
      }
    }
  }, {
    key: "executeLaterVMTurn",
    value: function executeLaterVMTurn(func) {
      if (this.active) {
        this.executeLaterFuncs.push(func);
      } else {
        func();
      }
    }
  }, {
    key: "ensureAnimationCssClassPresent",
    value: function ensureAnimationCssClassPresent() {
      var _this592 = this;

      this.animationThreadCount++;
      var animationThreadCountCopy = this.animationThreadCount;
      this.gridBodyCtrl.setColumnMovingCss(true);
      this.executeLaterFuncs.push(function () {
        if (_this592.animationThreadCount === animationThreadCountCopy) {
          _this592.gridBodyCtrl.setColumnMovingCss(false);
        }
      });
    }
  }, {
    key: "flush",
    value: function flush(callback) {
      var _this593 = this;

      if (this.executeNextFuncs.length === 0 && this.executeLaterFuncs.length === 0) {
        callback();
        return;
      }

      var runFuncs = function runFuncs(queue) {
        while (queue.length) {
          var func = queue.pop();

          if (func) {
            func();
          }
        }
      };

      this.getFrameworkOverrides().wrapIncoming(function () {
        window.setTimeout(function () {
          return runFuncs(_this593.executeNextFuncs);
        }, 0);
        window.setTimeout(function () {
          runFuncs(_this593.executeLaterFuncs);
          callback();
        }, 200);
      });
    }
  }]);

  return ColumnAnimationService;
}(_BeanStub2);

__decorateClass([_Autowired("ctrlsService")], ColumnAnimationService.prototype, "ctrlsService", 2);

__decorateClass([_PostConstruct], ColumnAnimationService.prototype, "postConstruct", 1);

ColumnAnimationService = __decorateClass([_Bean("columnAnimationService")], ColumnAnimationService); // community-modules/core/src/pagination/paginationAutoPageSizeService.ts

var PaginationAutoPageSizeService =
/*#__PURE__*/
function (_BeanStub84) {
  "use strict";

  _inherits(PaginationAutoPageSizeService, _BeanStub84);

  function PaginationAutoPageSizeService() {
    _classCallCheck(this, PaginationAutoPageSizeService);

    return _possibleConstructorReturn(this, _getPrototypeOf(PaginationAutoPageSizeService).apply(this, arguments));
  }

  _createClass(PaginationAutoPageSizeService, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this594 = this;

      this.ctrlsService.whenReady(function (p) {
        _this594.centerRowsCtrl = p.center;

        _this594.addManagedListener(_this594.eventService, _Events.EVENT_BODY_HEIGHT_CHANGED, _this594.checkPageSize.bind(_this594));

        _this594.addManagedListener(_this594.eventService, _Events.EVENT_SCROLL_VISIBILITY_CHANGED, _this594.checkPageSize.bind(_this594));

        _this594.addManagedPropertyListener("paginationAutoPageSize", _this594.onPaginationAutoSizeChanged.bind(_this594));

        _this594.checkPageSize();
      });
    }
  }, {
    key: "notActive",
    value: function notActive() {
      return !this.gos.get("paginationAutoPageSize") || this.centerRowsCtrl == null;
    }
  }, {
    key: "onPaginationAutoSizeChanged",
    value: function onPaginationAutoSizeChanged() {
      if (this.notActive()) {
        this.paginationProxy.unsetAutoCalculatedPageSize();
      } else {
        this.checkPageSize();
      }
    }
  }, {
    key: "checkPageSize",
    value: function checkPageSize() {
      var _this595 = this;

      if (this.notActive()) {
        return;
      }

      var bodyHeight = this.centerRowsCtrl.getViewportSizeFeature().getBodyHeight();

      if (bodyHeight > 0) {
        var update = function update() {
          var rowHeight = _this595.gos.getRowHeightAsNumber();

          var newPageSize = Math.floor(bodyHeight / rowHeight);

          _this595.paginationProxy.setPageSize(newPageSize, "autoCalculated");
        };

        if (!this.isBodyRendered) {
          update();
          this.isBodyRendered = true;
        } else {
          _debounce(function () {
            return update();
          }, 50)();
        }
      } else {
        this.isBodyRendered = false;
      }
    }
  }]);

  return PaginationAutoPageSizeService;
}(_BeanStub2);

__decorateClass([_Autowired("ctrlsService")], PaginationAutoPageSizeService.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("paginationProxy")], PaginationAutoPageSizeService.prototype, "paginationProxy", 2);

__decorateClass([_PostConstruct], PaginationAutoPageSizeService.prototype, "postConstruct", 1);

PaginationAutoPageSizeService = __decorateClass([_Bean("paginationAutoPageSizeService")], PaginationAutoPageSizeService); // community-modules/core/src/valueService/valueCache.ts

var _ValueCache =
/*#__PURE__*/
function (_BeanStub85) {
  "use strict";

  _inherits(_ValueCache, _BeanStub85);

  function _ValueCache() {
    var _this596;

    _classCallCheck(this, _ValueCache);

    _this596 = _possibleConstructorReturn(this, _getPrototypeOf(_ValueCache).apply(this, arguments));
    _this596.cacheVersion = 0;
    return _this596;
  }

  _createClass(_ValueCache, [{
    key: "init",
    value: function init() {
      this.active = this.gos.get("valueCache");
      this.neverExpires = this.gos.get("valueCacheNeverExpires");
    }
  }, {
    key: "onDataChanged",
    value: function onDataChanged() {
      if (this.neverExpires) {
        return;
      }

      this.expire();
    }
  }, {
    key: "expire",
    value: function expire() {
      this.cacheVersion++;
    }
  }, {
    key: "setValue",
    value: function setValue(rowNode, colId, value) {
      if (this.active) {
        if (rowNode.__cacheVersion !== this.cacheVersion) {
          rowNode.__cacheVersion = this.cacheVersion;
          rowNode.__cacheData = {};
        }

        rowNode.__cacheData[colId] = value;
      }
    }
  }, {
    key: "getValue",
    value: function getValue(rowNode, colId) {
      if (!this.active || rowNode.__cacheVersion !== this.cacheVersion) {
        return void 0;
      }

      return rowNode.__cacheData[colId];
    }
  }]);

  return _ValueCache;
}(_BeanStub2);

__decorateClass([_PostConstruct], _ValueCache.prototype, "init", 1);

_ValueCache = __decorateClass([_Bean("valueCache")], _ValueCache); // community-modules/core/src/valueService/changeDetectionService.ts

var SOURCE_PASTE = "paste";

var ChangeDetectionService =
/*#__PURE__*/
function (_BeanStub86) {
  "use strict";

  _inherits(ChangeDetectionService, _BeanStub86);

  function ChangeDetectionService() {
    _classCallCheck(this, ChangeDetectionService);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChangeDetectionService).apply(this, arguments));
  }

  _createClass(ChangeDetectionService, [{
    key: "init",
    value: function init() {
      if (this.rowModel.getType() === "clientSide") {
        this.clientSideRowModel = this.rowModel;
      }

      this.addManagedListener(this.eventService, _Events.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged.bind(this));
    }
  }, {
    key: "onCellValueChanged",
    value: function onCellValueChanged(event) {
      if (event.source === SOURCE_PASTE) {
        return;
      }

      this.doChangeDetection(event.node, event.column);
    }
  }, {
    key: "doChangeDetection",
    value: function doChangeDetection(rowNode, column) {
      if (this.gos.get("suppressChangeDetection")) {
        return;
      }

      var nodesToRefresh = [rowNode];

      if (this.clientSideRowModel && !rowNode.isRowPinned()) {
        var onlyChangedColumns = this.gos.get("aggregateOnlyChangedColumns");
        var changedPath = new _ChangedPath(onlyChangedColumns, this.clientSideRowModel.getRootNode());
        changedPath.addParentNode(rowNode.parent, [column]);
        this.clientSideRowModel.doAggregate(changedPath);
        changedPath.forEachChangedNodeDepthFirst(function (rowNode2) {
          nodesToRefresh.push(rowNode2);
        });
      }

      this.rowRenderer.refreshCells({
        rowNodes: nodesToRefresh
      });
    }
  }]);

  return ChangeDetectionService;
}(_BeanStub2);

__decorateClass([_Autowired("rowModel")], ChangeDetectionService.prototype, "rowModel", 2);

__decorateClass([_Autowired("rowRenderer")], ChangeDetectionService.prototype, "rowRenderer", 2);

__decorateClass([_PostConstruct], ChangeDetectionService.prototype, "init", 1);

ChangeDetectionService = __decorateClass([_Bean("changeDetectionService")], ChangeDetectionService); // community-modules/core/src/components/framework/agComponentUtils.ts

var AgComponentUtils =
/*#__PURE__*/
function (_BeanStub87) {
  "use strict";

  _inherits(AgComponentUtils, _BeanStub87);

  function AgComponentUtils() {
    _classCallCheck(this, AgComponentUtils);

    return _possibleConstructorReturn(this, _getPrototypeOf(AgComponentUtils).apply(this, arguments));
  }

  _createClass(AgComponentUtils, [{
    key: "adaptFunction",
    value: function adaptFunction(propertyName, jsCompFunc) {
      var metadata = this.componentMetadataProvider.retrieve(propertyName);

      if (metadata && metadata.functionAdapter) {
        return metadata.functionAdapter(jsCompFunc);
      }

      return null;
    }
  }, {
    key: "adaptCellRendererFunction",
    value: function adaptCellRendererFunction(callback) {
      var Adapter =
      /*#__PURE__*/
      function () {
        function Adapter() {
          _classCallCheck(this, Adapter);
        }

        _createClass(Adapter, [{
          key: "refresh",
          value: function refresh(params) {
            return false;
          }
        }, {
          key: "getGui",
          value: function getGui() {
            return this.eGui;
          }
        }, {
          key: "init",
          value: function init(params) {
            var callbackResult = callback(params);
            var type = typeof callbackResult;

            if (type === "string" || type === "number" || type === "boolean") {
              this.eGui = _loadTemplate("<span>" + callbackResult + "</span>");
              return;
            }

            if (callbackResult == null) {
              this.eGui = _loadTemplate("<span></span>");
              return;
            }

            this.eGui = callbackResult;
          }
        }]);

        return Adapter;
      }();

      return Adapter;
    }
  }, {
    key: "doesImplementIComponent",
    value: function doesImplementIComponent(candidate) {
      if (!candidate) {
        return false;
      }

      return candidate.prototype && "getGui" in candidate.prototype;
    }
  }]);

  return AgComponentUtils;
}(_BeanStub2);

__decorateClass([_Autowired("componentMetadataProvider")], AgComponentUtils.prototype, "componentMetadataProvider", 2);

AgComponentUtils = __decorateClass([_Bean("agComponentUtils")], AgComponentUtils); // community-modules/core/src/components/framework/componentMetadataProvider.ts

var ComponentMetadataProvider =
/*#__PURE__*/
function (_BeanStub88) {
  "use strict";

  _inherits(ComponentMetadataProvider, _BeanStub88);

  function ComponentMetadataProvider() {
    _classCallCheck(this, ComponentMetadataProvider);

    return _possibleConstructorReturn(this, _getPrototypeOf(ComponentMetadataProvider).apply(this, arguments));
  }

  _createClass(ComponentMetadataProvider, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.componentMetaData = {
        dateComponent: {
          mandatoryMethodList: ["getDate", "setDate"],
          optionalMethodList: ["afterGuiAttached", "setInputPlaceholder", "setInputAriaLabel", "setDisabled", "onParamsUpdated", "refresh"]
        },
        detailCellRenderer: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh"],
          functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
        },
        headerComponent: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh"]
        },
        headerGroupComponent: {
          mandatoryMethodList: [],
          optionalMethodList: []
        },
        loadingCellRenderer: {
          mandatoryMethodList: [],
          optionalMethodList: [],
          functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
        },
        loadingOverlayComponent: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh"]
        },
        noRowsOverlayComponent: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh"]
        },
        floatingFilterComponent: {
          mandatoryMethodList: ["onParentModelChanged"],
          optionalMethodList: ["afterGuiAttached", "onParamsUpdated", "refresh"]
        },
        cellRenderer: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh", "afterGuiAttached"],
          functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
        },
        cellEditor: {
          mandatoryMethodList: ["getValue"],
          optionalMethodList: ["isPopup", "isCancelBeforeStart", "isCancelAfterEnd", "getPopupPosition", "focusIn", "focusOut", "afterGuiAttached", "refresh"]
        },
        innerRenderer: {
          mandatoryMethodList: [],
          optionalMethodList: ["afterGuiAttached"],
          functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
        },
        fullWidthCellRenderer: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh", "afterGuiAttached"],
          functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
        },
        groupRowRenderer: {
          mandatoryMethodList: [],
          optionalMethodList: ["afterGuiAttached"],
          functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
        },
        filter: {
          mandatoryMethodList: ["isFilterActive", "doesFilterPass", "getModel", "setModel"],
          optionalMethodList: ["afterGuiAttached", "afterGuiDetached", "onNewRowsLoaded", "getModelAsString", "onFloatingFilterChanged", "onAnyFilterChanged", "refresh"]
        },
        statusPanel: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh"]
        },
        toolPanel: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh", "getState"]
        },
        tooltipComponent: {
          mandatoryMethodList: [],
          optionalMethodList: []
        },
        menuItem: {
          mandatoryMethodList: [],
          optionalMethodList: ["setActive", "select", "setExpanded", "configureDefaults"]
        }
      };
    }
  }, {
    key: "retrieve",
    value: function retrieve(name) {
      return this.componentMetaData[name];
    }
  }]);

  return ComponentMetadataProvider;
}(_BeanStub2);

__decorateClass([_Autowired("agComponentUtils")], ComponentMetadataProvider.prototype, "agComponentUtils", 2);

__decorateClass([_PostConstruct], ComponentMetadataProvider.prototype, "postConstruct", 1);

ComponentMetadataProvider = __decorateClass([_Bean("componentMetadataProvider")], ComponentMetadataProvider); // community-modules/core/src/environment.ts

var DEFAULT_ROW_HEIGHT = 25;
var MIN_COL_WIDTH = 10;
var MAT_GRID_SIZE = 8;
var BASE_GRID_SIZE = 4;
var BALHAM_GRID_SIZE = 4;
var ALPINE_GRID_SIZE = 6;
var QUARTZ_ICON_SIZE = 16;
var QUARTZ_FONT_SIZE = 14;
var QUARTZ_GRID_SIZE = 8;
var HARD_CODED_SIZES = {
  // this item is required for custom themes
  "ag-theme-custom": {
    headerHeight: 25,
    headerCellMinWidth: 24,
    listItemHeight: BASE_GRID_SIZE * 5,
    rowHeight: 25,
    chartMenuPanelWidth: 220
  },
  "ag-theme-material": {
    headerHeight: MAT_GRID_SIZE * 7,
    headerCellMinWidth: 48,
    listItemHeight: MAT_GRID_SIZE * 4,
    rowHeight: MAT_GRID_SIZE * 6,
    chartMenuPanelWidth: 240
  },
  "ag-theme-balham": {
    headerHeight: BALHAM_GRID_SIZE * 8,
    headerCellMinWidth: 24,
    listItemHeight: BALHAM_GRID_SIZE * 6,
    rowHeight: BALHAM_GRID_SIZE * 7,
    chartMenuPanelWidth: 220
  },
  "ag-theme-alpine": {
    headerHeight: ALPINE_GRID_SIZE * 8,
    headerCellMinWidth: 36,
    listItemHeight: ALPINE_GRID_SIZE * 4,
    rowHeight: ALPINE_GRID_SIZE * 7,
    chartMenuPanelWidth: 240
  },
  "ag-theme-quartz": {
    headerHeight: QUARTZ_FONT_SIZE + QUARTZ_GRID_SIZE * 4.25,
    headerCellMinWidth: 36,
    listItemHeight: QUARTZ_ICON_SIZE + QUARTZ_GRID_SIZE,
    rowHeight: QUARTZ_FONT_SIZE + QUARTZ_GRID_SIZE * 3.5,
    chartMenuPanelWidth: 260
  }
};
var SASS_PROPERTY_BUILDER = {
  headerHeight: ["ag-header-row"],
  headerCellMinWidth: ["ag-header-cell"],
  listItemHeight: ["ag-virtual-list-item"],
  rowHeight: ["ag-row"],
  chartMenuPanelWidth: ["ag-chart-docked-container"]
};

var _Environment =
/*#__PURE__*/
function (_BeanStub89) {
  "use strict";

  _inherits(_Environment, _BeanStub89);

  function _Environment() {
    var _this597;

    _classCallCheck(this, _Environment);

    _this597 = _possibleConstructorReturn(this, _getPrototypeOf(_Environment).apply(this, arguments));
    _this597.calculatedSizes = {};
    _this597.calculatedTheme = null;
    return _this597;
  }

  _createClass(_Environment, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this598 = this;

      var _a;

      var el = (_a = this.getTheme().el) != null ? _a : this.eGridDiv;
      this.addManagedPropertyListener("rowHeight", function () {
        return _this598.refreshRowHeightVariable();
      });
      this.mutationObserver = new MutationObserver(function () {
        _this598.calculatedSizes = {};
        _this598.calculatedTheme = null;
        _this598.calculatedTheme = _this598.getTheme();

        _this598.fireGridStylesChangedEvent();
      });
      this.mutationObserver.observe(el || this.eGridDiv, {
        attributes: true,
        attributeFilter: ["class"]
      });
    }
  }, {
    key: "fireGridStylesChangedEvent",
    value: function fireGridStylesChangedEvent() {
      var event = {
        type: _Events.EVENT_GRID_STYLES_CHANGED
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "getSassVariable",
    value: function getSassVariable(key) {
      var _this$getTheme = this.getTheme(),
          themeFamily = _this$getTheme.themeFamily,
          el = _this$getTheme.el;

      if (!themeFamily || themeFamily.indexOf("ag-theme") !== 0) {
        return;
      }

      if (!this.calculatedSizes) {
        this.calculatedSizes = {};
      }

      if (!this.calculatedSizes[themeFamily]) {
        this.calculatedSizes[themeFamily] = {};
      }

      var size = this.calculatedSizes[themeFamily][key];

      if (size != null) {
        return size;
      }

      this.calculatedSizes[themeFamily][key] = this.calculateValueForSassProperty(key, themeFamily, el);
      return this.calculatedSizes[themeFamily][key];
    }
  }, {
    key: "calculateValueForSassProperty",
    value: function calculateValueForSassProperty(property, theme, themeElement) {
      var _div$classList;

      var useTheme = "ag-theme-" + (theme.match("material") ? "material" : theme.match("balham") ? "balham" : theme.match("alpine") ? "alpine" : "custom");
      var defaultValue = HARD_CODED_SIZES[useTheme][property];
      var eDocument = this.gos.getDocument();

      if (!themeElement) {
        themeElement = this.eGridDiv;
      }

      if (!SASS_PROPERTY_BUILDER[property]) {
        return defaultValue;
      }

      var classList = SASS_PROPERTY_BUILDER[property];
      var div = eDocument.createElement("div");
      var classesFromThemeElement = Array.from(themeElement.classList);

      (_div$classList = div.classList).add.apply(_div$classList, [theme].concat(_toConsumableArray(classesFromThemeElement)));

      div.style.position = "absolute";
      var el = classList.reduce(function (prevEl, currentClass) {
        var currentDiv = eDocument.createElement("div");
        currentDiv.style.position = "static";
        currentDiv.classList.add(currentClass);
        prevEl.appendChild(currentDiv);
        return currentDiv;
      }, div);
      var calculatedValue = 0;

      if (eDocument.body) {
        eDocument.body.appendChild(div);
        var sizeName = property.toLowerCase().indexOf("height") !== -1 ? "height" : "width";
        calculatedValue = parseInt(window.getComputedStyle(el)[sizeName], 10);
        eDocument.body.removeChild(div);
      }

      return calculatedValue || defaultValue;
    }
  }, {
    key: "isThemeDark",
    value: function isThemeDark() {
      var _this$getTheme2 = this.getTheme(),
          theme = _this$getTheme2.theme;

      return !!theme && theme.indexOf("dark") >= 0;
    }
  }, {
    key: "chartMenuPanelWidth",
    value: function chartMenuPanelWidth() {
      return this.getSassVariable("chartMenuPanelWidth");
    }
  }, {
    key: "getTheme",
    value: function getTheme() {
      if (this.calculatedTheme) {
        return this.calculatedTheme;
      }

      var reg = /\bag-(material|(?:theme-([\w\-]*)))\b/g;
      var el = this.eGridDiv;
      var themeMatch = null;
      var allThemes = [];

      while (el) {
        themeMatch = reg.exec(el.className);

        if (!themeMatch) {
          el = el.parentElement || void 0;
        } else {
          var matched = el.className.match(reg);

          if (matched) {
            allThemes = matched;
          }

          break;
        }
      }

      if (!themeMatch) {
        return {
          allThemes: allThemes
        };
      }

      var theme = themeMatch[0];
      this.calculatedTheme = {
        theme: theme,
        el: el,
        themeFamily: theme.replace(/-dark$/, ""),
        allThemes: allThemes
      };
      return this.calculatedTheme;
    }
  }, {
    key: "getFromTheme",
    value: function getFromTheme(defaultValue, sassVariableName) {
      var _a;

      return (_a = this.getSassVariable(sassVariableName)) != null ? _a : defaultValue;
    }
  }, {
    key: "getDefaultRowHeight",
    value: function getDefaultRowHeight() {
      return this.getFromTheme(DEFAULT_ROW_HEIGHT, "rowHeight");
    }
  }, {
    key: "getListItemHeight",
    value: function getListItemHeight() {
      return this.getFromTheme(20, "listItemHeight");
    }
  }, {
    key: "refreshRowHeightVariable",
    value: function refreshRowHeightVariable() {
      var oldRowHeight = this.eGridDiv.style.getPropertyValue("--ag-line-height").trim();
      var height = this.gos.get("rowHeight");

      if (height == null || isNaN(height) || !isFinite(height)) {
        if (oldRowHeight !== null) {
          this.eGridDiv.style.setProperty("--ag-line-height", null);
        }

        return -1;
      }

      var newRowHeight = "".concat(height, "px");

      if (oldRowHeight != newRowHeight) {
        this.eGridDiv.style.setProperty("--ag-line-height", newRowHeight);
        return height;
      }

      return oldRowHeight != "" ? parseFloat(oldRowHeight) : -1;
    }
  }, {
    key: "getMinColWidth",
    value: function getMinColWidth() {
      var measuredMin = this.getFromTheme(null, "headerCellMinWidth");
      return _exists(measuredMin) ? Math.max(measuredMin, MIN_COL_WIDTH) : MIN_COL_WIDTH;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.calculatedSizes = null;

      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }

      _get(_getPrototypeOf(_Environment.prototype), "destroy", this).call(this);
    }
  }]);

  return _Environment;
}(_BeanStub2);

__decorateClass([_Autowired("eGridDiv")], _Environment.prototype, "eGridDiv", 2);

__decorateClass([_PostConstruct], _Environment.prototype, "postConstruct", 1);

_Environment = __decorateClass([_Bean("environment")], _Environment); // community-modules/core/src/rendering/rowContainerHeightService.ts

var RowContainerHeightService =
/*#__PURE__*/
function (_BeanStub90) {
  "use strict";

  _inherits(RowContainerHeightService, _BeanStub90);

  function RowContainerHeightService() {
    var _this599;

    _classCallCheck(this, RowContainerHeightService);

    _this599 = _possibleConstructorReturn(this, _getPrototypeOf(RowContainerHeightService).apply(this, arguments)); // the scrollY position

    _this599.scrollY = 0; // how tall the body is

    _this599.uiBodyHeight = 0;
    return _this599;
  }

  _createClass(RowContainerHeightService, [{
    key: "agWire",
    value: function agWire(loggerFactory) {
      this.logger = loggerFactory.create("RowContainerHeightService");
    }
  }, {
    key: "postConstruct",
    value: function postConstruct() {
      this.addManagedListener(this.eventService, _Events.EVENT_BODY_HEIGHT_CHANGED, this.updateOffset.bind(this));
      this.maxDivHeight = _getMaxDivHeight();
      this.logger.log("maxDivHeight = " + this.maxDivHeight);
    }
  }, {
    key: "isStretching",
    value: function isStretching() {
      return this.stretching;
    }
  }, {
    key: "getDivStretchOffset",
    value: function getDivStretchOffset() {
      return this.divStretchOffset;
    }
  }, {
    key: "updateOffset",
    value: function updateOffset() {
      if (!this.stretching) {
        return;
      }

      var gridBodyCon = this.ctrlsService.getGridBodyCtrl();
      var newScrollY = gridBodyCon.getScrollFeature().getVScrollPosition().top;
      var newBodyHeight = this.getUiBodyHeight();
      var atLeastOneChanged = newScrollY !== this.scrollY || newBodyHeight !== this.uiBodyHeight;

      if (atLeastOneChanged) {
        this.scrollY = newScrollY;
        this.uiBodyHeight = newBodyHeight;
        this.calculateOffset();
      }
    }
  }, {
    key: "calculateOffset",
    value: function calculateOffset() {
      this.setUiContainerHeight(this.maxDivHeight);
      this.pixelsToShave = this.modelHeight - this.uiContainerHeight;
      this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
      var scrollPercent = this.scrollY / this.maxScrollY;
      var divStretchOffset = scrollPercent * this.pixelsToShave;
      this.logger.log("Div Stretch Offset = ".concat(divStretchOffset, " (").concat(this.pixelsToShave, " * ").concat(scrollPercent, ")"));
      this.setDivStretchOffset(divStretchOffset);
    }
  }, {
    key: "setUiContainerHeight",
    value: function setUiContainerHeight(height) {
      if (height !== this.uiContainerHeight) {
        this.uiContainerHeight = height;
        this.eventService.dispatchEvent({
          type: _Events.EVENT_ROW_CONTAINER_HEIGHT_CHANGED
        });
      }
    }
  }, {
    key: "clearOffset",
    value: function clearOffset() {
      this.setUiContainerHeight(this.modelHeight);
      this.pixelsToShave = 0;
      this.setDivStretchOffset(0);
    }
  }, {
    key: "setDivStretchOffset",
    value: function setDivStretchOffset(newOffset) {
      var newOffsetFloor = typeof newOffset === "number" ? Math.floor(newOffset) : null;

      if (this.divStretchOffset === newOffsetFloor) {
        return;
      }

      this.divStretchOffset = newOffsetFloor;
      this.eventService.dispatchEvent({
        type: _Events.EVENT_HEIGHT_SCALE_CHANGED
      });
    }
  }, {
    key: "setModelHeight",
    value: function setModelHeight(modelHeight) {
      this.modelHeight = modelHeight;
      this.stretching = modelHeight != null && this.maxDivHeight > 0 && modelHeight > this.maxDivHeight;

      if (this.stretching) {
        this.calculateOffset();
      } else {
        this.clearOffset();
      }
    }
  }, {
    key: "getUiContainerHeight",
    value: function getUiContainerHeight() {
      return this.uiContainerHeight;
    }
  }, {
    key: "getRealPixelPosition",
    value: function getRealPixelPosition(modelPixel) {
      return modelPixel - this.divStretchOffset;
    }
  }, {
    key: "getUiBodyHeight",
    value: function getUiBodyHeight() {
      var gridBodyCon = this.ctrlsService.getGridBodyCtrl();
      var pos = gridBodyCon.getScrollFeature().getVScrollPosition();
      return pos.bottom - pos.top;
    }
  }, {
    key: "getScrollPositionForPixel",
    value: function getScrollPositionForPixel(rowTop) {
      if (this.pixelsToShave <= 0) {
        return rowTop;
      }

      var modelMaxScroll = this.modelHeight - this.getUiBodyHeight();
      var scrollPercent = rowTop / modelMaxScroll;
      var scrollPixel = this.maxScrollY * scrollPercent;
      return scrollPixel;
    }
  }]);

  return RowContainerHeightService;
}(_BeanStub2);

__decorateClass([_Autowired("ctrlsService")], RowContainerHeightService.prototype, "ctrlsService", 2);

__decorateClass([__decorateParam(0, _Qualifier("loggerFactory"))], RowContainerHeightService.prototype, "agWire", 1);

__decorateClass([_PostConstruct], RowContainerHeightService.prototype, "postConstruct", 1);

RowContainerHeightService = __decorateClass([_Bean("rowContainerHeightService")], RowContainerHeightService); // community-modules/core/src/rowNodes/selectableService.ts

var _SelectableService =
/*#__PURE__*/
function (_BeanStub91) {
  "use strict";

  _inherits(_SelectableService, _BeanStub91);

  function _SelectableService() {
    _classCallCheck(this, _SelectableService);

    return _possibleConstructorReturn(this, _getPrototypeOf(_SelectableService).apply(this, arguments));
  }

  _createClass(_SelectableService, [{
    key: "init",
    value: function init() {
      var _this600 = this;

      this.addManagedPropertyListener("isRowSelectable", function () {
        return _this600.updateSelectable();
      });
    }
    /**
     * Used by CSRM only, to update selectable state after group state changes.
     */

  }, {
    key: "updateSelectableAfterGrouping",
    value: function updateSelectableAfterGrouping() {
      this.updateSelectable(true);
    }
  }, {
    key: "updateSelectable",
    value: function updateSelectable() {
      var skipLeafNodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var isRowSelecting = !!this.gos.get("rowSelection");
      var isRowSelectable = this.gos.get("isRowSelectable");

      if (!isRowSelecting || !isRowSelectable) {
        return;
      }

      var isGroupSelectsChildren = this.gos.get("groupSelectsChildren");
      var isCsrmGroupSelectsChildren = this.rowModel.getType() === "clientSide" && isGroupSelectsChildren;
      var nodesToDeselect = [];

      var nodeCallback = function nodeCallback(node) {
        if (skipLeafNodes && !node.group) {
          return;
        }

        if (isCsrmGroupSelectsChildren && node.group) {
          var hasSelectableChild = node.childrenAfterGroup.some(function (rowNode) {
            return rowNode.selectable === true;
          });
          node.setRowSelectable(hasSelectableChild, true);
          return;
        }

        var rowSelectable = isRowSelectable ? isRowSelectable(node) : true;
        node.setRowSelectable(rowSelectable, true);

        if (!rowSelectable && node.isSelected()) {
          nodesToDeselect.push(node);
        }
      };

      if (isCsrmGroupSelectsChildren) {
        var csrm = this.rowModel;
        var changedPath = new _ChangedPath(false, csrm.getRootNode());
        changedPath.forEachChangedNodeDepthFirst(nodeCallback, true, true);
      } else {
        this.rowModel.forEachNode(nodeCallback);
      }

      if (nodesToDeselect.length) {
        this.selectionService.setNodesSelected({
          nodes: nodesToDeselect,
          newValue: false,
          source: "selectableChanged"
        });
      }

      if (isCsrmGroupSelectsChildren && this.selectionService instanceof SelectionService) {
        this.selectionService.updateGroupsFromChildrenSelections("selectableChanged");
      }
    }
  }]);

  return _SelectableService;
}(_BeanStub2);

__decorateClass([_Autowired("rowModel")], _SelectableService.prototype, "rowModel", 2);

__decorateClass([_Autowired("selectionService")], _SelectableService.prototype, "selectionService", 2);

__decorateClass([_PostConstruct], _SelectableService.prototype, "init", 1);

_SelectableService = __decorateClass([_Bean("selectableService")], _SelectableService); // community-modules/core/src/pagination/paginationComp.ts

var PaginationComp =
/*#__PURE__*/
function (_Component43) {
  "use strict";

  _inherits(PaginationComp, _Component43);

  function PaginationComp() {
    var _this601;

    _classCallCheck(this, PaginationComp);

    _this601 = _possibleConstructorReturn(this, _getPrototypeOf(PaginationComp).call(this));
    _this601.previousAndFirstButtonsDisabled = false;
    _this601.nextButtonDisabled = false;
    _this601.lastButtonDisabled = false;
    _this601.areListenersSetup = false;
    return _this601;
  }

  _createClass(PaginationComp, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this602 = this;

      var isRtl = this.gos.get("enableRtl");
      this.setTemplate(this.getTemplate());
      var btFirst = this.btFirst,
          btPrevious = this.btPrevious,
          btNext = this.btNext,
          btLast = this.btLast,
          pageSizeComp = this.pageSizeComp;
      this.activateTabIndex([btFirst, btPrevious, btNext, btLast]);
      btFirst.insertAdjacentElement("afterbegin", _createIconNoSpan(isRtl ? "last" : "first", this.gos));
      btPrevious.insertAdjacentElement("afterbegin", _createIconNoSpan(isRtl ? "next" : "previous", this.gos));
      btNext.insertAdjacentElement("afterbegin", _createIconNoSpan(isRtl ? "previous" : "next", this.gos));
      btLast.insertAdjacentElement("afterbegin", _createIconNoSpan(isRtl ? "first" : "last", this.gos));
      this.addManagedPropertyListener("pagination", this.onPaginationChanged.bind(this));
      this.addManagedPropertyListener("suppressPaginationPanel", this.onPaginationChanged.bind(this));
      this.addManagedPropertyListeners(["paginationPageSizeSelector", "paginationAutoPageSize", "suppressPaginationPanel"], function () {
        return _this602.onPageSizeRelatedOptionsChange();
      });
      this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
      this.onPaginationChanged();
    }
  }, {
    key: "onPaginationChanged",
    value: function onPaginationChanged() {
      var isPaging = this.gos.get("pagination");
      var paginationPanelEnabled = isPaging && !this.gos.get("suppressPaginationPanel");
      this.setDisplayed(paginationPanelEnabled);

      if (!paginationPanelEnabled) {
        return;
      }

      this.setupListeners();
      this.enableOrDisableButtons();
      this.updateRowLabels();
      this.setCurrentPageLabel();
      this.setTotalLabels();
      this.onPageSizeRelatedOptionsChange();
    }
  }, {
    key: "onPageSizeRelatedOptionsChange",
    value: function onPageSizeRelatedOptionsChange() {
      this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
    }
  }, {
    key: "setupListeners",
    value: function setupListeners() {
      var _this603 = this;

      if (!this.areListenersSetup) {
        this.addManagedListener(this.eventService, _Events.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this));
        [{
          el: this.btFirst,
          fn: this.onBtFirst.bind(this)
        }, {
          el: this.btPrevious,
          fn: this.onBtPrevious.bind(this)
        }, {
          el: this.btNext,
          fn: this.onBtNext.bind(this)
        }, {
          el: this.btLast,
          fn: this.onBtLast.bind(this)
        }].forEach(function (item) {
          var el = item.el,
              fn = item.fn;

          _this603.addManagedListener(el, "click", fn);

          _this603.addManagedListener(el, "keydown", function (e) {
            if (e.key === _KeyCode.ENTER || e.key === _KeyCode.SPACE) {
              e.preventDefault();
              fn();
            }
          });
        });
        this.areListenersSetup = true;
      }
    }
  }, {
    key: "onBtFirst",
    value: function onBtFirst() {
      if (!this.previousAndFirstButtonsDisabled) {
        this.paginationProxy.goToFirstPage();
      }
    }
  }, {
    key: "setCurrentPageLabel",
    value: function setCurrentPageLabel() {
      var pagesExist = this.paginationProxy.getTotalPages() > 0;
      var currentPage = this.paginationProxy.getCurrentPage();
      var toDisplay = pagesExist ? currentPage + 1 : 0;
      this.lbCurrent.textContent = this.formatNumber(toDisplay);
    }
  }, {
    key: "formatNumber",
    value: function formatNumber(value) {
      var userFunc = this.gos.getCallback("paginationNumberFormatter");

      if (userFunc) {
        var params = {
          value: value
        };
        return userFunc(params);
      }

      var localeTextFunc = this.localeService.getLocaleTextFunc();
      var thousandSeparator = localeTextFunc("thousandSeparator", ",");
      var decimalSeparator = localeTextFunc("decimalSeparator", ".");
      return _formatNumberCommas(value, thousandSeparator, decimalSeparator);
    }
  }, {
    key: "getTemplate",
    value: function getTemplate() {
      var localeTextFunc = this.localeService.getLocaleTextFunc();
      var strPage = localeTextFunc("page", "Page");
      var strTo = localeTextFunc("to", "to");
      var strOf = localeTextFunc("of", "of");
      var strFirst = localeTextFunc("firstPage", "First Page");
      var strPrevious = localeTextFunc("previousPage", "Previous Page");
      var strNext = localeTextFunc("nextPage", "Next Page");
      var strLast = localeTextFunc("lastPage", "Last Page");
      var compId = this.getCompId();
      return (
        /* html */
        "<div class=\"ag-paging-panel ag-unselectable\" id=\"ag-".concat(compId, "\">\n                <ag-page-size-selector ref=\"pageSizeComp\"></ag-page-size-selector>\n                <span class=\"ag-paging-row-summary-panel\" role=\"status\">\n                    <span id=\"ag-").concat(compId, "-first-row\" ref=\"lbFirstRowOnPage\" class=\"ag-paging-row-summary-panel-number\"></span>\n                    <span id=\"ag-").concat(compId, "-to\">").concat(strTo, "</span>\n                    <span id=\"ag-").concat(compId, "-last-row\" ref=\"lbLastRowOnPage\" class=\"ag-paging-row-summary-panel-number\"></span>\n                    <span id=\"ag-").concat(compId, "-of\">").concat(strOf, "</span>\n                    <span id=\"ag-").concat(compId, "-row-count\" ref=\"lbRecordCount\" class=\"ag-paging-row-summary-panel-number\"></span>\n                </span>\n                <span class=\"ag-paging-page-summary-panel\" role=\"presentation\">\n                    <div ref=\"btFirst\" class=\"ag-button ag-paging-button\" role=\"button\" aria-label=\"").concat(strFirst, "\"></div>\n                    <div ref=\"btPrevious\" class=\"ag-button ag-paging-button\" role=\"button\" aria-label=\"").concat(strPrevious, "\"></div>\n                    <span class=\"ag-paging-description\" role=\"status\">\n                        <span id=\"ag-").concat(compId, "-start-page\">").concat(strPage, "</span>\n                        <span id=\"ag-").concat(compId, "-start-page-number\" ref=\"lbCurrent\" class=\"ag-paging-number\"></span>\n                        <span id=\"ag-").concat(compId, "-of-page\">").concat(strOf, "</span>\n                        <span id=\"ag-").concat(compId, "-of-page-number\" ref=\"lbTotal\" class=\"ag-paging-number\"></span>\n                    </span>\n                    <div ref=\"btNext\" class=\"ag-button ag-paging-button\" role=\"button\" aria-label=\"").concat(strNext, "\"></div>\n                    <div ref=\"btLast\" class=\"ag-button ag-paging-button\" role=\"button\" aria-label=\"").concat(strLast, "\"></div>\n                </span>\n            </div>")
      );
    }
  }, {
    key: "onBtNext",
    value: function onBtNext() {
      if (!this.nextButtonDisabled) {
        this.paginationProxy.goToNextPage();
      }
    }
  }, {
    key: "onBtPrevious",
    value: function onBtPrevious() {
      if (!this.previousAndFirstButtonsDisabled) {
        this.paginationProxy.goToPreviousPage();
      }
    }
  }, {
    key: "onBtLast",
    value: function onBtLast() {
      if (!this.lastButtonDisabled) {
        this.paginationProxy.goToLastPage();
      }
    }
  }, {
    key: "enableOrDisableButtons",
    value: function enableOrDisableButtons() {
      var currentPage = this.paginationProxy.getCurrentPage();
      var maxRowFound = this.paginationProxy.isLastPageFound();
      var totalPages = this.paginationProxy.getTotalPages();
      this.previousAndFirstButtonsDisabled = currentPage === 0;
      this.toggleButtonDisabled(this.btFirst, this.previousAndFirstButtonsDisabled);
      this.toggleButtonDisabled(this.btPrevious, this.previousAndFirstButtonsDisabled);
      var zeroPagesToDisplay = this.isZeroPagesToDisplay();
      var onLastPage = currentPage === totalPages - 1;
      this.nextButtonDisabled = onLastPage || zeroPagesToDisplay;
      this.lastButtonDisabled = !maxRowFound || zeroPagesToDisplay || currentPage === totalPages - 1;
      this.toggleButtonDisabled(this.btNext, this.nextButtonDisabled);
      this.toggleButtonDisabled(this.btLast, this.lastButtonDisabled);
    }
  }, {
    key: "toggleButtonDisabled",
    value: function toggleButtonDisabled(button, disabled) {
      _setAriaDisabled(button, disabled);

      button.classList.toggle("ag-disabled", disabled);
    }
  }, {
    key: "updateRowLabels",
    value: function updateRowLabels() {
      var currentPage = this.paginationProxy.getCurrentPage();
      var pageSize = this.paginationProxy.getPageSize();
      var maxRowFound = this.paginationProxy.isLastPageFound();
      var rowCount = this.paginationProxy.isLastPageFound() ? this.paginationProxy.getMasterRowCount() : null;
      var startRow;
      var endRow;

      if (this.isZeroPagesToDisplay()) {
        startRow = endRow = 0;
      } else {
        startRow = pageSize * currentPage + 1;
        endRow = startRow + pageSize - 1;

        if (maxRowFound && endRow > rowCount) {
          endRow = rowCount;
        }
      }

      this.lbFirstRowOnPage.textContent = this.formatNumber(startRow);

      if (this.rowNodeBlockLoader.isLoading()) {
        var translate = this.localeService.getLocaleTextFunc();
        this.lbLastRowOnPage.innerHTML = translate("pageLastRowUnknown", "?");
      } else {
        this.lbLastRowOnPage.textContent = this.formatNumber(endRow);
      }
    }
  }, {
    key: "isZeroPagesToDisplay",
    value: function isZeroPagesToDisplay() {
      var maxRowFound = this.paginationProxy.isLastPageFound();
      var totalPages = this.paginationProxy.getTotalPages();
      return maxRowFound && totalPages === 0;
    }
  }, {
    key: "setTotalLabels",
    value: function setTotalLabels() {
      var lastPageFound = this.paginationProxy.isLastPageFound();
      var totalPages = this.paginationProxy.getTotalPages();
      var rowCount = lastPageFound ? this.paginationProxy.getMasterRowCount() : null;

      if (rowCount === 1) {
        var firstRow = this.paginationProxy.getRow(0);
        var hiddenGroupRow = firstRow && firstRow.group && !(firstRow.groupData || firstRow.aggData);

        if (hiddenGroupRow) {
          this.setTotalLabelsToZero();
          return;
        }
      }

      if (lastPageFound) {
        this.lbTotal.textContent = this.formatNumber(totalPages);
        this.lbRecordCount.textContent = this.formatNumber(rowCount);
      } else {
        var moreText = this.localeService.getLocaleTextFunc()("more", "more");
        this.lbTotal.innerHTML = moreText;
        this.lbRecordCount.innerHTML = moreText;
      }
    }
  }, {
    key: "setTotalLabelsToZero",
    value: function setTotalLabelsToZero() {
      this.lbFirstRowOnPage.textContent = this.formatNumber(0);
      this.lbCurrent.textContent = this.formatNumber(0);
      this.lbLastRowOnPage.textContent = this.formatNumber(0);
      this.lbTotal.textContent = this.formatNumber(0);
      this.lbRecordCount.textContent = this.formatNumber(0);
    }
  }]);

  return PaginationComp;
}(_Component2);

__decorateClass([_Autowired("paginationProxy")], PaginationComp.prototype, "paginationProxy", 2);

__decorateClass([_Autowired("rowNodeBlockLoader")], PaginationComp.prototype, "rowNodeBlockLoader", 2);

__decorateClass([_RefSelector("btFirst")], PaginationComp.prototype, "btFirst", 2);

__decorateClass([_RefSelector("btPrevious")], PaginationComp.prototype, "btPrevious", 2);

__decorateClass([_RefSelector("btNext")], PaginationComp.prototype, "btNext", 2);

__decorateClass([_RefSelector("btLast")], PaginationComp.prototype, "btLast", 2);

__decorateClass([_RefSelector("lbRecordCount")], PaginationComp.prototype, "lbRecordCount", 2);

__decorateClass([_RefSelector("lbFirstRowOnPage")], PaginationComp.prototype, "lbFirstRowOnPage", 2);

__decorateClass([_RefSelector("lbLastRowOnPage")], PaginationComp.prototype, "lbLastRowOnPage", 2);

__decorateClass([_RefSelector("lbCurrent")], PaginationComp.prototype, "lbCurrent", 2);

__decorateClass([_RefSelector("lbTotal")], PaginationComp.prototype, "lbTotal", 2);

__decorateClass([_RefSelector("pageSizeComp")], PaginationComp.prototype, "pageSizeComp", 2);

__decorateClass([_PostConstruct], PaginationComp.prototype, "postConstruct", 1); // community-modules/core/src/rendering/overlays/overlayWrapperComponent.ts


var _OverlayWrapperComponent =
/*#__PURE__*/
function (_Component44) {
  "use strict";

  _inherits(_OverlayWrapperComponent, _Component44);

  function _OverlayWrapperComponent() {
    var _this604;

    _classCallCheck(this, _OverlayWrapperComponent);

    _this604 = _possibleConstructorReturn(this, _getPrototypeOf(_OverlayWrapperComponent).call(this, _OverlayWrapperComponent.TEMPLATE));
    _this604.inProgress = false;
    _this604.destroyRequested = false;
    return _this604;
  }

  _createClass(_OverlayWrapperComponent, [{
    key: "updateLayoutClasses",
    value: function updateLayoutClasses(cssClass, params) {
      var overlayWrapperClassList = this.eOverlayWrapper.classList;
      overlayWrapperClassList.toggle("ag-layout-auto-height"
      /* AUTO_HEIGHT */
      , params.autoHeight);
      overlayWrapperClassList.toggle("ag-layout-normal"
      /* NORMAL */
      , params.normal);
      overlayWrapperClassList.toggle("ag-layout-print"
      /* PRINT */
      , params.print);
    }
  }, {
    key: "postConstruct",
    value: function postConstruct() {
      this.createManagedBean(new LayoutFeature(this));
      this.setDisplayed(false, {
        skipAriaHidden: true
      });
      this.overlayService.registerOverlayWrapperComp(this);
    }
  }, {
    key: "setWrapperTypeClass",
    value: function setWrapperTypeClass(overlayWrapperCssClass) {
      var overlayWrapperClassList = this.eOverlayWrapper.classList;

      if (this.activeOverlayWrapperCssClass) {
        overlayWrapperClassList.toggle(this.activeOverlayWrapperCssClass, false);
      }

      this.activeOverlayWrapperCssClass = overlayWrapperCssClass;
      overlayWrapperClassList.toggle(overlayWrapperCssClass, true);
    }
  }, {
    key: "showOverlay",
    value: function showOverlay(overlayComp, overlayWrapperCssClass, updateListenerDestroyFunc) {
      var _this605 = this;

      if (this.inProgress) {
        return;
      }

      this.setWrapperTypeClass(overlayWrapperCssClass);
      this.destroyActiveOverlay();
      this.inProgress = true;

      if (overlayComp) {
        overlayComp.then(function (comp) {
          _this605.inProgress = false;

          _this605.eOverlayWrapper.appendChild(comp.getGui());

          _this605.activeOverlay = comp;
          _this605.updateListenerDestroyFunc = updateListenerDestroyFunc;

          if (_this605.destroyRequested) {
            _this605.destroyRequested = false;

            _this605.destroyActiveOverlay();
          }
        });
      }

      this.setDisplayed(true, {
        skipAriaHidden: true
      });
    }
  }, {
    key: "destroyActiveOverlay",
    value: function destroyActiveOverlay() {
      var _a;

      if (this.inProgress) {
        this.destroyRequested = true;
        return;
      }

      if (!this.activeOverlay) {
        return;
      }

      this.activeOverlay = this.getContext().destroyBean(this.activeOverlay);
      (_a = this.updateListenerDestroyFunc) == null ? void 0 : _a.call(this);

      _clearElement(this.eOverlayWrapper);
    }
  }, {
    key: "hideOverlay",
    value: function hideOverlay() {
      this.destroyActiveOverlay();
      this.setDisplayed(false, {
        skipAriaHidden: true
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.destroyActiveOverlay();

      _get(_getPrototypeOf(_OverlayWrapperComponent.prototype), "destroy", this).call(this);
    }
  }]);

  return _OverlayWrapperComponent;
}(_Component2); // wrapping in outer div, and wrapper, is needed to center the loading icon


_OverlayWrapperComponent.TEMPLATE =
/* html */
"\n        <div class=\"ag-overlay\" role=\"presentation\">\n            <div class=\"ag-overlay-panel\" role=\"presentation\">\n                <div class=\"ag-overlay-wrapper\" ref=\"eOverlayWrapper\" role=\"presentation\"></div>\n            </div>\n        </div>";

__decorateClass([_Autowired("overlayService")], _OverlayWrapperComponent.prototype, "overlayService", 2);

__decorateClass([_RefSelector("eOverlayWrapper")], _OverlayWrapperComponent.prototype, "eOverlayWrapper", 2);

__decorateClass([_PostConstruct], _OverlayWrapperComponent.prototype, "postConstruct", 1);

var OverlayWrapperComponent = _OverlayWrapperComponent; // community-modules/core/src/entities/rowPositionUtils.ts

var _RowPositionUtils =
/*#__PURE__*/
function (_BeanStub92) {
  "use strict";

  _inherits(_RowPositionUtils, _BeanStub92);

  function _RowPositionUtils() {
    _classCallCheck(this, _RowPositionUtils);

    return _possibleConstructorReturn(this, _getPrototypeOf(_RowPositionUtils).apply(this, arguments));
  }

  _createClass(_RowPositionUtils, [{
    key: "getFirstRow",
    value: function getFirstRow() {
      var rowIndex = 0;
      var rowPinned;

      if (this.pinnedRowModel.getPinnedTopRowCount()) {
        rowPinned = "top";
      } else if (this.rowModel.getRowCount()) {
        rowPinned = null;
        rowIndex = this.paginationProxy.getPageFirstRow();
      } else if (this.pinnedRowModel.getPinnedBottomRowCount()) {
        rowPinned = "bottom";
      }

      return rowPinned === void 0 ? null : {
        rowIndex: rowIndex,
        rowPinned: rowPinned
      };
    }
  }, {
    key: "getLastRow",
    value: function getLastRow() {
      var rowIndex;
      var rowPinned = null;
      var pinnedBottomCount = this.pinnedRowModel.getPinnedBottomRowCount();
      var pinnedTopCount = this.pinnedRowModel.getPinnedTopRowCount();

      if (pinnedBottomCount) {
        rowPinned = "bottom";
        rowIndex = pinnedBottomCount - 1;
      } else if (this.rowModel.getRowCount()) {
        rowPinned = null;
        rowIndex = this.paginationProxy.getPageLastRow();
      } else if (pinnedTopCount) {
        rowPinned = "top";
        rowIndex = pinnedTopCount - 1;
      }

      return rowIndex === void 0 ? null : {
        rowIndex: rowIndex,
        rowPinned: rowPinned
      };
    }
  }, {
    key: "getRowNode",
    value: function getRowNode(gridRow) {
      switch (gridRow.rowPinned) {
        case "top":
          return this.pinnedRowModel.getPinnedTopRowData()[gridRow.rowIndex];

        case "bottom":
          return this.pinnedRowModel.getPinnedBottomRowData()[gridRow.rowIndex];

        default:
          return this.rowModel.getRow(gridRow.rowIndex);
      }
    }
  }, {
    key: "sameRow",
    value: function sameRow(rowA, rowB) {
      if (!rowA && !rowB) {
        return true;
      }

      if (rowA && !rowB || !rowA && rowB) {
        return false;
      }

      return rowA.rowIndex === rowB.rowIndex && rowA.rowPinned == rowB.rowPinned;
    } // tests if this row selection is before the other row selection

  }, {
    key: "before",
    value: function before(rowA, rowB) {
      switch (rowA.rowPinned) {
        case "top":
          if (rowB.rowPinned !== "top") {
            return true;
          }

          break;

        case "bottom":
          if (rowB.rowPinned !== "bottom") {
            return false;
          }

          break;

        default:
          if (_exists(rowB.rowPinned)) {
            return rowB.rowPinned !== "top";
          }

          break;
      }

      return rowA.rowIndex < rowB.rowIndex;
    }
  }]);

  return _RowPositionUtils;
}(_BeanStub2);

__decorateClass([_Autowired("rowModel")], _RowPositionUtils.prototype, "rowModel", 2);

__decorateClass([_Autowired("pinnedRowModel")], _RowPositionUtils.prototype, "pinnedRowModel", 2);

__decorateClass([_Autowired("paginationProxy")], _RowPositionUtils.prototype, "paginationProxy", 2);

_RowPositionUtils = __decorateClass([_Bean("rowPositionUtils")], _RowPositionUtils); // community-modules/core/src/entities/cellPositionUtils.ts

var _CellPositionUtils =
/*#__PURE__*/
function (_BeanStub93) {
  "use strict";

  _inherits(_CellPositionUtils, _BeanStub93);

  function _CellPositionUtils() {
    _classCallCheck(this, _CellPositionUtils);

    return _possibleConstructorReturn(this, _getPrototypeOf(_CellPositionUtils).apply(this, arguments));
  }

  _createClass(_CellPositionUtils, [{
    key: "createId",
    value: function createId(cellPosition) {
      var rowIndex = cellPosition.rowIndex,
          rowPinned = cellPosition.rowPinned,
          column = cellPosition.column;
      return this.createIdFromValues({
        rowIndex: rowIndex,
        column: column,
        rowPinned: rowPinned
      });
    }
  }, {
    key: "createIdFromValues",
    value: function createIdFromValues(cellPosition) {
      var rowIndex = cellPosition.rowIndex,
          rowPinned = cellPosition.rowPinned,
          column = cellPosition.column;
      return "".concat(rowIndex, ".").concat(rowPinned == null ? "null" : rowPinned, ".").concat(column.getId());
    }
  }, {
    key: "equals",
    value: function equals(cellA, cellB) {
      var colsMatch = cellA.column === cellB.column;
      var floatingMatch = cellA.rowPinned === cellB.rowPinned;
      var indexMatch = cellA.rowIndex === cellB.rowIndex;
      return colsMatch && floatingMatch && indexMatch;
    }
  }]);

  return _CellPositionUtils;
}(_BeanStub2);

_CellPositionUtils = __decorateClass([_Bean("cellPositionUtils")], _CellPositionUtils); // community-modules/core/src/undoRedo/undoRedoStack.ts

var UndoRedoAction = function UndoRedoAction(cellValueChanges) {
  "use strict";

  _classCallCheck(this, UndoRedoAction);

  this.cellValueChanges = cellValueChanges;
};

var RangeUndoRedoAction =
/*#__PURE__*/
function (_UndoRedoAction) {
  "use strict";

  _inherits(RangeUndoRedoAction, _UndoRedoAction);

  function RangeUndoRedoAction(cellValueChanges, initialRange, finalRange, ranges) {
    var _this606;

    _classCallCheck(this, RangeUndoRedoAction);

    _this606 = _possibleConstructorReturn(this, _getPrototypeOf(RangeUndoRedoAction).call(this, cellValueChanges));
    _this606.initialRange = initialRange;
    _this606.finalRange = finalRange;
    _this606.ranges = ranges;
    return _this606;
  }

  return RangeUndoRedoAction;
}(UndoRedoAction);

var _UndoRedoStack =
/*#__PURE__*/
function () {
  "use strict";

  function _UndoRedoStack(maxStackSize) {
    _classCallCheck(this, _UndoRedoStack);

    this.actionStack = [];
    this.maxStackSize = maxStackSize ? maxStackSize : _UndoRedoStack.DEFAULT_STACK_SIZE;
    this.actionStack = new Array(this.maxStackSize);
  }

  _createClass(_UndoRedoStack, [{
    key: "pop",
    value: function pop() {
      return this.actionStack.pop();
    }
  }, {
    key: "push",
    value: function push(item) {
      var shouldAddActions = item.cellValueChanges && item.cellValueChanges.length > 0;

      if (!shouldAddActions) {
        return;
      }

      if (this.actionStack.length === this.maxStackSize) {
        this.actionStack.shift();
      }

      this.actionStack.push(item);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.actionStack = [];
    }
  }, {
    key: "getCurrentStackSize",
    value: function getCurrentStackSize() {
      return this.actionStack.length;
    }
  }]);

  return _UndoRedoStack;
}();

_UndoRedoStack.DEFAULT_STACK_SIZE = 10;
var UndoRedoStack = _UndoRedoStack; // community-modules/core/src/undoRedo/undoRedoService.ts

var UndoRedoService =
/*#__PURE__*/
function (_BeanStub94) {
  "use strict";

  _inherits(UndoRedoService, _BeanStub94);

  function UndoRedoService() {
    var _this607;

    _classCallCheck(this, UndoRedoService);

    _this607 = _possibleConstructorReturn(this, _getPrototypeOf(UndoRedoService).apply(this, arguments));
    _this607.cellValueChanges = [];
    _this607.activeCellEdit = null;
    _this607.activeRowEdit = null;
    _this607.isPasting = false;
    _this607.isRangeInAction = false;

    _this607.onCellValueChanged = function (event) {
      var eventCell = {
        column: event.column,
        rowIndex: event.rowIndex,
        rowPinned: event.rowPinned
      };

      var isCellEditing = _this607.activeCellEdit !== null && _this607.cellPositionUtils.equals(_this607.activeCellEdit, eventCell);

      var isRowEditing = _this607.activeRowEdit !== null && _this607.rowPositionUtils.sameRow(_this607.activeRowEdit, eventCell);

      var shouldCaptureAction = isCellEditing || isRowEditing || _this607.isPasting || _this607.isRangeInAction;

      if (!shouldCaptureAction) {
        return;
      }

      var rowPinned = event.rowPinned,
          rowIndex = event.rowIndex,
          column = event.column,
          oldValue = event.oldValue,
          value = event.value;
      var cellValueChange = {
        rowPinned: rowPinned,
        rowIndex: rowIndex,
        columnId: column.getColId(),
        newValue: value,
        oldValue: oldValue
      };

      _this607.cellValueChanges.push(cellValueChange);
    };

    _this607.clearStacks = function () {
      _this607.undoStack.clear();

      _this607.redoStack.clear();
    };

    return _this607;
  }

  _createClass(UndoRedoService, [{
    key: "init",
    value: function init() {
      var _this608 = this;

      if (!this.gos.get("undoRedoCellEditing")) {
        return;
      }

      var undoRedoLimit = this.gos.get("undoRedoCellEditingLimit");

      if (undoRedoLimit <= 0) {
        return;
      }

      this.undoStack = new UndoRedoStack(undoRedoLimit);
      this.redoStack = new UndoRedoStack(undoRedoLimit);
      this.addRowEditingListeners();
      this.addCellEditingListeners();
      this.addPasteListeners();
      this.addFillListeners();
      this.addCellKeyListeners();
      this.addManagedListener(this.eventService, _Events.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged);
      this.addManagedListener(this.eventService, _Events.EVENT_MODEL_UPDATED, function (e) {
        if (!e.keepUndoRedoStack) {
          _this608.clearStacks();
        }
      });
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.clearStacks);
      this.addManagedListener(this.eventService, _Events.EVENT_NEW_COLUMNS_LOADED, this.clearStacks);
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_GROUP_OPENED, this.clearStacks);
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.clearStacks);
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_MOVED, this.clearStacks);
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_PINNED, this.clearStacks);
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_VISIBLE, this.clearStacks);
      this.addManagedListener(this.eventService, _Events.EVENT_ROW_DRAG_END, this.clearStacks);
      this.ctrlsService.whenReady(function (p) {
        _this608.gridBodyCtrl = p.gridBodyCtrl;
      });
    }
  }, {
    key: "getCurrentUndoStackSize",
    value: function getCurrentUndoStackSize() {
      return this.undoStack ? this.undoStack.getCurrentStackSize() : 0;
    }
  }, {
    key: "getCurrentRedoStackSize",
    value: function getCurrentRedoStackSize() {
      return this.redoStack ? this.redoStack.getCurrentStackSize() : 0;
    }
  }, {
    key: "undo",
    value: function undo(source) {
      var startEvent = {
        type: _Events.EVENT_UNDO_STARTED,
        source: source
      };
      this.eventService.dispatchEvent(startEvent);
      var operationPerformed = this.undoRedo(this.undoStack, this.redoStack, "initialRange", "oldValue", "undo");
      var endEvent = {
        type: _Events.EVENT_UNDO_ENDED,
        source: source,
        operationPerformed: operationPerformed
      };
      this.eventService.dispatchEvent(endEvent);
    }
  }, {
    key: "redo",
    value: function redo(source) {
      var startEvent = {
        type: _Events.EVENT_REDO_STARTED,
        source: source
      };
      this.eventService.dispatchEvent(startEvent);
      var operationPerformed = this.undoRedo(this.redoStack, this.undoStack, "finalRange", "newValue", "redo");
      var endEvent = {
        type: _Events.EVENT_REDO_ENDED,
        source: source,
        operationPerformed: operationPerformed
      };
      this.eventService.dispatchEvent(endEvent);
    }
  }, {
    key: "undoRedo",
    value: function undoRedo(undoRedoStack, opposingUndoRedoStack, rangeProperty, cellValueChangeProperty, source) {
      if (!undoRedoStack) {
        return false;
      }

      var undoRedoAction = undoRedoStack.pop();

      if (!undoRedoAction || !undoRedoAction.cellValueChanges) {
        return false;
      }

      this.processAction(undoRedoAction, function (cellValueChange) {
        return cellValueChange[cellValueChangeProperty];
      }, source);

      if (undoRedoAction instanceof RangeUndoRedoAction) {
        this.processRange(this.rangeService, undoRedoAction.ranges || [undoRedoAction[rangeProperty]]);
      } else {
        this.processCell(undoRedoAction.cellValueChanges);
      }

      opposingUndoRedoStack.push(undoRedoAction);
      return true;
    }
  }, {
    key: "processAction",
    value: function processAction(action, valueExtractor, source) {
      var _this609 = this;

      action.cellValueChanges.forEach(function (cellValueChange) {
        var rowIndex = cellValueChange.rowIndex,
            rowPinned = cellValueChange.rowPinned,
            columnId = cellValueChange.columnId;
        var rowPosition = {
          rowIndex: rowIndex,
          rowPinned: rowPinned
        };

        var currentRow = _this609.rowPositionUtils.getRowNode(rowPosition);

        if (!currentRow.displayed) {
          return;
        }

        currentRow.setDataValue(columnId, valueExtractor(cellValueChange), source);
      });
    }
  }, {
    key: "processRange",
    value: function processRange(rangeService, ranges) {
      var _this610 = this;

      var lastFocusedCell;
      rangeService.removeAllCellRanges(true);
      ranges.forEach(function (range, idx) {
        if (!range) {
          return;
        }

        var startRow = range.startRow;
        var endRow = range.endRow;

        if (idx === ranges.length - 1) {
          lastFocusedCell = {
            rowPinned: startRow.rowPinned,
            rowIndex: startRow.rowIndex,
            columnId: range.startColumn.getColId()
          };

          _this610.setLastFocusedCell(lastFocusedCell);
        }

        var cellRangeParams = {
          rowStartIndex: startRow.rowIndex,
          rowStartPinned: startRow.rowPinned,
          rowEndIndex: endRow.rowIndex,
          rowEndPinned: endRow.rowPinned,
          columnStart: range.startColumn,
          columns: range.columns
        };
        rangeService.addCellRange(cellRangeParams);
      });
    }
  }, {
    key: "processCell",
    value: function processCell(cellValueChanges) {
      var cellValueChange = cellValueChanges[0];
      var rowIndex = cellValueChange.rowIndex,
          rowPinned = cellValueChange.rowPinned;
      var rowPosition = {
        rowIndex: rowIndex,
        rowPinned: rowPinned
      };
      var row = this.rowPositionUtils.getRowNode(rowPosition);
      var lastFocusedCell = {
        rowPinned: cellValueChange.rowPinned,
        rowIndex: row.rowIndex,
        columnId: cellValueChange.columnId
      };
      this.setLastFocusedCell(lastFocusedCell, this.rangeService);
    }
  }, {
    key: "setLastFocusedCell",
    value: function setLastFocusedCell(lastFocusedCell, rangeService) {
      var rowIndex = lastFocusedCell.rowIndex,
          columnId = lastFocusedCell.columnId,
          rowPinned = lastFocusedCell.rowPinned;
      var scrollFeature = this.gridBodyCtrl.getScrollFeature();
      var column = this.columnModel.getGridColumn(columnId);

      if (!column) {
        return;
      }

      scrollFeature.ensureIndexVisible(rowIndex);
      scrollFeature.ensureColumnVisible(column);
      var cellPosition = {
        rowIndex: rowIndex,
        column: column,
        rowPinned: rowPinned
      };
      this.focusService.setFocusedCell(__spreadProps(__spreadValues({}, cellPosition), {
        forceBrowserFocus: true
      }));
      rangeService == null ? void 0 : rangeService.setRangeToCell(cellPosition);
    }
  }, {
    key: "addRowEditingListeners",
    value: function addRowEditingListeners() {
      var _this611 = this;

      this.addManagedListener(this.eventService, _Events.EVENT_ROW_EDITING_STARTED, function (e) {
        _this611.activeRowEdit = {
          rowIndex: e.rowIndex,
          rowPinned: e.rowPinned
        };
      });
      this.addManagedListener(this.eventService, _Events.EVENT_ROW_EDITING_STOPPED, function () {
        var action = new UndoRedoAction(_this611.cellValueChanges);

        _this611.pushActionsToUndoStack(action);

        _this611.activeRowEdit = null;
      });
    }
  }, {
    key: "addCellEditingListeners",
    value: function addCellEditingListeners() {
      var _this612 = this;

      this.addManagedListener(this.eventService, _Events.EVENT_CELL_EDITING_STARTED, function (e) {
        _this612.activeCellEdit = {
          column: e.column,
          rowIndex: e.rowIndex,
          rowPinned: e.rowPinned
        };
      });
      this.addManagedListener(this.eventService, _Events.EVENT_CELL_EDITING_STOPPED, function (e) {
        _this612.activeCellEdit = null;
        var shouldPushAction = e.valueChanged && !_this612.activeRowEdit && !_this612.isPasting && !_this612.isRangeInAction;

        if (shouldPushAction) {
          var action = new UndoRedoAction(_this612.cellValueChanges);

          _this612.pushActionsToUndoStack(action);
        }
      });
    }
  }, {
    key: "addPasteListeners",
    value: function addPasteListeners() {
      var _this613 = this;

      this.addManagedListener(this.eventService, _Events.EVENT_PASTE_START, function () {
        _this613.isPasting = true;
      });
      this.addManagedListener(this.eventService, _Events.EVENT_PASTE_END, function () {
        var action = new UndoRedoAction(_this613.cellValueChanges);

        _this613.pushActionsToUndoStack(action);

        _this613.isPasting = false;
      });
    }
  }, {
    key: "addFillListeners",
    value: function addFillListeners() {
      var _this614 = this;

      this.addManagedListener(this.eventService, _Events.EVENT_FILL_START, function () {
        _this614.isRangeInAction = true;
      });
      this.addManagedListener(this.eventService, _Events.EVENT_FILL_END, function (event) {
        var action = new RangeUndoRedoAction(_this614.cellValueChanges, event.initialRange, event.finalRange);

        _this614.pushActionsToUndoStack(action);

        _this614.isRangeInAction = false;
      });
    }
  }, {
    key: "addCellKeyListeners",
    value: function addCellKeyListeners() {
      var _this615 = this;

      this.addManagedListener(this.eventService, _Events.EVENT_KEY_SHORTCUT_CHANGED_CELL_START, function () {
        _this615.isRangeInAction = true;
      });
      this.addManagedListener(this.eventService, _Events.EVENT_KEY_SHORTCUT_CHANGED_CELL_END, function () {
        var action;

        if (_this615.rangeService && _this615.gos.get("enableRangeSelection")) {
          action = new RangeUndoRedoAction(_this615.cellValueChanges, void 0, void 0, _toConsumableArray(_this615.rangeService.getCellRanges()));
        } else {
          action = new UndoRedoAction(_this615.cellValueChanges);
        }

        _this615.pushActionsToUndoStack(action);

        _this615.isRangeInAction = false;
      });
    }
  }, {
    key: "pushActionsToUndoStack",
    value: function pushActionsToUndoStack(action) {
      this.undoStack.push(action);
      this.cellValueChanges = [];
      this.redoStack.clear();
    }
  }]);

  return UndoRedoService;
}(_BeanStub2);

__decorateClass([_Autowired("focusService")], UndoRedoService.prototype, "focusService", 2);

__decorateClass([_Autowired("ctrlsService")], UndoRedoService.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("cellPositionUtils")], UndoRedoService.prototype, "cellPositionUtils", 2);

__decorateClass([_Autowired("rowPositionUtils")], UndoRedoService.prototype, "rowPositionUtils", 2);

__decorateClass([_Autowired("columnModel")], UndoRedoService.prototype, "columnModel", 2);

__decorateClass([_Optional("rangeService")], UndoRedoService.prototype, "rangeService", 2);

__decorateClass([_PostConstruct], UndoRedoService.prototype, "init", 1);

UndoRedoService = __decorateClass([_Bean("undoRedoService")], UndoRedoService); // community-modules/core/src/headerRendering/common/headerPosition.ts

var _HeaderPositionUtils =
/*#__PURE__*/
function (_BeanStub95) {
  "use strict";

  _inherits(_HeaderPositionUtils, _BeanStub95);

  function _HeaderPositionUtils() {
    _classCallCheck(this, _HeaderPositionUtils);

    return _possibleConstructorReturn(this, _getPrototypeOf(_HeaderPositionUtils).apply(this, arguments));
  }

  _createClass(_HeaderPositionUtils, [{
    key: "findHeader",
    value: function findHeader(focusedHeader, direction) {
      var nextColumn;
      var getColMethod;

      if (focusedHeader.column instanceof _ColumnGroup2) {
        nextColumn = this.columnModel.getDisplayedGroupAtDirection(focusedHeader.column, direction);
      } else {
        getColMethod = "getDisplayedCol".concat(direction);
        nextColumn = this.columnModel[getColMethod](focusedHeader.column);
      }

      if (!nextColumn) {
        return;
      }

      var headerRowIndex = focusedHeader.headerRowIndex;

      if (this.getHeaderRowType(headerRowIndex) !== "filter"
      /* FLOATING_FILTER */
      ) {
          var columnsInPath = [nextColumn];

          while (nextColumn.getParent()) {
            nextColumn = nextColumn.getParent();
            columnsInPath.push(nextColumn);
          }

          nextColumn = columnsInPath[columnsInPath.length - 1 - headerRowIndex];
        }

      var _this$getHeaderIndexT = this.getHeaderIndexToFocus(nextColumn, headerRowIndex),
          column = _this$getHeaderIndexT.column,
          indexToFocus = _this$getHeaderIndexT.headerRowIndex;

      return {
        column: column,
        headerRowIndex: indexToFocus
      };
    }
  }, {
    key: "getHeaderIndexToFocus",
    value: function getHeaderIndexToFocus(column, currentIndex) {
      var nextColumn;

      if (column instanceof _ColumnGroup2 && this.isAnyChildSpanningHeaderHeight(column) && column.isPadding()) {
        var targetColumn = column;
        nextColumn = targetColumn.getLeafColumns()[0];
        var col = nextColumn;

        while (col !== targetColumn) {
          currentIndex++;
          col = col.getParent();
        }
      }

      return {
        column: nextColumn || column,
        headerRowIndex: currentIndex
      };
    }
  }, {
    key: "isAnyChildSpanningHeaderHeight",
    value: function isAnyChildSpanningHeaderHeight(columnGroup) {
      if (!columnGroup) {
        return false;
      }

      return columnGroup.getLeafColumns().some(function (col) {
        return col.isSpanHeaderHeight();
      });
    }
  }, {
    key: "getColumnVisibleParent",
    value: function getColumnVisibleParent(currentColumn, currentIndex) {
      var currentRowType = this.getHeaderRowType(currentIndex);
      var isFloatingFilter = currentRowType === "filter"
      /* FLOATING_FILTER */
      ;
      var isColumn = currentRowType === "column"
      /* COLUMN */
      ;
      var nextFocusColumn = isFloatingFilter ? currentColumn : currentColumn.getParent();
      var nextRow = currentIndex - 1;
      var headerRowIndexWithoutSpan = nextRow;

      if (isColumn && this.isAnyChildSpanningHeaderHeight(currentColumn.getParent())) {
        while (nextFocusColumn && nextFocusColumn.isPadding()) {
          nextFocusColumn = nextFocusColumn.getParent();
          nextRow--;
        }

        headerRowIndexWithoutSpan = nextRow;

        if (nextRow < 0) {
          nextFocusColumn = currentColumn;
          nextRow = currentIndex;
          headerRowIndexWithoutSpan = void 0;
        }
      }

      return {
        column: nextFocusColumn,
        headerRowIndex: nextRow,
        headerRowIndexWithoutSpan: headerRowIndexWithoutSpan
      };
    }
  }, {
    key: "getColumnVisibleChild",
    value: function getColumnVisibleChild(column, currentIndex) {
      var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "After";
      var currentRowType = this.getHeaderRowType(currentIndex);
      var nextFocusColumn = column;
      var nextRow = currentIndex + 1;
      var headerRowIndexWithoutSpan = nextRow;

      if (currentRowType === "group"
      /* COLUMN_GROUP */
      ) {
          var leafColumns = column.getDisplayedLeafColumns();
          var leafColumn = direction === "After" ? leafColumns[0] : _last(leafColumns);
          var columnsInTheWay = [];
          var currentColumn = leafColumn;

          while (currentColumn.getParent() !== column) {
            currentColumn = currentColumn.getParent();
            columnsInTheWay.push(currentColumn);
          }

          nextFocusColumn = leafColumn;

          if (leafColumn.isSpanHeaderHeight()) {
            for (var i = columnsInTheWay.length - 1; i >= 0; i--) {
              var colToFocus = columnsInTheWay[i];

              if (!colToFocus.isPadding()) {
                nextFocusColumn = colToFocus;
                break;
              }

              nextRow++;
            }
          } else {
            nextFocusColumn = _last(columnsInTheWay);

            if (!nextFocusColumn) {
              nextFocusColumn = leafColumn;
            }
          }
        }

      return {
        column: nextFocusColumn,
        headerRowIndex: nextRow,
        headerRowIndexWithoutSpan: headerRowIndexWithoutSpan
      };
    }
  }, {
    key: "getHeaderRowType",
    value: function getHeaderRowType(rowIndex) {
      var centerHeaderContainer = this.ctrlsService.getHeaderRowContainerCtrl();

      if (centerHeaderContainer) {
        return centerHeaderContainer.getRowType(rowIndex);
      }
    }
  }, {
    key: "findColAtEdgeForHeaderRow",
    value: function findColAtEdgeForHeaderRow(level, position) {
      var displayedColumns = this.columnModel.getAllDisplayedColumns();
      var column = displayedColumns[position === "start" ? 0 : displayedColumns.length - 1];

      if (!column) {
        return;
      }

      var childContainer = this.ctrlsService.getHeaderRowContainerCtrl(column.getPinned());
      var type = childContainer.getRowType(level);

      if (type == "group"
      /* COLUMN_GROUP */
      ) {
          var columnGroup = this.columnModel.getColumnGroupAtLevel(column, level);
          return {
            headerRowIndex: level,
            column: columnGroup
          };
        }

      return {
        // if type==null, means the header level didn't exist
        headerRowIndex: type == null ? -1 : level,
        column: column
      };
    }
  }]);

  return _HeaderPositionUtils;
}(_BeanStub2);

__decorateClass([_Autowired("columnModel")], _HeaderPositionUtils.prototype, "columnModel", 2);

__decorateClass([_Autowired("ctrlsService")], _HeaderPositionUtils.prototype, "ctrlsService", 2);

_HeaderPositionUtils = __decorateClass([_Bean("headerPositionUtils")], _HeaderPositionUtils); // community-modules/core/src/columns/columnDefFactory.ts

var ColumnDefFactory =
/*#__PURE__*/
function () {
  "use strict";

  function ColumnDefFactory() {
    _classCallCheck(this, ColumnDefFactory);
  }

  _createClass(ColumnDefFactory, [{
    key: "buildColumnDefs",
    value: function buildColumnDefs(cols, rowGroupColumns, pivotColumns) {
      var _this616 = this;

      var res = [];
      var colGroupDefs = {};
      cols.forEach(function (col) {
        var colDef = _this616.createDefFromColumn(col, rowGroupColumns, pivotColumns);

        var addToResult = true;
        var childDef = colDef;
        var pointer = col.getOriginalParent();
        var lastPointer = null;

        while (pointer) {
          var parentDef = null;

          if (pointer.isPadding()) {
            pointer = pointer.getOriginalParent();
            continue;
          }

          var existingParentDef = colGroupDefs[pointer.getGroupId()];

          if (existingParentDef) {
            existingParentDef.children.push(childDef);
            addToResult = false;
            break;
          }

          parentDef = _this616.createDefFromGroup(pointer);

          if (parentDef) {
            parentDef.children = [childDef];
            colGroupDefs[parentDef.groupId] = parentDef;
            childDef = parentDef;
            pointer = pointer.getOriginalParent();
          }

          if (pointer != null && lastPointer === pointer) {
            addToResult = false;
            break;
          }

          lastPointer = pointer;
        }

        if (addToResult) {
          res.push(childDef);
        }
      });
      return res;
    }
  }, {
    key: "createDefFromGroup",
    value: function createDefFromGroup(group) {
      var defCloned = _deepCloneDefinition(group.getColGroupDef(), ["children"]);

      if (defCloned) {
        defCloned.groupId = group.getGroupId();
      }

      return defCloned;
    }
  }, {
    key: "createDefFromColumn",
    value: function createDefFromColumn(col, rowGroupColumns, pivotColumns) {
      var colDefCloned = _deepCloneDefinition(col.getColDef());

      colDefCloned.colId = col.getColId();
      colDefCloned.width = col.getActualWidth();
      colDefCloned.rowGroup = col.isRowGroupActive();
      colDefCloned.rowGroupIndex = col.isRowGroupActive() ? rowGroupColumns.indexOf(col) : null;
      colDefCloned.pivot = col.isPivotActive();
      colDefCloned.pivotIndex = col.isPivotActive() ? pivotColumns.indexOf(col) : null;
      colDefCloned.aggFunc = col.isValueActive() ? col.getAggFunc() : null;
      colDefCloned.hide = col.isVisible() ? void 0 : true;
      colDefCloned.pinned = col.isPinned() ? col.getPinned() : null;
      colDefCloned.sort = col.getSort() ? col.getSort() : null;
      colDefCloned.sortIndex = col.getSortIndex() != null ? col.getSortIndex() : null;
      return colDefCloned;
    }
  }]);

  return ColumnDefFactory;
}();

ColumnDefFactory = __decorateClass([_Bean("columnDefFactory")], ColumnDefFactory); // community-modules/core/src/rendering/row/rowCssClassCalculator.ts

var RowCssClassCalculator =
/*#__PURE__*/
function () {
  "use strict";

  function RowCssClassCalculator() {
    _classCallCheck(this, RowCssClassCalculator);
  }

  _createClass(RowCssClassCalculator, [{
    key: "getInitialRowClasses",
    value: function getInitialRowClasses(params) {
      var classes = [];

      if (_exists(params.extraCssClass)) {
        classes.push(params.extraCssClass);
      }

      classes.push("ag-row");
      classes.push(params.rowFocused ? "ag-row-focus" : "ag-row-no-focus");

      if (params.fadeRowIn) {
        classes.push("ag-opacity-zero");
      }

      classes.push(params.rowIsEven ? "ag-row-even" : "ag-row-odd");

      if (params.rowNode.isRowPinned()) {
        classes.push("ag-row-pinned");
      }

      if (params.rowNode.isSelected()) {
        classes.push("ag-row-selected");
      }

      if (params.rowNode.footer) {
        classes.push("ag-row-footer");
      }

      classes.push("ag-row-level-" + params.rowLevel);

      if (params.rowNode.stub) {
        classes.push("ag-row-loading");
      }

      if (params.fullWidthRow) {
        classes.push("ag-full-width-row");
      }

      if (params.expandable) {
        classes.push("ag-row-group");
        classes.push(params.rowNode.expanded ? "ag-row-group-expanded" : "ag-row-group-contracted");
      }

      if (params.rowNode.dragging) {
        classes.push("ag-row-dragging");
      }

      _pushAll(classes, this.processClassesFromGridOptions(params.rowNode));

      _pushAll(classes, this.preProcessRowClassRules(params.rowNode));

      classes.push(params.printLayout ? "ag-row-position-relative" : "ag-row-position-absolute");

      if (params.firstRowOnPage) {
        classes.push("ag-row-first");
      }

      if (params.lastRowOnPage) {
        classes.push("ag-row-last");
      }

      if (params.fullWidthRow) {
        if (params.pinned === "left") {
          classes.push("ag-cell-last-left-pinned");
        }

        if (params.pinned === "right") {
          classes.push("ag-cell-first-right-pinned");
        }
      }

      return classes;
    }
  }, {
    key: "processClassesFromGridOptions",
    value: function processClassesFromGridOptions(rowNode) {
      var res = [];

      var process = function process(rowCls) {
        if (typeof rowCls === "string") {
          res.push(rowCls);
        } else if (Array.isArray(rowCls)) {
          rowCls.forEach(function (e) {
            return res.push(e);
          });
        }
      };

      var rowClass = this.gos.get("rowClass");

      if (rowClass) {
        if (typeof rowClass === "function") {
          console.warn("AG Grid: rowClass should not be a function, please use getRowClass instead");
          return [];
        }

        process(rowClass);
      }

      var rowClassFunc = this.gos.getCallback("getRowClass");

      if (rowClassFunc) {
        var params = {
          data: rowNode.data,
          node: rowNode,
          rowIndex: rowNode.rowIndex
        };
        var rowClassFuncResult = rowClassFunc(params);
        process(rowClassFuncResult);
      }

      return res;
    }
  }, {
    key: "preProcessRowClassRules",
    value: function preProcessRowClassRules(rowNode) {
      var res = [];
      this.processRowClassRules(rowNode, function (className) {
        res.push(className);
      }, function (className) {});
      return res;
    }
  }, {
    key: "processRowClassRules",
    value: function processRowClassRules(rowNode, onApplicableClass, onNotApplicableClass) {
      var rowClassParams = this.gos.addGridCommonParams({
        data: rowNode.data,
        node: rowNode,
        rowIndex: rowNode.rowIndex
      });
      this.stylingService.processClassRules(void 0, this.gos.get("rowClassRules"), rowClassParams, onApplicableClass, onNotApplicableClass);
    }
  }, {
    key: "calculateRowLevel",
    value: function calculateRowLevel(rowNode) {
      if (rowNode.group) {
        return rowNode.level;
      }

      return rowNode.parent ? rowNode.parent.level + 1 : 0;
    }
  }]);

  return RowCssClassCalculator;
}();

__decorateClass([_Autowired("stylingService")], RowCssClassCalculator.prototype, "stylingService", 2);

__decorateClass([_Autowired("gridOptionsService")], RowCssClassCalculator.prototype, "gos", 2);

RowCssClassCalculator = __decorateClass([_Bean("rowCssClassCalculator")], RowCssClassCalculator); // community-modules/core/src/rowNodes/rowNodeSorter.ts

var _RowNodeSorter =
/*#__PURE__*/
function (_BeanStub96) {
  "use strict";

  _inherits(_RowNodeSorter, _BeanStub96);

  function _RowNodeSorter() {
    _classCallCheck(this, _RowNodeSorter);

    return _possibleConstructorReturn(this, _getPrototypeOf(_RowNodeSorter).apply(this, arguments));
  }

  _createClass(_RowNodeSorter, [{
    key: "init",
    value: function init() {
      var _this617 = this;

      this.isAccentedSort = this.gos.get("accentedSort");
      this.primaryColumnsSortGroups = this.gos.isColumnsSortingCoupledToGroup();
      this.addManagedPropertyListener("accentedSort", function (propChange) {
        return _this617.isAccentedSort = propChange.currentValue;
      });
      this.addManagedPropertyListener("autoGroupColumnDef", function () {
        return _this617.primaryColumnsSortGroups = _this617.gos.isColumnsSortingCoupledToGroup();
      });
    }
  }, {
    key: "doFullSort",
    value: function doFullSort(rowNodes, sortOptions) {
      var mapper = function mapper(rowNode, pos) {
        return {
          currentPos: pos,
          rowNode: rowNode
        };
      };

      var sortedRowNodes = rowNodes.map(mapper);
      sortedRowNodes.sort(this.compareRowNodes.bind(this, sortOptions));
      return sortedRowNodes.map(function (item) {
        return item.rowNode;
      });
    }
  }, {
    key: "compareRowNodes",
    value: function compareRowNodes(sortOptions, sortedNodeA, sortedNodeB) {
      var nodeA = sortedNodeA.rowNode;
      var nodeB = sortedNodeB.rowNode;

      for (var i = 0, len = sortOptions.length; i < len; i++) {
        var sortOption = sortOptions[i];
        var isDescending = sortOption.sort === "desc";
        var valueA = this.getValue(nodeA, sortOption.column);
        var valueB = this.getValue(nodeB, sortOption.column);
        var comparatorResult = void 0;
        var providedComparator = this.getComparator(sortOption, nodeA);

        if (providedComparator) {
          comparatorResult = providedComparator(valueA, valueB, nodeA, nodeB, isDescending);
        } else {
          comparatorResult = _3.defaultComparator(valueA, valueB, this.isAccentedSort);
        }

        var validResult = !isNaN(comparatorResult);

        if (validResult && comparatorResult !== 0) {
          return sortOption.sort === "asc" ? comparatorResult : comparatorResult * -1;
        }
      }

      return sortedNodeA.currentPos - sortedNodeB.currentPos;
    }
  }, {
    key: "getComparator",
    value: function getComparator(sortOption, rowNode) {
      var column = sortOption.column;
      var comparatorOnCol = column.getColDef().comparator;

      if (comparatorOnCol != null) {
        return comparatorOnCol;
      }

      if (!column.getColDef().showRowGroup) {
        return;
      }

      var groupLeafField = !rowNode.group && column.getColDef().field;

      if (!groupLeafField) {
        return;
      }

      var primaryColumn = this.columnModel.getPrimaryColumn(groupLeafField);

      if (!primaryColumn) {
        return;
      }

      return primaryColumn.getColDef().comparator;
    }
  }, {
    key: "getValue",
    value: function getValue(node, column) {
      var _a, _b;

      if (!this.primaryColumnsSortGroups) {
        return this.valueService.getValue(column, node, false, false);
      }

      var isNodeGroupedAtLevel = node.rowGroupColumn === column;

      if (isNodeGroupedAtLevel) {
        var isGroupRows = this.gos.isGroupUseEntireRow(this.columnModel.isPivotActive());

        if (isGroupRows) {
          var leafChild = (_a = node.allLeafChildren) == null ? void 0 : _a[0];

          if (leafChild) {
            return this.valueService.getValue(column, leafChild, false, false);
          }

          return void 0;
        }

        var displayCol = this.columnModel.getGroupDisplayColumnForGroup(column.getId());

        if (!displayCol) {
          return void 0;
        }

        return (_b = node.groupData) == null ? void 0 : _b[displayCol.getId()];
      }

      if (node.group && column.getColDef().showRowGroup) {
        return void 0;
      }

      return this.valueService.getValue(column, node, false, false);
    }
  }]);

  return _RowNodeSorter;
}(_BeanStub2);

__decorateClass([_Autowired("valueService")], _RowNodeSorter.prototype, "valueService", 2);

__decorateClass([_Autowired("columnModel")], _RowNodeSorter.prototype, "columnModel", 2);

__decorateClass([_PostConstruct], _RowNodeSorter.prototype, "init", 1);

_RowNodeSorter = __decorateClass([_Bean("rowNodeSorter")], _RowNodeSorter); // community-modules/core/src/ctrlsService.ts

var _CtrlsService =
/*#__PURE__*/
function (_BeanStub97) {
  "use strict";

  _inherits(_CtrlsService, _BeanStub97);

  function _CtrlsService() {
    var _this618;

    _classCallCheck(this, _CtrlsService);

    _this618 = _possibleConstructorReturn(this, _getPrototypeOf(_CtrlsService).apply(this, arguments));
    _this618.params = {};
    _this618.ready = false;
    _this618.readyCallbacks = [];
    return _this618;
  }

  _createClass(_CtrlsService, [{
    key: "checkReady",
    value: function checkReady() {
      var params = this.params;
      this.ready = params.gridCtrl != null && params.gridBodyCtrl != null && params.center != null && params.left != null && params.right != null && params.bottomCenter != null && params.bottomLeft != null && params.bottomRight != null && params.topCenter != null && params.topLeft != null && params.topRight != null && params.stickyTopCenter != null && params.stickyTopLeft != null && params.stickyTopRight != null && params.stickyBottomCenter != null && params.stickyBottomLeft != null && params.stickyBottomRight != null && params.centerHeader != null && params.leftHeader != null && params.rightHeader != null && params.fakeHScrollComp != null && params.fakeVScrollComp != null && params.gridHeaderCtrl != null;

      if (this.ready) {
        this.readyCallbacks.forEach(function (c) {
          return c(params);
        });
        this.readyCallbacks.length = 0;
      }
    }
  }, {
    key: "whenReady",
    value: function whenReady(callback) {
      if (this.ready) {
        callback(this.params);
      } else {
        this.readyCallbacks.push(callback);
      }
    }
  }, {
    key: "register",
    value: function register(ctrlType, ctrl) {
      this.params[ctrlType] = ctrl;
      this.checkReady();
    }
  }, {
    key: "registerHeaderContainer",
    value: function registerHeaderContainer(ctrl, pinned) {
      switch (pinned) {
        case "left":
          this.params.leftHeader = ctrl;
          break;

        case "right":
          this.params.rightHeader = ctrl;
          break;

        default:
          this.params.centerHeader = ctrl;
          break;
      }

      this.checkReady();
    }
  }, {
    key: "get",
    value: function get(ctrlType) {
      return this.params[ctrlType];
    }
  }, {
    key: "getParams",
    value: function getParams() {
      return this.params;
    }
  }, {
    key: "getGridBodyCtrl",
    value: function getGridBodyCtrl() {
      return this.params.gridBodyCtrl;
    }
  }, {
    key: "getHeaderRowContainerCtrls",
    value: function getHeaderRowContainerCtrls() {
      return [this.params.leftHeader, this.params.rightHeader, this.params.centerHeader];
    }
  }, {
    key: "getHeaderRowContainerCtrl",
    value: function getHeaderRowContainerCtrl(pinned) {
      switch (pinned) {
        case "left":
          return this.params.leftHeader;

        case "right":
          return this.params.rightHeader;

        default:
          return this.params.centerHeader;
      }
    }
  }]);

  return _CtrlsService;
}(_BeanStub2);

_CtrlsService.NAME = "ctrlsService";
_CtrlsService = __decorateClass([_Bean(_CtrlsService.NAME)], _CtrlsService); // community-modules/core/src/ctrlsFactory.ts

var CtrlsFactory =
/*#__PURE__*/
function (_BeanStub98) {
  "use strict";

  _inherits(CtrlsFactory, _BeanStub98);

  function CtrlsFactory() {
    var _this619;

    _classCallCheck(this, CtrlsFactory);

    _this619 = _possibleConstructorReturn(this, _getPrototypeOf(CtrlsFactory).apply(this, arguments));
    _this619.registry = {};
    return _this619;
  }

  _createClass(CtrlsFactory, [{
    key: "register",
    value: function register(meta) {
      this.registry[meta.controllerName] = meta.controllerClass;
    }
  }, {
    key: "getInstance",
    value: function getInstance(name) {
      var ControllerClass = this.registry[name];

      if (ControllerClass == null) {
        return void 0;
      }

      return new ControllerClass();
    }
  }]);

  return CtrlsFactory;
}(_BeanStub2);

CtrlsFactory = __decorateClass([_Bean("ctrlsFactory")], CtrlsFactory); // community-modules/core/src/gridBodyComp/abstractFakeScrollComp.ts

var AbstractFakeScrollComp =
/*#__PURE__*/
function (_Component45) {
  "use strict";

  _inherits(AbstractFakeScrollComp, _Component45);

  function AbstractFakeScrollComp(template, direction) {
    var _this620;

    _classCallCheck(this, AbstractFakeScrollComp);

    _this620 = _possibleConstructorReturn(this, _getPrototypeOf(AbstractFakeScrollComp).call(this, template));
    _this620.direction = direction;
    _this620.hideTimeout = null;
    return _this620;
  }

  _createClass(AbstractFakeScrollComp, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.addManagedListener(this.eventService, _Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
      this.onScrollVisibilityChanged();
      this.addOrRemoveCssClass("ag-apple-scrollbar", _isMacOsUserAgent() || _isIOSUserAgent());
    }
  }, {
    key: "initialiseInvisibleScrollbar",
    value: function initialiseInvisibleScrollbar() {
      if (this.invisibleScrollbar !== void 0) {
        return;
      }

      this.invisibleScrollbar = _isInvisibleScrollbar();

      if (this.invisibleScrollbar) {
        this.hideAndShowInvisibleScrollAsNeeded();
        this.addActiveListenerToggles();
      }
    }
  }, {
    key: "addActiveListenerToggles",
    value: function addActiveListenerToggles() {
      var _this621 = this;

      var activateEvents = ["mouseenter", "mousedown", "touchstart"];
      var deactivateEvents = ["mouseleave", "touchend"];
      var eGui = this.getGui();
      activateEvents.forEach(function (eventName) {
        return _this621.addManagedListener(eGui, eventName, function () {
          return _this621.addOrRemoveCssClass("ag-scrollbar-active", true);
        });
      });
      deactivateEvents.forEach(function (eventName) {
        return _this621.addManagedListener(eGui, eventName, function () {
          return _this621.addOrRemoveCssClass("ag-scrollbar-active", false);
        });
      });
    }
  }, {
    key: "onScrollVisibilityChanged",
    value: function onScrollVisibilityChanged() {
      var _this622 = this;

      if (this.invisibleScrollbar === void 0) {
        this.initialiseInvisibleScrollbar();
      }

      this.animationFrameService.requestAnimationFrame(function () {
        return _this622.setScrollVisible();
      });
    }
  }, {
    key: "hideAndShowInvisibleScrollAsNeeded",
    value: function hideAndShowInvisibleScrollAsNeeded() {
      var _this623 = this;

      this.addManagedListener(this.eventService, _Events.EVENT_BODY_SCROLL, function (params) {
        if (params.direction === _this623.direction) {
          if (_this623.hideTimeout !== null) {
            window.clearTimeout(_this623.hideTimeout);
            _this623.hideTimeout = null;
          }

          _this623.addOrRemoveCssClass("ag-scrollbar-scrolling", true);
        }
      });
      this.addManagedListener(this.eventService, _Events.EVENT_BODY_SCROLL_END, function () {
        _this623.hideTimeout = window.setTimeout(function () {
          _this623.addOrRemoveCssClass("ag-scrollbar-scrolling", false);

          _this623.hideTimeout = null;
        }, 400);
      });
    }
  }, {
    key: "attemptSettingScrollPosition",
    value: function attemptSettingScrollPosition(value) {
      var _this624 = this;

      var viewport = this.getViewport();

      _waitUntil(function () {
        return _isVisible(viewport);
      }, function () {
        return _this624.setScrollPosition(value);
      }, 100);
    }
  }, {
    key: "getViewport",
    value: function getViewport() {
      return this.eViewport;
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      return this.eContainer;
    }
  }, {
    key: "onScrollCallback",
    value: function onScrollCallback(fn) {
      this.addManagedListener(this.getViewport(), "scroll", fn);
    }
  }]);

  return AbstractFakeScrollComp;
}(_Component2);

__decorateClass([_RefSelector("eViewport")], AbstractFakeScrollComp.prototype, "eViewport", 2);

__decorateClass([_RefSelector("eContainer")], AbstractFakeScrollComp.prototype, "eContainer", 2);

__decorateClass([_Autowired("scrollVisibleService")], AbstractFakeScrollComp.prototype, "scrollVisibleService", 2);

__decorateClass([_Autowired("ctrlsService")], AbstractFakeScrollComp.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("animationFrameService")], AbstractFakeScrollComp.prototype, "animationFrameService", 2); // community-modules/core/src/gridBodyComp/fakeHScrollComp.ts


var _FakeHScrollComp =
/*#__PURE__*/
function (_AbstractFakeScrollCo) {
  "use strict";

  _inherits(_FakeHScrollComp, _AbstractFakeScrollCo);

  function _FakeHScrollComp() {
    _classCallCheck(this, _FakeHScrollComp);

    return _possibleConstructorReturn(this, _getPrototypeOf(_FakeHScrollComp).call(this, _FakeHScrollComp.TEMPLATE, "horizontal"));
  }

  _createClass(_FakeHScrollComp, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this625 = this;

      _get(_getPrototypeOf(_FakeHScrollComp.prototype), "postConstruct", this).call(this);

      var spacerWidthsListener = this.setFakeHScrollSpacerWidths.bind(this);
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_CHANGED, spacerWidthsListener);
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, spacerWidthsListener);
      this.addManagedListener(this.eventService, _Events.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this));
      this.addManagedPropertyListener("domLayout", spacerWidthsListener);
      this.ctrlsService.register("fakeHScrollComp", this);
      this.createManagedBean(new CenterWidthFeature(function (width) {
        return _this625.eContainer.style.width = "".concat(width, "px");
      }));
      this.addManagedPropertyListeners(["suppressHorizontalScroll"], this.onScrollVisibilityChanged.bind(this));
    }
  }, {
    key: "initialiseInvisibleScrollbar",
    value: function initialiseInvisibleScrollbar() {
      if (this.invisibleScrollbar !== void 0) {
        return;
      }

      this.enableRtl = this.gos.get("enableRtl");

      _get(_getPrototypeOf(_FakeHScrollComp.prototype), "initialiseInvisibleScrollbar", this).call(this);

      if (this.invisibleScrollbar) {
        this.refreshCompBottom();
      }
    }
  }, {
    key: "onPinnedRowDataChanged",
    value: function onPinnedRowDataChanged() {
      this.refreshCompBottom();
    }
  }, {
    key: "refreshCompBottom",
    value: function refreshCompBottom() {
      if (!this.invisibleScrollbar) {
        return;
      }

      var bottomPinnedHeight = this.pinnedRowModel.getPinnedBottomTotalHeight();
      this.getGui().style.bottom = "".concat(bottomPinnedHeight, "px");
    }
  }, {
    key: "onScrollVisibilityChanged",
    value: function onScrollVisibilityChanged() {
      _get(_getPrototypeOf(_FakeHScrollComp.prototype), "onScrollVisibilityChanged", this).call(this);

      this.setFakeHScrollSpacerWidths();
    }
  }, {
    key: "setFakeHScrollSpacerWidths",
    value: function setFakeHScrollSpacerWidths() {
      var vScrollShowing = this.scrollVisibleService.isVerticalScrollShowing();
      var rightSpacing = this.columnModel.getDisplayedColumnsRightWidth();
      var scrollOnRight = !this.enableRtl && vScrollShowing;
      var scrollbarWidth = this.gos.getScrollbarWidth();

      if (scrollOnRight) {
        rightSpacing += scrollbarWidth;
      }

      _setFixedWidth(this.eRightSpacer, rightSpacing);

      this.eRightSpacer.classList.toggle("ag-scroller-corner", rightSpacing <= scrollbarWidth);
      var leftSpacing = this.columnModel.getDisplayedColumnsLeftWidth();
      var scrollOnLeft = this.enableRtl && vScrollShowing;

      if (scrollOnLeft) {
        leftSpacing += scrollbarWidth;
      }

      _setFixedWidth(this.eLeftSpacer, leftSpacing);

      this.eLeftSpacer.classList.toggle("ag-scroller-corner", leftSpacing <= scrollbarWidth);
    }
  }, {
    key: "setScrollVisible",
    value: function setScrollVisible() {
      var hScrollShowing = this.scrollVisibleService.isHorizontalScrollShowing();
      var invisibleScrollbar2 = this.invisibleScrollbar;
      var isSuppressHorizontalScroll = this.gos.get("suppressHorizontalScroll");
      var scrollbarWidth = hScrollShowing ? this.gos.getScrollbarWidth() || 0 : 0;
      var adjustedScrollbarWidth = scrollbarWidth === 0 && invisibleScrollbar2 ? 16 : scrollbarWidth;
      var scrollContainerSize = !isSuppressHorizontalScroll ? adjustedScrollbarWidth : 0;
      this.addOrRemoveCssClass("ag-scrollbar-invisible", invisibleScrollbar2);

      _setFixedHeight(this.getGui(), scrollContainerSize);

      _setFixedHeight(this.eViewport, scrollContainerSize);

      _setFixedHeight(this.eContainer, scrollContainerSize);

      this.setDisplayed(hScrollShowing, {
        skipAriaHidden: true
      });
    }
  }, {
    key: "getScrollPosition",
    value: function getScrollPosition() {
      return _getScrollLeft(this.getViewport(), this.enableRtl);
    }
  }, {
    key: "setScrollPosition",
    value: function setScrollPosition(value) {
      if (!_isVisible(this.getViewport())) {
        this.attemptSettingScrollPosition(value);
      }

      _setScrollLeft(this.getViewport(), value, this.enableRtl);
    }
  }]);

  return _FakeHScrollComp;
}(AbstractFakeScrollComp);

_FakeHScrollComp.TEMPLATE =
/* html */
"<div class=\"ag-body-horizontal-scroll\" aria-hidden=\"true\">\n            <div class=\"ag-horizontal-left-spacer\" ref=\"eLeftSpacer\"></div>\n            <div class=\"ag-body-horizontal-scroll-viewport\" ref=\"eViewport\">\n                <div class=\"ag-body-horizontal-scroll-container\" ref=\"eContainer\"></div>\n            </div>\n            <div class=\"ag-horizontal-right-spacer\" ref=\"eRightSpacer\"></div>\n        </div>";

__decorateClass([_RefSelector("eLeftSpacer")], _FakeHScrollComp.prototype, "eLeftSpacer", 2);

__decorateClass([_RefSelector("eRightSpacer")], _FakeHScrollComp.prototype, "eRightSpacer", 2);

__decorateClass([_Autowired("columnModel")], _FakeHScrollComp.prototype, "columnModel", 2);

__decorateClass([_Autowired("pinnedRowModel")], _FakeHScrollComp.prototype, "pinnedRowModel", 2);

__decorateClass([_PostConstruct], _FakeHScrollComp.prototype, "postConstruct", 1);

var FakeHScrollComp = _FakeHScrollComp; // community-modules/core/src/gridBodyComp/pinnedWidthService.ts

var PinnedWidthService =
/*#__PURE__*/
function (_BeanStub99) {
  "use strict";

  _inherits(PinnedWidthService, _BeanStub99);

  function PinnedWidthService() {
    _classCallCheck(this, PinnedWidthService);

    return _possibleConstructorReturn(this, _getPrototypeOf(PinnedWidthService).apply(this, arguments));
  }

  _createClass(PinnedWidthService, [{
    key: "postConstruct",
    value: function postConstruct() {
      var listener = this.checkContainerWidths.bind(this);
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
      this.addManagedListener(this.eventService, _Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, listener);
      this.addManagedPropertyListener("domLayout", listener);
    }
  }, {
    key: "checkContainerWidths",
    value: function checkContainerWidths() {
      var printLayout = this.gos.isDomLayout("print");
      var newLeftWidth = printLayout ? 0 : this.columnModel.getDisplayedColumnsLeftWidth();
      var newRightWidth = printLayout ? 0 : this.columnModel.getDisplayedColumnsRightWidth();

      if (newLeftWidth != this.leftWidth) {
        this.leftWidth = newLeftWidth;
        this.eventService.dispatchEvent({
          type: _Events.EVENT_LEFT_PINNED_WIDTH_CHANGED
        });
      }

      if (newRightWidth != this.rightWidth) {
        this.rightWidth = newRightWidth;
        this.eventService.dispatchEvent({
          type: _Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED
        });
      }
    }
  }, {
    key: "getPinnedRightWidth",
    value: function getPinnedRightWidth() {
      return this.rightWidth;
    }
  }, {
    key: "getPinnedLeftWidth",
    value: function getPinnedLeftWidth() {
      return this.leftWidth;
    }
  }]);

  return PinnedWidthService;
}(_BeanStub2);

__decorateClass([_Autowired("columnModel")], PinnedWidthService.prototype, "columnModel", 2);

__decorateClass([_PostConstruct], PinnedWidthService.prototype, "postConstruct", 1);

PinnedWidthService = __decorateClass([_Bean("pinnedWidthService")], PinnedWidthService); // community-modules/core/src/entities/rowNodeEventThrottle.ts

var RowNodeEventThrottle =
/*#__PURE__*/
function (_BeanStub100) {
  "use strict";

  _inherits(RowNodeEventThrottle, _BeanStub100);

  function RowNodeEventThrottle() {
    var _this626;

    _classCallCheck(this, RowNodeEventThrottle);

    _this626 = _possibleConstructorReturn(this, _getPrototypeOf(RowNodeEventThrottle).apply(this, arguments));
    _this626.events = [];
    return _this626;
  }

  _createClass(RowNodeEventThrottle, [{
    key: "postConstruct",
    value: function postConstruct() {
      if (this.rowModel.getType() == "clientSide") {
        this.clientSideRowModel = this.rowModel;
      }
    } // because the user can call rowNode.setExpanded() many times in one VM turn,
    // we throttle the calls to ClientSideRowModel using animationFrameService. this means for 100
    // row nodes getting expanded, we only update the CSRM once, and then we fire all events after
    // CSRM has updated.
    //
    // if we did not do this, then the user could call setExpanded on 100+ rows, causing the grid
    // to re-render 100+ times, which would be a performance lag.
    //
    // we use animationFrameService
    // rather than _.debounce() so this will get done if anyone flushes the animationFrameService
    // (eg user calls api.ensureRowVisible(), which in turn flushes ).

  }, {
    key: "dispatchExpanded",
    value: function dispatchExpanded(event, forceSync) {
      var _this627 = this;

      if (this.clientSideRowModel == null) {
        this.eventService.dispatchEvent(event);
        return;
      }

      this.events.push(event);

      var func = function func() {
        if (_this627.clientSideRowModel) {
          _this627.clientSideRowModel.onRowGroupOpened();
        }

        _this627.events.forEach(function (e) {
          return _this627.eventService.dispatchEvent(e);
        });

        _this627.events = [];
      };

      if (forceSync) {
        func();
      } else {
        if (this.dispatchExpandedDebounced == null) {
          this.dispatchExpandedDebounced = this.animationFrameService.debounce(func);
        }

        this.dispatchExpandedDebounced();
      }
    }
  }]);

  return RowNodeEventThrottle;
}(_BeanStub2);

__decorateClass([_Autowired("animationFrameService")], RowNodeEventThrottle.prototype, "animationFrameService", 2);

__decorateClass([_Autowired("rowModel")], RowNodeEventThrottle.prototype, "rowModel", 2);

__decorateClass([_PostConstruct], RowNodeEventThrottle.prototype, "postConstruct", 1);

RowNodeEventThrottle = __decorateClass([_Bean("rowNodeEventThrottle")], RowNodeEventThrottle); // community-modules/core/src/validation/rules/colDefValidations.ts

var COLUMN_DEFINITION_DEPRECATIONS = {
  columnsMenuParams: {
    version: "31.1",
    message: "Use `columnChooserParams` instead."
  },
  suppressMenu: {
    version: "31.1",
    message: "Use `suppressHeaderMenuButton` instead."
  },
  suppressCellFlash: {
    version: "31.2",
    message: "Use `enableCellChangeFlash={false}` in the ColDef"
  },
  dndSource: {
    version: "31.2",
    message: "This feature has been replaced by `Row Dragging to an External DropZone`."
  },
  dndSourceOnRowDrag: {
    version: "31.2",
    message: "This feature has been replaced by `Row Dragging to an External DropZone`."
  }
};

var CSRM_REQUIRES_ROW_GROUP_MODULE = function CSRM_REQUIRES_ROW_GROUP_MODULE(_options, gridOptions) {
  var _a;

  if (((_a = gridOptions.rowModelType) != null ? _a : "clientSide") === "clientSide") {
    return {
      module: "@ag-grid-enterprise/row-grouping"
      /* RowGroupingModule */

    };
  }

  return null;
};

var COLUMN_DEFINITION_VALIDATIONS = {
  // supported on all row models, but need module for client side.
  enableRowGroup: CSRM_REQUIRES_ROW_GROUP_MODULE,
  rowGroup: CSRM_REQUIRES_ROW_GROUP_MODULE,
  rowGroupIndex: CSRM_REQUIRES_ROW_GROUP_MODULE,
  enablePivot: CSRM_REQUIRES_ROW_GROUP_MODULE,
  enableValue: CSRM_REQUIRES_ROW_GROUP_MODULE,
  pivot: CSRM_REQUIRES_ROW_GROUP_MODULE,
  pivotIndex: CSRM_REQUIRES_ROW_GROUP_MODULE,
  aggFunc: CSRM_REQUIRES_ROW_GROUP_MODULE,
  cellEditor: function cellEditor(options) {
    if (options.cellEditor === "agRichSelect" || options.cellEditor === "agRichSelectCellEditor") {
      return {
        module: "@ag-grid-enterprise/rich-select"
        /* RichSelectModule */

      };
    }

    return null;
  },
  menuTabs: function menuTabs(options) {
    var _a;

    var enterpriseMenuTabs = ["columnsMenuTab", "generalMenuTab"];

    if ((_a = options.menuTabs) == null ? void 0 : _a.some(function (tab) {
      return enterpriseMenuTabs.includes(tab);
    })) {
      return {
        module: "@ag-grid-enterprise/menu"
        /* MenuModule */

      };
    }

    return null;
  },
  columnsMenuParams: {
    module: ["@ag-grid-enterprise/menu"
    /* MenuModule */
    , "@ag-grid-enterprise/column-tool-panel"
    /* ColumnsToolPanelModule */
    ]
  },
  columnChooserParams: {
    module: ["@ag-grid-enterprise/menu"
    /* MenuModule */
    , "@ag-grid-enterprise/column-tool-panel"
    /* ColumnsToolPanelModule */
    ]
  },
  headerCheckboxSelection: {
    supportedRowModels: ["clientSide", "serverSide"],
    dependencies: function dependencies(_options, _ref57) {
      var rowSelection = _ref57.rowSelection;
      return rowSelection === "multiple" ? null : "headerCheckboxSelection is only supported with rowSelection=multiple";
    }
  },
  headerCheckboxSelectionFilteredOnly: {
    supportedRowModels: ["clientSide"],
    dependencies: function dependencies(_options, _ref58) {
      var rowSelection = _ref58.rowSelection;
      return rowSelection === "multiple" ? null : "headerCheckboxSelectionFilteredOnly is only supported with rowSelection=multiple";
    }
  },
  headerCheckboxSelectionCurrentPageOnly: {
    supportedRowModels: ["clientSide"],
    dependencies: function dependencies(_options, _ref59) {
      var rowSelection = _ref59.rowSelection;
      return rowSelection === "multiple" ? null : "headerCheckboxSelectionCurrentPageOnly is only supported with rowSelection=multiple";
    }
  },
  children: function children() {
    return COL_DEF_VALIDATORS;
  }
};
var colDefPropertyMap = {
  headerName: void 0,
  columnGroupShow: void 0,
  headerClass: void 0,
  toolPanelClass: void 0,
  headerValueGetter: void 0,
  pivotKeys: void 0,
  groupId: void 0,
  colId: void 0,
  sort: void 0,
  initialSort: void 0,
  field: void 0,
  type: void 0,
  cellDataType: void 0,
  tooltipComponent: void 0,
  tooltipField: void 0,
  headerTooltip: void 0,
  cellClass: void 0,
  showRowGroup: void 0,
  filter: void 0,
  initialAggFunc: void 0,
  defaultAggFunc: void 0,
  aggFunc: void 0,
  pinned: void 0,
  initialPinned: void 0,
  chartDataType: void 0,
  cellAriaRole: void 0,
  cellEditorPopupPosition: void 0,
  headerGroupComponent: void 0,
  headerGroupComponentParams: void 0,
  cellStyle: void 0,
  cellRenderer: void 0,
  cellRendererParams: void 0,
  cellEditor: void 0,
  cellEditorParams: void 0,
  filterParams: void 0,
  pivotValueColumn: void 0,
  headerComponent: void 0,
  headerComponentParams: void 0,
  floatingFilterComponent: void 0,
  floatingFilterComponentParams: void 0,
  tooltipComponentParams: void 0,
  refData: void 0,
  columnsMenuParams: void 0,
  columnChooserParams: void 0,
  children: void 0,
  sortingOrder: void 0,
  allowedAggFuncs: void 0,
  menuTabs: void 0,
  pivotTotalColumnIds: void 0,
  cellClassRules: void 0,
  icons: void 0,
  sortIndex: void 0,
  initialSortIndex: void 0,
  flex: void 0,
  initialFlex: void 0,
  width: void 0,
  initialWidth: void 0,
  minWidth: void 0,
  maxWidth: void 0,
  rowGroupIndex: void 0,
  initialRowGroupIndex: void 0,
  pivotIndex: void 0,
  initialPivotIndex: void 0,
  suppressCellFlash: void 0,
  suppressColumnsToolPanel: void 0,
  suppressFiltersToolPanel: void 0,
  openByDefault: void 0,
  marryChildren: void 0,
  suppressStickyLabel: void 0,
  hide: void 0,
  initialHide: void 0,
  rowGroup: void 0,
  initialRowGroup: void 0,
  pivot: void 0,
  initialPivot: void 0,
  checkboxSelection: void 0,
  showDisabledCheckboxes: void 0,
  headerCheckboxSelection: void 0,
  headerCheckboxSelectionFilteredOnly: void 0,
  headerCheckboxSelectionCurrentPageOnly: void 0,
  suppressMenu: void 0,
  suppressHeaderMenuButton: void 0,
  suppressMovable: void 0,
  lockPosition: void 0,
  lockVisible: void 0,
  lockPinned: void 0,
  unSortIcon: void 0,
  suppressSizeToFit: void 0,
  suppressAutoSize: void 0,
  enableRowGroup: void 0,
  enablePivot: void 0,
  enableValue: void 0,
  editable: void 0,
  suppressPaste: void 0,
  suppressNavigable: void 0,
  enableCellChangeFlash: void 0,
  rowDrag: void 0,
  dndSource: void 0,
  autoHeight: void 0,
  wrapText: void 0,
  sortable: void 0,
  resizable: void 0,
  singleClickEdit: void 0,
  floatingFilter: void 0,
  cellEditorPopup: void 0,
  suppressFillHandle: void 0,
  wrapHeaderText: void 0,
  autoHeaderHeight: void 0,
  dndSourceOnRowDrag: void 0,
  valueGetter: void 0,
  valueSetter: void 0,
  filterValueGetter: void 0,
  keyCreator: void 0,
  valueFormatter: void 0,
  valueParser: void 0,
  comparator: void 0,
  equals: void 0,
  pivotComparator: void 0,
  suppressKeyboardEvent: void 0,
  suppressHeaderKeyboardEvent: void 0,
  colSpan: void 0,
  rowSpan: void 0,
  getQuickFilterText: void 0,
  onCellValueChanged: void 0,
  onCellClicked: void 0,
  onCellDoubleClicked: void 0,
  onCellContextMenu: void 0,
  rowDragText: void 0,
  tooltipValueGetter: void 0,
  cellRendererSelector: void 0,
  cellEditorSelector: void 0,
  suppressSpanHeaderHeight: void 0,
  useValueFormatterForExport: void 0,
  useValueParserForImport: void 0,
  mainMenuItems: void 0,
  contextMenuItems: void 0,
  suppressFloatingFilterButton: void 0,
  suppressHeaderFilterButton: void 0,
  suppressHeaderContextMenu: void 0,
  loadingCellRenderer: void 0,
  loadingCellRendererParams: void 0,
  loadingCellRendererSelector: void 0
};
var ALL_PROPERTIES = Object.keys(colDefPropertyMap);
var COL_DEF_VALIDATORS = {
  objectName: "colDef",
  allProperties: ALL_PROPERTIES,
  docsUrl: "column-properties/",
  deprecations: COLUMN_DEFINITION_DEPRECATIONS,
  validations: COLUMN_DEFINITION_VALIDATIONS
}; // community-modules/core/src/validation/rules/gridOptionsValidations.ts

var GRID_OPTION_DEPRECATIONS = {
  enableChartToolPanelsButton: {
    version: "29"
  },
  functionsPassive: {
    version: "29.2"
  },
  onColumnRowGroupChangeRequest: {
    version: "29.2"
  },
  onColumnPivotChangeRequest: {
    version: "29.2"
  },
  onColumnValueChangeRequest: {
    version: "29.2"
  },
  onColumnAggFuncChangeRequest: {
    version: "29.2"
  },
  serverSideFilterAllLevels: {
    version: "30",
    message: "All server-side group levels are now filtered by default. This can be toggled using `serverSideOnlyRefreshFilteredGroups`."
  },
  suppressAggAtRootLevel: {
    version: "30",
    message: "The root level aggregation is now suppressed by default. This can be toggled using  `alwaysAggregateAtRootLevel`."
  },
  excludeHiddenColumnsFromQuickFilter: {
    version: "30",
    message: "Hidden columns are now excluded from the Quick Filter by default. This can be toggled using `includeHiddenColumnsInQuickFilter`."
  },
  enterMovesDown: {
    version: "30",
    renamed: "enterNavigatesVertically"
  },
  enterMovesDownAfterEdit: {
    version: "30",
    renamed: "enterNavigatesVerticallyAfterEdit"
  },
  suppressParentsInRowNodes: {
    version: "30.2",
    message: "Using suppressParentsInRowNodes is no longer recommended. To serialize nodes it is now recommended to instead remove the parent node reference before serialization."
  },
  advancedFilterModel: {
    version: "31",
    message: "Use `initialState.filter.advancedFilterModel` instead."
  },
  suppressAsyncEvents: {
    version: "31",
    message: "Events should be handled asynchronously."
  },
  cellFadeDelay: {
    version: "31.1",
    renamed: "cellFadeDuration"
  },
  cellFlashDelay: {
    version: "31.1",
    renamed: "cellFlashDuration"
  },
  suppressServerSideInfiniteScroll: {
    version: "31.1"
  },
  serverSideSortOnServer: {
    version: "31.1"
  },
  serverSideFilterOnServer: {
    version: "31.1"
  },
  enableCellChangeFlash: {
    version: "31.2",
    message: "Use `enableCellChangeFlash` in the `ColDef` or `defaultColDef` for all columns."
  },
  groupIncludeFooter: {
    version: "31.3",
    message: "Use `groupTotalRow` instead."
  },
  groupIncludeTotalFooter: {
    version: "31.3",
    message: "Use `grandTotalRow` instead."
  }
};
var GRID_OPTION_DEFAULTS = {
  suppressContextMenu: false,
  preventDefaultOnContextMenu: false,
  allowContextMenuWithControlKey: false,
  suppressMenuHide: false,
  enableBrowserTooltips: false,
  tooltipTrigger: "hover",
  tooltipShowDelay: 2e3,
  tooltipHideDelay: 1e4,
  tooltipMouseTrack: false,
  tooltipShowMode: "standard",
  tooltipInteraction: false,
  copyHeadersToClipboard: false,
  copyGroupHeadersToClipboard: false,
  clipboardDelimiter: "	",
  suppressCopyRowsToClipboard: false,
  suppressCopySingleCellRanges: false,
  suppressLastEmptyLineOnPaste: false,
  suppressClipboardPaste: false,
  suppressClipboardApi: false,
  suppressCutToClipboard: false,
  maintainColumnOrder: false,
  suppressFieldDotNotation: false,
  allowDragFromColumnsToolPanel: false,
  suppressMovableColumns: false,
  suppressColumnMoveAnimation: false,
  suppressDragLeaveHidesColumns: false,
  suppressRowGroupHidesColumns: false,
  suppressAutoSize: false,
  autoSizePadding: 20,
  skipHeaderOnAutoSize: false,
  singleClickEdit: false,
  suppressClickEdit: false,
  readOnlyEdit: false,
  stopEditingWhenCellsLoseFocus: false,
  enterNavigatesVertically: false,
  enterNavigatesVerticallyAfterEdit: false,
  enableCellEditingOnBackspace: false,
  undoRedoCellEditing: false,
  undoRedoCellEditingLimit: 10,
  suppressCsvExport: false,
  suppressExcelExport: false,
  cacheQuickFilter: false,
  includeHiddenColumnsInQuickFilter: false,
  excludeChildrenWhenTreeDataFiltering: false,
  enableAdvancedFilter: false,
  includeHiddenColumnsInAdvancedFilter: false,
  enableCharts: false,
  suppressChartToolPanelsButton: false,
  masterDetail: false,
  keepDetailRows: false,
  keepDetailRowsCount: 10,
  detailRowAutoHeight: false,
  tabIndex: 0,
  rowBuffer: 10,
  valueCache: false,
  valueCacheNeverExpires: false,
  enableCellExpressions: false,
  suppressTouch: false,
  suppressFocusAfterRefresh: false,
  suppressAsyncEvents: false,
  suppressBrowserResizeObserver: false,
  suppressPropertyNamesCheck: false,
  suppressChangeDetection: false,
  debug: false,
  suppressLoadingOverlay: false,
  suppressNoRowsOverlay: false,
  pagination: false,
  paginationPageSize: 100,
  paginationPageSizeSelector: true,
  paginationAutoPageSize: false,
  paginateChildRows: false,
  suppressPaginationPanel: false,
  pivotMode: false,
  pivotPanelShow: "never",
  pivotDefaultExpanded: 0,
  pivotSuppressAutoColumn: false,
  suppressExpandablePivotGroups: false,
  functionsReadOnly: false,
  suppressAggFuncInHeader: false,
  alwaysAggregateAtRootLevel: false,
  aggregateOnlyChangedColumns: false,
  suppressAggFilteredOnly: false,
  removePivotHeaderRowWhenSingleValueColumn: false,
  animateRows: true,
  enableCellChangeFlash: false,
  cellFlashDelay: 500,
  cellFlashDuration: 500,
  cellFadeDelay: 1e3,
  cellFadeDuration: 1e3,
  allowShowChangeAfterFilter: false,
  domLayout: "normal",
  ensureDomOrder: false,
  enableRtl: false,
  suppressColumnVirtualisation: false,
  suppressMaxRenderedRowRestriction: false,
  suppressRowVirtualisation: false,
  rowDragManaged: false,
  suppressRowDrag: false,
  suppressMoveWhenRowDragging: false,
  rowDragEntireRow: false,
  rowDragMultiRow: false,
  embedFullWidthRows: false,
  groupDisplayType: "singleColumn",
  groupDefaultExpanded: 0,
  groupMaintainOrder: false,
  groupSelectsChildren: false,
  groupIncludeTotalFooter: false,
  groupSuppressBlankHeader: false,
  groupSelectsFiltered: false,
  showOpenedGroup: false,
  groupRemoveSingleChildren: false,
  groupRemoveLowestSingleChildren: false,
  groupHideOpenParents: false,
  groupAllowUnbalanced: false,
  rowGroupPanelShow: "never",
  suppressMakeColumnVisibleAfterUnGroup: false,
  treeData: false,
  rowGroupPanelSuppressSort: false,
  suppressGroupRowsSticky: false,
  rowModelType: "clientSide",
  asyncTransactionWaitMillis: 50,
  suppressModelUpdateAfterUpdateTransaction: false,
  cacheOverflowSize: 1,
  infiniteInitialRowCount: 1,
  serverSideInitialRowCount: 1,
  suppressServerSideInfiniteScroll: false,
  cacheBlockSize: 100,
  maxBlocksInCache: -1,
  maxConcurrentDatasourceRequests: 2,
  blockLoadDebounceMillis: 0,
  purgeClosedRowNodes: false,
  serverSideSortAllLevels: false,
  serverSideOnlyRefreshFilteredGroups: false,
  serverSideSortOnServer: false,
  serverSideFilterOnServer: false,
  serverSidePivotResultFieldSeparator: "_",
  viewportRowModelPageSize: 5,
  viewportRowModelBufferSize: 5,
  alwaysShowHorizontalScroll: false,
  alwaysShowVerticalScroll: false,
  debounceVerticalScrollbar: false,
  suppressHorizontalScroll: false,
  suppressScrollOnNewData: false,
  suppressScrollWhenPopupsAreOpen: false,
  suppressAnimationFrame: false,
  suppressMiddleClickScrolls: false,
  suppressPreventDefaultOnMouseWheel: false,
  rowMultiSelectWithClick: false,
  suppressRowDeselection: false,
  suppressRowClickSelection: false,
  suppressCellFocus: false,
  suppressHeaderFocus: false,
  suppressMultiRangeSelection: false,
  enableCellTextSelection: false,
  enableRangeSelection: false,
  enableRangeHandle: false,
  enableFillHandle: false,
  fillHandleDirection: "xy",
  suppressClearOnFillReduction: false,
  accentedSort: false,
  unSortIcon: false,
  suppressMultiSort: false,
  alwaysMultiSort: false,
  suppressMaintainUnsortedOrder: false,
  suppressRowHoverHighlight: false,
  suppressRowTransform: false,
  columnHoverHighlight: false,
  deltaSort: false,
  enableGroupEdit: false,
  suppressGroupMaintainValueType: false,
  functionsPassive: false,
  groupLockGroupColumns: 0,
  serverSideEnableClientSideSort: false,
  suppressServerSideFullWidthLoadingRow: false,
  pivotMaxGeneratedColumns: -1
};
var GRID_OPTION_VALIDATIONS = {
  sideBar: {
    module: "@ag-grid-enterprise/side-bar"
    /* SideBarModule */

  },
  statusBar: {
    module: "@ag-grid-enterprise/status-bar"
    /* StatusBarModule */

  },
  enableCharts: {
    module: "@ag-grid-enterprise/charts"
    /* GridChartsModule */

  },
  getMainMenuItems: {
    module: "@ag-grid-enterprise/menu"
    /* MenuModule */

  },
  getContextMenuItems: {
    module: "@ag-grid-enterprise/menu"
    /* MenuModule */

  },
  allowContextMenuWithControlKey: {
    module: "@ag-grid-enterprise/menu"
    /* MenuModule */

  },
  enableAdvancedFilter: {
    module: "@ag-grid-enterprise/advanced-filter"
    /* AdvancedFilterModule */

  },
  treeData: {
    supportedRowModels: ["clientSide", "serverSide"],
    module: "@ag-grid-enterprise/row-grouping"
    /* RowGroupingModule */
    ,
    dependencies: function dependencies(options) {
      var _a;

      var rowModel = (_a = options.rowModelType) != null ? _a : "clientSide";

      switch (rowModel) {
        case "clientSide":
          var csrmWarning = "treeData requires 'getDataPath' in the ".concat(rowModel, " row model.");
          return options.getDataPath ? null : csrmWarning;

        case "serverSide":
          var ssrmWarning = "treeData requires 'isServerSideGroup' and 'getServerSideGroupKey' in the ".concat(rowModel, " row model.");
          return options.isServerSideGroup && options.getServerSideGroupKey ? null : ssrmWarning;
      }

      return null;
    }
  },
  masterDetail: {
    module: "@ag-grid-enterprise/master-detail"
    /* MasterDetailModule */

  },
  enableRangeSelection: {
    module: "@ag-grid-enterprise/range-selection"
    /* RangeSelectionModule */

  },
  enableRangeHandle: {
    dependencies: {
      enableRangeSelection: [true]
    }
  },
  enableFillHandle: {
    dependencies: {
      enableRangeSelection: [true]
    }
  },
  groupDefaultExpanded: {
    supportedRowModels: ["clientSide"]
  },
  groupIncludeFooter: {
    supportedRowModels: ["clientSide", "serverSide"],
    dependencies: function dependencies(options) {
      var _a;

      var rowModel = (_a = options.rowModelType) != null ? _a : "clientSide";

      switch (rowModel) {
        case "clientSide":
          return null;

        case "serverSide":
          var warning = "groupIncludeFooter is not supported alongside suppressServerSideInfiniteScroll";
          return options.suppressServerSideInfiniteScroll ? warning : null;
      }

      return null;
    }
  },
  groupIncludeTotalFooter: {
    supportedRowModels: ["clientSide"]
  },
  groupRemoveSingleChildren: {
    dependencies: {
      groupHideOpenParents: [void 0, false],
      groupRemoveLowestSingleChildren: [void 0, false]
    }
  },
  groupRemoveLowestSingleChildren: {
    dependencies: {
      groupHideOpenParents: [void 0, false],
      groupRemoveSingleChildren: [void 0, false]
    }
  },
  groupSelectsChildren: {
    dependencies: {
      rowSelection: ["multiple"]
    }
  },
  suppressParentsInRowNodes: {
    dependencies: {
      groupSelectsChildren: [void 0, false]
    }
  },
  viewportDatasource: {
    supportedRowModels: ["viewport"],
    module: "@ag-grid-enterprise/viewport-row-model"
    /* ViewportRowModelModule */

  },
  serverSideDatasource: {
    supportedRowModels: ["serverSide"],
    module: "@ag-grid-enterprise/server-side-row-model"
    /* ServerSideRowModelModule */

  },
  cacheBlockSize: {
    supportedRowModels: ["serverSide", "infinite"]
  },
  datasource: {
    supportedRowModels: ["infinite"],
    module: "@ag-grid-community/infinite-row-model"
    /* InfiniteRowModelModule */

  },
  rowData: {
    supportedRowModels: ["clientSide"],
    module: "@ag-grid-community/client-side-row-model"
    /* ClientSideRowModelModule */

  },
  columnDefs: function columnDefs() {
    return COL_DEF_VALIDATORS;
  },
  defaultColDef: function defaultColDef() {
    return COL_DEF_VALIDATORS;
  },
  defaultColGroupDef: function defaultColGroupDef() {
    return COL_DEF_VALIDATORS;
  },
  autoGroupColumnDef: function autoGroupColumnDef() {
    return COL_DEF_VALIDATORS;
  }
};
var GRID_OPTIONS_VALIDATORS = {
  objectName: "gridOptions",
  allProperties: [].concat(_toConsumableArray(_PropertyKeys2.ALL_PROPERTIES), _toConsumableArray(_ComponentUtil2.EVENT_CALLBACKS)),
  propertyExceptions: ["api", "columnApi"],
  docsUrl: "grid-options/",
  deprecations: GRID_OPTION_DEPRECATIONS,
  validations: GRID_OPTION_VALIDATIONS
}; // community-modules/core/src/gridOptionsService.ts

var _GridOptionsService2 =
/*#__PURE__*/
function () {
  "use strict";

  function _GridOptionsService() {
    var _this628 = this;

    _classCallCheck(this, _GridOptionsService);

    this.destroyed = false;
    this.domDataKey = "__AG_" + Math.random().toString();
    this.propertyEventService = new _EventService(); // responsible for calling the onXXX functions on gridOptions
    // It forces events defined in GridOptionsService.alwaysSyncGlobalEvents to be fired synchronously.
    // This is required for events such as GridPreDestroyed.
    // Other events can be fired asynchronously or synchronously depending on config.

    this.globalEventHandlerFactory = function (restrictToSyncOnly) {
      return function (eventName, event) {
        if (_this628.destroyed) {
          return;
        }

        var alwaysSync = _ALWAYS_SYNC_GLOBAL_EVENTS.has(eventName);

        if (alwaysSync && !restrictToSyncOnly || !alwaysSync && restrictToSyncOnly) {
          return;
        }

        var eventHandlerName = _ComponentUtil2.getCallbackForEvent(eventName);

        var eventHandler = _this628.gridOptions[eventHandlerName];

        if (typeof eventHandler === "function") {
          _this628.frameworkOverrides.wrapOutgoing(function () {
            eventHandler(event);
          });
        }
      };
    };
  } // This is quicker then having code call gridOptionsService.get('context')


  _createClass(_GridOptionsService, [{
    key: "init",
    value: function init() {
      this.columnApi = new _ColumnApi(this.api);
      var async = !this.get("suppressAsyncEvents");
      this.eventService.addGlobalListener(this.globalEventHandlerFactory().bind(this), async);
      this.eventService.addGlobalListener(this.globalEventHandlerFactory(true).bind(this), false);
      this.propertyEventService.setFrameworkOverrides(this.frameworkOverrides);
      this.getScrollbarWidth();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.destroyed = true;
      this.columnApi = void 0;
    }
    /**
     * Get the raw value of the GridOptions property provided.
     * @param property
     */

  }, {
    key: "get",
    value: function get(property) {
      var _a;

      return (_a = this.gridOptions[property]) != null ? _a : GRID_OPTION_DEFAULTS[property];
    }
    /**
     * Get the GridOption callback but wrapped so that the common params of api,columnApi and context are automatically applied to the params.
     * @param property GridOption callback properties based on the fact that this property has a callback with params extending AgGridCommon
     */

  }, {
    key: "getCallback",
    value: function getCallback(property) {
      return this.mergeGridCommonParams(this.gridOptions[property]);
    }
    /**
     * Returns `true` if a value has been specified for this GridOption.
     * @param property GridOption property
     */

  }, {
    key: "exists",
    value: function exists(property) {
      return _exists(this.gridOptions[property]);
    }
    /**
    * Wrap the user callback and attach the api, columnApi and context to the params object on the way through.
    * @param callback User provided callback
    * @returns Wrapped callback where the params object not require api, columnApi and context
    */

  }, {
    key: "mergeGridCommonParams",
    value: function mergeGridCommonParams(callback) {
      var _this629 = this;

      if (callback) {
        var wrapped = function wrapped(callbackParams) {
          var mergedParams = callbackParams;
          mergedParams.api = _this629.api;
          mergedParams.columnApi = _this629.columnApi;
          mergedParams.context = _this629.context;
          return callback(mergedParams);
        };

        return wrapped;
      }

      return callback;
    }
  }, {
    key: "updateGridOptions",
    value: function updateGridOptions(_ref60) {
      var _this630 = this;

      var options = _ref60.options,
          _ref60$source = _ref60.source,
          source = _ref60$source === void 0 ? "api" : _ref60$source;
      var changeSet = {
        id: _GridOptionsService2.changeSetId++,
        properties: []
      };
      var events = [];
      Object.entries(options).forEach(function (_ref61) {
        var _ref62 = _slicedToArray(_ref61, 2),
            key = _ref62[0],
            value = _ref62[1];

        if (source === "api" && INITIAL_GRID_OPTION_KEYS[key]) {
          _warnOnce("".concat(key, " is an initial property and cannot be updated."));
        }

        var coercedValue = _GridOptionsService2.getCoercedValue(key, value);

        var shouldForce = typeof coercedValue === "object" && source === "api";
        var previousValue = _this630.gridOptions[key];

        if (shouldForce || previousValue !== coercedValue) {
          _this630.gridOptions[key] = coercedValue;
          var event = {
            type: key,
            currentValue: coercedValue,
            previousValue: previousValue,
            changeSet: changeSet,
            source: source
          };
          events.push(event);
        }
      });
      this.validationService.processGridOptions(this.gridOptions);
      changeSet.properties = events.map(function (event) {
        return event.type;
      });
      events.forEach(function (event) {
        if (_this630.gridOptions.debug) {
          console.log("AG Grid: Updated property ".concat(event.type, " from "), event.previousValue, " to  ", event.currentValue);
        }

        _this630.propertyEventService.dispatchEvent(event);
      });
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(key, listener) {
      this.propertyEventService.addEventListener(key, listener);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(key, listener) {
      this.propertyEventService.removeEventListener(key, listener);
    } // *************** Helper methods ************************** //
    // Methods to share common GridOptions related logic that goes above accessing a single property
    // the user might be using some non-standard scrollbar, eg a scrollbar that has zero
    // width and overlays (like the Safari scrollbar, but presented in Chrome). so we
    // allow the user to provide the scroll width before we work it out.

  }, {
    key: "getScrollbarWidth",
    value: function getScrollbarWidth() {
      if (this.scrollbarWidth == null) {
        var useGridOptions = typeof this.gridOptions.scrollbarWidth === "number" && this.gridOptions.scrollbarWidth >= 0;
        var scrollbarWidth = useGridOptions ? this.gridOptions.scrollbarWidth : _getScrollbarWidth();

        if (scrollbarWidth != null) {
          this.scrollbarWidth = scrollbarWidth;
          this.eventService.dispatchEvent({
            type: _Events.EVENT_SCROLLBAR_WIDTH_CHANGED
          });
        }
      }

      return this.scrollbarWidth;
    }
  }, {
    key: "isRowModelType",
    value: function isRowModelType(rowModelType) {
      return this.gridOptions.rowModelType === rowModelType || rowModelType === "clientSide" && _missing(this.gridOptions.rowModelType);
    }
  }, {
    key: "isDomLayout",
    value: function isDomLayout(domLayout) {
      var _a;

      var gridLayout = (_a = this.gridOptions.domLayout) != null ? _a : "normal";
      return gridLayout === domLayout;
    }
  }, {
    key: "isRowSelection",
    value: function isRowSelection() {
      return this.gridOptions.rowSelection === "single" || this.gridOptions.rowSelection === "multiple";
    }
  }, {
    key: "useAsyncEvents",
    value: function useAsyncEvents() {
      return !this.get("suppressAsyncEvents");
    }
  }, {
    key: "isGetRowHeightFunction",
    value: function isGetRowHeightFunction() {
      return typeof this.gridOptions.getRowHeight === "function";
    }
  }, {
    key: "getRowHeightForNode",
    value: function getRowHeightForNode(rowNode) {
      var allowEstimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var defaultRowHeight = arguments.length > 2 ? arguments[2] : undefined;

      if (defaultRowHeight == null) {
        defaultRowHeight = this.environment.getDefaultRowHeight();
      }

      if (this.isGetRowHeightFunction()) {
        if (allowEstimate) {
          return {
            height: defaultRowHeight,
            estimated: true
          };
        }

        var params = {
          node: rowNode,
          data: rowNode.data
        };
        var height = this.getCallback("getRowHeight")(params);

        if (this.isNumeric(height)) {
          if (height === 0) {
            _warnOnce("The return of `getRowHeight` cannot be zero. If the intention is to hide rows, use a filter instead.");
          }

          return {
            height: Math.max(1, height),
            estimated: false
          };
        }
      }

      if (rowNode.detail && this.get("masterDetail")) {
        return this.getMasterDetailRowHeight();
      }

      var rowHeight = this.gridOptions.rowHeight && this.isNumeric(this.gridOptions.rowHeight) ? this.gridOptions.rowHeight : defaultRowHeight;
      return {
        height: rowHeight,
        estimated: false
      };
    }
  }, {
    key: "getMasterDetailRowHeight",
    value: function getMasterDetailRowHeight() {
      if (this.get("detailRowAutoHeight")) {
        return {
          height: 1,
          estimated: false
        };
      }

      if (this.isNumeric(this.gridOptions.detailRowHeight)) {
        return {
          height: this.gridOptions.detailRowHeight,
          estimated: false
        };
      }

      return {
        height: 300,
        estimated: false
      };
    } // we don't allow dynamic row height for virtual paging

  }, {
    key: "getRowHeightAsNumber",
    value: function getRowHeightAsNumber() {
      if (!this.gridOptions.rowHeight || _missing(this.gridOptions.rowHeight)) {
        return this.environment.getDefaultRowHeight();
      }

      var rowHeight = this.environment.refreshRowHeightVariable();

      if (rowHeight !== -1) {
        return rowHeight;
      }

      console.warn("AG Grid row height must be a number if not using standard row model");
      return this.environment.getDefaultRowHeight();
    }
  }, {
    key: "isNumeric",
    value: function isNumeric(value) {
      return !isNaN(value) && typeof value === "number" && isFinite(value);
    }
  }, {
    key: "getDomDataKey",
    value: function getDomDataKey() {
      return this.domDataKey;
    } // returns the dom data, or undefined if not found

  }, {
    key: "getDomData",
    value: function getDomData(element, key) {
      var domData = element[this.getDomDataKey()];
      return domData ? domData[key] : void 0;
    }
  }, {
    key: "setDomData",
    value: function setDomData(element, key, value) {
      var domDataKey = this.getDomDataKey();
      var domData = element[domDataKey];

      if (_missing(domData)) {
        domData = {};
        element[domDataKey] = domData;
      }

      domData[key] = value;
    }
  }, {
    key: "getDocument",
    value: function getDocument() {
      var result = null;

      if (this.gridOptions.getDocument && _exists(this.gridOptions.getDocument)) {
        result = this.gridOptions.getDocument();
      } else if (this.eGridDiv) {
        result = this.eGridDiv.ownerDocument;
      }

      if (result && _exists(result)) {
        return result;
      }

      return document;
    }
  }, {
    key: "getWindow",
    value: function getWindow() {
      var eDocument = this.getDocument();
      return eDocument.defaultView || window;
    }
  }, {
    key: "getRootNode",
    value: function getRootNode() {
      return this.eGridDiv.getRootNode();
    }
  }, {
    key: "getActiveDomElement",
    value: function getActiveDomElement() {
      return this.getRootNode().activeElement;
    }
  }, {
    key: "getAsyncTransactionWaitMillis",
    value: function getAsyncTransactionWaitMillis() {
      return _exists(this.gridOptions.asyncTransactionWaitMillis) ? this.gridOptions.asyncTransactionWaitMillis : 50;
    }
  }, {
    key: "isAnimateRows",
    value: function isAnimateRows() {
      if (this.get("ensureDomOrder")) {
        return false;
      }

      return this.get("animateRows");
    }
  }, {
    key: "isGroupRowsSticky",
    value: function isGroupRowsSticky() {
      if (this.get("paginateChildRows") || this.get("groupHideOpenParents") || this.isDomLayout("print")) {
        return false;
      }

      return true;
    }
  }, {
    key: "isColumnsSortingCoupledToGroup",
    value: function isColumnsSortingCoupledToGroup() {
      var autoGroupColumnDef = this.gridOptions.autoGroupColumnDef;
      return !(autoGroupColumnDef == null ? void 0 : autoGroupColumnDef.comparator) && !this.get("treeData");
    }
  }, {
    key: "getGroupAggFiltering",
    value: function getGroupAggFiltering() {
      var userValue = this.gridOptions.groupAggFiltering;

      if (typeof userValue === "function") {
        return this.getCallback("groupAggFiltering");
      }

      if (userValue === true) {
        return function () {
          return true;
        };
      }

      return void 0;
    }
  }, {
    key: "getGrandTotalRow",
    value: function getGrandTotalRow() {
      var userValue = this.gridOptions.grandTotalRow;

      if (userValue) {
        return userValue;
      }

      var legacyValue = this.gridOptions.groupIncludeTotalFooter;

      if (legacyValue) {
        return "bottom";
      }

      return void 0;
    }
  }, {
    key: "getGroupTotalRowCallback",
    value: function getGroupTotalRowCallback() {
      var userValue = this.get("groupTotalRow");

      if (typeof userValue === "function") {
        return this.getCallback("groupTotalRow");
      }

      if (userValue) {
        return function () {
          return userValue;
        };
      }

      var legacyValue = this.get("groupIncludeFooter");

      if (typeof legacyValue === "function") {
        var legacyCallback = this.getCallback("groupIncludeFooter");
        return function (p) {
          return legacyCallback(p) ? "bottom" : void 0;
        };
      }

      return function () {
        return legacyValue ? "bottom" : void 0;
      };
    }
  }, {
    key: "isGroupMultiAutoColumn",
    value: function isGroupMultiAutoColumn() {
      if (this.gridOptions.groupDisplayType) {
        return this.gridOptions.groupDisplayType === "multipleColumns";
      }

      return this.get("groupHideOpenParents");
    }
  }, {
    key: "isGroupUseEntireRow",
    value: function isGroupUseEntireRow(pivotMode) {
      if (pivotMode) {
        return false;
      }

      return this.gridOptions.groupDisplayType === "groupRows";
    }
  }, {
    key: "getGridCommonParams",
    value: function getGridCommonParams() {
      return {
        api: this.api,
        columnApi: this.columnApi,
        context: this.context
      };
    }
  }, {
    key: "addGridCommonParams",
    value: function addGridCommonParams(params) {
      var updatedParams = params;
      updatedParams.api = this.api;
      updatedParams.columnApi = this.columnApi;
      updatedParams.context = this.context;
      return updatedParams;
    }
  }, {
    key: "context",
    get: function get() {
      return this.gridOptions["context"];
    }
  }], [{
    key: "toBoolean",
    value: function toBoolean(value) {
      if (typeof value === "boolean") {
        return value;
      }

      if (typeof value === "string") {
        return value.toUpperCase() === "TRUE" || value == "";
      }

      return false;
    }
  }, {
    key: "toNumber",
    value: function toNumber(value) {
      if (typeof value === "number") {
        return value;
      }

      if (typeof value === "string") {
        var parsed = parseInt(value);

        if (isNaN(parsed)) {
          return void 0;
        }

        return parsed;
      }

      return void 0;
    }
  }, {
    key: "toConstrainedNum",
    value: function toConstrainedNum(min, max) {
      return function (value) {
        var num = _GridOptionsService2.toNumber(value);

        if (num == null || num < min || num > max) {
          return void 0;
        }

        return num;
      };
    }
  }, {
    key: "getCoercedValue",
    value: function getCoercedValue(key, value) {
      var coerceFunc = _GridOptionsService2.PROPERTY_COERCIONS.get(key);

      if (!coerceFunc) {
        return value;
      }

      return coerceFunc(value);
    }
  }, {
    key: "getCoercedGridOptions",
    value: function getCoercedGridOptions(gridOptions) {
      var newGo = {};
      Object.entries(gridOptions).forEach(function (_ref63) {
        var _ref64 = _slicedToArray(_ref63, 2),
            key = _ref64[0],
            value = _ref64[1];

        var coercedValue = _GridOptionsService2.getCoercedValue(key, value);

        newGo[key] = coercedValue;
      });
      return newGo;
    }
  }]);

  return _GridOptionsService;
}();
/**
 * Handles value coercion including validation of ranges etc. If value is invalid, undefined is set, allowing default to be used.
 */


_GridOptionsService2.PROPERTY_COERCIONS = new Map([].concat(_toConsumableArray(_PropertyKeys2.BOOLEAN_PROPERTIES.map(function (key) {
  return [key, _GridOptionsService2.toBoolean];
})), _toConsumableArray(_PropertyKeys2.NUMBER_PROPERTIES.map(function (key) {
  return [key, _GridOptionsService2.toNumber];
})), [["groupAggFiltering", function (val) {
  return typeof val === "function" ? val : _GridOptionsService2.toBoolean(val);
}], ["pageSize", _GridOptionsService2.toConstrainedNum(1, Number.MAX_VALUE)], ["autoSizePadding", _GridOptionsService2.toConstrainedNum(0, Number.MAX_VALUE)], ["keepDetailRowsCount", _GridOptionsService2.toConstrainedNum(1, Number.MAX_VALUE)], ["rowBuffer", _GridOptionsService2.toConstrainedNum(0, Number.MAX_VALUE)], ["infiniteInitialRowCount", _GridOptionsService2.toConstrainedNum(1, Number.MAX_VALUE)], ["cacheOverflowSize", _GridOptionsService2.toConstrainedNum(1, Number.MAX_VALUE)], ["cacheBlockSize", _GridOptionsService2.toConstrainedNum(1, Number.MAX_VALUE)], ["serverSideInitialRowCount", _GridOptionsService2.toConstrainedNum(1, Number.MAX_VALUE)], ["viewportRowModelPageSize", _GridOptionsService2.toConstrainedNum(1, Number.MAX_VALUE)], ["viewportRowModelBufferSize", _GridOptionsService2.toConstrainedNum(0, Number.MAX_VALUE)]]));
_GridOptionsService2.changeSetId = 0;

__decorateClass([_Autowired("gridOptions")], _GridOptionsService2.prototype, "gridOptions", 2);

__decorateClass([_Autowired("eventService")], _GridOptionsService2.prototype, "eventService", 2);

__decorateClass([_Autowired("environment")], _GridOptionsService2.prototype, "environment", 2);

__decorateClass([_Autowired("frameworkOverrides")], _GridOptionsService2.prototype, "frameworkOverrides", 2);

__decorateClass([_Autowired("eGridDiv")], _GridOptionsService2.prototype, "eGridDiv", 2);

__decorateClass([_Autowired("validationService")], _GridOptionsService2.prototype, "validationService", 2);

__decorateClass([_Autowired("gridApi")], _GridOptionsService2.prototype, "api", 2);

__decorateClass([_PostConstruct], _GridOptionsService2.prototype, "init", 1);

__decorateClass([_PreDestroy], _GridOptionsService2.prototype, "destroy", 1);

_GridOptionsService2 = __decorateClass([_Bean("gridOptionsService")], _GridOptionsService2); // community-modules/core/src/localeService.ts

var _LocaleService =
/*#__PURE__*/
function (_BeanStub101) {
  "use strict";

  _inherits(_LocaleService, _BeanStub101);

  function _LocaleService() {
    _classCallCheck(this, _LocaleService);

    return _possibleConstructorReturn(this, _getPrototypeOf(_LocaleService).apply(this, arguments));
  }

  _createClass(_LocaleService, [{
    key: "getLocaleTextFunc",
    value: function getLocaleTextFunc() {
      var getLocaleText = this.gos.getCallback("getLocaleText");

      if (getLocaleText) {
        return function (key, defaultValue, variableValues) {
          var params = {
            key: key,
            defaultValue: defaultValue,
            variableValues: variableValues
          };
          return getLocaleText(params);
        };
      }

      var localeText = this.gos.get("localeText");
      return function (key, defaultValue, variableValues) {
        var localisedText = localeText && localeText[key];

        if (localisedText && variableValues && variableValues.length) {
          var found = 0;

          while (true) {
            if (found >= variableValues.length) {
              break;
            }

            var idx = localisedText.indexOf("${variable}");

            if (idx === -1) {
              break;
            }

            localisedText = localisedText.replace("${variable}", variableValues[found++]);
          }
        }

        return localisedText != null ? localisedText : defaultValue;
      };
    }
  }]);

  return _LocaleService;
}(_BeanStub2);

_LocaleService = __decorateClass([_Bean("localeService")], _LocaleService); // community-modules/core/src/gridBodyComp/fakeVScrollComp.ts

var _FakeVScrollComp =
/*#__PURE__*/
function (_AbstractFakeScrollCo2) {
  "use strict";

  _inherits(_FakeVScrollComp, _AbstractFakeScrollCo2);

  function _FakeVScrollComp() {
    _classCallCheck(this, _FakeVScrollComp);

    return _possibleConstructorReturn(this, _getPrototypeOf(_FakeVScrollComp).call(this, _FakeVScrollComp.TEMPLATE, "vertical"));
  }

  _createClass(_FakeVScrollComp, [{
    key: "postConstruct",
    value: function postConstruct() {
      _get(_getPrototypeOf(_FakeVScrollComp.prototype), "postConstruct", this).call(this);

      this.createManagedBean(new SetHeightFeature(this.eContainer));
      this.ctrlsService.register("fakeVScrollComp", this);
      this.addManagedListener(this.eventService, _Events.EVENT_ROW_CONTAINER_HEIGHT_CHANGED, this.onRowContainerHeightChanged.bind(this));
    }
  }, {
    key: "setScrollVisible",
    value: function setScrollVisible() {
      var vScrollShowing = this.scrollVisibleService.isVerticalScrollShowing();
      var invisibleScrollbar2 = this.invisibleScrollbar;
      var scrollbarWidth = vScrollShowing ? this.gos.getScrollbarWidth() || 0 : 0;
      var adjustedScrollbarWidth = scrollbarWidth === 0 && invisibleScrollbar2 ? 16 : scrollbarWidth;
      this.addOrRemoveCssClass("ag-scrollbar-invisible", invisibleScrollbar2);

      _setFixedWidth(this.getGui(), adjustedScrollbarWidth);

      _setFixedWidth(this.eViewport, adjustedScrollbarWidth);

      _setFixedWidth(this.eContainer, adjustedScrollbarWidth);

      this.setDisplayed(vScrollShowing, {
        skipAriaHidden: true
      });
    }
  }, {
    key: "onRowContainerHeightChanged",
    value: function onRowContainerHeightChanged() {
      var ctrlsService = this.ctrlsService;
      var gridBodyCtrl = ctrlsService.getGridBodyCtrl();
      var gridBodyViewportEl = gridBodyCtrl.getBodyViewportElement();
      var eViewportScrollTop = this.getScrollPosition();
      var gridBodyViewportScrollTop = gridBodyViewportEl.scrollTop;

      if (eViewportScrollTop != gridBodyViewportScrollTop) {
        this.setScrollPosition(gridBodyViewportScrollTop, true);
      }
    }
  }, {
    key: "getScrollPosition",
    value: function getScrollPosition() {
      return this.getViewport().scrollTop;
    }
  }, {
    key: "setScrollPosition",
    value: function setScrollPosition(value, force) {
      if (!force && !_isVisible(this.getViewport())) {
        this.attemptSettingScrollPosition(value);
      }

      this.getViewport().scrollTop = value;
    }
  }]);

  return _FakeVScrollComp;
}(AbstractFakeScrollComp);

_FakeVScrollComp.TEMPLATE =
/* html */
"<div class=\"ag-body-vertical-scroll\" aria-hidden=\"true\">\n            <div class=\"ag-body-vertical-scroll-viewport\" ref=\"eViewport\">\n                <div class=\"ag-body-vertical-scroll-container\" ref=\"eContainer\"></div>\n            </div>\n        </div>";

__decorateClass([_PostConstruct], _FakeVScrollComp.prototype, "postConstruct", 1);

var FakeVScrollComp = _FakeVScrollComp; // community-modules/core/src/columns/dataTypeService.ts

var MONTH_LOCALE_TEXT = {
  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December"
};
var MONTH_KEYS = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];

var _DataTypeService =
/*#__PURE__*/
function (_BeanStub102) {
  "use strict";

  _inherits(_DataTypeService, _BeanStub102);

  function _DataTypeService() {
    var _this631;

    _classCallCheck(this, _DataTypeService);

    _this631 = _possibleConstructorReturn(this, _getPrototypeOf(_DataTypeService).apply(this, arguments));
    _this631.dataTypeDefinitions = {};
    _this631.isWaitingForRowData = false;
    _this631.isColumnTypeOverrideInDataTypeDefinitions = false; // keep track of any column state updates whilst waiting for data types to be inferred

    _this631.columnStateUpdatesPendingInference = {};
    _this631.columnStateUpdateListenerDestroyFuncs = [];
    return _this631;
  }

  _createClass(_DataTypeService, [{
    key: "init",
    value: function init() {
      var _this632 = this;

      this.groupHideOpenParents = this.gos.get("groupHideOpenParents");
      this.addManagedPropertyListener("groupHideOpenParents", function () {
        _this632.groupHideOpenParents = _this632.gos.get("groupHideOpenParents");
      });
      this.processDataTypeDefinitions();
      this.addManagedPropertyListener("dataTypeDefinitions", function (event) {
        _this632.processDataTypeDefinitions();

        _this632.columnModel.recreateColumnDefs(convertSourceType(event.source));
      });
    }
  }, {
    key: "processDataTypeDefinitions",
    value: function processDataTypeDefinitions() {
      var _this633 = this;

      var _a;

      var defaultDataTypes = this.getDefaultDataTypes();
      this.dataTypeDefinitions = {};
      Object.entries(defaultDataTypes).forEach(function (_ref65) {
        var _ref66 = _slicedToArray(_ref65, 2),
            cellDataType = _ref66[0],
            dataTypeDefinition = _ref66[1];

        _this633.dataTypeDefinitions[cellDataType] = __spreadProps(__spreadValues({}, dataTypeDefinition), {
          groupSafeValueFormatter: _this633.createGroupSafeValueFormatter(dataTypeDefinition)
        });
      });
      var dataTypeDefinitions = (_a = this.gos.get("dataTypeDefinitions")) != null ? _a : {};
      this.dataTypeMatchers = {};
      Object.entries(dataTypeDefinitions).forEach(function (_ref67) {
        var _ref68 = _slicedToArray(_ref67, 2),
            cellDataType = _ref68[0],
            dataTypeDefinition = _ref68[1];

        var mergedDataTypeDefinition = _this633.processDataTypeDefinition(dataTypeDefinition, dataTypeDefinitions, [cellDataType], defaultDataTypes);

        if (mergedDataTypeDefinition) {
          _this633.dataTypeDefinitions[cellDataType] = mergedDataTypeDefinition;

          if (dataTypeDefinition.dataTypeMatcher) {
            _this633.dataTypeMatchers[cellDataType] = dataTypeDefinition.dataTypeMatcher;
          }
        }
      });
      this.checkObjectValueHandlers(defaultDataTypes);
      ["dateString", "text", "number", "boolean", "date"].forEach(function (cellDataType) {
        var overriddenDataTypeMatcher = _this633.dataTypeMatchers[cellDataType];

        if (overriddenDataTypeMatcher) {
          delete _this633.dataTypeMatchers[cellDataType];
        }

        _this633.dataTypeMatchers[cellDataType] = overriddenDataTypeMatcher != null ? overriddenDataTypeMatcher : defaultDataTypes[cellDataType].dataTypeMatcher;
      });
    }
  }, {
    key: "mergeDataTypeDefinitions",
    value: function mergeDataTypeDefinitions(parentDataTypeDefinition, childDataTypeDefinition) {
      var mergedDataTypeDefinition = __spreadValues(__spreadValues({}, parentDataTypeDefinition), childDataTypeDefinition);

      if (parentDataTypeDefinition.columnTypes && childDataTypeDefinition.columnTypes && childDataTypeDefinition.appendColumnTypes) {
        mergedDataTypeDefinition.columnTypes = [].concat(_toConsumableArray(this.convertColumnTypes(parentDataTypeDefinition.columnTypes)), _toConsumableArray(this.convertColumnTypes(childDataTypeDefinition.columnTypes)));
      }

      return mergedDataTypeDefinition;
    }
  }, {
    key: "processDataTypeDefinition",
    value: function processDataTypeDefinition(dataTypeDefinition, dataTypeDefinitions, alreadyProcessedDataTypes, defaultDataTypes) {
      var mergedDataTypeDefinition;
      var extendsCellDataType = dataTypeDefinition.extendsDataType;

      if (dataTypeDefinition.columnTypes) {
        this.isColumnTypeOverrideInDataTypeDefinitions = true;
      }

      if (dataTypeDefinition.extendsDataType === dataTypeDefinition.baseDataType) {
        var baseDataTypeDefinition = defaultDataTypes[extendsCellDataType];
        var overriddenBaseDataTypeDefinition = dataTypeDefinitions[extendsCellDataType];

        if (baseDataTypeDefinition && overriddenBaseDataTypeDefinition) {
          baseDataTypeDefinition = overriddenBaseDataTypeDefinition;
        }

        if (!this.validateDataTypeDefinition(dataTypeDefinition, baseDataTypeDefinition, extendsCellDataType)) {
          return void 0;
        }

        mergedDataTypeDefinition = this.mergeDataTypeDefinitions(baseDataTypeDefinition, dataTypeDefinition);
      } else {
        if (alreadyProcessedDataTypes.includes(extendsCellDataType)) {
          _warnOnce('Data type definition hierarchies (via the "extendsDataType" property) cannot contain circular references.');

          return void 0;
        }

        var extendedDataTypeDefinition = dataTypeDefinitions[extendsCellDataType];

        if (!this.validateDataTypeDefinition(dataTypeDefinition, extendedDataTypeDefinition, extendsCellDataType)) {
          return void 0;
        }

        var mergedExtendedDataTypeDefinition = this.processDataTypeDefinition(extendedDataTypeDefinition, dataTypeDefinitions, [].concat(_toConsumableArray(alreadyProcessedDataTypes), [extendsCellDataType]), defaultDataTypes);

        if (!mergedExtendedDataTypeDefinition) {
          return void 0;
        }

        mergedDataTypeDefinition = this.mergeDataTypeDefinitions(mergedExtendedDataTypeDefinition, dataTypeDefinition);
      }

      return __spreadProps(__spreadValues({}, mergedDataTypeDefinition), {
        groupSafeValueFormatter: this.createGroupSafeValueFormatter(mergedDataTypeDefinition)
      });
    }
  }, {
    key: "validateDataTypeDefinition",
    value: function validateDataTypeDefinition(dataTypeDefinition, parentDataTypeDefinition, parentCellDataType) {
      if (!parentDataTypeDefinition) {
        _warnOnce("The data type definition ".concat(parentCellDataType, " does not exist."));

        return false;
      }

      if (parentDataTypeDefinition.baseDataType !== dataTypeDefinition.baseDataType) {
        _warnOnce('The "baseDataType" property of a data type definition must match that of its parent.');

        return false;
      }

      return true;
    }
  }, {
    key: "createGroupSafeValueFormatter",
    value: function createGroupSafeValueFormatter(dataTypeDefinition) {
      var _this634 = this;

      if (!dataTypeDefinition.valueFormatter) {
        return void 0;
      }

      return function (params) {
        var _a, _b;

        if ((_a = params.node) == null ? void 0 : _a.group) {
          var aggFunc = params.column.getAggFunc();

          if (aggFunc) {
            if (aggFunc === "first" || aggFunc === "last") {
              return dataTypeDefinition.valueFormatter(params);
            }

            if (dataTypeDefinition.baseDataType === "number" && aggFunc !== "count") {
              if (typeof params.value === "number") {
                return dataTypeDefinition.valueFormatter(params);
              }

              if (typeof params.value === "object") {
                if (!params.value) {
                  return void 0;
                }

                if ("toNumber" in params.value) {
                  return dataTypeDefinition.valueFormatter(__spreadProps(__spreadValues({}, params), {
                    value: params.value.toNumber()
                  }));
                }

                if ("value" in params.value) {
                  return dataTypeDefinition.valueFormatter(__spreadProps(__spreadValues({}, params), {
                    value: params.value.value
                  }));
                }
              }
            }
          }

          if (!_this634.gos.get("suppressGroupMaintainValueType")) {
            return void 0;
          }
        } else if (_this634.groupHideOpenParents && params.column.isRowGroupActive()) {
          if (typeof params.value !== "string" || ((_b = dataTypeDefinition.dataTypeMatcher) == null ? void 0 : _b.call(dataTypeDefinition, params.value))) {
            return dataTypeDefinition.valueFormatter(params);
          }

          if (!_this634.gos.get("suppressGroupMaintainValueType")) {
            return void 0;
          }
        }

        return dataTypeDefinition.valueFormatter(params);
      };
    }
  }, {
    key: "updateColDefAndGetDataTypeDefinitionColumnType",
    value: function updateColDefAndGetDataTypeDefinitionColumnType(colDef, userColDef, colId) {
      var cellDataType = userColDef.cellDataType;
      var field = userColDef.field;

      if (cellDataType === void 0) {
        cellDataType = colDef.cellDataType;
      }

      if (cellDataType == null || cellDataType === true) {
        cellDataType = this.canInferCellDataType(colDef, userColDef) ? this.inferCellDataType(field, colId) : false;
      }

      if (!cellDataType) {
        colDef.cellDataType = false;
        return void 0;
      }

      var dataTypeDefinition = this.dataTypeDefinitions[cellDataType];

      if (!dataTypeDefinition) {
        _warnOnce("Missing data type definition - \"".concat(cellDataType, "\""));

        return void 0;
      }

      colDef.cellDataType = cellDataType;

      if (dataTypeDefinition.groupSafeValueFormatter) {
        colDef.valueFormatter = dataTypeDefinition.groupSafeValueFormatter;
      }

      if (dataTypeDefinition.valueParser) {
        colDef.valueParser = dataTypeDefinition.valueParser;
      }

      if (!dataTypeDefinition.suppressDefaultProperties) {
        this.setColDefPropertiesForBaseDataType(colDef, dataTypeDefinition, colId);
      }

      return dataTypeDefinition.columnTypes;
    }
  }, {
    key: "updateColDefAndGetColumnType",
    value: function updateColDefAndGetColumnType(colDef, userColDef, colId) {
      var _a, _b;

      var dataTypeDefinitionColumnType = this.updateColDefAndGetDataTypeDefinitionColumnType(colDef, userColDef, colId);
      var columnTypes = (_b = (_a = userColDef.type) != null ? _a : dataTypeDefinitionColumnType) != null ? _b : colDef.type;
      colDef.type = columnTypes;
      return columnTypes ? this.convertColumnTypes(columnTypes) : void 0;
    }
  }, {
    key: "addColumnListeners",
    value: function addColumnListeners(column) {
      if (!this.isWaitingForRowData) {
        return;
      }

      var columnStateUpdates = this.columnStateUpdatesPendingInference[column.getColId()];

      if (!columnStateUpdates) {
        return;
      }

      var columnListener = function columnListener(event) {
        columnStateUpdates.add(event.key);
      };

      column.addEventListener(_Column2.EVENT_STATE_UPDATED, columnListener);
      this.columnStateUpdateListenerDestroyFuncs.push(function () {
        return column.removeEventListener(_Column2.EVENT_STATE_UPDATED, columnListener);
      });
    }
  }, {
    key: "canInferCellDataType",
    value: function canInferCellDataType(colDef, userColDef) {
      var _this635 = this;

      var _a;

      if (this.rowModel.getType() !== "clientSide") {
        return false;
      }

      var propsToCheckForInference = {
        cellRenderer: true,
        valueGetter: true,
        valueParser: true,
        refData: true
      };

      if (this.doColDefPropsPreventInference(userColDef, propsToCheckForInference)) {
        return false;
      }

      var columnTypes = userColDef.type === null ? colDef.type : userColDef.type;

      if (columnTypes) {
        var columnTypeDefs = (_a = this.gos.get("columnTypes")) != null ? _a : {};
        var hasPropsPreventingInference = this.convertColumnTypes(columnTypes).some(function (columnType) {
          var columnTypeDef = columnTypeDefs[columnType.trim()];
          return columnTypeDef && _this635.doColDefPropsPreventInference(columnTypeDef, propsToCheckForInference);
        });

        if (hasPropsPreventingInference) {
          return false;
        }
      }

      return !this.doColDefPropsPreventInference(colDef, propsToCheckForInference);
    }
  }, {
    key: "doColDefPropsPreventInference",
    value: function doColDefPropsPreventInference(colDef, propsToCheckForInference) {
      var _this636 = this;

      return [["cellRenderer", "agSparklineCellRenderer"], ["valueGetter", void 0], ["valueParser", void 0], ["refData", void 0]].some(function (_ref69) {
        var _ref70 = _slicedToArray(_ref69, 2),
            prop = _ref70[0],
            comparisonValue = _ref70[1];

        return _this636.doesColDefPropPreventInference(colDef, propsToCheckForInference, prop, comparisonValue);
      });
    }
  }, {
    key: "doesColDefPropPreventInference",
    value: function doesColDefPropPreventInference(colDef, checkProps, prop, comparisonValue) {
      if (!checkProps[prop]) {
        return false;
      }

      var value = colDef[prop];

      if (value === null) {
        checkProps[prop] = false;
        return false;
      } else {
        return comparisonValue === void 0 ? !!value : value === comparisonValue;
      }
    }
  }, {
    key: "inferCellDataType",
    value: function inferCellDataType(field, colId) {
      var _a;

      if (!field) {
        return void 0;
      }

      var value;
      var initialData = this.getInitialData();

      if (initialData) {
        var fieldContainsDots = field.indexOf(".") >= 0 && !this.gos.get("suppressFieldDotNotation");
        value = _getValueUsingField(initialData, field, fieldContainsDots);
      } else {
        this.initWaitForRowData(colId);
      }

      if (value == null) {
        return void 0;
      }

      var _ref71 = (_a = Object.entries(this.dataTypeMatchers).find(function (_ref73) {
        var _ref74 = _slicedToArray(_ref73, 2),
            _cellDataType = _ref74[0],
            dataTypeMatcher = _ref74[1];

        return dataTypeMatcher(value);
      })) != null ? _a : ["object"],
          _ref72 = _slicedToArray(_ref71, 1),
          cellDataType = _ref72[0];

      return cellDataType;
    }
  }, {
    key: "getInitialData",
    value: function getInitialData() {
      var rowData = this.gos.get("rowData");

      if (rowData == null ? void 0 : rowData.length) {
        return rowData[0];
      } else if (this.initialData) {
        return this.initialData;
      } else {
        var rowNodes = this.rowModel.getRootNode().allLeafChildren;

        if (rowNodes == null ? void 0 : rowNodes.length) {
          return rowNodes[0].data;
        }
      }

      return null;
    }
  }, {
    key: "initWaitForRowData",
    value: function initWaitForRowData(colId) {
      var _this637 = this;

      this.columnStateUpdatesPendingInference[colId] =
      /* @__PURE__ */
      new Set();

      if (this.isWaitingForRowData) {
        return;
      }

      this.isWaitingForRowData = true;
      var columnTypeOverridesExist = this.isColumnTypeOverrideInDataTypeDefinitions;

      if (columnTypeOverridesExist) {
        this.columnModel.queueResizeOperations();
      }

      var destroyFunc = this.addManagedListener(this.eventService, _Events.EVENT_ROW_DATA_UPDATE_STARTED, function (event) {
        var firstRowData = event.firstRowData;

        if (!firstRowData) {
          return;
        }

        destroyFunc == null ? void 0 : destroyFunc();
        _this637.isWaitingForRowData = false;

        _this637.processColumnsPendingInference(firstRowData, columnTypeOverridesExist);

        _this637.columnStateUpdatesPendingInference = {};

        if (columnTypeOverridesExist) {
          _this637.columnModel.processResizeOperations();
        }

        var dataTypesInferredEvent = {
          type: _Events.EVENT_DATA_TYPES_INFERRED
        };

        _this637.eventService.dispatchEvent(dataTypesInferredEvent);
      });
    }
  }, {
    key: "isPendingInference",
    value: function isPendingInference() {
      return this.isWaitingForRowData;
    }
  }, {
    key: "processColumnsPendingInference",
    value: function processColumnsPendingInference(firstRowData, columnTypeOverridesExist) {
      var _this638 = this;

      this.initialData = firstRowData;
      var state = [];
      this.columnStateUpdateListenerDestroyFuncs.forEach(function (destroyFunc) {
        return destroyFunc();
      });
      this.columnStateUpdateListenerDestroyFuncs = [];
      var newRowGroupColumnStateWithoutIndex = {};
      var newPivotColumnStateWithoutIndex = {};
      Object.entries(this.columnStateUpdatesPendingInference).forEach(function (_ref75) {
        var _ref76 = _slicedToArray(_ref75, 2),
            colId = _ref76[0],
            columnStateUpdates = _ref76[1];

        var column = _this638.columnModel.getGridColumn(colId);

        if (!column) {
          return;
        }

        var oldColDef = column.getColDef();

        if (!_this638.columnModel.resetColumnDefIntoColumn(column, "cellDataTypeInferred")) {
          return;
        }

        var newColDef = column.getColDef();

        if (columnTypeOverridesExist && newColDef.type && newColDef.type !== oldColDef.type) {
          var updatedColumnState = _this638.getUpdatedColumnState(column, columnStateUpdates);

          if (updatedColumnState.rowGroup && updatedColumnState.rowGroupIndex == null) {
            newRowGroupColumnStateWithoutIndex[colId] = updatedColumnState;
          }

          if (updatedColumnState.pivot && updatedColumnState.pivotIndex == null) {
            newPivotColumnStateWithoutIndex[colId] = updatedColumnState;
          }

          state.push(updatedColumnState);
        }
      });

      if (columnTypeOverridesExist) {
        state.push.apply(state, _toConsumableArray(this.columnModel.generateColumnStateForRowGroupAndPivotIndexes(newRowGroupColumnStateWithoutIndex, newPivotColumnStateWithoutIndex)));
      }

      if (state.length) {
        this.columnModel.applyColumnState({
          state: state
        }, "cellDataTypeInferred");
      }

      this.initialData = null;
    }
  }, {
    key: "getUpdatedColumnState",
    value: function getUpdatedColumnState(column, columnStateUpdates) {
      var columnState = this.columnModel.getColumnStateFromColDef(column);
      columnStateUpdates.forEach(function (key) {
        delete columnState[key];

        if (key === "rowGroup") {
          delete columnState.rowGroupIndex;
        } else if (key === "pivot") {
          delete columnState.pivotIndex;
        }
      });
      return columnState;
    }
  }, {
    key: "checkObjectValueHandlers",
    value: function checkObjectValueHandlers(defaultDataTypes) {
      var resolvedObjectDataTypeDefinition = this.dataTypeDefinitions.object;
      var defaultObjectDataTypeDefinition = defaultDataTypes.object;
      this.hasObjectValueParser = resolvedObjectDataTypeDefinition.valueParser !== defaultObjectDataTypeDefinition.valueParser;
      this.hasObjectValueFormatter = resolvedObjectDataTypeDefinition.valueFormatter !== defaultObjectDataTypeDefinition.valueFormatter;
    }
  }, {
    key: "convertColumnTypes",
    value: function convertColumnTypes(type) {
      var typeKeys = [];

      if (type instanceof Array) {
        var invalidArray = type.some(function (a) {
          return typeof a !== "string";
        });

        if (invalidArray) {
          console.warn("if colDef.type is supplied an array it should be of type 'string[]'");
        } else {
          typeKeys = type;
        }
      } else if (typeof type === "string") {
        typeKeys = type.split(",");
      } else {
        console.warn("colDef.type should be of type 'string' | 'string[]'");
      }

      return typeKeys;
    }
  }, {
    key: "getDateStringTypeDefinition",
    value: function getDateStringTypeDefinition(column) {
      var _a;

      if (!column) {
        return this.dataTypeDefinitions.dateString;
      }

      return (_a = this.getDataTypeDefinition(column)) != null ? _a : this.dataTypeDefinitions.dateString;
    }
  }, {
    key: "getDateParserFunction",
    value: function getDateParserFunction(column) {
      return this.getDateStringTypeDefinition(column).dateParser;
    }
  }, {
    key: "getDateFormatterFunction",
    value: function getDateFormatterFunction(column) {
      return this.getDateStringTypeDefinition(column).dateFormatter;
    }
  }, {
    key: "getDataTypeDefinition",
    value: function getDataTypeDefinition(column) {
      var colDef = column.getColDef();

      if (!colDef.cellDataType) {
        return void 0;
      }

      return this.dataTypeDefinitions[colDef.cellDataType];
    }
  }, {
    key: "getBaseDataType",
    value: function getBaseDataType(column) {
      var _a;

      return (_a = this.getDataTypeDefinition(column)) == null ? void 0 : _a.baseDataType;
    }
  }, {
    key: "checkType",
    value: function checkType(column, value) {
      var _a;

      if (value == null) {
        return true;
      }

      var dataTypeMatcher = (_a = this.getDataTypeDefinition(column)) == null ? void 0 : _a.dataTypeMatcher;

      if (!dataTypeMatcher) {
        return true;
      }

      return dataTypeMatcher(value);
    }
  }, {
    key: "validateColDef",
    value: function validateColDef(colDef) {
      if (colDef.cellDataType === "object") {
        if (colDef.valueFormatter === this.dataTypeDefinitions.object.groupSafeValueFormatter && !this.hasObjectValueFormatter) {
          _warnOnce('Cell data type is "object" but no value formatter has been provided. Please either provide an object data type definition with a value formatter, or set "colDef.valueFormatter"');
        }

        if (colDef.editable && colDef.valueParser === this.dataTypeDefinitions.object.valueParser && !this.hasObjectValueParser) {
          _warnOnce('Cell data type is "object" but no value parser has been provided. Please either provide an object data type definition with a value parser, or set "colDef.valueParser"');
        }
      }
    }
  }, {
    key: "setColDefPropertiesForBaseDataType",
    value: function setColDefPropertiesForBaseDataType(colDef, dataTypeDefinition, colId) {
      var _this639 = this;

      var formatValue = function formatValue(column, node, value) {
        var valueFormatter = column.getColDef().valueFormatter;

        if (valueFormatter === dataTypeDefinition.groupSafeValueFormatter) {
          valueFormatter = dataTypeDefinition.valueFormatter;
        }

        return _this639.valueService.formatValue(column, node, value, valueFormatter);
      };

      var usingSetFilter = _ModuleRegistry2.__isRegistered("@ag-grid-enterprise/set-filter"
      /* SetFilterModule */
      , this.context.getGridId());

      var translate = this.localeService.getLocaleTextFunc();

      var mergeFilterParams = function mergeFilterParams(params) {
        var filterParams = colDef.filterParams;
        colDef.filterParams = typeof filterParams === "object" ? __spreadValues(__spreadValues({}, filterParams), params) : params;
      };

      switch (dataTypeDefinition.baseDataType) {
        case "number":
          {
            colDef.cellEditor = "agNumberCellEditor";

            if (usingSetFilter) {
              mergeFilterParams({
                comparator: function comparator(a, b) {
                  var valA = a == null ? 0 : parseInt(a);
                  var valB = b == null ? 0 : parseInt(b);
                  if (valA === valB) return 0;
                  return valA > valB ? 1 : -1;
                }
              });
            }

            break;
          }

        case "boolean":
          {
            colDef.cellEditor = "agCheckboxCellEditor";
            colDef.cellRenderer = "agCheckboxCellRenderer";

            colDef.suppressKeyboardEvent = function (params) {
              return !!params.colDef.editable && params.event.key === _KeyCode.SPACE;
            };

            if (usingSetFilter) {
              mergeFilterParams({
                valueFormatter: function valueFormatter(params) {
                  if (!_exists(params.value)) {
                    return translate("blanks", "(Blanks)");
                  }

                  return translate(String(params.value), params.value ? "True" : "False");
                }
              });
            } else {
              mergeFilterParams({
                maxNumConditions: 1,
                debounceMs: 0,
                filterOptions: ["empty", {
                  displayKey: "true",
                  displayName: "True",
                  predicate: function predicate(_filterValues, cellValue) {
                    return cellValue;
                  },
                  numberOfInputs: 0
                }, {
                  displayKey: "false",
                  displayName: "False",
                  predicate: function predicate(_filterValues, cellValue) {
                    return cellValue === false;
                  },
                  numberOfInputs: 0
                }]
              });
            }

            break;
          }

        case "date":
          {
            colDef.cellEditor = "agDateCellEditor";

            colDef.keyCreator = function (params) {
              return formatValue(params.column, params.node, params.value);
            };

            if (usingSetFilter) {
              mergeFilterParams({
                valueFormatter: function valueFormatter(params) {
                  var valueFormatted = formatValue(params.column, params.node, params.value);
                  return _exists(valueFormatted) ? valueFormatted : translate("blanks", "(Blanks)");
                },
                treeList: true,
                treeListFormatter: function treeListFormatter(pathKey, level) {
                  if (level === 1 && pathKey != null) {
                    var monthKey = MONTH_KEYS[Number(pathKey) - 1];
                    return translate(monthKey, MONTH_LOCALE_TEXT[monthKey]);
                  }

                  return pathKey != null ? pathKey : translate("blanks", "(Blanks)");
                }
              });
            }

            break;
          }

        case "dateString":
          {
            colDef.cellEditor = "agDateStringCellEditor";

            colDef.keyCreator = function (params) {
              return formatValue(params.column, params.node, params.value);
            };

            var convertToDate = dataTypeDefinition.dateParser;

            if (usingSetFilter) {
              mergeFilterParams({
                valueFormatter: function valueFormatter(params) {
                  var valueFormatted = formatValue(params.column, params.node, params.value);
                  return _exists(valueFormatted) ? valueFormatted : translate("blanks", "(Blanks)");
                },
                treeList: true,
                treeListPathGetter: function treeListPathGetter(value) {
                  var date = convertToDate(value != null ? value : void 0);
                  return date ? [String(date.getFullYear()), String(date.getMonth() + 1), String(date.getDate())] : null;
                },
                treeListFormatter: function treeListFormatter(pathKey, level) {
                  if (level === 1 && pathKey != null) {
                    var monthKey = MONTH_KEYS[Number(pathKey) - 1];
                    return translate(monthKey, MONTH_LOCALE_TEXT[monthKey]);
                  }

                  return pathKey != null ? pathKey : translate("blanks", "(Blanks)");
                }
              });
            } else {
              mergeFilterParams({
                comparator: function comparator(filterDate, cellValue) {
                  var cellAsDate = convertToDate(cellValue);

                  if (cellValue == null || cellAsDate < filterDate) {
                    return -1;
                  }

                  if (cellAsDate > filterDate) {
                    return 1;
                  }

                  return 0;
                }
              });
            }

            break;
          }

        case "object":
          {
            colDef.cellEditorParams = {
              useFormatter: true
            };

            colDef.comparator = function (a, b) {
              var column = _this639.columnModel.getPrimaryColumn(colId);

              var colDef2 = column == null ? void 0 : column.getColDef();

              if (!column || !colDef2) {
                return 0;
              }

              var valA = a == null ? "" : formatValue(column, null, a);
              var valB = b == null ? "" : formatValue(column, null, b);
              if (valA === valB) return 0;
              return valA > valB ? 1 : -1;
            };

            colDef.keyCreator = function (params) {
              return formatValue(params.column, params.node, params.value);
            };

            if (usingSetFilter) {
              mergeFilterParams({
                valueFormatter: function valueFormatter(params) {
                  var valueFormatted = formatValue(params.column, params.node, params.value);
                  return _exists(valueFormatted) ? valueFormatted : translate("blanks", "(Blanks)");
                }
              });
            } else {
              colDef.filterValueGetter = function (params) {
                return formatValue(params.column, params.node, _this639.valueService.getValue(params.column, params.node));
              };
            }

            break;
          }
      }
    }
  }, {
    key: "getDefaultDataTypes",
    value: function getDefaultDataTypes() {
      var defaultDateFormatMatcher = function defaultDateFormatMatcher(value) {
        return !!value.match("^\\d{4}-\\d{2}-\\d{2}$");
      };

      var translate = this.localeService.getLocaleTextFunc();
      return {
        number: {
          baseDataType: "number",
          // can be empty space with legacy copy
          valueParser: function valueParser(params) {
            var _a, _b;

            return ((_b = (_a = params.newValue) == null ? void 0 : _a.trim) == null ? void 0 : _b.call(_a)) === "" ? null : Number(params.newValue);
          },
          valueFormatter: function valueFormatter(params) {
            if (params.value == null) {
              return "";
            }

            if (typeof params.value !== "number" || isNaN(params.value)) {
              return translate("invalidNumber", "Invalid Number");
            }

            return String(params.value);
          },
          dataTypeMatcher: function dataTypeMatcher(value) {
            return typeof value === "number";
          }
        },
        text: {
          baseDataType: "text",
          valueParser: function valueParser(params) {
            return params.newValue === "" ? null : _toStringOrNull(params.newValue);
          },
          dataTypeMatcher: function dataTypeMatcher(value) {
            return typeof value === "string";
          }
        },
        boolean: {
          baseDataType: "boolean",
          valueParser: function valueParser(params) {
            var _a, _b;

            if (params.newValue == null) {
              return params.newValue;
            }

            return ((_b = (_a = params.newValue) == null ? void 0 : _a.trim) == null ? void 0 : _b.call(_a)) === "" ? null : String(params.newValue).toLowerCase() === "true";
          },
          valueFormatter: function valueFormatter(params) {
            return params.value == null ? "" : String(params.value);
          },
          dataTypeMatcher: function dataTypeMatcher(value) {
            return typeof value === "boolean";
          }
        },
        date: {
          baseDataType: "date",
          valueParser: function valueParser(params) {
            return _parseDateTimeFromString(params.newValue == null ? null : String(params.newValue));
          },
          valueFormatter: function valueFormatter(params) {
            var _a;

            if (params.value == null) {
              return "";
            }

            if (!(params.value instanceof Date) || isNaN(params.value.getTime())) {
              return translate("invalidDate", "Invalid Date");
            }

            return (_a = _serialiseDate(params.value, false)) != null ? _a : "";
          },
          dataTypeMatcher: function dataTypeMatcher(value) {
            return value instanceof Date;
          }
        },
        dateString: {
          baseDataType: "dateString",
          dateParser: function dateParser(value) {
            var _a;

            return (_a = _parseDateTimeFromString(value)) != null ? _a : void 0;
          },
          dateFormatter: function dateFormatter(value) {
            var _a;

            return (_a = _serialiseDate(value != null ? value : null, false)) != null ? _a : void 0;
          },
          valueParser: function valueParser(params) {
            return defaultDateFormatMatcher(String(params.newValue)) ? params.newValue : null;
          },
          valueFormatter: function valueFormatter(params) {
            return defaultDateFormatMatcher(String(params.value)) ? params.value : "";
          },
          dataTypeMatcher: function dataTypeMatcher(value) {
            return typeof value === "string" && defaultDateFormatMatcher(value);
          }
        },
        object: {
          baseDataType: "object",
          valueParser: function valueParser() {
            return null;
          },
          valueFormatter: function valueFormatter(params) {
            var _a;

            return (_a = _toStringOrNull(params.value)) != null ? _a : "";
          }
        }
      };
    }
  }]);

  return _DataTypeService;
}(_BeanStub2);

__decorateClass([_Autowired("rowModel")], _DataTypeService.prototype, "rowModel", 2);

__decorateClass([_Autowired("columnModel")], _DataTypeService.prototype, "columnModel", 2);

__decorateClass([_Autowired("valueService")], _DataTypeService.prototype, "valueService", 2);

__decorateClass([_PostConstruct], _DataTypeService.prototype, "init", 1);

_DataTypeService = __decorateClass([_Bean("dataTypeService")], _DataTypeService); // community-modules/core/src/syncService.ts

var SyncService =
/*#__PURE__*/
function (_BeanStub103) {
  "use strict";

  _inherits(SyncService, _BeanStub103);

  function SyncService() {
    var _this640;

    _classCallCheck(this, SyncService);

    _this640 = _possibleConstructorReturn(this, _getPrototypeOf(SyncService).apply(this, arguments));
    _this640.waitingForColumns = false;
    return _this640;
  }

  _createClass(SyncService, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this641 = this;

      this.addManagedPropertyListener("columnDefs", function (event) {
        return _this641.setColumnDefs(event);
      });
    }
  }, {
    key: "start",
    value: function start() {
      var _this642 = this;

      this.ctrlsService.whenReady(function () {
        var columnDefs = _this642.gos.get("columnDefs");

        if (columnDefs) {
          _this642.setColumnsAndData(columnDefs);
        } else {
          _this642.waitingForColumns = true;
        }

        _this642.gridReady();
      });
    }
  }, {
    key: "setColumnsAndData",
    value: function setColumnsAndData(columnDefs) {
      this.columnModel.setColumnDefs(columnDefs != null ? columnDefs : [], "gridInitializing");
      this.rowModel.start();
    }
  }, {
    key: "gridReady",
    value: function gridReady() {
      var _this643 = this;

      this.dispatchGridReadyEvent();

      var isEnterprise = _ModuleRegistry2.__isRegistered("@ag-grid-enterprise/core"
      /* EnterpriseCoreModule */
      , this.context.getGridId());

      var logger = new _Logger("AG Grid", function () {
        return _this643.gos.get("debug");
      });
      logger.log("initialised successfully, enterprise = ".concat(isEnterprise));
    }
  }, {
    key: "dispatchGridReadyEvent",
    value: function dispatchGridReadyEvent() {
      var readyEvent = {
        type: _Events.EVENT_GRID_READY
      };
      this.eventService.dispatchEvent(readyEvent);
    }
  }, {
    key: "setColumnDefs",
    value: function setColumnDefs(event) {
      var columnDefs = this.gos.get("columnDefs");

      if (!columnDefs) {
        return;
      }

      if (this.waitingForColumns) {
        this.waitingForColumns = false;
        this.setColumnsAndData(columnDefs);
        return;
      }

      this.columnModel.setColumnDefs(columnDefs, convertSourceType(event.source));
    }
  }]);

  return SyncService;
}(_BeanStub2);

__decorateClass([_Autowired("ctrlsService")], SyncService.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("columnModel")], SyncService.prototype, "columnModel", 2);

__decorateClass([_Autowired("rowModel")], SyncService.prototype, "rowModel", 2);

__decorateClass([_PostConstruct], SyncService.prototype, "postConstruct", 1);

SyncService = __decorateClass([_Bean("syncService")], SyncService); // community-modules/core/src/rendering/overlays/overlayService.ts

var OverlayService =
/*#__PURE__*/
function (_BeanStub104) {
  "use strict";

  _inherits(OverlayService, _BeanStub104);

  function OverlayService() {
    var _this644;

    _classCallCheck(this, OverlayService);

    _this644 = _possibleConstructorReturn(this, _getPrototypeOf(OverlayService).apply(this, arguments));
    _this644.manuallyDisplayed = false;
    return _this644;
  }

  _createClass(OverlayService, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this645 = this;

      this.addManagedListener(this.eventService, _Events.EVENT_ROW_DATA_UPDATED, function () {
        return _this645.onRowDataUpdated();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_NEW_COLUMNS_LOADED, function () {
        return _this645.onNewColumnsLoaded();
      });
    }
  }, {
    key: "registerOverlayWrapperComp",
    value: function registerOverlayWrapperComp(overlayWrapperComp) {
      this.overlayWrapperComp = overlayWrapperComp;

      if (!this.gos.get("columnDefs") || this.gos.isRowModelType("clientSide") && !this.gos.get("rowData")) {
        this.showLoadingOverlay();
      }
    }
  }, {
    key: "showLoadingOverlay",
    value: function showLoadingOverlay() {
      if (this.gos.get("suppressLoadingOverlay")) {
        return;
      }

      var params = {};
      var compDetails = this.userComponentFactory.getLoadingOverlayCompDetails(params);
      this.showOverlay(compDetails, "ag-overlay-loading-wrapper", "loadingOverlayComponentParams");
    }
  }, {
    key: "showNoRowsOverlay",
    value: function showNoRowsOverlay() {
      if (this.gos.get("suppressNoRowsOverlay")) {
        return;
      }

      var params = {};
      var compDetails = this.userComponentFactory.getNoRowsOverlayCompDetails(params);
      this.showOverlay(compDetails, "ag-overlay-no-rows-wrapper", "noRowsOverlayComponentParams");
    }
  }, {
    key: "showOverlay",
    value: function showOverlay(compDetails, wrapperCssClass, gridOption) {
      var _this646 = this;

      var promise = compDetails.newAgStackInstance();
      var listenerDestroyFunc = this.addManagedPropertyListener(gridOption, function (_ref77) {
        var currentValue = _ref77.currentValue;
        promise.then(function (comp) {
          if (comp.refresh) {
            comp.refresh(_this646.gos.addGridCommonParams(__spreadValues({}, currentValue != null ? currentValue : {})));
          }
        });
      });
      this.manuallyDisplayed = this.columnModel.isReady() && !this.paginationProxy.isEmpty();
      this.overlayWrapperComp.showOverlay(promise, wrapperCssClass, listenerDestroyFunc);
    }
  }, {
    key: "hideOverlay",
    value: function hideOverlay() {
      this.manuallyDisplayed = false;
      this.overlayWrapperComp.hideOverlay();
    }
  }, {
    key: "showOrHideOverlay",
    value: function showOrHideOverlay() {
      var isEmpty = this.paginationProxy.isEmpty();
      var isSuppressNoRowsOverlay = this.gos.get("suppressNoRowsOverlay");

      if (isEmpty && !isSuppressNoRowsOverlay) {
        this.showNoRowsOverlay();
      } else {
        this.hideOverlay();
      }
    }
  }, {
    key: "onRowDataUpdated",
    value: function onRowDataUpdated() {
      this.showOrHideOverlay();
    }
  }, {
    key: "onNewColumnsLoaded",
    value: function onNewColumnsLoaded() {
      if (this.columnModel.isReady() && !this.paginationProxy.isEmpty() && !this.manuallyDisplayed) {
        this.hideOverlay();
      }
    }
  }]);

  return OverlayService;
}(_BeanStub2);

__decorateClass([_Autowired("userComponentFactory")], OverlayService.prototype, "userComponentFactory", 2);

__decorateClass([_Autowired("paginationProxy")], OverlayService.prototype, "paginationProxy", 2);

__decorateClass([_Autowired("columnModel")], OverlayService.prototype, "columnModel", 2);

__decorateClass([_PostConstruct], OverlayService.prototype, "postConstruct", 1);

OverlayService = __decorateClass([_Bean("overlayService")], OverlayService); // community-modules/core/src/misc/stateService.ts

var StateService =
/*#__PURE__*/
function (_BeanStub105) {
  "use strict";

  _inherits(StateService, _BeanStub105);

  function StateService() {
    var _this647;

    _classCallCheck(this, StateService);

    _this647 = _possibleConstructorReturn(this, _getPrototypeOf(StateService).apply(this, arguments));
    _this647.suppressEvents = true;
    _this647.queuedUpdateSources =
    /* @__PURE__ */
    new Set();
    _this647.dispatchStateUpdateEventDebounced = _debounce(function () {
      return _this647.dispatchQueuedStateUpdateEvents();
    }, 0); // If user is doing a manual expand all node by node, we don't want to process one at a time.
    // EVENT_ROW_GROUP_OPENED is already async, so no impact of making the state async here.

    _this647.onRowGroupOpenedDebounced = _debounce(function () {
      return _this647.updateCachedState("rowGroupExpansion", _this647.getRowGroupExpansionState());
    }, 0); // similar to row expansion, want to debounce. However, selection is synchronous, so need to mark as stale in case `getState` is called.

    _this647.onRowSelectedDebounced = _debounce(function () {
      _this647.staleStateKeys.delete("rowSelection");

      _this647.updateCachedState("rowSelection", _this647.getRowSelectionState());
    }, 0);
    _this647.staleStateKeys =
    /* @__PURE__ */
    new Set();
    return _this647;
  }

  _createClass(StateService, [{
    key: "postConstruct",
    value: function postConstruct() {
      var _this648 = this;

      var _a;

      this.isClientSideRowModel = this.rowModel.getType() === "clientSide";
      this.cachedState = (_a = this.gos.get("initialState")) != null ? _a : {};
      this.ctrlsService.whenReady(function () {
        return _this648.suppressEventsAndDispatchInitEvent(function () {
          return _this648.setupStateOnGridReady();
        });
      });
      var newColumnsLoadedDestroyFunc = this.addManagedListener(this.eventService, _Events.EVENT_NEW_COLUMNS_LOADED, function (_ref78) {
        var source = _ref78.source;

        if (source === "gridInitializing") {
          newColumnsLoadedDestroyFunc == null ? void 0 : newColumnsLoadedDestroyFunc();

          _this648.suppressEventsAndDispatchInitEvent(function () {
            return _this648.setupStateOnColumnsInitialised();
          });
        }
      });
      var rowCountReadyDestroyFunc = this.addManagedListener(this.eventService, _Events.EVENT_ROW_COUNT_READY, function () {
        rowCountReadyDestroyFunc == null ? void 0 : rowCountReadyDestroyFunc();

        _this648.suppressEventsAndDispatchInitEvent(function () {
          return _this648.setupStateOnRowCountReady();
        });
      });
      var firstDataRenderedDestroyFunc = this.addManagedListener(this.eventService, _Events.EVENT_FIRST_DATA_RENDERED, function () {
        firstDataRenderedDestroyFunc == null ? void 0 : firstDataRenderedDestroyFunc();

        _this648.suppressEventsAndDispatchInitEvent(function () {
          return _this648.setupStateOnFirstDataRendered();
        });
      });
    }
  }, {
    key: "getState",
    value: function getState() {
      if (this.staleStateKeys.size) {
        this.refreshStaleState();
      }

      return this.cachedState;
    }
  }, {
    key: "setupStateOnGridReady",
    value: function setupStateOnGridReady() {
      var _this649 = this;

      this.updateCachedState("sideBar", this.getSideBarState());
      this.addManagedListener(this.eventService, _Events.EVENT_TOOL_PANEL_VISIBLE_CHANGED, function () {
        return _this649.updateCachedState("sideBar", _this649.getSideBarState());
      });
      this.addManagedListener(this.eventService, _Events.EVENT_SIDE_BAR_UPDATED, function () {
        return _this649.updateCachedState("sideBar", _this649.getSideBarState());
      });
    }
  }, {
    key: "setupStateOnColumnsInitialised",
    value: function setupStateOnColumnsInitialised() {
      var _this650 = this;

      var _a;

      var initialState = (_a = this.gos.get("initialState")) != null ? _a : {};
      this.setColumnState(initialState);
      this.setColumnGroupState(initialState);
      this.updateColumnState(["aggregation", "columnOrder", "columnPinning", "columnSizing", "columnVisibility", "pivot", "pivot", "rowGroup", "sort"]);
      this.updateCachedState("columnGroup", this.getColumnGroupState());
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_VALUE_CHANGED, function () {
        return _this650.updateColumnState(["aggregation"]);
      });
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_MOVED, function () {
        return _this650.updateColumnState(["columnOrder"]);
      });
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_PINNED, function () {
        return _this650.updateColumnState(["columnPinning"]);
      });
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_RESIZED, function () {
        return _this650.updateColumnState(["columnSizing"]);
      });
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_VISIBLE, function () {
        return _this650.updateColumnState(["columnVisibility"]);
      });
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_PIVOT_CHANGED, function () {
        return _this650.updateColumnState(["pivot"]);
      });
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, function () {
        return _this650.updateColumnState(["pivot"]);
      });
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_ROW_GROUP_CHANGED, function () {
        return _this650.updateColumnState(["rowGroup"]);
      });
      this.addManagedListener(this.eventService, _Events.EVENT_SORT_CHANGED, function () {
        return _this650.updateColumnState(["sort"]);
      });
      this.addManagedListener(this.eventService, _Events.EVENT_NEW_COLUMNS_LOADED, function () {
        return _this650.updateColumnState(["aggregation", "columnOrder", "columnPinning", "columnSizing", "columnVisibility", "pivot", "pivot", "rowGroup", "sort"]);
      });
      this.addManagedListener(this.eventService, _Events.EVENT_COLUMN_GROUP_OPENED, function () {
        return _this650.updateCachedState("columnGroup", _this650.getColumnGroupState());
      });
    }
  }, {
    key: "setupStateOnRowCountReady",
    value: function setupStateOnRowCountReady() {
      var _this651 = this;

      var _a;

      var _ref79 = (_a = this.gos.get("initialState")) != null ? _a : {},
          filterState = _ref79.filter,
          rowGroupExpansionState = _ref79.rowGroupExpansion,
          rowSelectionState = _ref79.rowSelection,
          paginationState = _ref79.pagination;

      var advancedFilterModel = this.gos.get("advancedFilterModel");

      if (filterState || advancedFilterModel) {
        this.setFilterState(filterState, advancedFilterModel);
      }

      if (rowGroupExpansionState) {
        this.setRowGroupExpansionState(rowGroupExpansionState);
      }

      if (rowSelectionState) {
        this.setRowSelectionState(rowSelectionState);
      }

      if (paginationState) {
        this.setPaginationState(paginationState);
      }

      this.updateCachedState("filter", this.getFilterState());
      this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState());
      this.updateCachedState("rowSelection", this.getRowSelectionState());
      this.updateCachedState("pagination", this.getPaginationState());
      this.addManagedListener(this.eventService, _Events.EVENT_FILTER_CHANGED, function () {
        return _this651.updateCachedState("filter", _this651.getFilterState());
      });
      this.addManagedListener(this.eventService, _Events.EVENT_ROW_GROUP_OPENED, function () {
        return _this651.onRowGroupOpenedDebounced();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_EXPAND_COLLAPSE_ALL, function () {
        return _this651.updateCachedState("rowGroupExpansion", _this651.getRowGroupExpansionState());
      });
      this.addManagedListener(this.eventService, _Events.EVENT_SELECTION_CHANGED, function () {
        _this651.staleStateKeys.add("rowSelection");

        _this651.onRowSelectedDebounced();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_PAGINATION_CHANGED, function (event) {
        if (event.newPage || event.newPageSize) {
          _this651.updateCachedState("pagination", _this651.getPaginationState());
        }
      });
    }
  }, {
    key: "setupStateOnFirstDataRendered",
    value: function setupStateOnFirstDataRendered() {
      var _this652 = this;

      var _a;

      var _ref80 = (_a = this.gos.get("initialState")) != null ? _a : {},
          scrollState = _ref80.scroll,
          rangeSelectionState = _ref80.rangeSelection,
          focusedCellState = _ref80.focusedCell,
          columnOrderState = _ref80.columnOrder;

      if (focusedCellState) {
        this.setFocusedCellState(focusedCellState);
      }

      if (rangeSelectionState) {
        this.setRangeSelectionState(rangeSelectionState);
      }

      if (scrollState) {
        this.setScrollState(scrollState);
      }

      this.setColumnPivotState(!!(columnOrderState == null ? void 0 : columnOrderState.orderedColIds));
      this.updateCachedState("sideBar", this.getSideBarState());
      this.updateCachedState("focusedCell", this.getFocusedCellState());
      this.updateCachedState("rangeSelection", this.getRangeSelectionState());
      this.updateCachedState("scroll", this.getScrollState());
      this.addManagedListener(this.eventService, _Events.EVENT_CELL_FOCUSED, function () {
        return _this652.updateCachedState("focusedCell", _this652.getFocusedCellState());
      });
      this.addManagedListener(this.eventService, _Events.EVENT_RANGE_SELECTION_CHANGED, function (event) {
        if (event.finished) {
          _this652.updateCachedState("rangeSelection", _this652.getRangeSelectionState());
        }
      });
      this.addManagedListener(this.eventService, _Events.EVENT_BODY_SCROLL_END, function () {
        return _this652.updateCachedState("scroll", _this652.getScrollState());
      });
    }
  }, {
    key: "getColumnState",
    value: function getColumnState() {
      var pivotMode = this.columnModel.isPivotMode();
      var sortColumns = [];
      var groupColIds = [];
      var aggregationColumns = [];
      var pivotColIds = [];
      var leftColIds = [];
      var rightColIds = [];
      var hiddenColIds = [];
      var columnSizes = [];
      var columns = [];
      var columnState = this.columnModel.getColumnState();

      for (var i = 0; i < columnState.length; i++) {
        var _columnState$i = columnState[i],
            colId = _columnState$i.colId,
            sort = _columnState$i.sort,
            sortIndex = _columnState$i.sortIndex,
            rowGroup = _columnState$i.rowGroup,
            rowGroupIndex = _columnState$i.rowGroupIndex,
            aggFunc = _columnState$i.aggFunc,
            pivot = _columnState$i.pivot,
            pivotIndex = _columnState$i.pivotIndex,
            pinned = _columnState$i.pinned,
            hide = _columnState$i.hide,
            width = _columnState$i.width,
            flex = _columnState$i.flex;
        columns.push(colId);

        if (sort) {
          sortColumns[sortIndex != null ? sortIndex : 0] = {
            colId: colId,
            sort: sort
          };
        }

        if (rowGroup) {
          groupColIds[rowGroupIndex != null ? rowGroupIndex : 0] = colId;
        }

        if (typeof aggFunc === "string") {
          aggregationColumns.push({
            colId: colId,
            aggFunc: aggFunc
          });
        }

        if (pivot) {
          pivotColIds[pivotIndex != null ? pivotIndex : 0] = colId;
        }

        if (pinned) {
          (pinned === "right" ? rightColIds : leftColIds).push(colId);
        }

        if (hide) {
          hiddenColIds.push(colId);
        }

        if (flex || width) {
          columnSizes.push({
            colId: colId,
            flex: flex != null ? flex : void 0,
            width: width
          });
        }
      }

      return {
        sort: sortColumns.length ? {
          sortModel: sortColumns
        } : void 0,
        rowGroup: groupColIds.length ? {
          groupColIds: groupColIds
        } : void 0,
        aggregation: aggregationColumns.length ? {
          aggregationModel: aggregationColumns
        } : void 0,
        pivot: pivotColIds.length || pivotMode ? {
          pivotMode: pivotMode,
          pivotColIds: pivotColIds
        } : void 0,
        columnPinning: leftColIds.length || rightColIds.length ? {
          leftColIds: leftColIds,
          rightColIds: rightColIds
        } : void 0,
        columnVisibility: hiddenColIds.length ? {
          hiddenColIds: hiddenColIds
        } : void 0,
        columnSizing: columnSizes.length ? {
          columnSizingModel: columnSizes
        } : void 0,
        columnOrder: columns.length ? {
          orderedColIds: columns
        } : void 0
      };
    }
  }, {
    key: "setColumnState",
    value: function setColumnState(initialState) {
      var sortState = initialState.sort,
          groupState = initialState.rowGroup,
          aggregationState = initialState.aggregation,
          pivotState = initialState.pivot,
          columnPinningState = initialState.columnPinning,
          columnVisibilityState = initialState.columnVisibility,
          columnSizingState = initialState.columnSizing,
          columnOrderState = initialState.columnOrder;
      var columnStateMap = {};

      var getColumnState = function getColumnState(colId) {
        var columnState = columnStateMap[colId];

        if (columnState) {
          return columnState;
        }

        columnState = {
          colId: colId
        };
        columnStateMap[colId] = columnState;
        return columnState;
      };

      if (sortState) {
        sortState.sortModel.forEach(function (_ref81, sortIndex) {
          var colId = _ref81.colId,
              sort = _ref81.sort;
          var columnState = getColumnState(colId);
          columnState.sort = sort;
          columnState.sortIndex = sortIndex;
        });
      }

      if (groupState) {
        groupState.groupColIds.forEach(function (colId, rowGroupIndex) {
          var columnState = getColumnState(colId);
          columnState.rowGroup = true;
          columnState.rowGroupIndex = rowGroupIndex;
        });
      }

      if (aggregationState) {
        aggregationState.aggregationModel.forEach(function (_ref82) {
          var colId = _ref82.colId,
              aggFunc = _ref82.aggFunc;
          getColumnState(colId).aggFunc = aggFunc;
        });
      }

      if (pivotState) {
        pivotState.pivotColIds.forEach(function (colId, pivotIndex) {
          var columnState = getColumnState(colId);
          columnState.pivot = true;
          columnState.pivotIndex = pivotIndex;
        });
        this.gos.updateGridOptions({
          options: {
            pivotMode: pivotState.pivotMode
          },
          source: "gridInitializing"
        });
      }

      if (columnPinningState) {
        columnPinningState.leftColIds.forEach(function (colId) {
          getColumnState(colId).pinned = "left";
        });
        columnPinningState.rightColIds.forEach(function (colId) {
          getColumnState(colId).pinned = "right";
        });
      }

      if (columnVisibilityState) {
        columnVisibilityState.hiddenColIds.forEach(function (colId) {
          getColumnState(colId).hide = true;
        });
      }

      if (columnSizingState) {
        columnSizingState.columnSizingModel.forEach(function (_ref83) {
          var colId = _ref83.colId,
              flex = _ref83.flex,
              width = _ref83.width;
          var columnState = getColumnState(colId);
          columnState.flex = flex != null ? flex : null;
          columnState.width = width;
        });
      }

      var columns = columnOrderState == null ? void 0 : columnOrderState.orderedColIds;
      var applyOrder = !!(columns == null ? void 0 : columns.length);
      var columnStates = applyOrder ? columns.map(function (colId) {
        return getColumnState(colId);
      }) : Object.values(columnStateMap);

      if (columnStates.length) {
        this.columnStates = columnStates;
        var defaultState = {
          sort: null,
          sortIndex: null,
          rowGroup: null,
          rowGroupIndex: null,
          aggFunc: null,
          pivot: null,
          pivotIndex: null,
          pinned: null,
          hide: null,
          flex: null
        };
        this.columnModel.applyColumnState({
          state: columnStates,
          applyOrder: applyOrder,
          defaultState: defaultState
        }, "gridInitializing");
      }
    }
  }, {
    key: "setColumnPivotState",
    value: function setColumnPivotState(applyOrder) {
      var columnStates = this.columnStates;
      this.columnStates = void 0;
      var columnGroupStates = this.columnGroupStates;
      this.columnGroupStates = void 0;

      if (!this.columnModel.isSecondaryColumnsPresent()) {
        return;
      }

      if (columnStates) {
        var secondaryColumnStates = [];
        var _iteratorNormalCompletion16 = true;
        var _didIteratorError16 = false;
        var _iteratorError16 = undefined;

        try {
          for (var _iterator16 = columnStates[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
            var columnState = _step16.value;

            if (this.columnModel.getSecondaryColumn(columnState.colId)) {
              secondaryColumnStates.push(columnState);
            }
          }
        } catch (err) {
          _didIteratorError16 = true;
          _iteratorError16 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion16 && _iterator16.return != null) {
              _iterator16.return();
            }
          } finally {
            if (_didIteratorError16) {
              throw _iteratorError16;
            }
          }
        }

        this.columnModel.applyColumnState({
          state: secondaryColumnStates,
          applyOrder: applyOrder
        }, "gridInitializing");
      }

      if (columnGroupStates) {
        this.columnModel.setColumnGroupState(columnGroupStates, "gridInitializing");
      }
    }
  }, {
    key: "getColumnGroupState",
    value: function getColumnGroupState() {
      var columnGroupState = this.columnModel.getColumnGroupState();
      var openColumnGroups = [];
      columnGroupState.forEach(function (_ref84) {
        var groupId = _ref84.groupId,
            open = _ref84.open;

        if (open) {
          openColumnGroups.push(groupId);
        }
      });
      return openColumnGroups.length ? {
        openColumnGroupIds: openColumnGroups
      } : void 0;
    }
  }, {
    key: "setColumnGroupState",
    value: function setColumnGroupState(initialState) {
      var _a;

      if (!initialState.hasOwnProperty("columnGroup")) {
        return;
      }

      var openColumnGroups = new Set((_a = initialState.columnGroup) == null ? void 0 : _a.openColumnGroupIds);
      var existingColumnGroupState = this.columnModel.getColumnGroupState();
      var stateItems = existingColumnGroupState.map(function (_ref85) {
        var groupId = _ref85.groupId;
        var open = openColumnGroups.has(groupId);

        if (open) {
          openColumnGroups.delete(groupId);
        }

        return {
          groupId: groupId,
          open: open
        };
      });
      openColumnGroups.forEach(function (groupId) {
        stateItems.push({
          groupId: groupId,
          open: true
        });
      });

      if (stateItems.length) {
        this.columnGroupStates = stateItems;
      }

      this.columnModel.setColumnGroupState(stateItems, "gridInitializing");
    }
  }, {
    key: "getFilterState",
    value: function getFilterState() {
      var _a;

      var filterModel = this.filterManager.getFilterModel();

      if (filterModel && Object.keys(filterModel).length === 0) {
        filterModel = void 0;
      }

      var advancedFilterModel = (_a = this.filterManager.getAdvancedFilterModel()) != null ? _a : void 0;
      return filterModel || advancedFilterModel ? {
        filterModel: filterModel,
        advancedFilterModel: advancedFilterModel
      } : void 0;
    }
  }, {
    key: "setFilterState",
    value: function setFilterState(filterState, gridOptionAdvancedFilterModel) {
      var _ref86 = filterState != null ? filterState : {
        advancedFilterModel: gridOptionAdvancedFilterModel
      },
          filterModel = _ref86.filterModel,
          advancedFilterModel = _ref86.advancedFilterModel;

      if (filterModel) {
        this.filterManager.setFilterModel(filterModel, "columnFilter");
      }

      if (advancedFilterModel) {
        this.filterManager.setAdvancedFilterModel(advancedFilterModel);
      }
    }
  }, {
    key: "getRangeSelectionState",
    value: function getRangeSelectionState() {
      var _a;

      var cellRanges = (_a = this.rangeService) == null ? void 0 : _a.getCellRanges().map(function (cellRange) {
        var id = cellRange.id,
            type = cellRange.type,
            startRow = cellRange.startRow,
            endRow = cellRange.endRow,
            columns = cellRange.columns,
            startColumn = cellRange.startColumn;
        return {
          id: id,
          type: type,
          startRow: startRow,
          endRow: endRow,
          colIds: columns.map(function (column) {
            return column.getColId();
          }),
          startColId: startColumn.getColId()
        };
      });
      return (cellRanges == null ? void 0 : cellRanges.length) ? {
        cellRanges: cellRanges
      } : void 0;
    }
  }, {
    key: "setRangeSelectionState",
    value: function setRangeSelectionState(rangeSelectionState) {
      var _this653 = this;

      if (!this.gos.get("enableRangeSelection") || !this.rangeService) {
        return;
      }

      var cellRanges = [];
      rangeSelectionState.cellRanges.forEach(function (cellRange) {
        var columns = [];
        cellRange.colIds.forEach(function (colId) {
          var column = _this653.columnModel.getGridColumn(colId);

          if (column) {
            columns.push(column);
          }
        });

        if (!columns.length) {
          return;
        }

        var startColumn = _this653.columnModel.getGridColumn(cellRange.startColId);

        if (!startColumn) {
          var allColumns = _this653.columnModel.getAllDisplayedColumns();

          var columnSet = new Set(columns);
          startColumn = allColumns.find(function (column) {
            return columnSet.has(column);
          });
        }

        cellRanges.push(__spreadProps(__spreadValues({}, cellRange), {
          columns: columns,
          startColumn: startColumn
        }));
      });
      this.rangeService.setCellRanges(cellRanges);
    }
  }, {
    key: "getScrollState",
    value: function getScrollState() {
      var _a, _b, _c;

      if (!this.isClientSideRowModel) {
        return void 0;
      }

      var scrollFeature = (_a = this.ctrlsService.getGridBodyCtrl()) == null ? void 0 : _a.getScrollFeature();

      var _ref87 = (_b = scrollFeature == null ? void 0 : scrollFeature.getHScrollPosition()) != null ? _b : {
        left: 0
      },
          left = _ref87.left;

      var _ref88 = (_c = scrollFeature == null ? void 0 : scrollFeature.getVScrollPosition()) != null ? _c : {
        top: 0
      },
          top = _ref88.top;

      return top || left ? {
        top: top,
        left: left
      } : void 0;
    }
  }, {
    key: "setScrollState",
    value: function setScrollState(scrollState) {
      var _a;

      if (!this.isClientSideRowModel) {
        return;
      }

      var top = scrollState.top,
          left = scrollState.left;
      (_a = this.ctrlsService.getGridBodyCtrl()) == null ? void 0 : _a.getScrollFeature().setScrollPosition(top, left);
    }
  }, {
    key: "getSideBarState",
    value: function getSideBarState() {
      var _a, _b;

      return (_b = (_a = this.sideBarService) == null ? void 0 : _a.getSideBarComp()) == null ? void 0 : _b.getState();
    }
  }, {
    key: "getFocusedCellState",
    value: function getFocusedCellState() {
      if (!this.isClientSideRowModel) {
        return void 0;
      }

      var focusedCell = this.focusService.getFocusedCell();

      if (focusedCell) {
        var column = focusedCell.column,
            rowIndex = focusedCell.rowIndex,
            rowPinned = focusedCell.rowPinned;
        return {
          colId: column.getColId(),
          rowIndex: rowIndex,
          rowPinned: rowPinned
        };
      }

      return void 0;
    }
  }, {
    key: "setFocusedCellState",
    value: function setFocusedCellState(focusedCellState) {
      if (!this.isClientSideRowModel) {
        return;
      }

      var colId = focusedCellState.colId,
          rowIndex = focusedCellState.rowIndex,
          rowPinned = focusedCellState.rowPinned;
      this.focusService.setFocusedCell({
        column: this.columnModel.getGridColumn(colId),
        rowIndex: rowIndex,
        rowPinned: rowPinned,
        forceBrowserFocus: true,
        preventScrollOnBrowserFocus: true
      });
    }
  }, {
    key: "getPaginationState",
    value: function getPaginationState() {
      var page = this.paginationProxy.getCurrentPage();
      var pageSize = !this.gos.get("paginationAutoPageSize") ? this.paginationProxy.getPageSize() : void 0;

      if (!page && !pageSize) {
        return;
      }

      return {
        page: page,
        pageSize: pageSize
      };
    }
  }, {
    key: "setPaginationState",
    value: function setPaginationState(paginationState) {
      if (paginationState.pageSize && !this.gos.get("paginationAutoPageSize")) {
        this.paginationProxy.setPageSize(paginationState.pageSize, "initialState");
      }

      if (typeof paginationState.page === "number") {
        this.paginationProxy.setPage(paginationState.page);
      }
    }
  }, {
    key: "getRowSelectionState",
    value: function getRowSelectionState() {
      var _a;

      var selectionState = this.selectionService.getSelectionState();
      var noSelections = !selectionState || !Array.isArray(selectionState) && (selectionState.selectAll === false || selectionState.selectAllChildren === false) && !((_a = selectionState == null ? void 0 : selectionState.toggledNodes) == null ? void 0 : _a.length);
      return noSelections ? void 0 : selectionState;
    }
  }, {
    key: "setRowSelectionState",
    value: function setRowSelectionState(rowSelectionState) {
      this.selectionService.setSelectionState(rowSelectionState, "gridInitializing");
    }
  }, {
    key: "getRowGroupExpansionState",
    value: function getRowGroupExpansionState() {
      var expandedRowGroups = this.expansionService.getExpandedRows();
      return expandedRowGroups.length ? {
        expandedRowGroupIds: expandedRowGroups
      } : void 0;
    }
  }, {
    key: "setRowGroupExpansionState",
    value: function setRowGroupExpansionState(rowGroupExpansionState) {
      this.expansionService.expandRows(rowGroupExpansionState.expandedRowGroupIds);
    }
  }, {
    key: "updateColumnState",
    value: function updateColumnState(features) {
      var _this654 = this;

      var newColumnState = this.getColumnState();
      var hasChanged = false;
      Object.entries(newColumnState).forEach(function (_ref89) {
        var _ref90 = _slicedToArray(_ref89, 2),
            key = _ref90[0],
            value = _ref90[1];

        if (!_jsonEquals(value, _this654.cachedState[key])) {
          hasChanged = true;
        }
      });
      this.cachedState = __spreadValues(__spreadValues({}, this.cachedState), newColumnState);

      if (hasChanged) {
        this.dispatchStateUpdateEvent(features);
      }
    }
  }, {
    key: "updateCachedState",
    value: function updateCachedState(key, value) {
      var existingValue = this.cachedState[key];
      this.setCachedStateValue(key, value);

      if (!_jsonEquals(value, existingValue)) {
        this.dispatchStateUpdateEvent([key]);
      }
    }
  }, {
    key: "setCachedStateValue",
    value: function setCachedStateValue(key, value) {
      this.cachedState = __spreadProps(__spreadValues({}, this.cachedState), _defineProperty({}, key, value));
    }
  }, {
    key: "refreshStaleState",
    value: function refreshStaleState() {
      var _this655 = this;

      this.staleStateKeys.forEach(function (key) {
        switch (key) {
          case "rowSelection":
            _this655.setCachedStateValue(key, _this655.getRowSelectionState());

            break;
        }
      });
      this.staleStateKeys.clear();
    }
  }, {
    key: "dispatchStateUpdateEvent",
    value: function dispatchStateUpdateEvent(sources) {
      var _this656 = this;

      if (this.suppressEvents) {
        return;
      }

      sources.forEach(function (source) {
        return _this656.queuedUpdateSources.add(source);
      });
      this.dispatchStateUpdateEventDebounced();
    }
  }, {
    key: "dispatchQueuedStateUpdateEvents",
    value: function dispatchQueuedStateUpdateEvents() {
      var sources = Array.from(this.queuedUpdateSources);
      this.queuedUpdateSources.clear();
      var event = {
        type: _Events.EVENT_STATE_UPDATED,
        sources: sources,
        state: this.cachedState
      };
      this.eventService.dispatchEvent(event);
    }
  }, {
    key: "suppressEventsAndDispatchInitEvent",
    value: function suppressEventsAndDispatchInitEvent(updateFunc) {
      var _this657 = this;

      this.suppressEvents = true;
      this.columnAnimationService.setSuppressAnimation(true);
      updateFunc();
      setTimeout(function () {
        _this657.suppressEvents = false;

        _this657.queuedUpdateSources.clear();

        if (!_this657.isAlive()) {
          return;
        }

        _this657.columnAnimationService.setSuppressAnimation(false);

        _this657.dispatchStateUpdateEvent(["gridInitializing"]);
      });
    }
  }]);

  return StateService;
}(_BeanStub2);

__decorateClass([_Autowired("filterManager")], StateService.prototype, "filterManager", 2);

__decorateClass([_Autowired("ctrlsService")], StateService.prototype, "ctrlsService", 2);

__decorateClass([_Autowired("focusService")], StateService.prototype, "focusService", 2);

__decorateClass([_Autowired("columnModel")], StateService.prototype, "columnModel", 2);

__decorateClass([_Autowired("paginationProxy")], StateService.prototype, "paginationProxy", 2);

__decorateClass([_Autowired("rowModel")], StateService.prototype, "rowModel", 2);

__decorateClass([_Autowired("selectionService")], StateService.prototype, "selectionService", 2);

__decorateClass([_Autowired("expansionService")], StateService.prototype, "expansionService", 2);

__decorateClass([_Autowired("columnAnimationService")], StateService.prototype, "columnAnimationService", 2);

__decorateClass([_Optional("sideBarService")], StateService.prototype, "sideBarService", 2);

__decorateClass([_Optional("rangeService")], StateService.prototype, "rangeService", 2);

__decorateClass([_PostConstruct], StateService.prototype, "postConstruct", 1);

StateService = __decorateClass([_Bean("stateService")], StateService); // community-modules/core/src/validation/validationService.ts

var ValidationService =
/*#__PURE__*/
function (_BeanStub106) {
  "use strict";

  _inherits(ValidationService, _BeanStub106);

  function ValidationService() {
    _classCallCheck(this, ValidationService);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValidationService).apply(this, arguments));
  }

  _createClass(ValidationService, [{
    key: "init",
    value: function init() {
      this.processGridOptions(this.gridOptions);
    }
  }, {
    key: "processGridOptions",
    value: function processGridOptions(options) {
      this.processOptions(options, GRID_OPTIONS_VALIDATORS);
    }
  }, {
    key: "processColumnDefs",
    value: function processColumnDefs(options) {
      this.processOptions(options, COL_DEF_VALIDATORS);
    }
  }, {
    key: "processOptions",
    value: function processOptions(options, validator) {
      var _this658 = this;

      var validations = validator.validations,
          deprecations = validator.deprecations,
          allProperties = validator.allProperties,
          propertyExceptions = validator.propertyExceptions,
          objectName = validator.objectName,
          docsUrl = validator.docsUrl;

      if (allProperties && this.gridOptions.suppressPropertyNamesCheck !== true) {
        this.checkProperties(options, [].concat(_toConsumableArray(propertyExceptions != null ? propertyExceptions : []), _toConsumableArray(Object.keys(deprecations))), allProperties, objectName, docsUrl);
      }

      var warnings =
      /* @__PURE__ */
      new Set();
      var optionKeys = Object.keys(options);
      optionKeys.forEach(function (key) {
        var _a;

        var deprecation = deprecations[key];

        if (deprecation) {
          if ("renamed" in deprecation) {
            var renamed = deprecation.renamed,
                version = deprecation.version;
            warnings.add("As of v".concat(version, ", ").concat(String(key), " is deprecated. Please use ").concat(String(renamed), " instead."));
            options[renamed] = options[key];
          } else {
            var message = deprecation.message,
                _version = deprecation.version;
            warnings.add("As of v".concat(_version, ", ").concat(String(key), " is deprecated. ").concat(message != null ? message : ""));
          }
        }

        var value = options[key];

        if (value == null || value === false) {
          return;
        }

        var rulesOrGetter = validations[key];
        var rules;

        if (!rulesOrGetter) {
          return;
        } else if (typeof rulesOrGetter === "function") {
          var fromGetter = rulesOrGetter(options, _this658.gridOptions);

          if (!fromGetter) {
            return;
          }

          if ("objectName" in fromGetter) {
            var value2 = options[key];

            if (Array.isArray(value2)) {
              value2.forEach(function (item) {
                _this658.processOptions(item, fromGetter);
              });
              return;
            }

            _this658.processOptions(options[key], fromGetter);

            return;
          }

          rules = fromGetter;
        } else {
          rules = rulesOrGetter;
        }

        var _rules = rules,
            module2 = _rules.module,
            dependencies = _rules.dependencies,
            supportedRowModels = _rules.supportedRowModels;

        if (supportedRowModels) {
          var rowModel = (_a = _this658.gridOptions.rowModelType) != null ? _a : "clientSide";

          if (!supportedRowModels.includes(rowModel)) {
            warnings.add("".concat(String(key), " is not supported with the '").concat(rowModel, "' row model."));
            return;
          }
        }

        if (module2) {
          var modules = Array.isArray(module2) ? module2 : [module2];
          var allRegistered = true;
          modules.forEach(function (m) {
            if (!_ModuleRegistry2.__assertRegistered(m, String(key), _this658.context.getGridId())) {
              allRegistered = false;
              warnings.add("".concat(String(key), " is only available when ").concat(m, " is loaded."));
            }
          });

          if (!allRegistered) {
            return;
          }
        }

        if (dependencies) {
          var warning = _this658.checkForWarning(key, dependencies, options);

          if (warning) {
            warnings.add(warning);
            return;
          }
        }
      });

      if (warnings.size > 0) {
        warnings.forEach(function (warning) {
          _warnOnce(warning);
        });
      }
    }
  }, {
    key: "checkForWarning",
    value: function checkForWarning(key, validator, options) {
      if (typeof validator === "function") {
        return validator(options, this.gridOptions);
      }

      var optionEntries = Object.entries(validator);
      var failed = optionEntries.find(function (_ref91) {
        var _ref92 = _slicedToArray(_ref91, 2),
            key2 = _ref92[0],
            value = _ref92[1];

        var gridOptionValue = options[key2];
        return !value.includes(gridOptionValue);
      });

      if (!failed) {
        return null;
      }

      var _failed = _slicedToArray(failed, 2),
          failedKey = _failed[0],
          possibleOptions = _failed[1];

      if (possibleOptions.length > 1) {
        return "'".concat(String(key), "' requires '").concat(failedKey, "' to be one of [").concat(possibleOptions.join(", "), "].");
      }

      return "'".concat(String(key), "' requires '").concat(failedKey, "' to be ").concat(possibleOptions[0], ".");
    }
  }, {
    key: "checkProperties",
    value: function checkProperties(object, exceptions, validProperties, containerName, docsUrl) {
      var VUE_FRAMEWORK_PROPS = ["__ob__", "__v_skip", "__metadata__"];

      var invalidProperties = _fuzzyCheckStrings(Object.getOwnPropertyNames(object), [].concat(VUE_FRAMEWORK_PROPS, _toConsumableArray(exceptions), _toConsumableArray(validProperties)), validProperties);

      _iterateObject(invalidProperties, function (key, value) {
        _warnOnce("invalid ".concat(containerName, " property '").concat(key, "' did you mean any of these: ").concat(value.slice(0, 8).join(", ")));
      });

      if (Object.keys(invalidProperties).length > 0 && docsUrl) {
        var url = this.getFrameworkOverrides().getDocLink(docsUrl);

        _warnOnce("to see all the valid ".concat(containerName, " properties please check: ").concat(url));
      }
    }
  }]);

  return ValidationService;
}(_BeanStub2);

__decorateClass([_Autowired("gridOptions")], ValidationService.prototype, "gridOptions", 2);

__decorateClass([_PostConstruct], ValidationService.prototype, "init", 1);

ValidationService = __decorateClass([_Bean("validationService")], ValidationService); // community-modules/core/src/misc/apiEventService.ts

var ApiEventService =
/*#__PURE__*/
function (_BeanStub107) {
  "use strict";

  _inherits(ApiEventService, _BeanStub107);

  function ApiEventService() {
    var _this659;

    _classCallCheck(this, ApiEventService);

    _this659 = _possibleConstructorReturn(this, _getPrototypeOf(ApiEventService).apply(this, arguments));
    _this659.syncEventListeners =
    /* @__PURE__ */
    new Map();
    _this659.asyncEventListeners =
    /* @__PURE__ */
    new Map();
    _this659.syncGlobalEventListeners =
    /* @__PURE__ */
    new Set();
    _this659.globalEventListenerPairs =
    /* @__PURE__ */
    new Map();
    return _this659;
  }

  _createClass(ApiEventService, [{
    key: "postConstruct",
    value: function postConstruct() {
      this.frameworkEventWrappingService = new FrameworkEventListenerService(this.getFrameworkOverrides());
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(eventType, userListener) {
      var listener = this.frameworkEventWrappingService.wrap(userListener);
      var async = this.gos.useAsyncEvents() && !_ALWAYS_SYNC_GLOBAL_EVENTS.has(eventType);
      ;
      var listeners = async ? this.asyncEventListeners : this.syncEventListeners;

      if (!listeners.has(eventType)) {
        listeners.set(eventType,
        /* @__PURE__ */
        new Set());
      }

      listeners.get(eventType).add(listener);
      this.eventService.addEventListener(eventType, listener, async);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventType, userListener) {
      var _a;

      var listener = this.frameworkEventWrappingService.unwrap(userListener);
      var asyncListeners = this.asyncEventListeners.get(eventType);
      var hasAsync = !!(asyncListeners == null ? void 0 : asyncListeners.delete(listener));

      if (!hasAsync) {
        (_a = this.syncEventListeners.get(eventType)) == null ? void 0 : _a.delete(listener);
      }

      this.eventService.removeEventListener(eventType, listener, hasAsync);
    }
  }, {
    key: "addGlobalListener",
    value: function addGlobalListener(userListener) {
      var listener = this.frameworkEventWrappingService.wrapGlobal(userListener);
      var async = this.gos.useAsyncEvents();

      if (async) {
        var syncListener = function syncListener(eventType, event) {
          if (_ALWAYS_SYNC_GLOBAL_EVENTS.has(eventType)) {
            listener(eventType, event);
          }
        };

        var asyncListener = function asyncListener(eventType, event) {
          if (!_ALWAYS_SYNC_GLOBAL_EVENTS.has(eventType)) {
            listener(eventType, event);
          }
        };

        this.globalEventListenerPairs.set(userListener, {
          syncListener: syncListener,
          asyncListener: asyncListener
        });
        this.eventService.addGlobalListener(syncListener, false);
        this.eventService.addGlobalListener(asyncListener, true);
      } else {
        this.syncGlobalEventListeners.add(listener);
        this.eventService.addGlobalListener(listener, false);
      }
    }
  }, {
    key: "removeGlobalListener",
    value: function removeGlobalListener(userListener) {
      var listener = this.frameworkEventWrappingService.unwrapGlobal(userListener);
      var hasAsync = this.globalEventListenerPairs.has(listener);

      if (hasAsync) {
        var _this$globalEventList = this.globalEventListenerPairs.get(listener),
            syncListener = _this$globalEventList.syncListener,
            asyncListener = _this$globalEventList.asyncListener;

        this.eventService.removeGlobalListener(syncListener, false);
        this.eventService.removeGlobalListener(asyncListener, true);
        this.globalEventListenerPairs.delete(userListener);
      } else {
        this.syncGlobalEventListeners.delete(listener);
        this.eventService.removeGlobalListener(listener, false);
      }
    }
  }, {
    key: "destroyEventListeners",
    value: function destroyEventListeners(map, async) {
      var _this660 = this;

      map.forEach(function (listeners, eventType) {
        listeners.forEach(function (listener) {
          return _this660.eventService.removeEventListener(eventType, listener, async);
        });
        listeners.clear();
      });
      map.clear();
    }
  }, {
    key: "destroyGlobalListeners",
    value: function destroyGlobalListeners(set, async) {
      var _this661 = this;

      set.forEach(function (listener) {
        return _this661.eventService.removeGlobalListener(listener, async);
      });
      set.clear();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this662 = this;

      _get(_getPrototypeOf(ApiEventService.prototype), "destroy", this).call(this);

      this.destroyEventListeners(this.syncEventListeners, false);
      this.destroyEventListeners(this.asyncEventListeners, true);
      this.destroyGlobalListeners(this.syncGlobalEventListeners, false);
      this.globalEventListenerPairs.forEach(function (_ref93) {
        var syncListener = _ref93.syncListener,
            asyncListener = _ref93.asyncListener;

        _this662.eventService.removeGlobalListener(syncListener, false);

        _this662.eventService.removeGlobalListener(asyncListener, true);
      });
      this.globalEventListenerPairs.clear();
    }
  }]);

  return ApiEventService;
}(_BeanStub2);

__decorateClass([_PostConstruct], ApiEventService.prototype, "postConstruct", 1);

ApiEventService = __decorateClass([_Bean("apiEventService")], ApiEventService); // community-modules/core/src/pagination/pageSizeSelector/pageSizeSelectorComp.ts

var PageSizeSelectorComp =
/*#__PURE__*/
function (_Component46) {
  "use strict";

  _inherits(PageSizeSelectorComp, _Component46);

  function PageSizeSelectorComp() {
    var _this663;

    _classCallCheck(this, PageSizeSelectorComp);

    _this663 = _possibleConstructorReturn(this, _getPrototypeOf(PageSizeSelectorComp).call(this,
    /* html */
    "<span class=\"ag-paging-page-size\"></span>"));
    _this663.hasEmptyOption = false;

    _this663.handlePageSizeItemSelected = function () {
      if (!_this663.selectPageSizeComp) {
        return;
      }

      var newValue = _this663.selectPageSizeComp.getValue();

      if (!newValue) {
        return;
      }

      var paginationPageSize = Number(newValue);

      if (isNaN(paginationPageSize) || paginationPageSize < 1 || paginationPageSize === _this663.paginationProxy.getPageSize()) {
        return;
      }

      _this663.paginationProxy.setPageSize(paginationPageSize, "pageSizeSelector");

      if (_this663.hasEmptyOption) {
        _this663.toggleSelectDisplay(true);
      }

      _this663.selectPageSizeComp.getFocusableElement().focus();
    };

    return _this663;
  }

  _createClass(PageSizeSelectorComp, [{
    key: "init",
    value: function init() {
      var _this664 = this;

      this.addManagedPropertyListener("paginationPageSizeSelector", function () {
        _this664.onPageSizeSelectorValuesChange();
      });
      this.addManagedListener(this.eventService, _Events.EVENT_PAGINATION_CHANGED, function (event) {
        return _this664.handlePaginationChanged(event);
      });
    }
  }, {
    key: "handlePaginationChanged",
    value: function handlePaginationChanged(paginationChangedEvent) {
      if (!this.selectPageSizeComp || !(paginationChangedEvent == null ? void 0 : paginationChangedEvent.newPageSize)) {
        return;
      }

      var paginationPageSize = this.paginationProxy.getPageSize();

      if (this.getPageSizeSelectorValues().includes(paginationPageSize)) {
        this.selectPageSizeComp.setValue(paginationPageSize.toString());
      } else {
        if (this.hasEmptyOption) {
          this.selectPageSizeComp.setValue("");
        } else {
          this.toggleSelectDisplay(true);
        }
      }
    }
  }, {
    key: "toggleSelectDisplay",
    value: function toggleSelectDisplay(show) {
      if (this.selectPageSizeComp) {
        this.reset();
      }

      if (!show) {
        return;
      }

      this.reloadPageSizesSelector();

      if (!this.selectPageSizeComp) {
        return;
      }

      this.appendChild(this.selectPageSizeComp);
    }
  }, {
    key: "reset",
    value: function reset() {
      _clearElement(this.getGui());

      if (!this.selectPageSizeComp) {
        return;
      }

      this.destroyBean(this.selectPageSizeComp);
      this.selectPageSizeComp = void 0;
    }
  }, {
    key: "onPageSizeSelectorValuesChange",
    value: function onPageSizeSelectorValuesChange() {
      if (!this.selectPageSizeComp) {
        return;
      }

      if (this.shouldShowPageSizeSelector()) {
        this.reloadPageSizesSelector();
      }
    }
  }, {
    key: "shouldShowPageSizeSelector",
    value: function shouldShowPageSizeSelector() {
      return this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel") && !this.gos.get("paginationAutoPageSize") && this.gos.get("paginationPageSizeSelector") !== false;
    }
  }, {
    key: "reloadPageSizesSelector",
    value: function reloadPageSizesSelector() {
      var _this665 = this;

      var pageSizeOptions = this.getPageSizeSelectorValues();
      var paginationPageSizeOption = this.paginationProxy.getPageSize();
      var shouldAddAndSelectEmptyOption = !paginationPageSizeOption || !pageSizeOptions.includes(paginationPageSizeOption);

      if (shouldAddAndSelectEmptyOption) {
        pageSizeOptions.unshift("");

        _warnOnce("The paginationPageSize grid option is set to a value that is not in the list of page size options.\n                Please make sure that the paginationPageSize grid option is set to one of the values in the \n                paginationPageSizeSelector array, or set the paginationPageSizeSelector to false to hide the page size selector.");
      }

      if (this.selectPageSizeComp) {
        this.destroyBean(this.selectPageSizeComp);
        this.selectPageSizeComp = void 0;
      }

      var localeTextFunc = this.localeService.getLocaleTextFunc();
      var localisedLabel = localeTextFunc("pageSizeSelectorLabel", "Page Size:");
      var options = pageSizeOptions.map(function (value) {
        return {
          value: String(value),
          text: String(value)
        };
      });
      var localisedAriaLabel = localeTextFunc("ariaPageSizeSelectorLabel", "Page Size");
      this.selectPageSizeComp = this.createManagedBean(new _AgSelect2()).addOptions(options).setValue(String(shouldAddAndSelectEmptyOption ? "" : paginationPageSizeOption)).setAriaLabel(localisedAriaLabel).setLabel(localisedLabel).onValueChange(function () {
        return _this665.handlePageSizeItemSelected();
      });
      this.hasEmptyOption = shouldAddAndSelectEmptyOption;
    }
  }, {
    key: "getPageSizeSelectorValues",
    value: function getPageSizeSelectorValues() {
      var defaultValues = [20, 50, 100];
      var paginationPageSizeSelectorValues = this.gos.get("paginationPageSizeSelector");

      if (!Array.isArray(paginationPageSizeSelectorValues) || !this.validateValues(paginationPageSizeSelectorValues)) {
        return defaultValues;
      }

      return _toConsumableArray(paginationPageSizeSelectorValues).sort(function (a, b) {
        return a - b;
      });
    }
  }, {
    key: "validateValues",
    value: function validateValues(values2) {
      if (!values2.length) {
        _warnOnce("The paginationPageSizeSelector grid option is an empty array. This is most likely a mistake.\n                If you want to hide the page size selector, please set the paginationPageSizeSelector to false.");

        return false;
      }

      for (var i = 0; i < values2.length; i++) {
        var value = values2[i];
        var isNumber = typeof value === "number";
        var isPositive = value > 0;

        if (!isNumber) {
          _warnOnce("The paginationPageSizeSelector grid option contains a non-numeric value.\n                    Please make sure that all values in the paginationPageSizeSelector array are numbers.");

          return false;
        }

        if (!isPositive) {
          _warnOnce("The paginationPageSizeSelector grid option contains a negative number or zero.\n                    Please make sure that all values in the paginationPageSizeSelector array are positive.");

          return false;
        }
      }

      return true;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.toggleSelectDisplay(false);

      _get(_getPrototypeOf(PageSizeSelectorComp.prototype), "destroy", this).call(this);
    }
  }]);

  return PageSizeSelectorComp;
}(_Component2);

__decorateClass([_Autowired("paginationProxy")], PageSizeSelectorComp.prototype, "paginationProxy", 2);

__decorateClass([_PostConstruct], PageSizeSelectorComp.prototype, "init", 1); // community-modules/core/src/rendering/ariaAnnouncementService.ts


var AriaAnnouncementService =
/*#__PURE__*/
function (_BeanStub108) {
  "use strict";

  _inherits(AriaAnnouncementService, _BeanStub108);

  function AriaAnnouncementService() {
    var _this666;

    _classCallCheck(this, AriaAnnouncementService);

    _this666 = _possibleConstructorReturn(this, _getPrototypeOf(AriaAnnouncementService).call(this));
    _this666.descriptionContainer = null;
    _this666.announceValue = _debounce(_this666.announceValue.bind(_assertThisInitialized(_this666)), 200);
    return _this666;
  }

  _createClass(AriaAnnouncementService, [{
    key: "postConstruct",
    value: function postConstruct() {
      var eDocument = this.gos.getDocument();
      var div = this.descriptionContainer = eDocument.createElement("div");
      div.classList.add("ag-aria-description-container");

      _setAriaLive(div, "polite");

      _setAriaRelevant(div, "additions text");

      _setAriaAtomic(div, true);

      this.eGridDiv.appendChild(div);
    }
  }, {
    key: "announceValue",
    value: function announceValue(value) {
      var _this667 = this;

      if (!this.descriptionContainer) {
        return;
      }

      this.descriptionContainer.textContent = "";
      setTimeout(function () {
        if (_this667.isAlive() && _this667.descriptionContainer) {
          _this667.descriptionContainer.textContent = value;
        }
      }, 50);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(AriaAnnouncementService.prototype), "destroy", this).call(this);

      var descriptionContainer = this.descriptionContainer;

      if (descriptionContainer) {
        _clearElement(descriptionContainer);

        if (descriptionContainer.parentElement) {
          descriptionContainer.parentElement.removeChild(descriptionContainer);
        }
      }

      this.descriptionContainer = null;
      this.eGridDiv = null;
    }
  }]);

  return AriaAnnouncementService;
}(_BeanStub2);

__decorateClass([_Autowired("eGridDiv")], AriaAnnouncementService.prototype, "eGridDiv", 2);

__decorateClass([_PostConstruct], AriaAnnouncementService.prototype, "postConstruct", 1);

AriaAnnouncementService = __decorateClass([_Bean("ariaAnnouncementService")], AriaAnnouncementService); // community-modules/core/src/grid.ts

var GlobalGridOptions = function GlobalGridOptions() {
  "use strict";

  _classCallCheck(this, GlobalGridOptions);
};

GlobalGridOptions.gridOptions = void 0;

function _provideGlobalGridOptions(gridOptions) {
  GlobalGridOptions.gridOptions = gridOptions;
}

function _createGrid(eGridDiv, gridOptions, params) {
  if (!gridOptions) {
    _errorOnce("No gridOptions provided to createGrid");

    return {};
  }

  var api = new _GridCoreCreator().create(eGridDiv, gridOptions, function (context) {
    var gridComp = new _GridComp(eGridDiv);
    context.createBean(gridComp);
  }, void 0, params);

  if (!Object.isFrozen(gridOptions) && !(params == null ? void 0 : params.frameworkOverrides)) {
    var apiUrl = "https://ag-grid.com/javascript-data-grid/grid-interface/#grid-api";
    Object.defineProperty(gridOptions, "api", {
      get: function get() {
        _errorOnce("gridOptions.api is no longer supported. See ".concat(apiUrl, "."));

        return void 0;
      },
      configurable: true
    });
    Object.defineProperty(gridOptions, "columnApi", {
      get: function get() {
        _errorOnce("gridOptions.columnApi is no longer supported and all methods moved to the grid api. See ".concat(apiUrl, "."));

        return void 0;
      },
      configurable: true
    });
  }

  return api;
}

var _Grid =
/*#__PURE__*/
function () {
  "use strict";

  // Not typed to enable setting api / columnApi for backwards compatibility
  function _Grid(eGridDiv, gridOptions, params) {
    var _this668 = this;

    _classCallCheck(this, _Grid);

    _warnOnce("Since v31 new Grid(...) is deprecated. Use createGrid instead: `const gridApi = createGrid(...)`. The grid api is returned from createGrid and will not be available on gridOptions.");

    if (!gridOptions) {
      _errorOnce("No gridOptions provided to the grid");

      return;
    }

    this.gridOptions = gridOptions;
    var api = new _GridCoreCreator().create(eGridDiv, gridOptions, function (context) {
      var gridComp = new _GridComp(eGridDiv);
      var bean = context.createBean(gridComp);
      bean.addDestroyFunc(function () {
        _this668.destroy();
      });
    }, void 0, params);
    this.gridOptions.api = api;
    this.gridOptions.columnApi = new _ColumnApi(api);
  }

  _createClass(_Grid, [{
    key: "destroy",
    value: function destroy() {
      var _a;

      if (this.gridOptions) {
        (_a = this.gridOptions.api) == null ? void 0 : _a.destroy();
        delete this.gridOptions.api;
        delete this.gridOptions.columnApi;
      }
    }
  }]);

  return _Grid;
}();

var nextGridId = 1;

var _GridCoreCreator =
/*#__PURE__*/
function () {
  "use strict";

  function _GridCoreCreator() {
    _classCallCheck(this, _GridCoreCreator);
  }

  _createClass(_GridCoreCreator, [{
    key: "create",
    value: function create(eGridDiv, providedOptions, createUi, acceptChanges, params) {
      var _a;

      var mergedGridOps = {};

      if (GlobalGridOptions.gridOptions) {
        _mergeDeep(mergedGridOps, GlobalGridOptions.gridOptions, true, true);

        mergedGridOps = __spreadValues(__spreadValues({}, mergedGridOps), providedOptions);
      } else {
        mergedGridOps = providedOptions;
      }

      var gridOptions = _GridOptionsService2.getCoercedGridOptions(mergedGridOps);

      var debug = !!gridOptions.debug;
      var gridId = (_a = gridOptions.gridId) != null ? _a : String(nextGridId++);
      var registeredModules = this.getRegisteredModules(params, gridId);
      var beanClasses = this.createBeansList(gridOptions.rowModelType, registeredModules, gridId);
      var providedBeanInstances = this.createProvidedBeans(eGridDiv, gridOptions, params);

      if (!beanClasses) {
        _errorOnce("Failed to create grid.");

        return void 0;
      }

      var contextParams = {
        providedBeanInstances: providedBeanInstances,
        beanClasses: beanClasses,
        debug: debug,
        gridId: gridId
      };
      var contextLogger = new _Logger("Context", function () {
        return contextParams.debug;
      });
      var context = new _Context(contextParams, contextLogger);
      var beans = context.getBean("beans");
      this.registerModuleUserComponents(beans, registeredModules);
      this.registerStackComponents(beans, registeredModules);
      this.registerControllers(beans, registeredModules);
      createUi(context);
      beans.syncService.start();

      if (acceptChanges) {
        acceptChanges(context);
      }

      var gridApi = context.getBean("gridApi");
      return gridApi;
    }
  }, {
    key: "registerControllers",
    value: function registerControllers(beans, registeredModules) {
      registeredModules.forEach(function (module2) {
        if (module2.controllers) {
          module2.controllers.forEach(function (meta) {
            return beans.ctrlsFactory.register(meta);
          });
        }
      });
    }
  }, {
    key: "registerStackComponents",
    value: function registerStackComponents(beans, registeredModules) {
      var agStackComponents = this.createAgStackComponentsList(registeredModules);
      beans.agStackComponentsRegistry.setupComponents(agStackComponents);
    }
  }, {
    key: "getRegisteredModules",
    value: function getRegisteredModules(params, gridId) {
      var passedViaConstructor = params ? params.modules : null;

      var registered = _ModuleRegistry2.__getRegisteredModules(gridId);

      var allModules = [];
      var mapNames = {};

      var addModule = function addModule(moduleBased, mod, gridId2) {
        var addIndividualModule = function addIndividualModule(currentModule) {
          if (!mapNames[currentModule.moduleName]) {
            mapNames[currentModule.moduleName] = true;
            allModules.push(currentModule);

            _ModuleRegistry2.__register(currentModule, moduleBased, gridId2);
          }
        };

        addIndividualModule(mod);

        if (mod.dependantModules) {
          mod.dependantModules.forEach(function (m) {
            return addModule(moduleBased, m, gridId2);
          });
        }
      };

      if (passedViaConstructor) {
        passedViaConstructor.forEach(function (m) {
          return addModule(true, m, gridId);
        });
      }

      if (registered) {
        registered.forEach(function (m) {
          return addModule(!_ModuleRegistry2.__isPackageBased(), m, void 0);
        });
      }

      return allModules;
    }
  }, {
    key: "registerModuleUserComponents",
    value: function registerModuleUserComponents(beans, registeredModules) {
      var moduleUserComps = this.extractModuleEntity(registeredModules, function (module2) {
        return module2.userComponents ? module2.userComponents : [];
      });
      moduleUserComps.forEach(function (compMeta) {
        beans.userComponentRegistry.registerDefaultComponent(compMeta.componentName, compMeta.componentClass);
      });
    }
  }, {
    key: "createProvidedBeans",
    value: function createProvidedBeans(eGridDiv, gridOptions, params) {
      var frameworkOverrides = params ? params.frameworkOverrides : null;

      if (_missing(frameworkOverrides)) {
        frameworkOverrides = new _VanillaFrameworkOverrides();
      }

      var seed = {
        gridOptions: gridOptions,
        eGridDiv: eGridDiv,
        globalEventListener: params ? params.globalEventListener : null,
        globalSyncEventListener: params ? params.globalSyncEventListener : null,
        frameworkOverrides: frameworkOverrides
      };

      if (params && params.providedBeanInstances) {
        Object.assign(seed, params.providedBeanInstances);
      }

      return seed;
    }
  }, {
    key: "createAgStackComponentsList",
    value: function createAgStackComponentsList(registeredModules) {
      var components = [{
        componentName: "AgCheckbox",
        componentClass: _AgCheckbox
      }, {
        componentName: "AgRadioButton",
        componentClass: _AgRadioButton
      }, {
        componentName: "AgToggleButton",
        componentClass: _AgToggleButton
      }, {
        componentName: "AgInputTextField",
        componentClass: _AgInputTextField
      }, {
        componentName: "AgInputTextArea",
        componentClass: _AgInputTextArea
      }, {
        componentName: "AgInputNumberField",
        componentClass: _AgInputNumberField
      }, {
        componentName: "AgInputDateField",
        componentClass: _AgInputDateField
      }, {
        componentName: "AgInputRange",
        componentClass: _AgInputRange
      }, {
        componentName: "AgRichSelect",
        componentClass: _AgRichSelect
      }, {
        componentName: "AgSelect",
        componentClass: _AgSelect2
      }, {
        componentName: "AgSlider",
        componentClass: _AgSlider2
      }, {
        componentName: "AgGridBody",
        componentClass: _GridBodyComp
      }, {
        componentName: "AgHeaderRoot",
        componentClass: _GridHeaderComp2
      }, {
        componentName: "AgSortIndicator",
        componentClass: _SortIndicatorComp2
      }, {
        componentName: "AgPagination",
        componentClass: PaginationComp
      }, {
        componentName: "AgPageSizeSelector",
        componentClass: PageSizeSelectorComp
      }, {
        componentName: "AgOverlayWrapper",
        componentClass: OverlayWrapperComponent
      }, {
        componentName: "AgGroupComponent",
        componentClass: _AgGroupComponent2
      }, {
        componentName: "AgRowContainer",
        componentClass: _RowContainerComp
      }, {
        componentName: "AgFakeHorizontalScroll",
        componentClass: FakeHScrollComp
      }, {
        componentName: "AgFakeVerticalScroll",
        componentClass: FakeVScrollComp
      }, {
        componentName: "AgAutocomplete",
        componentClass: _AgAutocomplete2
      }];
      var moduleAgStackComps = this.extractModuleEntity(registeredModules, function (module2) {
        return module2.agStackComponents ? module2.agStackComponents : [];
      });
      components = components.concat(moduleAgStackComps);
      return components;
    }
  }, {
    key: "createBeansList",
    value: function createBeansList() {
      var rowModelType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "clientSide";
      var registeredModules = arguments.length > 1 ? arguments[1] : undefined;
      var gridId = arguments.length > 2 ? arguments[2] : undefined;
      var rowModelModules = registeredModules.filter(function (module2) {
        return !module2.rowModel || module2.rowModel === rowModelType;
      });
      var rowModelModuleNames = {
        clientSide: "@ag-grid-community/client-side-row-model"
        /* ClientSideRowModelModule */
        ,
        infinite: "@ag-grid-community/infinite-row-model"
        /* InfiniteRowModelModule */
        ,
        serverSide: "@ag-grid-enterprise/server-side-row-model"
        /* ServerSideRowModelModule */
        ,
        viewport: "@ag-grid-enterprise/viewport-row-model"
        /* ViewportRowModelModule */

      };

      if (!rowModelModuleNames[rowModelType]) {
        _errorOnce("Could not find row model for rowModelType = " + rowModelType);

        return;
      }

      if (!_ModuleRegistry2.__assertRegistered(rowModelModuleNames[rowModelType], "rowModelType = '".concat(rowModelType, "'"), gridId)) {
        return;
      }

      var beans = [_Beans, _RowPositionUtils, _CellPositionUtils, _HeaderPositionUtils, PaginationAutoPageSizeService, _GridApi, _UserComponentRegistry, AgComponentUtils, ComponentMetadataProvider, _ResizeObserverService, _UserComponentFactory, RowContainerHeightService, _HorizontalResizeService, _LocaleService, ValidationService, _PinnedRowModel, _DragService, _DisplayedGroupCreator, _EventService, _GridOptionsService2, _PopupService2, SelectionService, _FilterManager, _ColumnModel, _HeaderNavigationService, _PaginationProxy, _RowRenderer, _ExpressionService, _ColumnFactory, _AlignedGridsService, _NavigationService, _ValueCache, _ValueService, _LoggerFactory, _AutoWidthCalculator, _StandardMenuFactory, _DragAndDropService2, _ColumnApi, _FocusService2, _MouseEventService2, _Environment, _CellNavigationService, _StylingService, _ScrollVisibleService, _SortController2, ColumnHoverService, ColumnAnimationService, _SelectableService, AutoGroupColService, ChangeDetectionService, _AnimationFrameService, UndoRedoService, _AgStackComponentsRegistry, ColumnDefFactory, RowCssClassCalculator, _RowNodeBlockLoader2, _RowNodeSorter, _CtrlsService, PinnedWidthService, RowNodeEventThrottle, CtrlsFactory, _DataTypeService, _QuickFilterService, SyncService, OverlayService, StateService, _ExpansionService, ApiEventService, AriaAnnouncementService, _MenuService];
      var moduleBeans = this.extractModuleEntity(rowModelModules, function (module2) {
        return module2.beans ? module2.beans : [];
      });
      beans.push.apply(beans, _toConsumableArray(moduleBeans));
      var beansNoDuplicates = [];
      beans.forEach(function (bean) {
        if (beansNoDuplicates.indexOf(bean) < 0) {
          beansNoDuplicates.push(bean);
        }
      });
      return beansNoDuplicates;
    }
  }, {
    key: "extractModuleEntity",
    value: function extractModuleEntity(moduleEntities, extractor) {
      var _ref94;

      return (_ref94 = []).concat.apply(_ref94, _toConsumableArray(moduleEntities.map(extractor)));
    }
  }]);

  return _GridCoreCreator;
}(); // community-modules/core/src/components/framework/frameworkComponentWrapper.ts


var _BaseComponentWrapper =
/*#__PURE__*/
function () {
  "use strict";

  function _BaseComponentWrapper() {
    _classCallCheck(this, _BaseComponentWrapper);
  }

  _createClass(_BaseComponentWrapper, [{
    key: "wrap",
    value: function wrap(OriginalConstructor, mandatoryMethodList) {
      var _this669 = this;

      var optionalMethodList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var componentType = arguments.length > 3 ? arguments[3] : undefined;
      var wrapper = this.createWrapper(OriginalConstructor, componentType);
      mandatoryMethodList.forEach(function (methodName) {
        _this669.createMethod(wrapper, methodName, true);
      });
      optionalMethodList.forEach(function (methodName) {
        _this669.createMethod(wrapper, methodName, false);
      });
      return wrapper;
    }
  }, {
    key: "unwrap",
    value: function unwrap(comp) {
      return comp;
    }
  }, {
    key: "createMethod",
    value: function createMethod(wrapper, methodName, mandatory) {
      wrapper.addMethod(methodName, this.createMethodProxy(wrapper, methodName, mandatory));
    }
  }, {
    key: "createMethodProxy",
    value: function createMethodProxy(wrapper, methodName, mandatory) {
      return function () {
        if (wrapper.hasMethod(methodName)) {
          return wrapper.callMethod(methodName, arguments);
        }

        if (mandatory) {
          console.warn("AG Grid: Framework component is missing the method " + methodName + "()");
        }

        return null;
      };
    }
  }]);

  return _BaseComponentWrapper;
}(); // community-modules/core/src/interfaces/iChartOptions.ts


var _ChartMappings = function _ChartMappings() {
  "use strict";

  _classCallCheck(this, _ChartMappings);
};

_ChartMappings.CHART_TYPE_TO_SERIES_TYPE = {
  column: "bar",
  groupedColumn: "bar",
  stackedColumn: "bar",
  normalizedColumn: "bar",
  bar: "bar",
  groupedBar: "bar",
  stackedBar: "bar",
  normalizedBar: "bar",
  line: "line",
  scatter: "scatter",
  bubble: "bubble",
  pie: "pie",
  donut: "donut",
  doughnut: "donut",
  area: "area",
  stackedArea: "area",
  normalizedArea: "area",
  histogram: "histogram",
  radarLine: "radar-line",
  radarArea: "radar-area",
  nightingale: "nightingale",
  radialColumn: "radial-column",
  radialBar: "radial-bar",
  sunburst: "sunburst",
  rangeBar: "range-bar",
  rangeArea: "range-area",
  boxPlot: "box-plot",
  treemap: "treemap",
  heatmap: "heatmap",
  waterfall: "waterfall"
};
_ChartMappings.COMBO_CHART_TYPES = ["columnLineCombo", "areaColumnCombo", "customCombo"];
_ChartMappings.SERIES_GROUP_TYPES = ["grouped", "stacked", "normalized"]; // community-modules/core/src/interfaces/iAgChartOptions.ts

var _FORCE_MODULE_DETECTION = 0; // community-modules/core/src/interfaces/iSparklineCellRendererParams.ts

var _BarColumnLabelPlacement =
/* @__PURE__ */
function (BarColumnLabelPlacement2) {
  BarColumnLabelPlacement2["InsideBase"] = "insideBase";
  BarColumnLabelPlacement2["InsideEnd"] = "insideEnd";
  BarColumnLabelPlacement2["Center"] = "center";
  BarColumnLabelPlacement2["OutsideEnd"] = "outsideEnd";
  return BarColumnLabelPlacement2;
}(_BarColumnLabelPlacement || {}); // community-modules/core/src/main.ts


var globalObj = typeof global === "undefined" ? {} : global;
globalObj.HTMLElement = typeof HTMLElement === "undefined" ? {} : HTMLElement;
globalObj.HTMLButtonElement = typeof HTMLButtonElement === "undefined" ? {} : HTMLButtonElement;
globalObj.HTMLSelectElement = typeof HTMLSelectElement === "undefined" ? {} : HTMLSelectElement;
globalObj.HTMLInputElement = typeof HTMLInputElement === "undefined" ? {} : HTMLInputElement;
globalObj.Node = typeof Node === "undefined" ? {} : Node;
globalObj.MouseEvent = typeof MouseEvent === "undefined" ? {} : MouseEvent;